// ===== data.js =====
window.SR_DATA = (() => {
  const vendedores = [
    { id: "05", nome: "J. N", codigo: "05", iniciais: "JN", cor: "#15324f" },
    { id: "06", nome: "Concei\xE7\xE3o", codigo: "06", iniciais: "CC", cor: "#2c5d8a" },
    { id: "07", nome: "Paulo Marques", codigo: "07", iniciais: "PM", cor: "#3a8a4d" },
    { id: "08", nome: "Cl\xE1udia Cunha", codigo: "08", iniciais: "CL", cor: "#d4a574" },
    { id: "21", nome: "Jorge Aguiar", codigo: "21", iniciais: "JA", cor: "#7c3aed" },
    { id: "22", nome: "Rosana Coutinho", codigo: "22", iniciais: "RC", cor: "#c4434b" },
    { id: "23", nome: "J. N. D&D", codigo: "23", iniciais: "DD", cor: "#0e766e" },
    { id: "27", nome: "JNC Santos Esteves", codigo: "27", iniciais: "JS", cor: "#475569" },
    { id: "28", nome: "JNC Jo\xE3o Raposo", codigo: "28", iniciais: "JR", cor: "#9a3412" },
    { id: "29", nome: "Andreia Praia", codigo: "29", iniciais: "AP", cor: "#0369a1" },
    { id: "33", nome: "Filipa Freitas", codigo: "33", iniciais: "FF", cor: "#a16207" },
    { id: "31", nome: "Vendedor 31", codigo: "31", iniciais: "V31", cor: "#6b7280" }
  ];
  const estados = [
    { id: "por_tratar", nome: "Por tratar", cor: "#6a7888", ordem: 1, terminal: false },
    { id: "em_progresso", nome: "Em progresso", cor: "#2c5d8a", ordem: 2, terminal: false },
    { id: "aguarda", nome: "Aguarda feedback", cor: "#7c3aed", ordem: 3, terminal: false },
    { id: "resolvido", nome: "Resolvido", cor: "#3a8a4d", ordem: 4, terminal: true },
    { id: "descartado", nome: "Para sucata", cor: "#475569", ordem: 5, terminal: true }
  ];
  const tiposAcao = [
    { id: "email", nome: "E-mail ao cliente", icon: "mail" },
    { id: "tel", nome: "Telefonema", icon: "phone" },
    { id: "visita", nome: "Visita comercial", icon: "visit" },
    { id: "proposta", nome: "Proposta enviada", icon: "doc" },
    { id: "reuniao", nome: "Reuni\xE3o interna", icon: "meeting" },
    { id: "desconto", nome: "Desconto aplicado", icon: "tag" },
    { id: "sucata", nome: "Marcado p/ sucata", icon: "trash" },
    { id: "venda_alt", nome: "Venda a cliente alternativo", icon: "swap" }
  ];
  const tiposArtigo = {
    CART\u00C3O: { nome: "Cart\xE3o", cor: "#a16207", bg: "#fef3c7", fg: "#78350f" },
    PAPEL: { nome: "Papel", cor: "#0369a1", bg: "#e0f2fe", fg: "#0c4a6e" },
    PL\u00C1STICO: { nome: "Pl\xE1stico", cor: "#7c3aed", bg: "#ede9fe", fg: "#5b21b6" },
    FITAS: { nome: "Fitas", cor: "#c4434b", bg: "#fee2e2", fg: "#991b1b" },
    ENVELOPES: { nome: "Envelopes", cor: "#0e766e", bg: "#ccfbf1", fg: "#115e59" },
    OUTROS: { nome: "Outros", cor: "#475569", bg: "#e2e8f0", fg: "#1e293b" },
    // Extended from real ERP data
    AUTOCOLANTE: { nome: "Autocolante", cor: "#0891b2", bg: "#e0f7fa", fg: "#064e5a" },
    CANTONEIRAS: { nome: "Cantoneiras", cor: "#6b7280", bg: "#f3f4f6", fg: "#374151" },
    "CINTA/AGRAFOS/COLA": { nome: "Cinta/Agrafos/Cola", cor: "#78716c", bg: "#f5f5f4", fg: "#44403c" },
    "Cart\xE3o": { nome: "Cart\xE3o", cor: "#a16207", bg: "#fef3c7", fg: "#78350f" },
    // lowercase variant — same visual as CARTÃO
    EPI: { nome: "EPI", cor: "#b45309", bg: "#fef3c7", fg: "#78350f" },
    "EPI/HIG": { nome: "EPI/Higiene", cor: "#b45309", bg: "#fff7ed", fg: "#7c2d12" },
    FERRAMENTA: { nome: "Ferramenta", cor: "#6b7280", bg: "#f3f4f6", fg: "#374151" },
    MADEIRA: { nome: "Madeira", cor: "#92400e", bg: "#fef3c7", fg: "#78350f" },
    M\u00C1QUINA: { nome: "M\xE1quina", cor: "#475569", bg: "#e2e8f0", fg: "#1e293b" },
    PL\u00C1STICOS: { nome: "Pl\xE1sticos", cor: "#7c3aed", bg: "#ede9fe", fg: "#5b21b6" },
    // plural variant — same visual as PLÁSTICO
    PROJETOS: { nome: "Projetos", cor: "#0369a1", bg: "#eff6ff", fg: "#1e40af" },
    "SPARE PARTS": { nome: "Spare Parts", cor: "#6b7280", bg: "#f3f4f6", fg: "#374151" }
  };
  const familias = {
    PA: { nome: "Produto Acabado", cor: "#15324f", bg: "#e3edf7", fg: "#15324f" },
    ME: { nome: "Mercadoria", cor: "#7c3aed", bg: "#f5f3ff", fg: "#5b21b6" },
    MP: { nome: "Mat\xE9ria-prima", cor: "#0e766e", bg: "#ccfbf1", fg: "#0f766e" },
    "MAT. PH": { nome: "Mat\xE9rias PH", cor: "#475569", bg: "#e2e8f0", fg: "#1e293b" },
    MS: { nome: "Materiais Suplementares", cor: "#6b7280", bg: "#f3f4f6", fg: "#374151" }
  };
  const tiposAquisicao = {
    "Produ\xE7\xE3o": { nome: "Produ\xE7\xE3o", cor: "#3a8a4d" },
    "Compra": { nome: "Compra", cor: "#0369a1" },
    "Subcontrato": { nome: "Subcontrato", cor: "#7c3aed" }
  };
  const classificacoes = {
    mono: { nome: "Mono", cor: "#c4434b", bg: "#fce8ea", fg: "#8a1f27", bd: "#e8a8ad" },
    fim_vida: { nome: "Fim de vida", cor: "#475569", bg: "#e3e8ee", fg: "#3d4f63", bd: "#c2cbd5" },
    parado: { nome: "Parado >12m", cor: "#d4a574", bg: "#fbf2e3", fg: "#7a4f12", bd: "#e8c896" },
    geral: { nome: "Stock", cor: "#0369a1", bg: "#e0f2fe", fg: "#0c4a6e", bd: "#bae6fd" }
  };
  const RAW = [
    ["110D138528098A0", "Cx Mod 201 385x280x98 0D1 NI(10485) CC", 385, 280, 98, "201", "CART\xC3O", "PA", 4999, 1001, 0, "2025-01-20", "2026-02-05", 0, 0, 1, "EUROPASTRY PORTUGAL S.A.", 5751, "Produ\xE7\xE3o", 0.45903, 2294.69, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10485)%20V1r2.pdf"],
    ["110D620015052A0", "Cx Mod 422 200x150x52 0D6 NI(11625) CC", 200, 150, 52, "422", "CART\xC3O", "PA", 130, 1, 0, "2025-09-16", "2025-09-23", 0, 0, 0, "NEVSTA - PAPER & TECNOLOGY, LDA.", 2218, "Produ\xE7\xE3o", 0.2527, 32.85, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(11625)%20R0.pdf"],
    ["112A832050320A0", "Cx Mod 203 320x50x320 2A8", 320, 50, 320, "203", "CART\xC3O", "ME", 400, 1, 0, "2021-12-06", "2021-09-23", 0, 0, 0, "ERNESTO GRILO SUCESSORS, LDA", 2483, "Compra", 0.33, 132, "06", null],
    ["112A8772380107A0", "Cx Mod 423 772x380x107 2A8 NI(2561)", 772, 380, 107, "423", "CART\xC3O", "ME", 820, 1, 0, "2022-06-28", "2023-01-04", 0, 0, 1, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Compra", 0.64835, 531.65, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(2561)%20mapa%20N%C2%BA2561.pdf"],
    ["112B7320276325A0", "Cx Mod 201 330x285x326 2B7", 320, 276, 325, "201", "CART\xC3O", "PA", 250, 1, 0, "2023-07-05", "2023-07-05", 0, 0, 0, "NILORN PORTUGAL - IND\xDASTRIA DE ETIQUETAS", 2e3, "Produ\xE7\xE3o", 0.42258, 105.65, "21", null],
    ["112B91195794100A1", "Cx Mod 422 1195x794x100 2B9 NI(5962) CC", 1195, 794, 100, "422", "CART\xC3O", "PA", 147, 1, 0, "2023-09-11", "2025-09-24", 0, 0, 0, "BRAMP - METAIS E POLIMEROS DE BRAGA", 2002, "Produ\xE7\xE3o", 1.00288, 147.42, "21", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/22-00709-03%20Ni(5962)%20V1r0.pdf"],
    ["112B9595364290A0", "Cx Mod 201 595x364x290 2B9 EM360 CC", 595, 364, 290, "201", "CART\xC3O", "PA", 656, 1, 0, "2026-05-12", "2026-02-11", 1, 0, 0, "EMBALAGENS CARLOS M. GON\xC7ALVES", 3150, "Produ\xE7\xE3o", 0.76772, 503.62, "08", null],
    ["112C01140980710A0", "Contentor 1140x980x710 NI(4114)", 1140, 980, 710, "200", "CART\xC3O", "PA", 23, 1, 0, "2025-02-04", "2024-07-05", 0, 0, 0, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Produ\xE7\xE3o", 29.07121, 668.64, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(c4114)_assembly.pdf"],
    ["113A6200200200A0", "Cx Mod 201 200x200x200 3A6 + imp", 200, 200, 200, "201", "CART\xC3O", "PA", 11, 360, 0, "2026-03-17", "2026-03-18", 0, 0, 0, "360 IMPRIMIR SL", 11431, "Produ\xE7\xE3o", 0.4605, 5.07, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/JNEVES-46011.pdf"],
    ["113A638030085A0", "Cx Mod 451 380x300x85 3A6 NI(4200)", 380, 300, 85, "451", "CART\xC3O", "ME", 780, 1, 0, "2024-07-18", "2025-02-10", 0, 0, 1, "EUROPASTRY PORTUGAL S A", 5751, "Compra", 0.17535, 136.77, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(4200)%20dias%20Tampo.pdf"],
    ["113A6390290280", "Cx Mod 201 390x290x280 3A6 + imp", 390, 290, 280, "201", "CART\xC3O", "PA", 18, 360, 0, "2026-01-22", "2026-01-21", 0, 0, 0, "360 IMPRIMIR SL", 11431, "Produ\xE7\xE3o", 0.34896, 6.28, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/JNEVES-44933.pdf"],
    ["114A0394292191A0", "Cx Mod 201 394x292x191 4A0 + imp", 394, 292, 191, "201", "CART\xC3O", "PA", 4, 360, 0, "2026-02-09", "2026-02-10", 0, 0, 0, "BINARY SUBJECT, SA", 10903, "Produ\xE7\xE3o", 0.99059, 3.96, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/JNEVES-45385.pdf"],
    ["112A8225174195A0", "Cx Mod 200 225x175x195 2A8 CC", 225, 174, 195, "200", "CART\xC3O", "PA", 268, 1, 0, "2026-01-19", "2026-01-28", 0, 0, 0, "ANT\xD3NIO AUGUSTO CORREIA, LDA", 2931, "Produ\xE7\xE3o", 0.10387, 27.84, "06", null],
    ["112A8225180165A0", "Cx Mod 200 225x180x165 2A8 NI(12348) CC", 225, 180, 165, "200", "CART\xC3O", "PA", 460, 1, 0, "2026-01-21", "2026-01-30", 0, 0, 0, "ANT\xD3NIO AUGUSTO CORREIA, LDA", 2931, "Produ\xE7\xE3o", 0.10595, 48.74, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(12348)%20R0%20tampo.pdf"],
    ["112C01120780935A2", "Contentor 1120x780x935 2C0 NI(5675) MAN 165", 1120, 780, 935, "200", "CART\xC3O", "PA", 13, 1, 0, "2025-12-22", "2026-02-10", 0, 0, 0, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Produ\xE7\xE3o", 41.04491, 533.58, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(c5675)%20V2.pdf"],
    ["112C01184782960A1", "Contentor 184x782x960 2C0 NI(9465)", 1184, 782, 960, "200", "CART\xC3O", "PA", 5, 8, 0, "2026-02-16", "2026-03-11", 0, 0, 0, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Produ\xE7\xE3o", 39.91068, 199.55, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(9465)%20R1.pdf"],
    ["112C015401136700A0", "Cx Mod 501 1540x1136x700 2C0 NI(8970)", 1540, 1136, 700, "501", "CART\xC3O", "PA", 78, 1, 0, "2023-02-22", "2023-02-15", 0, 0, 0, "STOCK-Jos\xE9 Neves", 2193, "Produ\xE7\xE3o", 6.73765, 525.54, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(8970)%20V1r0.pdf"],
    ["112C9575386310A0", "Cx Mod 200 575x386x310 2C9 NI(8453)", 575, 386, 310, "200", "CART\xC3O", "PA", 160, 1, 0, "2024-08-20", "2024-12-10", 0, 0, 1, "INOVEPLASTIKA - INOVA\xC7\xC3O E TECNOLOGIA", 9084, "Produ\xE7\xE3o", 0.77134, 123.41, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(8453)%20V1r0.pdf"],
    ["113A8375344140A0", "Cx Mod 201 380x350x145 3A8 NI(5136)", 375, 344, 140, "201", "CART\xC3O", "PA", 5205, 1, 0, "2026-01-06", "2026-01-20", 0, 1, 1, "NEVSTA - PAPER & TECNOLOGY, LDA.", 2218, "Produ\xE7\xE3o", 0.33842, 1761.48, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(5136)%20V1r0.pdf"],
    ["113B8630354290A0", "Cx Mod 471 630x354x290 3B8 NI(11470) CC", 630, 354, 290, "471", "CART\xC3O", "PA", 81, 1, 0, "2025-08-19", "2025-07-30", 0, 0, 0, "MECALBI - ENGINEERING SOLUTIONS", 15082, "Produ\xE7\xE3o", 6.53893, 529.65, "29", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(11470)%20R0.pdf"],
    ["114A0120120676A0", "Cx Mod 201 120x120x670 4A0 NI(9557) CC", 120, 120, 676, "201", "CART\xC3O", "PA", 13, 1, 0, "2025-04-23", "2025-05-20", 0, 0, 1, "DINAK S.A.", 3165, "Produ\xE7\xE3o", 0.67591, 8.79, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9557)%20V1r0.pdf"],
    ["114A0200100100A3", "Cx Mod 427 200x100x100 4A0 GI", 200, 100, 100, "427", "CART\xC3O", "PA", 1882, 360, 0, "2023-01-19", "2026-03-09", 0, 0, 1, "BINARY SUBJECT, SA", 10903, "Produ\xE7\xE3o", 0.23888, 449.57, "05", null],
    ["116C2585386305A1", "Cx Mod 200 585x386x305 6C2 NI(4563)", 585, 386, 305, "200", "CART\xC3O", "PA", 298, 1, 0, "2025-12-12", "2026-03-02", 0, 0, 0, "PPRR-PL\xC1STICOS,SA", 3848, "Produ\xE7\xE3o", 0.57861, 172.43, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(4563)%20V1r1.pdf"],
    ["116C614001140400A0", "Cx Mod 201 1400x1140x400 6C6 NI(9947) CC", 1400, 1140, 400, "201", "CART\xC3O", "PA", 274, 1, 0, "2025-03-13", "2025-03-14", 0, 1, 1, "AQUINOS, SA", 3216, "Produ\xE7\xE3o", 5.04961, 1383.59, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9947)%20V1r0.pdf"],
    ["116C62006786640A1", "Cx Mod 201 2006x786x640 6C6 NI(9875) CC", 2006, 786, 640, "201", "CART\xC3O", "PA", 496, 1, 0, "2026-01-30", "2026-03-13", 0, 0, 1, "AQUINOS, SA", 3216, "Produ\xE7\xE3o", 5.32378, 2640.59, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9875)%20V1r0.pdf"],
    ["117B9890390500A0", "Cx Mod 201 890x390x500 7B9 NI(3582)", 890, 390, 500, "201", "CART\xC3O", "PA", 358, 1, 0, "2025-12-22", "2018-01-04", 1, 0, 0, "CX PARA DIVIS\xD3RIAS KATHREIN", 2193, "Produ\xE7\xE3o", 1.52697, 546.66, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(3582).pdf"],
    ["118A2400208206A0", "Cx Mod 201 400x208x206 8A2", 400, 208, 206, "201", "CART\xC3O", "PA", 1120, 1, 0, "2022-08-17", "2022-08-17", 0, 0, 0, "RAPORAL, SA", 9696, "Produ\xE7\xE3o", 0.32578, 364.87, "29", null],
    ["118A7405204265A1", "Cx Mod 201 410x210x265 8A7 NI(9697) CC", 405, 204, 265, "201", "CART\xC3O", "PA", 4980, 1, 0, "2025-12-17", "2025-12-15", 0, 0, 1, "NEVSTA - PAPER & TECNOLOGY, LDA.", 2218, "Produ\xE7\xE3o", 0.27483, 1368.65, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9697)%20V1r0.pdf"],
    ["118B21150810130A0", "Cx Mod 452 1150x810x130 8B2", 1150, 810, 130, "452", "CART\xC3O", "PA", 48, 1, 0, "2025-07-28", "2026-01-23", 0, 0, 0, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Produ\xE7\xE3o", 1.25322, 60.15, "06", null],
    ["118B2784582245A0", "Cx Mod 201 780x586x250 8B2 NI(1929)", 784, 582, 245, "201", "CART\xC3O", "PA", 335, 1, 0, "2025-02-04", "2025-02-10", 0, 0, 1, "FICO CABLES - F\xC1BRICA DE ACESS\xD3RIOS", 1806, "Produ\xE7\xE3o", 1.99145, 667.14, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(1929)%20V1r0.pdf"],
    ["119B2780580935A2", "Cx Mod 200 800x600x950 9B2 NI(4179)", 780, 580, 935, "200", "CART\xC3O", "PA", 400, 1, 0, "2025-09-15", "2026-04-08", 0, 0, 1, "ALDI RETAIL UNIPESSOAL LDA", 15571, "Produ\xE7\xE3o", 1.72532, 690.13, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/gdd-dt-cart-0.1%20Ni(4179)%20V1rev1.pdf"],
    ["119B361043088A0", "Cx Mod 201 610x430x88 9B3 CC", 610, 430, 88, "201", "CART\xC3O", "PA", 1347, 1, 0, "2025-09-04", "2025-11-17", 0, 0, 1, "BINARY SUBJECT, SA", 10903, "Produ\xE7\xE3o", 0.98771, 1330.45, "05", null],
    ["119B41185986360A0", "Cx Mod 200 1185x986x360 9B4 NI(2522)", 1185, 986, 360, "200", "CART\xC3O", "ME", 23, 1, 0, "2021-08-17", "2022-08-16", 0, 0, 1, "FICO CABLES - F\xC1BRICA DE ACESS\xD3RIOS", 1806, "Compra", 5.21545, 119.96, "06", null],
    ["114A043031050A2", "Cx Mod 426 430x310x50 4A0 GI", 430, 310, 50, "426", "CART\xC3O", "PA", 514, 360, 0, "2025-03-24", "2025-07-08", 0, 0, 1, "360 IMPRIMIR SL", 11431, "Produ\xE7\xE3o", 0.28869, 148.39, "05", null],
    ["116B9200140140A0", "Cx Mod 201 200x140x140 6B9 CC", 200, 140, 140, "201", "CART\xC3O", "PA", 520, 1, 0, "2026-01-07", "2026-01-16", 0, 0, 0, "ALL TO, SA", 2387, "Produ\xE7\xE3o", 0.15252, 79.31, "07", null],
    ["116C61140370280A0", "Cx Mod 201 1140x370x280 6C6 CC", 1140, 370, 280, "201", "CART\xC3O", "PA", 360, 1, 0, "2025-05-12", "2025-05-26", 0, 0, 0, "MCS - TEXTILE SOLUTIONS LDA", 4915, "Produ\xE7\xE3o", 1.40088, 504.32, "06", null],
    ["116C61190490290A0", "Cx Mod 201 1200x500x300 6C6 NI(2970)", 1190, 490, 290, "201", "CART\xC3O", "PA", 92, 1, 0, "2025-09-01", "2025-10-13", 0, 0, 0, "SARRELIBER-TRANSFORMA\xC7\xC3O DE PL\xC1STICOS", 3830, "Produ\xE7\xE3o", 2.25323, 207.3, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(2970)%20KL.pdf"],
    ["117B816681124145A0", "Cx Mod 452 1668x1124x145 7B8", 1668, 1124, 145, "452", "CART\xC3O", "PA", 250, 1, 0, "2025-01-27", "2025-03-27", 0, 0, 1, "TEIJIN AUTOMOTIVE TECHNOLOGIES PORTUGAL", 1627, "Produ\xE7\xE3o", 1.70416, 426.04, "06", null],
    ["117B824441224225A0", "Cx Mod 452 2444x1224x225 7B8", 2444, 1224, 225, "452", "CART\xC3O", "PA", 103, 1, 0, "2024-09-23", "2024-01-12", 0, 1, 0, "PORTCRIL - SOCIEDADE PORTUGUESA", 12112, "Produ\xE7\xE3o", 3.04422, 313.55, "05", null],
    ["117B8340340310A0", "Cx Mod 201 340x340x310 7B8 NI(5207)", 340, 340, 310, "201", "CART\xC3O", "PA", 443, 1, 0, "2021-11-19", "2021-11-22", 0, 0, 0, "JP CERAMICA LDA", 12441, "Produ\xE7\xE3o", 0.37826, 167.57, "21", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(5207)%2021-12424-05%20-%20Ni5207.pdf"],
    ["117B8370340380A0", "Cx Mod 201 370x340x380 7B8 CC", 370, 340, 380, "201", "CART\xC3O", "PA", 234, 1, 0, "2024-07-15", "2024-07-18", 0, 1, 0, "FABRICA DE CAL\xC7ADO PENHA, S.A", 81, "Produ\xE7\xE3o", 0.67111, 157.04, "08", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(5351)%20V1r0.pdf"],
    ["118A7395390220A0", "Cx Mod 201 400x395x220 8A7 NI(8527)", 395, 390, 220, "201", "CART\xC3O", "PA", 614, 1, 0, "2025-12-17", "2026-01-15", 0, 0, 1, "NEVSTA - PAPER & TECNOLOGY, LDA.", 2218, "Produ\xE7\xE3o", 0.45126, 277.07, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(8527)%20V1r0.pdf"],
    ["118B9550464970A0", "Cx Mod 209 550x464x970 8B9 NI(4598)", 550, 464, 970, "209", "CART\xC3O", "PA", 19, 1, 0, "2024-09-23", "2024-10-18", 0, 0, 0, "DINIZ & CRUZ - VESTU\xC1RIO DO HOMEM", 4659, "Produ\xE7\xE3o", 2.64623, 50.28, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/20-06976-02%20Ni(4598)%20V1r3.pdf"],
    ["118C5586386387A0", "Cx Mod 201 600x400x400 8C5 NI(4557)", 584, 384, 384, "201", "CART\xC3O", "PA", 100, 1, 0, "2022-10-21", "2026-05-07", 0, 0, 1, "BORGWARNER VIANA, LDA", 13675, "Produ\xE7\xE3o", 1.10885, 110.89, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/21-09933-04%20_ni(4557)%20V1r1.pdf"],
    ["119B215801180150A0", "Cx Mod 452 1580x1180x150 9B2 CC", 1580, 1180, 150, "452", "CART\xC3O", "PA", 133, 1, 0, "2024-06-27", "2024-07-12", 0, 0, 1, "EUROSTYLE SYSTEMS PORTUGAL", 9077, "Produ\xE7\xE3o", 2.19556, 292.01, "06", null],
    ["119B27805801185A1", "Cx Mod 200 800x600x1200 9B2 NI(4178)", 780, 580, 1185, "200", "CART\xC3O", "PA", 320, 1, 0, "2025-05-26", "2025-06-23", 0, 0, 0, "COINDU - COMPONENTES AUTOM\xD3VEL, SA", 709, "Produ\xE7\xE3o", 2.71059, 867.39, "33", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/Ni(4178)%20V1rev1.pdf"],
    ["119B51109744950A0", "Cx Mod 200 1120x760x960 9B5 NI(3202)", 1109, 744, 950, "200", "CART\xC3O", "PA", 38, 1, 0, "2025-04-01", "2025-12-09", 0, 0, 1, "FICO CABLES - F\xC1BRICA DE ACESS\xD3RIOS", 1806, "Produ\xE7\xE3o", 5.50308, 209.12, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(3202)%20V1r1.pdf"],
    ["120D138528098A0", "Cx Mod 201 380x280x98 0D1 NI(11316) CC", 380, 280, 98, "201", "CART\xC3O", "PA", 3165, 1, 0, "2025-03-11", "2025-03-18", 0, 0, 1, "EUROPASTRY PORTUGAL S A", 5751, "Produ\xE7\xE3o", 0.42882, 1357.22, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(11316)%20R0.pdf"],
    ["120D6764492I1", "Conj Div 764x492+554x110 0D6 NI(10020) CC", 764, 492, 0, "", "CART\xC3O", "PA", 91, 1, 0, "2026-01-23", "2026-02-11", 0, 0, 0, "QV SERVICES UNIPESSOAL LDA", 14487, "Produ\xE7\xE3o", 0.52021, 47.34, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10020)%20R2.pdf"],
    ["120D018090", "Placa Favo 180x90x30", 180, 90, 0, "", "CART\xC3O", "MP", 59310, 1, 0, "2026-04-15", "2026-03-04", 0, 0, 0, "STOCK-Jos\xE9 Neves", 2193, "Compra", 0.06143, 3643.41, "05", null],
    ["121A1950710", "Placa E-TB1A1TL 950x710 1A1", 950, 710, 0, "", "CART\xC3O", "MP", 475, 1, 0, "2025-07-02", "2025-07-11", 0, 0, 0, "360 IMPRIMIR SL", 11431, "Compra", 0.30066, 142.81, "05", null],
    ["122A812001200", "Placa 1200x1200 2A8", 1200, 1200, 0, "", "CART\xC3O", "ME", 1700, 1001, 0, "2026-05-18", "2025-11-14", 1, 0, 0, "S.P.C. - SERVICO PORTUGUES DE CONTENTORES", 15411, "Compra", 0.48657, 827.17, "07", null],
    ["122A846050I1", "Conj. Divis\xF3rias 460x50 2A8 + 250x50 NI(4568)", 460, 50, 0, "", "CART\xC3O", "PA", 5e3, 1, 0, "2025-09-23", "2025-10-24", 0, 1, 0, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Subcontrato", 0.38, 1900, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(4568)%20V1r0.pdf"],
    ["122A8840590I3", "Placa 840x590 2A8 NI(9941) CC", 840, 590, 0, "", "CART\xC3O", "PA", 103, 1, 0, "2025-05-08", "2025-05-15", 0, 0, 0, "MUNDO NOTE - PAPELARIA", 14250, "Produ\xE7\xE3o", 0.20467, 21.08, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9941)%20V1r0.pdf"],
    ["122C020001000", "Placa BCA-KR2C0KR 2000x1000 2C0", 2e3, 1e3, 0, "", "CART\xC3O", "ME", 23, 1, 0, "2024-05-06", "2025-11-18", 0, 0, 0, "LABORAT\xD3RIO DA PAISAGEM", 13753, "Compra", 2.156, 49.59, "23", null],
    ["123A61060424", "Placa B-KR3A6TL 1060x424 3A6 GI", 1060, 424, 0, "", "CART\xC3O", "MP", 710, 1, 0, "2026-03-11", "2026-03-05", 1, 0, 0, "360 IMPRIMIR SL", 11431, "Compra", 0.17316, 122.94, "05", null],
    ["123A6370315", "Conj. Div. 370x315+276x315 3A6", 370, 315, 0, "", "CART\xC3O", "PA", 886, 360, 0, "2026-04-30", "2026-03-12", 1, 0, 0, "360 IMPRIMIR SL", 11431, "Produ\xE7\xE3o", 0.30607, 271.18, "05", null],
    ["123A6980384", "Placa B-KR3A6TL 980x384 3A6 GI", 980, 384, 0, "", "CART\xC3O", "MP", 1038, 360, 0, "2024-11-27", "2026-03-18", 1, 0, 0, "360 IMPRIMIR SL", 11431, "Compra", 0.17645, 183.16, "05", null],
    ["123A7340266I1", "Placa 340x265 3A7 NI(4105)", 340, 266, 0, "", "CART\xC3O", "PA", 5098, 1, 0, "2023-10-20", "2024-04-02", 0, 1, 1, "CONTINENTAL ADVANCED ANTENNA", 9110, "Produ\xE7\xE3o", 0.12089, 616.3, "33", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(4105)%2019-08271-01%20V1rev0.pdf"],
    ["126A010401550", "Placa B-WT6A0KR 1040x1550 6A0", 1040, 1550, 0, "", "CART\xC3O", "MP", 358, 360, 0, "2024-04-03", "2026-02-09", 0, 0, 0, "DOURECA PRODUTOS PL\xC1STICOS, LDA.", 4433, "Compra", 0.85704, 306.82, "06", null],
    ["127B93601096I1", "Placa 360x1096 7B9 NI(11377) CC", 360, 1096, 0, "", "CART\xC3O", "PA", 111, 1, 0, "2025-03-19", "2025-05-15", 0, 0, 1, "DOMINIO CULINARIO UNIPESSOAL LDA", 13591, "Produ\xE7\xE3o", 0.37896, 42.06, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(11377)%20R1.pdf"],
    ["128A423001400", "Placa C-TL8A4TL 2300x1400 8A4", 2300, 1400, 0, "", "CART\xC3O", "MP", 150, 1, 0, "2025-02-12", "2026-03-25", 0, 0, 0, "AUMOVIO ADVANCED ANTENNA", 9110, "Compra", 1.54669, 232, "33", null],
    ["203BBR700022", "Bob Papel Seda 700 BR 22 CC", 0, 0, 0, "", "PAPEL", "ME", 8118, 1, 0, "2025-08-25", "2026-01-05", 0, 0, 0, "A GRAFICA LIXA LDA", 5833, "Compra", 2.15348, 17481.95, "08", null],
    ["203BBR750022", "Bob Papel Seda 750 BR 22 CC", 0, 0, 0, "", "PAPEL", "ME", 1924, 1, 0, "2025-08-25", "2025-11-05", 0, 0, 0, "A GRAFICA LIXA LDA", 5833, "Compra", 2.15534, 4146.87, "08", null],
    ["204BCA3500120MP", "Papel Testliner 0350 CA 120 MP CC", 0, 0, 0, "", "PAPEL", "MP", 1700, 1001, 0, "2019-05-27", "2023-11-23", 0, 0, 0, "DS SMITH PACKAGING GALICIA, S.A.", 9863, "Compra", 0.44, 748, "05", null],
    ["221FCA260180120", "Envelope Almofadado Papel 180x260 CA Nr. 4 CC", 0, 0, 0, "", "PAPEL", "ME", 1018, 360, 0, "2026-05-04", "2026-03-17", 1, 0, 0, "ITZWOOD - SOLU\xC7\xD5ES TECNOLOGICAS LDA", 14295, "Compra", 0.08992, 91.54, "33", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10114)%20V1r0.pdf"],
    ["221FCA330240120", "Envelope Almofadado Papel 240x330 CA Nr. 7 CC", 0, 0, 0, "", "PAPEL", "ME", 14500, 1, 0, "2025-03-06", "2025-12-17", 1, 0, 0, "NEVSTA - PAPER & TECNOLOGY, LDA.", 2218, "Compra", 0.14015, 2032.18, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10116)%20V1r0.pdf"],
    ["31A35025040AZ", "Saco PE 350x250 - 40my AZ", 0, 0, 0, "", "PL\xC1STICO", "ME", 34, 1, 0, "2024-11-13", "2024-11-14", 0, 0, 0, "TECLENAJUNCOR, S.A.", 15025, "Compra", 16.1, 547.4, "29", null],
    ["352498012TR", "Filme Estir\xE1vel Auto 500 - 12my K777", 0, 0, 0, "", "PL\xC1STICO", "ME", 592, 8, 0, "2026-03-11", "2026-03-12", 0, 0, 0, "SPIRALPACK - MANIPULADORES DE PAPEL", 4640, "Compra", 1.9306, 1142.92, "06", null],
    ["377981470TR", "Tampa PET 147x98x28", 0, 0, 0, "", "PL\xC1STICO", "ME", 6, 1, 0, "2018-05-15", "2021-07-30", 0, 1, 0, "VIOLETFUTURE UNIPESSOAL LDA", 13043, "Compra", 14.45388, 86.72, "08", null],
    ["4A38CA4850I195", "Fita Ades. PAPEL CA 48x50 NI(11819) CC", 0, 0, 0, "", "FITAS", "PA", 1296, 1, 0, "2026-03-26", "2026-03-18", 0, 0, 0, "RAJAPACK UNIPESSOAL LDA", 15302, "Produ\xE7\xE3o", 0.9771, 1266.32, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(11819)%20R0.pdf"],
    ["4T44AZ5033", "Fita PVC T/60760 AZ 50x33", 0, 0, 0, "", "FITAS", "ME", 18, 1, 0, "2022-03-21", "2021-07-12", 0, 0, 0, "COINDU - COMPONENTES AUTOM\xD3VEL, SA", 709, "Compra", 7.89, 142.02, "33", null],
    ["NVSEMGF10001", "M\xE1quina de Fita Gomada", 0, 0, 0, "", "OUTROS", "ME", 31, 1, 0, "2024-10-02", "2026-02-23", 0, 0, 0, "LONGLIFE - SABOARIA ARTESANAL", 15177, "Compra", 959.02566, 29729.8, "29", null],
    ["NVSEDFS40001F", "Dispensador Ngreen Wrapper Hexa Double", 0, 0, 0, "", "OUTROS", "ME", 41, 1, 0, "2024-04-23", "2024-04-04", 0, 0, 0, "ALL TO, SA", 2387, "Compra", 42.3, 1734.3, "07", null],
    ["117C2383290291A0", "Cx Mod 201 383x290x291 7C2 NI(9758) CC", 383, 290, 291, "201", "CART\xC3O", "PA", 4712, 1, 0, "2025-05-23", "2025-06-17", 0, 0, 0, "ASCENZA AGRO, S.A", 4686, "Produ\xE7\xE3o", 1.27707, 6017.55, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9758)%20R1.pdf"],
    ["118A3490284385A0", "Cx Mod 201 490x284x385 8A4 NI(10710) CC", 490, 284, 385, "201", "CART\xC3O", "PA", 4623, 1, 0, "2026-01-06", "2026-03-03", 0, 0, 1, "A JOANINHA DOIS - PASTELARIA", 15545, "Produ\xE7\xE3o", 0.48189, 2227.78, "08", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10710)%20V1r0.pdf"],
    ["118A3575368260A0", "Cx Mod 201 585x380x260 8A3 NI(9419) CC", 575, 368, 260, "201", "CART\xC3O", "PA", 19162, 1, 0, "2026-01-06", "2026-01-22", 0, 0, 1, "NEVSTA - PAPER & TECNOLOGY, LDA.", 2218, "Produ\xE7\xE3o", 0.54039, 10354.95, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9419)%20V1r0.pdf"],
    ["118A7390390360A0", "Cx Mod 201 390x390x360 8A7 NI(10786) CC", 390, 390, 360, "201", "CART\xC3O", "PA", 3374, 1, 0, "2025-12-16", "2026-03-17", 0, 0, 0, "A JOANINHA DOIS - PASTELARIA", 15545, "Produ\xE7\xE3o", 0.53617, 1809.04, "08", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10786)%20V1r0.pdf"],
    ["113B61184756103A1", "Conj. Cx Mod 451 1184x756x103 3B6 + Palete NI(10477)", 1184, 756, 103, "451", "CART\xC3O", "ME", 48, 8, 0, "2025-08-12", "2026-02-23", 0, 0, 0, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Produ\xE7\xE3o", 9.19369, 441.3, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(10477)%20R2.pdf"],
    ["119B3164510981000A", "Cx Mod 200 1645x1098x1000 9B3 NI(5001)", 1645, 1098, 1e3, "200", "CART\xC3O", "PA", 8, 1, 0, "2026-02-23", "2026-03-12", 0, 0, 0, "TEIJIN AUTOMOTIVE TECHNOLOGIES PORTUGAL", 1627, "Produ\xE7\xE3o", 7.2171, 57.74, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(5001)%20V1r0%20Cx.pdf"],
    ["119B316681124145A0", "Cx Mod 452 1668x1124x145 9B3", 1668, 1124, 145, "452", "CART\xC3O", "PA", 39, 1, 0, "2026-01-29", "2026-03-12", 0, 0, 1, "TEIJIN AUTOMOTIVE TECHNOLOGIES PORTUGAL", 1627, "Produ\xE7\xE3o", 2.46055, 95.96, "06", null],
    ["119B34204201130A0", "Cx Mod 200 420x420x1130 9B3 NI(12033) CC", 420, 420, 1130, "200", "CART\xC3O", "PA", 150, 1, 0, "2025-10-09", "2025-10-15", 0, 0, 1, "NOVAQUI - EQUIPAMENTOS E MOBILI\xC1RIO", 15337, "Produ\xE7\xE3o", 1.76799, 265.2, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(12033)%20R0.pdf"],
    ["119B51000820240A0", "Cx Mod 402 1000x820x240 9B5 NI(8995) CC", 1e3, 820, 240, "402", "CART\xC3O", "PA", 238, 1, 0, "2026-04-22", "2026-01-30", 0, 0, 0, "STOCK-Jos\xE9 Neves", 2193, "Produ\xE7\xE3o", 2.2192, 528.17, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(8995)%20V1r0.pdf"],
    ["111A721514855A2", "Cx Mod 427 215x148x55 1A7 NI(10350) CC", 215, 148, 55, "427", "CART\xC3O", "PA", 4200, 1, 0, "2025-05-07", "2025-06-13", 0, 0, 0, "BEAUTY SLEEP LDA", 13039, "Produ\xE7\xE3o", 0.22707, 953.69, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10350)%20V1r3.pdf"],
    ["114A0170170100A0", "Cx Mod 427 170x170x100 4A0 NI(9565) CC", 170, 170, 100, "427", "CART\xC3O", "PA", 455, 1, 0, "2025-04-23", "2025-04-29", 0, 0, 1, "DINAK S.A.", 3165, "Produ\xE7\xE3o", 0.58326, 265.38, "05", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9565)%20V1r0.pdf"],
    ["116B9220108380A0", "Cx Mod 201 240x120x380 6B9 NI(10595) CC", 220, 108, 380, "201", "CART\xC3O", "PA", 625, 1, 0, "2024-06-27", "2025-05-12", 0, 0, 0, "FRANQUIMAIL - SERVI\xC7OS DE APOIO", 14854, "Produ\xE7\xE3o", 0.36758, 229.74, "28", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(10595)%20V1r0.pdf"],
    ["118A3535274260A0", "Cx Mod 201 535x274x260 8A3 NI(5460) CC", 535, 274, 260, "201", "CART\xC3O", "PA", 4710, 1, 0, "2026-01-06", "2026-05-19", 0, 0, 1, "AUTO SILVA ACESSORIOS S A", 8992, "Produ\xE7\xE3o", 0.40628, 1913.58, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(5460)%20V1r0.pdf"],
    ["118A4385280204A0", "Cx Mod 201 385x280x204 8A4 NI(11956) CC", 385, 280, 204, "201", "CART\xC3O", "PA", 4299, 1, 0, "2025-12-04", "2025-11-24", 0, 1, 0, "EUROPASTRY PORTUGAL S.A.", 5751, "Produ\xE7\xE3o", 0.37025, 1591.7, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(11956)%20R2.pdf"],
    ["112C01118778930A0", "Cx Mod 200 1118x778x930 2C0 NI(5676)", 1118, 778, 930, "200", "CART\xC3O", "PA", 79, 1, 0, "2026-01-05", "2026-01-23", 0, 0, 0, "BORGWARNER EMISSIONS SYSTEMS PORTUGAL", 3349, "Produ\xE7\xE3o", 9.54544, 754.09, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(5676)%20V1r0.pdf"],
    ["117B9788588505A1", "Cx Mod 201 793x594x505 7B9 NI(9315)", 788, 588, 505, "201", "CART\xC3O", "PA", 65, 1, 0, "2024-10-15", "2024-11-14", 0, 0, 0, "CONTINENTE HIPERMERCADOS SA", 11839, "Produ\xE7\xE3o", 1.81385, 117.9, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(9315)%20V2.pdf"],
    ["113A660038680A6", "Cx Mod 451 600x385x80 3A6 NI(12330) CC", 600, 386, 80, "451", "CART\xC3O", "PA", 3885, 1, 0, "2026-01-22", "2026-05-04", 0, 0, 1, "EUROPASTRY PORTUGAL S.A.", 5751, "Produ\xE7\xE3o", 0.20049, 778.9, "07", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/NI(12330)%20R0.pdf"],
    ["116C6880440595A0", "Cx Mod 202 880x440x595 6C6 NI(11360) CC", 880, 440, 595, "202", "CART\xC3O", "PA", 75, 1001, 0, "2025-12-15", "2026-01-06", 0, 1, 0, "AQUINOS, SA", 3216, "Produ\xE7\xE3o", 3.0205, 226.54, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(11360)%20R0.pdf"],
    ["118B615851064545A0", "Cx Mod 200 1585x1064x545 8B6 NI(8884) CC", 1585, 1064, 545, "200", "CART\xC3O", "PA", 416, 1, 0, "2024-06-18", "2025-02-25", 0, 1, 1, "AQUINOS, SA", 3216, "Produ\xE7\xE3o", 5.20522, 2165.37, "06", "https://josenevespt.sharepoint.com/sites/JN-DT/Documentos%20Partilhados/DT/ni(8884)%20V1r3.pdf"],
    ["129B532002000", "Placa BC-KR9B5KR 3200x2000 9B5", 3200, 2e3, 0, "", "CART\xC3O", "MP", 172, 1, 0, "2025-06-20", "2025-09-09", 1, 0, 0, "AQUINOS, SA", 2193, "Compra", 6.96565, 1198.09, "05", null],
    ["12B505", "Bobine Cart\xE3o Can 0500x46mts", 0, 505, 0, "", "CART\xC3O", "ME", 1766, 1, 0, "2026-03-04", "2026-05-22", 0, 0, 1, "LINGOTE ALUMINIOS, S.A.", 4442, "Compra", 1.68, 2968.06, "08", null]
  ];
  function hash(s) {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619);
    return Math.abs(h);
  }
  function rand(seed, max) {
    return hash(String(seed)) % max;
  }
  function parseDate(s) {
    if (!s) return null;
    return /* @__PURE__ */ new Date(s + "T00:00:00");
  }
  function classifyFlags(mono, fimVida, stockGeral, ultimaSaida) {
    const tags = [];
    if (mono) tags.push("mono");
    if (fimVida) tags.push("fim_vida");
    if (stockGeral) tags.push("geral");
    if (ultimaSaida) {
      const meses = (Date.now() - ultimaSaida.getTime()) / (1e3 * 60 * 60 * 24 * 30.4);
      if (meses > 12) tags.push("parado");
    }
    return tags;
  }
  const referencias = RAW.map((row, i) => {
    const [
      ref,
      design,
      c,
      l,
      h,
      fefco,
      tipoArtigo,
      familia,
      stock,
      armazem,
      encAbertas,
      ultEntradaStr,
      ultSaidaStr,
      stockGeral,
      mono,
      fimVida,
      ultCliente,
      nUltCli,
      tipoAquis,
      custoPond,
      totalA1,
      vendedorCod,
      url
    ] = row;
    const ultimaEntrada = parseDate(ultEntradaStr);
    const ultimaSaida = parseDate(ultSaidaStr);
    const flags = classifyFlags(mono, fimVida, stockGeral, ultimaSaida);
    const primaryTag = flags.includes("mono") ? "mono" : flags.includes("fim_vida") ? "fim_vida" : flags.includes("parado") ? "parado" : flags.includes("geral") ? "geral" : null;
    const stProb = rand(ref + "st" + i, 100);
    const estado = stProb < 40 ? "por_tratar" : stProb < 65 ? "em_progresso" : stProb < 80 ? "aguarda" : stProb < 92 ? "resolvido" : "descartado";
    const atrProb = rand(ref + "at" + i, 100);
    const atribuido = atrProb < 55 ? null : vendedores[rand(ref + "atv" + i, vendedores.length)].id;
    const niMatch = design.match(/NI\((\d+)\)/);
    const niNumber = niMatch ? niMatch[1] : null;
    const temCC = / CC$/.test(design) || / CC /.test(design);
    const temImp = /\+\s*imp/i.test(design);
    const acoes = gerarAcoes(ref + i, atribuido, estado);
    return {
      id: i + 1,
      codigo: ref.trim(),
      descricao: design.trim(),
      c,
      l,
      h,
      fefco: fefco || null,
      tipoArtigo,
      familia,
      stock,
      armazem,
      encAbertas,
      ultimaEntrada,
      ultimaSaida,
      stockGeral: !!stockGeral,
      mono: !!mono,
      fimVida: !!fimVida,
      ultimoCliente: ultCliente,
      nUltimoCliente: nUltCli,
      tipoAquis,
      custoPond,
      valor: totalA1,
      vendedorCod,
      url,
      niNumber,
      temCC,
      temImpressao: temImp,
      flags,
      primaryTag,
      estado,
      atribuido,
      observacoes: "",
      acoes
    };
  });
  function gerarAcoes(seed, atrib, estado) {
    if (estado === "por_tratar") return [];
    const n = 1 + rand(seed + "na", 4);
    const out = [];
    for (let i = 0; i < n; i++) {
      const t = tiposAcao[rand(seed + "ta" + i, tiposAcao.length - 1)];
      const aut = atrib || vendedores[rand(seed + "aut" + i, vendedores.length)].id;
      const dias = (n - i) * (3 + rand(seed + "di" + i, 10));
      const d = /* @__PURE__ */ new Date();
      d.setDate(d.getDate() - dias);
      out.push({
        id: "a" + seed + i,
        tipo: t.id,
        tipoNome: t.nome,
        autor: aut,
        criadoEm: d,
        descricao: descAcao(t.id, seed + i)
      });
    }
    return out.reverse();
  }
  function descAcao(tipo, seed) {
    const opts = {
      email: ["Enviado e-mail com proposta de stock", "Follow-up sem resposta", "E-mail com lista de monos em armaz\xE9m"],
      tel: ["Cliente indispon\xEDvel, deixei recado", "Falei com respons\xE1vel de compras", "Cliente vai analisar com a equipa"],
      visita: ["Visita ao armaz\xE9m do cliente", "Reuni\xE3o presencial com diretor de compras"],
      proposta: ["Proposta com desconto 15% sobre tabela", "Enviada proposta de venda em lote"],
      reuniao: ["Discuss\xE3o interna sobre op\xE7\xF5es", "Alinhamento com produ\xE7\xE3o"],
      desconto: ["Aplicado desconto adicional 8%", "Negociado pre\xE7o especial"],
      venda_alt: ["Encontrado cliente alternativo c/ necessidade similar"]
    };
    const arr = opts[tipo] || ["A\xE7\xE3o registada"];
    return arr[rand(seed, arr.length)];
  }
  function kpis() {
    const total = referencias.length;
    const valorTotal = referencias.reduce((s, r) => s + r.valor, 0);
    const porTag = {};
    Object.keys(classificacoes).forEach((k) => {
      const refs = referencias.filter((r) => r.flags.includes(k));
      porTag[k] = { count: refs.length, valor: refs.reduce((s, r) => s + r.valor, 0) };
    });
    const porFamilia = {};
    Object.keys(familias).forEach((k) => {
      const refs = referencias.filter((r) => r.familia === k);
      porFamilia[k] = { count: refs.length, valor: refs.reduce((s, r) => s + r.valor, 0) };
    });
    const porArtigo = {};
    Object.keys(tiposArtigo).forEach((k) => {
      const refs = referencias.filter((r) => r.tipoArtigo === k);
      if (refs.length > 0) porArtigo[k] = { count: refs.length, valor: refs.reduce((s, r) => s + r.valor, 0) };
    });
    const porVendedor = vendedores.map((v) => {
      const refs = referencias.filter((r) => r.atribuido === v.id);
      return {
        ...v,
        count: refs.length,
        valor: refs.reduce((s, r) => s + r.valor, 0),
        porTratar: refs.filter((r) => r.estado === "por_tratar").length,
        resolvidos: refs.filter((r) => ["resolvido", "descartado"].includes(r.estado)).length
      };
    });
    const naoAtribuidas = referencias.filter((r) => !r.atribuido).length;
    return { total, valorTotal, porTag, porFamilia, porArtigo, porVendedor, naoAtribuidas };
  }
  const fefcos = [...new Set(referencias.map((r) => r.fefco).filter(Boolean))].sort();
  const clientesUnicos = [...new Set(referencias.map((r) => r.ultimoCliente).filter(Boolean))].sort();
  return {
    vendedores,
    comerciais: vendedores,
    // alias retro-compatível
    estados,
    tiposAcao,
    tiposArtigo,
    familias,
    tiposAquisicao,
    classificacoes,
    fefcos,
    clientesUnicos,
    referencias,
    kpis: kpis()
  };
})();

// ===== router.js =====
function _toParams(p) {
  if (!p) return new URLSearchParams();
  if (p instanceof URLSearchParams) return new URLSearchParams(p);
  return new URLSearchParams(
    Object.entries(p).filter(([, v]) => v != null && v !== "")
  );
}
function parse(hash) {
  const raw = String(hash || "");
  const qIdx = raw.indexOf("?");
  const path = qIdx === -1 ? raw : raw.slice(0, qIdx);
  const params = new URLSearchParams(qIdx === -1 ? "" : raw.slice(qIdx + 1));
  const withoutHash = path.replace(/^#/, "");
  if (withoutHash && !withoutHash.startsWith("/")) {
    return {
      routeId: null,
      entidade: null,
      params
    };
  }
  const segs = withoutHash.split("/").filter(Boolean);
  const decode = (s) => {
    try {
      return decodeURIComponent(s);
    } catch (_) {
      return s;
    }
  };
  return {
    routeId: segs.length ? decode(segs[0]) : null,
    entidade: segs.length > 1 ? decode(segs[1]) : null,
    params
  };
}
function build({ routeId, entidade, params } = {}) {
  const qs = _toParams(params).toString();
  if (!routeId) return qs ? `#/?${qs}` : "#/";
  let out = "#/" + encodeURIComponent(routeId);
  if (entidade) out += "/" + encodeURIComponent(entidade);
  return qs ? `${out}?${qs}` : out;
}
function current() {
  return parse(window.location.hash);
}
let _escritoPeloRouter = null;
function consumirNavegacaoPropria(hash) {
  if (_escritoPeloRouter === null) return false;
  const escrita = _escritoPeloRouter;
  _escritoPeloRouter = null;
  return escrita === hash;
}
function navigate(to, { replace = false } = {}) {
  const next = build(to);
  if (next === window.location.hash) return;
  _escritoPeloRouter = next;
  if (replace) {
    window.history.replaceState(null, "", next);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  } else {
    window.location.hash = next;
  }
}
function setParams(patch, { replace = true } = {}) {
  const loc = current();
  const params = loc.params;
  for (const [k, v] of Object.entries(patch || {})) {
    if (v == null || v === "") params.delete(k);
    else params.set(k, String(v));
  }
  navigate({ ...loc, params }, { replace });
}
function subscribe(fn) {
  const handler = () => fn(current());
  window.addEventListener("hashchange", handler);
  return () => window.removeEventListener("hashchange", handler);
}
function hubDecidirSaida(guard, hashAnterior, hashNovo) {
  if (typeof guard !== "function") return { sair: true };
  if (!hashAnterior || hashAnterior === hashNovo) return { sair: true };
  let ok = true;
  try {
    ok = guard(hashNovo, hashAnterior) !== false;
  } catch (_) {
    ok = true;
  }
  return ok ? { sair: true } : { sair: false, repor: hashAnterior };
}
window.HubRouter = Object.freeze({
  parse,
  build,
  current,
  navigate,
  setParams,
  subscribe,
  consumirNavegacaoPropria,
  hubDecidirSaida
});

// ===== api.js =====
function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}
async function req(path, { method = "GET", body, params } = {}) {
  const url = new URL(path, window.location.origin);
  if (params) Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== void 0 && v !== "") url.searchParams.set(k, v);
  });
  const headers = { "Content-Type": "application/json" };
  const csrf = getCookie("csrftoken");
  if (csrf && method !== "GET") headers["X-CSRFToken"] = csrf;
  const res = await fetch(url, {
    method,
    headers,
    credentials: "include",
    body: body ? JSON.stringify(body) : void 0
  });
  if (!res.ok) throw new Error(`${method} ${path} \u2192 ${res.status}: ${await res.text()}`);
  if (res.status === 204) return null;
  return res.json();
}
function isNetworkError(e) {
  return !/→ \d+/.test(e && e.message || "");
}
async function valoraUpsert(base, id, body) {
  try {
    return await req(
      `/api/valora/${base}/${encodeURIComponent(id)}/`,
      { method: "PATCH", body }
    );
  } catch (e) {
    if (/→ 404/.test(e.message)) return req(`/api/valora/${base}/`, { method: "POST", body });
    throw e;
  }
}
window.API = {
  isNetworkError,
  me: () => req("/api/auth/me/"),
  updateMe: (patch) => req("/api/auth/me/", { method: "PATCH", body: patch }),
  uploadPhoto: async (file) => {
    const fd = new FormData();
    fd.append("photo", file);
    const csrf = getCookie("csrftoken");
    const r = await fetch("/api/auth/me/", {
      method: "PATCH",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
      credentials: "include",
      body: fd
    });
    if (!r.ok) throw new Error(`PATCH photo \u2192 ${r.status}: ${await r.text()}`);
    return r.json();
  },
  clearPhoto: () => req("/api/auth/me/", { method: "PATCH", body: { photo_clear: "1" } }),
  notifications: () => req("/api/notifications/"),
  notificationsUnread: () => req("/api/notifications/unread_count/"),
  markNotificationRead: (id, isRead) => req(
    `/api/notifications/${id}/`,
    { method: "PATCH", body: { is_read: isRead } }
  ),
  markAllNotificationsRead: () => req("/api/notifications/mark_all_read/", { method: "POST" }),
  deleteNotification: (id) => req(`/api/notifications/${id}/`, { method: "DELETE" }),
  notes: (params) => req("/api/notes/", { params }),
  createNote: (body) => req("/api/notes/", { method: "POST", body }),
  updateNote: (id, patch) => req(`/api/notes/${id}/`, { method: "PATCH", body: patch }),
  deleteNote: (id) => req(`/api/notes/${id}/`, { method: "DELETE" }),
  followers: (params) => req("/api/followers/", { params }),
  follow: (body) => req("/api/followers/", { method: "POST", body }),
  unfollow: (id) => req(`/api/followers/${id}/`, { method: "DELETE" }),
  anexos: (params) => req("/api/anexos/", { params }),
  addAnexoLink: (body) => req("/api/anexos/", { method: "POST", body }),
  deleteAnexo: (id) => req(`/api/anexos/${id}/`, { method: "DELETE" }),
  uploadAnexo: async (formData) => {
    const csrf = getCookie("csrftoken");
    const r = await fetch("/api/anexos/", {
      method: "POST",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
      credentials: "include",
      body: formData
    });
    if (!r.ok) throw new Error(`POST anexo \u2192 ${r.status}: ${await r.text()}`);
    return r.json();
  },
  savedViews: (params) => req("/api/saved-views/", { params }),
  createSavedView: (body) => req("/api/saved-views/", { method: "POST", body }),
  updateSavedView: (id, patch) => req(`/api/saved-views/${id}/`, { method: "PATCH", body: patch }),
  deleteSavedView: (id) => req(`/api/saved-views/${id}/`, { method: "DELETE" }),
  featureConfig: () => req("/api/features/config/"),
  featureMatrix: () => req("/api/features/config/matrix/"),
  saveFeatureMatrix: (body) => req("/api/features/config/matrix/", { method: "PUT", body }),
  anexosSettings: () => req("/api/anexos-settings/"),
  saveAnexosSettings: (body) => req("/api/anexos-settings/", { method: "PUT", body }),
  activityFeed: () => req("/api/activity-feed/"),
  minhasTarefas: () => req("/api/tarefas/"),
  meuCalendario: ({ de, ate }) => req("/api/calendario/", { params: { de, ate } }),
  // Outlook — o meu opt-in pessoal. O motor mudou de casa (SP-C, Task 4) e os
  // endpoints saíram com ele: já não vivem debaixo do prefixo do SCOUT.
  minhaOutlookLigacao: () => req("/api/outlook/ligacao/"),
  ligarOutlook: () => req("/api/outlook/ligacao/", { method: "POST" }),
  desligarOutlook: () => req("/api/outlook/ligacao/", { method: "DELETE" }),
  biStockFacts: () => req("/api/bi/stock-facts/"),
  biDataSources: () => req("/api/bi/datasources/"),
  createBIDataSource: (data) => req("/api/bi/datasources/", { method: "POST", body: data }),
  updateBIDataSource: (id, patch) => req(`/api/bi/datasources/${id}/`, { method: "PATCH", body: patch }),
  deleteBIDataSource: (id) => req(`/api/bi/datasources/${id}/`, { method: "DELETE" }),
  testBIDataSource: (id) => req(`/api/bi/datasources/${id}/test/`, { method: "POST" }),
  biQuery: (datasource, sql, max_rows) => req(
    "/api/bi/query/",
    { method: "POST", body: { datasource, sql, max_rows } }
  ),
  biFornecedores: () => req("/api/bi/fornecedores/"),
  biFornecedoresRatings: () => req("/api/bi/fornecedores-ratings/"),
  biVendas: () => req("/api/bi/vendas/"),
  biServicoLinhas: () => req("/api/bi/servico-linhas/"),
  biServicoFotografias: (params = {}) => {
    const qs = new URLSearchParams();
    for (const k of ["desde", "ate", "fluxo"]) if (params[k]) qs.set(k, params[k]);
    return req("/api/bi/servico-fotografias/?" + qs.toString());
  },
  biSupplierLogos: () => req("/api/bi/supplier-logos/"),
  createBISupplierLogo: (data) => req("/api/bi/supplier-logos/", { method: "POST", body: data }),
  updateBISupplierLogo: (id, patch) => req(`/api/bi/supplier-logos/${id}/`, { method: "PATCH", body: patch }),
  deleteBISupplierLogo: (id) => req(`/api/bi/supplier-logos/${id}/`, { method: "DELETE" }),
  syncBISupplierLogos: () => req("/api/bi/supplier-logos/sync/", { method: "POST" }),
  emailAllBISupplierPdfs: () => req("/api/bi/supplier-logos/email-all/", { method: "POST" }),
  biSupplierEmailSchedule: () => req("/api/bi/supplier-email-schedule/"),
  updateBISupplierEmailSchedule: (patch) => req("/api/bi/supplier-email-schedule/", { method: "PATCH", body: patch }),
  biOtdOpcoes: () => req("/api/bi/otd-opcoes/"),
  updateBIOtdOpcoes: (patch) => req("/api/bi/otd-opcoes/", { method: "PATCH", body: patch }),
  biServicoOpcoes: () => req("/api/bi/servico-opcoes/"),
  updateBIServicoOpcoes: (patch) => req("/api/bi/servico-opcoes/", { method: "PATCH", body: patch }),
  biMesa: (mes) => req("/api/bi/mesa/", { params: { mes } }),
  fecharBIMesa: (mes) => req("/api/bi/mesa/fecho/", { method: "POST", body: { mes } }),
  reabrirBIMesa: (mes) => req("/api/bi/mesa/fecho/", { method: "DELETE", params: { mes } }),
  biMesaPulso: () => req("/api/bi/mesa/pulso/"),
  biMesaTesouraria: () => req("/api/bi/mesa/tesouraria/"),
  biMesaOpcoes: () => req("/api/bi/mesa-opcoes/"),
  biMesaObjetivos: (ano) => req("/api/bi/mesa-objetivos/", { params: { ano } }),
  setBIMesaObjetivo: (b) => req("/api/bi/mesa-objetivos/", { method: "PUT", body: b }),
  updateBIMesaOpcoes: (patch) => req("/api/bi/mesa-opcoes/", { method: "PATCH", body: patch }),
  biReferenciasExcluidas: () => req("/api/bi/referencias-excluidas/"),
  createBIReferenciaExcluida: (data) => req("/api/bi/referencias-excluidas/", { method: "POST", body: data }),
  deleteBIReferenciaExcluida: (id) => req(`/api/bi/referencias-excluidas/${id}/`, { method: "DELETE" }),
  biMotivosAdiamento: () => req("/api/bi/motivos-adiamento/"),
  biMotivosAdiamentoCausas: () => req("/api/bi/motivos-adiamento/causas/"),
  createBIMotivoAdiamento: (data) => req("/api/bi/motivos-adiamento/", { method: "POST", body: data }),
  updateBIMotivoAdiamento: (id, data) => req(`/api/bi/motivos-adiamento/${id}/`, { method: "PATCH", body: data }),
  deleteBIMotivoAdiamento: (id) => req(`/api/bi/motivos-adiamento/${id}/`, { method: "DELETE" }),
  biSupplierRatings: () => req("/api/bi/supplier-ratings/"),
  createBISupplierRating: (data) => req("/api/bi/supplier-ratings/", { method: "POST", body: data }),
  updateBISupplierRating: (id, patch) => req(`/api/bi/supplier-ratings/${id}/`, { method: "PATCH", body: patch }),
  deleteBISupplierRating: (id) => req(`/api/bi/supplier-ratings/${id}/`, { method: "DELETE" }),
  uploadBISupplierLogo: async (id, file) => {
    const fd = new FormData();
    fd.append("logo", file);
    const csrf = getCookie("csrftoken");
    const r = await fetch(`/api/bi/supplier-logos/${id}/`, {
      method: "PATCH",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
      credentials: "include",
      body: fd
    });
    if (!r.ok) throw new Error(`PATCH logo \u2192 ${r.status}: ${await r.text()}`);
    return r.json();
  },
  login: (u, p) => req("/api/auth/login/", { method: "POST", body: { username: u, password: p } }),
  requestPasswordReset: (loginVal) => req("/api/auth/forgot-password/", { method: "POST", body: { login: loginVal } }),
  logout: () => req("/api/auth/logout/", { method: "POST" }),
  catalog: (params) => req("/api/catalog/", { params }),
  // Lookup dirigido a UMA referência (activa ou não — o backend já procura
  // com include_inactive=True). Usado quando um deep link aponta para uma
  // referência que não está na listagem carregada (que só tem activas):
  // 404 → não existe; outro estado (ex. 403 sem acesso) fica para quem
  // chama distinguir na mensagem.
  catalogDetail: (codigo) => req(`/api/catalog/${encodeURIComponent(codigo)}/`),
  estados: () => req("/api/estados/"),
  userTypes: () => req("/api/tipos-utilizador/"),
  createUserType: (data) => req("/api/tipos-utilizador/", { method: "POST", body: data }),
  updateUserType: (slug, patch) => req(`/api/tipos-utilizador/${slug}/`, { method: "PATCH", body: patch }),
  deleteUserType: (slug) => req(`/api/tipos-utilizador/${slug}/`, { method: "DELETE" }),
  // ===== Access Control (Sub-projecto #4) =====
  accessVocab: () => req("/api/access/vocab/"),
  accessRules: (params) => req("/api/administracao/access-rules/", { params }),
  createAccessRule: (data) => req("/api/administracao/access-rules/", { method: "POST", body: data }),
  updateAccessRule: (id, patch) => req(`/api/administracao/access-rules/${id}/`, { method: "PATCH", body: patch }),
  deleteAccessRule: (id) => req(`/api/administracao/access-rules/${id}/`, { method: "DELETE" }),
  teams: () => req("/api/administracao/teams/"),
  createTeam: (data) => req("/api/administracao/teams/", { method: "POST", body: data }),
  updateTeam: (id, patch) => req(`/api/administracao/teams/${id}/`, { method: "PATCH", body: patch }),
  deleteTeam: (id) => req(`/api/administracao/teams/${id}/`, { method: "DELETE" }),
  impersonate: (userId) => req("/api/administracao/impersonate/", { method: "POST", body: { user_id: userId } }),
  stopImpersonate: () => req("/api/administracao/impersonate/stop/", { method: "POST" }),
  impersonateCandidates: (q) => req("/api/administracao/impersonate/candidates/", { params: { q } }),
  // Quadro de desenvolvimentos (Administração)
  devBoard: (params) => req("/api/hivebox/dev-board/", { params }),
  devBoardCard: (id) => req(`/api/hivebox/dev-board/cards/${id}/`),
  devBoardCriarCard: (data) => req("/api/hivebox/dev-board/cards/", { method: "POST", body: data }),
  devBoardEditarCard: (id, patch) => req(`/api/hivebox/dev-board/cards/${id}/`, { method: "PATCH", body: patch }),
  hiveboxCriarMissao: (corpo) => req("/api/hivebox/missoes/", { method: "POST", body: corpo }),
  hiveboxAprovarMissao: (id) => req(`/api/hivebox/missoes/${id}/aprovar/`, { method: "POST" }),
  hiveboxRepetirMissao: (id) => req(`/api/hivebox/missoes/${id}/repetir/`, { method: "POST" }),
  devBoardProgramas: () => req("/api/hivebox/dev-board/programas/"),
  devBoardCriarPrograma: (data) => req("/api/hivebox/dev-board/programas/", { method: "POST", body: data }),
  devBoardEditarPrograma: (id, patch) => req(`/api/hivebox/dev-board/programas/${id}/`, { method: "PATCH", body: patch }),
  devBoardLigar: (cardId, data) => req(`/api/hivebox/dev-board/cards/${cardId}/ligacoes/`, { method: "POST", body: data }),
  devBoardEditarLigacao: (id, patch) => req(`/api/hivebox/dev-board/ligacoes/${id}/`, { method: "PATCH", body: patch }),
  devBoardDesligar: (id) => req(`/api/hivebox/dev-board/ligacoes/${id}/`, { method: "DELETE" }),
  devBoardCriarTarefa: (cardId, titulo) => req(
    `/api/hivebox/dev-board/cards/${cardId}/tarefas/manual/`,
    { method: "POST", body: { titulo } }
  ),
  devBoardEditarTarefa: (cardId, numero, patch) => req(
    `/api/hivebox/dev-board/cards/${cardId}/tarefas/${numero}/`,
    { method: "PATCH", body: patch }
  ),
  devBoardReordenar: (programa, ids) => req(
    "/api/hivebox/dev-board/cards/reordenar/",
    { method: "POST", body: { programa, ids } }
  ),
  devBoardDocumento: (id, tipo) => req(`/api/hivebox/dev-board/cards/${id}/documento/`, { params: { tipo } }),
  devBoardMarcarVerificacao: (cardId, numero, patch) => req(`/api/hivebox/dev-board/cards/${cardId}/verificacoes/${numero}/`, { method: "PATCH", body: patch }),
  devBoardVerificacoesTodas: () => req("/api/hivebox/dev-board/verificacoes/"),
  devBoardRecursos: () => req("/api/hivebox/dev-board/recursos/"),
  devBoardReabrir: (cardId) => req(`/api/hivebox/dev-board/cards/${cardId}/reabrir/`, { method: "POST" }),
  hiveboxPortoes: () => req("/api/hivebox/portoes/"),
  hiveboxPortaoEditar: (chave, patch) => req(`/api/hivebox/portoes/${chave}/`, { method: "PATCH", body: patch }),
  hiveboxPostos: () => req("/api/hivebox/postos/"),
  hiveboxTurno: (id) => req(`/api/hivebox/turnos/${id}/`),
  hiveboxColmeia: () => req("/api/hivebox/colmeia/"),
  hiveboxPerguntas: () => req("/api/hivebox/perguntas/"),
  hiveboxResponderPergunta: (id, resposta) => req(`/api/hivebox/perguntas/${id}/responder/`, { method: "POST", body: { resposta } }),
  hiveboxDecidirPedidoSuite: (id, decisao) => req(`/api/hivebox/pedidos-suite/${id}/decidir/`, { method: "POST", body: { decisao } }),
  tiposAcao: () => req("/api/tipos-acao/"),
  personalizacoes: () => req("/api/personalizacoes/"),
  createPersonalizacao: (data) => req("/api/personalizacoes/", { method: "POST", body: data }),
  updatePersonalizacao: (id_slug, patch) => req(`/api/personalizacoes/${id_slug}/`, { method: "PATCH", body: patch }),
  deletePersonalizacao: (id_slug) => req(`/api/personalizacoes/${id_slug}/`, { method: "DELETE" }),
  createEstado: (data) => req("/api/estados/", { method: "POST", body: data }),
  updateEstado: (id_slug, patch) => req(`/api/estados/${id_slug}/`, { method: "PATCH", body: patch }),
  deleteEstado: (id_slug) => req(`/api/estados/${id_slug}/`, { method: "DELETE" }),
  createTipoAcao: (data) => req("/api/tipos-acao/", { method: "POST", body: data }),
  updateTipoAcao: (id_slug, patch) => req(`/api/tipos-acao/${id_slug}/`, { method: "PATCH", body: patch }),
  deleteTipoAcao: (id_slug) => req(`/api/tipos-acao/${id_slug}/`, { method: "DELETE" }),
  dbConnections: () => req("/api/db-connections/"),
  createDBConnection: (data) => req("/api/db-connections/", { method: "POST", body: data }),
  updateDBConnection: (id, patch) => req(`/api/db-connections/${id}/`, { method: "PATCH", body: patch }),
  deleteDBConnection: (id) => req(`/api/db-connections/${id}/`, { method: "DELETE" }),
  activateDBConnection: (id) => req(`/api/db-connections/${id}/activate/`, { method: "POST" }),
  testDBConnection: (id) => req(`/api/db-connections/${id}/test/`, { method: "POST" }),
  users: (params) => req("/api/users/", { params }),
  createUser: (data) => req("/api/users/", { method: "POST", body: data }),
  updateUser: (id, patch) => req(`/api/users/${id}/`, { method: "PATCH", body: patch }),
  deactivateUser: (id) => req(`/api/users/${id}/`, { method: "DELETE" }),
  setUserPassword: (id, password) => req(`/api/users/${id}/set-password/`, {
    method: "POST",
    body: { password }
  }),
  sendSetPassword: (id) => req(`/api/users/${id}/send-set-password/`, { method: "POST" }),
  validateSetPassword: (uid, token) => req("/api/auth/set-password/", { params: { uid, token } }),
  setPasswordWithToken: (uid, token, password) => req("/api/auth/set-password/", {
    method: "POST",
    body: { uid, token, password }
  }),
  vendedores: () => req("/api/vendedores/"),
  monos: (params) => req("/api/monos/", { params }),
  bulkAssign: (codigos, atribuido_a) => req("/api/monos/bulk-assign/", {
    method: "POST",
    body: { codigos, atribuido_a }
  }),
  patchMono: (id, patch) => req(`/api/monos/${id}/`, { method: "PATCH", body: patch }),
  addAcao: (monoId, tipo_id_slug, descricao, atribuido_id = null, data_limite = null) => req(`/api/monos/${monoId}/acoes/`, {
    method: "POST",
    body: { tipo_id_slug, descricao, atribuido_id, data_limite }
  }),
  prazoAcao: (monoId, acaoId, data_limite) => req(
    `/api/monos/${monoId}/acoes/${acaoId}/prazo/`,
    { method: "POST", body: { data_limite } }
  ),
  deleteAcao: (monoId, acaoId) => req(`/api/monos/${monoId}/acoes/${acaoId}/`, { method: "DELETE" }),
  tratarAcao: (monoId, acaoId) => req(`/api/monos/${monoId}/acoes/${acaoId}/tratar/`, { method: "POST" }),
  transitionsMonthly: (params) => req("/api/monos/transitions-monthly/", { params }),
  periodFlow: (params) => req("/api/monos/period-flow/", { params }),
  // ===== Prospeção =====
  leads: (params) => req("/api/prospecao/leads/", { params }),
  createLead: (data) => req("/api/prospecao/leads/", { method: "POST", body: data }),
  updateLead: (id, patch) => req(`/api/prospecao/leads/${id}/`, { method: "PATCH", body: patch }),
  deleteLead: (id) => req(`/api/prospecao/leads/${id}/`, { method: "DELETE" }),
  viesCheck: (nif) => req("/api/prospecao/vies/", { method: "POST", body: { nif } }),
  validateLead: (nif) => req("/api/prospecao/validate/", { params: { nif } }),
  enrichLead: (nif) => req("/api/prospecao/enrich/", { params: { nif } }),
  dbinformaReport: (leadId) => req(`/api/prospecao/leads/${leadId}/dbinforma-report/`),
  dbinformaRefresh: (leadId) => req(`/api/prospecao/leads/${leadId}/dbinforma-refresh/`, { method: "POST" }),
  getLead: (id) => req(`/api/prospecao/leads/${id}/`),
  addLeadAcao: (leadId, tipo_id_slug, descricao, atribuido_id = null, data_limite = null) => req(`/api/prospecao/leads/${leadId}/acoes/`, {
    method: "POST",
    body: { tipo_id_slug, descricao, atribuido_id, data_limite }
  }),
  prazoLeadAcao: (leadId, acaoId, data_limite) => req(
    `/api/prospecao/leads/${leadId}/acoes/${acaoId}/prazo/`,
    { method: "POST", body: { data_limite } }
  ),
  deleteLeadAcao: (leadId, acaoId) => req(`/api/prospecao/leads/${leadId}/acoes/${acaoId}/`, { method: "DELETE" }),
  tratarLeadAcao: (leadId, acaoId) => req(`/api/prospecao/leads/${leadId}/acoes/${acaoId}/tratar/`, { method: "POST" }),
  leadNotas: (leadId) => req(`/api/prospecao/leads/${leadId}/notas/`),
  leadNotaCreate: (leadId, descricao) => req(
    `/api/prospecao/leads/${leadId}/notas/`,
    { method: "POST", body: { descricao } }
  ),
  leadNotaUpdate: (leadId, notaId, descricao) => req(
    `/api/prospecao/leads/${leadId}/notas/${notaId}/`,
    { method: "PATCH", body: { descricao } }
  ),
  leadNotaDelete: (leadId, notaId) => req(
    `/api/prospecao/leads/${leadId}/notas/${notaId}/`,
    { method: "DELETE" }
  ),
  dbinformaIndicators: () => req("/api/prospecao/indicators/"),
  scoutSearch: (data) => req("/api/prospecao/scout-search/", { method: "POST", body: data }),
  scoutImport: (data) => req("/api/prospecao/scout-import/", { method: "POST", body: data }),
  scoutStats: () => req("/api/prospecao/scout-stats/"),
  scoutPrompt: () => req("/api/prospecao/scout-prompt/"),
  scoutQueryLeads: (id) => req(`/api/prospecao/scout-queries/${id}/leads/`),
  whaleAccounts(params = {}) {
    const qs = new URLSearchParams();
    if (params.from && params.to) {
      qs.set("from", params.from);
      qs.set("to", params.to);
    } else {
      if (params.year != null) qs.set("year", String(params.year));
      if (params.cumulative) qs.set("cumulative", params.cumulative);
    }
    return req("/api/whale/accounts/?" + qs.toString());
  },
  whaleAccount(no, params = {}) {
    const qs = new URLSearchParams();
    if (params.from && params.to) {
      qs.set("from", params.from);
      qs.set("to", params.to);
    } else {
      if (params.year != null) qs.set("year", String(params.year));
      if (params.cumulative) qs.set("cumulative", params.cumulative);
    }
    return req(`/api/whale/accounts/${no}/?` + qs.toString());
  },
  whaleAccountUpdate: (no, patch) => req(`/api/whale/accounts/${no}/`, { method: "PATCH", body: patch }),
  whaleStats(params = {}) {
    const qs = new URLSearchParams();
    if (params.from && params.to) {
      qs.set("from", params.from);
      qs.set("to", params.to);
    } else {
      if (params.year != null) qs.set("year", String(params.year));
      if (params.cumulative) qs.set("cumulative", params.cumulative);
    }
    return req("/api/whale/stats/?" + qs.toString());
  },
  whaleMonthlyRanking(params = {}) {
    const qs = new URLSearchParams();
    if (params.from && params.to) {
      qs.set("from", params.from);
      qs.set("to", params.to);
    } else {
      if (params.year != null) qs.set("year", String(params.year));
      if (params.cumulative) qs.set("cumulative", params.cumulative);
    }
    return req("/api/whale/monthly-ranking/?" + qs.toString());
  },
  scoutDistricts: () => req("/api/prospecao/scout-districts/"),
  createScoutDistrict: (data) => req("/api/prospecao/scout-districts/", { method: "POST", body: data }),
  updateScoutDistrict: (id, patch) => req(`/api/prospecao/scout-districts/${id}/`, { method: "PATCH", body: patch }),
  deleteScoutDistrict: (id) => req(`/api/prospecao/scout-districts/${id}/`, { method: "DELETE" }),
  scoutSectors: () => req("/api/prospecao/scout-sectors/"),
  createScoutSector: (data) => req("/api/prospecao/scout-sectors/", { method: "POST", body: data }),
  updateScoutSector: (slug, patch) => req(`/api/prospecao/scout-sectors/${slug}/`, { method: "PATCH", body: patch }),
  deleteScoutSector: (slug) => req(`/api/prospecao/scout-sectors/${slug}/`, { method: "DELETE" }),
  bulkImportLeads: (items) => req("/api/prospecao/leads/bulk-import/", { method: "POST", body: { items } }),
  apiKeys: () => req("/api/api-keys/"),
  createApiKey: (data) => req("/api/api-keys/", { method: "POST", body: data }),
  updateApiKey: (provider, patch) => req(`/api/api-keys/${provider}/`, { method: "PATCH", body: patch }),
  deleteApiKey: (provider) => req(`/api/api-keys/${provider}/`, { method: "DELETE" }),
  logs: () => req("/api/logs/"),
  clearLogs: () => req("/api/logs/", { method: "DELETE" }),
  emailSettings: () => req("/api/email-settings/"),
  updateEmailSettings: (patch) => req("/api/email-settings/", { method: "PATCH", body: patch }),
  updateEmailLogo: async (file) => {
    const fd = new FormData();
    fd.append("email_logo", file);
    const csrf = getCookie("csrftoken");
    const r = await fetch("/api/email-settings/", {
      method: "PATCH",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
      credentials: "include",
      body: fd
    });
    if (!r.ok) throw new Error(`PATCH logo \u2192 ${r.status}: ${await r.text()}`);
    return r.json();
  },
  clearEmailLogo: () => req("/api/email-settings/", { method: "PATCH", body: { logo_clear: "1" } }),
  sendTestEmail: (to) => req("/api/email-settings/", { method: "POST", body: { to } }),
  hubBranding: () => req("/api/branding/"),
  uploadHubBrandingLogo: async (file) => {
    const fd = new FormData();
    fd.append("logo", file);
    const csrf = getCookie("csrftoken");
    const r = await fetch("/api/branding/", {
      method: "PATCH",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
      credentials: "include",
      body: fd
    });
    if (!r.ok) throw new Error(`PATCH branding logo \u2192 ${r.status}: ${await r.text()}`);
    return r.json();
  },
  clearHubBrandingLogo: () => req("/api/branding/", { method: "PATCH", body: { logo_clear: "1" } }),
  scheduledTasks: () => req("/api/scheduled-tasks/"),
  // ---------- Email templates (tipos de email) ----------
  emailTemplates: () => req("/api/email-templates/"),
  createEmailTemplate: (data) => req("/api/email-templates/", { method: "POST", body: data }),
  updateEmailTemplate: (key, patch) => req(`/api/email-templates/${key}/`, { method: "PATCH", body: patch }),
  deleteEmailTemplate: (key) => req(`/api/email-templates/${key}/`, { method: "DELETE" }),
  emailTemplatePreview: (draft) => req("/api/email-templates/preview/", { method: "POST", body: draft || {} }),
  // ---------- Chat ----------
  chatConversations: () => req("/api/chat/conversations/"),
  chatConversation: (id) => req(`/api/chat/conversations/${id}/`),
  chatCreateDM: (other_user_id) => req(
    "/api/chat/conversations/dm/",
    { method: "POST", body: { other_user_id } }
  ),
  chatCreateChannel: (data) => req(
    "/api/chat/conversations/channel/",
    { method: "POST", body: data }
  ),
  chatUpdateChannel: (id, patch) => req(
    `/api/chat/conversations/${id}/`,
    { method: "PATCH", body: patch }
  ),
  chatDeleteChannel: (id) => req(`/api/chat/conversations/${id}/`, { method: "DELETE" }),
  chatLeave: (id) => req(`/api/chat/conversations/${id}/leave/`, { method: "POST" }),
  chatMessages: (convId, before, limit = 50) => req(
    `/api/chat/conversations/${convId}/messages/`,
    { params: { before, limit } }
  ),
  chatSendMessage: (convId, body) => req(
    `/api/chat/conversations/${convId}/messages/`,
    { method: "POST", body: { body } }
  ),
  chatEditMessage: (id, body) => req(
    `/api/chat/messages/${id}/`,
    { method: "PATCH", body: { body } }
  ),
  chatDeleteMessage: (id) => req(`/api/chat/messages/${id}/`, { method: "DELETE" }),
  chatMarkRead: (convId) => req(
    `/api/chat/conversations/${convId}/read/`,
    { method: "POST" }
  ),
  chatUnreadCount: () => req("/api/chat/unread-count/"),
  openChatSocket: (convId) => {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return new WebSocket(`${proto}//${window.location.host}/ws/chat/${convId}/`);
  },
  openPresenceSocket: () => {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return new WebSocket(`${proto}//${window.location.host}/ws/presence/`);
  },
  openUserSocket: () => {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return new WebSocket(`${proto}//${window.location.host}/ws/user/`);
  },
  // ---------- Valora ----------
  valoraCardTypes: () => req("/api/valora/card-types/"),
  valoraTransport: () => req("/api/valora/transport/"),
  valoraMachines: () => req("/api/valora/machines/"),
  valoraPrintLocations: () => req("/api/valora/print-locations/"),
  valoraPallets: () => req("/api/valora/pallets/"),
  valoraFefcoModels: () => req("/api/valora/fefco-models/"),
  valoraGlobals: () => req("/api/valora/globals/"),
  valoraSaveGlobals: (body) => req("/api/valora/globals/", { method: "PATCH", body }),
  valoraSaveCardType: (row) => valoraUpsert("card-types", row.id, row),
  valoraDeleteCardType: (id) => req(`/api/valora/card-types/${encodeURIComponent(id)}/`, { method: "DELETE" }),
  valoraSaveTransport: (row) => valoraUpsert("transport", row.district, row),
  valoraDeleteTransport: (district) => req(`/api/valora/transport/${encodeURIComponent(district)}/`, { method: "DELETE" }),
  valoraSaveMachine: (row) => valoraUpsert("machines", row.id, row),
  valoraDeleteMachine: (id) => req(`/api/valora/machines/${encodeURIComponent(id)}/`, { method: "DELETE" }),
  valoraSetMachineCards: (id, card_types) => req(`/api/valora/machines/${encodeURIComponent(id)}/`, { method: "PATCH", body: { card_types } }),
  valoraSavePrintLocation: (row) => valoraUpsert("print-locations", row.code, row),
  valoraDeletePrintLocation: (code) => req(`/api/valora/print-locations/${encodeURIComponent(code)}/`, { method: "DELETE" }),
  valoraSavePallet: (row) => valoraUpsert("pallets", row.id, row),
  valoraDeletePallet: (id) => req(`/api/valora/pallets/${encodeURIComponent(id)}/`, { method: "DELETE" }),
  valoraSaveFefco: (row) => valoraUpsert("fefco-models", row.id, row),
  valoraDeleteFefco: (id) => req(`/api/valora/fefco-models/${encodeURIComponent(id)}/`, { method: "DELETE" }),
  valoraAiPallet: (prompt) => req("/api/valora/ai-pallet/", { method: "POST", body: { prompt } })
};
window.srToast = function srToast(title, kind = "success", body = "") {
  try {
    window.dispatchEvent(new CustomEvent("sr:realtime", { detail: {
      type: "notification.new",
      notification: {
        id: "local-" + Date.now(),
        kind,
        title,
        body,
        link_view: "",
        link_target: ""
      }
    } }));
  } catch (e) {
  }
};
window.hubConfirm = function hubConfirm(opts = {}) {
  return new Promise((resolve) => {
    const open = window.__hubConfirmOpen;
    if (typeof open !== "function") {
      resolve(false);
      return;
    }
    open({ danger: true, ...opts }, resolve);
  });
};
window.adaptCatalogItem = function adaptCatalogItem(it) {
  const desc = it.descricao || "";
  const niMatch = desc.match(/NI\((\d+)\)/);
  return {
    id: it.codigo,
    codigo: it.codigo,
    descricao: it.descricao,
    niNumber: niMatch ? niMatch[1] : null,
    temImpressao: !!niMatch || /\+\s*imp/i.test(desc),
    temCC: /(^|\s)CC(\s|$)/.test(desc),
    c: it.c,
    l: it.l,
    h: it.h,
    fefco: it.fefco,
    tipoArtigo: it.tipo_artigo,
    familia: it.familia,
    tipoAquis: it.tipo_aquis,
    stock: it.stock,
    armazem: it.armazem,
    encAbertas: it.enc_abertas,
    ultimaEntrada: it.ultima_entrada ? new Date(it.ultima_entrada) : null,
    ultimaSaida: it.ultima_saida ? new Date(it.ultima_saida) : null,
    stockGeral: it.stock_geral,
    mono: it.mono,
    fimVida: it.fim_vida,
    ultimoCliente: it.ultimo_cliente,
    nUltimoCliente: it.n_ultimo_cliente,
    vendedorCod: it.vendedor_cod,
    custoPond: parseFloat(it.custo_pond),
    valor: parseFloat(it.valor),
    url: it.url,
    flags: it.flags,
    primaryTag: it.flags[0] || null,
    estado: it.mono_state ? it.mono_state.estado.id_slug : "por_tratar",
    estadoTerminal: it.mono_state ? !!it.mono_state.estado.terminal : false,
    atribuido: it.mono_state ? it.mono_state.atribuido_a?.username || null : null,
    personalizacao: it.mono_state?.personalizacao?.id_slug || null,
    monoId: it.mono_state ? it.mono_state.id : null,
    monoCriadoEm: it.mono_state?.criado_em ? new Date(it.mono_state.criado_em) : null,
    monoAtualizadoEm: it.mono_state?.atualizado_em ? new Date(it.mono_state.atualizado_em) : null,
    observacoes: it.mono_state ? it.mono_state.observacoes : "",
    acoes: []
  };
};

// ===== layers.js =====
(function() {
  const pilha = [];
  let ligado = false;
  function ehCampoDeTexto(el) {
    if (!el) return false;
    const tag = el.tagName || "";
    return tag === "INPUT" || tag === "TEXTAREA" || !!el.isContentEditable;
  }
  function aoTeclar(e) {
    if (e.key !== "Escape") return;
    const topo = pilha[pilha.length - 1];
    if (!topo) return;
    if (topo.ignoraCampos && ehCampoDeTexto(e.target)) return;
    topo.handler(e);
  }
  function ligar() {
    if (ligado) return;
    document.addEventListener("keydown", aoTeclar);
    ligado = true;
  }
  function desligar() {
    if (!ligado || pilha.length) return;
    document.removeEventListener("keydown", aoTeclar);
    ligado = false;
  }
  window.HubLayers = {
    // Regista uma camada aberta. Devolve a função que a remove — chama-a no
    // cleanup do efeito que a abriu.
    push(handler, opts) {
      const entrada = { handler, ignoraCampos: !!(opts && opts.ignoraCampos) };
      pilha.push(entrada);
      ligar();
      return function remover() {
        const i = pilha.indexOf(entrada);
        if (i !== -1) pilha.splice(i, 1);
        desligar();
      };
    },
    __size: () => pilha.length,
    __top: () => pilha[pilha.length - 1] || null,
    __reset: () => {
      pilha.length = 0;
      desligar();
    }
  };
})();

// ===== tweaks-panel.jsx =====
const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === "object" && keyOrEdits !== null ? keyOrEdits : { [keyOrEdits]: val };
    setValues((prev) => ({ ...prev, ...edits }));
    window.parent.postMessage({ type: "__edit_mode_set_keys", edits }, "*");
    window.dispatchEvent(new CustomEvent("tweakchange", { detail: edits }));
  }, []);
  return [values, setTweak];
}
function TweaksPanel({ title = "Tweaks", children }) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({ x: 16, y: 16 });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth, h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + "px";
    panel.style.bottom = offsetRef.current.y + "px";
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", clampToViewport);
      return () => window.removeEventListener("resize", clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = (e) => {
      const t = e?.data?.type;
      if (t === "__activate_edit_mode") setOpen(true);
      else if (t === "__deactivate_edit_mode") setOpen(false);
    };
    window.addEventListener("message", onMsg);
    window.parent.postMessage({ type: "__edit_mode_available" }, "*");
    return () => window.removeEventListener("message", onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({ type: "__edit_mode_dismissed" }, "*");
  };
  const onDragStart = (e) => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX, sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = (ev) => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
  };
  if (!open) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("style", null, __TWEAKS_STYLE), /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: dragRef,
      className: "twk-panel",
      "data-omelette-chrome": "",
      style: { right: offsetRef.current.x, bottom: offsetRef.current.y }
    },
    /* @__PURE__ */ React.createElement("div", { className: "twk-hd", onMouseDown: onDragStart }, /* @__PURE__ */ React.createElement("b", null, title), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "twk-x",
        "aria-label": "Close tweaks",
        onMouseDown: (e) => e.stopPropagation(),
        onClick: dismiss
      },
      "\u2715"
    )),
    /* @__PURE__ */ React.createElement("div", { className: "twk-body" }, children)
  ));
}
function TweakSection({ label, children }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "twk-sect" }, label), children);
}
function TweakRow({ label, value, children, inline = false }) {
  return /* @__PURE__ */ React.createElement("div", { className: inline ? "twk-row twk-row-h" : "twk-row" }, /* @__PURE__ */ React.createElement("div", { className: "twk-lbl" }, /* @__PURE__ */ React.createElement("span", null, label), value != null && /* @__PURE__ */ React.createElement("span", { className: "twk-val" }, value)), children);
}
function TweakSlider({ label, value, min = 0, max = 100, step = 1, unit = "", onChange }) {
  return /* @__PURE__ */ React.createElement(TweakRow, { label, value: `${value}${unit}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "range",
      className: "twk-slider",
      min,
      max,
      step,
      value,
      onChange: (e) => onChange(Number(e.target.value))
    }
  ));
}
function TweakToggle({ label, value, onChange }) {
  return /* @__PURE__ */ React.createElement("div", { className: "twk-row twk-row-h" }, /* @__PURE__ */ React.createElement("div", { className: "twk-lbl" }, /* @__PURE__ */ React.createElement("span", null, label)), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "twk-toggle",
      "data-on": value ? "1" : "0",
      role: "switch",
      "aria-checked": !!value,
      onClick: () => onChange(!value)
    },
    /* @__PURE__ */ React.createElement("i", null)
  ));
}
function TweakRadio({ label, value, options, onChange }) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  const valueRef = React.useRef(value);
  valueRef.current = value;
  const labelLen = (o) => String(typeof o === "object" ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({ 2: 16, 3: 10 }[options.length] ?? 0);
  if (!fitsAsSegments) {
    const resolve = (s) => {
      const m = options.find((o) => String(typeof o === "object" ? o.value : o) === s);
      return m === void 0 ? s : typeof m === "object" ? m.value : m;
    };
    return /* @__PURE__ */ React.createElement(
      TweakSelect,
      {
        label,
        value,
        options,
        onChange: (s) => onChange(resolve(s))
      }
    );
  }
  const opts = options.map((o) => typeof o === "object" ? o : { value: o, label: o });
  const idx = Math.max(0, opts.findIndex((o) => o.value === value));
  const n = opts.length;
  const segAt = (clientX) => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = (e) => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = (ev) => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: trackRef,
      role: "radiogroup",
      onPointerDown,
      className: dragging ? "twk-seg dragging" : "twk-seg"
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "twk-seg-thumb",
        style: {
          left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
          width: `calc((100% - 4px) / ${n})`
        }
      }
    ),
    opts.map((o) => /* @__PURE__ */ React.createElement("button", { key: o.value, type: "button", role: "radio", "aria-checked": o.value === value }, o.label))
  ));
}
function TweakSelect({ label, value, options, onChange }) {
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement("select", { className: "twk-field", value, onChange: (e) => onChange(e.target.value) }, options.map((o) => {
    const v = typeof o === "object" ? o.value : o;
    const l = typeof o === "object" ? o.label : o;
    return /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l);
  })));
}
function TweakText({ label, value, placeholder, onChange }) {
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "twk-field",
      type: "text",
      value,
      placeholder,
      onChange: (e) => onChange(e.target.value)
    }
  ));
}
function TweakNumber({ label, value, min, max, step = 1, unit = "", onChange }) {
  const clamp = (n) => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({ x: 0, val: 0 });
  const onScrubStart = (e) => {
    e.preventDefault();
    startRef.current = { x: e.clientX, val: value };
    const decimals = (String(step).split(".")[1] || "").length;
    const move = (ev) => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "twk-num" }, /* @__PURE__ */ React.createElement("span", { className: "twk-num-lbl", onPointerDown: onScrubStart }, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value,
      min,
      max,
      step,
      onChange: (e) => onChange(clamp(Number(e.target.value)))
    }
  ), unit && /* @__PURE__ */ React.createElement("span", { className: "twk-num-unit" }, unit));
}
function __twkIsLight(hex) {
  const h = String(hex).replace("#", "");
  const x = h.length === 3 ? h.replace(/./g, (c) => c + c) : h.padEnd(6, "0");
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148e3;
}
const __TwkCheck = ({ light }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 14", "aria-hidden": "true" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M3 7.2 5.8 10 11 4.2",
    fill: "none",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: light ? "rgba(0,0,0,.78)" : "#fff"
  }
));
function TweakColor({ label, value, options, onChange }) {
  if (!options || !options.length) {
    return /* @__PURE__ */ React.createElement("div", { className: "twk-row twk-row-h" }, /* @__PURE__ */ React.createElement("div", { className: "twk-lbl" }, /* @__PURE__ */ React.createElement("span", null, label)), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "color",
        className: "twk-swatch",
        value,
        onChange: (e) => onChange(e.target.value)
      }
    ));
  }
  const key = (o) => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement("div", { className: "twk-chips", role: "radiogroup" }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: i,
        type: "button",
        className: "twk-chip",
        role: "radio",
        "aria-checked": on,
        "data-on": on ? "1" : "0",
        "aria-label": colors.join(", "),
        title: colors.join(" \xB7 "),
        style: { background: hero },
        onClick: () => onChange(o)
      },
      sup.length > 0 && /* @__PURE__ */ React.createElement("span", null, sup.map((c, j) => /* @__PURE__ */ React.createElement("i", { key: j, style: { background: c } }))),
      on && /* @__PURE__ */ React.createElement(__TwkCheck, { light: __twkIsLight(hero) })
    );
  })));
}
function TweakButton({ label, onClick, secondary = false }) {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: secondary ? "twk-btn secondary" : "twk-btn",
      onClick
    },
    label
  );
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});

// ===== components.jsx =====
const { useState, useEffect, useLayoutEffect, useMemo, useRef, useCallback } = React;
function BrandMark({ size = 36 }) {
  return /* @__PURE__ */ React.createElement("img", { src: "/static/assets/logo-mark.png", alt: "StockReborn", width: size, height: size * 1.27, style: { display: "block" } });
}
const Ico = {
  search: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ React.createElement("path", { d: "m21 21-4.3-4.3" })),
  chevron: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "m6 9 6 6 6-6" })),
  close: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M18 6 6 18M6 6l12 12" })),
  plus: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M12 5v14M5 12h14" })),
  filter: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 6h18M6 12h12M10 18h4" })),
  list: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 6h18M3 12h18M3 18h18" })),
  dashboard: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "3", width: "8", height: "10", rx: "1" }), /* @__PURE__ */ React.createElement("rect", { x: "13", y: "3", width: "8", height: "6", rx: "1" }), /* @__PURE__ */ React.createElement("rect", { x: "3", y: "15", width: "8", height: "6", rx: "1" }), /* @__PURE__ */ React.createElement("rect", { x: "13", y: "11", width: "8", height: "10", rx: "1" })),
  kanban: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "3", width: "5", height: "18", rx: "1" }), /* @__PURE__ */ React.createElement("rect", { x: "9.5", y: "3", width: "5", height: "18", rx: "1" }), /* @__PURE__ */ React.createElement("rect", { x: "16", y: "3", width: "5", height: "18", rx: "1" }), /* @__PURE__ */ React.createElement("path", { d: "M3 8h5M9.5 8h5M16 8h5" })),
  ranking: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 21h18" }), /* @__PURE__ */ React.createElement("rect", { x: "5", y: "13", width: "4", height: "8" }), /* @__PURE__ */ React.createElement("rect", { x: "10", y: "8", width: "4", height: "13" }), /* @__PURE__ */ React.createElement("rect", { x: "15", y: "3", width: "4", height: "18" })),
  bell: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" }), /* @__PURE__ */ React.createElement("path", { d: "M10 21a2 2 0 0 0 4 0" })),
  menu: (p) => /* @__PURE__ */ React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 12h18M3 6h18M3 18h18" })),
  camera: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "13", r: "3" })),
  ruler: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 8h18v8H3z" }), /* @__PURE__ */ React.createElement("path", { d: "M7 8v3M11 8v4M15 8v3M19 8v4" })),
  cog: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "3" }), /* @__PURE__ */ React.createElement("path", { d: "M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3h.1a1.6 1.6 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8v.1a1.6 1.6 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1Z" })),
  download: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" })),
  mail: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "5", width: "18", height: "14", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "m3 7 9 6 9-6" })),
  phone: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M22 16.92v3a2 2 0 0 1-2.2 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" })),
  visit: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "10", r: "3" })),
  doc: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }), /* @__PURE__ */ React.createElement("path", { d: "M14 2v6h6M8 13h8M8 17h5" })),
  pdf: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.6", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }), /* @__PURE__ */ React.createElement("path", { d: "M14 2v6h6" }), /* @__PURE__ */ React.createElement("text", { x: "7", y: "18", fontSize: "6", fontFamily: "monospace", fontWeight: "700", fill: "currentColor", stroke: "none" }, "PDF")),
  image: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }), /* @__PURE__ */ React.createElement("circle", { cx: "8.5", cy: "8.5", r: "1.6" }), /* @__PURE__ */ React.createElement("path", { d: "m21 15-5-5L5 21" })),
  sheet: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "M3 9h18M3 15h18M9 3v18M15 3v18" })),
  meeting: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("circle", { cx: "9", cy: "7", r: "3" }), /* @__PURE__ */ React.createElement("circle", { cx: "17", cy: "7", r: "3" }), /* @__PURE__ */ React.createElement("path", { d: "M2 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2M15 15a4 4 0 0 1 4 4v2" })),
  tag: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8Z" }), /* @__PURE__ */ React.createElement("circle", { cx: "7", cy: "7", r: "1.5" })),
  trash: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })),
  swap: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M16 3h5v5M21 8l-7 7M8 21H3v-5M3 16l7-7" })),
  user: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "8", r: "4" }), /* @__PURE__ */ React.createElement("path", { d: "M4 21a8 8 0 0 1 16 0" })),
  printer: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z" })),
  external: (p) => /* @__PURE__ */ React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3" })),
  refresh: (p) => /* @__PURE__ */ React.createElement("svg", { "data-ico": "refresh", width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 12a9 9 0 0 1 15.5-6.3L21 8M21 3v5h-5M21 12a9 9 0 0 1-15.5 6.3L3 16M3 21v-5h5" })),
  warehouse: (p) => /* @__PURE__ */ React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M3 21V9l9-5 9 5v12" }), /* @__PURE__ */ React.createElement("path", { d: "M9 21v-8h6v8" }), /* @__PURE__ */ React.createElement("path", { d: "M3 21h18" })),
  chat: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })),
  arrowLeft: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M19 12H5M12 19l-7-7 7-7" })),
  send: (p) => /* @__PURE__ */ React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" })),
  circleHalf: (p) => /* @__PURE__ */ React.createElement("svg", { "data-ico": "circleHalf", width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ React.createElement("path", { d: "M12 3v18" }), /* @__PURE__ */ React.createElement("path", { d: "M3 12a9 9 0 0 1 9-9", fill: "currentColor" })),
  userPlus: (p) => /* @__PURE__ */ React.createElement("svg", { "data-ico": "userPlus", width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("circle", { cx: "9", cy: "8", r: "4" }), /* @__PURE__ */ React.createElement("path", { d: "M3 21a6 6 0 0 1 12 0" }), /* @__PURE__ */ React.createElement("path", { d: "M19 8v6M22 11h-6" })),
  star: (p) => /* @__PURE__ */ React.createElement("svg", { "data-ico": "star", width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("path", { d: "M12 3l2.9 5.9 6.6.9-4.8 4.6 1.1 6.6L12 18l-5.9 3 1.1-6.6-4.8-4.6 6.6-.9z" })),
  archive: (p) => /* @__PURE__ */ React.createElement("svg", { "data-ico": "archive", width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", ...p }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "4", width: "18", height: "4", rx: "1" }), /* @__PURE__ */ React.createElement("path", { d: "M5 8v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8" }), /* @__PURE__ */ React.createElement("path", { d: "M10 12h4" })),
  dot: (p) => /* @__PURE__ */ React.createElement("svg", { "data-ico": "dot", width: "14", height: "14", viewBox: "0 0 24 24", fill: "currentColor", stroke: "none", ...p }, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "3" }))
};
const fmtEur = (n) => {
  if (n == null) return "\u2014";
  return "\u20AC" + n.toLocaleString("pt-PT", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};
const fmtEurDec = (n) => {
  if (n == null) return "\u2014";
  return "\u20AC" + n.toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
const fmtQty = (n) => {
  if (n == null) return "\u2014";
  return n.toLocaleString("pt-PT");
};
const fmtDate = (d) => {
  if (!d) return "\u2014";
  return d.toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric" });
};
const fmtDateTime = (d) => {
  if (!d) return "\u2014";
  return d.toLocaleString("pt-PT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};
const fmtDateRel = (d) => {
  if (!d) return "\u2014";
  const diff = Math.floor((Date.now() - d.getTime()) / 864e5);
  if (diff < 0) return `daqui a ${-diff} dias`;
  if (diff < 1) return "hoje";
  if (diff < 2) return "ontem";
  if (diff < 30) return `h\xE1 ${diff} dias`;
  const m = Math.floor(diff / 30);
  if (m < 12) return `h\xE1 ${m} ${m > 1 ? "meses" : "m\xEAs"}`;
  const y = Math.floor(m / 12);
  return `h\xE1 ${y} ano${y > 1 ? "s" : ""}`;
};
function fmtAgo(s) {
  if (!s) return "";
  const d = new Date(s);
  const diff = (Date.now() - d.getTime()) / 1e3;
  if (diff < 60) return "agora";
  if (diff < 3600) return `h\xE1 ${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `h\xE1 ${Math.floor(diff / 3600)}h`;
  return d.toLocaleDateString("pt-PT");
}
const orDash = (v) => v == null || v === "" ? "\u2014" : v;
function trimCli(s, n = 32) {
  if (!s) return "\u2014";
  return s.length > n ? s.slice(0, n - 1) + "\u2026" : s;
}
function ClassBadge({ tag }) {
  const data = SR_DATA.classificacoes[tag];
  if (!data) return null;
  return /* @__PURE__ */ React.createElement("span", { className: `badge tag-${tag}`, style: { background: data.bg, color: data.fg, borderColor: data.bd } }, data.nome);
}
function FlagDots({ flags }) {
  if (!flags || flags.length === 0) return /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, "\u2014");
  return /* @__PURE__ */ React.createElement("span", { style: { display: "flex", flexWrap: "wrap", gap: 3, alignItems: "center" } }, flags.map((f) => {
    const c = SR_DATA.classificacoes[f];
    if (!c) return null;
    return /* @__PURE__ */ React.createElement("span", { key: f, className: `badge tag-${f}`, style: { background: c.bg, color: c.fg, borderColor: c.bd } }, c.nome);
  }));
}
function StatePill({ stateId }) {
  const st = SR_DATA.estados.find((s) => s.id === stateId);
  if (!st) return null;
  return /* @__PURE__ */ React.createElement("span", { className: "pill", style: { color: st.cor, borderColor: st.cor + "40", background: st.cor + "10" } }, /* @__PURE__ */ React.createElement("span", { className: "dot" }), st.nome);
}
function ComercialPill({ id, compact = false }) {
  if (!id) return /* @__PURE__ */ React.createElement("span", { className: "com-unassigned" }, "\u2014 Sem vendedor \u2014");
  const c = SR_DATA.vendedores.find((x) => x.id === id) ?? { nome: "Sem vendedor", iniciais: "\u2014", cor: "#999", codigo: id };
  return /* @__PURE__ */ React.createElement("span", { className: "com-pill" }, /* @__PURE__ */ React.createElement("span", { className: "com-avatar", style: { background: c.cor } }, c.iniciais), !compact && /* @__PURE__ */ React.createElement("span", null, c.codigo, " \xB7 ", c.nome));
}
function _hashHue(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = h * 31 + s.charCodeAt(i) | 0;
  return Math.abs(h) % 360;
}
function PersonalizacaoPill({ slug, personalizacoes = [] }) {
  if (!slug) return /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, "\u2014");
  const p = personalizacoes.find((x) => x.id_slug === slug) ?? { nome: slug, cor: "#888" };
  return /* @__PURE__ */ React.createElement("span", { className: "pill", style: {
    background: p.cor,
    color: "#fff",
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 11,
    whiteSpace: "nowrap"
  } }, p.nome);
}
function InlinePersonalizacaoPicker({ slug, personalizacoes = [], onChange }) {
  return /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("span", { style: { cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4 }, title: "Mudar personaliza\xE7\xE3o" }, /* @__PURE__ */ React.createElement(PersonalizacaoPill, { slug, personalizacoes }), /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    onChange && onChange(null);
    close();
  } }, "\u2014 Sem personaliza\xE7\xE3o"), personalizacoes.map((p) => /* @__PURE__ */ React.createElement(MenuItem, { key: p.id_slug, onClick: () => {
    onChange && onChange(p.id_slug);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: p.cor } }) }, p.nome))));
}
function InlineStatePicker({ stateId, onChange }) {
  return /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("span", { style: { cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4 }, title: "Mudar estado" }, /* @__PURE__ */ React.createElement(StatePill, { stateId }), /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, SR_DATA.estados.map((s) => /* @__PURE__ */ React.createElement(MenuItem, { key: s.id, onClick: () => {
    onChange && onChange(s.id);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: s.cor } }) }, s.nome))));
}
function FamiliaTag({ familia }) {
  if (!familia) return null;
  const f = SR_DATA.familias[familia] ?? { nome: familia, cor: "#888", bg: "#eee", fg: "#333" };
  return /* @__PURE__ */ React.createElement("span", { className: "tag-fam", style: { background: f.bg, color: f.fg, borderColor: f.cor + "40" } }, familia);
}
function TipoArtigoChip({ tipo }) {
  if (!tipo) return /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014");
  const t = SR_DATA.tiposArtigo[tipo] ?? { nome: tipo, cor: "#888", bg: "#eee", fg: "#333" };
  return /* @__PURE__ */ React.createElement("span", { className: "chip-artigo", style: { background: t.bg, color: t.fg, borderColor: t.cor + "40" } }, t.nome);
}
const TipoTag = FamiliaTag;
function Dim({ c, l, h }) {
  const empty = !c && !l && !h || c === 0 && l === 0 && h === 0;
  if (empty) return /* @__PURE__ */ React.createElement("span", { className: "td-muted dim" }, "\u2014");
  if (!h || h === 0) {
    return /* @__PURE__ */ React.createElement("span", { className: "dim" }, c || "\u2014", /* @__PURE__ */ React.createElement("span", { className: "sep" }, "\xD7"), l || "\u2014");
  }
  return /* @__PURE__ */ React.createElement("span", { className: "dim" }, c, /* @__PURE__ */ React.createElement("span", { className: "sep" }, "\xD7"), l, /* @__PURE__ */ React.createElement("span", { className: "sep" }, "\xD7"), h);
}
function PdfLink({ url, niNumber, compact = false }) {
  if (!url) return /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, "\u2014");
  const label = niNumber ? `NI(${niNumber})` : "PDF";
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: (e) => e.stopPropagation(),
      className: "pdf-link",
      title: `Abrir ficha t\xE9cnica \xB7 ${label}`
    },
    /* @__PURE__ */ React.createElement(Ico.pdf, null),
    !compact && /* @__PURE__ */ React.createElement("span", null, label)
  );
}
function BoxSchema({ c, l, h, fefco, withImp = false }) {
  if (!h || h === 0) {
    if (!c || !l) {
      return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "center", width: 200, height: 140, color: "var(--muted)", fontFamily: "var(--font-mono)", fontSize: 11 } }, "(sem dimens\xF5es)");
    }
    const W2 = 140, H2 = 100;
    const ratio = c / Math.max(l, 1);
    const sw = ratio > 1 ? W2 : W2 * ratio;
    const sh = ratio > 1 ? H2 / ratio : H2;
    return /* @__PURE__ */ React.createElement("svg", { width: 200, height: 140, viewBox: "0 0 200 140", className: "box-svg" }, /* @__PURE__ */ React.createElement("rect", { x: (200 - sw) / 2, y: (140 - sh) / 2, width: sw, height: sh, fill: "var(--panel)", stroke: "var(--border-strong)", strokeWidth: "1" }), /* @__PURE__ */ React.createElement("text", { x: 100, y: (140 - sh) / 2 - 6, textAnchor: "middle", fontFamily: "var(--font-mono)", fontSize: "10", fill: "var(--text-2)" }, c), /* @__PURE__ */ React.createElement("text", { x: (200 - sw) / 2 - 6, y: 70, textAnchor: "end", fontFamily: "var(--font-mono)", fontSize: "10", fill: "var(--text-2)" }, l));
  }
  const max = Math.max(c, l, h);
  const sc = 80 / max;
  const W = c * sc, D = l * sc, H = h * sc;
  const ox = 40, oy = 130;
  const p1 = [ox, oy];
  const p2 = [ox + W, oy];
  const p3 = [ox + W, oy - H];
  const p4 = [ox, oy - H];
  const dx = D * 0.5, dy = -D * 0.4;
  const b1 = [p1[0] + dx, p1[1] + dy];
  const b2 = [p2[0] + dx, p2[1] + dy];
  const b3 = [p3[0] + dx, p3[1] + dy];
  const b4 = [p4[0] + dx, p4[1] + dy];
  const padX = 18, padTop = 14, padBottom = 20;
  const minX = ox - padX;
  const maxX = ox + W + dx + padX;
  const minY = p3[1] + dy - padTop;
  const maxY = oy + padBottom;
  const vbW = maxX - minX;
  const vbH = maxY - minY;
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "100%",
      height: vbH,
      viewBox: `${minX} ${minY} ${vbW} ${vbH}`,
      preserveAspectRatio: "xMidYMid meet",
      style: { maxWidth: vbW, display: "block" },
      className: "box-svg"
    },
    /* @__PURE__ */ React.createElement("polygon", { points: `${p4} ${p3} ${b3} ${b4}`, fill: "var(--bg-2)", stroke: "var(--border-strong)", strokeWidth: "1" }),
    /* @__PURE__ */ React.createElement("polygon", { points: `${p2} ${p3} ${b3} ${b2}`, fill: "var(--bg)", stroke: "var(--border-strong)", strokeWidth: "1" }),
    /* @__PURE__ */ React.createElement("polygon", { points: `${p1} ${p2} ${p3} ${p4}`, fill: "var(--panel)", stroke: "var(--border-strong)", strokeWidth: "1" }),
    withImp && fefco && /* @__PURE__ */ React.createElement("text", { x: p1[0] + W / 2, y: p1[1] - H / 2 + 4, textAnchor: "middle", fontFamily: "var(--font-mono)", fontSize: "9", fill: "var(--muted)" }, fefco),
    /* @__PURE__ */ React.createElement("text", { x: p1[0] + W / 2, y: p1[1] + 14, textAnchor: "middle", fontFamily: "var(--font-mono)", fontSize: "10", fill: "var(--text-2)" }, c),
    /* @__PURE__ */ React.createElement("text", { x: p2[0] + dx / 2 + 6, y: p2[1] + dy / 2 + 4, textAnchor: "start", fontFamily: "var(--font-mono)", fontSize: "10", fill: "var(--text-2)" }, l),
    /* @__PURE__ */ React.createElement("text", { x: p1[0] - 6, y: p1[1] - H / 2 + 4, textAnchor: "end", fontFamily: "var(--font-mono)", fontSize: "10", fill: "var(--text-2)" }, h)
  );
}
function DrawerShell({
  title,
  subtitle,
  onClose,
  footer,
  children,
  navList = [],
  onNavigate,
  currentId,
  headerExtra,
  bodyStyle,
  side,
  largura
}) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => window.HubLayers.push(
    () => {
      onCloseRef.current && onCloseRef.current();
    },
    { ignoraCampos: true }
  ), []);
  const idx = currentId != null ? navList.findIndex((a) => a.id === currentId || a.no === currentId || a.codigo === currentId) : -1;
  const prev = idx > 0 ? navList[idx - 1] : null;
  const next = idx >= 0 && idx < navList.length - 1 ? navList[idx + 1] : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "drawer-overlay" }), /* @__PURE__ */ React.createElement("aside", { className: "drawer", style: largura ? { width: largura, transition: "width 160ms ease" } : void 0 }, /* @__PURE__ */ React.createElement("header", { className: "drawer-header" }, onNavigate && navList.length > 1 && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4, marginRight: 8 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      disabled: !prev,
      "data-shortcut": "p",
      onClick: () => prev && onNavigate(prev),
      title: "Anterior (Alt+P)"
    },
    "\u2039",
    /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "P")
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      disabled: !next,
      "data-shortcut": "n",
      onClick: () => next && onNavigate(next),
      title: "Pr\xF3ximo (Alt+N)"
    },
    "\u203A",
    /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "N")
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 2, flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "ref-code" }, title), subtitle && /* @__PURE__ */ React.createElement("div", { className: "ref-desc" }, subtitle)), headerExtra, /* @__PURE__ */ React.createElement("button", { className: "drawer-close", onClick: onClose, title: "Fechar (Esc)" }, /* @__PURE__ */ React.createElement(Ico.close, null))), /* @__PURE__ */ React.createElement("div", { className: "drawer-body", style: side ? {
    // When a side panel is provided, fall back to the CSS-default grid
    // (.drawer-body { grid-template-columns: 1fr 360px }) so the side
    // collapses below the main column on narrow viewports via the
    // existing media query.
    overflow: "auto",
    padding: 0,
    ...bodyStyle
  } : {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    padding: 0,
    gridTemplateColumns: "none",
    // override the 1fr/360px default
    ...bodyStyle
  } }, side ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "drawer-main" }, children), /* @__PURE__ */ React.createElement("div", { className: "drawer-side" }, side)) : children), footer && /* @__PURE__ */ React.createElement("div", { className: "modal-foot" }, footer)));
}
function Checkbox({ checked, indeterminate, onChange, ...rest }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !!indeterminate;
  }, [indeterminate]);
  return /* @__PURE__ */ React.createElement(
    "input",
    {
      ref,
      type: "checkbox",
      className: "checkbox" + (indeterminate ? " indeterminate" : ""),
      checked: !!checked,
      onChange,
      onClick: (e) => e.stopPropagation(),
      ...rest
    }
  );
}
const HUB_POP_FOLGA = 4;
const HUB_POP_MARGEM = 8;
const HUB_POP_MAX = 360;
function hubLadoDoPopover({
  topoTrigger,
  fundoTrigger,
  alturaConteudo,
  alturaViewport,
  folga,
  margem
}) {
  const f = folga == null ? HUB_POP_FOLGA : folga;
  const m = margem == null ? HUB_POP_MARGEM : margem;
  const abaixo = alturaViewport - fundoTrigger - f - m;
  const acima = topoTrigger - f - m;
  const paraCima = alturaConteudo > abaixo && acima > abaixo;
  const espaco = Math.max(0, paraCima ? acima : abaixo);
  const maxHeight = Math.min(HUB_POP_MAX, espaco);
  return paraCima ? { lado: "cima", top: null, bottom: alturaViewport - topoTrigger + f, maxHeight } : { lado: "baixo", top: fundoTrigger + f, bottom: null, maxHeight };
}
window.hubLadoDoPopover = hubLadoDoPopover;
function Popover({ trigger, children, align = "left" }) {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState(null);
  const triggerRef = useRef(null);
  const popRef = useRef(null);
  useEffect(() => {
    if (!open || !triggerRef.current) {
      setCoords(null);
      return;
    }
    const r = triggerRef.current.getBoundingClientRect();
    setCoords({
      medido: false,
      topoTrigger: r.top,
      fundoTrigger: r.bottom,
      top: r.bottom + 4,
      bottom: null,
      maxHeight: 360,
      left: align === "right" ? null : r.left,
      right: align === "right" ? Math.max(0, window.innerWidth - r.right) : null
    });
  }, [open, align]);
  useLayoutEffect(() => {
    if (!open || !coords || coords.medido || !popRef.current) return;
    const alturaConteudo = popRef.current.scrollHeight;
    const d = hubLadoDoPopover({
      topoTrigger: coords.topoTrigger,
      fundoTrigger: coords.fundoTrigger,
      alturaConteudo,
      alturaViewport: window.innerHeight
    });
    setCoords((c) => ({ ...c, ...d, medido: true }));
  }, [open, coords]);
  useEffect(() => {
    if (!open) return void 0;
    const handler = (e) => {
      if (popRef.current && popRef.current.contains(e.target)) return;
      if (triggerRef.current && triggerRef.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    const tirarCamada = window.HubLayers.push(() => setOpen(false));
    return () => {
      document.removeEventListener("mousedown", handler);
      tirarCamada();
    };
  }, [open]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { ref: triggerRef, onClick: () => setOpen((o) => !o), style: { display: "inline-block" } }, trigger), open && coords && ReactDOM.createPortal(
    /* @__PURE__ */ React.createElement("div", { ref: popRef, style: {
      position: "fixed",
      ...coords.top !== null ? { top: coords.top } : {},
      ...coords.bottom != null ? { bottom: coords.bottom } : {},
      ...coords.left !== null ? { left: coords.left } : {},
      ...coords.right !== null ? { right: coords.right } : {},
      background: "var(--panel)",
      border: "1px solid var(--border)",
      borderRadius: "var(--radius)",
      boxShadow: "var(--shadow-md)",
      minWidth: 220,
      maxHeight: coords.maxHeight,
      overflowY: "auto",
      zIndex: 200,
      padding: 4,
      // Primeira passagem invisível: mede-se sem piscar. `visibility` e
      // não `display: none` — um elemento sem caixa não tem scrollHeight.
      visibility: coords.medido ? "visible" : "hidden"
    } }, typeof children === "function" ? children(() => setOpen(false)) : children),
    document.body
  ));
}
function MenuItem({ children, onClick, danger, icon }) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick,
      style: {
        padding: "7px 10px",
        borderRadius: 4,
        cursor: "pointer",
        fontSize: 12.5,
        color: danger ? "#b91c1c" : "var(--text)",
        display: "flex",
        alignItems: "center",
        gap: 8
      },
      onMouseEnter: (e) => e.currentTarget.style.background = "var(--row-hover)",
      onMouseLeave: (e) => e.currentTarget.style.background = "transparent"
    },
    icon,
    children
  );
}
function MentionTextarea({
  value,
  onChange,
  users = [],
  groups = [],
  hashtags = false,
  suggestedTags = [],
  placeholder,
  rows = 1,
  style,
  autoFocus,
  onSubmit,
  textareaRef,
  ...rest
}) {
  const innerRef = useRef(null);
  const taRef = textareaRef || innerRef;
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [activeIdx, setActiveIdx] = useState(0);
  const tokenStartRef = useRef(-1);
  const [hashMenuOpen, setHashMenuOpen] = useState(false);
  const [hashQuery, setHashQuery] = useState("");
  const [hashActiveIdx, setHashActiveIdx] = useState(0);
  const hashStartRef = useRef(-1);
  useEffect(() => {
    if (!menuOpen) return;
    return window.HubLayers.push(() => setMenuOpen(false));
  }, [menuOpen]);
  useEffect(() => {
    if (!hashMenuOpen) return;
    return window.HubLayers.push(() => setHashMenuOpen(false));
  }, [hashMenuOpen]);
  const candidates = useMemo(() => {
    if (!menuOpen) return [];
    const q = query.toLowerCase();
    const us = users.map((u) => ({
      kind: "user",
      key: "u" + u.id,
      label: u.username,
      sub: `${u.first_name || ""} ${u.last_name || ""}`.trim()
    }));
    const gs = (groups || []).map((g) => ({
      kind: "group",
      key: "g" + (g.id_slug || g.slug || g.id),
      label: g.id_slug || g.slug,
      sub: `grupo \xB7 ${g.nome || g.name}`
    }));
    const all = [...us, ...gs];
    if (!q) return all.slice(0, 10);
    return all.filter((c) => c.label.toLowerCase().includes(q) || (c.sub || "").toLowerCase().includes(q)).slice(0, 10);
  }, [users, groups, query, menuOpen]);
  useEffect(
    () => {
      if (activeIdx >= candidates.length) setActiveIdx(0);
    },
    [candidates.length, activeIdx]
  );
  const hashCandidates = useMemo(() => {
    if (!hashMenuOpen || !hashtags) return [];
    const q = hashQuery.toLowerCase();
    const filtered = q ? suggestedTags.filter((t) => t.toLowerCase().includes(q)) : suggestedTags;
    return filtered.slice(0, 10);
  }, [suggestedTags, hashQuery, hashMenuOpen, hashtags]);
  useEffect(
    () => {
      if (hashActiveIdx >= hashCandidates.length) setHashActiveIdx(0);
    },
    [hashCandidates.length, hashActiveIdx]
  );
  const detectMention = (text, cursor) => {
    let i = cursor - 1;
    while (i >= 0) {
      const ch = text[i];
      if (ch === "@") {
        const prev = i === 0 ? " " : text[i - 1];
        if (/\s/.test(prev) || i === 0) {
          const q = text.slice(i + 1, cursor);
          if (/^[a-zA-Z0-9._-]*$/.test(q)) return { start: i, query: q };
        }
        return null;
      }
      if (/\s/.test(ch)) return null;
      i--;
    }
    return null;
  };
  const detectHashtag = (text, cursor) => {
    const m = /(^|\s)#([\p{L}\d_-]*)$/u.exec(text.slice(0, cursor));
    if (!m) return null;
    const start = cursor - m[2].length - 1;
    return { start, query: m[2] };
  };
  const handleChange = (e) => {
    const v = e.target.value;
    onChange(v);
    const cursor = e.target.selectionStart;
    const tok = detectMention(v, cursor);
    if (tok) {
      tokenStartRef.current = tok.start;
      setQuery(tok.query);
      setMenuOpen(true);
      if (hashtags) {
        hashStartRef.current = -1;
        setHashMenuOpen(false);
      }
    } else {
      tokenStartRef.current = -1;
      setMenuOpen(false);
      if (hashtags) {
        const htok = detectHashtag(v, cursor);
        if (htok) {
          hashStartRef.current = htok.start;
          setHashQuery(htok.query);
          setHashMenuOpen(true);
        } else {
          hashStartRef.current = -1;
          setHashMenuOpen(false);
        }
      }
    }
  };
  const insert = (c) => {
    const ts = tokenStartRef.current;
    if (ts < 0) return;
    const ta = taRef.current;
    const cursor = ta?.selectionStart ?? value.length;
    const before = value.slice(0, ts);
    const after = value.slice(cursor);
    const inserted = `@${c.label} `;
    const next = before + inserted + after;
    onChange(next);
    setMenuOpen(false);
    tokenStartRef.current = -1;
    requestAnimationFrame(() => {
      const pos = (before + inserted).length;
      ta?.setSelectionRange(pos, pos);
      ta?.focus();
    });
  };
  const insertHash = (tag) => {
    const ts = hashStartRef.current;
    if (ts < 0) return;
    const ta = taRef.current;
    const cursor = ta?.selectionStart ?? value.length;
    const before = value.slice(0, ts);
    const after = value.slice(cursor);
    const inserted = `#${tag} `;
    const next = before + inserted + after;
    onChange(next);
    setHashMenuOpen(false);
    hashStartRef.current = -1;
    requestAnimationFrame(() => {
      const pos = (before + inserted).length;
      ta?.setSelectionRange(pos, pos);
      ta?.focus();
    });
  };
  const handleKeyDown = (e) => {
    if (menuOpen && candidates.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveIdx((i) => (i + 1) % candidates.length);
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveIdx((i) => (i - 1 + candidates.length) % candidates.length);
        return;
      }
      if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault();
        insert(candidates[activeIdx]);
        return;
      }
    }
    if (hashtags && hashMenuOpen && hashCandidates.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHashActiveIdx((i) => (i + 1) % hashCandidates.length);
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setHashActiveIdx((i) => (i - 1 + hashCandidates.length) % hashCandidates.length);
        return;
      }
      if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault();
        insertHash(hashCandidates[hashActiveIdx]);
        return;
      }
    }
    if (onSubmit && e.key === "Enter" && !e.shiftKey && !menuOpen && !hashMenuOpen) {
      e.preventDefault();
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative", flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement(
    "textarea",
    {
      ref: taRef,
      value,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onBlur: () => setTimeout(() => {
        setMenuOpen(false);
        if (hashtags) setHashMenuOpen(false);
      }, 120),
      rows,
      placeholder,
      autoFocus,
      style,
      ...rest
    }
  ), menuOpen && candidates.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    bottom: "100%",
    left: 0,
    marginBottom: 4,
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)",
    boxShadow: "var(--shadow-lg)",
    minWidth: 220,
    zIndex: 90,
    maxHeight: 260,
    overflow: "auto"
  } }, candidates.map((c, i) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: c.key,
      type: "button",
      onMouseDown: (e) => {
        e.preventDefault();
        insert(c);
      },
      onMouseEnter: () => setActiveIdx(i),
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "6px 10px",
        border: "none",
        cursor: "pointer",
        background: i === activeIdx ? "var(--bg-2)" : "transparent",
        fontSize: 13
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 600 } }, c.kind === "group" ? "# " : "@", c.label),
    c.sub && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, c.sub)
  ))), hashtags && hashMenuOpen && hashCandidates.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    bottom: "100%",
    left: 0,
    marginBottom: 4,
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)",
    boxShadow: "var(--shadow-lg)",
    minWidth: 180,
    zIndex: 90,
    maxHeight: 260,
    overflow: "auto"
  } }, hashCandidates.map((tag, i) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: tag,
      type: "button",
      onMouseDown: (e) => {
        e.preventDefault();
        insertHash(tag);
      },
      onMouseEnter: () => setHashActiveIdx(i),
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "6px 10px",
        border: "none",
        cursor: "pointer",
        background: i === hashActiveIdx ? "var(--bg-2)" : "transparent",
        fontSize: 13,
        fontWeight: 600
      }
    },
    "#",
    tag
  ))));
}
function escapeHtml(s) {
  return String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function _userDisplay(username) {
  const users = window.SR_USERS || [];
  const u = users.find((x) => x.username === username);
  if (!u) return null;
  const first = u.first_name || "";
  const last = u.last_name || "";
  const full = `${first} ${last}`.trim();
  return full || u.username;
}
function parseNoteToHtml(text) {
  const re = /(@[\p{L}\p{N}._-]+)|(#[\p{L}\p{N}\-_]+)/gu;
  let out = "";
  let last = 0;
  const src = String(text ?? "");
  for (const m of src.matchAll(re)) {
    out += escapeHtml(src.slice(last, m.index));
    if (m[1]) {
      const username = m[1].slice(1);
      const display = _userDisplay(username);
      const cls = display ? "mention-pill" : "mention-pill mention-unknown";
      const label = display || m[1];
      out += `<span class="${cls}" data-username="${escapeHtml(username)}">${escapeHtml(label)}</span>`;
    } else {
      out += `<span class="tag-pill">${escapeHtml(m[2])}</span>`;
    }
    last = m.index + m[0].length;
  }
  out += escapeHtml(src.slice(last));
  return out;
}
window.hubParseNoteToHtml = parseNoteToHtml;
Object.assign(window, {
  BrandMark,
  Ico,
  fmtEur,
  fmtEurDec,
  fmtQty,
  fmtDate,
  fmtDateTime,
  fmtDateRel,
  fmtAgo,
  orDash,
  trimCli,
  ClassBadge,
  FlagDots,
  StatePill,
  ComercialPill,
  PersonalizacaoPill,
  InlineStatePicker,
  InlinePersonalizacaoPicker,
  FamiliaTag,
  TipoArtigoChip,
  TipoTag,
  Dim,
  BoxSchema,
  PdfLink,
  DrawerShell,
  // UserPill + InlineUserPicker now live in packages/hub_shell/features/atribuicoes/frontend.jsx
  Checkbox,
  Popover,
  MenuItem,
  MentionTextarea
});
function ModalShell({ title, subtitle, onClose, footer, children, width }) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => window.HubLayers.push(
    () => {
      onCloseRef.current && onCloseRef.current();
    }
  ), []);
  return /* @__PURE__ */ React.createElement("div", { className: "modal-overlay" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "modal-box",
      style: width ? { width } : void 0,
      onClick: (e) => e.stopPropagation()
    },
    /* @__PURE__ */ React.createElement("div", { className: "modal-head" }, /* @__PURE__ */ React.createElement("div", { className: "title-block" }, /* @__PURE__ */ React.createElement("h3", { className: "title" }, title), subtitle && /* @__PURE__ */ React.createElement("div", { className: "sub" }, subtitle)), /* @__PURE__ */ React.createElement("button", { className: "btn ghost icon-only sm", onClick: onClose, title: "Fechar (Esc)" }, /* @__PURE__ */ React.createElement(Ico.close, null))),
    /* @__PURE__ */ React.createElement("div", { className: "modal-body" }, children),
    footer && /* @__PURE__ */ React.createElement("div", { className: "modal-foot" }, footer)
  ));
}
window.ModalShell = ModalShell;
function ConfirmHost() {
  const [req, setReq] = useState(null);
  useEffect(() => {
    window.__hubConfirmOpen = (opts2, resolve2) => {
      setReq((prev) => {
        if (prev) prev.resolve(false);
        return { opts: opts2, resolve: resolve2 };
      });
    };
    return () => {
      if (window.__hubConfirmOpen) delete window.__hubConfirmOpen;
    };
  }, []);
  if (!req) return null;
  const { opts, resolve } = req;
  const close = (val) => {
    setReq(null);
    resolve(val);
  };
  const footer = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: () => close(false) }, opts.cancelLabel || "Cancelar"), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: opts.danger === false ? "btn primary" : "btn danger",
      autoFocus: !opts.confirmDisabled,
      disabled: !!opts.confirmDisabled,
      onClick: () => close(true)
    },
    opts.confirmLabel || "Confirmar"
  ));
  return /* @__PURE__ */ React.createElement(ModalShell, { title: opts.title || "Confirmar", onClose: () => close(false), footer, width: 420 }, /* @__PURE__ */ React.createElement("div", { style: { whiteSpace: "pre-line" } }, opts.message));
}
window.ConfirmHost = ConfirmHost;
function HubMark({ size = 40 }) {
  return /* @__PURE__ */ React.createElement(
    "img",
    {
      src: "/static/assets/gjnhub-logo.svg",
      alt: "GJN HUB",
      style: { width: size, height: size, objectFit: "contain", display: "block" },
      onError: (e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = "/static/assets/logo-mark.png";
        e.currentTarget.style.height = size * 1.27 + "px";
      }
    }
  );
}
window.HubMark = HubMark;
function SimpleFormModal({ title, fields, initial, onClose, onSubmit, erro, submitLabel }) {
  const [form, setForm] = useState(initial);
  const [aGuardar, setAGuardar] = useState(false);
  const upd = (k, type) => (e) => setForm((f) => ({
    ...f,
    [k]: type === "checkbox" ? e.target.checked : type === "number" ? Number(e.target.value) : e.target.value
  }));
  const formId = `simple-form-${title.replace(/\s+/g, "-").toLowerCase()}`;
  const submeter = (e) => {
    e.preventDefault();
    if (aGuardar) return;
    const r = onSubmit(form);
    if (r && typeof r.then === "function") {
      setAGuardar(true);
      r.finally(() => setAGuardar(false));
    }
  };
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: formId, className: "btn primary sm", disabled: aGuardar }, submitLabel || "Guardar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: formId,
        onSubmit: submeter,
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      erro && /* @__PURE__ */ React.createElement("div", { className: "erro" }, erro),
      fields.map((f) => f.type === "checkbox" ? /* @__PURE__ */ React.createElement("label", { key: f.key, style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!form[f.key], onChange: upd(f.key, "checkbox") }), f.label) : /* @__PURE__ */ React.createElement("div", { key: f.key, className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, f.label), f.type === "textarea" ? /* @__PURE__ */ React.createElement("textarea", { value: form[f.key] || "", onChange: upd(f.key), rows: 3 }) : f.type === "select" ? /* @__PURE__ */ React.createElement("select", { value: form[f.key] ?? "", required: f.required, onChange: upd(f.key) }, (f.options || []).map((o) => /* @__PURE__ */ React.createElement("option", { key: o.value, value: o.value }, o.label))) : /* @__PURE__ */ React.createElement(
        "input",
        {
          type: f.type || "text",
          value: form[f.key] ?? "",
          required: f.required,
          autoFocus: f.autoFocus,
          onChange: upd(f.key, f.type)
        }
      )))
    )
  );
}
window.SimpleFormModal = SimpleFormModal;
function useHubTableSort(defaultSort) {
  const [sort, setSort] = React.useState(defaultSort || []);
  const toggle = React.useCallback((key, additive, defaultDir) => {
    const first = defaultDir === "desc" ? "desc" : "asc";
    const second = first === "asc" ? "desc" : "asc";
    setSort((prev) => {
      const idx = prev.findIndex((s) => s.key === key);
      const cur = idx >= 0 ? prev[idx] : null;
      if (!additive) {
        if (!cur) return [{ key, dir: first }];
        if (cur.dir === first) return [{ key, dir: second }];
        return [];
      }
      const copy = prev.slice();
      if (!cur) {
        copy.push({ key, dir: first });
        return copy;
      }
      if (cur.dir === first) {
        copy[idx] = { key, dir: second };
        return copy;
      }
      copy.splice(idx, 1);
      return copy;
    });
  }, []);
  const clear = React.useCallback(() => setSort([]), []);
  return { sort, setSort, toggle, clear };
}
function hubThClassName(sortable, sortIdx) {
  const parts = [];
  if (sortable) parts.push("sortable");
  if (sortIdx >= 0) parts.push("sorted");
  return parts.join(" ");
}
function HubTableTh({
  label,
  sortKey,
  sort,
  onToggle,
  align,
  style,
  title,
  defaultDir,
  sortable = true,
  onResizeStart,
  className,
  children
}) {
  const idx = (sort || []).findIndex((s) => s.key === sortKey);
  const item = idx >= 0 ? sort[idx] : null;
  const arrow = item ? item.dir === "asc" ? "\u2191" : "\u2193" : null;
  const handleClick = sortable ? (e) => onToggle(sortKey, !!e.shiftKey, defaultDir) : void 0;
  return /* @__PURE__ */ React.createElement(
    "th",
    {
      className: [hubThClassName(sortable, idx), className].filter(Boolean).join(" ") || void 0,
      onClick: handleClick,
      title: title || (sortable ? "Clique para ordenar. Shift-clique para adicionar \xE0 ordena\xE7\xE3o." : void 0),
      style: { textAlign: align, ...style || {} }
    },
    children || label,
    arrow && /* @__PURE__ */ React.createElement("span", { className: "sort-ind" }, arrow, sort.length > 1 && /* @__PURE__ */ React.createElement("sup", null, idx + 1)),
    onResizeStart && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "dt-resizer",
        onPointerDown: onResizeStart,
        onClick: (e) => e.stopPropagation(),
        onDoubleClick: (e) => {
          e.stopPropagation();
          onResizeStart(e, { reset: true });
        }
      }
    )
  );
}
function _hubCmp(a, b) {
  const aNull = a == null || a === "";
  const bNull = b == null || b === "";
  if (aNull && bNull) return 0;
  if (aNull) return 1;
  if (bNull) return -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  const na = Number(a), nb = Number(b);
  if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb;
  return String(a).localeCompare(String(b), "pt", { numeric: true });
}
function hubApplySort(rows, sort, getters) {
  if (!sort || !sort.length) return rows;
  const g = getters || {};
  const arr = rows.slice();
  arr.sort((ra, rb) => {
    for (const { key, dir } of sort) {
      const get = g[key] || ((r) => r[key]);
      let cmp = _hubCmp(get(ra), get(rb));
      if (cmp !== 0) return dir === "desc" ? -cmp : cmp;
    }
    return 0;
  });
  return arr;
}
window.HubTable = {
  useSortable: useHubTableSort,
  Th: HubTableTh,
  applySort: hubApplySort,
  __thClassName: hubThClassName
};
window.HubImpersonation = {
  canImpersonate(me, user) {
    return !!(me && me.can_impersonate && !(me.impersonation && me.impersonation.active) && user && !user.is_staff && !user.is_superuser && user.is_active !== false && user.id !== me.id);
  }
};
function hubListFilterRows(rows, { search = "", searchFields = [], filters = [] } = {}) {
  let out = rows || [];
  const q = (search || "").trim().toLowerCase();
  if (q && searchFields.length) {
    out = out.filter((row) => searchFields.some((f) => {
      const v = row[f];
      return v != null && String(v).toLowerCase().includes(q);
    }));
  }
  for (const { getter, values } of filters) {
    if (values && values.size) {
      out = out.filter((row) => values.has(getter(row)));
    }
  }
  return out;
}
function hubListPageInfo(total, page, pageSize) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
  const p = Math.min(Math.max(1, page || 1), totalPages);
  return { totalPages, page: p, offset: (p - 1) * pageSize };
}
function hubAgrupar(rows, groupBy) {
  if (!groupBy) return null;
  const porChave = /* @__PURE__ */ new Map();
  (rows || []).forEach((row) => {
    const k = groupBy(row);
    if (!porChave.has(k)) porChave.set(k, []);
    porChave.get(k).push(row);
  });
  return [...porChave.entries()].map(([key, rs]) => ({ key, rows: rs }));
}
function hubListActiveCount(values) {
  return Object.values(values || {}).filter((s) => s && s.size).length;
}
function hubListToggleSet(prev, v) {
  const next = new Set(prev);
  next.has(v) ? next.delete(v) : next.add(v);
  return next;
}
function hubListApplyFilterUpdate(prevValues, key, s) {
  const prev = prevValues ? prevValues[key] : void 0;
  const next = typeof s === "function" ? s(prev) : s instanceof Set ? s : /* @__PURE__ */ new Set();
  return { ...prevValues, [key]: next };
}
const HUB_COL_MIN_W = 60;
function hubLayoutBase(columns, state) {
  if (state && state.v) {
    return { v: 1, hidden: [...state.hidden || []], widths: { ...state.widths || {} } };
  }
  return { v: 1, hidden: (columns || []).filter((c) => c.hidden).map((c) => c.key), widths: {} };
}
function hubColumnsResolve(columns, state) {
  const base = hubLayoutBase(columns, state);
  const hidden = new Set(base.hidden);
  return (columns || []).filter((c) => c.fixed || !hidden.has(c.key)).map((c) => base.widths[c.key] != null ? { ...c, width: base.widths[c.key] } : c);
}
function hubColumnsToggle(state, columns, key) {
  const col = (columns || []).find((c) => c.key === key);
  if (!col || col.fixed) return state;
  const base = hubLayoutBase(columns, state);
  const hidden = new Set(base.hidden);
  hidden.has(key) ? hidden.delete(key) : hidden.add(key);
  return { ...base, hidden: [...hidden] };
}
function hubColumnsResize(state, columns, key, px) {
  const col = (columns || []).find((c) => c.key === key);
  if (!col) return state;
  const min = col.minWidth || HUB_COL_MIN_W;
  const base = hubLayoutBase(columns, state);
  base.widths[key] = Math.max(min, Math.round(px));
  return base;
}
function hubColumnSortable(col, server) {
  if (!col || col.sortable === false) return false;
  return server ? !!col.sortKey : true;
}
function hubSortToOrdering(sort, columns) {
  const byKey = {};
  (columns || []).forEach((c) => {
    byKey[c.key] = c;
  });
  return (sort || []).map((s) => {
    const c = byKey[s.key];
    if (!c || !hubColumnSortable(c, true)) return null;
    return (s.dir === "desc" ? "-" : "") + c.sortKey;
  }).filter(Boolean).join(",");
}
const HUB_LAYOUT_SUFFIX = ":layout";
const HUB_LAYOUT_NAME = "__layout__";
function hubLayoutViewId(viewId) {
  if (!viewId) return null;
  return viewId.endsWith(HUB_LAYOUT_SUFFIX) ? viewId : viewId + HUB_LAYOUT_SUFFIX;
}
function useHubColumnLayout(appLabel, viewId, columns) {
  const [state, setState] = React.useState(null);
  const rowId = React.useRef(null);
  const timer = React.useRef(null);
  const chain = React.useRef(Promise.resolve());
  const layoutView = hubLayoutViewId(viewId);
  const enabled = !!(appLabel && layoutView);
  React.useEffect(() => {
    if (!enabled) return;
    let alive = true;
    window.API.savedViews({ app_label: appLabel, view: layoutView }).then((r) => {
      const rows = Array.isArray(r) ? r : r?.results || [];
      const row = rows.find((x) => x.name === HUB_LAYOUT_NAME) || rows[0];
      if (!alive || !row) return;
      rowId.current = row.id;
      setState(row.state && row.state.v ? row.state : null);
    }).catch(() => {
    });
    return () => {
      alive = false;
    };
  }, [appLabel, layoutView, enabled]);
  React.useEffect(() => () => clearTimeout(timer.current), []);
  const setLayout = React.useCallback((next) => {
    setState(next);
    if (!enabled) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      chain.current = chain.current.then(() => {
        const p = rowId.current ? window.API.updateSavedView(rowId.current, { state: next }) : window.API.createSavedView({
          app_label: appLabel,
          view: layoutView,
          name: HUB_LAYOUT_NAME,
          state: next
        });
        return p.then((row) => {
          if (row && row.id) rowId.current = row.id;
        }).catch(() => {
        });
      });
    }, 600);
  }, [appLabel, layoutView, enabled]);
  const reset = React.useCallback(() => {
    setLayout(hubLayoutBase(columns, null));
  }, [setLayout, columns]);
  return { state, setLayout, reset };
}
function HubListSearch({ value, onChange, placeholder }) {
  return /* @__PURE__ */ React.createElement("div", { className: "search-input" }, /* @__PURE__ */ React.createElement(Ico.search, null), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: placeholder || "Pesquisar\u2026",
      value,
      onChange: (e) => onChange(e.target.value)
    }
  ));
}
function HubListBar({ children }) {
  return /* @__PURE__ */ React.createElement("div", { className: "filters" }, children);
}
function HubListChipFilter({ label, value, setValue, options }) {
  const set = value instanceof Set ? value : /* @__PURE__ */ new Set();
  const selected = options.filter((o) => set.has(o.value));
  const toggle = (v) => setValue((prev) => hubListToggleSet(prev, v));
  const summary = selected.length === 0 ? /* @__PURE__ */ React.createElement("span", null, "Todos") : selected.length === 1 ? /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 5 } }, selected[0].dot && /* @__PURE__ */ React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: selected[0].dot } }), selected[0].label) : /* @__PURE__ */ React.createElement("span", null, selected.length, " selecionados");
  return /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", { className: "filter-chip" + (set.size ? " active" : "") }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, label, ":"), summary, /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => setValue(/* @__PURE__ */ new Set()) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14 } }), "Limpar (todos)"), options.map((o) => /* @__PURE__ */ React.createElement(MenuItem, { key: o.value, onClick: () => toggle(o.value) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, display: "inline-flex", justifyContent: "center" } }, set.has(o.value) ? "\u2713" : ""), o.dot ? /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: o.dot } }) : /* @__PURE__ */ React.createElement("span", { style: { width: 8 } }), o.label))));
}
function HubListTypeahead({ label, value, setValue, loadOptions, placeholder }) {
  const set = value instanceof Set ? value : /* @__PURE__ */ new Set();
  const [q, setQ] = React.useState("");
  const [opts, setOpts] = React.useState([]);
  React.useEffect(() => {
    let alive = true;
    const t = setTimeout(() => {
      Promise.resolve(loadOptions(q)).then((r) => {
        if (alive) setOpts(r || []);
      }).catch(() => {
        if (alive) setOpts([]);
      });
    }, 300);
    return () => {
      alive = false;
      clearTimeout(t);
    };
  }, [q]);
  const toggle = (v) => setValue((prev) => hubListToggleSet(prev, v));
  const summary = set.size === 0 ? /* @__PURE__ */ React.createElement("span", null, "Todas") : /* @__PURE__ */ React.createElement("span", null, set.size, " selecionada(s)");
  return /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", { className: "filter-chip" + (set.size ? " active" : "") }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, label, ":"), summary, /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, () => /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 4, minWidth: 220 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "search-input-plain",
      placeholder: placeholder || "Escrever\u2026",
      value: q,
      onChange: (e) => setQ(e.target.value),
      style: { padding: "4px 6px", fontSize: 12 }
    }
  ), [...set].map((v) => /* @__PURE__ */ React.createElement(MenuItem, { key: "sel-" + v, onClick: () => toggle(v) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, display: "inline-flex", justifyContent: "center" } }, "\u2713"), v)), opts.filter((o) => !set.has(o.value)).map((o) => /* @__PURE__ */ React.createElement(MenuItem, { key: o.value, onClick: () => toggle(o.value) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14 } }), o.label)), !opts.length && !set.size && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: "4px 6px" } }, "Escreve para pesquisar\u2026")));
}
function HubListSubFilter({ label, value, setValue, options }) {
  const set = value instanceof Set ? value : /* @__PURE__ */ new Set();
  const toggle = (v) => setValue((prev) => hubListToggleSet(prev, v));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.04em", padding: "4px 6px" } }, label), options.map((o) => /* @__PURE__ */ React.createElement(MenuItem, { key: o.value, onClick: () => toggle(o.value) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, display: "inline-flex", justifyContent: "center" } }, set.has(o.value) ? "\u2713" : ""), o.dot ? /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: o.dot } }) : /* @__PURE__ */ React.createElement("span", { style: { width: 8 } }), o.label)));
}
function HubListClear({ active, onClear }) {
  if (!active) return null;
  return /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClear }, "Limpar (", active, ")");
}
function hubSigValor(v) {
  if (v instanceof Set || v instanceof Map) return hubSigValor([...v]);
  if (Array.isArray(v)) return v.map(hubSigValor);
  if (typeof v === "function") return "[fn]";
  if (v && typeof v === "object") {
    const o = {};
    Object.keys(v).sort().forEach((k) => {
      o[k] = hubSigValor(v[k]);
    });
    return o;
  }
  return v;
}
function hubFiltrosSig(partes) {
  try {
    return JSON.stringify(hubSigValor(partes));
  } catch (e) {
    return null;
  }
}
function hubPagerRange(total, page, pageSize) {
  const t = Math.max(0, total || 0);
  if (t === 0) return { from: 0, to: 0 };
  const size = Math.max(1, pageSize || 0);
  const pages = Math.max(1, Math.ceil(t / size));
  const p = Math.min(Math.max(1, page || 1), pages);
  return { from: (p - 1) * size + 1, to: Math.min(p * size, t) };
}
function hubPageSizeOptions(options, current) {
  if (!options || !options.length) return options;
  if (options.includes(current)) return options;
  return [...options, current].sort((a, b) => a - b);
}
function HubListPager({
  page,
  totalPages,
  onPage,
  total,
  pageSize,
  onPageSize,
  pageSizeOptions
}) {
  const { from, to } = hubPagerRange(total, page, pageSize);
  const n = (v) => (v || 0).toLocaleString("pt-PT");
  return /* @__PURE__ */ React.createElement("div", { className: "hub-pagebar" }, pageSizeOptions && onPageSize && /* @__PURE__ */ React.createElement("span", { className: "hub-pagebar-size", style: { display: "inline-flex", alignItems: "center", gap: 6 } }, "Mostrar", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: pageSize,
      onChange: (e) => onPageSize(Number(e.target.value)),
      style: { width: 74 }
    },
    pageSizeOptions.map((v) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, v))
  )), /* @__PURE__ */ React.createElement("span", null, n(from), "\u2013", n(to), " de ", n(total)), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: page <= 1,
      title: "Primeira p\xE1gina",
      onClick: () => onPage(1)
    },
    "\xAB"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: page <= 1,
      title: "P\xE1gina anterior",
      onClick: () => onPage(page - 1)
    },
    "\u2039"
  ), /* @__PURE__ */ React.createElement("span", null, page, " / ", totalPages), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: page >= totalPages,
      title: "P\xE1gina seguinte",
      onClick: () => onPage(page + 1)
    },
    "\u203A"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: page >= totalPages,
      title: "\xDAltima p\xE1gina",
      onClick: () => onPage(totalPages)
    },
    "\xBB"
  )));
}
function useHubListFilters(defs) {
  const [values, setValues] = React.useState(() => {
    const v = {};
    (defs || []).forEach((d) => {
      v[d.key] = /* @__PURE__ */ new Set();
    });
    return v;
  });
  const set = (key, s) => setValues((prev) => hubListApplyFilterUpdate(prev, key, s));
  const toggle = (key, val) => setValues((prev) => hubListApplyFilterUpdate(prev, key, (prevSet) => hubListToggleSet(prevSet, val)));
  const clear = () => setValues(() => {
    const v = {};
    (defs || []).forEach((d) => {
      v[d.key] = /* @__PURE__ */ new Set();
    });
    return v;
  });
  return { values, set, toggle, clear, count: hubListActiveCount(values) };
}
function hubColumnPickerItems(columns, state) {
  const visible = new Set(hubColumnsResolve(columns, state).map((c) => c.key));
  return (columns || []).map((c) => ({
    key: c.key,
    label: c.label,
    fixed: !!c.fixed,
    visible: visible.has(c.key)
  }));
}
function HubListColumnPicker({ columns, state, onToggle, onReset }) {
  const items = hubColumnPickerItems(columns, state);
  return /* @__PURE__ */ React.createElement(Popover, { align: "right", trigger: /* @__PURE__ */ React.createElement("button", { type: "button", className: "dt-cols-btn", title: "Colunas" }, /* @__PURE__ */ React.createElement(Ico.cog, null)) }, () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11.5,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    padding: "4px 6px"
  } }, "Colunas"), items.map((it) => /* @__PURE__ */ React.createElement(MenuItem, { key: it.key, onClick: it.fixed ? void 0 : () => onToggle(it.key) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, display: "inline-flex", justifyContent: "center" } }, it.visible ? "\u2713" : ""), /* @__PURE__ */ React.createElement(
    "span",
    {
      style: it.fixed ? { opacity: 0.5 } : void 0,
      title: it.fixed ? "Coluna fixa \u2014 n\xE3o pode ser escondida." : void 0
    },
    it.label
  ))), /* @__PURE__ */ React.createElement(MenuItem, { onClick: onReset }, /* @__PURE__ */ React.createElement("span", { style: { width: 14 } }), "Repor colunas")));
}
const HUB_TECTO_FOLGA = 8;
const HUB_TECTO_PISO = 160;
const HUB_TECTO_CREDIVEL = 120;
function hubTectoLista(alturaScroller, cabecalheira, folga) {
  const f = folga == null ? HUB_TECTO_FOLGA : folga;
  if (!(alturaScroller >= HUB_TECTO_CREDIVEL)) return null;
  const c = Math.max(0, cabecalheira || 0);
  return Math.max(HUB_TECTO_PISO, alturaScroller - c - f);
}
function hubScrollerMaisProximo(el) {
  if (!el || typeof window === "undefined" || !window.getComputedStyle) return null;
  let n = el.parentElement;
  while (n && n !== document.body && n !== document.documentElement) {
    const ov = window.getComputedStyle(n).overflowY;
    if (ov === "auto" || ov === "scroll" || ov === "overlay") return n;
    n = n.parentElement;
  }
  return document.documentElement;
}
function HubListList(props) {
  if (props.data != null && props.fetch != null) {
    console.error("HubList: passa `data` (client) OU `fetch` (server), n\xE3o ambos.");
    return /* @__PURE__ */ React.createElement("div", { className: "alert error" }, "HubList mal configurado.");
  }
  if (props.selectable && typeof props.onSelection !== "function") {
    console.error("HubList: `selectable` precisa de `selection` (um Set) e de `onSelection`.");
  }
  return /* @__PURE__ */ React.createElement(HubListListInner, { ...props });
}
function HubListListInner({
  columns,
  data,
  fetch,
  search,
  filters = [],
  pagination = "none",
  pageSize: pageSizeProp = 50,
  pageSizeOptions = [25, 50, 100, 200],
  rowKey,
  onRowClick,
  onRows,
  fetchDeps = [],
  refetchToken,
  title,
  toolbar,
  empty = "Sem resultados.",
  appLabel,
  viewId,
  selectable,
  selection,
  onSelection,
  initialPage,
  initialPageSize,
  initialSort,
  onViewState,
  // Gancho para a app marcar linhas (linha aberta, linha esbatida, linha
  // filtrada). Sem isto, migrar uma tabela com estilos por linha perdia-os em
  // silêncio — foi o que aconteceu ao Stock Reborn.
  rowClassName,
  // Gémeo do `rowClassName` para quando o estilo depende de um valor, não
  // de um estado com classe fixa (ex. opacidade proporcional a um campo da
  // linha) — `(row) => objeto de estilo`. Sem isto, uma tabela com `style`
  // inline condicional na `<tr>` original perdia-o ao migrar, ou tinha de
  // repetir o mesmo valor dentro do `render` de cada coluna — foi o que
  // aconteceu ao WHALES ("Totais mensais").
  rowStyle,
  // Gancho para a app desenhar uma linha por baixo de uma linha (alertas,
  // detalhe em linha). Devolve null para não desenhar nada.
  renderRowExtra,
  // Agrupamento: a app fornece a chave (`groupBy(row)`) e o conteúdo do
  // cabeçalho de cada grupo (`groupHeader({key, rows})`) — o componente
  // agrupa, desenha a linha e trata do colapso. Uma lista agrupada não
  // pagina (agrupar e paginar ao mesmo tempo parte grupos a meio entre
  // páginas), por isso `pagination` é ignorado quando há `groupBy`.
  // `groupOrder` (opcional) reordena os grupos já construídos — a app
  // decide o critério (ex. maior total primeiro), porque só ela sabe o
  // que somar. Sem `groupOrder`, mantém-se a ordem por omissão (primeira
  // aparição das chaves, que segue a ordenação das linhas).
  groupBy,
  groupHeader,
  groupsFechadosPorOmissao,
  groupOrder,
  // Segundo nível de agrupamento, DENTRO de cada grupo — a
  // app dá a chave e o cabeçalho, como no primeiro. Existe
  // porque agrupar por cliente e depois por encomenda é a
  // forma como quem planeia lê a lista: a morada decide o
  // camião, a encomenda decide o que sai junto.
  subGroupBy,
  subGroupHeader,
  // Arrastar a linha inteira: `(ev, row) => void`.
  onRowDragStart,
  // Modo cliente (`data`): a app carrega por fora e diz-o aqui, para a
  // lista mostrar a mesma barra que o modo servidor.
  loading: loadingProp
}) {
  const server = fetch != null;
  const serverPaged = server && pagination !== "none";
  const [searchVal, setSearchVal] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState("");
  const filterState = useHubListFilters(filters);
  const sort = window.HubTable.useSortable(initialSort || null);
  const [page, setPage] = React.useState(initialPage || 1);
  const [pageSize, setPageSize] = React.useState(initialPageSize || pageSizeProp);
  const [fechados, setFechados] = React.useState(() => new Set(groupsFechadosPorOmissao || []));
  const alternarGrupo = (k) => setFechados((p) => {
    const n = new Set(p);
    n.has(k) ? n.delete(k) : n.add(k);
    return n;
  });
  const layout = useHubColumnLayout(appLabel, viewId, columns);
  const layoutRef = React.useRef(layout.state);
  layoutRef.current = layout.state;
  const cols = hubColumnsResolve(columns, layout.state);
  const ordering = hubSortToOrdering(sort.sort, columns);
  const sortGetters = {};
  columns.forEach((c) => {
    if (c.sortValue) sortGetters[c.key] = c.sortValue;
  });
  React.useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchVal), 300);
    return () => clearTimeout(t);
  }, [searchVal]);
  const filtrosAnteriores = React.useRef(void 0);
  React.useEffect(() => {
    const assinatura = hubFiltrosSig([
      searchVal,
      [...Object.entries(filterState.values || {})].map(([k, v]) => [k, [...v || []]]),
      pageSize,
      sort.sort,
      ordering,
      fetchDeps
    ]);
    if (filtrosAnteriores.current === void 0) {
      filtrosAnteriores.current = assinatura;
      return;
    }
    if (assinatura !== null && filtrosAnteriores.current === assinatura) return;
    filtrosAnteriores.current = assinatura;
    setPage(1);
  }, [searchVal, filterState.values, pageSize, sort.sort, ordering, ...fetchDeps]);
  const onViewStateRef = React.useRef(onViewState);
  onViewStateRef.current = onViewState;
  React.useEffect(() => {
    onViewStateRef.current?.({ page, pageSize, sort: sort.sort });
  }, [page, pageSize, sort.sort]);
  const [srv, setSrv] = React.useState({ rows: [], total: 0, loading: true, erro: false });
  React.useEffect(() => {
    if (!server) return;
    let alive = true;
    setSrv((s) => ({ ...s, loading: true }));
    fetch({
      page,
      pageSize,
      search: debouncedSearch,
      filtros: filterState.values,
      sort: sort.sort,
      ordering
    }).then((r) => {
      if (!alive) return;
      const got = r.rows || [];
      setSrv({ rows: got, total: r.total || 0, loading: false, erro: false });
      onRows?.(got);
    }).catch(() => {
      if (alive) {
        setSrv({ rows: [], total: 0, loading: false, erro: true });
        window.srToast?.("N\xE3o foi poss\xEDvel carregar a lista.", "error");
      }
    });
    return () => {
      alive = false;
    };
  }, [server, page, pageSize, debouncedSearch, filterState.values, ordering, refetchToken, ...fetchDeps]);
  const searchFields = search && search.fields || [];
  const clientFiltered = server ? null : hubListFilterRows(data || [], {
    search: searchVal,
    searchFields,
    filters: filters.filter((f) => f.type === "chip").map((f) => ({ getter: f.getter || ((row) => row[f.key]), values: filterState.values[f.key] }))
  });
  const baseRows = serverPaged ? srv.rows : window.HubTable.applySort(server ? srv.rows : clientFiltered, sort.sort, sortGetters);
  const total = server ? srv.total : baseRows.length;
  const info = hubListPageInfo(total, page, pageSize);
  const rows = groupBy ? baseRows : server ? baseRows : pagination === "client" ? baseRows.slice(info.offset, info.offset + pageSize) : baseRows;
  const loading = server ? srv.loading : !!loadingProp;
  const erro = server ? srv.erro : false;
  const gruposBase = hubAgrupar(rows, groupBy);
  const grupos = gruposBase && groupOrder ? [...gruposBase].sort(groupOrder) : gruposBase;
  const subGrupos = React.useCallback(
    (linhas) => subGroupBy ? hubAgrupar(linhas, subGroupBy) : null,
    [subGroupBy]
  );
  React.useEffect(() => {
    if (loading || erro) return;
    if (page > info.totalPages) setPage(info.totalPages);
  }, [loading, erro, page, info.totalPages]);
  const sel = selection instanceof Set ? selection : null;
  const allSelected = !!sel && rows.length > 0 && rows.every((r) => sel.has(rowKey ? rowKey(r) : r.id));
  const someSelected = !!sel && rows.some((r) => sel.has(rowKey ? rowKey(r) : r.id));
  const toggleAll = (checked) => {
    const next = new Set(sel);
    rows.forEach((r) => {
      const k = rowKey ? rowKey(r) : r.id;
      checked ? next.add(k) : next.delete(k);
    });
    onSelection?.(next);
  };
  const toggleOne = (k) => {
    const next = new Set(sel);
    next.has(k) ? next.delete(k) : next.add(k);
    onSelection?.(next);
  };
  const wrapRef = React.useRef(null);
  const scrollTopoRef = React.useRef(null);
  const aSincronizar = React.useRef(false);
  const [larguraConteudo, setLarguraConteudo] = React.useState(0);
  const colRefs = React.useRef({});
  const raizRef = React.useRef(null);
  const [tecto, setTecto] = React.useState(null);
  React.useEffect(() => {
    const wrap = wrapRef.current;
    const raiz = raizRef.current;
    if (!wrap || !raiz || typeof ResizeObserver === "undefined") return void 0;
    const scroller = hubScrollerMaisProximo(wrap);
    const medir = () => {
      const alturaScroller = !scroller || scroller === document.documentElement ? window.innerHeight : scroller.clientHeight;
      const cabecalheira = Array.from(raiz.children).reduce((s, el) => el === wrap ? s : s + el.offsetHeight, 0) + 2;
      setTecto(hubTectoLista(alturaScroller, cabecalheira));
    };
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(raiz);
    if (scroller && scroller !== document.documentElement) ro.observe(scroller);
    window.addEventListener("resize", medir);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", medir);
    };
  }, []);
  React.useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return void 0;
    const aoRodar = (e) => {
      let dx = e.deltaX || (e.shiftKey ? e.deltaY : 0);
      if (!dx) return;
      if (e.deltaMode === 1) dx *= 16;
      else if (e.deltaMode === 2) dx *= wrap.clientWidth;
      if (!e.shiftKey && Math.abs(dx) <= Math.abs(e.deltaY)) return;
      const antes = wrap.scrollLeft;
      wrap.scrollLeft = antes + dx;
      if (wrap.scrollLeft !== antes) e.preventDefault();
    };
    wrap.addEventListener("wheel", aoRodar, { passive: false });
    return () => wrap.removeEventListener("wheel", aoRodar);
  }, []);
  React.useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap || typeof ResizeObserver === "undefined") return void 0;
    const medir = () => {
      const tabela2 = wrap.querySelector("table");
      const largura = tabela2 ? Math.max(tabela2.scrollWidth, wrap.scrollWidth) : 0;
      setLarguraConteudo(largura > wrap.clientWidth + 1 ? largura : 0);
    };
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(wrap);
    const tabela = wrap.querySelector("table");
    if (tabela) ro.observe(tabela);
    return () => ro.disconnect();
  });
  const espelhar = React.useCallback((de, para) => {
    if (aSincronizar.current) {
      aSincronizar.current = false;
      return;
    }
    if (!de || !para || de.scrollLeft === para.scrollLeft) return;
    aSincronizar.current = true;
    para.scrollLeft = de.scrollLeft;
  }, []);
  const dragKey = React.useRef(null);
  const onResizeStart = (key) => (e, opts) => {
    if (opts && opts.reset) {
      const base = hubLayoutBase(columns, layoutRef.current);
      delete base.widths[key];
      layout.setLayout(base);
      return;
    }
    if (dragKey.current) return;
    e.preventDefault();
    e.stopPropagation();
    const el = e.currentTarget;
    const th = el.parentNode;
    const startX = e.clientX;
    const startW = th.getBoundingClientRect().width;
    const min = (columns.find((c) => c.key === key) || {}).minWidth || 60;
    try {
      el.setPointerCapture(e.pointerId);
    } catch (err) {
    }
    el.classList.add("dragging");
    dragKey.current = key;
    let last = startW;
    let moved = false;
    const onMove = (ev) => {
      moved = true;
      last = Math.max(min, startW + (ev.clientX - startX));
      const colEl = colRefs.current[key];
      if (colEl) colEl.style.width = last + "px";
    };
    const onUp = () => {
      if (!dragKey.current) return;
      dragKey.current = null;
      el.classList.remove("dragging");
      try {
        el.releasePointerCapture(e.pointerId);
      } catch (err) {
      }
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
      if (moved) layout.setLayout(hubColumnsResize(layoutRef.current, columns, key, last));
    };
    document.addEventListener("pointermove", onMove);
    document.addEventListener("pointerup", onUp);
  };
  const stickyKey = (cols.find((c) => c.fixed) || {}).key;
  const cellCls = (c) => {
    const parts = [];
    if (c.mono) parts.push("td-mono");
    if (c.key === stickyKey) parts.push(selectable ? "dt-sticky-l2" : "dt-sticky-l");
    return parts.join(" ") || void 0;
  };
  const colSpanTotal = cols.length + (selectable ? 2 : 1);
  const renderRow = (row, indice) => {
    const k = rowKey ? rowKey(row) : row.id;
    const extra = renderRowExtra ? renderRowExtra(row, indice) : null;
    return /* @__PURE__ */ React.createElement(React.Fragment, { key: k }, /* @__PURE__ */ React.createElement(
      "tr",
      {
        className: [
          sel && sel.has(k) ? "selected" : null,
          extra != null ? "dt-com-extra" : null,
          onRowDragStart ? "dt-arrastavel" : null,
          rowClassName ? rowClassName(row) : null
        ].filter(Boolean).join(" ") || void 0,
        draggable: onRowDragStart ? true : void 0,
        onDragStart: onRowDragStart ? (ev) => onRowDragStart(ev, row) : void 0,
        onClick: onRowClick ? () => onRowClick(row) : void 0,
        style: onRowClick || rowStyle ? {
          ...onRowClick ? { cursor: "pointer" } : null,
          ...rowStyle ? rowStyle(row) : null
        } : void 0
      },
      selectable && /* @__PURE__ */ React.createElement("td", { className: "dt-sticky-l", onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: !!sel && sel.has(k),
          onChange: () => toggleOne(k)
        }
      )),
      cols.map((c) => /* @__PURE__ */ React.createElement(
        "td",
        {
          key: c.key,
          className: cellCls(c),
          style: c.align === "right" ? { textAlign: "right" } : void 0
        },
        c.render ? c.render(row, indice) : row[c.key] != null && row[c.key] !== "" ? String(row[c.key]) : "\u2014"
      )),
      /* @__PURE__ */ React.createElement("td", null)
    ), extra != null && /* @__PURE__ */ React.createElement("tr", { className: "dt-extra" }, /* @__PURE__ */ React.createElement("td", { colSpan: colSpanTotal }, extra)));
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "panel",
      ref: raizRef,
      style: { display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 }
    },
    (title || toolbar) && /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { flexShrink: 0 } }, title && /* @__PURE__ */ React.createElement("span", { className: "title" }, title), toolbar),
    /* @__PURE__ */ React.createElement("div", { style: { flexShrink: 0 } }, /* @__PURE__ */ React.createElement(HubListBar, null, search && /* @__PURE__ */ React.createElement(HubListSearch, { value: searchVal, onChange: setSearchVal, placeholder: search.placeholder }), filters.filter((f) => f.type === "chip").map((f) => /* @__PURE__ */ React.createElement(
      HubListChipFilter,
      {
        key: f.key,
        label: f.label,
        options: f.options,
        value: filterState.values[f.key],
        setValue: (s) => filterState.set(f.key, typeof s === "function" ? s(filterState.values[f.key]) : s)
      }
    )), filters.filter((f) => f.type === "typeahead").map((f) => /* @__PURE__ */ React.createElement(
      HubListTypeahead,
      {
        key: f.key,
        label: f.label,
        loadOptions: f.loadOptions,
        placeholder: f.placeholder,
        value: filterState.values[f.key],
        setValue: (s) => filterState.set(f.key, s)
      }
    )), /* @__PURE__ */ React.createElement(HubListClear, { active: filterState.count, onClear: filterState.clear }))),
    pagination !== "none" && !groupBy && /* @__PURE__ */ React.createElement("div", { style: { flexShrink: 0 } }, /* @__PURE__ */ React.createElement(
      HubListPager,
      {
        page: info.page,
        totalPages: info.totalPages,
        onPage: setPage,
        total,
        pageSize,
        onPageSize: setPageSize,
        pageSizeOptions: hubPageSizeOptions(pageSizeOptions, pageSize)
      }
    )),
    loading && /* @__PURE__ */ React.createElement("div", { style: { flexShrink: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar", role: "progressbar", "aria-label": "A carregar" })),
    larguraConteudo > 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "dt-scroll-topo",
        ref: scrollTopoRef,
        "aria-hidden": "true",
        onScroll: () => espelhar(scrollTopoRef.current, wrapRef.current)
      },
      /* @__PURE__ */ React.createElement("div", { style: { width: larguraConteudo, height: 1 } })
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "dt-wrap",
        ref: wrapRef,
        style: tecto != null ? { maxHeight: tecto } : void 0,
        onScroll: () => espelhar(wrapRef.current, scrollTopoRef.current)
      },
      /* @__PURE__ */ React.createElement("table", { className: "dt", "aria-busy": loading || void 0 }, /* @__PURE__ */ React.createElement("colgroup", null, selectable && /* @__PURE__ */ React.createElement("col", { style: { width: 34 } }), cols.map((c) => /* @__PURE__ */ React.createElement(
        "col",
        {
          key: c.key,
          ref: (el) => {
            colRefs.current[c.key] = el;
          },
          style: c.width ? { width: c.width } : void 0
        }
      )), /* @__PURE__ */ React.createElement("col", { style: { width: 34 } })), /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, selectable && /* @__PURE__ */ React.createElement("th", { className: "dt-sticky-l", style: { width: 34 } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: allSelected,
          ref: (el) => {
            if (el) el.indeterminate = someSelected && !allSelected;
          },
          onChange: (e) => toggleAll(e.target.checked)
        }
      )), cols.map((c) => /* @__PURE__ */ React.createElement(
        window.HubTable.Th,
        {
          key: c.key,
          label: c.label,
          sortKey: c.key,
          sort: sort.sort,
          onToggle: sort.toggle,
          align: c.align,
          title: c.title,
          sortable: hubColumnSortable(c, serverPaged),
          onResizeStart: onResizeStart(c.key),
          className: c.key === stickyKey ? selectable ? "dt-sticky-l2" : "dt-sticky-l" : void 0
        }
      )), /* @__PURE__ */ React.createElement("th", { className: "dt-cols" }, /* @__PURE__ */ React.createElement(
        HubListColumnPicker,
        {
          columns,
          state: layout.state,
          onToggle: (k) => layout.setLayout(hubColumnsToggle(layout.state, columns, k)),
          onReset: layout.reset
        }
      )))), /* @__PURE__ */ React.createElement("tbody", null, grupos ? grupos.length === 0 ? !loading && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: colSpanTotal, className: "muted" }, empty)) : (() => {
        let proximoIndice = info.offset;
        return grupos.map((g) => {
          const fechado = fechados.has(g.key);
          const indiceInicial = proximoIndice;
          proximoIndice += g.rows.length;
          return /* @__PURE__ */ React.createElement(React.Fragment, { key: g.key }, /* @__PURE__ */ React.createElement(
            "tr",
            {
              className: "dt-grupo" + (fechado ? " fechado" : ""),
              onClick: () => alternarGrupo(g.key)
            },
            /* @__PURE__ */ React.createElement("td", { colSpan: colSpanTotal }, /* @__PURE__ */ React.createElement("div", { className: "dt-grupo-conteudo" }, /* @__PURE__ */ React.createElement("span", { className: "dt-grupo-seta" }, /* @__PURE__ */ React.createElement(Ico.chevron, null)), groupHeader ? groupHeader({ key: g.key, rows: g.rows }) : null))
          ), !fechado && (() => {
            const subs = subGrupos(g.rows);
            if (!subs) return g.rows.map((row, i) => renderRow(row, indiceInicial + i));
            let n = indiceInicial;
            return subs.map((sg) => {
              const inicio = n;
              n += sg.rows.length;
              const chave = `${g.key}\0${sg.key}`;
              const subFechado = fechados.has(chave);
              return /* @__PURE__ */ React.createElement(React.Fragment, { key: chave }, /* @__PURE__ */ React.createElement(
                "tr",
                {
                  className: "dt-grupo dt-subgrupo" + (subFechado ? " fechado" : ""),
                  onClick: () => alternarGrupo(chave)
                },
                /* @__PURE__ */ React.createElement("td", { colSpan: colSpanTotal }, /* @__PURE__ */ React.createElement("div", { className: "dt-grupo-conteudo" }, /* @__PURE__ */ React.createElement("span", { className: "dt-grupo-seta" }, /* @__PURE__ */ React.createElement(Ico.chevron, null)), subGroupHeader ? subGroupHeader({ key: sg.key, rows: sg.rows, grupo: g.key }) : String(sg.key)))
              ), !subFechado && sg.rows.map((row, i) => renderRow(row, inicio + i)));
            });
          })());
        });
      })() : rows.length === 0 ? !loading && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: colSpanTotal, className: "muted" }, empty)) : rows.map((row, i) => renderRow(row, info.offset + i))))
    )
  );
}
window.HubList = {
  filterRows: hubListFilterRows,
  pageInfo: hubListPageInfo,
  __activeCount: hubListActiveCount,
  __agrupar: hubAgrupar,
  __toggleSet: hubListToggleSet,
  __applyFilterUpdate: hubListApplyFilterUpdate,
  __layoutBase: hubLayoutBase,
  __columnsResolve: hubColumnsResolve,
  __columnsToggle: hubColumnsToggle,
  __columnsResize: hubColumnsResize,
  __columnPickerItems: hubColumnPickerItems,
  ColumnPicker: HubListColumnPicker,
  __columnSortable: hubColumnSortable,
  __sortToOrdering: hubSortToOrdering,
  __layoutViewId: hubLayoutViewId,
  __pagerRange: hubPagerRange,
  __pageSizeOptions: hubPageSizeOptions,
  __filtrosSig: hubFiltrosSig,
  __tectoLista: hubTectoLista,
  __scrollerMaisProximo: hubScrollerMaisProximo,
  useColumnLayout: useHubColumnLayout,
  Bar: HubListBar,
  Search: HubListSearch,
  ChipFilter: HubListChipFilter,
  Typeahead: HubListTypeahead,
  SubFilter: HubListSubFilter,
  Clear: HubListClear,
  Pager: HubListPager,
  useFilters: useHubListFilters,
  List: HubListList
};

// ===== hub_features.js =====
(function() {
  let config = void 0;
  async function load() {
    try {
      config = await window.API.featureConfig();
    } catch (e) {
      console.warn("featureConfig failed, showing all features", e);
      config = null;
    }
    return config;
  }
  function enabled(app, feature) {
    if (config == null) return true;
    const list = config[app];
    if (!list) return true;
    return list.indexOf(feature) !== -1;
  }
  window.HubFeatures = {
    load,
    enabled,
    __reset() {
      config = void 0;
    }
  };
})();

// ===== account-charts.jsx =====
function _fmt(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}
function resolvePreset(preset, today) {
  const t = today instanceof Date ? today : /* @__PURE__ */ new Date();
  const y = t.getFullYear(), m = t.getMonth();
  if (preset === "ytd") {
    return { from: _fmt(new Date(y, 0, 1)), to: _fmt(t) };
  }
  if (preset === "last-12m") {
    const start = new Date(y - 1, m, t.getDate());
    return { from: _fmt(start), to: _fmt(t) };
  }
  if (preset === "this-month") {
    return { from: _fmt(new Date(y, m, 1)), to: _fmt(t) };
  }
  if (preset === "prev-month") {
    const py = m === 0 ? y - 1 : y, pm = m === 0 ? 11 : m - 1;
    return {
      from: _fmt(new Date(py, pm, 1)),
      to: _fmt(new Date(py, pm + 1, 0))
    };
  }
  if (preset === "this-quarter") {
    const qStart = Math.floor(m / 3) * 3;
    return {
      from: _fmt(new Date(y, qStart, 1)),
      to: _fmt(new Date(y, qStart + 3, 0))
    };
  }
  if (preset === "prev-quarter") {
    let qStart = Math.floor(m / 3) * 3 - 3;
    let qy = y;
    if (qStart < 0) {
      qStart += 12;
      qy -= 1;
    }
    return {
      from: _fmt(new Date(qy, qStart, 1)),
      to: _fmt(new Date(qy, qStart + 3, 0))
    };
  }
  const yr = preset.match(/^year:(\d{4})$/);
  if (yr) {
    const yy = Number(yr[1]);
    return { from: `${yy}-01-01`, to: `${yy}-12-31` };
  }
  const cm = preset.match(/^cumulative:(\d{4})$/);
  if (cm) {
    const yy = Number(cm[1]);
    return { from: "2025-01-01", to: `${yy}-12-31` };
  }
  if (preset === "custom") return null;
  return null;
}
function WhaleDateFilter({ value, onChange, _today, hidePresets }) {
  const today = _today || /* @__PURE__ */ new Date();
  const y = today.getFullYear();
  const years = [];
  for (let yr = 2025; yr <= y; yr++) years.push(yr);
  const hidden = Array.isArray(hidePresets) ? new Set(hidePresets) : null;
  const visible = (slug) => !hidden || !hidden.has(slug);
  const onSelect = (e) => {
    const preset = e.target.value;
    if (preset === "custom") {
      onChange({ preset: "custom", from: value.from, to: value.to });
      return;
    }
    const r = resolvePreset(preset, today);
    if (r) onChange({ preset, from: r.from, to: r.to });
  };
  const onFrom = (e) => onChange({ preset: "custom", from: e.target.value, to: value.to });
  const onTo = (e) => onChange({ preset: "custom", from: value.from, to: e.target.value });
  return /* @__PURE__ */ React.createElement("label", { style: { fontSize: 12, display: "inline-flex", alignItems: "center", gap: 6 } }, "Per\xEDodo", /* @__PURE__ */ React.createElement("select", { value: value.preset, onChange: onSelect, style: { marginLeft: 6 } }, visible("ytd") && /* @__PURE__ */ React.createElement("option", { value: "ytd" }, "YTD (", y, ")"), visible("last-12m") && /* @__PURE__ */ React.createElement("option", { value: "last-12m" }, "\xDAltimos 12 meses"), visible("this-month") && /* @__PURE__ */ React.createElement("option", { value: "this-month" }, "Este m\xEAs"), visible("prev-month") && /* @__PURE__ */ React.createElement("option", { value: "prev-month" }, "M\xEAs anterior"), visible("this-quarter") && /* @__PURE__ */ React.createElement("option", { value: "this-quarter" }, "Este trimestre"), visible("prev-quarter") && /* @__PURE__ */ React.createElement("option", { value: "prev-quarter" }, "Trimestre anterior"), /* @__PURE__ */ React.createElement("optgroup", { label: "Ano" }, years.map((yr) => /* @__PURE__ */ React.createElement("option", { key: "y" + yr, value: `year:${yr}` }, "Ano ", yr))), /* @__PURE__ */ React.createElement("optgroup", { label: "Acumulado" }, years.map((yr) => /* @__PURE__ */ React.createElement("option", { key: "c" + yr, value: `cumulative:${yr}` }, "Acumulado at\xE9 ", yr))), visible("custom") && /* @__PURE__ */ React.createElement("option", { value: "custom" }, "Personalizado\u2026")), value.preset === "custom" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("input", { type: "date", value: value.from, onChange: onFrom }), /* @__PURE__ */ React.createElement("span", null, "\u2014"), /* @__PURE__ */ React.createElement("input", { type: "date", value: value.to, onChange: onTo })));
}
function Rolling12mChart({ data, fmt }) {
  if (!data || !data.labels || data.labels.length === 0) {
    return /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12.5 } }, "Sem dados em u_indicst.");
  }
  const labels = data.labels;
  const cur = data.current || [];
  const hm = data.homologue || [];
  const n = labels.length;
  const w = 720, h = 220, padL = 50, padR = 12, padT = 14, padB = 28;
  const innerW = w - padL - padR, innerH = h - padT - padB;
  const slot = innerW / n;
  const max = Math.max(0.01, ...cur, ...hm);
  const toY = (v) => padT + innerH - Math.max(0, v) / max * innerH;
  const xCenter = (i) => padL + slot * (i + 0.5);
  const barW = Math.max(2, (slot - 4) / 2);
  const totalCur = cur.reduce((a, b) => a + b, 0);
  const totalHm = hm.reduce((a, b) => a + b, 0);
  const delta = totalHm ? (totalCur - totalHm) / totalHm * 100 : null;
  const regress = (arr) => {
    const k = arr.length;
    if (k < 2) return null;
    let sx = 0, sy = 0, sxx = 0, sxy = 0;
    arr.forEach((y, i) => {
      sx += i;
      sy += y;
      sxx += i * i;
      sxy += i * y;
    });
    const d = k * sxx - sx * sx;
    if (!d) return null;
    const a = (k * sxy - sx * sy) / d;
    const b = (sy - a * sx) / k;
    return { a, b };
  };
  const yaa = regress(cur);
  const yhm = regress(hm);
  const trendLine = (reg, stroke) => {
    if (!reg) return null;
    const y0 = reg.b, y1 = reg.a * (n - 1) + reg.b;
    const x0 = xCenter(0), x1 = xCenter(n - 1);
    return /* @__PURE__ */ React.createElement(
      "line",
      {
        x1: x0,
        y1: toY(y0),
        x2: x1,
        y2: toY(y1),
        stroke,
        strokeWidth: "1.8",
        strokeDasharray: "5 4",
        opacity: "0.9"
      }
    );
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 14,
    alignItems: "center",
    flexWrap: "wrap",
    fontSize: 12,
    marginBottom: 8
  } }, /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 12, height: 10, background: "var(--accent)" } }), "\xDAltimos 12m: ", /* @__PURE__ */ React.createElement("strong", null, fmt(totalCur), " \u20AC")), /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 12, height: 10, background: "var(--muted)", opacity: 0.5 } }), "Hom\xF3logo: ", /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--muted)" } }, fmt(totalHm), " \u20AC")), yaa && /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 16, height: 0, borderTop: `2px dashed ${yaa.a >= 0 ? "#16a34a" : "#dc2626"}` } }), "Yaa ", /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)", color: "var(--muted)" } }, "(", (yaa.a >= 0 ? "+" : "") + fmt(yaa.a), "/m\xEAs)")), yhm && /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 16, height: 0, borderTop: "2px dashed #6b7280" } }), "Yhm ", /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)", color: "var(--muted)" } }, "(", (yhm.a >= 0 ? "+" : "") + fmt(yhm.a), "/m\xEAs)")), delta != null && /* @__PURE__ */ React.createElement(DeltaBadge, { pct: delta })), /* @__PURE__ */ React.createElement("svg", { width: "100%", height: h, viewBox: `0 0 ${w} ${h}`, preserveAspectRatio: "none", style: { display: "block" } }, [0, 0.5, 1].map((p) => {
    const y = padT + innerH - p * innerH;
    return /* @__PURE__ */ React.createElement(
      "line",
      {
        key: p,
        x1: padL,
        y1: y,
        x2: w - padR,
        y2: y,
        stroke: "var(--border)",
        strokeDasharray: p === 0 ? "0" : "2 3"
      }
    );
  }), [0, 0.5, 1].map((p) => {
    const y = padT + innerH - p * innerH;
    return /* @__PURE__ */ React.createElement(
      "text",
      {
        key: "l" + p,
        x: padL - 6,
        y: y + 3,
        textAnchor: "end",
        fontSize: "9",
        fontFamily: "var(--font-mono)",
        fill: "var(--muted)"
      },
      fmt(p * max).split(",")[0]
    );
  }), labels.map((lbl, i) => {
    const xc = xCenter(i);
    const hH = hm[i] / max * innerH;
    const cH = cur[i] / max * innerH;
    return /* @__PURE__ */ React.createElement("g", { key: i }, /* @__PURE__ */ React.createElement(
      "rect",
      {
        x: xc - barW - 1,
        y: padT + innerH - hH,
        width: barW,
        height: hH,
        fill: "var(--muted)",
        opacity: "0.5"
      },
      /* @__PURE__ */ React.createElement("title", null, lbl, " hom\xF3logo: ", fmt(hm[i]), " \u20AC")
    ), /* @__PURE__ */ React.createElement(
      "rect",
      {
        x: xc + 1,
        y: padT + innerH - cH,
        width: barW,
        height: cH,
        fill: "var(--accent)"
      },
      /* @__PURE__ */ React.createElement("title", null, lbl, ": ", fmt(cur[i]), " \u20AC")
    ), /* @__PURE__ */ React.createElement(
      "text",
      {
        x: xc,
        y: h - 8,
        textAnchor: "middle",
        fontSize: "9",
        fontFamily: "var(--font-mono)",
        fill: "var(--muted)"
      },
      lbl
    ));
  }), trendLine(yhm, "#6b7280"), trendLine(yaa, yaa && yaa.a >= 0 ? "#16a34a" : "#dc2626")));
}
function Donut({ items, fmt, size = 160 }) {
  const totals = items.map((it) => Math.max(0, Number(it.value) || 0));
  const sum = totals.reduce((a, b) => a + b, 0);
  if (sum <= 0) return /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12 } }, "Sem dados.");
  const colors = [
    "#2563eb",
    "#16a34a",
    "#f59e0b",
    "#dc2626",
    "#7c3aed",
    "#0891b2",
    "#db2777",
    "#65a30d",
    "#a16207",
    "#475569"
  ];
  const r = size / 2, cx = r, cy = r, inner = r * 0.58;
  let acc = 0;
  const slices = totals.map((v, i) => {
    const start = acc / sum * Math.PI * 2 - Math.PI / 2;
    acc += v;
    const end = acc / sum * Math.PI * 2 - Math.PI / 2;
    const large = end - start > Math.PI ? 1 : 0;
    const x1 = cx + r * Math.cos(start), y1 = cy + r * Math.sin(start);
    const x2 = cx + r * Math.cos(end), y2 = cy + r * Math.sin(end);
    const ix1 = cx + inner * Math.cos(end), iy1 = cy + inner * Math.sin(end);
    const ix2 = cx + inner * Math.cos(start), iy2 = cy + inner * Math.sin(start);
    const d = `M ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} L ${ix1} ${iy1} A ${inner} ${inner} 0 ${large} 0 ${ix2} ${iy2} Z`;
    return {
      d,
      color: items[i].color || colors[i % colors.length],
      label: items[i].label,
      value: v,
      pct: v / sum * 100
    };
  });
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}` }, slices.map((s, i) => /* @__PURE__ */ React.createElement("path", { key: i, d: s.d, fill: s.color, stroke: "var(--panel)", strokeWidth: "1" }, /* @__PURE__ */ React.createElement("title", null, s.label, ": ", fmt(s.value), " \u20AC (", s.pct.toFixed(1), "%)"))), /* @__PURE__ */ React.createElement(
    "text",
    {
      x: cx,
      y: cy - 4,
      textAnchor: "middle",
      fontSize: "11",
      fill: "var(--muted)",
      fontFamily: "var(--font-mono)"
    },
    "total"
  ), /* @__PURE__ */ React.createElement(
    "text",
    {
      x: cx,
      y: cy + 12,
      textAnchor: "middle",
      fontSize: "13",
      fill: "var(--text)",
      fontWeight: "600"
    },
    fmt(sum)
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 4, fontSize: 12 } }, slices.map((s, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: { display: "flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 10, height: 10, borderRadius: 2, background: s.color, flexShrink: 0 } }), /* @__PURE__ */ React.createElement("span", { style: { minWidth: 90 } }, s.label), /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)", color: "var(--muted)" } }, s.pct.toFixed(1), "%")))));
}
function TipoArtRow({ t, fmt }) {
  const sw = 160, sh = 36, sp = 3;
  const hm = t.series.slice(0, 12);
  const cur = t.series.slice(12, 24);
  const max = Math.max(0.01, ...t.series);
  const xStep = (sw - sp * 2) / Math.max(1, 11);
  const toPts = (arr) => arr.map((v, i) => `${sp + i * xStep},${sh - sp - v / max * (sh - sp * 2)}`).join(" ");
  const ptsHm = toPts(hm), ptsCur = toPts(cur);
  return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("strong", null, t.tipoart || "\u2014")), /* @__PURE__ */ React.createElement("td", { className: "td-num", style: { fontWeight: 500 } }, fmt(t.vlr_ano), " \u20AC"), /* @__PURE__ */ React.createElement("td", { className: "td-num td-muted" }, fmt(t.vlr_ano_hm), " \u20AC"), /* @__PURE__ */ React.createElement("td", { className: "td-num" }, /* @__PURE__ */ React.createElement(DeltaBadge, { pct: t.delta_pct })), /* @__PURE__ */ React.createElement("td", { className: "td-num" }, Number(t.qtd_l12m).toLocaleString("pt-PT", { maximumFractionDigits: 0 })), /* @__PURE__ */ React.createElement("td", { className: "td-num" }, t.skus), /* @__PURE__ */ React.createElement("td", { title: "Linha grossa: \xFAltimos 12m \xB7 Linha clara tracejada: 12m hom\xF3logo" }, /* @__PURE__ */ React.createElement("svg", { width: sw, height: sh, viewBox: `0 0 ${sw} ${sh}`, style: { display: "block" } }, /* @__PURE__ */ React.createElement(
    "polyline",
    {
      points: ptsHm,
      fill: "none",
      stroke: "var(--muted)",
      strokeWidth: "1",
      strokeDasharray: "2 2",
      opacity: "0.7"
    }
  ), /* @__PURE__ */ React.createElement("polyline", { points: ptsCur, fill: "none", stroke: "var(--accent)", strokeWidth: "1.8" }))));
}
function TrendPill({ arrow, label }) {
  if (arrow == null) return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 12 } }, "\u2014");
  const a = Number(arrow);
  const style = a >= 2 ? { bg: "#bbf7d0", fg: "#14532d", icon: "\u2197\u2197" } : a >= 1 ? { bg: "#dcfce7", fg: "#166534", icon: "\u2197" } : a <= -2 ? { bg: "#fecaca", fg: "#7f1d1d", icon: "\u2198\u2198" } : a <= -1 ? { bg: "#fee2e2", fg: "#991b1b", icon: "\u2198" } : { bg: "#e5e7eb", fg: "#374151", icon: "\u2192" };
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 600,
    background: style.bg,
    color: style.fg,
    whiteSpace: "nowrap"
  } }, style.icon, " ", label || a);
}
function DeltaBadge({ pct, invert = false }) {
  if (pct == null) return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014");
  const positive = pct >= 0;
  const good = invert ? !positive : positive;
  const bg = good ? "#dcfce7" : "#fee2e2";
  const fg = good ? "#166534" : "#991b1b";
  const arrow = positive ? "\u25B2" : "\u25BC";
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 600,
    background: bg,
    color: fg,
    fontVariantNumeric: "tabular-nums"
  } }, arrow, " ", positive ? "+" : "", Number(pct).toFixed(1), " %");
}
function WhaleKpiCard({ kpi, fmt }) {
  const { label, value, prev, delta_pct, format } = kpi;
  const fmtVal = (v) => {
    if (v == null) return "\u2014";
    if (format === "eur") return `${fmt(v)} \u20AC`;
    if (format === "pct") return `${Number(v).toFixed(2)} %`;
    return Number(v).toLocaleString("pt-PT", { maximumFractionDigits: 0 });
  };
  const deltaColor = delta_pct == null ? "var(--muted)" : delta_pct >= 0 ? "#3a8a4d" : "#c4434b";
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: 10,
    background: "var(--bg)",
    borderRadius: 6,
    border: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em"
  } }, label), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 17, fontWeight: 600, marginTop: 4, fontVariantNumeric: "tabular-nums" } }, fmtVal(value)), (prev != null || delta_pct != null) && /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
    fontSize: 11,
    color: "var(--muted)"
  } }, prev != null && /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)" } }, fmtVal(prev)), delta_pct != null && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", color: deltaColor, fontWeight: 600 } }, delta_pct >= 0 ? "+" : "", delta_pct, " %")));
}
window.HubCharts = {
  Rolling12m: Rolling12mChart,
  Donut,
  KpiCard: WhaleKpiCard,
  ArtTypeRow: TipoArtRow,
  TrendPill,
  DeltaBadge,
  DateFilter: WhaleDateFilter,
  resolvePreset
  // preset→{from,to}; usado pelo DateFilter e pelas apps
};

// ===== anexos/frontend.jsx =====
const FILE_ICONS = [
  [["pdf"], () => Ico.pdf],
  [["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg", "heic", "tif", "tiff"], () => Ico.image],
  [["xls", "xlsx", "xlsm", "csv", "ods", "numbers"], () => Ico.sheet],
  [["zip", "rar", "7z", "gz", "tar"], () => Ico.archive],
  [["dwg", "dxf", "step", "stp", "iges", "igs", "stl", "sldprt", "sldasm"], () => Ico.ruler]
];
function extOf(nome) {
  const m = /\.([a-z0-9]+)$/i.exec(String(nome || ""));
  return m ? m[1].toLowerCase() : "";
}
function fileIcon(ext) {
  for (const [exts, get] of FILE_ICONS) if (exts.includes(ext)) return get();
  return Ico.doc;
}
function AnexoMenu({ isLink, href, onRemove }) {
  const [open, setOpen] = React.useState(false);
  const linkAttrs = isLink ? { target: "_blank", rel: "noopener noreferrer" } : { download: true };
  return /* @__PURE__ */ React.createElement("span", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "aria-label": "A\xE7\xF5es do anexo",
      onClick: () => setOpen((o) => !o),
      className: "btn ghost sm icon-only",
      style: { padding: "2px 6px" }
    },
    "\u22EF"
  ), open && /* @__PURE__ */ React.createElement("span", { style: {
    position: "absolute",
    right: 0,
    top: "100%",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    zIndex: 10,
    minWidth: 130
  } }, /* @__PURE__ */ React.createElement(
    "a",
    {
      href,
      ...linkAttrs,
      onClick: () => setOpen(false),
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "6px 10px",
        textDecoration: "none",
        color: "var(--text)",
        fontSize: 12.5
      }
    },
    isLink ? "Abrir" : "Descarregar"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setOpen(false);
        onRemove();
      },
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "6px 10px",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: 12.5,
        color: "#c4434b"
      }
    },
    "Remover"
  )));
}
function AnexosPanel({ app, resource, id, me }) {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [uploading, setUploading] = React.useState(false);
  const [addingLink, setAddingLink] = React.useState(false);
  const [linkNome, setLinkNome] = React.useState("");
  const [linkUrl, setLinkUrl] = React.useState("");
  const fileInputRef = React.useRef(null);
  const reload = React.useCallback(() => {
    setLoading(true);
    return window.API.anexos({ app_label: app, resource, resource_id: id }).then((data) => setRows(Array.isArray(data) ? data : data?.results || [])).catch(() => setRows([])).finally(() => setLoading(false));
  }, [app, resource, id]);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const remove = async (a) => {
    const ok = await window.hubConfirm({ message: "Remover anexo?" });
    if (!ok) return;
    try {
      await window.API.deleteAnexo(a.id);
      window.srToast && window.srToast("Anexo removido.");
      reload();
    } catch (e) {
      window.srToast && window.srToast("Erro a remover anexo.");
    }
  };
  const onPickFile = () => fileInputRef.current && fileInputRef.current.click();
  const onFileChosen = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("app_label", app);
      fd.append("resource", resource);
      fd.append("resource_id", id);
      fd.append("nome", file.name);
      fd.append("kind", "file");
      fd.append("ficheiro", file);
      await window.API.uploadAnexo(fd);
      window.srToast && window.srToast("Ficheiro adicionado.");
      reload();
    } catch (err) {
      window.srToast && window.srToast("Erro a adicionar ficheiro.");
    } finally {
      setUploading(false);
    }
  };
  const startAddLink = () => {
    setLinkNome("");
    setLinkUrl("");
    setAddingLink(true);
  };
  const cancelAddLink = () => setAddingLink(false);
  const confirmAddLink = async () => {
    const nome = linkNome.trim();
    const url = linkUrl.trim();
    if (!nome || !url) return;
    try {
      await window.API.addAnexoLink({
        app_label: app,
        resource,
        resource_id: id,
        nome,
        url,
        kind: "link"
      });
      window.srToast && window.srToast("Link adicionado.");
      setAddingLink(false);
      reload();
    } catch (err) {
      window.srToast && window.srToast("Erro a adicionar link.");
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "hub-anexos" }, /* @__PURE__ */ React.createElement("div", { className: "hub-anexos__toolbar", style: { display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 10 } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: uploading, onClick: onPickFile }, uploading ? "A enviar\u2026" : "Adicionar ficheiro"), /* @__PURE__ */ React.createElement("input", { ref: fileInputRef, type: "file", style: { display: "none" }, onChange: onFileChosen }), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: startAddLink }, "Adicionar link")), addingLink && /* @__PURE__ */ React.createElement("div", { className: "hub-anexos__link-form", style: { display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "Nome",
      value: linkNome,
      onChange: (e) => setLinkNome(e.target.value)
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "URL",
      value: linkUrl,
      onChange: (e) => setLinkUrl(e.target.value),
      style: { flex: 1 }
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn primary sm",
      disabled: !linkNome.trim() || !linkUrl.trim(),
      onClick: confirmAddLink
    },
    "Guardar"
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: cancelAddLink }, "Cancelar")), loading && rows.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12.5, padding: "4px 0" } }, "A carregar\u2026"), !loading && rows.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12.5, padding: "4px 0" } }, "Sem anexos."), rows.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "hub-anexos__list", style: { display: "flex", flexDirection: "column", gap: 8 } }, rows.map((a) => {
    const isLink = a.kind === "link";
    const href = isLink ? a.url : `/api/anexos/${a.id}/download/`;
    const ext = isLink ? "" : extOf(a.nome);
    const Icon = isLink ? Ico.external : fileIcon(ext);
    const when = a.criado_em ? new Date(a.criado_em) : null;
    const size = !isLink && a.tamanho ? `${Math.round(a.tamanho / 1024)} KB` : null;
    const foot = isLink ? "Link externo" : [size, ext ? ext.toUpperCase() : null].filter(Boolean).join("  \xB7  ");
    return /* @__PURE__ */ React.createElement("div", { key: a.id, className: "hub-anexos__card hub-card" }, /* @__PURE__ */ React.createElement("div", { className: "hub-anexos__top" }, /* @__PURE__ */ React.createElement("span", { className: "hub-anexos__by" }, /* @__PURE__ */ React.createElement("strong", null, a.criado_por_nome || "\u2014"), when && /* @__PURE__ */ React.createElement("span", null, " \xB7 ", fmtDateTime(when))), /* @__PURE__ */ React.createElement(AnexoMenu, { isLink, href, onRemove: () => remove(a) })), /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "hub-anexos__hit",
        href,
        ...isLink ? { target: "_blank", rel: "noopener noreferrer" } : { download: a.nome },
        title: isLink ? "Abrir link" : "Descarregar"
      },
      /* @__PURE__ */ React.createElement("span", { className: "hub-anexos__ficon" + (isLink ? " is-link" : "") }, /* @__PURE__ */ React.createElement(Icon, null)),
      /* @__PURE__ */ React.createElement("span", { className: "hub-anexos__name" }, a.nome)
    ), foot && /* @__PURE__ */ React.createElement("div", { className: "hub-anexos__foot" }, foot));
  })));
}
window.AnexosPanel = AnexosPanel;

// ===== atividades/frontend.jsx =====
const DIAS_SEMANA_CAL = ["Seg", "Ter", "Qua", "Qui", "Sex", "S\xE1b", "Dom"];
const MESES_CAL = [
  "janeiro",
  "fevereiro",
  "mar\xE7o",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro"
];
function _calIso(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
function _calSegunda(d) {
  const out = new Date(d);
  const dow = (out.getDay() + 6) % 7;
  out.setDate(out.getDate() - dow);
  out.setHours(0, 0, 0, 0);
  return out;
}
function _calGrelhaMes(ancora) {
  const primeiro = new Date(ancora.getFullYear(), ancora.getMonth(), 1);
  const inicio = _calSegunda(primeiro);
  return Array.from({ length: 42 }, (_, i) => {
    const d = new Date(inicio);
    d.setDate(inicio.getDate() + i);
    return d;
  });
}
function _calGrelhaSemana(ancora) {
  const inicio = _calSegunda(ancora);
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(inicio);
    d.setDate(inicio.getDate() + i);
    return d;
  });
}
function HubCalendarioView(props) {
  const { useState, useEffect, useMemo } = React;
  const navigate = props && props.navigate || window.HubRouter.navigate;
  const paramsIniciais = window.HubRouter.current().params;
  const [modo, setModo] = useState(paramsIniciais.get("modo") || "mes");
  const [ancoraISO, setAncoraISO] = useState(paramsIniciais.get("dia") || _calIso(/* @__PURE__ */ new Date()));
  const [app, setApp] = useState(paramsIniciais.get("app") || "");
  const [eventos, setEventos] = useState([]);
  const [prazos, setPrazos] = useState([]);
  const [aCarregar, setACarregar] = useState(false);
  const [erro, setErro] = useState("");
  const ancora = useMemo(() => /* @__PURE__ */ new Date(`${ancoraISO}T12:00:00`), [ancoraISO]);
  const dias = useMemo(
    () => modo === "semana" ? _calGrelhaSemana(ancora) : _calGrelhaMes(ancora),
    [modo, ancora]
  );
  useEffect(() => {
    window.HubRouter.setParams({ modo, dia: ancoraISO, app: app || null });
  }, [modo, ancoraISO, app]);
  useEffect(() => {
    let ignorado = false;
    setACarregar(true);
    setErro("");
    window.API.meuCalendario({ de: _calIso(dias[0]), ate: _calIso(dias[dias.length - 1]) }).then((r) => {
      if (ignorado) return;
      setEventos(r.eventos || []);
      setPrazos(r.prazos || []);
    }).catch((e) => {
      if (!ignorado) setErro(String(e.message || e));
    }).finally(() => {
      if (!ignorado) setACarregar(false);
    });
    return () => {
      ignorado = true;
    };
  }, [dias]);
  const appsNoIntervalo = useMemo(() => {
    const mapa = /* @__PURE__ */ new Map();
    eventos.forEach((e) => {
      if (e.app_label) mapa.set(e.app_label, e.app_nome || e.app_label);
    });
    prazos.forEach((p) => {
      if (p.app_label) mapa.set(p.app_label, p.app_nome || p.app_label);
    });
    return [...mapa.entries()].sort((a, b) => a[1].localeCompare(b[1]));
  }, [eventos, prazos]);
  const eventosFiltrados = useMemo(
    () => app ? eventos.filter((e) => e.app_label === app) : eventos,
    [eventos, app]
  );
  const prazosFiltrados = useMemo(
    () => app ? prazos.filter((p) => p.app_label === app) : prazos,
    [prazos, app]
  );
  const porDia = useMemo(() => {
    const mapa = {};
    eventosFiltrados.forEach((e) => {
      const chave = _calIso(new Date(e.inicio));
      (mapa[chave] = mapa[chave] || { eventos: [], prazos: [] }).eventos.push(e);
    });
    prazosFiltrados.forEach((p) => {
      if (!p.prazo) return;
      (mapa[p.prazo] = mapa[p.prazo] || { eventos: [], prazos: [] }).prazos.push(p);
    });
    return mapa;
  }, [eventosFiltrados, prazosFiltrados]);
  function saltar(passo) {
    const d = new Date(ancora);
    if (modo === "semana") {
      d.setDate(d.getDate() + passo * 7);
    } else {
      d.setDate(1);
      d.setMonth(d.getMonth() + passo);
    }
    setAncoraISO(_calIso(d));
  }
  function abrirRecurso(item) {
    const destino = window.HUB_REG.routeForLink(item.link_view);
    if (!destino || !destino.routeId) return;
    navigate({
      routeId: destino.routeId,
      entidade: item.link_target != null && item.link_target !== "" ? String(item.link_target) : null
    });
  }
  const titulo = modo === "semana" ? `Semana de ${_calIso(dias[0])}` : `${MESES_CAL[ancora.getMonth()]} de ${ancora.getFullYear()}`;
  const semNada = !aCarregar && eventosFiltrados.length === 0 && prazosFiltrados.length === 0;
  return /* @__PURE__ */ React.createElement("div", { className: "content" }, /* @__PURE__ */ React.createElement("div", { className: "toolbar" }, /* @__PURE__ */ React.createElement("button", { className: "btn", onClick: () => saltar(-1) }, "\u2039"), /* @__PURE__ */ React.createElement("strong", { style: { minWidth: 200, textAlign: "center" } }, titulo), /* @__PURE__ */ React.createElement("button", { className: "btn", onClick: () => saltar(1) }, "\u203A"), /* @__PURE__ */ React.createElement("button", { className: "btn", onClick: () => setAncoraISO(_calIso(/* @__PURE__ */ new Date())) }, "Hoje"), /* @__PURE__ */ React.createElement("span", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement("select", { value: modo, onChange: (e) => setModo(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "mes" }, "M\xEAs"), /* @__PURE__ */ React.createElement("option", { value: "semana" }, "Semana")), /* @__PURE__ */ React.createElement("select", { value: app, onChange: (e) => setApp(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todas as apps"), appsNoIntervalo.map(([label, nome]) => /* @__PURE__ */ React.createElement("option", { key: label, value: label }, nome)))), erro && /* @__PURE__ */ React.createElement("div", { className: "erro" }, erro), window.SR_ME?.apps?.includes("prospecao") && window.HubOutlookPainel && /* @__PURE__ */ React.createElement(window.HubOutlookPainel, null), semNada && /* @__PURE__ */ React.createElement("div", { className: "cal-empty" }, "N\xE3o tens compromissos nem prazos marcados neste per\xEDodo."), /* @__PURE__ */ React.createElement("div", { className: modo === "semana" ? "cal-grid cal-semana" : "cal-grid cal-mes" }, DIAS_SEMANA_CAL.map((d) => /* @__PURE__ */ React.createElement("div", { key: d, className: "cal-head" }, d)), dias.map((d) => {
    const chave = _calIso(d);
    const doMes = d.getMonth() === ancora.getMonth();
    const doDia = porDia[chave] || { eventos: [], prazos: [] };
    return /* @__PURE__ */ React.createElement("div", { key: chave, className: doMes ? "cal-dia" : "cal-dia cal-dia-fora" }, /* @__PURE__ */ React.createElement("div", { className: "cal-dia-num" }, d.getDate()), doDia.prazos.map((p) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: `prazo-${p.app_label}-${p.id}`,
        type: "button",
        className: "cal-evento cal-prazo",
        title: `Prazo \xB7 ${p.app_nome} \xB7 ${p.titulo}`,
        onClick: () => abrirRecurso(p)
      },
      /* @__PURE__ */ React.createElement("span", { className: "cal-prazo-marca", "aria-hidden": "true" }, "\u25B8"),
      /* @__PURE__ */ React.createElement("span", { className: "cal-titulo" }, p.titulo),
      /* @__PURE__ */ React.createElement("span", { className: "cal-app" }, p.app_nome)
    )), doDia.eventos.map((e) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: `evento-${e.app_label}-${e.id}`,
        type: "button",
        className: "cal-evento",
        title: `${e.app_nome} \xB7 ${e.titulo}`,
        onClick: () => abrirRecurso(e)
      },
      /* @__PURE__ */ React.createElement("span", { className: "cal-hora" }, new Date(e.inicio).toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" })),
      /* @__PURE__ */ React.createElement("span", { className: "cal-titulo" }, e.titulo),
      /* @__PURE__ */ React.createElement("span", { className: "cal-app" }, e.app_nome),
      e.sync_estado === "pendente" && /* @__PURE__ */ React.createElement("span", { className: "cal-aviso", title: "Por sincronizar" }, "\u2022"),
      e.sync_estado === "erro" && /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "cal-aviso cal-aviso-erro",
          title: "Desistiu de sincronizar com o Outlook \u2014 esgotou as tentativas. Edita ou cancela o evento para tentar de novo."
        },
        "\u2715"
      )
    )));
  })));
}
window.HubCalendarioView = HubCalendarioView;
function HubOutlookPainel() {
  const { useState, useEffect } = React;
  const [lig, setLig] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const carregar = () => window.API.minhaOutlookLigacao().then(setLig).catch(() => setLig(null));
  useEffect(carregar, []);
  if (!lig) return null;
  async function alternar() {
    setOcupado(true);
    try {
      if (lig.ativo) {
        const ok = await window.hubConfirm({
          title: "Desligar o Outlook",
          message: "As reuni\xF5es deixam de ser sincronizadas. As j\xE1 criadas ficam no teu calend\xE1rio.",
          confirmLabel: "Desligar"
        });
        if (!ok) return;
        setLig(await window.API.desligarOutlook());
      } else {
        const ok = await window.hubConfirm({
          title: "Ligar o Outlook",
          message: "As reuni\xF5es que marcares no hub passam a aparecer na tua agenda, e as reuni\xF5es da tua agenda com clientes reconhecidos passam a aparecer no hub \u2014 vis\xEDveis a quem tem acesso a esses registos.",
          confirmLabel: "Ligar"
        });
        if (!ok) return;
        setLig(await window.API.ligarOutlook());
      }
    } catch (e) {
      window.srToast?.(String(e.message || e), "error");
    } finally {
      setOcupado(false);
    }
  }
  return /* @__PURE__ */ React.createElement("div", { className: "panel-inline", style: { display: "flex", alignItems: "center", gap: 10 } }, /* @__PURE__ */ React.createElement("strong", null, "O meu Outlook"), /* @__PURE__ */ React.createElement("span", { className: lig.ativo ? "chip chip-on" : "chip" }, lig.ativo ? `ligado (${lig.mailbox})` : "desligado"), lig.estado === "erro" && /* @__PURE__ */ React.createElement("span", { className: "erro" }, lig.erro), lig.ultimo_sync && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\xFAltimo sync: ", new Date(lig.ultimo_sync).toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", disabled: ocupado, onClick: alternar }, lig.ativo ? "Desligar" : "Ligar"));
}
window.HubOutlookPainel = HubOutlookPainel;

// ===== atribuicoes/frontend.jsx =====
(function() {
  function eligibleUsers(users, appLabel) {
    const pool = (users || []).filter((u) => u.is_active !== false && (u.is_staff || (u.apps || []).includes(appLabel)));
    const anyAssignable = pool.some((u) => (u.assignable_apps || []).includes(appLabel));
    if (!anyAssignable) return pool;
    return pool.filter((u) => u.is_staff || (u.assignable_apps || []).includes(appLabel));
  }
  window.HubAtribuicoes = Object.assign(window.HubAtribuicoes || {}, { eligibleUsers });
})();
function _atrib_getCsrfCookie() {
  const m = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}
function _atrib_hashHue(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = h * 31 + s.charCodeAt(i) | 0;
  return Math.abs(h) % 360;
}
function UserPill({ username, users = [], compact = false }) {
  if (!username) return /* @__PURE__ */ React.createElement("span", { className: "com-unassigned" }, "\u2014 N\xE3o atribu\xEDdo \u2014");
  const u = users.find((x) => x.username === username);
  const display = u ? u.first_name ? `${u.first_name} ${u.last_name || ""}`.trim() : u.username : username;
  const initials = u ? ((u.first_name?.[0] || u.username[0]) + (u.last_name?.[0] || "")).toUpperCase() : username.slice(0, 2).toUpperCase();
  const color = `hsl(${_atrib_hashHue(username)} 45% 42%)`;
  return /* @__PURE__ */ React.createElement("span", { className: "com-pill" }, /* @__PURE__ */ React.createElement("span", { className: "com-avatar", style: { background: color } }, initials), !compact && /* @__PURE__ */ React.createElement("span", null, display));
}
function AssignmentDropdown({ username, users = [], onChange, appLabel = null, appSlug = null }) {
  const label = appLabel || appSlug;
  const eligible = label ? window.HubAtribuicoes.eligibleUsers(users, label) : users.filter((u) => u.is_active);
  return /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("span", { style: { cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4 }, title: "Mudar atribui\xE7\xE3o" }, /* @__PURE__ */ React.createElement(UserPill, { username, users, compact: true }), /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    onChange && onChange(null);
    close();
  } }, "\u2014 Remover atribui\xE7\xE3o"), eligible.map((u) => /* @__PURE__ */ React.createElement(MenuItem, { key: u.id, onClick: () => {
    onChange && onChange(u.id);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { className: "com-avatar", style: {
    background: `hsl(${_atrib_hashHue(u.username)} 45% 42%)`,
    width: 16,
    height: 16,
    fontSize: 8
  } }, (u.first_name ? u.first_name[0] : u.username[0]).toUpperCase()) }, `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username))));
}
function HubAssignableUsers({ appLabel, appName }) {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [savingId, setSavingId] = React.useState(null);
  const reload = React.useCallback(() => {
    setLoading(true);
    setError(null);
    return fetch(`/api/atribuicoes/${appLabel}/assignable/`, { credentials: "same-origin" }).then((r) => {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    }).then((data) => setRows(data || [])).catch(() => {
      setError("N\xE3o foi poss\xEDvel carregar os utilizadores.");
      window.srToast && window.srToast("Erro a carregar utilizadores.");
    }).finally(() => setLoading(false));
  }, [appLabel]);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const toggle = (u) => {
    const next = !u.is_assignable;
    setSavingId(u.id);
    setRows((rs) => rs.map((r) => r.id === u.id ? { ...r, is_assignable: next } : r));
    fetch(`/api/atribuicoes/${appLabel}/assignable/`, {
      method: "PUT",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-CSRFToken": _atrib_getCsrfCookie() },
      body: JSON.stringify({ user_id: u.id, is_assignable: next })
    }).then((r) => {
      if (!r.ok) throw new Error(String(r.status));
      window.srToast && window.srToast(next ? `${u.nome} marcado como atribu\xEDvel.` : `${u.nome} removido dos atribu\xEDveis.`);
    }).catch(() => {
      setRows((rs) => rs.map((r) => r.id === u.id ? { ...r, is_assignable: !next } : r));
      window.srToast && window.srToast("Erro a gravar. Tenta de novo.");
    }).finally(() => setSavingId(null));
  };
  const ATRIBUIVEIS_COLUNAS = [
    {
      key: "nome",
      label: "Utilizador",
      width: 260,
      minWidth: 180,
      fixed: true,
      render: (u) => u.nome || u.username
    },
    {
      key: "is_assignable",
      label: "Atribu\xEDvel",
      width: 120,
      minWidth: 100,
      render: (u) => /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: !!u.is_assignable,
          disabled: savingId === u.id,
          onChange: () => toggle(u)
        }
      ))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", null, error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), loading ? /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Utilizadores atribu\xEDveis", appName ? ` \u2014 ${appName}` : "")), /* @__PURE__ */ React.createElement("div", { style: { padding: 12, color: "var(--muted)" } }, "A carregar\u2026")) : /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "hub",
      viewId: "atribuicoes",
      title: `Utilizadores atribu\xEDveis${appName ? ` \u2014 ${appName}` : ""}`,
      toolbar: /* @__PURE__ */ React.createElement("span", { className: "sub", style: { marginLeft: 8 } }, "\xB7 sem nenhum marcado, qualquer utilizador com acesso pode ser atribu\xEDdo"),
      columns: ATRIBUIVEIS_COLUNAS,
      data: rows,
      pagination: "none",
      rowKey: (u) => u.id,
      empty: "Sem utilizadores com acesso a esta app."
    }
  ));
}
window.HubUserPill = UserPill;
window.HubAssignmentDropdown = AssignmentDropdown;
window.HubAssignableUsers = HubAssignableUsers;
window.UserPill = UserPill;
window.AssignmentDropdown = AssignmentDropdown;
window.InlineUserPicker = AssignmentDropdown;

// ===== chat-embed/frontend.jsx =====
function renderBody(body) {
  if (!body) return null;
  const out = [];
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`|@[a-zA-Z][a-zA-Z0-9._-]{1,29}|https?:\/\/[^\s]+)/g;
  let last = 0;
  let m;
  let key = 0;
  while ((m = re.exec(body)) !== null) {
    if (m.index > last) out.push(/* @__PURE__ */ React.createElement(React.Fragment, { key: key++ }, body.slice(last, m.index)));
    const tok = m[0];
    if (tok.startsWith("**")) {
      out.push(/* @__PURE__ */ React.createElement("strong", { key: key++ }, tok.slice(2, -2)));
    } else if (tok.startsWith("*")) {
      out.push(/* @__PURE__ */ React.createElement("em", { key: key++ }, tok.slice(1, -1)));
    } else if (tok.startsWith("`")) {
      out.push(/* @__PURE__ */ React.createElement("code", { key: key++, style: {
        background: "rgba(0,0,0,0.06)",
        padding: "0 4px",
        borderRadius: 3
      } }, tok.slice(1, -1)));
    } else if (tok.startsWith("@")) {
      out.push(/* @__PURE__ */ React.createElement("span", { key: key++, style: {
        background: "color-mix(in srgb, var(--accent) 25%, transparent)",
        color: "var(--accent)",
        padding: "0 4px",
        borderRadius: 4,
        fontWeight: 600
      } }, tok));
    } else {
      out.push(/* @__PURE__ */ React.createElement(
        "a",
        {
          key: key++,
          href: tok,
          target: "_blank",
          rel: "noopener noreferrer",
          style: { color: "inherit", textDecoration: "underline" }
        },
        tok
      ));
    }
    last = m.index + tok.length;
  }
  if (last < body.length) out.push(/* @__PURE__ */ React.createElement(React.Fragment, { key: key++ }, body.slice(last)));
  return out;
}
function ChatAvatar({ url, label, size = 28 }) {
  const initial = ((label || "?").trim()[0] || "?").toUpperCase();
  return /* @__PURE__ */ React.createElement("span", { style: {
    width: size,
    height: size,
    borderRadius: "50%",
    flexShrink: 0,
    overflow: "hidden",
    background: "var(--brand-navy, #2c5d8a)",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: Math.round(size * 0.42),
    fontWeight: 600,
    position: "relative"
  } }, initial, url && /* @__PURE__ */ React.createElement(
    "img",
    {
      src: url,
      alt: "",
      draggable: false,
      onError: (e) => {
        e.currentTarget.style.display = "none";
      },
      style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
    }
  ));
}
function MessageBubble({ m, mine }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 8,
    marginBottom: 8,
    flexDirection: mine ? "row-reverse" : "row",
    alignItems: "flex-end"
  } }, /* @__PURE__ */ React.createElement(ChatAvatar, { url: m.author_photo_url, label: m.author_username }), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexDirection: "column",
    alignItems: mine ? "flex-end" : "flex-start",
    minWidth: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    color: "var(--muted)",
    marginBottom: 2,
    fontFamily: "var(--font-mono)"
  } }, m.author_username, " \xB7 ", new Date(m.created_at).toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" }), m.edited_at ? " \xB7 editada" : ""), /* @__PURE__ */ React.createElement("div", { style: {
    background: mine ? "var(--accent)" : "var(--panel-2)",
    color: mine ? "#fff" : "var(--text)",
    padding: "6px 10px",
    borderRadius: 10,
    maxWidth: 460,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontStyle: m.is_deleted ? "italic" : "normal",
    opacity: m.is_deleted ? 0.6 : 1
  } }, m.is_deleted ? "(mensagem apagada)" : renderBody(m.body))));
}
function ComposeBox({ convId, onSent, onAppendLocal, ws, users = [], userTypes = [] }) {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const lastTypingSent = useRef(0);
  const sendTyping = () => {
    const now = Date.now();
    if (now - lastTypingSent.current > 2500 && ws && ws.readyState === 1) {
      ws.send(JSON.stringify({ type: "typing.start" }));
      lastTypingSent.current = now;
    }
  };
  const send = async () => {
    if (!text.trim() || sending) return;
    setSending(true);
    try {
      const msg = await window.API.chatSendMessage(convId, text.trim());
      setText("");
      onAppendLocal && onAppendLocal(msg);
      onSent && onSent(msg);
    } catch (e) {
    } finally {
      setSending(false);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--border)", padding: 8, display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement(
    MentionTextarea,
    {
      value: text,
      onChange: (v) => {
        setText(v);
        sendTyping();
      },
      users,
      groups: userTypes,
      onSubmit: send,
      rows: 1,
      placeholder: "Escreve uma mensagem\u2026 (Enter envia, Shift+Enter nova linha, @ para mencionar)",
      style: {
        width: "100%",
        resize: "none",
        fontSize: 16,
        padding: "8px 10px",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)"
      }
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      onClick: send,
      disabled: !text.trim() || sending
    },
    /* @__PURE__ */ React.createElement(Ico.send, null)
  ));
}
function ChatEmbed({
  convId,
  currentUserId,
  users = [],
  userTypes = [],
  compact = false,
  onClose = null,
  onSent,
  threadRef
}) {
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [meta, setMeta] = useState(null);
  const bottomRef = useRef(null);
  const didInitialScroll = useRef(false);
  useEffect(() => {
    didInitialScroll.current = false;
  }, [convId]);
  useLayoutEffect(() => {
    if (loading || msgs.length === 0) return;
    const behavior = didInitialScroll.current ? "smooth" : "auto";
    bottomRef.current?.scrollIntoView({ behavior, block: "end" });
    didInitialScroll.current = true;
  }, [loading, msgs.length, convId]);
  const loadInitial = async () => {
    setLoading(true);
    try {
      const [m, c] = await Promise.all([
        window.API.chatMessages(convId),
        window.API.chatConversation(convId)
      ]);
      setMsgs(m.results || []);
      setMeta(c);
      setHasMore((m.results || []).length >= 50);
      await window.API.chatMarkRead(convId).catch(() => {
      });
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadInitial();
  }, [convId]);
  const wsRef = useRef(null);
  const [typing, setTyping] = useState([]);
  const [wsConnected, setWsConnected] = useState(false);
  useEffect(() => {
    let cancelled = false;
    let ws = null;
    let reconnectTimer = null;
    let pingTimer = null;
    let backoff = 1e3;
    const handleMessage = (evt) => {
      try {
        const data = JSON.parse(evt.data);
        if (data.type === "pong") return;
        if (data.type === "message.new") {
          setMsgs((prev) => {
            if (prev.some((m) => m.id === data.message.id)) return prev;
            return [...prev, data.message];
          });
          window.API.chatMarkRead(convId).catch(() => {
          });
        } else if (data.type === "message.edit") {
          setMsgs((prev) => prev.map((m) => m.id === data.id ? { ...m, body: data.body, edited_at: data.edited_at } : m));
        } else if (data.type === "message.delete") {
          setMsgs((prev) => prev.map((m) => m.id === data.id ? { ...m, body: "", is_deleted: true } : m));
        } else if (data.type === "member.typing") {
          setTyping((prev) => {
            const now = Date.now();
            const others = prev.filter((t) => t.user_id !== data.user_id && now - t.ts < 4e3);
            return [...others, { ...data, ts: now }];
          });
        }
      } catch (e) {
      }
    };
    const connect = () => {
      if (cancelled) return;
      ws = window.API.openChatSocket(convId);
      wsRef.current = ws;
      ws.onopen = () => {
        backoff = 1e3;
        setWsConnected(true);
        pingTimer = setInterval(() => {
          if (ws && ws.readyState === 1) {
            try {
              ws.send(JSON.stringify({ type: "ping" }));
            } catch (e) {
            }
          }
        }, 25e3);
      };
      ws.onmessage = handleMessage;
      ws.onerror = () => {
      };
      ws.onclose = () => {
        setWsConnected(false);
        if (pingTimer) {
          clearInterval(pingTimer);
          pingTimer = null;
        }
        if (cancelled) return;
        reconnectTimer = setTimeout(connect, backoff);
        backoff = Math.min(backoff * 2, 3e4);
      };
    };
    connect();
    return () => {
      cancelled = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (pingTimer) clearInterval(pingTimer);
      if (ws) {
        try {
          ws.onclose = null;
          ws.close();
        } catch (e) {
        }
      }
      wsRef.current = null;
    };
  }, [convId]);
  useEffect(() => {
    const t = setInterval(() => setTyping((prev) => prev.filter((x) => Date.now() - x.ts < 4e3)), 1e3);
    return () => clearInterval(t);
  }, []);
  const loadOlder = async () => {
    if (msgs.length === 0) return;
    const before = msgs[0].id;
    const r = await window.API.chatMessages(convId, before);
    const older = r.results || [];
    setMsgs((prev) => [...older, ...prev]);
    setHasMore(older.length >= 50);
  };
  if (threadRef) threadRef.current = { reload: loadInitial, append: (m) => setMsgs((prev) => [...prev, m]) };
  if (loading) return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, color: "var(--muted)" } }, "A carregar\u2026");
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", flex: 1, minHeight: 0 } }, /* @__PURE__ */ React.createElement("div", { style: {
    padding: "10px 14px",
    borderBottom: "1px solid var(--border)",
    fontSize: 13,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 8
  } }, meta?.kind === "channel" ? `# ${meta.name}` : (() => {
    const name = meta?.other_user ? `${meta.other_user.first_name || ""} ${meta.other_user.last_name || ""}`.trim() || meta.other_user.username : "DM";
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ChatAvatar, { url: meta?.other_user?.photo_url, label: name, size: 26 }), name);
  })()), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflow: "auto", padding: 12 } }, hasMore && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      style: { width: "100%", marginBottom: 8 },
      onClick: loadOlder
    },
    "Carregar mais antigas"
  ), msgs.map((m) => /* @__PURE__ */ React.createElement(MessageBubble, { key: m.id, m, mine: m.author_id === currentUserId })), /* @__PURE__ */ React.createElement("div", { ref: bottomRef })), typing.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: "4px 14px", fontSize: 11.5, color: "var(--muted)" } }, typing.map((t) => t.username).join(", "), " a escrever\u2026"), /* @__PURE__ */ React.createElement(
    ComposeBox,
    {
      convId,
      onSent,
      ws: wsRef.current,
      users,
      userTypes,
      onAppendLocal: (m) => setMsgs((prev) => prev.some((x) => x.id === m.id) ? prev : [...prev, m])
    }
  ));
}
window.HubChatEmbed = ChatEmbed;
window.HubChatAvatar = ChatAvatar;

// ===== conta/frontend.jsx =====
function ImageCropModal({ file, onConfirm, onCancel }) {
  const FRAME = 280, OUT = 256;
  const [img, setImg] = useState(null);
  const [minScale, setMinScale] = useState(1);
  const [scale, setScale] = useState(1);
  const [off, setOff] = useState({ x: 0, y: 0 });
  const [busy, setBusy] = useState(false);
  const drag = useRef(null);
  useEffect(() => {
    const url = URL.createObjectURL(file);
    const im = new Image();
    im.onload = () => {
      const ms = Math.max(FRAME / im.width, FRAME / im.height);
      setImg(im);
      setMinScale(ms);
      setScale(ms);
      setOff({ x: (FRAME - im.width * ms) / 2, y: (FRAME - im.height * ms) / 2 });
    };
    im.src = url;
    return () => URL.revokeObjectURL(url);
  }, [file]);
  const clampOff = (o, s) => {
    const w = img.width * s, h = img.height * s;
    return { x: Math.min(0, Math.max(FRAME - w, o.x)), y: Math.min(0, Math.max(FRAME - h, o.y)) };
  };
  const onDown = (e) => {
    drag.current = { x: e.clientX, y: e.clientY, ox: off.x, oy: off.y };
    e.currentTarget.setPointerCapture(e.pointerId);
  };
  const onMove = (e) => {
    if (!drag.current || !img) return;
    setOff(clampOff({ x: drag.current.ox + (e.clientX - drag.current.x), y: drag.current.oy + (e.clientY - drag.current.y) }, scale));
  };
  const onUp = () => {
    drag.current = null;
  };
  const zoom = (s) => {
    if (!img) return;
    const ns = Math.max(minScale, Math.min(minScale * 5, s));
    const cx = FRAME / 2, cy = FRAME / 2;
    const k = ns / scale;
    setOff((o) => clampOff({ x: cx - (cx - o.x) * k, y: cy - (cy - o.y) * k }, ns));
    setScale(ns);
  };
  const confirm = () => {
    if (!img) return;
    setBusy(true);
    const c = document.createElement("canvas");
    c.width = OUT;
    c.height = OUT;
    const ctx = c.getContext("2d");
    const r = OUT / FRAME;
    ctx.drawImage(img, off.x * r, off.y * r, img.width * scale * r, img.height * scale * r);
    c.toBlob((b) => {
      setBusy(false);
      if (b) onConfirm(b);
    }, "image/jpeg", 0.9);
  };
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: "Ajustar foto",
      subtitle: "Arrasta para enquadrar e usa o zoom",
      onClose: onCancel,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onCancel }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: confirm, disabled: !img || busy }, busy ? "A processar\u2026" : "Usar foto"))
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 14 } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: FRAME,
          height: FRAME,
          position: "relative",
          overflow: "hidden",
          borderRadius: 8,
          background: "var(--bg-2)",
          touchAction: "none",
          cursor: "grab"
        },
        onPointerDown: onDown,
        onPointerMove: onMove,
        onPointerUp: onUp,
        onPointerLeave: onUp,
        onWheel: (e) => {
          e.preventDefault();
          zoom(scale * (e.deltaY < 0 ? 1.06 : 0.94));
        }
      },
      img && /* @__PURE__ */ React.createElement("img", { src: img.src, alt: "", draggable: false, style: {
        position: "absolute",
        left: off.x,
        top: off.y,
        width: img.width * scale,
        height: img.height * scale,
        maxWidth: "none",
        userSelect: "none"
      } }),
      /* @__PURE__ */ React.createElement("div", { style: {
        position: "absolute",
        inset: 0,
        borderRadius: "50%",
        boxShadow: "0 0 0 9999px rgba(0,0,0,0.45)",
        pointerEvents: "none"
      } })
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "range",
        min: minScale,
        max: minScale * 5,
        step: minScale / 100,
        value: scale,
        onChange: (e) => zoom(parseFloat(e.target.value)),
        style: { width: FRAME }
      }
    ))
  );
}
window.ImageCropModal = ImageCropModal;
function NotificationsPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    try {
      const r = await window.API.notifications();
      setItems(r.results || r || []);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const toggle = async (n) => {
    await window.API.markNotificationRead(n.id, !n.is_read);
    load();
  };
  const del = async (n) => {
    if (!await window.hubConfirm({ message: "Apagar esta notifica\xE7\xE3o?" })) return;
    await window.API.deleteNotification(n.id);
    load();
  };
  if (loading) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026");
  const NOTIFICACOES_COLUNAS = [
    {
      key: "title",
      label: "T\xEDtulo",
      width: 240,
      minWidth: 170,
      fixed: true,
      render: (n) => /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("span", { style: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        display: "inline-block",
        flexShrink: 0,
        background: { info: "#2563eb", success: "#16a34a", warning: "#f59e0b", error: "#dc2626" }[n.kind] || "#2563eb"
      } }), /* @__PURE__ */ React.createElement("strong", null, n.title))
    },
    {
      key: "body",
      label: "Mensagem",
      width: 320,
      minWidth: 200,
      render: (n) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, n.body || "\u2014")
    },
    {
      key: "created_at",
      label: "Data",
      width: 170,
      minWidth: 150,
      render: (n) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, new Date(n.created_at).toLocaleString("pt-PT"))
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      width: 220,
      minWidth: 190,
      render: (n) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => toggle(n) }, n.is_read ? "Marcar n\xE3o lida" : "Marcar lida"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => del(n), style: { marginLeft: 6 } }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "hub",
      viewId: "conta-notificacoes",
      columns: NOTIFICACOES_COLUNAS,
      data: items,
      pagination: "none",
      rowKey: (n) => n.id,
      rowStyle: (n) => ({ opacity: n.is_read ? 0.65 : 1 }),
      empty: "Sem notifica\xE7\xF5es."
    }
  );
}
window.NotificationsPanel = NotificationsPanel;
function ActivityPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    window.API.activityFeed().then((r) => setItems((r.results || []).map((a, i) => ({ ...a, __k: i })))).catch(() => {
    }).finally(() => setLoading(false));
  }, []);
  if (loading) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026");
  const APP_COLORS = { stock: "#2c5d8a", prospecao: "#7c3aed", whale: "#0891b2" };
  const ATIVIDADE_COLUNAS = [
    {
      key: "app",
      label: "App",
      width: 130,
      minWidth: 105,
      fixed: true,
      render: (a) => /* @__PURE__ */ React.createElement("span", { style: {
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 10,
        background: APP_COLORS[a.app] || "#6b7280",
        color: "#fff",
        fontSize: 11,
        fontWeight: 600
      } }, a.app)
    },
    {
      key: "text",
      label: "Atividade",
      width: 320,
      minWidth: 220,
      render: (a) => a.text
    },
    {
      key: "when",
      label: "Quando",
      width: 170,
      minWidth: 150,
      render: (a) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, new Date(a.when).toLocaleString("pt-PT"))
    }
  ];
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "hub",
      viewId: "conta-historico",
      columns: ATIVIDADE_COLUNAS,
      data: items,
      pagination: "none",
      rowKey: (a) => a.__k,
      empty: "Sem atividade."
    }
  );
}
window.ActivityPanel = ActivityPanel;
function HistoricoPanel() {
  const [events, setEvents] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [filters, setFilters] = React.useState({ app: "", verb: "", from: "", to: "" });
  const [total, setTotal] = React.useState(0);
  React.useEffect(() => {
    const params = new URLSearchParams({ page });
    if (filters.app) params.set("app", filters.app);
    if (filters.verb) params.set("verb", filters.verb);
    if (filters.from) params.set("from", filters.from);
    if (filters.to) params.set("to", filters.to);
    fetch(`/api/hub/audit/?${params}`, { credentials: "same-origin" }).then((r) => r.json()).then((body) => {
      setEvents(body.results || []);
      setTotal(body.count || 0);
    }).catch(() => {
      setEvents([]);
      setTotal(0);
    });
  }, [page, filters.app, filters.verb, filters.from, filters.to]);
  const apps = [...window.HUB_REG.appRoster().map((a) => a.app_label), "core"];
  const verbs = ["created", "updated", "assigned", "reassigned", "closed", "approved", "deleted", "config_changed", "bulk_import", "bulk_assign"];
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("select", { value: filters.app, onChange: (e) => setFilters({ ...filters, app: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todas as apps"), apps.map((a) => /* @__PURE__ */ React.createElement("option", { key: a, value: a }, a))), /* @__PURE__ */ React.createElement("select", { value: filters.verb, onChange: (e) => setFilters({ ...filters, verb: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todos os verbos"), verbs.map((v) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, v))), /* @__PURE__ */ React.createElement("input", { type: "date", value: filters.from, onChange: (e) => setFilters({ ...filters, from: e.target.value }) }), /* @__PURE__ */ React.createElement("input", { type: "date", value: filters.to, onChange: (e) => setFilters({ ...filters, to: e.target.value }) })), /* @__PURE__ */ React.createElement("ul", { style: { listStyle: "none", padding: 0 } }, events.length === 0 && /* @__PURE__ */ React.createElement("li", { style: { color: "var(--muted)" } }, "Sem eventos"), events.map((e) => /* @__PURE__ */ React.createElement("li", { key: e.id, style: { padding: "6px 0", borderBottom: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, new Date(e.when).toLocaleString("pt-PT")), " \xB7 ", /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, fontWeight: 600 } }, e.app_label), " \xB7 ", /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, background: "var(--accent-soft)", padding: "1px 6px", borderRadius: 3 } }, e.verb), " \xB7 ", /* @__PURE__ */ React.createElement("span", null, e.summary)))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 12 } }, /* @__PURE__ */ React.createElement("button", { disabled: page <= 1, onClick: () => setPage((p) => p - 1) }, "Anterior"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "P\xE1gina ", page), /* @__PURE__ */ React.createElement("button", { disabled: page * 25 >= total, onClick: () => setPage((p) => p + 1) }, "Pr\xF3xima")));
}
window.HistoricoPanel = HistoricoPanel;
function MyAccountView({ me, reloadMe, tab: extTab, onTab }) {
  const [tabState, setTabState] = useState("perfil");
  const tab = extTab || tabState;
  const setTab = onTab || setTabState;
  const [form, setForm] = useState({
    first_name: me?.first_name || "",
    last_name: me?.last_name || "",
    email: me?.email || "",
    phone: me?.phone || "",
    job_title: me?.job_title || ""
  });
  const [savingProfile, setSavingProfile] = useState(false);
  const [error, setError] = useState(null);
  const [pwModal, setPwModal] = useState(false);
  const [cropFile, setCropFile] = useState(null);
  const dirty = JSON.stringify(form) !== JSON.stringify({
    first_name: me?.first_name || "",
    last_name: me?.last_name || "",
    email: me?.email || "",
    phone: me?.phone || "",
    job_title: me?.job_title || ""
  });
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = async () => {
    setSavingProfile(true);
    setError(null);
    try {
      await window.API.updateMe(form);
      await reloadMe();
    } catch (e) {
      setError(e.message);
    } finally {
      setSavingProfile(false);
    }
  };
  const onPhoto = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (f) {
      setError(null);
      setCropFile(f);
    }
  };
  const confirmCrop = async (blob) => {
    setCropFile(null);
    setError(null);
    try {
      await window.API.uploadPhoto(new File([blob], "avatar.jpg", { type: "image/jpeg" }));
      await reloadMe();
    } catch (err) {
      setError(err.message);
    }
  };
  const clearPhoto = async () => {
    if (!await window.hubConfirm({ message: "Remover foto de perfil?" })) return;
    try {
      await window.API.clearPhoto();
      await reloadMe();
    } catch (e) {
      setError(e.message);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, maxWidth: 800 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14, marginBottom: 18 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    overflow: "hidden",
    background: "var(--brand-navy)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 24,
    fontWeight: 600,
    position: "relative",
    flexShrink: 0
  } }, me?.photo_url ? /* @__PURE__ */ React.createElement("img", { src: me.photo_url, alt: "", style: { width: "100%", height: "100%", objectFit: "cover" } }) : (me?.first_name?.[0] || me?.username?.[0] || "?").toUpperCase(), /* @__PURE__ */ React.createElement("label", { style: {
    position: "absolute",
    bottom: 0,
    right: 0,
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: "50%",
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "var(--text)"
  }, title: "Mudar foto" }, /* @__PURE__ */ React.createElement(Ico.camera, null), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "file",
      accept: "image/*",
      onChange: onPhoto,
      style: { position: "absolute", opacity: 0, width: 1, height: 1 }
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 17, fontWeight: 600 } }, `${me?.first_name || ""} ${me?.last_name || ""}`.trim() || me?.username), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: "var(--muted)", fontFamily: "var(--font-mono)" } }, "@", me?.username, " \xB7 ", me?.email || "\u2014"), me?.photo_url && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: clearPhoto, style: { marginTop: 6 } }, "Remover foto"))), !onTab && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 16, borderBottom: "1px solid var(--border)", marginBottom: 16 } }, [
    ["perfil", "Perfil"],
    ["notificacoes", "Notifica\xE7\xF5es"],
    ["atividade", "Atividade"],
    ["historico", "Hist\xF3rico"]
  ].map(([k, label]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: k,
      onClick: () => setTab(k),
      style: {
        background: "transparent",
        border: "none",
        cursor: "pointer",
        padding: "8px 4px",
        fontSize: 13,
        color: tab === k ? "var(--text)" : "var(--muted)",
        fontWeight: tab === k ? 600 : 400,
        borderBottom: tab === k ? "2px solid var(--accent)" : "2px solid transparent"
      }
    },
    label
  ))), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12.5, marginBottom: 10 } }, error), tab === "perfil" && /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Primeiro nome"), /* @__PURE__ */ React.createElement("input", { value: form.first_name, onChange: upd("first_name") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "\xDAltimo nome"), /* @__PURE__ */ React.createElement("input", { value: form.last_name, onChange: upd("last_name") })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { gridColumn: "span 2" } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Email"), /* @__PURE__ */ React.createElement("input", { type: "email", value: form.email, onChange: upd("email") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Telefone"), /* @__PURE__ */ React.createElement("input", { value: form.phone, onChange: upd("phone") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Cargo / fun\xE7\xE3o"), /* @__PURE__ */ React.createElement("input", { value: form.job_title, onChange: upd("job_title") }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end", marginTop: 16 } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPwModal(true) }, "Mudar password"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", disabled: !dirty || savingProfile, onClick: save }, savingProfile ? "A guardar\u2026" : "Guardar altera\xE7\xF5es"))), tab === "notificacoes" && /* @__PURE__ */ React.createElement(NotificationsPanel, null), tab === "atividade" && /* @__PURE__ */ React.createElement(ActivityPanel, null), tab === "historico" && /* @__PURE__ */ React.createElement(HistoricoPanel, null), pwModal && /* @__PURE__ */ React.createElement(
    PasswordModal,
    {
      username: me?.username,
      onClose: () => setPwModal(false),
      onSubmit: async (pw) => {
        try {
          await window.API.setUserPassword(me.id, pw);
          setPwModal(false);
          window.srToast("Password alterada.");
        } catch (e) {
          setError(e.message);
        }
      }
    }
  ), cropFile && /* @__PURE__ */ React.createElement(
    ImageCropModal,
    {
      file: cropFile,
      onCancel: () => setCropFile(null),
      onConfirm: confirmCrop
    }
  ));
}
window.MyAccountView = MyAccountView;

// ===== notificacoes/frontend.jsx =====

// ===== saved_views/frontend.jsx =====
function HubSavedViews({ appLabel, view, currentState, onApply }) {
  const [views, setViews] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [draftName, setDraftName] = React.useState("");
  const reload = React.useCallback(() => {
    window.API.savedViews({ app_label: appLabel, view }).then((rows) => setViews(Array.isArray(rows) ? rows : rows?.results || [])).catch(() => setViews([]));
  }, [appLabel, view]);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const startSaveAs = () => {
    setDraftName("");
    setSaving(true);
  };
  const cancelSaveAs = () => {
    setSaving(false);
    setDraftName("");
  };
  const confirmSaveAs = () => {
    const name = draftName.trim();
    if (!name) return;
    window.API.createSavedView({ app_label: appLabel, view, name, state: currentState }).then(() => {
      setSaving(false);
      setDraftName("");
      reload();
    });
  };
  const setDefault = (v, val) => window.API.updateSavedView(v.id, { is_default: val }).then(reload);
  const remove = (v) => window.API.deleteSavedView(v.id).then(reload);
  return /* @__PURE__ */ React.createElement("div", { className: "hub-saved-views" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm hub-saved-views__toggle",
      onClick: () => setOpen((o) => !o)
    },
    "Vistas"
  ), open && /* @__PURE__ */ React.createElement("div", { className: "hub-saved-views__menu" }, views.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "hub-saved-views__empty", style: {
    color: "var(--muted)",
    fontSize: 12.5,
    padding: "4px 8px"
  } }, "Sem vistas guardadas."), views.map((v) => /* @__PURE__ */ React.createElement("div", { key: v.id, className: "hub-saved-views__row", style: {
    display: "flex",
    alignItems: "center",
    gap: 6
  } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "hub-saved-views__apply",
      onClick: () => {
        onApply(v.state);
        setOpen(false);
      },
      style: {
        flex: 1,
        textAlign: "left",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        padding: "4px 6px"
      }
    },
    v.name
  ), /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "hub-saved-views__star",
      role: "button",
      title: "Default de entrada",
      onClick: () => setDefault(v, !v.is_default),
      style: { cursor: "pointer" }
    },
    v.is_default ? "\u2605" : "\u2606"
  ), /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "hub-saved-views__del",
      role: "button",
      title: "Apagar vista",
      onClick: () => remove(v),
      style: { cursor: "pointer" }
    },
    "\u2715"
  ))), saving ? /* @__PURE__ */ React.createElement("div", { className: "hub-saved-views__saveas-form", style: {
    display: "flex",
    gap: 6,
    padding: "6px 4px"
  } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      autoFocus: true,
      value: draftName,
      placeholder: "Nome da vista",
      onChange: (e) => setDraftName(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") confirmSaveAs();
        if (e.key === "Escape") cancelSaveAs();
      },
      style: { flex: 1 }
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn primary sm",
      disabled: !draftName.trim(),
      onClick: confirmSaveAs
    },
    "Guardar"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: cancelSaveAs
    },
    "Cancelar"
  )) : /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm hub-saved-views__saveas",
      onClick: startSaveAs
    },
    "Guardar filtros atuais como\u2026"
  )));
}
window.HubSavedViews = HubSavedViews;
window.HubSavedViewsAPI = {
  list: (appLabel, view) => window.API.savedViews({ app_label: appLabel, view }),
  getDefault: (appLabel, view) => window.API.savedViews({ app_label: appLabel, view }).then((rows) => {
    const arr = Array.isArray(rows) ? rows : rows?.results || [];
    return arr.find((v) => v.is_default) || null;
  })
};

// ===== timeline/frontend.jsx =====
const TAB_LABELS = { logs: "Hist\xF3rico", acoes: "Timeline", notas: "Notas", anexos: "Anexos" };
const TAB_ORDER = ["acoes", "notas"];
function mergeAcoesLogs(acoes, logs) {
  const A = (acoes || []).map((a) => ({
    _kind: "acao",
    _ts: a.criadoEm && a.criadoEm.getTime ? a.criadoEm.getTime() : 0,
    item: a
  }));
  const L = (logs || []).map((l) => ({
    _kind: "log",
    _ts: l.criado_em ? Date.parse(l.criado_em) : 0,
    item: l
  }));
  return A.concat(L).sort((x, y) => (y._ts || 0) - (x._ts || 0));
}
function hubPrazoLabelFromDias(dias) {
  if (dias === 0) return "hoje";
  if (dias === 1) return "amanh\xE3";
  if (dias === -1) return "ontem";
  if (dias < 0) return `${dias} dias`;
  return `em ${dias} dias`;
}
function hubPrazoLabel(prazoISO, hojeISO2) {
  if (!prazoISO) return null;
  const prazo = Date.parse(`${prazoISO}T00:00:00Z`);
  const hoje = Date.parse(`${hojeISO2}T00:00:00Z`);
  if (Number.isNaN(prazo) || Number.isNaN(hoje)) return null;
  const dias = Math.round((prazo - hoje) / 864e5);
  const tom = dias < 0 ? "atrasado" : dias <= 2 ? "urgente" : "normal";
  return { label: hubPrazoLabelFromDias(dias), tom };
}
const PRAZO_CORES = {
  atrasado: "#dc2626",
  urgente: "#f59e0b",
  normal: "var(--muted)"
};
function hojeISO() {
  const d = /* @__PURE__ */ new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}
window.hubPrazoLabel = hubPrazoLabel;
window.hubPrazoLabelFromDias = hubPrazoLabelFromDias;
const KEY_FOR = { logs: "timeline", notas: "notas", seguidores: "seguidores", anexos: "anexos" };
function gated(surface, appLabel) {
  const key = KEY_FOR[surface];
  if (!key) return true;
  if (!window.HubFeatures) return true;
  return window.HubFeatures.enabled(appLabel, key) !== false;
}
function lsKey(appSlug) {
  return `hub_timeline_tab_${appSlug || "_"}`;
}
function computePresent(streams, appLabel, flags) {
  const { hasAnexos = false, hasNotasSelf = false, hasLogs = false } = flags || {};
  const order = hasAnexos ? TAB_ORDER.concat("anexos") : TAB_ORDER;
  return order.filter((k) => {
    if (k === "anexos") return hasAnexos && gated(k, appLabel);
    if (k === "notas") return (!!streams.notas || hasNotasSelf) && gated(k, appLabel);
    if (k === "acoes") return !!streams.acoes || hasLogs;
    return !!streams[k] && gated(k, appLabel);
  });
}
function computeShowSeguidores(appLabel, seguidoresProp, hasSeguidoresSelf) {
  if (!gated("seguidores", appLabel)) return false;
  return !!seguidoresProp || !!hasSeguidoresSelf;
}
function pickInitialTab(present, appSlug, defaultTab, overrideTab) {
  if (present.length === 0) return null;
  if (overrideTab && present.includes(overrideTab)) return overrideTab;
  let stored = null;
  try {
    stored = window.localStorage.getItem(lsKey(appSlug));
  } catch (_) {
  }
  if (stored && present.includes(stored)) return stored;
  if (defaultTab && present.includes(defaultTab)) return defaultTab;
  return present[0];
}
function HubActionTimeline({
  streams = {},
  appSlug = "_",
  defaultTab = "acoes",
  overrideTab = void 0,
  users = [],
  userTypes = null,
  tiposAcao = null,
  me = null,
  title = "Hist\xF3rico",
  appLabel,
  assignable = false,
  canDelete = (a) => !a.system,
  seguidores = null,
  // Abas extra fornecidas pela app: [{ key, label, count?, render: () => node }].
  // Aparecem a par das abas de stream (acoes/notas/logs), sem que o shell saiba
  // do conteúdo — a app dá o render.
  extraTabs = [],
  // Resource triplet — enables the Anexos/Notas/Seguidores self-render.
  // Optional: existing callers that omit these never get those surfaces
  // (see gated()/hasAnexos/hasNotasSelf/hasSeguidoresSelf).
  resource = void 0,
  resourceId = void 0
}) {
  const extras = extraTabs || [];
  const hasTriplet = !!(appLabel && resource && resourceId);
  const hasAnexos = hasTriplet;
  const hasNotasSelf = hasTriplet && !streams.notas;
  const hasSeguidoresSelf = hasTriplet && !seguidores;
  const hasLogs = !!streams.logs;
  const showLogsToggle = hasLogs && gated("logs", appLabel);
  const logItems = streams.logs && streams.logs.items || [];
  const present = computePresent(streams, appLabel, { hasAnexos, hasNotasSelf, hasLogs });
  const showSeguidores = computeShowSeguidores(appLabel, seguidores, hasSeguidoresSelf);
  const effectiveSeguidores = seguidores || (hasSeguidoresSelf ? { __self: true, appLabel, resource, resourceId, me } : null);
  const showTabs = present.length + extras.length >= 2;
  const [active, setActive] = useState(
    () => pickInitialTab(present, appSlug, defaultTab, overrideTab)
  );
  useEffect(() => {
    if (!active) return;
    try {
      window.localStorage.setItem(lsKey(appSlug), active);
    } catch (_) {
    }
  }, [active, appSlug]);
  useEffect(() => {
    if (overrideTab && present.includes(overrideTab)) setActive(overrideTab);
  }, [overrideTab]);
  if (!showTabs) {
    const only = present[0] || "acoes";
    let tab;
    if (only === "acoes") {
      tab = /* @__PURE__ */ React.createElement(
        TimelineTab,
        {
          cfg: streams.acoes || { items: [], api: {} },
          logs: logItems,
          showLogsToggle,
          users,
          userTypes,
          tiposAcao,
          me,
          title,
          appSlug,
          appLabel,
          assignable,
          canDelete
        }
      );
    } else if (only === "anexos") {
      tab = /* @__PURE__ */ React.createElement(
        window.AnexosPanel,
        {
          app: appLabel,
          resource,
          id: resourceId,
          me
        }
      );
    } else if (hasNotasSelf) {
      tab = /* @__PURE__ */ React.createElement(
        SelfNotasTab,
        {
          appLabel,
          resource,
          resourceId,
          users,
          me
        }
      );
    } else {
      tab = /* @__PURE__ */ React.createElement(NotasTab, { cfg: streams.notas, users, me });
    }
    if (!showSeguidores) return tab;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SeguidoresSection, { seguidores: effectiveSeguidores }), tab);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showSeguidores && /* @__PURE__ */ React.createElement(SeguidoresSection, { seguidores: effectiveSeguidores }), /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-testid": "hub-timeline-tabs",
      role: "tablist",
      style: {
        display: "flex",
        flexWrap: "wrap",
        gap: 4,
        borderBottom: "1px solid var(--border)",
        marginBottom: 10
      }
    },
    present.map((k) => {
      const count = k === "anexos" || k === "notas" && !streams.notas ? null : (streams[k].items || []).length;
      const selected = active === k;
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: k,
          type: "button",
          role: "tab",
          "aria-selected": selected,
          onClick: () => setActive(k),
          style: {
            padding: "6px 12px",
            fontSize: 12.5,
            fontWeight: selected ? 700 : 500,
            background: "transparent",
            border: "none",
            borderBottom: selected ? "2px solid var(--accent)" : "2px solid transparent",
            color: selected ? "var(--accent)" : "var(--muted)",
            cursor: "pointer"
          }
        },
        TAB_LABELS[k],
        count != null && /* @__PURE__ */ React.createElement("span", { style: {
          color: "var(--muted)",
          fontWeight: 500
        } }, " (", count, ")")
      );
    }),
    extras.map((t) => {
      const selected = active === t.key;
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: t.key,
          type: "button",
          role: "tab",
          "aria-selected": selected,
          onClick: () => setActive(t.key),
          style: {
            padding: "6px 12px",
            fontSize: 12.5,
            fontWeight: selected ? 700 : 500,
            background: "transparent",
            border: "none",
            borderBottom: selected ? "2px solid var(--accent)" : "2px solid transparent",
            color: selected ? "var(--accent)" : "var(--muted)",
            cursor: "pointer"
          }
        },
        t.label,
        t.count != null && /* @__PURE__ */ React.createElement("span", { style: {
          color: "var(--muted)",
          fontWeight: 500
        } }, " (", t.count, ")")
      );
    })
  ), active === "acoes" && /* @__PURE__ */ React.createElement(
    TimelineTab,
    {
      cfg: streams.acoes || { items: [], api: {} },
      logs: logItems,
      showLogsToggle,
      users,
      userTypes,
      tiposAcao,
      me,
      title,
      appSlug,
      appLabel,
      assignable,
      canDelete
    }
  ), active === "notas" && (hasNotasSelf ? /* @__PURE__ */ React.createElement(
    SelfNotasTab,
    {
      appLabel,
      resource,
      resourceId,
      users,
      me
    }
  ) : /* @__PURE__ */ React.createElement(NotasTab, { cfg: streams.notas, users, me })), active === "anexos" && /* @__PURE__ */ React.createElement(
    window.AnexosPanel,
    {
      app: appLabel,
      resource,
      id: resourceId,
      me
    }
  ), extras.map((t) => active === t.key ? /* @__PURE__ */ React.createElement(React.Fragment, { key: t.key }, t.render()) : null));
}
function SeguidoresSection({ seguidores }) {
  if (seguidores && seguidores.__self) {
    return /* @__PURE__ */ React.createElement(
      SelfSeguidoresSection,
      {
        appLabel: seguidores.appLabel,
        resource: seguidores.resource,
        resourceId: seguidores.resourceId,
        me: seguidores.me
      }
    );
  }
  return /* @__PURE__ */ React.createElement(SeguidoresSectionView, { seguidores });
}
function SelfSeguidoresSection({ appLabel, resource, resourceId, me }) {
  const [items, setItems] = useState([]);
  const usersList = window.SR_USERS || [];
  const canManage = !!me?.access_actions?.[appLabel]?.includes("assign");
  const reload = () => {
    window.API.followers({ app_label: appLabel, resource, resource_id: resourceId }).then((data) => setItems(Array.isArray(data) ? data : data?.results || [])).catch(() => setItems([]));
  };
  useEffect(() => {
    reload();
  }, [appLabel, resource, resourceId]);
  const onFollow = async () => {
    try {
      await window.API.follow({ app_label: appLabel, resource, resource_id: resourceId });
      reload();
    } catch (e) {
      window.srToast && window.srToast("Erro a seguir.");
    }
  };
  const onUnfollow = async (id) => {
    try {
      await window.API.unfollow(id);
      reload();
    } catch (e) {
      window.srToast && window.srToast("Erro a deixar de seguir.");
    }
  };
  const onAddOther = async (userId) => {
    try {
      await window.API.follow({
        app_label: appLabel,
        resource,
        resource_id: resourceId,
        user_id: userId
      });
      reload();
    } catch (e) {
      window.srToast && window.srToast("Erro a adicionar seguidor.");
    }
  };
  return /* @__PURE__ */ React.createElement(SeguidoresSectionView, { seguidores: {
    items,
    me,
    canManage,
    users: usersList,
    onFollow,
    onUnfollow,
    onAddOther
  } });
}
function SeguidoresSectionView({ seguidores }) {
  const [adding, setAdding] = useState(false);
  if (!seguidores) return null;
  const {
    items = [],
    me,
    canManage,
    users = [],
    onFollow,
    onUnfollow,
    onAddOther
  } = seguidores;
  const mine = items.find((f) => f.user === me?.id);
  return /* @__PURE__ */ React.createElement("div", { className: "hub-seguidores", style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { className: "hub-seguidores__row", style: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
    fontSize: 12.5
  } }, /* @__PURE__ */ React.createElement("span", { className: "hub-seguidores__label", style: {
    color: "var(--muted)",
    fontWeight: 600
  } }, "Seguidores"), items.map((f) => /* @__PURE__ */ React.createElement(
    window.HubUserPill,
    {
      key: f.id,
      username: f.user_username,
      users,
      compact: true
    }
  )), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm hub-seguidores__toggle",
      onClick: () => mine ? onUnfollow(mine.id) : onFollow()
    },
    mine ? "Deixar de seguir" : "Seguir"
  ), canManage && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm hub-seguidores__add",
      onClick: () => setAdding((v) => !v)
    },
    "+ adicionar"
  )), canManage && adding && /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "hub-seguidores__picker",
      style: { marginTop: 6 },
      onChange: (e) => {
        if (e.target.value) {
          onAddOther(Number(e.target.value));
          setAdding(false);
        }
      }
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "Escolher utilizador\u2026"),
    users.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.nome || u.username))
  ));
}
function resolveActorName(username, users) {
  if (!username) return "Sistema";
  const u = (users || []).find((x) => x.username === username);
  if (!u) return username;
  const full = `${u.first_name || ""} ${u.last_name || ""}`.trim();
  return full || u.nome || u.username;
}
function TimelineTab({
  cfg,
  logs = [],
  showLogsToggle = false,
  users,
  userTypes,
  tiposAcao,
  me,
  title,
  appSlug,
  appLabel,
  assignable,
  canDelete
}) {
  const acoes = cfg?.items || [];
  const api = cfg?.api || {};
  const logsKey = `hub_timeline_logs_${appSlug || "_"}`;
  const [verLogs, setVerLogs] = useState(() => {
    if (!showLogsToggle) return false;
    try {
      const stored = window.localStorage.getItem(logsKey);
      if (stored != null) return stored === "1";
    } catch (_) {
    }
    return acoes.length === 0;
  });
  useEffect(() => {
    if (!showLogsToggle) return;
    try {
      window.localStorage.setItem(logsKey, verLogs ? "1" : "0");
    } catch (_) {
    }
  }, [verLogs, logsKey, showLogsToggle]);
  const { onAdd, onDelete, onToggleTratada } = api;
  const types = tiposAcao || (window.SR_DATA?.tiposAcao || []);
  const mentionGroups = userTypes || window.SR_USERTYPES || [];
  const mentionUsers = users.length ? users : window.SR_USERS || [];
  const [adding, setAdding] = useState(false);
  const [tipo, setTipo] = useState(types[0]?.id || "email");
  const [desc, setDesc] = useState("");
  const [atribuidoId, setAtribuidoId] = useState(null);
  const [prazo, setPrazo] = useState("");
  useEffect(() => {
    if (!tipo && types[0]) setTipo(types[0].id);
  }, [types]);
  useEffect(() => {
    if (!atribuidoId) setPrazo("");
  }, [atribuidoId]);
  const submit = async () => {
    if (!desc.trim() || !onAdd) return;
    await onAdd(tipo, desc.trim(), atribuidoId, prazo || null);
    setDesc("");
    setAtribuidoId(null);
    setPrazo("");
    setAdding(false);
  };
  const ordered = [...acoes].sort((a, b) => (b.criadoEm?.getTime?.() || 0) - (a.criadoEm?.getTime?.() || 0));
  const userLabel = (username) => {
    if (!username) return /* @__PURE__ */ React.createElement("span", { style: {
      color: "var(--muted)",
      fontStyle: "italic"
    } }, "sistema");
    const u = (users || []).find((x) => x.username === username);
    const display = u ? u.first_name ? `${u.first_name} ${u.last_name || ""}`.trim() : u.username : username;
    return /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, display);
  };
  const meUsername = me?.username;
  const isTask = (a) => !a.system && !!a.atribuido;
  const canTratar = (a) => isTask(a) && !!onToggleTratada && (me?.is_staff || meUsername === a.autor || meUsername === a.atribuido);
  const onSetPrazo = api.onSetPrazo;
  const canPrazo = (a) => isTask(a) && !!onSetPrazo && (me?.is_staff || meUsername === a.autor || meUsername === a.atribuido);
  const assignableUsers = (mentionUsers || []).filter((u) => {
    if (!u.is_active) return false;
    if (!appSlug) return true;
    if (u.is_staff) return true;
    return (u.apps || []).includes(appSlug);
  });
  const displayItems = verLogs ? mergeAcoesLogs(ordered, logs) : ordered.map((a) => ({ _kind: "acao", item: a }));
  const renderLog = (l) => {
    const when = l.criado_em ? new Date(l.criado_em) : null;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: "log-" + l.id,
        className: "hub-card",
        style: { borderLeft: "3px solid var(--muted-2)" }
      },
      /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 6,
        fontSize: 11.5,
        color: "var(--muted)",
        marginBottom: 4
      } }, /* @__PURE__ */ React.createElement("span", { style: {
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        fontWeight: 600,
        fontSize: 10
      } }, "Altera\xE7\xE3o"), /* @__PURE__ */ React.createElement("span", null, "\xB7"), /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--text-2)" } }, resolveActorName(l.actor_username, users)), when && /* @__PURE__ */ React.createElement("span", { title: fmtDateRel(when) }, "\xB7 ", fmtDateTime(when))),
      /* @__PURE__ */ React.createElement("div", { style: {
        color: "var(--text-2)",
        fontSize: 12.5,
        overflowWrap: "anywhere",
        whiteSpace: "pre-wrap"
      } }, l.descricao)
    );
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  } }, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginBottom: 0 } }, title, " (", ordered.length, ")"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6 } }, showLogsToggle && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-pressed": verLogs,
      title: "Mostrar/ocultar os logs de altera\xE7\xF5es",
      onClick: () => setVerLogs((v) => !v),
      style: {
        borderColor: verLogs ? "var(--accent)" : "var(--border)",
        color: verLogs ? "var(--accent)" : "var(--muted)",
        fontWeight: verLogs ? 600 : 500
      }
    },
    verLogs ? "\u2713 " : "",
    "Ver logs"
  ), onAdd && !adding && /* @__PURE__ */ React.createElement("button", { className: "btn sm primary", onClick: () => setAdding(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Adicionar"))), adding && /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: 10,
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
    gap: 8
  } }, /* @__PURE__ */ React.createElement("select", { value: tipo, onChange: (e) => setTipo(e.target.value) }, types.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.nome))), /* @__PURE__ */ React.createElement(
    MentionTextarea,
    {
      value: desc,
      onChange: setDesc,
      users: mentionUsers,
      groups: mentionGroups,
      placeholder: "O que aconteceu\u2026 (usa @ para mencionar)",
      autoFocus: true,
      rows: 3
    }
  ), assignable && /* @__PURE__ */ React.createElement("label", { style: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12
  } }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", minWidth: 90 } }, "Atribuir a:"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: atribuidoId || "",
      onChange: (e) => setAtribuidoId(
        e.target.value ? Number(e.target.value) : null
      ),
      style: { flex: 1 }
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 ningu\xE9m \u2014"),
    assignableUsers.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username))
  )), assignable && atribuidoId && /* @__PURE__ */ React.createElement("label", { style: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12
  } }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", minWidth: 90 } }, "Prazo:"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "date",
      value: prazo,
      onChange: (e) => setPrazo(e.target.value),
      style: { flex: 1 }
    }
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      onClick: submit,
      disabled: !desc.trim()
    },
    "Guardar"
  ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
    setAdding(false);
    setDesc("");
    setAtribuidoId(null);
    setPrazo("");
  } }, "Cancelar"))), /* @__PURE__ */ React.createElement("div", { className: "timeline", style: { marginTop: 14 } }, displayItems.map((entry) => {
    if (entry._kind === "log") return renderLog(entry.item);
    const a = entry.item;
    return /* @__PURE__ */ React.createElement("div", { key: a.id, className: "tl-item hub-card " + (a.system ? "muted" : "accent") }, /* @__PURE__ */ React.createElement("div", { className: "tl-head", style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 6,
      fontSize: 12.5
    } }, /* @__PURE__ */ React.createElement("span", { className: "tl-type" }, a.tipoNome), /* @__PURE__ */ React.createElement("span", { className: "tl-meta" }, "\xB7"), userLabel(a.autor), a.atribuido && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "tl-meta" }, "\u2192"), /* @__PURE__ */ React.createElement("span", { style: {
      padding: "1px 8px",
      borderRadius: 10,
      fontSize: 11,
      fontWeight: 600,
      background: "color-mix(in srgb, var(--accent) 18%, transparent)",
      color: "var(--accent)"
    } }, a.atribuido)), /* @__PURE__ */ React.createElement("span", { className: "tl-meta", title: fmtDateRel(a.criadoEm) }, "\xB7 ", fmtDateTime(a.criadoEm)), isTask(a) && /* @__PURE__ */ React.createElement(
      PrazoChip,
      {
        acao: a,
        editavel: canPrazo(a),
        onSet: (iso) => onSetPrazo(a, iso)
      }
    ), /* @__PURE__ */ React.createElement("div", { style: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center",
      gap: 6
    } }, a.tratada ? /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        title: a.tratadaPor ? `Tratada por ${a.tratadaPor}` + (canTratar(a) ? " \u2014 clica para reabrir" : "") : "Tratada",
        onClick: () => canTratar(a) && onToggleTratada(a),
        style: {
          padding: "1px 9px",
          borderRadius: 10,
          fontSize: 11,
          fontWeight: 600,
          border: "1px solid #16a34a",
          background: "color-mix(in srgb, #16a34a 14%, transparent)",
          color: "#15803d",
          cursor: canTratar(a) ? "pointer" : "default"
        }
      },
      "\u2713 Tratada"
    ) : canTratar(a) ? /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        title: "Marcar tarefa como tratada",
        onClick: () => onToggleTratada(a),
        style: { padding: "2px 9px", fontSize: 11 }
      },
      "Marcar tratada"
    ) : null, onDelete && canDelete(a) && /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm icon-only",
        title: "Apagar a\xE7\xE3o",
        style: { padding: "2px 4px" },
        onClick: () => onDelete(a)
      },
      /* @__PURE__ */ React.createElement(Ico.trash, null)
    ))), /* @__PURE__ */ React.createElement("div", { className: "tl-body" }, a.descricao));
  }), displayItems.length === 0 && /* @__PURE__ */ React.createElement("div", { style: {
    color: "var(--muted)",
    fontSize: 12.5,
    padding: "8px 0"
  } }, "Sem a\xE7\xF5es registadas", onAdd ? ". Adiciona a primeira para come\xE7ar o hist\xF3rico." : ".")));
}
function PrazoChip({ acao, editavel, onSet }) {
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState(acao.prazo || "");
  useEffect(() => {
    setValor(acao.prazo || "");
  }, [acao.prazo]);
  const info = hubPrazoLabel(acao.prazo, hojeISO());
  if (editando) {
    return /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: valor,
        autoFocus: true,
        onChange: (e) => setValor(e.target.value),
        style: { fontSize: 11, padding: "1px 4px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn primary sm",
        style: { padding: "1px 7px", fontSize: 11 },
        onClick: () => {
          onSet(valor || null);
          setEditando(false);
        }
      },
      "ok"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        style: { padding: "1px 7px", fontSize: 11 },
        onClick: () => {
          setValor(acao.prazo || "");
          setEditando(false);
        }
      },
      "cancelar"
    ));
  }
  if (!info) {
    if (!editavel) return null;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        title: "Definir prazo",
        onClick: () => setEditando(true),
        style: { padding: "1px 7px", fontSize: 11 }
      },
      "+ prazo"
    );
  }
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      title: editavel ? `Prazo ${acao.prazo} \u2014 clica para alterar` : `Prazo ${acao.prazo}`,
      onClick: () => editavel && setEditando(true),
      style: {
        padding: "1px 8px",
        borderRadius: 10,
        fontSize: 11,
        fontWeight: 600,
        border: `1px solid ${PRAZO_CORES[info.tom]}`,
        background: "transparent",
        color: PRAZO_CORES[info.tom],
        cursor: editavel ? "pointer" : "default"
      }
    },
    "\u23F0 ",
    info.label
  );
}
function SelfNotasTab({ appLabel, resource, resourceId, users, me }) {
  const [items, setItems] = useState([]);
  const reload = () => {
    window.API.notes({ app_label: appLabel, resource, resource_id: resourceId }).then((data) => setItems(Array.isArray(data) ? data : data?.results || [])).catch(() => setItems([]));
  };
  useEffect(() => {
    reload();
  }, [appLabel, resource, resourceId]);
  const onAdd = async (descricao) => {
    await window.API.createNote({
      app_label: appLabel,
      resource,
      resource_id: resourceId,
      descricao
    });
    reload();
  };
  const onUpdate = async (id, descricao) => {
    await window.API.updateNote(id, { descricao });
    reload();
  };
  const onDelete = async (id) => {
    await window.API.deleteNote(id);
    reload();
  };
  return /* @__PURE__ */ React.createElement(
    NotasTab,
    {
      cfg: { items, api: { onAdd, onUpdate, onDelete } },
      users,
      me
    }
  );
}
function NotasTab({ cfg, users, me }) {
  const items = cfg?.items || [];
  const api = cfg?.api || {};
  const { onAdd, onUpdate, onDelete } = api;
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState("");
  const [editing, setEditing] = useState(null);
  const usersList = users.length ? users : window.SR_USERS || [];
  const submit = async () => {
    if (!draft.trim() || !onAdd) return;
    await onAdd(draft.trim());
    setDraft("");
    setAdding(false);
  };
  const submitEdit = async () => {
    if (!editing || !onUpdate) return;
    await onUpdate(editing.id, editing.descricao.trim());
    setEditing(null);
  };
  const canEdit = (n) => !!me && (me.is_staff || me.username === n.autor_username);
  const suggestedTags = useMemo(() => {
    const s = /* @__PURE__ */ new Set();
    const re = /#[\p{L}\d_-]+/gu;
    for (const n of items) {
      for (const m of String(n.descricao || "").matchAll(re)) {
        s.add(m[0].slice(1));
      }
    }
    return Array.from(s).sort();
  }, [items]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  } }, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginBottom: 0 } }, "Notas (", items.length, ")"), onAdd && !adding && /* @__PURE__ */ React.createElement("button", { className: "btn sm primary", onClick: () => setAdding(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Nota")), adding && /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: 10,
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
    gap: 8
  } }, /* @__PURE__ */ React.createElement(
    MentionTextarea,
    {
      value: draft,
      onChange: setDraft,
      users: usersList,
      groups: window.SR_USERTYPES || [],
      hashtags: true,
      suggestedTags,
      placeholder: "Nota (usa @ para mencionar, # para tag)",
      autoFocus: true,
      rows: 3
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      onClick: submit,
      disabled: !draft.trim()
    },
    "Guardar"
  ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
    setAdding(false);
    setDraft("");
  } }, "Cancelar"))), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginTop: 12
  } }, items.map((n) => {
    const when = n.criado_em ? new Date(n.criado_em) : null;
    const isEditing = editing?.id === n.id;
    return /* @__PURE__ */ React.createElement("div", { key: n.id, className: "hub-card" }, /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontSize: 12,
      color: "var(--muted)",
      marginBottom: 6
    } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--text-2)" } }, n.autor_username), when && /* @__PURE__ */ React.createElement("span", { title: fmtDateRel(when) }, "\xB7 ", fmtDateTime(when)), n.edited && /* @__PURE__ */ React.createElement("span", { style: { fontStyle: "italic" } }, "\xB7 [editada]"), canEdit(n) && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto" } }, /* @__PURE__ */ React.createElement(
      NotaMenu,
      {
        nota: n,
        onEdit: () => setEditing({
          id: n.id,
          descricao: n.descricao
        }),
        onDelete: () => onDelete && onDelete(n.id)
      }
    ))), isEditing ? /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      flexDirection: "column",
      gap: 6
    } }, /* @__PURE__ */ React.createElement(
      MentionTextarea,
      {
        value: editing.descricao,
        onChange: (v) => setEditing({
          ...editing,
          descricao: v
        }),
        users: usersList,
        groups: window.SR_USERTYPES || [],
        hashtags: true,
        suggestedTags,
        autoFocus: true,
        rows: 3
      }
    ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        onClick: submitEdit,
        disabled: !editing.descricao.trim()
      },
      "Guardar"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        onClick: () => setEditing(null)
      },
      "Cancelar"
    ))) : /* @__PURE__ */ React.createElement("div", { dangerouslySetInnerHTML: {
      __html: window.hubParseNoteToHtml(n.descricao)
    } }));
  }), items.length === 0 && /* @__PURE__ */ React.createElement("div", { style: {
    color: "var(--muted)",
    fontSize: 12.5,
    padding: "8px 0"
  } }, "Sem notas. Adiciona a primeira para come\xE7ar.")));
}
function NotaMenu({ nota, onEdit, onDelete }) {
  const [open, setOpen] = useState(false);
  return /* @__PURE__ */ React.createElement("span", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "aria-label": `Nota menu ${nota.id}`,
      onClick: () => setOpen((o) => !o),
      className: "btn ghost sm icon-only",
      style: { padding: "2px 6px" }
    },
    "\u22EF"
  ), open && /* @__PURE__ */ React.createElement("span", { style: {
    position: "absolute",
    right: 0,
    top: "100%",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    zIndex: 10,
    minWidth: 100
  } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setOpen(false);
        onEdit();
      },
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "6px 10px",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: 12.5
      }
    },
    "Editar"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setOpen(false);
        onDelete();
      },
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "6px 10px",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: 12.5,
        color: "#c4434b"
      }
    },
    "Apagar"
  )));
}
window.HubActionTimeline = HubActionTimeline;
window.ActionTimeline = HubActionTimeline;
window.HubActionTimelineLogic = {
  KEY_FOR,
  gated,
  computePresent,
  computeShowSeguidores,
  pickInitialTab,
  mergeAcoesLogs
};

// ===== toasts/frontend.jsx =====
const TAREFAS_GRUPOS = [
  { key: "atrasadas", titulo: "Atrasadas", cor: "#dc2626", aberto: true },
  { key: "proximas", titulo: "Pr\xF3ximas", cor: "#f59e0b", aberto: true },
  { key: "futuras", titulo: "Futuras", cor: "var(--muted)", aberto: false }
];
function hubTarefasResumo(payload) {
  const p = payload || {};
  const grupos = TAREFAS_GRUPOS.map((g) => {
    const itens = p[g.key] || [];
    return { ...g, itens, label: `${g.titulo} (${itens.length})` };
  });
  const acionaveis = p.contagens && p.contagens.acionaveis || 0;
  return { grupos, acionaveis };
}
window.hubTarefasResumo = hubTarefasResumo;
function playChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ac = new Ctx();
    const g = ac.createGain();
    g.gain.setValueAtTime(1e-4, ac.currentTime);
    g.gain.exponentialRampToValueAtTime(0.18, ac.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(1e-4, ac.currentTime + 0.45);
    g.connect(ac.destination);
    [880, 1320].forEach((f, i) => {
      const o = ac.createOscillator();
      o.type = "sine";
      o.frequency.value = f;
      o.connect(g);
      o.start(ac.currentTime + i * 0.09);
      o.stop(ac.currentTime + 0.45);
    });
    setTimeout(() => {
      try {
        ac.close();
      } catch {
      }
    }, 700);
  } catch {
  }
}
function RealtimeToasts({ onNavigate }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});
  const kindColor = { info: "#2563eb", success: "#16a34a", warning: "#f59e0b", error: "#dc2626" };
  const dismiss = useCallback((uid) => {
    setToasts((xs) => xs.filter((t) => t.uid !== uid));
    if (timers.current[uid]) {
      clearTimeout(timers.current[uid]);
      delete timers.current[uid];
    }
  }, []);
  useEffect(() => {
    const onRealtime = (e) => {
      const d = e.detail;
      if (!d || d.type !== "notification.new" || !d.notification) return;
      const n = d.notification;
      if (n.link_view === "chat") return;
      const uid = `${n.id}-${Date.now()}`;
      setToasts((xs) => [...xs.slice(-3), { ...n, uid }]);
      playChime();
      if (n.kind !== "error") timers.current[uid] = setTimeout(() => dismiss(uid), 6e3);
    };
    window.addEventListener("sr:realtime", onRealtime);
    return () => {
      window.removeEventListener("sr:realtime", onRealtime);
      Object.values(timers.current).forEach(clearTimeout);
    };
  }, [dismiss]);
  if (toasts.length === 0) return null;
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "flex-end",
    pointerEvents: "none"
  } }, toasts.map((n) => {
    const navigable = !!(n.link_view && onNavigate);
    const isErr = n.kind === "error";
    const copy = (e) => {
      e.stopPropagation();
      const txt = [n.title, n.body].filter(Boolean).join("\n");
      try {
        navigator.clipboard.writeText(txt);
        window.srToast("Copiado.", "success");
      } catch {
      }
    };
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: n.uid,
        onClick: navigable ? () => {
          onNavigate(n.link_view, n.link_target);
          dismiss(n.uid);
        } : void 0,
        style: {
          pointerEvents: "auto",
          width: isErr ? 400 : 320,
          maxWidth: "calc(100vw - 32px)",
          background: "var(--panel)",
          border: "1px solid var(--border)",
          borderLeft: `3px solid ${kindColor[n.kind] || kindColor.info}`,
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-lg)",
          padding: "11px 12px",
          cursor: navigable ? "pointer" : "default",
          animation: "srToastIn .22s ease-out",
          display: "flex",
          gap: 9,
          alignItems: "flex-start"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        marginTop: 5,
        flexShrink: 0,
        background: kindColor[n.kind] || kindColor.info
      } }),
      /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, n.title), n.body && /* @__PURE__ */ React.createElement("div", { style: {
        fontSize: 12,
        color: "var(--muted)",
        marginTop: 2,
        userSelect: "text",
        cursor: "text",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        ...isErr ? { maxHeight: 160, overflow: "auto" } : {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical"
        }
      } }, n.body)),
      /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        flexDirection: "column",
        gap: 2,
        flexShrink: 0,
        marginTop: -2,
        marginRight: -4
      } }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost icon-only sm",
          title: "Copiar",
          onClick: copy
        },
        "\u29C9"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost icon-only sm",
          title: "Dispensar",
          onClick: (e) => {
            e.stopPropagation();
            dismiss(n.uid);
          }
        },
        "\xD7"
      ))
    );
  }));
}
window.RealtimeToasts = RealtimeToasts;
function ChatToasts({ onOpen }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});
  const dismiss = useCallback((convId) => {
    setToasts((xs) => xs.filter((t) => t.convId !== convId));
    if (timers.current[convId]) {
      clearTimeout(timers.current[convId]);
      delete timers.current[convId];
    }
  }, []);
  useEffect(() => {
    const onRealtime = (e) => {
      const d = e.detail;
      if (!d || d.type !== "notification.new" || !d.notification) return;
      const n = d.notification;
      if (n.link_view !== "chat") return;
      const convId = n.link_target || "";
      const sender = String(n.title || "").replace(/^\[@\]\s*/, "").split(":")[0].trim() || "algu\xE9m";
      playChime();
      setToasts((xs) => {
        const existing = xs.find((t) => t.convId === convId);
        if (existing) return xs.map((t) => t.convId === convId ? { ...t, count: t.count + 1, sender, uid: Date.now() } : t);
        return [...xs.slice(-3), { convId, sender, count: 1, uid: Date.now() }];
      });
      if (timers.current[convId]) clearTimeout(timers.current[convId]);
      timers.current[convId] = setTimeout(() => dismiss(convId), 7e3);
    };
    window.addEventListener("sr:realtime", onRealtime);
    return () => {
      window.removeEventListener("sr:realtime", onRealtime);
      Object.values(timers.current).forEach(clearTimeout);
    };
  }, [dismiss]);
  if (toasts.length === 0) return null;
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "flex-end",
    pointerEvents: "none"
  } }, toasts.map((t) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: t.convId,
      onClick: () => {
        onOpen && onOpen(t.convId);
        dismiss(t.convId);
      },
      style: {
        pointerEvents: "auto",
        width: 300,
        maxWidth: "calc(100vw - 32px)",
        background: "var(--panel)",
        border: "1px solid var(--border)",
        borderLeft: "3px solid var(--accent)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-lg)",
        padding: "11px 12px",
        cursor: "pointer",
        animation: "srToastIn .22s ease-out",
        display: "flex",
        gap: 9,
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React.createElement("span", { style: { flexShrink: 0, color: "var(--accent)", display: "inline-flex" } }, /* @__PURE__ */ React.createElement(Ico.chat, null)),
    /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, t.count === 1 ? "1 nova mensagem" : `${t.count} novas mensagens`, " de ", t.sender), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", marginTop: 2 } }, "Clica para abrir o chat")),
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        title: "Dispensar",
        onClick: (e) => {
          e.stopPropagation();
          dismiss(t.convId);
        }
      },
      "\xD7"
    )
  )));
}
window.ChatToasts = ChatToasts;
function ToastDock({ onNavigate }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "fixed",
    bottom: 16,
    right: 16,
    zIndex: 200,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "flex-end"
  } }, /* @__PURE__ */ React.createElement(ChatToasts, { onOpen: (convId) => onNavigate && onNavigate("chat", convId) }), /* @__PURE__ */ React.createElement(RealtimeToasts, { onNavigate }));
}
window.ToastDock = ToastDock;
function NotificationBell({ onOpenAccount, onNavigate }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [activities, setActivities] = useState([]);
  const [aba, setAba] = useState("notificacoes");
  const [tarefas, setTarefas] = useState(null);
  const [abertos, setAbertos] = useState(
    () => new Set(TAREFAS_GRUPOS.filter((g) => g.aberto).map((g) => g.key))
  );
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(() => /* @__PURE__ */ new Set());
  const ref = useRef(null);
  useEffect(() => {
    if (!open) setSelected(/* @__PURE__ */ new Set());
  }, [open]);
  const loadCount = async () => {
    try {
      const r = await window.API.notificationsUnread();
      setUnread(r.unread || 0);
    } catch (e) {
    }
  };
  const loadFull = async () => {
    setLoading(true);
    try {
      const [r1, r2, r3] = await Promise.all([
        window.API.notifications(),
        window.API.activityFeed().catch(() => ({ results: [] })),
        window.API.minhasTarefas().catch(() => null)
      ]);
      setItems(r1.results || r1 || []);
      setActivities(r2.results || []);
      setTarefas(r3);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 3e4);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const onRealtime = (e) => {
      const d = e.detail;
      if (!d || d.type !== "notification.new") return;
      setUnread((u) => u + 1);
      const n = d.notification;
      if (n) setItems((xs) => xs.some((x) => x.id === n.id) ? xs : [n, ...xs]);
    };
    window.addEventListener("sr:realtime", onRealtime);
    return () => window.removeEventListener("sr:realtime", onRealtime);
  }, []);
  useEffect(() => {
    if (open) loadFull();
  }, [open]);
  useEffect(() => {
    if (!open) return;
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  const markRead = async (n, isRead = true) => {
    await window.API.markNotificationRead(n.id, isRead);
    setItems((xs) => xs.map((x) => x.id === n.id ? { ...x, is_read: isRead, read_at: isRead ? (/* @__PURE__ */ new Date()).toISOString() : null } : x));
    loadCount();
  };
  const markAll = async () => {
    await window.API.markAllNotificationsRead();
    setItems((xs) => xs.map((x) => ({ ...x, is_read: true, read_at: (/* @__PURE__ */ new Date()).toISOString() })));
    setUnread(0);
    setSelected(/* @__PURE__ */ new Set());
  };
  const markSelectedRead = async () => {
    const ids = Array.from(selected);
    if (ids.length === 0) return;
    const now = (/* @__PURE__ */ new Date()).toISOString();
    await Promise.all(ids.map((id) => window.API.markNotificationRead(id, true).catch(() => {
    })));
    setItems((xs) => xs.map((x) => selected.has(x.id) ? { ...x, is_read: true, read_at: now } : x));
    setSelected(/* @__PURE__ */ new Set());
    loadCount();
  };
  const toggleSelected = (id) => setSelected((prev) => {
    const n = new Set(prev);
    if (n.has(id)) n.delete(id);
    else n.add(id);
    return n;
  });
  const fmtWhen = (s) => window.fmtAgo(s);
  const kindColor = {
    info: "#2563eb",
    success: "#16a34a",
    warning: "#f59e0b",
    error: "#dc2626"
  };
  const resumo = window.hubTarefasResumo(tarefas);
  const toggleGrupo = (key) => setAbertos((prev) => {
    const n = new Set(prev);
    if (n.has(key)) n.delete(key);
    else n.add(key);
    return n;
  });
  return /* @__PURE__ */ React.createElement("div", { ref, style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      onClick: () => setOpen((o) => !o),
      title: "Notifica\xE7\xF5es",
      style: { position: "relative" }
    },
    /* @__PURE__ */ React.createElement(Ico.bell, null),
    unread > 0 && /* @__PURE__ */ React.createElement("span", { style: {
      position: "absolute",
      top: -2,
      right: -2,
      background: "#dc2626",
      color: "#fff",
      fontSize: 10,
      fontWeight: 700,
      lineHeight: 1,
      padding: "2px 5px",
      borderRadius: 10,
      minWidth: 16,
      border: "2px solid var(--panel)"
    } }, unread > 99 ? "99+" : unread)
  ), open && /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: "calc(100% + 6px)",
    right: 0,
    zIndex: 80,
    width: 380,
    maxWidth: "calc(100vw - 24px)",
    maxHeight: "70vh",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius-lg)",
    boxShadow: "var(--shadow-lg)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 4,
    padding: "8px 10px 0",
    borderBottom: "1px solid var(--border)"
  } }, [
    ["notificacoes", `Notifica\xE7\xF5es${unread > 0 ? ` (${unread})` : ""}`],
    ["tarefas", `Tarefas${resumo.acionaveis > 0 ? ` (${resumo.acionaveis})` : ""}`]
  ].map(([k, label]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: k,
      type: "button",
      role: "tab",
      "aria-selected": aba === k,
      onClick: () => setAba(k),
      style: {
        padding: "6px 12px",
        fontSize: 12.5,
        fontWeight: aba === k ? 700 : 500,
        background: "transparent",
        border: "none",
        borderBottom: aba === k ? "2px solid var(--accent)" : "2px solid transparent",
        color: aba === k ? "var(--accent)" : "var(--muted)",
        cursor: "pointer"
      }
    },
    label
  )), aba === "notificacoes" && (selected.size > 0 ? /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      style: { marginLeft: "auto" },
      onClick: markSelectedRead
    },
    "Marcar ",
    selected.size,
    " lida",
    selected.size > 1 ? "s" : ""
  ) : /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      style: { marginLeft: "auto" },
      onClick: markAll,
      disabled: unread === 0
    },
    "Marcar tudo lido"
  ))), aba === "notificacoes" && /* @__PURE__ */ React.createElement("div", { style: { overflow: "auto", flex: 1 } }, loading && /* @__PURE__ */ React.createElement("div", { style: { padding: 14, color: "var(--muted)", fontSize: 12 } }, "A carregar\u2026"), !loading && items.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: 14, color: "var(--muted)", fontSize: 12.5 } }, "Sem notifica\xE7\xF5es."), items.map((n) => {
    const navigable = !!(n.link_view && onNavigate);
    const isSelected = selected.has(n.id);
    const onClick = () => {
      if (!n.is_read) markRead(n, true);
      if (navigable) {
        onNavigate(n.link_view, n.link_target);
        setOpen(false);
      }
    };
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: n.id,
        style: {
          padding: 10,
          borderBottom: "1px solid var(--border)",
          background: isSelected ? "color-mix(in srgb, #2563eb 10%, var(--panel))" : n.is_read ? "transparent" : "color-mix(in srgb, #2563eb 4%, var(--panel))",
          display: "flex",
          gap: 8,
          alignItems: "flex-start"
        }
      },
      !n.is_read && /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: isSelected,
          onChange: () => toggleSelected(n.id),
          onClick: (e) => e.stopPropagation(),
          style: { marginTop: 4, cursor: "pointer", flexShrink: 0 },
          title: "Selecionar"
        }
      ),
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: kindColor[n.kind] || kindColor.info,
        marginTop: 6,
        flexShrink: 0
      } }),
      /* @__PURE__ */ React.createElement("div", { onClick, style: {
        flex: 1,
        minWidth: 0,
        cursor: navigable || !n.is_read ? "pointer" : "default"
      } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: n.is_read ? 400 : 600 } }, n.title), n.body && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", marginTop: 2 } }, n.body), /* @__PURE__ */ React.createElement("div", { style: {
        fontSize: 11,
        color: "var(--muted)",
        marginTop: 4,
        fontFamily: "var(--font-mono)"
      } }, fmtWhen(n.created_at)))
    );
  }), activities.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    padding: "8px 12px 4px",
    fontSize: 10.5,
    fontFamily: "var(--font-mono)",
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    background: "var(--bg)",
    borderTop: "1px solid var(--border)"
  } }, "Atividade recente"), activities.slice(0, 20).map((a, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: {
    padding: "8px 12px",
    borderBottom: "1px solid var(--border)",
    fontSize: 12,
    color: "var(--text)",
    display: "flex",
    gap: 6
  } }, /* @__PURE__ */ React.createElement("span", { style: {
    fontFamily: "var(--font-mono)",
    color: "var(--muted)",
    fontSize: 10,
    width: 60,
    flexShrink: 0
  } }, a.app), /* @__PURE__ */ React.createElement("span", { style: { flex: 1 } }, a.text), /* @__PURE__ */ React.createElement("span", { style: {
    fontFamily: "var(--font-mono)",
    color: "var(--muted)",
    fontSize: 10,
    flexShrink: 0
  } }, fmtWhen(a.when))))), aba === "tarefas" && /* @__PURE__ */ React.createElement("div", { style: { overflow: "auto", flex: 1 } }, loading && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 14,
    color: "var(--muted)",
    fontSize: 12
  } }, "A carregar\u2026"), !loading && resumo.grupos.every((g) => g.itens.length === 0) && /* @__PURE__ */ React.createElement("div", { style: { padding: 14, color: "var(--muted)", fontSize: 12.5 } }, "N\xE3o tens tarefas com prazo."), resumo.grupos.map((g) => g.itens.length === 0 ? null : /* @__PURE__ */ React.createElement("div", { key: g.key }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => toggleGrupo(g.key),
      style: {
        width: "100%",
        textAlign: "left",
        padding: "8px 12px",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.4,
        textTransform: "uppercase",
        color: "var(--muted)"
      }
    },
    abertos.has(g.key) ? "\u25BE" : "\u25B8",
    " ",
    g.label
  ), abertos.has(g.key) && g.itens.map((t) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: `${t.app}-${t.id}`,
      onClick: () => {
        if (t.link_view && onNavigate) {
          onNavigate(t.link_view, t.link_target);
          setOpen(false);
        }
      },
      style: {
        padding: "8px 12px",
        display: "flex",
        gap: 8,
        alignItems: "flex-start",
        cursor: t.link_view ? "pointer" : "default",
        borderBottom: "1px solid var(--border)"
      }
    },
    /* @__PURE__ */ React.createElement("span", { style: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: g.cor,
      marginTop: 5,
      flexShrink: 0
    } }),
    /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, overflowWrap: "anywhere" } }, t.titulo), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, [
      t.app_nome,
      t.contexto,
      t.autor_nome ? `atribu\xEDda por ${t.autor_nome}` : null
    ].filter(Boolean).join(" \xB7 "))),
    /* @__PURE__ */ React.createElement("span", { style: {
      fontSize: 11,
      fontWeight: 600,
      color: g.cor,
      whiteSpace: "nowrap"
    } }, window.hubPrazoLabelFromDias(t.dias))
  ))))), /* @__PURE__ */ React.createElement("div", { style: {
    padding: "8px 12px",
    borderTop: "1px solid var(--border)",
    background: "var(--panel-2)",
    textAlign: "center"
  } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
    setOpen(false);
    onOpenAccount && onOpenAccount();
  } }, "Ver na minha conta"))));
}
window.NotificationBell = NotificationBell;

// ===== administracao/frontend/administracao_manual.jsx =====
const _FOLD_STORAGE_KEY = "plugin_manual.foldState";
function _loadFoldState() {
  try {
    const raw = window.localStorage.getItem(_FOLD_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_) {
    return {};
  }
}
function _saveFoldState(state) {
  try {
    window.localStorage.setItem(_FOLD_STORAGE_KEY, JSON.stringify(state));
  } catch (_) {
  }
}
function AdministracaoManualView() {
  const { useState, useEffect, useMemo, useCallback } = React;
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [selected, setSelected] = useState({ section: "commands", key: null });
  const [q, setQ] = useState("");
  const [collapsed, setCollapsed] = useState(_loadFoldState);
  useEffect(() => {
    _saveFoldState(collapsed);
  }, [collapsed]);
  const toggle = useCallback((id) => {
    setCollapsed((prev) => ({ ...prev, [id]: !prev[id] }));
  }, []);
  useEffect(() => {
    fetch("/api/administracao/manual/", { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error("HTTP " + r.status))).then((d) => {
      setData(d);
      if (d.commands && d.commands.length && !selected.key) {
        setSelected({ section: "commands", key: d.commands[0].name });
      }
    }).catch((e) => setErr(e.message));
  }, []);
  const sections = useMemo(() => {
    if (!data) return [];
    return [
      { id: "commands", label: "Slash commands", items: data.commands.map((c) => ({ key: c.name, label: c.name, sub: c.description })) },
      { id: "policies", label: "Policies", items: data.policies.map((p) => ({ key: p.name, label: p.name })) },
      { id: "features", label: "Features", items: data.features.map((f) => ({ key: f.name, label: f.label, sub: `${f.status} \xB7 v${f.version}` })) },
      { id: "apps", label: "Hub apps", items: data.apps.map((a) => ({ key: a.slug, label: a.slug, sub: `${a.status} \xB7 v${a.version}` })) },
      { id: "scheduled_tasks", label: "Tarefas agendadas", items: data.scheduled_tasks.map((t) => ({
        key: t.name,
        label: t.description || t.unit,
        sub: t.app + " \xB7 " + ("installed" in t ? t.installed ? t.active ? "activo" : "instalado" : "n\xE3o instalado" : "estado desconhecido")
      })) }
    ];
  }, [data]);
  const currentContent = useMemo(() => {
    if (!data) return null;
    const bySection = {
      commands: () => data.commands.find((c) => c.name === selected.key),
      policies: () => data.policies.find((p) => p.name === selected.key),
      features: () => data.features.find((f) => f.name === selected.key),
      apps: () => data.apps.find((a) => a.slug === selected.key),
      scheduled_tasks: () => data.scheduled_tasks.find((t) => t.name === selected.key)
    };
    return bySection[selected.section] ? bySection[selected.section]() : null;
  }, [data, selected]);
  const filteredSections = useMemo(() => {
    if (!q.trim()) return sections;
    const needle = q.toLowerCase();
    return sections.map((s) => ({
      ...s,
      items: s.items.filter(
        (i) => i.label.toLowerCase().includes(needle) || (i.sub || "").toLowerCase().includes(needle)
      )
    })).filter((s) => s.items.length > 0);
  }, [sections, q]);
  if (err) {
    return React.createElement(
      "div",
      { style: { padding: 20, color: "crimson" } },
      React.createElement("h2", null, "Erro a carregar o manual"),
      err
    );
  }
  if (!data) {
    return React.createElement("div", { style: { padding: 20, color: "#888" } }, "A carregar\u2026");
  }
  const searchActive = !!q.trim();
  return React.createElement(
    "div",
    {
      style: { display: "grid", gridTemplateColumns: "280px 1fr", gap: 16, height: "calc(100vh - 120px)", padding: 16 }
    },
    // Sidebar
    React.createElement(
      "aside",
      {
        style: { borderRight: "1px solid #e5e7eb", overflowY: "auto", paddingRight: 12 }
      },
      React.createElement("input", {
        type: "text",
        placeholder: "Filtrar\u2026",
        value: q,
        onChange: (e) => setQ(e.target.value),
        style: { width: "100%", padding: "6px 10px", border: "1px solid #d1d5db", borderRadius: 6, marginBottom: 12, boxSizing: "border-box" }
      }),
      filteredSections.map((s) => {
        const isCollapsed = !searchActive && !!collapsed[s.id];
        return React.createElement(
          "div",
          { key: s.id, style: { marginBottom: 12 } },
          React.createElement(
            "button",
            {
              type: "button",
              onClick: () => toggle(s.id),
              "aria-expanded": !isCollapsed,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                padding: "4px 0",
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 600,
                textTransform: "uppercase",
                color: "#6b7280",
                fontFamily: "inherit"
              }
            },
            React.createElement("span", null, s.label + " (" + s.items.length + ")"),
            React.createElement("span", { style: { fontSize: 10, marginLeft: 6 } }, isCollapsed ? "\u25B8" : "\u25BE")
          ),
          !isCollapsed && React.createElement(
            "ul",
            { style: { listStyle: "none", padding: 0, margin: "6px 0 0" } },
            s.items.map((i) => {
              const active = selected.section === s.id && selected.key === i.key;
              return React.createElement(
                "li",
                { key: i.key },
                React.createElement(
                  "button",
                  {
                    onClick: () => setSelected({ section: s.id, key: i.key }),
                    style: {
                      display: "block",
                      width: "100%",
                      textAlign: "left",
                      padding: "6px 8px",
                      margin: "2px 0",
                      background: active ? "#eef2ff" : "transparent",
                      color: active ? "#3730a3" : "#111827",
                      border: "none",
                      borderRadius: 4,
                      cursor: "pointer",
                      fontFamily: "inherit",
                      fontSize: 13
                    }
                  },
                  React.createElement("div", { style: { fontWeight: active ? 600 : 500 } }, i.label),
                  i.sub && React.createElement("div", { style: { fontSize: 11, color: "#6b7280", marginTop: 2 } }, i.sub)
                )
              );
            })
          )
        );
      })
    ),
    // Content pane
    React.createElement(
      "main",
      {
        style: { overflowY: "auto", paddingRight: 24, lineHeight: 1.6 }
      },
      currentContent ? React.createElement(
        "div",
        null,
        React.createElement(
          "h1",
          { style: { marginTop: 0 } },
          currentContent.name || currentContent.label || currentContent.slug
        ),
        currentContent.description && React.createElement("p", {
          style: { color: "#6b7280", marginTop: 0 }
        }, currentContent.description),
        currentContent.argument_hint && React.createElement("pre", {
          style: { background: "#f3f4f6", padding: "8px 12px", borderRadius: 6, fontSize: 12 }
        }, currentContent.argument_hint),
        currentContent.status && React.createElement(
          "div",
          {
            style: { display: "flex", gap: 12, marginBottom: 16, fontSize: 12, color: "#6b7280" }
          },
          React.createElement(
            "span",
            null,
            "Status: ",
            React.createElement("strong", null, currentContent.status)
          ),
          React.createElement(
            "span",
            null,
            "Version: ",
            React.createElement("strong", null, currentContent.version)
          )
        ),
        selected.section === "scheduled_tasks" && React.createElement(
          "div",
          { style: { marginBottom: 16 } },
          React.createElement(
            "div",
            {
              style: { display: "flex", gap: 12, flexWrap: "wrap", fontSize: 12, color: "#6b7280", marginBottom: 12 }
            },
            React.createElement("span", null, "App: ", React.createElement("strong", null, currentContent.app)),
            React.createElement("span", null, "Agenda: ", React.createElement("code", null, currentContent.schedule || "\u2014")),
            React.createElement(
              "span",
              null,
              "Ficheiros: ",
              React.createElement("code", null, currentContent.timer_path),
              " \xB7 ",
              React.createElement("code", null, currentContent.service_path)
            )
          ),
          "installed" in currentContent ? React.createElement(
            "div",
            { style: { display: "flex", gap: 16, flexWrap: "wrap", fontSize: 12, marginBottom: 12 } },
            React.createElement("span", null, "Instalado: ", React.createElement("strong", null, currentContent.installed ? "sim" : "n\xE3o")),
            React.createElement("span", null, "Enabled: ", React.createElement("strong", null, currentContent.enabled ? "sim" : "n\xE3o")),
            React.createElement("span", null, "Ativo: ", React.createElement("strong", null, currentContent.active ? "sim" : "n\xE3o")),
            React.createElement("span", null, "Pr\xF3xima corrida: ", React.createElement(
              "strong",
              null,
              currentContent.next_run ? new Date(currentContent.next_run).toLocaleString("pt-PT") : "\u2014"
            )),
            React.createElement("span", null, "\xDAltima corrida: ", React.createElement(
              "strong",
              null,
              currentContent.last_run ? new Date(currentContent.last_run).toLocaleString("pt-PT") : "\u2014"
            )),
            React.createElement("span", null, "Resultado: ", React.createElement("strong", null, currentContent.service_result || "\u2014"))
          ) : React.createElement(
            "div",
            { style: { fontSize: 12, color: "#b45309", marginBottom: 12 } },
            "Estado systemd indispon\xEDvel nesta m\xE1quina \u2014 a mostrar apenas a declara\xE7\xE3o."
          ),
          currentContent.exec_start && React.createElement(
            "div",
            { style: { marginBottom: 12 } },
            React.createElement("div", { style: { fontSize: 12, fontWeight: 600, marginBottom: 4 } }, "O que executa"),
            React.createElement(
              "pre",
              { style: { background: "#f3f4f6", padding: "8px 12px", borderRadius: 6, fontSize: 12, overflowX: "auto" } },
              currentContent.exec_start
            )
          ),
          currentContent.install_commands && currentContent.install_commands.length > 0 && React.createElement(
            "div",
            { style: { marginBottom: 12 } },
            React.createElement("div", { style: { fontSize: 12, fontWeight: 600, marginBottom: 4 } }, "Instalar"),
            React.createElement(
              "pre",
              { style: { background: "#f3f4f6", padding: "8px 12px", borderRadius: 6, fontSize: 12, overflowX: "auto" } },
              currentContent.install_commands.join("\n")
            )
          ),
          currentContent.verify_commands && currentContent.verify_commands.length > 0 && React.createElement(
            "div",
            { style: { marginBottom: 12 } },
            React.createElement("div", { style: { fontSize: 12, fontWeight: 600, marginBottom: 4 } }, "Verificar"),
            React.createElement(
              "pre",
              { style: { background: "#f3f4f6", padding: "8px 12px", borderRadius: 6, fontSize: 12, overflowX: "auto" } },
              currentContent.verify_commands.join("\n")
            )
          ),
          currentContent.reprocess_commands && currentContent.reprocess_commands.length > 0 && React.createElement(
            "div",
            { style: { marginBottom: 12 } },
            React.createElement("div", { style: { fontSize: 12, fontWeight: 600, marginBottom: 4 } }, "Reprocessar uma corrida em falta"),
            React.createElement(
              "pre",
              { style: { background: "#f3f4f6", padding: "8px 12px", borderRadius: 6, fontSize: 12, overflowX: "auto" } },
              currentContent.reprocess_commands.join("\n")
            )
          )
        ),
        currentContent.html && React.createElement("div", {
          className: "manual-body",
          dangerouslySetInnerHTML: { __html: currentContent.html }
        })
      ) : React.createElement(
        "div",
        { style: { color: "#6b7280", padding: 20 } },
        "Escolhe uma entrada na barra lateral."
      )
    )
  );
}
window.AdministracaoManualView = AdministracaoManualView;

// ===== administracao/frontend/user-config-guide.jsx =====
function AdministracaoUserConfigGuideView() {
  const { useState, useEffect } = React;
  const [html, setHtml] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    fetch("/api/administracao/user-config-guide/", { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error("HTTP " + r.status))).then((d) => setHtml(d.html || "")).catch((e) => setErr(e.message));
  }, []);
  if (err) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 13 } }, err));
  }
  if (html === null) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026");
  }
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 900 } }, /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 24 } }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "markdown-body",
      dangerouslySetInnerHTML: { __html: html }
    }
  )));
}
window.AdministracaoUserConfigGuideView = AdministracaoUserConfigGuideView;

// ===== administracao/frontend/user-types.jsx =====
function UserTypeFormModal({ initial, isNew, onClose, onSubmit }) {
  const [form, setForm] = useState({ ...initial });
  const upd = (k) => (e) => setForm((f) => ({
    ...f,
    [k]: e.target.type === "checkbox" ? e.target.checked : e.target.type === "number" ? Number(e.target.value) : e.target.value
  }));
  const submit = (e) => {
    e.preventDefault();
    const data = { ...form };
    if (isNew && !data.id_slug) {
      data.id_slug = data.nome.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
    }
    onSubmit(data);
  };
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: isNew ? "Novo tipo de utilizador" : `Editar ${initial.nome}`,
      subtitle: "Perfil reutiliz\xE1vel de permiss\xF5es",
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "user-type-form", className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: "user-type-form",
        onSubmit: submit,
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement(
        "input",
        {
          value: form.nome,
          onChange: upd("nome"),
          required: true,
          autoFocus: true,
          placeholder: "ex: Comercial Stock, Gestor Whale, Admin"
        }
      )),
      isNew && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Identificador (slug)"), /* @__PURE__ */ React.createElement(
        "input",
        {
          value: form.id_slug,
          onChange: upd("id_slug"),
          placeholder: "auto a partir do nome",
          pattern: "[a-z0-9_]*"
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Descri\xE7\xE3o (opcional)"), /* @__PURE__ */ React.createElement("textarea", { value: form.description || "", onChange: upd("description"), rows: 2 })),
      /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Cor"), /* @__PURE__ */ React.createElement("input", { type: "color", value: form.cor, onChange: upd("cor"), style: { height: 36, padding: 4 } })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Ordem"), /* @__PURE__ */ React.createElement("input", { type: "number", value: form.ordem, onChange: upd("ordem"), min: 0 }))),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Permiss\xF5es concedidas"), /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        flexDirection: "column",
        gap: 6,
        padding: 10,
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)"
      } }, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!form.is_admin, onChange: upd("is_admin") }), /* @__PURE__ */ React.createElement("strong", null, "Admin"), " ", /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "(is_staff \u2014 acesso a tudo)")), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!form.is_assignable, onChange: upd("is_assignable") }), "Atribu\xEDvel ", /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, '(aparece no dropdown "Atribu\xEDdo ao tratamento")')), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!form.can_impersonate, onChange: upd("can_impersonate") }), "Pode impersonar ", /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "(entrar como utilizadores n\xE3o-admin \u2014 auditado)")), /* @__PURE__ */ React.createElement("div", { style: { height: 4 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "O acesso por app deste tipo define-se na ", /* @__PURE__ */ React.createElement("strong", null, "Matriz de Acessos"), " ", "(Acessos \u2192 Matriz de Acessos), via regras por app. Um tipo ", /* @__PURE__ */ React.createElement("em", null, "Admin"), " tem acesso a tudo.")))
    )
  );
}
window.UserTypeFormModal = UserTypeFormModal;
function UserTypesView() {
  const [types, setTypes] = useState([]);
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const load = async () => {
    try {
      setError(null);
      const r = await window.API.userTypes();
      setTypes(r.results || r);
    } catch (e) {
      setError(e.message);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const handleSave = async (data, isNew) => {
    try {
      setError(null);
      if (isNew) await window.API.createUserType(data);
      else await window.API.updateUserType(editing.id_slug, data);
      setEditing(null);
      setCreating(false);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDelete = async (t) => {
    if (!await window.hubConfirm({ message: `Apagar tipo "${t.nome}"?
Os utilizadores associados perdem este perfil.` })) return;
    try {
      setError(null);
      await window.API.deleteUserType(t.id_slug);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const yes = "\u2713";
  const columns = [
    {
      key: "nome",
      label: "Nome",
      width: 220,
      minWidth: 170,
      fixed: true,
      render: (t) => /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 12, height: 12, borderRadius: 3, background: t.cor, border: "1px solid var(--border)" } }), /* @__PURE__ */ React.createElement("strong", null, t.nome))
    },
    {
      key: "identificador",
      label: "Identificador",
      width: 180,
      minWidth: 140,
      mono: true,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, t.id_slug)
    },
    {
      key: "admin",
      label: "Admin",
      title: "is_staff (acesso a tudo)",
      width: 90,
      minWidth: 75,
      render: (t) => t.is_admin ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, yes) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "atribuivel",
      label: "Atribu\xEDvel",
      title: "Aparece no dropdown Atribu\xEDdo",
      width: 120,
      minWidth: 100,
      render: (t) => t.is_assignable ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, yes) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "regras",
      label: "Regras",
      title: "N\xBA de AccessRule configuradas para este tipo (Matriz de Acessos)",
      width: 95,
      minWidth: 80,
      align: "right",
      mono: true,
      render: (t) => t.is_admin ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" }, title: "Admin v\xEA tudo por bypass \u2014 regras da matriz n\xE3o se aplicam" }, "bypass") : t.access_rule_count ?? 0
    },
    {
      key: "users",
      label: "Users",
      title: "N\xBA de utilizadores com este tipo",
      width: 85,
      minWidth: 70,
      align: "right",
      mono: true,
      render: (t) => t.user_count ?? 0
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 150,
      minWidth: 130,
      render: (t) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(t) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleDelete(t) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 1100 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Tipos de utilizador"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 perfis reutiliz\xE1veis com bundle de permiss\xF5es"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Novo")), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 14px",
    marginBottom: 12,
    background: "var(--bg-2)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)",
    fontSize: 12.5
  } }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "Novo aqui? O guia end-to-end mostra o workflow completo (UserTypes \u2192 Matriz de Acessos \u2192 Equipas \u2192 atribui\xE7\xE3o a users)."), /* @__PURE__ */ React.createElement(
    "a",
    {
      href: "#admin_user_config_guide",
      style: { marginLeft: "auto", fontWeight: 600, whiteSpace: "nowrap" }
    },
    "Ver guia \u2192"
  )), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "administracao",
      viewId: "tipos-utilizador",
      columns,
      data: types,
      pagination: "none",
      rowKey: (t) => t.id_slug,
      empty: 'Sem tipos definidos. Cria um para come\xE7ar (ex. "Comercial Stock", "Gestor Whale", "Admin").'
    }
  ), (editing || creating) && /* @__PURE__ */ React.createElement(
    UserTypeFormModal,
    {
      initial: editing || {
        nome: "",
        id_slug: "",
        cor: "#6a7888",
        ordem: 100,
        is_admin: false,
        is_assignable: false,
        can_impersonate: false
      },
      isNew: creating,
      onClose: () => {
        setEditing(null);
        setCreating(false);
      },
      onSubmit: (data) => handleSave(data, creating)
    }
  ));
}
window.UserTypesView = UserTypesView;

// ===== administracao/frontend/access-matrix.jsx =====
const _RULE_PALETTE = [
  { bg: "#3a8a4d", fg: "#fff" },
  { bg: "#d4a574", fg: "#000" },
  { bg: "#e6c05c", fg: "#000" },
  { bg: "#4a7ec4", fg: "#fff" }
];
function ruleShort(code) {
  const m = code && code.match(/^R\d+/);
  return m ? m[0] : code || "";
}
function ruleColor(code) {
  const m = code && code.match(/^R(\d+)/);
  const n = m ? parseInt(m[1], 10) : 1;
  return _RULE_PALETTE[(n - 1 + _RULE_PALETTE.length) % _RULE_PALETTE.length];
}
function larguraPorRotulo(label, minimo) {
  return Math.max(minimo, Math.round(label.length * 8.8) + 32);
}
function RuleBadge({ rule, actionsCount, overrideCount, isAdmin }) {
  if (isAdmin) {
    const c2 = ruleColor("R1_ALL");
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          display: "inline-block",
          padding: "2px 8px",
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 600,
          background: c2.bg,
          color: c2.fg,
          opacity: 0.7
        },
        title: "Admin \u2014 bypass total via is_admin"
      },
      "R1 \xB7 \u{1F6E1}"
    );
  }
  if (!rule) {
    return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, "\u2014");
  }
  const c = ruleColor(rule);
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    background: c.bg,
    color: c.fg
  } }, ruleShort(rule), actionsCount > 0 && /* @__PURE__ */ React.createElement("span", { style: { opacity: 0.85 } }, " \xB7 ", actionsCount), overrideCount > 0 && /* @__PURE__ */ React.createElement("sup", { style: { marginLeft: 2, fontSize: 9 } }, "+", overrideCount));
}
function AccessMatrixView() {
  const APP_LIST = window.HUB_REG.appRoster().map((a) => ({ slug: a.app_label, label: a.name }));
  const [userTypes, setUserTypes] = React.useState([]);
  const [rules, setRules] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [search, setSearch] = React.useState("");
  const [editing, setEditing] = React.useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const [uts, rs] = await Promise.all([
        window.API.userTypes(),
        window.API.accessRules()
      ]);
      setUserTypes(uts.results || uts);
      setRules(rs.results || rs);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    load();
  }, []);
  const ruleIndex = React.useMemo(() => {
    const idx = /* @__PURE__ */ new Map();
    for (const r of rules) {
      const key = `${r.user_type}:${r.app_label}`;
      const cur = idx.get(key) || { defaultRule: null, overrides: [] };
      if (r.resource === "") cur.defaultRule = r;
      else cur.overrides.push(r);
      idx.set(key, cur);
    }
    return idx;
  }, [rules]);
  const filteredTypes = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    let arr = userTypes;
    if (q) arr = arr.filter((u) => u.nome.toLowerCase().includes(q));
    return [...arr].sort((a, b) => {
      if (a.is_admin !== b.is_admin) return a.is_admin ? -1 : 1;
      return (a.ordem || 999) - (b.ordem || 999) || a.nome.localeCompare(b.nome, "pt-PT");
    });
  }, [userTypes, search]);
  const openCell = (userType, appLabel) => {
    if (userType.is_admin) return;
    setEditing({ userType, appLabel });
  };
  const columns = [
    {
      key: "nome",
      label: "Tipo",
      width: 110,
      minWidth: 90,
      fixed: true,
      render: (ut) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, ut.is_admin && /* @__PURE__ */ React.createElement("span", { style: { marginRight: 4 } }, "\u{1F6E1}"), ut.nome)
    },
    ...APP_LIST.map((a) => ({
      key: a.slug,
      label: a.label,
      sortable: false,
      width: larguraPorRotulo(a.label, 80),
      render: (ut) => {
        const key = `${ut.id}:${a.slug}`;
        const cell = ruleIndex.get(key) || { defaultRule: null, overrides: [] };
        const editable = !ut.is_admin;
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            onClick: editable ? () => openCell(ut, a.slug) : void 0,
            style: {
              display: "flex",
              justifyContent: "center",
              cursor: editable ? "pointer" : "not-allowed"
            }
          },
          /* @__PURE__ */ React.createElement(
            RuleBadge,
            {
              rule: cell.defaultRule?.rule,
              actionsCount: (cell.defaultRule?.actions || []).length,
              overrideCount: cell.overrides.length,
              isAdmin: ut.is_admin
            }
          )
        );
      }
    }))
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Matriz de Acessos"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "Pesquisar tipo\u2026",
      value: search,
      onChange: (e) => setSearch(e.target.value),
      style: { marginLeft: "auto", minWidth: 220 }
    }
  )), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "administracao",
      viewId: "matriz-acessos",
      columns,
      data: filteredTypes,
      pagination: "none",
      rowKey: (ut) => ut.id,
      empty: "Sem UserTypes que correspondam \xE0 pesquisa."
    }
  ), editing && /* @__PURE__ */ React.createElement(
    window.AccessRuleEditor,
    {
      userType: editing.userType,
      appLabel: editing.appLabel,
      onClose: () => setEditing(null),
      onSaved: () => {
        setEditing(null);
        load();
      }
    }
  ));
}
window.AccessMatrixView = AccessMatrixView;

// ===== administracao/frontend/feature-config.jsx =====
function FeatureConfigView() {
  const APP_LIST = window.HUB_REG.appRoster().map((a) => ({ slug: a.app_label, label: a.name }));
  const [features, setFeatures] = React.useState([]);
  const [rows, setRows] = React.useState({});
  const [userTypes, setUserTypes] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const keyOf = (app, key) => `${app}|${key}`;
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await window.API.featureMatrix();
      setFeatures(data.features);
      const map = {};
      (data.config || []).forEach((c) => {
        map[keyOf(c.app_label, c.feature_key)] = {
          enabled: c.enabled,
          usertype_ids: c.usertype_ids || []
        };
      });
      setRows(map);
      const uts = await window.API.userTypes();
      setUserTypes((uts.results || uts).map((u) => ({ id: u.id, name: u.nome })));
    } catch (e) {
      setError(String(e));
    }
    setLoading(false);
  };
  React.useEffect(() => {
    load();
  }, []);
  const cell = (app, key) => rows[keyOf(app, key)] || { enabled: true, usertype_ids: [] };
  const setCell = (app, key, patch) => setRows((m) => ({
    ...m,
    [keyOf(app, key)]: { ...cell(app, key), ...patch }
  }));
  const save = async () => {
    const config = [];
    Object.entries(rows).forEach(([k, v]) => {
      const [app_label, feature_key] = k.split("|");
      config.push({ app_label, feature_key, enabled: v.enabled, usertype_ids: v.usertype_ids });
    });
    try {
      await window.API.saveFeatureMatrix({ config });
      window.srToast("Configura\xE7\xE3o de features guardada", "success");
      load();
    } catch (e) {
      window.srToast(String(e), "error");
    }
  };
  if (loading) return /* @__PURE__ */ React.createElement("div", { className: "panel" }, "A carregar\u2026");
  if (error) return /* @__PURE__ */ React.createElement("div", { className: "panel" }, "Erro: ", error);
  const columns = [
    {
      key: "label",
      label: "App",
      width: 160,
      minWidth: 130,
      fixed: true,
      render: (app) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, app.label)
    },
    ...features.map((f) => ({
      key: f.key,
      label: f.label,
      sortable: false,
      width: 230,
      minWidth: 180,
      render: (app) => {
        const c = cell(app.slug, f.key);
        return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            checked: c.enabled,
            onChange: (e) => setCell(app.slug, f.key, { enabled: e.target.checked })
          }
        )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
          "select",
          {
            multiple: true,
            value: c.usertype_ids.map(String),
            disabled: !c.enabled,
            style: { minWidth: 120, fontSize: 11 },
            onChange: (e) => setCell(app.slug, f.key, {
              usertype_ids: Array.from(e.target.selectedOptions).map((o) => Number(o.value))
            })
          },
          userTypes.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.name))
        )));
      }
    }))
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Features por app")), /* @__PURE__ */ React.createElement("p", { style: { color: "var(--muted)", fontSize: 12.5, marginTop: 0, marginBottom: 14 } }, 'Liga/desliga cada feature por app. Vazio em "tipos" = todos. Desligado = escondido para todos. (Disponibilidade apenas \u2014 n\xE3o altera acessos.)'), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "administracao",
      viewId: "features-por-app",
      columns,
      data: APP_LIST,
      pagination: "none",
      rowKey: (app) => app.slug,
      empty: "Sem apps registadas."
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: save }, "Guardar")));
}
window.FeatureConfigView = FeatureConfigView;

// ===== administracao/frontend/anexos-settings.jsx =====
function AnexosSettingsView() {
  const empty = {
    graph_tenant_id: "",
    graph_client_id: "",
    sharepoint_site_id: "",
    sharepoint_drive_id: "",
    pasta_base: "",
    is_enabled: false,
    has_secret: false,
    is_configured: false
  };
  const [form, setForm] = React.useState(empty);
  const [secret, setSecret] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await window.API.anexosSettings();
      setForm({ ...empty, ...data });
      setSecret("");
    } catch (e) {
      setError(String(e));
    }
    setLoading(false);
  };
  React.useEffect(() => {
    load();
  }, []);
  const upd = (k) => (e) => setForm((f) => ({
    ...f,
    [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  }));
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = {
        graph_tenant_id: form.graph_tenant_id,
        graph_client_id: form.graph_client_id,
        sharepoint_site_id: form.sharepoint_site_id,
        sharepoint_drive_id: form.sharepoint_drive_id,
        pasta_base: form.pasta_base,
        is_enabled: form.is_enabled
      };
      if (secret) body.graph_client_secret = secret;
      await window.API.saveAnexosSettings(body);
      window.srToast("Defini\xE7\xF5es de anexos guardadas", "success");
      load();
    } catch (e2) {
      window.srToast(String(e2), "error");
    }
    setSaving(false);
  };
  if (loading) return /* @__PURE__ */ React.createElement("div", { className: "panel" }, "A carregar\u2026");
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 640 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Anexos \u2014 armazenamento")), /* @__PURE__ */ React.createElement("p", { style: { color: "var(--muted)", fontSize: 12.5, marginTop: 0, marginBottom: 14 } }, "Credenciais Microsoft Graph / SharePoint usadas para guardar ficheiros anexados a partir do hub. ", form.is_configured ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "Configurado.") : /* @__PURE__ */ React.createElement("span", null, "Ainda n\xE3o configurado.")), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement("form", { onSubmit: save, className: "panel", style: {
    padding: 16,
    display: "flex",
    flexDirection: "column",
    gap: 12
  } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Tenant ID"), /* @__PURE__ */ React.createElement("input", { value: form.graph_tenant_id, onChange: upd("graph_tenant_id") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Client ID"), /* @__PURE__ */ React.createElement("input", { value: form.graph_client_id, onChange: upd("graph_client_id") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Client secret"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: secret,
      onChange: (e) => setSecret(e.target.value),
      placeholder: form.has_secret ? "definido \u2014 deixa vazio para manter" : "sk-..."
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "SharePoint Site ID"), /* @__PURE__ */ React.createElement("input", { value: form.sharepoint_site_id, onChange: upd("sharepoint_site_id") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "SharePoint Drive ID"), /* @__PURE__ */ React.createElement("input", { value: form.sharepoint_drive_id, onChange: upd("sharepoint_drive_id") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Pasta base"), /* @__PURE__ */ React.createElement("input", { value: form.pasta_base, onChange: upd("pasta_base"), placeholder: "ex: Anexos" })), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: form.is_enabled, onChange: upd("is_enabled") }), " Ativo"), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn primary sm", disabled: saving }, saving ? "A guardar\u2026" : "Guardar"))));
}
window.AnexosSettingsView = AnexosSettingsView;

// ===== administracao/frontend/access-rule-editor.jsx =====
const ACCESS_PRESETS = {
  read_only: ["read"],
  read_edit: ["read", "update"],
  comercial: ["read", "create", "update", "assign"],
  aprovador: ["read", "update", "approve"],
  total: ["read", "create", "update", "delete", "assign", "export", "approve", "config"]
};
const PRESET_LABELS = {
  read_only: "S\xF3 leitura",
  read_edit: "Leitura + Editar",
  comercial: "Comercial",
  aprovador: "Aprovador",
  total: "Total",
  custom: "Custom\u2026"
};
const _RULE_NONE = { value: "", label: "Sem acesso (apaga a regra)" };
function _ruleOptions(rules) {
  return [_RULE_NONE, ...(rules || []).map((r) => ({
    value: r.code,
    label: `${(r.code.match(/^R\d+/) || [r.code])[0]} \u2014 ${r.label}`
  }))];
}
function detectPreset(actions) {
  const target = [...actions || []].sort().join(",");
  for (const [key, presetActions] of Object.entries(ACCESS_PRESETS)) {
    if ([...presetActions].sort().join(",") === target) return key;
  }
  return "custom";
}
window.ACCESS_PRESETS = ACCESS_PRESETS;
window.detectPreset = detectPreset;
function _scopedRoutesFor(appLabel) {
  const apps = window.__HUB_APPS || [];
  const app = apps.find((a) => (a.appLabel || a.slug) === appLabel);
  if (!app) return [];
  return (app.routes || []).filter((r) => r.scoped).map((r) => ({ id: r.id, label: r.label }));
}
function dashboardChecklist(appLabel, overrides) {
  const byResource = {};
  for (const o of overrides || []) byResource[o.resource] = o;
  return _scopedRoutesFor(appLabel).map(({ id, label }) => {
    const ov = byResource[id];
    const checked = !ov || (ov.actions || []).includes("read");
    return { id, label, checked, ruleId: ov ? ov.id : null };
  });
}
function denyRulePayload(userTypeId, appLabel, resourceId) {
  return {
    user_type: userTypeId,
    app_label: appLabel,
    resource: resourceId,
    rule: "R1_ALL",
    actions: []
  };
}
window.dashboardChecklist = dashboardChecklist;
window.denyRulePayload = denyRulePayload;
function AccessRuleRow({ rule, onChange, onDelete, showResource, rules, actions }) {
  const preset = detectPreset(rule.actions);
  const [customExpanded, setCustomExpanded] = React.useState(preset === "custom");
  const setPreset = (p) => {
    if (p === "custom") {
      setCustomExpanded(true);
      return;
    }
    setCustomExpanded(false);
    onChange({ ...rule, actions: [...ACCESS_PRESETS[p]] });
  };
  const toggleAction = (a) => {
    const s = new Set(rule.actions);
    if (s.has(a)) s.delete(a);
    else s.add(a);
    onChange({ ...rule, actions: [...s] });
  };
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: 10,
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)"
  } }, showResource && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Resource (route ou modelo)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rule.resource || "",
      placeholder: "ex: leads-stats",
      onChange: (e) => onChange({ ...rule, resource: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Rule"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: rule.rule || "",
      onChange: (e) => onChange({ ...rule, rule: e.target.value })
    },
    _ruleOptions(rules).map((r) => /* @__PURE__ */ React.createElement("option", { key: r.value, value: r.value }, r.label))
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Preset de ac\xE7\xF5es"), /* @__PURE__ */ React.createElement("select", { value: preset, onChange: (e) => setPreset(e.target.value) }, Object.entries(PRESET_LABELS).map(([k, label]) => /* @__PURE__ */ React.createElement("option", { key: k, value: k }, label))))), customExpanded && /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    padding: 8,
    background: "var(--bg-2)",
    borderRadius: 6
  } }, (actions || []).map((a) => /* @__PURE__ */ React.createElement("label", { key: a, style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: 12.5
  } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: rule.actions.includes(a),
      onChange: () => toggleAction(a)
    }
  ), a))), onDelete && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: onDelete,
      style: { alignSelf: "flex-start" }
    },
    "\u2715 Remover override"
  ));
}
function AccessRuleEditor({ userType, appLabel, currentUserId, onClose, onSaved }) {
  const [defaultRule, setDefaultRule] = React.useState({
    id: null,
    user_type: userType.id,
    app_label: appLabel,
    resource: "",
    rule: "R1_ALL",
    actions: [...ACCESS_PRESETS.total]
  });
  const [overrides, setOverrides] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [vocab, setVocab] = React.useState({ rules: [], actions: [] });
  React.useEffect(() => {
    window.API.accessVocab().then((v) => setVocab({ rules: v.rules || [], actions: v.actions || [] })).catch(() => {
    });
  }, []);
  const isSelfEdit = (userType.users || []).some((u) => u.id === currentUserId);
  React.useEffect(() => {
    (async () => {
      try {
        const rules = await window.API.accessRules({
          user_type: userType.id,
          app_label: appLabel
        });
        const arr = rules.results || rules;
        const def = arr.find((r) => r.resource === "");
        if (def) setDefaultRule(def);
        setOverrides(arr.filter((r) => r.resource !== ""));
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [userType.id, appLabel]);
  const saveOne = async (r) => {
    if (r.rule === "") {
      if (r.id) await window.API.deleteAccessRule(r.id);
      return null;
    }
    if (r.id) return window.API.updateAccessRule(r.id, {
      rule: r.rule,
      actions: r.actions,
      resource: r.resource
    });
    return window.API.createAccessRule({
      user_type: r.user_type,
      app_label: r.app_label,
      resource: r.resource,
      rule: r.rule,
      actions: r.actions
    });
  };
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      await saveOne(defaultRule);
      for (const o of overrides) await saveOne(o);
      onSaved && onSaved();
      onClose();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };
  const addOverride = () => setOverrides((prev) => [...prev, {
    id: null,
    user_type: userType.id,
    app_label: appLabel,
    resource: "",
    rule: "R1_ALL",
    actions: [...ACCESS_PRESETS.read_only]
  }]);
  const updateOverride = (idx, r) => setOverrides((prev) => prev.map((o, i) => i === idx ? r : o));
  const removeOverride = async (idx) => {
    const o = overrides[idx];
    if (o.id) await window.API.deleteAccessRule(o.id);
    setOverrides((prev) => prev.filter((_, i) => i !== idx));
  };
  const dashboards = dashboardChecklist(appLabel, overrides);
  const toggleDashboard = async (item) => {
    if (item.checked) {
      const created = await window.API.createAccessRule(
        denyRulePayload(userType.id, appLabel, item.id)
      );
      setOverrides((prev) => [...prev, { ...created }]);
    } else {
      if (item.ruleId) await window.API.deleteAccessRule(item.ruleId);
      setOverrides((prev) => prev.filter((o) => o.resource !== item.id));
    }
  };
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: `${userType.nome} \u2192 ${appLabel}`,
      subtitle: "Editar regra de acesso",
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: save, disabled: saving }, saving ? "A guardar\u2026" : "Guardar"))
    },
    isSelfEdit && /* @__PURE__ */ React.createElement("div", { style: {
      padding: 10,
      background: "#fff3cd",
      border: "1px solid #ffeeba",
      borderRadius: 6,
      color: "#856404",
      fontSize: 12.5,
      marginBottom: 12
    } }, "\u26A0\uFE0F Est\xE1s a editar o teu pr\xF3prio perfil. Cuidado com auto-lockout."),
    error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error),
    loading ? /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026") : /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement("h3", { style: {
      margin: "0 0 6px",
      fontSize: 13,
      fontWeight: 600,
      textTransform: "uppercase",
      color: "var(--muted)"
    } }, "Regra por defeito"), /* @__PURE__ */ React.createElement(
      AccessRuleRow,
      {
        rule: defaultRule,
        onChange: setDefaultRule,
        rules: vocab.rules,
        actions: vocab.actions
      }
    )), dashboards.length > 0 && /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement("h3", { style: {
      margin: "0 0 6px",
      fontSize: 13,
      fontWeight: 600,
      textTransform: "uppercase",
      color: "var(--muted)"
    } }, "Acesso por dashboard"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 6 } }, dashboards.map((item) => /* @__PURE__ */ React.createElement("label", { key: item.id, style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      fontSize: 13
    } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: item.checked,
        onChange: () => toggleDashboard(item)
      }
    ), item.label))), /* @__PURE__ */ React.createElement("p", { style: { margin: "6px 0 0", color: "var(--muted)", fontSize: 11.5 } }, "Desmarcar tira o dashboard a este tipo de utilizador. Por defeito, todos ligados.")), /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 6
    } }, /* @__PURE__ */ React.createElement("h3", { style: {
      margin: 0,
      fontSize: 13,
      fontWeight: 600,
      textTransform: "uppercase",
      color: "var(--muted)"
    } }, "Overrides por resource (", overrides.length, ")"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", onClick: addOverride }, "+ Adicionar override")), overrides.length === 0 && /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 12 } }, "Sem overrides \u2014 a regra por defeito aplica-se a toda a app."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, overrides.map((o, i) => /* @__PURE__ */ React.createElement(
      AccessRuleRow,
      {
        key: i,
        rule: o,
        showResource: true,
        rules: vocab.rules,
        actions: vocab.actions,
        onChange: (r) => updateOverride(i, r),
        onDelete: () => removeOverride(i)
      }
    )))))
  );
}
window.AccessRuleEditor = AccessRuleEditor;

// ===== administracao/frontend/access-teams.jsx =====
function TeamModal({ team, isNew, onClose, onSubmit }) {
  const initial = team || { name: "", description: "", active: true, members: [] };
  const [form, setForm] = React.useState({
    name: initial.name || "",
    description: initial.description || "",
    active: initial.active !== false,
    members: initial.members || []
  });
  const [allUsers, setAllUsers] = React.useState([]);
  const [pickUserId, setPickUserId] = React.useState("");
  React.useEffect(() => {
    window.API.users().then((r) => setAllUsers(r.results || r)).catch(() => {
    });
  }, []);
  const addMember = () => {
    const id = Number(pickUserId);
    if (!id) return;
    if (form.members.find((m) => m.id === id)) return;
    const u = allUsers.find((x) => x.id === id);
    if (!u) return;
    setForm((f) => ({ ...f, members: [...f.members, {
      id: u.id,
      username: u.username,
      first_name: u.first_name || "",
      last_name: u.last_name || ""
    }] }));
    setPickUserId("");
  };
  const removeMember = (id) => setForm((f) => ({ ...f, members: f.members.filter((m) => m.id !== id) }));
  const submit = (e) => {
    e.preventDefault();
    onSubmit({
      name: form.name,
      description: form.description,
      active: form.active,
      member_ids: form.members.map((m) => m.id)
    });
  };
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: isNew ? "Nova equipa" : `Editar ${team.name}`,
      subtitle: "Grupo para regra R4_TEAM",
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "team-form", className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: "team-form",
        onSubmit: submit,
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement(
        "input",
        {
          value: form.name,
          required: true,
          autoFocus: true,
          onChange: (e) => setForm((f) => ({ ...f, name: e.target.value }))
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Descri\xE7\xE3o"), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          rows: 2,
          value: form.description,
          onChange: (e) => setForm((f) => ({ ...f, description: e.target.value }))
        }
      )),
      /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: form.active,
          onChange: (e) => setForm((f) => ({ ...f, active: e.target.checked }))
        }
      ), "Activa"),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Membros"), /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        flexDirection: "column",
        gap: 6,
        padding: 10,
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)"
      } }, form.members.length === 0 && /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 12 } }, "Sem membros."), form.members.map((m) => /* @__PURE__ */ React.createElement("div", { key: m.id, style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: 13
      } }, /* @__PURE__ */ React.createElement("span", null, m.first_name || m.last_name ? `${m.first_name} ${m.last_name}`.trim() : m.username), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          onClick: () => removeMember(m.id)
        },
        "\u2715"
      ))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 6 } }, /* @__PURE__ */ React.createElement(
        "select",
        {
          value: pickUserId,
          onChange: (e) => setPickUserId(e.target.value),
          style: { flex: 1 }
        },
        /* @__PURE__ */ React.createElement("option", { value: "" }, "Adicionar user\u2026"),
        allUsers.filter((u) => !form.members.find((m) => m.id === u.id)).map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.first_name || u.last_name ? `${u.first_name} ${u.last_name}`.trim() : u.username))
      ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", onClick: addMember }, "+"))))
    )
  );
}
function AccessTeamsView() {
  const [teams, setTeams] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [editing, setEditing] = React.useState(null);
  const [creating, setCreating] = React.useState(false);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.API.teams();
      setTeams(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    load();
  }, []);
  const handleSubmit = async (data) => {
    try {
      if (editing) await window.API.updateTeam(editing.id, data);
      else await window.API.createTeam(data);
      setEditing(null);
      setCreating(false);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const toggleActive = async (team, active) => {
    try {
      await window.API.updateTeam(team.id, { active });
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const del = async (team) => {
    const nMembers = (team.members || []).length;
    const msg = nMembers > 0 ? `Apagar "${team.name}"? Vai remover ${nMembers} membros. AccessRule R4_TEAM continuam mas ficam sem efeito.` : `Apagar "${team.name}"?`;
    if (!await window.hubConfirm({ message: msg })) return;
    try {
      await window.API.deleteTeam(team.id);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const columns = [
    {
      key: "nome",
      label: "Nome",
      width: 190,
      minWidth: 150,
      fixed: true,
      render: (t) => /* @__PURE__ */ React.createElement("strong", null, t.name)
    },
    {
      key: "descricao",
      label: "Descri\xE7\xE3o",
      width: 320,
      minWidth: 200,
      render: (t) => /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, t.description || "\u2014")
    },
    {
      key: "membros",
      label: "Membros",
      width: 100,
      minWidth: 85,
      align: "right",
      mono: true,
      render: (t) => (t.members || []).length
    },
    {
      key: "estado",
      label: "Estado",
      width: 130,
      minWidth: 110,
      render: (t) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: t.active,
          onChange: (e) => toggleActive(t, e.target.checked)
        }
      ), t.active ? "Activo" : "Inactivo"))
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 110,
      minWidth: 90,
      render: (t) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => del(t) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minHeight: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexShrink: 0 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Equipas"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 ", teams.length), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      style: { marginLeft: "auto" },
      onClick: () => setCreating(true)
    },
    "+ Nova equipa"
  )), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "administracao",
      viewId: "equipas",
      columns,
      data: teams,
      pagination: "none",
      rowKey: (t) => t.id,
      onRowClick: setEditing,
      empty: "Sem equipas. Cria a primeira para poderes usar R4_TEAM."
    }
  ), (creating || editing) && /* @__PURE__ */ React.createElement(
    TeamModal,
    {
      team: editing,
      isNew: !editing,
      onClose: () => {
        setCreating(false);
        setEditing(null);
      },
      onSubmit: handleSubmit
    }
  ));
}
window.AccessTeamsView = AccessTeamsView;

// ===== administracao/frontend/general.jsx =====
function ApiKeyFormModal({ initial, isNew, onClose, onSubmit }) {
  const [form, setForm] = useState({
    provider: initial.provider || "",
    label: initial.label || "",
    username: "",
    value: "",
    is_active: initial.is_active !== false
  });
  const upd = (k) => (e) => setForm((f) => ({
    ...f,
    [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  }));
  const needsUsername = form.provider === "dbinforma";
  const formId = "apikey-form";
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: isNew ? "Nova credencial" : `Editar ${initial.provider}`,
      subtitle: "API key encriptada em BD",
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: formId, className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: formId,
        onSubmit: (e) => {
          e.preventDefault();
          onSubmit(form);
        },
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Provider"), isNew ? /* @__PURE__ */ React.createElement("select", { value: form.provider, onChange: upd("provider"), required: true, autoFocus: true }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"), /* @__PURE__ */ React.createElement("option", { value: "anthropic" }, "anthropic (SCOUT IA)"), /* @__PURE__ */ React.createElement("option", { value: "dbinforma" }, "dbinforma (user + password)"), /* @__PURE__ */ React.createElement("option", { value: "github" }, "github (quadro de desenvolvimentos)"), /* @__PURE__ */ React.createElement("option", { value: "dev-board" }, "dev-board (sess\xF5es do Claude)")) : /* @__PURE__ */ React.createElement("input", { value: form.provider, disabled: true })),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Label"), /* @__PURE__ */ React.createElement(
        "input",
        {
          value: form.label,
          onChange: upd("label"),
          placeholder: form.provider === "dbinforma" ? "ex: DBInforma (apinforma)" : "ex: Anthropic (SCOUT)"
        }
      )),
      needsUsername && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "userId"), /* @__PURE__ */ React.createElement(
        "input",
        {
          value: form.username,
          onChange: upd("username"),
          placeholder: isNew ? "userId fornecido pela Informa D&B" : "deixa vazio para manter",
          required: isNew
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, needsUsername ? "Password" : "API key"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "password",
          value: form.value,
          onChange: upd("value"),
          placeholder: isNew ? needsUsername ? "password" : "sk-ant-..." : "deixa vazio para manter",
          required: isNew
        }
      )),
      /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: form.is_active, onChange: upd("is_active") }), " Ativa")
    )
  );
}
window.ApiKeyFormModal = ApiKeyFormModal;
function ApiKeyPanel() {
  const [keys, setKeys] = useState([]);
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState(null);
  const load = async () => {
    try {
      const r = await window.API.apiKeys();
      setKeys(r.results || r);
    } catch (e) {
      setError(e.message);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const handleSave = async (data, isNew) => {
    try {
      setError(null);
      if (isNew) await window.API.createApiKey(data);
      else await window.API.updateApiKey(data.provider, data);
      setEditing(null);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDelete = async (k) => {
    if (!await window.hubConfirm({ message: `Apagar key "${k.provider}"?` })) return;
    try {
      await window.API.deleteApiKey(k.provider);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const known = [
    { provider: "anthropic", label: "Anthropic (SCOUT)" },
    { provider: "dbinforma", label: "DBInforma (enrichment)" },
    { provider: "github", label: "GitHub \u2014 leitura de PRs (quadro de desenvolvimentos)" },
    { provider: "dev-board", label: "Quadro de desenvolvimentos \u2014 token das sess\xF5es do Claude" }
  ];
  const columns = [
    {
      key: "provider",
      label: "Provider",
      width: 130,
      minWidth: 105,
      fixed: true,
      mono: true,
      render: (k) => /* @__PURE__ */ React.createElement("strong", null, k.provider)
    },
    {
      key: "label",
      label: "Label",
      width: 220,
      minWidth: 160,
      render: (k) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, k.label || known.find((x) => x.provider === k.provider)?.label || "\u2014")
    },
    {
      key: "tem_valor",
      label: "Tem valor",
      width: 100,
      minWidth: 85,
      render: (k) => k.has_value ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "ativa",
      label: "Ativa",
      width: 85,
      minWidth: 70,
      render: (k) => k.is_active ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "atualizada",
      label: "Atualizada",
      width: 120,
      minWidth: 100,
      render: (k) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, new Date(k.updated_at).toLocaleDateString("pt-PT"))
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 170,
      minWidth: 150,
      render: (k) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(k) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleDelete(k) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "API keys (integra\xE7\xF5es externas)"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 encriptadas em BD"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setEditing("new") }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Nova")), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "administracao",
      viewId: "chaves-api",
      columns,
      data: keys,
      pagination: "none",
      rowKey: (k) => k.provider,
      empty: "Sem keys. Adiciona pelo menos `anthropic` se queres usar o SCOUT."
    }
  ), editing && /* @__PURE__ */ React.createElement(
    ApiKeyFormModal,
    {
      initial: editing === "new" ? { provider: "", label: "", is_active: true } : editing,
      isNew: editing === "new",
      onClose: () => setEditing(null),
      onSubmit: (data) => handleSave(data, editing === "new")
    }
  ));
}
window.ApiKeyPanel = ApiKeyPanel;
function HubBrandingPanel() {
  const [cfg, setCfg] = useState(null);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => window.API.hubBranding().then(setCfg).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  useEffect(() => {
    load();
  }, []);
  const onFile = (file) => {
    if (!file) return;
    setBusy(true);
    setMsg(null);
    window.API.uploadHubBrandingLogo(file).then(() => {
      load();
      setMsg({ ok: true, text: "Logo do grupo atualizado." });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setBusy(false));
  };
  const onClear = () => {
    setBusy(true);
    setMsg(null);
    window.API.clearHubBrandingLogo().then(() => {
      load();
      setMsg({ ok: true, text: "Logo removido \u2014 volta ao default." });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setBusy(false));
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Logo do grupo Jos\xE9 Neves"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 usado nos PDFs gerados pelo hub (ex. servi\xE7o de fornecedores)")), /* @__PURE__ */ React.createElement("div", { style: { padding: 16, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 120,
    height: 120,
    border: "1px solid var(--border)",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--bg-soft, #f7f9fb)",
    overflow: "hidden"
  } }, cfg && cfg.logo_url ? /* @__PURE__ */ React.createElement(
    "img",
    {
      src: cfg.logo_url,
      alt: "",
      style: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }
    }
  ) : /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)", textAlign: "center", padding: 8 } }, "(sem logo \u2014 usa o default)")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("label", { className: "btn primary sm", style: { cursor: "pointer", opacity: busy ? 0.6 : 1 } }, busy ? "A carregar\u2026" : cfg && cfg.logo_url ? "Trocar logo" : "Carregar logo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "file",
      accept: "image/*",
      style: { display: "none" },
      disabled: busy,
      onChange: (e) => onFile(e.target.files && e.target.files[0])
    }
  )), cfg && cfg.logo_url && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: busy, onClick: onClear }, "Remover"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", maxWidth: 260 } }, "PNG ou SVG, fundo transparente recomendado. Vai aparecer no header dos PDFs."))), msg && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: msg.ok ? "#059669" : "#c4434b", fontSize: 12 } }, msg.text));
}
window.HubBrandingPanel = HubBrandingPanel;
function ScheduledTasksPanel() {
  const [tasks, setTasks] = useState(null);
  const [projectRoot, setProjectRoot] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showManual, setShowManual] = useState(false);
  const load = () => {
    setLoading(true);
    setError(null);
    window.API.scheduledTasks().then((r) => {
      setTasks(r.tasks || []);
      setProjectRoot(r.project_root || "");
    }).catch((e) => setError(e.message || String(e))).finally(() => setLoading(false));
  };
  useEffect(() => {
    load();
  }, []);
  const fmtTs = (iso) => iso ? new Date(iso).toLocaleString("pt-PT") : "\u2014";
  const dot = (ok, muted) => /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: muted ? "var(--muted)" : ok ? "#059669" : "#c4434b"
  } });
  const installScript = tasks && tasks.length > 0 && [
    "# Correr no servidor de destino. O cd \xE9 o que torna isto copi\xE1vel a",
    "# partir de qualquer diret\xF3rio \u2014 os caminhos das units s\xE3o relativos.",
    "set -e",
    projectRoot ? `cd "${projectRoot}"` : "# cd <root do checkout>",
    "",
    "# 1. Copiar as unit files declaradas em apps/*/deploy/",
    ...tasks.flatMap((t) => [
      `sudo cp "${t.timer_path}"   /etc/systemd/system/`,
      `sudo cp "${t.service_path}" /etc/systemd/system/`
    ]),
    "",
    "# 2. Recarregar systemd + activar cada timer",
    "sudo systemctl daemon-reload",
    ...tasks.map((t) => `sudo systemctl enable --now ${t.unit}`),
    "",
    "# 3. Confirmar que est\xE3o a correr",
    `sudo systemctl list-timers | grep -E '${tasks.map((t) => t.unit.replace(/\./g, "\\.")).join("|")}'`
  ].join("\n");
  const copyInstall = async () => {
    try {
      await navigator.clipboard.writeText(installScript);
    } catch {
    }
  };
  const unitsColumns = [
    {
      // 145 e nao 120: o slug mais longo entre apps/*/deploy/ ('cargoplanner',
      // ex-'inbound_verum' antes da Task 7 do SP-1) precisa de 128px. E um
      // rotulo de app, um identificador — cortar um identificador nunca e o
      // desenho a funcionar.
      key: "app",
      label: "App",
      width: 145,
      minWidth: 100,
      fixed: true,
      mono: true,
      render: (t) => t.app
    },
    {
      // 300: 'bi-supplier-email-monthly.timer' precisa de 272px. Nome de ficheiro,
      // outro identificador — quem procura a unit precisa do nome inteiro.
      key: "unit",
      label: "Unit",
      width: 300,
      minWidth: 200,
      mono: true,
      render: (t) => t.unit
    },
    {
      // 400: a descricao mais longa precisa de 369px e cortava em 5 de 5 linhas.
      // A tabela ja rola na horizontal por desenho (a soma das 10 colunas passa
      // o contentor), por isso alargar nao troca nada por nada — rola-se na mesma
      // e le-se tudo.
      key: "descricao",
      label: "Descri\xE7\xE3o",
      width: 400,
      minWidth: 180,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", title: t.exec_start }, t.description || "\u2014")
    },
    {
      key: "agenda",
      label: "Agenda",
      width: 150,
      minWidth: 120,
      mono: true,
      render: (t) => /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11 } }, t.on_calendar || t.on_unit_active_sec || t.on_boot_sec || "\u2014")
    },
    {
      key: "inst",
      label: "Inst",
      title: "Instalado em /etc/systemd/system",
      width: 55,
      minWidth: 45,
      align: "center",
      render: (t) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, dot(!!t.installed, !("installed" in t)))
    },
    {
      key: "on",
      label: "On",
      title: "Enabled",
      width: 55,
      minWidth: 45,
      align: "center",
      render: (t) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, dot(!!t.enabled, !("installed" in t)))
    },
    {
      key: "act",
      label: "Act",
      title: "Active",
      width: 55,
      minWidth: 45,
      align: "center",
      render: (t) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, dot(!!t.active, !("installed" in t)))
    },
    {
      key: "proximo",
      label: "Pr\xF3ximo",
      width: 160,
      minWidth: 130,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, fmtTs(t.next_run))
    },
    {
      key: "ultimo",
      label: "\xDAltimo",
      width: 160,
      minWidth: 130,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, fmtTs(t.last_run))
    },
    {
      key: "resultado",
      label: "Resultado",
      width: 120,
      minWidth: 95,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, t.service_result || "\u2014")
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Tarefas agendadas (systemd timers)"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 declaradas em ", /* @__PURE__ */ React.createElement("code", null, "apps/<slug>/deploy/")), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      style: { marginLeft: "auto" },
      disabled: loading,
      onClick: load
    },
    loading ? "A atualizar\u2026" : "Atualizar"
  )), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), tasks && tasks.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: 20, textAlign: "center", color: "var(--muted)" } }, "Nenhum timer declarado."), tasks && tasks.length > 0 && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "administracao",
      viewId: "units-systemd",
      columns: unitsColumns,
      data: tasks,
      pagination: "none",
      rowKey: (t) => t.unit
    }
  ), tasks && tasks.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => setShowManual((v) => !v),
      style: {
        width: "100%",
        textAlign: "left",
        padding: "8px 12px",
        fontSize: 12,
        background: "transparent",
        border: "none",
        cursor: "pointer",
        color: "var(--muted)",
        display: "flex",
        alignItems: "center",
        gap: 6
      }
    },
    /* @__PURE__ */ React.createElement("span", { style: {
      display: "inline-block",
      transform: showManual ? "rotate(90deg)" : "none",
      transition: "transform 120ms"
    } }, "\u25B8"),
    "Manual de instala\xE7\xE3o \u2014 usar sempre que o servi\xE7o mude de servidor"
  ), showManual && /* @__PURE__ */ React.createElement("div", { style: { padding: "0 12px 12px" } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    marginBottom: 6
  } }, "Copiar o bloco abaixo e correr no novo servidor, a partir da raiz do checkout deste reposit\xF3rio. Actualiza-se automaticamente \xE0 medida que forem adicionadas novas apps com timers.", /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: copyInstall,
      style: {
        marginLeft: 10,
        padding: "2px 8px",
        fontSize: 11,
        borderRadius: 4,
        border: "1px solid var(--border)",
        background: "var(--panel)",
        cursor: "pointer"
      }
    },
    "Copiar"
  )), /* @__PURE__ */ React.createElement("pre", { style: {
    background: "#0f172a",
    color: "#e2e8f0",
    padding: 12,
    borderRadius: 6,
    fontSize: 11,
    lineHeight: 1.5,
    overflowX: "auto",
    margin: 0,
    fontFamily: "var(--mono, monospace)"
  } }, installScript), /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    marginTop: 8
  } }, "Para remover um timer:", /* @__PURE__ */ React.createElement("code", { style: { marginLeft: 6 } }, "sudo systemctl disable --now <unit> ; sudo rm /etc/systemd/system/<unit>"), ". Para mudar o hor\xE1rio, editar o", /* @__PURE__ */ React.createElement("code", { style: { marginLeft: 4 } }, "OnCalendar="), " no ficheiro", /* @__PURE__ */ React.createElement("code", { style: { marginLeft: 4 } }, ".timer"), " do reposit\xF3rio, recopiar para ", /* @__PURE__ */ React.createElement("code", null, "/etc/systemd/system/"), " e correr", /* @__PURE__ */ React.createElement("code", { style: { marginLeft: 4 } }, "sudo systemctl daemon-reload && sudo systemctl restart <unit>"), "."))));
}
window.ScheduledTasksPanel = ScheduledTasksPanel;
function GeneralAdminView({ users = [], reloadUsers, me }) {
  return (
    // A lista de utilizadores enche a janela (é uma tabela: com um cap de
    // largura as colunas de Tipos e Ações ficavam espremidas). Os painéis
    // seguintes são formulários — esses continuam limitados a 900px.
    /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement(TeamPanel, { users, reloadUsers, me }), /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 900 } }, /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(HubBrandingPanel, null), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(ScheduledTasksPanel, null), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(ApiKeyPanel, null)))
  );
}
window.GeneralAdminView = GeneralAdminView;

// ===== administracao/frontend/email.jsx =====
function EmailSettingsView({ me }) {
  const [cfg, setCfg] = useState(null);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [pwTouched, setPwTouched] = useState(false);
  const [gsTouched, setGsTouched] = useState(false);
  const [testTo, setTestTo] = useState(me?.email || "");
  const [testing, setTesting] = useState(false);
  useEffect(() => {
    window.API.emailSettings().then(setCfg).catch((e) => setError(e.message));
  }, []);
  if (!cfg) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { style: { padding: 16, color: error ? "#c4434b" : "var(--muted)" } }, error || "A carregar\u2026"));
  }
  const upd = (k) => (e) => {
    const v = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setCfg((c) => ({ ...c, [k]: v }));
    if (k === "password") setPwTouched(true);
    if (k === "graph_client_secret") setGsTouched(true);
  };
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const patch = {
        mode: cfg.mode || "smtp",
        from_email: cfg.from_email || "",
        is_enabled: !!cfg.is_enabled,
        host: cfg.host || "",
        port: Number(cfg.port) || 587,
        username: cfg.username || "",
        use_tls: !!cfg.use_tls,
        graph_tenant_id: cfg.graph_tenant_id || "",
        graph_client_id: cfg.graph_client_id || "",
        graph_sender: cfg.graph_sender || ""
      };
      if (pwTouched) patch.password = cfg.password || "";
      if (gsTouched) patch.graph_client_secret = cfg.graph_client_secret || "";
      const saved = await window.API.updateEmailSettings(patch);
      setCfg({ ...saved, password: "", graph_client_secret: "" });
      setPwTouched(false);
      setGsTouched(false);
      window.srToast("Configura\xE7\xE3o de email guardada.");
    } catch (e2) {
      setError(e2.message);
    } finally {
      setSaving(false);
    }
  };
  const test = async () => {
    setTesting(true);
    try {
      const r = await window.API.sendTestEmail(testTo);
      window.srToast(r.message);
    } catch (e2) {
      const m = String(e2.message || e2);
      const j = m.match(/\{.*\}$/s);
      let msg = m;
      try {
        msg = j ? JSON.parse(j[0]).message || m : m;
      } catch {
      }
      window.srToast("Falha no envio do email de teste", "error", msg);
    } finally {
      setTesting(false);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { maxWidth: 640 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Email"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 usado para enviar links de defini\xE7\xE3o de password e notifica\xE7\xF5es")), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement("form", { onSubmit: save, style: { display: "flex", flexDirection: "column", gap: 12, padding: 14 } }, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!cfg.is_enabled, onChange: upd("is_enabled") }), "Ativar envio (se desligado, os emails v\xE3o para a consola do servidor)"), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "M\xE9todo"), /* @__PURE__ */ React.createElement("select", { value: cfg.mode || "smtp", onChange: upd("mode") }, /* @__PURE__ */ React.createElement("option", { value: "smtp" }, "SMTP"), /* @__PURE__ */ React.createElement("option", { value: "graph" }, "Microsoft Graph (OAuth2)"))), (cfg.mode || "smtp") === "smtp" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 2 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Servidor (host)"), /* @__PURE__ */ React.createElement("input", { value: cfg.host || "", onChange: upd("host"), placeholder: "smtp.office365.com" })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 1 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Porta"), /* @__PURE__ */ React.createElement("input", { type: "number", value: cfg.port ?? 587, onChange: upd("port") }))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Utilizador"), /* @__PURE__ */ React.createElement("input", { value: cfg.username || "", onChange: upd("username"), autoComplete: "off" })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Password"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: cfg.password || "",
      onChange: upd("password"),
      autoComplete: "new-password",
      placeholder: cfg.has_password ? "deixa vazio para manter" : ""
    }
  )), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!cfg.use_tls, onChange: upd("use_tls") }), " Usar TLS")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Tenant ID (Directory)"), /* @__PURE__ */ React.createElement("input", { value: cfg.graph_tenant_id || "", onChange: upd("graph_tenant_id"), autoComplete: "off" })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Client ID (Application)"), /* @__PURE__ */ React.createElement("input", { value: cfg.graph_client_id || "", onChange: upd("graph_client_id"), autoComplete: "off" })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Client Secret"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: cfg.graph_client_secret || "",
      onChange: upd("graph_client_secret"),
      autoComplete: "new-password",
      placeholder: cfg.has_graph_secret ? "deixa vazio para manter" : ""
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Mailbox remetente (UPN)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.graph_sender || "",
      onChange: upd("graph_sender"),
      placeholder: "no-reply@joseneves.pt"
    }
  ), /* @__PURE__ */ React.createElement("span", { className: "hint" }, "Requer permiss\xE3o Mail.Send (Application) com consentimento de admin."))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Remetente (From)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.from_email || "",
      onChange: upd("from_email"),
      placeholder: "GJN HUB <no-reply@exemplo.pt>"
    }
  )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn primary sm", disabled: saving }, saving ? "A guardar\u2026" : "Guardar"), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 10, fontSize: 12, color: "var(--muted)" } }, 'Aspeto e conte\xFAdo dos emails em "Templates de email".'))), /* @__PURE__ */ React.createElement("div", { style: {
    borderTop: "1px solid var(--border)",
    padding: 14,
    display: "flex",
    gap: 8,
    alignItems: "flex-end",
    flexWrap: "wrap"
  } }, /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 1, minWidth: 200 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Email de teste para"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "email",
      value: testTo,
      onChange: (e) => setTestTo(e.target.value),
      placeholder: "o-teu@email.pt"
    }
  )), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: test, disabled: testing || !testTo }, testing ? "A enviar\u2026" : "Enviar email de teste")));
}
window.EmailSettingsView = EmailSettingsView;

// ===== administracao/frontend/email-templates.jsx =====
const BLANK_TEMPLATE = {
  key: "",
  name: "",
  is_builtin: false,
  subject: "",
  kind: "standard",
  title: "",
  intro: "Ol\xE1 {nome},\n\n",
  button_label: "",
  body_html: ""
};
function EmailTemplatesView() {
  const [cfg, setCfg] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [selKey, setSelKey] = useState(null);
  const [tpl, setTpl] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const [savingBrand, setSavingBrand] = useState(false);
  const [savingTpl, setSavingTpl] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");
  const loadTemplates = useCallback(async (selectKey) => {
    const r = await window.API.emailTemplates();
    const list = r.results || r || [];
    setTemplates(list);
    return list;
  }, []);
  useEffect(() => {
    window.API.emailSettings().then(setCfg).catch((e) => setError(e.message));
    loadTemplates().then((list) => {
      if (list.length) {
        setSelKey(list[0].key);
        setTpl(list[0]);
      }
    }).catch((e) => setError(e.message));
  }, [loadTemplates]);
  useEffect(() => {
    if (!tpl || !cfg) return;
    const t = setTimeout(() => {
      window.API.emailTemplatePreview({
        kind: tpl.kind,
        subject: tpl.subject || "",
        title: tpl.title || "",
        intro: tpl.intro || "",
        button_label: tpl.button_label || "",
        body_html: tpl.body_html || "",
        header_title: cfg.email_header_title || "",
        accent: cfg.email_accent || "#15324f",
        signature: cfg.email_signature || ""
      }).then((r) => setPreviewHtml(r.html || "")).catch(() => {
      });
    }, 350);
    return () => clearTimeout(t);
  }, [tpl, cfg]);
  if (!cfg) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { style: { padding: 16, color: error ? "#c4434b" : "var(--muted)" } }, error || "A carregar\u2026"));
  }
  const updCfg = (k) => (e) => setCfg((c) => ({ ...c, [k]: e.target.value }));
  const updTpl = (k) => (e) => setTpl((t) => ({ ...t, [k]: e.target.value }));
  const selectTemplate = (key) => {
    setCreating(false);
    setError(null);
    const found = templates.find((t) => t.key === key);
    if (found) {
      setSelKey(key);
      setTpl(found);
    }
  };
  const newTemplate = () => {
    setCreating(true);
    setError(null);
    setSelKey(null);
    setTpl({ ...BLANK_TEMPLATE });
  };
  const saveBrand = async () => {
    setSavingBrand(true);
    setError(null);
    try {
      await window.API.updateEmailSettings({
        email_header_title: cfg.email_header_title || "",
        email_accent: cfg.email_accent || "#15324f",
        email_signature: cfg.email_signature || ""
      });
      window.srToast("Marca guardada.");
    } catch (e2) {
      setError(e2.message);
    } finally {
      setSavingBrand(false);
    }
  };
  const onLogoFile = async (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!f) return;
    try {
      const saved = await window.API.updateEmailLogo(f);
      setCfg((c) => ({ ...c, logo_url: saved.logo_url }));
      window.srToast("Logo atualizado.");
    } catch (e2) {
      setError(e2.message);
    }
  };
  const clearLogo = async () => {
    try {
      await window.API.clearEmailLogo();
      setCfg((c) => ({ ...c, logo_url: null }));
      window.srToast("Logo removido.");
    } catch (e2) {
      setError(e2.message);
    }
  };
  const saveTemplate = async (e) => {
    e.preventDefault();
    setSavingTpl(true);
    setError(null);
    const payload = {
      key: tpl.key,
      name: tpl.name,
      subject: tpl.subject || "",
      kind: tpl.kind,
      title: tpl.title || "",
      intro: tpl.intro || "",
      button_label: tpl.button_label || "",
      body_html: tpl.body_html || ""
    };
    try {
      if (creating) {
        if (!tpl.key || !tpl.name) throw new Error("Indica um identificador e um nome.");
        await window.API.createEmailTemplate(payload);
      } else {
        await window.API.updateEmailTemplate(tpl.key, payload);
      }
      window.srToast("Tipo de email guardado.");
      const list = await loadTemplates();
      const saved = list.find((t) => t.key === tpl.key);
      setCreating(false);
      setSelKey(tpl.key);
      if (saved) setTpl(saved);
    } catch (e2) {
      setError(e2.message);
    } finally {
      setSavingTpl(false);
    }
  };
  const deleteTemplate = async () => {
    if (creating || tpl.is_builtin) return;
    if (!await window.hubConfirm({ message: `Eliminar o tipo de email "${tpl.name}"?` })) return;
    setError(null);
    try {
      await window.API.deleteEmailTemplate(tpl.key);
      window.srToast("Tipo de email eliminado.");
      const list = await loadTemplates();
      if (list.length) {
        setSelKey(list[0].key);
        setTpl(list[0]);
      } else {
        setSelKey(null);
        setTpl(null);
      }
    } catch (e2) {
      setError(e2.message);
    }
  };
  const isStandard = tpl && tpl.kind === "standard";
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 16, alignItems: "flex-start", flexWrap: "wrap", padding: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 340, maxWidth: 560, display: "flex", flexDirection: "column", gap: 16 } }, error && /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Marca"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 partilhada por todos os emails")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 12, padding: 14 } }, /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 2 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "T\xEDtulo do cabe\xE7alho"), /* @__PURE__ */ React.createElement("input", { value: cfg.email_header_title || "", onChange: updCfg("email_header_title"), placeholder: "GJN HUB" })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 1 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Cor de destaque"), /* @__PURE__ */ React.createElement("input", { type: "color", value: cfg.email_accent || "#15324f", onChange: updCfg("email_accent"), style: { height: 34, padding: 2, width: "100%" } }))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Assinatura / rodap\xE9"), /* @__PURE__ */ React.createElement("textarea", { value: cfg.email_signature || "", onChange: updCfg("email_signature"), rows: 2 })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Logo (PNG, embebido no email)"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" } }, cfg.logo_url && /* @__PURE__ */ React.createElement("img", { src: cfg.logo_url, alt: "logo", style: { height: 40, background: "var(--panel-2)", border: "1px solid var(--border)", borderRadius: 4, padding: 4 } }), /* @__PURE__ */ React.createElement("label", { className: "btn ghost sm", style: { cursor: "pointer" } }, cfg.logo_url ? "Trocar logo" : "Carregar logo", /* @__PURE__ */ React.createElement("input", { type: "file", accept: "image/png,image/jpeg", onChange: onLogoFile, style: { display: "none" } })), cfg.logo_url && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: clearLogo }, "Remover")), /* @__PURE__ */ React.createElement("span", { className: "hint" }, "Sem logo, usa-se o t\xEDtulo do cabe\xE7alho como texto.")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: saveBrand, disabled: savingBrand }, savingBrand ? "A guardar\u2026" : "Guardar marca")))), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Tipos de email"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", style: { marginLeft: "auto" }, onClick: newTemplate }, "+ Novo tipo")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 12, padding: 14 } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Tipo de email"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: creating ? "__new__" : selKey || "",
      onChange: (e) => e.target.value === "__new__" ? newTemplate() : selectTemplate(e.target.value)
    },
    creating && /* @__PURE__ */ React.createElement("option", { value: "__new__" }, "\u2014 novo tipo \u2014"),
    templates.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.key, value: t.key }, t.name, t.is_builtin ? " (integrado)" : ""))
  )), tpl && /* @__PURE__ */ React.createElement("form", { onSubmit: saveTemplate, style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 1 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement("input", { value: tpl.name || "", onChange: updTpl("name"), placeholder: "Ex.: Boas-vindas" })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 1 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Identificador"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: tpl.key || "",
      onChange: updTpl("key"),
      disabled: !creating,
      placeholder: "ex.: boas_vindas"
    }
  ), creating && /* @__PURE__ */ React.createElement("span", { className: "hint" }, "Sem espa\xE7os; usado internamente."))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Assunto"), /* @__PURE__ */ React.createElement("input", { value: tpl.subject || "", onChange: updTpl("subject") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Template"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 14, fontSize: 13 } }, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", gap: 6, alignItems: "center", cursor: "pointer" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "radio",
      name: "tplkind",
      checked: tpl.kind === "standard",
      onChange: () => setTpl((t) => ({ ...t, kind: "standard" }))
    }
  ), " Padr\xE3o (s\xF3 texto)"), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", gap: 6, alignItems: "center", cursor: "pointer" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "radio",
      name: "tplkind",
      checked: tpl.kind === "custom",
      onChange: () => setTpl((t) => ({ ...t, kind: "custom" }))
    }
  ), " Pr\xF3prio (HTML)"))), isStandard ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "T\xEDtulo"), /* @__PURE__ */ React.createElement("input", { value: tpl.title || "", onChange: updTpl("title"), placeholder: "Define a tua password" })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Texto"), /* @__PURE__ */ React.createElement("textarea", { value: tpl.intro || "", onChange: updTpl("intro"), rows: 6 })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "R\xF3tulo do bot\xE3o (opcional)"), /* @__PURE__ */ React.createElement("input", { value: tpl.button_label || "", onChange: updTpl("button_label"), placeholder: "Definir password" }), /* @__PURE__ */ React.createElement("span", { className: "hint" }, "Se preenchido, o bot\xE3o aponta para ", "{link}", "."))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "HTML do email"), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      value: tpl.body_html || "",
      onChange: updTpl("body_html"),
      rows: 12,
      style: { fontFamily: "var(--font-mono, monospace)", fontSize: 12 }
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "hint" }, "Vari\xE1veis dispon\xEDveis: ", "{nome}", ", ", "{link}", !isStandard && /* @__PURE__ */ React.createElement("span", null, ", ", "{logo}"), "."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn primary sm", disabled: savingTpl }, savingTpl ? "A guardar\u2026" : "Guardar tipo"), !creating && !tpl.is_builtin && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: deleteTemplate }, "Eliminar")))))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { flex: 1, minWidth: 320, position: "sticky", top: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Pr\xE9-visualiza\xE7\xE3o")), /* @__PURE__ */ React.createElement(
    "iframe",
    {
      title: "preview",
      srcDoc: previewHtml,
      style: { width: "100%", height: 560, border: "none", background: "#fff", display: "block" }
    }
  )));
}
window.EmailTemplatesView = EmailTemplatesView;

// ===== administracao/frontend/team.jsx =====
function PasswordModal({ username, onClose, onSubmit }) {
  const [pw, setPw] = useState("");
  const formId = "pw-form";
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: "Mudar password",
      subtitle: username,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: formId, className: "btn primary sm" }, "Mudar password"))
    },
    /* @__PURE__ */ React.createElement("form", { id: formId, onSubmit: (e) => {
      e.preventDefault();
      onSubmit(pw);
    } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nova password"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "password",
        value: pw,
        onChange: (e) => setPw(e.target.value),
        required: true,
        minLength: 4,
        autoFocus: true
      }
    ), /* @__PURE__ */ React.createElement("span", { className: "hint" }, "M\xEDnimo 4 caracteres.")))
  );
}
window.PasswordModal = PasswordModal;
function UserFormModal({ title, initial = {}, withPassword = false, onClose, onSubmit, allTypes = [] }) {
  const [username, setUsername] = useState(initial.username || "");
  const [firstName, setFirstName] = useState(initial.first_name || "");
  const [lastName, setLastName] = useState(initial.last_name || "");
  const [email, setEmail] = useState(initial.email || "");
  const [typeIds, setTypeIds] = useState(new Set(initial.user_type_ids || []));
  const [modo, setModo] = useState("email");
  const [password, setPassword] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const data = {
      first_name: firstName,
      last_name: lastName,
      email,
      user_type_ids: Array.from(typeIds)
    };
    data.username = username;
    if (withPassword && modo === "password") data.password = password;
    onSubmit(data);
  };
  const toggleType = (id) => setTypeIds((s) => {
    const n = new Set(s);
    if (n.has(id)) n.delete(id);
    else n.add(id);
    return n;
  });
  const formId = "user-form";
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      subtitle: withPassword ? "Criar novo utilizador" : "Editar dados pessoais",
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: formId, className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: formId,
        onSubmit: submit,
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Username"), /* @__PURE__ */ React.createElement(
        "input",
        {
          value: username,
          onChange: (e) => setUsername(e.target.value),
          required: true,
          autoFocus: withPassword
        }
      ), !withPassword && username !== (initial.username || "") && /* @__PURE__ */ React.createElement("span", { className: "hint" }, "Passa a entrar com \xAB", username, "\xBB. A password n\xE3o muda, e a pessoa \xE9 avisada no sino. Men\xE7\xF5es antigas (\xAB@", initial.username, "\xBB) ficam com o nome escrito na altura.")),
      withPassword && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Primeira password"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          onClick: () => setModo("email"),
          className: modo === "email" ? "btn primary sm" : "btn ghost sm"
        },
        "Enviar link por email"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          onClick: () => setModo("password"),
          className: modo === "password" ? "btn primary sm" : "btn ghost sm"
        },
        "Definir password agora"
      ))),
      /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Primeiro nome"), /* @__PURE__ */ React.createElement("input", { value: firstName, onChange: (e) => setFirstName(e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "\xDAltimo nome"), /* @__PURE__ */ React.createElement("input", { value: lastName, onChange: (e) => setLastName(e.target.value) }))),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Email", withPassword && modo === "password" ? " (opcional)" : ""), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "email",
          value: email,
          onChange: (e) => setEmail(e.target.value),
          required: withPassword && modo === "email"
        }
      ), withPassword && modo === "email" && /* @__PURE__ */ React.createElement("span", { className: "hint" }, "Ser\xE1 enviado um email com um link para o utilizador definir a password.")),
      withPassword && modo === "password" && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Password"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "password",
          value: password,
          onChange: (e) => setPassword(e.target.value),
          required: true,
          minLength: 4
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "hint" }, "M\xEDnimo 4 caracteres. Comunica-a ao utilizador fora do hub \u2014 ele n\xE3o recebe emails.")),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Tipos / perfis"), allTypes.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: {
        fontSize: 12,
        color: "var(--muted)",
        padding: 8,
        border: "1px dashed var(--border)",
        borderRadius: "var(--radius)"
      } }, 'Sem tipos definidos. Cria-os em "Tipos de utilizador".') : /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        flexWrap: "wrap",
        gap: 6,
        padding: 8,
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)",
        maxHeight: 180,
        overflow: "auto"
      } }, allTypes.map((t) => {
        const on = typeIds.has(t.id);
        return /* @__PURE__ */ React.createElement(
          "button",
          {
            key: t.id,
            type: "button",
            onClick: () => toggleType(t.id),
            title: t.description || "",
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: 5,
              padding: "4px 10px",
              borderRadius: 14,
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              border: "1px solid transparent",
              background: on ? t.cor || "var(--accent)" : "var(--bg)",
              color: on ? "#fff" : "var(--text)",
              borderColor: on ? "transparent" : "var(--border)"
            }
          },
          on ? "\u2713 " : "",
          t.nome
        );
      })), /* @__PURE__ */ React.createElement("span", { className: "hint" }, "As permiss\xF5es (admin, app stock, etc.) s\xE3o derivadas dos tipos atribu\xEDdos."))
    )
  );
}
window.UserFormModal = UserFormModal;
function TeamPanel({ users, reloadUsers, me }) {
  const [showInactive, setShowInactive] = useState(false);
  const [creating, setCreating] = useState(false);
  const [editing, setEditing] = useState(null);
  const [pwUser, setPwUser] = useState(null);
  const [error, setError] = useState(null);
  const [allTypes, setAllTypes] = useState([]);
  useEffect(() => {
    reloadUsers && reloadUsers(showInactive);
  }, [showInactive]);
  useEffect(() => {
    window.API.userTypes().then((r) => setAllTypes(r.results || r)).catch(() => {
    });
  }, []);
  const handleCreate = async (data) => {
    try {
      setError(null);
      await window.API.createUser(data);
      setCreating(false);
      await reloadUsers(showInactive);
    } catch (e) {
      window.srToast("N\xE3o foi poss\xEDvel criar", "error", e.message);
    }
  };
  const handleUpdate = async (id, patch) => {
    try {
      setError(null);
      await window.API.updateUser(id, patch);
      setEditing(null);
      await reloadUsers(showInactive);
    } catch (e) {
      window.srToast("N\xE3o foi poss\xEDvel guardar", "error", e.message);
    }
  };
  const handleDeactivate = async (u) => {
    if (!await window.hubConfirm({ message: `Desativar utilizador "${u.username}"? O hist\xF3rico fica preservado.` })) return;
    try {
      setError(null);
      await window.API.deactivateUser(u.id);
      await reloadUsers(showInactive);
    } catch (e) {
      setError(e.message);
    }
  };
  const handleReactivate = async (u) => {
    try {
      setError(null);
      await window.API.updateUser(u.id, { is_active: true });
      await reloadUsers(showInactive);
    } catch (e) {
      setError(e.message);
    }
  };
  const handleSetPassword = async (id, password) => {
    try {
      setError(null);
      await window.API.setUserPassword(id, password);
      setPwUser(null);
    } catch (e) {
      setError(e.message);
    }
  };
  const handleResendSetPassword = async (u) => {
    if (!u.email) {
      window.srToast("Este utilizador n\xE3o tem email definido.", "warning");
      return;
    }
    try {
      setError(null);
      await window.API.sendSetPassword(u.id);
      window.srToast(`Email de defini\xE7\xE3o de password enviado para ${u.email}.`);
    } catch (e) {
      const m = String(e.message || e);
      const j = m.match(/\{.*\}$/s);
      let msg = m;
      try {
        msg = j ? JSON.parse(j[0]).detail || m : m;
      } catch {
      }
      window.srToast("Falha ao enviar email", "error", msg);
    }
  };
  const toggleStaff = async (u) => {
    if (u.id === me?.id) {
      window.srToast("N\xE3o te podes despromover a ti pr\xF3prio.", "warning");
      return;
    }
    try {
      setError(null);
      await window.API.updateUser(u.id, { is_staff: !u.is_staff });
      await reloadUsers(showInactive);
    } catch (e) {
      setError(e.message);
    }
  };
  const enterAsUser = async (u) => {
    if (!window.HubImpersonation.canImpersonate(me, u)) return;
    try {
      await window.API.impersonate(u.id);
      window.location.reload();
    } catch (e) {
      window.srToast("Falha ao entrar como utilizador", "error", e.message);
    }
  };
  const columns = [
    {
      key: "username",
      label: "Username",
      width: 150,
      minWidth: 120,
      fixed: true,
      mono: true,
      render: (u) => /* @__PURE__ */ React.createElement("strong", null, u.username)
    },
    {
      key: "nome",
      label: "Nome",
      width: 180,
      minWidth: 140,
      render: (u) => `${u.first_name || ""} ${u.last_name || ""}`.trim() || "\u2014"
    },
    {
      key: "email",
      label: "Email",
      width: 220,
      minWidth: 170,
      render: (u) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, u.email || "\u2014")
    },
    {
      key: "tipos",
      label: "Tipos",
      width: 220,
      minWidth: 160,
      render: (u) => (u.user_types || []).length === 0 ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 12 } }, "\u2014") : (u.user_types || []).map((t) => /* @__PURE__ */ React.createElement("span", { key: t.id, title: t.nome, style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "2px 8px",
        borderRadius: 10,
        fontSize: 11,
        fontWeight: 600,
        background: t.cor || "#e5e7eb",
        color: "#fff",
        marginRight: 4,
        marginBottom: 2
      } }, t.nome))
    },
    {
      key: "ativo",
      label: "Ativo",
      width: 75,
      minWidth: 60,
      render: (u) => u.is_active ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2717")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 480,
      minWidth: 380,
      render: (u) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(u) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPwUser(u) }, "Password"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => handleResendSetPassword(u),
          title: "Enviar email para o utilizador definir a password"
        },
        "Enviar email"
      ), u.is_active ? /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleDeactivate(u), disabled: u.id === me?.id }, "Desativar") : /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleReactivate(u) }, "Reativar"), window.HubImpersonation.canImpersonate(me, u) && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => enterAsUser(u),
          title: "Ver o hub como este utilizador"
        },
        "Entrar como"
      ))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Utilizadores"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, '\xB7 acessos por app definidos no menu "Acessos por app"'), /* @__PURE__ */ React.createElement("label", { style: { marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: showInactive, onChange: (e) => setShowInactive(e.target.checked) }), "Mostrar desativados"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Novo")), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "administracao",
      viewId: "utilizadores",
      columns,
      search: {
        fields: ["username", "first_name", "last_name", "email"],
        placeholder: "Pesquisar utilizador\u2026"
      },
      data: users,
      pagination: "client",
      rowKey: (u) => u.id,
      rowStyle: (u) => u.is_active ? void 0 : { opacity: 0.5 },
      empty: "Sem utilizadores."
    }
  ), creating && /* @__PURE__ */ React.createElement(
    UserFormModal,
    {
      title: "Novo utilizador",
      onClose: () => setCreating(false),
      onSubmit: handleCreate,
      withPassword: true,
      allTypes
    }
  ), editing && /* @__PURE__ */ React.createElement(
    UserFormModal,
    {
      title: `Editar ${editing.username}`,
      initial: editing,
      onClose: () => setEditing(null),
      onSubmit: (data) => handleUpdate(editing.id, data),
      allTypes
    }
  ), pwUser && /* @__PURE__ */ React.createElement(
    PasswordModal,
    {
      username: pwUser.username,
      onClose: () => setPwUser(null),
      onSubmit: (pw) => handleSetPassword(pwUser.id, pw)
    }
  ));
}
window.TeamPanel = TeamPanel;

// ===== administracao/frontend/log-console.jsx =====
function AdminLogConsole() {
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [auto, setAuto] = useState(true);
  const [err, setErr] = useState(null);
  const [sel, setSel] = useState(null);
  const bodyRef = useRef(null);
  const lvlColor = {
    ERROR: "#dc2626",
    CRITICAL: "#dc2626",
    WARNING: "#f59e0b",
    INFO: "var(--muted)",
    DEBUG: "var(--muted-2)"
  };
  const load = useCallback(() => {
    window.API.logs().then((r) => {
      setLogs(r.results || []);
      setErr(null);
    }).catch((e) => setErr(e.message));
  }, []);
  useEffect(() => {
    if (!open) return;
    load();
    if (!auto) return;
    const t = setInterval(load, 4e3);
    return () => clearInterval(t);
  }, [open, auto, load]);
  useEffect(() => {
    if (open && bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [logs, open]);
  const clear = async () => {
    try {
      await window.API.clearLogs();
      setLogs([]);
    } catch (e) {
      setErr(e.message);
    }
  };
  const fmtT = (t) => new Date(t * 1e3).toLocaleTimeString("pt-PT");
  const copySel = () => {
    if (!sel) return;
    const txt = `${fmtT(sel.time)} ${sel.level}
${sel.message}`;
    try {
      navigator.clipboard.writeText(txt);
      window.srToast("Copiado.", "success");
    } catch {
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "sr-logconsole" }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "var(--panel-2)",
    borderTop: "1px solid var(--border)",
    padding: "6px 12px",
    fontSize: 12
  } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setOpen((o) => !o) }, open ? "\u25BE" : "\u25B4", " Logs do servidor"), open && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: load }, "Atualizar"), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: auto, onChange: (e) => setAuto(e.target.checked) }), " auto"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: clear }, "Limpar"), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, logs.length, " linhas"), err && /* @__PURE__ */ React.createElement("span", { style: { color: "#dc2626" } }, err))), open && /* @__PURE__ */ React.createElement("div", { ref: bodyRef, style: {
    height: 260,
    overflow: "auto",
    background: "var(--bg)",
    borderTop: "1px solid var(--border)",
    padding: "8px 12px",
    fontFamily: "var(--font-mono, monospace)",
    fontSize: 11.5,
    lineHeight: 1.5
  } }, logs.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "Sem registos."), logs.map((l, i) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: i,
      onClick: () => setSel(l),
      title: "Clica para ver tudo",
      style: {
        display: "flex",
        gap: 6,
        cursor: "pointer",
        whiteSpace: "nowrap",
        overflow: "hidden",
        borderBottom: "1px solid var(--border)",
        padding: "2px 0"
      }
    },
    /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted-2)", flexShrink: 0 } }, fmtT(l.time)),
    /* @__PURE__ */ React.createElement("span", { style: { color: lvlColor[l.level] || "var(--muted)", fontWeight: 700, flexShrink: 0 } }, l.level),
    /* @__PURE__ */ React.createElement("span", { style: { overflow: "hidden", textOverflow: "ellipsis" } }, (l.message || "").split("\n")[0])
  ))), sel && /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: "Registo do servidor",
      subtitle: `${fmtT(sel.time)} \xB7 ${sel.level}`,
      onClose: () => setSel(null),
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setSel(null) }, "Fechar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: copySel }, "Copiar"))
    },
    /* @__PURE__ */ React.createElement("pre", { style: {
      margin: 0,
      maxHeight: "55vh",
      overflow: "auto",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      userSelect: "text",
      fontFamily: "var(--font-mono, monospace)",
      fontSize: 12,
      lineHeight: 1.5
    } }, sel.message)
  ));
}
window.AdminLogConsole = AdminLogConsole;

// ===== administracao/frontend/auditoria.jsx =====
(function() {
  function viaAdminLabel(row) {
    return row && row.impersonator_name ? `via ${row.impersonator_name}` : null;
  }
  window.viaAdminLabel = viaAdminLabel;
  function fetchAudit(params) {
    const p = new URLSearchParams(params);
    return fetch(`/api/administracao/audit/?${p}`, {
      credentials: "same-origin"
    }).then((r) => r.json()).then((body) => body.results || []).catch(() => []);
  }
  const ellipsis = { display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
  function EventsTab() {
    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [filters, setFilters] = React.useState({
      actor: "",
      app: "",
      verb: "",
      resource: "",
      resource_id: "",
      from: "",
      to: ""
    });
    React.useEffect(() => {
      const active = {};
      for (const [k, v] of Object.entries(filters)) if (v) active[k] = v;
      setLoading(true);
      fetchAudit(active).then((data) => {
        setRows(data);
        setLoading(false);
      });
    }, [JSON.stringify(filters)]);
    function setFilter(key, val) {
      setFilters((f) => ({ ...f, [key]: val }));
    }
    const columns = [
      {
        key: "when",
        label: "Quando",
        width: 170,
        minWidth: 90,
        fixed: true,
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-tight" }, new Date(r.when).toLocaleString("pt-PT"))
      },
      {
        key: "actor_name",
        label: "Actor",
        width: 120,
        minWidth: 70,
        render: (r) => /* @__PURE__ */ React.createElement(React.Fragment, null, r.actor_name || "\u2014", viaAdminLabel(r) && /* @__PURE__ */ React.createElement("span", { className: "badge-via-admin", title: "A\xE7\xE3o feita por um admin em impersona\xE7\xE3o" }, " ", viaAdminLabel(r)))
      },
      { key: "app_label", label: "App", width: 120, minWidth: 60 },
      {
        key: "verb",
        label: "Verb",
        width: 130,
        minWidth: 65,
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "badge" }, r.verb)
      },
      {
        key: "resource",
        label: "Resource",
        width: 130,
        minWidth: 90,
        render: (r) => `${r.resource}${r.resource_id ? ` #${r.resource_id}` : ""}`
      },
      {
        key: "summary",
        label: "Sum\xE1rio",
        width: 400,
        minWidth: 220,
        render: (r) => /* @__PURE__ */ React.createElement("span", { style: ellipsis, title: r.summary }, r.summary)
      }
    ];
    return /* @__PURE__ */ React.createElement("div", { className: "events-tab", style: { display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "audit-filters", style: { display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        placeholder: "Actor id",
        value: filters.actor,
        onChange: (e) => setFilter("actor", e.target.value),
        style: { flex: "1 1 100px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        placeholder: "App",
        value: filters.app,
        onChange: (e) => setFilter("app", e.target.value),
        style: { flex: "1 1 80px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        placeholder: "Verb",
        value: filters.verb,
        onChange: (e) => setFilter("verb", e.target.value),
        style: { flex: "1 1 80px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        placeholder: "Resource",
        value: filters.resource,
        onChange: (e) => setFilter("resource", e.target.value),
        style: { flex: "1 1 100px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        placeholder: "Resource id",
        value: filters.resource_id,
        onChange: (e) => setFilter("resource_id", e.target.value),
        style: { flex: "1 1 80px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: filters.from,
        onChange: (e) => setFilter("from", e.target.value),
        style: { flex: "1 1 120px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: filters.to,
        onChange: (e) => setFilter("to", e.target.value),
        style: { flex: "1 1 120px" }
      }
    )), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        loading,
        appLabel: "administracao",
        viewId: "auditoria-eventos",
        columns,
        data: rows,
        pagination: "client",
        initialSort: [{ key: "when", dir: "desc" }],
        rowKey: (r) => r.id,
        empty: "Sem eventos."
      }
    ));
  }
  function DenialsTab() {
    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [denialReasons, setDenialReasons] = React.useState([]);
    const [filters, setFilters] = React.useState({
      actor: "",
      app: "",
      reason: "",
      from: "",
      to: ""
    });
    React.useEffect(() => {
      window.API.accessVocab().then((v) => setDenialReasons(v.denial_reasons || [])).catch(() => {
      });
    }, []);
    React.useEffect(() => {
      const active = { type: "denials" };
      for (const [k, v] of Object.entries(filters)) if (v) active[k] = v;
      setLoading(true);
      fetchAudit(active).then((data) => {
        setRows(data);
        setLoading(false);
      });
    }, [JSON.stringify(filters)]);
    function setFilter(key, val) {
      setFilters((f) => ({ ...f, [key]: val }));
    }
    const columns = [
      {
        key: "when",
        label: "Quando",
        width: 170,
        minWidth: 90,
        fixed: true,
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-tight" }, new Date(r.when).toLocaleString("pt-PT"))
      },
      {
        key: "actor_name",
        label: "Actor",
        width: 120,
        minWidth: 70,
        render: (r) => r.actor_name || "\u2014"
      },
      { key: "app_label", label: "App", width: 120, minWidth: 60 },
      { key: "required_action", label: "Action", width: 120, minWidth: 75 },
      {
        key: "path",
        label: "Path",
        width: 280,
        minWidth: 160,
        mono: true,
        render: (r) => /* @__PURE__ */ React.createElement("span", { style: ellipsis, title: r.path }, r.path)
      },
      {
        key: "reason",
        label: "Reason",
        width: 140,
        minWidth: 80,
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "badge reason" }, r.reason)
      },
      { key: "ip", label: "IP", width: 120, minWidth: 50, mono: true }
    ];
    return /* @__PURE__ */ React.createElement("div", { className: "denials-tab", style: { display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "audit-filters", style: { display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        placeholder: "Actor id",
        value: filters.actor,
        onChange: (e) => setFilter("actor", e.target.value),
        style: { flex: "1 1 100px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        placeholder: "App",
        value: filters.app,
        onChange: (e) => setFilter("app", e.target.value),
        style: { flex: "1 1 80px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "select",
      {
        value: filters.reason,
        onChange: (e) => setFilter("reason", e.target.value),
        style: { flex: "1 1 160px" }
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "Todas as raz\xF5es"),
      denialReasons.map((r) => /* @__PURE__ */ React.createElement("option", { key: r, value: r }, r))
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: filters.from,
        onChange: (e) => setFilter("from", e.target.value),
        style: { flex: "1 1 120px" }
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: filters.to,
        onChange: (e) => setFilter("to", e.target.value),
        style: { flex: "1 1 120px" }
      }
    )), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        loading,
        appLabel: "administracao",
        viewId: "auditoria-denials",
        columns,
        data: rows,
        pagination: "client",
        initialSort: [{ key: "when", dir: "desc" }],
        rowKey: (r) => r.id,
        empty: "Sem denials."
      }
    ));
  }
  const AUDIT_ABAS = ["events", "denials"];
  const auditAbaDoURL = () => {
    const v = window.HubRouter.current().params.get("aba");
    return AUDIT_ABAS.includes(v) ? v : "events";
  };
  function AuditoriaView() {
    const [tab, setTab] = React.useState(auditAbaDoURL);
    React.useEffect(() => window.HubRouter.subscribe(() => setTab(auditAbaDoURL())), []);
    const irPara = (nova) => {
      setTab(nova);
      window.HubRouter.setParams({ aba: nova === "events" ? null : nova });
    };
    return /* @__PURE__ */ React.createElement("div", { className: "auditoria", style: { padding: 16, display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: "0 0 16px", fontSize: 18, fontWeight: 600 } }, "Auditoria"), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "tabs",
        style: {
          display: "flex",
          gap: 16,
          borderBottom: "1px solid var(--border)",
          marginBottom: 16,
          flexShrink: 0
        }
      },
      /* @__PURE__ */ React.createElement(
        "button",
        {
          className: tab === "events" ? "tab-btn active" : "tab-btn",
          onClick: () => irPara("events"),
          style: {
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "8px 4px",
            fontWeight: tab === "events" ? 600 : 400,
            borderBottom: tab === "events" ? "2px solid var(--accent)" : "2px solid transparent",
            marginBottom: -1
          }
        },
        "Business events"
      ),
      /* @__PURE__ */ React.createElement(
        "button",
        {
          className: tab === "denials" ? "tab-btn active" : "tab-btn",
          onClick: () => irPara("denials"),
          style: {
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "8px 4px",
            fontWeight: tab === "denials" ? 600 : 400,
            borderBottom: tab === "denials" ? "2px solid var(--accent)" : "2px solid transparent",
            marginBottom: -1
          }
        },
        "Denials"
      )
    ), tab === "events" ? /* @__PURE__ */ React.createElement(EventsTab, null) : /* @__PURE__ */ React.createElement(DenialsTab, null));
  }
  window.AuditoriaView = AuditoriaView;
})();

// ===== administracao/frontend/impersonacao.jsx =====
(function() {
  function ImpersonacaoView({ me }) {
    const [history, setHistory] = React.useState([]);
    React.useEffect(() => {
      let alive = true;
      fetch(
        "/api/administracao/audit/?verb=impersonation_started&page_size=20",
        { credentials: "same-origin" }
      ).then((r) => r.json()).then((d) => {
        if (alive) setHistory(d.results || d || []);
      }).catch(() => {
        if (alive) setHistory([]);
      });
      return () => {
        alive = false;
      };
    }, []);
    const enter = async (u) => {
      if (!window.HubImpersonation.canImpersonate(me, u)) return;
      try {
        await window.API.impersonate(u.id);
        window.location.reload();
      } catch (e) {
        window.srToast("Falha ao entrar como utilizador", "error", e.message);
      }
    };
    const candidateColumns = [
      { key: "name", label: "Nome", width: 240, fixed: true, render: (u) => /* @__PURE__ */ React.createElement("span", null, u.name, " ", /* @__PURE__ */ React.createElement("span", { className: "muted" }, "@", u.username)) },
      { key: "email", label: "Email", width: 260, render: (u) => u.email || "\u2014" },
      { key: "_action", label: "A\xE7\xF5es", sortable: false, width: 140, render: (u) => /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => enter(u) }, "Entrar como") }
    ];
    const historyColumns = [
      { key: "when", label: "Quando", width: 180, fixed: true, render: (h) => h.when ? new Date(h.when).toLocaleString("pt-PT") : "\u2014" },
      { key: "summary", label: "Evento", width: 360, render: (h) => h.summary || "\u2014" }
    ];
    return /* @__PURE__ */ React.createElement("div", { className: "impersonacao", style: { display: "flex", flexDirection: "column", gap: 16, flex: "1 1 auto", minHeight: 0, padding: 16 } }, /* @__PURE__ */ React.createElement("header", null, /* @__PURE__ */ React.createElement("h2", { style: { margin: "0 0 4px", fontSize: 18, fontWeight: 600 } }, "Impersona\xE7\xE3o"), /* @__PURE__ */ React.createElement("p", { className: "muted", style: { margin: 0 } }, "Entra como um utilizador n\xE3o-admin para ver o hub tal como ele. Todas as a\xE7\xF5es ficam auditadas com o teu nome.")), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        title: "Utilizadores",
        columns: candidateColumns,
        search: { placeholder: "Procurar utilizador\u2026" },
        fetch: ({ search }) => window.API.impersonateCandidates(search).then((r) => ({ rows: r.results || [], total: (r.results || []).length })),
        pagination: "none",
        rowKey: (u) => u.id,
        empty: "Sem utilizadores.",
        appLabel: "administracao",
        viewId: "impersonacao"
      }
    ), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        title: "Impersona\xE7\xF5es recentes",
        columns: historyColumns,
        data: history,
        pagination: "none",
        rowKey: (h) => h.id,
        empty: "Sem impersona\xE7\xF5es recentes.",
        appLabel: "administracao",
        viewId: "impersonacao-recentes"
      }
    ));
  }
  window.ImpersonacaoView = ImpersonacaoView;
})();

// ===== administracao/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "administracao",
  order: 999,
  name: "Administra\xE7\xE3o",
  sub: "Manual e utilit\xE1rios do hub",
  accent: "#4b5563",
  launcher: false,
  frontendFiles: [
    "frontend/administracao_manual.jsx",
    "frontend/user-config-guide.jsx",
    "frontend/user-types.jsx",
    "frontend/access-matrix.jsx",
    "frontend/feature-config.jsx",
    "frontend/anexos-settings.jsx",
    "frontend/access-rule-editor.jsx",
    "frontend/access-teams.jsx",
    "frontend/general.jsx",
    "frontend/email.jsx",
    "frontend/email-templates.jsx",
    "frontend/team.jsx",
    "frontend/log-console.jsx",
    "frontend/auditoria.jsx",
    "frontend/impersonacao.jsx"
  ],
  routes: []
});

// ===== aquinos_extrator/frontend/styles.jsx =====
const AQE_CSS = `
.aqe-root { display:grid; grid-template-columns: 280px 1fr; height:100%; gap:1px; background:var(--border); }
.aqe-side { background:var(--panel); display:flex; flex-direction:column; min-height:0; }
.aqe-main { background:var(--panel); display:flex; flex-direction:column; min-height:0; overflow:auto; padding-bottom:48px; }
.aqe-toolbar { display:flex; gap:8px; align-items:center; padding:12px 16px; border-bottom:1px solid var(--border); }
.aqe-btn { padding:0 12px; border-radius:var(--radius); border:1px solid var(--border); background:var(--panel-2); color:var(--text); cursor:pointer; font:inherit; box-sizing:border-box; height:32px; line-height:1; display:inline-flex; align-items:center; justify-content:center; gap:6px; white-space:nowrap; flex:0 0 auto; }
.aqe-btn--icon { width:32px; padding:0; }
.aqe-btn--icon svg { display:block; }
.aqe-btn--primary { background:var(--accent); color:#fff; border-color:var(--accent); }
.aqe-btn:disabled { opacity:.5; cursor:not-allowed; }
.aqe-dropzone { border:2px dashed var(--border-strong); border-radius:var(--radius-lg); padding:24px; text-align:center; margin:12px; cursor:pointer; color:var(--muted); }
.aqe-dropzone.over { background:var(--row-hover); }
.aqe-filelist { flex:1; overflow:auto; padding:0 12px 48px; }
.aqe-fileitem { display:flex; gap:8px; align-items:center; padding:8px; border-radius:var(--radius); margin-bottom:4px; background:var(--panel-2); }
.aqe-fileitem--ok   { border-left:3px solid #22c55e; }
.aqe-fileitem--warn { border-left:3px solid #fb923c; }
.aqe-fileitem--err  { border-left:3px solid #ef4444; }
.aqe-empty { padding:48px; text-align:center; color:var(--muted); }
.aqe-status-dot { display:inline-block; width:8px; height:8px; border-radius:50%; }
.aqe-status-dot--ok   { background:#22c55e; }
.aqe-status-dot--warn { background:#fb923c; }
.aqe-status-dot--err  { background:#ef4444; }
.aqe-overlay { position:fixed; inset:0; background:rgba(0,0,0,.5); z-index:1000; display:flex; flex-direction:column; }
.aqe-overlay__bar { background:var(--panel); border-bottom:1px solid var(--border); padding:8px 12px; display:flex; align-items:center; }
.aqe-overlay__body { flex:1; display:grid; grid-template-columns: 1fr 360px; gap:1px; background:var(--border); overflow:hidden; }
.aqe-overlay__pdf { background:var(--bg-2); overflow:auto; display:flex; justify-content:center; align-items:flex-start; padding:16px; }
.aqe-overlay__pdf > canvas { flex:0 0 auto; display:block; align-self:flex-start; }
.aqe-overlay__form { background:var(--panel); padding:16px; overflow:auto; display:flex; flex-direction:column; gap:10px; }
.aqe-overlay__form label { display:flex; flex-direction:column; gap:4px; font-size:13px; color:var(--muted); }
.aqe-overlay__form input { padding:6px 8px; border:1px solid var(--border); border-radius:var(--radius); background:var(--panel-2); color:var(--text); font:inherit; }
.aqe-overlay__form label.aqe-required input { border-color:#ef4444; }
.aqe-overlay--preview .aqe-overlay__body { grid-template-columns: 1fr; }
.aqe-set-root { padding:24px; max-width:880px; margin:0 auto; }
.aqe-set-section { border:1px solid var(--border); border-radius:var(--radius-lg); padding:16px; margin-bottom:16px; }
.aqe-set-section legend { padding:0 8px; font-weight:600; color:var(--text); }
.aqe-set-row { display:grid; grid-template-columns: 240px 1fr; gap:12px; align-items:center; margin-bottom:8px; }
.aqe-set-row label { display:flex; flex-direction:column; }
.aqe-set-row label small { color:var(--muted); font-size:11px; margin-top:2px; }
.aqe-set-row input, .aqe-set-row select, .aqe-set-row textarea {
  padding:6px 8px; border:1px solid var(--border); border-radius:var(--radius);
  background:var(--panel-2); color:var(--text); font:inherit; width:100%; box-sizing:border-box;
}
.aqe-set-footer { display:flex; align-items:center; padding:8px 0; }
.aqe-usage-root { padding:24px; display:flex; flex-direction:column; gap:16px; }
.aqe-usage-toolbar { display:flex; align-items:center; gap:8px; flex-wrap:wrap;
                     padding:12px; background:var(--panel-2); border-radius:var(--radius); }
.aqe-usage-toolbar label { font-size:12px; color:var(--muted); }
.aqe-kpi-grid { display:grid; grid-template-columns: repeat(6, 1fr); gap:12px; }
.aqe-kpi { background:var(--panel); border:1px solid var(--border); border-radius:var(--radius);
           padding:12px 16px; text-align:center; }
.aqe-kpi-v { font-size:22px; font-weight:600; color:var(--text); }
.aqe-kpi-l { font-size:11px; color:var(--muted); margin-top:4px; text-transform:uppercase; }
.aqe-usage-chart { background:var(--panel); border:1px solid var(--border);
                   border-radius:var(--radius); padding:12px; }
.aqe-usage-chart-head { display:flex; justify-content:flex-end; margin-bottom:8px; }
.aqe-usage-breakdown { background:var(--panel); border:1px solid var(--border);
                       border-radius:var(--radius); }
.aqe-usage-breakdown-head { display:flex; justify-content:space-between; align-items:center;
                            padding:12px 16px; border-bottom:1px solid var(--border); }
@media (max-width: 1200px) { .aqe-kpi-grid { grid-template-columns: repeat(3, 1fr); } }

/* Bottom log drawer (per-session, ephemeral). Toggle stays visible
   collapsed; expanded reveals a scrollable list. Fixed at viewport
   bottom but offset by the hub sidebar width \u2014 mirrors the existing
   .sr-logconsole pattern in design/src/styles.css. */
.aqe-log { position:fixed; left:220px; right:0; bottom:0; z-index:900;
           background:var(--panel); border-top:1px solid var(--border);
           box-shadow:var(--shadow-md); display:flex; flex-direction:column; }
.app[data-sidebar="collapsed"] .aqe-log { left:56px; }
@media (max-width: 900px) { .aqe-log { left:0; } }
.aqe-log--open { height:260px; }
.aqe-log-toggle { display:flex; align-items:center; gap:12px; padding:6px 16px;
                  background:var(--panel-2); border:none; border-top:1px solid var(--border);
                  cursor:pointer; font:inherit; color:var(--text); width:100%; text-align:left; }
.aqe-log-badge { background:#fb923c; color:#fff; border-radius:10px; padding:0 8px;
                 font-size:11px; font-weight:600; }
.aqe-log-body { flex:1; display:flex; flex-direction:column; min-height:0; }
.aqe-log-head { display:flex; justify-content:space-between; align-items:center;
                padding:6px 16px; border-bottom:1px solid var(--border); font-size:12px; color:var(--muted); }
.aqe-log-list { flex:1; overflow:auto; font-family:var(--font-mono); font-size:var(--fs-mono); }
.aqe-log-row { display:grid; grid-template-columns:90px 24px 1fr; gap:8px;
               padding:4px 16px; border-bottom:1px solid var(--border); }
.aqe-log-row:hover { background:var(--row-hover); }
.aqe-log-ts   { color:var(--muted); }
.aqe-log-icon { text-align:center; }
.aqe-log-row--ok   .aqe-log-icon { color:#22c55e; }
.aqe-log-row--warn .aqe-log-icon { color:#fb923c; }
.aqe-log-row--err  .aqe-log-icon { color:#ef4444; }
.aqe-log-row--err  .aqe-log-text { color:#ef4444; }

.aqe-picker { display:flex; align-items:center; gap:8px; }
.aqe-picker__label { color:var(--muted); font-size:13px; }
.aqe-picker__select { padding:0 8px; height:32px; box-sizing:border-box; border:1px solid var(--border);
                      border-radius:var(--radius); background:var(--panel-2); color:var(--text);
                      font:inherit; min-width:240px; }
.aqe-gerir-body { flex:1; overflow:auto; padding:16px; background:var(--panel); }
.aqe-gerir-body .aqe-btn { margin-right:4px; }

.aqe-modal__backdrop { position:fixed; inset:0; background:rgba(0,0,0,.45); z-index:1100;
                       display:flex; align-items:center; justify-content:center; }
.aqe-modal { background:var(--panel); border:1px solid var(--border); border-radius:var(--radius-lg);
             box-shadow:var(--shadow-md); padding:20px; min-width:360px; max-width:480px;
             display:flex; flex-direction:column; gap:12px; }
.aqe-modal__title { font-weight:600; color:var(--text); font-size:15px; }
.aqe-modal__input { padding:8px 10px; border:1px solid var(--border); border-radius:var(--radius);
                    background:var(--panel-2); color:var(--text); font:inherit; }
.aqe-modal__input:focus { outline:none; border-color:var(--accent); }
.aqe-modal__body { font-size:13px; color:var(--text); line-height:1.5; }
.aqe-modal__actions { display:flex; justify-content:flex-end; gap:8px; }
.aqe-btn--danger { background:#ef4444; color:#fff; border-color:#ef4444; }
.aqe-btn--danger:hover { background:#dc2626; border-color:#dc2626; }

.aqe-spinner { display:inline-block; width:14px; height:14px; vertical-align:middle;
               border:2px solid var(--border); border-top-color:var(--accent);
               border-radius:50%; animation:aqe-spin .8s linear infinite; }
@keyframes aqe-spin { to { transform:rotate(360deg); } }
.aqe-fileitem--processing { border-left:3px solid var(--accent); background:var(--row-hover); }
.aqe-row--missing td { background:rgba(251,146,60,.08); }
.aqe-row--missing td:first-child { border-left:3px solid #fb923c; }
.aqe-row--clickable { cursor:pointer; }
.aqe-row--clickable:hover td { background:var(--row-hover); }
.aqe-row--clickable.aqe-row--missing:hover td { background:rgba(251,146,60,.16); }
`;
(function injectAqeStyles() {
  const id = "aqe-styles";
  if (document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = AQE_CSS;
  document.head.appendChild(style);
})();

// ===== aquinos_extrator/frontend/aqe-api.jsx =====
function _getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}
async function _send(path, init) {
  const res = await fetch(path, { credentials: "include", ...init });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${init.method || "GET"} ${path} \u2192 ${res.status}: ${body}`);
  }
  if (res.status === 204) return null;
  return res.json();
}
window.AqeAPI = {
  get: (path) => _send(path, { method: "GET", headers: {} }),
  put: (path, body) => {
    const csrf = _getCookie("csrftoken");
    return _send(path, {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...csrf ? { "X-CSRFToken": csrf } : {} },
      body: JSON.stringify(body)
    });
  },
  post: (path, body) => {
    const csrf = _getCookie("csrftoken");
    return _send(path, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...csrf ? { "X-CSRFToken": csrf } : {} },
      body: JSON.stringify(body)
    });
  },
  upload: (path, formData) => {
    const csrf = _getCookie("csrftoken");
    return _send(path, {
      method: "POST",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
      body: formData
    });
  }
};

// ===== aquinos_extrator/frontend/aqe-echart.jsx =====
function AqeEChart({ option, height = 300 }) {
  const elRef = React.useRef(null);
  const instRef = React.useRef(null);
  React.useEffect(() => {
    if (!elRef.current || !window.echarts) return;
    instRef.current = window.echarts.init(elRef.current);
    const onResize = () => instRef.current && instRef.current.resize();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      if (instRef.current) {
        instRef.current.dispose();
        instRef.current = null;
      }
    };
  }, []);
  React.useEffect(() => {
    if (instRef.current && option) instRef.current.setOption(option, true);
  }, [option]);
  return React.createElement("div", {
    ref: elRef,
    style: { width: "100%", height: `${height}px` }
  });
}
window.AqeEChart = AqeEChart;

// ===== aquinos_extrator/frontend/vendor.jsx =====
const PDFJS_URL = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
const PDFJS_WORK = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
const XLSX_URL = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
const _cache = {};
function _load(key, url, globalName, onReady) {
  if (_cache[key]) return _cache[key];
  _cache[key] = new Promise((resolve, reject) => {
    const tag = document.createElement("script");
    tag.src = url;
    tag.setAttribute("data-aquinos-vendor", key);
    tag.onload = () => {
      if (onReady) onReady(window[globalName]);
      resolve(window[globalName]);
    };
    tag.onerror = () => reject(new Error("failed to load " + url));
    document.head.appendChild(tag);
  });
  return _cache[key];
}
window.AquinosVendor = {
  loadPdfjs: () => _load(
    "pdfjs",
    PDFJS_URL,
    "pdfjsLib",
    (lib) => {
      lib.GlobalWorkerOptions.workerSrc = PDFJS_WORK;
    }
  ),
  loadXlsx: () => _load("xlsx", XLSX_URL, "XLSX")
};

// ===== aquinos_extrator/frontend/review.jsx =====
function AquinosReviewOverlay({
  result,
  sessionId,
  config,
  onClose,
  onSaved,
  onPrev,
  onNext,
  previewOnly
}) {
  const canvasRef = React.useRef(null);
  const pageRef = React.useRef(null);
  const pdfScrollRef = React.useRef(null);
  const [fields, setFields] = React.useState({ ...result?.fields || {} });
  const [zoom, setZoom] = React.useState(1);
  const [fitZoom, setFitZoom] = React.useState(1);
  const [saving, setSaving] = React.useState(false);
  const [pdfError, setPdfError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose?.();
        return;
      }
      if (!e.altKey) return;
      const k = e.key.toLowerCase();
      if (k === "n") {
        e.preventDefault();
        onNext?.();
      } else if (k === "p") {
        e.preventDefault();
        onPrev?.();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onNext, onPrev]);
  React.useEffect(() => {
    setFields({ ...result?.fields || {} });
    pageRef.current = null;
  }, [result?.filename]);
  React.useEffect(() => {
    if (!result || !sessionId) return;
    setPdfError(null);
    setLoading(true);
    let cancelled = false;
    (async () => {
      const url = `/api/aquinos-extrator/sessions/${sessionId}/files/${encodeURIComponent(result.filename)}/`;
      try {
        const resp = await fetch(url, { credentials: "include" });
        if (cancelled) return;
        if (!resp.ok) {
          setPdfError(`N\xE3o foi poss\xEDvel carregar o PDF (HTTP ${resp.status}).`);
          setLoading(false);
          return;
        }
        const ab = await resp.arrayBuffer();
        if (cancelled) return;
        const lib = await window.AquinosVendor.loadPdfjs();
        const pdf = await lib.getDocument({ data: ab }).promise;
        const page = await pdf.getPage(1);
        if (cancelled) return;
        pageRef.current = page;
        const el = pdfScrollRef.current;
        if (el) {
          const cs = window.getComputedStyle(el);
          const padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
          const padY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
          const W = Math.max(0, el.clientWidth - padX);
          const H = Math.max(0, el.clientHeight - padY);
          if (W > 0 && H > 0) {
            const baseVp = page.getViewport({ scale: 1 });
            const fitScale = Math.min(W / baseVp.width, H / baseVp.height);
            const fit = Math.max(
              config?.zoom_min ?? 0.25,
              Math.min(config?.zoom_max ?? 4, fitScale / 1.5)
            );
            setFitZoom(fit);
            setZoom(fit);
          }
        }
        setLoading(false);
      } catch (e) {
        if (!cancelled) {
          setPdfError(`Erro a carregar o PDF: ${e.message || e}`);
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [result?.filename, sessionId]);
  React.useEffect(() => {
    if (loading || pdfError || !pageRef.current) return;
    const page = pageRef.current;
    const vp = page.getViewport({ scale: zoom * 1.5 });
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.width = vp.width;
    canvas.height = vp.height;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, vp.width, vp.height);
    const task = page.render({ canvasContext: ctx, viewport: vp });
    let cancelled = false;
    task.promise.catch((e) => {
      if (cancelled) return;
      if (e?.name === "RenderingCancelledException") return;
      setPdfError(`Erro a renderizar o PDF: ${e.message || e}`);
    });
    return () => {
      cancelled = true;
      try {
        task.cancel();
      } catch (_) {
      }
    };
  }, [zoom, loading, pdfError]);
  React.useEffect(() => {
    const el = pdfScrollRef.current;
    if (!el || loading || pdfError) return;
    let down = false;
    let startX = 0, startY = 0, startScrollLeft = 0, startScrollTop = 0;
    const onDown = (e) => {
      if (e.button !== 0) return;
      down = true;
      startX = e.clientX;
      startY = e.clientY;
      startScrollLeft = el.scrollLeft;
      startScrollTop = el.scrollTop;
      el.style.cursor = "grabbing";
      e.preventDefault();
    };
    const onMove = (e) => {
      if (!down) return;
      el.scrollLeft = startScrollLeft - (e.clientX - startX);
      el.scrollTop = startScrollTop - (e.clientY - startY);
    };
    const onUp = () => {
      if (!down) return;
      down = false;
      el.style.cursor = "";
    };
    el.addEventListener("mousedown", onDown);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    return () => {
      el.removeEventListener("mousedown", onDown);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
  }, [loading, pdfError]);
  const save = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await window.AqeAPI.post("/api/aquinos-extrator/extract/", {
        session: sessionId,
        filename: result.filename,
        edited: 1,
        fields
      });
      onSaved({ ...result, fields, status: "ok", manually_edited: true });
    } finally {
      setSaving(false);
    }
  };
  const zMin = config?.zoom_min ?? 0.25;
  const zMax = config?.zoom_max ?? 4;
  const zStep = config?.zoom_step ?? 0.25;
  const clampZoom = (z) => Math.max(zMin, Math.min(zMax, z));
  React.useEffect(() => {
    const el = pdfScrollRef.current;
    if (!el) return;
    const handler = (e) => {
      if (loading || pdfError) return;
      e.preventDefault();
      const delta = e.deltaY < 0 ? zStep : -zStep;
      const offsetX = e.offsetX, offsetY = e.offsetY;
      setZoom((z) => {
        const next = clampZoom(z + delta);
        if (next === z) return z;
        const sc = pdfScrollRef.current;
        if (sc) {
          const ratio = next / z;
          const cx = sc.scrollLeft + offsetX;
          const cy = sc.scrollTop + offsetY;
          requestAnimationFrame(() => {
            sc.scrollLeft = cx * ratio - offsetX;
            sc.scrollTop = cy * ratio - offsetY;
          });
        }
        return next;
      });
    };
    el.addEventListener("wheel", handler, { passive: false });
    return () => el.removeEventListener("wheel", handler);
  }, [loading, pdfError, zMin, zMax, zStep]);
  if (!result) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-overlay" + (previewOnly ? " aqe-overlay--preview" : "") }, /* @__PURE__ */ React.createElement("div", { className: "aqe-overlay__bar" }, /* @__PURE__ */ React.createElement("button", { className: "aqe-btn aqe-btn--icon", onClick: onPrev, title: "Anterior (Alt+P)" }, "\u2039"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn aqe-btn--icon", onClick: onNext, title: "Pr\xF3ximo (Alt+N)" }, "\u203A"), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 12, fontWeight: 600 } }, result.filename), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("button", { className: "aqe-btn aqe-btn--icon", onClick: () => setZoom((z) => clampZoom(z - zStep)) }, "\u2212"), /* @__PURE__ */ React.createElement("span", { style: { minWidth: 48, textAlign: "center" } }, Math.round(zoom * 100), "%"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn aqe-btn--icon", onClick: () => setZoom((z) => clampZoom(z + zStep)) }, "+"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", style: { marginLeft: 4 }, onClick: () => setZoom(fitZoom) }, "\u22A1 Fit")), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn aqe-btn--icon", onClick: onClose, style: { marginLeft: 12 } }, "\u2715")), /* @__PURE__ */ React.createElement("div", { className: "aqe-overlay__body" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "aqe-overlay__pdf",
      ref: pdfScrollRef,
      onDoubleClick: () => {
        if (loading || pdfError) return;
        const url = `/api/aquinos-extrator/sessions/${sessionId}/files/${encodeURIComponent(result.filename)}/`;
        window.open(url, "_blank", "noopener,noreferrer");
      },
      title: "Arrasta para mover \xB7 Wheel/+/\u2212 para zoom \xB7 Duplo-clique abre em separador novo",
      style: { cursor: loading || pdfError ? "default" : "grab" }
    },
    pdfError ? /* @__PURE__ */ React.createElement("div", { className: "aqe-empty", style: { color: "#ef4444", maxWidth: 480 } }, pdfError) : loading ? /* @__PURE__ */ React.createElement("div", { className: "aqe-empty" }, /* @__PURE__ */ React.createElement("span", { className: "aqe-spinner" }), " A carregar PDF\u2026") : /* @__PURE__ */ React.createElement("canvas", { ref: canvasRef, key: zoom })
  ), !previewOnly && /* @__PURE__ */ React.createElement("div", { className: "aqe-overlay__form" }, config.export_columns.map(([k, label]) => /* @__PURE__ */ React.createElement("label", { key: k, className: config.required_fields.includes(k) && !fields[k] ? "aqe-required" : "" }, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      id: `aqe-field-${k}`,
      name: k,
      autoComplete: "off",
      value: fields[k] ?? "",
      onChange: (e) => setFields({ ...fields, [k]: e.target.value })
    }
  ))), /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement("span", null, "Observa\xE7\xF5es"), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      id: "aqe-field-observacoes",
      name: "observacoes",
      rows: 4,
      autoComplete: "off",
      value: fields.observacoes ?? "",
      onChange: (e) => setFields({ ...fields, observacoes: e.target.value }),
      style: {
        resize: "vertical",
        minHeight: 60,
        font: "inherit",
        padding: "6px 8px",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)",
        background: "var(--panel-2)",
        color: "var(--text)"
      }
    }
  )), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn aqe-btn--primary", disabled: saving, onClick: save }, saving ? "A guardar\u2026" : "Guardar"))));
}
window.AquinosReviewOverlay = AquinosReviewOverlay;

// ===== aquinos_extrator/frontend/sessions.jsx =====
function AquinosConfirmModal({ title, body, confirmLabel, danger, onClose, onConfirm }) {
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      } else if (e.key === "Enter") {
        e.preventDefault();
        onConfirm();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onConfirm]);
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-modal__backdrop" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-modal", onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("div", { className: "aqe-modal__title" }, title), body && /* @__PURE__ */ React.createElement("div", { className: "aqe-modal__body" }, body), /* @__PURE__ */ React.createElement("div", { className: "aqe-modal__actions" }, /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "aqe-btn " + (danger ? "aqe-btn--danger" : "aqe-btn--primary"),
      onClick: onConfirm
    },
    confirmLabel || "OK"
  ))));
}
function AquinosNameModal({ title, initial, submitLabel, onClose, onSubmit }) {
  const [name, setName] = React.useState(initial || "");
  const inputRef = React.useRef(null);
  React.useEffect(() => {
    const id = setTimeout(() => inputRef.current?.focus(), 0);
    return () => clearTimeout(id);
  }, []);
  const submit = () => {
    const v = (name || "").trim();
    if (!v) return;
    onSubmit(v);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-modal__backdrop" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-modal", onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("div", { className: "aqe-modal__title" }, title), /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      className: "aqe-modal__input",
      id: "aqe-name-modal-input",
      name: "aqeNameModalInput",
      autoComplete: "off",
      value: name,
      onChange: (e) => setName(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          submit();
        } else if (e.key === "Escape") {
          e.preventDefault();
          onClose();
        }
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "aqe-modal__actions" }, /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "aqe-btn aqe-btn--primary",
      disabled: !(name || "").trim(),
      onClick: submit
    },
    submitLabel || "OK"
  ))));
}
function AquinosSessionPicker({ activeId, onChange, onOpenGerir, onCreate }) {
  const [sessions, setSessions] = React.useState([]);
  const [newOpen, setNewOpen] = React.useState(false);
  React.useEffect(() => {
    window.AqeAPI.get("/api/aquinos-extrator/sessions/").then(setSessions);
  }, []);
  const create = async (name) => {
    setNewOpen(false);
    const created = await window.AqeAPI.post(
      "/api/aquinos-extrator/sessions/",
      { name }
    );
    setSessions((prev) => [created, ...prev]);
    onCreate(created);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-picker" }, /* @__PURE__ */ React.createElement("span", { className: "aqe-picker__label" }, "Sess\xE3o:"), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "aqe-picker__select",
      value: activeId ?? "",
      onChange: (e) => onChange(e.target.value ? Number(e.target.value) : null)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolhe \u2014"),
    sessions.map((s) => /* @__PURE__ */ React.createElement("option", { key: s.id, value: s.id }, s.name))
  ), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: () => setNewOpen(true) }, "+ Nova"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: onOpenGerir }, "\u2699 Gerir"), newOpen && /* @__PURE__ */ React.createElement(
    window.AquinosNameModal,
    {
      title: "Nova sess\xE3o",
      initial: "",
      submitLabel: "Criar",
      onClose: () => setNewOpen(false),
      onSubmit: create
    }
  ));
}
function AquinosSessionGerir({ onClose, onChange }) {
  const [rows, setRows] = React.useState([]);
  const [renameTarget, setRenameTarget] = React.useState(null);
  const [deleteTarget, setDeleteTarget] = React.useState(null);
  const reload = React.useCallback(() => {
    window.AqeAPI.get("/api/aquinos-extrator/sessions/?archived=true").then(setRows);
  }, []);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const submitRename = async (name) => {
    const target = renameTarget;
    setRenameTarget(null);
    await window.AqeAPI.put(
      `/api/aquinos-extrator/sessions/${target.id}/`,
      { name }
    );
    reload();
    onChange?.();
  };
  const toggleArchive = async (s) => {
    await window.AqeAPI.put(
      `/api/aquinos-extrator/sessions/${s.id}/`,
      { archived: !s.archived }
    );
    reload();
    onChange?.();
  };
  const submitDelete = async () => {
    const s = deleteTarget;
    setDeleteTarget(null);
    const resp = await fetch(`/api/aquinos-extrator/sessions/${s.id}/`, {
      method: "DELETE",
      credentials: "include",
      headers: { "X-CSRFToken": document.cookie.match(/csrftoken=([^;]+)/)?.[1] || "" }
    });
    if (resp.ok) {
      reload();
      onChange?.();
    }
  };
  const sessionColumns = [
    {
      key: "name",
      label: "Nome",
      width: 170,
      minWidth: 130,
      render: (s) => /* @__PURE__ */ React.createElement("span", { title: s.name }, s.name)
    },
    {
      key: "created_by_username",
      label: "Criada por",
      width: 120,
      minWidth: 100,
      render: (s) => s.created_by_username ?? "\u2014"
    },
    { key: "file_count", label: "Ficheiros", width: 90, minWidth: 70, align: "right", mono: true },
    { key: "ok_count", label: "OK", width: 60, minWidth: 50, align: "right", mono: true },
    { key: "parcial_count", label: "~", width: 50, minWidth: 40, align: "right", mono: true },
    { key: "erro_count", label: "\u2715", width: 50, minWidth: 40, align: "right", mono: true },
    { key: "pending_count", label: "\u231B", width: 55, minWidth: 40, align: "right", mono: true },
    {
      key: "updated_at",
      label: "\xDAltima modifica\xE7\xE3o",
      width: 210,
      minWidth: 170,
      mono: true,
      render: (s) => new Date(s.updated_at).toLocaleString("pt-PT")
    },
    {
      key: "last_modified_by_username",
      label: "Por",
      width: 120,
      minWidth: 100,
      render: (s) => s.last_modified_by_username ?? "\u2014"
    },
    {
      key: "archived",
      label: "Estado",
      width: 100,
      minWidth: 80,
      render: (s) => s.archived ? "Arquivada" : "Activa"
    },
    {
      key: "acoes",
      label: "Ac\xE7\xF5es",
      width: 370,
      minWidth: 320,
      sortable: false,
      // botões, não um dado
      render: (s) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: () => setRenameTarget(s) }, "Renomear"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: () => toggleArchive(s) }, s.archived ? "Desarquivar" : "Arquivar"), s.can_delete && /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: () => setDeleteTarget(s) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-overlay" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-overlay__bar" }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, "Gerir sess\xF5es"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", style: { marginLeft: "auto" }, onClick: onClose }, "\u2715")), /* @__PURE__ */ React.createElement("div", { className: "aqe-gerir-body" }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "aquinos_extrator",
      viewId: "sessoes",
      columns: sessionColumns,
      data: rows,
      pagination: "client",
      rowKey: (s) => s.id,
      empty: "Sem sess\xF5es."
    }
  )), renameTarget && /* @__PURE__ */ React.createElement(
    window.AquinosNameModal,
    {
      title: `Renomear "${renameTarget.name}"`,
      initial: renameTarget.name,
      submitLabel: "Guardar",
      onClose: () => setRenameTarget(null),
      onSubmit: submitRename
    }
  ), deleteTarget && /* @__PURE__ */ React.createElement(
    window.AquinosConfirmModal,
    {
      title: `Apagar "${deleteTarget.name}"?`,
      body: "Esta ac\xE7\xE3o remove os PDFs e o hist\xF3rico da sess\xE3o. \xC9 irrevers\xEDvel.",
      confirmLabel: "Apagar",
      danger: true,
      onClose: () => setDeleteTarget(null),
      onConfirm: submitDelete
    }
  ));
}
window.AquinosConfirmModal = AquinosConfirmModal;
window.AquinosNameModal = AquinosNameModal;
window.AquinosSessionPicker = AquinosSessionPicker;
window.AquinosSessionGerir = AquinosSessionGerir;

// ===== aquinos_extrator/frontend/log-panel.jsx =====
function AqeLogPanel({ logs, onClear }) {
  const [open, setOpen] = React.useState(false);
  const warnCnt = logs.filter((l) => l.kind === "warn" || l.kind === "err").length;
  const icon = (k) => k === "ok" ? "\u2713" : k === "warn" ? "\u26A0" : k === "err" ? "\u2715" : "\xB7";
  return /* @__PURE__ */ React.createElement("div", { className: open ? "aqe-log aqe-log--open" : "aqe-log" }, /* @__PURE__ */ React.createElement("button", { className: "aqe-log-toggle", onClick: () => setOpen(!open) }, /* @__PURE__ */ React.createElement("span", null, "\u{1F4CB} Logs (", logs.length, ")"), warnCnt > 0 && /* @__PURE__ */ React.createElement("span", { className: "aqe-log-badge" }, "\u26A0 ", warnCnt), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto" } }, open ? "\u25BE" : "\u25B4")), open && /* @__PURE__ */ React.createElement("div", { className: "aqe-log-body" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-log-head" }, /* @__PURE__ */ React.createElement("span", null, logs.length, " entradas (mais recentes em cima)"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", onClick: onClear, disabled: !logs.length }, "Limpar")), /* @__PURE__ */ React.createElement("div", { className: "aqe-log-list" }, logs.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "aqe-empty", style: { padding: 16 } }, "Sem logs nesta sess\xE3o.") : logs.slice().reverse().map((l, i) => /* @__PURE__ */ React.createElement("div", { key: i, className: `aqe-log-row aqe-log-row--${l.kind}` }, /* @__PURE__ */ React.createElement("span", { className: "aqe-log-ts" }, l.ts), /* @__PURE__ */ React.createElement("span", { className: "aqe-log-icon" }, icon(l.kind)), /* @__PURE__ */ React.createElement("span", { className: "aqe-log-text" }, l.text))))));
}
window.AqeLogPanel = AqeLogPanel;

// ===== aquinos_extrator/frontend/view.jsx =====
const SETTINGS_URL = "/api/aquinos-extrator/settings/";
const SESSIONS_URL = "/api/aquinos-extrator/sessions/";
const EXTRACT_URL = "/api/aquinos-extrator/extract/";
const ACTIVE_KEY = "aqe_active_session";
function fileReference(name, regex) {
  try {
    const re = new RegExp(regex);
    const m = name.match(re);
    if (m) return (m[1] || m[0]).trim();
  } catch (_) {
  }
  return name.replace(/\.pdf$/i, "");
}
function _Icon({ children, title }) {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": title ? void 0 : "true",
      role: title ? "img" : void 0
    },
    title && /* @__PURE__ */ React.createElement("title", null, title),
    children
  );
}
function TrashIcon() {
  return /* @__PURE__ */ React.createElement(_Icon, null, /* @__PURE__ */ React.createElement("polyline", { points: "3 6 5 6 21 6" }), /* @__PURE__ */ React.createElement("path", { d: "M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6" }), /* @__PURE__ */ React.createElement("path", { d: "M10 11v6M14 11v6" }), /* @__PURE__ */ React.createElement("path", { d: "M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" }));
}
function RetryIcon() {
  return /* @__PURE__ */ React.createElement(_Icon, null, /* @__PURE__ */ React.createElement("polyline", { points: "23 4 23 10 17 10" }), /* @__PURE__ */ React.createElement("polyline", { points: "1 20 1 14 7 14" }), /* @__PURE__ */ React.createElement("path", { d: "M3.51 9a9 9 0 0114.85-3.36L23 10" }), /* @__PURE__ */ React.createElement("path", { d: "M20.49 15a9 9 0 01-14.85 3.36L1 14" }));
}
function UploadIcon() {
  return /* @__PURE__ */ React.createElement(_Icon, null, /* @__PURE__ */ React.createElement("path", { d: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" }), /* @__PURE__ */ React.createElement("polyline", { points: "17 8 12 3 7 8" }), /* @__PURE__ */ React.createElement("line", { x1: "12", y1: "3", x2: "12", y2: "15" }));
}
function AquinosExtratorView() {
  const [config, setConfig] = React.useState(null);
  const [sessions, setSessions] = React.useState([]);
  const [activeId, setActiveId] = React.useState(null);
  const [files, setFiles] = React.useState([]);
  const [results, setResults] = React.useState([]);
  const [busy, setBusy] = React.useState(false);
  const [processing, setProcessing] = React.useState(null);
  const [reviewIdx, setReviewIdx] = React.useState(-1);
  const [deleteTarget, setDeleteTarget] = React.useState(null);
  const [previewFilename, setPreviewFilename] = React.useState(null);
  const [gerirOpen, setGerirOpen] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const inputRef = React.useRef(null);
  const addLog = React.useCallback((kind, text) => {
    const ts = (/* @__PURE__ */ new Date()).toLocaleTimeString("pt-PT");
    setLogs((L) => [...L, { ts, kind, text }]);
  }, []);
  React.useEffect(() => {
    window.AqeAPI.get(SETTINGS_URL).then(setConfig);
  }, []);
  React.useEffect(() => {
    window.AqeAPI.get(SESSIONS_URL).then((list) => {
      setSessions(list);
      const stored = Number(localStorage.getItem(ACTIVE_KEY) || 0) || null;
      const fromStored = stored && list.find((s) => s.id === stored && !s.archived);
      const fallback = [...list].filter((s) => !s.archived).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))[0] || null;
      setActiveId((fromStored || fallback)?.id ?? null);
    });
  }, []);
  React.useEffect(() => {
    if (activeId) localStorage.setItem(ACTIVE_KEY, String(activeId));
    else localStorage.removeItem(ACTIVE_KEY);
  }, [activeId]);
  const reloadSessionData = React.useCallback(async (sid) => {
    if (!sid) {
      setFiles([]);
      setResults([]);
      return;
    }
    const [f, ext] = await Promise.all([
      window.AqeAPI.get(`${SESSIONS_URL}${sid}/files/`),
      window.AqeAPI.get(`${SESSIONS_URL}${sid}/extractions/`)
    ]);
    setFiles(f);
    setResults(ext.filter((r) => r.status !== "pending"));
  }, []);
  React.useEffect(() => {
    reloadSessionData(activeId);
  }, [activeId, reloadSessionData]);
  const addFiles = React.useCallback(async (list) => {
    if (!activeId) return;
    const have = new Set(files.map((f) => f.filename));
    const incoming = Array.from(list).filter(
      (f) => f.type === "application/pdf" && !have.has(f.name)
    );
    if (!incoming.length) return;
    const fd = new FormData();
    incoming.forEach((f) => fd.append("pdf", f));
    try {
      const rows = await window.AqeAPI.upload(
        `${SESSIONS_URL}${activeId}/files/`,
        fd
      );
      setFiles((prev) => [...prev, ...rows]);
      addLog("info", `Carregados ${rows.length} ficheiros para sess\xE3o #${activeId}`);
    } catch (e) {
      addLog("err", `Erro no upload: ${e}`);
    }
  }, [activeId, files, addLog]);
  const removeFile = async (filename) => {
    const resp = await fetch(
      `${SESSIONS_URL}${activeId}/files/${encodeURIComponent(filename)}/`,
      {
        method: "DELETE",
        credentials: "include",
        headers: { "X-CSRFToken": document.cookie.match(/csrftoken=([^;]+)/)?.[1] || "" }
      }
    );
    if (resp.ok) {
      setFiles((prev) => prev.filter((f) => f.filename !== filename));
      setResults((prev) => prev.filter((r) => r.filename !== filename));
      addLog("info", `Removido ${filename}`);
    } else {
      addLog("err", `Erro ao remover ${filename}: ${resp.status}`);
    }
  };
  const confirmRemove = (filename) => setDeleteTarget(filename);
  const _extractRow = async (filename) => {
    setProcessing(filename);
    try {
      const r = await window.AqeAPI.post(
        EXTRACT_URL,
        { session: activeId, filename }
      );
      const kind = r.status === "ok" ? "ok" : r.status === "parcial" ? "warn" : "err";
      addLog(kind, `${filename} \u2014 ${r.status}${r.message && r.status !== "ok" ? `: ${r.message}` : ""}`);
      return { filename, ...r };
    } catch (e) {
      addLog("err", `${filename} \u2014 erro: ${e}`);
      return { filename, status: "erro", message: String(e), fields: {} };
    } finally {
      setProcessing(null);
    }
  };
  const _upsertResult = (row) => {
    setResults((prev) => {
      const next = [...prev];
      const idx = next.findIndex((x) => x.filename === row.filename);
      if (idx >= 0) next[idx] = row;
      else next.push(row);
      return next;
    });
  };
  const processOne = async (filename) => {
    if (busy || !activeId) return;
    setBusy(true);
    addLog("info", `A reprocessar ${filename}\u2026`);
    const row = await _extractRow(filename);
    _upsertResult(row);
    setBusy(false);
  };
  const _putReupload = async (filename, file) => {
    const fd = new FormData();
    fd.append("pdf", file);
    const csrf = document.cookie.match(/csrftoken=([^;]+)/)?.[1] || "";
    try {
      const resp = await fetch(
        `${SESSIONS_URL}${activeId}/files/${encodeURIComponent(filename)}/`,
        {
          method: "PUT",
          credentials: "include",
          headers: { "X-CSRFToken": csrf },
          body: fd
        }
      );
      if (resp.ok) {
        addLog("ok", `${filename} \u2014 reenviado`);
        return true;
      }
      let detail = `HTTP ${resp.status}`;
      try {
        detail = (await resp.json()).detail || detail;
      } catch (_) {
      }
      addLog("err", `${filename} \u2014 falha no reenvio: ${detail}`);
    } catch (err) {
      addLog("err", `${filename} \u2014 erro a reenviar: ${err}`);
    }
    return false;
  };
  const reuploadOne = (filename) => {
    if (!activeId) return;
    const picker = document.createElement("input");
    picker.type = "file";
    picker.accept = "application/pdf";
    picker.onchange = async (e) => {
      const f = e.target.files?.[0];
      if (!f) return;
      addLog("info", `A reenviar ${filename}\u2026`);
      if (await _putReupload(filename, f)) {
        setResults((prev) => prev.map((r) => r.filename === filename ? { ...r, pdf_available: true } : r));
      }
    };
    picker.click();
  };
  const reuploadMissing = () => {
    if (!activeId) return;
    const missing = results.filter((r) => r.pdf_available === false);
    if (!missing.length) return;
    const want = new Set(missing.map((r) => r.filename));
    const picker = document.createElement("input");
    picker.type = "file";
    picker.accept = "application/pdf";
    picker.multiple = true;
    picker.onchange = async (e) => {
      const picked = Array.from(e.target.files || []);
      const matches = picked.filter((f) => want.has(f.name));
      const ignored = picked.filter((f) => !want.has(f.name));
      if (ignored.length) {
        addLog("warn", `${ignored.length} ficheiro(s) ignorado(s) \u2014 nome n\xE3o corresponde a row em falta: ${ignored.map((f) => f.name).join(", ")}`);
      }
      if (!matches.length) {
        addLog("warn", "Nenhum ficheiro escolhido corresponde a uma row em falta.");
        return;
      }
      addLog("info", `A reenviar ${matches.length} ficheiro(s) em falta\u2026`);
      const restored = /* @__PURE__ */ new Set();
      for (const f of matches) {
        if (await _putReupload(f.name, f)) restored.add(f.name);
      }
      setResults((prev) => prev.map((r) => restored.has(r.filename) ? { ...r, pdf_available: true } : r));
      addLog("info", `Reenvio terminado: ${restored.size}/${matches.length} ok.`);
    };
    picker.click();
  };
  const retryErrors = async () => {
    if (busy || !activeId) return;
    const erroRows = results.filter((r) => r.status === "erro");
    const noPdf = erroRows.filter((r) => r.pdf_available === false);
    const runnable = erroRows.filter((r) => r.pdf_available !== false);
    if (noPdf.length) {
      addLog("warn", `${noPdf.length} ficheiro(s) sem PDF em disco \u2014 usa Reenviar antes.`);
    }
    if (!runnable.length) return;
    setBusy(true);
    addLog("info", `A reprocessar ${runnable.length} erro(s)\u2026`);
    for (const r of runnable) {
      const row = await _extractRow(r.filename);
      _upsertResult(row);
    }
    setBusy(false);
    addLog("info", "Reprocessamento de erros terminado.");
  };
  const processAll = async () => {
    if (!config || busy || !activeId) return;
    setBusy(true);
    const pending = files.filter((f) => !results.find(
      (r) => r.filename === f.filename && r.status === "ok"
    ));
    addLog("info", `A processar ${pending.length} ficheiro(s)\u2026`);
    for (const f of pending) {
      const row = await _extractRow(f.filename);
      _upsertResult(row);
    }
    setBusy(false);
    addLog("info", "Processamento terminado.");
  };
  if (!config) return /* @__PURE__ */ React.createElement("div", { className: "aqe-empty" }, "A carregar defini\xE7\xF5es\u2026");
  const pendingCount = files.filter((f) => !results.find(
    (r) => r.filename === f.filename && r.status === "ok"
  )).length;
  const AQE_SPECS_COL_META = {
    referencia: { width: 120, mono: true },
    largura: { width: 120, align: "right", mono: true },
    comprimento: { width: 155, align: "right", mono: true },
    medidas: { width: 162 },
    qualidade: { width: 105 },
    fefco: { width: 95 }
  };
  const aqeLarguraPorRotulo = (label, minimo) => Math.max(minimo, Math.round((label || "").length * 8.8) + 32);
  const specsColumns = [
    ...config.export_columns.map(([k, label]) => {
      const meta = AQE_SPECS_COL_META[k] || { width: aqeLarguraPorRotulo(label, 90) };
      return {
        key: k,
        label,
        width: meta.width,
        minWidth: 70,
        align: meta.align,
        mono: meta.mono,
        // O valor vive em `r.fields[k]`, não em `r[k]` — sem isto a
        // ordenação por omissão (`row[c.key]`) leria sempre undefined.
        sortValue: (r) => r.fields?.[k] ?? "",
        render: (r) => {
          const v = r.fields?.[k] ?? "";
          return v === "" ? "" : /* @__PURE__ */ React.createElement("span", { title: String(v) }, v);
        }
      };
    }),
    {
      key: "estado",
      label: "Estado",
      width: 100,
      minWidth: 80,
      sortable: false,
      // ícone de estado, não um dado
      render: (r) => {
        const isProcessing = processing === r.filename;
        const pdfMissing = r.pdf_available === false;
        return isProcessing ? /* @__PURE__ */ React.createElement("span", { className: "aqe-spinner", title: "A processar\u2026" }) : pdfMissing ? /* @__PURE__ */ React.createElement("span", { title: "PDF em falta \u2014 usa Reenviar antes de Reprocessar", style: { color: "#fb923c" } }, "\u26A0") : /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `aqe-status-dot aqe-status-dot--${r.status === "ok" ? "ok" : r.status === "parcial" ? "warn" : "err"}`,
            title: r.status === "erro" && r.message ? r.message : config.status_labels[r.status]
          }
        );
      }
    },
    {
      key: "acoes",
      label: "",
      width: 140,
      minWidth: 110,
      sortable: false,
      // botões, não um dado
      render: (r) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation(), style: { whiteSpace: "nowrap" } }, (r.status === "erro" || r.status === "parcial") && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "aqe-btn aqe-btn--icon",
          disabled: busy,
          style: { marginRight: 4 },
          title: "Reprocessar",
          onClick: () => processOne(r.filename)
        },
        /* @__PURE__ */ React.createElement(RetryIcon, null)
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "aqe-btn aqe-btn--icon",
          style: { marginRight: 4 },
          title: "Reenviar PDF (substitui o ficheiro em disco, mant\xE9m o hist\xF3rico)",
          onClick: () => reuploadOne(r.filename)
        },
        /* @__PURE__ */ React.createElement(UploadIcon, null)
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "aqe-btn aqe-btn--icon",
          disabled: busy,
          title: "Apagar este PDF da sess\xE3o (mant\xE9m hist\xF3rico no /usage/)",
          onClick: () => confirmRemove(r.filename)
        },
        /* @__PURE__ */ React.createElement(TrashIcon, null)
      ))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-root" }, /* @__PURE__ */ React.createElement("aside", { className: "aqe-side" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "aqe-dropzone",
      onClick: () => activeId && inputRef.current?.click(),
      onDragOver: (e) => {
        e.preventDefault();
        e.currentTarget.classList.add("over");
      },
      onDragLeave: (e) => e.currentTarget.classList.remove("over"),
      onDrop: (e) => {
        e.preventDefault();
        e.currentTarget.classList.remove("over");
        addFiles(e.dataTransfer.files);
      },
      style: { opacity: activeId ? 1 : 0.5, pointerEvents: activeId ? "auto" : "none" }
    },
    "Arrasta PDFs aqui",
    /* @__PURE__ */ React.createElement("br", null),
    /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12 } }, "ou clica para escolher")
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      type: "file",
      accept: "application/pdf",
      multiple: true,
      hidden: true,
      onChange: (e) => addFiles(e.target.files)
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "aqe-filelist" }, files.map((f) => {
    const r = results.find((r2) => r2.filename === f.filename);
    const isProcessing = processing === f.filename;
    const cls = isProcessing ? "aqe-fileitem--processing" : r ? "aqe-fileitem--" + (r.status === "ok" ? "ok" : r.status === "parcial" ? "warn" : "err") : "";
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: f.filename,
        className: `aqe-fileitem ${cls}`,
        role: "button",
        title: "Pr\xE9-visualizar o PDF",
        onClick: () => !isProcessing && setPreviewFilename(f.filename)
      },
      /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, f.filename), /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12 } }, fileReference(f.filename, config.filename_regex))),
      isProcessing ? /* @__PURE__ */ React.createElement("span", { className: "aqe-spinner", title: "A processar\u2026" }) : /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "aqe-btn aqe-btn--icon",
          onClick: (e) => {
            e.stopPropagation();
            confirmRemove(f.filename);
          },
          title: "Apagar este PDF da sess\xE3o (mant\xE9m hist\xF3rico no /usage/)"
        },
        /* @__PURE__ */ React.createElement(TrashIcon, null)
      )
    );
  }))), /* @__PURE__ */ React.createElement("section", { className: "aqe-main" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-toolbar" }, /* @__PURE__ */ React.createElement(
    window.AquinosSessionPicker,
    {
      activeId,
      onChange: setActiveId,
      onOpenGerir: () => setGerirOpen(true),
      onCreate: (s) => {
        setSessions((prev) => [s, ...prev]);
        setActiveId(s.id);
      }
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "aqe-btn aqe-btn--primary",
      disabled: busy || !activeId || pendingCount === 0,
      onClick: processAll
    },
    "\u25B6 Processar",
    pendingCount > 0 ? ` (${pendingCount})` : ""
  ), (() => {
    const erroCount = results.filter((r) => r.status === "erro").length;
    return erroCount > 0 && /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "aqe-btn",
        disabled: busy,
        onClick: retryErrors,
        title: "Reprocessar todos os ficheiros com erro"
      },
      /* @__PURE__ */ React.createElement(RetryIcon, null),
      " Erros (",
      erroCount,
      ")"
    );
  })(), (() => {
    const missingCount = results.filter((r) => r.pdf_available === false).length;
    return missingCount > 0 && /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "aqe-btn",
        disabled: busy,
        onClick: reuploadMissing,
        title: "Escolher ficheiros locais e substituir os PDFs em falta (matching por nome)"
      },
      /* @__PURE__ */ React.createElement(UploadIcon, null),
      " Em falta (",
      missingCount,
      ")"
    );
  })(), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "aqe-btn",
      disabled: results.length === 0,
      onClick: async () => {
        const XLSX = await window.AquinosVendor.loadXlsx();
        const head = [...config.export_columns.map(([, label]) => label), "Observa\xE7\xF5es"];
        const rows = results.map((r) => [
          ...config.export_columns.map(([k]) => r.fields?.[k] ?? ""),
          r.fields?.observacoes ?? ""
        ]);
        const ws = XLSX.utils.aoa_to_sheet([head, ...rows]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Projetos");
        const date = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
        const name = config.export_filename_template.replace("{date}", date);
        XLSX.writeFile(wb, name);
      }
    },
    "\u2193 Excel"
  ), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", color: "var(--muted)", fontSize: 12 } }, results.filter((r) => r.status === "ok").length, " \u2713 \xB7", " ", results.filter((r) => r.status === "parcial").length, " ~ \xB7", " ", results.filter((r) => r.status === "erro").length, " \u2715")), !activeId ? /* @__PURE__ */ React.createElement("div", { className: "aqe-empty" }, "Cria uma sess\xE3o para come\xE7ar.") : results.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "aqe-empty" }, files.length === 0 ? "Carrega PDFs para come\xE7ar" : "Sem resultados ainda \u2014 carrega Processar.") : /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "aquinos_extrator",
      viewId: "specs",
      columns: specsColumns,
      data: results,
      pagination: "client",
      rowKey: (r) => r.filename,
      rowClassName: (r) => r.pdf_available === false ? "aqe-row--missing" : void 0,
      onRowClick: (r) => setReviewIdx(results.findIndex((x) => x.filename === r.filename)),
      empty: "Sem resultados."
    }
  )), reviewIdx >= 0 && /* @__PURE__ */ React.createElement(
    window.AquinosReviewOverlay,
    {
      result: results[reviewIdx],
      sessionId: activeId,
      config,
      onClose: () => setReviewIdx(-1),
      onPrev: () => setReviewIdx(Math.max(0, reviewIdx - 1)),
      onNext: () => setReviewIdx(Math.min(results.length - 1, reviewIdx + 1)),
      onSaved: (patched) => {
        const next = [...results];
        next[reviewIdx] = patched;
        setResults(next);
        setReviewIdx(-1);
      }
    }
  ), previewFilename && (() => {
    const idx = files.findIndex((f) => f.filename === previewFilename);
    return /* @__PURE__ */ React.createElement(
      window.AquinosReviewOverlay,
      {
        result: { filename: previewFilename, fields: {} },
        sessionId: activeId,
        config,
        previewOnly: true,
        onClose: () => setPreviewFilename(null),
        onPrev: () => idx > 0 && setPreviewFilename(files[idx - 1].filename),
        onNext: () => idx < files.length - 1 && setPreviewFilename(files[idx + 1].filename),
        onSaved: () => setPreviewFilename(null)
      }
    );
  })(), gerirOpen && /* @__PURE__ */ React.createElement(
    window.AquinosSessionGerir,
    {
      onClose: () => setGerirOpen(false),
      onChange: () => {
        window.AqeAPI.get(SESSIONS_URL).then(setSessions);
        reloadSessionData(activeId);
      }
    }
  ), deleteTarget && /* @__PURE__ */ React.createElement(
    window.AquinosConfirmModal,
    {
      title: `Apagar "${deleteTarget}"?`,
      body: "Remove o ficheiro da sess\xE3o. O hist\xF3rico no /usage/ (custo, tentativas) \xE9 preservado \u2014 apenas perde a liga\xE7\xE3o \xE0 sess\xE3o.",
      confirmLabel: "Apagar",
      danger: true,
      onClose: () => setDeleteTarget(null),
      onConfirm: () => {
        removeFile(deleteTarget);
        setDeleteTarget(null);
      }
    }
  ), /* @__PURE__ */ React.createElement(window.AqeLogPanel, { logs, onClear: () => setLogs([]) }));
}
window.AquinosExtratorView = AquinosExtratorView;

// ===== aquinos_extrator/frontend/settings.jsx =====
const AQE_SETTINGS_URL = "/api/aquinos-extrator/settings/";
function AqeSection({ title, children }) {
  return /* @__PURE__ */ React.createElement("fieldset", { className: "aqe-set-section" }, /* @__PURE__ */ React.createElement("legend", null, title), children);
}
function AqeRow({ label, hint, children }) {
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-set-row" }, /* @__PURE__ */ React.createElement("label", null, label, hint && /* @__PURE__ */ React.createElement("small", null, hint)), children);
}
function AquinosExtratorSettings() {
  const [data, setData] = React.useState(null);
  const [edited, setEdited] = React.useState({});
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [models, setModels] = React.useState({ list: [], error: null });
  React.useEffect(() => {
    window.AqeAPI.get(AQE_SETTINGS_URL).then((d) => {
      setData(d);
      setEdited({});
    });
  }, []);
  React.useEffect(() => {
    window.AqeAPI.get("/api/aquinos-extrator/models/").then((r) => setModels({ list: r.models || [], error: r.error })).catch((e) => setModels({ list: [], error: String(e) }));
  }, []);
  if (!data) return /* @__PURE__ */ React.createElement("div", { className: "aqe-empty" }, "A carregar\u2026");
  const v = (k) => edited[k] !== void 0 ? edited[k] : data[k];
  const set = (k, value) => setEdited({ ...edited, [k]: value });
  const dirty = Object.keys(edited).length > 0;
  const submit = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = { ...edited };
      if (payload.ai_api_key && payload.ai_api_key === data.ai_api_key_mask) delete payload.ai_api_key;
      const next = await window.AqeAPI.put(AQE_SETTINGS_URL, payload);
      setData(next);
      setEdited({});
    } catch (e) {
      setError(String(e));
    } finally {
      setSaving(false);
    }
  };
  const costFlag = "\u26A0 afecta custo";
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-set-root" }, /* @__PURE__ */ React.createElement("h2", { style: { margin: "0 0 12px" } }, "Defini\xE7\xF5es \u2014 Aquinos Extrator"), /* @__PURE__ */ React.createElement(AqeSection, { title: "Provider IA" }, /* @__PURE__ */ React.createElement(AqeRow, { label: "Provider" }, /* @__PURE__ */ React.createElement("select", { value: v("ai_provider"), onChange: (e) => set("ai_provider", e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "anthropic" }, "Anthropic"))), /* @__PURE__ */ React.createElement(AqeRow, { label: "API URL" }, /* @__PURE__ */ React.createElement("input", { value: v("ai_api_url"), onChange: (e) => set("ai_api_url", e.target.value) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "API version" }, /* @__PURE__ */ React.createElement("input", { value: v("ai_api_version"), onChange: (e) => set("ai_api_version", e.target.value) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Modelo", hint: models.error ? `(${models.error}) \u2014 fallback texto livre` : costFlag }, models.list.length > 0 ? /* @__PURE__ */ React.createElement("select", { value: v("model_name"), onChange: (e) => set("model_name", e.target.value) }, !models.list.some((m) => m.id === v("model_name")) && /* @__PURE__ */ React.createElement("option", { value: v("model_name") }, v("model_name"), " (n\xE3o listado)"), models.list.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.display_name, " \u2014 ", m.id))) : /* @__PURE__ */ React.createElement("input", { value: v("model_name"), onChange: (e) => set("model_name", e.target.value) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Max tokens", hint: costFlag }, /* @__PURE__ */ React.createElement("input", { type: "number", value: v("max_tokens"), onChange: (e) => set("max_tokens", parseInt(e.target.value, 10) || 0) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "API key" }, /* @__PURE__ */ React.createElement("input", { name: "ai_api_key", type: "password", placeholder: data.ai_api_key_mask || "(n\xE3o configurada)", onChange: (e) => set("ai_api_key", e.target.value) }))), /* @__PURE__ */ React.createElement(AqeSection, { title: "Pricing por modelo (admin-only)" }, /* @__PURE__ */ React.createElement(AqeRow, { label: "model_pricing (JSON)", hint: "EUR por 1M tokens; cost dos logs futuros usa este pricing" }, /* @__PURE__ */ React.createElement(
    "textarea",
    {
      rows: 6,
      value: JSON.stringify(v("model_pricing") || {}, null, 2),
      onChange: (e) => {
        try {
          set("model_pricing", JSON.parse(e.target.value));
        } catch (_) {
        }
      },
      style: { fontFamily: "var(--font-mono)" }
    }
  ))), /* @__PURE__ */ React.createElement(AqeSection, { title: "Pipeline" }, /* @__PURE__ */ React.createElement(AqeRow, { label: "Usar MarkItDown como contexto" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: v("use_markitdown_context"), onChange: (e) => set("use_markitdown_context", e.target.checked) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "DPI do render", hint: costFlag }, /* @__PURE__ */ React.createElement("input", { type: "number", value: v("vision_dpi"), onChange: (e) => set("vision_dpi", parseInt(e.target.value, 10) || 72) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "P\xE1ginas a renderizar", hint: costFlag }, /* @__PURE__ */ React.createElement("input", { type: "number", value: v("vision_max_pages"), onChange: (e) => set("vision_max_pages", parseInt(e.target.value, 10) || 1) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Tamanho m\xE1x. PDF (MB)", hint: costFlag }, /* @__PURE__ */ React.createElement("input", { type: "number", value: v("max_pdf_mb"), onChange: (e) => set("max_pdf_mb", parseInt(e.target.value, 10) || 1) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Retry delays (ms, JSON)" }, /* @__PURE__ */ React.createElement("input", { value: JSON.stringify(v("retry_delays_ms")), onChange: (e) => {
    try {
      set("retry_delays_ms", JSON.parse(e.target.value));
    } catch (_) {
    }
  } }))), /* @__PURE__ */ React.createElement(AqeSection, { title: "Prompt & Schema" }, /* @__PURE__ */ React.createElement(AqeRow, { label: "System prompt" }, /* @__PURE__ */ React.createElement("textarea", { rows: 12, value: v("system_prompt"), onChange: (e) => set("system_prompt", e.target.value), style: { fontFamily: "var(--font-mono)" } })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Field schema (JSON)" }, /* @__PURE__ */ React.createElement("input", { value: JSON.stringify(v("field_schema")), onChange: (e) => {
    try {
      set("field_schema", JSON.parse(e.target.value));
    } catch (_) {
    }
  } })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Numeric fields (JSON)" }, /* @__PURE__ */ React.createElement("input", { value: JSON.stringify(v("numeric_fields")), onChange: (e) => {
    try {
      set("numeric_fields", JSON.parse(e.target.value));
    } catch (_) {
    }
  } })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Required fields (JSON)" }, /* @__PURE__ */ React.createElement("input", { value: JSON.stringify(v("required_fields")), onChange: (e) => {
    try {
      set("required_fields", JSON.parse(e.target.value));
    } catch (_) {
    }
  } }))), /* @__PURE__ */ React.createElement(AqeSection, { title: "Filename & Export" }, /* @__PURE__ */ React.createElement(AqeRow, { label: "Filename regex" }, /* @__PURE__ */ React.createElement("input", { value: v("filename_regex"), onChange: (e) => set("filename_regex", e.target.value) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Export columns (JSON: [[chave, label], ...])" }, /* @__PURE__ */ React.createElement("input", { value: JSON.stringify(v("export_columns")), onChange: (e) => {
    try {
      set("export_columns", JSON.parse(e.target.value));
    } catch (_) {
    }
  } })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Export filename template" }, /* @__PURE__ */ React.createElement("input", { value: v("export_filename_template"), onChange: (e) => set("export_filename_template", e.target.value) }))), /* @__PURE__ */ React.createElement(AqeSection, { title: "UX" }, /* @__PURE__ */ React.createElement(AqeRow, { label: "Zoom m\xEDnimo" }, /* @__PURE__ */ React.createElement("input", { type: "number", step: "0.05", value: v("zoom_min"), onChange: (e) => set("zoom_min", parseFloat(e.target.value)) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Zoom m\xE1ximo" }, /* @__PURE__ */ React.createElement("input", { type: "number", step: "0.05", value: v("zoom_max"), onChange: (e) => set("zoom_max", parseFloat(e.target.value)) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Zoom incremento" }, /* @__PURE__ */ React.createElement("input", { type: "number", step: "0.05", value: v("zoom_step"), onChange: (e) => set("zoom_step", parseFloat(e.target.value)) })), /* @__PURE__ */ React.createElement(AqeRow, { label: "Status labels (JSON)" }, /* @__PURE__ */ React.createElement("input", { value: JSON.stringify(v("status_labels")), onChange: (e) => {
    try {
      set("status_labels", JSON.parse(e.target.value));
    } catch (_) {
    }
  } }))), /* @__PURE__ */ React.createElement("div", { className: "aqe-set-footer" }, /* @__PURE__ */ React.createElement("button", { className: "aqe-btn aqe-btn--primary", disabled: !dirty || saving, onClick: submit }, saving ? "A guardar\u2026" : "Guardar altera\xE7\xF5es"), error && /* @__PURE__ */ React.createElement("span", { style: { color: "#ef4444", marginLeft: 12 } }, error), data.updated_at && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", color: "var(--muted)", fontSize: 12 } }, "\xDAltima edi\xE7\xE3o: ", new Date(data.updated_at).toLocaleString("pt-PT"), " por ", data.updated_by_username || "(desconhecido)")));
}
window.AquinosExtratorSettings = AquinosExtratorSettings;

// ===== aquinos_extrator/frontend/usage.jsx =====
const AQE_USAGE_URL = "/api/aquinos-extrator/usage/";
const AQE_U_PRESETS = [
  { id: "24h", label: "\xDAltimas 24h", days: 1 },
  { id: "7d", label: "\xDAltimos 7d", days: 7 },
  { id: "30d", label: "\xDAltimos 30d", days: 30 },
  { id: "90d", label: "\xDAltimos 90d", days: 90 }
];
function aqeURangeFromPreset(presetId) {
  const p = AQE_U_PRESETS.find((p2) => p2.id === presetId) || AQE_U_PRESETS[2];
  const to = /* @__PURE__ */ new Date();
  const from = new Date(to.getTime() - p.days * 24 * 3600 * 1e3);
  return { from: from.toISOString(), to: to.toISOString() };
}
function aqeUFmtEur(n) {
  if (n == null) return "\u2014";
  return new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 4
  }).format(n);
}
function aqeUFmtInt(n) {
  if (n == null) return "\u2014";
  return new Intl.NumberFormat("pt-PT").format(n);
}
function aqeUFmtPct(n) {
  if (n == null) return "\u2014";
  return (n * 100).toFixed(1) + "%";
}
function aqeUFmtMs(n) {
  if (n == null) return "\u2014";
  if (n < 1e3) return n + " ms";
  return (n / 1e3).toFixed(1) + " s";
}
const AQE_USAGE_BREAKDOWN_COLUMNS = [
  {
    key: "key",
    label: "Key",
    width: 300,
    minWidth: 160,
    render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.key }, r.key)
  },
  {
    key: "calls",
    label: "Calls",
    width: 90,
    minWidth: 70,
    align: "right",
    mono: true,
    render: (r) => aqeUFmtInt(r.calls)
  },
  {
    key: "tokens",
    label: "Tokens (in+out)",
    width: 220,
    minWidth: 160,
    align: "right",
    mono: true,
    // Valor calculado (soma de dois campos) — sem `sortValue` a ordenação
    // por omissão leria `row['tokens']`, que não existe.
    sortValue: (r) => r.input_tokens + r.output_tokens,
    render: (r) => aqeUFmtInt(r.input_tokens + r.output_tokens)
  },
  {
    key: "cost_eur",
    label: "Custo \u20AC",
    width: 130,
    minWidth: 90,
    align: "right",
    mono: true,
    render: (r) => aqeUFmtEur(r.cost_eur)
  },
  {
    key: "erro_count",
    label: "Erros",
    width: 100,
    minWidth: 70,
    align: "right",
    mono: true,
    render: (r) => aqeUFmtInt(r.erro_count)
  }
];
function AquinosExtratorUsage() {
  const [preset, setPreset] = React.useState("30d");
  const [granularity, setGranularity] = React.useState("day");
  const [breakdown, setBreakdown] = React.useState("none");
  const [chartMeasure, setChartMeasure] = React.useState("calls");
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    const r = aqeURangeFromPreset(preset);
    const qs = new URLSearchParams({
      from: r.from,
      to: r.to,
      granularity,
      breakdown
    }).toString();
    setLoading(true);
    setError(null);
    window.AqeAPI.get(`${AQE_USAGE_URL}?${qs}`).then((d) => {
      setData(d);
      setLoading(false);
    }).catch((e) => {
      setError(String(e));
      setLoading(false);
    });
  }, [preset, granularity, breakdown]);
  const exportXlsx = async () => {
    if (!data || !data.breakdown.length) return;
    const XLSX = await window.AquinosVendor.loadXlsx();
    const head = [
      "Key",
      "Calls",
      "Input tokens",
      "Output tokens",
      "Cost (EUR)",
      "OK",
      "Parcial",
      "Erro"
    ];
    const rows = data.breakdown.map((r) => [
      r.key,
      r.calls,
      r.input_tokens,
      r.output_tokens,
      r.cost_eur,
      r.ok_count,
      r.parcial_count,
      r.erro_count
    ]);
    const ws = XLSX.utils.aoa_to_sheet([head, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Breakdown");
    const date = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
    XLSX.writeFile(wb, `aquinos_consumo_${breakdown}_${date}.xlsx`);
  };
  const chartOption = data ? {
    grid: { left: 50, right: 16, top: 10, bottom: 30 },
    xAxis: {
      type: "category",
      data: data.series.map((s) => s.bucket.slice(0, granularity === "hour" ? 13 : 10)),
      axisLabel: { fontSize: 11 }
    },
    yAxis: { type: "value", axisLabel: { fontSize: 11 } },
    series: [{
      type: "bar",
      data: data.series.map((s) => chartMeasure === "cost_eur" ? s.cost_eur : s[chartMeasure]),
      itemStyle: { color: "var(--accent)" }
    }],
    tooltip: { trigger: "axis" }
  } : null;
  return /* @__PURE__ */ React.createElement("div", { className: "aqe-usage-root" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-usage-toolbar" }, /* @__PURE__ */ React.createElement("div", null, AQE_U_PRESETS.map((p) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: p.id,
      className: "aqe-btn " + (preset === p.id ? "aqe-btn--primary" : ""),
      onClick: () => setPreset(p.id)
    },
    p.label
  ))), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" } }, /* @__PURE__ */ React.createElement("label", null, "Granularidade", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: granularity,
      onChange: (e) => setGranularity(e.target.value),
      style: { marginLeft: 6 }
    },
    /* @__PURE__ */ React.createElement("option", { value: "hour" }, "hora"),
    /* @__PURE__ */ React.createElement("option", { value: "day" }, "dia"),
    /* @__PURE__ */ React.createElement("option", { value: "month" }, "m\xEAs")
  )), /* @__PURE__ */ React.createElement("label", null, "Breakdown", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: breakdown,
      onChange: (e) => setBreakdown(e.target.value),
      style: { marginLeft: 6 }
    },
    /* @__PURE__ */ React.createElement("option", { value: "none" }, "\u2014"),
    /* @__PURE__ */ React.createElement("option", { value: "user" }, "Utilizador"),
    /* @__PURE__ */ React.createElement("option", { value: "model" }, "Modelo"),
    /* @__PURE__ */ React.createElement("option", { value: "document" }, "Documento")
  )))), loading && /* @__PURE__ */ React.createElement("div", { className: "aqe-empty" }, "A carregar\u2026"), error && /* @__PURE__ */ React.createElement("div", { className: "aqe-empty", style: { color: "#ef4444" } }, error), data && !loading && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-grid" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-v" }, aqeUFmtInt(data.kpis.calls)), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-l" }, "chamadas")), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-v" }, aqeUFmtInt(data.kpis.input_tokens)), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-l" }, "tokens in")), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-v" }, aqeUFmtInt(data.kpis.output_tokens)), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-l" }, "tokens out")), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-v" }, aqeUFmtEur(data.kpis.cost_eur)), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-l" }, "custo")), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-v" }, aqeUFmtPct(data.kpis.error_rate)), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-l" }, "taxa erro")), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-v" }, aqeUFmtMs(data.kpis.latency_p95_ms)), /* @__PURE__ */ React.createElement("div", { className: "aqe-kpi-l" }, "lat\xEAncia p95"))), /* @__PURE__ */ React.createElement("div", { className: "aqe-usage-chart" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-usage-chart-head" }, /* @__PURE__ */ React.createElement("label", null, "M\xE9trica", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: chartMeasure,
      onChange: (e) => setChartMeasure(e.target.value),
      style: { marginLeft: 6 }
    },
    /* @__PURE__ */ React.createElement("option", { value: "calls" }, "Chamadas"),
    /* @__PURE__ */ React.createElement("option", { value: "cost_eur" }, "Custo \u20AC"),
    /* @__PURE__ */ React.createElement("option", { value: "input_tokens" }, "Tokens in"),
    /* @__PURE__ */ React.createElement("option", { value: "output_tokens" }, "Tokens out")
  ))), /* @__PURE__ */ React.createElement(window.AqeEChart, { option: chartOption, height: 260 })), breakdown !== "none" && /* @__PURE__ */ React.createElement("div", { className: "aqe-usage-breakdown" }, /* @__PURE__ */ React.createElement("div", { className: "aqe-usage-breakdown-head" }, /* @__PURE__ */ React.createElement("span", null, "Top por ", breakdown === "user" ? "utilizador" : breakdown === "model" ? "modelo" : "documento"), /* @__PURE__ */ React.createElement("button", { className: "aqe-btn", disabled: !data.breakdown.length, onClick: exportXlsx }, "\u2193 XLSX")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "aquinos_extrator",
      viewId: "uso",
      columns: AQE_USAGE_BREAKDOWN_COLUMNS,
      data: data.breakdown.slice(0, 50),
      pagination: "client",
      rowKey: (r) => r.key,
      empty: "Sem dados."
    }
  ))));
}
window.AquinosExtratorUsage = AquinosExtratorUsage;

// ===== aquinos_extrator/frontend/entry.jsx =====

// ===== aquinos_extrator/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "aquinos_extrator",
  order: 7,
  name: "AQUINOS EXTRATOR",
  sub: "Extra\xE7\xE3o de specs de PDFs Aquinos",
  accent: "#0076CE",
  brandLogo: "/static/assets/extractor-logo.png",
  brandEmoji: "\u{1F4E4}",
  brandEmojiFontSize: "26px",
  home: "aquinos_extrator",
  launcher: true,
  frontendFiles: [
    "frontend/styles.jsx",
    "frontend/aqe-api.jsx",
    "frontend/aqe-echart.jsx",
    "frontend/vendor.jsx",
    "frontend/review.jsx",
    "frontend/sessions.jsx",
    "frontend/log-panel.jsx",
    "frontend/view.jsx",
    "frontend/settings.jsx",
    "frontend/usage.jsx",
    "frontend/entry.jsx"
  ],
  routes: [
    { id: "aquinos_extrator", section: "Aquinos Extrator", icon: "upload", label: "Extrator", adminOnly: false, title: "AQUINOS EXTRATOR", tooltip: "Extrator de specs Aquinos" },
    { id: "aquinos_extrator_settings", section: "Configura\xE7\xF5es", icon: "cog", label: "Configura\xE7\xF5es", adminOnly: true, title: "AQUINOS EXTRATOR \u2014 Configura\xE7\xF5es", tooltip: "Defini\xE7\xF5es do m\xF3dulo" },
    { id: "aquinos_extrator_usage", section: "Consumo", icon: "chart", label: "Consumo", adminOnly: false, title: "AQUINOS EXTRATOR \u2014 Consumo", tooltip: "Estat\xEDsticas de uso da API IA" }
  ],
  render: {
    aquinos_extrator: () => React.createElement(window.AquinosExtratorView),
    aquinos_extrator_settings: () => React.createElement(window.AquinosExtratorSettings),
    aquinos_extrator_usage: () => React.createElement(window.AquinosExtratorUsage)
  }
});

// ===== bi/_shared/frontend/data.jsx =====
const EUR = new Intl.NumberFormat("pt-PT", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0
});
const INT = new Intl.NumberFormat("pt-PT");
const FORN_ACCENT = "#1e3a5f";
const FORN_GREEN = "#15803d";
const FORN_AMBER = "#b45309";
const FORN_RED = "#b91c1c";
const PCT1 = (v) => v == null || !isFinite(v) ? "\u2014" : (v * 100).toFixed(1).replace(".", ",") + "%";
const DAYS1 = (v) => v == null || !isFinite(v) ? "\u2014" : v.toFixed(1).replace(".", ",") + " d";
function otdColor(v) {
  if (v == null || !isFinite(v)) return "var(--muted)";
  return v >= 0.95 ? FORN_GREEN : v >= 0.85 ? FORN_AMBER : FORN_RED;
}
const FORN_MEASURES = [
  { key: "valor", label: "Valor", fmt: (v) => EUR.format(v) },
  { key: "encomendas", label: "Encomendas", fmt: (v) => INT.format(v) },
  { key: "m2prec", label: "m\xB2 recebidos", fmt: (v) => INT.format(Math.round(v)) + " m\xB2" }
];
const fornFmt = (measure) => (FORN_MEASURES.find((m) => m.key === measure) || FORN_MEASURES[0]).fmt;
const FORN_DIMS = [
  { key: "cliente", label: "Cliente" },
  { key: "fornecedor", label: "Fornecedor" },
  { key: "qualidade", label: "Qualidade" },
  { key: "armrec", label: "Armaz\xE9m rece\xE7\xE3o" }
];
const FORN_FLAGS = {
  sos: { label: "SOS", pred: (r) => r.sos > 0 },
  antecipada: { label: "Antecipada", pred: (r) => r.antecipada > 0 },
  sem_conf: { label: "Sem data confirmada", pred: (r) => r.sem_conf > 0 },
  late_conf: { label: "Atraso vs confirmada", pred: (r) => r.atraso_conf > 0 },
  late_sol: { label: "Atraso vs solicitada", pred: (r) => r.atraso_sol > 0 },
  rec_d1_conf: { label: "Entrega D+1 vs confirmada", pred: (r) => r.rec_d1_conf > 0 },
  req_8d: { label: "Req. > 8 dias da solicitada", pred: (r) => r.req_8d > 0 },
  req_le8d: { label: "Req. \u2264 8 dias da solicitada", pred: (r) => r.req_8d === 0 },
  below_lt: { label: "Req. abaixo do LT te\xF3rico", pred: (r) => r.below_lt > 0 },
  at_above_lt: { label: "Req. \u2265 LT te\xF3rico", pred: (r) => r.below_lt === 0 && !(r.sem_lt > 0) },
  sem_lt: { label: "Req. sem LT te\xF3rico", pred: (r) => r.sem_lt > 0 }
};
const FORN_SUM_KEYS = [
  "encomendas",
  "qtt",
  "valor",
  "m2preq",
  "m2prec",
  "atraso_conf",
  "atraso_sol",
  "confirmadas",
  "sos",
  "antecipada",
  "sem_conf",
  "rec_d1_conf",
  "req_8d",
  "below_lt",
  "sem_lt",
  "atraso_conf_c",
  "sem_conf_ok",
  "sem_conf_atraso",
  "sem_conf_d1_sol",
  "lt_real_sum",
  "lt_real_n",
  "lt_c_sum",
  "lt_c_n",
  "atraso_forn_sum",
  "atraso_forn_pos",
  "atraso_forn_n"
];
const FORN_ZERO = () => {
  const a = {};
  for (const k of FORN_SUM_KEYS) a[k] = 0;
  return a;
};
function fornSum(rows) {
  const a = FORN_ZERO();
  for (const r of rows) for (const k of FORN_SUM_KEYS) a[k] += r[k] || 0;
  return a;
}
function fornBy(rows, dim) {
  const m = /* @__PURE__ */ new Map();
  for (const r of rows) {
    let a = m.get(r[dim]);
    if (!a) {
      a = FORN_ZERO();
      m.set(r[dim], a);
    }
    for (const k of FORN_SUM_KEYS) a[k] += r[k] || 0;
  }
  return m;
}
const fornOtdConf = (a, soComConf, d1ATempo) => {
  let den = a.encomendas;
  let atraso = a.atraso_conf;
  if (soComConf) {
    const reentra = a.sem_conf_atraso || 0;
    den = a.encomendas - a.sem_conf + reentra;
    atraso = a.atraso_conf_c + reentra;
    if (d1ATempo) atraso -= a.rec_d1_conf + (a.sem_conf_d1_sol || 0);
  } else if (d1ATempo) {
    atraso -= a.rec_d1_conf + (a.sem_conf_d1_sol || 0);
  }
  if (!(den > 0)) return null;
  return 1 - atraso / den;
};
const fornDerive = (a, opts = {}) => ({
  ...a,
  otdConf: fornOtdConf(a, !!opts.soComConf, !!opts.d1ATempo),
  otdSol: a.encomendas ? 1 - a.atraso_sol / a.encomendas : null,
  pctConf: a.encomendas ? a.confirmadas / a.encomendas : null,
  semConfPct: a.encomendas ? a.sem_conf / a.encomendas : null,
  recD1ConfPct: a.encomendas ? a.rec_d1_conf / a.encomendas : null,
  req8dPct: a.encomendas ? a.req_8d / a.encomendas : null,
  belowLtPct: a.encomendas - a.sem_lt > 0 ? a.below_lt / (a.encomendas - a.sem_lt) : null,
  ltReal: a.lt_real_n ? a.lt_real_sum / a.lt_real_n : null,
  ltContr: a.lt_c_n ? a.lt_c_sum / a.lt_c_n : null,
  // Atraso do fornecedor = receção − confirmada (sem confirmação, − solicitada), mín. 0 (cartão #256): média
  // dos atrasos > 0 e % das linhas com os dois LT que se atrasaram. Espelha
  // _derive() em fornecedores/backend/service.py.
  atrasoForn: a.atraso_forn_pos ? a.atraso_forn_sum / a.atraso_forn_pos : null,
  atrasoFornPct: a.atraso_forn_n ? a.atraso_forn_pos / a.atraso_forn_n : null
});
const fornRowKey = /* @__PURE__ */ (() => {
  const ids = /* @__PURE__ */ new WeakMap();
  let n = 0;
  return (r) => {
    if (!ids.has(r)) ids.set(r, ++n);
    return ids.get(r);
  };
})();
function fornShort(name) {
  return String(name || "").replace(/[,.]?\s*(S\.?A\.?|LDA\.?|SA\.?)\s*$/i, "").trim();
}
function applyFlags(rows, flags) {
  if (!flags.size) return rows;
  const preds = [...flags].map((f) => FORN_FLAGS[f].pred);
  return rows.filter((r) => preds.every((p) => p(r)));
}
function applyBuckets(rows, buckets) {
  if (!buckets.size) return rows;
  return rows.filter((r) => buckets.has(deliveryBucket(r)));
}
const rowYm = (r) => r.ano + "-" + r.mes;
const ymLabel = (ym) => ym.slice(5) + "/" + ym.slice(0, 4);
function applyMonths(rows, months) {
  if (!months.size) return rows;
  return rows.filter((r) => months.has(rowYm(r)));
}
const chipStyle = (color) => ({
  padding: "3px 10px",
  borderRadius: 999,
  fontSize: 12,
  cursor: "pointer",
  border: "1px solid " + color,
  background: color + "14",
  color
});

// ===== bi/_shared/frontend/charts.jsx =====
function fmtMeasure(value, measure) {
  return measure === "valor" ? EUR.format(value) : INT.format(value);
}
function filterRows(rows, filters, exceptDim) {
  const dims = Object.keys(filters);
  return rows.filter((r) => {
    for (const dim of dims) {
      if (dim === exceptDim) continue;
      const sel = filters[dim];
      if (sel.size && !sel.has(r[dim])) return false;
    }
    return true;
  });
}
function aggregate(rows, dim, measure) {
  const m = /* @__PURE__ */ new Map();
  for (const r of rows) m.set(r[dim], (m.get(r[dim]) || 0) + (r[measure] || 0));
  return [...m.entries()].map(([name, value]) => ({ name, value })).sort((a, b) => b.value - a.value);
}
function EChart({ option, onSelect, onEmptyClick, height = 300 }) {
  const elRef = useRef(null);
  const instRef = useRef(null);
  const selRef = useRef(onSelect);
  selRef.current = onSelect;
  const emptyRef = useRef(onEmptyClick);
  emptyRef.current = onEmptyClick;
  useEffect(() => {
    if (!elRef.current || !window.echarts) return;
    const inst = window.echarts.init(elRef.current);
    instRef.current = inst;
    const onResize = () => inst.resize();
    window.addEventListener("resize", onResize);
    inst.on("click", (p) => selRef.current && selRef.current(p.name, p));
    inst.getZr().on("click", (event) => {
      if (!emptyRef.current || event.target) return;
      const pt = [event.offsetX, event.offsetY];
      if (!inst.containPixel({ gridIndex: 0 }, pt)) return;
      const idx = inst.convertFromPixel({ xAxisIndex: 0 }, pt);
      const cats = inst.getOption()?.xAxis?.[0]?.data;
      const cat = cats && cats[Math.round(idx)];
      if (cat != null) emptyRef.current(cat);
    });
    return () => {
      window.removeEventListener("resize", onResize);
      inst.dispose();
      instRef.current = null;
    };
  }, []);
  useEffect(() => {
    if (instRef.current && option) instRef.current.setOption(option, true);
  }, [option]);
  if (!window.echarts) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, color: "var(--muted)", fontSize: 13 } }, "Biblioteca de gr\xE1ficos n\xE3o carregou.");
  }
  return /* @__PURE__ */ React.createElement("div", { ref: elRef, style: { width: "100%", height } });
}
function DimBarChart({ title, rows, dim, measure, selected, accent, onToggle, height = 300 }) {
  const option = useMemo(() => {
    const data = aggregate(rows, dim, measure).slice(0, 15);
    const cats = data.map((d) => d.name);
    return {
      title: {
        text: title,
        left: 0,
        top: 0,
        textStyle: { fontSize: 13, fontWeight: 600, color: "#334155" }
      },
      grid: { left: 8, right: 24, top: 36, bottom: 8, containLabel: true },
      tooltip: {
        trigger: "item",
        formatter: (p) => `${p.name}<br/><b>${fmtMeasure(p.value, measure)}</b>`
      },
      xAxis: { type: "value", axisLabel: {
        formatter: (v) => measure === "valor" ? v >= 1e3 ? v / 1e3 + "k" : v : v
      } },
      yAxis: {
        type: "category",
        inverse: true,
        data: cats,
        axisLabel: { fontSize: 11, width: 110, overflow: "truncate" }
      },
      series: [{
        type: "bar",
        data: data.map((d) => ({
          name: d.name,
          value: d.value,
          itemStyle: {
            color: selected.size === 0 || selected.has(d.name) ? accent : "#cbd5e1"
          }
        })),
        barMaxWidth: 22,
        emphasis: { itemStyle: { color: accent } }
      }]
    };
  }, [rows, dim, measure, selected, accent, title]);
  return /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height,
      onSelect: (name) => onToggle(dim, name)
    }
  );
}
function KpiCard({ label, value, accent }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 10,
    padding: "12px 14px"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4
  } }, label), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 700, color: accent, marginTop: 4 } }, value));
}
function DrillTable({ rows, measure }) {
  const sorted = useMemo(
    () => [...rows].sort((a, b) => (b[measure] || 0) - (a[measure] || 0)),
    [rows, measure]
  );
  const columns = [
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 150,
      minWidth: 110,
      fixed: true,
      mono: true,
      render: (r) => r.codigo
    },
    {
      key: "descricao",
      label: "Descri\xE7\xE3o",
      width: 320,
      minWidth: 200,
      render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.descricao }, r.descricao)
    },
    { key: "vendedor", label: "Vendedor", width: 140, minWidth: 100, render: (r) => r.vendedor },
    { key: "familia", label: "Fam\xEDlia", width: 110, minWidth: 80, render: (r) => r.familia },
    {
      key: "valor",
      label: "Valor",
      width: 90,
      minWidth: 70,
      align: "right",
      mono: true,
      render: (r) => EUR.format(r.valor)
    },
    {
      key: "stock",
      label: "Stock",
      width: 80,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (r) => INT.format(r.stock)
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Detalhe"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", INT.format(rows.length), " refer\xEAncia(s)")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "charts-detalhe",
      columns,
      data: sorted,
      pagination: "client",
      rowKey: (r) => r.codigo,
      empty: "Sem refer\xEAncias."
    }
  ));
}
const VISION_ACCENT = "#1e3a5f";
const visionCard = {
  background: "var(--panel)",
  border: "1px solid var(--border)",
  borderRadius: 10,
  padding: 14
};
const visionInput = {
  padding: "7px 10px",
  borderRadius: 7,
  fontSize: 13,
  border: "1px solid var(--border)",
  background: "var(--bg)",
  color: "var(--text)",
  width: "100%",
  boxSizing: "border-box"
};
const visionBtn = (primary) => ({
  padding: "7px 14px",
  borderRadius: 7,
  fontSize: 13,
  cursor: "pointer",
  border: "1px solid " + (primary ? VISION_ACCENT : "var(--border)"),
  background: primary ? VISION_ACCENT : "var(--panel)",
  color: primary ? "#fff" : "var(--text)"
});
const QUERY_HISTORY_KEY = "vision.queryHistory";
const QUERY_HISTORY_MAX = 20;
function loadQueryHistory() {
  try {
    return JSON.parse(localStorage.getItem(QUERY_HISTORY_KEY) || "[]");
  } catch {
    return [];
  }
}
const DS_DEFAULTS = {
  trino: { port: 8080, driver: "http" },
  mssql: { port: 1433, driver: "ODBC Driver 18 for SQL Server" }
};
const EMPTY_DS = {
  name: "",
  engine: "trino",
  host: "",
  port: 8080,
  database: "",
  schema_name: "",
  username: "",
  password: "",
  driver: "http",
  is_active: true
};
function Field({ label, children }) {
  return /* @__PURE__ */ React.createElement("label", { style: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    fontSize: 12,
    color: "var(--muted)"
  } }, label, children);
}

// ===== bi/dashboard_vendas/frontend/view.jsx =====
function VisionView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [measure, setMeasure] = useState("valor");
  const [filters, setFilters] = useState({
    vendedor: /* @__PURE__ */ new Set(),
    familia: /* @__PURE__ */ new Set(),
    tipo_artigo: /* @__PURE__ */ new Set()
  });
  useEffect(() => {
    let alive = true;
    window.API.biStockFacts().then((d) => {
      if (alive) setData(d);
    }).catch((e) => {
      if (alive) setError(e.message || String(e));
    });
    return () => {
      alive = false;
    };
  }, []);
  const toggle = (dim, name) => {
    setFilters((prev) => {
      const next = { ...prev, [dim]: new Set(prev[dim]) };
      if (next[dim].has(name)) next[dim].delete(name);
      else next[dim].add(name);
      return next;
    });
  };
  const clearAll = () => setFilters({
    vendedor: /* @__PURE__ */ new Set(),
    familia: /* @__PURE__ */ new Set(),
    tipo_artigo: /* @__PURE__ */ new Set()
  });
  const rows = data?.rows || [];
  const fullyFiltered = useMemo(
    () => filterRows(rows, filters, null),
    [rows, filters]
  );
  const kpis = useMemo(() => {
    let valor = 0, stock = 0, monos = 0;
    for (const r of fullyFiltered) {
      valor += r.valor;
      stock += r.stock;
      if (r.mono) monos += 1;
    }
    return { valor, stock, monos, count: fullyFiltered.length };
  }, [fullyFiltered]);
  const activeChips = useMemo(() => {
    const chips = [];
    for (const dim of Object.keys(filters))
      for (const name of filters[dim]) chips.push({ dim, name });
    return chips;
  }, [filters]);
  if (error) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--danger, #b91c1c)" } }, "Erro ao carregar dados: ", error);
  }
  if (!data) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar dados\u2026");
  }
  const accent = "#1e3a5f";
  const card = {
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 10,
    padding: 14
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 16 } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12
  } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 700 } }, "Dashboard de Vendas"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "M\xE9trica:"), data.measures.map((m) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: m.key,
      type: "button",
      onClick: () => setMeasure(m.key),
      style: {
        padding: "5px 12px",
        borderRadius: 7,
        fontSize: 12,
        cursor: "pointer",
        border: "1px solid var(--border)",
        background: measure === m.key ? accent : "var(--panel)",
        color: measure === m.key ? "#fff" : "var(--text)"
      }
    },
    m.label
  )))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12 } }, /* @__PURE__ */ React.createElement(KpiCard, { label: "Valor total", value: EUR.format(kpis.valor), accent }), /* @__PURE__ */ React.createElement(KpiCard, { label: "Stock total", value: INT.format(kpis.stock) + " un.", accent }), /* @__PURE__ */ React.createElement(KpiCard, { label: "Refer\xEAncias", value: INT.format(kpis.count), accent }), /* @__PURE__ */ React.createElement(KpiCard, { label: "Monos", value: INT.format(kpis.monos), accent })), activeChips.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Filtros:"), activeChips.map((c) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: c.dim + c.name,
      type: "button",
      onClick: () => toggle(c.dim, c.name),
      style: {
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 12,
        cursor: "pointer",
        border: "1px solid " + accent,
        background: accent + "14",
        color: accent
      }
    },
    c.name,
    " \u2715"
  )), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: clearAll,
      style: {
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 12,
        cursor: "pointer",
        border: "1px solid var(--border)",
        background: "var(--panel)",
        color: "var(--muted)"
      }
    },
    "Limpar tudo"
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: card }, /* @__PURE__ */ React.createElement(
    DimBarChart,
    {
      title: "Por vendedor",
      dim: "vendedor",
      measure,
      rows: filterRows(rows, filters, "vendedor"),
      selected: filters.vendedor,
      accent,
      onToggle: toggle
    }
  )), /* @__PURE__ */ React.createElement("div", { style: card }, /* @__PURE__ */ React.createElement(
    DimBarChart,
    {
      title: "Por fam\xEDlia",
      dim: "familia",
      measure,
      rows: filterRows(rows, filters, "familia"),
      selected: filters.familia,
      accent,
      onToggle: toggle
    }
  )), /* @__PURE__ */ React.createElement("div", { style: card }, /* @__PURE__ */ React.createElement(
    DimBarChart,
    {
      title: "Por tipo de artigo",
      dim: "tipo_artigo",
      measure,
      rows: filterRows(rows, filters, "tipo_artigo"),
      selected: filters.tipo_artigo,
      accent,
      onToggle: toggle
    }
  ))), /* @__PURE__ */ React.createElement(DrillTable, { rows: fullyFiltered, measure }));
}
Object.assign(window, { VisionView });

// ===== bi/fornecedores/frontend/view.jsx =====
const FORN_LT_ORIGEM = { forcado: "LT for\xE7ado \xE0 m\xE3o", ref_forn: "LT da ref+fornecedor", cartao: "LT do cart\xE3o do fornecedor" };
const FORN_LT_ORIGEM_SIGLA = { forcado: "F", ref_forn: "RF", cartao: "C" };
function FornecedoresView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [measure, setMeasure] = useState("valor");
  const [ano, setAno] = useState(() => (/* @__PURE__ */ new Date()).getFullYear());
  const [filters, setFilters] = useState({
    cliente: /* @__PURE__ */ new Set(),
    fornecedor: /* @__PURE__ */ new Set(),
    qualidade: /* @__PURE__ */ new Set(),
    armrec: /* @__PURE__ */ new Set()
  });
  const [flags, setFlags] = useState(/* @__PURE__ */ new Set());
  const [buckets, setBuckets] = useState(/* @__PURE__ */ new Set());
  const [months, setMonths] = useState(/* @__PURE__ */ new Set());
  const [otdPorOmissao, setOtdPorOmissao] = useState({ soComConf: false, d1ATempo: false });
  const [otdUrl, setOtdUrl] = useState(() => window.HubRouter.current().params);
  useEffect(() => window.HubRouter.subscribe(
    () => setOtdUrl(window.HubRouter.current().params)
  ), []);
  useEffect(() => {
    let alive = true;
    window.API.biOtdOpcoes().then((o) => {
      if (alive) setOtdPorOmissao({
        soComConf: !!o.so_com_data_confirmada,
        d1ATempo: !!o.d1_a_tempo
      });
    }).catch(() => {
    });
    return () => {
      alive = false;
    };
  }, []);
  const otdOpt = (param, omissao) => {
    const v = otdUrl.get(param);
    return v == null ? omissao : v === "1";
  };
  const otd = {
    soComConf: otdOpt("otd_so_conf", otdPorOmissao.soComConf),
    d1ATempo: otdOpt("otd_d1", otdPorOmissao.d1ATempo)
  };
  const setOtd = (param, valor, omissao) => window.HubRouter.setParams(
    // Igual ao valor por omissão → sai do URL, o link fica limpo.
    { [param]: valor === omissao ? null : valor ? "1" : "0" }
  );
  useEffect(() => {
    let alive = true;
    window.API.biFornecedores().then((d) => {
      if (alive) setData(d);
    }).catch((e) => {
      if (!alive) return;
      const m = String(e.message || e);
      const j = m.match(/\{.*\}$/s);
      try {
        setError(j ? JSON.parse(j[0]).error : m);
      } catch {
        setError(m);
      }
    });
    return () => {
      alive = false;
    };
  }, []);
  const toggle = (dim, name) => setFilters((prev) => {
    const next = { ...prev, [dim]: new Set(prev[dim]) };
    if (next[dim].has(name)) next[dim].delete(name);
    else next[dim].add(name);
    return next;
  });
  const toggleFlag = (key) => setFlags((prev) => {
    const next = new Set(prev);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    return next;
  });
  const pickFlag = (flag, sibling) => setFlags((prev) => {
    const next = new Set(prev);
    if (next.has(flag)) next.delete(flag);
    else {
      next.add(flag);
      [].concat(sibling).forEach((s) => next.delete(s));
    }
    return next;
  });
  const toggleBucket = (key) => setBuckets((prev) => {
    const next = new Set(prev);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    return next;
  });
  const toggleMonth = (ym) => setMonths((prev) => {
    const next = new Set(prev);
    if (next.has(ym)) next.delete(ym);
    else next.add(ym);
    return next;
  });
  const onMonthSegment = (ym, bucketKey) => {
    const onlyM = months.size === 1 && months.has(ym);
    const onlyB = buckets.size === 1 && buckets.has(bucketKey);
    if (onlyM && buckets.size === 0) {
      setBuckets(/* @__PURE__ */ new Set([bucketKey]));
    } else if (onlyM && onlyB) {
      setMonths(/* @__PURE__ */ new Set());
    } else if (months.size === 0 && onlyB) {
      setBuckets(/* @__PURE__ */ new Set());
    } else {
      setMonths(/* @__PURE__ */ new Set([ym]));
      setBuckets(/* @__PURE__ */ new Set());
    }
  };
  const evolYm = otdUrl.get("evol") === "dia" ? otdUrl.get("evol_mes") : null;
  const evolNivel = evolYm ? "dia" : "mes";
  const abrirDias = (ym) => {
    setMonths(/* @__PURE__ */ new Set([ym]));
    window.HubRouter.setParams({ evol: "dia", evol_mes: ym }, { replace: false });
  };
  const voltarMeses = () => window.HubRouter.setParams({ evol: null, evol_mes: null });
  const toggleBucketUnico = (key) => setBuckets((prev) => prev.size === 1 && prev.has(key) ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([key]));
  const clearAll = () => {
    setFilters({
      cliente: /* @__PURE__ */ new Set(),
      fornecedor: /* @__PURE__ */ new Set(),
      qualidade: /* @__PURE__ */ new Set(),
      armrec: /* @__PURE__ */ new Set()
    });
    setFlags(/* @__PURE__ */ new Set());
    setBuckets(/* @__PURE__ */ new Set());
    setMonths(/* @__PURE__ */ new Set());
  };
  const anos = useMemo(() => {
    const s = new Set((data?.rows || []).map((r) => r.ano));
    return [...s].sort();
  }, [data]);
  useEffect(() => {
    if (anos.length && ano !== "all" && !anos.includes(ano)) setAno(anos[anos.length - 1]);
  }, [anos]);
  const anoRows = useMemo(() => {
    const rows = data?.rows || [];
    return ano === "all" ? rows : rows.filter((r) => r.ano === ano);
  }, [data, ano]);
  const filterOptions = useMemo(() => {
    const seen = {
      cliente: /* @__PURE__ */ new Set(),
      fornecedor: /* @__PURE__ */ new Set(),
      qualidade: /* @__PURE__ */ new Set(),
      armrec: /* @__PURE__ */ new Set()
    };
    const out = [];
    for (const r of data?.rows || []) {
      for (const { key } of FORN_DIMS) {
        const val = r[key];
        if (val && !seen[key].has(val)) {
          seen[key].add(val);
          out.push({ dim: key, value: val });
        }
      }
    }
    return out;
  }, [data]);
  const dimFiltered = useMemo(
    () => filterRows(anoRows, filters, null),
    [anoRows, filters]
  );
  const flagFiltered = useMemo(
    () => applyFlags(dimFiltered, flags),
    [dimFiltered, flags]
  );
  const fullyFiltered = useMemo(
    () => applyMonths(applyBuckets(flagFiltered, buckets), months),
    [flagFiltered, buckets, months]
  );
  const rowsFor = (dim) => applyMonths(
    applyBuckets(applyFlags(filterRows(anoRows, filters, dim), flags), buckets),
    months
  );
  const kpi = useMemo(
    () => fornDerive(fornSum(fullyFiltered), otd),
    [fullyFiltered, otd.soComConf, otd.d1ATempo]
  );
  const activeChips = useMemo(() => {
    const chips = [];
    for (const dim of Object.keys(filters))
      for (const name of filters[dim]) chips.push({ kind: "dim", dim, name });
    for (const f of flags) chips.push({ kind: "flag", key: f });
    for (const b of buckets) chips.push({ kind: "bucket", key: b });
    for (const m of months) chips.push({ kind: "month", ym: m });
    return chips;
  }, [filters, flags, buckets, months]);
  if (error) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: FORN_RED } }, "Erro ao carregar dados: ", error);
  }
  if (!data) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar dados do Trino\u2026");
  }
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 16 } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12
  } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 700 } }, "Servi\xE7o de Fornecedores de Cart\xE3o"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Ano:"), ["all", ...anos].map((a) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: a,
      type: "button",
      onClick: () => setAno(a),
      style: { ...visionBtn(ano === a), padding: "5px 12px", fontSize: 12 }
    },
    a === "all" ? "Todos" : a
  ))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "M\xE9trica:"), FORN_MEASURES.map((m) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: m.key,
      type: "button",
      onClick: () => setMeasure(m.key),
      style: { ...visionBtn(measure === m.key), padding: "5px 12px", fontSize: 12 }
    },
    m.label
  ))), /* @__PURE__ */ React.createElement(
    "a",
    {
      href: "/api/bi/fornecedores/pdf-zip",
      target: "_blank",
      rel: "noopener",
      className: "vision-btn-export",
      style: {
        ...visionBtn(false),
        padding: "5px 12px",
        fontSize: 12,
        textDecoration: "none",
        display: "inline-block"
      }
    },
    "Exportar PDFs (ZIP)"
  ))), /* @__PURE__ */ React.createElement(
    FornFilterBar,
    {
      options: filterOptions,
      filters,
      onAdd: (dim, value) => toggle(dim, value)
    }
  ), activeChips.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Filtros:"), activeChips.map((c) => {
    if (c.kind === "dim") return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: "d:" + c.dim + c.name,
        type: "button",
        onClick: () => toggle(c.dim, c.name),
        style: chipStyle(FORN_ACCENT)
      },
      (c.dim === "fornecedor" ? fornShort(c.name) : c.name) || c.name,
      " \u2715"
    );
    if (c.kind === "bucket") {
      const b = DELIVERY_BUCKETS.find((x) => x.key === c.key);
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: "b:" + c.key,
          type: "button",
          onClick: () => toggleBucket(c.key),
          style: chipStyle(b.color)
        },
        b.label,
        " \u2715"
      );
    }
    if (c.kind === "month") return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: "m:" + c.ym,
        type: "button",
        onClick: () => toggleMonth(c.ym),
        style: chipStyle("#6d28d9")
      },
      "M\xEAs ",
      ymLabel(c.ym),
      " \u2715"
    );
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: "f:" + c.key,
        type: "button",
        onClick: () => toggleFlag(c.key),
        style: chipStyle(FORN_AMBER)
      },
      FORN_FLAGS[c.key].label,
      " \u2715"
    );
  }), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: clearAll,
      style: {
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 12,
        cursor: "pointer",
        border: "1px solid var(--border)",
        background: "var(--panel)",
        color: "var(--muted)"
      }
    },
    "Limpar tudo"
  )), /* @__PURE__ */ React.createElement("div", { className: "vision-kpi-grid" }, /* @__PURE__ */ React.createElement(FornKpi, { label: "Encomendas", value: INT.format(kpi.encomendas) }), /* @__PURE__ */ React.createElement(FornKpi, { label: "Valor de compras", value: EUR.format(kpi.valor) }), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "OTD data confirmada" + (otd.soComConf ? " \xB7 s\xF3 c/ data conf." : "") + (otd.d1ATempo ? " \xB7 D+1 a tempo" : ""),
      value: PCT1(kpi.otdConf),
      color: otdColor(kpi.otdConf),
      sub: "clicar: ver atrasos",
      active: flags.has("late_conf"),
      onClick: () => toggleFlag("late_conf"),
      extra: /* @__PURE__ */ React.createElement(
        "div",
        {
          style: { marginTop: 6, display: "flex", flexDirection: "column", gap: 2 },
          onClick: (e) => e.stopPropagation()
        },
        /* @__PURE__ */ React.createElement("label", { style: { fontSize: 11, display: "flex", gap: 5, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            checked: otd.soComConf,
            onChange: (e) => setOtd("otd_so_conf", e.target.checked, otdPorOmissao.soComConf)
          }
        ), "S\xF3 com data confirmada"),
        /* @__PURE__ */ React.createElement("label", { style: { fontSize: 11, display: "flex", gap: 5, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            checked: otd.d1ATempo,
            onChange: (e) => setOtd("otd_d1", e.target.checked, otdPorOmissao.d1ATempo)
          }
        ), "D+1 conta a tempo")
      )
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "OTD data solicitada",
      value: PCT1(kpi.otdSol),
      color: otdColor(kpi.otdSol),
      sub: "clicar: ver atrasos",
      active: flags.has("late_sol"),
      onClick: () => toggleFlag("late_sol")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Lead time real",
      value: DAYS1(kpi.ltReal),
      sub: kpi.ltContr != null ? "contratado: " + DAYS1(kpi.ltContr) : null
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Atraso m\xE9dio do fornecedor",
      value: DAYS1(kpi.atrasoForn),
      color: kpi.atrasoForn > 0 ? FORN_RED : void 0,
      sub: kpi.atrasoFornPct != null ? PCT1(kpi.atrasoFornPct) + " das linhas \xB7 rece\xE7\xE3o \u2212 confirmada" : "rece\xE7\xE3o \u2212 confirmada"
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Reqs SOS",
      value: INT.format(kpi.sos),
      color: kpi.sos > 0 ? FORN_AMBER : void 0,
      sub: "clicar: filtrar SOS",
      active: flags.has("sos"),
      onClick: () => toggleFlag("sos")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Reqs antecipadas",
      value: INT.format(kpi.antecipada),
      color: kpi.antecipada > 0 ? FORN_AMBER : void 0,
      sub: "clicar: filtrar antecipadas",
      active: flags.has("antecipada"),
      onClick: () => toggleFlag("antecipada")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Sem data confirmada",
      value: INT.format(kpi.sem_conf),
      color: kpi.sem_conf > 0 ? FORN_AMBER : void 0,
      sub: "\u2248 " + PCT1(kpi.semConfPct) + " \xB7 clicar: filtrar",
      active: flags.has("sem_conf"),
      onClick: () => toggleFlag("sem_conf")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Entregas D+1 (data conf.)",
      value: INT.format(kpi.rec_d1_conf),
      sub: "\u2248 " + PCT1(kpi.recD1ConfPct) + " \xB7 clicar: filtrar",
      active: flags.has("rec_d1_conf"),
      onClick: () => toggleFlag("rec_d1_conf")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpiSeg,
    {
      label: "Req. vs 8 dias da solicitada",
      value: INT.format(kpi.req_8d),
      sub: "> 8 dias \u2248 " + PCT1(kpi.req8dPct),
      flags,
      onPick: pickFlag,
      segments: [
        { flag: "req_8d", sibling: "req_le8d", label: "> 8d" },
        { flag: "req_le8d", sibling: "req_8d", label: "\u2264 8d" }
      ]
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpiSeg,
    {
      label: "Req. vs LT te\xF3rico",
      value: INT.format(kpi.below_lt),
      color: kpi.below_lt > 0 ? FORN_RED : void 0,
      sub: "abaixo \u2248 " + PCT1(kpi.belowLtPct) + " das c/ LT \xB7 " + INT.format(kpi.sem_lt) + " sem LT",
      flags,
      onPick: pickFlag,
      segments: [
        { flag: "below_lt", sibling: ["at_above_lt", "sem_lt"], label: "< LT" },
        { flag: "at_above_lt", sibling: ["below_lt", "sem_lt"], label: "\u2265 LT" },
        { flag: "sem_lt", sibling: ["below_lt", "at_above_lt"], label: "sem LT" }
      ]
    }
  ), /* @__PURE__ */ React.createElement("div", { style: {
    gridColumn: "span 2",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 10,
    padding: "6px 10px"
  } }, /* @__PURE__ */ React.createElement(
    FornDimBar,
    {
      title: "Rece\xE7\xF5es por armaz\xE9m",
      rows: rowsFor("armrec"),
      dim: "armrec",
      measure,
      selected: filters.armrec,
      emptyLabel: "(sem armaz\xE9m)",
      onToggle: (n) => toggle("armrec", n),
      height: 108
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "vision-chart-grid" }, /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    FornDimBar,
    {
      title: "Por fornecedor",
      rows: rowsFor("fornecedor"),
      dim: "fornecedor",
      measure,
      selected: filters.fornecedor,
      shorten: fornShort,
      onToggle: (n) => toggle("fornecedor", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    FornDimBar,
    {
      title: "Por cliente",
      rows: rowsFor("cliente"),
      dim: "cliente",
      measure,
      selected: filters.cliente,
      onToggle: (n) => toggle("cliente", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    FornDimBar,
    {
      title: "Por qualidade de cart\xE3o",
      rows: rowsFor("qualidade"),
      dim: "qualidade",
      measure,
      selected: filters.qualidade,
      emptyLabel: "(sem qualidade)",
      onToggle: (n) => toggle("qualidade", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    FornLeadTimeChart,
    {
      rows: rowsFor("fornecedor"),
      onToggle: (n) => toggle("fornecedor", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, gridColumn: "1 / -1" } }, /* @__PURE__ */ React.createElement(
    FornMonthlyChart,
    {
      rows: flagFiltered,
      selectedBuckets: buckets,
      selectedMonths: months,
      onSegment: onMonthSegment,
      onMonthPick: toggleMonth,
      nivel: evolNivel,
      ymAberto: evolYm,
      onAbrir: abrirDias,
      onVoltar: voltarMeses,
      onDiaSegment: toggleBucketUnico
    }
  ))), /* @__PURE__ */ React.createElement(FornRatingsPanel, null), /* @__PURE__ */ React.createElement(FornDetailTable, { rows: fullyFiltered }));
}
const FORN_RATING_LETTER_ORDER = { A: 0, B: 1, C: 2, D: 3 };
function FornRatingsPanel() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState("mes");
  useEffect(() => {
    let alive = true;
    window.API.biFornecedoresRatings().then((r) => {
      if (alive) setData(r.ratings || []);
    }).catch((e) => alive && setError(e.message || String(e)));
    return () => {
      alive = false;
    };
  }, []);
  const sorted = useMemo(() => {
    if (!data) return [];
    const key = tab;
    return [...data].sort((a, b) => {
      const la = FORN_RATING_LETTER_ORDER[a[key].letter] ?? 4;
      const lb = FORN_RATING_LETTER_ORDER[b[key].letter] ?? 4;
      if (la !== lb) return la - lb;
      return (b[key].score || 0) - (a[key].score || 0);
    });
  }, [data, tab]);
  const letterColor = (l) => ({
    A: "#15803d",
    B: "#ca8a04",
    C: "#ea580c",
    D: "#b91c1c"
  })[l] || "var(--muted)";
  const compCell = (row, key) => {
    const c = (row[tab].components || []).find((x) => x.key === key);
    if (!c) return "\u2014";
    if (c.not_available) return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014");
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        style: { color: letterColor(c.letter), fontWeight: 600 },
        title: `peso ${c.weight}% \xB7 score ${c.score?.toFixed(1)}%`
      },
      c.contribution.toFixed(1),
      " %"
    );
  };
  const compSortValue = (row, key) => {
    const c = (row[tab].components || []).find((x) => x.key === key);
    return c && !c.not_available ? c.contribution : null;
  };
  const columns = [
    {
      key: "letra",
      label: "Letra",
      width: 70,
      minWidth: 55,
      align: "center",
      sortValue: (row) => FORN_RATING_LETTER_ORDER[row[tab].letter] ?? 4,
      render: (row) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement("span", { style: {
        display: "inline-block",
        minWidth: 22,
        textAlign: "center",
        background: letterColor(row[tab].letter),
        color: "white",
        fontWeight: 700,
        fontSize: 12,
        padding: "2px 6px",
        borderRadius: 4
      } }, row[tab].letter))
    },
    {
      key: "score",
      label: "Score",
      width: 80,
      minWidth: 65,
      align: "right",
      mono: true,
      sortValue: (row) => row[tab].score || 0,
      render: (row) => /* @__PURE__ */ React.createElement("span", { style: { color: letterColor(row[tab].letter), fontWeight: 600 } }, row[tab].score?.toFixed(1), " %")
    },
    {
      key: "fornecedor",
      label: "Fornecedor",
      width: 200,
      minWidth: 140,
      fixed: true,
      render: (row) => /* @__PURE__ */ React.createElement("span", { title: row.fornecedor }, fornShort(row.fornecedor))
    },
    {
      key: "phc_no",
      label: "N\xBA PHC",
      width: 90,
      minWidth: 70,
      align: "right",
      mono: true,
      render: (row) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, row.phc_no ?? "\u2014")
    },
    {
      key: "cert",
      label: "Certif.",
      width: 90,
      minWidth: 70,
      sortValue: (row) => compSortValue(row, "cert"),
      render: (row) => compCell(row, "cert")
    },
    {
      key: "otd",
      label: "OTD",
      width: 90,
      minWidth: 70,
      sortValue: (row) => compSortValue(row, "otd"),
      render: (row) => compCell(row, "otd")
    },
    {
      key: "claims",
      label: "Reclama\xE7\xF5es",
      width: 110,
      minWidth: 90,
      sortValue: (row) => compSortValue(row, "claims"),
      render: (row) => compCell(row, "claims")
    },
    {
      key: "qualitative",
      label: "Qualitativa",
      width: 110,
      minWidth: 90,
      sortValue: (row) => compSortValue(row, "qualitative"),
      render: (row) => compCell(row, "qualitative")
    },
    {
      key: "action",
      label: "A\xE7\xE3o",
      width: 260,
      minWidth: 160,
      sortable: false,
      render: (row) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 }, title: row[tab].action }, row[tab].action)
    }
  ];
  if (error) {
    return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: FORN_RED } }, "Erro nos ratings: ", error);
  }
  if (!data) {
    return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: "var(--muted)", fontSize: 13 } }, "A calcular\u2026");
  }
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Ranking de classifica\xE7\xE3o de fornecedores"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginLeft: "auto" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: {
        ...visionBtn(tab === "mes"),
        padding: "4px 10px",
        fontSize: 12
      },
      onClick: () => setTab("mes")
    },
    "M\xEAs"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: {
        ...visionBtn(tab === "ytd"),
        padding: "4px 10px",
        fontSize: 12
      },
      onClick: () => setTab("ytd")
    },
    "YTD"
  ))), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "fornecedores-ratings",
      columns,
      data: sorted,
      pagination: "client",
      rowKey: (row) => row.fornecedor,
      empty: "Nenhum fornecedor com classifica\xE7\xE3o configurada. Vai a Configura\xE7\xF5es \u2192 Fornecedores \u2192 Classifica\xE7\xE3o para adicionar."
    }
  ));
}
function FornFilterBar({ options, filters, onAdd }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const matches = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return [];
    const out = [];
    for (const o of options) {
      if (filters[o.dim].has(o.value)) continue;
      if (o.value.toLowerCase().includes(needle)) out.push(o);
      if (out.length >= 30) break;
    }
    return out;
  }, [q, options, filters]);
  const add = (o) => {
    onAdd(o.dim, o.value);
    setQ("");
    setOpen(false);
  };
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: q,
      placeholder: "Filtrar por cliente, fornecedor ou qualidade de cart\xE3o\u2026",
      onChange: (e) => {
        setQ(e.target.value);
        setOpen(true);
      },
      onFocus: () => setOpen(true),
      onBlur: () => setTimeout(() => setOpen(false), 150),
      onKeyDown: (e) => {
        if (e.key === "Enter" && matches[0]) add(matches[0]);
      },
      style: {
        width: "100%",
        boxSizing: "border-box",
        padding: "9px 12px",
        fontSize: 13,
        borderRadius: 8,
        border: "1px solid var(--border)",
        background: "var(--panel)",
        color: "var(--text, inherit)"
      }
    }
  ), open && matches.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    zIndex: 20,
    top: "100%",
    left: 0,
    right: 0,
    marginTop: 4,
    maxHeight: 280,
    overflowY: "auto",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)"
  } }, matches.map((o) => {
    const meta = FORN_DIMS.find((d) => d.key === o.dim);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: o.dim + ":" + o.value,
        onMouseDown: () => add(o),
        style: {
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "7px 12px",
          cursor: "pointer",
          fontSize: 13,
          borderBottom: "1px solid var(--border)"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        ...chipStyle(FORN_ACCENT),
        padding: "1px 8px",
        cursor: "default",
        fontSize: 11
      } }, meta.label),
      /* @__PURE__ */ React.createElement("span", null, o.dim === "fornecedor" ? fornShort(o.value) : o.value)
    );
  })));
}
function FornKpi({ label, value, sub, color, active, onClick, extra }) {
  const clickable = !!onClick;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick,
      role: clickable ? "button" : void 0,
      style: {
        background: active ? FORN_ACCENT + "0e" : "var(--panel)",
        border: "1px solid " + (active ? FORN_ACCENT : "var(--border)"),
        borderRadius: 10,
        padding: "12px 14px",
        cursor: clickable ? "pointer" : "default",
        boxShadow: active ? "inset 0 0 0 1px " + FORN_ACCENT : void 0
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 11,
      color: "var(--muted)",
      textTransform: "uppercase",
      letterSpacing: 0.4
    } }, label),
    /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 22,
      fontWeight: 700,
      marginTop: 4,
      color: color || FORN_ACCENT
    } }, value),
    sub && /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 11,
      color: active ? FORN_ACCENT : "var(--muted)",
      marginTop: 2
    } }, sub),
    extra
  );
}
function FornKpiSeg({ label, value, sub, color, segments, flags, onPick }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 10,
    padding: "12px 14px"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4
  } }, label), /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 22,
    fontWeight: 700,
    marginTop: 4,
    color: color || FORN_ACCENT
  } }, value), sub && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 2 } }, sub), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 8 } }, segments.map((s) => {
    const on = flags.has(s.flag);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: s.flag,
        type: "button",
        onClick: () => onPick(s.flag, s.sibling),
        style: {
          flex: 1,
          padding: "3px 8px",
          fontSize: 11,
          borderRadius: 6,
          cursor: "pointer",
          fontWeight: 600,
          border: "1px solid " + (on ? FORN_ACCENT : "var(--border)"),
          background: on ? FORN_ACCENT : "var(--panel)",
          color: on ? "#fff" : "var(--muted)"
        }
      },
      s.label
    );
  })));
}
function FornDimPie({ title, rows, dim, measure, selected, onToggle, emptyLabel, by, fmt }) {
  const aggregate = by || fornBy;
  const fmtFor = fmt || fornFmt;
  const label = (name) => name === "" || name == null ? emptyLabel || "(vazio)" : name;
  const byLabel = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    for (const [name] of aggregate(rows, dim)) m.set(label(name), name);
    return m;
  }, [rows, dim]);
  const option = useMemo(() => {
    const f = fmtFor(measure);
    const data = [...aggregate(rows, dim).entries()].map(([name, a]) => ({ name: label(name), value: a[measure] })).sort((a, b) => b.value - a.value);
    return {
      title: {
        text: title,
        left: 0,
        top: 0,
        textStyle: { fontSize: 13, fontWeight: 600, color: "#334155" }
      },
      tooltip: {
        trigger: "item",
        formatter: (p) => `${p.name}<br/><b>${f(p.value)}</b> (${p.percent}%)`
      },
      legend: { bottom: 0, itemWidth: 12, itemHeight: 9, textStyle: { fontSize: 11 } },
      series: [{
        type: "pie",
        radius: ["45%", "66%"],
        center: ["50%", "48%"],
        label: { show: false },
        data: data.map((d) => ({
          name: d.name,
          value: d.value,
          itemStyle: selected.size && !selected.has(byLabel.get(d.name)) ? { opacity: 0.3 } : void 0
        }))
      }]
    };
  }, [rows, dim, measure, selected, title]);
  return /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height: 230,
      onSelect: (lbl) => onToggle(byLabel.get(lbl) ?? lbl)
    }
  );
}
function FornDimBar({ title, rows, dim, measure, selected, onToggle, shorten, emptyLabel, height = 280 }) {
  const label = (name) => name === "" || name == null ? emptyLabel || "(vazio)" : shorten ? shorten(name) : name;
  const byLabel = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    for (const [name] of fornBy(rows, dim)) m.set(label(name), name);
    return m;
  }, [rows, dim]);
  const sortedData = useMemo(() => [...fornBy(rows, dim).entries()].map(([name, a]) => ({ name, value: a[measure] })).sort((a, b) => b.value - a.value).slice(0, 15), [rows, dim, measure]);
  const option = useMemo(() => {
    const fmt = fornFmt(measure);
    return {
      title: {
        text: title,
        left: 0,
        top: 0,
        textStyle: { fontSize: 13, fontWeight: 600, color: "#334155" }
      },
      grid: { left: 8, right: 24, top: 32, bottom: 8, containLabel: true },
      tooltip: {
        trigger: "item",
        formatter: (p) => `${p.name}<br/><b>${fmt(p.value)}</b>`
      },
      xAxis: { type: "value", axisLabel: {
        formatter: (v) => v >= 1e6 ? v / 1e6 + "M" : v >= 1e3 ? v / 1e3 + "k" : v
      } },
      yAxis: {
        type: "category",
        inverse: true,
        data: sortedData.map((d) => label(d.name)),
        axisLabel: { fontSize: 11, width: 150, overflow: "truncate" }
      },
      series: [{
        type: "bar",
        barMaxWidth: 22,
        data: sortedData.map((d) => ({
          name: label(d.name),
          value: d.value,
          itemStyle: { color: selected.size === 0 || selected.has(d.name) ? FORN_ACCENT : "#cbd5e1" }
        })),
        emphasis: { itemStyle: { color: FORN_ACCENT } }
      }]
    };
  }, [sortedData, measure, selected, title]);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height,
      onSelect: (lbl) => onToggle(byLabel.get(lbl) ?? lbl)
    }
  ), dim === "fornecedor" && sortedData.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px 8px",
    marginTop: 6,
    paddingLeft: 4
  } }, sortedData.map((d) => /* @__PURE__ */ React.createElement(
    "a",
    {
      key: d.name,
      href: `/api/bi/fornecedores/${encodeURIComponent(d.name)}/pdf`,
      target: "_blank",
      rel: "noopener",
      title: `Exportar PDF \u2014 ${label(d.name)}`,
      onClick: (e) => e.stopPropagation(),
      style: {
        fontSize: 11,
        padding: "1px 6px",
        borderRadius: 4,
        border: "1px solid var(--border)",
        background: "var(--panel)",
        color: "var(--text)",
        textDecoration: "none"
      }
    },
    label(d.name),
    " PDF"
  ))));
}
function deliveryBucket(r) {
  if (!(r.atraso_conf > 0)) return r.atraso_sol > 0 ? "conf" : "sol";
  return r.rec_d1_conf > 0 ? "d1" : "late";
}
const DELIVERY_BUCKETS = [
  { key: "sol", label: "At\xE9 \xE0 data solicitada", color: FORN_GREEN },
  { key: "conf", label: "At\xE9 \xE0 confirmada (ap\xF3s solic.)", color: "#0d9488" },
  { key: "d1", label: "Dia seguinte (D+1)", color: FORN_AMBER },
  { key: "late", label: "Atraso > 1 dia", color: FORN_RED }
];
function fornDia(r) {
  const ym = rowYm(r);
  return r.datareq && String(r.datareq).slice(0, 7) === ym ? r.datareq : ym + "-01";
}
function fornEvolucao(rows, nivel, ym) {
  const por = /* @__PURE__ */ new Map();
  for (const r of rows) {
    if (nivel === "dia" && rowYm(r) !== ym) continue;
    const k = nivel === "dia" ? fornDia(r) : rowYm(r);
    let a = por.get(k);
    if (!a) {
      a = { sol: 0, conf: 0, d1: 0, late: 0 };
      por.set(k, a);
    }
    a[deliveryBucket(r)] += 1;
  }
  const chaves = [...por.keys()].sort();
  const ag = chaves.map((k) => por.get(k));
  const total = ag.map((a) => a.sol + a.conf + a.d1 + a.late);
  const pct = ag.map((a, i) => total[i] ? +((a.sol + a.conf + a.d1) / total[i] * 100).toFixed(1) : null);
  return { chaves, ag, total, pct };
}
const FORN_LINHA_PCT = "#1d4ed8";
function FornMonthlyChart({
  rows,
  selectedBuckets,
  selectedMonths,
  onSegment,
  onMonthPick,
  nivel,
  ymAberto,
  onAbrir,
  onVoltar,
  onDiaSegment
}) {
  const dia = nivel === "dia";
  const { option, labelToKey } = useMemo(() => {
    const dimBucket = (key) => selectedBuckets && selectedBuckets.size && !selectedBuckets.has(key);
    const pinMonth = (ym) => !dia && selectedMonths && selectedMonths.size && !selectedMonths.has(ym);
    const { chaves, ag, total, pct } = fornEvolucao(rows, nivel, ymAberto);
    const labels = chaves.map((k) => dia ? k.slice(8) : k.slice(5) + "/" + k.slice(2, 4));
    const labelToKey2 = new Map(labels.map((l, i) => [l, chaves[i]]));
    const barra = (b, stack) => ({
      name: b.label,
      type: "bar",
      stack,
      barMaxWidth: 18,
      yAxisIndex: 0,
      data: ag.map((a, i) => ({
        value: a[b.key],
        itemStyle: { color: dimBucket(b.key) || pinMonth(chaves[i]) ? b.color + "40" : b.color }
      }))
    });
    const [sol, conf, d1, late] = DELIVERY_BUCKETS;
    const option2 = {
      title: {
        text: dia ? "Evolu\xE7\xE3o di\xE1ria \u2014 " + ymLabel(ymAberto) : "Evolu\xE7\xE3o mensal",
        subtext: "linhas de encomenda",
        left: 0,
        top: 0,
        textStyle: { fontSize: 13, fontWeight: 600, color: "#334155" },
        subtextStyle: { fontSize: 10 }
      },
      grid: { left: 8, right: 8, top: 44, bottom: 44, containLabel: true },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (ps) => {
          const i = ps[0].dataIndex;
          const a = ag[i];
          const ate = a.sol + a.conf + a.d1;
          const p = pct[i];
          return ps[0].axisValue + ` \u2014 ${total[i]} linhas<br/>At\xE9 D+1: <b>${ate}</b> \xB7 Atraso > 1 dia: <b>${a.late}</b>` + ps.filter((x) => x.seriesType === "bar").map(
            (x) => `<br/>${x.marker} ${x.seriesName}: <b>${x.value}</b>`
          ).join("") + `<br/>% at\xE9 D+1: <b>${p == null ? "\u2014" : p.toFixed(1).replace(".", ",") + " %"}</b>`;
        }
      },
      legend: { bottom: 0, itemWidth: 12, itemHeight: 9, textStyle: { fontSize: 10 } },
      xAxis: { type: "category", data: labels, axisLabel: { fontSize: 10 } },
      yAxis: [
        {
          type: "value",
          axisLabel: { fontSize: 10 },
          name: "linhas",
          nameTextStyle: { fontSize: 10 }
        },
        {
          type: "value",
          min: 0,
          max: 100,
          axisLabel: { fontSize: 10, formatter: "{value} %" },
          splitLine: { show: false }
        }
      ],
      series: [
        barra(sol, "ate"),
        barra(conf, "ate"),
        barra(d1, "ate"),
        barra(late, "atraso"),
        {
          name: "% at\xE9 D+1",
          type: "line",
          yAxisIndex: 1,
          data: pct,
          connectNulls: true,
          symbolSize: 5,
          lineStyle: { color: FORN_LINHA_PCT, width: 2 },
          itemStyle: { color: FORN_LINHA_PCT }
        }
      ]
    };
    return { option: option2, labelToKey: labelToKey2 };
  }, [rows, selectedBuckets, selectedMonths, nivel, ymAberto, dia]);
  const unico = selectedMonths && selectedMonths.size === 1 ? [...selectedMonths][0] : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, dia && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: onVoltar,
      className: "forn-evol-voltar",
      style: { ...chipStyle("#6d28d9"), alignSelf: "flex-start", marginBottom: 4 }
    },
    "\u2190 meses"
  ), !dia && unico && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => onAbrir(unico),
      className: "forn-evol-abrir",
      style: { ...chipStyle("#6d28d9"), marginBottom: 4 }
    },
    "Ver dias de ",
    ymLabel(unico),
    " \u2192"
  ), /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height: 300,
      onSelect: (name, p) => {
        const k = labelToKey.get(name);
        const b = DELIVERY_BUCKETS.find((x) => x.label === (p && p.seriesName));
        if (!b || !k) return;
        if (dia) onDiaSegment(b.key);
        else onSegment(k, b.key);
      },
      onEmptyClick: (name) => {
        const k = labelToKey.get(name);
        if (k && !dia) onMonthPick(k);
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 2, textAlign: "center" } }, dia ? "Clica numa cor para filtrar \xB7 \xAB\u2190 meses\xBB volta ao m\xEAs a m\xEAs" : "Clica na barra: 1\xD7 m\xEAs \xB7 2\xD7 cor no m\xEAs \xB7 3\xD7 cor \xB7 4\xD7 limpa"));
}
function FornLeadTimeChart({ rows, onToggle }) {
  const byShort = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    for (const [name] of fornBy(rows, "fornecedor")) m.set(fornShort(name), name);
    return m;
  }, [rows]);
  const option = useMemo(() => {
    const data = [...fornBy(rows, "fornecedor").entries()].map(([name, a]) => ({ name, ...fornDerive(a) })).sort((a, b) => b.encomendas - a.encomendas).slice(0, 8);
    return {
      title: {
        text: "Lead time \u2014 real vs contratado (dias)",
        left: 0,
        top: 0,
        textStyle: { fontSize: 13, fontWeight: 600, color: "#334155" }
      },
      grid: { left: 8, right: 24, top: 32, bottom: 28, containLabel: true },
      tooltip: {
        trigger: "axis",
        formatter: (ps) => ps[0].name + ps.map(
          (p) => `<br/>${p.marker} ${p.seriesName}: <b>${DAYS1(p.value)}</b>`
        ).join("")
      },
      legend: { bottom: 0, itemWidth: 14, itemHeight: 9, textStyle: { fontSize: 11 } },
      xAxis: { type: "value", axisLabel: { fontSize: 10 } },
      yAxis: {
        type: "category",
        inverse: true,
        data: data.map((d) => fornShort(d.name)),
        axisLabel: { fontSize: 11, width: 150, overflow: "truncate" }
      },
      series: [
        {
          name: "LT real",
          type: "bar",
          barMaxWidth: 12,
          itemStyle: { color: FORN_ACCENT },
          data: data.map((d) => d.ltReal == null ? null : +d.ltReal.toFixed(1))
        },
        {
          name: "LT contratado",
          type: "bar",
          barMaxWidth: 12,
          itemStyle: { color: "#94a3b8" },
          data: data.map((d) => d.ltContr == null ? null : +d.ltContr.toFixed(1))
        }
      ]
    };
  }, [rows]);
  return /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height: 280,
      onSelect: (short) => onToggle(byShort.get(short) || short)
    }
  );
}
const FORN_PAGE_SIZE = 15;
function FornDetailTable({ rows }) {
  const sorted = useMemo(
    () => [...rows].sort((a, b) => String(b.datareq || "").localeCompare(String(a.datareq || ""))),
    [rows]
  );
  const Dot = ({ on, color, title }) => /* @__PURE__ */ React.createElement("span", { title, style: {
    display: "inline-block",
    width: 9,
    height: 9,
    borderRadius: "50%",
    background: on ? color : "var(--border)"
  } });
  const columns = [
    {
      key: "obrano",
      label: "Ordem",
      width: 75,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (r) => r.obrano
    },
    {
      // 240, não os 180 do desenho original: medido no browser, "DS SMITH
      // PACKAGING PORTUGAL" precisa de 237px e cortava a 180 — é a coluna
      // identificadora da linha, cortar não se justifica.
      key: "fornecedor",
      label: "Fornecedor",
      width: 240,
      minWidth: 160,
      fixed: true,
      render: (r) => /* @__PURE__ */ React.createElement("strong", { title: r.fornecedor }, fornShort(r.fornecedor))
    },
    {
      key: "cliente",
      label: "Cliente",
      width: 200,
      minWidth: 140,
      render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.cliente }, r.cliente || "\u2014")
    },
    {
      // 190 e nao 130: a referencia mais longa precisa de 184px nos
      // fornecedores e 168 nas vendas, e cortava em 7/15 e 12/15 das linhas.
      // E um identificador — corta-lo nunca e o desenho a funcionar, mesmo
      // havendo title no hover. A tabela ja rola; alargar nao custa nada.
      key: "ref",
      label: "Ref.",
      width: 190,
      minWidth: 130,
      mono: true,
      render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.ref }, r.ref || "\u2014")
    },
    {
      key: "design",
      label: "Designa\xE7\xE3o",
      width: 240,
      minWidth: 150,
      render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.design }, r.design || "\u2014")
    },
    { key: "qualidade", label: "Qual.", width: 70, minWidth: 55, render: (r) => r.qualidade || "\u2014" },
    { key: "armrec", label: "Arm.", width: 70, minWidth: 55, render: (r) => r.armrec || "\u2014" },
    {
      key: "qtt",
      label: "Qtt",
      width: 60,
      minWidth: 50,
      align: "right",
      mono: true,
      render: (r) => INT.format(Math.round(r.qtt))
    },
    {
      key: "valor",
      label: "Valor",
      width: 75,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (r) => EUR.format(r.valor)
    },
    {
      key: "m2prec",
      label: "m\xB2 rec.",
      width: 80,
      minWidth: 65,
      align: "right",
      mono: true,
      render: (r) => INT.format(Math.round(r.m2prec))
    },
    { key: "datareq", label: "Data req.", width: 100, minWidth: 85, render: (r) => r.datareq || "\u2014" },
    { key: "datasol", label: "Solic.", width: 100, minWidth: 85, render: (r) => r.datasol || "\u2014" },
    { key: "dataconfirmada", label: "Confirm.", width: 100, minWidth: 85, render: (r) => r.dataconfirmada || "\u2014" },
    { key: "dataultrec", label: "\xDAlt. rec.", width: 100, minWidth: 85, render: (r) => r.dataultrec || "\u2014" },
    {
      key: "min_leadtime",
      label: "LT te\xF3r.",
      width: 85,
      minWidth: 65,
      align: "right",
      title: "Lead time te\xF3rico: for\xE7ado \u2192 ref+fornecedor \u2192 cart\xE3o do fornecedor",
      render: (r) => r.min_leadtime == null ? "\u2014" : /* @__PURE__ */ React.createElement("span", { title: FORN_LT_ORIGEM[r.lt_origem] || "" }, r.min_leadtime + " d", r.lt_origem ? /* @__PURE__ */ React.createElement("sup", { style: { marginLeft: 2, opacity: 0.7 } }, FORN_LT_ORIGEM_SIGLA[r.lt_origem]) : null)
    },
    {
      key: "leadtimereal",
      label: "LT real",
      width: 80,
      minWidth: 60,
      align: "right",
      render: (r) => r.leadtimereal == null ? "\u2014" : r.leadtimereal + " d"
    },
    {
      key: "atraso_forn",
      label: "Atraso forn.",
      width: 95,
      minWidth: 70,
      align: "right",
      title: "Atraso do fornecedor = rece\xE7\xE3o \u2212 data confirmada (sem confirma\xE7\xE3o, \u2212 data solicitada), m\xEDnimo 0 (0 = cumpriu)",
      render: (r) => r.atraso_forn == null ? "\u2014" : /* @__PURE__ */ React.createElement("span", { style: r.atraso_forn > 0 ? { color: FORN_RED, fontWeight: 700 } : void 0 }, r.atraso_forn + " d")
    },
    {
      key: "lt_acima",
      label: "LT acima",
      width: 85,
      minWidth: 65,
      align: "right",
      title: "Lead time real acima do te\xF3rico = LT real \u2212 LT te\xF3rico, m\xEDnimo 0 (s\xF3 informa\xE7\xE3o)",
      render: (r) => r.lt_acima == null ? "\u2014" : /* @__PURE__ */ React.createElement("span", { style: r.lt_acima > 0 ? { color: FORN_RED } : void 0 }, r.lt_acima + " d")
    },
    {
      key: "dias_req_sol",
      label: "req\u2192sol",
      width: 90,
      minWidth: 70,
      align: "right",
      title: "Dias entre data de requisi\xE7\xE3o e data solicitada",
      render: (r) => r.dias_req_sol == null ? "\u2014" : /* @__PURE__ */ React.createElement(
        "span",
        {
          title: r.sem_lt > 0 ? "Sem LT te\xF3rico" : r.below_lt > 0 ? "Abaixo do LT te\xF3rico" : "Igual/acima do LT te\xF3rico",
          style: {
            display: "inline-block",
            minWidth: 24,
            padding: "1px 8px",
            borderRadius: 10,
            color: "#fff",
            fontWeight: 700,
            background: r.sem_lt > 0 ? "#9ca3af" : r.below_lt > 0 ? FORN_RED : FORN_GREEN
          }
        },
        r.dias_req_sol
      )
    },
    {
      key: "sos",
      label: "SOS",
      width: 65,
      minWidth: 50,
      align: "center",
      sortValue: (r) => r.sos || 0,
      render: (r) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement(Dot, { on: r.sos > 0, color: FORN_AMBER, title: "Req SOS" }))
    },
    {
      key: "antecipada",
      label: "Antecip.",
      width: 75,
      minWidth: 55,
      align: "center",
      sortValue: (r) => r.antecipada || 0,
      render: (r) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement(Dot, { on: r.antecipada > 0, color: FORN_AMBER, title: "Req antecipada" }))
    },
    {
      key: "atrasos",
      label: "Atrasos",
      width: 85,
      minWidth: 65,
      align: "center",
      sortValue: (r) => (r.atraso_conf > 0 ? 1 : 0) + (r.atraso_sol > 0 ? 1 : 0),
      render: (r) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", gap: 5, justifyContent: "center" } }, /* @__PURE__ */ React.createElement(Dot, { on: r.atraso_conf > 0, color: FORN_RED, title: "Atraso vs data confirmada" }), /* @__PURE__ */ React.createElement(Dot, { on: r.atraso_sol > 0, color: "#d97706", title: "Atraso vs data solicitada" })))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Detalhe linha a linha"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", INT.format(sorted.length), " linha(s)")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "fornecedores-detalhe",
      columns,
      data: sorted,
      pagination: "client",
      pageSize: FORN_PAGE_SIZE,
      rowKey: fornRowKey,
      empty: "Sem dados para os filtros ativos."
    }
  ));
}
Object.assign(window, { FornecedoresView });

// ===== bi/vendas/frontend/view.jsx =====
const VEN_MEASURES = [
  { key: "valor", label: "Valor", fmt: (v) => EUR.format(v) },
  { key: "margem", label: "Margem", fmt: (v) => EUR.format(v) },
  { key: "encomendas", label: "Linhas", fmt: (v) => INT.format(v) },
  { key: "qtt", label: "Quantidade", fmt: (v) => INT.format(Math.round(v)) }
];
const venFmt = (measure) => (VEN_MEASURES.find((m) => m.key === measure) || VEN_MEASURES[0]).fmt;
const VEN_DIMS = [
  { key: "cliente", label: "Cliente" },
  { key: "tipoartigo", label: "Tipo de artigo" },
  { key: "armazem", label: "Armaz\xE9m" },
  { key: "ncli", label: "N\xBA cliente (PHC)" },
  { key: "tipoaquisicao", label: "Aquisi\xE7\xE3o" }
];
const VEN_DIM_KEYS = VEN_DIMS.map((d) => d.key);
const venEmptyFilters = () => {
  const f = {};
  for (const k of VEN_DIM_KEYS) f[k] = /* @__PURE__ */ new Set();
  return f;
};
const venPrepare = (r) => ({
  ...r,
  ncli: r.ncliente == null ? "" : String(r.ncliente),
  margem: (r.valor || 0) - (r.totalmp || 0) - (r.totalme || 0)
});
const VEN_FLAGS = {
  sos: { label: "SOS", pred: (r) => r.sos > 0 },
  late_conf: { label: "Atraso vs confirmada", pred: (r) => r.atraso_conf > 0 },
  late_sol: { label: "Atraso vs solicitada", pred: (r) => r.atraso_sol > 0 },
  antecipada: { label: "Antecipada", pred: (r) => r.antecipada > 0 },
  mais10: { label: "Enc. > 10 dias", pred: (r) => r.mais10 > 0 },
  stock: { label: "Artigo de stock", pred: (r) => r.artstock > 0 }
};
const VEN_SUM_KEYS = [
  "encomendas",
  "qtt",
  "valor",
  "totalmp",
  "totalme",
  "margem",
  "sos",
  "atraso_conf",
  "atraso_sol",
  "antecipada",
  "mais10",
  "artstock"
];
const VEN_ZERO = () => {
  const a = {};
  for (const k of VEN_SUM_KEYS) a[k] = 0;
  return a;
};
function venSum(rows) {
  const a = VEN_ZERO();
  for (const r of rows) for (const k of VEN_SUM_KEYS) a[k] += r[k] || 0;
  return a;
}
function venBy(rows, dim) {
  const m = /* @__PURE__ */ new Map();
  for (const r of rows) {
    let a = m.get(r[dim]);
    if (!a) {
      a = VEN_ZERO();
      m.set(r[dim], a);
    }
    for (const k of VEN_SUM_KEYS) a[k] += r[k] || 0;
  }
  return m;
}
const venDerive = (a) => ({
  ...a,
  margemPct: a.valor ? a.margem / a.valor : null,
  otdConf: a.encomendas ? 1 - a.atraso_conf / a.encomendas : null,
  otdSol: a.encomendas ? 1 - a.atraso_sol / a.encomendas : null,
  antecipPct: a.encomendas ? a.antecipada / a.encomendas : null,
  mais10Pct: a.encomendas ? a.mais10 / a.encomendas : null
});
function venBucket(r) {
  if (!(r.atraso_conf > 0)) return r.atraso_sol > 0 ? "conf" : "sol";
  return "late";
}
const VEN_BUCKETS = [
  { key: "sol", label: "At\xE9 \xE0 data solicitada", color: FORN_GREEN },
  { key: "conf", label: "At\xE9 \xE0 confirmada (ap\xF3s solic.)", color: "#0d9488" },
  { key: "late", label: "Atraso vs confirmada", color: FORN_RED }
];
function venApplyFlags(rows, flags) {
  if (!flags.size) return rows;
  const preds = [...flags].map((f) => VEN_FLAGS[f].pred);
  return rows.filter((r) => preds.every((p) => p(r)));
}
function venApplyBuckets(rows, buckets) {
  if (!buckets.size) return rows;
  return rows.filter((r) => buckets.has(venBucket(r)));
}
function VendasView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [measure, setMeasure] = useState("valor");
  const [ano, setAno] = useState(() => (/* @__PURE__ */ new Date()).getFullYear());
  const [filters, setFilters] = useState(venEmptyFilters);
  const [comAnuladas, setComAnuladas] = useState(false);
  const [flags, setFlags] = useState(/* @__PURE__ */ new Set());
  const [buckets, setBuckets] = useState(/* @__PURE__ */ new Set());
  const [months, setMonths] = useState(/* @__PURE__ */ new Set());
  useEffect(() => {
    let alive = true;
    window.API.biVendas().then((d) => {
      if (alive) setData({ ...d, rows: (d.rows || []).map(venPrepare) });
    }).catch((e) => {
      if (!alive) return;
      const m = String(e.message || e);
      const j = m.match(/\{.*\}$/s);
      try {
        setError(j ? JSON.parse(j[0]).error : m);
      } catch {
        setError(m);
      }
    });
    return () => {
      alive = false;
    };
  }, []);
  const toggle = (dim, name) => setFilters((prev) => {
    const next = { ...prev, [dim]: new Set(prev[dim]) };
    if (next[dim].has(name)) next[dim].delete(name);
    else next[dim].add(name);
    return next;
  });
  const toggleFlag = (key) => setFlags((prev) => {
    const next = new Set(prev);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    return next;
  });
  const toggleBucket = (key) => setBuckets((prev) => {
    const next = new Set(prev);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    return next;
  });
  const toggleMonth = (ym) => setMonths((prev) => {
    const next = new Set(prev);
    if (next.has(ym)) next.delete(ym);
    else next.add(ym);
    return next;
  });
  const onMonthSegment = (ym, bucketKey) => {
    const onlyM = months.size === 1 && months.has(ym);
    const onlyB = buckets.size === 1 && buckets.has(bucketKey);
    if (onlyM && buckets.size === 0) {
      setBuckets(/* @__PURE__ */ new Set([bucketKey]));
    } else if (onlyM && onlyB) {
      setMonths(/* @__PURE__ */ new Set());
    } else if (months.size === 0 && onlyB) {
      setBuckets(/* @__PURE__ */ new Set());
    } else {
      setMonths(/* @__PURE__ */ new Set([ym]));
      setBuckets(/* @__PURE__ */ new Set());
    }
  };
  const clearAll = () => {
    setFilters(venEmptyFilters());
    setComAnuladas(false);
    setFlags(/* @__PURE__ */ new Set());
    setBuckets(/* @__PURE__ */ new Set());
    setMonths(/* @__PURE__ */ new Set());
  };
  const anos = useMemo(() => {
    const s = new Set((data?.rows || []).map((r) => r.ano));
    return [...s].sort();
  }, [data]);
  useEffect(() => {
    if (anos.length && ano !== "all" && !anos.includes(ano)) setAno(anos[anos.length - 1]);
  }, [anos]);
  const anoRows = useMemo(() => {
    const rows = data?.rows || [];
    const doAno = ano === "all" ? rows : rows.filter((r) => r.ano === ano);
    return comAnuladas ? doAno : doAno.filter((r) => !(r.anuladoof > 0));
  }, [data, ano, comAnuladas]);
  const filterOptions = useMemo(() => {
    const seen = venEmptyFilters();
    const out = [];
    for (const r of data?.rows || []) {
      for (const { key } of VEN_DIMS) {
        const val = r[key];
        if (val && !seen[key].has(val)) {
          seen[key].add(val);
          out.push({ dim: key, value: val });
        }
      }
    }
    return out;
  }, [data]);
  const dimFiltered = useMemo(
    () => filterRows(anoRows, filters, null),
    [anoRows, filters]
  );
  const flagFiltered = useMemo(
    () => venApplyFlags(dimFiltered, flags),
    [dimFiltered, flags]
  );
  const fullyFiltered = useMemo(
    () => applyMonths(venApplyBuckets(flagFiltered, buckets), months),
    [flagFiltered, buckets, months]
  );
  const rowsFor = (dim) => applyMonths(
    venApplyBuckets(venApplyFlags(filterRows(anoRows, filters, dim), flags), buckets),
    months
  );
  const kpi = useMemo(() => venDerive(venSum(fullyFiltered)), [fullyFiltered]);
  const activeChips = useMemo(() => {
    const chips = [];
    for (const dim of Object.keys(filters))
      for (const name of filters[dim]) chips.push({ kind: "dim", dim, name });
    for (const f of flags) chips.push({ kind: "flag", key: f });
    for (const b of buckets) chips.push({ kind: "bucket", key: b });
    for (const m of months) chips.push({ kind: "month", ym: m });
    return chips;
  }, [filters, flags, buckets, months]);
  if (error) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: FORN_RED } }, "Erro ao carregar dados: ", error);
  }
  if (!data) {
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar dados do Trino\u2026");
  }
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 16 } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12
  } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 700 } }, "Servi\xE7o de Vendas"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Ano:"), ["all", ...anos].map((a) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: a,
      type: "button",
      onClick: () => setAno(a),
      style: { ...visionBtn(ano === a), padding: "5px 12px", fontSize: 12 }
    },
    a === "all" ? "Todos" : a
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => setComAnuladas((v) => !v),
      title: "Linhas cuja OF foi anulada",
      style: { ...visionBtn(comAnuladas), padding: "5px 12px", fontSize: 12 }
    },
    comAnuladas ? "Com OF anuladas" : "Sem OF anuladas"
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "M\xE9trica:"), VEN_MEASURES.map((m) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: m.key,
      type: "button",
      onClick: () => setMeasure(m.key),
      style: { ...visionBtn(measure === m.key), padding: "5px 12px", fontSize: 12 }
    },
    m.label
  ))))), /* @__PURE__ */ React.createElement(
    VenFilterBar,
    {
      options: filterOptions,
      filters,
      onAdd: (dim, value) => toggle(dim, value)
    }
  ), activeChips.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Filtros:"), activeChips.map((c) => {
    if (c.kind === "dim") return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: "d:" + c.dim + c.name,
        type: "button",
        onClick: () => toggle(c.dim, c.name),
        style: chipStyle(FORN_ACCENT)
      },
      (c.dim === "cliente" ? fornShort(c.name) : c.name) || c.name,
      " \u2715"
    );
    if (c.kind === "bucket") {
      const b = VEN_BUCKETS.find((x) => x.key === c.key);
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: "b:" + c.key,
          type: "button",
          onClick: () => toggleBucket(c.key),
          style: chipStyle(b.color)
        },
        b.label,
        " \u2715"
      );
    }
    if (c.kind === "month") return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: "m:" + c.ym,
        type: "button",
        onClick: () => toggleMonth(c.ym),
        style: chipStyle("#6d28d9")
      },
      "M\xEAs ",
      ymLabel(c.ym),
      " \u2715"
    );
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: "f:" + c.key,
        type: "button",
        onClick: () => toggleFlag(c.key),
        style: chipStyle(FORN_AMBER)
      },
      VEN_FLAGS[c.key].label,
      " \u2715"
    );
  }), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: clearAll,
      style: {
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 12,
        cursor: "pointer",
        border: "1px solid var(--border)",
        background: "var(--panel)",
        color: "var(--muted)"
      }
    },
    "Limpar tudo"
  )), /* @__PURE__ */ React.createElement("div", { className: "vision-kpi-grid" }, /* @__PURE__ */ React.createElement(FornKpi, { label: "Linhas de venda", value: INT.format(kpi.encomendas) }), /* @__PURE__ */ React.createElement(FornKpi, { label: "Valor de vendas", value: EUR.format(kpi.valor) }), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Margem",
      value: EUR.format(kpi.margem),
      sub: "venda \u2212 MP \u2212 ME \xB7 " + PCT1(kpi.margemPct)
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "OTD data confirmada",
      value: PCT1(kpi.otdConf),
      color: otdColor(kpi.otdConf),
      sub: "clicar: ver atrasos",
      active: flags.has("late_conf"),
      onClick: () => toggleFlag("late_conf")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "OTD data solicitada",
      value: PCT1(kpi.otdSol),
      color: otdColor(kpi.otdSol),
      sub: "clicar: ver atrasos",
      active: flags.has("late_sol"),
      onClick: () => toggleFlag("late_sol")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Encs SOS",
      value: INT.format(kpi.sos),
      color: kpi.sos > 0 ? FORN_AMBER : void 0,
      sub: "clicar: filtrar SOS",
      active: flags.has("sos"),
      onClick: () => toggleFlag("sos")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Antecipadas",
      value: INT.format(kpi.antecipada),
      sub: "\u2248 " + PCT1(kpi.antecipPct) + " \xB7 clicar: filtrar",
      active: flags.has("antecipada"),
      onClick: () => toggleFlag("antecipada")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Enc. com > 10 dias",
      value: INT.format(kpi.mais10),
      sub: "\u2248 " + PCT1(kpi.mais10Pct) + " \xB7 clicar: filtrar",
      active: flags.has("mais10"),
      onClick: () => toggleFlag("mais10")
    }
  ), /* @__PURE__ */ React.createElement(
    FornKpi,
    {
      label: "Artigos de stock",
      value: INT.format(kpi.artstock),
      sub: "clicar: s\xF3 stock",
      active: flags.has("stock"),
      onClick: () => toggleFlag("stock")
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "vision-chart-grid" }, /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    VenDimBar,
    {
      title: "Por cliente",
      rows: rowsFor("cliente"),
      dim: "cliente",
      measure,
      selected: filters.cliente,
      shorten: fornShort,
      onToggle: (n) => toggle("cliente", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    VenDimBar,
    {
      title: "Por tipo de artigo",
      rows: rowsFor("tipoartigo"),
      dim: "tipoartigo",
      measure,
      selected: filters.tipoartigo,
      emptyLabel: "(sem tipo)",
      onToggle: (n) => toggle("tipoartigo", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    VenDimBar,
    {
      title: "Por n\xBA de cliente (PHC)",
      rows: rowsFor("ncli"),
      dim: "ncli",
      measure,
      selected: filters.ncli,
      emptyLabel: "(sem n\xBA)",
      onToggle: (n) => toggle("ncli", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    VenDimBar,
    {
      title: "Por aquisi\xE7\xE3o",
      rows: rowsFor("tipoaquisicao"),
      dim: "tipoaquisicao",
      measure,
      selected: filters.tipoaquisicao,
      emptyLabel: "(sem aquisi\xE7\xE3o)",
      onToggle: (n) => toggle("tipoaquisicao", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    FornDimPie,
    {
      title: "Por armaz\xE9m (expedi\xE7\xE3o)",
      rows: rowsFor("armazem"),
      dim: "armazem",
      measure,
      selected: filters.armazem,
      emptyLabel: "(sem armaz\xE9m)",
      by: venBy,
      fmt: venFmt,
      onToggle: (n) => toggle("armazem", n)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, gridColumn: "1 / -1" } }, /* @__PURE__ */ React.createElement(
    VenMonthlyChart,
    {
      rows: flagFiltered,
      selectedBuckets: buckets,
      selectedMonths: months,
      onSegment: onMonthSegment,
      onMonthPick: toggleMonth
    }
  ))), /* @__PURE__ */ React.createElement(VenDetailTable, { rows: fullyFiltered }));
}
function VenFilterBar({ options, filters, onAdd }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const matches = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return [];
    const out = [];
    for (const o of options) {
      if (filters[o.dim].has(o.value)) continue;
      if (o.value.toLowerCase().includes(needle)) out.push(o);
      if (out.length >= 30) break;
    }
    return out;
  }, [q, options, filters]);
  const add = (o) => {
    onAdd(o.dim, o.value);
    setQ("");
    setOpen(false);
  };
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: q,
      placeholder: "Filtrar por cliente, n\xBA de cliente, tipo de artigo, aquisi\xE7\xE3o ou armaz\xE9m\u2026",
      onChange: (e) => {
        setQ(e.target.value);
        setOpen(true);
      },
      onFocus: () => setOpen(true),
      onBlur: () => setTimeout(() => setOpen(false), 150),
      onKeyDown: (e) => {
        if (e.key === "Enter" && matches[0]) add(matches[0]);
      },
      style: {
        width: "100%",
        boxSizing: "border-box",
        padding: "9px 12px",
        fontSize: 13,
        borderRadius: 8,
        border: "1px solid var(--border)",
        background: "var(--panel)",
        color: "var(--text, inherit)"
      }
    }
  ), open && matches.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    zIndex: 20,
    top: "100%",
    left: 0,
    right: 0,
    marginTop: 4,
    maxHeight: 280,
    overflowY: "auto",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)"
  } }, matches.map((o) => {
    const meta = VEN_DIMS.find((d) => d.key === o.dim);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: o.dim + ":" + o.value,
        onMouseDown: () => add(o),
        style: {
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "7px 12px",
          cursor: "pointer",
          fontSize: 13,
          borderBottom: "1px solid var(--border)"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        ...chipStyle(FORN_ACCENT),
        padding: "1px 8px",
        cursor: "default",
        fontSize: 11
      } }, meta.label),
      /* @__PURE__ */ React.createElement("span", null, o.dim === "cliente" ? fornShort(o.value) : o.value)
    );
  })));
}
function VenDimBar({ title, rows, dim, measure, selected, onToggle, shorten, emptyLabel }) {
  const label = (name) => name === "" || name == null ? emptyLabel || "(vazio)" : shorten ? shorten(name) : name;
  const byLabel = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    for (const [name] of venBy(rows, dim)) m.set(label(name), name);
    return m;
  }, [rows, dim]);
  const option = useMemo(() => {
    const fmt = venFmt(measure);
    const data = [...venBy(rows, dim).entries()].map(([name, a]) => ({ name, value: a[measure] })).sort((a, b) => b.value - a.value).slice(0, 15);
    return {
      title: {
        text: title,
        left: 0,
        top: 0,
        textStyle: { fontSize: 13, fontWeight: 600, color: "#334155" }
      },
      grid: { left: 8, right: 24, top: 32, bottom: 8, containLabel: true },
      tooltip: {
        trigger: "item",
        formatter: (p) => `${p.name}<br/><b>${fmt(p.value)}</b>`
      },
      xAxis: { type: "value", axisLabel: {
        formatter: (v) => v >= 1e6 ? v / 1e6 + "M" : v >= 1e3 ? v / 1e3 + "k" : v
      } },
      yAxis: {
        type: "category",
        inverse: true,
        data: data.map((d) => label(d.name)),
        axisLabel: { fontSize: 11, width: 150, overflow: "truncate" }
      },
      series: [{
        type: "bar",
        barMaxWidth: 22,
        data: data.map((d) => ({
          name: label(d.name),
          value: d.value,
          itemStyle: { color: selected.size === 0 || selected.has(d.name) ? FORN_ACCENT : "#cbd5e1" }
        })),
        emphasis: { itemStyle: { color: FORN_ACCENT } }
      }]
    };
  }, [rows, dim, measure, selected, title]);
  return /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height: 280,
      onSelect: (lbl) => onToggle(byLabel.get(lbl) ?? lbl)
    }
  );
}
function VenMonthlyChart({ rows, selectedBuckets, selectedMonths, onSegment, onMonthPick }) {
  const { option, labelToYm } = useMemo(() => {
    const dimBucket = (key) => selectedBuckets && selectedBuckets.size && !selectedBuckets.has(key);
    const pinMonth = (ym) => selectedMonths && selectedMonths.size && !selectedMonths.has(ym);
    const byMonth = /* @__PURE__ */ new Map();
    for (const r of rows) {
      const ym = rowYm(r);
      let a = byMonth.get(ym);
      if (!a) {
        a = { sol: 0, conf: 0, late: 0 };
        byMonth.set(ym, a);
      }
      a[venBucket(r)] += 1;
    }
    const monthsArr = [...byMonth.keys()].sort();
    const labels = monthsArr.map((ym) => ym.slice(5) + "/" + ym.slice(2, 4));
    const labelToYm2 = new Map(labels.map((l, i) => [l, monthsArr[i]]));
    const agg = monthsArr.map((ym) => byMonth.get(ym));
    const option2 = {
      title: {
        text: "Evolu\xE7\xE3o mensal",
        left: 0,
        top: 0,
        textStyle: { fontSize: 13, fontWeight: 600, color: "#334155" }
      },
      grid: { left: 8, right: 8, top: 32, bottom: 44, containLabel: true },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (ps) => {
          const total = ps.reduce((s, p) => s + (p.value || 0), 0);
          return ps[0].axisValue + ` \u2014 ${total} linha(s)` + ps.map(
            (p) => `<br/>${p.marker} ${p.seriesName}: <b>${p.value}</b>`
          ).join("");
        }
      },
      legend: { bottom: 0, itemWidth: 12, itemHeight: 9, textStyle: { fontSize: 10 } },
      xAxis: { type: "category", data: labels, axisLabel: { fontSize: 10 } },
      yAxis: { type: "value", axisLabel: { fontSize: 10 } },
      series: VEN_BUCKETS.map((b) => ({
        name: b.label,
        type: "bar",
        stack: "total",
        barMaxWidth: 26,
        data: agg.map((a, i) => ({
          value: a[b.key],
          itemStyle: { color: dimBucket(b.key) || pinMonth(monthsArr[i]) ? b.color + "40" : b.color }
        }))
      }))
    };
    return { option: option2, labelToYm: labelToYm2 };
  }, [rows, selectedBuckets, selectedMonths]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height: 300,
      onSelect: (name, p) => {
        const ym = labelToYm.get(name);
        const b = VEN_BUCKETS.find((x) => x.label === (p && p.seriesName));
        if (b && ym) onSegment(ym, b.key);
      },
      onEmptyClick: (name) => {
        const ym = labelToYm.get(name);
        if (ym) onMonthPick(ym);
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 2, textAlign: "center" } }, "Clica na barra: 1\xD7 m\xEAs \xB7 2\xD7 cor no m\xEAs \xB7 3\xD7 cor \xB7 4\xD7 limpa"));
}
const VEN_PAGE_SIZE = 15;
function VenDetailTable({ rows }) {
  const sorted = useMemo(
    () => [...rows].sort((a, b) => String(b.dataenc || "").localeCompare(String(a.dataenc || ""))),
    [rows]
  );
  const Dot = ({ on, color, title }) => /* @__PURE__ */ React.createElement("span", { title, style: {
    display: "inline-block",
    width: 9,
    height: 9,
    borderRadius: "50%",
    background: on ? color : "var(--border)"
  } });
  const columns = [
    {
      key: "obrano",
      label: "Ordem",
      width: 75,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (r) => r.obrano
    },
    {
      key: "ncli",
      label: "N\xBA cli.",
      width: 75,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (r) => r.ncli || "\u2014"
    },
    { key: "dataenc", label: "Data enc.", width: 100, minWidth: 85, render: (r) => r.dataenc || "\u2014" },
    {
      key: "cliente",
      label: "Cliente",
      width: 200,
      minWidth: 140,
      fixed: true,
      render: (r) => /* @__PURE__ */ React.createElement("strong", { title: r.cliente }, fornShort(r.cliente) || "\u2014")
    },
    {
      // 190 e nao 130: a referencia mais longa precisa de 184px nos
      // fornecedores e 168 nas vendas, e cortava em 7/15 e 12/15 das linhas.
      // E um identificador — corta-lo nunca e o desenho a funcionar, mesmo
      // havendo title no hover. A tabela ja rola; alargar nao custa nada.
      key: "ref",
      label: "Ref.",
      width: 190,
      minWidth: 130,
      mono: true,
      render: (r) => r.ref || "\u2014"
    },
    {
      key: "design",
      label: "Designa\xE7\xE3o",
      width: 240,
      minWidth: 150,
      render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.design }, r.design || "\u2014")
    },
    { key: "tipoartigo", label: "Tipo", width: 90, minWidth: 70, render: (r) => r.tipoartigo || "\u2014" },
    { key: "armazem", label: "Arm.", width: 70, minWidth: 55, render: (r) => r.armazem || "\u2014" },
    {
      // 80, não 70: medido no browser, um valor de 5 dígitos com separador de
      // milhar ("17 160") precisa de 72px e cortava 2/15 linhas a 70.
      key: "qtt",
      label: "Qtt",
      width: 80,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (r) => INT.format(Math.round(r.qtt))
    },
    {
      key: "valor",
      label: "Valor",
      width: 75,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (r) => EUR.format(r.valor)
    },
    {
      key: "margem",
      label: "Margem",
      width: 90,
      minWidth: 70,
      align: "right",
      mono: true,
      render: (r) => EUR.format(r.margem)
    },
    {
      key: "margemPct",
      label: "Margem %",
      width: 85,
      minWidth: 65,
      align: "right",
      mono: true,
      sortValue: (r) => r.valor ? r.margem / r.valor : null,
      render: (r) => r.valor ? PCT1(r.margem / r.valor) : "\u2014"
    },
    { key: "datasol", label: "Solic.", width: 100, minWidth: 85, render: (r) => r.datasol || "\u2014" },
    { key: "dataconf", label: "Confirm.", width: 100, minWidth: 85, render: (r) => r.dataconf || "\u2014" },
    { key: "datapick", label: "Pick", width: 100, minWidth: 85, render: (r) => r.datapick || "\u2014" },
    {
      key: "sos",
      label: "SOS",
      width: 65,
      minWidth: 50,
      align: "center",
      sortValue: (r) => r.sos || 0,
      render: (r) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement(Dot, { on: r.sos > 0, color: FORN_AMBER, title: "Enc SOS" }))
    },
    {
      key: "atrasos",
      label: "Atrasos",
      width: 85,
      minWidth: 65,
      align: "center",
      sortValue: (r) => (r.atraso_conf > 0 ? 1 : 0) + (r.atraso_sol > 0 ? 1 : 0),
      render: (r) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", gap: 5, justifyContent: "center" } }, /* @__PURE__ */ React.createElement(Dot, { on: r.atraso_conf > 0, color: FORN_RED, title: "Atraso vs data confirmada" }), /* @__PURE__ */ React.createElement(Dot, { on: r.atraso_sol > 0, color: "#d97706", title: "Atraso vs data solicitada" })))
    },
    {
      key: "antecipada",
      label: "Antec.",
      width: 80,
      minWidth: 65,
      align: "center",
      sortValue: (r) => r.antecipada || 0,
      render: (r) => /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement(Dot, { on: r.antecipada > 0, color: FORN_GREEN, title: "Antecipada" }))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Detalhe linha a linha"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", INT.format(sorted.length), " linha(s)")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "vendas-detalhe",
      columns,
      data: sorted,
      pagination: "client",
      pageSize: VEN_PAGE_SIZE,
      rowKey: fornRowKey,
      empty: "Sem dados para os filtros ativos."
    }
  ));
}
Object.assign(window, { VendasView });

// ===== bi/servico_linhas/frontend/comum.jsx =====
const SL_ETAPAS = {
  mercadoria: [
    { key: "lancamento", label: "Lan\xE7amento" },
    { key: "requisicao", label: "Requisi\xE7\xE3o" },
    { key: "fornecedor", label: "Fornecedor" },
    { key: "logistica", label: "Log\xEDstica" }
  ],
  producao: [
    { key: "lancamento", label: "Lan\xE7amento" },
    { key: "requisicao", label: "Requisi\xE7\xE3o MP" },
    { key: "fornecedor", label: "Fornecedor MP" },
    { key: "producao", label: "Produ\xE7\xE3o" },
    { key: "logistica", label: "Log\xEDstica" }
  ]
};
const SL_FLUXOS = { mercadoria: "Mercadoria", producao: "Produ\xE7\xE3o" };
const SL_CAUSAS = [
  { key: "comercial_abaixo_lt", label: "Comercial prometeu abaixo do lead time", responsavel: "Comercial", cor: "#172554" },
  { key: "prazo_curto", label: "Prazo abaixo do lead time", responsavel: "Comercial", cor: "#1e40af" },
  { key: "promessa", label: "Promessa al\xE9m da solicitada", responsavel: "Comercial", cor: "#3b82f6" },
  { key: "lancamento", label: "Lan\xE7amento tardio", responsavel: "Comercial", cor: "#93c5fd" },
  { key: "requisicao", label: "Requisi\xE7\xE3o tardia", responsavel: "Compras", cor: "#7c3aed" },
  { key: "forn_confirmou_tarde", label: "Fornecedor confirmou tarde", responsavel: "Compras / fornecedor", cor: "#fb923c" },
  { key: "forn_nao_cumpriu", label: "Fornecedor n\xE3o cumpriu", responsavel: "Fornecedor", cor: "#ea580c" },
  { key: "producao", label: "Produ\xE7\xE3o", responsavel: "Produ\xE7\xE3o", cor: "#b4412b" },
  { key: "sem_stock", label: "Sem stock", responsavel: "Produ\xE7\xE3o / Planeamento", cor: "#a16207" },
  { key: "logistica", label: "Log\xEDstica", responsavel: "Log\xEDstica", cor: "#0f766e" },
  { key: "enc_fechada", label: "Encomenda fechada", responsavel: "Comercial", cor: "#475569" },
  // Só chegam pelo motivo do adiamento (cartão 202).
  { key: "cliente", label: "Cliente", responsavel: "Cliente", cor: "#64748b" },
  { key: "financeiro", label: "Fatura\xE7\xE3o bloqueada", responsavel: "Financeiro / Cliente", cor: "#be185d" }
];
const SL_CAUSA = Object.fromEntries(SL_CAUSAS.map((c) => [c.key, c]));
const SL_ESTADOS = {
  atrasada: { label: "Atrasada", cor: "#b91c1c" },
  em_risco: { label: "Em risco", cor: "#b45309" },
  fora_sol: {
    label: "Fora da solicitada \xB7 dentro da prometida",
    cor: "#b45309",
    title: "Passou da data solicitada mas ainda n\xE3o da prometida ao cliente. S\xF3 o estado das linhas abertas: as entregues e o n\xEDvel de servi\xE7o continuam a medir face \xE0 solicitada."
  },
  no_prazo: { label: "No prazo", cor: "#15803d" },
  // Cliente bloqueado no PHC (cartão 257): não conta como atrasada nem em risco.
  bloqueado: { label: "Cliente bloqueado (PHC)", cor: "#be185d" },
  // Encomenda fechada no PHC sem nada entregue (cartão #256): fora dos três contadores.
  fechada_phc: { label: "Encomenda fechada no PHC", cor: "#475569" }
};
const slAddDias = (iso, n) => {
  const d = /* @__PURE__ */ new Date(iso + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
const slDiff = (a, b) => a && b ? Math.round((Date.parse(b) - Date.parse(a)) / 864e5) : null;
const slGet = (r, campo) => campo.split(".").reduce((o, k) => o == null ? o : o[k], r);
function slAgrupar(iso, gran) {
  if (!iso) return null;
  if (gran === "mes") return iso.slice(0, 7);
  if (gran === "semana") {
    const dow = ((/* @__PURE__ */ new Date(iso + "T00:00:00Z")).getUTCDay() + 6) % 7;
    return slAddDias(iso, -dow);
  }
  return iso;
}
function slRotulo(chave, gran) {
  if (!chave) return "\u2014";
  if (gran === "mes") return `${chave.slice(5, 7)}/${chave.slice(0, 4)}`;
  const dm = `${chave.slice(8, 10)}/${chave.slice(5, 7)}`;
  return gran === "semana" ? `S ${dm}` : dm;
}
function slJanela(periodo, de, ate, hoje) {
  if (periodo === "custom") return [de || slAddDias(hoje, -29), ate || hoje];
  const n = { 7: 7, 30: 30, 90: 90 }[periodo] || 30;
  return [slAddDias(hoje, -(n - 1)), hoje];
}
function slPeriodo(rows, janela, campo) {
  const [ini, fim] = janela;
  return rows.filter((r) => {
    const v = slGet(r, campo);
    return v && v >= ini && v <= fim;
  });
}
function slNivel(ok, n) {
  const valor = n > 0 ? ok / n : null;
  return { valor, cor: otdColor(valor), n, ok };
}
function slEstadoHoje(r) {
  const e = r.estado;
  if (!e) return null;
  if (e.fechada_phc) return "fechada_phc";
  return e.situacao || e.vs_sol || "no_prazo";
}
function slEstadoGrupo(r) {
  const k = slEstadoHoje(r);
  return k === "fora_sol" ? "em_risco" : k;
}
function slCasa(r, filtro) {
  if (!filtro) return true;
  const { bloco, chave } = filtro;
  if (bloco === "hoje") {
    if (chave.startsWith("parada:")) {
      const etapa = chave.slice(7);
      return !!r.estado && !r.estado.bloqueado && !r.estado.fechada_phc && r.estado.etapa_atual === etapa && !(etapa === "logistica" && r.enc_fechada);
    }
    return slEstadoGrupo(r) === chave;
  }
  if (bloco === "causas") return !!r.causa && r.causa.principal === chave;
  if (bloco === "adiamentos") return !!r.adiamento && slMotivo(r) === chave;
  if (bloco === "operacoes") {
    const k = chave.replace(/^etapa:/, "");
    return !!r.causa && r.etapas.some((e) => e.key === k && e.excesso > 0);
  }
  return true;
}
function slEncFechadaCasa(r, modo) {
  if (modo === "fechada") return r.enc_fechada === true;
  if (modo === "aberta") return r.enc_fechada === false;
  return true;
}
function slBloqueadoCasa(r, modo) {
  if (modo === "sim") return !!r.cliente_bloqueado;
  if (modo === "nao") return !r.cliente_bloqueado;
  return true;
}
function slAvisoBloqueio(r) {
  return !!r.cliente_estado && !r.cliente_bloqueado;
}
const SL_DATAS = [
  { key: "real", label: "Entrega" },
  { key: "sol", label: "Solicitada" },
  { key: "prom", label: "Prometida" }
];
function slDataCasa(r, tipo, de, ate) {
  const campo = { real: "real", sol: "solicitada", prom: "prometida" }[tipo];
  if (!campo) return true;
  const v = r.entrega && r.entrega[campo];
  return !!v && (!de || v >= de) && (!ate || v <= ate);
}
function slEntregaCasa(r, modo) {
  const real = r.entrega && r.entrega.real;
  if (modo === "sem") return !real && !!r.estado;
  if (modo === "com") return !!real;
  return true;
}
function slOrdenar(rows, sort, columns, applySort) {
  const g = {};
  columns.forEach((c) => {
    if (c.sortValue) g[c.key] = c.sortValue;
  });
  return applySort(rows, sort, g);
}
const slAlternar = (atual, novo) => atual && atual.bloco === novo.bloco && atual.chave === novo.chave ? null : novo;
const SL_UN = new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 2 });
const SL_EUR2 = new Intl.NumberFormat("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
function slAMenosTexto(a) {
  return `\u2212${SL_UN.format(Math.abs(a.un))} un \xB7 \u2212${SL_EUR2.format(Math.abs(a.valor))} \u20AC`;
}
function slAMenosTotal(rows) {
  const com = rows.filter((r) => r.a_menos);
  return {
    n: com.length,
    un: com.reduce((s, r) => s + r.a_menos.un, 0),
    valor: Math.round(com.reduce((s, r) => s + r.a_menos.valor, 0) * 100) / 100
  };
}
const SL_SEM_SEGMENTO = "(sem segmento)";
const slSegmento = (r) => (r.tipoartigo || "").trim() || SL_SEM_SEGMENTO;
function slSegmentosDe(rows) {
  const s = new Set(rows.map(slSegmento));
  const vazio = s.delete(SL_SEM_SEGMENTO);
  const out = [...s].sort((a, b) => a.localeCompare(b, "pt"));
  return vazio ? [...out, SL_SEM_SEGMENTO] : out;
}
const slNorm = (v) => String(v == null ? "" : v).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
const slTextoCasa = (r, f) => {
  const cont = (campo, q) => !q || slNorm(r[campo]).includes(slNorm(q));
  const enc = slNorm(f.enc);
  return cont("cliente", f.cliente) && cont("design", f.design) && cont("ref", f.ref) && (!enc || slNorm(r.nenc).startsWith(enc));
};
const slBuscaCasa = (r, q) => {
  const t = slNorm(q);
  return !t || slNorm(r.cliente).includes(t) || slNorm(r.ref).includes(t) || slNorm(r.design).includes(t) || slNorm(r.nenc).startsWith(t);
};
const slPorEntregarLigado = (encf, entr) => encf === "aberta" && entr === "sem";
const slPorEntregarPatch = (encf, entr) => slPorEntregarLigado(encf, entr) ? { encf: null, entr: null } : { encf: "aberta", entr: "sem" };
function slChips(v) {
  const c = [];
  const add = (id, rotulo, limpar, painel) => c.push({ id, rotulo, limpar, painel: !!painel });
  if (v.encf) add("encf", `Encomenda: ${v.encf === "aberta" ? "aberta" : "fechada"}`, { encf: null });
  if (v.entr) add("entr", `Entrega: ${v.entr === "sem" ? "sem data" : "com data"}`, { entr: null });
  if (v.q) add("q", `Pesquisa: ${v.q}`, { q: null });
  if (v.cliente) add("cliente", `Cliente: ${v.cliente}`, { cliente: null });
  if (v.enc) add("enc", `Enc.: ${v.enc}`, { enc: null });
  if (v.ref) add("ref", `Ref.: ${v.ref}`, { ref: null });
  if (v.design) add("design", `Designa\xE7\xE3o: ${v.design}`, { design: null });
  if (v.bloq) add("bloq", v.bloq === "sim" ? "Cliente bloqueado" : "Cliente n\xE3o bloqueado", { bloq: null }, true);
  if (v.amenos) add("amenos", "Entregue a menos", { amenos: null }, true);
  if (v.adiada) add("adiada", "Com adiamento", { adiada: null }, true);
  if (v.motivo) add("motivo", `Motivo: ${v.motivo}`, { motivo: null }, true);
  if (v.sos) add("sos", "SOS", { sos: null }, true);
  if (v.primeiras) add("primeiras", "S\xF3 primeiras", { primeiras: null }, true);
  if (v.aquis) add("aquis", `Aquisi\xE7\xE3o: ${v.aquis}`, { aquis: null }, true);
  if (v.vendedor) add("vendedor", `Vendedor: ${v.vendedor}`, { vendedor: null }, true);
  if (v.seg && v.seg.length) add("seg", `Segmento: ${v.seg.join(", ")}`, { seg: null }, true);
  if (v.dtipo) {
    const t = (SL_DATAS.find((d) => d.key === v.dtipo) || {}).label || v.dtipo;
    const iv = v.dde || v.date ? ` ${v.dde || "\u2026"} \u2013 ${v.date || "\u2026"}` : "";
    add("dtipo", `${t}:${iv || " qualquer data"}`, { dtipo: null, dde: null, date: null }, true);
  }
  if (v.bloco && v.chave) add("bloco", `Filtro: ${v.bloco} \xB7 ${v.chave}`, { bloco: null, chave: null });
  return c;
}
const slChipsPainel = (v) => slChips(v).filter((x) => x.painel).length;
const slLimparTudo = (v) => Object.assign({}, ...slChips(v).map((x) => x.limpar));
const slSegParse = (s) => s ? s.split("|").filter(Boolean) : [];
const slSegCasa = (r, sel) => !sel.length || sel.includes(slSegmento(r));
const slSegAlternar = (sel, seg) => sel.includes(seg) ? sel.filter((x) => x !== seg) : [...sel, seg];
function slPorSegmento(linhas) {
  const m = /* @__PURE__ */ new Map();
  linhas.forEach((r) => {
    const k = slSegmento(r);
    if (!m.has(k)) m.set(k, []);
    m.get(k).push(r);
  });
  return [...m.entries()].map(([segmento, ls]) => ({ segmento, ls })).sort((a, b) => b.ls.length - a.ls.length || a.segmento.localeCompare(b.segmento, "pt"));
}
const SL_SEM_MOTIVO = "(sem motivo)";
const slMotivo = (r) => r.adiamento && r.adiamento.motivo || SL_SEM_MOTIVO;
function slMotivosDe(rows) {
  const s = new Set(rows.filter((r) => r.adiamento).map(slMotivo));
  const vazio = s.delete(SL_SEM_MOTIVO);
  const out = [...s].sort((a, b) => a.localeCompare(b, "pt"));
  return vazio ? [...out, SL_SEM_MOTIVO] : out;
}
function slAdiamentosPorMotivo(linhas) {
  const m = /* @__PURE__ */ new Map();
  linhas.filter((r) => r.adiamento).forEach((r) => {
    const k = slMotivo(r);
    const e = m.get(k) || { motivo: k, linhas: 0, adiamentos: 0, causa: r.adiamento.causa, mapeado: r.adiamento.mapeado };
    e.linhas += 1;
    e.adiamentos += r.adiamento.contagem || 1;
    m.set(k, e);
  });
  return [...m.values()].sort((a, b) => b.linhas - a.linhas || a.motivo.localeCompare(b.motivo, "pt"));
}
function slNivelAdiamentos(linhas) {
  const conta = (campo) => {
    let ok = 0;
    let n = 0;
    linhas.forEach((r) => {
      const a = campo(r);
      if (a == null) return;
      n += 1;
      if (a <= 0) ok += 1;
    });
    return slNivel(ok, n);
  };
  return {
    com: conta((r) => r.entrega.atraso_sol),
    sem: conta((r) => r.entrega.atraso_sol_original != null ? r.entrega.atraso_sol_original : r.entrega.atraso_sol),
    n: linhas.filter((r) => r.entrega.atraso_sol_original != null).length
  };
}
function slCorMarco(etapa, data) {
  if (etapa) {
    if (etapa.inconsistente) return "inconsistente";
    if (etapa.fim) return etapa.excesso > 0 ? "acima" : "a_tempo";
    return etapa.inicio ? "em_curso" : "sem_dados";
  }
  return data ? "a_tempo" : "sem_dados";
}
function slMarcos(r) {
  const prod = r.fluxo === "producao";
  const p = prod ? "mp" : "me";
  const ets = Object.fromEntries((r.etapas || []).map((e) => [e.key, e]));
  const col = (c) => r[c + p] || null;
  const sufixo = prod ? "MP" : "ME";
  const comForn = !!(ets.requisicao || ets.fornecedor || col("datadareq") || col("datareq") || col("datasol") || col("dataconf") || col("datarec"));
  const m = (key, label, data, etapa) => ({ key, label, data, cor: slCorMarco(etapa, data) });
  const out = [m("encomenda", "Encomenda", r.dataenc || null, ets.lancamento)];
  if (comForn) {
    out.push(m("requisicao", `Requisi\xE7\xE3o ${sufixo}`, col("datadareq"), ets.requisicao));
    out.push(m("solicitada_forn", "Solicitada ao fornecedor", col("datasol"), null));
    out.push(m("confirmacao", "Confirma\xE7\xE3o do fornecedor", col("dataconf"), null));
    out.push(m("rececao", `Rece\xE7\xE3o ${sufixo}`, col("datarec"), ets.fornecedor));
  }
  if (prod && r.of) out.push(m("fabrico", "Fabrico (fecho da OF)", (ets.producao || {}).fim || null, ets.producao));
  if (r.adiamento) out.push(m("adiada", "Adiada para", r.adiamento.nova_data, null));
  out.push(m("picking", "Picking", (r.marcos || {}).pick || null, null));
  out.push(m("entrega", "Entrega", (r.entrega || {}).real || null, ets.logistica));
  return out;
}
const SL_ETAPA_MARCO = {
  lancamento: "encomenda",
  requisicao: "requisicao",
  fornecedor: "rececao",
  producao: "fabrico",
  logistica: "entrega"
};
function slTimeline(r, hoje) {
  const aberta = !!r.estado;
  const porMarco = {};
  (r.etapas || []).forEach((e) => {
    if (SL_ETAPA_MARCO[e.key]) porMarco[SL_ETAPA_MARCO[e.key]] = e;
  });
  const etapa = (e) => {
    const emCurso = !e.fim && !!e.inicio && aberta && !e.inconsistente;
    const dias = e.inconsistente ? null : e.fim ? e.dias : emCurso ? slDiff(e.inicio, hoje) : null;
    const planeadoDias = e.planeado && e.inicio && e.planeado >= e.inicio ? slDiff(e.inicio, e.planeado) : null;
    return {
      tipo: "etapa",
      key: e.key,
      label: e.label,
      dias,
      planeadoDias,
      excesso: e.excesso || 0,
      aberta: emCurso,
      espera: e.espera || null,
      origem: e.origem_planeado || null,
      cor: slCorMarco(e, e.inicio),
      inconsistente: !!e.inconsistente,
      frac: 0
    };
  };
  const out = [];
  slMarcos(r).forEach((m) => {
    const e = porMarco[m.key];
    if (e) out.push(etapa(e));
    out.push({ tipo: "marco", ...m });
  });
  const maior = Math.max(1, ...out.filter((i) => i.tipo === "etapa").map((i) => Math.max(i.dias || 0, i.planeadoDias || 0)));
  out.forEach((i) => {
    if (i.tipo === "etapa") i.frac = Math.max(i.dias || 0, i.planeadoDias || 0) / maior;
  });
  return out;
}
const slDias = (v) => v == null ? "\u2014" : `${v > 0 ? "+" : v < 0 ? "\u2212" : ""}${Math.abs(v)} d`;
const slData = (iso) => iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "\u2014";
function SlPastilha({ cor, children, title }) {
  return /* @__PURE__ */ React.createElement("span", { title, style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: "1px 8px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    whiteSpace: "nowrap",
    color: cor,
    background: cor + "1a",
    border: "1px solid " + cor + "55"
  } }, /* @__PURE__ */ React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: cor } }), children);
}
function SlCausaPastilha({ causa }) {
  const c = SL_CAUSA[causa];
  return c ? /* @__PURE__ */ React.createElement(SlPastilha, { cor: c.cor, title: `Respons\xE1vel: ${c.responsavel}` }, c.label) : null;
}
function SlEstadoPastilha({ chave }) {
  const e = SL_ESTADOS[chave];
  return e ? /* @__PURE__ */ React.createElement(SlPastilha, { cor: e.cor, title: e.title }, e.label) : null;
}
function SlChipCliente({ row }) {
  if (row.cliente_bloqueado) {
    return /* @__PURE__ */ React.createElement(SlPastilha, { cor: "#be185d", title: row.cliente_estado }, "Bloqueado");
  }
  return slAvisoBloqueio(row) ? /* @__PURE__ */ React.createElement(SlPastilha, { cor: "#b45309", title: row.cliente_estado }, row.cliente_estado.replace(/^Cliente /, "").replace(/\.$/, "")) : null;
}
function SlAMenosSelo({ a }) {
  return a ? /* @__PURE__ */ React.createElement(SlPastilha, { cor: "#b45309", title: "Linha fechada com menos quantidade entregue do que a encomendada" }, "\u26A0 entregue a menos ", slAMenosTexto(a)) : null;
}
function SlPrimeiraEnc() {
  return /* @__PURE__ */ React.createElement(SlPastilha, { cor: "#0f766e", title: "Primeira encomenda desta refer\xEAncia" }, "1.\xAA enc.");
}
function SlVazio({ children }) {
  return /* @__PURE__ */ React.createElement("div", { style: { padding: "28px 16px", textAlign: "center", color: "var(--muted)", fontSize: 13 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, opacity: 0.5, marginBottom: 6 } }, "\u25CC"), children);
}

// ===== bi/servico_linhas/frontend/hoje.jsx =====
function slHojeContar(rows, fluxo) {
  const out = { atrasada: 0, em_risco: 0, no_prazo: 0, bloqueado: 0, total: 0 };
  for (const r of rows) {
    if (r.fluxo !== fluxo) continue;
    const k = slEstadoGrupo(r);
    if (!k || !(k in out)) continue;
    out[k] += 1;
    out.total += 1;
  }
  return out;
}
function slHojeEtapas(rows, fluxo) {
  const por = {};
  for (const e of SL_ETAPAS[fluxo]) por[e.key] = { key: e.key, label: e.label, n: 0, soma: 0, excedidas: 0 };
  for (const r of rows) {
    const s = r.estado;
    if (r.fluxo !== fluxo || !s || s.bloqueado || s.fechada_phc || !por[s.etapa_atual]) continue;
    if (s.etapa_atual === "logistica" && r.enc_fechada) continue;
    const p = por[s.etapa_atual];
    p.n += 1;
    p.soma += s.excesso_etapa || 0;
    if ((s.excesso_etapa || 0) > 0) p.excedidas += 1;
  }
  return SL_ETAPAS[fluxo].map((e) => {
    const p = por[e.key];
    return { key: p.key, label: p.label, n: p.n, excedidas: p.excedidas, excesso: p.n ? p.soma / p.n : 0 };
  });
}
function slHojeCorEtapa(excesso) {
  return excesso > 5 ? SL_ESTADOS.atrasada.cor : excesso > 0 ? SL_ESTADOS.em_risco.cor : SL_ESTADOS.no_prazo.cor;
}
const SL_HOJE_ORDEM = ["atrasada", "em_risco", "no_prazo", "bloqueado"];
function SlHojeNumero({ chave, valor, filtro, setFiltro }) {
  const e = SL_ESTADOS[chave];
  const ativo = !!filtro && filtro.bloco === "hoje" && filtro.chave === chave;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "aria-pressed": ativo,
      title: `Filtrar a lista: ${e.label.toLowerCase()}`,
      onClick: () => setFiltro(slAlternar(filtro, { bloco: "hoje", chave })),
      style: {
        textAlign: "left",
        cursor: "pointer",
        padding: "10px 12px",
        borderRadius: 10,
        background: ativo ? e.cor + "1f" : "var(--panel-2, transparent)",
        color: "inherit",
        border: `1px solid ${ativo ? e.cor : "var(--border, #e5e7eb)"}`,
        borderLeft: `4px solid ${e.cor}`
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 30, fontWeight: 700, lineHeight: 1.05, color: e.cor, fontVariantNumeric: "tabular-nums" } }, INT.format(valor)),
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", marginTop: 2, display: "flex", alignItems: "center", gap: 4 } }, e.label)
  );
}
function SlHojeMontagem({ etapas, fluxo, filtro, setFiltro }) {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", marginTop: 14 }, "aria-label": `Linha de montagem \u2014 ${SL_FLUXOS[fluxo]}` }, etapas.map((e, i) => {
    const cor = slHojeCorEtapa(e.excesso);
    const chave = `parada:${e.key}`;
    const ativo = !!filtro && filtro.bloco === "hoje" && filtro.chave === chave;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: e.key,
        type: "button",
        "aria-pressed": ativo,
        title: `${e.n} linha(s) paradas em \xAB${e.label}\xBB${e.n ? ` \xB7 excesso m\xE9dio ${e.excesso.toFixed(1).replace(".", ",")} d` : ""}`,
        onClick: () => setFiltro(slAlternar(filtro, { bloco: "hoje", chave })),
        style: {
          flex: 1,
          minWidth: 0,
          cursor: "pointer",
          border: 0,
          padding: "8px 14px 8px 20px",
          marginLeft: i ? -8 : 0,
          color: "inherit",
          textAlign: "center",
          background: cor + (ativo ? "55" : "26"),
          boxShadow: ativo ? `inset 0 -3px 0 ${cor}` : "none",
          clipPath: `polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%${i ? ", 12px 50%" : ""})`
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, e.label),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: cor, fontVariantNumeric: "tabular-nums" } }, INT.format(e.n)),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: "var(--muted)", whiteSpace: "nowrap" } }, !e.n ? "sem paradas" : e.excesso > 0 ? `+${e.excesso.toFixed(1).replace(".", ",")} d em m\xE9dia` : "dentro do planeado")
    );
  }));
}
function SlHojeColuna({ fluxo, rows, filtro, setFiltro }) {
  const c = slHojeContar(rows, fluxo);
  const etapas = slHojeEtapas(rows, fluxo);
  return /* @__PURE__ */ React.createElement("div", { style: { flex: "1 1 520px", minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", gap: 8, marginBottom: 8 } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, SL_FLUXOS[fluxo]), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, INT.format(c.total), " linha(s) abertas com movimento")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", gap: 8 } }, SL_HOJE_ORDEM.map((k) => /* @__PURE__ */ React.createElement(SlHojeNumero, { key: k, chave: k, valor: c[k], filtro, setFiltro }))), /* @__PURE__ */ React.createElement(SlHojeMontagem, { etapas, fluxo, filtro, setFiltro }));
}
function SlHoje({ rows, fluxo, filtro, setFiltro }) {
  if (!rows || !rows.length) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement(SlVazio, null, "Sem linhas abertas para os filtros ativos."));
  }
  const fluxos = fluxo === "mercadoria" || fluxo === "producao" ? [fluxo] : ["mercadoria", "producao"];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Hoje"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 linhas abertas, hoje")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 28, padding: "4px 16px 16px" } }, fluxos.map((f) => /* @__PURE__ */ React.createElement(SlHojeColuna, { key: f, fluxo: f, rows, filtro, setFiltro }))));
}
window.ServicoBlocos = Object.assign(window.ServicoBlocos || {}, { Hoje: SlHoje });

// ===== bi/servico_linhas/frontend/causas.jsx =====
function slcEntregues(rows, periodo) {
  return slPeriodo(rows, periodo, "entrega.real").filter((r) => r.causa);
}
function slcOtd(linhas) {
  const conta = (campo) => {
    let ok = 0;
    let n = 0;
    linhas.forEach((r) => {
      const a = r.entrega[campo];
      if (a == null) return;
      n += 1;
      if (a <= 0) ok += 1;
    });
    return slNivel(ok, n);
  };
  return { sol: conta("atraso_sol"), prom: conta("atraso_prom") };
}
function slcPorCausa(linhas, causas) {
  const atrasadas = linhas.filter((r) => r.causa.principal);
  return causas.map((c) => ({
    ...c,
    linhas: atrasadas.filter((r) => r.causa.principal === c.key).length,
    dias: atrasadas.reduce((s, r) => s + (r.causa.excessos[c.key] || 0), 0)
  })).filter((c) => c.linhas > 0).sort((a, b) => b.linhas - a.linhas || b.dias - a.dias);
}
function slcSerie(linhas, gran, causas) {
  const baldes = /* @__PURE__ */ new Map();
  linhas.forEach((r) => {
    const k = slAgrupar(r.entrega.real, gran);
    if (!baldes.has(k)) baldes.set(k, []);
    baldes.get(k).push(r);
  });
  return [...baldes.keys()].sort().map((k) => {
    const ls = baldes.get(k);
    const porCausa = {};
    causas.forEach((c) => {
      porCausa[c.key] = ls.filter((r) => r.causa.principal === c.key).length;
    });
    return { chave: k, n: ls.length, porCausa, otd: slcOtd(ls) };
  });
}
function slcAbaixoPorVendedor(linhas) {
  const por = /* @__PURE__ */ new Map();
  linhas.forEach((r) => {
    if (!r.lead_time_forn || r.lead_time_forn.teorico == null) return;
    const v = r.vendedor || "\u2014";
    const o = por.get(v) || { vendedor: v, n: 0, abaixo: 0 };
    o.n += 1;
    if (r.abaixo_lt) o.abaixo += 1;
    por.set(v, o);
  });
  return [...por.values()].map((o) => ({ ...o, pct: o.abaixo / o.n })).sort((a, b) => b.pct - a.pct || b.abaixo - a.abaixo || a.vendedor.localeCompare(b.vendedor));
}
function slcLeadTimePorFornecedor(linhas) {
  const por = /* @__PURE__ */ new Map();
  linhas.forEach((r) => {
    const lt = r.lead_time_forn;
    const nome = ((r.fluxo === "producao" ? r.fornmp : r.fornme) || "").trim();
    if (!lt || !nome) return;
    const o = por.get(nome) || { fornecedor: nome, n: 0, st: 0, nt: 0, sr: 0, nr: 0 };
    o.n += 1;
    if (lt.teorico != null) {
      o.st += lt.teorico;
      o.nt += 1;
    }
    if (lt.real != null) {
      o.sr += lt.real;
      o.nr += 1;
    }
    por.set(nome, o);
  });
  return [...por.values()].map((o) => ({
    fornecedor: o.fornecedor,
    n: o.n,
    teorico: o.nt ? o.st / o.nt : null,
    real: o.nr ? o.sr / o.nr : null
  })).sort((a, b) => (b.real ?? 0) - (b.teorico ?? 0) - ((a.real ?? 0) - (a.teorico ?? 0)) || a.fornecedor.localeCompare(b.fornecedor));
}
function slcSegmentos(linhas, causas) {
  return slPorSegmento(linhas).map(({ segmento, ls }) => {
    const causasSeg = slcPorCausa(ls, causas);
    return {
      segmento,
      n: ls.length,
      atrasadas: ls.filter((r) => r.causa.principal).length,
      otd: slcOtd(ls),
      principal: causasSeg.length ? causasSeg[0].key : null,
      dias: causasSeg.reduce((s, c) => s + c.dias, 0)
    };
  });
}
const SLC_TIP_SOL = "Entregas a tempo contra a data SOLICITADA pelo cliente (atraso \u2264 0 d). \xC9 o n\xEDvel de servi\xE7o que o cliente sente.";
const SLC_TIP_PROM = "Entregas a tempo contra a data PROMETIDA. A diferen\xE7a para o OTD da solicitada \xE9 o que se perde na promessa: entreg\xE1mos quando dissemos, mas depois de quando o cliente pediu.";
function SlcOtd({ titulo, nivel, dica }) {
  return /* @__PURE__ */ React.createElement("div", { title: dica, style: { flex: 1, minWidth: 200 } }, /* @__PURE__ */ React.createElement(KpiCard, { label: titulo, value: nivel.valor == null ? "\u2014" : PCT1(nivel.valor), accent: nivel.cor }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", margin: "3px 2px 0" } }, INT.format(nivel.ok), " de ", INT.format(nivel.n), " linhas a tempo"));
}
function SlcBarras({ dados, filtro, onClick }) {
  const maxL = Math.max(1, ...dados.map((d) => d.linhas));
  const maxD = Math.max(1, ...dados.map((d) => d.dias));
  const ativo = filtro && filtro.bloco === "causas" ? filtro.chave : null;
  return /* @__PURE__ */ React.createElement("div", { role: "list", "aria-label": "Linhas atrasadas por causa principal", style: { display: "flex", flexDirection: "column", gap: 8 } }, dados.map((d) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: d.key,
      type: "button",
      role: "listitem",
      onClick: () => onClick(d.key),
      "aria-pressed": ativo === d.key,
      title: `${d.label} \xB7 ${d.responsavel}: ${d.linhas} linha(s) atrasada(s) com esta causa principal; ${d.dias} dia(s) perdidos`,
      style: {
        all: "unset",
        cursor: "pointer",
        display: "block",
        padding: "4px 6px",
        borderRadius: 8,
        boxSizing: "border-box",
        width: "100%",
        opacity: ativo && ativo !== d.key ? 0.4 : 1,
        outline: ativo === d.key ? `2px solid ${d.cor}` : "none"
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: 8, fontSize: 12, marginBottom: 3 } }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, d.label), " ", /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, d.responsavel)), /* @__PURE__ */ React.createElement("span", { className: "mono" }, INT.format(d.linhas), " lin. \xB7 ", INT.format(d.dias), " d")),
    /* @__PURE__ */ React.createElement("div", { style: { height: 12, borderRadius: 3, background: d.cor, width: `${d.linhas / maxL * 100}%`, minWidth: 3 } }),
    /* @__PURE__ */ React.createElement("div", { style: {
      height: 4,
      borderRadius: 2,
      marginTop: 2,
      background: d.cor + "88",
      width: `${d.dias / maxD * 100}%`,
      minWidth: d.dias > 0 ? 3 : 0
    } })
  )), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: "var(--muted)" } }, "Barra grossa: linhas atrasadas (causa principal) \xB7 barra fina: dias perdidos nessa causa \xB7 clicar filtra a lista"));
}
function SlcSegmentos({ dados }) {
  const nivel = (n) => n.valor == null ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014") : /* @__PURE__ */ React.createElement("strong", { title: `${n.ok} de ${n.n} a tempo`, style: { color: n.cor } }, PCT1(n.valor));
  const columns = [
    { key: "segmento", label: "Segmento", width: 170, minWidth: 110, fixed: true, render: (d) => /* @__PURE__ */ React.createElement("strong", null, d.segmento) },
    { key: "n", label: "Linhas", width: 80, minWidth: 60, align: "right", mono: true, render: (d) => INT.format(d.n) },
    { key: "atrasadas", label: "Atrasadas", width: 90, minWidth: 70, align: "right", mono: true, render: (d) => INT.format(d.atrasadas) },
    { key: "sol", label: "OTD solicitada", width: 120, minWidth: 90, align: "right", sortValue: (d) => d.otd.sol.valor, render: (d) => nivel(d.otd.sol) },
    { key: "prom", label: "OTD prometida", width: 120, minWidth: 90, align: "right", sortValue: (d) => d.otd.prom.valor, render: (d) => nivel(d.otd.prom) },
    {
      key: "principal",
      label: "Causa principal",
      width: 230,
      minWidth: 150,
      sortValue: (d) => d.principal || "",
      render: (d) => d.principal ? /* @__PURE__ */ React.createElement(SlCausaPastilha, { causa: d.principal }) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    { key: "dias", label: "Dias perdidos", width: 110, minWidth: 80, align: "right", mono: true, render: (d) => INT.format(d.dias) }
  ];
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "causas-por-segmento" }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600, margin: "0 0 4px" } }, "Por segmento de produto"), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "servico-causas-segmento",
      columns,
      data: dados,
      rowKey: (d) => d.segmento,
      empty: "Sem segmentos."
    }
  ));
}
function SlcAdiamentos({ dados, filtro, onClick }) {
  if (dados.length === 0) return /* @__PURE__ */ React.createElement(SlVazio, null, "Sem adiamentos nas entregas deste per\xEDodo.");
  const max = Math.max(...dados.map((d) => d.linhas));
  const ativa = filtro && filtro.bloco === "adiamentos" ? filtro.chave : null;
  return /* @__PURE__ */ React.createElement("div", { role: "list", "aria-label": "Adiamentos por motivo", style: { display: "flex", flexDirection: "column", gap: 6 } }, dados.map((d) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: d.motivo,
      type: "button",
      role: "listitem",
      onClick: () => onClick(d.motivo),
      "aria-pressed": ativa === d.motivo,
      title: `${d.linhas} linha(s), ${d.adiamentos} adiamento(s)${d.mapeado ? "" : " \u2014 motivo sem causa atribu\xEDda"}`,
      style: {
        display: "block",
        textAlign: "left",
        border: 0,
        background: "transparent",
        cursor: "pointer",
        padding: 0,
        fontSize: 12,
        opacity: ativa && ativa !== d.motivo ? 0.5 : 1
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: 8 } }, /* @__PURE__ */ React.createElement("strong", null, d.motivo), /* @__PURE__ */ React.createElement("span", { className: "mono" }, INT.format(d.linhas), " linha(s)")),
    /* @__PURE__ */ React.createElement("div", { style: { height: 6, borderRadius: 3, background: "#64748b22" } }, /* @__PURE__ */ React.createElement("div", { style: {
      height: 6,
      borderRadius: 3,
      background: (SL_CAUSA[d.causa] || {}).cor || "#64748b",
      width: `${d.linhas / max * 100}%`
    } }))
  )));
}
function SlcEvolucao({ serie, gran, causas, onCausa }) {
  const option = useMemo(() => {
    return {
      tooltip: { trigger: "axis" },
      legend: { type: "scroll", bottom: 0, textStyle: { fontSize: 11 } },
      grid: { left: 40, right: 48, top: 28, bottom: 56 },
      xAxis: { type: "category", boundaryGap: false, data: serie.map((s) => slRotulo(s.chave, gran)) },
      yAxis: [
        { type: "value", name: "linhas atrasadas", minInterval: 1, nameTextStyle: { fontSize: 10 } },
        {
          type: "value",
          name: "OTD",
          min: 0,
          max: 1,
          axisLabel: { formatter: (v) => `${Math.round(v * 100)}%` },
          splitLine: { show: false },
          nameTextStyle: { fontSize: 10 }
        }
      ],
      series: [
        ...causas.map((c) => ({
          name: c.label,
          type: "line",
          stack: "causas",
          areaStyle: { opacity: 0.85 },
          symbol: "none",
          lineStyle: { width: 0 },
          itemStyle: { color: c.cor },
          color: c.cor,
          data: serie.map((s) => s.porCausa[c.key])
        })),
        {
          name: "OTD solicitada",
          type: "line",
          yAxisIndex: 1,
          symbolSize: 5,
          color: "#111827",
          lineStyle: { width: 2 },
          data: serie.map((s) => s.otd.sol.valor == null ? null : s.otd.sol.valor)
        },
        {
          name: "OTD prometida",
          type: "line",
          yAxisIndex: 1,
          symbolSize: 5,
          color: "#7c3aed",
          lineStyle: { width: 2, type: "dashed" },
          data: serie.map((s) => s.otd.prom.valor == null ? null : s.otd.prom.valor)
        }
      ]
    };
  }, [serie, gran, causas]);
  const porNome = Object.fromEntries(causas.map((c) => [c.label, c.key]));
  return /* @__PURE__ */ React.createElement(
    EChart,
    {
      option,
      height: 300,
      onSelect: (nome, p) => {
        const k = porNome[p.seriesName];
        if (k) onCausa(k);
      }
    }
  );
}
const SLC_D1 = new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 1 });
function SlcPromessasAbaixo({ dados }) {
  if (dados.length === 0) return /* @__PURE__ */ React.createElement(SlVazio, null, "Sem linhas com lead time do fornecedor neste per\xEDodo.");
  return /* @__PURE__ */ React.createElement("div", { role: "list", "aria-label": "Prometida abaixo do lead time por vendedor", style: { display: "flex", flexDirection: "column", gap: 6 } }, dados.map((d) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: d.vendedor,
      role: "listitem",
      style: { fontSize: 12 },
      title: `${d.abaixo} de ${d.n} linhas com fornecedor prometidas abaixo da data m\xEDnima`
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: 8 } }, /* @__PURE__ */ React.createElement("strong", null, d.vendedor), /* @__PURE__ */ React.createElement("span", { className: "mono" }, PCT1(d.pct), " \xB7 ", INT.format(d.abaixo), " de ", INT.format(d.n))),
    /* @__PURE__ */ React.createElement("div", { style: { height: 6, borderRadius: 3, background: "#17255422" } }, /* @__PURE__ */ React.createElement("div", { style: { height: 6, borderRadius: 3, background: "#172554", width: `${d.pct * 100}%`, minWidth: d.abaixo > 0 ? 3 : 0 } }))
  )));
}
function SlcLeadTimeForn({ dados }) {
  if (dados.length === 0) return /* @__PURE__ */ React.createElement(SlVazio, null, "Sem lead times de fornecedores neste per\xEDodo.");
  const f = (v) => v == null ? "\u2014" : `${SLC_D1.format(v)} d`;
  return /* @__PURE__ */ React.createElement("div", { role: "list", "aria-label": "Lead time te\xF3rico e real por fornecedor", style: { display: "flex", flexDirection: "column", gap: 4, maxHeight: 260, overflowY: "auto" } }, dados.map((d) => /* @__PURE__ */ React.createElement("div", { key: d.fornecedor, role: "listitem", style: { display: "flex", justifyContent: "space-between", gap: 8, fontSize: 12 } }, /* @__PURE__ */ React.createElement("span", null, d.fornecedor, " ", /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, INT.format(d.n), " lin.")), /* @__PURE__ */ React.createElement("span", { className: "mono" }, "te\xF3rico ", f(d.teorico), " \xB7 real ", f(d.real)))));
}
function SlCausas({ rows, periodo, gran, filtro, setFiltro }) {
  const linhas = useMemo(() => slcEntregues(rows, periodo), [rows, periodo]);
  const otd = useMemo(() => slcOtd(linhas), [linhas]);
  const dados = useMemo(() => slcPorCausa(linhas, SL_CAUSAS), [linhas]);
  const serie = useMemo(() => slcSerie(linhas, gran, SL_CAUSAS), [linhas, gran]);
  const vendedores = useMemo(() => slcAbaixoPorVendedor(linhas), [linhas]);
  const fornecedores = useMemo(() => slcLeadTimePorFornecedor(linhas), [linhas]);
  const segmentos = useMemo(() => slcSegmentos(linhas, SL_CAUSAS), [linhas]);
  const adiamentos = useMemo(() => slAdiamentosPorMotivo(linhas), [linhas]);
  const nAtrasadas = dados.reduce((s, d) => s + d.linhas, 0);
  const alternar = (chave) => setFiltro(slAlternar(filtro, { bloco: "causas", chave }));
  const alternarMotivo = (chave) => setFiltro(slAlternar(filtro, { bloco: "adiamentos", chave }));
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Falhas no per\xEDodo"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", INT.format(linhas.length), " linha(s) entregue(s), ", INT.format(nAtrasadas), " atrasada(s)")), /* @__PURE__ */ React.createElement("div", { style: { padding: "4px 16px 16px", display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(SlcOtd, { titulo: "OTD solicitada", nivel: otd.sol, dica: SLC_TIP_SOL }), /* @__PURE__ */ React.createElement(SlcOtd, { titulo: "OTD prometida", nivel: otd.prom, dica: SLC_TIP_PROM })), linhas.length === 0 ? /* @__PURE__ */ React.createElement(SlVazio, null, "Sem linhas entregues neste per\xEDodo e filtros.") : nAtrasadas === 0 ? /* @__PURE__ */ React.createElement(SlVazio, null, "Nenhuma linha atrasada neste per\xEDodo \u2014 nada a explicar.") : /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "minmax(280px, 2fr) minmax(320px, 3fr)", gap: 20, alignItems: "start" } }, /* @__PURE__ */ React.createElement(SlcBarras, { dados, filtro, onClick: alternar }), /* @__PURE__ */ React.createElement(
    SlcEvolucao,
    {
      serie,
      gran,
      causas: SL_CAUSAS.filter((c) => dados.some((d) => d.key === c.key)),
      onCausa: alternar
    }
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 20, alignItems: "start" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600, marginBottom: 6 } }, "Prometidas abaixo do lead time, por vendedor"), /* @__PURE__ */ React.createElement(SlcPromessasAbaixo, { dados: vendedores })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600, marginBottom: 6 } }, "Lead time m\xE9dio por fornecedor"), /* @__PURE__ */ React.createElement(SlcLeadTimeForn, { dados: fornecedores }))), /* @__PURE__ */ React.createElement("div", { "data-testid": "causas-adiamentos" }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600, marginBottom: 6 } }, "Adiamentos por motivo"), /* @__PURE__ */ React.createElement(SlcAdiamentos, { dados: adiamentos, filtro, onClick: alternarMotivo })), linhas.length > 0 && /* @__PURE__ */ React.createElement(SlcSegmentos, { dados: segmentos })));
}
window.ServicoBlocos = Object.assign(window.ServicoBlocos || {}, { Causas: SlCausas });

// ===== bi/servico_linhas/frontend/operacoes.jsx =====
function sloMediana(v) {
  if (!v.length) return null;
  const s = [...v].sort((a, b) => a - b);
  const m = s.length >> 1;
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
}
function sloAgregar(rows, metas, janela, gran, fluxo) {
  const entregues = slPeriodo(rows.filter((r) => r.causa), janela, "entrega.real");
  const fluxos = fluxo === "todos" ? ["mercadoria", "producao"] : [fluxo];
  const out = [];
  for (const f of fluxos) {
    for (const def of SL_ETAPAS[f]) {
      const obs = [];
      for (const r of entregues) {
        if (r.fluxo !== f) continue;
        if (def.key === "logistica" && r.enc_fechada) continue;
        const e = r.etapas.find((x) => x.key === def.key);
        if (e && e.dias != null && !e.inconsistente) obs.push({ dias: e.dias, ok: e.excesso === 0, dia: r.entrega.real });
      }
      const baldes = /* @__PURE__ */ new Map();
      for (const o of obs) {
        const k = slAgrupar(o.dia, gran);
        const b = baldes.get(k) || { ok: 0, n: 0 };
        b.n += 1;
        b.ok += o.ok ? 1 : 0;
        baldes.set(k, b);
      }
      const serie = [...baldes.entries()].sort((a, b) => a[0] < b[0] ? -1 : 1).map(([k, b]) => ({ chave: k, valor: b.ok / b.n, n: b.n }));
      const dias = obs.map((o) => o.dias);
      out.push({
        id: `${f}:${def.key}`,
        fluxo: f,
        key: def.key,
        label: def.label,
        n: obs.length,
        media: dias.length ? dias.reduce((a, b) => a + b, 0) / dias.length : null,
        mediana: sloMediana(dias),
        meta: ((metas || {})[f] || {})[def.key] ?? null,
        nivel: slNivel(obs.filter((o) => o.ok).length, obs.length),
        serie
      });
    }
  }
  return out;
}
function sloSegmentos(rows, metas, janela) {
  const entregues = slPeriodo(rows.filter((r) => r.causa), janela, "entrega.real");
  return slPorSegmento(entregues).map(({ segmento, ls }) => {
    let ok = 0, obs = 0, soma = 0, somaMeta = 0;
    ls.forEach((r) => {
      let dias = 0, meta = 0;
      r.etapas.forEach((e) => {
        if (e.dias == null || e.inconsistente) return;
        dias += e.dias;
        meta += ((metas || {})[r.fluxo] || {})[e.key] || 0;
        obs += 1;
        ok += e.excesso === 0 ? 1 : 0;
      });
      soma += dias;
      somaMeta += meta;
    });
    return { segmento, n: ls.length, media: soma / ls.length, meta: somaMeta / ls.length, nivel: slNivel(ok, obs) };
  });
}
const sloD1 = (v) => v == null ? "\u2014" : v.toLocaleString("pt-PT", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
function SloBullet({ media, meta, max }) {
  if (media == null) return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014");
  const W = 150;
  const x = (v) => Math.max(0, Math.min(W, v / max * W));
  const dentro = meta == null || media <= meta;
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: W,
      height: 18,
      role: "img",
      "aria-label": `M\xE9dio ${sloD1(media)} d${meta != null ? `, meta ${meta} d` : ""}`,
      style: { display: "block" }
    },
    /* @__PURE__ */ React.createElement("title", null, `M\xE9dio ${sloD1(media)} d \xB7 meta ${meta ?? "\u2014"} d`),
    /* @__PURE__ */ React.createElement("rect", { x: 0, y: 4, width: W, height: 10, rx: 3, fill: "var(--border)", opacity: 0.45 }),
    /* @__PURE__ */ React.createElement("rect", { x: 0, y: 4, width: Math.max(2, x(media)), height: 10, rx: 3, fill: dentro ? "#15803d" : "#b45309" }),
    meta != null && /* @__PURE__ */ React.createElement("rect", { x: x(meta) - 1, y: 0, width: 2.5, height: 18, fill: "var(--text)" })
  );
}
function SloSpark({ serie, cor }) {
  if (serie.length < 2) return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, serie.length ? "1 ponto" : "\u2014");
  const W = 96, H = 24, P = 2;
  const pts = serie.map((s, i) => [P + i / (serie.length - 1) * (W - 2 * P), P + (1 - s.valor) * (H - 2 * P)]);
  const ult = pts[pts.length - 1];
  return /* @__PURE__ */ React.createElement("svg", { width: W, height: H, role: "img", "aria-label": "N\xEDvel de servi\xE7o ao longo do per\xEDodo", style: { display: "block" } }, /* @__PURE__ */ React.createElement("title", null, serie.map((s) => `${slRotulo(s.chave, s.chave.length === 7 ? "mes" : "dia")} ${Math.round(s.valor * 100)}%`).join(" \xB7 ")), /* @__PURE__ */ React.createElement(
    "polyline",
    {
      points: pts.map((p) => p.join(",")).join(" "),
      fill: "none",
      stroke: cor,
      strokeWidth: 1.6,
      strokeLinejoin: "round",
      strokeLinecap: "round"
    }
  ), /* @__PURE__ */ React.createElement("circle", { cx: ult[0], cy: ult[1], r: 2.6, fill: cor }));
}
function SloSegmentos({ dados }) {
  const columns = [
    { key: "segmento", label: "Segmento", width: 170, minWidth: 110, fixed: true, render: (d) => /* @__PURE__ */ React.createElement("strong", null, d.segmento) },
    { key: "n", label: "Linhas", width: 80, minWidth: 60, align: "right", mono: true, render: (d) => INT.format(d.n) },
    { key: "media", label: "Lead time m\xE9dio", width: 130, minWidth: 90, align: "right", mono: true, render: (d) => `${sloD1(d.media)} d` },
    { key: "meta", label: "Meta", width: 90, minWidth: 60, align: "right", mono: true, render: (d) => `${sloD1(d.meta)} d` },
    {
      key: "nivel",
      label: "N\xEDvel de servi\xE7o",
      width: 130,
      minWidth: 100,
      align: "right",
      sortValue: (d) => d.nivel.valor,
      render: (d) => d.nivel.valor == null ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014") : /* @__PURE__ */ React.createElement("strong", { title: `${d.nivel.ok} de ${d.nivel.n} medi\xE7\xF5es sem excesso`, style: { color: d.nivel.cor } }, PCT1(d.nivel.valor))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "operacoes-por-segmento", style: { padding: "4px 16px 8px" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600, margin: "8px 0 4px" } }, "Por segmento de produto"), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "servico-operacoes-segmento",
      columns,
      data: dados,
      rowKey: (d) => d.segmento,
      empty: "Sem segmentos."
    }
  ));
}
function SloAdiamentos({ rows, periodo }) {
  const linhas = useMemo(() => slPeriodo(rows.filter((r) => r.causa), periodo, "entrega.real"), [rows, periodo]);
  const d = useMemo(() => slNivelAdiamentos(linhas), [linhas]);
  const valor = (n) => n.valor == null ? "\u2014" : PCT1(n.valor);
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "operacoes-adiamentos", style: { padding: "4px 16px 8px" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600, margin: "8px 0 4px" } }, "N\xEDvel de servi\xE7o e adiamentos a pedido do cliente"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 24, flexWrap: "wrap", fontSize: 12 } }, /* @__PURE__ */ React.createElement("span", { title: `${d.com.ok} de ${d.com.n} entregues at\xE9 \xE0 data de refer\xEAncia` }, "Com o adiamento (nova data conta): ", /* @__PURE__ */ React.createElement("strong", { style: { color: d.com.cor } }, valor(d.com))), /* @__PURE__ */ React.createElement("span", { title: `${d.sem.ok} de ${d.sem.n} entregues at\xE9 \xE0 data solicitada original` }, "Sem o adiamento (solicitada original): ", /* @__PURE__ */ React.createElement("strong", { style: { color: d.sem.cor } }, valor(d.sem))), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, INT.format(d.n), " linha(s) adiada(s) a pedido do cliente")));
}
function SlOperacoes({ rows, metas, fluxo, periodo, gran, filtro, setFiltro }) {
  const linhas = useMemo(
    () => sloAgregar(rows, metas, periodo, gran, fluxo),
    [rows, metas, periodo, gran, fluxo]
  );
  const segmentos = useMemo(() => sloSegmentos(rows, metas, periodo), [rows, metas, periodo]);
  const max = useMemo(() => Math.max(1, ...linhas.flatMap((l) => [l.media || 0, l.meta || 0])) * 1.15, [linhas]);
  const ativa = filtro && filtro.bloco === "operacoes" ? filtro.chave.replace(/^etapa:/, "") : null;
  const comFluxo = fluxo === "todos";
  const total = linhas.reduce((a, l) => a + l.n, 0);
  const columns = [
    {
      key: "label",
      label: "Etapa",
      width: 170,
      minWidth: 120,
      fixed: true,
      render: (l) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, l.label, comFluxo && /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontWeight: 400 } }, " \xB7 ", SL_FLUXOS[l.fluxo]))
    },
    { key: "n", label: "Linhas", width: 80, minWidth: 60, align: "right", mono: true, render: (l) => INT.format(l.n) },
    { key: "media", label: "Lead time m\xE9dio", width: 120, minWidth: 90, align: "right", mono: true, render: (l) => l.media == null ? "\u2014" : `${sloD1(l.media)} d` },
    { key: "mediana", label: "Mediana", width: 90, minWidth: 70, align: "right", mono: true, render: (l) => l.mediana == null ? "\u2014" : `${sloD1(l.mediana)} d` },
    { key: "meta", label: "Meta", width: 80, minWidth: 60, align: "right", mono: true, render: (l) => l.meta == null ? "\u2014" : `${l.meta} d` },
    {
      key: "bullet",
      label: "Real vs meta",
      width: 170,
      minWidth: 130,
      sortable: false,
      render: (l) => /* @__PURE__ */ React.createElement(SloBullet, { media: l.media, meta: l.meta, max })
    },
    {
      key: "nivel",
      label: "N\xEDvel de servi\xE7o",
      width: 130,
      minWidth: 100,
      align: "right",
      sortValue: (l) => l.nivel.valor,
      render: (l) => l.nivel.valor == null ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014") : /* @__PURE__ */ React.createElement("strong", { title: `${l.nivel.ok} de ${l.nivel.n} sem excesso`, style: { color: l.nivel.cor } }, PCT1(l.nivel.valor))
    },
    {
      key: "spark",
      label: `Por ${{ dia: "dia", semana: "semana", mes: "m\xEAs" }[gran]}`,
      width: 120,
      minWidth: 100,
      sortable: false,
      render: (l) => /* @__PURE__ */ React.createElement(SloSpark, { serie: l.serie, cor: l.nivel.cor })
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Opera\xE7\xF5es"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 lead time por etapa, entregas no per\xEDodo \xB7 meta = dias de calend\xE1rio"), ativa && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", style: { marginLeft: "auto" }, onClick: () => setFiltro(null) }, "Etapa: ", ativa, " \u2715")), total === 0 ? /* @__PURE__ */ React.createElement(SlVazio, null, "Sem entregas no per\xEDodo para medir o lead time.") : /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "servico-operacoes",
      columns,
      data: linhas.filter((l) => l.n > 0),
      rowKey: (l) => l.id,
      onRowClick: (l) => setFiltro(slAlternar(filtro, { bloco: "operacoes", chave: `etapa:${l.key}` })),
      rowStyle: (l) => ativa === l.key ? { background: VISION_ACCENT + "1a" } : null,
      empty: "Sem etapas."
    }
  ), total > 0 && /* @__PURE__ */ React.createElement(SloAdiamentos, { rows, periodo }), total > 0 && /* @__PURE__ */ React.createElement(SloSegmentos, { dados: segmentos }), /* @__PURE__ */ React.createElement("div", { style: { padding: "6px 16px 12px", fontSize: 11, color: "var(--muted)" } }, "N\xEDvel de servi\xE7o: % de linhas em que a etapa terminou dentro do planeado. A barra \xE9 o lead time m\xE9dio; o tra\xE7o, a meta. Clicar numa etapa filtra a lista pelas entregas com excesso nela."));
}
window.ServicoBlocos = Object.assign(window.ServicoBlocos || {}, { Operacoes: SlOperacoes });

// ===== bi/servico_linhas/frontend/risco.jsx =====
function slrSerie(fotos, fluxo, gran) {
  const porDia = {};
  for (const f of fotos) {
    if (f.etapa !== "" || fluxo !== "todos" && f.fluxo !== fluxo) continue;
    const m = f.metricas;
    const d = porDia[f.dia] || (porDia[f.dia] = { abertas: 0, em_risco: 0, atrasadas: 0, entregues: 0, sol: 0, prom: 0 });
    d.abertas += m.abertas || 0;
    d.em_risco += m.em_risco_sol || 0;
    d.atrasadas += m.atrasadas_sol || 0;
    d.entregues += m.entregues_dia || 0;
    d.sol += m.a_tempo_sol || 0;
    d.prom += m.a_tempo_prom || 0;
  }
  const baldes = {};
  for (const dia of Object.keys(porDia).sort()) {
    const d = porDia[dia];
    const chave = slAgrupar(dia, gran);
    const b = baldes[chave] || (baldes[chave] = { chave, entregues: 0, sol: 0, prom: 0 });
    b.abertas = d.abertas;
    b.em_risco = d.em_risco;
    b.atrasadas = d.atrasadas;
    b.entregues += d.entregues;
    b.sol += d.sol;
    b.prom += d.prom;
  }
  return Object.values(baldes).sort((a, b) => a.chave < b.chave ? -1 : 1).map((b) => ({
    chave: b.chave,
    abertas: b.abertas,
    em_risco: b.em_risco,
    atrasadas: b.atrasadas,
    entregues: b.entregues,
    aTempoSol: b.entregues ? b.sol / b.entregues : null,
    aTempoProm: b.entregues ? b.prom / b.entregues : null
  }));
}
function slrVazio(primeiroDia) {
  if (!primeiroDia) return "Ainda n\xE3o h\xE1 fotografias di\xE1rias \u2014 a primeira grava-se quando o timer das 06:00 correr pela primeira vez.";
  return `Sem fotografias neste per\xEDodo. H\xE1 fotografias desde ${primeiroDia.slice(8, 10)}/${primeiroDia.slice(5, 7)}/${primeiroDia.slice(0, 4)}.`;
}
function SlRiscoCurva({ serie, gran }) {
  const option = useMemo(() => {
    const pct = (v) => v == null ? null : Math.round(v * 1e3) / 1e3;
    return {
      tooltip: { trigger: "axis", valueFormatter: (v) => v == null ? "\u2014" : v },
      legend: { bottom: 0, textStyle: { fontSize: 11 } },
      grid: { left: 44, right: 48, top: 28, bottom: 40 },
      xAxis: { type: "category", data: serie.map((s) => slRotulo(s.chave, gran)) },
      yAxis: [
        { type: "value", name: "linhas", minInterval: 1, nameTextStyle: { fontSize: 10 } },
        {
          type: "value",
          name: "a tempo",
          min: 0,
          max: 1,
          axisLabel: { formatter: (v) => `${Math.round(v * 100)}%` },
          splitLine: { show: false },
          nameTextStyle: { fontSize: 10 }
        }
      ],
      series: [
        { name: "Abertas", type: "line", symbolSize: 4, color: "#6b7280", data: serie.map((s) => s.abertas) },
        { name: "Em risco", type: "line", symbolSize: 4, color: SL_ESTADOS.em_risco.cor, data: serie.map((s) => s.em_risco) },
        { name: "Atrasadas", type: "line", symbolSize: 4, color: SL_ESTADOS.atrasada.cor, data: serie.map((s) => s.atrasadas) },
        {
          name: "A tempo (solicitada)",
          type: "line",
          yAxisIndex: 1,
          symbolSize: 4,
          color: "#111827",
          lineStyle: { width: 2 },
          connectNulls: true,
          data: serie.map((s) => pct(s.aTempoSol))
        },
        {
          name: "A tempo (prometida)",
          type: "line",
          yAxisIndex: 1,
          symbolSize: 4,
          color: "#7c3aed",
          lineStyle: { width: 2, type: "dashed" },
          connectNulls: true,
          data: serie.map((s) => pct(s.aTempoProm))
        }
      ]
    };
  }, [serie, gran]);
  return /* @__PURE__ */ React.createElement(EChart, { option, height: 300 });
}
function SlRisco({ fluxo, periodo, gran }) {
  const [estado, setEstado] = useState({ fase: "carregar", rows: [], primeiro: null, erro: null });
  const [ini, fim] = periodo;
  useEffect(() => {
    let vivo = true;
    setEstado((e) => ({ ...e, fase: "carregar" }));
    window.API.biServicoFotografias({ desde: ini, ate: fim }).then((d) => {
      if (vivo) setEstado({ fase: "ok", rows: d.rows, primeiro: d.primeiro_dia, erro: null });
    }).catch((e) => {
      if (vivo) setEstado({ fase: "erro", rows: [], primeiro: null, erro: String(e.message || e) });
    });
    return () => {
      vivo = false;
    };
  }, [ini, fim]);
  const serie = useMemo(() => slrSerie(estado.rows, fluxo, gran), [estado.rows, fluxo, gran]);
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Risco ao longo do tempo"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 fotografia di\xE1ria das linhas abertas e das entregas")), /* @__PURE__ */ React.createElement("div", { style: { padding: "4px 16px 16px" } }, estado.fase === "carregar" && !estado.rows.length ? /* @__PURE__ */ React.createElement(SlVazio, null, "A carregar a fotografia\u2026") : estado.fase === "erro" ? /* @__PURE__ */ React.createElement(SlVazio, null, "N\xE3o foi poss\xEDvel carregar a fotografia: ", estado.erro) : serie.length === 0 ? /* @__PURE__ */ React.createElement(SlVazio, null, slrVazio(estado.primeiro)) : /* @__PURE__ */ React.createElement(SlRiscoCurva, { serie, gran }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: "var(--muted)", marginTop: 6 } }, "Linhas abertas com movimento, ", gran === "mes" ? "no \xFAltimo dia de cada m\xEAs" : gran === "semana" ? "no \xFAltimo dia de cada semana" : "em cada dia", "; \xABem risco\xBB e \xABatrasadas\xBB contra a data solicitada. \xABA tempo\xBB = entregas do per\xEDodo entregues na data (ou antes), \xE0 direita em %.")));
}
window.ServicoBlocos = Object.assign(window.ServicoBlocos || {}, { Risco: SlRisco });

// ===== bi/servico_linhas/frontend/drawer.jsx =====
const SL_APP = "bi";
const SL_RES = "linha_servico";
const SL_COR_MARCO = {
  a_tempo: "#15803d",
  acima: "#b91c1c",
  em_curso: "#b45309",
  inconsistente: "#6b7280",
  sem_dados: "var(--border)"
};
const SL_LEGENDA_MARCO = {
  a_tempo: "a tempo",
  acima: "acima do planeado",
  em_curso: "em curso",
  inconsistente: "datas inconsistentes",
  sem_dados: "sem data"
};
const SlApi = /* @__PURE__ */ (() => {
  const B = (b) => `/api/bi/servico/linhas/${encodeURIComponent(b)}`;
  const csrf = () => {
    const m = document.cookie.match("(^|;)\\s*csrftoken\\s*=\\s*([^;]+)");
    return m ? m.pop() : "";
  };
  const req = (url, { method = "GET", body } = {}) => {
    const opts = { method, credentials: "same-origin", headers: {} };
    if (method !== "GET") opts.headers["X-CSRFToken"] = csrf();
    if (body !== void 0) {
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then((r) => {
      if (r.status === 204) return null;
      if (!r.ok) return r.json().then((e) => Promise.reject(e)).catch((e) => Promise.reject(e || { status: r.status }));
      return r.json();
    });
  };
  return {
    acoes: (b) => req(`${B(b)}/acoes/`),
    addAcao: (b, tipo_id_slug, descricao, atribuido_id, data_limite) => req(`${B(b)}/acoes/`, { method: "POST", body: { tipo_id_slug, descricao, atribuido_id, data_limite } }),
    delAcao: (b, id) => req(`${B(b)}/acoes/${id}/`, { method: "DELETE" }),
    tratar: (b, id) => req(`${B(b)}/acoes/${id}/tratar/`, { method: "POST", body: {} }),
    prazo: (b, id, iso) => req(`${B(b)}/acoes/${id}/prazo/`, { method: "POST", body: { data_limite: iso || null } }),
    audit: (b) => req(`${B(b)}/audit/`),
    anexos: (b) => req(`${B(b)}/anexos/`),
    stock: (b) => req(`${B(b)}/stock/`),
    downloadUrl: (b, stamp) => `${B(b)}/anexo/${encodeURIComponent(stamp)}/download/`,
    verUrl: (b, stamp) => `${B(b)}/anexo/${encodeURIComponent(stamp)}/download/?ver=1`
  };
})();
const SL_EXT_IMG = ["png", "jpg", "jpeg", "gif", "webp"];
function slAnexoTipo(a) {
  if (!a) return null;
  if (a.url) return "link";
  const ext = String(a.fext || "").toLowerCase();
  if (ext === "pdf") return "pdf";
  return SL_EXT_IMG.includes(ext) ? "img" : "baixar";
}
function slAnexoAberto(anexos, stamp) {
  if (!anexos || !stamp) return null;
  const a = [...anexos.encomenda || [], ...anexos.artigo || []].find((x) => x.anexosstamp === stamp);
  return a && ["pdf", "img"].includes(slAnexoTipo(a)) ? a : null;
}
function SlVisualizador({ bistamp, a, onFechar }) {
  const nome = `${a.fname || "anexo"}${a.fext ? "." + a.fext : ""}`;
  const src = SlApi.verUrl(bistamp, a.anexosstamp);
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minWidth: 0, height: "100%", borderLeft: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderBottom: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("span", { style: { flex: 1, minWidth: 0, fontSize: 12.5, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, title: nome }, nome), /* @__PURE__ */ React.createElement("a", { className: "btn ghost sm", href: src, target: "_blank", rel: "noopener noreferrer", title: "Abrir em nova aba" }, "\u2922"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: onFechar }, "\u2715 fechar documento")), slAnexoTipo(a) === "pdf" ? /* @__PURE__ */ React.createElement("iframe", { title: nome, src, style: { flex: 1, border: 0, width: "100%" } }) : /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflow: "auto", padding: 12 } }, /* @__PURE__ */ React.createElement("img", { alt: nome, src, style: { maxWidth: "100%" } })));
}
function SlAnexoLinha({ bistamp, a, onVer }) {
  const nome = `${a.fname || "anexo"}${a.fext ? "." + a.fext : ""}`;
  const tipo = slAnexoTipo(a);
  const isLink = tipo === "link";
  const embebivel = tipo === "pdf" || tipo === "img";
  const href = isLink ? a.url : SlApi.downloadUrl(bistamp, a.anexosstamp);
  const estilo = { display: "flex", alignItems: "baseline", gap: 6, padding: "3px 0", fontSize: 12.5, textDecoration: "none" };
  const conteudo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { style: { flex: "0 0 auto", color: "var(--muted)" } }, isLink ? "\u2197" : embebivel ? "\u{1F441}" : "\u2B07"), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--accent)", flex: "0 0 auto", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, nome), a.descricao ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11, flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, a.descricao) : null);
  if (embebivel) {
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        href,
        title: a.descricao || nome,
        style: estilo,
        onClick: (ev) => {
          ev.preventDefault();
          onVer(a.anexosstamp);
        }
      },
      conteudo
    );
  }
  return /* @__PURE__ */ React.createElement("a", { href, target: "_blank", rel: "noopener noreferrer", title: a.descricao || nome, style: estilo }, conteudo);
}
function SlAnexosTab({ bistamp, anexos, onVer }) {
  if (anexos === null) {
    return /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12.5, padding: "8px 0" } }, "A carregar anexos\u2026");
  }
  const grupo = (titulo, lista) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginBottom: 4 } }, titulo), (lista || []).length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12 } }, "Sem anexos.") : lista.map((a) => /* @__PURE__ */ React.createElement(SlAnexoLinha, { key: a.anexosstamp, bistamp, a, onVer })));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, anexos.erro && /* @__PURE__ */ React.createElement("div", { style: { color: FORN_AMBER, fontSize: 12, marginBottom: 8 } }, "N\xE3o foi poss\xEDvel ler os anexos do PHC."), grupo("Encomenda", anexos.encomenda), grupo("Artigo", anexos.artigo));
}
function SlEtapaLinha({ it }) {
  const cor = it.excesso > 0 ? SL_COR_MARCO.a_tempo : SL_COR_MARCO[it.cor] || SL_COR_MARCO.sem_dados;
  const real = it.dias == null ? 0 : Math.min(it.dias, it.planeadoDias == null ? it.dias : Math.max(it.planeadoDias, 0));
  const exc = it.dias != null && it.excesso > 0 ? Math.min(it.excesso, it.dias) : 0;
  const pct = (n) => `${Math.max(0, n / Math.max(1, it.dias || 0, it.planeadoDias || 0) * it.frac * 100)}%`;
  const texto = it.inconsistente ? "datas inconsistentes" : it.aberta ? `h\xE1 ${it.dias} d` : it.dias != null ? `${it.dias} d` : "";
  return /* @__PURE__ */ React.createElement("div", { "data-etapa": it.key, style: { padding: "2px 0 2px 4px", fontSize: 12, opacity: it.inconsistente ? 0.6 : 1 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6, alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, it.label), /* @__PURE__ */ React.createElement("span", { style: { color: it.aberta ? SL_COR_MARCO.em_curso : "var(--text)" } }, texto), it.planeadoDias != null && !it.inconsistente && /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\xB7 planeado ", it.planeadoDias, " d"), it.excesso > 0 && !it.inconsistente && /* @__PURE__ */ React.createElement("span", { style: { color: SL_COR_MARCO.acima, fontWeight: 700 } }, "\xB7 +", it.excesso, " d"), it.espera && /* @__PURE__ */ React.createElement("span", { style: { color: "#6b7280" } }, "\xB7 parado ", it.espera.dias, " d")), !it.inconsistente && it.dias != null && /* @__PURE__ */ React.createElement("div", { style: { position: "relative", height: 6, marginTop: 3, background: "var(--border)", borderRadius: 3, overflow: "hidden" } }, it.planeadoDias != null && /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 0, bottom: 0, left: 0, width: pct(it.planeadoDias), background: VISION_ACCENT + "33" } }), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 1,
    bottom: 1,
    left: 0,
    width: pct(real),
    borderRadius: 3,
    background: it.aberta ? `repeating-linear-gradient(45deg, ${cor}, ${cor} 4px, ${cor}88 4px, ${cor}88 8px)` : cor
  } }), exc > 0 && /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 1, bottom: 1, left: pct(real), width: pct(exc), background: SL_COR_MARCO.acima } })));
}
function SlTimelineMarcos({ row, hoje }) {
  const itens = slTimeline(row, hoje);
  const cores = [...new Set(itens.map((m) => m.cor))].filter((c) => c !== "sem_dados");
  return /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 18 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Timeline"), /* @__PURE__ */ React.createElement("div", { style: { borderLeft: "2px solid var(--border)", marginLeft: 5, paddingLeft: 14 } }, itens.map((m) => m.tipo === "etapa" ? /* @__PURE__ */ React.createElement(SlEtapaLinha, { key: "e" + m.key, it: m }) : /* @__PURE__ */ React.createElement(
    "div",
    {
      key: m.key,
      "data-marco": m.key,
      title: SL_LEGENDA_MARCO[m.cor],
      style: { display: "flex", alignItems: "center", gap: 10, padding: "4px 0", position: "relative" }
    },
    /* @__PURE__ */ React.createElement("span", { style: {
      position: "absolute",
      left: -20,
      width: 11,
      height: 11,
      borderRadius: "50%",
      background: m.cor === "em_curso" ? "var(--panel, #fff)" : SL_COR_MARCO[m.cor],
      border: m.cor === "em_curso" ? `2px solid ${SL_COR_MARCO.em_curso}` : "2px solid var(--panel, #fff)"
    } }),
    /* @__PURE__ */ React.createElement("span", { style: { flex: 1, fontSize: 13 } }, m.label, m.cor === "inconsistente" && /* @__PURE__ */ React.createElement("span", { style: { color: FORN_AMBER } }, " \u26A0")),
    /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12.5, width: 110, textAlign: "right", color: m.data ? "var(--text)" : "var(--muted)" } }, slData(m.data))
  ))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 6, display: "flex", flexWrap: "wrap", gap: 12 } }, cores.map((c) => /* @__PURE__ */ React.createElement("span", { key: c, style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: SL_COR_MARCO[c] } }), SL_LEGENDA_MARCO[c])), /* @__PURE__ */ React.createElement("span", null, "Claro: planeado \xB7 cheio: real \xB7 vermelho: excesso \xB7 tracejado: em curso")));
}
function SlKv({ pairs }) {
  return /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, pairs.filter(Boolean).map(([k, v]) => /* @__PURE__ */ React.createElement(React.Fragment, { key: k }, /* @__PURE__ */ React.createElement("div", { className: "k" }, k), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, v))));
}
const SL_CAIXA = { margin: "0 0 10px", padding: "10px 12px", borderRadius: 10, border: "1px solid var(--border)", fontSize: 12 };
const SL_ROTULO = { fontSize: 10, textTransform: "uppercase", letterSpacing: 0.4, color: "var(--muted)" };
const SL_CHIP = { display: "inline-block", padding: "2px 9px", borderRadius: 999, fontSize: 11, fontWeight: 600, marginRight: 6 };
function SlChip({ cor, children, testid }) {
  return /* @__PURE__ */ React.createElement("span", { "data-testid": testid, style: { ...SL_CHIP, color: cor, border: "1px solid " + cor + "66", background: cor + "14" } }, children);
}
function SlStock({ stock, gerido }) {
  const num = (n) => new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 2 }).format(n);
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "drawer-stock" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Stock por armaz\xE9m"), /* @__PURE__ */ React.createElement("div", { style: SL_CAIXA }, stock == null && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), stock && stock.erro && /* @__PURE__ */ React.createElement("div", { style: { color: FORN_AMBER } }, stock.erro), stock && !stock.erro && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { marginBottom: stock.armazens.length ? 8 : 0 } }, /* @__PURE__ */ React.createElement(SlChip, { testid: "chip-stock-total", cor: stock.total ? FORN_GREEN : FORN_AMBER }, "Stock total ", num(stock.total)), /* @__PURE__ */ React.createElement(SlChip, { testid: "chip-gerido", cor: gerido ? FORN_GREEN : "#64748b" }, gerido ? "Gerido por stock" : "N\xE3o gerido por stock")), stock.armazens.length > 0 && /* @__PURE__ */ React.createElement(SlKv, { pairs: stock.armazens.map((a) => [`Armaz\xE9m ${a.armazem}`, num(a.stock)]) }))));
}
function SlDrawer({ row, hoje, onClose, anexoStamp, onAnexo, navList, currentId, onNavigate }) {
  const bistamp = String(row.bistamp || "").trim();
  const e = row.entrega;
  const c = row.causa;
  const s = row.estado;
  const me = window.SR_ME || null;
  const users = window.SR_USERS || [];
  const resParams = { app_label: SL_APP, resource: SL_RES, resource_id: bistamp };
  const [notas, setNotas] = React.useState([]);
  const [followers, setFollowers] = React.useState([]);
  const [logs, setLogs] = React.useState([]);
  const [acoes, setAcoes] = React.useState([]);
  const [anexos, setAnexos] = React.useState(null);
  const [stock, setStock] = React.useState(null);
  const refreshNotas = React.useCallback(() => {
    window.API.notes(resParams).then((r) => setNotas(r.results || r || [])).catch(() => setNotas([]));
  }, [bistamp]);
  const refreshFollowers = React.useCallback(() => {
    window.API.followers(resParams).then((r) => setFollowers(r.results || r || [])).catch(() => setFollowers([]));
  }, [bistamp]);
  const refreshLogs = React.useCallback(() => {
    SlApi.audit(bistamp).then((rows) => setLogs((rows || []).map((a) => ({
      id: a.id,
      evento: a.verb,
      descricao: a.summary,
      actor_username: a.actor_name,
      criado_em: a.when
    })))).catch(() => setLogs([]));
  }, [bistamp]);
  const refreshAcoes = React.useCallback(() => {
    SlApi.acoes(bistamp).then((r) => setAcoes((r.results || r || []).map((a) => ({
      id: a.id,
      source: "acao",
      tipo: a.tipo?.id_slug,
      tipoNome: a.tipo?.nome || a.tipo?.id_slug,
      autor: a.autor_username,
      atribuido: a.atribuido_username || null,
      criadoEm: a.criado_em ? new Date(a.criado_em) : null,
      descricao: a.descricao,
      tratada: !!a.tratada_em,
      tratadaEm: a.tratada_em ? new Date(a.tratada_em) : null,
      tratadaPor: a.tratada_por_username || null,
      prazo: a.data_limite || null
    })))).catch(() => setAcoes([]));
  }, [bistamp]);
  React.useEffect(() => {
    if (!bistamp) return;
    setAnexos(null);
    setStock(null);
    let vivo = true;
    SlApi.stock(bistamp).then((r) => vivo && setStock(r)).catch((e2) => vivo && setStock({ erro: e2 && e2.erro || "N\xE3o foi poss\xEDvel ler o stock." }));
    SlApi.anexos(bistamp).then((r) => setAnexos({ encomenda: r.encomenda || [], artigo: r.artigo || [], erro: !!r.erro })).catch(() => setAnexos({ encomenda: [], artigo: [], erro: true }));
    refreshNotas();
    refreshFollowers();
    refreshLogs();
    refreshAcoes();
    return () => {
      vivo = false;
    };
  }, [bistamp]);
  const notasApi = {
    onAdd: (descricao) => window.API.createNote({ ...resParams, descricao }).then(() => {
      refreshNotas();
      refreshLogs();
    }),
    onUpdate: (id, descricao) => window.API.updateNote(id, { descricao }).then(refreshNotas),
    onDelete: (id) => window.API.deleteNote(id).then(refreshNotas)
  };
  const depois = () => {
    refreshAcoes();
    refreshLogs();
  };
  const acoesApi = {
    onAdd: (tipo, descricao, atribuidoId, prazo) => SlApi.addAcao(bistamp, tipo, descricao, atribuidoId, prazo).then(depois),
    onDelete: (a) => SlApi.delAcao(bistamp, a.id).then(depois),
    onToggleTratada: (a) => SlApi.tratar(bistamp, a.id).then(depois),
    onSetPrazo: (a, iso) => SlApi.prazo(bistamp, a.id, iso).then(depois)
  };
  const seguidores = {
    items: followers,
    me,
    canManage: !!(me && me.is_staff),
    users,
    onFollow: () => window.API.follow(resParams).then(refreshFollowers),
    onUnfollow: (id) => window.API.unfollow(id).then(refreshFollowers),
    onAddOther: (uid) => window.API.follow({ ...resParams, user_id: uid }).then(refreshFollowers)
  };
  const side = /* @__PURE__ */ React.createElement(
    window.HubActionTimeline,
    {
      streams: { acoes: { items: acoes, api: acoesApi }, notas: { items: notas, api: notasApi }, logs: { items: logs } },
      seguidores,
      users,
      me,
      assignable: !!(me && me.is_staff),
      appLabel: SL_APP,
      appSlug: "bi",
      resource: SL_RES,
      resourceId: bistamp,
      defaultTab: "acoes",
      title: "Atividade",
      extraTabs: [{
        key: "anexos_phc",
        label: "Anexos PHC",
        count: anexos ? anexos.encomenda.length + anexos.artigo.length : null,
        render: () => /* @__PURE__ */ React.createElement(SlAnexosTab, { bistamp, anexos, onVer: onAnexo })
      }]
    }
  );
  const datasol = row.fluxo === "mercadoria" ? row.datasolme : row.datasolmp;
  const dataRec = row.fluxo === "mercadoria" ? row.datarecme : row.datarecmp;
  const dataConf = row.fluxo === "mercadoria" ? row.dataconfme : row.dataconfmp;
  const diasSobre = datasol && dataRec ? Math.round((Date.parse(dataRec) - Date.parse(datasol)) / 864e5) : null;
  const detalhe = [
    ["Cliente", row.cliente_estado ? /* @__PURE__ */ React.createElement("span", { key: "cl", style: { display: "inline-flex", gap: 6, alignItems: "center", flexWrap: "wrap" } }, row.cliente || "\u2014", " ", /* @__PURE__ */ React.createElement(SlChipCliente, { row }), " ", /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, row.cliente_estado)) : row.cliente || "\u2014"],
    ["Designa\xE7\xE3o", row.design || "\u2014"],
    ["Segmento", slSegmento(row)],
    row.vendedor ? ["Vendedor", row.vendedor] : null,
    row.primeira_enc ? ["Primeira encomenda", /* @__PURE__ */ React.createElement("strong", { key: "pe", style: { color: FORN_GREEN } }, "Primeira encomenda desta refer\xEAncia")] : null,
    ["Qtd. enc. / ent.", `${INT.format(Math.round(row.qtdenc))} / ${INT.format(Math.round(row.qtdent))}`],
    ["Observa\xE7\xF5es da linha", stock == null ? "A carregar\u2026" : stock.obs || "\u2014"],
    row.enc_fechada != null ? ["Encomenda fechada", row.enc_fechada ? "Sim" : "N\xE3o"] : null,
    row.tipo_enc ? ["Tipo de encomenda", row.tipo_enc] : null,
    row.origem_stock ? [
      row.origem_stock.origem === "sem_stock" ? "Sem stock" : "Entrega de stock",
      row.origem_stock.stock == null ? "encomenda que n\xE3o reaprovisiona." : `stock da refer\xEAncia a ${row.origem_stock.data} = ${INT.format(Math.round(row.origem_stock.stock))}` + (row.origem_stock.origem === "sem_stock" ? " (abaixo da quantidade)." : ".")
    ] : null,
    row.of ? ["OF", row.of.nof] : null,
    row.fornmp || row.fornme ? ["Fornecedor", (row.fluxo === "producao" ? row.fornmp : row.fornme) || "\u2014"] : null,
    datasol ? ["Datas do fornecedor", [
      `solicitada ${slData(datasol)}`,
      dataConf ? `confirmada ${slData(dataConf)}` : null,
      dataRec ? `rece\xE7\xE3o ${slData(dataRec)}` : null
    ].filter(Boolean).join(" \xB7 ") + (row.lead_time_forn && row.lead_time_forn.atraso != null ? ` \u2014 atraso do fornecedor ${row.lead_time_forn.atraso} d (face \xE0 ${dataConf ? "confirmada" : "solicitada"})` : "") + (dataConf && diasSobre > 0 ? ` \xB7 +${diasSobre} d face \xE0 solicitada` : "")] : null,
    row.lead_time_forn ? [
      "Lead time do fornecedor",
      `te\xF3rico ${row.lead_time_forn.teorico ?? "\u2014"} d \xB7 real ${row.lead_time_forn.real ?? "\u2014"} d` + (row.lead_time_forn.lt_acima != null ? ` \xB7 real acima do te\xF3rico ${row.lead_time_forn.lt_acima} d` : "") + ` \xB7 pedido em ${row.lead_time_forn.pedido ?? "\u2014"} d`
    ] : null
  ];
  const aberto = slAnexoAberto(anexos, anexoStamp);
  return /* @__PURE__ */ React.createElement(
    window.DrawerShell,
    {
      title: `Enc. ${row.nenc} \xB7 ${row.ref || "\u2014"}`,
      subtitle: `${SL_FLUXOS[row.fluxo]} \xB7 ${row.aquisicao}${row.of ? ` \xB7 OF ${row.of.nof}` : ""}`,
      onClose,
      navList,
      currentId,
      onNavigate,
      largura: aberto ? "min(1400px, 92vw)" : void 0,
      side
    },
    /* @__PURE__ */ React.createElement("div", { style: aberto ? { display: "flex", alignItems: "flex-start", minWidth: 0 } : void 0 }, /* @__PURE__ */ React.createElement("div", { style: aberto ? { flex: "1 1 0", minWidth: 0, paddingRight: 16 } : void 0 }, /* @__PURE__ */ React.createElement(SlTimelineMarcos, { row, hoje }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, "Solicitada:"), " ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, slData(e.solicitada)), " ", e.atraso_sol != null && /* @__PURE__ */ React.createElement("span", null, "(", slDias(e.atraso_sol), ")")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, "Prometida:"), " ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, slData(e.prometida)), " ", e.atraso_prom != null && /* @__PURE__ */ React.createElement("span", null, "(", slDias(e.atraso_prom), ")")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, "Entrega:"), " ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, slData(e.real)), row.entrega_phc_hoje && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement(SlChip, { testid: "chip-entregue-hoje", cor: FORN_GREEN }, "Entregue hoje (PHC)"))), row.inconsistente && /* @__PURE__ */ React.createElement("div", { style: { color: FORN_AMBER, marginTop: 6 } }, "H\xE1 etapas com datas inconsistentes no PHC \u2014 n\xE3o entram nos excessos.")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, alignItems: "start" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Detalhe"), /* @__PURE__ */ React.createElement(SlKv, { pairs: detalhe })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Diagn\xF3stico"), row.a_menos && /* @__PURE__ */ React.createElement("div", { style: { ...SL_CAIXA, border: "1px solid #b4530966", background: "#b4530912" } }, /* @__PURE__ */ React.createElement(SlAMenosSelo, { a: row.a_menos }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, marginTop: 6, color: "var(--muted)" } }, "Linha fechada com ", INT.format(Math.round(row.qtdent)), " entregues de ", INT.format(Math.round(row.qtdenc)), " encomendadas (valor sem IVA).")), c && c.principal && /* @__PURE__ */ React.createElement("div", { style: { ...SL_CAIXA, border: "1px solid " + SL_CAUSA[c.principal].cor + "66", background: SL_CAUSA[c.principal].cor + "12" } }, /* @__PURE__ */ React.createElement("div", { style: SL_ROTULO }, "Causa principal"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", marginTop: 4, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(SlCausaPastilha, { causa: c.principal }), /* @__PURE__ */ React.createElement("span", null, SL_CAUSA[c.principal].responsavel, " \xB7 ", c.excessos[c.principal], " d")), Object.entries(c.excessos).filter(([k, v]) => k !== c.principal && v > 0 && SL_CAUSA[k]).length > 0 && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, marginTop: 6, color: "var(--muted)" } }, "Tamb\xE9m: ", Object.entries(c.excessos).filter(([k, v]) => k !== c.principal && v > 0 && SL_CAUSA[k]).sort((a, b) => b[1] - a[1]).map(([k, v]) => `${SL_CAUSA[k].label} (${v} d)`).join(" \xB7 ")), c.lead_time && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, marginTop: 6, color: "var(--muted)" } }, "Lead time acordado do fornecedor: ", c.lead_time.leadtime, " d", c.lead_time.acima ? " \u2014 a requisi\xE7\xE3o pedia acima dele." : ".")), c && !c.principal && /* @__PURE__ */ React.createElement("div", { style: { ...SL_CAIXA, color: FORN_GREEN } }, "Entregue a tempo.", c.adiada_por && /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, c.adiada_por === "cliente" ? " Adiada a pedido do cliente." : ` Adiada \u2014 ${row.adiamento && row.adiamento.motivo || (SL_CAUSA[c.adiada_por] || {}).label || c.adiada_por}.`)), row.adiamento && /* @__PURE__ */ React.createElement("div", { style: SL_CAIXA, "data-testid": "drawer-adiamento" }, /* @__PURE__ */ React.createElement("div", { style: SL_ROTULO }, "Adiamento"), /* @__PURE__ */ React.createElement(SlKv, { pairs: [
      ["Nova data", slData(row.adiamento.nova_data)],
      ["Motivo", row.adiamento.motivo || "\u2014"],
      ["Comunica\xE7\xE3o", row.adiamento.comunicacao || "\u2014"],
      ["N\xBA de adiamentos", String(row.adiamento.contagem)]
    ] }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, marginTop: 6, color: "var(--muted)" } }, row.adiamento.efetivo ? "A nova data \xE9 a data de refer\xEAncia desta linha." : row.adiamento.mapeado ? "A data de refer\xEAncia continua a solicitada." : "Motivo sem causa atribu\xEDda (Defini\xE7\xF5es VISION \u2192 Servi\xE7o): s\xF3 se mostra.")), s && /* @__PURE__ */ React.createElement("div", { style: SL_CAIXA }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" } }, /* @__PURE__ */ React.createElement(SlEstadoPastilha, { chave: slEstadoHoje(row) }), s.fechada_phc ? /* @__PURE__ */ React.createElement("span", null, "sem nada entregue \u2014 fora dos atrasos em aberto") : /* @__PURE__ */ React.createElement("span", null, "\xE0 espera de ", /* @__PURE__ */ React.createElement("strong", null, s.a_espera_de))), slEstadoHoje(row) === "fora_sol" && e.solicitada && e.prometida && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", marginTop: 4 } }, Math.round((new Date(hoje) - new Date(e.solicitada)) / 864e5), " d ap\xF3s a solicitada (", slData(e.solicitada), ") \xB7", " ", "faltam ", Math.round((new Date(e.prometida) - new Date(hoje)) / 864e5), " d para a prometida (", slData(e.prometida), ")"), !s.fechada_phc && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", marginTop: 4 } }, "Etapa \xAB", (SL_ETAPAS[row.fluxo].find((x) => x.key === s.etapa_atual) || {}).label, "\xBB h\xE1 ", s.dias_na_etapa ?? "\u2014", " d", s.excesso_etapa > 0 && ` (${s.excesso_etapa} d acima do planeado)`, " \xB7 projetada ", slData(s.projetada))), (row.lead_time_forn?.abaixo || row.abaixo_lt) && /* @__PURE__ */ React.createElement("div", { style: SL_CAIXA }, /* @__PURE__ */ React.createElement("div", { style: SL_ROTULO }, "Fornecedor abaixo do lead time"), row.lead_time_forn?.abaixo && /* @__PURE__ */ React.createElement("div", { style: { color: FORN_AMBER, marginTop: 4 } }, "Pedido abaixo do lead time."), row.abaixo_lt && /* @__PURE__ */ React.createElement("div", { style: { color: FORN_AMBER, marginTop: 4 } }, "Prometida abaixo do lead time (\u2212", row.abaixo_lt.dias, " d): prometida ", slData(row.abaixo_lt.prometida), ", data m\xEDnima ", slData(row.abaixo_lt.minima), ".")), /* @__PURE__ */ React.createElement(SlStock, { stock, gerido: !!row.artstock })))), aberto && /* @__PURE__ */ React.createElement("div", { style: { flex: "1.4 1 0", minWidth: 0, position: "sticky", top: 0, height: "calc(100vh - 110px)" } }, /* @__PURE__ */ React.createElement(SlVisualizador, { bistamp, a: aberto, onFechar: () => onAnexo(null) })))
  );
}

// ===== bi/servico_linhas/frontend/filtros.jsx =====
const SL_FLUXO_OPCOES = [
  { key: "todos", label: "Todos" },
  { key: "mercadoria", label: "Mercadoria" },
  { key: "producao", label: "Produ\xE7\xE3o" }
];
const SL_PERIODOS = [
  { key: "7", label: "7 dias" },
  { key: "30", label: "30 dias" },
  { key: "90", label: "90 dias" },
  { key: "custom", label: "De\u2013at\xE9" }
];
const SL_GRANS = [
  { key: "dia", label: "Dia" },
  { key: "semana", label: "Semana" },
  { key: "mes", label: "M\xEAs" }
];
const SL_AQUIS = ["Compra", "Subcontrato", "Produ\xE7\xE3o"];
function SlSeg({ opcoes, valor, onChange, label }) {
  return /* @__PURE__ */ React.createElement("div", { role: "group", "aria-label": label, style: {
    display: "inline-flex",
    border: "1px solid var(--border)",
    borderRadius: 8,
    overflow: "hidden"
  } }, opcoes.map((o) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: o.key,
      type: "button",
      onClick: () => onChange(o.key),
      "aria-pressed": valor === o.key,
      style: {
        padding: "5px 12px",
        fontSize: 12,
        cursor: "pointer",
        border: 0,
        borderRight: "1px solid var(--border)",
        fontWeight: valor === o.key ? 700 : 500,
        background: valor === o.key ? VISION_ACCENT : "var(--panel)",
        color: valor === o.key ? "#fff" : "var(--text)"
      }
    },
    o.label
  )));
}
const slRotuloLinha = { fontSize: 11, color: "var(--muted)", display: "inline-flex", gap: 6, alignItems: "center" };
function SlGrupo({ titulo, children }) {
  return /* @__PURE__ */ React.createElement("fieldset", { style: { border: 0, padding: 0, margin: "0 0 10px", display: "flex", flexDirection: "column", gap: 6 } }, /* @__PURE__ */ React.createElement("legend", { style: { fontSize: 11, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", padding: 0, marginBottom: 4 } }, titulo), children);
}
function SlCheck({ checked, onChange, children }) {
  return /* @__PURE__ */ React.createElement("label", { style: { fontSize: 12, display: "inline-flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked, onChange: (e) => onChange(e.target.checked) }), " ", children);
}
function SlPainelFiltros({ v, setP, vendedores, segmentos, motivos, n }) {
  const [aberto, setAberto] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!aberto) return void 0;
    const fora = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAberto(false);
    };
    const tecla = (e) => {
      if (e.key === "Escape") setAberto(false);
    };
    document.addEventListener("mousedown", fora);
    document.addEventListener("keydown", tecla);
    return () => {
      document.removeEventListener("mousedown", fora);
      document.removeEventListener("keydown", tecla);
    };
  }, [aberto]);
  const flag = (nome) => (on) => setP({ [nome]: on ? "1" : null });
  return /* @__PURE__ */ React.createElement("div", { ref, style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn sm",
      "aria-haspopup": "dialog",
      "aria-expanded": aberto,
      onClick: () => setAberto(!aberto),
      style: n > 0 ? { borderColor: VISION_ACCENT, fontWeight: 700 } : void 0
    },
    "Filtros (",
    n,
    ") \u25BE"
  ), aberto && /* @__PURE__ */ React.createElement(
    "div",
    {
      role: "dialog",
      "aria-label": "Filtros da lista",
      style: {
        position: "absolute",
        zIndex: 30,
        top: "100%",
        left: 0,
        marginTop: 4,
        padding: 12,
        width: 340,
        maxHeight: "70vh",
        overflow: "auto",
        background: "var(--panel)",
        border: "1px solid var(--border)",
        borderRadius: 8,
        boxShadow: "0 6px 24px rgba(0,0,0,.18)"
      }
    },
    /* @__PURE__ */ React.createElement(SlGrupo, { titulo: "Estado" }, /* @__PURE__ */ React.createElement("select", { value: v.bloq, onChange: (e) => setP({ bloq: e.target.value || null }), "aria-label": "Cliente bloqueado" }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Cliente bloqueado: todos"), /* @__PURE__ */ React.createElement("option", { value: "sim" }, "Cliente bloqueado"), /* @__PURE__ */ React.createElement("option", { value: "nao" }, "Cliente n\xE3o bloqueado")), /* @__PURE__ */ React.createElement(SlCheck, { checked: v.amenos, onChange: flag("amenos") }, "Entregue a menos")),
    /* @__PURE__ */ React.createElement(SlGrupo, { titulo: "Adiamentos" }, /* @__PURE__ */ React.createElement(SlCheck, { checked: v.adiada, onChange: flag("adiada") }, "Com adiamento"), /* @__PURE__ */ React.createElement("select", { value: v.motivo, onChange: (e) => setP({ motivo: e.target.value || null }), "aria-label": "Motivo do adiamento" }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todos os motivos"), motivos.map((m) => /* @__PURE__ */ React.createElement("option", { key: m, value: m }, m)))),
    /* @__PURE__ */ React.createElement(SlGrupo, { titulo: "Encomenda" }, /* @__PURE__ */ React.createElement(SlCheck, { checked: v.sos, onChange: flag("sos") }, "SOS"), /* @__PURE__ */ React.createElement(SlCheck, { checked: v.primeiras, onChange: flag("primeiras") }, "S\xF3 primeiras encomendas"), /* @__PURE__ */ React.createElement("select", { value: v.aquis, onChange: (e) => setP({ aquis: e.target.value || null }), "aria-label": "Tipo de aquisi\xE7\xE3o" }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todas as aquisi\xE7\xF5es"), SL_AQUIS.map((a) => /* @__PURE__ */ React.createElement("option", { key: a, value: a }, a)))),
    /* @__PURE__ */ React.createElement(SlGrupo, { titulo: "Pessoas" }, /* @__PURE__ */ React.createElement("select", { value: v.vendedor, onChange: (e) => setP({ vendedor: e.target.value || null }), "aria-label": "Vendedor" }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todos os vendedores"), vendedores.map((x) => /* @__PURE__ */ React.createElement("option", { key: x, value: x }, x))), /* @__PURE__ */ React.createElement("div", { role: "group", "aria-label": "Segmentos", style: { maxHeight: 130, overflow: "auto", display: "flex", flexDirection: "column", gap: 2 } }, /* @__PURE__ */ React.createElement("span", { style: slRotuloLinha }, "Segmento"), segmentos.map((s) => /* @__PURE__ */ React.createElement(SlCheck, { key: s, checked: v.seg.includes(s), onChange: () => setP({ seg: slSegAlternar(v.seg, s).join("|") || null }) }, s)))),
    /* @__PURE__ */ React.createElement(SlGrupo, { titulo: "Datas" }, /* @__PURE__ */ React.createElement(
      "select",
      {
        value: v.dtipo,
        "aria-label": "Filtrar a lista por data",
        onChange: (e) => setP({ dtipo: e.target.value || null, dde: e.target.value ? v.dde || null : null, date: e.target.value ? v.date || null : null })
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "Sem filtro de data"),
      SL_DATAS.map((d) => /* @__PURE__ */ React.createElement("option", { key: d.key, value: d.key }, d.label))
    ), v.dtipo && /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", gap: 6, alignItems: "center", fontSize: 12 } }, /* @__PURE__ */ React.createElement("input", { type: "date", "aria-label": "Data de", value: v.dde, max: v.date || void 0, onChange: (e) => setP({ dde: e.target.value || null }) }), "\u2013", /* @__PURE__ */ React.createElement("input", { type: "date", "aria-label": "Data at\xE9", value: v.date, min: v.dde || void 0, onChange: (e) => setP({ date: e.target.value || null }) })))
  ));
}
function SlFiltros({ v, setP, janela, vendedores, segmentos, motivos, hoje, nInconsistentes }) {
  const chips = slChips(v);
  const n = slChipsPainel(v);
  const ligado = slPorEntregarLigado(v.encf, v.entr);
  return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, padding: "10px 12px", display: "flex", flexDirection: "column", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: slRotuloLinha }, "Fluxo", /* @__PURE__ */ React.createElement(SlSeg, { label: "Fluxo", opcoes: SL_FLUXO_OPCOES, valor: v.fluxo, onChange: (x) => setP({ fluxo: x === "todos" ? null : x }) })), /* @__PURE__ */ React.createElement("span", { style: slRotuloLinha }, "Per\xEDodo", /* @__PURE__ */ React.createElement(SlSeg, { label: "Per\xEDodo", opcoes: SL_PERIODOS, valor: v.periodo, onChange: (x) => setP({ periodo: x === "30" ? null : x }) })), v.periodo === "custom" && /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", gap: 6, alignItems: "center", fontSize: 12 } }, /* @__PURE__ */ React.createElement("input", { type: "date", "aria-label": "De", value: janela[0], max: janela[1], onChange: (e) => setP({ de: e.target.value || null }) }), "\u2013", /* @__PURE__ */ React.createElement("input", { type: "date", "aria-label": "At\xE9", value: janela[1], min: janela[0], onChange: (e) => setP({ ate: e.target.value || null }) })), /* @__PURE__ */ React.createElement("span", { style: slRotuloLinha }, "Granularidade", /* @__PURE__ */ React.createElement(SlSeg, { label: "Granularidade", opcoes: SL_GRANS, valor: v.gran, onChange: (x) => setP({ gran: x === "dia" ? null : x }) })), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", fontSize: 11, color: "var(--muted)" } }, "Os KPIs e os blocos s\xF3 seguem esta linha \xB7 Dados at\xE9 ", slData(hoje), nInconsistentes > 0 && ` \xB7 ${INT.format(nInconsistentes)} linha(s) com datas inconsistentes`)), /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--border)", paddingTop: 10, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn sm",
      "aria-pressed": ligado,
      title: "Encomenda aberta e sem data de entrega",
      onClick: () => setP(slPorEntregarPatch(v.encf, v.entr)),
      style: ligado ? { background: VISION_ACCENT, color: "#fff", borderColor: VISION_ACCENT, fontWeight: 700 } : void 0
    },
    "Por entregar"
  ), /* @__PURE__ */ React.createElement("span", { style: slRotuloLinha }, "Encomenda", /* @__PURE__ */ React.createElement(
    SlSeg,
    {
      label: "Encomenda",
      opcoes: [{ key: "todas", label: "Todas" }, { key: "aberta", label: "Aberta" }, { key: "fechada", label: "Fechada" }],
      valor: v.encf || "todas",
      onChange: (x) => setP({ encf: x === "todas" ? null : x })
    }
  )), /* @__PURE__ */ React.createElement("span", { style: slRotuloLinha }, "Entrega", /* @__PURE__ */ React.createElement(
    SlSeg,
    {
      label: "Entrega",
      opcoes: [{ key: "todas", label: "Todas" }, { key: "sem", label: "Sem data" }, { key: "com", label: "Com data" }],
      valor: v.entr || "todas",
      onChange: (x) => setP({ entr: x === "todas" ? null : x })
    }
  )), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "search",
      placeholder: "Cliente, encomenda, refer\xEAncia ou designa\xE7\xE3o\u2026",
      "aria-label": "Pesquisar",
      value: v.q,
      onChange: (e) => setP({ q: e.target.value || null }),
      style: { flex: "1 1 260px", minWidth: 220, maxWidth: 420 }
    }
  ), /* @__PURE__ */ React.createElement(SlPainelFiltros, { v, setP, vendedores, segmentos, motivos, n })), chips.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }, "aria-label": "Filtros ativos" }, chips.map((c) => /* @__PURE__ */ React.createElement("span", { key: c.id, "data-testid": `chip-${c.id}`, style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: 12,
    padding: "2px 4px 2px 10px",
    border: "1px solid var(--border)",
    borderRadius: 999,
    background: "var(--panel)"
  } }, c.rotulo, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "aria-label": `Tirar ${c.rotulo}`,
      onClick: () => setP(c.limpar),
      style: { border: 0, background: "transparent", cursor: "pointer", color: "var(--muted)", padding: "0 6px" }
    },
    "\u2715"
  ))), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", onClick: () => setP(slLimparTudo(v)) }, "Limpar tudo")));
}
Object.assign(window, { SlFiltros });

// ===== bi/servico_linhas/frontend/view.jsx =====
function ServicoLinhasView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [urlParams, setUrlParams] = useState(() => window.HubRouter.current().params);
  useEffect(() => window.HubRouter.subscribe(
    () => setUrlParams(window.HubRouter.current().params)
  ), []);
  const escolha = (nome, validos, omissao) => {
    const v = urlParams.get(nome);
    return validos.includes(v) ? v : omissao;
  };
  const fluxo = escolha("fluxo", ["todos", "mercadoria", "producao"], "todos");
  const periodo = escolha("periodo", ["7", "30", "90", "custom"], "30");
  const gran = escolha("gran", ["dia", "semana", "mes"], "dia");
  const de = urlParams.get("de") || "";
  const ate = urlParams.get("ate") || "";
  const aquis = urlParams.get("aquis") || "";
  const q = urlParams.get("q") || "";
  const cliente = urlParams.get("cliente") || "";
  const enc = urlParams.get("enc") || "";
  const design = urlParams.get("design") || "";
  const ref = urlParams.get("ref") || "";
  const vendedor = urlParams.get("vendedor") || "";
  const segSel = useMemo(() => slSegParse(urlParams.get("seg")), [urlParams]);
  const sos = urlParams.get("sos") === "1";
  const soAMenos = urlParams.get("amenos") === "1";
  const soAdiadas = urlParams.get("adiada") === "1";
  const motivo = urlParams.get("motivo") || "";
  const dataTipo = escolha("dtipo", ["real", "sol", "prom"], "");
  const dataDe = urlParams.get("dde") || "";
  const dataAte = urlParams.get("date") || "";
  const entrega = escolha("entr", ["sem", "com"], "");
  const soPrimeiras = urlParams.get("primeiras") === "1";
  const encFechada = urlParams.get("encf") || "";
  const bloqueado = escolha("bloq", ["sim", "nao"], "");
  const bloco = urlParams.get("bloco") || "";
  const chave = urlParams.get("chave") || "";
  const filtro = useMemo(() => bloco && chave ? { bloco, chave } : null, [bloco, chave]);
  const setP = (patch) => window.HubRouter.setParams(patch);
  const setFiltro = (f) => setP({ bloco: f ? f.bloco : null, chave: f ? f.chave : null });
  const linhaUrl = urlParams.get("linha") || "";
  const anexoUrl = urlParams.get("anexo") || "";
  useEffect(() => {
    let alive = true;
    window.API.biServicoLinhas().then((d) => {
      if (alive) setData(d);
    }).catch((e) => {
      if (!alive) return;
      const m = String(e.message || e);
      const j = m.match(/\{.*\}$/s);
      try {
        setError(j ? JSON.parse(j[0]).error : m);
      } catch {
        setError(m);
      }
    });
    return () => {
      alive = false;
    };
  }, []);
  const base = useMemo(() => data ? data.rows.filter((r) => r.fluxo !== "servico") : [], [data]);
  const vendedores = useMemo(() => [...new Set(base.map((r) => r.vendedor).filter(Boolean))].sort(), [base]);
  const segmentos = useMemo(() => slSegmentosDe(base), [base]);
  const motivos = useMemo(() => slMotivosDe(base), [base]);
  const chaveLinha = useMemo(() => {
    const visto = {};
    const m = /* @__PURE__ */ new Map();
    base.forEach((r) => {
      const b = String(r.bistamp || "").trim();
      const k = visto[b] || 0;
      visto[b] = k + 1;
      m.set(r, k ? `${b}#${k}` : b);
    });
    return m;
  }, [base]);
  const aberta = useMemo(
    () => linhaUrl ? base.find((r) => chaveLinha.get(r) === linhaUrl) || null : null,
    [base, linhaUrl, chaveLinha]
  );
  const rows = useMemo(() => {
    const txt = { cliente, enc, design, ref };
    return base.filter((r) => (fluxo === "todos" || r.fluxo === fluxo) && (!aquis || r.aquisicao === aquis) && slSegCasa(r, segSel) && (!vendedor || r.vendedor === vendedor) && (!sos || r.encsos) && (!soAMenos || r.a_menos) && (!soPrimeiras || r.primeira_enc) && slEncFechadaCasa(r, encFechada) && slBloqueadoCasa(r, bloqueado) && (!(soAdiadas || motivo) || r.adiamento && (!motivo || slMotivo(r) === motivo)) && slTextoCasa(r, txt) && slBuscaCasa(r, q));
  }, [base, fluxo, aquis, vendedor, segSel, sos, soAMenos, soPrimeiras, encFechada, bloqueado, soAdiadas, motivo, q, cliente, enc, design, ref]);
  const hoje = data ? data.hoje : "";
  const janela = useMemo(
    () => hoje ? slJanela(periodo, de, ate, hoje) : ["", ""],
    [periodo, de, ate, hoje]
  );
  const lista = useMemo(() => {
    const [i, f] = janela;
    const noPeriodo = (r) => r.entrega.real && r.entrega.real >= i && r.entrega.real <= f;
    const dataOk = (r) => (!dataTipo || slDataCasa(r, dataTipo, dataDe, dataAte)) && slEntregaCasa(r, entrega);
    if (!filtro) {
      return rows.filter((r) => (dataTipo ? r.estado || r.entrega.real : r.estado || noPeriodo(r)) || soAMenos && r.a_menos).filter(dataOk);
    }
    const dePeriodo = ["causas", "operacoes", "adiamentos"].includes(filtro.bloco);
    return rows.filter((r) => slCasa(r, filtro) && (!dePeriodo || noPeriodo(r)) && dataOk(r));
  }, [rows, filtro, janela, soAMenos, dataTipo, dataDe, dataAte, entrega]);
  const columns = [
    { key: "nenc", label: "Enc.", width: 70, minWidth: 55, align: "right", mono: true },
    {
      key: "cliente",
      label: "Cliente",
      width: 190,
      minWidth: 130,
      fixed: true,
      render: (r) => /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("strong", { title: r.cliente }, fornShort(r.cliente) || "\u2014"), /* @__PURE__ */ React.createElement(SlChipCliente, { row: r }))
    },
    { key: "ref", label: "Ref.", width: 170, minWidth: 120, mono: true, render: (r) => r.ref || "\u2014" },
    {
      key: "primeira_enc",
      label: "1.\xAA enc.",
      width: 80,
      minWidth: 65,
      sortValue: (r) => r.primeira_enc ? 1 : 0,
      render: (r) => r.primeira_enc ? /* @__PURE__ */ React.createElement(SlPrimeiraEnc, null) : "\u2014"
    },
    { key: "segmento", label: "Segmento", width: 120, minWidth: 90, sortValue: (r) => slSegmento(r), render: (r) => slSegmento(r) },
    { key: "fluxo", label: "Fluxo", width: 100, minWidth: 80, sortValue: (r) => r.fluxo, render: (r) => SL_FLUXOS[r.fluxo] },
    {
      key: "diag",
      label: "Causa / estado",
      width: 220,
      minWidth: 150,
      sortValue: (r) => r.causa ? r.causa.principal || "" : r.estado ? slEstadoHoje(r) : "",
      render: (r) => r.causa ? r.causa.principal ? /* @__PURE__ */ React.createElement(SlCausaPastilha, { causa: r.causa.principal }) : /* @__PURE__ */ React.createElement("span", { style: { color: FORN_GREEN } }, "A tempo") : /* @__PURE__ */ React.createElement(SlEstadoPastilha, { chave: slEstadoHoje(r) })
    },
    {
      key: "enc_fechada",
      label: "Encomenda fechada",
      width: 120,
      minWidth: 90,
      sortValue: (r) => r.enc_fechada ? 1 : 0,
      render: (r) => r.enc_fechada ? "Sim" : ""
    },
    {
      key: "a_menos",
      label: "Entregue a menos",
      width: 230,
      minWidth: 150,
      sortValue: (r) => r.a_menos ? r.a_menos.valor : 0,
      render: (r) => /* @__PURE__ */ React.createElement(SlAMenosSelo, { a: r.a_menos })
    },
    {
      key: "espera",
      label: "\xC0 espera de",
      width: 190,
      minWidth: 120,
      sortValue: (r) => r.estado ? r.estado.a_espera_de : "",
      render: (r) => r.estado ? r.estado.a_espera_de : "\u2014"
    },
    { key: "sol", label: "Solicitada", width: 100, minWidth: 85, sortValue: (r) => r.entrega.solicitada || "", render: (r) => slData(r.entrega.solicitada) },
    {
      key: "solforn",
      label: "Solicitada forn.",
      width: 110,
      minWidth: 90,
      hidden: true,
      sortValue: (r) => (r.fluxo === "mercadoria" ? r.datasolme : r.datasolmp) || "",
      render: (r) => slData(r.fluxo === "mercadoria" ? r.datasolme : r.datasolmp)
    },
    {
      key: "adiada",
      label: "Adiada",
      width: 100,
      minWidth: 85,
      sortValue: (r) => r.adiamento ? r.adiamento.nova_data : "",
      render: (r) => r.adiamento ? /* @__PURE__ */ React.createElement("span", { title: `${r.adiamento.motivo || "sem motivo"} \xB7 ${r.adiamento.contagem}\xD7` }, slData(r.adiamento.nova_data)) : "\u2014"
    },
    { key: "prom", label: "Prometida", width: 100, minWidth: 85, sortValue: (r) => r.entrega.prometida || "", render: (r) => slData(r.entrega.prometida) },
    { key: "real", label: "Entrega", width: 100, minWidth: 85, sortValue: (r) => r.entrega.real || "", render: (r) => r.entrega_phc_hoje ? /* @__PURE__ */ React.createElement("span", { title: "Entregue hoje, segundo o PHC (o Trino ainda n\xE3o a tem)" }, slData(r.entrega.real), " ", /* @__PURE__ */ React.createElement("span", { "data-testid": "chip-entregue-hoje", style: { fontSize: 10, fontWeight: 600, color: FORN_GREEN, border: "1px solid " + FORN_GREEN + "66", borderRadius: 999, padding: "0 6px" } }, "PHC hoje")) : slData(r.entrega.real) },
    {
      key: "atraso_sol",
      label: "vs solicitada",
      width: 100,
      minWidth: 80,
      align: "right",
      mono: true,
      sortValue: (r) => r.entrega.atraso_sol,
      render: (r) => slDias(r.entrega.atraso_sol)
    },
    {
      key: "atraso_prom",
      label: "vs prometida",
      width: 100,
      minWidth: 80,
      align: "right",
      mono: true,
      sortValue: (r) => r.entrega.atraso_prom,
      render: (r) => slDias(r.entrega.atraso_prom)
    }
  ];
  const [sort, setSort] = useState([]);
  const ordenada = useMemo(
    () => slOrdenar(lista, sort, columns, window.HubTable.applySort),
    [lista, sort]
  );
  const navList = useMemo(() => ordenada.map((r) => ({ id: chaveLinha.get(r) })), [ordenada, chaveLinha]);
  const totalAMenos = useMemo(() => slAMenosTotal(lista), [lista]);
  if (error) return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { margin: 16, padding: 16, color: FORN_RED } }, error);
  if (!data) return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { margin: 16, padding: 16 } }, "A carregar\u2026");
  const blocos = window.ServicoBlocos || {};
  const propsBloco = { rows, metas: data.metas, hoje, fluxo, periodo: janela, gran, filtro, setFiltro };
  const nInconsistentes = rows.filter((r) => r.inconsistente).length;
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 16, display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement(
    SlFiltros,
    {
      setP,
      janela,
      vendedores,
      segmentos,
      motivos,
      hoje,
      nInconsistentes,
      v: {
        fluxo,
        periodo,
        gran,
        encf: encFechada,
        entr: entrega,
        q,
        cliente,
        enc,
        design,
        ref,
        bloq: bloqueado,
        amenos: soAMenos,
        adiada: soAdiadas,
        motivo,
        sos,
        primeiras: soPrimeiras,
        aquis,
        vendedor,
        seg: segSel,
        dtipo: dataTipo,
        dde: dataDe,
        date: dataAte,
        bloco: filtro ? filtro.bloco : "",
        chave: filtro ? filtro.chave : ""
      }
    }
  ), data.of_erro && /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 10, color: FORN_AMBER, fontSize: 12 } }, data.of_erro, " \u2014 as etapas de produ\xE7\xE3o ficam sem o fecho da OF."), data.fechadas_erro && /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 10, color: FORN_AMBER, fontSize: 12 } }, data.fechadas_erro, " \u2014 sem isto nenhuma linha \xE9 assinalada \xABentregue a menos\xBB."), data.clientes_erro && /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 10, color: FORN_AMBER, fontSize: 12 } }, data.clientes_erro, " \u2014 nenhum cliente \xE9 dado por bloqueado."), data.adiamento_erro && /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 10, color: FORN_AMBER, fontSize: 12 } }, data.adiamento_erro, " \u2014 as linhas abertas ficam sem adiamento."), ["Hoje", "Causas", "Operacoes", "Risco"].map((n) => {
    const B = blocos[n];
    return B ? /* @__PURE__ */ React.createElement(B, { key: n, ...propsBloco }) : null;
  }), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Linhas de encomenda"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", INT.format(lista.length), " linha(s)"), /* @__PURE__ */ React.createElement("span", { className: "sub", "data-testid": "kpi-a-menos", title: "Total das linhas filtradas entregues abaixo do pedido (sem IVA)" }, "\xB7 \u26A0 entregue a menos: ", INT.format(totalAMenos.n), " linha(s)", totalAMenos.n > 0 && ` \xB7 ${slAMenosTexto(totalAMenos)}`)), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "bi",
      viewId: "servico-linhas",
      columns,
      data: lista,
      pagination: "client",
      pageSize: 15,
      rowKey: (r) => r.id,
      onViewState: (s) => setSort(s.sort || []),
      onRowClick: (r) => setP({ linha: chaveLinha.get(r), anexo: null }),
      empty: "Sem linhas para os filtros ativos."
    }
  )), aberta && /* @__PURE__ */ React.createElement(
    SlDrawer,
    {
      row: aberta,
      hoje,
      navList,
      currentId: linhaUrl,
      onNavigate: (it) => setP({ linha: it.id, anexo: null }),
      anexoStamp: anexoUrl,
      onAnexo: (st) => window.HubRouter.setParams({ anexo: st }, { replace: !st }),
      onClose: () => setP({ linha: null, anexo: null })
    }
  ));
}
Object.assign(window, { ServicoLinhasView });

// ===== bi/sql/frontend/view.jsx =====
function VisionQuery() {
  const [sources, setSources] = useState(null);
  const [sourceId, setSourceId] = useState("");
  const [sql, setSql] = useState("");
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [history, setHistory] = useState(loadQueryHistory);
  const [showHistory, setShowHistory] = useState(false);
  const pushHistory = (entry) => setHistory((prev) => {
    const next = [entry, ...prev].slice(0, QUERY_HISTORY_MAX);
    try {
      localStorage.setItem(QUERY_HISTORY_KEY, JSON.stringify(next));
    } catch {
    }
    return next;
  });
  const clearHistory = () => {
    try {
      localStorage.removeItem(QUERY_HISTORY_KEY);
    } catch {
    }
    setHistory([]);
  };
  useEffect(() => {
    window.API.biDataSources().then((r) => {
      const active = (r.results || r).filter((d) => d.is_active);
      setSources(active);
      if (active.length && !sourceId) setSourceId(String(active[0].id));
    }).catch((e) => setError(e.message || String(e)));
  }, []);
  const run = () => {
    if (!sourceId || !sql.trim() || running) return;
    const ranSql = sql.trim();
    const ranSource = Number(sourceId);
    setRunning(true);
    setError(null);
    setResult(null);
    window.API.biQuery(ranSource, sql, 1e3).then((r) => {
      setResult(r);
      pushHistory({
        sql: ranSql,
        sourceId: ranSource,
        ts: Date.now(),
        ok: true,
        rowCount: r.row_count,
        elapsedMs: r.elapsed_ms
      });
    }).catch((e) => {
      const m = String(e.message || e);
      const j = m.match(/\{.*\}$/s);
      let msg = m;
      try {
        msg = j ? JSON.parse(j[0]).error : m;
      } catch {
        msg = m;
      }
      setError(msg);
      pushHistory({
        sql: ranSql,
        sourceId: ranSource,
        ts: Date.now(),
        ok: false,
        error: msg
      });
    }).finally(() => setRunning(false));
  };
  const loadFromHistory = (h) => {
    setSql(h.sql);
    if (h.sourceId && (sources || []).some((s) => s.id === h.sourceId))
      setSourceId(String(h.sourceId));
  };
  const onKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
      e.preventDefault();
      run();
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12
  } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 700 } }, "An\xE1lise explorat\xF3ria"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Fonte de dados:"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: sourceId,
      onChange: (e) => setSourceId(e.target.value),
      style: { ...visionInput, width: 260 }
    },
    (sources || []).map((s) => /* @__PURE__ */ React.createElement("option", { key: s.id, value: s.id }, s.name, " \u2014 ", s.engine === "trino" ? "Trino/Presto" : "MSSQL")),
    sources && sources.length === 0 && /* @__PURE__ */ React.createElement("option", { value: "" }, "(sem fontes configuradas)")
  ))), sources && sources.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: "var(--muted)", fontSize: 13 } }, "Nenhuma fonte de dados ativa. Configura uma liga\xE7\xE3o Trino/Presto ou MSSQL na tab ", /* @__PURE__ */ React.createElement("b", null, "Defini\xE7\xF5es"), "."), /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement(
    "textarea",
    {
      value: sql,
      onChange: (e) => setSql(e.target.value),
      onKeyDown,
      placeholder: "SELECT ...\n\n(Ctrl+Enter para executar \u2014 apenas queries de leitura)",
      spellCheck: false,
      rows: 8,
      style: {
        ...visionInput,
        fontFamily: "var(--mono, monospace)",
        fontSize: 13,
        resize: "vertical",
        lineHeight: 1.5
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, alignItems: "center", marginTop: 10 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: run,
      disabled: running || !sourceId || !sql.trim(),
      style: { ...visionBtn(true), opacity: running || !sourceId || !sql.trim() ? 0.6 : 1 }
    },
    running ? "A executar\u2026" : "Executar"
  ), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Limite de 1000 linhas \xB7 Ctrl+Enter"), result && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)", marginLeft: "auto" } }, INT.format(result.row_count), " linha(s)", result.truncated ? " (truncado)" : "", " \xB7 ", result.elapsed_ms, " ms"))), history.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, padding: 0, overflow: "hidden" } }, /* @__PURE__ */ React.createElement(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 14px",
        cursor: "pointer",
        borderBottom: showHistory ? "1px solid var(--border)" : "none"
      },
      onClick: () => setShowHistory((v) => !v)
    },
    /* @__PURE__ */ React.createElement("span", { style: { fontSize: 13, fontWeight: 600 } }, "Hist\xF3rico \u2014 \xFAltimas ", history.length, " query(s)"),
    /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, showHistory ? "\u25BE" : "\u25B8"),
    showHistory && /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        onClick: (e) => {
          e.stopPropagation();
          clearHistory();
        },
        style: {
          ...visionBtn(false),
          marginLeft: "auto",
          padding: "3px 10px",
          fontSize: 12
        }
      },
      "Limpar hist\xF3rico"
    )
  ), showHistory && /* @__PURE__ */ React.createElement("div", { style: { maxHeight: 320, overflowY: "auto" } }, history.map((h, i) => {
    const src = (sources || []).find((s) => s.id === h.sourceId);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: i,
        onClick: () => loadFromHistory(h),
        title: "Carregar esta query no editor",
        style: {
          display: "flex",
          alignItems: "baseline",
          gap: 10,
          padding: "8px 14px",
          cursor: "pointer",
          borderTop: i ? "1px solid var(--border)" : "none"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 7,
        height: 7,
        borderRadius: "50%",
        flexShrink: 0,
        alignSelf: "center",
        background: h.ok ? "#15803d" : "#b91c1c"
      } }),
      /* @__PURE__ */ React.createElement("code", { style: {
        flex: 1,
        fontSize: 12,
        fontFamily: "var(--mono, monospace)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      } }, h.sql.replace(/\s+/g, " ")),
      /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)", whiteSpace: "nowrap" } }, h.ok ? INT.format(h.rowCount) + " linha(s) \xB7 " + h.elapsedMs + " ms" : "erro", src ? " \xB7 " + src.name : "", " \xB7 " + new Date(h.ts).toLocaleString("pt-PT"))
    );
  }))), error && /* @__PURE__ */ React.createElement("div", { style: {
    ...visionCard,
    borderColor: "#fca5a5",
    color: "var(--danger, #b91c1c)",
    fontFamily: "var(--mono, monospace)",
    fontSize: 12,
    whiteSpace: "pre-wrap"
  } }, error), result && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, padding: 0, overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: { overflowX: "auto", overflowY: "auto", maxHeight: 520 } }, /* @__PURE__ */ React.createElement("table", { style: {
    width: "max-content",
    minWidth: "100%",
    borderCollapse: "collapse",
    fontSize: 12
  } }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { style: {
    textAlign: "left",
    color: "var(--muted)",
    position: "sticky",
    top: 0,
    background: "var(--panel)"
  } }, /* @__PURE__ */ React.createElement("th", { style: { padding: "8px 12px", borderBottom: "1px solid var(--border)" } }, "#"), result.columns.map((c, i) => /* @__PURE__ */ React.createElement("th", { key: i, style: {
    padding: "8px 12px",
    borderBottom: "1px solid var(--border)",
    whiteSpace: "nowrap"
  } }, c)))), /* @__PURE__ */ React.createElement("tbody", null, result.rows.map((row, ri) => /* @__PURE__ */ React.createElement("tr", { key: ri, style: { borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("td", { style: { padding: "6px 12px", color: "var(--muted)" } }, ri + 1), row.map((v, ci) => /* @__PURE__ */ React.createElement("td", { key: ci, style: {
    padding: "6px 12px",
    fontFamily: "var(--mono, monospace)",
    whiteSpace: "nowrap",
    maxWidth: 320,
    overflow: "hidden",
    textOverflow: "ellipsis"
  } }, v === null ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "NULL") : String(v))))), result.rows.length === 0 && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(
    "td",
    {
      colSpan: result.columns.length + 1,
      style: { padding: 20, textAlign: "center", color: "var(--muted)" }
    },
    "Sem resultados."
  )))))));
}
Object.assign(window, { VisionQuery });

// ===== bi/mesa/frontend/puros.jsx =====
const MESA_MES_RE = /^(\d{4})-(0[1-9]|1[0-2])$/;
const MESA_NOMES_MES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
function mesaChave(ano, mes) {
  return `${ano}-${String(mes).padStart(2, "0")}`;
}
function mesaMesAnterior(mes) {
  const [a, m] = mes.split("-").map(Number);
  return m === 1 ? mesaChave(a - 1, 12) : mesaChave(a, m - 1);
}
function mesaProximo(mes) {
  const [a, m] = mes.split("-").map(Number);
  return m === 12 ? mesaChave(a + 1, 1) : mesaChave(a, m + 1);
}
function mesaMeses(mes, n = 13) {
  const out = [mes];
  while (out.length < n) out.unshift(mesaMesAnterior(out[0]));
  return out;
}
function mesaUltimoFechado(hojeISO) {
  return mesaMesAnterior(hojeISO.slice(0, 7));
}
function mesaMesValido(valor, hojeISO) {
  if (!valor || !MESA_MES_RE.test(valor)) return null;
  return valor <= hojeISO.slice(0, 7) ? valor : null;
}
function mesaRotuloMes(mes) {
  const [a, m] = mes.split("-").map(Number);
  return `${MESA_NOMES_MES[m - 1]} ${a}`;
}
function mesaVariacao(atual, anterior) {
  if (atual == null || anterior == null) return null;
  const abs = atual - anterior;
  return { abs, pct: anterior === 0 ? null : abs / anterior };
}
function mesaDesvioObjetivo(valor, objetivo) {
  return mesaVariacao(valor, objetivo);
}
function mesaAbertura(serieAbertura, mes, homologo) {
  const doMes = serieAbertura && serieAbertura[mes] || {};
  const doHomologo = serieAbertura && serieAbertura[homologo] || {};
  return Object.keys(doMes).map((rotulo) => ({
    rotulo,
    valor: doMes[rotulo],
    variacao: rotulo in doHomologo ? mesaVariacao(doMes[rotulo], doHomologo[rotulo]) : null
  })).sort((x, y) => y.valor - x.valor);
}
function mesaFormatador(unidade, sinal = false) {
  const sd = sinal ? "always" : "auto";
  if (unidade === "pct") return new Intl.NumberFormat("pt-PT", { style: "unit", unit: "percent", maximumFractionDigits: 1, signDisplay: sd });
  return unidade === "eur" ? new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 0, signDisplay: sd }) : new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 1, signDisplay: sd });
}
function mesaEixo(v) {
  if (Math.abs(v) < 1e3) return new Intl.NumberFormat("pt-PT").format(v);
  return new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 1 }).format(v / 1e3) + "k";
}
function mesaDiferencaFecho(congelado, vivo) {
  if (congelado == null || vivo == null) return null;
  const abs = vivo - congelado;
  return Math.abs(abs) < 5e-3 ? null : abs;
}
function mesaEstadoDoUrl(params, hojeISO) {
  const pega = (k) => params && typeof params.get === "function" ? params.get(k) : null;
  return {
    mes: mesaMesValido(pega("mes"), hojeISO) || mesaUltimoFechado(hojeISO),
    abertura: pega("abertura") === "aquisicao" ? "aquisicao" : "categoria",
    vista: ["pulso", "tesouraria"].includes(pega("vista")) ? pega("vista") : "mensal"
  };
}
function pulsoDiasDoMes(mes) {
  const [a, m] = mes.split("-").map(Number);
  return new Date(a, m, 0).getDate();
}
function pulsoChaveDia(mes, dia) {
  return `${mes}-${String(dia).padStart(2, "0")}`;
}
function pulsoAcumulado(dias, mes, ate) {
  const fim = Math.min(ate, pulsoDiasDoMes(mes));
  let soma = 0;
  for (let d = 1; d <= fim; d += 1) soma += dias && dias[pulsoChaveDia(mes, d)] || 0;
  return soma;
}
function pulsoSerieAcumulada(dias, mes, ate) {
  const out = [];
  let soma = 0;
  for (let d = 1; d <= Math.min(ate, pulsoDiasDoMes(mes)); d += 1) {
    soma += dias && dias[pulsoChaveDia(mes, d)] || 0;
    out.push(soma);
  }
  return out;
}
function pulsoMedia(dias, hojeISO, n) {
  const [a, m, d] = hojeISO.split("-").map(Number);
  let soma = 0;
  for (let i = 0; i < n; i += 1) {
    const x = new Date(a, m - 1, d - i);
    const k = `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
    soma += dias && dias[k] || 0;
  }
  return soma / n;
}
function pulsoCartao(dias, hojeISO, anterior, homologo) {
  const mes = hojeISO.slice(0, 7);
  const dia = Number(hojeISO.slice(8, 10));
  const acumulado = pulsoAcumulado(dias, mes, dia);
  const acAnterior = pulsoAcumulado(dias, anterior, dia);
  const acHomologo = pulsoAcumulado(dias, homologo, dia);
  return {
    hoje: dias && dias[hojeISO] || 0,
    acumulado,
    acAnterior,
    acHomologo,
    vsAnterior: mesaVariacao(acumulado, acAnterior),
    vsHomologo: mesaVariacao(acumulado, acHomologo),
    media7: pulsoMedia(dias, hojeISO, 7),
    media14: pulsoMedia(dias, hojeISO, 14)
  };
}

// ===== bi/mesa/frontend/view.jsx =====
const MESA_VERDE = "#15803d";
const MESA_VERMELHO = "#b91c1c";
const MESA_PCT = new Intl.NumberFormat("pt-PT", { style: "percent", maximumFractionDigits: 1, signDisplay: "always" });
function mesaHojeISO() {
  const d = /* @__PURE__ */ new Date();
  const dois = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${dois(d.getMonth() + 1)}-${dois(d.getDate())}`;
}
function MesaVariacao({ rotulo, variacao, stale, unidade }) {
  const cor = stale || !variacao ? "var(--muted)" : variacao.abs >= 0 ? MESA_VERDE : MESA_VERMELHO;
  return /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, rotulo, " ", /* @__PURE__ */ React.createElement("span", { style: { color: cor, fontWeight: 600 } }, variacao ? variacao.pct == null ? "\u2014" : MESA_PCT.format(variacao.pct) : "\u2014"), variacao && /* @__PURE__ */ React.createElement("span", { style: { color: cor } }, " (", mesaFormatador(unidade, true).format(variacao.abs), ")"));
}
function MesaBarras({ meses, serie, mes, homologo, stale, unidade }) {
  const option = useMemo(() => ({
    grid: { left: 4, right: 4, top: 6, bottom: 18 },
    tooltip: { trigger: "item", formatter: (p) => `${mesaRotuloMes(p.name)}<br/><b>${mesaFormatador(unidade).format(p.value)}</b>` },
    xAxis: { type: "category", data: meses, axisLabel: { fontSize: 9, formatter: (m) => m.slice(5) }, axisTick: { show: false } },
    yAxis: { type: "value", show: false },
    series: [{ type: "bar", data: meses.map((m) => ({
      value: serie[m] ?? null,
      // sem leitura = sem barra, nunca 0
      itemStyle: { color: stale ? "#cbd5e1" : m === mes ? VISION_ACCENT : m === homologo ? "#64748b" : "#cbd5e1" }
    })), barMaxWidth: 18 }]
  }), [meses, serie, mes, homologo, stale, unidade]);
  return /* @__PURE__ */ React.createElement(EChart, { option, height: 90 });
}
function MesaCartao({ ind, meses, mes, emCurso, erro, fecho, objetivo }) {
  const anterior = mesaMesAnterior(mes);
  const homologo = meses[0];
  const semLeitura = !ind.serie || ind.serie[mes] == null;
  const serie = ind.serie || ind.ultima_boa && ind.ultima_boa.serie || null;
  const cor = semLeitura ? "var(--muted)" : VISION_ACCENT;
  const congelado = fecho && fecho.valores && fecho.valores[ind.id] != null ? fecho.valores[ind.id] : null;
  const diferenca = semLeitura ? null : mesaDiferencaFecho(congelado, serie && serie[mes]);
  const desvio = semLeitura ? null : mesaDesvioObjetivo(serie && serie[mes], objetivo);
  const lidoEm = semLeitura ? ind.ultima_boa && ind.ultima_boa.lido_em : ind.lido_em;
  return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", textTransform: "uppercase", letterSpacing: 0.4 } }, ind.titulo, " ", /* @__PURE__ */ React.createElement(
    "span",
    {
      title: ind.definicao,
      tabIndex: 0,
      role: "img",
      "aria-label": `Defini\xE7\xE3o: ${ind.definicao}`,
      style: { cursor: "help", color: VISION_ACCENT }
    },
    "\u24D8"
  )), emCurso && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "#b45309" } }, "em curso")), semLeitura && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: MESA_VERMELHO } }, "sem leitura", lidoEm ? ` \xB7 \xFAltima leitura \xE0s ${lidoEm.slice(11, 16)}` : "", /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 400, color: "var(--muted)" } }, erro)), congelado != null && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 30, fontWeight: 700, color: VISION_ACCENT } }, mesaFormatador(ind.unidade).format(congelado)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "\u{1F512} fechado")), congelado == null && serie && serie[mes] != null && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 30, fontWeight: 700, color: cor } }, mesaFormatador(ind.unidade).format(serie[mes])), congelado != null && !semLeitura && diferenca != null && /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { fontSize: 12, color: "#b45309", fontWeight: 600 },
      title: "O valor ao vivo mudou depois do fecho (por exemplo, um documento lan\xE7ado com data atrasada)."
    },
    "ao vivo agora ",
    mesaFormatador(ind.unidade).format(serie[mes]),
    " (",
    mesaFormatador(ind.unidade, true).format(diferenca),
    ")"
  ), serie && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 18 } }, /* @__PURE__ */ React.createElement(MesaVariacao, { rotulo: "vs. m\xEAs anterior", variacao: mesaVariacao(serie[mes], serie[anterior]), stale: semLeitura, unidade: ind.unidade }), /* @__PURE__ */ React.createElement(MesaVariacao, { rotulo: "vs. hom\xF3logo", variacao: mesaVariacao(serie[mes], serie[homologo]), stale: semLeitura, unidade: ind.unidade })), serie && /* @__PURE__ */ React.createElement(MesaBarras, { meses, serie, mes, homologo, stale: semLeitura, unidade: ind.unidade }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "Objetivo: ", objetivo == null ? "\u2014" : mesaFormatador(ind.unidade).format(objetivo), objetivo != null && desvio && /* @__PURE__ */ React.createElement("span", { style: { color: semLeitura ? "var(--muted)" : desvio.abs >= 0 ? MESA_VERDE : MESA_VERMELHO, fontWeight: 600 } }, " ", "\xB7 ", desvio.pct == null ? "\u2014" : MESA_PCT.format(desvio.pct), " (", mesaFormatador(ind.unidade, true).format(desvio.abs), ")"), !semLeitura && lidoEm ? ` \xB7 lido \xE0s ${lidoEm.slice(11, 16)}` : ""));
}
function MesaAbertura({ ind, mes, homologo, abertura, setAbertura }) {
  const aberturas = useMemo(() => ind.aberturas || {}, [ind.aberturas]);
  const ids = Object.keys(aberturas);
  const atual = aberturas[abertura] ? abertura : ids[0];
  const linhas = useMemo(
    () => atual && ind.serie ? mesaAbertura(aberturas[atual].serie, mes, homologo) : [],
    [aberturas, atual, ind.serie, mes, homologo]
  );
  const option = useMemo(() => {
    const ordenadas = [...linhas].reverse();
    return {
      grid: { left: 8, right: 80, top: 8, bottom: 8, containLabel: true },
      tooltip: { trigger: "item", formatter: (p) => {
        const l = ordenadas[p.dataIndex];
        const v = l.variacao ? l.variacao.pct == null ? "\u2014" : MESA_PCT.format(l.variacao.pct) : "sem hom\xF3logo";
        return `${l.rotulo}<br/><b>${mesaFormatador(ind.unidade).format(l.valor)}</b> \xB7 vs. hom\xF3logo ${v}`;
      } },
      xAxis: { type: "value", axisLabel: { formatter: mesaEixo } },
      yAxis: { type: "category", data: ordenadas.map((l) => l.rotulo), axisLabel: { fontSize: 11 } },
      series: [{
        type: "bar",
        data: ordenadas.map((l) => l.valor),
        itemStyle: { color: VISION_ACCENT },
        label: {
          show: true,
          position: "right",
          fontSize: 10,
          formatter: (p) => {
            const l = ordenadas[p.dataIndex];
            return l.variacao && l.variacao.pct != null ? MESA_PCT.format(l.variacao.pct) : "";
          }
        }
      }]
    };
  }, [linhas, ind.unidade]);
  if (!atual || !ind.serie) return null;
  return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center" } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 600, fontSize: 13 } }, ind.titulo, " \u2014 ", aberturas[atual].titulo), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, ids.map((id) => /* @__PURE__ */ React.createElement("button", { key: id, type: "button", style: visionBtn(id === atual), "aria-pressed": id === atual, onClick: () => setAbertura(id) }, aberturas[id].titulo)))), linhas.length ? /* @__PURE__ */ React.createElement(EChart, { option, height: Math.max(120, 28 * linhas.length) }) : /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 13 } }, "Sem linhas neste m\xEAs."));
}
function MesaFecho({ pronto, mes, aoMudar }) {
  const [ocupado, setOcupado] = useState(false);
  const [msg, setMsg] = useState(null);
  const fecho = pronto.fecho;
  const agir = (fn) => {
    setOcupado(true);
    setMsg(null);
    fn(mes).then(aoMudar).catch((e) => setMsg(e.message || String(e))).finally(() => setOcupado(false));
  };
  if (!fecho && (pronto.em_curso || !pronto.pode_fechar)) return null;
  return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", alignItems: "center", gap: 12, fontSize: 13 } }, fecho ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", null, "\u{1F512} M\xEAs fechado em ", fecho.fechado_em.slice(0, 10), " \xE0s ", fecho.fechado_em.slice(11, 16), fecho.fechado_por ? ` por ${fecho.fechado_por}` : "", " \u2014 os valores abaixo est\xE3o congelados."), pronto.pode_fechar && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: visionBtn(false),
      disabled: ocupado,
      onClick: () => window.hubConfirm({
        title: "Reabrir o m\xEAs",
        message: "Os valores congelados perdem-se.",
        confirmLabel: "Reabrir"
      }).then((ok) => ok && agir(window.API.reabrirBIMesa))
    },
    "Reabrir"
  )) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "M\xEAs por fechar \u2014 fechar congela os valores de cada indicador para a ata."), /* @__PURE__ */ React.createElement("button", { type: "button", style: visionBtn(true), disabled: ocupado, onClick: () => agir(window.API.fecharBIMesa) }, ocupado ? "A fechar\u2026" : "Fechar m\xEAs")), msg && /* @__PURE__ */ React.createElement("span", { style: { color: MESA_VERMELHO } }, msg));
}
function MesaMensal({ seletor }) {
  const [urlParams, setUrlParams] = useState(() => window.HubRouter.current().params);
  useEffect(() => window.HubRouter.subscribe(
    () => setUrlParams(window.HubRouter.current().params)
  ), []);
  const hoje = mesaHojeISO();
  const { mes, abertura } = mesaEstadoDoUrl(urlParams, hoje);
  const [data, setData] = useState(null);
  const [erro, setErro] = useState(null);
  const [recarga, setRecarga] = useState(0);
  useEffect(() => {
    let vivo = true;
    setData(null);
    setErro(null);
    window.API.biMesa(mes).then((d) => {
      if (vivo) setData(d);
    }).catch((e) => {
      if (vivo) setErro(e.message || String(e));
    });
    return () => {
      vivo = false;
    };
  }, [mes, recarga]);
  const irPara = (m) => window.HubRouter.setParams({ mes: m }, { replace: false });
  const podeAvancar = mes < hoje.slice(0, 7);
  const pronto = data && data.mes === mes ? data : null;
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 700 } }, "Mesa da administra\xE7\xE3o"), seletor, /* @__PURE__ */ React.createElement("button", { type: "button", style: visionBtn(false), onClick: () => irPara(mesaMesAnterior(mes)), title: "M\xEAs anterior", "aria-label": "M\xEAs anterior" }, "\u2039"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 600, minWidth: 90, textAlign: "center" } }, mesaRotuloMes(mes)), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: visionBtn(false),
      disabled: !podeAvancar,
      onClick: () => podeAvancar && irPara(mesaProximo(mes)),
      title: "M\xEAs seguinte",
      "aria-label": "M\xEAs seguinte"
    },
    "\u203A"
  ), pronto && pronto.em_curso && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "#b45309", fontWeight: 600 } }, "m\xEAs em curso"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "face ao anterior e ao hom\xF3logo \xB7 ", pronto && pronto.cache ? "em cache" : "ao vivo")), erro && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: MESA_VERMELHO } }, erro), !pronto && !erro && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), pronto && /* @__PURE__ */ React.createElement(MesaFecho, { pronto, mes, aoMudar: () => setRecarga((n) => n + 1) }), pronto && /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))", gap: 14 } }, pronto.indicadores.map((ind) => /* @__PURE__ */ React.createElement(
    MesaCartao,
    {
      key: ind.id,
      ind,
      meses: pronto.meses,
      mes,
      emCurso: pronto.em_curso,
      erro: pronto.erros && pronto.erros[ind.id],
      fecho: pronto.fecho,
      objetivo: pronto.objetivos ? pronto.objetivos[ind.id] : void 0
    }
  ))), pronto && pronto.indicadores.filter((i) => i.aberturas && Object.keys(i.aberturas).length).map((ind) => /* @__PURE__ */ React.createElement(
    MesaAbertura,
    {
      key: ind.id,
      ind,
      mes,
      homologo: pronto.meses[0],
      abertura,
      setAbertura: (id) => window.HubRouter.setParams({ abertura: id })
    }
  )));
}
function MesaSeletor({ vista }) {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, [["mensal", "Mensal"], ["pulso", "Pulso"], ["tesouraria", "Tesouraria"]].map(([id, rotulo]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: id,
      type: "button",
      style: visionBtn(id === vista),
      onClick: () => window.HubRouter.setParams({ vista: id === "mensal" ? null : id }, { replace: false })
    },
    rotulo
  )));
}
const PULSO_REFRESCO_MS = 5 * 60 * 1e3;
const PULSO_CORES = { atual: VISION_ACCENT, anterior: "#b45309", homologo: "#64748b" };
function PulsoGrafico({ dias, mes, anterior, homologo, ate }) {
  const option = useMemo(() => {
    const n = pulsoDiasDoMes(mes);
    const eixo = Array.from({ length: n }, (_, i) => i + 1);
    const linha = (m, nome, cor, limite) => ({
      name: nome,
      type: "line",
      yAxisIndex: 1,
      showSymbol: false,
      lineStyle: { color: cor, width: 2 },
      itemStyle: { color: cor },
      data: pulsoSerieAcumulada(dias, m, limite)
    });
    return {
      grid: { left: 4, right: 4, top: 22, bottom: 18 },
      legend: { top: 0, textStyle: { fontSize: 10 } },
      tooltip: { trigger: "axis", valueFormatter: (v) => v == null ? "\u2014" : EUR.format(v) },
      xAxis: { type: "category", data: eixo, axisLabel: { fontSize: 9 }, axisTick: { show: false } },
      yAxis: [{ type: "value", show: false }, { type: "value", show: false }],
      series: [
        {
          name: "Dia",
          type: "bar",
          barMaxWidth: 10,
          itemStyle: { color: "#cbd5e1" },
          data: eixo.map((d) => d <= ate ? dias[pulsoChaveDia(mes, d)] || 0 : null)
        },
        linha(mes, mesaRotuloMes(mes), PULSO_CORES.atual, ate),
        linha(anterior, mesaRotuloMes(anterior), PULSO_CORES.anterior, n),
        linha(homologo, mesaRotuloMes(homologo), PULSO_CORES.homologo, n)
      ]
    };
  }, [dias, mes, anterior, homologo, ate]);
  return /* @__PURE__ */ React.createElement(EChart, { option, height: 150 });
}
function PulsoCartao({ ind, hoje, anterior, homologo, erro }) {
  const mes = hoje.slice(0, 7);
  const c = useMemo(
    () => ind.dias ? pulsoCartao(ind.dias, hoje, anterior, homologo) : null,
    [ind.dias, hoje, anterior, homologo]
  );
  return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", textTransform: "uppercase", letterSpacing: 0.4 } }, ind.titulo, " ", /* @__PURE__ */ React.createElement("span", { title: ind.definicao, style: { cursor: "help", color: VISION_ACCENT } }, "\u24D8")), !c && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: MESA_VERMELHO }, title: erro }, "sem leitura", /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 400, color: "var(--muted)" } }, erro)), c && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 28, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "Hoje"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 26, fontWeight: 700, color: VISION_ACCENT } }, EUR.format(c.hoje))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "Acumulado de ", mesaRotuloMes(mes)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 26, fontWeight: 700, color: VISION_ACCENT } }, EUR.format(c.acumulado)))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 18, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(MesaVariacao, { rotulo: `vs. ${mesaRotuloMes(anterior)} at\xE9 ao dia`, variacao: c.vsAnterior }), /* @__PURE__ */ React.createElement(MesaVariacao, { rotulo: `vs. ${mesaRotuloMes(homologo)} at\xE9 ao dia`, variacao: c.vsHomologo })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "M\xE9dia 7 dias ", /* @__PURE__ */ React.createElement("b", null, EUR.format(c.media7)), " \xB7 14 dias ", /* @__PURE__ */ React.createElement("b", null, EUR.format(c.media14))), /* @__PURE__ */ React.createElement(
    PulsoGrafico,
    {
      dias: ind.dias,
      mes,
      anterior,
      homologo,
      ate: Number(hoje.slice(8, 10))
    }
  )));
}
function MesaPulso({ seletor }) {
  const [data, setData] = useState(null);
  const [erro, setErro] = useState(null);
  useEffect(() => {
    let vivo = true;
    const ler = () => window.API.biMesaPulso().then((d) => {
      if (vivo) {
        setData(d);
        setErro(null);
      }
    }).catch((e) => {
      if (vivo) setErro(e.message || String(e));
    });
    ler();
    const t = setInterval(ler, PULSO_REFRESCO_MS);
    return () => {
      vivo = false;
      clearInterval(t);
    };
  }, []);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 700 } }, "Pulso"), seletor, data && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "#b45309", fontWeight: 600 } }, "m\xEAs em curso"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, data && data.lido_em ? `lido \xE0s ${data.lido_em.slice(11, 16)} \xB7 ` : "", "atualiza de 5 em 5 minutos")), erro && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: MESA_VERMELHO } }, erro), !data && !erro && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), data && /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))", gap: 14 } }, data.indicadores.map((ind) => /* @__PURE__ */ React.createElement(
    PulsoCartao,
    {
      key: ind.id,
      ind,
      hoje: data.hoje,
      anterior: data.anterior,
      homologo: data.homologo,
      erro: data.erros && data.erros[ind.id]
    }
  ))));
}
const TESOURARIA_LADOS = [
  ["clientes", "Clientes", "O que os clientes nos devem (conta-corrente `cc`, d\xE9bito \u2212 cr\xE9dito)."],
  ["fornecedores", "Fornecedores", "O que devemos aos fornecedores (conta-corrente `fc`, cr\xE9dito \u2212 d\xE9bito)."]
];
function TesourariaCartao({ rotulo, definicao, valores, erro }) {
  return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600 } }, rotulo, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      title: definicao,
      "aria-label": `Defini\xE7\xE3o: ${rotulo}`,
      style: { border: 0, background: "none", color: "var(--muted)", cursor: "help" }
    },
    "\u24D8"
  )), erro && /* @__PURE__ */ React.createElement("div", { style: { color: MESA_VERMELHO, fontWeight: 600 } }, "sem leitura ", /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 400, fontSize: 12 } }, erro)), valores && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "Saldo"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 26, fontWeight: 700, color: VISION_ACCENT } }, EUR.format(valores.saldo))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 28 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "Vencido"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 700, color: valores.vencido > 0 ? MESA_VERMELHO : void 0 } }, EUR.format(valores.vencido))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "A vencer"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 700 } }, EUR.format(valores.a_vencer))))));
}
function MesaTesouraria({ seletor }) {
  const [data, setData] = useState(null);
  const [erro, setErro] = useState(null);
  useEffect(() => {
    let vivo = true;
    window.API.biMesaTesouraria().then((d) => {
      if (vivo) {
        setData(d);
        setErro(null);
      }
    }).catch((e) => {
      if (vivo) setErro(e.message || String(e));
    });
    return () => {
      vivo = false;
    };
  }, []);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 700 } }, "Tesouraria"), seletor, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "#b45309", fontWeight: 600 } }, "ao vivo, n\xE3o fecha"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, data && data.lido_em ? `lido \xE0s ${data.lido_em.slice(11, 16)}` : "")), erro && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: MESA_VERMELHO } }, erro), !data && !erro && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), data && /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 14 } }, TESOURARIA_LADOS.map(([id, rotulo, definicao]) => /* @__PURE__ */ React.createElement(
    TesourariaCartao,
    {
      key: id,
      rotulo,
      definicao,
      valores: data[id],
      erro: data.erros && data.erros[id]
    }
  ))));
}
function VisionMesaView() {
  const [urlParams, setUrlParams] = useState(() => window.HubRouter.current().params);
  useEffect(() => window.HubRouter.subscribe(
    () => setUrlParams(window.HubRouter.current().params)
  ), []);
  const { vista } = mesaEstadoDoUrl(urlParams, mesaHojeISO());
  const seletor = /* @__PURE__ */ React.createElement(MesaSeletor, { vista });
  if (vista === "tesouraria") return /* @__PURE__ */ React.createElement(MesaTesouraria, { seletor });
  return vista === "pulso" ? /* @__PURE__ */ React.createElement(MesaPulso, { seletor }) : /* @__PURE__ */ React.createElement(MesaMensal, { seletor });
}
window.VisionMesaView = VisionMesaView;

// ===== bi/settings/frontend/view.jsx =====
function SupplierConfigSection() {
  const [rows, setRows] = useState(null);
  const [msg, setMsg] = useState(null);
  const [emailsDraft, setEmailsDraft] = useState({});
  const [websiteDraft, setWebsiteDraft] = useState({});
  const [phcDraft, setPhcDraft] = useState({});
  const [savingPhcId, setSavingPhcId] = useState(null);
  const [savingId, setSavingId] = useState(null);
  const [savingWebId, setSavingWebId] = useState(null);
  const [uploadingId, setUploadingId] = useState(null);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);
  const [newName, setNewName] = useState("");
  const [creating, setCreating] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [sendingAll, setSendingAll] = useState(false);
  const [schedule, setSchedule] = useState(null);
  const [scheduleDraft, setScheduleDraft] = useState(null);
  const [savingSchedule, setSavingSchedule] = useState(false);
  const reload = () => window.API.biSupplierLogos().then((r) => {
    const list = r.results || r;
    setRows(list);
    setEmailsDraft(Object.fromEntries(list.map((s) => [s.id, s.emails || ""])));
    setWebsiteDraft(Object.fromEntries(list.map((s) => [s.id, s.website || ""])));
    setPhcDraft(Object.fromEntries(list.map((s) => [s.id, s.phc_no ?? ""])));
  }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  const reloadSchedule = () => window.API.biSupplierEmailSchedule().then((s) => {
    setSchedule(s);
    setScheduleDraft(s);
  }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  useEffect(() => {
    reload();
    reloadSchedule();
  }, []);
  const sendAll = () => {
    setSendingAll(true);
    setMsg(null);
    window.API.emailAllBISupplierPdfs().then((r) => {
      setMsg({
        ok: true,
        text: `Envio: ${r.sent} enviados, ${r.skipped} sem emails/dados, ${r.errors} erros.`
      });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setSendingAll(false));
  };
  const saveSchedule = () => {
    setSavingSchedule(true);
    setMsg(null);
    const body = { enabled: !!scheduleDraft.enabled };
    window.API.updateBISupplierEmailSchedule(body).then(() => {
      reloadSchedule();
      setMsg({ ok: true, text: "Agenda mensal guardada." });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setSavingSchedule(false));
  };
  const syncFromTrino = () => {
    setSyncing(true);
    setMsg(null);
    window.API.syncBISupplierLogos().then((r) => {
      reload();
      setMsg({
        ok: true,
        text: `Sync do Trino: ${r.created} novos, ${r.existed} j\xE1 existiam, N\xBA PHC actualizado em ${r.phc_updated ?? 0}, ${r.logo_fetched} logos via Clearbit.`
      });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setSyncing(false));
  };
  const saveWebsite = (s) => {
    setSavingWebId(s.id);
    setMsg(null);
    window.API.updateBISupplierLogo(s.id, { website: websiteDraft[s.id] || "" }).then(() => {
      reload();
      setMsg({
        ok: true,
        text: `Website de "${s.fornecedor}" guardado \u2014 tentei buscar logo no Clearbit.`
      });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setSavingWebId(null));
  };
  const savePhc = (s) => {
    setSavingPhcId(s.id);
    setMsg(null);
    const raw = String(phcDraft[s.id] ?? "").trim();
    const val = raw === "" ? null : Number(raw);
    if (val !== null && !Number.isFinite(val)) {
      setSavingPhcId(null);
      setMsg({ ok: false, text: "N\xBA PHC deve ser inteiro." });
      return;
    }
    window.API.updateBISupplierLogo(s.id, { phc_no: val }).then(() => {
      reload();
      setMsg({
        ok: true,
        text: `N\xBA PHC de "${s.fornecedor}" guardado.`
      });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setSavingPhcId(null));
  };
  const saveEmails = (s) => {
    setSavingId(s.id);
    setMsg(null);
    window.API.updateBISupplierLogo(s.id, { emails: emailsDraft[s.id] || "" }).then(() => {
      reload();
      setMsg({ ok: true, text: `Emails de "${s.fornecedor}" guardados.` });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setSavingId(null));
  };
  const onFile = (s, file) => {
    if (!file) return;
    setUploadingId(s.id);
    setMsg(null);
    window.API.uploadBISupplierLogo(s.id, file).then(() => {
      reload();
      setMsg({ ok: true, text: `Imagem de "${s.fornecedor}" atualizada.` });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setUploadingId(null));
  };
  const remove = (s) => {
    window.API.deleteBISupplierLogo(s.id).then(() => {
      setPendingDeleteId(null);
      reload();
      setMsg({ ok: true, text: `"${s.fornecedor}" apagado.` });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  };
  const create = () => {
    const name = newName.trim();
    if (!name) {
      setMsg({ ok: false, text: "Indica o nome do fornecedor." });
      return;
    }
    setCreating(true);
    setMsg(null);
    window.API.createBISupplierLogo({ fornecedor: name, emails: "" }).then(() => {
      setNewName("");
      reload();
      setMsg({ ok: true, text: `"${name}" criado.` });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setCreating(false));
  };
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 700 } }, "Fornecedores \u2014 imagem e emails"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Imagem usada no PDF e emails para onde envi\xE1-lo.")), msg && /* @__PURE__ */ React.createElement("div", { style: {
    ...visionCard,
    fontSize: 13,
    color: msg.ok ? "var(--success, #15803d)" : "var(--danger, #b91c1c)",
    borderColor: msg.ok ? "#86efac" : "#fca5a5"
  } }, msg.text), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...visionBtn(true), opacity: syncing ? 0.6 : 1 },
      disabled: syncing,
      onClick: syncFromTrino
    },
    syncing ? "A importar\u2026" : "\u21E9 Importar fornecedores do Trino"
  ), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "Cria em falta a partir de ", /* @__PURE__ */ React.createElement("code", null, "hive.kpiscompras_silver.reqs"), " e tenta o logo via Clearbit.")), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...visionBtn(true), opacity: sendingAll ? 0.6 : 1 },
      disabled: sendingAll,
      onClick: sendAll
    },
    sendingAll ? "A enviar\u2026" : "\u2709 Enviar PDFs a todos"
  ), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "Envia o PDF a cada fornecedor com emails configurados. Pode demorar alguns segundos por fornecedor.")), scheduleDraft && (() => {
    const dirty = schedule && scheduleDraft.enabled !== schedule.enabled;
    return /* @__PURE__ */ React.createElement("div", { style: {
      borderTop: "1px solid var(--border)",
      paddingTop: 10,
      display: "flex",
      flexDirection: "column",
      gap: 8
    } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } }, /* @__PURE__ */ React.createElement("label", { style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      fontSize: 13
    } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: !!scheduleDraft.enabled,
        onChange: (e) => setScheduleDraft((d) => ({ ...d, enabled: e.target.checked }))
      }
    ), "Envio mensal autom\xE1tico (dia 5 \xE0s 08:00)"), schedule && schedule.last_run_at && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)", marginLeft: "auto" } }, "\xFAltimo envio: ", new Date(schedule.last_run_at).toLocaleString("pt-PT"), schedule.last_run_summary && " \xB7 " + schedule.last_run_summary)), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, 'O assunto e o corpo do email editam-se em Administra\xE7\xE3o \u2192 Templates de email (modelo "Servi\xE7o de fornecedor").'), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        style: { ...visionBtn(dirty), opacity: !dirty || savingSchedule ? 0.6 : 1 },
        disabled: !dirty || savingSchedule,
        onClick: saveSchedule
      },
      savingSchedule ? "A guardar\u2026" : "Guardar agenda"
    )));
  })()), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 13, fontWeight: 600 } }, "Adicionar manualmente:"), /* @__PURE__ */ React.createElement(
    "input",
    {
      style: { ...visionInput, minWidth: 260 },
      value: newName,
      onChange: (e) => setNewName(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") create();
      },
      placeholder: 'ex. "DS SMITH PORTUGAL, LDA"'
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...visionBtn(true), opacity: creating ? 0.6 : 1 },
      disabled: creating,
      onClick: create
    },
    creating ? "A criar\u2026" : "+ Criar"
  )), !rows && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 13 } }, "A carregar\u2026"), rows && rows.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: "var(--muted)", fontSize: 13 } }, "Sem fornecedores configurados."), rows && rows.map((s) => {
    const draft = emailsDraft[s.id] ?? "";
    const dirty = draft !== (s.emails || "");
    const isDeleting = pendingDeleteId === s.id;
    return /* @__PURE__ */ React.createElement("div", { key: s.id, style: {
      ...visionCard,
      display: "grid",
      gridTemplateColumns: "80px 1fr auto",
      gap: 12,
      alignItems: "start"
    } }, /* @__PURE__ */ React.createElement("div", { style: {
      width: 80,
      height: 80,
      border: "1px solid var(--border)",
      borderRadius: 4,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--bg-soft, #f7f9fb)",
      overflow: "hidden"
    } }, s.logo_url ? /* @__PURE__ */ React.createElement(
      "img",
      {
        src: s.logo_url,
        alt: "",
        style: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }
      }
    ) : /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, color: "var(--muted)" } }, "sem imagem")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 6, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 14 } }, s.fornecedor), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("label", { style: { fontSize: 11, color: "var(--muted)", minWidth: 60 } }, "N\xBA PHC:"), /* @__PURE__ */ React.createElement(
      "input",
      {
        style: { ...visionInput, fontSize: 12, flex: 1 },
        type: "number",
        value: phcDraft[s.id] ?? "",
        onChange: (e) => setPhcDraft((m) => ({ ...m, [s.id]: e.target.value })),
        placeholder: "ex. 4321 (coluna no em u_agirrfor)"
      }
    ), (() => {
      const pdirty = String(phcDraft[s.id] ?? "") !== String(s.phc_no ?? "");
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          style: {
            ...visionBtn(pdirty),
            fontSize: 12,
            padding: "4px 10px",
            opacity: !pdirty || savingPhcId === s.id ? 0.6 : 1
          },
          disabled: !pdirty || savingPhcId === s.id,
          onClick: () => savePhc(s)
        },
        savingPhcId === s.id ? "A guardar\u2026" : "Guardar N\xBA"
      );
    })()), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("label", { style: { fontSize: 11, color: "var(--muted)", minWidth: 60 } }, "Website:"), /* @__PURE__ */ React.createElement(
      "input",
      {
        style: { ...visionInput, fontSize: 12, flex: 1 },
        value: websiteDraft[s.id] ?? "",
        onChange: (e) => setWebsiteDraft((m) => ({ ...m, [s.id]: e.target.value })),
        placeholder: "ex. dssmith.com"
      }
    ), (() => {
      const wdirty = (websiteDraft[s.id] ?? "") !== (s.website || "");
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          style: {
            ...visionBtn(wdirty),
            fontSize: 12,
            padding: "4px 10px",
            opacity: !wdirty || savingWebId === s.id ? 0.6 : 1
          },
          disabled: !wdirty || savingWebId === s.id,
          onClick: () => saveWebsite(s)
        },
        savingWebId === s.id ? "Clearbit\u2026" : "Guardar + logo"
      );
    })()), /* @__PURE__ */ React.createElement("label", { style: { fontSize: 11, color: "var(--muted)" } }, "Emails destinat\xE1rios (um por linha, ou separados por v\xEDrgula):"), /* @__PURE__ */ React.createElement(
      "textarea",
      {
        style: {
          ...visionInput,
          minHeight: 60,
          resize: "vertical",
          fontFamily: "var(--mono, monospace)",
          fontSize: 12
        },
        value: draft,
        onChange: (e) => setEmailsDraft((m) => ({ ...m, [s.id]: e.target.value })),
        placeholder: "compras@fornecedor.pt\nqualidade@fornecedor.pt"
      }
    ), s.email_list && s.email_list.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, s.email_list.length, " destinat\xE1rio", s.email_list.length === 1 ? "" : "s", " activos.")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 6, minWidth: 130 } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        style: { ...visionBtn(dirty), opacity: !dirty || savingId === s.id ? 0.6 : 1 },
        disabled: !dirty || savingId === s.id,
        onClick: () => saveEmails(s)
      },
      savingId === s.id ? "A guardar\u2026" : "Guardar emails"
    ), /* @__PURE__ */ React.createElement("label", { style: {
      ...visionBtn(false),
      cursor: "pointer",
      textAlign: "center",
      opacity: uploadingId === s.id ? 0.6 : 1
    } }, uploadingId === s.id ? "A carregar\u2026" : s.logo_url ? "Trocar imagem" : "Carregar imagem", /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "file",
        accept: "image/*",
        style: { display: "none" },
        disabled: uploadingId === s.id,
        onChange: (e) => onFile(s, e.target.files && e.target.files[0])
      }
    )), isDeleting ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4 } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        style: { ...visionBtn(false), color: "var(--danger, #b91c1c)", flex: 1 },
        onClick: () => remove(s)
      },
      "Confirmar"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        style: { ...visionBtn(false), flex: 1 },
        onClick: () => setPendingDeleteId(null)
      },
      "\xD7"
    )) : /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        style: { ...visionBtn(false), color: "var(--danger, #b91c1c)" },
        onClick: () => setPendingDeleteId(s.id)
      },
      "Apagar"
    )));
  }));
}
function VisionSettings() {
  const [sources, setSources] = useState(null);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [testMsg, setTestMsg] = useState({});
  const reload = () => window.API.biDataSources().then((r) => setSources(r.results || r)).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  useEffect(() => {
    reload();
  }, []);
  const setField = (k, v) => setForm((f) => {
    const next = { ...f, [k]: v };
    if (k === "engine") {
      next.port = DS_DEFAULTS[v].port;
      next.driver = DS_DEFAULTS[v].driver;
    }
    return next;
  });
  const save = () => {
    if (!form.name || !form.host || !form.username) {
      setMsg({ ok: false, text: "Nome, IP do servidor e username s\xE3o obrigat\xF3rios." });
      return;
    }
    setBusy(true);
    setMsg(null);
    const body = { ...form, port: Number(form.port) || DS_DEFAULTS[form.engine].port };
    const p = form.id ? window.API.updateBIDataSource(form.id, body) : window.API.createBIDataSource(body);
    p.then(() => {
      setForm(null);
      reload();
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setBusy(false));
  };
  const remove = (s) => {
    if (!window.confirm(`Apagar a liga\xE7\xE3o "${s.name}"?`)) return;
    window.API.deleteBIDataSource(s.id).then(reload).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  };
  const test = (s) => {
    setTestMsg((m) => ({ ...m, [s.id]: { ok: true, text: "A testar\u2026" } }));
    window.API.testBIDataSource(s.id).then((r) => setTestMsg((m) => ({ ...m, [s.id]: { ok: r.ok, text: r.message } }))).catch((e) => {
      const raw = String(e.message || e);
      let text = raw;
      try {
        const j = raw.match(/\{.*\}$/s);
        if (j) text = JSON.parse(j[0]).message || raw;
      } catch {
      }
      setTestMsg((m) => ({ ...m, [s.id]: { ok: false, text } }));
    });
  };
  const isTrino = form && form.engine === "trino";
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: 14,
    maxWidth: 980
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 700 } }, "Liga\xE7\xF5es a fontes de dados"), !form && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: visionBtn(true),
      onClick: () => {
        setMsg(null);
        setForm({ ...EMPTY_DS });
      }
    },
    "+ Nova liga\xE7\xE3o"
  )), msg && /* @__PURE__ */ React.createElement("div", { style: {
    ...visionCard,
    fontSize: 13,
    color: msg.ok ? "var(--success, #15803d)" : "var(--danger, #b91c1c)",
    borderColor: msg.ok ? "#86efac" : "#fca5a5"
  } }, msg.text), form && /* @__PURE__ */ React.createElement("div", { style: visionCard }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, marginBottom: 12 } }, form.id ? "Editar liga\xE7\xE3o" : "Nova liga\xE7\xE3o"), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 12
  } }, /* @__PURE__ */ React.createElement(Field, { label: "Nome" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: form.name,
      onChange: (e) => setField("name", e.target.value),
      placeholder: 'ex. "Trino produ\xE7\xE3o"'
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Tipo de servidor" }, /* @__PURE__ */ React.createElement(
    "select",
    {
      style: visionInput,
      value: form.engine,
      onChange: (e) => setField("engine", e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "trino" }, "Trino / Presto"),
    /* @__PURE__ */ React.createElement("option", { value: "mssql" }, "Microsoft SQL Server")
  )), /* @__PURE__ */ React.createElement(Field, { label: isTrino ? "Driver (http ou https)" : "Driver ODBC" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: form.driver,
      onChange: (e) => setField("driver", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "IP do servidor" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: form.host,
      onChange: (e) => setField("host", e.target.value),
      placeholder: "ex. 192.168.1.50"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Porta" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      type: "number",
      value: form.port,
      onChange: (e) => setField("port", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: isTrino ? "Cat\xE1logo" : "Base de dados" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: form.database,
      onChange: (e) => setField("database", e.target.value),
      placeholder: isTrino ? "ex. hive" : "ex. ERP"
    }
  )), isTrino && /* @__PURE__ */ React.createElement(Field, { label: "Schema (opcional)" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: form.schema_name,
      onChange: (e) => setField("schema_name", e.target.value),
      placeholder: "ex. default"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Username" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: form.username,
      autoComplete: "off",
      onChange: (e) => setField("username", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: form.id ? "Password (vazio = manter)" : "Password" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      type: "password",
      value: form.password || "",
      autoComplete: "new-password",
      onChange: (e) => setField("password", e.target.value)
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 14 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...visionBtn(true), opacity: busy ? 0.6 : 1 },
      disabled: busy,
      onClick: save
    },
    busy ? "A guardar\u2026" : "Guardar"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: visionBtn(false),
      onClick: () => {
        setForm(null);
        setMsg(null);
      }
    },
    "Cancelar"
  ))), !sources && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 13 } }, "A carregar\u2026"), sources && sources.length === 0 && !form && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: "var(--muted)", fontSize: 13 } }, "Sem liga\xE7\xF5es configuradas. Cria uma para usares a An\xE1lise SQL."), sources && sources.map((s) => /* @__PURE__ */ React.createElement("div", { key: s.id, style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 700, fontSize: 14 } }, s.name), /* @__PURE__ */ React.createElement("span", { style: {
    fontSize: 11,
    padding: "2px 8px",
    borderRadius: 999,
    background: VISION_ACCENT + "14",
    color: VISION_ACCENT,
    border: "1px solid " + VISION_ACCENT
  } }, s.engine === "trino" ? "Trino / Presto" : "MSSQL"), !s.is_active && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "inativa"), /* @__PURE__ */ React.createElement("span", { style: {
    fontSize: 12,
    color: "var(--muted)",
    fontFamily: "var(--mono, monospace)"
  } }, s.host, ":", s.port, s.database ? " / " + s.database : "", " \xB7 ", s.username), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement("button", { type: "button", style: visionBtn(false), onClick: () => test(s) }, "Testar"), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: visionBtn(false),
      onClick: () => {
        setMsg(null);
        setForm({ ...s, password: "" });
      }
    },
    "Editar"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...visionBtn(false), color: "var(--danger, #b91c1c)" },
      onClick: () => remove(s)
    },
    "Apagar"
  ))), testMsg[s.id] && /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12,
    fontFamily: "var(--mono, monospace)",
    color: testMsg[s.id].ok ? "var(--success, #15803d)" : "var(--danger, #b91c1c)"
  } }, testMsg[s.id].text))));
}
function VisionSuppliersSettings() {
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: 20,
    maxWidth: 1100
  } }, /* @__PURE__ */ React.createElement(SupplierConfigSection, null), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: "var(--border)" } }), /* @__PURE__ */ React.createElement(SupplierRatingSection, null));
}
function SupplierRatingSection() {
  const [suppliers, setSuppliers] = useState(null);
  const [ratings, setRatings] = useState(null);
  const [drafts, setDrafts] = useState({});
  const [savingId, setSavingId] = useState(null);
  const [msg, setMsg] = useState(null);
  const reload = () => Promise.all([
    window.API.biSupplierLogos(),
    window.API.biSupplierRatings()
  ]).then(([sr, rr]) => {
    const sList = sr.results || sr;
    const rList = rr.results || rr;
    setSuppliers(sList);
    setRatings(rList);
    const byId = Object.fromEntries(rList.map((r) => [r.supplier, r]));
    const initialDrafts = {};
    sList.forEach((s) => {
      initialDrafts[s.id] = byId[s.id] || {
        supplier: s.id,
        iso_9001: false,
        iso_9001_weight: 0,
        iso_14001: false,
        iso_14001_weight: 0,
        chain_of_custody: false,
        chain_of_custody_weight: 0,
        otd_weight: 0,
        claims_weight: 0,
        claims_demerit: 0,
        claims_demerit_mes: 0,
        claims_count: 0,
        qualitative_letter: "A",
        qualitative_weight: 0
      };
    });
    setDrafts(initialDrafts);
  }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  useEffect(() => {
    reload();
  }, []);
  const setField = (sid, key, val) => setDrafts((d) => ({
    ...d,
    [sid]: { ...d[sid], [key]: val }
  }));
  const save = (s) => {
    const draft = drafts[s.id];
    if (!draft) return;
    setSavingId(s.id);
    setMsg(null);
    const existing = ratings.find((r) => r.supplier === s.id);
    const p = existing ? window.API.updateBISupplierRating(existing.id, draft) : window.API.createBISupplierRating(draft);
    p.then(() => {
      reload();
      setMsg({ ok: true, text: `Classifica\xE7\xE3o de "${s.fornecedor}" guardada.` });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setSavingId(null));
  };
  const labelStyle = { fontSize: 11, color: "var(--muted)" };
  const smallInput = {
    ...visionInput,
    padding: "4px 6px",
    fontSize: 12,
    width: "100%"
  };
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 700 } }, "Fornecedores \u2014 classifica\xE7\xE3o"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "Peso e origem dos 4 componentes que definem a letra do fornecedor no PDF.")), msg && /* @__PURE__ */ React.createElement("div", { style: {
    ...visionCard,
    fontSize: 13,
    color: msg.ok ? "var(--success, #15803d)" : "var(--danger, #b91c1c)",
    borderColor: msg.ok ? "#86efac" : "#fca5a5"
  } }, msg.text), !suppliers && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 13 } }, "A carregar\u2026"), suppliers && suppliers.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: "var(--muted)", fontSize: 13 } }, "Cria primeiro fornecedores acima."), suppliers && suppliers.map((s) => {
    const draft = drafts[s.id];
    if (!draft) return null;
    return /* @__PURE__ */ React.createElement("div", { key: s.id, style: { ...visionCard, display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 700, fontSize: 14 } }, s.fornecedor)), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { border: "1px solid var(--border)", borderRadius: 4, padding: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 700, marginBottom: 6 } }, "Certifica\xE7\xF5es"), [
      { chk: "iso_9001", w: "iso_9001_weight", label: "ISO 9001" },
      { chk: "iso_14001", w: "iso_14001_weight", label: "ISO 14001" },
      { chk: "chain_of_custody", w: "chain_of_custody_weight", label: "Chain of Custody" }
    ].map((c) => /* @__PURE__ */ React.createElement("div", { key: c.chk, style: {
      display: "grid",
      gridTemplateColumns: "1fr 60px",
      gap: 4,
      alignItems: "center",
      marginBottom: 4
    } }, /* @__PURE__ */ React.createElement("label", { style: { display: "flex", alignItems: "center", gap: 4, fontSize: 12 } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: draft[c.chk],
        onChange: (e) => setField(s.id, c.chk, e.target.checked)
      }
    ), c.label), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "0.1",
        style: { ...smallInput, textAlign: "right" },
        value: draft[c.w],
        onChange: (e) => setField(s.id, c.w, e.target.value),
        placeholder: "peso %"
      }
    )))), /* @__PURE__ */ React.createElement("div", { style: { border: "1px solid var(--border)", borderRadius: 4, padding: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 700, marginBottom: 6 } }, "OTD Solicitada"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginBottom: 6 } }, "Score vem do YTD."), /* @__PURE__ */ React.createElement("div", { style: labelStyle }, "Peso (%)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "0.1",
        style: smallInput,
        value: draft.otd_weight,
        onChange: (e) => setField(s.id, "otd_weight", e.target.value)
      }
    )), /* @__PURE__ */ React.createElement("div", { style: { border: "1px solid var(--border)", borderRadius: 4, padding: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 700, marginBottom: 6 } }, "Reclama\xE7\xF5es"), /* @__PURE__ */ React.createElement("div", { style: labelStyle }, "Peso (%)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "0.1",
        style: smallInput,
        value: draft.claims_weight,
        onChange: (e) => setField(s.id, "claims_weight", e.target.value)
      }
    ), /* @__PURE__ */ React.createElement("div", { style: { ...labelStyle, marginTop: 4 } }, "Dem\xE9rito por reclama\xE7\xE3o \u2014 YTD (%)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "0.1",
        style: smallInput,
        value: draft.claims_demerit,
        onChange: (e) => setField(s.id, "claims_demerit", e.target.value)
      }
    ), /* @__PURE__ */ React.createElement("div", { style: { ...labelStyle, marginTop: 4 } }, "Dem\xE9rito por reclama\xE7\xE3o \u2014 m\xEAs (%)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "0.1",
        style: smallInput,
        value: draft.claims_demerit_mes,
        onChange: (e) => setField(s.id, "claims_demerit_mes", e.target.value)
      }
    ), /* @__PURE__ */ React.createElement("div", { style: { ...labelStyle, marginTop: 4 } }, "N\xBA de reclama\xE7\xF5es (fallback)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "1",
        style: smallInput,
        value: draft.claims_count,
        onChange: (e) => setField(s.id, "claims_count", e.target.value)
      }
    )), /* @__PURE__ */ React.createElement("div", { style: { border: "1px solid var(--border)", borderRadius: 4, padding: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 700, marginBottom: 6 } }, "Qualitativa"), /* @__PURE__ */ React.createElement("div", { style: labelStyle }, "Letra"), /* @__PURE__ */ React.createElement(
      "select",
      {
        style: smallInput,
        value: draft.qualitative_letter,
        onChange: (e) => setField(s.id, "qualitative_letter", e.target.value)
      },
      /* @__PURE__ */ React.createElement("option", { value: "A" }, "A (100 %)"),
      /* @__PURE__ */ React.createElement("option", { value: "B" }, "B (75 %)"),
      /* @__PURE__ */ React.createElement("option", { value: "C" }, "C (50 %)"),
      /* @__PURE__ */ React.createElement("option", { value: "D" }, "D (25 %)")
    ), /* @__PURE__ */ React.createElement("div", { style: { ...labelStyle, marginTop: 4 } }, "Peso (%)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "0.1",
        style: smallInput,
        value: draft.qualitative_weight,
        onChange: (e) => setField(s.id, "qualitative_weight", e.target.value)
      }
    ))), (() => {
      const wKeys = [
        "iso_9001_weight",
        "iso_14001_weight",
        "chain_of_custody_weight",
        "otd_weight",
        "claims_weight",
        "qualitative_weight"
      ];
      const total = wKeys.reduce(
        (acc, k) => acc + (parseFloat(draft[k]) || 0),
        0
      );
      const rounded = Math.round(total * 10) / 10;
      const ok = Math.abs(rounded - 100) < 0.05;
      return /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap"
      } }, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          style: {
            ...visionBtn(ok),
            opacity: !ok || savingId === s.id ? 0.6 : 1
          },
          disabled: !ok || savingId === s.id,
          onClick: () => save(s)
        },
        savingId === s.id ? "A guardar\u2026" : "Guardar classifica\xE7\xE3o"
      ), /* @__PURE__ */ React.createElement("span", { style: {
        fontSize: 12,
        color: ok ? "var(--success, #15803d)" : "var(--danger, #b91c1c)",
        fontWeight: 600
      } }, "Soma pesos: ", rounded, " % ", ok ? "\u2713" : "\xB7 deve ser 100 %"));
    })());
  }));
}
function VisionServicoSettings() {
  const [rows, setRows] = useState(null);
  const [msg, setMsg] = useState(null);
  const [ref, setRef] = useState("");
  const [descricao, setDescricao] = useState("");
  const [busy, setBusy] = useState(false);
  const reload = () => window.API.biReferenciasExcluidas().then((r) => setRows(r.results || r)).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  useEffect(() => {
    reload();
  }, []);
  const add = () => {
    if (!ref.trim()) return;
    setBusy(true);
    setMsg(null);
    window.API.createBIReferenciaExcluida({ ref: ref.trim(), descricao: descricao.trim() }).then(() => {
      setRef("");
      setDescricao("");
      setMsg({ ok: true, text: "Refer\xEAncia acrescentada." });
      return reload();
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setBusy(false));
  };
  const remove = (r) => {
    if (!window.confirm(`A refer\xEAncia "${r.ref}" volta a contar no servi\xE7o. Continuar?`)) return;
    window.API.deleteBIReferenciaExcluida(r.id).then(reload).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  };
  const [otd, setOtd] = useState(null);
  useEffect(() => {
    window.API.biOtdOpcoes().then(setOtd).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  }, []);
  const mudaOtd = (campo, valor) => {
    setMsg(null);
    window.API.updateBIOtdOpcoes({ [campo]: valor }).then((o) => {
      setOtd(o);
      setMsg({ ok: true, text: "Op\xE7\xE3o do OTD guardada." });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  };
  const [svc, setSvc] = useState(null);
  const [svcErro, setSvcErro] = useState(null);
  useEffect(() => {
    window.API.biServicoOpcoes().then(setSvc).catch((e) => setSvcErro(e.message || String(e)));
  }, []);
  const guardaSvc = (patch) => {
    setSvcErro(null);
    window.API.updateBIServicoOpcoes(patch).then((o) => {
      setSvc(o);
      setMsg({ ok: true, text: "Metas do Servi\xE7o guardadas." });
    }).catch((e) => {
      setSvcErro(e.message || String(e));
    });
  };
  const [motivos, setMotivos] = useState(null);
  const [causasOpc, setCausasOpc] = useState([]);
  const [novoMotivo, setNovoMotivo] = useState("");
  const recarregaMotivos = () => window.API.biMotivosAdiamento().then((r) => setMotivos(r.results || r)).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  useEffect(() => {
    recarregaMotivos();
    window.API.biMotivosAdiamentoCausas().then(setCausasOpc).catch(() => {
    });
  }, []);
  const guardaMotivo = (m, patch) => window.API.updateBIMotivoAdiamento(m.id, patch).then(() => {
    setMsg({ ok: true, text: "Motivo guardado." });
    return recarregaMotivos();
  }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  const addMotivo = () => {
    if (!novoMotivo.trim()) return;
    window.API.createBIMotivoAdiamento({ motivo: novoMotivo.trim() }).then(() => {
      setNovoMotivo("");
      setMsg({ ok: true, text: "Motivo acrescentado." });
      return recarregaMotivos();
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  };
  const removeMotivo = async (m) => {
    if (!await window.hubConfirm({ message: `O motivo "${m.motivo}" deixa de atribuir causa. Continuar?` })) return;
    window.API.deleteBIMotivoAdiamento(m.id).then(recarregaMotivos).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  };
  const NOME_FLUXO = { mercadoria: "Mercadoria", producao: "Produ\xE7\xE3o" };
  const inteiro = (v) => /^\d+$/.test(String(v).trim());
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 14, maxWidth: 800 } }, /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 15 } }, "Metas do Servi\xE7o (dias por etapa)"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "Quantos dias cada etapa deve levar. Uma etapa que passe da meta conta como excesso no diagn\xF3stico das linhas (causa do atraso e estado das abertas)."), svcErro && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--danger, #c0392b)", fontSize: 12 } }, svcErro), svc && Object.keys(svc.etapas).map((fluxo) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: fluxo,
      "data-testid": `metas-${fluxo}`,
      style: { display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }
    },
    /* @__PURE__ */ React.createElement("div", { style: { width: 90, fontWeight: 600, fontSize: 13, paddingBottom: 6 } }, NOME_FLUXO[fluxo] || fluxo),
    svc.etapas[fluxo].map((et) => /* @__PURE__ */ React.createElement(Field, { key: et.key, label: et.label }, /* @__PURE__ */ React.createElement(
      "input",
      {
        style: { ...visionInput, width: 80 },
        type: "number",
        min: "0",
        step: "1",
        defaultValue: svc.metas[fluxo]?.[et.key],
        "aria-label": `${NOME_FLUXO[fluxo] || fluxo} \u2014 ${et.label} (dias)`,
        onBlur: (e) => {
          const v = e.target.value;
          if (!inteiro(v)) {
            setSvcErro("Os dias s\xE3o um inteiro \u2265 0.");
            return;
          }
          if (Number(v) === svc.metas[fluxo]?.[et.key]) return;
          guardaSvc({ metas: { [fluxo]: { [et.key]: Number(v) } } });
        }
      }
    )))
  )), svc && /* @__PURE__ */ React.createElement(Field, { label: "Sem movimento (dias)" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: { ...visionInput, width: 80 },
      type: "number",
      min: "1",
      step: "1",
      defaultValue: svc.sem_movimento_dias,
      "aria-label": "Sem movimento (dias)",
      onBlur: (e) => {
        const v = e.target.value;
        if (!inteiro(v)) {
          setSvcErro("Os dias s\xE3o um inteiro \u2265 1.");
          return;
        }
        if (Number(v) === svc.sem_movimento_dias) return;
        guardaSvc({ sem_movimento_dias: Number(v) });
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 4 } }, "Uma linha aberta com a data solicitada h\xE1 mais dias do que isto sai do diagn\xF3stico de Servi\xE7o (lista, contadores, blocos e fotografia)."))), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 }, "data-testid": "motivos-adiamento" }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 15 } }, "Motivos de adiamento"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "Cada motivo de adiamento do PHC atribui uma causa \xE0 linha atrasada. \xABNova data \xE9 a de refer\xEAncia\xBB \xE9 o adiamento a pedido do cliente: a entrega at\xE9 \xE0 nova data conta a tempo. Um motivo que n\xE3o esteja aqui mostra-se no diagn\xF3stico mas n\xE3o muda a causa."), motivos && motivos.map((m) => /* @__PURE__ */ React.createElement("div", { key: m.id, style: { display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600, fontSize: 13, minWidth: 230 } }, m.motivo), /* @__PURE__ */ React.createElement(
    "select",
    {
      style: visionInput,
      value: m.causa,
      "aria-label": `Causa de \xAB${m.motivo}\xBB`,
      onChange: (e) => guardaMotivo(m, { causa: e.target.value })
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "(s\xF3 mostra)"),
    causasOpc.map((c) => /* @__PURE__ */ React.createElement("option", { key: c.key, value: c.key }, c.label, " \u2014 ", c.responsavel))
  ), /* @__PURE__ */ React.createElement("label", { style: { fontSize: 12, display: "inline-flex", gap: 4, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!m.muda_data,
      onChange: (e) => guardaMotivo(m, { muda_data: e.target.checked })
    }
  ), "Nova data \xE9 a de refer\xEAncia"), /* @__PURE__ */ React.createElement("button", { type: "button", style: {
    ...visionBtn(false),
    marginLeft: "auto",
    color: "var(--danger, #b91c1c)"
  }, onClick: () => removeMotivo(m) }, "Apagar"))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement(Field, { label: "Novo motivo" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: novoMotivo,
      placeholder: "tal como no PHC",
      onChange: (e) => setNovoMotivo(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") addMotivo();
      }
    }
  )), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: visionBtn(true),
      disabled: !novoMotivo.trim(),
      onClick: addMotivo
    },
    "Acrescentar"
  ))), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 6 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 15 } }, "OTD data confirmada"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "Valor por omiss\xE3o dos interruptores do dashboard de Fornecedores. O PDF por fornecedor e o rating seguem sempre estas op\xE7\xF5es."), otd && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { style: { fontSize: 13, display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!otd.so_com_data_confirmada,
      onChange: (e) => mudaOtd("so_com_data_confirmada", e.target.checked)
    }
  ), "S\xF3 com data confirmada (as linhas sem data confirmada n\xE3o entram no total)"), /* @__PURE__ */ React.createElement("label", { style: { fontSize: 13, display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!otd.d1_a_tempo,
      onChange: (e) => mudaOtd("d1_a_tempo", e.target.checked)
    }
  ), "D+1 conta a tempo (entrega no dia seguinte \xE0 data confirmada n\xE3o \xE9 atraso)"))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 15 } }, "Refer\xEAncias fora do servi\xE7o"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", marginTop: 4 } }, "Artigos que n\xE3o s\xE3o servi\xE7o do fornecedor/cliente (portes, STC\u2026). Deixam de contar em todos os KPIs, gr\xE1ficos e tabelas dos dashboards de Servi\xE7o de Fornecedores e de Vendas, no PDF por fornecedor e no rating. A compara\xE7\xE3o ignora espa\xE7os nas pontas.")), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", gap: 8, alignItems: "flex-end", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(Field, { label: "Refer\xEAncia" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: ref,
      placeholder: "ex. 71500010",
      onChange: (e) => setRef(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") add();
      }
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Descri\xE7\xE3o (opcional)" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: visionInput,
      value: descricao,
      placeholder: "ex. PORTES",
      onChange: (e) => setDescricao(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") add();
      }
    }
  )), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...visionBtn(true), opacity: busy ? 0.6 : 1 },
      disabled: busy || !ref.trim(),
      onClick: add
    },
    "Acrescentar"
  )), msg && /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12,
    color: msg.ok ? "var(--success, #15803d)" : "var(--danger, #b91c1c)"
  } }, msg.text), !rows && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 13 } }, "A carregar\u2026"), rows && rows.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, color: "var(--muted)", fontSize: 13 } }, "Lista vazia: todas as refer\xEAncias contam."), rows && rows.map((r) => /* @__PURE__ */ React.createElement("div", { key: r.id, style: { ...visionCard, display: "flex", alignItems: "center", gap: 10 } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 700, fontFamily: "var(--mono, monospace)" } }, r.ref), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, r.descricao), /* @__PURE__ */ React.createElement("button", { type: "button", style: {
    ...visionBtn(false),
    marginLeft: "auto",
    color: "var(--danger, #b91c1c)"
  }, onClick: () => remove(r) }, "Apagar"))));
}
Object.assign(window, { VisionSettings, VisionSuppliersSettings, VisionServicoSettings });
const MESA_LISTAS = [
  ["utilizadores_excluidos", "Utilizadores internos exclu\xEDdos", "Valores de bo.inome que N\xC3O contam na angaria\xE7\xE3o. Pode ficar vazia."],
  ["tabelas", "Tipos de tabela que contam", "Valores de bo.tabela2. Pelo menos um."],
  ["familias", "Fam\xEDlias que contam", "Valores de st.familia. Pelo menos uma."]
];
function VisionMesaSettings() {
  const [opc, setOpc] = useState(null);
  const [texto, setTexto] = useState({});
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    window.API.biMesaOpcoes().then((o) => {
      setOpc(o);
      setTexto(Object.fromEntries(MESA_LISTAS.map(([k]) => [k, (o[k] || []).join("\n")])));
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  }, []);
  const guarda = (k) => {
    setBusy(true);
    setMsg(null);
    const lista = texto[k].split("\n").map((v) => v.trim()).filter(Boolean);
    window.API.updateBIMesaOpcoes({ [k]: lista }).then((o) => {
      setOpc(o);
      setMsg({ ok: true, text: "Regra da Mesa guardada. A pr\xF3xima leitura j\xE1 a aplica." });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) })).finally(() => setBusy(false));
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 14, maxWidth: 800 } }, msg && /* @__PURE__ */ React.createElement("div", { style: { color: msg.ok ? "#15803d" : "#b91c1c", fontSize: 13 } }, msg.text), !opc && !msg && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), opc && MESA_LISTAS.map(([k, titulo, ajuda]) => /* @__PURE__ */ React.createElement("div", { key: k, style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 15 } }, titulo), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, ajuda, " Um valor por linha, tal como est\xE1 no PHC."), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      rows: Math.max(3, (texto[k] || "").split("\n").length),
      style: { ...visionInput, fontFamily: "inherit" },
      value: texto[k] || "",
      onChange: (e) => setTexto({ ...texto, [k]: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "button", style: visionBtn(true), disabled: busy, onClick: () => guarda(k) }, "Guardar")))), /* @__PURE__ */ React.createElement(VisionMesaObjetivos, null), /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, fontSize: 13, color: "var(--muted)" } }, "As refer\xEAncias que n\xE3o contam na angaria\xE7\xE3o s\xE3o a lista de ", /* @__PURE__ */ React.createElement("b", null, "refer\xEAncias fora do servi\xE7o"), "(Configura\xE7\xF5es \u2192 Servi\xE7o), a mesma dos dashboards de servi\xE7o. A angaria\xE7\xE3o da Mesa exclui por isso tamb\xE9m STC e STC-TV, que o painel do Superset n\xE3o exclu\xEDa."));
}
const MESA_MESES_OBJ = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
function VisionMesaObjetivos() {
  const [ano, setAno] = useState((/* @__PURE__ */ new Date()).getFullYear());
  const [dados, setDados] = useState(null);
  const [texto, setTexto] = useState({});
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    setDados(null);
    window.API.biMesaObjetivos(ano).then((d) => {
      setDados(d);
      const t = {};
      Object.entries(d.objetivos).forEach(([ind, meses]) => Object.entries(meses).forEach(([m, v]) => {
        t[`${ind}|${m}`] = String(v).replace(".", ",");
      }));
      setTexto(t);
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  }, [ano]);
  const guarda = (ind, mes) => {
    const k = `${ind}|${mes}`;
    const cru = (texto[k] || "").trim().replace(/\s/g, "").replace(",", ".");
    const valor = cru === "" ? null : Number(cru);
    if (valor !== null && !Number.isFinite(valor)) {
      setMsg({ ok: false, text: `\xAB${texto[k]}\xBB n\xE3o \xE9 um n\xFAmero.` });
      return;
    }
    const atual = dados.objetivos[ind] && dados.objetivos[ind][mes];
    if (valor === null && atual == null || valor === atual) return;
    window.API.setBIMesaObjetivo({ indicador: ind, mes, valor }).then(() => {
      setDados((d) => {
        const meses = { ...d.objetivos[ind] || {} };
        if (valor === null) delete meses[mes];
        else meses[mes] = valor;
        return { ...d, objetivos: { ...d.objetivos, [ind]: meses } };
      });
      setMsg({ ok: true, text: "Objetivo guardado." });
    }).catch((e) => setMsg({ ok: false, text: e.message || String(e) }));
  };
  return /* @__PURE__ */ React.createElement("div", { style: { ...visionCard, display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center" } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 15 } }, "Objetivos por indicador e m\xEAs"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("button", { type: "button", style: visionBtn(false), "aria-label": "Ano anterior", onClick: () => setAno(ano - 1) }, "\u2039"), /* @__PURE__ */ React.createElement("b", null, ano), /* @__PURE__ */ React.createElement("button", { type: "button", style: visionBtn(false), "aria-label": "Ano seguinte", onClick: () => setAno(ano + 1) }, "\u203A"))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "Na unidade do indicador (euros, para a fatura\xE7\xE3o e a angaria\xE7\xE3o). Um m\xEAs em branco fica sem objetivo e o cart\xE3o da Mesa mostra \xABObjetivo: \u2014\xBB. Grava ao sair do campo."), msg && /* @__PURE__ */ React.createElement("div", { style: { color: msg.ok ? "#15803d" : "#b91c1c", fontSize: 13 } }, msg.text), !dados && !msg && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), dados && dados.indicadores.map((i) => /* @__PURE__ */ React.createElement("div", { key: i.id }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 600, fontSize: 13, margin: "6px 0 4px" } }, i.titulo), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))", gap: 8 } }, MESA_MESES_OBJ.map((nome, n) => {
    const mes = `${dados.ano}-${String(n + 1).padStart(2, "0")}`;
    const k = `${i.id}|${mes}`;
    return /* @__PURE__ */ React.createElement("label", { key: mes, style: { fontSize: 11, color: "var(--muted)", display: "flex", flexDirection: "column", gap: 2 } }, nome, /* @__PURE__ */ React.createElement(
      "input",
      {
        style: visionInput,
        inputMode: "decimal",
        "aria-label": `${i.titulo} ${mes}`,
        value: texto[k] || "",
        onChange: (e) => setTexto({ ...texto, [k]: e.target.value }),
        onBlur: () => guarda(i.id, mes)
      }
    ));
  })))));
}
window.VisionMesaSettings = VisionMesaSettings;

// ===== bi/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "bi",
  order: 4,
  name: "VISION",
  sub: "Business Intelligence",
  accent: "#1e3a5f",
  brandLogo: "/static/assets/vision-logo.png?v=2",
  brandEmoji: "\u{1F989}",
  brandEmojiFontSize: "26px",
  home: "bi_fornecedores",
  launcher: true,
  frontendFiles: [
    "_shared/frontend/data.jsx",
    "_shared/frontend/charts.jsx",
    "dashboard_vendas/frontend/view.jsx",
    "fornecedores/frontend/view.jsx",
    "vendas/frontend/view.jsx",
    "servico_linhas/frontend/comum.jsx",
    "servico_linhas/frontend/hoje.jsx",
    "servico_linhas/frontend/causas.jsx",
    "servico_linhas/frontend/operacoes.jsx",
    "servico_linhas/frontend/risco.jsx",
    "servico_linhas/frontend/drawer.jsx",
    "servico_linhas/frontend/filtros.jsx",
    "servico_linhas/frontend/view.jsx",
    "sql/frontend/view.jsx",
    "mesa/frontend/puros.jsx",
    "mesa/frontend/view.jsx",
    "settings/frontend/view.jsx"
  ],
  routes: [
    { id: "bi", section: "An\xE1lise", icon: "dashboard", label: "Dashboard de Vendas", adminOnly: false, scoped: true, title: "VISION \u2014 Dashboard de Vendas", tooltip: "Dashboard de Vendas" },
    { id: "bi_fornecedores", section: "An\xE1lise", icon: "ranking", label: "Servi\xE7o de Fornecedores de Cart\xE3o", adminOnly: false, scoped: true, title: "VISION \u2014 Servi\xE7o de Fornecedores de Cart\xE3o", tooltip: "KPIs de servi\xE7o dos fornecedores de cart\xE3o" },
    { id: "bi_vendas", section: "An\xE1lise", icon: "ranking", label: "Servi\xE7o de Vendas", adminOnly: false, scoped: true, title: "VISION \u2014 Servi\xE7o de Vendas", tooltip: "KPIs de servi\xE7o de vendas" },
    { id: "bi_servico_linhas", section: "An\xE1lise", icon: "ranking", label: "Servi\xE7o \u2014 diagn\xF3stico", adminOnly: false, scoped: true, title: "VISION \u2014 Servi\xE7o \u2014 diagn\xF3stico", tooltip: "Onde falha o servi\xE7o: etapas, causas e estado de cada linha de encomenda" },
    { id: "bi_sql", section: "An\xE1lise", icon: "search", label: "An\xE1lise SQL", adminOnly: false, scoped: true, title: "VISION \u2014 An\xE1lise SQL", tooltip: "An\xE1lise explorat\xF3ria SQL (Trino/Presto, MSSQL)" },
    { id: "bi_mesa", section: "Administra\xE7\xE3o", icon: "dashboard", label: "Mesa", adminOnly: false, scoped: true, title: "VISION \u2014 Mesa da administra\xE7\xE3o", tooltip: "Os indicadores de topo da reuni\xE3o mensal: m\xEAs fechado, anterior e hom\xF3logo" },
    { id: "bi_admin", section: "Configura\xE7\xF5es", icon: "cog", label: "Liga\xE7\xF5es a fontes de dados", adminOnly: true, title: "VISION \u2014 Liga\xE7\xF5es a fontes de dados", tooltip: "Liga\xE7\xF5es Trino/Presto e MSSQL" },
    { id: "bi_admin_fornecedores", section: "Configura\xE7\xF5es", icon: "ranking", label: "Fornecedores", adminOnly: true, title: "VISION \u2014 Configura\xE7\xF5es de Fornecedores", tooltip: "Imagem, emails, envio mensal e classifica\xE7\xE3o" },
    { id: "bi_admin_servico", section: "Configura\xE7\xF5es", icon: "cog", label: "Servi\xE7o", adminOnly: true, title: "VISION \u2014 Refer\xEAncias fora do servi\xE7o", tooltip: "Refer\xEAncias (portes, STC\u2026) que n\xE3o contam nos dashboards de servi\xE7o" },
    { id: "bi_admin_mesa", section: "Configura\xE7\xF5es", icon: "cog", label: "Mesa", adminOnly: true, title: "VISION \u2014 Regras da Mesa", tooltip: "Utilizadores, tabelas e fam\xEDlias que contam na angaria\xE7\xE3o" }
  ],
  render: {
    bi: () => React.createElement(window.VisionView),
    bi_fornecedores: () => React.createElement(window.FornecedoresView),
    bi_vendas: () => React.createElement(window.VendasView),
    bi_servico_linhas: () => React.createElement(window.ServicoLinhasView),
    bi_sql: () => React.createElement(window.VisionQuery),
    bi_mesa: () => React.createElement(window.VisionMesaView),
    bi_admin: () => React.createElement(window.VisionSettings),
    bi_admin_fornecedores: () => React.createElement(window.VisionSuppliersSettings),
    bi_admin_servico: () => React.createElement(window.VisionServicoSettings),
    bi_admin_mesa: () => React.createElement(window.VisionMesaSettings)
  }
});

// ===== cargoplanner/frontend/cargoplanner_api.js =====
(function() {
  function cookie(nome) {
    const m = document.cookie.match("(^|;)\\s*" + nome + "\\s*=\\s*([^;]+)");
    return m ? m.pop() : "";
  }
  const LIGACAO = function() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
    } catch (_) {
    }
    return "lig-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }();
  async function req(caminho, { params, method = "GET", body, keepalive } = {}) {
    let url = caminho;
    if (params) {
      const q = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v !== void 0 && v !== null && v !== "") q.append(k, v);
      });
      const s = q.toString();
      if (s) url += (url.includes("?") ? "&" : "?") + s;
    }
    const resp = await fetch(url, {
      method,
      credentials: "same-origin",
      // `keepalive` deixa o pedido terminar DEPOIS de a página morrer — é o
      // que salva a última alteração quando se fecha o separador.
      ...keepalive ? { keepalive: true } : {},
      headers: {
        "X-CSRFToken": cookie("csrftoken"),
        // Vai em TODOS os pedidos, não só nos que hoje publicam um evento:
        // é o único sítio por onde esta app fala com o servidor, e o dia em
        // que uma escrita nova passar a publicar já vai identificada. Numa
        // leitura não custa nada — o servidor só lê o cabeçalho onde publica.
        "X-CP-Ligacao": LIGACAO,
        ...body ? { "Content-Type": "application/json" } : {}
      },
      ...body ? { body: JSON.stringify(body) } : {}
    });
    let corpo = null;
    try {
      corpo = await resp.json();
    } catch (_) {
      corpo = null;
    }
    if (!resp.ok) {
      const err = new Error(corpo && (corpo.detail || corpo.erro) || `HTTP ${resp.status}`);
      err.status = resp.status;
      err.corpo = corpo;
      throw err;
    }
    return corpo;
  }
  function errosDeCampo(corpo) {
    if (!corpo || typeof corpo !== "object" || Array.isArray(corpo)) return "";
    const frases = [];
    Object.keys(corpo).forEach((chave) => {
      if (chave === "detail") return;
      const v = corpo[chave];
      if (typeof v === "string") {
        if (v) frases.push(v);
        return;
      }
      if (Array.isArray(v)) v.forEach((x) => {
        if (typeof x === "string" && x) frases.push(x);
      });
    });
    return frases.join(" ");
  }
  function erroMensagem(err, fallback) {
    const corpo = err && err.corpo;
    if (corpo && corpo.detail) return corpo.detail;
    const campos = errosDeCampo(corpo);
    if (campos) return campos;
    if (err && err.message) return err.message;
    return fallback || "N\xE3o foi poss\xEDvel falar com o servidor.";
  }
  function erroTransitorio(err) {
    const status = err && err.status;
    if (status == null) return true;
    if (status === 408 || status === 429) return true;
    return status < 400 || status >= 500;
  }
  const B = "/api/cargoplanner";
  window.CargoplannerAPI = {
    // O id deste separador (ver o `const LIGACAO`, no topo). Exposto porque
    // é contra ele que quem recebe um evento do socket compara o `origem`
    // para saber se é o eco da sua própria gravação.
    ligacao: LIGACAO,
    // Os dias que não são de trabalho (#102). Leem-se uma vez — mudam duas
    // vezes por ano — e a marca do ecrã sai de `cpDiaUtil`.
    feriados: () => req(`${B}/feriados/`),
    feriadoCriar: (corpo) => req(`${B}/feriados/`, { method: "POST", body: corpo }),
    feriadoGuardar: (id, corpo) => req(`${B}/feriados/${id}/`, { method: "PUT", body: corpo }),
    feriadoApagar: (id) => req(`${B}/feriados/${id}/`, { method: "DELETE" }),
    entregas: (dia) => req(`${B}/entregas/`, { params: { dia } }),
    // **O «já atribuído», à parte da leitura do ERP** (#101). Aquela demora
    // ~50 s e só se relê quando muda a data das ENTREGAS; isto é um agregado
    // sobre `CargaLinha` — medido, 0,043 s —, e relê-se a cada gravação de
    // carga e ao mudar de dia. POST porque os bistamps da janela não cabem
    // com jeito num query string, e um GET de TUDO cresceria sem limite.
    atribuido: (bistamps) => req(
      `${B}/atribuido/`,
      { method: "POST", body: { bistamps: bistamps || [] } }
    ),
    guardarLinha: (bistamp, dados) => req(
      `${B}/entregas/${encodeURIComponent(bistamp)}/`,
      { method: "PUT", body: dados }
    ),
    // ---------------------------------------------------------- recolhas
    // Clientes do PHC para escolher uma paragem de recolha, e o geocoder para
    // uma morada escrita à mão.
    clientes: (q) => req(`${B}/clientes/`, { params: { q } }),
    geocodificar: (dados) => req(`${B}/geocodificar/`, { method: "POST", body: dados }),
    // O que uma etiqueta é, a partir do lote — a consulta que a Receção já
    // tinha (`rececao_picar.jsx`), agora também no tablet do operador
    // (`ondas_operador_etiqueta.jsx`). Passa pela impressora escolhida do
    // utilizador (é ela que diz a empresa/ERP), tal como na Receção.
    etiqueta: (lote) => req(`${B}/etiqueta/`, { params: { lote } }),
    // Aloca um lote de etiquetas a uma localização — escreve no PHC
    // (`AlocarView`, Task 3). `dados` = {codigos, local, empresa}; a empresa
    // vai SEMPRE explícita (ver `OndOpAlocar`, `ondas_operador_etiqueta.jsx`).
    alocar: (dados) => req(`${B}/alocar/`, { method: "POST", body: dados }),
    // Fornecedores do PHC, para ligar uma transportadora do hub ao `fl`. É
    // o número deles que a carga criada no ERP leva — e os nomes não casam
    // com os do hub, por isso escolhe-se da lista, não se adivinha.
    fornecedoresPhc: (q) => req(`${B}/fornecedores-phc/`, { params: { q } }),
    // Os motivos com que uma carga é criada no PHC (vocabulário editável).
    motivosCarga: () => req(`${B}/motivos-carga/`),
    artigosNaoCarga: () => req(`${B}/artigos-nao-carga/`),
    criarArtigoNaoCarga: (d) => req(`${B}/artigos-nao-carga/`, { method: "POST", body: d }),
    guardarArtigoNaoCarga: (id, d) => req(`${B}/artigos-nao-carga/${id}/`, { method: "PUT", body: d }),
    apagarArtigoNaoCarga: (id) => req(`${B}/artigos-nao-carga/${id}/`, { method: "DELETE" }),
    // Os períodos do dia (Definições → Vocabulários) — os grupos da coluna
    // dos camiões. A LEITURA é do quadro, não só de Definições.
    periodos: () => req(`${B}/periodos-dia/`),
    criarPeriodo: (d) => req(`${B}/periodos-dia/`, { method: "POST", body: d }),
    guardarPeriodo: (id, d) => req(`${B}/periodos-dia/${id}/`, { method: "PUT", body: d }),
    apagarPeriodo: (id) => req(`${B}/periodos-dia/${id}/`, { method: "DELETE" }),
    // **Mover a carga de camião ou de dia.** Endpoint próprio e não um
    // PATCH: é o servidor que sabe que viagens já estão ocupadas naquele
    // camião nesse dia, e é ele que faz a carga virar 2ª viagem em vez de
    // bater no `unique_together`. Devolve a carga como ficou, mais o que
    // aconteceu à onda de preparação.
    moverCarga: (id, dados) => req(
      `${B}/cargas/${id}/mover/`,
      { method: "POST", body: dados }
    ),
    // **Lança no picking do PHC** (dossier 82). Escrita irreversível e
    // endpoint próprio, como a criação da carga: os lotes gravam-se a cada
    // leitura do scanner, e isto não pode ir à boleia desse autosave.
    //
    // **Um corpo vazio (`{}`) quer dizer «lança tudo o que falta desta
    // tarefa».** É assim que o «Concluir» a chama — o `codigo` não é
    // obrigatório; com ele, lança só essa palete (409 se já estiver
    // lançada).
    lancarPickingNoPhc: (tarefaId, dados) => req(
      `${B}/tarefas/${tarefaId}/picking-phc/`,
      { method: "POST", body: dados }
    ),
    // **O que está preso, e em nome de quem** (cartão #131). A reserva
    // existe porque a linha do dossier 82 não desconta o stock da palete —
    // é o hub que sabe, sozinho, quanto de cada palete já está na mão de
    // alguém. Devolve `{reservas, cobertura}`.
    //
    // Os filtros recortam as LINHAS; a cobertura vem sempre da operação
    // inteira (ver `todas_as_reservas`). Sem filtro é a lista de curadoria,
    // e aí o recurso de acesso é outro — por isso o ecrã de Definições
    // chama-a sem argumentos e os blocos chamam-na com.
    reservasDePalete: (filtros) => req(
      `${B}/reservas-de-palete/`,
      { params: filtros || {} }
    ),
    // **Devolve uma palete ao armazém.** Endpoint próprio e não um PATCH
    // dos lotes: eles gravam-se a cada leitura do scanner. Uma palete por
    // lançar é apagada; uma já lançada fica carimbada e deixa de reservar —
    // a linha do PHC não se desfaz por aqui.
    largarReserva: (tarefaId, codigo) => req(
      `${B}/tarefas/${tarefaId}/largar-reserva/`,
      { method: "POST", body: { codigo } }
    ),
    // **Cria a carga no PHC** — escrita irreversível, endpoint próprio, e
    // nunca à boleia do autosave da carga. O servidor recusa o segundo
    // envio com 409.
    criarCargaNoPhc: (id, dados) => req(
      `${B}/cargas/${id}/phc/`,
      { method: "POST", body: dados }
    ),
    // Confirma onde uma localização é, antes de alocar (Task 5) —
    // `LocalizacaoView`, a mesma validação que `AlocarView` aplica na
    // escrita, aqui só de leitura. `encontrado: false` é resposta legítima
    // (código mal lido, ou sítio por acrescentar a `u_locais_arm`), nunca
    // um erro.
    localizacao: (codigo, empresa) => req(
      `${B}/localizacao/`,
      { params: { codigo, empresa } }
    ),
    // Onde está o stock de uma referência — código de etiqueta, referência
    // ou designação, por FIFO (Task 6, `StockView`). A empresa é inferida
    // no servidor (como em `etiqueta`), nunca escolhida aqui. Devolve
    // `{sugestoes, linhas, cortou}` — a mesma procura serve as duas coisas
    // (ver `erp_stock.py`).
    procurarStock: (q) => req(`${B}/stock/`, { params: { q } }),
    // Quanto há de uma referência em cada armazém da operação, e quanto dela
    // está reservado a clientes / encomendado a fornecedores
    // (`StockPorArmazemView`). A empresa é opcional — o tablet manda a que
    // veio com a etiqueta lida, para não somar stock da base errada.
    stockPorArmazem: (ref, empresa) => req(
      `${B}/stock/armazens/`,
      { params: { ref, empresa } }
    ),
    // ------------------------------------------------ vocabulários (config)
    // Listas de rótulo puro: vivem em tabelas, não no código. Ver
    // "Configurable vocabularies policy" no CLAUDE.md da raiz.
    categorias: () => req(`${B}/categorias-tir/`),
    criarCategoria: (d) => req(`${B}/categorias-tir/`, { method: "POST", body: d }),
    guardarCategoria: (id, d) => req(`${B}/categorias-tir/${id}/`, { method: "PUT", body: d }),
    apagarCategoria: (id) => req(`${B}/categorias-tir/${id}/`, { method: "DELETE" }),
    descargas: () => req(`${B}/tipos-descarga/`),
    criarDescarga: (d) => req(`${B}/tipos-descarga/`, { method: "POST", body: d }),
    guardarDescarga: (id, d) => req(`${B}/tipos-descarga/${id}/`, { method: "PUT", body: d }),
    apagarDescarga: (id) => req(`${B}/tipos-descarga/${id}/`, { method: "DELETE" }),
    motivosUrgencia: () => req(`${B}/motivos-urgencia/`),
    criarMotivoUrgencia: (d) => req(`${B}/motivos-urgencia/`, { method: "POST", body: d }),
    guardarMotivoUrgencia: (id, d) => req(`${B}/motivos-urgencia/${id}/`, { method: "PUT", body: d }),
    apagarMotivoUrgencia: (id) => req(`${B}/motivos-urgencia/${id}/`, { method: "DELETE" }),
    // Os motivos com que uma carga é criada no PHC — a LEITURA é do modal
    // de «Preparada» (quem planeia), a escrita é de Definições.
    criarMotivoCarga: (d) => req(`${B}/motivos-carga/`, { method: "POST", body: d }),
    guardarMotivoCarga: (id, d) => req(`${B}/motivos-carga/${id}/`, { method: "PUT", body: d }),
    apagarMotivoCarga: (id) => req(`${B}/motivos-carga/${id}/`, { method: "DELETE" }),
    // Os cais do armazém — onde uma carga se monta. `?ativos=1` é o que o
    // hero da carga pede: curar a lista é de Definições, escolher um é de
    // quem planeia, e um cais desativado não se escolhe.
    cais: (opts) => req(`${B}/cais/`, { params: opts }),
    criarCais: (d) => req(`${B}/cais/`, { method: "POST", body: d }),
    guardarCais: (id, d) => req(`${B}/cais/${id}/`, { method: "PUT", body: d }),
    apagarCais: (id) => req(`${B}/cais/${id}/`, { method: "DELETE" }),
    // As bases do ERP (PHC). Um cais guarda-se COM a base — a `u_locais_arm`
    // é por PHC, e o mesmo código pode ser outro sítio na outra base.
    empresas: () => req(`${B}/empresas/`),
    // Procurar localizações do armazém para CURAR a lista de cais. A
    // `localizacao()` acima responde «este código existe?»; isto responde
    // «quais é que há?» — duas letras no mínimo, e a base é obrigatória.
    locaisArm: (q, empresa) => req(`${B}/locais-arm/`, { params: { q, empresa } }),
    // As unidades industriais: a origem e o regresso de uma carga (RF04).
    unidades: (opts) => req(`${B}/unidades/`, { params: opts }),
    criarUnidade: (d) => req(`${B}/unidades/`, { method: "POST", body: d }),
    guardarUnidade: (id, d) => req(`${B}/unidades/${id}/`, { method: "PUT", body: d }),
    apagarUnidade: (id) => req(`${B}/unidades/${id}/`, { method: "DELETE" }),
    // Os dois parâmetros do tempo de preparação (minutos/palete, mínimo por
    // linha) — singleton, sem lista. A LEITURA é pedida pelo cabeçalho da
    // carga (quadro de planeamento) e pela geração da onda; a ESCRITA vive
    // em Definições → «Turnos e armazéns».
    parametrosPreparacao: () => req(`${B}/parametros-preparacao/`),
    guardarParametrosPreparacao: (d) => req(
      `${B}/parametros-preparacao/`,
      { method: "PUT", body: d }
    ),
    // ------------------------------------------- o pessoal das ondas
    // Os catálogos de onde (armazéns) e de vocabulário (turnos/competências),
    // mais as fichas e a escala.
    armazens: () => req(`${B}/armazens/`),
    criarArmazem: (d) => req(`${B}/armazens/`, { method: "POST", body: d }),
    guardarArmazem: (id, d) => req(`${B}/armazens/${id}/`, { method: "PUT", body: d }),
    apagarArmazem: (id) => req(`${B}/armazens/${id}/`, { method: "DELETE" }),
    turnos: () => req(`${B}/turnos/`),
    criarTurno: (d) => req(`${B}/turnos/`, { method: "POST", body: d }),
    guardarTurno: (id, d) => req(`${B}/turnos/${id}/`, { method: "PUT", body: d }),
    apagarTurno: (id) => req(`${B}/turnos/${id}/`, { method: "DELETE" }),
    competencias: () => req(`${B}/competencias/`),
    criarCompetencia: (d) => req(`${B}/competencias/`, { method: "POST", body: d }),
    guardarCompetencia: (id, d) => req(`${B}/competencias/${id}/`, { method: "PUT", body: d }),
    apagarCompetencia: (id) => req(`${B}/competencias/${id}/`, { method: "DELETE" }),
    operadores: () => req(`${B}/operadores/`),
    criarOperador: (d) => req(`${B}/operadores/`, { method: "POST", body: d }),
    guardarOperador: (id, d) => req(`${B}/operadores/${id}/`, { method: "PUT", body: d }),
    apagarOperador: (id) => req(`${B}/operadores/${id}/`, { method: "DELETE" }),
    // Candidatos a nova ficha: a pool app-scoped do hub
    // (`packages/hub_shell/features/atribuicoes`), não `/api/users/` — esse é
    // do Stock Reborn (`app_label='stockreborn'`) e nenhum dos três perfis
    // da logística tem regra nenhuma nessa app: dava 403 a quem só usa a
    // Cargo Planner. `is_active`/`app_label` não são parâmetro aqui — o
    // endpoint já devolve só quem tem acesso à própria app.
    candidatosOperador: () => req("/api/atribuicoes/cargoplanner/assignable/"),
    // O ENVELOPE do dia: pessoas resolvidas + turnos + competências. Um
    // pedido e um estado de carregamento, em vez de três.
    operadoresDoDia: (dia) => req(`${B}/operadores/`, { params: { dia } }),
    // A escala endereça-se por (operador, dia), não por pk.
    escala: (de, ate) => req(`${B}/escala/`, { params: { de, ate } }),
    guardarEscala: (d) => req(`${B}/escala/`, { method: "PUT", body: d }),
    apagarEscala: (operador, dia) => req(`${B}/escala/`, {
      method: "DELETE",
      params: { operador, dia }
    }),
    // ------------------------------------------------------------ ondas
    // O planeamento operacional deixou de morrer no F5. Uma onda leva as
    // tarefas NESTED (POST/PUT), substituídas por inteiro a cada gravação —
    // como as linhas de uma `Carga`. Um PATCH que não repita `tarefas` não
    // as apaga: é por isso que atribuir/reordenar uma onda usa PATCH e não
    // PUT (reenviar a onda inteira a cada arrasto reescrevia as tarefas e
    // apagava, de caminho, o tempo real que o operador já tivesse
    // registado).
    ondas: (dia) => req(`${B}/ondas/`, { params: { dia } }),
    // O PERÍODO, para o dashboard de desempenho. Medir uma pessoa num dia só
    // não é medir — e é por isso que este endpoint filtra por intervalo em
    // vez de o cliente pedir dia a dia.
    ondasNoPeriodo: (de, ate) => req(`${B}/ondas/`, { params: { de, ate } }),
    // As que estão à espera de dono, num período ou em todo o histórico —
    // é o que a lista de «Ondas disponíveis» mostra. O filtro é do SERVIDOR
    // (`?sem_pessoa=1`) e não do cliente: com o âmbito «Todas» por omissão,
    // filtrar cá obrigava a trazer o histórico inteiro com as tarefas todas
    // para deitar fora quase tudo.
    ondasSemDono: (de, ate) => req(
      `${B}/ondas/`,
      { params: { de, ate, sem_pessoa: 1 } }
    ),
    criarOnda: (d) => req(`${B}/ondas/`, { method: "POST", body: d }),
    guardarOnda: (id, d) => req(`${B}/ondas/${id}/`, { method: "PATCH", body: d }),
    apagarOnda: (id) => req(`${B}/ondas/${id}/`, { method: "DELETE" }),
    // Arquivar (#114) é um endpoint PRÓPRIO, e não um `PATCH {estado:
    // 'arquivada'}` — mexe em TRÊS coisas numa transacção só (a onda, as
    // tarefas por fazer, a carga), e o quadro grava a cada arrasto: um
    // PATCH de estado viajaria à boleia de qualquer gravação em curso.
    arquivarOnda: (id) => req(`${B}/ondas/${id}/arquivar/`, { method: "POST", body: {} }),
    // O cronómetro do tablet endereça UMA tarefa — é este endpoint que existe
    // para gravar `tempo_real_min` sem reescrever a onda à volta dela.
    guardarTarefa: (id, d) => req(`${B}/tarefas/${id}/`, { method: "PATCH", body: d }),
    // A OF que satisfaz a encomenda desta tarefa, e o que ela já produziu.
    // Endpoint à PARTE e não campo da tarefa: vive do ERP, é lento em
    // comparação com a leitura das ondas, e uma falha dele não pode deixar o
    // tablet sem trabalho para mostrar.
    ofDaTarefa: (id) => req(`${B}/tarefas/${id}/of/`),
    // Os três vocabulários das ondas. Leem-se uma vez (não mudam com o dia)
    // e a escrita vive em Definições → «Turnos e armazéns».
    tiposOnda: () => req(`${B}/tipos-onda/`),
    motivosOnda: () => req(`${B}/motivos-onda/`),
    prioridadesOnda: () => req(`${B}/prioridades-onda/`),
    // ----------------------------------------------------- tipos de TIR
    // O catálogo: as MEDIDAS de um camião vivem no tipo, não em cada TIR —
    // mudar a largura útil de um semirreboque muda-a em toda a frota.
    tiposTir: () => req(`${B}/tipos-tir/`),
    criarTipoTir: (dados) => req(`${B}/tipos-tir/`, { method: "POST", body: dados }),
    guardarTipoTir: (id, dados) => req(`${B}/tipos-tir/${id}/`, { method: "PUT", body: dados }),
    apagarTipoTir: (id) => req(`${B}/tipos-tir/${id}/`, { method: "DELETE" }),
    // ---------------------------------------------- transportadoras e tarifas
    // Quem transporta, e por quanto. As tarifas pedem-se por transportadora
    // (`{ transportadora: id }`) no ecrã de Definições, e TODAS no quadro de
    // planeamento — que precisa de as cruzar com a frota inteira.
    transportadoras: (opts) => req(`${B}/transportadoras/`, { params: opts }),
    criarTransportadora: (d) => req(`${B}/transportadoras/`, { method: "POST", body: d }),
    guardarTransportadora: (id, d) => req(`${B}/transportadoras/${id}/`, { method: "PUT", body: d }),
    apagarTransportadora: (id) => req(`${B}/transportadoras/${id}/`, { method: "DELETE" }),
    tarifas: (opts) => req(`${B}/tarifas/`, { params: opts }),
    criarTarifa: (d) => req(`${B}/tarifas/`, { method: "POST", body: d }),
    guardarTarifa: (id, d) => req(`${B}/tarifas/${id}/`, { method: "PUT", body: d }),
    apagarTarifa: (id) => req(`${B}/tarifas/${id}/`, { method: "DELETE" }),
    // ------------------------------------------------------------ frota
    tirs: (opts) => req(`${B}/tirs/`, { params: opts }),
    criarTir: (dados) => req(`${B}/tirs/`, { method: "POST", body: dados }),
    guardarTir: (id, dados) => req(`${B}/tirs/${id}/`, { method: "PUT", body: dados }),
    apagarTir: (id) => req(`${B}/tirs/${id}/`, { method: "DELETE" }),
    // ----------------------------------------------------------- cargas
    // O que era estado do browser passa a existir em base de dados: o que
    // está em cada TIR e em que estado está a carga sobrevivem ao F5.
    cargas: (dia) => req(`${B}/cargas/`, { params: { dia } }),
    // As moradas cujo ponto no mapa não é de confiança, mais a COBERTURA
    // do detector — sem ela, uma lista vazia lê-se como «está tudo bem».
    moradasPorCorrigir: () => req(`${B}/moradas-por-corrigir/`),
    criarCarga: (dados, opts) => req(`${B}/cargas/`, { method: "POST", body: dados, ...opts }),
    guardarCarga: (id, dados, opts) => req(`${B}/cargas/${id}/`, { method: "PUT", body: dados, ...opts }),
    apagarCarga: (id) => req(`${B}/cargas/${id}/`, { method: "DELETE" }),
    // Um socket por DIA (`/ws/cargoplanner/<dia>/`): anuncia quando outra
    // pessoa grava ou apaga uma carga desse dia — ver `backend/consumers.py`
    // e `backend/realtime.py`. A resolução de protocolo (ws:/wss:) segue o
    // MESMO padrão que `packages/hub_shell/src/api.js` já usa para os
    // sockets do chat (`openChatSocket`); fica aqui, e não lá, pela mesma
    // razão do resto deste ficheiro — não furar a fronteira app/shell.
    abrirSocket: (dia) => {
      const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
      return new WebSocket(`${proto}//${window.location.host}/ws/cargoplanner/${dia}/`);
    },
    erroMensagem,
    erroTransitorio
  };
})();

// ===== cargoplanner/frontend/cargoplanner_dados.js =====
const CP_UNIDADES = [];
const CP_CLIENTES = [
  {
    id: "A",
    nome: "Cliente A",
    local: "MAIA",
    morada: "Zona Industrial da Maia, Lote 12",
    cp: "4470-000 Maia",
    lat: 41.235,
    lng: -8.62,
    cor: "#3b82f6"
  },
  {
    id: "B",
    nome: "Cliente B",
    local: "PORTO",
    morada: "Rua da Ind\xFAstria, 100",
    cp: "4100-000 Porto",
    lat: 41.1579,
    lng: -8.6291,
    cor: "#f97316"
  },
  {
    id: "C",
    nome: "Cliente C",
    local: "RIO TINTO",
    morada: "Parque Industrial de Rio Tinto",
    cp: "4435-000 Rio Tinto",
    lat: 41.1793,
    lng: -8.5556,
    cor: "#a855f7"
  },
  {
    id: "D",
    nome: "Cliente D",
    local: "LISBOA",
    morada: "Estrada da Circunvala\xE7\xE3o, 500",
    cp: "1900-000 Lisboa",
    lat: 38.7223,
    lng: -9.1393,
    cor: "#22c55e"
  },
  {
    id: "E",
    nome: "Cliente E",
    local: "BRAGA",
    morada: "Av. da Liberdade, 800",
    cp: "4710-000 Braga",
    lat: 41.5454,
    lng: -8.4265,
    cor: "#db2777"
  },
  {
    id: "F",
    nome: "Cliente F",
    local: "AVEIRO",
    morada: "Zona Industrial de Taboeira",
    cp: "3800-000 Aveiro",
    lat: 40.6405,
    lng: -8.6538,
    cor: "#0891b2"
  }
];
const CP_CAMIOES = [
  // Guimarães→Maia→Porto→Rio Tinto→Lisboa→Guimarães é um dia inteiro: a
  // janela tem de dar para o percurso que a carga do seed desenha.
  {
    id: "TIR-17",
    aluguer: "proprio",
    transportadora: null,
    matricula: "AA-12-BB",
    motorista: "Jo\xE3o Santos",
    capacidade: 24,
    metros: 13.6,
    larguraUtil: 2.45,
    periodo: "manha",
    inicio: "08:00",
    fim: "22:00"
  },
  {
    id: "TIR-14",
    aluguer: "proprio",
    transportadora: null,
    matricula: "AB-34-CD",
    motorista: "Rui Marques",
    capacidade: 24,
    metros: 13.6,
    larguraUtil: 2.45,
    periodo: "manha",
    inicio: "10:00",
    fim: "18:00"
  },
  {
    id: "TIR-09",
    aluguer: "proprio",
    transportadora: null,
    matricula: "AC-56-DE",
    motorista: "Nuno Faria",
    capacidade: 24,
    metros: 13.6,
    larguraUtil: 2.45,
    periodo: "manha",
    inicio: "09:00",
    fim: "17:00"
  },
  {
    id: "TIR-03",
    aluguer: "alugado",
    transportadora: "Distriseven \u2014 Transportes",
    matricula: "AD-78-EF",
    motorista: "H\xE9lder Lima",
    capacidade: 18,
    metros: 7.2,
    larguraUtil: 2.45,
    periodo: "manha",
    inicio: "07:00",
    fim: "15:00"
  },
  {
    id: "TIR-02",
    aluguer: "alugado",
    transportadora: "Distriseven \u2014 Transportes",
    matricula: "AE-90-FG",
    motorista: "S\xE9rgio Cruz",
    capacidade: 24,
    metros: 13.6,
    larguraUtil: 2.45,
    periodo: "tarde",
    inicio: "14:00",
    fim: "22:00"
  },
  // Lugar reservado no plano, ainda por contratar.
  {
    id: "TIR-05",
    aluguer: "por_alugar",
    transportadora: null,
    matricula: null,
    motorista: null,
    capacidade: 33,
    metros: 13.6,
    larguraUtil: 2.45,
    periodo: "tarde",
    inicio: "16:00",
    fim: "23:00"
  }
];
const CP_ALUGUER = [
  { id: "proprio", label: "Frota pr\xF3pria" },
  { id: "alugado", label: "Alugado" },
  { id: "por_alugar", label: "Por alugar" }
];
const CP_ESTADOS = [
  { id: "em_planeamento", label: "Em planeamento", cor: "#6a7888" },
  { id: "planeada", label: "Planeada", cor: "#2563eb" },
  { id: "em_preparacao", label: "Em prepara\xE7\xE3o", cor: "#d97706" },
  { id: "preparada", label: "Preparada", cor: "#7c3aed" },
  { id: "expedida", label: "Expedida", cor: "#16a34a" },
  { id: "bloqueada", label: "Bloqueada", cor: "#dc2626" },
  { id: "cancelada", label: "Cancelada", cor: "#9aa6b3" }
];
const CP_FLUXO_ESTADOS = ["em_planeamento", "planeada", "em_preparacao", "preparada", "expedida"];
function cpISO(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
function cpHoje() {
  return cpISO(/* @__PURE__ */ new Date());
}
function cpDiaUtilMais(diaISO, n) {
  let d = diaISO;
  let restantes = Math.max(0, n | 0);
  let guarda = 0;
  while (restantes > 0 && guarda < 400) {
    d = cpDiaMais(d, 1);
    guarda += 1;
    const [y, m, dd] = d.split("-").map(Number);
    const semana = new Date(Date.UTC(y, m - 1, dd)).getUTCDay();
    if (semana !== 0 && semana !== 6) restantes -= 1;
  }
  return d;
}
function cpDiaUtilMenos(diaISO, n) {
  let d = diaISO;
  let restantes = Math.max(0, n | 0);
  let guarda = 0;
  while (restantes > 0 && guarda < 400) {
    d = cpDiaMais(d, -1);
    guarda += 1;
    const [y, m, dd] = d.split("-").map(Number);
    const semana = new Date(Date.UTC(y, m - 1, dd)).getUTCDay();
    if (semana !== 0 && semana !== 6) restantes -= 1;
  }
  return d;
}
function cpDiaMais(diaISO, n) {
  const [y, m, d] = String(diaISO).split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + n);
  const p = (x) => String(x).padStart(2, "0");
  return `${dt.getUTCFullYear()}-${p(dt.getUTCMonth() + 1)}-${p(dt.getUTCDate())}`;
}
function cpEntregasSeed(dia0) {
  const dia1 = cpDiaMais(dia0, 1);
  const dia2 = cpDiaMais(dia0, 2);
  const L = (dia, clienteId, ref, descricao, of, qtdTotal, qtdDisponivel, unPorPalete, prevDisp, prevOffset) => ({
    id: `${dia}:${ref}`,
    dia,
    clienteId,
    ref,
    descricao,
    of,
    qtdTotal,
    qtdDisponivel,
    unPorPalete,
    prevDisp: prevDisp || null,
    prevOffset: prevOffset || 0
  });
  return [
    // ---- dia da estreia do planeamento (o "hoje" do ecrã) ----
    L(dia0, "A", "XPT01", "Artigo X", "OF-1001", 2e3, 1e3, 500, "06:30", 0),
    L(dia0, "A", "XPT02", "Artigo Y", "OF-1002", 1e3, 500, 500, "07:30", 0),
    L(dia0, "A", "ABC03", "Suporte", "OF-1010", 600, 600, 300, "09:00", 0),
    L(dia0, "B", "XPT03", "Artigo Z", "OF-1003", 1800, 800, 600, "06:00", 0),
    L(dia0, "B", "DEF10", "Painel", "OF-1004", 600, 300, 300, "09:30", 0),
    L(dia0, "C", "18PA", "Artigo A", "OF-1005", 1e3, 1e3, 340, null, 0),
    L(dia0, "C", "19PA", "Artigo B", "OF-1006", 700, 700, 350, null, 0),
    L(dia0, "C", "22PA", "Artigo K", "OF-1025", 800, 800, 400, null, 0),
    L(dia0, "D", "A001", "Artigo C", "OF-1007", 2e3, 1500, 500, "07:45", 0),
    L(dia0, "D", "A002", "Artigo D", "OF-1008", 1500, 1500, 750, null, 0),
    L(dia0, "D", "LMN20", "Tampa", "OF-1009", 500, 0, 500, "11:00", 1),
    L(dia0, "E", "GHI07", "Estrado", "OF-1011", 900, 900, 300, null, 0),
    L(dia0, "E", "GHI08", "Tampo", "OF-1012", 1200, 600, 400, "09:00", 0),
    L(dia0, "F", "JKL22", "Caixa", "OF-1013", 800, 800, 400, null, 0),
    L(dia0, "F", "JKL23", "Tampa lateral", "OF-1014", 400, 200, 200, "12:30", 0),
    // ---- dia seguinte ----
    L(dia1, "C", "20PA", "Artigo E", "OF-1015", 1200, 1200, 400, null, 0),
    L(dia1, "C", "21PA", "Artigo F", "OF-1016", 900, 300, 300, "10:30", 0),
    L(dia1, "D", "A010", "Artigo G", "OF-1017", 2400, 1200, 600, "15:00", 0),
    L(dia1, "E", "GHI09", "Base", "OF-1018", 600, 600, 300, null, 0),
    L(dia1, "E", "GHI10", "Perfil", "OF-1019", 450, 0, 150, "09:30", 0),
    L(dia1, "B", "XPT08", "Artigo H", "OF-1020", 1500, 1500, 500, null, 0),
    // ---- dia +2 ----
    L(dia2, "A", "XPT12", "Artigo I", "OF-1021", 1e3, 400, 250, "11:00", 0),
    L(dia2, "A", "XPT13", "Artigo J", "OF-1022", 750, 750, 250, null, 0),
    L(dia2, "F", "JKL30", "Caixa alta", "OF-1023", 1600, 800, 400, "14:30", 0),
    L(dia2, "F", "JKL31", "Tampo alto", "OF-1024", 600, 600, 300, null, 0)
  ];
}
function cpCargasSeed(dia0) {
  return [
    {
      id: "c1",
      camiaoId: "TIR-17",
      dia: dia0,
      origemId: "jn",
      regressoId: "jn",
      estado: "planeada",
      ordemClientes: ["A", "B", "C", "D"],
      linhas: [
        { entregaId: `${dia0}:XPT01`, qtd: 1e3 },
        { entregaId: `${dia0}:XPT02`, qtd: 500 },
        { entregaId: `${dia0}:ABC03`, qtd: 600 },
        { entregaId: `${dia0}:XPT03`, qtd: 800 },
        { entregaId: `${dia0}:DEF10`, qtd: 300 },
        { entregaId: `${dia0}:18PA`, qtd: 1e3 },
        { entregaId: `${dia0}:19PA`, qtd: 700 },
        { entregaId: `${dia0}:A001`, qtd: 1500 },
        { entregaId: `${dia0}:A002`, qtd: 1500 }
      ]
    },
    {
      id: "c2",
      camiaoId: "TIR-14",
      dia: dia0,
      origemId: "nevsta",
      regressoId: null,
      estado: "em_planeamento",
      ordemClientes: ["E"],
      linhas: [{ entregaId: `${dia0}:GHI07`, qtd: 900 }]
    },
    {
      id: "c3",
      camiaoId: "TIR-02",
      dia: dia0,
      origemId: "seven",
      regressoId: "seven",
      estado: "planeada",
      ordemClientes: ["F"],
      linhas: [{ entregaId: `${dia0}:JKL22`, qtd: 800 }]
      // Deliberadamente em conflito (RF28): acaba às 14:30, o TIR-02 sai às
      // 14:00. Serve para o painel de conflitos ter o que mostrar.
    },
    {
      id: "c4",
      camiaoId: "TIR-09",
      dia: dia0,
      origemId: "jn",
      regressoId: null,
      estado: "em_planeamento",
      ordemClientes: [],
      linhas: []
    }
  ];
}
function cpCriarDados(dia0) {
  const base = dia0 || cpHoje();
  return {
    diaBase: base,
    unidades: CP_UNIDADES,
    clientes: CP_CLIENTES,
    camioes: CP_CAMIOES,
    aluguer: CP_ALUGUER,
    estados: CP_ESTADOS,
    fluxoEstados: CP_FLUXO_ESTADOS,
    entregas: cpEntregasSeed(base),
    cargas: cpCargasSeed(base)
  };
}
window.CP_PRECISAO = {
  street: "rua",
  postcode: "c\xF3d. postal",
  place: "localidade",
  locality: "localidade",
  region: "regi\xE3o",
  district: "distrito",
  neighborhood: "zona"
};
window.CargoplannerDados = {
  criar: cpCriarDados,
  hoje: cpHoje,
  diaMais: cpDiaMais,
  diaUtilMais: cpDiaUtilMais,
  diaUtilMenos: cpDiaUtilMenos,
  iso: cpISO,
  UNIDADES: CP_UNIDADES,
  CLIENTES: CP_CLIENTES,
  CAMIOES: CP_CAMIOES,
  ALUGUER: CP_ALUGUER,
  ESTADOS: CP_ESTADOS,
  FLUXO_ESTADOS: CP_FLUXO_ESTADOS
};

// ===== cargoplanner/frontend/cargoplanner_logica.js =====
const CP_DESCARGA_MIN = 30;
const CP_FATOR_ESTRADA = 1.28;
const CP_VELOCIDADE_KMH = 72;
const CP_MARGEM_RISCO_MIN = 60;
function cpHhmm2min(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || "").trim());
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
}
function cpMin2hhmm(min) {
  if (min == null || !isFinite(min)) return "\u2014";
  const total = Math.round(min);
  const d = Math.floor(total / 1440);
  const rest = (total % 1440 + 1440) % 1440;
  const p = (n) => String(n).padStart(2, "0");
  const base = `${p(Math.floor(rest / 60))}:${p(rest % 60)}`;
  return d > 0 ? `${base} (+${d}d)` : base;
}
function cpDuracao(min) {
  if (min == null || !isFinite(min)) return "\u2014";
  const t = Math.round(min);
  const h = Math.floor(t / 60);
  const m = t % 60;
  return h > 0 ? `${h}h ${String(m).padStart(2, "0")}m` : `${m} min`;
}
function cpHaversineKm(a, b) {
  if (!a || !b) return 0;
  const R = 6371;
  const rad = (x) => x * Math.PI / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
}
function cpTemCoords(p) {
  return !!p && p.lat != null && p.lng != null && isFinite(p.lat) && isFinite(p.lng);
}
function cpKmEstrada(a, b) {
  if (!cpTemCoords(a) || !cpTemCoords(b)) return null;
  return Math.round(cpHaversineKm(a, b) * CP_FATOR_ESTRADA);
}
function cpMinutosViagem(km) {
  if (km == null) return null;
  return Math.round(km / CP_VELOCIDADE_KMH * 60);
}
function cpPaletes(qtd, unPorPalete) {
  const u = Number(unPorPalete) || 0;
  const q = Number(qtd) || 0;
  if (u <= 0 || q <= 0) return 0;
  return Math.ceil(q / u);
}
function cpEntregasVisiveis(lista, mostrar) {
  const todas = lista || [];
  if (mostrar) return todas;
  return todas.filter((e) => {
    if (!e || !e.naoCarga) return true;
    return !!e.atribuido && Object.keys(e.atribuido).length > 0;
  });
}
function cpIndexar(lista, chave) {
  const out = {};
  for (const it of lista || []) out[it[chave || "id"]] = it;
  return out;
}
function cpReordenar(arr, from, to) {
  const out = (arr || []).slice();
  if (from < 0 || from >= out.length) return out;
  const alvo = Math.max(0, Math.min(out.length - 1, to));
  const [x] = out.splice(from, 1);
  out.splice(alvo, 0, x);
  return out;
}
function cpDisponibilidade(entrega, partidaMin, qtd, disponivel) {
  if (!entrega) return "produzido";
  const q = qtd == null ? Number(entrega.qtdTotal) : Number(qtd);
  const d = disponivel == null ? Number(entrega.qtdDisponivel) : Number(disponivel);
  if (d >= q) return "produzido";
  if (Number(entrega.prevOffset) > 0) return "atrasado";
  const prev = cpHhmm2min(entrega.prevDisp);
  if (prev == null) return "producao";
  if (partidaMin == null) return "producao";
  if (prev + CP_MARGEM_RISCO_MIN <= partidaMin) return "producao";
  if (prev <= partidaMin) return "risco";
  return "atrasado";
}
const CP_DISP_LABEL = {
  produzido: "Produzido",
  producao: "Em produ\xE7\xE3o",
  risco: "Risco \u2014 produ\xE7\xE3o apertada",
  atrasado: "Risco \u2014 produ\xE7\xE3o depois da sa\xEDda"
};
function cpDiaUtil(diaISO, feriados) {
  if (!diaISO) return null;
  const [y, m, dd] = String(diaISO).split("-").map(Number);
  if (!y || !m || !dd) return null;
  const semana = new Date(Date.UTC(y, m - 1, dd)).getUTCDay();
  if (semana === 0) return { tipo: "fim_de_semana", nome: "domingo" };
  if (semana === 6) return { tipo: "fim_de_semana", nome: "s\xE1bado" };
  const f = (feriados || []).find((x) => x && x.ativo !== false && x.data === diaISO);
  return f ? { tipo: "feriado", nome: f.nome } : null;
}
const CP_MESES = [
  "janeiro",
  "fevereiro",
  "mar\xE7o",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro"
];
function cpMesMais(mesISO, n) {
  const m = /^(\d{4})-(\d{2})$/.exec(String(mesISO || ""));
  if (!m) return null;
  const total = Number(m[1]) * 12 + (Number(m[2]) - 1) + (n | 0);
  const ano = Math.floor(total / 12);
  const mes = total % 12 + 1;
  return `${ano}-${String(mes).padStart(2, "0")}`;
}
function cpMesDoDia(diaISO) {
  const m = /^(\d{4})-(\d{2})-\d{2}$/.exec(String(diaISO || ""));
  return m ? `${m[1]}-${m[2]}` : null;
}
function cpGradeDoMes(mesISO, feriados) {
  const m = /^(\d{4})-(\d{2})$/.exec(String(mesISO || ""));
  if (!m) return null;
  const ano = Number(m[1]);
  const mes = Number(m[2]);
  if (mes < 1 || mes > 12) return null;
  const primeiro = new Date(Date.UTC(ano, mes - 1, 1));
  const recuo = (primeiro.getUTCDay() + 6) % 7;
  const inicio = new Date(Date.UTC(ano, mes - 1, 1 - recuo));
  const ultimo = new Date(Date.UTC(ano, mes, 0)).getUTCDate();
  const total = Math.ceil((recuo + ultimo) / 7) * 7;
  const semanas = [];
  for (let i = 0; i < total; i += 1) {
    const d = new Date(inicio.getTime() + i * 864e5);
    const iso = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
    if (i % 7 === 0) semanas.push([]);
    semanas[semanas.length - 1].push({
      dia: iso,
      numero: d.getUTCDate(),
      foraDoMes: d.getUTCMonth() + 1 !== mes,
      motivo: cpDiaUtil(iso, feriados)
    });
  }
  return { ano, mes, rotulo: `${CP_MESES[mes - 1]} ${ano}`, semanas };
}
function cpAtribuidoDaLinha(entrega, cargas) {
  if (!entrega) return 0;
  let total = 0;
  const doEcra = /* @__PURE__ */ new Set();
  for (const c of cargas || []) {
    if (c.servidorId != null) doEcra.add(String(c.servidorId));
    if (CP_ESTADOS_SEM_VIAGEM.includes(c.estado)) continue;
    for (const l of c.linhas || []) {
      if (l.entregaId === entrega.id) total += Number(l.qtd) || 0;
    }
  }
  for (const [id, qtd] of Object.entries(entrega.atribuido || {})) {
    if (doEcra.has(String(id))) continue;
    total += Number(qtd) || 0;
  }
  return total;
}
function cpOndeEstaOResto(entrega, cargas) {
  if (!entrega || !entrega.atribuido) return [];
  const doEcra = new Set((cargas || []).filter((c) => c.servidorId != null).map((c) => String(c.servidorId)));
  return Object.entries(entrega.atribuido).filter(([id]) => !doEcra.has(String(id))).map(([id, qtd]) => ({ cargaServidorId: Number(id), qtd: Number(qtd) || 0 })).filter((x) => x.qtd > 0);
}
function cpQtdAtribuida(cargas, dia, entregaId, exceptoCargaId) {
  let total = 0;
  for (const c of cargas || []) {
    if (dia && c.dia !== dia) continue;
    if (exceptoCargaId && c.id === exceptoCargaId) continue;
    for (const l of c.linhas || []) {
      if (l.entregaId === entregaId) total += Number(l.qtd) || 0;
    }
  }
  return total;
}
function cpPool(dados, dia, cargas, partidaMin) {
  const porCliente = /* @__PURE__ */ new Map();
  for (const e of dados.entregas || []) {
    if (e.dia !== dia) continue;
    const atribuida = cpQtdAtribuida(cargas, dia, e.id, null);
    const porAtribuir = Number(e.qtdTotal) - atribuida;
    if (porAtribuir <= 0) continue;
    const disponivel = Math.max(0, Number(e.qtdDisponivel) - atribuida);
    const artigo = {
      entrega: e,
      qtdPorAtribuir: porAtribuir,
      qtdDisponivel: Math.min(disponivel, porAtribuir),
      qtdPrevista: Math.max(0, porAtribuir - disponivel),
      paletes: cpPaletes(porAtribuir, e.unPorPalete),
      disponibilidade: cpDisponibilidade(e, partidaMin, porAtribuir, disponivel)
    };
    if (!porCliente.has(e.clienteId)) {
      porCliente.set(e.clienteId, {
        clienteId: e.clienteId,
        cliente: cpClienteDaEntrega(e.clienteId, e, dados),
        artigos: [],
        qtd: 0,
        paletes: 0
      });
    }
    const g = porCliente.get(e.clienteId);
    g.artigos.push(artigo);
    g.qtd += porAtribuir;
    g.paletes += artigo.paletes;
  }
  return [...porCliente.values()].sort((a, b) => a.clienteId.localeCompare(b.clienteId));
}
function cpArtigosPorKit(artigos) {
  const fora = [];
  const porKit = /* @__PURE__ */ new Map();
  for (const a of artigos || []) {
    const e = a && a.entrega || {};
    const chave = e.kitBistamp || "";
    if (!chave) {
      fora.push({ tipo: "linha", artigo: a });
      continue;
    }
    if (!porKit.has(chave)) {
      const entrada = {
        tipo: "kit",
        kitBistamp: chave,
        kitRef: e.kitRef || "",
        componentes: [],
        qtd: 0,
        paletes: 0,
        semPaletes: 0,
        kits: null,
        foraDeProporcao: false
      };
      porKit.set(chave, entrada);
      fora.push(entrada);
    }
    const k = porKit.get(chave);
    k.componentes.push(a);
    k.qtd += Number(a.qtd) || 0;
    if (a.paletes == null || !Number.isFinite(Number(a.paletes))) k.semPaletes += 1;
    else k.paletes += Number(a.paletes);
    if (!k.kitRef && e.kitRef) k.kitRef = e.kitRef;
  }
  for (const k of porKit.values()) {
    const qtds = {};
    const razoes = {};
    for (const c of k.componentes) {
      qtds[c.entrega.id] = Number(c.qtd) || 0;
      razoes[c.entrega.id] = c.entrega.kitRazao;
    }
    k.kits = cpKitsDeQuantidades(qtds, razoes);
    k.foraDeProporcao = k.kits != null && k.componentes.some((c) => (Number(c.qtd) || 0) > k.kits * (Number(c.entrega.kitRazao) || 0));
  }
  return fora;
}
function cpLinhasDoKit(entrada) {
  return (entrada && entrada.componentes || []).map((c) => c.entrega.id);
}
function cpItensDoKit(kit, componentes) {
  return (componentes || []).filter((c) => c && Number(c.qtdTotal) > 0).map((c) => ({ entregaId: c.id, qtd: Number(c.qtdTotal) }));
}
function cpItensParaArrastar(linhas, kits) {
  const porKit = kits && kits.porKit || null;
  const fora = /* @__PURE__ */ new Map();
  const juntar = (item) => {
    if (!fora.has(item.entregaId)) fora.set(item.entregaId, item);
  };
  for (const l of linhas || []) {
    if (!l) continue;
    const comps = porKit && porKit[l.id];
    if (comps) {
      cpItensDoKit(l, comps).forEach(juntar);
      continue;
    }
    if (Number(l.qtdTotal) > 0) juntar({ entregaId: l.id, qtd: Number(l.qtdTotal) });
  }
  return [...fora.values()];
}
const CP_CORES_CLIENTE = [
  "#3b82f6",
  "#f97316",
  "#a855f7",
  "#22c55e",
  "#db2777",
  "#0891b2",
  "#f59e0b",
  "#14b8a6",
  "#6366f1",
  "#84cc16"
];
function cpCorDoCliente(id) {
  let h = 0;
  const t = String(id || "");
  for (let i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) % 99991;
  return CP_CORES_CLIENTE[h % CP_CORES_CLIENTE.length];
}
function cpClienteDaEntrega(id, entrega, dados) {
  const doMock = cpIndexar(dados.clientes || [])[id];
  if (doMock) return doMock;
  return {
    id,
    nome: entrega && entrega.clienteNome || String(id),
    local: entrega && entrega.local || "",
    morada: entrega && entrega.morada || "",
    cp: "",
    lat: (entrega && entrega.lat) != null ? entrega.lat : null,
    lng: (entrega && entrega.lng) != null ? entrega.lng : null,
    precisao: entrega && entrega.precisaoMorada || "",
    // O NÍVEL é a decisão (porta/aproximado/por_corrigir); a `precisao` é
    // como o Mapbox chamou ao resultado. São coisas diferentes, e foi por se
    // decidir pela segunda que um ponto em Mirandela passou por exacto.
    nivel: entrega && entrega.nivelMorada || "",
    cor: cpCorDoCliente(id)
  };
}
function cpAmostrasOrdenadas(carga) {
  return [...carga && carga.entregasManuais || []].sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
}
function cpIdDaAmostra(amostra, i) {
  return `am:${amostra && amostra.id != null ? amostra.id : `n${i}`}`;
}
function cpParagens(carga, dados) {
  if (!carga) return [];
  const entregas = cpIndexar(dados.entregas);
  const porCliente = /* @__PURE__ */ new Map();
  for (const l of carga.linhas || []) {
    const e = entregas[l.entregaId];
    if (!e) continue;
    if (!porCliente.has(e.clienteId)) porCliente.set(e.clienteId, []);
    porCliente.get(e.clienteId).push({
      entrega: e,
      qtd: Number(l.qtd) || 0,
      paletes: cpPaletes(l.qtd, e.unPorPalete)
    });
  }
  const ordem = (carga.ordemClientes || []).filter((id) => porCliente.has(id));
  for (const id of porCliente.keys()) if (!ordem.includes(id)) ordem.push(id);
  const derivadas = ordem.map((id, i) => {
    const artigos = porCliente.get(id);
    return {
      ordem: i + 1,
      clienteId: id,
      cliente: cpClienteDaEntrega(id, artigos[0] && artigos[0].entrega, dados),
      // O horário de descarga é do CLIENTE (vem no `c_logobs` de qualquer
      // linha dele); a compatibilidade depende do camião, por isso calcula-se
      // aqui, onde os dois se encontram.
      horarios: artigos[0] && artigos[0].entrega && artigos[0].entrega.horarios || "",
      artigos,
      qtd: artigos.reduce((s, a) => s + a.qtd, 0),
      paletes: artigos.reduce((s, a) => s + a.paletes, 0)
    };
  });
  const amostras = cpAmostrasOrdenadas(carga).map((a, i) => ({
    ordem: derivadas.length + i + 1,
    clienteId: cpIdDaAmostra(a, i),
    amostra: true,
    // A POSIÇÃO na lista das declaradas — é por ela que o ✕ a tira. Uma
    // amostra acabada de criar ainda não tem `id` do servidor, e duas para a
    // mesma morada seriam indistinguíveis por qualquer outra chave.
    indiceAmostra: i,
    // O `id` do servidor — a chave por onde os volumes se penduram (#112).
    // `null` numa amostra acabada de declarar, que ainda não gravou.
    entregaManualId: a.id != null ? a.id : null,
    cliente: {
      id: cpIdDaAmostra(a, i),
      nome: a.nome,
      local: a.local || "",
      morada: a.morada || "",
      cp: "",
      lat: a.lat != null ? a.lat : null,
      lng: a.lng != null ? a.lng : null,
      cor: CP_COR_AMOSTRA,
      precisao: ""
    },
    horarios: "",
    artigos: [],
    qtd: 0,
    paletes: 0
  }));
  return [...derivadas, ...amostras];
}
function cpPercurso(carga, dados) {
  const vazio = { pontos: [], kmTotal: 0, minTotal: 0, partidaMin: null };
  if (!carga) return vazio;
  const camiao = cpCamiaoDaCarga(carga, dados);
  const unidades = cpIndexar(dados.unidades);
  const origem = unidades[carga.origemId];
  const regresso = carga.regressoId ? unidades[carga.regressoId] : null;
  const paragens = cpParagens(carga, dados);
  const partidaMin = camiao ? cpHhmm2min(camiao.inicio) : null;
  const pontos = [];
  if (origem) {
    pontos.push({
      tipo: "origem",
      id: origem.id,
      nome: origem.nome,
      local: origem.local,
      morada: origem.morada,
      cp: origem.cp,
      lat: origem.lat,
      lng: origem.lng,
      cor: "var(--muted)",
      km: 0,
      min: 0,
      hora: partidaMin,
      paletes: 0
    });
  }
  let anterior = origem || null;
  let relogio = partidaMin;
  for (const p of paragens) {
    const km = anterior ? cpKmEstrada(anterior, p.cliente) : 0;
    const min = cpMinutosViagem(km);
    if (relogio != null && min != null) relogio += min;
    else if (min == null) relogio = null;
    pontos.push({
      tipo: "paragem",
      id: p.clienteId,
      ordem: p.ordem,
      nome: p.cliente.nome,
      local: p.cliente.local,
      morada: p.cliente.morada,
      cp: p.cliente.cp,
      lat: p.cliente.lat,
      lng: p.cliente.lng,
      cor: p.cliente.cor,
      precisao: p.cliente.precisao || "",
      // **Esta é a que se esquece.** O `cpPercurso` reconstrói cada paragem
      // num PONTO campo a campo, e o ecrã recebe pontos, não paragens — a
      // mesma armadilha que a marca `amostra` e as duas chaves da pendura
      // dos volumes já pagaram neste exacto sítio.
      nivel: p.cliente.nivel || "",
      km,
      min,
      hora: relogio,
      paletes: p.paletes,
      qtd: p.qtd,
      artigos: p.artigos,
      // **A marca da amostra TEM de atravessar o percurso.** `cpPercurso`
      // reconstrói cada paragem num ponto, campo a campo — e uma marca que
      // ele não copie desaparece em silêncio. A cor sobrevivia (vem do
      // `cliente`) e a marca não, por isso o ecrã pintava a paragem de roxo
      // e não dizia porquê: «0 paletes» sem explicação, que é exactamente o
      // que a marca existe para evitar. Apanhado em browser; os testes do
      // `cpParagens` passavam todos.
      amostra: !!p.amostra,
      indiceAmostra: p.indiceAmostra,
      // **As DUAS chaves da pendura dos volumes têm de atravessar o percurso
      // também** (#112). O ecrã recebe PONTOS, não paragens — e
      // `cpPacotesDaParagem` pergunta por `clienteId`/`entregaManualId`,
      // exactamente os dois campos que esta reconstrução não copiava: num
      // transitário os volumes de um cliente deixavam de aparecer (o filtro
      // casava `clientePhc === undefined`) e os de uma amostra nunca
      // chegavam a ter pendura nenhuma. É a MESMA armadilha do `amostra`
      // acima, e nenhum teste do `cpParagens` a veria.
      //
      // `clienteId` repete o `id` de propósito: o ponto passa a responder
      // pela mesma pergunta com o mesmo nome que a paragem, em vez de obrigar
      // quem o consome a saber que ali o cliente se chama `id`. Os dois saem
      // da mesma expressão, por isso não há como divergirem.
      clienteId: p.clienteId,
      entregaManualId: p.entregaManualId
    });
    if (relogio != null) relogio += CP_DESCARGA_MIN;
    anterior = p.cliente;
  }
  for (const r of cpRecolhasOrdenadas(carga)) {
    if (!cpTemCoords(r)) continue;
    const km = anterior ? cpKmEstrada(anterior, r) : 0;
    const min = cpMinutosViagem(km);
    if (relogio != null && min != null) relogio += min;
    else if (min == null) relogio = null;
    pontos.push({
      tipo: "recolha",
      id: `r${r.id != null ? r.id : r.ordem}`,
      recolha: r,
      nome: r.nome,
      local: r.local || "",
      morada: r.morada || "",
      cp: "",
      lat: r.lat,
      lng: r.lng,
      cor: CP_COR_RECOLHA,
      motivo: r.motivo || "",
      km,
      min,
      hora: relogio,
      paletes: 0
    });
    if (relogio != null) relogio += CP_RECOLHA_MIN;
    anterior = r;
  }
  if (regresso && anterior) {
    const km = cpKmEstrada(anterior, regresso);
    const min = cpMinutosViagem(km);
    if (relogio != null && min != null) relogio += min;
    else if (min == null) relogio = null;
    pontos.push({
      tipo: "regresso",
      id: regresso.id,
      nome: regresso.nome,
      local: regresso.local,
      morada: regresso.morada,
      cp: regresso.cp,
      lat: regresso.lat,
      lng: regresso.lng,
      cor: "var(--muted)",
      km,
      min,
      hora: relogio,
      paletes: 0
    });
  }
  const semCoords = pontos.filter((p) => p.tipo === "paragem" && !cpTemCoords(p));
  const kmTotal = semCoords.length ? null : pontos.reduce((s, p) => s + (p.km || 0), 0);
  const minTotal = relogio != null && partidaMin != null ? relogio - partidaMin : pontos.reduce((s, p) => s + (p.min || 0), 0);
  return {
    pontos,
    kmTotal,
    minTotal: semCoords.length ? null : minTotal,
    partidaMin,
    paragens,
    semCoords
  };
}
function cpAplicarRota(percurso, rota) {
  if (!percurso || !rota || !rota.legs) return percurso;
  const pontos = percurso.pontos || [];
  if (pontos.length < 2 || rota.legs.length !== pontos.length - 1) return percurso;
  let relogio = percurso.partidaMin;
  const novos = pontos.map((p, i) => {
    if (i === 0) return { ...p, km: 0, min: 0, hora: relogio, real: true };
    const leg = rota.legs[i - 1];
    if (relogio != null) relogio += leg.min;
    const np = { ...p, km: leg.km, min: leg.min, hora: relogio, real: true };
    if (p.tipo === "paragem" && relogio != null) relogio += CP_DESCARGA_MIN;
    return np;
  });
  return {
    ...percurso,
    pontos: novos,
    kmTotal: rota.kmTotal,
    minTotal: relogio != null && percurso.partidaMin != null ? relogio - percurso.partidaMin : rota.minTotal,
    real: true
  };
}
const CP_COR_AMOSTRA = "#7c3aed";
const CP_LARGURA_UTIL = 2.45;
function cpPorFila(larguraPalete, larguraCamiao) {
  const lc = larguraCamiao || CP_LARGURA_UTIL;
  if (!larguraPalete || larguraPalete <= 0) return 1;
  return Math.max(1, Math.floor(lc / larguraPalete));
}
function cpCamadas(alturaPalete, alturaCamiao) {
  const p = Number(alturaPalete);
  const c = Number(alturaCamiao);
  if (!p || !c || p <= 0 || c <= 0) return 1;
  return Math.max(1, Math.floor(c / p));
}
function cpMetrosDaLinha(paletes, larguraPalete, profundidade, larguraCamiao, alturaPalete, alturaCamiao) {
  if (!paletes || paletes <= 0) return 0;
  if (!profundidade || profundidade <= 0) return null;
  const porChao = cpPorFila(larguraPalete, larguraCamiao) * cpCamadas(alturaPalete, alturaCamiao);
  const filas = Math.ceil(paletes / porChao);
  return Number((filas * profundidade).toFixed(2));
}
function cpMetrosDaEntrega(entrega, qtd, larguraCamiao, alturaCamiao) {
  if (!entrega) return null;
  const paletes = cpPaletes(qtd, entrega.unPorPalete);
  if (!paletes) return entrega.unPorPalete ? 0 : null;
  return cpMetrosDaLinha(
    paletes,
    entrega.paleteLargura,
    entrega.paleteProfundidade,
    larguraCamiao,
    entrega.paleteAltura,
    alturaCamiao
  );
}
function cpCorDaData(entrega, hoje) {
  if (!entrega || !entrega.alterada || !entrega.dia || !hoje) return "";
  const d = String(entrega.dia);
  const h = String(hoje);
  if (d < h) return "passou";
  if (d === h) return "hoje";
  return "futuro";
}
const _RE_HORA = /(\d{1,2})(?:[:hH.,](\d{2}))?\s*(?:h|horas)?/g;
function cpJanelaDoTexto(texto) {
  if (!texto) return null;
  const t = String(texto);
  if (!/\d/.test(t)) return null;
  const horas = [];
  let m = _RE_HORA.exec(t);
  while (m && horas.length < 8) {
    const h = Number(m[1]);
    const min = Number(m[2] || 0);
    if (h >= 0 && h <= 24 && min < 60) horas.push(h * 60 + min);
    m = _RE_HORA.exec(t);
  }
  _RE_HORA.lastIndex = 0;
  if (horas.length < 2) return null;
  const ini = Math.min(...horas);
  const fim = Math.max(...horas);
  if (fim - ini < 30 || fim - ini >= 15 * 60) return null;
  return { ini, fim };
}
function cpJanelaDaParagem(carga, clienteId, ponto) {
  const combinada = carga && carga.janelas ? carga.janelas[clienteId] : null;
  if (combinada) {
    const ini = cpHhmm2min(combinada.inicio);
    const fim = cpHhmm2min(combinada.fim);
    if (ini != null || fim != null) return { inicio: ini, fim, origem: "combinada" };
  }
  const hora = ponto && ponto.hora != null ? ponto.hora : null;
  if (hora == null) return null;
  return { inicio: hora, fim: null, origem: "calculada" };
}
function cpTextoDaJanela(janela) {
  if (!janela) return "";
  if (janela.inicio != null && janela.fim != null && janela.fim !== janela.inicio) {
    return `${cpMin2hhmm(janela.inicio)}\u2013${cpMin2hhmm(janela.fim)}`;
  }
  return cpMin2hhmm(janela.inicio != null ? janela.inicio : janela.fim);
}
function cpHorarioCompativel(textoCliente, camiao, janela) {
  const cliente = cpJanelaDoTexto(textoCliente);
  if (!cliente) return true;
  if (janela && janela.origem === "combinada") {
    const ini2 = janela.inicio != null ? janela.inicio : janela.fim;
    const fim2 = janela.fim != null ? janela.fim : janela.inicio;
    return ini2 <= cliente.fim && fim2 >= cliente.ini;
  }
  if (!camiao || !camiao.inicio || !camiao.fim) return true;
  const ini = cpHhmm2min(camiao.inicio);
  const fim = cpHhmm2min(camiao.fim);
  if (ini == null || fim == null) return true;
  return ini <= cliente.fim && fim >= cliente.ini;
}
function cpParagemComHorarioMau(carga, dados, camiao) {
  for (const p of cpParagens(carga, dados)) {
    const janela = cpJanelaDaParagem(carga, p.clienteId, null);
    if (!cpHorarioCompativel(p.horarios, camiao, janela)) return { paragem: p, janela };
  }
  return null;
}
function cpCorDaLinha(entrega, dia) {
  if (!entrega) return "";
  const total = Number(entrega.qtdTotal) || 0;
  const disponivel = Number(entrega.qtdDisponivel) || 0;
  if (total > 0 && disponivel >= total) return "stock";
  const of = entrega.dataFabrico;
  if (of && (!dia || String(of) <= String(dia))) return "planeado";
  return "";
}
const CP_CAMPOS_COND = [
  { id: "qtdTotal", label: "Por entregar" },
  { id: "qtdDisponivel", label: "Em stock" },
  { id: "qtdPrevista", label: "Por produzir" },
  { id: "paletes", label: "Paletes" },
  { id: "valor", label: "Valor (\u20AC)" }
];
const CP_OPERADORES = [
  { id: "gt", label: ">" },
  { id: "gte", label: "\u2265" },
  { id: "lt", label: "<" },
  { id: "lte", label: "\u2264" },
  { id: "eq", label: "=" },
  { id: "ne", label: "\u2260" }
];
function cpValorDoCampo(linha, campo) {
  if (!linha || !campo) return null;
  const v = linha[campo];
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
function cpCondicaoOk(linha, cond) {
  if (!cond || !cond.campo || !cond.op) return true;
  const a = cpValorDoCampo(linha, cond.campo);
  const b = cond.tipo === "campo" ? cpValorDoCampo(linha, cond.campo2) : cond.valor === "" || cond.valor == null ? null : Number(cond.valor);
  if (a == null || b == null || !Number.isFinite(b)) return false;
  switch (cond.op) {
    case "gt":
      return a > b;
    case "gte":
      return a >= b;
    case "lt":
      return a < b;
    case "lte":
      return a <= b;
    case "eq":
      return a === b;
    case "ne":
      return a !== b;
    default:
      return true;
  }
}
function cpFiltrarPorCondicoes(linhas, condicoes) {
  const ativas = (condicoes || []).filter((c) => c && c.campo && c.op && (c.tipo === "campo" ? c.campo2 : c.valor !== "" && c.valor != null));
  if (!ativas.length) return linhas || [];
  return (linhas || []).filter((l) => ativas.every((c) => cpCondicaoOk(l, c)));
}
function cpTextoDaCondicao(cond) {
  const nome = (id) => (CP_CAMPOS_COND.find((c) => c.id === id) || {}).label || id;
  const op = (CP_OPERADORES.find((o) => o.id === cond.op) || {}).label || cond.op;
  const dir = cond.tipo === "campo" ? nome(cond.campo2) : String(cond.valor);
  return `${nome(cond.campo)} ${op} ${dir}`;
}
function cpCoord(p) {
  if (!p) return null;
  const lat = Array.isArray(p) ? p[0] : p.lat;
  const lng = Array.isArray(p) ? p[1] : p.lng;
  if (lat == null || lng == null || lat === 0 && lng === 0) return null;
  return { lat: Number(lat), lng: Number(lng) };
}
function cpKmAoSegmento(ponto, a, b) {
  const P = cpCoord(ponto);
  const A = cpCoord(a);
  const B = cpCoord(b);
  if (!P || !A) return null;
  if (!B) return cpHaversineKm(A, P);
  const R = 6371;
  const rad = Math.PI / 180;
  const cos = Math.cos((A.lat + B.lat) / 2 * rad);
  const x = (v) => (v.lng - A.lng) * rad * R * cos;
  const y = (v) => (v.lat - A.lat) * rad * R;
  const bx = x(B), by = y(B), px = x(P), py = y(P);
  const l2 = bx * bx + by * by;
  if (l2 === 0) return cpHaversineKm(A, P);
  let tt = (px * bx + py * by) / l2;
  tt = Math.max(0, Math.min(1, tt));
  const dx = px - tt * bx, dy = py - tt * by;
  return Math.sqrt(dx * dx + dy * dy);
}
function cpKmAoPercurso(ponto, linha) {
  const pontos = (linha || []).map(cpCoord).filter(Boolean);
  if (!cpCoord(ponto) || !pontos.length) return null;
  if (pontos.length === 1) return cpHaversineKm(pontos[0], cpCoord(ponto));
  let melhor = Infinity;
  for (let i = 0; i < pontos.length - 1; i++) {
    const d = cpKmAoSegmento(ponto, pontos[i], pontos[i + 1]);
    if (d != null && d < melhor) melhor = d;
  }
  return melhor === Infinity ? null : melhor;
}
function cpKmDaRotaPorCliente(entregas, linha) {
  const out = {};
  for (const e of entregas || []) {
    if (e.clienteId in out) continue;
    const km = cpKmAoPercurso(e, linha);
    out[e.clienteId] = km == null ? null : Math.round(km * 10) / 10;
  }
  return out;
}
function cpKmDaRotaPorLocal(kmPorCliente, localPorCliente) {
  const out = {};
  for (const id of Object.keys(kmPorCliente || {})) {
    const chave = cpChaveDeLocal(localPorCliente, id);
    const km = kmPorCliente[id];
    if (!(chave in out)) out[chave] = km;
    else if (km != null && (out[chave] == null || km < out[chave])) out[chave] = km;
  }
  return out;
}
function cpNormalizarLocal(texto) {
  return String(texto || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/\s+/g, " ").trim();
}
function cpChaveDeLocal(localPorCliente, clienteId) {
  const l = cpNormalizarLocal((localPorCliente || {})[clienteId]);
  return l || `\0${clienteId}`;
}
function cpOrdemPorProximidade(kmPorCliente, localPorCliente) {
  const km = kmPorCliente || {};
  const porLocal = localPorCliente ? cpKmDaRotaPorLocal(km, localPorCliente) : null;
  const antes = (a, b) => {
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;
    return a - b;
  };
  return (ga, gb) => {
    if (porLocal) {
      const la = cpChaveDeLocal(localPorCliente, ga.key);
      const lb = cpChaveDeLocal(localPorCliente, gb.key);
      if (la !== lb) {
        const d2 = antes(porLocal[la], porLocal[lb]);
        return d2 !== 0 ? d2 : String(la).localeCompare(String(lb), "pt");
      }
    }
    const d = antes(km[ga.key], km[gb.key]);
    return d !== 0 ? d : String(ga.key).localeCompare(String(gb.key), "pt");
  };
}
const CP_RECOLHA_MIN = CP_DESCARGA_MIN;
const CP_COR_RECOLHA = "#0f766e";
function cpRecolhasOrdenadas(carga) {
  return [...carga && carga.recolhas || []].sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
}
function cpOrdemFisica(paragens) {
  return (paragens || []).slice().reverse().map((p, i) => ({
    ...p,
    posicaoCarga: i + 1,
    zona: i === 0 ? "fundo" : i === paragens.length - 1 ? "porta" : "meio"
  }));
}
function cpM(v) {
  return Number(v || 0).toFixed(2).replace(".", ",");
}
function cpPegada(entrega, alturaCamiao) {
  const largura = Number(entrega && entrega.paleteLargura) || 0;
  const profundidade = Number(entrega && entrega.paleteProfundidade) || 0;
  if (largura <= 0 || profundidade <= 0) return null;
  const camadas = cpCamadas(entrega && entrega.paleteAltura, alturaCamiao);
  return { largura, profundidade, camadas, key: `${largura}x${profundidade}x${camadas}` };
}
function cpPegadaDoPacote(pacote, alturaCamiao) {
  const largura = (Number(pacote && pacote.larguraCm) || 0) / 100;
  const profundidade = (Number(pacote && pacote.comprimentoCm) || 0) / 100;
  if (largura <= 0 || profundidade <= 0) return null;
  const camadas = cpCamadas((Number(pacote && pacote.alturaCm) || 0) / 100, alturaCamiao);
  return { largura, profundidade, camadas, key: `${largura}x${profundidade}x${camadas}` };
}
function cpMelhorArranjo(n, pegada, larguraCamiao) {
  if (!pegada || !n || n <= 0) return null;
  const W = larguraCamiao || CP_LARGURA_UTIL;
  const porFilaComprido = Math.floor(W / pegada.largura) * pegada.camadas;
  const porFilaLado = Math.floor(W / pegada.profundidade) * pegada.camadas;
  if (porFilaComprido <= 0 && porFilaLado <= 0) return null;
  let melhor = null;
  const maxComprido = porFilaComprido > 0 ? Math.ceil(n / porFilaComprido) : 0;
  for (let a = 0; a <= maxComprido; a++) {
    const restam = n - a * porFilaComprido;
    let b = 0;
    if (restam > 0) {
      if (porFilaLado <= 0) continue;
      b = Math.ceil(restam / porFilaLado);
    }
    const metros = a * pegada.profundidade + b * pegada.largura;
    if (!melhor || metros < melhor.metros) melhor = { a, b, metros };
  }
  if (!melhor) return null;
  return {
    filasComprido: melhor.a,
    filasLado: melhor.b,
    porFilaComprido,
    porFilaLado,
    largura: pegada.largura,
    profundidade: pegada.profundidade,
    camadas: pegada.camadas,
    paletes: n,
    metros: Number(melhor.metros.toFixed(2))
  };
}
function cpRepartirCorrida(arranjo, contribuicoes) {
  const filas = [];
  for (let i2 = 0; i2 < arranjo.filasComprido; i2++) {
    filas.push({ cap: arranjo.porFilaComprido, custo: arranjo.profundidade, usadas: 0, por: /* @__PURE__ */ new Map() });
  }
  for (let i2 = 0; i2 < arranjo.filasLado; i2++) {
    filas.push({ cap: arranjo.porFilaLado, custo: arranjo.largura, usadas: 0, por: /* @__PURE__ */ new Map() });
  }
  let i = 0;
  for (const c of contribuicoes) {
    let restam = c.paletes;
    while (restam > 0 && i < filas.length) {
      const fila = filas[i];
      const livres = fila.cap - fila.usadas;
      const usa = Math.min(livres, restam);
      if (usa > 0) {
        fila.por.set(c.clienteId, (fila.por.get(c.clienteId) || 0) + usa);
        fila.usadas += usa;
        restam -= usa;
      }
      if (fila.usadas >= fila.cap) i += 1;
    }
  }
  const porCliente = /* @__PURE__ */ new Map();
  for (const fila of filas) {
    if (!fila.usadas) continue;
    for (const [clienteId, qtd] of fila.por) {
      const parte = fila.custo * (qtd / fila.usadas);
      porCliente.set(clienteId, (porCliente.get(clienteId) || 0) + parte);
    }
  }
  return porCliente;
}
function cpResumoArranjo(corridas) {
  const comprido = (corridas || []).reduce((s, c) => s + c.filasComprido, 0);
  const lado = (corridas || []).reduce((s, c) => s + c.filasLado, 0);
  const partes = [];
  if (comprido) partes.push(`${comprido} ${comprido === 1 ? "fila" : "filas"} ao comprido`);
  if (lado) partes.push(`${lado} ${lado === 1 ? "fila" : "filas"} de lado`);
  return partes.join(" + ");
}
function cpDetalheArranjo(corridas) {
  return (corridas || []).map((c) => {
    const clientes = c.clientesNomes.join(" + ");
    const filas = [
      c.filasComprido ? `${c.filasComprido} ao comprido` : "",
      c.filasLado ? `${c.filasLado} de lado` : ""
    ].filter(Boolean).join(" + ");
    return `${clientes}: ${c.paletes} pal. (${cpM(c.largura)}\xD7${cpM(c.profundidade)} m${c.camadas > 1 ? `, ${c.camadas} camadas` : ""}) \u2014 ${filas} = ${cpM(c.metros)} m`;
  }).join("\n");
}
function cpOcupacao(carga, dados) {
  const camiao = cpCamiaoDaCarga(carga, dados);
  const capacidade = camiao && camiao.capacidade != null ? Number(camiao.capacidade) : 0;
  const paragens = cpParagens(carga, dados);
  const ocupadas = paragens.reduce((s, p) => s + p.paletes, 0);
  const fisica = cpOrdemFisica(paragens);
  const larguraCamiao = camiao && camiao.larguraUtil || CP_LARGURA_UTIL;
  const alturaCamiao = camiao && camiao.alturaUtil || null;
  let empilhadas = 0;
  let metros = 0;
  let semMedida = 0;
  let semPaletes = 0;
  let semMedidaVolumes = 0;
  const esteira = [];
  for (const p of fisica) {
    for (const a of p.artigos) {
      if (!a.entrega.unPorPalete) semPaletes += 1;
      if (!a.paletes || a.paletes <= 0) continue;
      const pegada = cpPegada(a.entrega, alturaCamiao);
      if (!pegada) {
        semMedida += 1;
        continue;
      }
      esteira.push({ clienteId: p.clienteId, paletes: a.paletes, pegada });
    }
    if (p.amostra) {
      for (const pk of cpPacotesDaParagem(carga, p)) {
        const n = Math.max(0, Math.round(Number(pk.quantidade) || 0));
        if (!n) continue;
        const pegada = cpPegadaDoPacote(pk, alturaCamiao);
        if (!pegada) {
          semMedida += 1;
          semMedidaVolumes += 1;
          continue;
        }
        esteira.push({ clienteId: p.clienteId, paletes: n, pegada });
      }
    }
  }
  const corridas = [];
  for (const item of esteira) {
    const atual = corridas[corridas.length - 1];
    if (atual && atual.pegada.key === item.pegada.key) {
      atual.paletes += item.paletes;
      atual.contribuicoes.push({ clienteId: item.clienteId, paletes: item.paletes });
    } else {
      corridas.push({
        pegada: item.pegada,
        paletes: item.paletes,
        contribuicoes: [{ clienteId: item.clienteId, paletes: item.paletes }]
      });
    }
  }
  const porCliente = /* @__PURE__ */ new Map();
  const arranjos = [];
  for (const corrida of corridas) {
    const arranjo = cpMelhorArranjo(corrida.paletes, corrida.pegada, larguraCamiao);
    if (!arranjo) {
      semMedida += corrida.contribuicoes.length;
      continue;
    }
    metros += arranjo.metros;
    if (corrida.pegada.camadas > 1) empilhadas += corrida.contribuicoes.length;
    const repartido = cpRepartirCorrida(arranjo, corrida.contribuicoes);
    for (const [clienteId, parte] of repartido) {
      porCliente.set(clienteId, (porCliente.get(clienteId) || 0) + parte);
    }
    const idsUnicos = [...new Set(corrida.contribuicoes.map((c) => c.clienteId))];
    arranjos.push({
      clientesIds: idsUnicos,
      clientesNomes: idsUnicos.map((id) => {
        const pp = fisica.find((x) => x.clienteId === id);
        return pp && pp.cliente && pp.cliente.nome || String(id);
      }),
      paletes: arranjo.paletes,
      largura: arranjo.largura,
      profundidade: arranjo.profundidade,
      camadas: arranjo.camadas,
      filasComprido: arranjo.filasComprido,
      filasLado: arranjo.filasLado,
      metros: arranjo.metros
    });
  }
  metros = Number(metros.toFixed(2));
  const metrosCapacidade = camiao && camiao.metros || 0;
  const base = {
    capacidade,
    ocupadas,
    metros,
    metrosCapacidade,
    metrosDisponiveis: Number(Math.max(0, metrosCapacidade - metros).toFixed(2)),
    metrosExcedeu: metrosCapacidade > 0 && metros > metrosCapacidade,
    metrosPct: metrosCapacidade > 0 ? Math.round(metros / metrosCapacidade * 100) : 0,
    semMedida,
    semMedidaVolumes,
    semPaletes,
    empilhadas,
    // `capacidade === 0` é "sem limite em paletes" (a frota guardada mede-se em
    // metros) — e sem limite nada excede. Sem esta guarda, QUALQUER carga num
    // camião da frota aparecia como excesso de capacidade.
    disponiveis: capacidade > 0 ? Math.max(0, capacidade - ocupadas) : 0,
    excedente: capacidade > 0 ? Math.max(0, ocupadas - capacidade) : 0,
    excedeu: capacidade > 0 && ocupadas > capacidade,
    pct: capacidade > 0 ? Math.round(ocupadas / capacidade * 100) : 0,
    // Os metros de cada cliente são a soma do que lhe coube em CADA corrida
    // — incluindo fatias de filas partilhadas com o vizinho (`arranjo`,
    // acima). Um cliente sem nenhuma linha medível fica com metros 0, não
    // omitido: continua a ter paletes e cor no desenho do camião.
    segmentos: fisica.map((p) => {
      const m = porCliente.get(p.clienteId) || 0;
      return {
        clienteId: p.clienteId,
        cliente: p.cliente,
        cor: p.cliente.cor,
        paletes: p.paletes,
        metros: Number(m.toFixed(2)),
        ordemEntrega: p.ordem,
        posicaoCarga: p.posicaoCarga,
        pct: metrosCapacidade > 0 ? Math.round(m / metrosCapacidade * 100) : 0
      };
    }),
    // O arranjo físico — quantas filas em cada orientação, e o detalhe por
    // corrida — para o ecrã poder dizer COMO carregar, não só quanto ocupa.
    arranjo: {
      filasComprido: arranjos.reduce((s, c) => s + c.filasComprido, 0),
      filasLado: arranjos.reduce((s, c) => s + c.filasLado, 0),
      resumo: cpResumoArranjo(arranjos),
      detalhe: cpDetalheArranjo(arranjos),
      corridas: arranjos
    }
  };
  if (cpEhTransitario(camiao)) {
    return {
      ...base,
      transitario: true,
      excedeu: false,
      metrosExcedeu: false,
      excedente: 0
    };
  }
  return { ...base, transitario: false };
}
function cpTextoSemMedida(ocupacao) {
  const total = ocupacao && Number(ocupacao.semMedida) || 0;
  if (!total) return "";
  const vol = ocupacao && Number(ocupacao.semMedidaVolumes) || 0;
  const linhas = Math.max(0, total - vol);
  const fim = " \u2014 n\xE3o entram na conta, por isso os metros s\xE3o um M\xCDNIMO";
  if (!vol) {
    return `${linhas} linha(s) sem dimens\xF5es de palete no ERP${fim}`;
  }
  if (!linhas) {
    return `${vol} volume(s) de amostra sem medidas escritas${fim}`;
  }
  return `${total} sem medidas: ${linhas} linha(s) do ERP sem dimens\xF5es de palete e ${vol} volume(s) de amostra por medir${fim}`;
}
function cpKitsDaLista(linhas) {
  const lista = linhas || [];
  const ids = new Set(lista.map((l) => l && l.id || "").filter(Boolean));
  const porKit = {};
  const soltas = [];
  for (const l of lista) {
    const kit = l && l.kitBistamp || "";
    if (kit && ids.has(kit)) {
      if (!porKit[kit]) porKit[kit] = [];
      porKit[kit].push(l);
    } else {
      soltas.push(l);
    }
  }
  return { porKit, soltas };
}
function cpKitsDeQuantidades(porComponente, razoes) {
  const ids = Object.keys(porComponente || {});
  if (!ids.length) return null;
  let min = null;
  for (const id of ids) {
    const razao = Number((razoes || {})[id]);
    if (!Number.isFinite(razao) || razao <= 0) return null;
    const kits = Math.floor((Number(porComponente[id]) || 0) / razao);
    if (min == null || kits < min) min = kits;
  }
  return min;
}
function cpKitAtribuido(kit, componentes, cargas) {
  const porComponente = {};
  const razoes = {};
  for (const c of componentes || []) {
    if (!c || !c.id) continue;
    porComponente[c.id] = cpAtribuidoDaLinha(c, cargas);
    razoes[c.id] = c.kitRazao;
  }
  const kits = cpKitsDeQuantidades(porComponente, razoes);
  return { kits: kits == null ? 0 : kits, sabe: kits != null, porComponente, razoes };
}
function cpKitPorAtribuir(kit, componentes, cargas) {
  const r = cpKitAtribuido(kit, componentes, cargas);
  const total = Number(kit && kit.qtdTotal) || 0;
  if (!r.sabe) {
    return {
      kits: null,
      sabe: false,
      atribuidos: r.kits,
      excesso: 0,
      total,
      porComponente: r.porComponente
    };
  }
  return {
    kits: Math.max(0, total - r.kits),
    sabe: true,
    atribuidos: r.kits,
    excesso: Math.max(0, r.kits - total),
    total,
    porComponente: r.porComponente
  };
}
function cpKitsCobertos(componente) {
  const razao = Number(componente && componente.kitRazao) || 0;
  if (razao <= 0) return null;
  const disponivel = Number(componente && componente.qtdDisponivel) || 0;
  return Math.max(0, Math.floor(disponivel / razao));
}
function cpAgregadoDoKit(kit, componentes) {
  const comps = (componentes || []).filter(Boolean);
  let paletes = 0;
  let semPaletes = 0;
  let semMedida = 0;
  let semRazao = 0;
  let metros = 0;
  let stockPior = null;
  const razoes = [];
  const esteira = [];
  for (const c of comps) {
    if (!c.unPorPalete) semPaletes += 1;
    const n = cpPaletes(c.qtdTotal, c.unPorPalete);
    paletes += n;
    if (n > 0) {
      const pegada = cpPegada(c, null);
      if (!pegada) semMedida += 1;
      else esteira.push({ paletes: n, pegada });
    }
    const razao = Number(c.kitRazao) || 0;
    if (razao > 0 && !razoes.includes(razao)) razoes.push(razao);
    const cobre = cpKitsCobertos(c);
    if (cobre === null) {
      semRazao += 1;
      continue;
    }
    if (!stockPior || cobre < stockPior.cobre) {
      stockPior = {
        bistamp: c.id || "",
        ref: c.ref || "",
        cobre,
        razao,
        disponivel: Number(c.qtdDisponivel) || 0
      };
    }
  }
  const corridas = [];
  for (const item of esteira) {
    const atual = corridas[corridas.length - 1];
    if (atual && atual.pegada.key === item.pegada.key) {
      atual.paletes += item.paletes;
      atual.linhas += 1;
    } else {
      corridas.push({ pegada: item.pegada, paletes: item.paletes, linhas: 1 });
    }
  }
  for (const corrida of corridas) {
    const arranjo = cpMelhorArranjo(corrida.paletes, corrida.pegada, CP_LARGURA_UTIL);
    if (!arranjo) {
      semMedida += corrida.linhas;
      continue;
    }
    metros += arranjo.metros;
  }
  return {
    componentes: comps.length,
    paletes,
    metros: Number(metros.toFixed(2)),
    // `null` = nenhum componente soube responder (sem componentes, ou nenhum
    // com razão conhecida). Nunca um número: o ecrã tem de poder dizer que
    // não sabe em vez de pintar verde.
    stockPior,
    semMedida,
    semPaletes,
    semRazao,
    // As razões presentes, sem repetir — para o ecrã poder resumir «×1 · ×2»
    // sem percorrer os componentes. A razão de CADA um continua a viver no
    // `kitRazao` dele, que é a única fonte.
    razoes: razoes.sort((a, b) => a - b)
  };
}
function cpCorDoKit(kit, agregado, componentes, dia) {
  if (!kit || !agregado) return "";
  const total = Number(kit.qtdTotal) || 0;
  const pior = agregado.stockPior;
  if (total > 0 && !agregado.semRazao && pior && pior.cobre >= total) return "stock";
  const comps = (componentes || []).filter(Boolean);
  if (!comps.length) return "";
  return comps.every((c) => cpCorDaLinha(c, dia)) ? "planeado" : "";
}
function cpCoberturaDoKit(kit, agregado) {
  const total = Number(kit && kit.qtdTotal) || 0;
  const pior = agregado && agregado.stockPior;
  if (!pior) return { disponivel: 0, total, sabe: false };
  return { disponivel: pior.cobre, total, sabe: !agregado.semRazao };
}
const CP_TEMPO_PREP_OMISSAO = Object.freeze({
  minutos_por_palete: 6,
  minutos_minimos_linha: 10,
  margem_picking_pct: 10,
  recuo_max_dias_uteis: 2
});
function cpTempoPreparacaoLinha(paletes, parametros) {
  const p = parametros || CP_TEMPO_PREP_OMISSAO;
  const minPorPalete = Number(p.minutos_por_palete) || 0;
  const minimo = Number(p.minutos_minimos_linha) || 0;
  const porPalete = (Number(paletes) || 0) * minPorPalete;
  return Math.max(minimo, porPalete);
}
function cpTempoPreparacao(carga, dados) {
  const p = dados && dados.parametrosPreparacao || CP_TEMPO_PREP_OMISSAO;
  const paragens = cpParagens(carga, dados);
  let minutos = 0;
  let linhas = 0;
  let paletes = 0;
  let comMinimo = 0;
  const minPorPalete = Number(p.minutos_por_palete) || 0;
  for (const par of paragens) {
    for (const a of par.artigos) {
      linhas += 1;
      const t = cpTempoPreparacaoLinha(a.paletes, p);
      minutos += t;
      paletes += Number(a.paletes) || 0;
      if (t > (Number(a.paletes) || 0) * minPorPalete) comMinimo += 1;
    }
  }
  return {
    minutos: Math.round(minutos),
    linhas,
    paletes,
    comMinimo,
    minutosPorPalete: minPorPalete,
    minutosMinimosLinha: Number(p.minutos_minimos_linha) || 0
  };
}
function cpEuros(v) {
  return Number((Number(v) || 0).toFixed(2)) + 0;
}
function cpTarifaDaCarga(carga, dados) {
  if (!carga) return null;
  if (carga.custo) return { ...carga.custo, origem: "carga" };
  const t = cpTarifaDoCatalogo(carga, dados);
  return t ? { ...t, origem: "tarifa" } : null;
}
function cpTarifaDoCatalogo(carga, dados) {
  const camiao = cpCamiaoDaCarga(carga, dados);
  if (!camiao || camiao.transportadoraId == null || camiao.tipoId == null) return null;
  return (dados && dados.tarifas || []).find(
    (x) => x.transportadoraId === camiao.transportadoraId && x.tipoId === camiao.tipoId && x.ativo
  ) || null;
}
const CP_ZONA_LIGACOES = /* @__PURE__ */ new Set(["DE", "DO", "DA", "DOS", "DAS", "E"]);
function cpChaveDeZona(texto) {
  return cpNormalizarLocal(String(texto || "").replace(/[.,;:/()\-\u2013\u2014]/g, " ")).split(" ").filter((p) => p && !CP_ZONA_LIGACOES.has(p)).join(" ");
}
function cpRotuloDaZona(z) {
  if (!z) return "";
  const destino = z.concelho ? `${z.concelho} (${z.distrito})` : `${z.distrito} (distrito)`;
  return z.origem ? `${destino}, a partir de ${z.origem}` : destino;
}
function cpZonaDoDestino(zonas, origem, distrito, concelho) {
  const dk = cpChaveDeZona(distrito);
  const ck = cpChaveDeZona(concelho);
  if (!dk) return { motivo: "sem_zona" };
  const ok = cpChaveDeZona(origem);
  const doDistrito = (zonas || []).filter((z) => cpChaveDeZona(z.distrito) === dk);
  const niveis = ok ? [ok, ""] : [""];
  for (const o of niveis) {
    const daOrigem = doDistrito.filter((z) => cpChaveDeZona(z.origem) === o);
    const exacta = ck && daOrigem.find((z) => z.concelho && cpChaveDeZona(z.concelho) === ck);
    if (exacta) return { zona: exacta };
    const distritoTodo = daOrigem.find((z) => !cpChaveDeZona(z.concelho));
    if (distritoTodo) return { zona: distritoTodo };
  }
  if (!ck) return { motivo: "sem_zona" };
  if (doDistrito.length) return { motivo: "concelho_por_casar" };
  return { motivo: "fora_de_zona" };
}
const CP_MOTIVOS_ZONA = [
  "sem_zona",
  "concelho_por_casar",
  "fora_de_zona",
  "zona_nao_serve",
  "zona_preco_a_definir"
];
function cpPrecoPorZona(carga, dados, tarifa) {
  const catalogo = cpTarifaDoCatalogo(carga, dados);
  const zonas = catalogo && catalogo.zonas || tarifa && tarifa.zonas || [];
  const origem = carga && carga.origemId || "";
  const paragens = cpParagens(carga, dados);
  if (!paragens.length) {
    const aChegar = (carga && carga.linhas || []).length > 0;
    return { motivo: "sem_zona", paragem: null, destino: null, aChegar };
  }
  const falhas = [];
  let melhor = null;
  for (const p of paragens) {
    const nome = p.cliente && p.cliente.nome || String(p.clienteId);
    if (p.amostra) {
      falhas.push({ motivo: "sem_zona", paragem: nome, destino: null });
      continue;
    }
    const vistos = /* @__PURE__ */ new Set();
    for (const a of p.artigos || []) {
      const e = a.entrega || {};
      const chave = `${cpChaveDeZona(e.distrito)}|${cpChaveDeZona(e.concelho)}`;
      if (vistos.has(chave)) continue;
      vistos.add(chave);
      const destino = { distrito: e.distrito || "", concelho: e.concelho || "" };
      const r = cpZonaDoDestino(zonas, origem, e.distrito, e.concelho);
      if (r.motivo) {
        falhas.push({ motivo: r.motivo, paragem: nome, destino });
        continue;
      }
      if (r.zona.situacao === "nao_serve") {
        falhas.push({ motivo: "zona_nao_serve", paragem: nome, destino, zona: r.zona });
        continue;
      }
      const preco = r.zona.situacao === "preco" ? Number(r.zona.preco) : NaN;
      if (!Number.isFinite(preco)) {
        falhas.push({ motivo: "zona_preco_a_definir", paragem: nome, destino, zona: r.zona });
        continue;
      }
      if (!melhor || preco > melhor.preco) melhor = { preco, zona: r.zona, destino, paragem: nome };
    }
  }
  if (falhas.length) {
    return falhas.sort((x, y) => CP_MOTIVOS_ZONA.indexOf(x.motivo) - CP_MOTIVOS_ZONA.indexOf(y.motivo))[0];
  }
  const descargas = paragens.length;
  return {
    ...melhor,
    descargas,
    descargasExtra: Math.max(0, descargas - (Number(tarifa && tarifa.paragensIncluidas) || 0))
  };
}
function cpTextoSemCustoZona(carga, dados) {
  const tarifa = cpTarifaDaCarga(carga, dados);
  if (!tarifa || tarifa.aluguerModo !== "zona") return null;
  if (cpEhTransitario(cpCamiaoDaCarga(carga, dados))) return null;
  const r = cpPrecoPorZona(carga, dados, tarifa);
  if (!r.motivo) return null;
  const quem = r.paragem ? `\xAB${r.paragem}\xBB` : "Esta carga";
  const onde = r.destino ? [r.destino.concelho, r.destino.distrito].filter(Boolean).join(", ") || "sem nada" : "";
  const textos = {
    sem_zona: {
      curto: "sem zona",
      longo: r.paragem ? `${quem} n\xE3o tem distrito e concelho na morada de entrega do PHC \u2014 sem eles n\xE3o se sabe a zona. Corrige-se na morada, no PHC; a tarifa n\xE3o tem culpa.` : r.aChegar ? "As entregas desta carga ainda n\xE3o chegaram do ERP \u2014 sem elas n\xE3o se sabe a zona. Volta daqui a um instante." : "Esta carga s\xF3 tem recolhas: a tarifa por zona cobra descargas, e n\xE3o h\xE1 nenhuma."
    },
    concelho_por_casar: {
      curto: "concelho por casar",
      longo: `${quem}: o PHC diz \xAB${onde}\xBB. A tabela tem esse distrito mas nenhum concelho com esse nome \u2014 ou est\xE1 escrito de outra maneira (ou no distrito errado) num dos dois, ou a tabela n\xE3o o tem. N\xE3o se trata como \xABfora de zona\xBB sem algu\xE9m confirmar.`
    },
    fora_de_zona: {
      curto: "fora de zona",
      longo: `${quem}: \xAB${onde}\xBB n\xE3o est\xE1 na tabela desta transportadora. O pre\xE7o fora de zona ainda n\xE3o est\xE1 modelado \u2014 n\xE3o se inventa um.`
    },
    zona_nao_serve: {
      curto: "ve\xEDculo n\xE3o serve",
      longo: `${quem}: a tabela diz que este tipo de ve\xEDculo N\xC3O faz \xAB${onde}\xBB (0 na tabela n\xE3o \xE9 gr\xE1tis). Escolhe outro tipo de ve\xEDculo ou outra transportadora.`
    },
    zona_preco_a_definir: {
      curto: "pre\xE7o a definir",
      longo: `${quem}: a tabela tem \xAB${onde}\xBB com o pre\xE7o A DEFINIR \u2014 \xE9 uma rota que obriga a perguntar. Sem esse pre\xE7o n\xE3o se sabe se n\xE3o era ela a zona mais distante.`
    }
  };
  return textos[r.motivo] || null;
}
const CP_ESTADOS_SEM_VIAGEM = ["cancelada", "bloqueada"];
const CP_ESTADOS_QUE_FECHAM = ["planeada", "em_preparacao"];
function cpRotuloDaCarga(carga) {
  if (!carga) return null;
  const v = Number(carga.viagem) || 1;
  return v > 1 ? `${carga.camiaoId} \xB7 ${v}\xAA` : carga.camiaoId;
}
function cpCaisCanonico(codigo) {
  const t = String(codigo == null ? "" : codigo).trim().toUpperCase();
  return t || null;
}
function cpKmFaturados(percurso, carga) {
  if (!percurso || !Number.isFinite(percurso.kmTotal)) return null;
  const algumKmDesconhecido = (percurso.pontos || []).some((p) => !Number.isFinite(p.km));
  if (algumKmDesconhecido) return null;
  if (carga && carga.regressoFaturado) return Number(percurso.kmTotal.toFixed(1));
  const volta = (percurso.pontos || []).find((p) => p.tipo === "regresso");
  return Number((percurso.kmTotal - (volta ? volta.km || 0 : 0)).toFixed(1));
}
function cpViagensPagas(cargas, camiaoId, dia) {
  const comCarga = (cargas || []).filter(
    (c) => c.camiaoId === camiaoId && c.dia === dia && (c.linhas || []).length > 0 && !CP_ESTADOS_SEM_VIAGEM.includes(c.estado)
  );
  return Math.max(1, comCarga.length);
}
function cpValorDaCarga(carga, dados) {
  const entregas = cpIndexar(dados && dados.entregas || []);
  let valor = 0;
  let semValor = 0;
  for (const l of carga && carga.linhas || []) {
    const e = entregas[l.entregaId];
    if (!e) {
      semValor += 1;
      continue;
    }
    const total = Number(e.valor) || 0;
    if (!total) {
      semValor += 1;
      continue;
    }
    const qtdTotal = Number(e.qtdTotal);
    if (!Number.isFinite(qtdTotal) || qtdTotal <= 0) {
      semValor += 1;
      continue;
    }
    const proporcao = Math.min(1, (Number(l.qtd) || 0) / qtdTotal);
    valor += total * proporcao;
  }
  return { valor: cpEuros(valor), semValor };
}
function cpParseDecimal(v) {
  if (typeof v === "number") return Number.isFinite(v) ? v : 0;
  if (v == null) return 0;
  const s = String(v).trim().replace(",", ".");
  if (s === "") return 0;
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}
function cpDecimalOuNulo(v) {
  if (v == null) return null;
  const s = String(v).trim().replace(",", ".");
  if (s === "") return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}
const CP_CUSTO_CAMPOS_NUM = [
  "aluguer",
  "km",
  "paragensIncluidas",
  "paragem",
  "regresso",
  "sobretaxaPct"
];
function cpCamposPrecoNegativos(custo) {
  if (!custo) return [];
  return CP_CUSTO_CAMPOS_NUM.filter((campo) => cpParseDecimal(custo[campo]) < 0);
}
function cpCustoConvertido(custo) {
  if (!custo) return null;
  return {
    aluguer: cpParseDecimal(custo.aluguer),
    aluguerModo: custo.aluguerModo || "viagem",
    km: cpParseDecimal(custo.km),
    paragensIncluidas: Math.round(cpParseDecimal(custo.paragensIncluidas)),
    paragem: cpParseDecimal(custo.paragem),
    regresso: cpParseDecimal(custo.regresso),
    sobretaxaPct: cpParseDecimal(custo.sobretaxaPct),
    origemTarifaId: custo.origemTarifaId != null ? custo.origemTarifaId : null,
    copiadoEm: custo.copiadoEm || null
  };
}
function cpCargaHipotetica(carga, edicao) {
  const e = edicao || {};
  return {
    ...carga,
    custo: e.custo ? cpCustoConvertido(e.custo) : null,
    transporte: {
      ...carga.transporte || {},
      transportadoraId: e.transportadoraId ? Number(e.transportadoraId) : null,
      tipoId: e.tipoId ? Number(e.tipoId) : null
    }
  };
}
function cpCustoDaCarga(carga, dados, percurso) {
  const semLinhas = !(carga && carga.linhas || []).length;
  const semRecolhas = !(carga && carga.recolhas || []).length;
  if (semLinhas && semRecolhas) return null;
  if (cpEhTransitario(cpCamiaoDaCarga(carga, dados))) {
    const t = cpTotaisDosPacotes(carga && carga.pacotes || []);
    if (!t.volumes) return null;
    return {
      total: t.valor,
      transitario: true,
      volumes: t.volumes,
      semValor: t.semValor,
      km: 0,
      // `cpCustoDoDia` acumula `totalBruto` (não arredondado) para não somar
      // arredondamentos já feitos e arredondar tudo outra vez a seguir — aqui
      // `t.valor` já é o único total que esta conta tem.
      totalBruto: t.valor
    };
  }
  const tarifa = cpTarifaDaCarga(carga, dados);
  if (!tarifa) return null;
  if (tarifa.aluguerModo === "zona") return cpCustoPorZona(carga, dados, percurso, tarifa);
  const km = cpKmFaturados(percurso, carga);
  if (km == null) return null;
  const entregas = cpIndexar(dados && dados.entregas || []);
  const semEntregas = (carga && carga.linhas || []).filter((l) => !entregas[l.entregaId]).length;
  const paragens = cpParagens(carga, dados).length + cpRecolhasOrdenadas(carga).length;
  const extra = Math.max(0, paragens - (Number(tarifa.paragensIncluidas) || 0));
  const custoKm = (Number(tarifa.km) || 0) * km;
  const combustivel = custoKm * (Number(tarifa.sobretaxaPct) || 0) / 100;
  const viagens = tarifa.aluguerModo === "dia" ? cpViagensPagas(dados && dados.cargas || [], carga.camiaoId, carga.dia) : 1;
  const aluguer = (Number(tarifa.aluguer) || 0) / viagens;
  const paragensCusto = (Number(tarifa.paragem) || 0) * extra;
  const regresso = carga.regressoFaturado ? Number(tarifa.regresso) || 0 : 0;
  const totalBruto = aluguer + custoKm + combustivel + paragensCusto + regresso;
  return {
    origem: tarifa.origem,
    km,
    viagensPagas: viagens,
    paragens,
    paragensExtra: extra,
    semEntregas,
    aluguer: cpEuros(aluguer),
    custoKm: cpEuros(custoKm),
    combustivel: cpEuros(combustivel),
    paragensCusto: cpEuros(paragensCusto),
    regresso: cpEuros(regresso),
    total: cpEuros(totalBruto),
    // Não arredondado — é o que `cpCustoDoDia` acumula, para não somar
    // arredondamentos já feitos e arredondar tudo outra vez a seguir.
    totalBruto
  };
}
function cpCustoPorZona(carga, dados, percurso, tarifa) {
  const r = cpPrecoPorZona(carga, dados, tarifa);
  if (r.motivo) return null;
  const entregas = cpIndexar(dados && dados.entregas || []);
  const semEntregas = (carga && carga.linhas || []).filter((l) => !entregas[l.entregaId]).length;
  const km = cpKmFaturados(percurso, carga);
  const paragensCusto = (Number(tarifa.paragem) || 0) * r.descargasExtra;
  const regresso = carga.regressoFaturado ? Number(tarifa.regresso) || 0 : 0;
  const totalBruto = r.preco + paragensCusto + regresso;
  return {
    origem: tarifa.origem,
    zona: { ...r.zona, rotulo: cpRotuloDaZona(r.zona), paragem: r.paragem },
    // Os km só servem o rácio €/km; sem eles o rácio cala-se, o preço não.
    km: km == null ? 0 : km,
    viagensPagas: 1,
    paragens: r.descargas,
    paragensExtra: r.descargasExtra,
    semEntregas,
    aluguer: cpEuros(r.preco),
    custoKm: 0,
    combustivel: 0,
    paragensCusto: cpEuros(paragensCusto),
    regresso: cpEuros(regresso),
    total: cpEuros(totalBruto),
    totalBruto
  };
}
function cpMotivoSemCusto(carga, dados, percurso) {
  const semLinhas = !(carga && carga.linhas || []).length;
  const semRecolhas = !(carga && carga.recolhas || []).length;
  if (semLinhas && semRecolhas) return "sem_planeamento";
  if (cpEhTransitario(cpCamiaoDaCarga(carga, dados))) {
    return (carga && carga.pacotes || []).length ? null : "transitario_sem_volumes";
  }
  const tarifa = cpTarifaDaCarga(carga, dados);
  if (!tarifa) return "sem_tarifa";
  if (tarifa.aluguerModo === "zona") return cpPrecoPorZona(carga, dados, tarifa).motivo || null;
  const km = cpKmFaturados(percurso, carga);
  if (km == null) return "sem_km";
  return null;
}
function cpRaciosDaCarga(custo, ocupacao, valorMercadoria) {
  if (!custo) return null;
  const t = Number(custo.total) || 0;
  const oc = ocupacao || {};
  const valor = Number(valorMercadoria) || 0;
  return {
    pctValor: valor > 0 ? Number((t / valor * 100).toFixed(1)) : null,
    // I1 — com linhas «s/ paletes» (`unPorPalete` desconhecido, 40 % das
    // linhas) `oc.ocupadas` é um total PARCIAL: dividir por ele dava um
    // €/palete demasiado alto e com ar de exato. Mesma defesa que `porMetro`
    // já tinha para o `semMedida`.
    porPalete: !oc.semPaletes && (Number(oc.ocupadas) || 0) > 0 ? cpEuros(t / oc.ocupadas) : null,
    // Com linhas «s/ medida» os metros são um total PARCIAL: dividir por eles
    // dava um €/m demasiado alto e com ar de exato.
    porMetro: !oc.semMedida && (Number(oc.metros) || 0) > 0 ? cpEuros(t / oc.metros) : null,
    // Em modo zona o preço vem da tabela de zonas, não dos km: dividir por
    // eles daria um €/km sem significado (cartão #173).
    porKm: !custo.zona && (Number(custo.km) || 0) > 0 ? cpEuros(t / custo.km) : null
  };
}
function cpCustoDoDia(dados, dia, percursoPorCarga) {
  const doDia = (dados && dados.cargas || []).filter(
    (c) => c.dia === dia && ((c.linhas || []).length > 0 || (c.recolhas || []).length > 0) && !CP_ESTADOS_SEM_VIAGEM.includes(c.estado)
  );
  let total = 0;
  let valor = 0;
  let valorSemPreco = 0;
  let comPreco = 0;
  let semPreco = 0;
  const semPrecoPorMotivo = {};
  for (const c of doDia) {
    const p = percursoPorCarga && percursoPorCarga[c.id] || cpPercurso(c, dados);
    const custo = cpCustoDaCarga(c, dados, p);
    const valorCarga = cpValorDaCarga(c, dados).valor;
    if (custo) {
      total += custo.totalBruto;
      comPreco += 1;
      valor += valorCarga;
    } else {
      semPreco += 1;
      valorSemPreco += valorCarga;
      const motivo = cpMotivoSemCusto(c, dados, p) || "desconhecido";
      semPrecoPorMotivo[motivo] = (semPrecoPorMotivo[motivo] || 0) + 1;
    }
  }
  return {
    total: cpEuros(total),
    valor: cpEuros(valor),
    valorSemPreco: cpEuros(valorSemPreco),
    comPreco,
    semPreco,
    semPrecoPorMotivo,
    pctValor: valor > 0 ? Number((total / valor * 100).toFixed(1)) : null
  };
}
const CP_MOTIVO_SEM_CUSTO_CURTO = {
  sem_tarifa: "sem tarifa",
  sem_km: "sem km fi\xE1veis",
  transitario_sem_volumes: "transit\xE1rio sem volumes",
  sem_zona: "sem zona",
  concelho_por_casar: "concelho por casar",
  fora_de_zona: "fora de zona",
  zona_nao_serve: "ve\xEDculo n\xE3o serve",
  zona_preco_a_definir: "pre\xE7o a definir",
  desconhecido: "sem pre\xE7o"
};
function cpTextoDoDiaSemPreco(custoDoDia) {
  const n = custoDoDia && custoDoDia.semPreco || 0;
  if (!n) return null;
  const porMotivo = custoDoDia.semPrecoPorMotivo || {};
  const motivos = Object.keys(porMotivo);
  const soTarifa = motivos.length > 0 && motivos.every((m) => m === "sem_tarifa");
  const partes = motivos.map((m) => `${porMotivo[m]} ${CP_MOTIVO_SEM_CUSTO_CURTO[m] || m}`);
  return {
    soTarifa,
    curto: soTarifa ? "sem tarifas \u2014 ver Defini\xE7\xF5es" : partes.join(" \xB7 ") || "sem pre\xE7o",
    longo: soTarifa ? `${n} carga(s) sem tarifa configurada. Configura-as em Defini\xE7\xF5es \u2192 \xABTransportadoras\xBB.` : `${n} carga(s) sem pre\xE7o: ${partes.join(", ")}. Abre cada uma para ver o motivo \u2014 \xABsem tarifa\xBB resolve-se em Defini\xE7\xF5es; os motivos de zona, na morada do PHC ou na tabela de pre\xE7os da transportadora.`
  };
}
function cpCabeNaCarga(carga, dados, entrega, qtd) {
  const camiao = cpCamiaoDaCarga(carga, dados);
  if (cpEhTransitario(camiao)) {
    return {
      ok: true,
      transitario: true,
      paletesExtra: 0,
      totalDepois: 0,
      capacidade: 0,
      metrosDepois: 0,
      metrosCapacidade: 0
    };
  }
  const oc = cpOcupacao(carga, dados);
  const extra = cpPaletes(qtd, entrega && entrega.unPorPalete);
  const total = oc.ocupadas + extra;
  const larguraCamiao = camiao && camiao.larguraUtil || CP_LARGURA_UTIL;
  const alturaCamiao = camiao && camiao.alturaUtil || null;
  const pegada = cpPegada(entrega, alturaCamiao);
  const arranjoExtra = pegada ? cpMelhorArranjo(extra, pegada, larguraCamiao) : null;
  const metrosDepois = Number((oc.metros + (arranjoExtra ? arranjoExtra.metros : 0)).toFixed(2));
  const okPaletes = oc.capacidade > 0 ? total <= oc.capacidade : true;
  const okMetros = oc.metrosCapacidade > 0 && arranjoExtra ? metrosDepois <= oc.metrosCapacidade : true;
  return {
    ok: okPaletes && okMetros,
    transitario: false,
    paletesExtra: extra,
    totalDepois: total,
    capacidade: oc.capacidade,
    metrosDepois,
    metrosCapacidade: oc.metrosCapacidade
  };
}
function cpComItens(carga, itens, dados) {
  const linhas = (carga.linhas || []).slice();
  const ordem = (carga.ordemClientes || []).slice();
  for (const it of itens || []) {
    const qtd = Number(it.qtd) || 0;
    if (qtd <= 0) continue;
    const i = linhas.findIndex((l) => l.entregaId === it.entregaId);
    if (i === -1) linhas.push({ entregaId: it.entregaId, qtd });
    else linhas[i] = { ...linhas[i], qtd: linhas[i].qtd + qtd };
    const cli = cpClienteIdDaEntrega(dados.entregas, it.entregaId);
    if (cli && !ordem.includes(cli)) ordem.push(cli);
  }
  return { ...carga, linhas, ordemClientes: ordem };
}
function cpAvisoAoAdicionar(carga, dados, itens) {
  if (!itens || !itens.length) return null;
  const oc = cpOcupacao(cpComItens(carga, itens, dados), dados);
  if (oc.excedeu) {
    return `Isto p\xF5e ${oc.ocupadas} paletes num cami\xE3o de ${oc.capacidade}. Reduz quantidades ou tira artigos \u2014 a carga n\xE3o pode ser confirmada assim.`;
  }
  if (oc.metrosExcedeu) {
    const ressalva = oc.semMedida ? ` (mais ${oc.semMedida} linha${oc.semMedida === 1 ? "" : "s"} sem medida conhecida \u2014 o excesso pode ser maior)` : "";
    return `Isto p\xF5e ${cpM(oc.metros)} m de carga num cami\xE3o de ${cpM(oc.metrosCapacidade)} m${ressalva}. Reduz quantidades ou tira artigos \u2014 a carga n\xE3o pode ser confirmada assim.`;
  }
  return null;
}
function cpConflitos(cargas, dados, dia) {
  const doDia = (cargas || []).filter((c) => !dia || c.dia === dia);
  const out = [];
  for (const c of doDia) {
    const oc = cpOcupacao(c, dados);
    const camiao = cpCamiaoDaCarga(c, dados);
    const mauHorario = cpParagemComHorarioMau(c, dados, camiao);
    if (oc.excedeu) {
      out.push({
        tipo: "capacidade",
        nivel: "aviso",
        funcionarioId: null,
        cargaId: c.id,
        msg: `O ${c.camiaoId} est\xE1 com ${oc.ocupadas} paletes para uma capacidade de ${oc.capacidade}.`
      });
    } else if (mauHorario) {
      out.push({
        tipo: "horario",
        nivel: "erro",
        funcionarioId: null,
        cargaId: c.id,
        // Diz contra o QUÊ se comparou: com uma chegada combinada, a janela do
        // camião não é quem decidiu, e nomeá-la era mentir.
        // Nomeia o CLIENTE — o `cpParagemComHorarioMau` devolve-o, e o hero
        // já o dizia; um tooltip que diz «um cliente» manda quem o lê abrir a
        // carga para descobrir qual.
        msg: mauHorario.janela && mauHorario.janela.origem === "combinada" ? `O ${c.camiaoId} leva a ${mauHorario.paragem.cliente.nome}, cujo hor\xE1rio de descarga n\xE3o bate com a chegada combinada (${cpTextoDaJanela(mauHorario.janela)}).` : `O ${c.camiaoId} leva a ${mauHorario.paragem.cliente.nome}, cujo hor\xE1rio de descarga n\xE3o bate com a janela do cami\xE3o.`
      });
    } else if (oc.metrosExcedeu) {
      out.push({
        tipo: "capacidade",
        nivel: "aviso",
        funcionarioId: null,
        cargaId: c.id,
        msg: `O ${c.camiaoId} est\xE1 com ${cpM(oc.metros)} m de carga para ${cpM(oc.metrosCapacidade)} m.`
      });
    }
  }
  return out;
}
function cpValidar(carga, dados) {
  const problemas = [];
  if (!carga) return { ok: false, bloqueado: true, problemas: [{ campo: "carga", nivel: "erro", msg: "N\xE3o h\xE1 carga selecionada." }] };
  const camiao = cpCamiaoDaCarga(carga, dados);
  const oc = cpOcupacao(carga, dados);
  const paragens = cpParagens(carga, dados);
  const entregas = cpIndexar(dados.entregas);
  const partidaMin = camiao ? cpHhmm2min(camiao.inicio) : null;
  if (!carga.origemId) problemas.push({ campo: "origem", nivel: "erro", msg: "A carga n\xE3o tem origem definida." });
  if (!(carga.linhas || []).length) problemas.push({ campo: "artigos", nivel: "erro", msg: "A carga n\xE3o tem artigos." });
  if (!oc.transitario) {
    if (oc.excedeu) {
      problemas.push({
        campo: "capacidade",
        nivel: "aviso",
        msg: `Excede a capacidade em ${oc.excedente} palete(s) (${oc.ocupadas}/${oc.capacidade}).`
      });
    } else if (oc.metrosExcedeu) {
      problemas.push({
        campo: "capacidade",
        nivel: "aviso",
        msg: `Excede o comprimento do cami\xE3o: ${cpM(oc.metros)} m para ${cpM(oc.metrosCapacidade)} m.`
      });
    }
  }
  for (const p of paragens) {
    const janelaP = cpJanelaDaParagem(carga, p.clienteId, null);
    if (!cpHorarioCompativel(p.horarios, camiao, janelaP)) {
      problemas.push({
        campo: "horario",
        nivel: "erro",
        // A frase diz contra o QUÊ se comparou: com uma chegada combinada, a
        // janela do camião não é quem decidiu, e nomeá-la era mentir.
        msg: janelaP && janelaP.origem === "combinada" ? `${p.cliente.nome} descarrega em \xAB${String(p.horarios).trim()}\xBB e a chegada combinada \xE9 ${cpTextoDaJanela(janelaP)}.` : `${p.cliente.nome} descarrega em \xAB${String(p.horarios).trim()}\xBB e o ${carga.camiaoId} anda entre as ${camiao.inicio} e as ${camiao.fim}.`
      });
    }
  }
  for (const l of carga.linhas || []) {
    const e = entregas[l.entregaId];
    if (!e) continue;
    const noutras = cpQtdAtribuida(dados.cargas, carga.dia, e.id, carga.id);
    const disponivel = Math.max(0, Number(e.qtdDisponivel) - noutras);
    const d = cpDisponibilidade(e, partidaMin, l.qtd, disponivel);
    if (d === "atrasado") {
      problemas.push({
        campo: "producao",
        nivel: "erro",
        msg: `${e.ref} n\xE3o est\xE1 produzido a tempo da sa\xEDda (previs\xE3o ${e.prevOffset > 0 ? "no dia seguinte" : e.prevDisp}).`
      });
    }
  }
  const semOrdem = paragens.filter(
    (p) => !p.amostra && !(carga.ordemClientes || []).includes(p.clienteId)
  );
  if (semOrdem.length) {
    problemas.push({
      campo: "sequencia",
      nivel: "erro",
      msg: `Sem posi\xE7\xE3o na sequ\xEAncia de entrega: ${semOrdem.map((p) => p.cliente.nome).join(", ")}.`
    });
  }
  return {
    ok: problemas.length === 0,
    bloqueado: problemas.some((p) => p.nivel === "erro"),
    problemas
  };
}
function cpProximoEstado(estado, fluxo) {
  const f = fluxo || [];
  const i = f.indexOf(estado);
  if (i === -1 || i === f.length - 1) return null;
  return f[i + 1];
}
function cpClienteIdDaEntrega(entregas, entregaId) {
  const e = (entregas || []).find((x) => x.id === entregaId);
  return e ? e.clienteId : void 0;
}
function cpEntregasGuardadas(guardadas, ate) {
  if (!guardadas || guardadas.ate !== ate || !Array.isArray(guardadas.entregas)) return null;
  return guardadas.entregas;
}
function cpCamiaoDoTir(tir) {
  const num = (v, alt) => v == null || v === "" ? alt : Number(v);
  const texto = (v) => v ? String(v) : null;
  return {
    // O ECRÃ conhece um camião pelo código; o id do servidor viaja à parte
    // para as gravações o poderem usar.
    id: tir.codigo,
    tirId: tir.id,
    tipoId: tir.tipo,
    tipoNome: tir.tipo_nome || "",
    // Um transitário não é um veículo nosso: vem buscar, cobra ao volume, e
    // o percurso a seguir é dele. A marca é do TIPO e viaja achatada.
    transitario: !!tir.tipo_transitario,
    aluguer: tir.aluguer || "proprio",
    transportadoraId: tir.transportadora != null ? tir.transportadora : null,
    transportadoraNome: tir.transportadora_nome || null,
    matricula: texto(tir.matricula),
    motorista: texto(tir.motorista),
    metros: num(tir.metros, 13.6),
    larguraUtil: num(tir.largura_util, CP_LARGURA_UTIL),
    alturaUtil: num(tir.altura_util, null),
    pesoMaxKg: num(tir.peso_max_kg, null),
    // Vazio é «esta ficha não diz nada» — e é legítimo: o grupo decide-se
    // pela HORA. Inventar 'manha' aqui punha na ficha um período que ninguém
    // escolheu, e tornava o grupo «Sem horário» inalcançável.
    periodo: tir.periodo || "",
    inicio: String(tir.inicio || "08:00").slice(0, 5),
    fim: String(tir.fim || "16:00").slice(0, 5)
  };
}
function cpCamiaoDaCarga(carga, dados) {
  if (!carga) return null;
  const base = (dados && dados.camioes || []).find((c) => c.id === carga.camiaoId);
  if (!base) return null;
  const t = carga.transporte;
  const primeira = (Number(carga.viagem) || 1) === 1;
  if (!t) {
    return cpComTransportadoraInterno(
      primeira ? { ...base } : { ...base, inicio: null, fim: null },
      dados
    );
  }
  const efetivo = { ...base };
  if (t.tipoId != null) {
    efetivo.tipoId = t.tipoId;
    const tipo = (dados && dados.tiposTir || []).find((x) => x.id === t.tipoId);
    if (tipo) {
      efetivo.tipoNome = tipo.nome;
      efetivo.metros = Number(tipo.comprimento_m);
      efetivo.larguraUtil = Number(tipo.largura_m);
      efetivo.alturaUtil = tipo.altura_m != null ? Number(tipo.altura_m) : null;
      efetivo.pesoMaxKg = tipo.peso_max_kg != null ? Number(tipo.peso_max_kg) : null;
    } else if (t.tipoNome) {
      efetivo.tipoNome = t.tipoNome;
    }
  }
  if (t.aluguer) efetivo.aluguer = t.aluguer;
  if (t.transportadoraId != null) {
    efetivo.transportadoraId = t.transportadoraId;
    efetivo.transportadoraNome = t.transportadoraNome || null;
  }
  if (t.matricula) efetivo.matricula = t.matricula;
  if (t.motorista) efetivo.motorista = t.motorista;
  if (t.inicio) efetivo.inicio = t.inicio;
  else if (!primeira) efetivo.inicio = null;
  if (t.fim) efetivo.fim = t.fim;
  else if (!primeira) efetivo.fim = null;
  return cpComTransportadoraInterno(efetivo, dados);
}
function cpEhTransitario(camiao) {
  return !!(camiao && camiao.transitario);
}
function cpComTransportadoraInterno(camiao, dados) {
  if (!camiao || camiao.aluguer !== "proprio" || camiao.transportadoraId != null) return camiao;
  const interno = (dados && dados.transportadoras || []).find((f) => f.interno);
  if (!interno) return camiao;
  return { ...camiao, transportadoraId: interno.id, transportadoraNome: interno.nome };
}
function cpCargaDe(cargas, camiaoId, dia, viagem) {
  const n = Number(viagem) || 1;
  return (cargas || []).find(
    (c) => c.camiaoId === camiaoId && c.dia === dia && (Number(c.viagem) || 1) === n
  ) || null;
}
function cpSaidaDoCamiao(camiao, cargas, dia) {
  if (!camiao) return null;
  const primeira = cpCargaDe(cargas, camiao.id, dia, 1);
  const excecao = primeira && primeira.transporte && primeira.transporte.inicio;
  return cpHhmm2min(excecao || camiao.inicio);
}
function cpOrdemDosCamioes(camioes, cargas, dia) {
  const doDia = (cargas || []).filter((c) => !dia || c.dia === dia);
  const urgentes = new Set(doDia.filter((c) => c.urgente).map((c) => c.camiaoId));
  const saida = new Map(
    (camioes || []).map((c) => [c.id, cpSaidaDoCamiao(c, doDia, dia)])
  );
  const chave = (c) => {
    const min = saida.get(c.id);
    return [
      urgentes.has(c.id) ? 0 : 1,
      min == null ? Number.POSITIVE_INFINITY : min,
      String(c.id)
    ];
  };
  return [...camioes || []].sort((a, b) => {
    const [ua, ma, ca] = chave(a);
    const [ub, mb, cb] = chave(b);
    if (ua !== ub) return ua - ub;
    if (ma !== mb) return ma - mb;
    return ca.localeCompare(cb);
  });
}
function cpPeriodoDoServidor(p) {
  return {
    id: String(p && p.codigo || ""),
    label: p && (p.nome || p.codigo) || "",
    desdeMin: cpHhmm2min(String(p && p.desde || "").slice(0, 5)),
    ativo: !p || p.ativo !== false
  };
}
function cpPeriodoDoCamiao(camiao, cargas, dia, periodos) {
  if (!camiao) return null;
  const lista = (periodos || []).filter((p) => p && p.ativo !== false && Number.isFinite(p.desdeMin)).slice().sort((a, b) => a.desdeMin - b.desdeMin);
  const hora = cpSaidaDoCamiao(camiao, cargas, dia);
  if (hora == null || !lista.length) return camiao.periodo || null;
  let escolhido = null;
  for (const p of lista) if (p.desdeMin <= hora) escolhido = p.id;
  return escolhido != null ? escolhido : lista[0].id;
}
function cpCamioesPorPeriodo(camioes, cargas, dia, periodos) {
  const frota = camioes || [];
  const lista = (periodos || []).filter((p) => p && p.ativo !== false && Number.isFinite(p.desdeMin)).slice().sort((a, b) => a.desdeMin - b.desdeMin);
  if (!lista.length) {
    return frota.length ? [{ id: "", label: "Cami\xF5es", camioes: frota }] : [];
  }
  const porId = new Map(lista.map((p) => [p.id, []]));
  const orfaos = [];
  for (const c of frota) {
    const id = cpPeriodoDoCamiao(c, cargas, dia, lista);
    if (id != null && porId.has(id)) porId.get(id).push(c);
    else orfaos.push(c);
  }
  const out = lista.filter((p) => porId.get(p.id).length).map((p) => ({ id: p.id, label: p.label, camioes: porId.get(p.id) }));
  if (orfaos.length) out.push({ id: null, label: "Sem hor\xE1rio", camioes: orfaos });
  return out;
}
function cpViagensDoDia(camioes, cargas, dia) {
  const doDia = (cargas || []).filter((c) => c.dia === dia);
  const ordenados = cpOrdemDosCamioes(camioes || [], doDia, dia);
  const out = [];
  for (const camiao of ordenados) {
    const minhas = doDia.filter((c) => c.camiaoId === camiao.id);
    const porViagem = new Map(minhas.map((c) => [Number(c.viagem) || 1, c]));
    const maxViagem = Math.max(1, ...porViagem.keys());
    for (let v = 1; v <= maxViagem; v++) {
      out.push({ camiao, viagem: v, carga: porViagem.get(v) || null });
    }
  }
  return out;
}
function cpProximaViagem(cargas, camiaoId, dia) {
  const doCamiao = (cargas || []).filter((c) => c.camiaoId === camiaoId && c.dia === dia);
  const maxAtual = doCamiao.length ? Math.max(...doCamiao.map((c) => Number(c.viagem) || 1)) : 1;
  return maxAtual + 1;
}
function cpValoresDaTarifa(o) {
  const num = (v) => v == null || v === "" ? 0 : Number(v);
  return {
    aluguer: num(o.custo_aluguer),
    aluguerModo: o.aluguer_modo || "viagem",
    km: num(o.custo_km),
    paragensIncluidas: Number(o.paragens_incluidas) || 0,
    paragem: num(o.custo_paragem),
    regresso: num(o.custo_regresso),
    sobretaxaPct: num(o.sobretaxa_pct),
    // De onde este `CargaCusto` veio, e quando — só existem no `CargaCusto`
    // (a `Tarifa` em si não tem proveniência: ELA é a origem). Ler
    // `o.origem_tarifa`/`o.copiado_em` de um objeto de `Tarifa` dá
    // `undefined`, que cai em `null` — inofensivo, porque nada usa isto num
    // objeto que não seja um `CargaCusto`.
    origemTarifaId: o.origem_tarifa != null ? o.origem_tarifa : null,
    copiadoEm: o.copiado_em || null
  };
}
function cpValoresParaServidor(v) {
  const t = v || {};
  return {
    custo_aluguer: Number(t.aluguer) || 0,
    aluguer_modo: t.aluguerModo || "viagem",
    custo_km: Number(t.km) || 0,
    paragens_incluidas: Number(t.paragensIncluidas) || 0,
    custo_paragem: Number(t.paragem) || 0,
    custo_regresso: Number(t.regresso) || 0,
    sobretaxa_pct: Number(t.sobretaxaPct) || 0,
    // De onde os valores foram copiados, e quando (`CargaCusto.origem_tarifa`/
    // `copiado_em`) — só `copiarTarifa` (`cargoplanner_carga.jsx`) os
    // preenche; um preço escrito à mão não inventa uma origem.
    origem_tarifa: t.origemTarifaId != null ? t.origemTarifaId : null,
    copiado_em: t.copiadoEm || null
  };
}
function cpTarifaDoServidor(t) {
  return {
    ...cpValoresDaTarifa(t),
    // As zonas de uma tarifa por zona (#124). `preco` é número ou `null` —
    // `null` nunca vira 0: «a definir» e «não serve» não são grátis.
    zonas: (t.zonas || []).map((z) => ({
      id: z.id,
      origem: z.origem || "",
      distrito: z.distrito || "",
      concelho: z.concelho || "",
      situacao: z.situacao || "preco",
      preco: z.preco == null || z.preco === "" ? null : Number(z.preco)
    })),
    id: t.id,
    transportadoraId: t.transportadora,
    transportadoraNome: t.transportadora_nome || "",
    tipoId: t.tipo_tir,
    tipoNome: t.tipo_nome || "",
    ativo: t.ativo !== false
  };
}
function cpMapaDePreparadores(bruto) {
  const mapa = {};
  for (const [cliente, id] of Object.entries(bruto || {})) {
    mapa[String(cliente)] = id == null || id === "" ? null : String(id);
  }
  return mapa;
}
function cpPreparadorDaParagem(carga, clientePhc, ondas, dadosOndas) {
  const chave = String(clientePhc == null ? "" : clientePhc);
  const onda = (ondas || []).find(
    (o) => o.cargaId === (carga && carga.id) && String(o.clientePhc || "") === chave && !window.OndasLogica.foraDeCirculacao(o)
  );
  const pessoas = dadosOndas && dadosOndas.pessoas || [];
  const nomeDe = (id2, achatado) => {
    if (id2 == null || id2 === "") return null;
    const p = pessoas.find((x) => String(x.id) === String(id2));
    return p ? p.nome : achatado || `#${id2}`;
  };
  if (onda) {
    return {
      pessoaId: onda.pessoaId == null ? null : String(onda.pessoaId),
      nome: nomeDe(onda.pessoaId, onda.pessoaNome),
      ondaId: onda.id,
      codigo: onda.codigo,
      deOnda: true
    };
  }
  const mapa = carga && carga.preparadoresPorCliente || {};
  const temChave = Object.prototype.hasOwnProperty.call(mapa, chave);
  const id = temChave ? mapa[chave] : carga && carga.preparadorId;
  const nomes = carga && carga.preparadoresNomes || {};
  return {
    pessoaId: id == null || id === "" ? null : String(id),
    nome: nomeDe(id, temChave ? nomes[chave] : carga && carga.preparadorNome),
    ondaId: null,
    codigo: null,
    deOnda: false
  };
}
function cpPreparadorDaCarga(carga, paragens, ondas, dadosOndas) {
  const lista = paragens || [];
  if (!lista.length) {
    const id = carga && carga.preparadorId;
    return {
      pessoaId: id == null || id === "" ? null : String(id),
      nome: carga && carga.preparadorNome || null,
      varios: false
    };
  }
  const vistos = lista.map(
    (p) => cpPreparadorDaParagem(carga, p.clienteId, ondas, dadosOndas)
  );
  const ids = [...new Set(vistos.map((x) => x.pessoaId == null ? "" : x.pessoaId))];
  if (ids.length > 1) return { pessoaId: null, nome: null, varios: true };
  const um = vistos[0];
  return { pessoaId: um.pessoaId, nome: um.nome, varios: false };
}
function cpPacotesDaParagem(carga, paragem) {
  const pacotes = carga && carga.pacotes || [];
  if (paragem && paragem.amostra) {
    const id = paragem.entregaManualId;
    if (id == null) return [];
    return pacotes.filter((p) => p.entregaManual === id);
  }
  const cliente = paragem && paragem.clienteId;
  return pacotes.filter((p) => p.entregaManual == null && p.clientePhc === cliente);
}
function cpTotaisDosPacotes(pacotes) {
  let volumes = 0, pesoKg = 0, semPeso = 0, valor = 0, semValor = 0;
  for (const p of pacotes || []) {
    const n = Number(p.quantidade) || 0;
    volumes += n;
    if (p.pesoKg == null) semPeso += n;
    else pesoKg += n * Number(p.pesoKg);
    if (p.valorTransporte == null) semValor += n;
    else valor += n * Number(p.valorTransporte);
  }
  return { volumes, pesoKg: cpEuros(pesoKg), semPeso, valor: cpEuros(valor), semValor };
}
function cpCargaDoServidor(c) {
  return {
    id: `srv-${c.id}`,
    servidorId: c.id,
    // A versão para detetar edição concorrente (RF novo, 2026-09). Guarda-se
    // a STRING que o servidor mandou, tal como veio — nunca se passa por um
    // `Date` do JavaScript (só tem precisão ao milissegundo) nem se
    // reformata, porque é essa viagem que perderia os microssegundos e daria
    // um 409 a cada gravação sem ninguém ter mudado nada.
    versao: c.atualizado_em || null,
    // O retrato do planeado vs efetivado, congelado ao passar a «Preparada»
    // (`null` = a carga ainda não passou por lá — e isso é diferente de um
    // retrato vazio).
    preparacao: c.preparacao || null,
    // O cais/localização do armazém onde esta carga se monta — é contra ele
    // que o tablet faz match ao alocar uma palete picada.
    localizacaoDestino: c.localizacao_destino || "",
    // Quem vai preparar. **String**, como todos os ids de operador desta app
    // (`escala.resolver` devolve `str(op.pk)`): um inteiro nunca casaria com
    // o `p.id` da lista de pessoas, e a escolha nunca «pegava».
    preparadorId: c.preparador == null ? null : String(c.preparador),
    preparadorNome: c.preparador_nome || null,
    // E um por PARAGEM, com a mesma regra da string. `null` é «esta paragem
    // foi posta a “por atribuir”» e a chave AUSENTE é «nunca ninguém lhe
    // tocou» — a primeira impede o preparador da carga de a reclamar.
    preparadoresPorCliente: cpMapaDePreparadores(c.preparadores),
    preparadoresNomes: c.preparadores_nomes || {},
    // **A janela prevista de chegada COMBINADA**, por paragem (cartão #50).
    // Só a combinada viaja — a calculada sai do `cpPercurso` a cada render, e
    // gravá-la criava uma segunda verdade. `{}` e não `undefined`: um servidor
    // mais velho não pode fazer o ecrã rebentar a ler a chave.
    janelas: c.janelas || {},
    // O que a carga leva quando é criada no PHC, e a marca de que já foi.
    identificacao: c.identificacao || "",
    valorTransporte: c.valor_transporte == null ? null : Number(c.valor_transporte),
    valorExtra: c.valor_extra == null ? null : Number(c.valor_extra),
    motivoCargaId: c.motivo_carga == null ? null : c.motivo_carga,
    entregaSos: c.entrega_sos == null ? null : !!c.entrega_sos,
    phcEnviadaEm: c.phc_enviada_em || null,
    camiaoId: c.tir_codigo,
    tirId: c.tir,
    dia: c.dia,
    origemId: c.origem || null,
    regressoId: c.regresso || null,
    regressoFaturado: !!c.regresso_faturado,
    // `null` = segue a tarifa ao vivo. NÃO é «tarifa a zero» — é a distinção
    // que dá preço às cargas de frota própria.
    custo: c.custo ? cpValoresDaTarifa(c.custo) : null,
    estado: c.estado || "em_planeamento",
    viagem: Number(c.viagem) || 1,
    urgente: !!c.urgente,
    motivoUrgenciaId: c.motivo_urgencia != null ? c.motivo_urgencia : null,
    motivoUrgenciaNome: c.motivo_urgencia_nome || null,
    notaUrgencia: c.nota_urgencia || "",
    // O transporte praticado NESTA carga. `null`/`''` = herda o do TIR — a
    // fusão das duas coisas faz-se num sítio só, em `cpCamiaoDaCarga`.
    transporte: {
      tipoId: c.tipo_tir != null ? c.tipo_tir : null,
      tipoNome: c.tipo_tir_nome || null,
      transportadoraId: c.transportadora != null ? c.transportadora : null,
      transportadoraNome: c.transportadora_nome || null,
      aluguer: c.aluguer || "",
      matricula: c.matricula || "",
      motorista: c.motorista || "",
      // O servidor manda HH:MM:SS; o ecrã (e o `<input type="time">`) fala
      // HH:MM. Sem o corte, a comparação com a janela do camião falhava.
      inicio: c.inicio ? String(c.inicio).slice(0, 5) : null,
      fim: c.fim ? String(c.fim).slice(0, 5) : null
    },
    ordemClientes: c.ordem_clientes || [],
    linhas: (c.linhas || []).map((l) => ({ entregaId: l.bistamp, qtd: Number(l.qtd) || 0 })),
    recolhas: (c.recolhas || []).map((r, i) => ({ ...r, ordem: r.ordem != null ? r.ordem : i })),
    // **As paragens de ENTREGA declaradas à mão** — a amostra sem encomenda
    // (cartão #73). `[]` e não `undefined`: um servidor mais velho não pode
    // fazer o ecrã rebentar a ler a chave.
    entregasManuais: (c.entregas_manuais || []).map((e, i) => ({
      ...e,
      ordem: e.ordem != null ? e.ordem : i
    })),
    // Os volumes de uma carga de transitário. Os decimais vêm como STRING do
    // DRF (`"12.500"`): somados sem converter, concatenam-se em silêncio.
    // `null` é «não se sabe» e tem de sobreviver à tradução — `Number(null)`
    // é 0, que é a resposta errada.
    pacotes: (c.pacotes || []).map((p) => ({
      clientePhc: p.cliente_phc || "",
      quantidade: Number(p.quantidade) || 1,
      comprimentoCm: p.comprimento_cm == null ? null : Number(p.comprimento_cm),
      larguraCm: p.largura_cm == null ? null : Number(p.largura_cm),
      alturaCm: p.altura_cm == null ? null : Number(p.altura_cm),
      pesoKg: p.peso_kg == null ? null : Number(p.peso_kg),
      valorTransporte: p.valor_transporte == null ? null : Number(p.valor_transporte),
      valorMercadoria: p.valor_mercadoria == null ? null : Number(p.valor_mercadoria),
      observacoes: p.observacoes || "",
      // A segunda pendura (#112): a amostra a que este volume pertence.
      entregaManual: p.entrega_manual == null ? null : p.entrega_manual
    }))
  };
}
function cpCargaParaServidor(carga, camioes) {
  const camiao = (camioes || []).find((c) => c.id === carga.camiaoId);
  const corpo = {
    tir: carga.tirId || camiao && camiao.tirId || null,
    // A versão que este ecrã leu da última vez. `null`/`undefined` numa
    // carga nova (nunca lida do servidor) não pede deteção nenhuma — o
    // servidor grava como sempre gravou. Write-only do lado do servidor:
    // nunca sai numa resposta, só `atualizado_em` sai.
    versao_esperada: carga.versao || null,
    dia: carga.dia,
    estado: carga.estado || "em_planeamento",
    viagem: Number(carga.viagem) || 1,
    urgente: !!carga.urgente,
    // Sem urgência não vai motivo nenhum: mandar o antigo fazia o servidor
    // gravar uma carga não-urgente com motivo agarrado (que ele limpa, mas
    // é melhor não lho pedir).
    motivo_urgencia: carga.urgente ? carga.motivoUrgenciaId || null : null,
    nota_urgencia: carga.urgente ? carga.notaUrgencia || "" : "",
    tipo_tir: carga.transporte && carga.transporte.tipoId || null,
    transportadora: carga.transporte && carga.transporte.transportadoraId || null,
    regresso_faturado: !!carga.regressoFaturado,
    // Substituição integral, como as linhas e as recolhas: o cliente manda a
    // carga como ela ficou. `null` APAGA o `CargaCusto` — é o «Repor os
    // preços da tarifa».
    custo: carga.custo ? cpValoresParaServidor(carga.custo) : null,
    aluguer: carga.transporte && carga.transporte.aluguer || "",
    matricula: carga.transporte && carga.transporte.matricula || "",
    motorista: carga.transporte && carga.transporte.motorista || "",
    // `null` e não `''`: é `null` que limpa um TimeField do lado do servidor.
    inicio: carga.transporte && carga.transporte.inicio || null,
    fim: carga.transporte && carga.transporte.fim || null,
    origem: carga.origemId || "",
    regresso: carga.regressoId || "",
    ordem_clientes: carga.ordemClientes || [],
    localizacao_destino: carga.localizacaoDestino || "",
    // Volta a NÚMERO: o `preparador` é uma FK, e o servidor quer o pk.
    preparador: carga.preparadorId == null || carga.preparadorId === "" ? null : Number(carga.preparadorId),
    // Volta a número, mantendo o `null` explícito — ver `cpMapaDePreparadores`.
    preparadores: Object.fromEntries(
      Object.entries(carga.preparadoresPorCliente || {}).map(
        ([cliente, id]) => [cliente, id == null || id === "" ? null : Number(id)]
      )
    ),
    // As horas vão como o ecrã as tem — `HH:MM`, o que o `<input type="time">`
    // fala. Quem as limpa manda a entrada FORA do objeto, não uma entrada
    // vazia: é assim que a calculada volta a valer (e o `_validar_janelas` do
    // servidor faz a mesma limpeza, para um cliente antigo não a contornar).
    janelas: carga.janelas || {},
    // Cortado a 10: o PARÂMETRO do procedimento é `char(10)` (a coluna é
    // `char(20)`), e o que passar disso é cortado no PHC em silêncio.
    identificacao: (carga.identificacao || "").slice(0, 10),
    // **Escritos à mão, com vírgula decimal** (o teclado PT dá vírgula, e um
    // `type="number"` recusa-a). Vazio é `null` e NÃO zero: é a distinção
    // que trava o envio ao PHC em vez de lá pôr uma carga a zero euros —
    // por isso não se usa o `cpParseDecimal`, que devolve 0 para vazio.
    valor_transporte: cpDecimalOuNulo(carga.valorTransporte),
    valor_extra: cpDecimalOuNulo(carga.valorExtra),
    motivo_carga: carga.motivoCargaId == null ? null : carga.motivoCargaId,
    entrega_sos: carga.entregaSos == null ? null : !!carga.entregaSos,
    linhas: (carga.linhas || []).map((l, i) => ({
      bistamp: l.entregaId,
      qtd: l.qtd,
      ordem: i
    })),
    recolhas: cpRecolhasOrdenadas(carga).map((r, i) => ({
      tipo: r.tipo,
      referencia: r.referencia || "",
      nome: r.nome,
      morada: r.morada || "",
      local: r.local || "",
      lat: r.lat != null ? r.lat : null,
      lng: r.lng != null ? r.lng : null,
      motivo: r.motivo || "",
      ordem: i
    })),
    // A amostra: a mesma forma, SEM `motivo` — ver o modelo.
    entregas_manuais: cpAmostrasOrdenadas(carga).map((e, i) => ({
      // **O `id` volta para o servidor**, e é ele que diz «esta é a MESMA
      // amostra». Sem o mandar, cada gravação da carga — e ela grava-se a
      // cada arrasto — recriava a amostra com uma chave nova e o
      // `Pacote.entrega_manual` ficava a apontar para uma linha apagada
      // (`CASCADE`: os volumes iam atrás). Uma amostra acabada de criar no
      // ecrã ainda não tem id, e aí não se manda chave nenhuma.
      ...e.id != null ? { id: e.id } : {},
      tipo: e.tipo,
      referencia: e.referencia || "",
      nome: e.nome,
      morada: e.morada || "",
      local: e.local || "",
      lat: e.lat != null ? e.lat : null,
      lng: e.lng != null ? e.lng : null,
      ordem: i
    })),
    // Os volumes de um transitário — caminho inverso de `cpCargaDoServidor`.
    // `null` continua `null` (não se sabe), nunca 0 — mesma disciplina da
    // tradução de entrada.
    pacotes: (carga.pacotes || []).map((p, i) => ({
      cliente_phc: p.clientePhc || "",
      quantidade: Number(p.quantidade) || 1,
      comprimento_cm: p.comprimentoCm == null ? null : p.comprimentoCm,
      largura_cm: p.larguraCm == null ? null : p.larguraCm,
      altura_cm: p.alturaCm == null ? null : p.alturaCm,
      peso_kg: p.pesoKg == null ? null : p.pesoKg,
      valor_transporte: p.valorTransporte == null ? null : p.valorTransporte,
      valor_mercadoria: p.valorMercadoria == null ? null : p.valorMercadoria,
      observacoes: p.observacoes || "",
      // `null` explícito, nunca `undefined`: o servidor exige exactamente UMA
      // das duas penduras, e um `undefined` chega lá como chave ausente — que
      // num PATCH parcial o DRF trataria como «não mexer».
      entrega_manual: p.entregaManual == null ? null : p.entregaManual,
      ordem: i
    }))
  };
  if (carga.preparacao) corpo.preparacao = carga.preparacao;
  return corpo;
}
function cpEntregaSos(carga, dados) {
  if (carga && carga.entregaSos != null) return !!carga.entregaSos;
  const entregas = cpIndexar(dados && dados.entregas);
  return (carga && carga.linhas || []).some((l) => {
    const e = entregas[l.entregaId];
    return !!(e && e.sos);
  });
}
function cpAplicarEfetivado(carga, ajustaveis) {
  if (!carga || !(ajustaveis || []).length) return carga;
  const por = {};
  (ajustaveis || []).forEach((l) => {
    if (!l || !l.bistamp) return;
    const q = l.aplicar == null ? l.picado : l.aplicar;
    if (q != null) por[l.bistamp] = Number(q);
  });
  const linhas = (carga.linhas || []).map((l) => por[l.entregaId] == null ? l : { ...l, qtd: por[l.entregaId] }).filter((l) => (Number(l.qtd) || 0) > 0);
  return { ...carga, linhas };
}
function cpEhEcoProprio(origem, minhaLigacao) {
  if (origem == null || minhaLigacao == null) return false;
  return String(origem) === String(minhaLigacao);
}
function cpFundirCargaSocket(cargas, cargaServidor, { origem, minhaLigacao, porGravar } = {}) {
  if (cpEhEcoProprio(origem, minhaLigacao)) return { acao: "ignorar" };
  const recebida = cpCargaDoServidor(cargaServidor);
  const local = cpCargaDe(cargas, recebida.camiaoId, recebida.dia, recebida.viagem);
  const pendentes = porGravar instanceof Set ? porGravar : new Set(porGravar || []);
  if (local && pendentes.has(local.id)) {
    return { acao: "conflito", cargaId: local.id, servidor: cargaServidor };
  }
  const noutroSlot = recebida.servidorId == null ? null : (cargas || []).find((c) => c.servidorId === recebida.servidorId && !(local && c.id === local.id));
  const deLimpar = noutroSlot ? noutroSlot.id : null;
  if (local) {
    return {
      acao: "aplicar",
      cargaId: local.id,
      deLimpar,
      carga: { ...recebida, id: local.id }
    };
  }
  return { acao: "aplicar", cargaId: recebida.id, deLimpar, carga: recebida };
}
function cpRemoverCargaSocket(cargas, msg, { origem, minhaLigacao } = {}) {
  if (cpEhEcoProprio(origem, minhaLigacao)) return { acao: "ignorar" };
  const alvo = (cargas || []).find((c) => c.servidorId === (msg && msg.id));
  if (!alvo) return { acao: "ignorar" };
  return { acao: "remover", cargaId: alvo.id };
}
function cpSaudeDaLigacao(ligacoes, agoraMs) {
  const lista = Array.isArray(ligacoes) ? ligacoes : [];
  const vivo = lista.length > 0 && lista.every((l) => l && l.ligada);
  if (vivo) return { vivo: true, desdeMs: null, minutos: null, texto: "ao vivo" };
  const sinais = lista.map((l) => l && l.ultimoSinalMs).filter((v) => typeof v === "number");
  if (!sinais.length || sinais.length < lista.length) {
    return { vivo: false, desdeMs: null, minutos: null, texto: "desligado \u2014 sem dados" };
  }
  const desdeMs = Math.min(...sinais);
  const minutos = Math.max(0, Math.floor((agoraMs - desdeMs) / 6e4));
  const idade = minutos < 1 ? "h\xE1 menos de 1 min" : `h\xE1 ${minutos} min`;
  return { vivo: false, desdeMs, minutos, texto: `desligado \u2014 dados de ${idade}` };
}
function cpDeveReler({ primeiraLigacao } = {}) {
  return !primeiraLigacao;
}
function cpUrgenciaAoMudarDeCamiao(origem) {
  return {
    urgente: !!origem.urgente,
    motivoUrgenciaId: origem.motivoUrgenciaId || null,
    motivoUrgenciaNome: origem.motivoUrgenciaNome || null,
    notaUrgencia: origem.notaUrgencia || ""
  };
}
function cpUrgenciaVazia() {
  return { urgente: false, motivoUrgenciaId: null, motivoUrgenciaNome: null, notaUrgencia: "" };
}
function cpFichaPropria(pessoas, userId) {
  if (userId == null) return null;
  const alvo = String(userId);
  return (pessoas || []).find((p) => p.userId != null && String(p.userId) === alvo) || null;
}
function cpParcelasDoCusto(custo, carga, tarifa) {
  if (!custo) return [];
  const t = tarifa || {};
  if (custo.zona) {
    const linhas2 = [{
      chave: "zona",
      label: "Zona mais distante",
      valor: custo.aluguer,
      nota: `${custo.zona.rotulo} \u2014 paga-se a zona mais distante, n\xE3o uma por descarga`
    }];
    if (custo.paragensExtra > 0) {
      linhas2.push({
        chave: "paragens",
        label: "Descargas extra",
        valor: custo.paragensCusto,
        nota: `${custo.paragensExtra} de ${custo.paragens} descarga(s) al\xE9m das inclu\xEDdas`
      });
    }
    if (carga && carga.regressoFaturado) {
      linhas2.push({ chave: "regresso", label: "Regresso", valor: custo.regresso, nota: null });
    }
    return linhas2;
  }
  const linhas = [
    {
      chave: "aluguer",
      label: "Aluguer",
      valor: custo.aluguer,
      // O aluguer ao dia reparte-se pelas viagens COM linhas — um cartão de
      // viagem vazio é um lugar reservado, não uma volta feita.
      nota: custo.viagensPagas > 1 ? `repartido por ${custo.viagensPagas} viagens do dia` : t.aluguerModo === "dia" ? "ao dia, e esta \xE9 a \xFAnica viagem com carga" : null
    },
    {
      chave: "km",
      label: "Quil\xF3metros",
      valor: custo.custoKm,
      nota: `${custo.km} km faturados`
    }
  ];
  const pct = Number(t.sobretaxaPct) || 0;
  if (pct > 0) {
    linhas.push({
      chave: "combustivel",
      label: "Combust\xEDvel",
      valor: custo.combustivel,
      nota: `sobretaxa de ${String(pct).replace(".", ",")} % sobre os quil\xF3metros`
    });
  }
  if (custo.paragensExtra > 0) {
    linhas.push({
      chave: "paragens",
      label: "Paragens extra",
      valor: custo.paragensCusto,
      nota: `${custo.paragensExtra} de ${custo.paragens} paragem(ns) al\xE9m das inclu\xEDdas`
    });
  }
  if (carga && carga.regressoFaturado) {
    linhas.push({ chave: "regresso", label: "Regresso", valor: custo.regresso, nota: null });
  }
  return linhas;
}
function cpParcelasOmitidas(custo, carga, tarifa) {
  if (!custo) return [];
  const t = tarifa || {};
  const fora = [];
  if (custo.zona) {
    fora.push("O pre\xE7o por zona n\xE3o depende dos quil\xF3metros nem leva sobretaxa de combust\xEDvel.");
    if (custo.paragensExtra <= 0) {
      fora.push(`As ${custo.paragens} descarga(s) cabem nas inclu\xEDdas pela tarifa.`);
    }
    const recolhas = (carga && carga.recolhas || []).length;
    if (recolhas) {
      fora.push(`${recolhas} recolha(s) n\xE3o entram: a tabela por zona cobra descargas.`);
    }
    if (!(carga && carga.regressoFaturado)) {
      fora.push("O regresso n\xE3o est\xE1 a ser faturado \u2014 liga-se em \xAB\uFF0B Custos de regresso\xBB.");
    }
    fora.push("\xC9 o pre\xE7o de refer\xEAncia para dias \xFAteis em hor\xE1rio normal \u2014 fora disso n\xE3o \xE9 este.");
    return fora;
  }
  if (!(Number(t.sobretaxaPct) > 0)) {
    fora.push("Esta tarifa n\xE3o tem sobretaxa de combust\xEDvel.");
  }
  if (custo.paragensExtra <= 0) {
    fora.push(`As ${custo.paragens} paragem(ns) cabem nas inclu\xEDdas pela tarifa.`);
  }
  if (!(carga && carga.regressoFaturado)) {
    fora.push("O regresso n\xE3o est\xE1 a ser faturado \u2014 liga-se em \xAB\uFF0B Custos de regresso\xBB.");
  }
  return fora;
}
function cpDestinosDaEntrega(entregaId, cargas, ondas, dadosOndas, clientePhc) {
  if (!entregaId) return [];
  const pessoas = dadosOndas && dadosOndas.pessoas || [];
  const destinos = [];
  for (const c of cargas || []) {
    const qtd = (c.linhas || []).filter((l) => l.entregaId === entregaId).reduce((t, l) => t + (Number(l.qtd) || 0), 0);
    if (qtd <= 0) continue;
    const onda = (ondas || []).find((o) => o.cargaId === c.id) || null;
    const pessoa = onda && onda.pessoaId ? pessoas.find((p) => p.id === onda.pessoaId) || null : null;
    destinos.push({
      cargaId: c.id,
      camiaoId: c.camiaoId,
      viagem: Number(c.viagem) || 1,
      dia: c.dia,
      estado: c.estado || "em_planeamento",
      qtd,
      onda,
      pessoa,
      // A janela prevista de chegada DESTA paragem, nesta carga — e só a
      // COMBINADA (`ponto` a `null`). A carga pode não ser a que está aberta:
      // recalcular-lhe o percurso (a geometria da rota, os km, o relógio) para
      // mostrar uma estimativa num modal era pedir muito para afirmar pouco.
      // Sem cliente, não há paragem por que perguntar.
      janela: clientePhc ? cpJanelaDaParagem(c, clientePhc, null) : null
    });
  }
  return destinos.sort((a, b) => String(a.dia).localeCompare(String(b.dia)) || String(a.camiaoId).localeCompare(String(b.camiaoId)) || a.viagem - b.viagem);
}
function cpLargarNaParagem({
  ler,
  idx,
  paragens,
  onAdicionar,
  onReordenar,
  onAlvo,
  onSobreZona
}) {
  return (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (onAlvo) onAlvo(null);
    if (onSobreZona) onSobreZona(false);
    const p = ler(ev);
    if (p && p.k === "artigos") {
      onAdicionar(p.itens);
      return;
    }
    if (!p || p.k !== "paragem") return;
    const de = (paragens || []).findIndex((x) => x.id === p.clienteId);
    if (de === -1 || de === idx) return;
    onReordenar(de, idx);
  };
}
function cpLargarNaZonaDaCarga({ ler, onAdicionar, onSobreZona }) {
  return (ev) => {
    ev.preventDefault();
    if (onSobreZona) onSobreZona(false);
    const p = ler(ev);
    if (p && p.k === "artigos") onAdicionar(p.itens);
  };
}
function cpTextoDoDiaNaoUtil(motivo) {
  if (!motivo) return null;
  if (motivo.tipo === "feriado") {
    return {
      curto: `feriado \u2014 ${motivo.nome}`,
      completo: `Feriado \u2014 ${motivo.nome} (edit\xE1vel em Defini\xE7\xF5es \u2192 Vocabul\xE1rios)`
    };
  }
  return { curto: motivo.nome, completo: motivo.nome };
}
window.CargoplannerLogica = {
  parcelasDoCusto: cpParcelasDoCusto,
  destinosDaEntrega: cpDestinosDaEntrega,
  parcelasOmitidas: cpParcelasOmitidas,
  clienteIdDaEntrega: cpClienteIdDaEntrega,
  entregasGuardadas: cpEntregasGuardadas,
  entregasVisiveis: cpEntregasVisiveis,
  corDaLinha: cpCorDaLinha,
  corDaData: cpCorDaData,
  janelaDoTexto: cpJanelaDoTexto,
  horarioCompativel: cpHorarioCompativel,
  textoDaJanela: cpTextoDaJanela,
  janelaDaParagem: cpJanelaDaParagem,
  condicaoOk: cpCondicaoOk,
  filtrarPorCondicoes: cpFiltrarPorCondicoes,
  textoDaCondicao: cpTextoDaCondicao,
  CAMPOS_COND: CP_CAMPOS_COND,
  OPERADORES: CP_OPERADORES,
  kmAoSegmento: cpKmAoSegmento,
  kmAoPercurso: cpKmAoPercurso,
  kmDaRotaPorCliente: cpKmDaRotaPorCliente,
  kmDaRotaPorLocal: cpKmDaRotaPorLocal,
  normalizarLocal: cpNormalizarLocal,
  ordemPorProximidade: cpOrdemPorProximidade,
  camiaoDoTir: cpCamiaoDoTir,
  camiaoDaCarga: cpCamiaoDaCarga,
  ehTransitario: cpEhTransitario,
  comTransportadoraInterno: cpComTransportadoraInterno,
  cargaDe: cpCargaDe,
  ordemDosCamioes: cpOrdemDosCamioes,
  saidaDoCamiao: cpSaidaDoCamiao,
  periodoDoServidor: cpPeriodoDoServidor,
  periodoDoCamiao: cpPeriodoDoCamiao,
  camioesPorPeriodo: cpCamioesPorPeriodo,
  viagensDoDia: cpViagensDoDia,
  proximaViagem: cpProximaViagem,
  cargaDoServidor: cpCargaDoServidor,
  mapaDePreparadores: cpMapaDePreparadores,
  preparadorDaParagem: cpPreparadorDaParagem,
  preparadorDaCarga: cpPreparadorDaCarga,
  pacotesDaParagem: cpPacotesDaParagem,
  totaisDosPacotes: cpTotaisDosPacotes,
  cargaParaServidor: cpCargaParaServidor,
  aplicarEfetivado: cpAplicarEfetivado,
  entregaSos: cpEntregaSos,
  decimalOuNulo: cpDecimalOuNulo,
  ehEcoProprio: cpEhEcoProprio,
  fundirCargaSocket: cpFundirCargaSocket,
  removerCargaSocket: cpRemoverCargaSocket,
  hhmm2min: cpHhmm2min,
  min2hhmm: cpMin2hhmm,
  duracao: cpDuracao,
  haversineKm: cpHaversineKm,
  kmEstrada: cpKmEstrada,
  minutosViagem: cpMinutosViagem,
  paletes: cpPaletes,
  kitsDaLista: cpKitsDaLista,
  kitsDeQuantidades: cpKitsDeQuantidades,
  kitAtribuido: cpKitAtribuido,
  kitPorAtribuir: cpKitPorAtribuir,
  kitsCobertos: cpKitsCobertos,
  agregadoDoKit: cpAgregadoDoKit,
  corDoKit: cpCorDoKit,
  coberturaDoKit: cpCoberturaDoKit,
  porFila: cpPorFila,
  metrosDaLinha: cpMetrosDaLinha,
  camadas: cpCamadas,
  metrosDaEntrega: cpMetrosDaEntrega,
  LARGURA_UTIL: CP_LARGURA_UTIL,
  temCoords: cpTemCoords,
  indexar: cpIndexar,
  corDoCliente: cpCorDoCliente,
  clienteDaEntrega: cpClienteDaEntrega,
  reordenar: cpReordenar,
  disponibilidade: cpDisponibilidade,
  DISP_LABEL: CP_DISP_LABEL,
  qtdAtribuida: cpQtdAtribuida,
  pool: cpPool,
  itensParaArrastar: cpItensParaArrastar,
  itensDoKit: cpItensDoKit,
  artigosPorKit: cpArtigosPorKit,
  linhasDoKit: cpLinhasDoKit,
  paragens: cpParagens,
  percurso: cpPercurso,
  aplicarRota: cpAplicarRota,
  ordemFisica: cpOrdemFisica,
  recolhasOrdenadas: cpRecolhasOrdenadas,
  amostrasOrdenadas: cpAmostrasOrdenadas,
  idDaAmostra: cpIdDaAmostra,
  COR_AMOSTRA: CP_COR_AMOSTRA,
  COR_RECOLHA: CP_COR_RECOLHA,
  RECOLHA_MIN: CP_RECOLHA_MIN,
  ocupacao: cpOcupacao,
  textoSemMedida: cpTextoSemMedida,
  TEMPO_PREP_OMISSAO: CP_TEMPO_PREP_OMISSAO,
  tempoPreparacaoLinha: cpTempoPreparacaoLinha,
  tempoPreparacao: cpTempoPreparacao,
  pegada: cpPegada,
  pegadaDoPacote: cpPegadaDoPacote,
  melhorArranjo: cpMelhorArranjo,
  repartirCorrida: cpRepartirCorrida,
  resumoArranjo: cpResumoArranjo,
  valoresDaTarifa: cpValoresDaTarifa,
  valoresParaServidor: cpValoresParaServidor,
  tarifaDoServidor: cpTarifaDoServidor,
  tarifaDaCarga: cpTarifaDaCarga,
  chaveDeZona: cpChaveDeZona,
  zonaDoDestino: cpZonaDoDestino,
  precoPorZona: cpPrecoPorZona,
  textoSemCustoZona: cpTextoSemCustoZona,
  MOTIVOS_ZONA: CP_MOTIVOS_ZONA,
  kmFaturados: cpKmFaturados,
  viagensPagas: cpViagensPagas,
  valorDaCarga: cpValorDaCarga,
  parseDecimal: cpParseDecimal,
  camposPrecoNegativos: cpCamposPrecoNegativos,
  custoConvertido: cpCustoConvertido,
  cargaHipotetica: cpCargaHipotetica,
  custoDaCarga: cpCustoDaCarga,
  motivoSemCusto: cpMotivoSemCusto,
  raciosDaCarga: cpRaciosDaCarga,
  custoDoDia: cpCustoDoDia,
  textoDoDiaSemPreco: cpTextoDoDiaSemPreco,
  euros: cpEuros,
  cabeNaCarga: cpCabeNaCarga,
  largarNaParagem: cpLargarNaParagem,
  largarNaZonaDaCarga: cpLargarNaZonaDaCarga,
  // Exportada para o ecrã fazer a fusão PELA MESMA função que o aviso usa:
  // duas cópias da regra «como um artigo entra numa carga» divergiam em
  // silêncio, e o aviso passava a descrever uma carga diferente da gravada.
  comItens: cpComItens,
  avisoAoAdicionar: cpAvisoAoAdicionar,
  conflitos: cpConflitos,
  validar: cpValidar,
  proximoEstado: cpProximoEstado,
  urgenciaAoMudarDeCamiao: cpUrgenciaAoMudarDeCamiao,
  urgenciaVazia: cpUrgenciaVazia,
  fichaPropria: cpFichaPropria,
  saudeDaLigacao: cpSaudeDaLigacao,
  deveReler: cpDeveReler,
  metrosTexto: cpM,
  ESTADOS_QUE_FECHAM: CP_ESTADOS_QUE_FECHAM,
  ESTADOS_SEM_VIAGEM: CP_ESTADOS_SEM_VIAGEM,
  rotuloDaCarga: cpRotuloDaCarga,
  caisCanonico: cpCaisCanonico,
  diaUtil: cpDiaUtil,
  textoDoDiaNaoUtil: cpTextoDoDiaNaoUtil,
  gradeDoMes: cpGradeDoMes,
  mesMais: cpMesMais,
  mesDoDia: cpMesDoDia,
  atribuidoDaLinha: cpAtribuidoDaLinha,
  ondeEstaOResto: cpOndeEstaOResto,
  DESCARGA_MIN: CP_DESCARGA_MIN,
  MARGEM_RISCO_MIN: CP_MARGEM_RISCO_MIN
};

// ===== cargoplanner/frontend/ondas_dados.js =====
const OND_ESTADOS = [
  { id: "disponivel", label: "Dispon\xEDvel", cor: "#6a7888" },
  { id: "planeada", label: "Planeada", cor: "#2563eb" },
  { id: "atribuida", label: "Atribu\xEDda", cor: "#7c3aed" },
  { id: "em_execucao", label: "Em curso", cor: "#0891b2" },
  { id: "pausada", label: "Pausada", cor: "#f59e0b" },
  { id: "concluida", label: "Conclu\xEDda", cor: "#16a34a" },
  { id: "bloqueada", label: "Bloqueada", cor: "#dc2626" },
  { id: "cancelada", label: "Cancelada", cor: "#9aa6b3" },
  // Cartão #114. Arquivar não é aviso nem erro — é arrumação do QUADRO, não
  // do trabalho (ver `ondForaDeCirculacao`). Mesmo cinzento da `cancelada`:
  // as duas são desistências, nunca âmbar nem vermelho.
  { id: "arquivada", label: "Arquivada", cor: "#9aa6b3" }
];
const OND_ESTADOS_TAREFA = [
  { id: "pendente", label: "Pendente", cor: "#6a7888" },
  { id: "em_execucao", label: "Em curso", cor: "#0891b2" },
  { id: "pausada", label: "Pausada", cor: "#f59e0b" },
  { id: "concluida", label: "Conclu\xEDda", cor: "#16a34a" },
  { id: "bloqueada", label: "Bloqueada", cor: "#dc2626" },
  { id: "cancelada", label: "Cancelada", cor: "#9aa6b3" }
];
const OND_MOTIVOS_PAUSA = [
  { id: "espera_material", label: "Espera de material" },
  { id: "espera_empilhador", label: "Espera de empilhador" },
  { id: "nao_localizado", label: "Material n\xE3o localizado" },
  { id: "qualidade", label: "Problema de qualidade" },
  { id: "equipamento", label: "Equipamento indispon\xEDvel" },
  { id: "prioridade", label: "Altera\xE7\xE3o de prioridade" },
  { id: "apoio", label: "Apoio a outro trabalho" },
  { id: "outro", label: "Outro" },
  // **Escrito pela APP, não escolhido por ninguém** — é o que fica na pausa
  // quando o operador chama outra tarefa e esta estava a decorrer. Tem id
  // estável porque o código o refere (`OndasLogica.MOTIVO_TROCA`), ao
  // contrário dos outros motivos; e `automatico` tira-o da lista que o
  // modal de pausar oferece: quem pausa à mão não escolhe isto, seria uma
  // razão que a app é que sabe.
  { id: "troca_de_tarefa", label: "Trocou de tarefa", automatico: true }
];
const OND_ORIGENS_TEMPO = [
  { id: "padrao", label: "Tempo padr\xE3o" },
  { id: "historico", label: "Hist\xF3rico" },
  { id: "calculado", label: "C\xE1lculo autom\xE1tico" },
  { id: "manual", label: "Manual" }
];
function ondCriarDados(dia) {
  return {
    dia,
    // Os três vocabulários vêm do servidor e são injetados pelo shell — aqui
    // ficam VAZIOS de propósito. Semeá-los com uma cópia do catálogo era a
    // dívida que a "Single source of truth policy" proíbe: no dia em que
    // alguém mudasse a cor de um tipo em Definições, o ecrã mostrava a cor
    // velha até à primeira resposta, e nunca mais se saberia qual das duas
    // listas é que mandava.
    tipos: [],
    motivos: [],
    prioridades: [],
    estados: OND_ESTADOS,
    estadosTarefa: OND_ESTADOS_TAREFA,
    motivosPausa: OND_MOTIVOS_PAUSA,
    origensTempo: OND_ORIGENS_TEMPO,
    // Idem: as ondas e as tarefas do dia chegam do servidor.
    ondas: [],
    tarefas: []
  };
}
window.OndasDados = {
  criar: ondCriarDados,
  ESTADOS: OND_ESTADOS,
  ESTADOS_TAREFA: OND_ESTADOS_TAREFA,
  MOTIVOS_PAUSA: OND_MOTIVOS_PAUSA,
  ORIGENS_TEMPO: OND_ORIGENS_TEMPO
};

// ===== cargoplanner/frontend/ondas_logica.js =====
const OND_INTERVALO_MIN = 15;
function _L() {
  return window.CargoplannerLogica;
}
function ondIndexar(lista, chave) {
  const out = {};
  for (const it of lista || []) out[it[chave || "id"]] = it;
  return out;
}
function ondFimTurnoMin(turno) {
  const L = _L();
  const ini = L.hhmm2min(turno.inicio);
  let fim = L.hhmm2min(turno.fim);
  if (fim <= ini) fim += 1440;
  return fim;
}
function ondTarefasDaOnda(ondaId, dados) {
  return (dados.tarefas || []).filter((t) => t.ondaId === ondaId);
}
function ondDuracaoPrevista(onda, dados) {
  if (!onda) return 0;
  const ts = ondTarefasDaOnda(onda.id, dados);
  if (ts.length) return ts.reduce((s, t) => s + (Number(t.tempoPrevMin) || 0), 0);
  return Number(onda.duracaoMin) || 0;
}
function ondTempoReal(onda, dados) {
  return ondTarefasDaOnda(onda.id, dados).reduce((s, t) => s + (Number(t.tempoRealMin) || 0), 0);
}
function ondOcupacaoMedida(onda, dados) {
  const ts = ondTarefasDaOnda(onda.id, dados);
  const medido = ts.reduce((s, t) => s + (Number(t.tempoRealMin) || 0), 0);
  if (medido > 0) return { minutos: medido, base: "medido" };
  const ems = ts.flatMap((t) => (t.lotes || []).map((l) => Date.parse(l && l.em || ""))).filter((ms) => Number.isFinite(ms)).sort((a, b) => a - b);
  if (ems.length >= 2) {
    const min = Math.round((ems[ems.length - 1] - ems[0]) / 6e4);
    if (min > 0) return { minutos: min, base: "picks" };
  }
  return { minutos: ondDuracaoPrevista(onda, dados), base: "previsto" };
}
function ondTextoDaBase(base, minutos) {
  const CL = window.CargoplannerLogica;
  const d = CL ? CL.duracao(minutos) : `${minutos} min`;
  if (base === "medido") return `${d} medidos`;
  if (base === "picks") return `\u2248 ${d} pelos registos de picking`;
  return `${d} previstos (sem medi\xE7\xE3o)`;
}
function ondDesvio(onda, dados) {
  const ts = ondTarefasDaOnda(onda.id, dados);
  const feitas = ts.filter((t) => t.tempoRealMin != null);
  const previsto = ondDuracaoPrevista(onda, dados);
  const real = ondTempoReal(onda, dados);
  const previstoDasFeitas = feitas.reduce((s, t) => s + (Number(t.tempoPrevMin) || 0), 0);
  const comparavel = feitas.length > 0;
  const desvioMin = comparavel ? real - previstoDasFeitas : null;
  return {
    previstoMin: previsto,
    previstoDasFeitasMin: previstoDasFeitas,
    realMin: real,
    desvioMin,
    desvioPct: comparavel && previstoDasFeitas > 0 ? Math.round(desvioMin / previstoDasFeitas * 100) : null,
    comparavel,
    tarefasFeitas: feitas.length,
    tarefasTotal: ts.length
  };
}
function ondMinDoDia(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.getHours() * 60 + d.getMinutes();
}
function ondMesmoDia(diaISO, ms) {
  if (!diaISO || ms == null) return false;
  const d = new Date(ms);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}` === String(diaISO);
}
const OND_FORA_DE_CIRCULACAO = /* @__PURE__ */ new Set(["cancelada", "arquivada"]);
function ondForaDeCirculacao(onda) {
  return !!onda && OND_FORA_DE_CIRCULACAO.has(onda.estado);
}
function ondDesistencia(onda) {
  return !!onda && onda.estado === "cancelada";
}
const OND_TAREFA_TERMINAIS = /* @__PURE__ */ new Set(["concluida", "cancelada"]);
const OND_CARGA_RECUA_DE = /* @__PURE__ */ new Set(["planeada", "em_preparacao"]);
function ondConsequenciasDeArquivar(onda, dados, cargas, ondas) {
  const todasTarefas = ondTarefasDaOnda(onda.id, dados);
  const porFazer = todasTarefas.filter((t) => !OND_TAREFA_TERMINAIS.has(t.estado));
  const tarefas = porFazer.length;
  const emExecucao = porFazer.filter((t) => t.estado === "em_execucao").length;
  const phcLancadas = ondPhcDosLotes(todasTarefas).lancadas;
  if (!onda.cargaId) {
    return { tarefas, emExecucao, phcLancadas, carga: "sem_carga", cargaCodigo: null };
  }
  const carga = (cargas || []).find((c) => c.id === onda.cargaId);
  if (!carga) {
    return { tarefas, emExecucao, phcLancadas, carga: "desconhecida", cargaCodigo: null };
  }
  const cargaCodigo = ondRotuloCarga(onda);
  if (carga.estado === "em_planeamento") {
    return { tarefas, emExecucao, phcLancadas, carga: "ja_em_planeamento", cargaCodigo };
  }
  if (!OND_CARGA_RECUA_DE.has(carga.estado)) {
    return { tarefas, emExecucao, phcLancadas, carga: "nao_recua_estado", cargaCodigo };
  }
  const outraViva = (ondas || []).some(
    (o) => o.id !== onda.id && o.cargaId === onda.cargaId && !ondForaDeCirculacao(o)
  );
  if (outraViva) {
    return { tarefas, emExecucao, phcLancadas, carga: "nao_recua_outra_onda", cargaCodigo };
  }
  return { tarefas, emExecucao, phcLancadas, carga: "recua", cargaCodigo };
}
function ondAgendaDaPessoa(pessoaId, ondas, dados, agoraMs) {
  const L = _L();
  const pessoa = (dados.pessoas || []).find((p) => p.id === pessoaId);
  if (!pessoa) return [];
  const minhas = (ondas || []).filter((o) => o.pessoaId === pessoaId && !ondForaDeCirculacao(o)).slice().sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  const indisp = (pessoa.indisponibilidades || []).map((i) => ({
    ...i,
    ini: L.hhmm2min(i.inicio),
    fim: L.hhmm2min(i.fim)
  }));
  let relogio = L.hhmm2min(pessoa.inicioTrabalho);
  if (agoraMs != null && dados.dia && ondMesmoDia(dados.dia, agoraMs)) {
    const agoraMin = ondMinDoDia(new Date(agoraMs).toISOString());
    if (agoraMin != null && relogio != null) relogio = Math.max(relogio, agoraMin);
  }
  return minhas.map((onda, i) => {
    const dur = ondDuracaoPrevista(onda, dados);
    const iniReal = ondMinDoDia(onda.inicioReal);
    let inicio;
    let fim;
    let base;
    const real = iniReal != null;
    if (real) {
      inicio = iniReal;
      const medida = ondOcupacaoMedida(onda, dados);
      base = medida.base;
      fim = inicio + medida.minutos;
    } else {
      inicio = relogio;
      for (let volta = 0; volta < 8; volta++) {
        const choque = indisp.find((x) => inicio < x.fim && inicio + dur > x.ini);
        if (!choque) break;
        inicio = choque.fim;
      }
      base = "previsto";
      fim = inicio + dur;
    }
    relogio = fim + OND_INTERVALO_MIN;
    return {
      onda,
      ordem: i + 1,
      inicioMin: inicio,
      fimMin: fim,
      duracaoMin: dur,
      real,
      base
    };
  });
}
function ondOcupacaoDaPessoa(pessoaId, ondas, dados) {
  const agenda = ondAgendaDaPessoa(pessoaId, ondas, dados);
  const quem = (dados.pessoas || []).find((p) => p.id === pessoaId);
  const capacidade = Number.isFinite(quem?.capacidadeMin) ? quem.capacidadeMin : 420;
  const planeado = agenda.reduce((s, a) => s + a.duracaoMin, 0);
  const real = agenda.reduce((s, a) => s + ondTempoReal(a.onda, dados), 0);
  const tarefas = agenda.reduce((s, a) => s + ondTarefasDaOnda(a.onda.id, dados).length, 0);
  const previstoDasFeitas = agenda.reduce(
    (s, a) => s + ondDesvio(a.onda, dados).previstoDasFeitasMin,
    0
  );
  const comparavel = real > 0 && previstoDasFeitas > 0;
  return {
    ondas: agenda.length,
    tarefas,
    planeadoMin: planeado,
    realMin: real,
    previstoDasFeitasMin: previstoDasFeitas,
    desvioMin: comparavel ? real - previstoDasFeitas : null,
    capacidadeMin: capacidade,
    pct: capacidade > 0 ? Math.round(planeado / capacidade * 100) : 0,
    excede: planeado > capacidade,
    agenda
  };
}
function ondConflitosDaPessoa(pessoaId, ondas, dados) {
  const L = _L();
  const pessoa = (dados.pessoas || []).find((p) => p.id === pessoaId);
  if (!pessoa) return [];
  const tipos = ondIndexar(dados.tipos);
  const turnos = ondIndexar(dados.turnos);
  const turno = turnos[pessoa.turnoId];
  const agenda = ondAgendaDaPessoa(pessoaId, ondas, dados);
  const porId = ondIndexar(ondas);
  const out = [];
  for (const a of agenda) {
    const tipo = tipos[a.onda.tipoId];
    if (turno && a.onda.estado !== "concluida" && a.fimMin > ondFimTurnoMin(turno)) {
      out.push({
        tipo: "fora_do_turno",
        pessoaId,
        ondaId: a.onda.id,
        msg: `${a.onda.codigo} acaba \xE0s ${L.min2hhmm(a.fimMin)}, depois do fim do turno de ${pessoa.nome} (${turno.fim}).`
      });
    }
    if (tipo && tipo.competencia && !(pessoa.competencias || []).includes(tipo.competencia)) {
      const comp = (dados.competencias || []).find((c) => c.id === tipo.competencia);
      out.push({
        tipo: "sem_competencia",
        pessoaId,
        ondaId: a.onda.id,
        msg: `${a.onda.codigo} (${tipo.label}) exige "${(comp || {}).label || tipo.competencia}" e ${pessoa.nome} n\xE3o a tem.`
      });
    }
    for (const depId of a.onda.dependeDe || []) {
      const dep = porId[depId];
      if (!dep) continue;
      if (dep.estado === "concluida") continue;
      if (!dep.pessoaId) {
        out.push({
          tipo: "dependencia",
          pessoaId,
          ondaId: a.onda.id,
          msg: `${a.onda.codigo} depende de ${dep.codigo}, que ainda n\xE3o est\xE1 atribu\xEDda a ningu\xE9m.`
        });
        continue;
      }
      const agDep = ondAgendaDaPessoa(dep.pessoaId, ondas, dados).find((x) => x.onda.id === dep.id);
      if (agDep && agDep.fimMin > a.inicioMin) {
        out.push({
          tipo: "dependencia",
          pessoaId,
          ondaId: a.onda.id,
          msg: `${a.onda.codigo} come\xE7a \xE0s ${L.min2hhmm(a.inicioMin)}, antes de ${dep.codigo} acabar (${L.min2hhmm(agDep.fimMin)}).`
        });
      }
    }
  }
  const oc = ondOcupacaoDaPessoa(pessoaId, ondas, dados);
  if (oc.excede) {
    out.push({
      tipo: "sobrecarga",
      pessoaId,
      ondaId: null,
      msg: `${pessoa.nome} tem ${L.duracao(oc.planeadoMin)} planeados para uma capacidade de ${L.duracao(oc.capacidadeMin)} (${oc.pct}%).`
    });
  }
  return out;
}
function ondConflitos(ondas, dados) {
  return (dados.pessoas || []).flatMap((p) => ondConflitosDaPessoa(p.id, ondas, dados));
}
function ondValidarAtribuicao(onda, pessoa, ondas, dados) {
  const L = _L();
  const avisos = [];
  if (!onda || !pessoa) return avisos;
  const tipo = ondIndexar(dados.tipos)[onda.tipoId];
  const turno = ondIndexar(dados.turnos)[pessoa.turnoId];
  if (tipo && tipo.competencia && !(pessoa.competencias || []).includes(tipo.competencia)) {
    const comp = (dados.competencias || []).find((c) => c.id === tipo.competencia);
    avisos.push({
      nivel: "erro",
      tipo: "competencia",
      msg: `${pessoa.nome} n\xE3o tem a compet\xEAncia "${(comp || {}).label || tipo.competencia}", exigida por ${tipo.label}.`
    });
  }
  const simuladas = (ondas || []).map((o) => o.id === onda.id ? { ...o, pessoaId: pessoa.id, ordem: 9999 } : o);
  const agenda = ondAgendaDaPessoa(pessoa.id, simuladas, dados);
  const nova = agenda.find((a) => a.onda.id === onda.id);
  if (nova && turno && nova.fimMin > ondFimTurnoMin(turno)) {
    avisos.push({
      nivel: "aviso",
      tipo: "turno",
      msg: `Acabaria \xE0s ${L.min2hhmm(nova.fimMin)}, depois do fim do turno (${turno.fim}).`
    });
  }
  const oc = ondOcupacaoDaPessoa(pessoa.id, simuladas, dados);
  if (oc.excede) {
    avisos.push({
      nivel: "aviso",
      tipo: "carga",
      msg: `Ficaria com ${L.duracao(oc.planeadoMin)} planeados para ${L.duracao(oc.capacidadeMin)} de capacidade (${oc.pct}%).`
    });
  }
  for (const i of pessoa.indisponibilidades || []) {
    if (nova && nova.inicioMin < L.hhmm2min(i.fim) && nova.fimMin > L.hhmm2min(i.inicio)) {
      avisos.push({
        nivel: "aviso",
        tipo: "disponibilidade",
        msg: `Apanha "${i.motivo}" (${i.inicio}\u2013${i.fim}).`
      });
    }
  }
  const porId = ondIndexar(ondas);
  for (const depId of onda.dependeDe || []) {
    const dep = porId[depId];
    if (dep && dep.estado !== "concluida") {
      avisos.push({
        nivel: "aviso",
        tipo: "dependencia",
        msg: `Depende de ${dep.codigo}, que ainda n\xE3o est\xE1 conclu\xEDda.`
      });
    }
  }
  return avisos;
}
function ondPodeIniciar(onda, ondas) {
  const porId = ondIndexar(ondas);
  const bloqueios = (onda.dependeDe || []).map((id) => porId[id]).filter((d) => d && d.estado !== "concluida");
  return { ok: bloqueios.length === 0, bloqueios };
}
function ondAcumuladoDeTarefa(t) {
  if (!t) return 0;
  if (t._acumulado != null) return Number(t._acumulado) || 0;
  let conhecido = null;
  const pausas = t.pausas || [];
  for (let i = pausas.length - 1; i >= 0; i -= 1) {
    const a = pausas[i] && pausas[i].acumuladoMin;
    if (a != null) {
      conhecido = Number(a) || 0;
      break;
    }
  }
  (t.lotes || []).forEach((l) => {
    const a = l && l.acumuladoMin;
    if (a == null) return;
    const n = Number(a);
    if (Number.isFinite(n) && (conhecido == null || n > conhecido)) conhecido = n;
  });
  return conhecido == null ? 0 : conhecido;
}
function ondAcumuladoAgora(t, agora) {
  if (!t) return 0;
  return ondAcumuladoDeTarefa(t) + (t._inicioReal != null ? agora - t._inicioReal : 0);
}
function ondArredondarAcumulado(min) {
  return Math.round(Math.max(0, Number(min) || 0) * 100) / 100;
}
const OND_MOTIVO_TROCA = "troca_de_tarefa";
function ondTrabalhoDoOperador(pessoaId, ondas, dados, escolhidaId) {
  const agenda = ondAgendaDaPessoa(pessoaId, ondas, dados);
  const tarefas = agenda.flatMap((a) => ondTarefasDaOnda(a.onda.id, dados).map((t) => ({ tarefa: t, onda: a.onda, agenda: a })));
  const porFazer = tarefas.filter(
    (x) => x.tarefa.estado !== "concluida" && x.tarefa.estado !== "cancelada"
  );
  const feitas = tarefas.filter((x) => x.tarefa.estado === "concluida");
  const emCurso = porFazer.find((x) => x.tarefa.estado === "em_execucao") || null;
  const escolhida = escolhidaId ? porFazer.find((x) => x.tarefa.id === escolhidaId) || null : null;
  const atual = escolhida || emCurso || porFazer.find((x) => x.tarefa.estado !== "pausada") || porFazer[0] || null;
  const pausadas = porFazer.filter((x) => x !== atual && x.tarefa.estado === "pausada");
  const seguintes = porFazer.filter((x) => x !== atual && x.tarefa.estado !== "pausada");
  return {
    atual,
    pausadas,
    seguintes,
    feitas,
    porFazer,
    emCursoOutra: emCurso && emCurso !== atual ? emCurso : null,
    // `true` quando o ecrã está onde está por decisão do operador, e não por
    // omissão — é o que deixa a vista dizer-lhe que saiu da ordem do plano.
    chamada: !!escolhida
  };
}
function ondDisponiveis(ondas) {
  return (ondas || []).filter((o) => !o.pessoaId && !ondForaDeCirculacao(o));
}
function ondDestinoDaCarga(carga, camiao) {
  const cais = (carga && carga.localizacaoDestino || "").trim();
  if (cais) return cais;
  return `Cais \xB7 ${camiao ? camiao.id : "\u2014"}`;
}
function ondJuntarSemRepetir(lista, novas) {
  const antes = lista || [];
  if (!novas || !novas.length) return antes;
  const tenho = new Set(antes.map((x) => x.id));
  const faltam = novas.filter((x) => !tenho.has(x.id));
  return faltam.length ? [...antes, ...faltam] : antes;
}
function ondGerarOndasDeCarga(carga, dadosCargas, ondas, dia) {
  if (!carga) return [];
  const CL = window.CargoplannerLogica;
  const paragens = CL.paragens(carga, dadosCargas);
  if (!paragens.length) return [];
  const camiao = CL.camiaoDaCarga(carga, dadosCargas);
  const ocupacaoTotal = CL.ocupacao(carga, dadosCargas);
  const daCarga = (ondas || []).filter(
    (o) => o.cargaId === carga.id && !ondForaDeCirculacao(o)
  );
  if (daCarga.some((o) => !String(o.clientePhc || ""))) return [];
  const jaExistem = new Set(daCarga.map((o) => String(o.clientePhc || "")));
  const fisica = CL.ordemFisica(paragens);
  const saida = [];
  let n = (ondas || []).length;
  for (const p of fisica) {
    const chave = String(p.clienteId || "");
    if (jaExistem.has(chave)) continue;
    n += 1;
    const id = `o-carga-${carga.id}-${chave || "sem-cliente"}`;
    const paletes = p.artigos.reduce((t, a) => t + (a.paletes || 0), 0);
    const mapaPrep = carga.preparadoresPorCliente || {};
    const prepDaParagem = (Object.prototype.hasOwnProperty.call(mapaPrep, chave) ? mapaPrep[chave] : carga.preparadorId) || null;
    const onda = {
      id,
      codigo: `Onda ${String(900 + n).padStart(3, "0")}`,
      tipoId: "preparacao",
      motivoId: null,
      // A prioridade `urgente` (rank 4) já existe; a lista de «Ondas
      // disponíveis» ordena por rank, por isso a carga urgente sobe sozinha.
      prioridadeId: carga.urgente ? "urgente" : "alta",
      dia: dia || carga.dia,
      // Nasce ATRIBUÍDA a quem a carga disser que prepara ESTA paragem — a
      // intenção por cliente quando existe, a da carga quando não. Uma
      // paragem posta explicitamente a «por atribuir» (chave presente, valor
      // nulo) nasce disponível mesmo que a carga tenha preparador: é uma
      // decisão de quem planeou, não uma omissão.
      estado: prepDaParagem == null ? "disponivel" : "atribuida",
      pessoaId: prepDaParagem,
      ordem: 0,
      // O que se MOSTRA é o nome do cliente; a CHAVE é o `clientePhc`.
      clienteId: p.cliente.nome,
      clientePhc: chave,
      cargaId: carga.id,
      cargaServidorId: carga.servidorId == null ? null : carga.servidorId,
      zona: null,
      qtdTotal: p.qtd,
      paletes,
      dependeDe: [],
      observacoes: `Gerada a partir da carga ${carga.camiaoId} \u2014 ${p.cliente.nome}.`,
      // RF-OND-33 — o retrato DESTE cliente no momento em que a onda nasceu.
      // É a comparação com isto que deteta que a carga mudou depois; por
      // isso passou a ser por cliente, como a própria onda.
      origemCarga: {
        cargaId: carga.id,
        camiaoId: carga.camiaoId,
        viagem: Number(carga.viagem) || 1,
        saida: camiao ? camiao.inicio : null,
        paletes,
        clientes: [p.clienteId],
        refs: p.artigos.map((a) => a.entrega.ref).sort(),
        urgente: !!carga.urgente,
        // A ocupação da CARGA inteira, para o ecrã poder dizer o peso desta
        // paragem no todo sem ir buscar a carga outra vez.
        paletesDaCarga: ocupacaoTotal.ocupadas
      }
    };
    const tarefas = p.artigos.map((a, k) => ({
      id: `${onda.id}-t${k + 1}`,
      ondaId: onda.id,
      tipo: "Picking",
      artigo: a.entrega.ref,
      descricao: a.entrega.descricao,
      qtd: a.qtd,
      // A unidade da linha de encomenda, para o tablet não escrever «un.»
      // sobre 29 quilos (medido: 9 % das linhas não são `UN`).
      unidade: a.entrega.unidade || "",
      origem: "Armaz\xE9m",
      destino: ondDestinoDaCarga(carga, camiao),
      clienteId: p.cliente.nome,
      cargaId: carga.id,
      // De que LINHA da carga nasceu — é esta chave que deixa a onda
      // acompanhar a carga depois (`ondSincronizarOndaComCarga`). Sem ela,
      // duas linhas da mesma referência para o mesmo cliente (duas
      // encomendas) são indistinguíveis uma da outra.
      bistamp: a.entrega.id,
      foraDaCarga: false,
      // **De que KIT é esta tarefa.** As tarefas de um kit já nasciam uma
      // por componente (as linhas da carga SÃO os componentes); o que
      // faltava era dizer que andam juntas — quem pica 2 de um kit de 8 não
      // expede nada. Vazio nas linhas normais, que são a maioria.
      ...ondKitDeOrigem(a.entrega),
      // RF-OND-31 — minutos por palete + mínimo por linha, os dois
      // configuráveis (Definições → «Turnos e armazéns»). A fórmula vive em
      // `cargoplanner_logica.js`, o MESMO sítio que o cabeçalho da carga usa
      // para o resumo antes de a onda existir.
      tempoPrevMin: CL.tempoPreparacaoLinha(a.paletes, dadosCargas.parametrosPreparacao),
      tempoRealMin: null,
      origemTempo: "padrao",
      estado: "pendente",
      pausas: []
    }));
    saida.push({ onda, tarefas });
  }
  return saida;
}
function ondPreparadoresDaCarga(cargaId, ondas, dadosOndas) {
  if (!cargaId) return [];
  const pessoas = dadosOndas && dadosOndas.pessoas || [];
  const por = /* @__PURE__ */ new Map();
  for (const o of ondas || []) {
    if (o.cargaId !== cargaId || ondForaDeCirculacao(o)) continue;
    const chave = o.pessoaId == null || o.pessoaId === "" ? null : String(o.pessoaId);
    if (!por.has(chave)) {
      const p = pessoas.find((x) => String(x.id) === chave);
      por.set(chave, {
        pessoaId: chave,
        // O nome pode não estar na escala DESTE dia (férias, troca de turno):
        // aí vale o que a onda achatou, e só em último caso o id.
        nome: chave == null ? null : p ? p.nome : o.pessoaNome || `#${chave}`,
        codigos: []
      });
    }
    por.get(chave).codigos.push(o.codigo);
  }
  return [...por.values()];
}
function ondPercursoDaOnda(onda, tarefas) {
  const daOnda = (tarefas || []).filter((t) => onda && t.ondaId === onda.id);
  const juntar = (campo) => {
    const vistos = [];
    daOnda.forEach((t) => {
      const v = String(t[campo] || "").trim();
      if (v && !vistos.includes(v)) vistos.push(v);
    });
    return vistos;
  };
  return { origem: juntar("origem"), destino: juntar("destino") };
}
function ondFundirOndaSocket(ondas, ondaServidor, { origem, minhaLigacao, dia } = {}) {
  if (ondEhEcoProprio(origem, minhaLigacao)) return { acao: "ignorar" };
  if (!ondaServidor) return { acao: "ignorar" };
  const nova = ondOndaDoServidor(ondaServidor);
  const lista = ondas || [];
  const i = lista.findIndex((o) => o.id === nova.id);
  if (dia && nova.dia !== dia) {
    return i === -1 ? { acao: "ignorar" } : { acao: "remover", ondaId: nova.id };
  }
  return { acao: "aplicar", onda: nova, tarefas: ondTarefasDoServidor([ondaServidor]) };
}
function ondDisponivelDeOutroDia(onda, dia) {
  if (!onda || !onda.dia) return false;
  return onda.dia !== dia && !onda.pessoaId && !ondForaDeCirculacao(onda);
}
function ondFundirOndaFora(ondasFora, ondaServidor, { origem, minhaLigacao, dia } = {}) {
  if (ondEhEcoProprio(origem, minhaLigacao)) return { acao: "ignorar" };
  if (!ondaServidor) return { acao: "ignorar" };
  const nova = ondOndaDoServidor(ondaServidor);
  const estava = (ondasFora || []).some((o) => o.id === nova.id);
  if (!ondDisponivelDeOutroDia(nova, dia)) {
    return estava ? { acao: "remover", ondaId: nova.id } : { acao: "ignorar" };
  }
  return { acao: "aplicar", onda: nova, tarefas: ondTarefasDoServidor([ondaServidor]) };
}
function ondFundirOndaDeCargas(lista, ondaServidor, { origem, minhaLigacao, desde, ate } = {}) {
  if (ondEhEcoProprio(origem, minhaLigacao)) return { acao: "ignorar" };
  if (!ondaServidor) return { acao: "ignorar" };
  const nova = ondOndaDoServidor(ondaServidor);
  const estava = (lista || []).some((o) => o.id === nova.id);
  const serve = !!nova.cargaId && ondDentroDoPeriodo(nova.dia, desde, ate);
  if (!serve) return estava ? { acao: "remover", ondaId: nova.id } : { acao: "ignorar" };
  return { acao: "aplicar", onda: nova, tarefas: ondTarefasDoServidor([ondaServidor]) };
}
function ondDentroDoPeriodo(dia, de, ate) {
  if (!dia) return false;
  if (de && dia < de) return false;
  if (ate && dia > ate) return false;
  return true;
}
function ondFundirOndaNoPeriodo(ondas, ondaServidor, { de, ate } = {}) {
  if (!ondaServidor) return { acao: "ignorar" };
  const nova = ondOndaDoServidor(ondaServidor);
  const lista = ondas || [];
  const i = lista.findIndex((o) => o.id === nova.id);
  if (!ondDentroDoPeriodo(nova.dia, de, ate)) {
    return i === -1 ? { acao: "ignorar" } : { acao: "remover", ondaId: nova.id };
  }
  return { acao: "aplicar", onda: nova, tarefas: ondTarefasDoServidor([ondaServidor]) };
}
function ondRemoverOndaDoPeriodo(ondas, msg) {
  const id = msg && msg.id != null ? ondId(msg.id) : null;
  if (!id) return { acao: "ignorar" };
  if (!(ondas || []).some((o) => o.id === id)) return { acao: "ignorar" };
  return { acao: "remover", ondaId: id };
}
function ondPeriodoAlcancavel(diaDoSocket, de, ate) {
  return ondDentroDoPeriodo(diaDoSocket, de, ate);
}
function ondRemoverOndaSocket(ondas, msg, { origem, minhaLigacao } = {}) {
  if (ondEhEcoProprio(origem, minhaLigacao)) return { acao: "ignorar" };
  const id = msg && msg.id != null ? ondId(msg.id) : null;
  if (!id) return { acao: "ignorar" };
  if (!(ondas || []).some((o) => o.id === id)) return { acao: "ignorar" };
  return { acao: "remover", ondaId: id };
}
function ondEhEcoProprio(origem, minhaLigacao) {
  if (origem == null || minhaLigacao == null) return false;
  return String(origem) === String(minhaLigacao);
}
function ondRotuloCarga(onda) {
  if (!onda) return null;
  const oc = onda.origemCarga;
  if (oc && oc.camiaoId) {
    return oc.viagem > 1 ? `${oc.camiaoId} \xB7 ${oc.viagem}\xAA` : oc.camiaoId;
  }
  return onda.cargaId || null;
}
function ondRotuloDaOnda(onda) {
  if (!onda) return null;
  const carga = ondRotuloCarga(onda);
  const cliente = onda.clienteId || null;
  if (carga && cliente) return `${carga} \xB7 ${cliente}`;
  return carga || cliente || onda.zona || null;
}
function ondCargaAlterada(onda, carga, dadosCargas) {
  if (!onda || !onda.origemCarga || !carga) return null;
  const CL = window.CargoplannerLogica;
  let paragens = CL.paragens(carga, dadosCargas);
  if (onda.clientePhc) {
    paragens = paragens.filter((p) => String(p.clienteId) === String(onda.clientePhc));
  }
  const agora = {
    // As paletes DESTAS paragens — sem `clientePhc` (onda antiga, de quando
    // a onda era uma só) são as da carga inteira, que é o que ela era.
    paletes: onda.clientePhc ? paragens.reduce((t, p) => t + p.artigos.reduce((x, a) => x + (a.paletes || 0), 0), 0) : CL.ocupacao(carga, dadosCargas).ocupadas,
    clientes: paragens.map((p) => p.clienteId),
    refs: paragens.flatMap((p) => p.artigos.map((a) => a.entrega.ref)).sort(),
    urgente: !!carga.urgente
  };
  const antes = onda.origemCarga;
  const difs = [];
  if (agora.paletes !== antes.paletes) {
    difs.push(`paletes: ${antes.paletes} \u2192 ${agora.paletes}`);
  }
  if (agora.clientes.join(",") !== (antes.clientes || []).join(",")) {
    difs.push(`clientes: ${(antes.clientes || []).join("/")} \u2192 ${agora.clientes.join("/")}`);
  }
  if (agora.refs.join(",") !== (antes.refs || []).join(",")) {
    difs.push("artigos alterados");
  }
  if (agora.urgente !== !!antes.urgente) {
    difs.push(agora.urgente ? "carga passou a urgente" : "carga deixou de ser urgente");
  }
  return difs.length ? difs : null;
}
function ondTarefaTocada(t) {
  if (!t) return false;
  if ((t.estado || "pendente") !== "pendente") return true;
  if (t.tempoRealMin != null) return true;
  if ((t.lotes || []).length > 0) return true;
  if ((t.pausas || []).length > 0) return true;
  return false;
}
function ondLargarOndaVazia(onda, tarefas, carga) {
  if (!onda || !carga) return { largar: false, motivo: "sem_carga" };
  if (!onda.cargaId) return { largar: false, motivo: "sem_carga" };
  if ((carga.linhas || []).length > 0) {
    return { largar: false, motivo: "carga_tem_linhas" };
  }
  const estado = onda.estado || "disponivel";
  if (estado === "concluida" || estado === "em_execucao") {
    return { largar: false, motivo: "tem_trabalho" };
  }
  const minhas = (tarefas || []).filter((t) => t && t.ondaId === onda.id);
  if (minhas.some(ondTarefaTocada)) {
    return { largar: false, motivo: "tem_trabalho" };
  }
  return { largar: true, motivo: "sem_trabalho" };
}
function ondLinhasDaCarga(carga, dadosCargas, clientePhc) {
  const CL = window.CargoplannerLogica;
  let paragens = CL.paragens(carga, dadosCargas);
  if (clientePhc) {
    paragens = paragens.filter((p) => String(p.clienteId) === String(clientePhc));
  }
  const linhas = [];
  for (const p of CL.ordemFisica(paragens)) {
    for (const a of p.artigos) {
      linhas.push({
        bistamp: a.entrega.id,
        artigo: a.entrega.ref,
        descricao: a.entrega.descricao,
        qtd: a.qtd,
        unidade: a.entrega.unidade || "",
        // **A quantidade tem de ser EXATA nesta linha?** É o «qtd. certa» da
        // coluna Acond., e é o que tira a margem de ±10 % do caminho — o
        // cliente pediu o número que pediu. Medido: 249 das 384 linhas de
        // uma janela normal são assim, por isso o ramo estrito é o comum.
        qtdCerta: !!a.entrega.quantidadeCerta,
        paletes: a.paletes,
        clienteNome: p.cliente.nome,
        // De que kit é a linha — para a sincronização poder ACOMPANHAR uma
        // composição que mude no ERP, como já acompanha a quantidade e a
        // descrição. Sem isto, uma tarefa criada pela sincronização (um
        // componente acrescentado à carga depois de a onda existir) nascia
        // sem kit, e o tablet não dizia que ela anda com as outras.
        ...ondKitDeOrigem(a.entrega)
      });
    }
  }
  return { paragens, linhas };
}
function ondSincronizarOndaComCarga(onda, tarefas, carga, dadosCargas) {
  if (!onda || !onda.origemCarga || !carga) return null;
  const CL = window.CargoplannerLogica;
  const { paragens, linhas } = ondLinhasDaCarga(carga, dadosCargas, onda.clientePhc);
  if ((carga.linhas || []).length > 0 && !linhas.length) return null;
  const ocupacao = CL.ocupacao(carga, dadosCargas);
  const camiao = CL.camiaoDaCarga(carga, dadosCargas);
  const daOnda = (tarefas || []).filter((t) => t.ondaId === onda.id);
  const porCasar = daOnda.slice();
  const casar = (linha) => {
    let i = porCasar.findIndex((t) => t.bistamp && t.bistamp === linha.bistamp);
    if (i === -1) {
      i = porCasar.findIndex((t) => !t.bistamp && t.artigo === linha.artigo && (t.clienteId || "") === (linha.clienteNome || ""));
    }
    return i === -1 ? null : porCasar.splice(i, 1)[0];
  };
  const difs = [];
  const novas = [];
  let destinoMudou = false;
  let seq = daOnda.length;
  let acrescentadas = 0;
  let removidas = 0;
  let marcadas = 0;
  for (const linha of linhas) {
    const t = casar(linha);
    if (!t) {
      seq += 1;
      acrescentadas += 1;
      difs.push(`+ ${linha.artigo}`);
      novas.push({
        id: `${onda.id}-t${seq}`,
        ondaId: onda.id,
        tipo: "Picking",
        artigo: linha.artigo,
        descricao: linha.descricao,
        qtd: linha.qtd,
        unidade: linha.unidade || "",
        origem: "Armaz\xE9m",
        destino: ondDestinoDaCarga(carga, camiao),
        clienteId: linha.clienteNome,
        cargaId: carga.id,
        bistamp: linha.bistamp,
        tempoPrevMin: CL.tempoPreparacaoLinha(
          linha.paletes,
          dadosCargas.parametrosPreparacao
        ),
        tempoRealMin: null,
        origemTempo: "padrao",
        estado: "pendente",
        pausas: [],
        lotes: [],
        foraDaCarga: false,
        ...ondKitDeOrigem(linha),
        // Marca de nascença: é o que diz ao servidor «cria esta», em vez de
        // «actualiza aquela» (ver `ondSincronizacaoParaServidor`).
        _nova: true
      });
      continue;
    }
    const mudouQtd = ondNum(t.qtd) !== ondNum(linha.qtd);
    if (mudouQtd) difs.push(`${linha.artigo}: ${ondNum(t.qtd)} \u2192 ${ondNum(linha.qtd)}`);
    const razaoAntes = t.kitRazao == null ? null : ondNum(t.kitRazao);
    const razaoAgora = linha.kitRazao == null ? null : ondNum(linha.kitRazao);
    if ((t.kitRef || "") !== (linha.kitRef || "")) {
      difs.push(linha.kitRef ? `${linha.artigo}: passou a ser componente do kit ${linha.kitRef}` : `${linha.artigo}: j\xE1 n\xE3o \xE9 componente de kit`);
    } else if (razaoAntes !== razaoAgora) {
      difs.push(`${linha.artigo}: \xD7${razaoAntes == null ? "?" : razaoAntes} \u2192 \xD7${razaoAgora == null ? "?" : razaoAgora} por kit`);
    }
    if (t.destino !== ondDestinoDaCarga(carga, camiao)) destinoMudou = true;
    if (t.foraDaCarga) difs.push(`${linha.artigo} voltou \xE0 carga`);
    novas.push({
      ...t,
      qtd: linha.qtd,
      // A unidade acompanha a linha do ERP; sem ela na linha, fica a que
      // estava (uma tarefa antiga não tem por onde a inventar).
      unidade: linha.unidade || t.unidade || "",
      descricao: linha.descricao || t.descricao,
      // O cais da carga mudou? As tarefas seguem-no — é para lá que as
      // paletes vão, e o tablet valida contra o destino da TAREFA.
      destino: ondDestinoDaCarga(carga, camiao),
      // O previsto acompanha a quantidade, pela MESMA fórmula que gerou a
      // tarefa. O medido (`tempoRealMin`) nunca se toca.
      tempoPrevMin: mudouQtd ? CL.tempoPreparacaoLinha(linha.paletes, dadosCargas.parametrosPreparacao) : t.tempoPrevMin,
      bistamp: t.bistamp || linha.bistamp,
      // **O kit acompanha a LINHA, como a quantidade.** Se o ERP mudar a
      // composição, a tarefa muda com ela — é isso que faz dos três campos
      // plano e não medição. E uma tarefa gerada antes disto existir ganha
      // aqui o kit que lhe faltava, sem precisar de ser recriada.
      ...ondKitDeOrigem(linha),
      foraDaCarga: false
    });
  }
  for (const t of porCasar) {
    if (ondTarefaTocada(t)) {
      if (!t.foraDaCarga) {
        marcadas += 1;
        difs.push(`\u2212 ${t.artigo} (j\xE1 trabalhada \u2014 fica marcada)`);
      }
      novas.push({ ...t, foraDaCarga: true });
    } else {
      removidas += 1;
      difs.push(`\u2212 ${t.artigo}`);
    }
  }
  if (destinoMudou) {
    difs.push(`destino: ${ondDestinoDaCarga(carga, camiao)}`);
  }
  const antesIds = daOnda.map((t) => t.id).join(",");
  const depoisIds = novas.map((t) => t.id).join(",");
  if (!difs.length && antesIds !== depoisIds) difs.push("ordem de carregamento alterada");
  let prioridadeId = onda.prioridadeId;
  const eraUrgente = !!(onda.origemCarga || {}).urgente;
  if (!!carga.urgente !== eraUrgente) {
    prioridadeId = carga.urgente ? "urgente" : "alta";
    difs.push(carga.urgente ? "carga passou a urgente" : "carga deixou de ser urgente");
  }
  if (!difs.length) return null;
  let estado = onda.estado;
  if (acrescentadas > 0 && estado === "concluida") {
    estado = onda.pessoaId ? "atribuida" : "disponivel";
    difs.push("a onda estava conclu\xEDda e voltou a ter trabalho");
  }
  const ondaNova = {
    ...onda,
    estado,
    prioridadeId,
    clienteId: paragens.map((p) => p.cliente.nome).join(", "),
    qtdTotal: paragens.reduce((s, p) => s + p.qtd, 0),
    paletes: ocupacao.ocupadas,
    // O retrato passa a ser o de AGORA — senão `ondCargaAlterada` continuava
    // a gritar sobre uma diferença que esta função acabou de resolver.
    origemCarga: {
      ...onda.origemCarga,
      cargaId: carga.id,
      camiaoId: carga.camiaoId,
      viagem: Number(carga.viagem) || 1,
      saida: camiao ? camiao.inicio : null,
      paletes: ocupacao.ocupadas,
      clientes: paragens.map((p) => p.clienteId),
      refs: paragens.flatMap((p) => p.artigos.map((a) => a.entrega.ref)).sort(),
      urgente: !!carga.urgente
    }
  };
  return { onda: ondaNova, tarefas: novas, difs, acrescentadas, removidas, marcadas };
}
const OND_HORAS_LIMIAR = 4;
function ondInstante(diaISO, minutos) {
  if (!diaISO || minutos == null) return null;
  const [y, m, d] = String(diaISO).split("-").map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0).getTime() + minutos * 6e4;
}
function ondJanelaDeColocacao(carga, dadosCargas, agoraMs, opcoes) {
  if (!carga) return null;
  const CL = window.CargoplannerLogica;
  const D = window.CargoplannerDados;
  const camiao = CL.camiaoDaCarga(carga, dadosCargas);
  const saidaMin = camiao ? CL.hhmm2min(camiao.inicio) : null;
  if (saidaMin == null) return null;
  const ate = ondInstante(carga.dia, saidaMin);
  if (ate == null || ate <= agoraMs) return null;
  const daConfig = dadosCargas && dadosCargas.parametrosPreparacao && dadosCargas.parametrosPreparacao.recuo_max_dias_uteis;
  const escolhido = (opcoes && opcoes.recuoMaxDiasUteis) != null ? opcoes.recuoMaxDiasUteis : daConfig != null ? daConfig : 2;
  const recuo = Math.max(0, Number(escolhido) || 0);
  const limite = ondInstante(D.diaUtilMenos(carga.dia, recuo), 0);
  return { de: Math.max(agoraMs, limite), ate };
}
function ondDiasCandidatos(carga, dadosCargas, agoraMs, opcoes) {
  const D = window.CargoplannerDados;
  const janela = ondJanelaDeColocacao(carga, dadosCargas, agoraMs, opcoes);
  if (!janela) return [];
  const dias = [];
  let dia = carga.dia;
  for (let volta = 0; volta < 60; volta += 1) {
    const inicioDoDia = ondInstante(dia, 0);
    if (inicioDoDia == null || inicioDoDia + 1440 * 6e4 <= janela.de) break;
    dias.push(dia);
    dia = D.diaMais(dia, -1);
  }
  return dias;
}
function ondNoLimiarDaSaida(carga, dadosCargas, agoraMs, horas) {
  const CL = window.CargoplannerLogica;
  const camiao = carga ? CL.camiaoDaCarga(carga, dadosCargas) : null;
  const saidaMin = camiao ? CL.hhmm2min(camiao.inicio) : null;
  if (saidaMin == null) return false;
  const saida = ondInstante(carga.dia, saidaMin);
  if (saida == null) return false;
  const h = Number(horas != null ? horas : OND_HORAS_LIMIAR);
  return agoraMs >= saida - h * 36e5;
}
function ondColocacaoDaOnda(onda, carga, dadosCargas, ctxPorDia, agoraMs, opcoes) {
  const janela = ondJanelaDeColocacao(carga, dadosCargas, agoraMs, opcoes);
  if (!janela) return { motivo: "sem_janela" };
  let viuAlguem = false;
  for (const dia of ondDiasCandidatos(carga, dadosCargas, agoraMs, opcoes)) {
    const ctx = ctxPorDia && ctxPorDia[dia];
    if (ctx && ctx.dados) {
      let melhor = null;
      const comAOnda = [...(ctx.ondas || []).filter((o) => o.id !== onda.id), onda];
      for (const pessoa of ctx.dados.pessoas || []) {
        const avisos = ondValidarAtribuicao(onda, pessoa, comAOnda, ctx.dados) || [];
        if (avisos.some((a) => a.nivel === "erro")) continue;
        viuAlguem = true;
        const agenda = ondAgendaDaPessoa(
          pessoa.id,
          comAOnda.map((o) => o.id === onda.id ? { ...o, pessoaId: pessoa.id, ordem: 9999 } : o),
          ctx.dados
        );
        const bloco = agenda.find((a) => a.onda.id === onda.id);
        if (!bloco) continue;
        const acaba = ondInstante(dia, bloco.fimMin);
        if (acaba == null || acaba > janela.ate || acaba < janela.de) continue;
        if (!melhor || acaba > melhor.acaba) {
          melhor = { acaba, pessoaId: pessoa.id, pessoa, avisos, fimMin: bloco.fimMin };
        }
      }
      if (melhor) {
        const turno = (ctx.dados.turnos || []).find((t) => t.id === melhor.pessoa.turnoId);
        return {
          dia,
          pessoaId: melhor.pessoaId,
          nome: melhor.pessoa.nome,
          turnoLabel: melhor.pessoa.turnoLabel || turno && turno.label || null,
          acabaMs: melhor.acaba,
          acabaMin: melhor.fimMin,
          avisos: melhor.avisos
        };
      }
    }
  }
  return { motivo: viuAlguem ? "sem_quando" : "sem_competencia" };
}
function ondDiaCurto(diaISO) {
  const p = String(diaISO || "").split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}` : String(diaISO || "");
}
function ondTextoDaColocacao(colocacao, carga, dadosCargas) {
  if (!colocacao) return null;
  const CL = window.CargoplannerLogica;
  const D = window.CargoplannerDados;
  if (!colocacao.motivo) {
    const vespera = carga && colocacao.dia === D.diaMais(carga.dia, -1);
    const quando = colocacao.dia && carga && colocacao.dia !== carga.dia ? `${ondDiaCurto(colocacao.dia)}${vespera ? " (v\xE9spera)" : ""}` : "no pr\xF3prio dia";
    const turno = colocacao.turnoLabel ? `, ${colocacao.turnoLabel}` : "";
    const hora = colocacao.acabaMin != null ? ` \xB7 acaba \xE0s ${CL.min2hhmm(colocacao.acabaMin)}` : "";
    return {
      tipo: "ok",
      dia: colocacao.dia,
      pessoaId: colocacao.pessoaId,
      texto: `${quando}${turno} \xB7 ${colocacao.nome || "por atribuir"}${hora}`,
      ressalvas: (colocacao.avisos || []).map((a) => a.msg).filter(Boolean)
    };
  }
  const camiao = carga ? CL.camiaoDaCarga(carga, dadosCargas) : null;
  const saida = camiao && camiao.inicio ? ` (${camiao.inicio})` : "";
  const porque = {
    sem_janela: `A sa\xEDda${saida} j\xE1 passou \u2014 n\xE3o h\xE1 janela nenhuma para preparar esta carga. \xC9 o que acontece a uma carga atrasada.`,
    sem_competencia: `N\xE3o h\xE1 onde preparar esta carga antes da sa\xEDda${saida}: ningu\xE9m ao servi\xE7o nestes dias tem a compet\xEAncia necess\xE1ria \u2014 \xE9 escala ou forma\xE7\xE3o, n\xE3o \xE9 falta de tempo.`,
    sem_quando: `N\xE3o h\xE1 onde preparar esta carga antes da sa\xEDda${saida}: h\xE1 quem possa faz\xEA-lo, e ningu\xE9m acaba a tempo \u2014 \xE9 preciso libertar algu\xE9m ou mudar a hora de sa\xEDda.`
  }[colocacao.motivo];
  return {
    tipo: "nao_da",
    motivo: colocacao.motivo,
    dia: null,
    pessoaId: null,
    texto: porque || "N\xE3o foi poss\xEDvel colocar a prepara\xE7\xE3o desta carga.",
    ressalvas: []
  };
}
function ondComColocacao(geradas, carga, dadosCargas, ctxPorDia, agoraMs, opcoes) {
  return (geradas || []).map((g) => {
    const comTarefas = {};
    for (const [d, ctx] of Object.entries(ctxPorDia || {})) {
      comTarefas[d] = ctx && ctx.dados ? { ...ctx, dados: {
        ...ctx.dados,
        tarefas: [...ctx.dados.tarefas || [], ...g.tarefas || []]
      } } : ctx;
    }
    const r = ondColocacaoDaOnda(g.onda, carga, dadosCargas, comTarefas, agoraMs, opcoes);
    const dono = g.onda.pessoaId != null ? g.onda.pessoaId : r.pessoaId || null;
    return {
      ...g,
      onda: {
        ...g.onda,
        dia: r.dia || g.onda.dia,
        pessoaId: dono,
        estado: dono && g.onda.estado === "disponivel" ? "atribuida" : g.onda.estado,
        colocacao: r
      }
    };
  });
}
function ondJanelaDoCais(carga, dadosCargas, ondas, dadosOndas) {
  const CL = window.CargoplannerLogica;
  if (!carga) return null;
  if (CL.ESTADOS_SEM_VIAGEM.includes(carga.estado)) return null;
  const cais = CL.caisCanonico(carga.localizacaoDestino);
  if (!cais) return null;
  const camiao = CL.camiaoDaCarga(carga, dadosCargas);
  const saidaMin = camiao ? CL.hhmm2min(camiao.inicio) : null;
  if (saidaMin == null) return null;
  const ate = ondInstante(carga.dia, saidaMin);
  if (ate == null) return null;
  const onda = (ondas || []).find(
    (o) => o.cargaId === carga.id && !ondForaDeCirculacao(o) && o.pessoaId
  );
  const bloco = onda ? (ondAgendaDaPessoa(onda.pessoaId, ondas, dadosOndas) || []).find((b) => b.onda.id === onda.id) : null;
  const de = bloco ? ondInstante(onda.dia || carga.dia, bloco.inicioMin) : null;
  if (de == null || de > ate) {
    return { cais, de: ate, ate, inicioConhecido: false };
  }
  return { cais, de, ate, inicioConhecido: true };
}
function ondJanelasChocam(a, b) {
  if (!a || !b) return false;
  if (a.de === a.ate && b.de === b.ate) return a.de === b.de;
  if (a.de === a.ate) return a.de > b.de && a.de < b.ate;
  if (b.de === b.ate) return b.de > a.de && b.de < a.ate;
  return a.de < b.ate && b.de < a.ate;
}
function ondChoquesDeCais(cargas, dadosCargas, ondas, dadosOndas) {
  const CL = window.CargoplannerLogica;
  const comJanela = (cargas || []).map((c) => ({ carga: c, j: ondJanelaDoCais(c, dadosCargas, ondas, dadosOndas) })).filter((x) => x.j);
  const saida = {};
  for (const x of comJanela) {
    const outros = comJanela.filter(
      (y) => y.carga.id !== x.carga.id && y.j.cais === x.j.cais && ondJanelasChocam(x.j, y.j)
    );
    if (!outros.length) continue;
    saida[x.carga.id] = outros.map((y) => ({
      cargaId: y.carga.id,
      // O rótulo é o do CAMIÃO: o `cargaId` é um `srv-42` que não diz nada a
      // quem lê o aviso, e é a ele que se vai falar a seguir.
      rotulo: CL.rotuloDaCarga(y.carga),
      cais: y.j.cais,
      de: y.j.de,
      ate: y.j.ate,
      inicioConhecido: y.j.inicioConhecido
    }));
  }
  return saida;
}
function ondCaisOcupadoPor(codigo, carga, cargas, dadosCargas, ondas, dadosOndas) {
  const CL = window.CargoplannerLogica;
  const cais = CL.caisCanonico(codigo);
  if (!cais || !carga) return [];
  const minha = ondJanelaDoCais(
    { ...carga, localizacaoDestino: cais },
    dadosCargas,
    ondas,
    dadosOndas
  );
  if (!minha) return [];
  return (cargas || []).filter((c) => c.id !== carga.id).map((c) => ({ carga: c, j: ondJanelaDoCais(c, dadosCargas, ondas, dadosOndas) })).filter((x) => x.j && x.j.cais === cais && ondJanelasChocam(minha, x.j)).map((x) => ({
    cargaId: x.carga.id,
    rotulo: CL.rotuloDaCarga(x.carga),
    cais: x.j.cais,
    de: x.j.de,
    ate: x.j.ate,
    inicioConhecido: x.j.inicioConhecido
  }));
}
function ondPrevisaoPreparacao(carga, dadosCargas, ondas, dadosOndas, agoraMs) {
  const CL = window.CargoplannerLogica;
  const vazio = (estado) => ({
    estado,
    nivel: null,
    msg: null,
    minutosAtraso: null,
    horaLimite: null,
    minutosNecessarios: null,
    semPaletes: 0
  });
  if (!carga) return vazio("sem_horario");
  const camiao = CL.camiaoDaCarga(carga, dadosCargas);
  const saidaMin = camiao ? CL.hhmm2min(camiao.inicio) : null;
  if (saidaMin == null) return vazio("sem_horario");
  const oc = CL.ocupacao(carga, dadosCargas);
  const ressalvaIncompleta = oc.semPaletes > 0 ? ` (${oc.semPaletes} linha${oc.semPaletes === 1 ? "" : "s"} sem quantidade por palete no ERP \u2014 o tempo real pode ser maior)` : "";
  const dia = carga.dia;
  const onda = (ondas || []).find(
    (o) => o.cargaId === carga.id && !ondForaDeCirculacao(o)
  );
  const faltamMin = agoraMs != null && ondNoLimiarDaSaida(carga, dadosCargas, agoraMs) ? Math.round((ondInstante(carga.dia, saidaMin) - agoraMs) / 6e4) : null;
  const urgencia = faltamMin == null ? "" : faltamMin <= 0 ? " A hora de sa\xEDda j\xE1 passou." : ` Faltam ${CL.duracao(faltamMin)} para a sa\xEDda.`;
  if (!onda || !onda.pessoaId) {
    const prev = CL.tempoPreparacao(carga, dadosCargas);
    if (!prev.linhas) return vazio("sem_atribuicao");
    return {
      estado: "sem_atribuicao",
      nivel: "aviso",
      minutosAtraso: null,
      horaLimite: null,
      minutosNecessarios: prev.minutos,
      semPaletes: oc.semPaletes,
      msg: `Precisa de ${CL.duracao(prev.minutos)} de prepara\xE7\xE3o e ainda n\xE3o est\xE1 atribu\xEDda a ningu\xE9m em Ondas \u2014 n\xE3o d\xE1 para dizer se fica pronta a tempo da sa\xEDda (${camiao.inicio})${ressalvaIncompleta}.${urgencia}`
    };
  }
  const minha = (ondAgendaDaPessoa(onda.pessoaId, ondas, dadosOndas) || []).find((a) => a.onda.id === onda.id);
  if (!minha) return vazio("sem_atribuicao");
  const fimReal = ondInstante(onda.dia || carga.dia, minha.fimMin);
  const saidaReal = ondInstante(carga.dia, saidaMin);
  if (fimReal == null || saidaReal == null || fimReal <= saidaReal) return vazio("a_tempo");
  const atrasoMin = Math.round((fimReal - saidaReal) / 6e4);
  const horaLimiteMin = saidaMin - minha.duracaoMin;
  return {
    estado: "atraso",
    nivel: "aviso",
    minutosAtraso: atrasoMin,
    horaLimite: CL.min2hhmm(horaLimiteMin),
    minutosNecessarios: minha.duracaoMin,
    semPaletes: oc.semPaletes,
    msg: `A prepara\xE7\xE3o (${onda.codigo}) s\xF3 acaba \xE0s ${CL.min2hhmm(minha.fimMin)}, ${CL.duracao(atrasoMin)} depois da sa\xEDda (${camiao.inicio}). Tinha de come\xE7ar at\xE9 \xE0s ${CL.min2hhmm(horaLimiteMin)}${ressalvaIncompleta}.${urgencia}`
  };
}
function ondMetricas(ondas, dados) {
  const vivas = (ondas || []).filter((o) => !ondForaDeCirculacao(o));
  const concluidas = vivas.filter((o) => o.estado === "concluida");
  const porTipo = {};
  for (const o of vivas) {
    const d = ondDesvio(o, dados);
    if (!porTipo[o.tipoId]) porTipo[o.tipoId] = { previsto: 0, real: 0, n: 0 };
    porTipo[o.tipoId].previsto += d.previstoMin;
    porTipo[o.tipoId].real += d.realMin;
    porTipo[o.tipoId].n += 1;
  }
  const tarefas = dados.tarefas || [];
  const comReal = tarefas.filter((t) => t.tempoRealMin != null);
  const dentroDoTempo = comReal.filter((t) => t.tempoRealMin <= t.tempoPrevMin);
  return {
    ondasTotal: vivas.length,
    ondasConcluidas: concluidas.length,
    ondasPorAtribuir: ondDisponiveis(vivas).length,
    tarefasTotal: tarefas.length,
    tarefasConcluidas: tarefas.filter((t) => t.estado === "concluida").length,
    pctDentroDoTempo: comReal.length ? Math.round(dentroDoTempo.length / comReal.length * 100) : null,
    porTipo
  };
}
const OND_SEM_ARMAZEM = "__sem_armazem__";
function ondArmazensPresentes(pessoas) {
  const porId = /* @__PURE__ */ new Map();
  let semArmazem = false;
  (pessoas || []).forEach((p) => {
    if (p.armazemId) porId.set(p.armazemId, p.armazemLabel || p.armazem || p.armazemId);
    else semArmazem = true;
  });
  const lista = [...porId.entries()].map(([id, label]) => ({ id, label })).sort((a, b) => a.label.localeCompare(b.label));
  if (semArmazem) lista.push({ id: OND_SEM_ARMAZEM, label: "Sem armaz\xE9m" });
  return lista;
}
function ondNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}
function ondTexto(v, max) {
  const t = v == null ? "" : String(v);
  return t.length <= max ? t : `${t.slice(0, max - 1)}\u2026`;
}
function ondId(v) {
  return v == null ? null : String(v);
}
function ondVocabDoServidor(lista) {
  return (lista || []).map((v) => ({
    id: v.codigo,
    servidorId: v.id,
    label: v.nome,
    cor: v.cor || null,
    // O CÓDIGO da competência (não o nome nem o pk): é contra
    // `pessoa.competencias`, que `escala.resolver` devolve como códigos,
    // que `ondValidarAtribuicao` a compara.
    competencia: v.competencia_codigo || null,
    rank: v.ordem == null ? 0 : v.ordem,
    ativo: v.ativo !== false
  }));
}
function ondMotivosDoServidor(lista) {
  return (lista || []).map((m) => ({
    id: ondId(m.id),
    servidorId: m.id,
    label: m.nome,
    rank: m.ordem == null ? 0 : m.ordem,
    ativo: m.ativo !== false
  }));
}
function ondTarefaDoServidor(t, ondaId, cargaId) {
  return {
    id: ondId(t.id),
    servidorId: t.id,
    ondaId,
    // O mesmo id de apresentação que a onda tem — para uma tarefa lida do
    // servidor ficar igual a uma acabada de gerar, e não haver campos que
    // existem antes do F5 e desaparecem depois.
    cargaId: cargaId == null ? null : cargaId,
    tipo: t.tipo || "",
    artigo: t.artigo || "",
    descricao: t.descricao || "",
    qtd: ondNum(t.qtd),
    // A unidade da linha de encomenda. Vazia é «não se sabe» — o ecrã cai
    // em «un.», que é o que 91 % das linhas são.
    unidade: t.unidade || "",
    origem: t.origem || "",
    destino: t.destino || "",
    tempoPrevMin: ondNum(t.tempo_prev_min),
    // `null` é «ainda não se mediu», e NÃO zero — a distinção é a que faz
    // `ondTempoReal` não contar uma tarefa por medir como instantânea.
    tempoRealMin: t.tempo_real_min == null ? null : ondNum(t.tempo_real_min),
    origemTempo: t.origem_tempo || "padrao",
    // Carimbados pelo SERVIDOR na transição de estado — ver
    // `backend/tarefa_carimbos.py`. Nunca viajam no sentido contrário.
    inicioReal: t.inicio_real || null,
    fimReal: t.fim_real || null,
    // **A versão, tal como o servidor a mandou.** String CRUA, nunca
    // passada por um `Date` do JavaScript: ele só tem precisão ao
    // milissegundo, e perdê-la dava um 409 a cada gravação sem ninguém ter
    // mudado nada. É a armadilha que a carga já pagou, e está escrita no
    // `CLAUDE.md` desta app.
    versao: t.atualizado_em || null,
    estado: t.estado || "pendente",
    pausas: t.pausas || [],
    // Os lotes já picados para esta tarefa, guardados no hub e ainda não
    // enviados ao PHC — ver `ondPicadoDaTarefa`, mais abaixo.
    lotes: t.lotes || [],
    clienteId: t.cliente_id || null,
    // De que linha da carga nasceu, e se essa linha ainda lá está — ver
    // `ondSincronizarOndaComCarga`. Vazio nas tarefas geradas antes disto.
    bistamp: t.bistamp || "",
    foraDaCarga: !!t.fora_da_carga,
    // De que KIT é esta tarefa (fatia c). Vazio é «não é de kit nenhum»,
    // que é a esmagadora maioria.
    kitRef: t.kit_ref || "",
    kitBistamp: t.kit_bistamp || "",
    // **`null` é «não se sabe», e NUNCA 1.** O `ondNum` devolveria 0 para
    // `null`, e 0 na divisão da proporção dá `Infinity` — por isso o nulo
    // atravessa intacto, como o `tempo_real_min` logo acima.
    kitRazao: t.kit_razao == null ? null : ondNum(t.kit_razao)
  };
}
function ondKitDeOrigem(src) {
  const o = src || {};
  return {
    kitRef: o.kitRef || "",
    kitBistamp: o.kitBistamp || "",
    kitRazao: o.kitRazao == null ? null : ondNum(o.kitRazao)
  };
}
function ondKitDaTarefa(tarefa, tarefas) {
  const chave = tarefa && tarefa.kitBistamp || "";
  if (!chave) return null;
  const onda = tarefa && tarefa.ondaId || null;
  const irmas = (tarefas || []).filter((t) => t && t.kitBistamp === chave && (!onda || !t.ondaId || t.ondaId === onda));
  const i = irmas.findIndex((t) => t === tarefa || t.id && t.id === tarefa.id);
  const total = (i === -1 ? irmas.length + 1 : irmas.length) || 1;
  const razao = Number(tarefa.kitRazao);
  return {
    ref: tarefa.kitRef || "",
    bistamp: chave,
    // Zero e não-número são «não se sabe» como o nulo: 0 daria `Infinity` na
    // divisão da proporção. A mesma guarda do `cpKitsDeQuantidades`.
    razao: Number.isFinite(razao) && razao > 0 ? razao : null,
    // Sem a lista (o tablet pode ter a tarefa e ainda não a onda toda)
    // responde pela própria: «1 de 1» é o que se sabe, e é honesto.
    indice: i === -1 ? total : i + 1,
    total
  };
}
function ondOndaDoServidor(o) {
  return {
    id: ondId(o.id),
    servidorId: o.id,
    codigo: o.codigo || "",
    tipoId: o.tipo_codigo || null,
    motivoId: ondId(o.motivo),
    prioridadeId: o.prioridade_codigo || null,
    dia: o.dia,
    estado: o.estado || "disponivel",
    pessoaId: ondId(o.pessoa),
    // O NOME vem achatado do servidor, e o dashboard depende disso: um
    // período de um mês atravessa dias em que a pessoa pode nem estar
    // escalada, e a lista de pessoas do dia (`escala.resolver`) não a teria.
    // Sem isto, medir alguém que mudou de turno ou saiu da equipa dava uma
    // linha sem nome.
    pessoaNome: o.pessoa_nome || null,
    ordem: ondNum(o.ordem),
    clienteId: o.cliente_id || null,
    // A CHAVE do cliente que esta onda prepara — o que distingue as ondas da
    // mesma carga umas das outras. `cliente_id` ao lado é o NOME, para se
    // mostrar.
    clientePhc: o.cliente_phc || "",
    // O ecrã trata uma carga pelo id de APRESENTAÇÃO (`srv-7`) — é o que a
    // aba Cargas usa e o que `ondGerarOndasDeCarga` compara para saber se já
    // existe onda para aquela carga. O pk fica ao lado, em `cargaServidorId`,
    // que é o que a FK do servidor quer: derivar um do outro por parsing do
    // texto seria transformar um rótulo de ecrã em chave de base de dados.
    cargaId: o.carga == null ? null : `srv-${o.carga}`,
    cargaServidorId: o.carga == null ? null : o.carga,
    zona: o.zona || null,
    qtdTotal: ondNum(o.qtd_total),
    paletes: ondNum(o.paletes),
    dependeDe: (o.depende_de || []).map(ondId),
    observacoes: o.observacoes || "",
    origemCarga: o.origem_carga || null,
    // Quem teve esta onda e não a acabou (#113). Lista, porque a mesma onda
    // pode transitar várias vezes; `[]` é «nunca transitou». As entradas vêm
    // na forma do servidor (`pessoa_id`, `pessoa_nome`) e ficam assim — ver
    // `ondTransitou` para a razão de não serem traduzidas.
    transicoes: o.transicoes || [],
    versao: o.atualizado_em || null,
    // Quando é que esta onda aconteceu MESMO — derivados das tarefas pelo
    // servidor (o menor início; o maior fim, e só quando está concluída).
    // `null` é «não se mediu»: uma onda anterior a isto fica no lugar
    // simulado, e o ecrã di-lo.
    inicioReal: o.inicio_real || null,
    fimReal: o.fim_real || null
  };
}
function ondTarefasDoServidor(ondas) {
  const fora = [];
  (ondas || []).forEach((o) => {
    const ondaId = ondId(o.id);
    const cargaId = o.carga == null ? null : `srv-${o.carga}`;
    (o.tarefas || []).forEach((t) => fora.push(ondTarefaDoServidor(t, ondaId, cargaId)));
  });
  return fora;
}
function ondTarefaParaServidor(t, cargaServidorId) {
  return {
    tipo: ondTexto(t.tipo, 60),
    artigo: ondTexto(t.artigo, 40),
    descricao: ondTexto(t.descricao, 200),
    qtd: ondNum(t.qtd),
    unidade: ondTexto(t.unidade, 12),
    origem: ondTexto(t.origem, 80),
    destino: ondTexto(t.destino, 80),
    tempo_prev_min: Math.max(0, Math.round(ondNum(t.tempoPrevMin))),
    tempo_real_min: t.tempoRealMin == null ? null : Math.max(0, Math.round(ondNum(t.tempoRealMin))),
    origem_tempo: t.origemTempo || "padrao",
    estado: t.estado || "pendente",
    pausas: t.pausas || [],
    cliente_id: ondTexto(t.clienteId, 160),
    bistamp: ondTexto(t.bistamp, 25),
    fora_da_carga: !!t.foraDaCarga,
    ...ondKitParaServidor(t),
    // A carga de uma tarefa é sempre a da ONDA — não há caso em que
    // divirjam, e derivá-la aqui poupa um campo que se podia dessincronizar
    // tarefa a tarefa sem ninguém reparar.
    carga: cargaServidorId == null ? null : cargaServidorId
  };
}
function ondKitParaServidor(t) {
  const razao = Number(t && t.kitRazao);
  return {
    kit_ref: ondTexto(t && t.kitRef, 40),
    kit_bistamp: ondTexto(t && t.kitBistamp, 25),
    kit_razao: t && t.kitRazao != null && Number.isFinite(razao) ? razao : null
  };
}
function ondTarefaPlanoParaServidor(t) {
  return {
    id: t.servidorId,
    qtd: ondNum(t.qtd),
    // A unidade é do PLANO, como a quantidade: vem da linha de encomenda, e
    // se ela mudar no ERP a tarefa acompanha. Não é medição de ninguém.
    unidade: ondTexto(t.unidade, 12),
    descricao: ondTexto(t.descricao, 200),
    destino: ondTexto(t.destino, 80),
    tempo_prev_min: Math.max(0, Math.round(ondNum(t.tempoPrevMin))),
    cliente_id: ondTexto(t.clienteId, 160),
    bistamp: ondTexto(t.bistamp, 25),
    fora_da_carga: !!t.foraDaCarga,
    // De que kit é — é do PLANO, como a unidade e a quantidade: se o ERP
    // mudar a composição, a tarefa acompanha-a.
    ...ondKitParaServidor(t)
  };
}
function ondSincronizacaoParaServidor(onda, catalogos, tarefas) {
  const corpo = ondOndaParaServidor(onda, catalogos);
  corpo.tarefas = (tarefas || []).map((t) => t._nova ? ondTarefaParaServidor(t, corpo.carga) : ondTarefaPlanoParaServidor(t));
  return corpo;
}
function ondTarefaProgressoParaServidor(t) {
  const corpo = {
    estado: t.estado || "pendente",
    tempo_real_min: t.tempoRealMin == null ? null : Math.max(0, Math.round(ondNum(t.tempoRealMin))),
    origem_tempo: t.origemTempo || "padrao",
    pausas: t.pausas || []
  };
  if (t.versao) corpo.versao_esperada = t.versao;
  return corpo;
}
function ondLotesParaServidor(t) {
  const corpo = { lotes: (t.lotes || []).map((l) => ({
    codigo: l.codigo || "",
    ref: l.ref || "",
    qtd: l.qtd == null ? null : ondNum(l.qtd),
    // **Quanto a PALETE tinha quando se picou.** É o que deixa saber se ela
    // saiu inteira; sem isto no corpo, a whitelist do servidor nunca o veria
    // — e uma chave que não faz a viagem desaparece em silêncio.
    stockPalete: l.stockPalete == null ? null : ondNum(l.stockPalete),
    // **O cronómetro no instante do pick** (cartão #148). Sem ele aqui a
    // whitelist do servidor nunca o veria, e um F5 voltava a perder o tempo.
    acumuladoMin: l.acumuladoMin == null ? null : Number(l.acumuladoMin),
    // De ONDE veio, e PARA ONDE foi alocada. `destino` vazio é «picada mas
    // ainda por alocar» — e é esse estado que o tablet não deixa concluir.
    local: l.local || "",
    destino: l.destino || "",
    // A base do PHC de onde a etiqueta foi lida: a alocação precisa dela, e
    // um F5 a meio do picking apagava-a se ela vivesse só no React.
    empresa: l.empresa == null ? null : Number(l.empresa),
    em: l.em || "",
    // **A linha que esta palete já criou no picking do PHC** (dossier 82).
    // Tem de fazer a viagem de volta: é ela que impede um segundo
    // lançamento da mesma palete, e esta função é uma WHITELIST — uma chave
    // que não esteja aqui desaparece em silêncio, exactamente como o
    // `acumuladoMin` desapareceu no servidor.
    phcBistamp: l.phcBistamp || "",
    phcObrano: l.phcObrano == null ? null : Number(l.phcObrano),
    // **O carimbo de quem devolveu a palete ao armazém** (cartão #131). Tem
    // de fazer a viagem de volta pela MESMA razão do `phcBistamp` logo
    // acima, e o preço de o esquecer era maior: sem ele aqui, a primeira
    // etiqueta que o operador lesse nesta tarefa mandava a lista toda sem o
    // carimbo, o servidor lia a chave ausente como «não largada», e a palete
    // voltava a reservar **sem ninguém a ter picado**. Pior ainda no ramo em
    // que `largar-reserva` é a ÚNICA saída — uma palete já lançada no
    // dossier 82 não se desmarca nem se corrige no tablet.
    largadaEm: l.largadaEm || null
    // `phcErro` fica DE FORA de propósito: é o que correu mal agora, não um
    // facto sobre a palete. Gravá-lo punha no servidor uma falha de rede de
    // há três dias, e ao reler o dia a palete aparecia com um erro que já
    // não existe. A whitelist do servidor deita-o fora na mesma.
  })) };
  if (t.versao) corpo.versao_esperada = t.versao;
  return corpo;
}
function ondPhcDosLotes(tarefas) {
  const lista = Array.isArray(tarefas) ? tarefas : tarefas ? [tarefas] : [];
  let lancadas = 0, porLancar = 0, comErro = 0;
  lista.forEach((t) => (t.lotes || []).forEach((l) => {
    if (l.phcBistamp) lancadas += 1;
    else {
      porLancar += 1;
      if (l.phcErro) comErro += 1;
    }
  }));
  return { lancadas, porLancar, comErro, total: lancadas + porLancar };
}
function ondEstadoPhcDoLote(tarefa, lote) {
  if (!tarefa || !lote) return null;
  if (lote.phcBistamp) return "lancada";
  if (lote.phcErro) return "falhou";
  return tarefa.estado === "concluida" ? "por_lancar" : null;
}
function ondLinhaAposRecusa(resultado, fallback) {
  if (!resultado || !resultado.recusado) return null;
  return {
    ok: false,
    // A frase do servidor é a que interessa — nomeia a palete, quanto sobra
    // e quem tem o resto. O genérico é só rede de segurança para uma recusa
    // que não trouxe texto nenhum.
    msg: resultado.mensagem || fallback || "O servidor recusou esta grava\xE7\xE3o."
  };
}
function ondLinhaAposPicar(resultado) {
  return ondLinhaAposRecusa(
    resultado,
    "O servidor recusou esta palete. N\xE3o ficou picada."
  );
}
function ondPaleteSaiInteira(lote) {
  if (!lote) return null;
  const picada = lote.qtd == null || lote.qtd === "" ? null : ondNum(lote.qtd);
  const tinha = lote.stockPalete == null || lote.stockPalete === "" ? null : ondNum(lote.stockPalete);
  if (picada == null || tinha == null) return null;
  if (!(tinha > 0)) return null;
  return picada >= tinha;
}
function ondLotesPorAlocar(tarefa) {
  return (tarefa && tarefa.lotes || []).filter((l) => !l.destino && ondPaleteSaiInteira(l) !== false);
}
function ondPicadoDaTarefa(tarefa) {
  const lotes = tarefa && tarefa.lotes || [];
  const pedido = ondNum(tarefa && tarefa.qtd);
  let picado = 0;
  let semQtd = 0;
  lotes.forEach((l) => {
    if (l.qtd == null || l.qtd === "") {
      semQtd += 1;
      return;
    }
    picado += ondNum(l.qtd);
  });
  const falta = Math.max(0, pedido - picado);
  const porAlocar = ondLotesPorAlocar(tarefa).length;
  return {
    lotes,
    paletes: lotes.length,
    picado,
    pedido,
    semQtd,
    porAlocar,
    alocadas: lotes.length - porAlocar,
    falta,
    excesso: Math.max(0, picado - pedido),
    // «Já chega» só se afirma quando se sabe de todas.
    chega: !semQtd && pedido > 0 && picado >= pedido
  };
}
function ondTectoDePaletes(porFazer, parametros) {
  const bruto = parametros ? parametros.max_paletes_por_alocar : null;
  const n = bruto == null || bruto === "" ? 0 : ondNum(bruto);
  const tecto = n > 0 ? n : null;
  const porAlocar = (porFazer || []).reduce(
    (soma, x) => soma + ondLotesPorAlocar(x && x.tarefa).length,
    0
  );
  if (tecto == null) {
    return {
      tecto: null,
      porAlocar,
      podePicar: true,
      restam: null,
      motivo: "sem_tecto"
    };
  }
  return {
    tecto,
    porAlocar,
    podePicar: porAlocar < tecto,
    // Nunca negativo: quem já tinha mais do que o tecto quando ele desceu em
    // Definições vê «0 restantes», não «-4».
    restam: Math.max(0, tecto - porAlocar),
    motivo: porAlocar >= tecto ? "no_tecto" : "ha_espaco"
  };
}
function ondTectoComEmCurso(tecto, emCurso) {
  const extra = Math.max(0, Number(emCurso) || 0);
  if (!tecto || tecto.tecto == null || !extra) return tecto;
  const porAlocar = tecto.porAlocar + extra;
  return {
    tecto: tecto.tecto,
    porAlocar,
    podePicar: porAlocar < tecto.tecto,
    restam: Math.max(0, tecto.tecto - porAlocar),
    motivo: porAlocar >= tecto.tecto ? "no_tecto" : "ha_espaco"
  };
}
function ondTextoDoTecto(r) {
  if (!r || r.tecto == null || r.podePicar) return "";
  const n = r.porAlocar;
  return `${n} palete${n === 1 ? "" : "s"} por alocar \u2014 l\xEA a localiza\xE7\xE3o de destino antes de picar mais`;
}
function ondReservaDaPalete(linha, opcoes) {
  const l = linha || {};
  const o = opcoes || {};
  const minha = o.tarefaId == null ? null : String(o.tarefaId);
  const bruto = l.stock == null || l.stock === "" ? NaN : Number(l.stock);
  const stock = Number.isFinite(bruto) ? bruto : null;
  const anotada = typeof l.reservado === "number" && Number.isFinite(l.reservado) || l.reserva_incompleta === true;
  const todas = Array.isArray(l.reservado_por) ? l.reservado_por : [];
  const por = minha == null ? todas : todas.filter((e) => String(e && e.tarefa) !== minha);
  let reservado = 0;
  let incompleta = false;
  if (anotada && minha != null) {
    por.forEach((e) => {
      if (!e || e.qtd == null) {
        incompleta = true;
        return;
      }
      const n = Number(e.qtd);
      reservado += Number.isFinite(n) ? n : 0;
    });
    if (incompleta) reservado = null;
  } else if (anotada) {
    reservado = l.reserva_incompleta === true ? null : l.reservado;
    incompleta = l.reserva_incompleta === true;
  }
  const disponivel = reservado === null || stock === null ? null : Math.max(stock - reservado, 0);
  let estado;
  if (!anotada) estado = "sem_info";
  else if (incompleta) estado = "por_medir";
  else if (!reservado) estado = "livre";
  else if (disponivel === 0) estado = "esgotada";
  else estado = "reservada";
  const quem = por.map(ondQuemTemAPalete).join(", ");
  const num = (v) => Number(v).toLocaleString("pt-PT");
  const comQuem = quem || "outra tarefa";
  let nivel = null;
  let texto = null;
  if (estado === "reservada") {
    nivel = "aviso";
    texto = disponivel === null ? `${num(reservado)} j\xE1 picado por ${comQuem} \u2014 n\xE3o se sabe quanto sobra.` : `Livre ${num(disponivel)} de ${num(stock)} \u2014 ${num(reservado)} j\xE1 picado por ${comQuem}.`;
  } else if (estado === "esgotada") {
    nivel = "bloqueio";
    texto = `Sem nada livre: as ${num(stock)} desta palete j\xE1 est\xE3o picadas por ${comQuem}.`;
  } else if (estado === "por_medir") {
    nivel = "aviso";
    texto = `Algu\xE9m j\xE1 picou desta palete e n\xE3o se sabe quanto levou (${comQuem}) \u2014 confirme no armaz\xE9m o que sobra antes de levar.`;
  }
  return {
    estado,
    reservado,
    disponivel,
    por,
    quem,
    nivel,
    texto,
    // Só «esgotada» impede. Tudo o resto avisa — incluindo o «não se sabe»,
    // pela razão escrita no topo.
    podePicar: estado !== "esgotada",
    // **A caixa da quantidade nasce com o que está LIVRE, não com o stock da
    // palete.** Nascer com o stock inteiro era pôr o operador a reivindicar
    // o que outra pessoa já tem na mão — e a gravação levava com o 400 da
    // regra do servidor sem ele perceber porquê.
    //
    // **Onde o livre não se sabe (`por_medir`), nasce VAZIA (`null`).** Foi
    // a decisão desta task, entre as três possíveis: o stock inteiro é uma
    // reivindicação que pode estar errada (é precisamente a palete de que
    // alguém já levou não se sabe quanto), e zero diria «levei nenhuma».
    // Vazia é a única das três que não inventa um número — e quem picar sem
    // escrever nada fica com um lote sem quantidade, que é o estado que a
    // app já modela (`semQtd`) e que diz a verdade: levou-se dali, não se
    // mediu. O operador escreve o número assim que o souber.
    qtdInicial: disponivel
  };
}
function ondQuemTemAPalete(entrada) {
  const e = entrada || {};
  if (e.pessoa && e.onda) return `${e.pessoa} (onda ${e.onda})`;
  if (e.pessoa) return String(e.pessoa);
  if (e.onda) return `onda ${e.onda}, ainda sem dono`;
  return "outra tarefa";
}
function ondQtdAPicar(ecra, qtdEtiqueta) {
  const numero = (v2) => {
    if (v2 == null || v2 === "") return null;
    const n2 = Number(v2);
    return Number.isFinite(n2) ? n2 : null;
  };
  const e = ecra || null;
  if (!e) return numero(qtdEtiqueta);
  const inicial = numero(e.qtdInicial);
  if (e.escrito === void 0 || e.escrito === null) return inicial;
  const v = String(e.escrito).replace(",", ".").trim();
  if (!v) return inicial;
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : inicial;
}
function ondEcraDaPalete(escritas, codigo, qtdInicial) {
  const m = escritas || {};
  return {
    escrito: Object.prototype.hasOwnProperty.call(m, codigo) ? m[codigo] : void 0,
    qtdInicial
  };
}
function ondDentroDaMargem(linha, margemPct) {
  if (!linha || linha.motivo || linha.picado == null) return null;
  const planeado = ondNum(linha.planeado);
  const picado = ondNum(linha.picado);
  if (linha.qtdCerta) return picado === planeado;
  if (!planeado) return picado === planeado;
  const pct = Math.abs(Number(margemPct));
  if (!Number.isFinite(pct) || pct <= 0) return picado === planeado;
  return Math.abs(picado - planeado) <= planeado * pct / 100;
}
function ondCargaPodeFechar(ondas, tarefas, carga, dadosCargas, parametros) {
  if (!carga) return { podeFechar: false, motivo: "sem_carga", fora: [] };
  const lista = Array.isArray(ondas) ? ondas : ondas ? [ondas] : [];
  const daCarga = lista.filter((o) => o.cargaId === carga.id && !ondForaDeCirculacao(o));
  if (!daCarga.length) return { podeFechar: false, motivo: "sem_onda", fora: [] };
  const ids = new Set(daCarga.map((o) => o.id));
  const suas = (tarefas || []).filter((t) => ids.has(t.ondaId));
  if (!suas.length) return { podeFechar: false, motivo: "sem_tarefas", fora: [] };
  const porFazer = suas.filter(
    (t) => t.estado !== "concluida" && t.estado !== "cancelada"
  );
  if (porFazer.length) {
    return {
      podeFechar: false,
      motivo: "a_trabalhar",
      fora: [],
      porFazer: porFazer.length
    };
  }
  const efetivado = ondEfetivadoDaCarga(daCarga, tarefas, carga, dadosCargas);
  if (!efetivado) return { podeFechar: false, motivo: "sem_carga", fora: [] };
  const naCarga = (carga.linhas || []).length;
  if (!efetivado.linhas.length) {
    return {
      podeFechar: false,
      motivo: naCarga ? "entregas_por_chegar" : "sem_linhas",
      fora: []
    };
  }
  if (efetivado.linhas.length !== naCarga) {
    return {
      podeFechar: false,
      motivo: "linhas_por_resolver",
      fora: [],
      resolvidas: efetivado.linhas.length,
      naCarga
    };
  }
  const margem = parametros && Number(parametros.margem_picking_pct);
  const pct = Number.isFinite(margem) ? margem : 10;
  const kits = efetivado.kits || [];
  const porApurar = kits.filter((k) => !k.sabe);
  if (porApurar.length) {
    return {
      podeFechar: false,
      motivo: "kit_por_apurar",
      fora: [],
      kits: porApurar,
      margemPct: pct,
      efetivado
    };
  }
  const desproporcionados = kits.filter((k) => !k.exacta);
  if (desproporcionados.length) {
    return {
      podeFechar: false,
      motivo: "kit_fora_de_proporcao",
      fora: [],
      kits: desproporcionados,
      margemPct: pct,
      efetivado
    };
  }
  const curtos = kits.filter((k) => ondKitsCurtos(k, pct));
  if (curtos.length) {
    return {
      podeFechar: false,
      motivo: "kits_fora_da_margem",
      fora: [],
      kits: curtos,
      margemPct: pct,
      efetivado
    };
  }
  const deKit = /* @__PURE__ */ new Set();
  kits.forEach((k) => k.componentes.forEach((c) => deKit.add(c.bistamp)));
  const fora = [];
  let desconhecidas = 0;
  for (const l of efetivado.linhas) {
    if (deKit.has(l.bistamp)) continue;
    const ok = ondDentroDaMargem(l, pct);
    if (ok === null) {
      desconhecidas += 1;
      fora.push({ ...l, porque: "nao_se_sabe" });
    } else if (!ok) fora.push({ ...l, porque: l.qtdCerta ? "qtd_exata" : "fora_da_margem" });
  }
  if (fora.length) {
    return {
      podeFechar: false,
      motivo: "diferencas",
      fora,
      desconhecidas,
      margemPct: pct,
      efetivado
    };
  }
  return { podeFechar: true, motivo: "", fora: [], kits, margemPct: pct, efetivado };
}
function ondKitsCurtos(kit, margemPct) {
  if (!kit || !kit.sabe) return false;
  const planeados = ondNum(kit.kitsPlaneados);
  const picados = ondNum(kit.kitsPicados);
  if (picados >= planeados) return false;
  if ((kit.componentes || []).some((c) => c.qtdCerta)) return true;
  if (!planeados) return false;
  const pct = Math.abs(Number(margemPct));
  if (!Number.isFinite(pct) || pct <= 0) return true;
  return planeados - picados > planeados * pct / 100;
}
function ondN(v) {
  const n = ondNum(v);
  return (Math.round(n * 1e3) / 1e3).toLocaleString("pt-PT");
}
function ondFaltasDoKit(kit) {
  if (!kit || !kit.sabe) return [];
  let alvo = 0;
  for (const c of kit.componentes || []) {
    const razao = ondNum(c.kitRazao);
    if (razao <= 0) return [];
    alvo = Math.max(alvo, Math.floor(ondNum(c.picado) / razao));
  }
  const faltas = [];
  for (const c of kit.componentes || []) {
    const falta = alvo * ondNum(c.kitRazao) - ondNum(c.picado);
    if (falta > 0) faltas.push({ artigo: c.artigo, bistamp: c.bistamp, falta });
  }
  return faltas;
}
function ondAvisoDeNaoFechou(r) {
  if (!r || r.podeFechar || !r.motivo) return null;
  const aviso = (msg) => ({ nivel: "aviso", motivo: r.motivo, msg });
  if (r.motivo === "entregas_por_chegar") {
    return aviso("O picking est\xE1 conclu\xEDdo, mas as entregas do ERP ainda n\xE3o chegaram \u2014 a carga s\xF3 fecha quando houver com que comparar.");
  }
  if (r.motivo === "linhas_por_resolver") {
    return aviso(`O picking est\xE1 conclu\xEDdo, mas s\xF3 ${r.resolvidas} de ${r.naCarga} linhas resolveram contra as entregas \u2014 a que falta pode estar fora da janela de datas. A carga n\xE3o fecha com um retrato incompleto.`);
  }
  if (r.motivo === "kit_fora_de_proporcao") {
    const k = (r.kits || [])[0];
    const s = k && k.sobras && k.sobras[0] || null;
    const n = (r.kits || []).length;
    const mais = n > 1 ? ` (e mais ${n - 1} kit(s) na mesma situa\xE7\xE3o)` : "";
    if (!s) return aviso(`O kit ${k ? k.kitRef : ""} n\xE3o ficou em propor\xE7\xE3o.${mais}`);
    const faltas = ondFaltasDoKit(k);
    const texto = faltas.length ? ` \u2014 ${faltas.map((f) => `faltam ${ondN(f.falta)} de ${f.artigo}`).join(", ")}` : "";
    return aviso(`O picking est\xE1 conclu\xEDdo, mas o kit ${k.kitRef} tem ${ondN(s.sobra)} de ${s.artigo} que n\xE3o formaram kit${texto}. A carga n\xE3o fecha sozinha${mais}: abre \xABPreparada\xBB para ver e decidir.`);
  }
  if (r.motivo === "kit_por_apurar") {
    const k = (r.kits || [])[0];
    return aviso(`O picking est\xE1 conclu\xEDdo, mas n\xE3o se sabe a composi\xE7\xE3o do kit ${k ? k.kitRef : ""} \u2014 falta a raz\xE3o de algum componente, ou falta o registo do que foi picado. A carga n\xE3o fecha sobre uma propor\xE7\xE3o que ningu\xE9m conseguiu apurar.`);
  }
  if (r.motivo === "kits_fora_da_margem") {
    const k = (r.kits || [])[0];
    return aviso(`O picking est\xE1 conclu\xEDdo e o kit ${k ? k.kitRef : ""} est\xE1 em propor\xE7\xE3o, mas s\xF3 d\xE1 ${ondN(k && k.kitsPicados)} kits de ${ondN(k && k.kitsPlaneados)} planeados \u2014 mais do que a margem de ${r.margemPct}% aceita. A carga n\xE3o fecha sozinha.`);
  }
  if (r.motivo === "diferencas") {
    const n = (r.fora || []).length;
    const semRegisto = r.desconhecidas || 0;
    const detalhe = semRegisto === n ? `${n} linha(s) sem registo de picking` : semRegisto ? `${n - semRegisto} fora da margem de ${r.margemPct}% e ${semRegisto} sem registo de picking` : `${n} linha(s) fora da margem de ${r.margemPct}%`;
    return aviso(`O picking est\xE1 conclu\xEDdo, mas h\xE1 ${detalhe} \u2014 a carga n\xE3o fecha sozinha. Abre \xABPreparada\xBB para ver e decidir.`);
  }
  return null;
}
function ondEfetivadoDaCarga(ondas, tarefas, carga, dadosCargas) {
  if (!carga) return null;
  const lista = Array.isArray(ondas) ? ondas : ondas ? [ondas] : [];
  const ids = new Set(lista.map((o) => o.id));
  const { linhas } = ondLinhasDaCarga(carga, dadosCargas);
  const daOnda = (tarefas || []).filter((t) => ids.has(t.ondaId));
  const porBistamp = {};
  daOnda.forEach((t) => {
    if (t.bistamp) porBistamp[t.bistamp] = t;
  });
  const fora = [];
  const resultado = linhas.map((l) => {
    const t = porBistamp[l.bistamp] || daOnda.find((x) => !x.bistamp && x.artigo === l.artigo && (x.clienteId || "") === (l.clienteNome || ""));
    const base = {
      bistamp: l.bistamp,
      artigo: l.artigo,
      descricao: l.descricao,
      cliente: l.clienteNome,
      planeado: ondNum(l.qtd),
      qtdCerta: !!l.qtdCerta,
      // **De que kit é a linha, para a proporção poder ser calculada** (#119).
      // Esta função reconstrói cada linha CAMPO A CAMPO, e um campo que não
      // esteja aqui desaparece em silêncio — é a MESMA armadilha que o
      // `cpPercurso` já pagou duas vezes (a marca `amostra`, e depois o
      // `clienteId`/`entregaManualId` dos volumes). Sem isto,
      // `ondKitsDaPreparacao` não via kit nenhum e a carga fechava sobre
      // qualquer proporção.
      ...ondKitDeOrigem(l)
    };
    if (!t) return { ...base, picado: null, paletes: 0, motivo: "sem_tarefa" };
    const p = ondPicadoDaTarefa(t);
    if (!p.paletes) return { ...base, picado: null, paletes: 0, motivo: "sem_registo" };
    if (p.semQtd) {
      return { ...base, picado: p.picado, paletes: p.paletes, motivo: "sem_qtd" };
    }
    return { ...base, picado: p.picado, paletes: p.paletes, motivo: "" };
  });
  daOnda.forEach((t) => {
    if (!t.foraDaCarga) return;
    const p = ondPicadoDaTarefa(t);
    if (!p.paletes) return;
    fora.push({
      artigo: t.artigo,
      descricao: t.descricao,
      picado: p.picado,
      paletes: p.paletes,
      cliente: t.clienteId || ""
    });
  });
  const kitsCalculados = ondKitsDaPreparacao(resultado);
  const proporcional = {};
  for (const k of kitsCalculados) {
    for (const c of k.componentes) {
      proporcional[c.bistamp] = k.sabe ? k.kitsPicados * ondNum(c.kitRazao) : ondNum(c.planeado);
    }
  }
  resultado.forEach((l) => {
    l.aplicar = l.motivo || l.picado == null ? l.planeado : proporcional[l.bistamp] == null ? l.picado : proporcional[l.bistamp];
  });
  const ajustaveis = resultado.filter(
    (l) => !l.motivo && l.picado != null && l.aplicar !== l.planeado
  );
  return {
    linhas: resultado,
    foraDaCarga: fora,
    ajustaveis,
    totalPlaneado: resultado.reduce((s, l) => s + l.planeado, 0),
    // O total do EFETIVADO conta só o que se sabe — somar as linhas sem
    // registo como zero dava um total que parece medido e não é.
    totalPicado: resultado.reduce((s, l) => s + (l.picado == null ? 0 : l.picado), 0),
    semRegisto: resultado.filter((l) => l.motivo === "sem_registo").length,
    semTarefa: resultado.filter((l) => l.motivo === "sem_tarefa").length,
    semQtd: resultado.filter((l) => l.motivo === "sem_qtd").length,
    // Quantas ficam exatamente como se tinha pedido.
    certas: resultado.filter((l) => !l.motivo && l.picado === l.planeado).length,
    // **A proporção dos kits, calculada UMA vez** (#119). Três sítios a
    // precisam — o fecho automático, o modal da «Preparada» e o retrato que
    // ele grava —, e três chamadas davam três donos do mesmo número.
    kits: kitsCalculados
  };
}
function ondKitsDaPreparacao(linhas) {
  const porKit = /* @__PURE__ */ new Map();
  for (const l of linhas || []) {
    const chave = l && l.kitBistamp || "";
    if (!chave) continue;
    if (!porKit.has(chave)) {
      porKit.set(chave, {
        kitRef: l.kitRef || "",
        kitBistamp: chave,
        componentes: []
      });
    }
    porKit.get(chave).componentes.push(l);
  }
  const CL = window.CargoplannerLogica;
  const saida = [];
  for (const k of porKit.values()) {
    const razoes = {};
    const planeados = {};
    const picados = {};
    let sabe = true;
    for (const c of k.componentes) {
      razoes[c.bistamp] = c.kitRazao;
      planeados[c.bistamp] = ondNum(c.planeado);
      if (c.picado == null) sabe = false;
      picados[c.bistamp] = ondNum(c.picado);
    }
    const kitsPlaneados = CL.kitsDeQuantidades(planeados, razoes);
    const kitsPicados = sabe ? CL.kitsDeQuantidades(picados, razoes) : null;
    if (kitsPicados == null) sabe = false;
    const sobras = [];
    if (sabe) {
      for (const c of k.componentes) {
        const sobra = ondNum(c.picado) - kitsPicados * ondNum(c.kitRazao);
        if (sobra > 0) {
          sobras.push({
            bistamp: c.bistamp,
            artigo: c.artigo,
            descricao: c.descricao,
            sobra,
            razao: ondNum(c.kitRazao)
          });
        }
      }
    }
    saida.push({
      ...k,
      kitsPlaneados: kitsPlaneados == null ? null : kitsPlaneados,
      kitsPicados,
      sabe,
      // Proporção exacta = sabe-se, e nada sobrou. Com `sabe` falso fica
      // falso, de propósito.
      exacta: sabe && !sobras.length,
      sobras
    });
  }
  return saida;
}
function ondPreparacaoParaServidor(efetivado) {
  if (!efetivado) return null;
  return {
    em: (/* @__PURE__ */ new Date()).toISOString(),
    linhas: efetivado.linhas.map((l) => ({
      bistamp: l.bistamp,
      artigo: l.artigo,
      descricao: l.descricao,
      cliente: l.cliente,
      planeado: l.planeado,
      picado: l.picado,
      paletes: l.paletes,
      // O que se PICOU e o que FICOU na carga são números diferentes num kit:
      // picaram-se 110, ficaram 100, e os 10 voltaram ao pool. O retrato diz
      // os dois — é ele que responde a «porque é que a linha dizia 110?».
      aplicado: l.aplicar == null ? null : ondNum(l.aplicar),
      ajustada: !l.motivo && l.picado != null && l.aplicar !== l.planeado,
      motivo: l.motivo || ""
    })),
    total_planeado: efetivado.totalPlaneado,
    total_picado: efetivado.totalPicado,
    // **Os kits, com a sobra** — é o que responde a «porque é que a linha diz
    // 110 e saíram 100?» a quem reabre a carga daqui a três semanas. Lista
    // VAZIA e não chave ausente: «esta carga não tem kits» e «esta versão não
    // sabia de kits» são coisas diferentes.
    kits: (efetivado.kits || []).map((k) => ({
      ref: k.kitRef,
      bistamp: k.kitBistamp,
      kits: k.kitsPicados,
      planeados: k.kitsPlaneados,
      sobras: k.sobras.map((x) => ({ artigo: x.artigo, sobra: x.sobra }))
    }))
  };
}
function ondOndaParaServidor(onda, catalogos, tarefas) {
  const pk = (lista, id) => {
    const achado = (lista || []).find((v) => v.id === id);
    return achado ? achado.servidorId : null;
  };
  const c = catalogos || {};
  const corpo = {
    tipo: pk(c.tipos, onda.tipoId),
    motivo: pk(c.motivos, onda.motivoId),
    prioridade: pk(c.prioridades, onda.prioridadeId),
    dia: onda.dia,
    estado: onda.estado || "disponivel",
    pessoa: onda.pessoaId == null ? null : Number(onda.pessoaId),
    ordem: Math.max(0, Math.round(ondNum(onda.ordem))),
    cliente_id: ondTexto(onda.clienteId, 250),
    // A chave do cliente. Tem de ir: é metade da restrição que garante uma
    // onda por (carga, cliente) — sem ela, duas ondas da mesma carga
    // chegavam ao servidor com a mesma chave vazia e a segunda era recusada.
    cliente_phc: ondTexto(onda.clientePhc, 24),
    zona: ondTexto(onda.zona, 80),
    qtd_total: ondNum(onda.qtdTotal),
    paletes: ondNum(onda.paletes),
    // Ids de OUTRAS ondas: no ecrã são texto, na coluna são inteiros. Um id
    // que não seja número (uma onda ainda por gravar) fica de fora em vez de
    // ir como `NaN`.
    depende_de: (onda.dependeDe || []).map(Number).filter((n) => Number.isInteger(n)),
    observacoes: onda.observacoes || "",
    carga: onda.cargaServidorId == null ? null : onda.cargaServidorId,
    origem_carga: onda.origemCarga || null
  };
  if (tarefas) {
    corpo.tarefas = tarefas.map((t) => ondTarefaParaServidor(t, corpo.carga));
  }
  return corpo;
}
const OND_CAMPOS_GRAVAVEIS = [
  "pessoaId",
  "ordem",
  "estado",
  "tipoId",
  "motivoId",
  "prioridadeId",
  "dia",
  "clienteId",
  "zona",
  "qtdTotal",
  "paletes",
  "observacoes",
  "dependeDe"
];
function ondAlteradas(antes, depois) {
  const porId = ondIndexar(antes || []);
  return (depois || []).filter((o) => {
    const a = porId[o.id];
    if (!a) return true;
    return OND_CAMPOS_GRAVAVEIS.some((k) => k === "dependeDe" ? (a[k] || []).join(",") !== (o[k] || []).join(",") : a[k] !== o[k]);
  });
}
function ondProximaOrdem(lista, pessoaId) {
  return (lista || []).filter((o) => o.pessoaId === pessoaId).reduce((m, o) => Math.max(m, o.ordem || 0), 0) + 1;
}
function ondAtribuirOnda(ondas, ondaId, pessoaId, posicao) {
  const lista = ondas || [];
  if (!lista.find((o) => o.id === ondaId)) return lista;
  const semEla = lista.filter((o) => o.id !== ondaId);
  const alvo = posicao == null ? ondProximaOrdem(semEla, pessoaId) : posicao + 1;
  return lista.map((o) => {
    if (o.id === ondaId) {
      return {
        ...o,
        pessoaId,
        ordem: alvo,
        estado: o.estado === "disponivel" ? "atribuida" : o.estado
      };
    }
    if (posicao != null && o.pessoaId === pessoaId && (o.ordem || 0) >= alvo) {
      return { ...o, ordem: (o.ordem || 0) + 1 };
    }
    return o;
  });
}
function ondRetirarOnda(ondas, ondaId) {
  return (ondas || []).map((o) => o.id === ondaId ? { ...o, pessoaId: null, ordem: 0, estado: "disponivel" } : o);
}
const OND_ESTADOS_SEM_TRANSICAO = ["em_execucao", "concluida"];
function ondFimDoTurnoMs(diaISO, pessoa) {
  const L = _L();
  const fim = L.hhmm2min(pessoa && pessoa.fimTrabalho);
  if (fim == null) return null;
  const partes = String(diaISO || "").split("-").map(Number);
  const [y, mo, d] = partes;
  if (!y || !mo || !d) return null;
  const ini = L.hhmm2min(pessoa.inicioTrabalho);
  const atravessa = ini != null && fim <= ini;
  return new Date(
    y,
    mo - 1,
    d + (atravessa ? 1 : 0),
    Math.floor(fim / 60),
    fim % 60,
    0,
    0
  ).getTime();
}
function ondTransitou(onda, pessoa, agoraMs) {
  if (!onda || !pessoa || agoraMs == null) return false;
  if (onda.pessoaId == null || onda.pessoaId === "") return false;
  if (ondForaDeCirculacao(onda)) return false;
  if (OND_ESTADOS_SEM_TRANSICAO.includes(onda.estado)) return false;
  const fim = ondFimDoTurnoMs(onda.dia, pessoa);
  if (fim == null || agoraMs < fim) return false;
  const turno = pessoa.turnoId || "";
  const repetida = (onda.transicoes || []).some((t) => String(t.pessoa_id) === String(onda.pessoaId) && String(t.turno || "") === turno && String(t.dia || "") === String(onda.dia));
  if (repetida) return false;
  return {
    dia: onda.dia,
    turno,
    pessoa_id: String(onda.pessoaId),
    // Achatado: apagar uma ficha não pode apagar a responsabilidade de quem
    // teve a onda, e a FK vai a `null` neste mesmo gesto.
    pessoa_nome: pessoa.nome || onda.pessoaNome || "",
    em: new Date(agoraMs).toISOString()
  };
}
function ondMarcaDaTransicao(onda) {
  const lista = onda && onda.transicoes || [];
  if (!lista.length) return null;
  const ultima = lista[lista.length - 1];
  return {
    nome: String(ultima.pessoa_nome == null ? "" : ultima.pessoa_nome),
    turno: String(ultima.turno || ""),
    dia: String(ultima.dia || ""),
    vezes: lista.length
  };
}
function ondComTransicoes(ondas, dados, agoraMs) {
  const lista = ondas || [];
  const porId = {};
  (dados && dados.pessoas || []).forEach((p) => {
    porId[String(p.id)] = p;
  });
  const mudadas = [];
  const nova = lista.map((o) => {
    const t = ondTransitou(o, porId[String(o.pessoaId)], agoraMs);
    if (!t) return o;
    const mudada = {
      ...o,
      pessoaId: null,
      pessoaNome: null,
      ordem: 0,
      estado: "disponivel",
      transicoes: [...o.transicoes || [], t]
    };
    mudadas.push(mudada);
    return mudada;
  });
  return { ondas: mudadas.length ? nova : lista, mudadas };
}
function ondTransicaoParaServidor(onda) {
  return {
    pessoa: null,
    estado: "disponivel",
    ordem: 0,
    transicoes: onda.transicoes || []
  };
}
function ondReordenarOndas(ondas, pessoaId, de, para) {
  const lista = ondas || [];
  const minhas = lista.filter((o) => o.pessoaId === pessoaId).slice().sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  const nova = window.CargoplannerLogica.reordenar(minhas, de, para);
  const ordemPorId = {};
  nova.forEach((o, i) => {
    ordemPorId[o.id] = i + 1;
  });
  return lista.map((o) => ordemPorId[o.id] ? { ...o, ordem: ordemPorId[o.id] } : o);
}
function ondDesempenhoPorPessoa(ondas, dados) {
  const porPessoa = /* @__PURE__ */ new Map();
  const vazio = (id, nome) => ({
    pessoaId: id,
    nome,
    ondas: 0,
    ondasConcluidas: 0,
    tarefas: 0,
    tarefasConcluidas: 0,
    tarefasMedidas: 0,
    previstoMin: 0,
    realMin: 0,
    // **Comparável = medida E com tempo previsto.** Uma tarefa sem previsto
    // não está dentro nem fora dele, e era isso que a conta fazia: com
    // `tempoPrevMin` a 0, `real <= previsto` é sempre falso e a tarefa
    // entrava como «fora do tempo». Apareceu com as alocações — que são
    // medidas e não têm previsto nenhum (ver `alocacao_onda.py`) —, mas já
    // valia para qualquer tarefa criada à mão sem estimativa.
    tarefasComparaveis: 0,
    previstoComparavelMin: 0,
    realComparavelMin: 0,
    dentroDoTempo: 0,
    pausas: 0,
    // **O que ela NÃO acabou** (#113). A onda que transita perde o dono, e
    // era isso que apagava o rasto: sem estes três números, o trabalho que
    // alguém deixou por acabar não era de ninguém.
    //
    // `naoTerminadas` conta ONDAS e `transicoes` conta VEZES, porque são
    // perguntas diferentes: a mesma onda pode cair duas vezes das mãos da
    // mesma pessoa, e dizer «duas ondas» seria falso. `ondasQueTeve` é o
    // denominador — as que passaram pelas mãos dela, tenha-as ainda ou não.
    naoTerminadas: 0,
    ondasQueTeve: 0,
    transicoes: 0
  });
  const conjuntos = /* @__PURE__ */ new Map();
  const conj = (chave) => {
    if (!conjuntos.has(chave)) {
      conjuntos.set(chave, { tidas: /* @__PURE__ */ new Set(), naoAcabadas: /* @__PURE__ */ new Set() });
    }
    return conjuntos.get(chave);
  };
  const todas = { tidas: /* @__PURE__ */ new Set(), naoAcabadas: /* @__PURE__ */ new Set() };
  for (const o of ondas || []) {
    if (ondDesistencia(o)) continue;
    const id = o.pessoaId || null;
    const chave = id || "__sem_pessoa__";
    if (!porPessoa.has(chave)) {
      porPessoa.set(chave, vazio(id, o.pessoaNome || null));
    }
    const d = porPessoa.get(chave);
    if (!d.nome && o.pessoaNome) d.nome = o.pessoaNome;
    d.ondas += 1;
    if (o.estado === "concluida") d.ondasConcluidas += 1;
    if (id) {
      conj(chave).tidas.add(o.id);
      todas.tidas.add(o.id);
    }
    for (const tr of o.transicoes || []) {
      const quem = String(tr.pessoa_id == null ? "" : tr.pessoa_id);
      if (!quem) continue;
      if (!porPessoa.has(quem)) {
        porPessoa.set(quem, vazio(quem, tr.pessoa_nome || null));
      }
      const dq = porPessoa.get(quem);
      if (!dq.nome && tr.pessoa_nome) dq.nome = tr.pessoa_nome;
      dq.transicoes += 1;
      conj(quem).tidas.add(o.id);
      conj(quem).naoAcabadas.add(o.id);
      todas.tidas.add(o.id);
      todas.naoAcabadas.add(o.id);
    }
    for (const t of ondTarefasDaOnda(o.id, dados)) {
      if (t.estado === "cancelada") continue;
      d.tarefas += 1;
      d.pausas += (t.pausas || []).length;
      if (t.estado === "concluida") d.tarefasConcluidas += 1;
      if (t.tempoRealMin == null) continue;
      d.tarefasMedidas += 1;
      d.previstoMin += Number(t.tempoPrevMin) || 0;
      d.realMin += Number(t.tempoRealMin) || 0;
      if (!(Number(t.tempoPrevMin) > 0)) continue;
      d.tarefasComparaveis += 1;
      d.previstoComparavelMin += Number(t.tempoPrevMin) || 0;
      d.realComparavelMin += Number(t.tempoRealMin) || 0;
      if (Number(t.tempoRealMin) <= Number(t.tempoPrevMin)) d.dentroDoTempo += 1;
    }
  }
  const fechar = (d, c) => {
    const medidas = d.tarefasMedidas;
    return {
      ...d,
      naoTerminadas: c ? c.naoAcabadas.size : d.naoTerminadas,
      ondasQueTeve: c ? c.tidas.size : d.ondasQueTeve,
      // O último recurso para nomear alguém cujas ondas não trouxeram nome
      // nenhum (uma ficha apagada, por exemplo). Uma linha sem nada no sítio
      // do nome era indistinguível de um erro de leitura.
      nome: d.nome || (d.pessoaId ? `#${d.pessoaId}` : null),
      // O desvio compara o real com o previsto DAS MEDIDAS — nunca com o
      // previsto total. É a mesma regra do `ondDesvio` por onda, e existe
      // pela mesma razão: comparar um real parcial com um previsto inteiro
      // dava sempre um enorme «adiantado» que não quer dizer nada.
      // **O desvio é sobre as COMPARÁVEIS**, não sobre todas as medidas:
      // somar um previsto de 0 (uma alocação) dava «atrasado 3 min» contra
      // uma estimativa que não existe.
      desvioMin: d.tarefasComparaveis ? d.realComparavelMin - d.previstoComparavelMin : null,
      desvioPct: d.tarefasComparaveis && d.previstoComparavelMin > 0 ? Math.round((d.realComparavelMin - d.previstoComparavelMin) / d.previstoComparavelMin * 100) : null,
      pctDentroDoTempo: d.tarefasComparaveis ? Math.round(d.dentroDoTempo / d.tarefasComparaveis * 100) : null,
      // Quantas se deram por feitas sem ninguém as ter cronometrado. É o
      // número que diz o quanto se pode confiar na coluna do lado.
      concluidasSemMedida: Math.max(0, d.tarefasConcluidas - medidas)
    };
  };
  const pessoas = [...porPessoa.entries()].filter(([k]) => k !== "__sem_pessoa__").map(([k, d]) => fechar(d, conjuntos.get(k))).sort((a, b) => String(a.nome || "").localeCompare(String(b.nome || "")));
  const semPessoaBruto = porPessoa.get("__sem_pessoa__");
  return {
    pessoas,
    semPessoa: semPessoaBruto ? fechar(semPessoaBruto, conjuntos.get("__sem_pessoa__")) : null,
    total: fechar(pessoas.reduce((acc, p) => {
      [
        "ondas",
        "ondasConcluidas",
        "tarefas",
        "tarefasConcluidas",
        "tarefasMedidas",
        "previstoMin",
        "realMin",
        "tarefasComparaveis",
        "previstoComparavelMin",
        "realComparavelMin",
        "dentroDoTempo",
        "pausas",
        "transicoes"
      ].forEach((k) => {
        acc[k] += p[k];
      });
      return acc;
    }, vazio(null, null)), todas)
  };
}
const OND_QR_FOCO = "CPFOCO";
const OND_QR_ENTER = "CPENTER";
function ondComandoDoScanner(texto) {
  const bruto = texto == null ? "" : String(texto);
  const alto = bruto.toUpperCase();
  for (const [comando, sentinela] of [["enter", OND_QR_ENTER], ["foco", OND_QR_FOCO]]) {
    const i = alto.indexOf(sentinela);
    if (i === -1) continue;
    const resto = (bruto.slice(0, i) + bruto.slice(i + sentinela.length)).trim();
    return { comando, resto };
  }
  return { comando: null, resto: bruto };
}
function ondGestoDeAlocar(estado) {
  const e = estado || {};
  const texto = String(e.texto == null ? "" : e.texto).trim();
  if (e.aAlocar) return { acao: "nada", falta: null };
  if (e.aLer) return { acao: "nada", falta: e.porLer > 0 ? "fila" : "a_ler" };
  if (!e.etiquetas) return { acao: "nada", falta: "sem_etiquetas" };
  if (e.localInfo) {
    const confirmado = String(e.localInfo.codigo || "").trim().toUpperCase();
    if (!texto || texto.toUpperCase() === confirmado) return { acao: "alocar", falta: null };
  }
  if (texto) return {
    acao: "validar_e_alocar",
    falta: e.aValidarLocal ? "a_validar" : null
  };
  if (e.erroLocal) return { acao: "nada", falta: null };
  return { acao: "nada", falta: "sem_local" };
}
function ondDeveAutoValidarLocal(estado) {
  const e = estado || {};
  if (!e.temEmpresa) return false;
  if (e.localInfo || e.aValidarLocal || e.erroLocal) return false;
  return !!(String(e.texto == null ? "" : e.texto).trim() && String(e.textoVisivel == null ? "" : e.textoVisivel).trim());
}
function ondFilaEntrar(fila, pedido) {
  const f = fila || [];
  const i = f.findIndex((x) => x.tarefa === pedido.tarefa && x.tipo === pedido.tipo);
  if (i === -1) return [...f, pedido];
  const nova = f.slice();
  nova[i] = pedido;
  return nova;
}
function ondFilaVersaoNova(fila, tarefa, versao) {
  const f = fila || [];
  return f.map((x) => {
    if (x.tarefa !== tarefa) return x;
    if (!x.corpo || !("versao_esperada" in x.corpo)) return x;
    return { ...x, corpo: { ...x.corpo, versao_esperada: versao } };
  });
}
function ondFilaSair(fila, id) {
  const f = fila || [];
  return f.filter((x) => x.id !== id);
}
function ondFilaPor(fila, tarefa) {
  const f = fila || [];
  return f.filter((x) => x.tarefa === tarefa).length;
}
function ondLargarNaAgenda({
  ler,
  idx,
  agenda,
  pessoaId,
  onAtribuir,
  onReordenar,
  onAlvo,
  onSobre
}) {
  return (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (onAlvo) onAlvo(null);
    if (onSobre) onSobre(false);
    const p = ler(ev);
    if (!p || p.k !== "onda") return;
    const daPessoa = (agenda || []).findIndex((a) => a.onda.id === p.ondaId);
    if (daPessoa === -1) {
      onAtribuir(p.ondaId, pessoaId, idx);
      return;
    }
    if (daPessoa !== idx) onReordenar(pessoaId, daPessoa, idx);
  };
}
window.OndasLogica = {
  preparadoresDaCarga: ondPreparadoresDaCarga,
  filaEntrar: ondFilaEntrar,
  filaVersaoNova: ondFilaVersaoNova,
  filaSair: ondFilaSair,
  filaPor: ondFilaPor,
  QR_FOCO: OND_QR_FOCO,
  QR_ENTER: OND_QR_ENTER,
  comandoDoScanner: ondComandoDoScanner,
  gestoDeAlocar: ondGestoDeAlocar,
  deveAutoValidarLocal: ondDeveAutoValidarLocal,
  INTERVALO_MIN: OND_INTERVALO_MIN,
  SEM_ARMAZEM: OND_SEM_ARMAZEM,
  armazensPresentes: ondArmazensPresentes,
  indexar: ondIndexar,
  fimTurnoMin: ondFimTurnoMin,
  tarefasDaOnda: ondTarefasDaOnda,
  duracaoPrevista: ondDuracaoPrevista,
  tempoReal: ondTempoReal,
  ocupacaoMedida: ondOcupacaoMedida,
  textoDaBase: ondTextoDaBase,
  desvio: ondDesvio,
  agendaDaPessoa: ondAgendaDaPessoa,
  mesmoDia: ondMesmoDia,
  fimDoTurnoMs: ondFimDoTurnoMs,
  transitou: ondTransitou,
  marcaDaTransicao: ondMarcaDaTransicao,
  comTransicoes: ondComTransicoes,
  transicaoParaServidor: ondTransicaoParaServidor,
  ESTADOS_SEM_TRANSICAO: OND_ESTADOS_SEM_TRANSICAO,
  minDoDia: ondMinDoDia,
  ocupacaoDaPessoa: ondOcupacaoDaPessoa,
  conflitosDaPessoa: ondConflitosDaPessoa,
  conflitos: ondConflitos,
  validarAtribuicao: ondValidarAtribuicao,
  podeIniciar: ondPodeIniciar,
  acumuladoDeTarefa: ondAcumuladoDeTarefa,
  acumuladoAgora: ondAcumuladoAgora,
  arredondarAcumulado: ondArredondarAcumulado,
  MOTIVO_TROCA: OND_MOTIVO_TROCA,
  trabalhoDoOperador: ondTrabalhoDoOperador,
  disponiveis: ondDisponiveis,
  gerarOndasDeCarga: ondGerarOndasDeCarga,
  juntarSemRepetir: ondJuntarSemRepetir,
  cargaAlterada: ondCargaAlterada,
  destinoDaCarga: ondDestinoDaCarga,
  efetivadoDaCarga: ondEfetivadoDaCarga,
  kitsDaPreparacao: ondKitsDaPreparacao,
  dentroDaMargem: ondDentroDaMargem,
  cargaPodeFechar: ondCargaPodeFechar,
  avisoDeNaoFechou: ondAvisoDeNaoFechou,
  preparacaoParaServidor: ondPreparacaoParaServidor,
  sincronizarOndaComCarga: ondSincronizarOndaComCarga,
  tarefaTocada: ondTarefaTocada,
  largarOndaVazia: ondLargarOndaVazia,
  linhasDaCarga: ondLinhasDaCarga,
  previsaoPreparacao: ondPrevisaoPreparacao,
  janelaDoCais: ondJanelaDoCais,
  janelasChocam: ondJanelasChocam,
  choquesDeCais: ondChoquesDeCais,
  caisOcupadoPor: ondCaisOcupadoPor,
  janelaDeColocacao: ondJanelaDeColocacao,
  colocacaoDaOnda: ondColocacaoDaOnda,
  comColocacao: ondComColocacao,
  diasCandidatos: ondDiasCandidatos,
  noLimiarDaSaida: ondNoLimiarDaSaida,
  textoDaColocacao: ondTextoDaColocacao,
  HORAS_LIMIAR: OND_HORAS_LIMIAR,
  instante: ondInstante,
  percursoDaOnda: ondPercursoDaOnda,
  rotuloCarga: ondRotuloCarga,
  fundirOndaSocket: ondFundirOndaSocket,
  disponivelDeOutroDia: ondDisponivelDeOutroDia,
  fundirOndaFora: ondFundirOndaFora,
  fundirOndaDeCargas: ondFundirOndaDeCargas,
  fundirOndaNoPeriodo: ondFundirOndaNoPeriodo,
  removerOndaDoPeriodo: ondRemoverOndaDoPeriodo,
  periodoAlcancavel: ondPeriodoAlcancavel,
  removerOndaSocket: ondRemoverOndaSocket,
  ehEcoProprio: ondEhEcoProprio,
  rotuloDaOnda: ondRotuloDaOnda,
  metricas: ondMetricas,
  desempenhoPorPessoa: ondDesempenhoPorPessoa,
  // A tradução servidor ⇄ ecrã e as mutações do planeamento.
  ondaDoServidor: ondOndaDoServidor,
  ondaParaServidor: ondOndaParaServidor,
  kitDaTarefa: ondKitDaTarefa,
  tarefaDoServidor: ondTarefaDoServidor,
  tarefasDoServidor: ondTarefasDoServidor,
  tarefaParaServidor: ondTarefaParaServidor,
  tarefaPlanoParaServidor: ondTarefaPlanoParaServidor,
  sincronizacaoParaServidor: ondSincronizacaoParaServidor,
  tarefaProgressoParaServidor: ondTarefaProgressoParaServidor,
  lotesParaServidor: ondLotesParaServidor,
  picadoDaTarefa: ondPicadoDaTarefa,
  paleteSaiInteira: ondPaleteSaiInteira,
  lotesPorAlocar: ondLotesPorAlocar,
  tectoDePaletes: ondTectoDePaletes,
  tectoComEmCurso: ondTectoComEmCurso,
  textoDoTecto: ondTextoDoTecto,
  reservaDaPalete: ondReservaDaPalete,
  quemTemAPalete: ondQuemTemAPalete,
  qtdAPicar: ondQtdAPicar,
  ecraDaPalete: ondEcraDaPalete,
  phcDosLotes: ondPhcDosLotes,
  estadoPhcDoLote: ondEstadoPhcDoLote,
  linhaAposPicar: ondLinhaAposPicar,
  linhaAposRecusa: ondLinhaAposRecusa,
  vocabDoServidor: ondVocabDoServidor,
  motivosDoServidor: ondMotivosDoServidor,
  foraDeCirculacao: ondForaDeCirculacao,
  desistencia: ondDesistencia,
  consequenciasDeArquivar: ondConsequenciasDeArquivar,
  alteradas: ondAlteradas,
  atribuirOnda: ondAtribuirOnda,
  retirarOnda: ondRetirarOnda,
  reordenarOndas: ondReordenarOndas,
  largarNaAgenda: ondLargarNaAgenda,
  proximaOrdem: ondProximaOrdem
};

// ===== cargoplanner/frontend/cargoplanner_rotas.js =====
const CP_OSRM = "https://router.project-osrm.org/route/v1/driving/";
const CP_MAPBOX_DIR = "https://api.mapbox.com/directions/v5/mapbox/driving/";
function cpToken() {
  return typeof window !== "undefined" && window.MAPBOX_TOKEN || "";
}
function cpFornecedor() {
  return cpToken() ? "mapbox" : "osrm";
}
function cpChaveRota(pontos) {
  return (pontos || []).filter((p) => p && p.lat != null && p.lng != null).map((p) => `${p.lng.toFixed(5)},${p.lat.toFixed(5)}`).join(";");
}
const _cpRotasCache = /* @__PURE__ */ new Map();
async function cpObterRota(pontos, { sinal } = {}) {
  const chave = cpChaveRota(pontos);
  if (!chave || chave.indexOf(";") === -1) return null;
  if (chave.split(";").length > 25) throw new Error("Rota com mais de 25 paragens");
  if (_cpRotasCache.has(chave)) return _cpRotasCache.get(chave);
  const token = cpToken();
  const fornecedor = token ? "mapbox" : "osrm";
  const url = token ? `${CP_MAPBOX_DIR}${chave}?overview=full&geometries=geojson&access_token=${encodeURIComponent(token)}` : `${CP_OSRM}${chave}?overview=full&geometries=geojson`;
  const resp = await fetch(url, { signal: sinal });
  if (!resp.ok) throw new Error(`${fornecedor === "mapbox" ? "Mapbox" : "OSRM"} ${resp.status}`);
  const json = await resp.json();
  if (json.code !== "Ok" || !json.routes || !json.routes.length) {
    throw new Error(`${fornecedor === "mapbox" ? "Mapbox" : "OSRM"}: ${json.code || "sem rota"}`);
  }
  const r = json.routes[0];
  const out = {
    kmTotal: Math.round(r.distance / 1e3),
    minTotal: Math.round(r.duration / 60),
    legs: (r.legs || []).map((l) => ({
      km: Math.round(l.distance / 1e3),
      min: Math.round(l.duration / 60)
    })),
    // O GeoJSON vem em [lng, lat]; o Leaflet quer [lat, lng].
    geometria: ((r.geometry || {}).coordinates || []).map((c) => [c[1], c[0]]),
    fornecedor
  };
  _cpRotasCache.set(chave, out);
  return out;
}
const CP_CORES_ROTA = [
  "#2563eb",
  "#dc2626",
  "#7c3aed",
  "#0891b2",
  "#ea580c",
  "#15803d",
  "#db2777",
  "#a16207"
];
function cpCorDoCamiao(id) {
  let h = 0;
  const t = String(id || "");
  for (let i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) % 99991;
  return CP_CORES_ROTA[h % CP_CORES_ROTA.length];
}
function useCpRotas(sequencias) {
  const lista = React.useMemo(() => (sequencias || []).map((s) => ({ id: s.id, pontos: s.pontos, chave: cpChaveRota(s.pontos) })).filter((s) => s.chave && s.chave.indexOf(";") !== -1), [sequencias]);
  const assinatura = lista.map((s) => `${s.id}=${s.chave}`).join("|");
  const [st, setSt] = React.useState({ porId: {}, aCarregar: false, falhas: {} });
  React.useEffect(() => {
    if (!lista.length) {
      setSt({ porId: {}, aCarregar: false, falhas: {} });
      return void 0;
    }
    const ctrl = new AbortController();
    let vivo = true;
    setSt((s) => ({ ...s, aCarregar: true }));
    Promise.all(lista.map((s) => cpObterRota(s.pontos, { sinal: ctrl.signal }).then((rota) => ({ id: s.id, rota })).catch((err) => ({ id: s.id, erro: String(err && err.message || err) })))).then((res) => {
      if (!vivo) return;
      const porId = {};
      const falhas = {};
      for (const r of res) {
        if (r.rota) porId[r.id] = r.rota;
        else if (r.erro && r.erro !== "AbortError") falhas[r.id] = r.erro;
      }
      setSt({ porId, aCarregar: false, falhas });
    });
    return () => {
      vivo = false;
      ctrl.abort();
    };
  }, [assinatura]);
  return st;
}
function useCpRota(pontos) {
  const chave = cpChaveRota(pontos);
  const [st, setSt] = React.useState({ estado: "vazio", rota: null, erro: null });
  React.useEffect(() => {
    if (!chave || chave.indexOf(";") === -1) {
      setSt({ estado: "vazio", rota: null, erro: null });
      return void 0;
    }
    const ctrl = new AbortController();
    let vivo = true;
    setSt((s) => ({ ...s, estado: "a_carregar" }));
    cpObterRota(pontos, { sinal: ctrl.signal }).then((rota) => {
      if (vivo) setSt({ estado: rota ? "ok" : "vazio", rota, erro: null });
    }).catch((err) => {
      if (!vivo || err.name === "AbortError") return;
      setSt({ estado: "falhou", rota: null, erro: String(err.message || err) });
    });
    return () => {
      vivo = false;
      ctrl.abort();
    };
  }, [chave]);
  return st;
}
window.CpRotas = {
  obter: cpObterRota,
  chave: cpChaveRota,
  usar: useCpRota,
  token: cpToken,
  fornecedor: cpFornecedor,
  usarVarias: useCpRotas,
  corDoCamiao: cpCorDoCamiao,
  CORES: CP_CORES_ROTA,
  OSRM: CP_OSRM,
  MAPBOX: CP_MAPBOX_DIR
};

// ===== cargoplanner/frontend/cargoplanner_mapa.jsx =====
function CpMapa({ percurso, rota, cargas, enquadrarTudo }) {
  const elRef = React.useRef(null);
  const mapRef = React.useRef(null);
  const camadaRef = React.useRef(null);
  const pontos = React.useMemo(() => percurso && percurso.pontos || [], [percurso]);
  const outras = React.useMemo(() => cargas && cargas.length ? cargas : [{
    cargaId: "atual",
    camiaoId: "",
    cor: "#2563eb",
    // Explícito, não deixado a `undefined`: o `if (!c.transitario)` mais
    // abaixo desenha a linha quando isto for falsy, e um objeto sintético
    // sem a chave é falsy por acidente, não por decisão.
    transitario: false,
    pontos,
    rota,
    selecionada: true
  }], [cargas, pontos, rota]);
  const temLeaflet = typeof window !== "undefined" && !!window.L;
  React.useEffect(() => {
    if (!temLeaflet || !elRef.current || mapRef.current) return void 0;
    const L = window.L;
    const map = L.map(elRef.current, { zoomControl: true, attributionControl: true });
    const token = window.CpRotas.token();
    if (token) {
      L.tileLayer(
        `https://api.mapbox.com/styles/v1/mapbox/streets-v12/tiles/{z}/{x}/{y}@2x?access_token=${encodeURIComponent(token)}`,
        {
          maxZoom: 19,
          tileSize: 512,
          zoomOffset: -1,
          attribution: "&copy; Mapbox &copy; OpenStreetMap"
        }
      ).addTo(map);
    } else {
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 18,
        attribution: "&copy; OpenStreetMap"
      }).addTo(map);
    }
    map.setView([39.8, -8.4], 6);
    mapRef.current = map;
    const t = setTimeout(() => map.invalidateSize(), 60);
    const onResize = () => map.invalidateSize();
    window.addEventListener("resize", onResize);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", onResize);
      map.remove();
      mapRef.current = null;
    };
  }, [temLeaflet]);
  React.useEffect(() => {
    const map = mapRef.current;
    if (!map || !window.L) return;
    const L = window.L;
    if (camadaRef.current) {
      camadaRef.current.remove();
      camadaRef.current = null;
    }
    const grupo = L.layerGroup().addTo(map);
    const paraEnquadrar = [];
    const ordenadas = [...outras].sort((a, b) => (a.selecionada ? 1 : 0) - (b.selecionada ? 1 : 0));
    for (const c of ordenadas) {
      const coords = (c.pontos || []).filter((x) => x.lat != null && x.lng != null).map((x) => [x.lat, x.lng]);
      if (coords.length < 2) continue;
      const geo = c.rota && c.rota.geometria && c.rota.geometria.length > 1 ? c.rota.geometria : null;
      const traco = geo || coords;
      if (!c.transitario) {
        L.polyline(traco, {
          color: c.cor,
          weight: c.selecionada ? 5 : 3,
          opacity: c.selecionada ? 0.9 : 0.35,
          // Tracejado quando é a linha reta e não a rota real — aí é uma
          // referência, não um caminho.
          dashArray: geo ? null : "6 6"
        }).addTo(grupo).bindTooltip(
          `${c.camiaoId}${c.rota ? ` \xB7 ${c.rota.kmTotal} km` : ""}`,
          { sticky: true }
        );
      }
      if (c.selecionada) paraEnquadrar.push(...traco);
      else if (enquadrarTudo) paraEnquadrar.push(...traco);
      if (c.selecionada) {
        for (const p of c.pontos) {
          if (p.lat == null) continue;
          const eParagem = p.tipo === "paragem";
          const eRecolha = p.tipo === "recolha";
          const texto = eParagem ? String(p.ordem) : p.tipo === "origem" ? "O" : eRecolha ? "\u2193" : "R";
          const fundo = eParagem ? p.cor : eRecolha ? p.cor : "#475569";
          const aprox = p.nivel === "aproximado";
          L.marker([p.lat, p.lng], {
            icon: L.divIcon({
              className: "cp-map-pin-wrap",
              html: `<span class="cp-map-pin${eRecolha ? " is-recolha" : ""}${aprox ? " is-aprox" : ""}" style="background:${fundo}">${texto}</span>`,
              iconSize: [22, 22],
              iconAnchor: [11, 11]
            }),
            zIndexOffset: 500
          }).addTo(grupo).bindTooltip(
            `${eRecolha ? "Recolha" : texto} \xB7 ${p.nome}${p.local ? ` \u2014 ${p.local}` : ""}` + (eRecolha && p.motivo ? ` \xB7 ${p.motivo}` : "") + (aprox ? " \xB7 ponto APROXIMADO \u2014 a porta n\xE3o se confirmou" : "")
          );
        }
      } else {
        for (const p of c.pontos) {
          if (p.lat == null || p.tipo !== "paragem") continue;
          L.circleMarker([p.lat, p.lng], {
            radius: 4,
            color: c.cor,
            weight: 2,
            opacity: 0.6,
            fillColor: c.cor,
            fillOpacity: 0.5
          }).addTo(grupo).bindTooltip(`${c.camiaoId} \xB7 ${p.nome}`);
        }
      }
    }
    camadaRef.current = grupo;
    if (paraEnquadrar.length > 1) {
      map.fitBounds(L.latLngBounds(paraEnquadrar).pad(0.12));
    }
  }, [outras, enquadrarTudo]);
  if (!temLeaflet) {
    return /* @__PURE__ */ React.createElement("div", { className: "cp-mapa-fallback" }, /* @__PURE__ */ React.createElement("div", { className: "cp-mapa-fallback__msg" }, "Mapa indispon\xEDvel \u2014 a biblioteca Leaflet n\xE3o carregou (sem rede ou bloqueada)."), /* @__PURE__ */ React.createElement("ol", { className: "cp-mapa-fallback__lista" }, pontos.map((p, i) => /* @__PURE__ */ React.createElement("li", { key: `${p.tipo}-${p.id}-${i}` }, /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-pin",
        style: { background: p.tipo === "paragem" || p.tipo === "recolha" ? p.cor : "#475569" }
      },
      p.tipo === "paragem" ? p.ordem : p.tipo === "origem" ? "O" : p.tipo === "recolha" ? "\u2193" : "R"
    ), /* @__PURE__ */ React.createElement("span", null, p.nome, p.local ? ` \u2014 ${p.local}` : ""), p.km ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, p.km, " km") : null))));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "cp-mapa", ref: elRef });
}
window.CpMapa = CpMapa;

// ===== cargoplanner/frontend/cargoplanner_morada.jsx =====
function CpEscolhaDeMorada({ dados, onMudar, onErro }) {
  const [tipo, setTipo] = React.useState("unidade");
  const [unidadeId, setUnidadeId] = React.useState(
    ((dados.unidades || [])[0] || {}).id || ""
  );
  const [procura, setProcura] = React.useState("");
  const [clientes, setClientes] = React.useState([]);
  const [aProcurar, setAProcurar] = React.useState(false);
  const [cliente, setCliente] = React.useState(null);
  const [livre, setLivre] = React.useState({ nome: "", morada: "", local: "" });
  const [ponto, setPonto] = React.useState(null);
  const [aGeocodificar, setAGeocodificar] = React.useState(false);
  React.useEffect(() => {
    if (tipo !== "cliente" || procura.trim().length < 2) {
      setClientes([]);
      return void 0;
    }
    let vivo = true;
    setAProcurar(true);
    const t = setTimeout(() => {
      window.CargoplannerAPI.clientes(procura).then((r) => {
        if (vivo) {
          setClientes(r && r.clientes || []);
          setAProcurar(false);
        }
      }).catch((e) => {
        if (!vivo) return;
        setAProcurar(false);
        onErro?.(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel procurar no ERP."));
      });
    }, 350);
    return () => {
      vivo = false;
      clearTimeout(t);
    };
  }, [procura, tipo, onErro]);
  const localizar = React.useCallback(async (morada, local) => {
    onErro?.(null);
    setAGeocodificar(true);
    setPonto(null);
    try {
      const r = await window.CargoplannerAPI.geocodificar({ morada, local });
      setPonto(r && r.encontrado ? r : "nao");
    } catch (e) {
      onErro?.(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel localizar a morada."));
    } finally {
      setAGeocodificar(false);
    }
  }, [onErro]);
  React.useEffect(() => {
    if (tipo !== "cliente" || !cliente) return;
    localizar(cliente.morada || "", cliente.local || "");
  }, [cliente, tipo, localizar]);
  const unidade = (dados.unidades || []).find((u) => u.id === unidadeId) || null;
  const escolhida = React.useMemo(() => {
    const p = ponto && ponto !== "nao" ? ponto : null;
    if (tipo === "unidade") {
      if (!unidade) return null;
      return {
        tipo: "unidade",
        referencia: unidade.id,
        nome: unidade.nome,
        morada: unidade.morada || "",
        local: unidade.local || "",
        lat: unidade.lat,
        lng: unidade.lng
      };
    }
    if (tipo === "cliente") {
      if (!cliente) return null;
      return {
        tipo: "cliente",
        referencia: String(cliente.no),
        nome: cliente.nome,
        morada: cliente.morada || "",
        local: cliente.local || "",
        lat: p ? p.lat : null,
        lng: p ? p.lng : null
      };
    }
    if (!String(livre.nome).trim() || !String(livre.morada).trim()) return null;
    return {
      tipo: "livre",
      referencia: "",
      nome: livre.nome.trim(),
      morada: livre.morada.trim(),
      local: livre.local.trim(),
      lat: p ? p.lat : null,
      lng: p ? p.lng : null
    };
  }, [tipo, unidade, cliente, livre, ponto]);
  React.useEffect(() => {
    onMudar?.(escolhida);
  }, [escolhida, onMudar]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "cp-recolha-tipos", role: "group", "aria-label": "Onde \xE9 a paragem" }, [["unidade", "Unidade do grupo"], ["cliente", "Cliente"], ["livre", "Outra morada"]].map(([id, label]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: id,
      className: `btn ghost sm${tipo === id ? " is-on" : ""}`,
      onClick: () => {
        setTipo(id);
        onErro?.(null);
      }
    },
    label
  ))), tipo === "unidade" && /* @__PURE__ */ React.createElement("label", { className: "field cp-field-larga" }, /* @__PURE__ */ React.createElement("span", null, "Unidade"), /* @__PURE__ */ React.createElement("select", { className: "cp-select", value: unidadeId, onChange: (e) => setUnidadeId(e.target.value) }, (dados.unidades || []).map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.nome, u.local ? ` \u2014 ${u.local}` : ""))), unidade && !unidade.lat && /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "Esta unidade n\xE3o tem coordenadas: fica na lista, fora do percurso.")), tipo === "cliente" && /* @__PURE__ */ React.createElement("label", { className: "field cp-field-larga" }, /* @__PURE__ */ React.createElement("span", null, "Cliente"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "cp-select",
      value: procura,
      autoFocus: true,
      placeholder: "Escreve parte do nome\u2026",
      onChange: (e) => {
        setProcura(e.target.value);
        setCliente(null);
      }
    }
  ), aProcurar && /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "A procurar no ERP\u2026"), !aProcurar && procura.trim().length >= 2 && !clientes.length && /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "Nenhum cliente com esse nome."), !!clientes.length && /* @__PURE__ */ React.createElement("ul", { className: "cp-recolha-clientes" }, clientes.map((c) => /* @__PURE__ */ React.createElement("li", { key: c.no }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: cliente && cliente.no === c.no ? "is-on" : "",
      onClick: () => setCliente(c)
    },
    /* @__PURE__ */ React.createElement("b", null, c.nome),
    /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, [c.morada, c.local].filter(Boolean).join(" \xB7 ") || "sem morada no ERP")
  )))), cliente && /* @__PURE__ */ React.createElement("div", { className: "cp-recolha-geo" }, aGeocodificar && /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "A localizar a morada\u2026"), !aGeocodificar && ponto === "nao" && /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "A morada do ERP n\xE3o foi localizada. Podes acrescent\xE1-la na mesma \u2014 fica na lista, fora do percurso."), !aGeocodificar && ponto && ponto !== "nao" && /* @__PURE__ */ React.createElement("small", { className: "cp-ok-txt" }, "Localizada", ponto.precisao && ponto.precisao !== "address" ? ` (ao n\xEDvel "${window.CP_PRECISAO[ponto.precisao] || ponto.precisao}")` : "", "."))), tipo === "livre" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Nome *"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "cp-select",
      value: livre.nome,
      placeholder: "Cliente, armaz\xE9m, feira\u2026",
      onChange: (e) => setLivre({ ...livre, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Localidade"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "cp-select",
      value: livre.local,
      onChange: (e) => {
        setLivre({ ...livre, local: e.target.value });
        setPonto(null);
      }
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field cp-field-larga" }, /* @__PURE__ */ React.createElement("span", null, "Morada *"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "cp-select",
      value: livre.morada,
      onChange: (e) => {
        setLivre({ ...livre, morada: e.target.value });
        setPonto(null);
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "cp-recolha-geo" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      disabled: !livre.morada.trim() || aGeocodificar,
      onClick: () => localizar(livre.morada, livre.local)
    },
    aGeocodificar ? "A localizar\u2026" : "Localizar no mapa"
  ), ponto === "nao" && /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "N\xE3o foi encontrada. Podes acrescent\xE1-la na mesma \u2014 fica na lista, fora do percurso."), ponto && ponto !== "nao" && /* @__PURE__ */ React.createElement("small", { className: "cp-ok-txt" }, "Encontrada", ponto.precisao && ponto.precisao !== "address" ? ` (ao n\xEDvel "${window.CP_PRECISAO[ponto.precisao] || ponto.precisao}")` : "", ".")))));
}
window.CpEscolhaDeMorada = CpEscolhaDeMorada;

// ===== cargoplanner/frontend/cargoplanner_recolhas.jsx =====
function CpRecolhaModal({ dados, onFechar, onCriar }) {
  const [morada, setMorada] = React.useState(null);
  const [motivo, setMotivo] = React.useState("");
  const [erro, setErro] = React.useState(null);
  const aoMudar = React.useCallback((m) => setMorada(m), []);
  const aoErro = React.useCallback((e) => setErro(e), []);
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Acrescentar uma recolha",
      width: 560,
      onClose: onFechar,
      subtitle: "Uma paragem para apanhar, n\xE3o para entregar. N\xE3o conta para a capacidade.",
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          disabled: !morada,
          onClick: () => onCriar({ ...morada, motivo })
        },
        "Acrescentar"
      ))
    },
    erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro),
    /* @__PURE__ */ React.createElement("div", { className: "cp-form" }, /* @__PURE__ */ React.createElement(window.CpEscolhaDeMorada, { dados, onMudar: aoMudar, onErro: aoErro }), /* @__PURE__ */ React.createElement("label", { className: "field cp-field-larga" }, /* @__PURE__ */ React.createElement("span", null, "Motivo"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        value: motivo,
        placeholder: "Devolu\xE7\xE3o de paletes, material para repara\xE7\xE3o\u2026",
        onChange: (e) => setMotivo(e.target.value)
      }
    )))
  );
}
window.CpRecolhaModal = CpRecolhaModal;

// ===== cargoplanner/frontend/cargoplanner_amostra.jsx =====
function CpAmostraModal({ dados, onFechar, onCriar }) {
  const [morada, setMorada] = React.useState(null);
  const [erro, setErro] = React.useState(null);
  const aoMudar = React.useCallback((m) => setMorada(m), []);
  const aoErro = React.useCallback((e) => setErro(e), []);
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Acrescentar uma entrega de amostra",
      width: 560,
      onClose: onFechar,
      subtitle: "Uma entrega sem encomenda lan\xE7ada. Fica na ordem de entrega, como as outras.",
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          disabled: !morada,
          onClick: () => onCriar({ ...morada })
        },
        "Acrescentar"
      ))
    },
    erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro),
    /* @__PURE__ */ React.createElement("div", { className: "cp-form" }, /* @__PURE__ */ React.createElement(window.CpEscolhaDeMorada, { dados, onMudar: aoMudar, onErro: aoErro })),
    /* @__PURE__ */ React.createElement("p", { className: "cp-dim", style: { marginTop: 10 } }, "Os volumes desta amostra \u2014 medidas, peso e descri\xE7\xE3o \u2014 ainda n\xE3o se registam aqui: por agora ela entra no percurso e n\xE3o conta para a capacidade do cami\xE3o.")
  );
}
window.CpAmostraModal = CpAmostraModal;

// ===== cargoplanner/frontend/cargoplanner_carga.jsx =====
const CP_DND = "text/plain";
function cpLerPayload(ev) {
  try {
    return JSON.parse(ev.dataTransfer.getData(CP_DND) || "null");
  } catch (_) {
    return null;
  }
}
function cpEscreverPayload(ev, payload) {
  ev.dataTransfer.setData(CP_DND, JSON.stringify(payload));
  ev.dataTransfer.effectAllowed = "move";
}
const CP_CAMPOS_PRECO = [
  ["aluguer", "Aluguer \u20AC"],
  ["km", "\u20AC/km"],
  ["paragensIncluidas", "Paragens inclu\xEDdas"],
  ["paragem", "\u20AC/paragem extra"],
  ["regresso", "\u20AC regresso"],
  ["sobretaxaPct", "Combust\xEDvel %"]
];
function CpCaisEscolha({ carga, cais, onMudar, ocupadoPor }) {
  const valor = carga && carga.localizacaoDestino || "";
  const lista = cais || [];
  const conhecido = lista.some((c) => c.codigo === valor);
  const ocupado = (codigo) => {
    const q = ocupadoPor ? ocupadoPor(codigo) || [] : [];
    return q.length ? q.map((x) => x.rotulo).filter(Boolean).join(", ") : null;
  };
  return /* @__PURE__ */ React.createElement("label", { className: "cp-fluxo__escolha", title: "O s\xEDtio do armaz\xE9m onde esta carga se monta. \xC9 daqui que sai o destino de cada tarefa de picking, e \xE9 contra isto que o tablet confere ao alocar. Um cais leva uma carga de cada vez, desde que a prepara\xE7\xE3o come\xE7a at\xE9 o cami\xE3o sair." }, /* @__PURE__ */ React.createElement("span", { className: "cp-fluxo__escolha-label" }, "Cais"), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "cp-select sm",
      value: valor,
      disabled: !carga,
      "aria-label": "Cais de destino da carga",
      onChange: (e) => onMudar(e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem cais \u2014"),
    lista.map((c) => {
      const quem = ocupado(c.codigo);
      return /* @__PURE__ */ React.createElement("option", { key: c.id, value: c.codigo }, c.nome, " \xB7 ", c.codigo, quem ? ` \u2014 ocupado (${quem})` : "");
    }),
    valor && !conhecido && /* @__PURE__ */ React.createElement("option", { value: valor }, valor, " \u2014 fora da lista")
  ));
}
function CpPreparadorEscolha({
  pessoas,
  valor,
  nomeSolto,
  varios,
  titulo,
  etiqueta,
  rotulo,
  disabled,
  onMudar
}) {
  const lista = pessoas || [];
  const v = valor == null ? "" : String(valor);
  return /* @__PURE__ */ React.createElement("label", { className: "cp-fluxo__escolha", title: titulo }, etiqueta !== false && /* @__PURE__ */ React.createElement("span", { className: "cp-fluxo__escolha-label" }, rotulo || "Prepara"), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "cp-select sm",
      value: varios ? "__varios__" : v,
      disabled: !!disabled,
      "aria-label": titulo,
      onChange: (e) => {
        if (e.target.value === "__varios__") return;
        onMudar(e.target.value || null);
      }
    },
    varios && /* @__PURE__ */ React.createElement("option", { value: "__varios__" }, "v\xE1rios \u2014 ver as paragens"),
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 por atribuir \u2014"),
    lista.map((p) => /* @__PURE__ */ React.createElement("option", { key: p.id, value: p.id }, p.nome)),
    nomeSolto && /* @__PURE__ */ React.createElement("option", { value: v }, nomeSolto, " \u2014 fora da escala")
  ));
}
function CpEstadoFluxo({
  carga,
  dados,
  validacao,
  onEstado,
  cais,
  pessoas,
  preparador,
  onCais,
  onPreparador,
  caisOcupadoPor
}) {
  const fluxo = dados.fluxoEstados || [];
  const porId = (id) => (dados.estados || []).find((e) => e.id === id) || { id, label: id, cor: "#6a7888" };
  const atual = carga ? carga.estado : null;
  const foraDoFluxo = atual && !fluxo.includes(atual);
  const i = fluxo.indexOf(atual);
  const bloqueado = !!validacao.bloqueado;
  const recuar = async (destino) => {
    const ok = await window.hubConfirm({
      title: "Recuar o estado",
      message: `P\xF4r a carga de volta em \xAB${porId(destino).label}\xBB? O que j\xE1 tiver sido feito a jusante deixa de estar assinalado.`,
      confirmLabel: "Recuar",
      danger: true
    });
    if (ok) onEstado(destino);
  };
  if (foraDoFluxo) {
    const e = porId(atual);
    return /* @__PURE__ */ React.createElement("div", { className: "cp-fluxo cp-fluxo--fora" }, /* @__PURE__ */ React.createElement("span", { className: "cp-estado-pill", style: { "--cp-estado": e.cor } }, /* @__PURE__ */ React.createElement("span", { className: "cp-estado-dot", style: { background: e.cor } }), e.label), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => onEstado(fluxo[0]) }, "Retomar planeamento"));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "cp-fluxo", role: "group", "aria-label": "Estado da carga" }, fluxo.map((id, n) => {
    const e = porId(id);
    const feito = n < i;
    const eAtual = n === i;
    const proximo = n === i + 1;
    const podeIr = proximo ? !bloqueado : n < i;
    const titulo = eAtual ? "Estado atual" : proximo ? bloqueado ? `Resolve primeiro: ${validacao.problemas.filter((p) => p.nivel === "erro").map((p) => p.msg).join(" ")}` : `Passar a ${e.label}` : n < i ? `Recuar a ${e.label}` : "S\xF3 se avan\xE7a um passo de cada vez";
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: id,
        type: "button",
        title: titulo,
        "aria-current": eAtual ? "step" : void 0,
        disabled: eAtual || !podeIr,
        onClick: () => n < i ? recuar(id) : onEstado(id),
        className: `cp-fluxo__passo${eAtual ? " is-atual" : ""}${feito ? " is-feito" : ""}${proximo && !bloqueado ? " is-proximo" : ""}`,
        style: { "--cp-estado": e.cor }
      },
      /* @__PURE__ */ React.createElement("span", { className: "cp-fluxo__dot" }),
      e.label
    );
  }), /* @__PURE__ */ React.createElement(
    CpCaisEscolha,
    {
      carga,
      cais,
      onMudar: onCais,
      ocupadoPor: caisOcupadoPor
    }
  ), /* @__PURE__ */ React.createElement(
    CpPreparadorEscolha,
    {
      pessoas,
      disabled: !carga,
      valor: preparador && preparador.pessoaId,
      varios: !!(preparador && preparador.varios),
      nomeSolto: preparador && preparador.foraDaEscala,
      titulo: "Quem prepara a carga",
      onMudar: onPreparador
    }
  ));
}
function CpSairDoFluxo({ carga, onEstado }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: () => onEstado("bloqueada"),
      disabled: !carga,
      title: "A carga n\xE3o pode seguir \u2014 fica marcada e sai do fluxo"
    },
    "Bloquear"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: () => onEstado("cancelada"),
      disabled: !carga,
      title: "A carga n\xE3o vai acontecer"
    },
    "Cancelar"
  ));
}
function CpMoverModal({ carga, camioes, onFechar, onMover }) {
  const [tirId, setTirId] = React.useState(carga ? carga.tirId : null);
  const [dia, setDia] = React.useState(carga ? carga.dia : "");
  const [aMover, setAMover] = React.useState(false);
  const [erro, setErro] = React.useState(null);
  const lista = (camioes || []).filter((c) => c.tirId != null);
  const mudou = carga && (String(tirId) !== String(carga.tirId) || dia !== carga.dia);
  const mover = async () => {
    setErro(null);
    setAMover(true);
    try {
      await onMover({ tir: tirId, dia });
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel mover a carga."));
      setAMover(false);
    }
  };
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Mover a carga",
      subtitle: carga ? `${carga.camiaoId} \xB7 ${carga.dia}` : "",
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          disabled: !mudou || aMover,
          title: mudou ? "" : "Escolhe outro cami\xE3o ou outro dia",
          onClick: mover
        },
        aMover ? "A mover\u2026" : "Mover"
      ))
    },
    erro && /* @__PURE__ */ React.createElement("div", { className: "cp-erro", role: "alert" }, erro),
    /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Cami\xE3o"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: tirId == null ? "" : String(tirId),
        onChange: (e) => setTirId(e.target.value)
      },
      lista.map((c) => /* @__PURE__ */ React.createElement("option", { key: c.tirId, value: c.tirId }, c.id, c.tipoNome ? ` \u2014 ${c.tipoNome}` : ""))
    )),
    /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Dia"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "date",
        value: dia,
        onChange: (e) => setDia(e.target.value)
      }
    )),
    /* @__PURE__ */ React.createElement("p", { className: "cp-dim" }, "Se esse cami\xE3o j\xE1 tiver carga nesse dia, esta passa a ser a viagem seguinte \u2014 nada se mistura."),
    /* @__PURE__ */ React.createElement("p", { className: "cp-dim" }, "Vai a carga inteira: artigos, recolhas, pre\xE7os negociados, CMRs e o que j\xE1 estiver registado. As ondas de prepara\xE7\xE3o (uma por cliente) acompanham o dia novo \u2014 menos as que j\xE1 tenham trabalho feito, que ficam onde est\xE3o, e o ecr\xE3 diz quais.")
  );
}
function CpUrgenciaModal({ carga, onFechar, onGuardar }) {
  const [motivos, setMotivos] = React.useState([]);
  const [erro, setErro] = React.useState(null);
  const [motivoId, setMotivoId] = React.useState(
    carga && carga.motivoUrgenciaId ? String(carga.motivoUrgenciaId) : ""
  );
  const [nota, setNota] = React.useState(carga && carga.notaUrgencia || "");
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.motivosUrgencia().then((lista) => {
      if (vivo) setMotivos((lista || []).filter((m) => m.ativo));
    }).catch((e) => {
      if (vivo) setErro(window.CargoplannerAPI.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel ler os motivos."
      ));
    });
    return () => {
      vivo = false;
    };
  }, []);
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Marcar a carga como urgente",
      subtitle: carga ? `${carga.camiaoId} \xB7 ${carga.dia}` : "",
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          disabled: !motivoId,
          title: motivoId ? "" : "Escolhe um motivo",
          onClick: () => onGuardar({
            motivoId: Number(motivoId),
            motivoNome: (motivos.find((m) => String(m.id) === motivoId) || {}).nome || null,
            nota: nota.trim()
          })
        },
        "Marcar urgente"
      ))
    },
    erro && /* @__PURE__ */ React.createElement("div", { className: "cp-erro", role: "alert" }, erro),
    /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Motivo"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: motivoId,
        onChange: (e) => setMotivoId(e.target.value)
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"),
      motivos.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.nome))
    )),
    /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Nota (opcional)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "text",
        maxLength: 200,
        value: nota,
        placeholder: "Qual cliente, qual encomenda",
        onChange: (e) => setNota(e.target.value)
      }
    )),
    /* @__PURE__ */ React.createElement("p", { className: "muted" }, "Os motivos editam-se em Defini\xE7\xF5es \u2192 Vocabul\xE1rios.")
  );
}
function CpTotalPrevisto({ carga, dados, percurso, custo, transportadoraId, tipoId, onPreencher }) {
  const L = window.CargoplannerLogica;
  if (!carga) return null;
  const hipotetica = L.cargaHipotetica(carga, { custo, transportadoraId, tipoId });
  const c = L.custoDaCarga(hipotetica, dados, percurso);
  if (!c) {
    const motivo = L.motivoSemCusto(hipotetica, dados, percurso);
    const zonaSem = L.textoSemCustoZona(hipotetica, dados);
    return /* @__PURE__ */ React.createElement("div", { className: "cp-precos__total" }, /* @__PURE__ */ React.createElement("p", { className: "muted" }, zonaSem ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, "Sem pre\xE7o \u2014 ", zonaSem.curto), " \u2014 ", zonaSem.longo) : motivo === "sem_planeamento" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, "Ainda sem carga"), " \u2014 esta viagem n\xE3o tem linhas nem recolhas. O pre\xE7o previsto aparece assim que houver artigos (ou uma recolha) nesta carga; n\xE3o \xE9 uma tarifa em falta.") : motivo === "transitario_sem_volumes" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, "Paga-se ao volume"), " \u2014 um transit\xE1rio cobra \xE0 unidade enviada, n\xE3o \xE0 viagem: n\xE3o h\xE1 transportadora nem tarifa a escolher aqui. O pre\xE7o h\xE1 de vir do registo dos volumes de cada paragem, que ainda n\xE3o existe.") : motivo === "sem_km" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, "Sem quil\xF3metros fi\xE1veis"), " \u2014 uma paragem ou unidade desta rota n\xE3o tem coordenadas. Escolher outra transportadora n\xE3o resolve; \xE9 a morada que precisa de corre\xE7\xE3o.") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, "Sem tarifa"), " \u2014 escolhe uma transportadora com pre\xE7os para este tipo de ve\xEDculo, ou preenche-os \xE0 m\xE3o, em baixo. (Uma carga sem tarifa n\xE3o mostra 0 \u20AC: mostra que n\xE3o sabe.)")), motivo === "sem_tarifa" && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onPreencher }, "Preencher os pre\xE7os \xE0 m\xE3o"));
  }
  const eur = (v) => `${v.toFixed(2).replace(".", ",")} \u20AC`;
  return /* @__PURE__ */ React.createElement("p", { className: "cp-precos__total" }, /* @__PURE__ */ React.createElement("b", null, "Total previsto ", eur(c.total)), c.zona ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " ", "\xB7 zona mais distante: ", c.zona.rotulo, " ", eur(c.aluguer), c.paragensExtra > 0 && ` \xB7 ${c.paragensExtra} descarga(s) extra ${eur(c.paragensCusto)}`, c.regresso > 0 && ` \xB7 regresso ${eur(c.regresso)}`, " ", "\xB7 dias \xFAteis, hor\xE1rio normal") : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " ", "\xB7 aluguer ", eur(c.aluguer), c.viagensPagas > 1 && ` (\xF7 ${c.viagensPagas} viagens)`, " ", "\xB7 ", c.km, " km ", eur(c.custoKm), " ", "\xB7 combust\xEDvel ", eur(c.combustivel), c.paragensExtra > 0 && ` \xB7 ${c.paragensExtra} paragem(ns) extra ${eur(c.paragensCusto)}`, c.regresso > 0 && ` \xB7 regresso ${eur(c.regresso)}`));
}
function CpTransporteModal({
  carga,
  camiao,
  tipos,
  transportadoras,
  tarifas,
  dados,
  percurso,
  onFechar,
  onGuardar
}) {
  const L = window.CargoplannerLogica;
  const t = carga && carga.transporte || {};
  const [tipoId, setTipoId] = React.useState(t.tipoId != null ? String(t.tipoId) : "");
  const [transportadoraId, setTransportadoraId] = React.useState(
    t.transportadoraId != null ? String(t.transportadoraId) : ""
  );
  const [aluguer, setAluguer] = React.useState(t.aluguer || "");
  const [matricula, setMatricula] = React.useState(t.matricula || "");
  const [motorista, setMotorista] = React.useState(t.motorista || "");
  const [inicio, setInicio] = React.useState(t.inicio || "");
  const [fim, setFim] = React.useState(t.fim || "");
  const [custo, setCusto] = React.useState(carga && carga.custo ? { ...carga.custo } : null);
  const aluguerEfetivo = aluguer || camiao && camiao.aluguer || "proprio";
  const jaAlugado = aluguerEfetivo === "alugado";
  const doCamiao = (v) => v ? `Do cami\xE3o: ${v}` : "Do cami\xE3o: \u2014";
  const rotuloAluguer = (v) => ((dados.aluguer || []).find((a) => a.id === v) || {}).label || v;
  const camiaoComTransportadora = camiao ? L.comTransportadoraInterno(camiao, dados) : null;
  const camposNegativos = L.camposPrecoNegativos(custo);
  const rotulosNegativos = CP_CAMPOS_PRECO.filter(([campo]) => camposNegativos.includes(campo)).map(([, rotulo]) => rotulo);
  const repor = () => {
    setTipoId("");
    setTransportadoraId("");
    setAluguer("");
    setMatricula("");
    setMotorista("");
    setInicio("");
    setFim("");
    setCusto(null);
  };
  const pedirRepor = async () => {
    if (custo) {
      const ok = await window.hubConfirm({
        title: "Repor o do cami\xE3o",
        message: "Isto tamb\xE9m apaga os PRE\xC7OS NEGOCIADOS desta carga \u2014 n\xE3o s\xF3 o tipo, a contrata\xE7\xE3o, a matr\xEDcula e o motorista. A partir daqui a carga volta a seguir a tarifa da ficha do cami\xE3o.",
        confirmLabel: "Repor tudo, incluindo os pre\xE7os",
        danger: true
      });
      if (!ok) return;
    }
    repor();
  };
  const preencherAMao = () => setCusto({
    aluguer: 0,
    aluguerModo: "viagem",
    km: 0,
    paragensIncluidas: 0,
    paragem: 0,
    regresso: 0,
    sobretaxaPct: 0
  });
  const copiarTarifa = (novoTransportadoraId, novoTipoId) => {
    const tipoEfetivo = novoTipoId ? Number(novoTipoId) : camiao && camiao.tipoId;
    const tar = (tarifas || []).find(
      (x) => x.transportadoraId === Number(novoTransportadoraId) && x.tipoId === tipoEfetivo && x.ativo
    );
    setCusto(tar ? {
      aluguer: tar.aluguer,
      aluguerModo: tar.aluguerModo,
      km: tar.km,
      paragensIncluidas: tar.paragensIncluidas,
      paragem: tar.paragem,
      regresso: tar.regresso,
      sobretaxaPct: tar.sobretaxaPct,
      origemTarifaId: tar.id,
      copiadoEm: (/* @__PURE__ */ new Date()).toISOString()
    } : null);
  };
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Transporte desta carga",
      subtitle: carga ? `${carga.camiaoId} \xB7 ${carga.dia}` : "",
      onClose: onFechar,
      width: 520,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost",
          onClick: pedirRepor,
          title: "Rep\xF5e o tipo, a contrata\xE7\xE3o, a matr\xEDcula, o motorista, o hor\xE1rio \u2014 e OS PRE\xC7OS negociados desta carga"
        },
        "Repor o do cami\xE3o"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), aluguerEfetivo === "por_alugar" && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost",
          disabled: !transportadoraId,
          title: transportadoraId ? "Confirmar que o cami\xE3o est\xE1 alugado a esta transportadora" : "Escolhe primeiro a transportadora",
          onClick: () => setAluguer("alugado")
        },
        "Marcar como alugado"
      ), aluguerEfetivo === "alugado" && /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: async () => {
        const ok = await window.hubConfirm({
          title: "Voltar a \xABpor alugar\xBB",
          message: "Isto desfaz um compromisso j\xE1 assumido. A transportadora n\xE3o \xE9 avisada \u2014 \xE9 preciso falar com ela.",
          confirmLabel: "Voltar a por alugar",
          danger: true
        });
        if (ok) setAluguer("por_alugar");
      } }, "Voltar a por alugar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          disabled: camposNegativos.length > 0,
          title: camposNegativos.length > 0 ? `Corrige antes de gravar: ${rotulosNegativos.join(", ")} n\xE3o pode ser negativo.` : "",
          onClick: () => onGuardar({
            tipoId: tipoId ? Number(tipoId) : null,
            tipoNome: (tipos.find((x) => String(x.id) === tipoId) || {}).nome || null,
            transportadoraId: transportadoraId ? Number(transportadoraId) : null,
            transportadoraNome: (transportadoras.find((f) => String(f.id) === transportadoraId) || {}).nome || null,
            aluguer,
            matricula: matricula.trim(),
            motorista: motorista.trim(),
            inicio: inicio || null,
            fim: fim || null
          }, custo ? L.custoConvertido(custo) : null)
        },
        "Guardar"
      ))
    },
    jaAlugado && /* @__PURE__ */ React.createElement("div", { className: "cp-aviso-faixa", role: "status" }, "Este transporte j\xE1 est\xE1 alugado. Alterar aqui ", /* @__PURE__ */ React.createElement("b", null, "n\xE3o avisa a transportadora"), " \u2014 \xE9 preciso falar com ela."),
    /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Tipo de ve\xEDculo"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: tipoId,
        onChange: (e) => {
          const id = e.target.value;
          setTipoId(id);
          if (transportadoraId) copiarTarifa(transportadoraId, id);
        }
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, doCamiao(camiao && camiao.tipoNome)),
      (tipos || []).filter((x) => x.ativo !== false).map((x) => /* @__PURE__ */ React.createElement("option", { key: x.id, value: x.id }, x.nome))
    )),
    /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Contrata\xE7\xE3o"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: aluguer,
        onChange: (e) => setAluguer(e.target.value)
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, doCamiao(camiao && rotuloAluguer(camiao.aluguer))),
      /* @__PURE__ */ React.createElement("option", { value: "proprio" }, "Frota pr\xF3pria"),
      /* @__PURE__ */ React.createElement("option", { value: "por_alugar" }, "Por alugar"),
      /* @__PURE__ */ React.createElement("option", { value: "alugado", disabled: true }, "Alugado")
    )),
    /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Transportadora"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: transportadoraId,
        onChange: (e) => {
          const id = e.target.value;
          setTransportadoraId(id);
          if (!id) {
            setCusto(null);
            return;
          }
          copiarTarifa(id, tipoId);
        }
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, doCamiao(camiaoComTransportadora && camiaoComTransportadora.transportadoraNome)),
      (transportadoras || []).filter((f) => f.ativo !== false).map((f) => /* @__PURE__ */ React.createElement("option", { key: f.id, value: f.id }, f.nome))
    )),
    /* @__PURE__ */ React.createElement("div", { className: "cp-campo-par" }, /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Matr\xEDcula"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "text",
        maxLength: 16,
        value: matricula,
        placeholder: doCamiao(camiao && camiao.matricula),
        onChange: (e) => setMatricula(e.target.value)
      }
    )), /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Motorista"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "text",
        maxLength: 120,
        value: motorista,
        placeholder: doCamiao(camiao && camiao.motorista),
        onChange: (e) => setMotorista(e.target.value)
      }
    ))),
    /* @__PURE__ */ React.createElement("div", { className: "cp-campo-par" }, /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Sa\xEDda"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "time",
        value: inicio,
        onChange: (e) => setInicio(e.target.value)
      }
    )), /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Fim"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "time",
        value: fim,
        onChange: (e) => setFim(e.target.value)
      }
    ))),
    /* @__PURE__ */ React.createElement("div", { className: "cp-precos" }, /* @__PURE__ */ React.createElement("div", { className: "cp-precos__top" }, /* @__PURE__ */ React.createElement("b", null, "Pre\xE7os desta carga"), custo ? /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        onClick: () => setCusto(null),
        title: "Apagar os pre\xE7os pr\xF3prios desta carga e voltar a seguir o cat\xE1logo"
      },
      "Repor os pre\xE7os da tarifa"
    ) : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "A seguir a tarifa do cat\xE1logo")), custo && /* @__PURE__ */ React.createElement("div", { className: "cp-precos__campos" }, CP_CAMPOS_PRECO.map(([campo, rotulo]) => /* @__PURE__ */ React.createElement("label", { className: "cp-campo", key: campo }, /* @__PURE__ */ React.createElement("span", null, rotulo), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "text",
        inputMode: "decimal",
        value: custo[campo],
        onChange: (e) => setCusto({ ...custo, [campo]: e.target.value })
      }
    ))), /* @__PURE__ */ React.createElement("label", { className: "cp-campo" }, /* @__PURE__ */ React.createElement("span", null, "Modo de aluguer"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: custo.aluguerModo,
        onChange: (e) => setCusto({ ...custo, aluguerModo: e.target.value })
      },
      /* @__PURE__ */ React.createElement("option", { value: "viagem" }, "Por viagem"),
      /* @__PURE__ */ React.createElement("option", { value: "dia" }, "Por dia (reparte-se pelas viagens)"),
      /* @__PURE__ */ React.createElement("option", { value: "zona" }, "Por zona de destino")
    ))), camposNegativos.length > 0 && /* @__PURE__ */ React.createElement("p", { className: "cp-erro", role: "alert" }, rotulosNegativos.join(", "), " n\xE3o pode ser negativo."), /* @__PURE__ */ React.createElement(
      CpTotalPrevisto,
      {
        carga,
        dados,
        percurso,
        custo,
        transportadoraId,
        tipoId,
        onPreencher: preencherAMao
      }
    )),
    /* @__PURE__ */ React.createElement("p", { className: "muted" }, "Vazio = vale o do cami\xE3o. Isto muda s\xF3 esta carga; a ficha do cami\xE3o edita-se em Defini\xE7\xF5es \u2192 Frota.")
  );
}
function CpCabecalhoCarga({
  camiao,
  carga,
  dados,
  percurso,
  ocupacao,
  validacao,
  gravacao,
  onResolverConflito,
  onEstado,
  onLimpar,
  onUrgencia,
  onTransporte,
  onMover,
  custo,
  racios,
  motivoSemCusto,
  tempoPreparacao,
  pessoas,
  preparadorDaCarga,
  preparadorDaParagem,
  onCais,
  onPreparador,
  onPreparadorParagem,
  caisOcupadoPor
}) {
  const L = window.CargoplannerLogica;
  const real = !!percurso.real;
  const [detalhe, setDetalhe] = React.useState(false);
  const eur = (v) => `${(Number(v) || 0).toFixed(2).replace(".", ",")} \u20AC`;
  const zonaSemCusto = custo ? null : L.textoSemCustoZona(carga, dados);
  return /* @__PURE__ */ React.createElement("header", { className: "cp-cabecalho" }, /* @__PURE__ */ React.createElement("div", { className: "cp-cabecalho__top" }, /* @__PURE__ */ React.createElement("h2", { className: "cp-cabecalho__titulo" }, camiao ? camiao.id : "\u2014"), camiao && camiao.aluguer === "por_alugar" && /* @__PURE__ */ React.createElement("span", { className: "cp-estado-pill cp-pill-aviso", title: "Ainda n\xE3o h\xE1 transportadora, viatura nem motorista para este lugar" }, "Por alugar"), carga && carga.urgente && /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "cp-estado-pill cp-pill-urgente",
      title: `Urgente \u2014 ${carga.motivoUrgenciaNome || "sem motivo"}` + (carga.notaUrgencia ? `
${carga.notaUrgencia}` : "")
    },
    "Urgente"
  ), /* @__PURE__ */ React.createElement("div", { className: "cp-cabecalho__acoes" }, gravacao && gravacao.estado !== "limpo" && gravacao.estado !== "conflito" && /* @__PURE__ */ React.createElement(
    "span",
    {
      className: `cp-gravacao${gravacao.estado === "erro" ? " is-erro" : ""}`,
      role: "status",
      title: gravacao.erro || ""
    },
    gravacao.estado === "a_guardar" ? "A guardar\u2026" : gravacao.estado === "erro" ? "N\xE3o gravou" : "Guardado"
  ), gravacao && gravacao.estado === "conflito" && /* @__PURE__ */ React.createElement("span", { className: "cp-gravacao is-erro", role: "status" }, "Esta carga foi alterada por outra pessoa", /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: onResolverConflito,
      title: "Descarta a tua edi\xE7\xE3o por gravar e mostra o que est\xE1 agora no servidor"
    },
    "Recarregar do servidor"
  )), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: onTransporte,
      disabled: !carga,
      title: "Mudar o tipo, a transportadora ou o hor\xE1rio s\xF3 desta carga"
    },
    "Transporte"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: onMover,
      disabled: !carga,
      title: "Passar esta carga para outro cami\xE3o, para outro dia, ou os dois"
    },
    "Mover"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: onUrgencia,
      disabled: !carga,
      title: carga && carga.urgente ? "Deixar de estar urgente" : "Marcar esta carga como urgente"
    },
    carga && carga.urgente ? "Deixar de ser urgente" : "Marcar urgente"
  ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: onLimpar, disabled: !carga || !(carga.linhas || []).length }, /* @__PURE__ */ React.createElement(window.Ico.trash, null), " Limpar carga"), /* @__PURE__ */ React.createElement(CpSairDoFluxo, { carga, onEstado }))), /* @__PURE__ */ React.createElement(
    CpEstadoFluxo,
    {
      carga,
      dados,
      validacao,
      onEstado,
      cais: dados.cais,
      pessoas,
      preparador: preparadorDaCarga,
      onCais,
      onPreparador,
      caisOcupadoPor
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "cp-cabecalho__meta is-clicavel",
      role: "button",
      tabIndex: 0,
      title: "Ver o detalhe \u2014 como cada um destes n\xFAmeros foi feito",
      onClick: () => setDetalhe(true),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setDetalhe(true);
        }
      }
    },
    /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Data"), " ", carga ? carga.dia : "\u2014"),
    /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Transporte"), " ", !camiao ? "\u2014" : camiao.aluguer === "proprio" ? "Frota pr\xF3pria" : camiao.transportadoraNome || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por contratar")),
    /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Motorista"), " ", camiao && camiao.motorista || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por atribuir")),
    /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Matr\xEDcula"), " ", camiao && camiao.matricula || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por atribuir")),
    /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Sa\xEDda"), " ", !camiao ? "\u2014" : camiao.inicio ? camiao.inicio : /* @__PURE__ */ React.createElement("i", { className: "cp-sem-janela" }, "Hor\xE1rio por definir")),
    !ocupacao.transitario && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Dist\xE2ncia ", real ? "por estrada" : "(estimada)"), " ", percurso.kmTotal == null ? "\u2014" : `${percurso.kmTotal} km`), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Dura\xE7\xE3o ", real ? "de condu\xE7\xE3o" : "(estimada)"), " ", percurso.minTotal == null ? "\u2014" : L.duracao(percurso.minTotal))),
    ocupacao.transitario ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Transit\xE1rio"), " ", /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "paga-se ao volume \u2014 sem ocupa\xE7\xE3o a calcular")) : /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Ocupa\xE7\xE3o"), " ", /* @__PURE__ */ React.createElement("span", { className: ocupacao.metrosExcedeu ? "cp-erro-txt" : "" }, ocupacao.metros.toFixed(2).replace(".", ","), " / ", (ocupacao.metrosCapacidade || 0).toFixed(2).replace(".", ","), " m (", ocupacao.metrosPct, "%)", /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", ocupacao.ocupadas, " pal."), ocupacao.empilhadas > 0 && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-dim",
        title: `${ocupacao.empilhadas} contadas EMPILHADAS: a altura cabe mais do que uma vez na altura \xFAtil do cami\xE3o. As restantes contam uma camada \u2014 \xE9 o que se assume quando a altura n\xE3o se sabe.`
      },
      " ",
      "\xB7 empilha ",
      ocupacao.empilhadas
    ), ocupacao.semMedida > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: L.textoSemMedida(ocupacao) }, " ", "+", ocupacao.semMedida, " s/ medida"), ocupacao.arranjo && ocupacao.arranjo.resumo && // Não chega o total: sem dizer COMO carregar, um número otimizado
    // que ninguém reproduz é uma SUBestimativa — pior do que a
    // sobrestimativa que isto substitui. O detalhe por corrida
    // (que clientes, que pegada) vai no title.
    /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: ocupacao.arranjo.detalhe }, " ", "\xB7 ", ocupacao.arranjo.resumo))),
    /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Pre\xE7o previsto"), " ", !custo ? /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar", title: zonaSemCusto ? zonaSemCusto.longo : motivoSemCusto === "sem_planeamento" ? "Ainda n\xE3o h\xE1 nada planeado nesta carga \u2014 nem linhas, nem recolhas. Um 0 \u20AC diria \xABesta volta n\xE3o custa nada\xBB; a verdade \xE9 que a volta ainda n\xE3o existe." : motivoSemCusto === "transitario_sem_volumes" ? "Um transit\xE1rio paga-se ao volume enviado, n\xE3o \xE0 viagem \u2014 n\xE3o h\xE1 transportadora nem tarifa a escolher aqui. O pre\xE7o h\xE1 de vir do registo dos volumes de cada paragem, que ainda n\xE3o existe (#49)." : motivoSemCusto === "sem_km" ? "A volta tem paragens sem coordenadas \u2014 sem quil\xF3metros fi\xE1veis n\xE3o h\xE1 como calcular o pre\xE7o. Um 0 \u20AC diria \xABn\xE3o custa nada\xBB, que \xE9 a leitura errada." : "N\xE3o h\xE1 tarifa para esta transportadora e tipo de ve\xEDculo. Um 0 \u20AC diria \xABn\xE3o custa nada\xBB, que \xE9 a leitura errada." }, zonaSemCusto ? zonaSemCusto.curto : motivoSemCusto === "sem_planeamento" ? "sem carga" : motivoSemCusto === "transitario_sem_volumes" ? "paga-se ao volume" : "sem tarifa") : custo.transitario ? (
      /* **O preço de um transitário não se decompõe em aluguer e km** —
                       ele cobra à UNIDADE enviada, e o total é a soma dos volumes
                       registados nas paragens. O ramo de baixo escreveria aqui
                       «Aluguer 0,00 €», «0 km × tarifa» e «Preços do catálogo de
                       tarifas» — esta última pura e simplesmente falsa (`custo.origem`
                       nem existe nesta conta). Gateado pela MARCA, nunca por um
                       número ser zero: um tipo de transitário criado em Definições
                       fica com as medidas por omissão se ninguém as zerar.
      
                       Os RÁCIOS (€/palete, €/m, €/km) ficam de fora de propósito,
                       como no `CpCargaModal`: dividem por metros, paletes e km que
                       num transitário não significam nada. Ter aqui o que o modal
                       omite punha os dois a discordar sobre a mesma carga. */
      /* @__PURE__ */ React.createElement("span", { title: `${custo.volumes} volume(s) registado(s) nas paragens desta carga.
O total \xE9 a soma do valor de transporte de cada um.` + (custo.semValor > 0 ? `

${custo.semValor} volume(s) ainda sem valor: este total \xE9 um M\xCDNIMO, n\xE3o o valor.` : "") + "\n\nUm transit\xE1rio cobra \xE0 unidade enviada \u2014 n\xE3o h\xE1 aluguer, km nem paragens a somar." }, custo.total.toFixed(2).replace(".", ","), " \u20AC", /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", custo.volumes, " vol."), custo.semValor > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: `${custo.semValor} volume(s) sem valor de transporte registado \u2014 por isso este pre\xE7o est\xE1 INCOMPLETO (\xE9 um m\xEDnimo, n\xE3o o valor).` }, " ", "+", custo.semValor, " s/ valor"))
    ) : /* @__PURE__ */ React.createElement("span", { title: custo.zona ? L.parcelasDoCusto(custo, carga, L.tarifaDaCarga(carga, dados)).map((p) => `${p.label} ${eur(p.valor)}${p.nota ? ` \u2014 ${p.nota}` : ""}`).concat(L.parcelasOmitidas(custo, carga, L.tarifaDaCarga(carga, dados))).join("\n") : `Aluguer ${eur(custo.aluguer)}` + (custo.viagensPagas > 1 ? ` (\xF7 ${custo.viagensPagas} viagens do dia)` : "") + `
${custo.km} km \xD7 tarifa = ${eur(custo.custoKm)}
Combust\xEDvel ${eur(custo.combustivel)}` + (custo.paragensExtra > 0 ? `
${custo.paragensExtra} paragem(ns) al\xE9m das inclu\xEDdas = ${eur(custo.paragensCusto)}` : "") + (custo.regresso > 0 ? `
Regresso ${eur(custo.regresso)}` : "") + (custo.origem === "carga" ? "\n\nPre\xE7os pr\xF3prios desta carga (editados no Transporte)." : "\n\nPre\xE7os do cat\xE1logo de tarifas.") }, custo.total.toFixed(2).replace(".", ","), " \u20AC", racios && racios.pctValor != null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", String(racios.pctValor).replace(".", ","), " % da mercadoria"), racios && racios.porPalete != null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Custo por palete transportada" }, " ", "\xB7 ", racios.porPalete.toFixed(2).replace(".", ","), " \u20AC/pal."), racios && racios.porMetro != null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Custo por metro de cami\xE3o ocupado" }, " ", "\xB7 ", racios.porMetro.toFixed(2).replace(".", ","), " \u20AC/m"), racios && racios.porKm != null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Custo por quil\xF3metro faturado" }, " ", "\xB7 ", racios.porKm.toFixed(2).replace(".", ","), " \u20AC/km"), custo.semEntregas > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: `${custo.semEntregas} linha(s) cuja entrega n\xE3o est\xE1 carregada \u2014 as paragens delas n\xE3o entram na conta, por isso este pre\xE7o est\xE1 INCOMPLETO (\xE9 um m\xEDnimo, n\xE3o o valor).` }, " ", "+", custo.semEntregas, " s/ entrega"))),
    tempoPreparacao && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Prepara\xE7\xE3o prevista"), " ", tempoPreparacao.linhas === 0 ? "\u2014" : /* @__PURE__ */ React.createElement("span", { title: `${tempoPreparacao.paletes} palete(s) \xD7 ${tempoPreparacao.minutosPorPalete} min` + (tempoPreparacao.comMinimo > 0 ? `
${tempoPreparacao.comMinimo} de ${tempoPreparacao.linhas} linha(s) abaixo do m\xEDnimo levaram o m\xEDnimo de ${tempoPreparacao.minutosMinimosLinha} min/linha` : "") + "\n\nEstes minutos ajustam-se em Defini\xE7\xF5es \u2192 Turnos e armaz\xE9ns, \xE0 medida que os tempos reais das ondas o justificarem." }, L.duracao(tempoPreparacao.minutos), tempoPreparacao.comMinimo > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " ", "\xB7 ", tempoPreparacao.comMinimo, " no m\xEDnimo")))
  ), !validacao.ok && /* @__PURE__ */ React.createElement("ul", { className: "cp-problemas", "aria-label": "Problemas e avisos da carga" }, validacao.problemas.map((p, i) => /* @__PURE__ */ React.createElement("li", { key: i, className: p.nivel === "aviso" ? "is-aviso" : "is-erro" }, p.msg))), detalhe && /* @__PURE__ */ React.createElement(
    window.CpCargaModal,
    {
      camiao,
      carga,
      dados,
      percurso,
      ocupacao,
      validacao,
      custo,
      racios,
      motivoSemCusto,
      tempoPreparacao,
      onFechar: () => setDetalhe(false)
    }
  ));
}
function CpParagem({
  ponto,
  onDragStart,
  onDragOver,
  onDrop,
  alvo,
  onRemover,
  aberto,
  onAbrir,
  onRemoverLinha,
  onRemoverLinhas,
  onQtd,
  cargaId,
  pessoas,
  preparador,
  onPreparador,
  transitario,
  carga,
  onPacotes,
  janela,
  onJanela,
  onRemoverAmostra,
  metrosOcupados
}) {
  const L = window.CargoplannerLogica;
  const anexosLigados = window.HubFeatures ? window.HubFeatures.enabled("cargoplanner", "anexos") : true;
  const temVolumes = transitario || !!ponto.amostra;
  const pacotes = temVolumes ? L.pacotesDaParagem(carga, ponto) : [];
  const combinada = (carga && carga.janelas ? carga.janelas[ponto.id] : null) || {};
  const janelaCaixas = { inicio: combinada.inicio || "", fim: combinada.fim || "" };
  const totaisPacotes = temVolumes ? L.totaisDosPacotes(pacotes) : null;
  const eur = (v) => `${(Number(v) || 0).toFixed(2).replace(".", ",")} \u20AC`;
  const numOuNulo = (v) => {
    const limpo = String(v == null ? "" : v).trim().replace(",", ".");
    if (limpo === "") return null;
    const x = Number(limpo);
    return Number.isFinite(x) ? x : null;
  };
  const [rascunhos, setRascunhos] = React.useState({});
  const valorCampo = (i, campo, valorModelo) => {
    const chave = `${i}:${campo}`;
    return Object.prototype.hasOwnProperty.call(rascunhos, chave) ? rascunhos[chave] : valorModelo == null ? "" : String(valorModelo);
  };
  const limparRascunho = (i, campo) => {
    setRascunhos((prev) => {
      const chave = `${i}:${campo}`;
      if (!Object.prototype.hasOwnProperty.call(prev, chave)) return prev;
      const { [chave]: _omit, ...resto } = prev;
      return resto;
    });
  };
  const pacoteMudar = (i, campo, valor) => {
    onPacotes(ponto, (ps) => ps.map((p, idx) => idx === i ? { ...p, [campo]: valor } : p), true);
  };
  const pacoteEscrever = (i, campo, texto) => {
    setRascunhos((prev) => ({ ...prev, [`${i}:${campo}`]: texto }));
    const n = numOuNulo(texto);
    pacoteMudar(i, campo, campo === "quantidade" ? n == null ? 1 : Math.max(1, Math.round(n)) : n);
  };
  const pacoteTexto = (i, campo, texto) => {
    pacoteMudar(i, campo, texto);
  };
  const pacoteRemover = (i) => {
    onPacotes(ponto, (ps) => ps.filter((_, idx) => idx !== i));
    setRascunhos({});
  };
  const pacoteAdicionar = () => {
    onPacotes(ponto, (ps) => [...ps, {
      // **A pendura certa, UMA só** (cartão #112): numa amostra é a FK, num
      // cliente é o `cliente_phc`. Mandar as duas dá 400 no servidor, e é
      // assim que deve ser — uma chave dupla discorda de si própria.
      clientePhc: ponto.amostra ? "" : ponto.id,
      entregaManual: ponto.amostra ? ponto.entregaManualId : null,
      quantidade: 1,
      comprimentoCm: null,
      larguraCm: null,
      alturaCm: null,
      pesoKg: null,
      valorTransporte: null,
      valorMercadoria: null,
      observacoes: ""
    }]);
  };
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      className: `cp-paragem ${alvo ? "is-alvo" : ""}`,
      draggable: true,
      onDragStart,
      onDragOver,
      onDrop,
      title: "Arrasta para mudar a ordem de entrega"
    },
    /* @__PURE__ */ React.createElement("span", { className: "cp-pin", style: { background: ponto.cor } }, ponto.ordem),
    /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__corpo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__linha1" }, /* @__PURE__ */ React.createElement("span", { className: "cp-paragem__nome", style: { color: ponto.cor } }, ponto.nome, " \u2014 ", ponto.local), ponto.amostra && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-amostra-marca",
        title: "Entrega declarada \xE0 m\xE3o, sem encomenda lan\xE7ada. N\xE3o tem artigos nem hor\xE1rio de descarga do ERP; o que leva s\xE3o os volumes registados aqui, e s\xE3o as medidas deles que d\xE3o os metros que ocupa."
      },
      "amostra"
    ), /* @__PURE__ */ React.createElement("span", { className: "cp-paragem__paletes" }, ponto.paletes, " paletes")), /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__morada" }, ponto.morada, ponto.cp ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("br", null), ponto.cp) : null, ponto.precisao && ponto.precisao !== "address" && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-precisao",
        title: `O Mapbox s\xF3 localizou esta morada ao n\xEDvel "${ponto.precisao}" \u2014 o ponto \xE9 aproximado.`
      },
      window.CP_PRECISAO[ponto.precisao] || ponto.precisao,
      " aprox."
    )), !transitario && /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__nums" }, /* @__PURE__ */ React.createElement("span", { title: "Hora prevista de chegada" }, L.min2hhmm(ponto.hora)), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, ponto.km, " km \xB7 ", L.duracao(ponto.min), " desde a paragem anterior")), onJanela && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "cp-paragem__janela",
        onClick: (e) => e.stopPropagation(),
        onDragStart: (e) => e.stopPropagation(),
        draggable: false
      },
      /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "Chegada"),
      /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "cp-select cp-janela__h",
          type: "time",
          "aria-label": "In\xEDcio da janela de chegada",
          value: janelaCaixas.inicio,
          onChange: (e) => onJanela(ponto.id, { inicio: e.target.value, fim: janelaCaixas.fim })
        }
      ),
      /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2013"),
      /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "cp-select cp-janela__h",
          type: "time",
          "aria-label": "Fim da janela de chegada",
          value: janelaCaixas.fim,
          onChange: (e) => onJanela(ponto.id, { inicio: janelaCaixas.inicio, fim: e.target.value })
        }
      ),
      janela ? /* @__PURE__ */ React.createElement(
        "span",
        {
          className: `cp-janela__origem is-${janela.origem}`,
          title: janela.origem !== "combinada" ? `Calculada pelo percurso (${L.textoDaJanela(janela)}). Escreve uma janela para a fixar.` : transitario ? `Chegada combinada (${L.textoDaJanela(janela)}) \u2014 escrita por quem planeia. Num transit\xE1rio \xE9 a \xFAnica hora que se pode afirmar.` : `Chegada combinada (${L.textoDaJanela(janela)}) \u2014 escrita por quem planeia, e ganha \xE0 hora calculada pela rota.`
        },
        janela.origem
      ) : /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "cp-janela__origem is-sem",
          title: "Sem rota e sem janela escrita: n\xE3o se sabe a que horas chega."
        },
        "sem previs\xE3o"
      )
    ), onPreparador && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "cp-paragem__prep",
        onClick: (e) => e.stopPropagation(),
        onDragStart: (e) => e.stopPropagation(),
        draggable: false
      },
      /* @__PURE__ */ React.createElement(
        CpPreparadorEscolha,
        {
          pessoas,
          valor: preparador && preparador.pessoaId,
          nomeSolto: preparador && preparador.foraDaEscala,
          rotulo: "Prepara",
          titulo: preparador && preparador.deOnda ? `Quem prepara esta paragem \u2014 reatribui a ${preparador.codigo}.` : "Quem vai preparar esta paragem. A onda deste cliente nasce j\xE1 atribu\xEDda a esta pessoa quando a carga for planeada.",
          onMudar: (v2) => onPreparador(ponto.id, v2)
        }
      ),
      preparador && preparador.deOnda && /* @__PURE__ */ React.createElement("span", { className: "cp-dim cp-paragem__onda" }, preparador.codigo)
    )),
    !ponto.amostra && /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm cp-paragem__abrir",
        title: aberto ? "Fechar os produtos" : "Ver os produtos desta paragem",
        onClick: (e) => {
          e.stopPropagation();
          onAbrir(!aberto);
        }
      },
      /* @__PURE__ */ React.createElement(window.Ico.chevron, { style: { transform: aberto ? "none" : "rotate(-90deg)" } })
    ),
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm cp-paragem__x",
        title: ponto.amostra ? "Retirar esta amostra da carga" : "Retirar este cliente da carga",
        onClick: (e) => {
          e.stopPropagation();
          if (ponto.amostra) onRemoverAmostra?.(ponto.indiceAmostra);
          else onRemover(ponto.id);
        }
      },
      /* @__PURE__ */ React.createElement(window.Ico.close, null)
    ),
    cargaId && anexosLigados && // `stopPropagation` no wrapper, não no botão: o Popover já põe o
    // próprio `onClick` (que abre/fecha) num `<span>` à volta do
    // `trigger` — pôr `stopPropagation` no botão impedia esse `onClick`
    // de chegar lá, porque também é ele o alvo do clique. À volta de
    // tudo, o wrapper só trava a subida ao `<li>` arrastável depois de o
    // Popover já ter aberto.
    /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, React.createElement(window.Popover, {
      align: "left",
      trigger: /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost icon-only sm cp-paragem__docs",
          title: "CMR desta paragem"
        },
        /* @__PURE__ */ React.createElement(window.Ico.doc, null)
      )
    }, /* @__PURE__ */ React.createElement("div", { className: "cp-cli-pop__docs" }, /* @__PURE__ */ React.createElement("div", { className: "cp-cli-pop__docs-h" }, "CMR desta paragem"), /* @__PURE__ */ React.createElement(
      window.AnexosPanel,
      {
        app: "cargoplanner",
        resource: "paragem",
        id: `${cargaId}:${ponto.id}`
      }
    )))),
    aberto && /* @__PURE__ */ React.createElement("ul", { className: "cp-paragem__linhas" }, L.artigosPorKit(ponto.artigos || []).filter((x) => x.tipo === "kit").map((k) => /* @__PURE__ */ React.createElement("li", { key: k.kitBistamp, className: "cp-kit-carga" }, /* @__PURE__ */ React.createElement("span", { className: "cp-kit-carga__topo" }, /* @__PURE__ */ React.createElement("span", { className: "td-mono cp-pl-ref" }, k.kitRef || "kit"), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-tag cp-tag--kit",
        title: `Kit com ${k.componentes.length} componente(s). O artigo do kit \xE9 virtual no ERP: o que vai no cami\xE3o s\xE3o os componentes, e \xE9 deles que saem as paletes e os metros.`
      },
      "KIT"
    ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, k.kits == null ? "kits por apurar" : `${k.kits.toLocaleString("pt-PT")} kit(s)`), k.foraDeProporcao && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-marca-noutro-dia",
        title: "As quantidades na carga n\xE3o fazem kits inteiros: h\xE1 componentes a mais do que os kits completos pedem. Quem confere a guia tem de o saber \u2014 a propor\xE7\xE3o valida-se no picking."
      },
      "fora de propor\xE7\xE3o"
    ), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-carrinho__pal",
        title: k.semPaletes ? `${k.semPaletes} componente(s) sem quantidade por palete no ERP (st.u_qtcxpl) \u2014 a soma est\xE1 incompleta.` : void 0
      },
      k.paletes || !k.semPaletes ? `${k.paletes} pal.` : "\u2014 pal.",
      k.semPaletes > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " +", k.semPaletes, "?")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        title: "Retirar o kit inteiro da carga",
        onClick: (ev) => {
          ev.stopPropagation();
          if (onRemoverLinhas) onRemoverLinhas(L.linhasDoKit(k));
          else L.linhasDoKit(k).forEach((id) => onRemoverLinha(id));
        }
      },
      /* @__PURE__ */ React.createElement(window.Ico.close, null)
    )), /* @__PURE__ */ React.createElement("ul", { className: "cp-kit-carga__comps" }, k.componentes.map((a) => /* @__PURE__ */ React.createElement("li", { key: a.entrega.id }, /* @__PURE__ */ React.createElement("span", { className: "td-mono cp-pl-ref" }, a.entrega.ref), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-kit__razao",
        title: `${a.entrega.kitRazao} por cada kit`
      },
      "\xD7",
      a.entrega.kitRazao == null ? "?" : a.entrega.kitRazao
    ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim cp-pl-desc", title: a.entrega.descricao }, a.entrega.descricao), /* @__PURE__ */ React.createElement("span", { className: "cp-pl-ctrl" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-qtd",
        type: "number",
        min: "0",
        step: "1",
        value: a.qtd,
        "aria-label": `Quantidade de ${a.entrega.ref}`,
        onClick: (ev) => ev.stopPropagation(),
        onChange: (ev) => onQtd(a.entrega.id, Number(ev.target.value))
      }
    ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "un."), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: `cp-qtd-stock${(a.entrega.qtdDisponivel || 0) >= a.qtd ? " is-ok" : ""}`,
        title: `${(a.entrega.qtdDisponivel || 0).toLocaleString("pt-PT")} em stock, ${a.qtd.toLocaleString("pt-PT")} nesta carga`
      },
      (a.entrega.qtdDisponivel || 0).toLocaleString("pt-PT"),
      " stk"
    ), /* @__PURE__ */ React.createElement("span", { className: "cp-carrinho__pal" }, a.paletes ? `${a.paletes} pal.` : "\u2014 pal."))))))), (ponto.artigos || []).filter((a) => !(a.entrega && a.entrega.kitBistamp)).map((a) => /* @__PURE__ */ React.createElement(
      "li",
      {
        key: a.entrega.id,
        draggable: true,
        onDragStart: (ev) => {
          ev.stopPropagation();
          window.CpDnd.escrever(ev, { k: "linha", entregaId: a.entrega.id });
        },
        title: "Arrasta para as entregas para retirar"
      },
      /* @__PURE__ */ React.createElement("span", { className: "td-mono cp-pl-ref" }, a.entrega.ref),
      /* @__PURE__ */ React.createElement("span", { className: "cp-dim cp-pl-desc", title: a.entrega.descricao }, a.entrega.descricao),
      /* @__PURE__ */ React.createElement("span", { className: "cp-pl-ctrl" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "cp-qtd",
          type: "number",
          min: "0",
          step: "1",
          value: a.qtd,
          "aria-label": `Quantidade de ${a.entrega.ref}`,
          onClick: (ev) => ev.stopPropagation(),
          onChange: (ev) => onQtd(a.entrega.id, Number(ev.target.value))
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "un."), /* @__PURE__ */ React.createElement(
        "span",
        {
          className: `cp-qtd-stock${(a.entrega.qtdDisponivel || 0) >= a.qtd ? " is-ok" : ""}`,
          title: `${(a.entrega.qtdDisponivel || 0).toLocaleString("pt-PT")} em stock, ${a.qtd.toLocaleString("pt-PT")} nesta carga`
        },
        (a.entrega.qtdDisponivel || 0).toLocaleString("pt-PT"),
        " stk"
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-carrinho__pal" }, a.paletes ? `${a.paletes} pal.` : "\u2014 pal."), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost icon-only sm",
          title: "Retirar da carga",
          onClick: (ev) => {
            ev.stopPropagation();
            onRemoverLinha(a.entrega.id);
          }
        },
        /* @__PURE__ */ React.createElement(window.Ico.close, null)
      ))
    ))),
    temVolumes && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "cp-paragem__pacotes",
        onClick: (e) => e.stopPropagation(),
        onDragStart: (e) => e.stopPropagation(),
        draggable: false
      },
      /* @__PURE__ */ React.createElement("span", { className: "cp-dim cp-paragem__pacotes-resumo" }, totaisPacotes.volumes, " volume(s) \xB7 ", totaisPacotes.pesoKg.toLocaleString("pt-PT"), " kg", totaisPacotes.semPeso > 0 && ` (+${totaisPacotes.semPeso} s/ peso)`, transitario && /* @__PURE__ */ React.createElement(React.Fragment, null, " \xB7 ", eur(totaisPacotes.valor), totaisPacotes.semValor > 0 && ` (+${totaisPacotes.semValor} sem valor)`), !transitario && metrosOcupados != null && /* @__PURE__ */ React.createElement("span", { title: "Calculado pelas medidas dos volumes, pela mesma conta de filas das paletes. \xC9 um M\xCDNIMO GEOM\xC9TRICO: a largura do cami\xE3o divide-se pela do volume, e ningu\xE9m garante que se consiga encostar tantos lado a lado." }, " \xB7 ", Number(metrosOcupados).toFixed(2).replace(".", ","), " m", " ", /* @__PURE__ */ React.createElement("i", null, "(m\xEDnimo geom\xE9trico)"))),
      /* @__PURE__ */ React.createElement("ul", { className: "cp-pacotes-lista" }, pacotes.map((p, i) => /* @__PURE__ */ React.createElement("li", { key: i, className: "cp-pacote" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          inputMode: "decimal",
          className: "cp-pacote__qtd",
          "aria-label": "Quantidade de volumes",
          value: valorCampo(i, "quantidade", p.quantidade),
          onChange: (ev) => pacoteEscrever(i, "quantidade", ev.target.value),
          onBlur: () => limparRascunho(i, "quantidade")
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\xD7"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          inputMode: "decimal",
          className: "cp-pacote__dim",
          "aria-label": "Comprimento (cm)",
          placeholder: "compr.",
          value: valorCampo(i, "comprimentoCm", p.comprimentoCm),
          onChange: (ev) => pacoteEscrever(i, "comprimentoCm", ev.target.value),
          onBlur: () => limparRascunho(i, "comprimentoCm")
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\xD7"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          inputMode: "decimal",
          className: "cp-pacote__dim",
          "aria-label": "Largura (cm)",
          placeholder: "larg.",
          value: valorCampo(i, "larguraCm", p.larguraCm),
          onChange: (ev) => pacoteEscrever(i, "larguraCm", ev.target.value),
          onBlur: () => limparRascunho(i, "larguraCm")
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\xD7"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          inputMode: "decimal",
          className: "cp-pacote__dim",
          "aria-label": "Altura (cm)",
          placeholder: "alt.",
          value: valorCampo(i, "alturaCm", p.alturaCm),
          onChange: (ev) => pacoteEscrever(i, "alturaCm", ev.target.value),
          onBlur: () => limparRascunho(i, "alturaCm")
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "cm"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          inputMode: "decimal",
          className: "cp-pacote__dim",
          "aria-label": "Peso (kg)",
          placeholder: "peso",
          value: valorCampo(i, "pesoKg", p.pesoKg),
          onChange: (ev) => pacoteEscrever(i, "pesoKg", ev.target.value),
          onBlur: () => limparRascunho(i, "pesoKg")
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "kg"), transitario && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          inputMode: "decimal",
          className: "cp-pacote__valor",
          "aria-label": "Valor de transporte (\u20AC)",
          placeholder: "0,00",
          value: valorCampo(i, "valorTransporte", p.valorTransporte),
          onChange: (ev) => pacoteEscrever(i, "valorTransporte", ev.target.value),
          onBlur: () => limparRascunho(i, "valorTransporte")
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u20AC")), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost icon-only sm",
          title: "Remover este volume",
          onClick: () => pacoteRemover(i)
        },
        /* @__PURE__ */ React.createElement(window.Ico.close, null)
      ), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "cp-pacote__obs",
          "aria-label": "Descri\xE7\xE3o do volume",
          placeholder: "descri\xE7\xE3o (ex. caixa de amostras, rolo embalado)",
          maxLength: 200,
          value: p.observacoes || "",
          onChange: (ev) => pacoteTexto(i, "observacoes", ev.target.value)
        }
      )))),
      /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: pacoteAdicionar }, /* @__PURE__ */ React.createElement(window.Ico.plus, null), " Volume"),
      !transitario && /* @__PURE__ */ React.createElement("span", { className: "cp-dim cp-pacotes-nota" }, "As medidas d\xE3o os metros que isto ocupa no cami\xE3o. Sem valor de transporte: o pre\xE7o desta carga vem da tarifa do cami\xE3o, n\xE3o do volume.")
    )
  );
}
function CpPontoUnidade({ ponto, tipo, unidades, valor, onMudar, podeLimpar }) {
  const L = window.CargoplannerLogica;
  return /* @__PURE__ */ React.createElement("li", { className: `cp-unidade cp-unidade--${tipo}` }, /* @__PURE__ */ React.createElement("span", { className: "cp-pin cp-pin--unidade" }, tipo === "origem" ? "O" : "R"), /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__corpo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__linha1" }, /* @__PURE__ */ React.createElement("span", { className: "cp-unidade__label" }, tipo === "origem" ? "Origem" : "Regresso"), ponto && ponto.km ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, ponto.km, " km") : null), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "cp-select",
      value: valor || "",
      onChange: (e) => onMudar(e.target.value || null),
      "aria-label": tipo === "origem" ? "Unidade de origem" : "Unidade de regresso"
    },
    podeLimpar && /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem regresso \u2014"),
    unidades.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.nome, " \u2014 ", u.local))
  ), ponto && ponto.hora != null && /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__nums" }, /* @__PURE__ */ React.createElement("span", null, L.min2hhmm(ponto.hora)))));
}
function CpRecolha({ ponto, alvo, onDragStart, onDragOver, onDrop, onRemover, transitario }) {
  const L = window.CargoplannerLogica;
  const r = ponto.recolha || {};
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      className: `cp-paragem cp-recolha ${alvo ? "is-alvo" : ""}`,
      draggable: true,
      onDragStart,
      onDragOver,
      onDrop,
      title: "Arrasta para mudar a ordem das recolhas"
    },
    /* @__PURE__ */ React.createElement("span", { className: "cp-pin cp-pin--recolha", style: { background: ponto.cor }, title: "Recolha" }, /* @__PURE__ */ React.createElement(window.Ico.download, null)),
    /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__corpo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__linha1" }, /* @__PURE__ */ React.createElement("span", { className: "cp-paragem__nome", style: { color: ponto.cor } }, ponto.nome), /* @__PURE__ */ React.createElement("span", { className: "cp-tag", title: `Recolha \u2014 ${r.tipo === "unidade" ? "unidade do grupo" : r.tipo === "cliente" ? "cliente" : "morada escrita \xE0 m\xE3o"}` }, "recolha")), /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__morada" }, [ponto.morada, ponto.local].filter(Boolean).join(" \xB7 ") || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Sem morada")), ponto.motivo && /* @__PURE__ */ React.createElement("div", { className: "cp-recolha__motivo" }, ponto.motivo), !transitario && /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__nums" }, /* @__PURE__ */ React.createElement("span", { title: "Hora prevista de chegada" }, L.min2hhmm(ponto.hora)), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, ponto.km, " km \xB7 ", L.duracao(ponto.min), " desde a paragem anterior"))),
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm cp-paragem__x",
        title: "Retirar esta recolha",
        onClick: (e) => {
          e.stopPropagation();
          onRemover();
        }
      },
      /* @__PURE__ */ React.createElement(window.Ico.close, null)
    )
  );
}
function CpRecolhasSemPonto({ recolhas, onRemover }) {
  if (!recolhas.length) return null;
  return /* @__PURE__ */ React.createElement("ul", { className: "cp-percurso cp-recolhas-orfas" }, recolhas.map((r, i) => /* @__PURE__ */ React.createElement("li", { key: r.id != null ? r.id : `s${i}`, className: "cp-paragem cp-recolha" }, /* @__PURE__ */ React.createElement("span", { className: "cp-pin cp-pin--recolha is-sem-ponto", title: "Sem coordenadas" }, "?"), /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__corpo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__linha1" }, /* @__PURE__ */ React.createElement("span", { className: "cp-paragem__nome" }, r.nome), /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--aviso", title: "Sem coordenadas \u2014 n\xE3o entra no percurso nem no mapa" }, "sem ponto")), /* @__PURE__ */ React.createElement("div", { className: "cp-paragem__morada" }, [r.morada, r.local].filter(Boolean).join(" \xB7 ") || "\u2014"), r.motivo && /* @__PURE__ */ React.createElement("div", { className: "cp-recolha__motivo" }, r.motivo)), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm cp-paragem__x",
      title: "Retirar esta recolha",
      onClick: () => onRemover(r)
    },
    /* @__PURE__ */ React.createElement(window.Ico.close, null)
  ))));
}
function CpDocumentosDaCarga({ carga }) {
  const [aberto, setAberto] = React.useState(false);
  const ligada = window.HubFeatures ? window.HubFeatures.enabled("cargoplanner", "anexos") : true;
  const id = carga && carga.servidorId;
  if (!ligada || !id) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "cp-docs" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: () => setAberto((a) => !a),
      "aria-expanded": aberto
    },
    aberto ? "\u25BE" : "\u25B8",
    " Documentos (CMR)"
  ), aberto && /* @__PURE__ */ React.createElement(
    window.AnexosPanel,
    {
      app: "cargoplanner",
      resource: "carga",
      id: String(id)
    }
  ));
}
function CpDetalheCarga({
  carga,
  dados,
  percurso,
  rota,
  cargasNoMapa,
  onReordenar,
  onOrigem,
  onRegresso,
  onAlternarRegresso,
  onRemoverCliente,
  onAdicionar,
  onRemoverLinha,
  onRemoverLinhas,
  onQtd,
  onNovaRecolha,
  onRemoverRecolha,
  onReordenarRecolhas,
  onNovaAmostra,
  onRemoverAmostra,
  pessoas,
  preparadorDaParagem,
  onPreparadorParagem,
  onPacotes,
  onJanela,
  ocupacao
}) {
  const [alvo, setAlvo] = React.useState(null);
  const [abertos, setAbertos] = React.useState(() => /* @__PURE__ */ new Set());
  const [sobreZona, setSobreZona] = React.useState(false);
  const [tudo, setTudo] = React.useState(true);
  const paragens = percurso.pontos.filter((p) => p.tipo === "paragem");
  const recolhas = percurso.pontos.filter((p) => p.tipo === "recolha");
  const [alvoRec, setAlvoRec] = React.useState(null);
  const L2 = window.CargoplannerLogica;
  const semPonto = L2.recolhasOrdenadas(carga).filter((r) => r.lat == null || r.lng == null);
  const origem = percurso.pontos.find((p) => p.tipo === "origem");
  const regresso = percurso.pontos.find((p) => p.tipo === "regresso");
  const L = window.CargoplannerLogica;
  const transitario = L.ehTransitario(L.camiaoDaCarga(carga, dados));
  const metrosPorParagem = React.useMemo(
    () => new Map(
      (ocupacao && ocupacao.segmentos || []).map((s) => [s.clienteId, s.metros])
    ),
    [ocupacao]
  );
  const largar = (idx) => L.largarNaParagem({
    ler: cpLerPayload,
    idx,
    paragens,
    onAdicionar,
    onReordenar,
    onAlvo: setAlvo,
    onSobreZona: setSobreZona
  });
  const largarNaZona = L.largarNaZonaDaCarga({
    ler: cpLerPayload,
    onAdicionar,
    onSobreZona: setSobreZona
  });
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: `panel cp-zona cp-zona--carga ${sobreZona ? "is-sobre" : ""}`,
      "aria-label": "Detalhe da carga",
      onDragOver: (ev) => {
        ev.preventDefault();
        setSobreZona(true);
      },
      onDragLeave: () => setSobreZona(false),
      onDrop: largarNaZona
    },
    /* @__PURE__ */ React.createElement("div", { className: "panel-h cp-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Detalhe da Carga"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, paragens.length, " paragem(ns)", recolhas.length + semPonto.length > 0 && ` \xB7 ${recolhas.length + semPonto.length} recolha(s)`), /* @__PURE__ */ React.createElement("div", { className: "cp-zona__h-fim" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        onClick: onNovaRecolha,
        title: "Uma paragem para apanhar alguma coisa no regresso"
      },
      /* @__PURE__ */ React.createElement(window.Ico.plus, null),
      " Recolha"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        onClick: onNovaAmostra,
        title: "Uma entrega sem encomenda lan\xE7ada \u2014 uma amostra"
      },
      /* @__PURE__ */ React.createElement(window.Ico.plus, null),
      " Amostra"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: `btn ghost sm${carga && carga.regressoFaturado ? " is-ativo" : ""}`,
        title: carga && carga.regressoFaturado ? "Os km e o custo do regresso EST\xC3O a contar. Clica para os tirar." : "Contar os km da volta a casa e o custo fixo de regresso da tarifa",
        onClick: onAlternarRegresso
      },
      carga && carga.regressoFaturado ? "\u2713 Custos de regresso" : "\uFF0B Custos de regresso"
    ))),
    /* @__PURE__ */ React.createElement("div", { className: "cp-zona__fixo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-mapa-topo" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: `chip ${tudo ? "chip-on" : ""}`,
        onClick: () => setTudo((t) => !t),
        title: "Enquadrar todas as cargas do dia ou s\xF3 esta"
      },
      tudo ? "Dia todo" : "S\xF3 esta carga"
    ), /* @__PURE__ */ React.createElement("div", { className: "cp-mapa-legenda" }, (cargasNoMapa || []).map((c) => /* @__PURE__ */ React.createElement(
      "span",
      {
        key: c.cargaId,
        className: `cp-mapa-legenda__item ${c.selecionada ? "is-sel" : ""}`,
        title: c.rota ? `${c.camiaoId} \u2014 ${c.rota.kmTotal} km` : c.camiaoId
      },
      /* @__PURE__ */ React.createElement("span", { className: "cp-mapa-legenda__traco", style: { background: c.cor } }),
      c.camiaoId
    )))), /* @__PURE__ */ React.createElement(
      window.CpMapa,
      {
        percurso,
        rota: rota.rota,
        cargas: cargasNoMapa,
        enquadrarTudo: tudo
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: "cp-zona__body" }, /* @__PURE__ */ React.createElement("ol", { className: "cp-percurso" }, /* @__PURE__ */ React.createElement(
      CpPontoUnidade,
      {
        ponto: origem,
        tipo: "origem",
        unidades: dados.unidades,
        valor: carga && carga.origemId,
        onMudar: onOrigem,
        podeLimpar: false
      }
    ), paragens.map((p, i) => /* @__PURE__ */ React.createElement(
      CpParagem,
      {
        key: p.id,
        ponto: p,
        alvo: alvo === i,
        onDragStart: (ev) => cpEscreverPayload(ev, {
          k: "paragem",
          clienteId: p.id,
          camiaoId: carga && carga.camiaoId
        }),
        onDragOver: (ev) => {
          ev.preventDefault();
          setAlvo(i);
        },
        onDrop: largar(i),
        onRemover: onRemoverCliente,
        aberto: abertos.has(p.id),
        onAbrir: (abrir) => setAbertos((s2) => {
          const n = new Set(s2);
          if (abrir) n.add(p.id);
          else n.delete(p.id);
          return n;
        }),
        onRemoverLinha,
        onRemoverLinhas,
        onQtd,
        cargaId: carga && carga.servidorId,
        pessoas,
        preparador: preparadorDaParagem && preparadorDaParagem(p.id),
        onPreparador: onPreparadorParagem,
        transitario,
        carga,
        onPacotes,
        onRemoverAmostra,
        metrosOcupados: metrosPorParagem.has(p.id) ? metrosPorParagem.get(p.id) : null,
        janela: (
          // **Num transitário o ponto NÃO entra**: a hora do percurso é um
          // número nosso sobre uma rota que não é nossa, e esta app gateia
          // tudo o que vem da rota pela MARCA, nunca pelo valor (o `hora`
          // continua a ser calculado, e não significa nada aqui). Sem ele
          // só a combinada pode aparecer — a única hora que a app pode
          // afirmar num transitário — e, sem ela, «sem previsão».
          L.janelaDaParagem(carga, p.id, transitario ? null : p)
        ),
        onJanela
      }
    )), !paragens.length && /* @__PURE__ */ React.createElement("li", { className: "cp-vazio" }, "Sem paragens. Arrasta entregas para a carga."), recolhas.map((p, i) => /* @__PURE__ */ React.createElement(
      CpRecolha,
      {
        key: p.id,
        ponto: p,
        alvo: alvoRec === i,
        onDragStart: (ev) => cpEscreverPayload(ev, { k: "recolha", indice: i }),
        onDragOver: (ev) => {
          ev.preventDefault();
          setAlvoRec(i);
        },
        onDrop: (ev) => {
          ev.preventDefault();
          setAlvoRec(null);
          const carga2 = cpLerPayload(ev);
          if (carga2 && carga2.k === "recolha" && carga2.indice !== i) {
            onReordenarRecolhas(carga2.indice, i);
          }
        },
        onRemover: () => onRemoverRecolha(p.recolha),
        transitario
      }
    )), /* @__PURE__ */ React.createElement(
      CpPontoUnidade,
      {
        ponto: regresso,
        tipo: "regresso",
        unidades: dados.unidades,
        valor: carga && carga.regressoId,
        onMudar: onRegresso,
        podeLimpar: true
      }
    )), /* @__PURE__ */ React.createElement(CpRecolhasSemPonto, { recolhas: semPonto, onRemover: onRemoverRecolha }), transitario ? /* @__PURE__ */ React.createElement("div", { className: "cp-percurso__totais" }, /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "Transit\xE1rio \u2014 paga-se ao volume enviado, sem rota nem km a calcular")) : /* @__PURE__ */ React.createElement("div", { className: "cp-percurso__totais" }, /* @__PURE__ */ React.createElement("span", null, "Dist\xE2ncia total: ", /* @__PURE__ */ React.createElement("b", null, percurso.kmTotal == null ? "\u2014" : `${percurso.kmTotal} km`)), /* @__PURE__ */ React.createElement("span", null, "Tempo estimado: ", /* @__PURE__ */ React.createElement("b", null, percurso.minTotal == null ? "\u2014" : L.duracao(percurso.minTotal))), /* @__PURE__ */ React.createElement("span", { className: "cp-rota-fonte", title: rota.erro || void 0 }, rota.estado === "ok" ? `rota por estrada (${(rota.rota && rota.rota.fornecedor) === "mapbox" ? "Mapbox" : "OSRM"})` : rota.estado === "a_carregar" ? "a calcular a rota\u2026" : rota.estado === "falhou" ? "estimativa \u2014 rota indispon\xEDvel" : "estimativa")), percurso.semCoords && percurso.semCoords.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "cp-nota-paletes" }, percurso.semCoords.length, " paragem(ns) sem coordenadas \u2014 o ERP d\xE1 a morada em texto e mais nada. Sem geocodifica\xE7\xE3o n\xE3o h\xE1 percurso nem dist\xE2ncia, e \xE9 por isso que aparecem a \xAB\u2014\xBB em vez de um n\xFAmero inventado: ", percurso.semCoords.map((p) => p.nome).join(", "), ".")),
    /* @__PURE__ */ React.createElement(CpDocumentosDaCarga, { carga })
  );
}
window.CpRecolha = CpRecolha;
window.CpEstadoFluxo = CpEstadoFluxo;
window.CpMoverModal = CpMoverModal;
window.CpUrgenciaModal = CpUrgenciaModal;
window.CpTransporteModal = CpTransporteModal;
window.CpCabecalhoCarga = CpCabecalhoCarga;
window.CpDetalheCarga = CpDetalheCarga;
window.CpDnd = { ler: cpLerPayload, escrever: cpEscreverPayload, TIPO: CP_DND };
function CpLinhaDetalhe({ label, children, nota }) {
  return /* @__PURE__ */ React.createElement("div", { className: "cp-det__linha" }, /* @__PURE__ */ React.createElement("span", { className: "cp-det__label" }, label), /* @__PURE__ */ React.createElement("span", { className: "cp-det__valor" }, children), nota && /* @__PURE__ */ React.createElement("span", { className: "cp-det__nota" }, nota));
}
function CpSeccaoDetalhe({ titulo, children, vazio }) {
  return /* @__PURE__ */ React.createElement("section", { className: "cp-det__seccao" }, /* @__PURE__ */ React.createElement("h4", { className: "cp-det__titulo" }, titulo), vazio ? /* @__PURE__ */ React.createElement("p", { className: "cp-det__vazio" }, vazio) : children);
}
function CpPreparadaModal({
  camiao,
  efetivado,
  onConfirmar,
  onFechar,
  phc,
  onPhc
}) {
  const n = (v) => v == null ? "\u2014" : Number(v).toLocaleString("pt-PT");
  const MOTIVOS = {
    sem_tarefa: "sem tarefa na onda",
    sem_registo: "sem lotes picados",
    sem_qtd: "lote sem quantidade"
  };
  const ajusta = (efetivado.ajustaveis || []).length;
  const porSaber = efetivado.semRegisto + efetivado.semTarefa + efetivado.semQtd;
  const comSobra = (efetivado.kits || []).filter((k) => k.sobras && k.sobras.length);
  const num = (v) => {
    const limpo = String(v == null ? "" : v).trim().replace(",", ".");
    if (limpo === "") return null;
    const x = Number(limpo);
    return Number.isFinite(x) ? x : null;
  };
  const valor = num(phc.valorTransporte);
  const semFornecedor = !phc.fornecedorNo;
  const pode = valor != null && !semFornecedor;
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: `Prepara\xE7\xE3o da carga \u2014 ${camiao ? camiao.id : "\u2014"}`,
      subtitle: "O que se pediu, e o que o operador picou.",
      width: 760,
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          onClick: onConfirmar,
          disabled: !phc.enviadaEm && !pode,
          title: phc.enviadaEm ? "" : semFornecedor ? "A transportadora n\xE3o est\xE1 ligada a um fornecedor do PHC" : valor == null ? "Indica o pre\xE7o do transporte" : ""
        },
        phc.enviadaEm ? "Confirmar prepara\xE7\xE3o" : ajusta ? `Confirmar, corrigir ${ajusta} linha(s) e criar no PHC` : "Confirmar e criar no PHC"
      ))
    },
    /* @__PURE__ */ React.createElement("div", { className: "cp-det" }, /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Total" }, /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Planeado" }, n(efetivado.totalPlaneado), " un."), /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Efetivado" }, n(efetivado.totalPicado), " un."), porSaber > 0 && /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Por apurar" }, porSaber, " linha(s) sem registo de picking \u2014 ficam pelo planeado")), /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: `Linhas (${efetivado.linhas.length})` }, efetivado.linhas.map((l, i) => /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { key: `${l.bistamp}-${i}`, label: l.artigo }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, n(l.planeado)), " \u2192 ", /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, n(l.picado)), l.motivo ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", MOTIVOS[l.motivo] || l.motivo) : l.picado === l.planeado ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 certo") : /* @__PURE__ */ React.createElement("span", { className: "cp-alerta" }, " \xB7 ", l.picado > l.planeado ? `${n(l.picado - l.planeado)} a mais` : `faltam ${n(l.planeado - l.picado)}`)))), comSobra.length > 0 && /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: `Kits fora de propor\xE7\xE3o (${comSobra.length})` }, comSobra.map((k, i) => /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { key: `k-${k.kitBistamp}-${i}`, label: k.kitRef }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, n(k.kitsPicados)), " kit(s) inteiros", k.sobras.map((s) => /* @__PURE__ */ React.createElement("span", { key: s.bistamp, className: "cp-alerta" }, " \xB7 ", n(s.sobra), " de ", s.artigo, " que n\xE3o formaram kit")))), /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Ao confirmar" }, "a sobra sai da carga e volta \xE0s entregas por atribuir \u2014 o kit s\xF3 se expede inteiro, e na propor\xE7\xE3o certa.")), efetivado.foraDaCarga.length > 0 && /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Picado, mas j\xE1 n\xE3o est\xE1 na carga" }, efetivado.foraDaCarga.map((l, i) => /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { key: `f-${i}`, label: l.artigo }, n(l.picado), " un. em ", l.paletes, " palete(s)"))), /* @__PURE__ */ React.createElement("p", { className: "cp-dim" }, ajusta ? comSobra.length ? "As linhas com diferen\xE7a passam ao que de facto vai: a quantidade picada numa linha normal, e os kits inteiros num componente de kit. O resto volta \xE0s entregas por atribuir, e o planeado fica registado nesta carga." : "As linhas com diferen\xE7a passam \xE0 quantidade picada; o que faltou volta \xE0s entregas por atribuir. O planeado fica registado nesta carga." : "Nada a corrigir \u2014 o retrato do planeado fica registado nesta carga."), /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Criar a carga no PHC" }, phc.enviadaEm ? /* @__PURE__ */ React.createElement("p", { className: "cp-dim" }, "J\xE1 foi criada no PHC em ", String(phc.enviadaEm).slice(0, 16).replace("T", " "), ". Confirmar aqui s\xF3 fecha a prepara\xE7\xE3o \u2014 n\xE3o envia outra vez.") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Transportadora" }, phc.fornecedorNome || phc.transportadoraNome || "\u2014", semFornecedor ? /* @__PURE__ */ React.createElement("span", { className: "cp-alerta" }, " \xB7 sem fornecedor do PHC \u2014 liga-a em Defini\xE7\xF5es") : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 #", phc.fornecedorNo)), /* @__PURE__ */ React.createElement("label", { className: "cp-phc-campo" }, "Pre\xE7o do transporte", /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        inputMode: "decimal",
        value: phc.valorTransporte || "",
        placeholder: "0,00",
        onChange: (e) => onPhc({ valorTransporte: e.target.value })
      }
    ), phc.previsto != null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "previsto pela tarifa: ", n(Math.round(phc.previsto * 100) / 100), " \u20AC")), /* @__PURE__ */ React.createElement("label", { className: "cp-phc-campo" }, "Valor extra", /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        inputMode: "decimal",
        value: phc.valorExtra || "",
        placeholder: "0,00",
        onChange: (e) => onPhc({ valorExtra: e.target.value })
      }
    )), /* @__PURE__ */ React.createElement("label", { className: "cp-phc-campo" }, "Identifica\xE7\xE3o", /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        maxLength: 10,
        value: phc.identificacao || "",
        placeholder: "at\xE9 10 caracteres",
        onChange: (e) => onPhc({ identificacao: e.target.value })
      }
    ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "o PHC s\xF3 guarda 10")), /* @__PURE__ */ React.createElement("label", { className: "cp-phc-campo" }, "Motivo", /* @__PURE__ */ React.createElement(
      "select",
      {
        value: phc.motivoCargaId || "",
        onChange: (e) => onPhc({
          motivoCargaId: e.target.value ? Number(e.target.value) : null
        })
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem motivo \u2014"),
      (phc.motivos || []).map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.nome))
    )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Entrega SOS", /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: !!phc.sos,
        onChange: (e) => onPhc({ entregaSos: e.target.checked })
      }
    ), phc.sosDasLinhas && phc.entregaSos == null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 uma encomenda desta carga \xE9 SOS")), valor == null && /* @__PURE__ */ React.createElement("p", { className: "cp-alerta" }, "Sem pre\xE7o n\xE3o se cria a carga no PHC \u2014 uma linha a zero euros \xE9 uma fatura por zero."))))
  );
}
function CpCargaModal({
  camiao,
  carga,
  dados,
  percurso,
  ocupacao,
  validacao,
  custo,
  racios,
  motivoSemCusto,
  tempoPreparacao,
  onFechar
}) {
  const L = window.CargoplannerLogica;
  const eur = (v) => `${(Number(v) || 0).toFixed(2).replace(".", ",")} \u20AC`;
  const m = (v) => `${(Number(v) || 0).toFixed(2).replace(".", ",")} m`;
  const zonaSemCusto = custo ? null : L.textoSemCustoZona(carga, dados);
  const tarifa = React.useMemo(
    () => carga ? L.tarifaDaCarga(carga, dados) : null,
    [carga, dados, L]
  );
  const parcelas = React.useMemo(
    () => L.parcelasDoCusto(custo, carga, tarifa),
    [custo, carga, tarifa, L]
  );
  const omitidas = React.useMemo(
    () => L.parcelasOmitidas(custo, carga, tarifa),
    [custo, carga, tarifa, L]
  );
  const real = !!(percurso && percurso.real);
  const corridas = ocupacao && ocupacao.arranjo && ocupacao.arranjo.corridas || [];
  const nLinhas = (carga && carga.linhas || []).length;
  const aResolver = nLinhas > 0 && (ocupacao && ocupacao.segmentos || []).length === 0;
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: `Detalhe da carga \u2014 ${camiao ? camiao.id : "\u2014"}`,
      subtitle: "Como \xE9 que cada n\xFAmero do cabe\xE7alho foi feito.",
      width: "min(1180px, 94vw)",
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Fechar")
    },
    /* @__PURE__ */ React.createElement("div", { className: "cp-det" }, carga && carga.preparacao && /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Prepara\xE7\xE3o (planeado vs efetivado)" }, /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Planeado" }, Number(carga.preparacao.total_planeado || 0).toLocaleString("pt-PT"), " un."), /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Efetivado" }, Number(carga.preparacao.total_picado || 0).toLocaleString("pt-PT"), " un."), (carga.preparacao.linhas || []).filter((l) => l.ajustada || l.motivo).map((l, i) => /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { key: `prep-${i}`, label: l.artigo }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, Number(l.planeado || 0).toLocaleString("pt-PT")), " \u2192 ", /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, l.picado == null ? "\u2014" : Number(l.picado).toLocaleString("pt-PT")), l.motivo ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", l.motivo) : null))), /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Transporte" }, /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Transportadora" }, !camiao ? "\u2014" : camiao.aluguer === "proprio" ? "Frota pr\xF3pria" : camiao.transportadoraNome || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por contratar")), /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Contrata\xE7\xE3o" }, !camiao ? "\u2014" : camiao.aluguer === "proprio" ? "Frota pr\xF3pria" : camiao.aluguer === "alugado" ? "Alugado" : /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por alugar")), /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Motorista" }, camiao && camiao.motorista || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por atribuir")), /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Matr\xEDcula" }, camiao && camiao.matricula || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por atribuir")), /* @__PURE__ */ React.createElement(
      CpLinhaDetalhe,
      {
        label: "Janela",
        nota: camiao && !camiao.inicio ? "sem hor\xE1rio, o percurso n\xE3o calcula horas de chegada" : null
      },
      camiao && camiao.inicio ? `${camiao.inicio}${camiao.fim ? ` \u2013 ${camiao.fim}` : ""}` : /* @__PURE__ */ React.createElement("i", { className: "cp-sem-janela" }, "Hor\xE1rio por definir")
    ), carga && carga.urgente && /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Urgente", nota: carga.notaUrgencia || null }, carga.motivoUrgenciaNome || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "sem motivo"))), /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Percurso" }, ocupacao.transitario ? /* @__PURE__ */ React.createElement("p", { className: "cp-det__aviso" }, "O percurso \xE9 feito pelo ", /* @__PURE__ */ React.createElement("b", null, "transit\xE1rio"), ", n\xE3o por n\xF3s \u2014 n\xE3o h\xE1 rota nossa a medir nem km a mostrar.") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      CpLinhaDetalhe,
      {
        label: "Dist\xE2ncia",
        nota: real ? "rota real por estrada" : "estimativa \u2014 a rota por estrada n\xE3o chegou"
      },
      percurso.kmTotal == null ? "\u2014" : `${percurso.kmTotal} km`
    ), /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Dura\xE7\xE3o de condu\xE7\xE3o" }, percurso.minTotal == null ? "\u2014" : L.duracao(percurso.minTotal)), custo && /* @__PURE__ */ React.createElement(
      CpLinhaDetalhe,
      {
        label: "Paragens",
        nota: custo.paragensExtra > 0 ? `${custo.paragensExtra} al\xE9m das inclu\xEDdas pela tarifa` : "dentro das inclu\xEDdas"
      },
      custo.paragens
    ))), /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Ocupa\xE7\xE3o" }, ocupacao.transitario ? /* @__PURE__ */ React.createElement("p", { className: "cp-det__aviso" }, "Este cami\xE3o \xE9 um ", /* @__PURE__ */ React.createElement("b", null, "transit\xE1rio"), ": paga-se ao volume enviado, n\xE3o \xE0 viagem \u2014 n\xE3o h\xE1 ocupa\xE7\xE3o nem capacidade a calcular aqui.") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      CpLinhaDetalhe,
      {
        label: "Metros",
        nota: aResolver ? "por medir \u2014 as entregas ainda n\xE3o chegaram do ERP" : `${ocupacao.metrosPct}% de ${m(ocupacao.metrosCapacidade || 0)}`
      },
      /* @__PURE__ */ React.createElement("span", { className: ocupacao.metrosExcedeu ? "cp-erro-txt" : "" }, m(ocupacao.metros))
    ), /* @__PURE__ */ React.createElement(
      CpLinhaDetalhe,
      {
        label: "Paletes",
        nota: ocupacao.semPaletes > 0 ? `total PARCIAL \u2014 ${ocupacao.semPaletes} linha(s) sem quantidade por palete no ERP` : null
      },
      ocupacao.ocupadas
    ), (ocupacao.semPaletes > 0 || ocupacao.semMedida > 0) && /* @__PURE__ */ React.createElement("p", { className: "cp-det__aviso" }, "Os metros e as paletes acima s\xE3o um ", /* @__PURE__ */ React.createElement("b", null, "m\xEDnimo"), ", n\xE3o o valor.", (ocupacao.semPaletes > 0 || ocupacao.semMedida > (Number(ocupacao.semMedidaVolumes) || 0)) && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", "H\xE1 linhas que o ERP n\xE3o permite medir: corrigir isso \xE9 preencher", " ", /* @__PURE__ */ React.createElement("b", null, ocupacao.semPaletes > 0 ? "a quantidade por palete" : "as dimens\xF5es da palete"), " ", "no artigo, n\xE3o mexer no cami\xE3o."), ocupacao.semMedidaVolumes > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", "E h\xE1 ", /* @__PURE__ */ React.createElement("b", null, ocupacao.semMedidaVolumes, " volume(s) de amostra"), " sem medidas \u2014 esses escrevem-se na pr\xF3pria paragem, no detalhe da carga.")), ocupacao.empilhadas > 0 && /* @__PURE__ */ React.createElement(
      CpLinhaDetalhe,
      {
        label: "Empilhadas",
        nota: "a altura cabe mais do que uma vez na altura \xFAtil; as restantes contam uma camada"
      },
      ocupacao.empilhadas
    ), ocupacao.semMedida > 0 && /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Sem medida", nota: L.textoSemMedida(ocupacao) }, ocupacao.semMedida), corridas.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "cp-det__corridas" }, /* @__PURE__ */ React.createElement("div", { className: "cp-det__label" }, "Como carregar"), /* @__PURE__ */ React.createElement("ol", null, corridas.map((c, i) => /* @__PURE__ */ React.createElement("li", { key: i }, /* @__PURE__ */ React.createElement("b", null, (c.clientesNomes || []).join(" + ")), " \u2014 ", c.paletes, " pal. de ", m(c.largura), "\xD7", m(c.profundidade), c.camadas > 1 ? `, ${c.camadas} camadas` : "", ": ", [
      c.filasComprido ? `${c.filasComprido} fila(s) ao comprido` : "",
      c.filasLado ? `${c.filasLado} de lado` : ""
    ].filter(Boolean).join(" + "), " = ", /* @__PURE__ */ React.createElement("b", null, m(c.metros))))), /* @__PURE__ */ React.createElement("p", { className: "cp-det__nota" }, "Pela ordem f\xEDsica de carregamento (o inverso da ordem de entrega). Uma fila pode ser partilhada por dois clientes seguidos \u2014 quem descarrega primeiro tira s\xF3 as suas paletes dela.")))), /* @__PURE__ */ React.createElement(
      CpSeccaoDetalhe,
      {
        titulo: "Pre\xE7o previsto",
        vazio: custo ? null : aResolver ? `Esta carga tem ${nLinhas} linha(s), mas as entregas ainda n\xE3o chegaram do ERP \u2014 sem as paragens n\xE3o h\xE1 volta para calcular. Volta daqui a um instante.` : zonaSemCusto ? zonaSemCusto.longo : motivoSemCusto === "sem_planeamento" ? "Ainda n\xE3o h\xE1 nada planeado nesta carga \u2014 nem linhas, nem recolhas. Um 0 \u20AC diria \xABesta volta n\xE3o custa nada\xBB; a verdade \xE9 que a volta ainda n\xE3o existe." : motivoSemCusto === "transitario_sem_volumes" ? "Um transit\xE1rio paga-se ao volume enviado, n\xE3o \xE0 viagem \u2014 n\xE3o h\xE1 transportadora nem tarifa a escolher para ele. O pre\xE7o h\xE1 de vir do registo dos volumes de cada paragem, que ainda n\xE3o existe." : motivoSemCusto === "sem_km" ? "A volta tem paragens sem coordenadas \u2014 sem quil\xF3metros fi\xE1veis n\xE3o h\xE1 pre\xE7o. O que falta corrigir \xE9 a morada, n\xE3o a tarifa." : "N\xE3o h\xE1 tarifa para esta transportadora e este tipo de ve\xEDculo. Escolhe a transportadora em \xABTransporte\xBB, ou preenche os pre\xE7os \xE0 m\xE3o."
      },
      custo && (custo.transitario ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Volumes" }, custo.volumes, " volume(s)"), /* @__PURE__ */ React.createElement(
        CpLinhaDetalhe,
        {
          label: "Total",
          nota: "soma do valor de transporte de cada volume registado nas paragens"
        },
        /* @__PURE__ */ React.createElement("b", null, eur(custo.total))
      ), custo.semValor > 0 && /* @__PURE__ */ React.createElement("p", { className: "cp-det__aviso" }, custo.semValor, " volume(s) sem valor de transporte registado \u2014 este total \xE9 um ", /* @__PURE__ */ React.createElement("b", null, "m\xEDnimo"), ", n\xE3o o valor."), /* @__PURE__ */ React.createElement("p", { className: "cp-det__nota" }, "Um transit\xE1rio paga-se ao volume enviado, n\xE3o \xE0 viagem: n\xE3o h\xE1 aluguer, quil\xF3metros nem paragens a somar aqui.")) : /* @__PURE__ */ React.createElement(React.Fragment, null, parcelas.map((p) => /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { key: p.chave, label: p.label, nota: p.nota }, eur(p.valor))), /* @__PURE__ */ React.createElement(
        CpLinhaDetalhe,
        {
          label: "Total",
          nota: custo.origem === "carga" ? "pre\xE7os pr\xF3prios desta carga, editados em \xABTransporte\xBB" : "pre\xE7os do cat\xE1logo de tarifas"
        },
        /* @__PURE__ */ React.createElement("b", null, eur(custo.total))
      ), custo.semEntregas > 0 && /* @__PURE__ */ React.createElement("p", { className: "cp-det__aviso" }, custo.semEntregas, " linha(s) cuja entrega ainda n\xE3o chegou do ERP: as paragens delas n\xE3o entram na conta. Este pre\xE7o \xE9 um ", /* @__PURE__ */ React.createElement("b", null, "m\xEDnimo"), ", n\xE3o o valor."), omitidas.length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "cp-det__omitidas" }, omitidas.map((o, i) => /* @__PURE__ */ React.createElement("li", { key: i }, o))), racios && /* @__PURE__ */ React.createElement("div", { className: "cp-det__racios" }, racios.pctValor != null && /* @__PURE__ */ React.createElement("span", null, String(racios.pctValor).replace(".", ","), " % da mercadoria"), racios.porPalete != null && /* @__PURE__ */ React.createElement("span", null, eur(racios.porPalete), "/palete"), racios.porMetro != null && /* @__PURE__ */ React.createElement("span", null, eur(racios.porMetro), "/metro"), racios.porKm != null && /* @__PURE__ */ React.createElement("span", null, eur(racios.porKm), "/km"))))
    ), tempoPreparacao && /* @__PURE__ */ React.createElement(
      CpSeccaoDetalhe,
      {
        titulo: "Prepara\xE7\xE3o prevista",
        vazio: tempoPreparacao.linhas > 0 ? null : aResolver ? `Esta carga tem ${nLinhas} linha(s), mas as entregas ainda n\xE3o chegaram do ERP \u2014 sem elas n\xE3o h\xE1 o que medir. Volta daqui a um instante.` : "Nada planeado ainda \u2014 n\xE3o h\xE1 prepara\xE7\xE3o a prever."
      },
      /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Tempo" }, L.duracao(tempoPreparacao.minutos)),
      /* @__PURE__ */ React.createElement(CpLinhaDetalhe, { label: "Base do c\xE1lculo" }, tempoPreparacao.paletes, " palete(s) \xD7 ", tempoPreparacao.minutosPorPalete, " min"),
      tempoPreparacao.comMinimo > 0 && /* @__PURE__ */ React.createElement(
        CpLinhaDetalhe,
        {
          label: "No m\xEDnimo por linha",
          nota: `picar e abrir cada refer\xEAncia tem um custo fixo \u2014 por isso o m\xEDnimo \xE9 por LINHA, n\xE3o pelo total da carga`
        },
        tempoPreparacao.comMinimo,
        " de ",
        tempoPreparacao.linhas,
        " linha(s),",
        " ",
        "a ",
        tempoPreparacao.minutosMinimosLinha,
        " min cada"
      ),
      /* @__PURE__ */ React.createElement("p", { className: "cp-det__nota" }, "Estes minutos mudam-se em ", /* @__PURE__ */ React.createElement("b", null, "Defini\xE7\xF5es \u2192 Turnos e armaz\xE9ns"), ", \xE0 medida que os tempos reais das ondas o justificarem.")
    ), carga && carga.servidorId != null && /* @__PURE__ */ React.createElement(
      window.CpReservasDaLista,
      {
        carga: carga.servidorId,
        titulo: "Paletes que esta carga segura"
      }
    ), validacao && validacao.problemas && validacao.problemas.length > 0 && /* @__PURE__ */ React.createElement(CpSeccaoDetalhe, { titulo: "Problemas e avisos" }, /* @__PURE__ */ React.createElement("ul", { className: "cp-problemas" }, validacao.problemas.map((p, i) => /* @__PURE__ */ React.createElement("li", { key: i, className: p.nivel === "aviso" ? "is-aviso" : "is-erro" }, p.msg)))))
  );
}
window.CpLinhaDetalhe = CpLinhaDetalhe;
window.CpSeccaoDetalhe = CpSeccaoDetalhe;
window.CpCargaModal = CpCargaModal;
window.CpPreparadaModal = CpPreparadaModal;

// ===== cargoplanner/frontend/cargoplanner_seletor_dia.jsx =====
const CP_TECLAS_DIA = {
  ArrowLeft: -1,
  ArrowRight: 1,
  ArrowUp: -7,
  ArrowDown: 7
};
function CpSeletorDia({ valor, onMudar, feriados, ariaLabel }) {
  const L = window.CargoplannerLogica;
  const D = window.CargoplannerDados;
  const [aberto, setAberto] = React.useState(false);
  const [mes, setMes] = React.useState(() => L.mesDoDia(valor) || L.mesDoDia(D.hoje()));
  const [focado, setFocado] = React.useState(null);
  const caixa = React.useRef(null);
  const botao = React.useRef(null);
  React.useEffect(() => {
    if (aberto) {
      setMes(L.mesDoDia(valor) || L.mesDoDia(D.hoje()));
      setFocado(null);
    }
  }, [aberto, valor, L, D]);
  React.useEffect(() => {
    if (!aberto) return void 0;
    const fora = (e) => {
      if (caixa.current && !caixa.current.contains(e.target)) setAberto(false);
    };
    document.addEventListener("mousedown", fora);
    return () => document.removeEventListener("mousedown", fora);
  }, [aberto]);
  const grade = L.gradeDoMes(mes, feriados);
  function escolher(dia) {
    setAberto(false);
    if (botao.current) botao.current.focus();
    if (dia && dia !== valor) onMudar(dia);
  }
  function teclado(e) {
    if (e.key === "Escape") {
      setAberto(false);
      if (botao.current) botao.current.focus();
      return;
    }
    const base = focado || valor || D.hoje();
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      escolher(base);
      return;
    }
    const passo = CP_TECLAS_DIA[e.key];
    if (passo == null) return;
    e.preventDefault();
    const novo = D.diaMais(base, passo);
    setFocado(novo);
    const m = L.mesDoDia(novo);
    if (m !== mes) setMes(m);
  }
  return /* @__PURE__ */ React.createElement("span", { className: "cp-seletor-dia", ref: caixa }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      ref: botao,
      className: "cp-dia-input cp-seletor-dia__botao",
      "aria-label": ariaLabel,
      "aria-haspopup": "dialog",
      "aria-expanded": aberto,
      onClick: () => setAberto((a) => !a)
    },
    valor || "\u2014"
  ), aberto && grade && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "cp-seletor-dia__painel",
      role: "dialog",
      "aria-label": ariaLabel,
      onKeyDown: teclado,
      tabIndex: -1,
      ref: (el) => {
        if (el) el.focus();
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: "cp-seletor-dia__topo" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost icon-only sm",
        title: "M\xEAs anterior",
        onClick: () => setMes(L.mesMais(mes, -1))
      },
      "\u2039"
    ), /* @__PURE__ */ React.createElement("b", null, grade.rotulo), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost icon-only sm",
        title: "M\xEAs seguinte",
        onClick: () => setMes(L.mesMais(mes, 1))
      },
      "\u203A"
    )),
    /* @__PURE__ */ React.createElement("div", { className: "cp-seletor-dia__semana" }, ["S", "T", "Q", "Q", "S", "S", "D"].map((d, i) => /* @__PURE__ */ React.createElement("span", { key: i, className: "cp-seletor-dia__inicial" }, d))),
    grade.semanas.map((semana, i) => /* @__PURE__ */ React.createElement("div", { key: i, className: "cp-seletor-dia__semana" }, semana.map((d) => {
      const cls = ["cp-seletor-dia__dia"];
      if (d.foraDoMes) cls.push("is-fora");
      if (d.motivo) cls.push(d.motivo.tipo === "feriado" ? "is-feriado" : "is-fds");
      if (d.dia === valor) cls.push("is-escolhido");
      if (d.dia === focado) cls.push("is-focado");
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: d.dia,
          type: "button",
          className: cls.join(" "),
          title: d.motivo ? d.motivo.nome : d.dia,
          "aria-label": d.motivo ? `${d.dia} \u2014 ${d.motivo.nome}` : d.dia,
          onClick: () => escolher(d.dia)
        },
        d.numero
      );
    }))),
    /* @__PURE__ */ React.createElement("div", { className: "cp-seletor-dia__legenda" }, /* @__PURE__ */ React.createElement("span", { className: "cp-seletor-dia__marca is-fds" }), " fim-de-semana", /* @__PURE__ */ React.createElement("span", { className: "cp-seletor-dia__marca is-feriado" }), " feriado")
  ));
}
window.CpSeletorDia = CpSeletorDia;

// ===== cargoplanner/frontend/cargoplanner_camioes.jsx =====
function CpBarraOcupacao({ ocupacao }) {
  const total = ocupacao.metrosCapacidade || 0;
  const segs = ocupacao.segmentos.filter((s) => s.metros);
  const livre = Math.max(0, total - ocupacao.metros);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "cp-barra",
      title: `${ocupacao.metros.toFixed(2)} m de ${total.toFixed(2)} m`
    },
    segs.map((s) => /* @__PURE__ */ React.createElement(
      "span",
      {
        key: s.clienteId,
        className: "cp-barra__seg",
        style: { background: s.cliente.cor, flexGrow: s.metros },
        title: `${s.cliente.nome} \u2014 ${s.metros.toFixed(2)} m`
      }
    )),
    livre > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-barra__seg cp-barra__cel--vazia", style: { flexGrow: livre } }),
    ocupacao.metrosExcedeu && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-barra__excesso",
        title: `${(ocupacao.metros - total).toFixed(2)} m a mais`
      },
      "+",
      (ocupacao.metros - total).toFixed(1),
      "m"
    )
  );
}
function cpOrdinalViagem(v) {
  return `${v}\xAA`;
}
function CpCamiaoCard({
  camiao,
  carga,
  viagem,
  totalViagens,
  dados,
  ativo,
  onSelecionar,
  onRemoverViagem,
  onLargarArtigos,
  onMoverCarga,
  onMoverCliente,
  conflitos,
  preparadores
}) {
  const [sobre, setSobre] = React.useState(false);
  const L = window.CargoplannerLogica;
  const efetivo = L.camiaoDaCarga(carga, dados) || camiao;
  const ocupacao = L.ocupacao(
    carga || { camiaoId: camiao.id, viagem, linhas: [], ordemClientes: [] },
    dados
  );
  const percursoDoCartao = L.percurso(carga, dados);
  const custo = L.custoDaCarga(carga, dados, percursoDoCartao);
  const motivoSemCusto = custo ? null : L.motivoSemCusto(carga, dados, percursoDoCartao);
  const zonaSemCusto = custo ? null : L.textoSemCustoZona(carga, dados);
  const estado = (dados.estados || []).find((e) => e.id === (carga && carga.estado));
  const conflitosDaCarga = carga ? conflitos.filter((c) => c.cargaId === carga.id) : [];
  const errosDaCarga = conflitosDaCarga.filter((c) => c.nivel !== "aviso");
  const avisosDaCarga = conflitosDaCarga.filter((c) => c.nivel === "aviso");
  const temConflito = errosDaCarga.length > 0;
  const temAvisoCapacidade = !temConflito && avisosDaCarga.length > 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `cp-camiao ${ativo ? "is-ativo" : ""} ${temConflito ? "tem-conflito" : ""} ${temAvisoCapacidade ? "tem-aviso-capacidade" : ""} ${sobre ? "is-sobre" : ""}`,
      draggable: true,
      onDragStart: (ev) => window.CpDnd.escrever(ev, { k: "carga", camiaoId: camiao.id, viagem }),
      onDragOver: (ev) => {
        ev.preventDefault();
        setSobre(true);
      },
      onDragLeave: () => setSobre(false),
      onDrop: (ev) => {
        ev.preventDefault();
        setSobre(false);
        const p = window.CpDnd.ler(ev);
        if (p && p.k === "artigos") onLargarArtigos(camiao.id, viagem, p.itens);
        else if (p && p.k === "carga" && p.camiaoId !== camiao.id) {
          onMoverCarga(p.camiaoId, p.viagem, camiao.id, viagem);
        } else if (p && p.k === "paragem" && p.camiaoId && p.camiaoId !== camiao.id) {
          onMoverCliente(p.camiaoId, p.clienteId, camiao.id, viagem);
        }
      },
      onClick: () => onSelecionar(camiao.id, viagem),
      role: "button",
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelecionar(camiao.id, viagem);
        }
      },
      "aria-pressed": ativo,
      title: `${camiao.id} \u2014 ${efetivo.matricula || "sem viatura"} \u2014 ${efetivo.motorista || "sem motorista"}
Arrasta para a linha de um colaborador para atribuir a prepara\xE7\xE3o`
    },
    /* @__PURE__ */ React.createElement("div", { className: "cp-camiao__top" }, /* @__PURE__ */ React.createElement("span", { className: "cp-camiao__id" }, camiao.id), totalViagens > 1 && /* @__PURE__ */ React.createElement("span", { className: "cp-viagem-marca", title: `${cpOrdinalViagem(viagem)} viagem de hoje` }, cpOrdinalViagem(viagem)), viagem > 1 && /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm cp-camiao__x",
        title: `Apagar a ${cpOrdinalViagem(viagem)} viagem do ${camiao.id}`,
        onClick: (e) => {
          e.stopPropagation();
          onRemoverViagem(camiao.id, viagem);
        }
      },
      /* @__PURE__ */ React.createElement(window.Ico.close, null)
    )),
    (estado || temConflito || temAvisoCapacidade) && /* @__PURE__ */ React.createElement("div", { className: "cp-camiao__estado" }, estado && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-estado-pill cp-estado-pill--sm",
        style: { "--cp-estado": estado.cor }
      },
      estado.label
    ), temConflito && /* @__PURE__ */ React.createElement("span", { className: "cp-camiao__alerta", title: errosDaCarga.map((c) => c.msg).join("\n") }, "!"), temAvisoCapacidade && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-camiao__alerta cp-camiao__alerta--aviso",
        title: avisosDaCarga.map((c) => c.msg).join("\n")
      },
      "!"
    )),
    /* @__PURE__ */ React.createElement("div", { className: "cp-camiao__janela" }, efetivo.inicio ? /* @__PURE__ */ React.createElement(React.Fragment, null, efetivo.inicio, " \u2013 ", efetivo.fim) : /* @__PURE__ */ React.createElement("span", { className: "cp-sem-janela" }, "Hor\xE1rio por definir"), efetivo.aluguer === "por_alugar" && /* @__PURE__ */ React.createElement("span", { className: "cp-tag-alugar", title: "Sem transportadora, viatura nem motorista" }, "por alugar"), carga && carga.urgente && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-camiao-urgente",
        title: `Urgente \u2014 ${carga.motivoUrgenciaNome || "sem motivo"}`
      },
      "Urgente"
    )),
    carga && /* @__PURE__ */ React.createElement("div", { className: "cp-camiao__prep" }, carga.localizacaoDestino ? /* @__PURE__ */ React.createElement("span", { className: "cp-camiao__cais", title: "Cais onde esta carga se monta" }, carga.localizacaoDestino) : /* @__PURE__ */ React.createElement("span", { className: "cp-camiao__cais is-falta", title: "Sem cais definido \u2014 o picking n\xE3o sabe para onde levar as paletes" }, "sem cais"), !preparadores.length && /* @__PURE__ */ React.createElement("span", { className: "cp-camiao__prep-falta", title: "Ainda n\xE3o h\xE1 onda de prepara\xE7\xE3o para esta carga" }, "sem prepara\xE7\xE3o"), preparadores.map((p) => /* @__PURE__ */ React.createElement(
      "span",
      {
        key: p.pessoaId || "por-atribuir",
        className: `cp-camiao__prep-nome${p.nome ? "" : " is-falta"}`,
        title: p.nome ? `${p.nome} prepara esta carga (${p.codigos.join(", ")})` : `${p.codigos.join(", ")} ainda n\xE3o tem ningu\xE9m atribu\xEDdo`
      },
      p.nome || (p.codigos.length > 1 ? `por atribuir (${p.codigos.length})` : "por atribuir")
    ))),
    !ocupacao.transitario && /* @__PURE__ */ React.createElement(CpBarraOcupacao, { ocupacao }),
    /* @__PURE__ */ React.createElement("div", { className: "cp-camiao__foot" }, ocupacao.transitario ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Paga-se ao volume enviado \u2014 sem ocupa\xE7\xE3o a calcular" }, "transit\xE1rio") : /* @__PURE__ */ React.createElement(
      "span",
      {
        className: ocupacao.metrosExcedeu ? "cp-erro-txt" : "",
        title: `${ocupacao.ocupadas} palete(s)`
      },
      ocupacao.metros.toFixed(1).replace(".", ","),
      "/",
      (ocupacao.metrosCapacidade || 0).toFixed(1).replace(".", ","),
      " m",
      ocupacao.semMedida > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: L.textoSemMedida(ocupacao) }, " +?")
    ), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "cp-camiao__euro",
        title: custo ? custo.transitario ? `Soma dos volumes registados nas paragens \u2014 ${custo.volumes} volume(s).` + (custo.semValor > 0 ? ` ${custo.semValor} sem valor registado: este total \xE9 um M\xCDNIMO.` : "") : custo.zona ? `Pre\xE7o por zona \u2014 zona mais distante: ${custo.zona.rotulo}.` + (custo.paragensExtra > 0 ? ` ${custo.paragensExtra} descarga(s) extra.` : "") + " Vale para dias \xFAteis em hor\xE1rio normal." : `Estimativa \u2014 o cart\xE3o calcula a dist\xE2ncia direta, n\xE3o pede a rota real a cada cami\xE3o (seriam ~90 chamadas). O valor pela rota por estrada est\xE1 no cabe\xE7alho da carga.
Valor exacto desta estimativa: ${custo.total.toFixed(2).replace(".", ",")} \u20AC` : zonaSemCusto ? `Sem pre\xE7o \u2014 ${zonaSemCusto.curto}: ${zonaSemCusto.longo}` : motivoSemCusto === "sem_planeamento" ? "Sem linhas ainda \u2014 nada planeado, nada a prever" : motivoSemCusto === "transitario_sem_volumes" ? "Transit\xE1rio \u2014 paga-se ao volume enviado, ainda por registar" : "Sem tarifa para esta transportadora e tipo"
      },
      custo ? custo.transitario || custo.zona ? `${custo.total.toFixed(2).replace(".", ",")} \u20AC` : `~${Math.round(custo.total)} \u20AC` : "\u2014"
    ))
  );
}
function CpNotaDiaUtil({ dia, feriados }) {
  const L = window.CargoplannerLogica;
  const texto = L.textoDoDiaNaoUtil(L.diaUtil(dia, feriados));
  if (!texto) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "cp-nota-dia-util__linha" }, /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "cp-nota-dia-util",
      title: texto.completo,
      "aria-label": texto.completo
    },
    "\u26A0 ",
    texto.curto
  ));
}
window.CpNotaDiaUtil = CpNotaDiaUtil;
function CpCamioes({
  dados,
  cargas,
  dia,
  camiaoSel,
  viagemSel,
  onSelecionar,
  onDia,
  onNovo,
  onNovaViagem,
  onRemoverViagem,
  onRemover,
  onLargarArtigos,
  onMoverCarga,
  onMoverCliente,
  conflitos,
  percursoPorCarga,
  ondas,
  dadosOndas
}) {
  const D = window.CargoplannerDados;
  const L = window.CargoplannerLogica;
  const OL = window.OndasLogica;
  const viagemAtiva = viagemSel || 1;
  const porPeriodo = L.camioesPorPeriodo(
    dados.camioes || [],
    cargas,
    dia,
    dados.periodos || []
  ).map((g) => ({ ...g, viagens: L.viagensDoDia(g.camioes, cargas, dia) }));
  const custoDoDia = React.useMemo(
    () => L.custoDoDia(dados, dia, percursoPorCarga),
    [L, dados, dia, percursoPorCarga]
  );
  const semPrecoDia = L.textoDoDiaSemPreco(custoDoDia);
  return /* @__PURE__ */ React.createElement("section", { className: "panel cp-zona cp-zona--camioes", "aria-label": "Cami\xF5es" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h cp-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Cami\xF5es (", (dados.camioes || []).length, ")"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm cp-zona__h-fim", onClick: onNovo, title: "Acrescentar um cami\xE3o \xE0 frota" }, /* @__PURE__ */ React.createElement(window.Ico.plus, null), " Novo")), /* @__PURE__ */ React.createElement("div", { className: "cp-dia-nav" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      title: "Dia anterior",
      onClick: () => onDia(D.diaMais(dia, -1))
    },
    "\u2039"
  ), /* @__PURE__ */ React.createElement(
    window.CpSeletorDia,
    {
      valor: dia,
      onMudar: onDia,
      feriados: dados.feriados,
      ariaLabel: "Dia de planeamento"
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      title: "Dia seguinte",
      onClick: () => onDia(D.diaMais(dia, 1))
    },
    "\u203A"
  ), /* @__PURE__ */ React.createElement(CpNotaDiaUtil, { dia, feriados: dados.feriados })), /* @__PURE__ */ React.createElement("div", { className: "cp-dia-total", title: "Soma das cargas do dia que t\xEAm pre\xE7o. As que n\xE3o t\xEAm ficam de fora \u2014 um total que as engolisse mentia por omiss\xE3o. Cada carga entra pela rota real por estrada assim que ela chega (a mesma que o mapa desenha); at\xE9 l\xE1, e se a rota falhar, entra pela estimativa \u2014 como o pre\xE7o mostrado no cabe\xE7alho da carga aberta." }, /* @__PURE__ */ React.createElement("b", null, "Dia"), " ", custoDoDia.comPreco === 0 ? custoDoDia.semPreco === 0 ? /* @__PURE__ */ React.createElement("span", { className: "muted" }, "sem cargas") : /* @__PURE__ */ React.createElement("span", { className: "muted", title: semPrecoDia.longo }, semPrecoDia.curto) : /* @__PURE__ */ React.createElement(React.Fragment, null, custoDoDia.total.toFixed(2).replace(".", ","), " \u20AC", custoDoDia.pctValor != null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", String(custoDoDia.pctValor).replace(".", ","), " % da mercadoria"), semPrecoDia && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: semPrecoDia.longo }, " ", "+", custoDoDia.semPreco, " ", semPrecoDia.soTarifa ? "sem tarifa" : "sem pre\xE7o"))), /* @__PURE__ */ React.createElement("div", { className: "cp-zona__body" }, porPeriodo.map((p) => {
    const totalPorCamiao = /* @__PURE__ */ new Map();
    for (const v of p.viagens) {
      totalPorCamiao.set(v.camiao.id, (totalPorCamiao.get(v.camiao.id) || 0) + 1);
    }
    const grupos = [];
    for (const v of p.viagens) {
      const ultimo = grupos[grupos.length - 1];
      if (ultimo && ultimo.camiao.id === v.camiao.id) ultimo.viagens.push(v);
      else grupos.push({ camiao: v.camiao, viagens: [v] });
    }
    return /* @__PURE__ */ React.createElement("div", { key: p.id == null ? "_sem_horario" : p.id, className: "cp-periodo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-periodo__h" }, p.label), grupos.map((g) => /* @__PURE__ */ React.createElement("div", { key: g.camiao.id, className: "cp-viagem-grupo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-viagem-grupo__h" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm cp-camiao__x",
        title: `Desativar o ${g.camiao.id} \u2014 sai da lista do dia`,
        onClick: () => onRemover(g.camiao.id)
      },
      /* @__PURE__ */ React.createElement(window.Ico.close, null)
    )), g.viagens.map((v) => /* @__PURE__ */ React.createElement(
      CpCamiaoCard,
      {
        key: `${v.camiao.id}#${v.viagem}`,
        camiao: v.camiao,
        carga: v.carga,
        viagem: v.viagem,
        totalViagens: totalPorCamiao.get(v.camiao.id) || 1,
        dados,
        ativo: v.camiao.id === camiaoSel && v.viagem === viagemAtiva,
        onSelecionar,
        onRemoverViagem,
        onLargarArtigos,
        onMoverCarga,
        onMoverCliente,
        conflitos,
        preparadores: OL.preparadoresDaCarga(
          v.carga && v.carga.id,
          ondas,
          dadosOndas
        )
      }
    )), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm cp-viagem-mais",
        onClick: () => onNovaViagem(g.camiao.id),
        title: `Nova viagem para o ${g.camiao.id}`
      },
      /* @__PURE__ */ React.createElement(window.Ico.plus, null),
      " viagem"
    ))));
  })));
}
function CpNovoCamiaoModal({ dados, tipos, onFechar, onCriar }) {
  const [f, setF] = React.useState({
    id: "",
    tipo: "",
    matricula: "",
    motorista: "",
    periodo: "",
    inicio: "08:00",
    fim: "16:00",
    aluguer: "proprio",
    transportadora: ""
  });
  const [transportadoras, setTransportadoras] = React.useState([]);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.transportadoras({ ativos: 1 }).then((fs) => {
      if (vivo) setTransportadoras(fs || []);
    }).catch(() => {
      if (vivo) setTransportadoras([]);
    });
    return () => {
      vivo = false;
    };
  }, []);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const jaExiste = (dados.camioes || []).some(
    (c) => c.id.toUpperCase() === String(f.id).trim().toUpperCase()
  );
  const disponiveis = (tipos || []).filter((t) => t.ativo);
  const tipoSel = disponiveis.find((t) => String(t.id) === String(f.tipo)) || null;
  const valido = String(f.id).trim() && !jaExiste && !!tipoSel;
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Novo cami\xE3o",
      width: 520,
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary", disabled: !valido, onClick: () => onCriar(f) }, "Acrescentar"))
    },
    /* @__PURE__ */ React.createElement("div", { className: "cp-form" }, /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Identifica\xE7\xE3o *"), /* @__PURE__ */ React.createElement("input", { className: "cp-select", value: f.id, onChange: set("id"), placeholder: "TIR-21" }), jaExiste && /* @__PURE__ */ React.createElement("small", { className: "cp-erro-txt" }, "J\xE1 existe um cami\xE3o com essa identifica\xE7\xE3o.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Contrata\xE7\xE3o"), /* @__PURE__ */ React.createElement("select", { className: "cp-select", value: f.aluguer, onChange: set("aluguer") }, (dados.aluguer || []).filter((a) => a.id !== "alugado").map((a) => /* @__PURE__ */ React.createElement("option", { key: a.id, value: a.id }, a.label)), /* @__PURE__ */ React.createElement("option", { value: "alugado", disabled: true }, "Alugado"))), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Transportadora"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: f.transportadora,
        onChange: set("transportadora"),
        disabled: f.aluguer === "por_alugar"
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, f.aluguer === "proprio" ? "Frota pr\xF3pria" : "\u2014 escolher \u2014"),
      transportadoras.filter((fo) => fo.ativo !== false).map((fo) => /* @__PURE__ */ React.createElement("option", { key: fo.id, value: fo.id }, fo.nome))
    )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Matr\xEDcula"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        value: f.matricula,
        onChange: set("matricula"),
        placeholder: f.aluguer === "por_alugar" ? "Por atribuir" : "AA-00-BB"
      }
    )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Motorista"), /* @__PURE__ */ React.createElement("input", { className: "cp-select", value: f.motorista, onChange: set("motorista") })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Tipo *"), /* @__PURE__ */ React.createElement("select", { className: "cp-select", value: f.tipo, onChange: set("tipo") }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), disponiveis.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.nome))), tipoSel ? /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, Number(tipoSel.comprimento_m).toFixed(2).replace(".", ","), " m de comprimento", " \xB7 ", Number(tipoSel.largura_m).toFixed(2).replace(".", ","), " m de largura \xFAtil", " \xB7 ", Number(tipoSel.peso_max_kg).toLocaleString("pt-PT"), " kg") : /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "As medidas v\xEAm do tipo. Se falta um, cria-o em Defini\xE7\xF5es \u2192 \xABTipos de TIR\xBB.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Per\xEDodo"), /* @__PURE__ */ React.createElement("select", { className: "cp-select", value: f.periodo, onChange: set("periodo") }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 (o grupo vem da hora de sa\xEDda)"), (dados.periodos || []).filter((p) => p.ativo !== false).map((p) => /* @__PURE__ */ React.createElement("option", { key: p.id, value: p.id }, p.label))), /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "S\xF3 vale quando o cami\xE3o n\xE3o tem hora de sa\xEDda. Com hora, \xE9 ela que decide o grupo.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Sa\xEDda"), /* @__PURE__ */ React.createElement("input", { className: "cp-select", type: "time", value: f.inicio, onChange: set("inicio") })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Fim da janela"), /* @__PURE__ */ React.createElement("input", { className: "cp-select", type: "time", value: f.fim, onChange: set("fim") })))
  );
}
window.CpCamioes = CpCamioes;
window.CpNovoCamiaoModal = CpNovoCamiaoModal;
window.CpBarraOcupacao = CpBarraOcupacao;

// ===== cargoplanner/frontend/cargoplanner_entregas.jsx =====
const CP_DISP_CORES = {
  produzido: "#16a34a",
  // verde  — material físico
  producao: "#2563eb",
  // azul   — em produção, chega a tempo
  risco: "#f97316",
  // laranja— em cima da hora
  atrasado: "#dc2626"
  // vermelho — depois da saída
};
function CpPontoDisp({ estado, titulo }) {
  const L = window.CargoplannerLogica;
  return /* @__PURE__ */ React.createElement("span", { className: "cp-disp", title: titulo || L.DISP_LABEL[estado] || estado }, /* @__PURE__ */ React.createElement("span", { className: "cp-disp__dot", style: { background: CP_DISP_CORES[estado] || "#94a3b8" } }));
}
const CP_CAMPOS_PROCURA = [
  { id: "todos", label: "Todos os campos" },
  { id: "clienteNome", label: "Cliente" },
  { id: "ref", label: "Artigo" },
  { id: "descricao", label: "Descri\xE7\xE3o" },
  { id: "encomenda", label: "Encomenda" },
  { id: "refCliente", label: "Ref. cliente" },
  { id: "local", label: "Localidade" },
  { id: "morada", label: "Morada de descarga" },
  { id: "observacoes", label: "Observa\xE7\xF5es" }
];
const CP_AGRUPAR = {
  cliente_morada: {
    label: "Cliente + morada de descarga",
    chave: (r) => `${r.clienteId}\0${r.morada || ""}`
  },
  cliente: { label: "Cliente", chave: (r) => String(r.clienteId) },
  encomenda: { label: "Encomenda", chave: (r) => String(r.encomenda || "\u2014") }
};
const CP_FILTROS_STOCK = [
  { id: "todos", label: "Todas" },
  { id: "cobre", label: "Stock cobre a linha" },
  { id: "com", label: "Com algum stock" },
  { id: "sem", label: "Sem stock" }
];
const CP_PERTO_KM = 15;
function rotuloNoutrosDias(r) {
  const lista = r.noutrosDias || [];
  if (!lista.length) return "J\xE1 est\xE1 toda noutra carga.";
  const n = (v) => Number(v || 0).toLocaleString("pt-PT");
  const total = lista.reduce((s2, x) => s2 + (Number(x.qtd) || 0), 0);
  const erp = Number(r.qtdErp || 0);
  const quantas = lista.length === 1 ? "numa carga de outro dia" : `em ${lista.length} cargas de outros dias`;
  if (total > erp) {
    return `Aten\xE7\xE3o: est\xE3o ${n(total)} unidades em cargas \u2014 mais do que as ${n(erp)} que a encomenda tem por entregar. A mesma linha foi colocada ${quantas}, e alguma est\xE1 a mais: tira-a de uma delas, no dia dessa carga.`;
  }
  return `${n(total)} de ${n(erp)} j\xE1 est\xE3o ${quantas}. Para a mover, tira-a de l\xE1 primeiro \u2014 no dia dessa carga.`;
}
function CpEntregas({
  dia,
  entregas,
  aCarregar,
  erro,
  onDia,
  onLargarDaCarga,
  onLargarCliente,
  onAdicionar,
  onRecarregar,
  onGuardarLinha,
  linhaDaRota,
  diaPlaneamento,
  camiaoVazio,
  cargas,
  ondas,
  dadosOndas,
  feriados,
  mostrarNaoCarga,
  nNaoCarga,
  onMostrarNaoCarga
}) {
  const D = window.CargoplannerDados;
  const CL = window.CargoplannerLogica;
  const [selecao, setSelecao] = React.useState(() => /* @__PURE__ */ new Set());
  const [sobre, setSobre] = React.useState(false);
  const [aEditar, setAEditar] = React.useState(null);
  const [aVer, setAVer] = React.useState(null);
  const [ordemClientes, setOrdemClientes] = React.useState("rota");
  const [procura, setProcura] = React.useState("");
  const [campoProcura, setCampoProcura] = React.useState("todos");
  const [filtroStock, setFiltroStock] = React.useState("todos");
  const [agrupar, setAgrupar] = React.useState("cliente_morada");
  const kmDaRota = React.useMemo(
    () => CL.kmDaRotaPorCliente(entregas || [], linhaDaRota),
    [entregas, linhaDaRota, CL]
  );
  const localDoCliente = React.useMemo(() => {
    const out = {};
    for (const e of entregas || []) if (!(e.clienteId in out)) out[e.clienteId] = e.local || "";
    return out;
  }, [entregas]);
  const kmDoLocal = React.useMemo(
    () => CL.kmDaRotaPorLocal(kmDaRota, localDoCliente),
    [kmDaRota, localDoCliente, CL]
  );
  const temRota = (linhaDaRota || []).length > 0 && !camiaoVazio;
  const porRota = ordemClientes === "rota" && temRota;
  const kits = React.useMemo(() => CL.kitsDaLista(entregas || []), [entregas, CL]);
  const agregados = React.useMemo(() => {
    const out = {};
    for (const [bistamp, comps] of Object.entries(kits.porKit)) {
      const kit = (entregas || []).find((e) => e.id === bistamp);
      if (kit) out[bistamp] = CL.agregadoDoKit(kit, comps);
    }
    return out;
  }, [kits, entregas, CL]);
  const kitIds = React.useMemo(() => new Set(Object.keys(agregados)), [agregados]);
  const poolKits = React.useMemo(() => {
    const out = {};
    for (const [bistamp, comps] of Object.entries(kits.porKit)) {
      const kit = (entregas || []).find((e) => e.id === bistamp);
      if (kit) out[bistamp] = CL.kitPorAtribuir(kit, comps, cargas);
    }
    return out;
  }, [kits, entregas, cargas, CL]);
  const kitSemNada = React.useCallback((r) => {
    const pool = poolKits[r && r.id];
    return !!pool && pool.sabe && !pool.kits;
  }, [poolKits]);
  const [kitsAbertos, setKitsAbertos] = React.useState(() => /* @__PURE__ */ new Set());
  const abrirKit = React.useCallback((id, abrir) => setKitsAbertos((s) => {
    const n = new Set(s);
    if (abrir) n.add(id);
    else n.delete(id);
    return n;
  }), []);
  const kitsRef = React.useRef(kits);
  kitsRef.current = kits;
  const itensDe = React.useCallback(
    (linhas) => CL.itensParaArrastar(linhas, kitsRef.current),
    [CL]
  );
  const arrastarLinhas = (ev, linhas) => window.CpDnd.escrever(ev, { k: "artigos", itens: itensDe(linhas) });
  const corDe = React.useCallback((r) => {
    const ag = agregados[r.id];
    return ag ? CL.corDoKit(r, ag, kits.porKit[r.id], dia) : CL.corDaLinha(r, dia);
  }, [agregados, kits, dia, CL]);
  const paleteDe = React.useCallback((r) => {
    const ag = agregados[r.id];
    if (!ag) return r.paletes;
    return ag.componentes ? ag.paletes : null;
  }, [agregados]);
  const hoje = D.hoje();
  const colunas = React.useMemo(() => [
    {
      key: "drag",
      label: "",
      width: 30,
      minWidth: 30,
      sortable: false,
      fixed: true,
      render: (r) => r.presaNoutroDia || kitSemNada(r) ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: kitSemNada(r) ? "Os componentes deste kit j\xE1 est\xE3o todos em cargas" : "J\xE1 est\xE1 toda noutra carga" }, "\u2014") : /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "ond-handle",
          draggable: true,
          onDragStart: (ev) => {
            const linhas = selecao.has(r.id) && selecao.size > 1 ? entregas.filter((e) => selecao.has(e.id)) : [r];
            arrastarLinhas(ev, linhas);
          },
          title: "Arrasta para a carga, para um cami\xE3o ou para o detalhe"
        },
        "\u22EE\u22EE"
      )
    },
    {
      key: "ref",
      label: "Artigo",
      width: 145,
      minWidth: 110,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono", title: r.codigo }, r.ref, r.sos && /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--sos", title: "Encomenda SOS \u2014 urgente" }, "SOS"), r.primeiraEntrega && /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--novo", title: "Nunca entreg\xE1mos esta refer\xEAncia" }, "1\xAA"), agregados[r.id] && /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "cp-tag cp-tag--kit",
          title: `Kit: expede-se com ${agregados[r.id].componentes} componente(s). As paletes, os metros e o stock desta linha s\xE3o DELES \u2014 o artigo do kit \xE9 virtual no ERP (sem dimens\xF5es de palete e com stock negativo). Abre o chevron na descri\xE7\xE3o para os ver.`
        },
        "KIT"
      ))
    },
    {
      key: "descricao",
      label: "Descri\xE7\xE3o",
      width: 190,
      minWidth: 120,
      render: (r) => {
        const ag = agregados[r.id];
        if (!ag) return r.descricao || /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014");
        const aberto = kitsAbertos.has(r.id);
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { title: r.descricao }, r.descricao), ag.componentes > 0 ? /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn ghost icon-only sm cp-kit__abrir",
            "aria-expanded": aberto,
            title: aberto ? "Fechar os componentes" : `Ver os ${ag.componentes} componentes deste kit`,
            onClick: (ev) => {
              ev.stopPropagation();
              abrirKit(r.id, !aberto);
            }
          },
          /* @__PURE__ */ React.createElement(window.Ico.chevron, { style: { transform: aberto ? "none" : "rotate(-90deg)" } })
        ) : /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "cp-dim",
            title: "Este kit n\xE3o tem componentes nesta lista \u2014 ou ficaram fora da janela de datas, ou foram cortados por outro filtro da query. As paletes e o stock dele ficam por saber."
          },
          " ",
          "sem componentes"
        ), aberto && ag.componentes > 0 && /* @__PURE__ */ React.createElement(
          "ul",
          {
            className: "cp-kit__comps",
            onClick: (ev) => ev.stopPropagation(),
            draggable: false,
            onDragStart: (ev) => {
              ev.preventDefault();
              ev.stopPropagation();
            }
          },
          (kits.porKit[r.id] || []).map((c) => /* @__PURE__ */ React.createElement("li", { key: c.id }, /* @__PURE__ */ React.createElement("span", { className: "td-mono cp-pl-ref" }, c.ref), c.kitRazao ? /* @__PURE__ */ React.createElement(
            "span",
            {
              className: "cp-kit__razao",
              title: `${String(c.kitRazao).replace(".", ",")} por cada kit`
            },
            "\xD7",
            String(c.kitRazao).replace(".", ",")
          ) : /* @__PURE__ */ React.createElement(
            "span",
            {
              className: "cp-dim",
              title: "N\xE3o se sabe quantos deste componente leva um kit \u2014 a linha do K tem quantidade zero na encomenda."
            },
            "\xD7?"
          ), /* @__PURE__ */ React.createElement("span", { className: "cp-kit-desc", title: c.descricao }, c.descricao), /* @__PURE__ */ React.createElement("span", null, (c.qtdTotal || 0).toLocaleString("pt-PT"), " ", c.unidade || "un."), /* @__PURE__ */ React.createElement(
            "span",
            {
              className: `cp-qtd-stock${(c.qtdDisponivel || 0) >= (c.qtdTotal || 0) ? " is-ok" : ""}`,
              title: `${(c.qtdDisponivel || 0).toLocaleString("pt-PT")} em stock`
            },
            (c.qtdDisponivel || 0).toLocaleString("pt-PT"),
            " stk"
          ), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, c.paletes == null ? "\u2014 pal." : `${c.paletes} pal.`)))
        ));
      }
    },
    {
      key: "encomenda",
      label: "Encomenda",
      width: 96,
      minWidth: 80,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, r.encomenda)
    },
    {
      key: "qtdTotal",
      label: "Por entregar",
      width: 96,
      minWidth: 80,
      align: "right",
      // Num kit o que se mostra é um valor CALCULADO (kits, não unidades), por
      // isso a coluna declara-o: sem `sortValue` ordenaria pelo `qtdTotal` do
      // K, que não desce nunca, e os kits apareciam sempre por colocar.
      sortValue: (r) => {
        const pool = poolKits[r.id];
        if (!pool) return r.qtdTotal;
        return pool.sabe ? pool.kits : -1;
      },
      render: (r) => {
        const pool = poolKits[r.id];
        if (pool) {
          if (!pool.sabe) {
            return /* @__PURE__ */ React.createElement(
              "span",
              {
                className: "cp-porconfirmar",
                title: "N\xE3o se sabe quantos kits faltam: algum componente n\xE3o tem raz\xE3o conhecida, e trat\xE1-la como \xD71 inventava a composi\xE7\xE3o."
              },
              "\u2014"
            );
          }
          const dica = `${pool.total.toLocaleString("pt-PT")} kit(s) na encomenda, ${pool.atribuidos.toLocaleString("pt-PT")} j\xE1 em cargas` + (pool.excesso ? ` \u2014 ${pool.excesso.toLocaleString("pt-PT")} a MAIS do que a encomenda pede, o que num kit \xE9 leg\xEDtimo desde que a propor\xE7\xE3o esteja certa` : "") + ". Conta-se pelos componentes: o pior deles manda.";
          if (!pool.kits) {
            return /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: dica }, "0 ", /* @__PURE__ */ React.createElement("b", { className: "cp-marca-noutro-dia" }, pool.excesso ? "em cargas, com excesso" : "em cargas"));
          }
          return /* @__PURE__ */ React.createElement("span", { title: dica }, pool.kits.toLocaleString("pt-PT"), " ", /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "kits"), pool.atribuidos > 0 && /* @__PURE__ */ React.createElement("b", { className: "cp-marca-noutro-dia" }, " ", "+", pool.atribuidos.toLocaleString("pt-PT"), " em cargas"));
        }
        if (r.presaNoutroDia) {
          return /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: rotuloNoutrosDias(r) }, "0 ", /* @__PURE__ */ React.createElement("b", { className: "cp-marca-noutro-dia" }, "noutra carga"));
        }
        const resto = (r.noutrosDias || []).reduce((s2, x) => s2 + (Number(x.qtd) || 0), 0);
        if (!resto) return r.qtdTotal.toLocaleString("pt-PT");
        return /* @__PURE__ */ React.createElement("span", { title: rotuloNoutrosDias(r) }, r.qtdTotal.toLocaleString("pt-PT"), " ", /* @__PURE__ */ React.createElement("b", { className: "cp-marca-noutro-dia" }, "+", resto.toLocaleString("pt-PT"), " noutra carga"));
      }
    },
    {
      key: "qtdDisponivel",
      label: "Em stock",
      width: 84,
      minWidth: 70,
      align: "right",
      // **Ordena por um valor CALCULADO num kit, e por isso declara-o.** Sem
      // `sortValue` a coluna ordenaria por `row.qtdDisponivel` — que num K é
      // sempre 0 — e todos os kits caíam juntos no fundo, em silêncio.
      sortValue: (r) => {
        const ag = agregados[r.id];
        if (!ag) return r.qtdDisponivel;
        return ag.stockPior ? ag.stockPior.cobre : null;
      },
      render: (r) => {
        const ag = agregados[r.id];
        if (!ag) return r.qtdDisponivel.toLocaleString("pt-PT");
        if (!ag.stockPior) {
          return /* @__PURE__ */ React.createElement(
            "span",
            {
              className: "cp-dim",
              title: "N\xE3o se sabe quantos kits o stock cobre: nenhum componente desta lista soube responder."
            },
            "\u2014"
          );
        }
        const p = ag.stockPior;
        return /* @__PURE__ */ React.createElement("span", { title: `O stock cobre ${p.cobre.toLocaleString("pt-PT")} kit(s). Manda o componente PIOR coberto \u2014 ${p.ref}, com ${p.disponivel.toLocaleString("pt-PT")} em stock a \xD7${String(p.razao).replace(".", ",")} por kit. Um kit s\xF3 sai quando o que falta mais j\xE1 c\xE1 est\xE1.` + (ag.semRazao ? `

Aten\xE7\xE3o: ${ag.semRazao} componente(s) sem raz\xE3o conhecida \u2014 a cobertura pode ser menor do que esta.` : "") }, /* @__PURE__ */ React.createElement("b", null, p.cobre.toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " kits"), ag.semRazao > 0 && /* @__PURE__ */ React.createElement("b", { className: "cp-marca-noutro-dia" }, " +", ag.semRazao, "?"));
      }
    },
    {
      key: "paletes",
      label: "Paletes",
      width: 74,
      minWidth: 62,
      align: "right",
      // Mesma razão do `sortValue` acima: num kit as paletes são as dos
      // componentes, e `row.paletes` é sempre `null` (o K não tem `u_qtcxpl`).
      sortValue: (r) => {
        const ag = agregados[r.id];
        if (ag) return ag.componentes ? ag.paletes : null;
        return r.paletes == null ? null : r.paletes;
      },
      render: (r) => {
        const ag = agregados[r.id];
        if (ag) {
          if (!ag.componentes) {
            return /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Sem componentes nesta lista \u2014 as paletes do kit ficam por saber" }, "\u2014");
          }
          return /* @__PURE__ */ React.createElement("b", { title: `${ag.paletes} palete(s), somadas dos ${ag.componentes} componentes \u2014 o artigo do kit n\xE3o tem dimens\xF5es no ERP.` + (ag.semPaletes ? `
${ag.semPaletes} componente(s) sem quantidade por palete (st.u_qtcxpl): essas n\xE3o entram na soma.` : "") + (ag.semMedida ? `
${ag.semMedida} componente(s) sem dimens\xF5es de palete (st.usr4): contam para as paletes, n\xE3o para os metros.` : "") }, ag.paletes, ag.semPaletes > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " +", ag.semPaletes, "?"));
        }
        return r.paletes == null ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Sem quantidade por palete no ERP" }, "\u2014") : /* @__PURE__ */ React.createElement("b", { title: r.paleteTexto }, r.paletes);
      }
    },
    {
      key: "valor",
      label: "Valor",
      width: 92,
      minWidth: 76,
      align: "right",
      render: (r) => r.valor.toLocaleString("pt-PT", { style: "currency", currency: "EUR" })
    },
    {
      key: "dataFabrico",
      label: "Fabrico",
      width: 96,
      minWidth: 84,
      render: (r) => r.dataFabrico ? r.dataFabrico : /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Sem ordem de fabrico associada" }, "\u2014")
    },
    {
      key: "dia",
      label: "Data entrega",
      width: 116,
      minWidth: 100,
      render: (r) => {
        const cor = CL.corDaData(r, hoje);
        return /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `${r.vencida ? "cp-erro-txt" : ""}${cor ? ` cp-data--${cor}` : ""}`,
            title: r.alterada ? `Alterada por n\xF3s. No ERP: ${r.dataEntregaErp}` : void 0
          },
          r.dia,
          r.vencida ? " \u26A0" : "",
          r.alterada && /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--alt", title: `No ERP: ${r.dataEntregaErp}` }, "alt.")
        );
      }
    },
    {
      key: "observacoes",
      label: "Observa\xE7\xF5es",
      width: 170,
      minWidth: 120,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "cp-obs-cel", title: r.observacoes || "Sem observa\xE7\xF5es" }, r.observacoes || /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014"))
    },
    {
      key: "acoes",
      label: "",
      width: 34,
      minWidth: 34,
      sortable: false,
      render: (r) => /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost icon-only sm",
          title: "Editar data de entrega e observa\xE7\xF5es",
          onClick: (ev) => {
            ev.stopPropagation();
            setAEditar(r.id);
          }
        },
        /* @__PURE__ */ React.createElement(window.Ico.cog, null)
      )
    },
    {
      key: "acond",
      label: "Acond.",
      width: 96,
      minWidth: 80,
      sortable: false,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "cp-acond" }, r.cintadas && /* @__PURE__ */ React.createElement("span", { className: "cp-tag", title: "Caixas cintadas" }, "cint"), r.envolvidas && /* @__PURE__ */ React.createElement("span", { className: "cp-tag", title: "Caixas envolvidas" }, "env"), r.caixaAmostra && /* @__PURE__ */ React.createElement("span", { className: "cp-tag", title: "Leva caixa de amostra" }, "amos"), r.rotulosCliente && /* @__PURE__ */ React.createElement("span", { className: "cp-tag", title: "Leva r\xF3tulos do cliente" }, "r\xF3t"), r.quantidadeCerta && /* @__PURE__ */ React.createElement("span", { className: "cp-tag", title: "Quantidade certa" }, "qc"), !(r.cintadas || r.envolvidas || r.caixaAmostra || r.rotulosCliente || r.quantidadeCerta) && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014"))
    },
    { key: "armazemNome", label: "Origem", width: 120, minWidth: 96 }
  ], [selecao, entregas, hoje, agregados, poolKits, kitSemNada, kits, kitsAbertos, abrirKit]);
  const cabecalhoCliente = React.useCallback(({ rows }) => {
    const c = rows[0];
    const qtd = rows.reduce((s, r) => s + r.qtdTotal, 0);
    const valor = rows.reduce((s, r) => s + r.valor, 0);
    const comPal = rows.filter((r) => paleteDe(r) != null);
    const paletes = comPal.reduce((s, r) => s + paleteDe(r), 0);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "cp-grp",
        draggable: true,
        onDragStart: (ev) => arrastarLinhas(ev, rows),
        title: "Arrasta o cliente inteiro para a carga"
      },
      /* @__PURE__ */ React.createElement("span", { className: "cp-grp__nome" }, c.clienteNome),
      c.local && /* @__PURE__ */ React.createElement("span", { className: "cp-grp__local" }, c.local),
      agrupar === "cliente_morada" && c.morada && /* @__PURE__ */ React.createElement("span", { className: "cp-grp__morada", title: c.morada }, String(c.morada).replace(/^Desc\.:[^;]*;/, "").replace(/;/g, " \xB7 ").slice(0, 46)),
      kmDaRota[c.clienteId] != null && /* @__PURE__ */ React.createElement(
        "span",
        {
          className: `cp-grp__km${kmDaRota[c.clienteId] <= CP_PERTO_KM ? " is-perto" : ""}`,
          title: `Dist\xE2ncia em linha reta desta morada ao tra\xE7ado da carga selecionada \u2014 \xE9 um ind\xEDcio de \xABfica a caminho\xBB, n\xE3o o desvio real.` + (kmDoLocal && c.local && kmDoLocal[CL.normalizarLocal(c.local)] != null ? `
${c.local}: o cliente mais perto da rota est\xE1 a ${String(kmDoLocal[CL.normalizarLocal(c.local)]).replace(".", ",")} km, e \xE9 essa a dist\xE2ncia que ordena a localidade.` : "")
        },
        String(kmDaRota[c.clienteId]).replace(".", ","),
        " km da rota"
      ),
      c.clienteBloqueado && /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--bloq", title: c.estadoCliente }, "BLOQUEADO"),
      c.clienteVaiBloquear && /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--aviso", title: c.estadoCliente }, c.estadoCliente),
      c.clienteEstadoDesconhecido && /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "cp-tag cp-tag--porconfirmar",
          title: "O estado de cr\xE9dito deste cliente ainda n\xE3o chegou do ERP. N\xE3o quer dizer que esteja em ordem \u2014 quer dizer que ainda n\xE3o se sabe. Volta a abrir daqui a instantes."
        },
        "cr\xE9dito por confirmar"
      ),
      c.clienteVD && /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--vd", title: "Cliente VD" }, "VD"),
      /* @__PURE__ */ React.createElement("span", { className: "cp-grp__tot" }, rows.length, " linha(s) \xB7 ", qtd.toLocaleString("pt-PT"), " un.", comPal.length ? /* @__PURE__ */ React.createElement(React.Fragment, null, " \xB7 ", /* @__PURE__ */ React.createElement("b", null, paletes, " pal.")) : null, comPal.length < rows.length && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: `${rows.length - comPal.length} linha(s) sem quantidade por palete` }, " ", "(+", rows.length - comPal.length, " s/ pal.)"), " \xB7 ", /* @__PURE__ */ React.createElement("b", null, valor.toLocaleString("pt-PT", { style: "currency", currency: "EUR" }))),
      (c.horarios || c.obsCliente || c.obsMorada) && /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "cp-grp__logi",
          title: [c.horarios, c.obsCliente, c.obsMorada].filter(Boolean).join("\n")
        },
        /* @__PURE__ */ React.createElement(window.Ico.doc, null),
        " log\xEDstica"
      ),
      /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          title: "Adicionar o cliente inteiro \xE0 carga",
          onClick: (ev) => {
            ev.stopPropagation();
            onAdicionar(itensDe(rows));
          }
        },
        /* @__PURE__ */ React.createElement(window.Ico.plus, null)
      )
    );
  }, [onAdicionar, kmDaRota, kmDoLocal, agrupar, paleteDe]);
  const visiveis = React.useMemo(() => {
    let out = kits.soltas;
    const cob = (e) => {
      const ag = agregados[e.id];
      if (!ag) return { disponivel: e.qtdDisponivel || 0, total: e.qtdTotal || 0, sabe: true };
      return CL.coberturaDoKit(e, ag);
    };
    if (filtroStock === "com") out = out.filter((e) => {
      const c = cob(e);
      return c.sabe && c.disponivel > 0;
    });
    else if (filtroStock === "cobre") out = out.filter((e) => {
      const c = cob(e);
      return c.sabe && c.disponivel >= c.total;
    });
    else if (filtroStock === "sem") out = out.filter((e) => {
      const c = cob(e);
      return !(c.sabe && c.disponivel > 0);
    });
    const q = procura.trim().toLowerCase();
    if (q) {
      const campos = campoProcura === "todos" ? CP_CAMPOS_PROCURA.filter((c) => c.id !== "todos").map((c) => c.id) : [campoProcura];
      out = out.filter((e) => campos.some((c) => String(e[c] == null ? "" : e[c]).toLowerCase().includes(q)));
    }
    return out;
  }, [kits, agregados, filtroStock, procura, campoProcura, CL]);
  const escondidas = kits.soltas.length - visiveis.length;
  const cabecalhoEncomenda = React.useCallback(({ rows }) => {
    const cores = rows.map((r) => corDe(r));
    const cor = cores.every((c) => c === "stock") ? "stock" : cores.every((c) => c) ? "planeado" : "";
    const qtd = rows.reduce((s, r) => s + (r.qtdTotal || 0), 0);
    const valor = rows.reduce((s, r) => s + (r.valor || 0), 0);
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        className: `cp-sub${cor ? ` cp-sub--${cor}` : ""}`,
        draggable: true,
        onDragStart: (ev) => {
          ev.stopPropagation();
          arrastarLinhas(ev, rows);
        },
        title: "Arrasta a encomenda inteira para a carga"
      },
      /* @__PURE__ */ React.createElement("b", null, "Encomenda ", rows[0].encomenda),
      rows.some((r) => r.sos) && /* @__PURE__ */ React.createElement("span", { className: "cp-tag cp-tag--sos", title: "Encomenda SOS \u2014 urgente" }, "SOS"),
      /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, rows.length, " linha(s) \xB7 ", qtd.toLocaleString("pt-PT"), " un.", " \xB7 ", valor.toLocaleString("pt-PT", { style: "currency", currency: "EUR" })),
      rows[0].dataObra && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "OF ", rows[0].dataObra)
    );
  }, [dia, CL, corDe]);
  const sosPrimeiro = (a, b) => {
    const sos = (g) => g.rows.some((r) => r.sos) ? 1 : 0;
    return sos(b) - sos(a);
  };
  const ordemPorStock = React.useCallback((a, b) => {
    const s = sosPrimeiro(a, b);
    if (s) return s;
    const cobertura = (g) => {
      const total = g.rows.reduce((s2, r) => s2 + (r.qtdTotal || 0), 0);
      const disp = g.rows.reduce((s2, r) => s2 + Math.min(r.qtdDisponivel || 0, r.qtdTotal || 0), 0);
      return total > 0 ? disp / total : 0;
    };
    const d = cobertura(b) - cobertura(a);
    if (Math.abs(d) > 1e-3) return d;
    const valor = (g) => g.rows.reduce((s2, r) => s2 + (r.valor || 0), 0);
    return valor(b) - valor(a);
  }, []);
  const linhasComArtigo = React.useMemo(
    () => (entregas || []).filter((e) => !kitIds.has(e.id)),
    [entregas, kitIds]
  );
  const semPalete = linhasComArtigo.filter((e) => e.paletes == null).length;
  const emEdicao = (entregas || []).find((e) => e.id === aEditar) || null;
  const emVer = (entregas || []).find((e) => e.id === aVer) || null;
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: `panel cp-zona cp-zona--entregas ${sobre ? "is-sobre" : ""}`,
      "aria-label": "Entregas dispon\xEDveis",
      onDragOver: (ev) => {
        ev.preventDefault();
        setSobre(true);
      },
      onDragLeave: () => setSobre(false),
      onDrop: (ev) => {
        ev.preventDefault();
        setSobre(false);
        const p = window.CpDnd.ler(ev);
        if (p && p.k === "linha") onLargarDaCarga(p.entregaId);
        else if (p && p.k === "paragem" && onLargarCliente) onLargarCliente(p.clienteId);
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: "panel-h cp-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Entregas previstas at\xE9"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost icon-only sm", title: "Dia anterior", onClick: () => onDia(D.diaMais(dia, -1)) }, "\u2039"), /* @__PURE__ */ React.createElement(
      window.CpSeletorDia,
      {
        valor: dia,
        onMudar: onDia,
        feriados,
        ariaLabel: "Dia das entregas"
      }
    ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost icon-only sm", title: "Dia seguinte", onClick: () => onDia(D.diaMais(dia, 1)) }, "\u203A"), /* @__PURE__ */ React.createElement("div", { className: "cp-zona__h-fim" }, /* @__PURE__ */ React.createElement("div", { className: "search-input cp-procura" }, /* @__PURE__ */ React.createElement(window.Ico.search, null), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        value: procura,
        placeholder: "Escreve uma palavra\u2026",
        onChange: (e) => setProcura(e.target.value)
      }
    ), /* @__PURE__ */ React.createElement(
      "select",
      {
        value: campoProcura,
        onChange: (e) => setCampoProcura(e.target.value),
        title: "Onde procurar a palavra"
      },
      CP_CAMPOS_PROCURA.map((c) => /* @__PURE__ */ React.createElement("option", { key: c.id, value: c.id }, c.label))
    )), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: `btn ghost sm${mostrarNaoCarga ? " is-on" : ""}`,
        "aria-pressed": !!mostrarNaoCarga,
        title: "Ferramentas e portes n\xE3o s\xE3o mercadoria a carregar: ficam escondidos por omiss\xE3o",
        onClick: () => onMostrarNaoCarga && onMostrarNaoCarga(!mostrarNaoCarga)
      },
      "Mostrar ferramentas e portes",
      nNaoCarga ? ` (${nNaoCarga})` : ""
    ), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select cp-chip-select",
        value: filtroStock,
        onChange: (e) => setFiltroStock(e.target.value),
        title: "Filtrar por stock"
      },
      CP_FILTROS_STOCK.map((f) => /* @__PURE__ */ React.createElement("option", { key: f.id, value: f.id }, f.label))
    ), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select cp-chip-select",
        value: agrupar,
        onChange: (e) => setAgrupar(e.target.value),
        title: "Como agrupar a lista"
      },
      Object.entries(CP_AGRUPAR).map(([id, a]) => /* @__PURE__ */ React.createElement("option", { key: id, value: id }, "Agrupar: ", a.label))
    ), /* @__PURE__ */ React.createElement("span", { className: "cp-ordem-clientes", role: "group", "aria-label": "Ordem dos clientes" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: `btn ghost sm${porRota ? " is-on" : ""}`,
        disabled: !temRota,
        title: temRota ? "Clientes agrupados por localidade, com a localidade mais perto do tra\xE7ado \xE0 frente" : "Sem carga selecionada n\xE3o h\xE1 rota para medir",
        onClick: () => setOrdemClientes("rota")
      },
      "Por rota"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: `btn ghost sm${porRota ? "" : " is-on"}`,
        title: "Clientes pela ordem da lista (a coluna que estiver a ordenar)",
        onClick: () => setOrdemClientes("lista")
      },
      "Por lista"
    )), selecao.size > 0 && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
      onAdicionar(itensDe(entregas.filter((e) => selecao.has(e.id))));
      setSelecao(/* @__PURE__ */ new Set());
    } }, "Adicionar ", selecao.size, " \xE0 carga"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost icon-only sm", title: "Recarregar do ERP", onClick: onRecarregar }, /* @__PURE__ */ React.createElement(window.Ico.refresh, null))), /* @__PURE__ */ React.createElement(window.CpNotaDiaUtil, { dia, feriados })),
    erro && /* @__PURE__ */ React.createElement("div", { className: "cp-aviso", role: "status" }, /* @__PURE__ */ React.createElement("span", null, erro), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: onRecarregar }, "Tentar outra vez")),
    !erro && /* @__PURE__ */ React.createElement("div", { className: "cp-legenda", role: "note" }, /* @__PURE__ */ React.createElement("span", { className: "cp-legenda__cor cp-legenda__cor--stock" }), " stock cobre a linha", /* @__PURE__ */ React.createElement("span", { className: "cp-legenda__cor cp-legenda__cor--planeado" }), " fabrico aberto at\xE9 ao dia", escondidas > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-legenda__fora" }, escondidas, " linha(s) fora pelo filtro")),
    semPalete > 0 && !erro && /* @__PURE__ */ React.createElement("div", { className: "cp-nota-paletes" }, semPalete, " de ", linhasComArtigo.length, " linhas n\xE3o t\xEAm quantidade por palete no ERP (", /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, "st.u_qtcxpl"), ") \u2014 para essas, as paletes ficam por saber e n\xE3o entram na ocupa\xE7\xE3o do cami\xE3o."),
    /* @__PURE__ */ React.createElement("div", { className: "cp-zona__body cp-zona__body--lista" }, React.createElement(window.HubList.List, {
      appLabel: "cargoplanner",
      viewId: "entregas",
      columns: colunas,
      data: visiveis,
      rowKey: (r) => r.id,
      // Clicar na linha abre o detalhe. Não colide com nada: selecionar é
      // pela caixa, arrastar é com o rato em movimento, e editar a data
      // continua no ⚙ — que faz `stopPropagation` para não abrir os dois.
      onRowClick: (r) => setAVer(r.id),
      // A linha inteira arrasta — a coluna de pega continua lá para quem
      // já lhe apanhou o jeito, mas agarrar a linha em qualquer sítio é o
      // que toda a gente tenta primeiro.
      onRowDragStart: (ev, r) => {
        if (r.presaNoutroDia || kitSemNada(r)) {
          ev.preventDefault();
          return;
        }
        const linhas = selecao.has(r.id) && selecao.size > 1 ? entregas.filter((e) => selecao.has(e.id) && !e.presaNoutroDia && !kitSemNada(e)) : [r];
        arrastarLinhas(ev, linhas);
      },
      // Verde: o stock cobre a linha. Amarelo: há OF aberta até ao dia.
      // A regra é do `logica.corDaLinha`, aqui só se pinta. Num KIT a
      // pergunta é a mesma e a resposta vem dos COMPONENTES — `corDe` é o
      // único sítio que decide qual das duas regras vale.
      rowClassName: (r) => {
        const cor = corDe(r);
        return cor ? `cp-linha--${cor}` : void 0;
      },
      // Agrupado por cliente: o cabeçalho leva a informação do cliente, as
      // linhas os produtos. O HubList NÃO pagina listas agrupadas (agrupar
      // e paginar partia grupos entre páginas) — foi a troca aceite para
      // ter o cliente em cima.
      groupBy: CP_AGRUPAR[agrupar].chave,
      groupHeader: cabecalhoCliente,
      // Dentro do cliente, por encomenda: é o que sai junto, e leva a
      // mesma lógica de cores das linhas.
      subGroupBy: agrupar === "encomenda" ? void 0 : (r) => r.encomenda,
      subGroupHeader: agrupar === "encomenda" ? void 0 : cabecalhoEncomenda,
      // Os grupos (clientes) ordenam-se por proximidade à rota; as linhas
      // dentro de cada um continuam a seguir a coluna que estiver ativa.
      groupOrder: porRota ? (a, b) => sosPrimeiro(a, b) || CL.ordemPorProximidade(kmDaRota, localDoCliente)(a, b) : camiaoVazio ? ordemPorStock : sosPrimeiro,
      initialSort: [{ key: "dia", dir: "asc" }],
      selectable: true,
      selection: selecao,
      onSelection: setSelecao,
      fetchDeps: [dia, agrupar, filtroStock],
      empty: aCarregar ? "A ler as entregas do ERP\u2026" : "Nenhuma entrega por satisfazer at\xE9 este dia."
    })),
    emVer && /* @__PURE__ */ React.createElement(
      window.CpEntregaModal,
      {
        entrega: emVer,
        cargas,
        ondas,
        dadosOndas,
        onFechar: () => setAVer(null)
      }
    ),
    emEdicao && /* @__PURE__ */ React.createElement(
      CpEditarLinhaModal,
      {
        linha: emEdicao,
        onFechar: () => setAEditar(null),
        onGuardar: (dados) => {
          onGuardarLinha(emEdicao.id, dados);
          setAEditar(null);
        }
      }
    )
  );
}
function CpEditarLinhaModal({ linha, onFechar, onGuardar }) {
  const [data, setData] = React.useState(linha.dia || "");
  const [obs, setObs] = React.useState(linha.observacoes || "");
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: `${linha.ref} \u2014 ${linha.clienteNome}`,
      subtitle: "Guardado no planeador. O ERP n\xE3o \xE9 alterado.",
      width: 520,
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          onClick: () => onGuardar({ data_entrega: data || null, observacoes: obs })
        },
        "Guardar"
      ))
    },
    /* @__PURE__ */ React.createElement("div", { className: "cp-form" }, /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Data de entrega"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "cp-select",
        type: "date",
        value: data,
        onChange: (e) => setData(e.target.value)
      }
    ), /* @__PURE__ */ React.createElement("small", { className: "cp-dim" }, "No ERP: ", linha.dataEntregaErp || "\u2014")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Fabrico (ERP)"), /* @__PURE__ */ React.createElement("input", { className: "cp-select", value: linha.dataFabrico || "\u2014", disabled: true })), /* @__PURE__ */ React.createElement("label", { className: "field cp-form__wide" }, /* @__PURE__ */ React.createElement("span", null, "Observa\xE7\xF5es"), /* @__PURE__ */ React.createElement(
      "textarea",
      {
        className: "cp-select",
        rows: 4,
        value: obs,
        onChange: (e) => setObs(e.target.value)
      }
    )))
  );
}
function CpArtigosCarga({ carga, dados, paragens, ocupacao, onRemover, onQtd, onAdicionar }) {
  const [sobre, setSobre] = React.useState(false);
  const [abertos, setAbertos] = React.useState(() => /* @__PURE__ */ new Set());
  const nArtigos = paragens.reduce((s, p) => s + p.artigos.length, 0);
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: `panel cp-zona cp-zona--carrinho ${sobre ? "is-sobre" : ""} ${ocupacao.excedeu ? "is-cheio" : ""}`,
      "aria-label": "Artigos adicionados \xE0 carga",
      onDragOver: (ev) => {
        ev.preventDefault();
        setSobre(true);
      },
      onDragLeave: () => setSobre(false),
      onDrop: (ev) => {
        ev.preventDefault();
        setSobre(false);
        const p = window.CpDnd.ler(ev);
        if (p && p.k === "artigos") onAdicionar(p.itens);
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: "panel-h cp-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Artigos j\xE1 adicionados \xE0 carga"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "(ordem de entrega) \xB7 ", nArtigos, " artigo(s) \xB7 ", ocupacao.ocupadas, " paletes")),
    /* @__PURE__ */ React.createElement("div", { className: "cp-carrinho" }, paragens.map((p) => {
      const aberto = abertos.has(p.clienteId);
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: p.clienteId,
          className: "cp-carrinho__card",
          style: { "--cp-cor": p.cliente.cor }
        },
        /* @__PURE__ */ React.createElement("div", { className: "cp-carrinho__h", onClick: () => setAbertos((s) => {
          const n = new Set(s);
          if (n.has(p.clienteId)) n.delete(p.clienteId);
          else n.add(p.clienteId);
          return n;
        }) }, /* @__PURE__ */ React.createElement("span", { className: "cp-pin cp-pin--sm", style: { background: p.cliente.cor } }, p.ordem), /* @__PURE__ */ React.createElement("span", { className: "cp-carrinho__nome" }, p.cliente.id, " \u2014 ", p.cliente.local), /* @__PURE__ */ React.createElement("span", { className: "cp-carrinho__pal" }, p.paletes, " paletes"), /* @__PURE__ */ React.createElement(window.Ico.chevron, { style: { transform: aberto ? "none" : "rotate(-90deg)" } })),
        /* @__PURE__ */ React.createElement("div", { className: "cp-carrinho__refs" }, p.artigos.map((a) => a.entrega.ref).join(", ")),
        aberto && /* @__PURE__ */ React.createElement("ul", { className: "cp-carrinho__linhas" }, p.artigos.map((a) => /* @__PURE__ */ React.createElement(
          "li",
          {
            key: a.entrega.id,
            draggable: true,
            onDragStart: (ev) => window.CpDnd.escrever(ev, { k: "linha", entregaId: a.entrega.id }),
            title: "Arrasta de volta para as entregas para retirar"
          },
          /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, a.entrega.ref),
          /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, a.entrega.descricao),
          /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "cp-qtd",
              type: "number",
              min: "0",
              step: "1",
              value: a.qtd,
              "aria-label": `Quantidade de ${a.entrega.ref}`,
              onChange: (ev) => onQtd(a.entrega.id, Number(ev.target.value))
            }
          ),
          /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "un."),
          /* @__PURE__ */ React.createElement("span", { className: "cp-carrinho__pal" }, a.paletes, " pal."),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn ghost icon-only sm",
              title: "Retirar da carga",
              onClick: () => onRemover(a.entrega.id)
            },
            /* @__PURE__ */ React.createElement(window.Ico.close, null)
          )
        )))
      );
    }), !paragens.length && /* @__PURE__ */ React.createElement("div", { className: "cp-vazio cp-vazio--drop" }, "Solta aqui artigos ou um cliente inteiro."))
  );
}
function CpOcupacaoCamiao({ ocupacao, camiao, compacto }) {
  const L = window.CargoplannerLogica;
  const emMetros = ocupacao.metrosCapacidade > 0 && ocupacao.metros > 0;
  const total = emMetros ? Math.max(ocupacao.metrosCapacidade, ocupacao.metros) : Math.max(ocupacao.capacidade, ocupacao.ocupadas) || 1;
  const excedeu = ocupacao.excedeu || ocupacao.metrosExcedeu;
  const livre = emMetros ? ocupacao.metrosDisponiveis : ocupacao.disponiveis;
  const corpo = /* @__PURE__ */ React.createElement("div", { className: `cp-camiao-viz ${compacto ? "is-compacto" : ""}` }, /* @__PURE__ */ React.createElement("div", { className: "cp-camiao-viz__eixo" }, /* @__PURE__ */ React.createElement("span", null, "\u2190 Fundo (\xFAltima entrega)"), /* @__PURE__ */ React.createElement("span", null, "Primeira entrega (porta / descarga) \u2192")), /* @__PURE__ */ React.createElement("div", { className: "cp-camiao-viz__corpo" }, /* @__PURE__ */ React.createElement("div", { className: "cp-camiao-viz__cabine", title: "Cabine", "aria-hidden": "true" }, /* @__PURE__ */ React.createElement(window.Ico.warehouse, null)), /* @__PURE__ */ React.createElement("div", { className: `cp-camiao-viz__caixa ${excedeu ? "is-cheio" : ""}` }, ocupacao.segmentos.map((s) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: s.clienteId,
      className: "cp-camiao-viz__seg",
      style: { background: s.cor, flexGrow: emMetros ? s.metros || 0.01 : s.paletes },
      title: `${s.cliente.nome} \u2014 ${s.paletes} paletes \xB7 ${L.metrosTexto(s.metros)} m \u2014 ${s.pct}% \xB7 entrega n\xBA ${s.ordemEntrega}, carregado em ${s.posicaoCarga}\xBA`
    },
    /* @__PURE__ */ React.createElement("b", null, (s.cliente.nome || String(s.cliente.id)).split(/[ ,]/)[0].slice(0, 10)),
    /* @__PURE__ */ React.createElement("span", null, emMetros ? `${L.metrosTexto(s.metros)} m` : `${s.paletes} pal.`),
    /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "(", s.pct, "%)")
  )), livre > 0 && /* @__PURE__ */ React.createElement("div", { className: "cp-camiao-viz__livre", style: { flexGrow: livre } }, emMetros ? `${L.metrosTexto(livre)} m livres` : `${livre} livres`), !ocupacao.segmentos.length && /* @__PURE__ */ React.createElement("div", { className: "cp-camiao-viz__livre", style: { flexGrow: total } }, "Vazio"))), /* @__PURE__ */ React.createElement("div", { className: "cp-camiao-viz__totais" }, /* @__PURE__ */ React.createElement("span", null, "Total ", /* @__PURE__ */ React.createElement("b", null, L.metrosTexto(ocupacao.metrosCapacidade), " m")), /* @__PURE__ */ React.createElement("span", { className: excedeu ? "cp-erro-txt" : "" }, "Ocupado ", /* @__PURE__ */ React.createElement("b", null, L.metrosTexto(ocupacao.metros), " m (", ocupacao.metrosPct, "%)"), /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", ocupacao.ocupadas, " pal.")), /* @__PURE__ */ React.createElement("span", null, "Livre ", /* @__PURE__ */ React.createElement("b", null, L.metrosTexto(ocupacao.metrosDisponiveis), " m")), ocupacao.semMedida > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: L.textoSemMedida(ocupacao) }, "+", ocupacao.semMedida, " s/ medida"), excedeu && /* @__PURE__ */ React.createElement("span", { className: "cp-erro-txt" }, "Excede o cami\xE3o \u2014 a carga n\xE3o pode ser confirmada.")));
  if (compacto) return corpo;
  return /* @__PURE__ */ React.createElement("section", { className: "panel cp-zona cp-zona--camiao", "aria-label": "Ocupa\xE7\xE3o do cami\xE3o" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h cp-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Ocupa\xE7\xE3o do cami\xE3o (previs\xE3o)"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, camiao ? `${camiao.id} \xB7 ${camiao.matricula}` : "\u2014")), corpo);
}
window.CpEntregas = CpEntregas;
window.CpArtigosCarga = CpArtigosCarga;
window.CpOcupacaoCamiao = CpOcupacaoCamiao;
window.CpDispCores = CP_DISP_CORES;
function CpEntregaModal({ entrega, cargas, ondas, dadosOndas, onFechar }) {
  const L = window.CargoplannerLogica;
  const hoje = window.CargoplannerDados.hoje();
  const e = entrega || {};
  const n = (v) => (Number(v) || 0).toLocaleString("pt-PT");
  const m = (v) => `${(Number(v) || 0).toFixed(2).replace(".", ",")} m`;
  const clientePhc = L.clienteIdDaEntrega(e);
  const destinos = React.useMemo(
    () => L.destinosDaEntrega(e.id, cargas, ondas, dadosOndas, clientePhc),
    [e.id, cargas, ondas, dadosOndas, clientePhc, L]
  );
  const notas = [
    ["Hor\xE1rio de descarga", e.horarios, "do cliente, no PHC (`c_logobs`)"],
    ["Observa\xE7\xF5es da linha", e.obsLinha, "desta linha de encomenda"],
    ["Observa\xE7\xF5es do cliente", e.obsCliente, "valem para todas as entregas deste cliente"],
    ["Observa\xE7\xF5es da morada", e.obsMorada, "valem para esta morada de descarga"]
  ].filter(([, v]) => v && String(v).trim());
  const acond = [
    e.cintadas && "Cintadas",
    e.envolvidas && "Envolvidas",
    e.caixaAmostra && "Caixa de amostra",
    e.rotulosCliente && "R\xF3tulos do cliente",
    e.quantidadeCerta && "Quantidade certa"
  ].filter(Boolean);
  const temQtdErp = e.qtdErp != null;
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: `${e.ref || "\u2014"} \u2014 ${e.descricao || "sem descri\xE7\xE3o"}`,
      subtitle: `${e.clienteNome || "\u2014"} \xB7 encomenda ${e.encomenda || "\u2014"}`,
      width: 720,
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Fechar")
    },
    /* @__PURE__ */ React.createElement("div", { className: "cp-det" }, /* @__PURE__ */ React.createElement(window.CpSeccaoDetalhe, { titulo: "Quantidades" }, temQtdErp && /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Por entregar (ERP)",
        nota: "o que a encomenda ainda n\xE3o entregou"
      },
      n(e.qtdErp),
      " ",
      e.unidade || "un."
    ), temQtdErp && e.qtdAtribuida > 0 && /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "J\xE1 em cami\xF5es",
        nota: "repartido pelas cargas abaixo"
      },
      n(e.qtdAtribuida),
      " ",
      e.unidade || "un."
    ), /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Por atribuir",
        nota: temQtdErp && e.qtdAtribuida > 0 ? "\xE9 ESTE o n\xFAmero que a coluna \xABPor entregar\xBB da lista mostra" : null
      },
      /* @__PURE__ */ React.createElement("b", null, n(e.qtdTotal)),
      " ",
      e.unidade || "un."
    ), /* @__PURE__ */ React.createElement(window.CpLinhaDetalhe, { label: "Em stock" }, n(e.qtdDisponivel)), e.qtdPrevista > 0 && /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Por produzir",
        nota: e.dataFabrico ? `OF aberta a ${e.dataFabrico}` : "sem OF aberta conhecida"
      },
      n(e.qtdPrevista)
    ), /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Paletes",
        nota: e.unPorPalete ? `${n(e.unPorPalete)} ${e.unidade || "un."} por palete` : "o ERP n\xE3o diz quantas unidades leva uma palete (`st.u_qtcxpl` vazio)"
      },
      e.paletes == null ? /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "n\xE3o se sabe") : e.paletes
    ), e.valor > 0 && /* @__PURE__ */ React.createElement(window.CpLinhaDetalhe, { label: "Valor da mercadoria" }, `${Number(e.valor).toFixed(2).replace(".", ",")} \u20AC`)), /* @__PURE__ */ React.createElement(
      window.CpSeccaoDetalhe,
      {
        titulo: "Onde j\xE1 est\xE1, e quem a prepara",
        vazio: destinos.length ? null : "Ainda n\xE3o est\xE1 em cami\xE3o nenhum \u2014 arrasta-a para uma carga."
      },
      destinos.map((d) => /* @__PURE__ */ React.createElement(
        window.CpLinhaDetalhe,
        {
          key: d.cargaId,
          label: d.viagem > 1 ? `${d.camiaoId} \xB7 ${d.viagem}\xAA` : d.camiaoId,
          nota: d.dia
        },
        n(d.qtd),
        " ",
        e.unidade || "un.",
        " \u2014 ",
        d.pessoa ? /* @__PURE__ */ React.createElement("b", null, d.pessoa.nome) : d.onda ? /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "onda ", d.onda.codigo, ", ainda sem ningu\xE9m") : /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "sem onda de prepara\xE7\xE3o"),
        d.janela && /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "cp-dim",
            title: "Chegada combinada por quem planeia \u2014 ganha \xE0 hora calculada pela rota."
          },
          " \xB7 chega ",
          L.textoDaJanela(d.janela),
          " (combinada)"
        )
      ))
    ), /* @__PURE__ */ React.createElement(window.CpSeccaoDetalhe, { titulo: "Artigo" }, /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Refer\xEAncia",
        nota: e.primeiraEntrega ? "NUNCA entreg\xE1mos esta refer\xEAncia \u2014 \xE9 onde as coisas correm mal" : e.nEntregas ? `${e.nEntregas} entrega(s) anteriores` : null
      },
      e.ref || "\u2014"
    ), e.refCliente && /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Ref. do cliente",
        nota: "\xE9 por esta que ele trata o artigo"
      },
      e.refCliente
    ), /* @__PURE__ */ React.createElement(window.CpLinhaDetalhe, { label: "Origem" }, e.armazemNome || "\u2014"), e.codigo && /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "C\xF3digo de barras",
        nota: "o mesmo que sai na etiqueta da linha"
      },
      e.codigo
    ), /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Palete",
        nota: e.paleteTexto ? `do ERP: \xAB${e.paleteTexto}\xBB` : "o ERP n\xE3o traz medidas"
      },
      e.paleteLargura && e.paleteProfundidade ? `${m(e.paleteLargura)} \xD7 ${m(e.paleteProfundidade)}${e.paleteTipo ? ` (${e.paleteTipo})` : ""}` : /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "sem medidas")
    ), /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Altura da palete",
        nota: e.paleteAlturaTexto ? `do ERP: \xAB${e.paleteAlturaTexto}\xBB` : "vazia em 78 % dos artigos \u2014 a\xED conta-se UMA camada, nunca mais"
      },
      e.paleteAltura ? m(e.paleteAltura) : /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "n\xE3o se sabe")
    ), acond.length > 0 && /* @__PURE__ */ React.createElement(window.CpLinhaDetalhe, { label: "Acondicionamento" }, acond.join(" \xB7 "))), /* @__PURE__ */ React.createElement(window.CpSeccaoDetalhe, { titulo: "Entrega" }, /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Data",
        nota: e.alterada && e.dataEntregaErp ? `alterada por n\xF3s \u2014 no ERP era ${e.dataEntregaErp}` : e.dia && hoje && String(e.dia) < String(hoje) ? "atrasada \u2014 j\xE1 passou" : null
      },
      e.dia || "\u2014"
    ), /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Cliente",
        nota: e.clienteVD ? "cliente VD" : null
      },
      e.clienteNome || "\u2014"
    ), /* @__PURE__ */ React.createElement(
      window.CpLinhaDetalhe,
      {
        label: "Morada",
        nota: e.precisao && e.precisao !== "address" ? `localizada s\xF3 ao n\xEDvel \xAB${e.precisao}\xBB \u2014 a rota passa por um ponto ALGURES na zona, n\xE3o pela porta` : null
      },
      e.morada || "\u2014"
    ), !L.temCoords(e) && /* @__PURE__ */ React.createElement("p", { className: "cp-det__aviso" }, "Sem coordenadas: esta paragem n\xE3o entra no percurso nem no pre\xE7o. O que falta corrigir \xE9 a ", /* @__PURE__ */ React.createElement("b", null, "morada no ERP"), "."), (e.clienteBloqueado || e.clienteVaiBloquear || e.sos) && /* @__PURE__ */ React.createElement("p", { className: "cp-det__aviso" }, e.sos && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, "Encomenda SOS"), " \u2014 passa \xE0 frente de tudo.", /* @__PURE__ */ React.createElement("br", null)), e.estadoCliente)), /* @__PURE__ */ React.createElement(
      window.CpSeccaoDetalhe,
      {
        titulo: "Notas e log\xEDstica",
        vazio: notas.length ? null : "Sem observa\xE7\xF5es no ERP para esta linha."
      },
      notas.map(([label, valor, origem]) => /* @__PURE__ */ React.createElement(window.CpLinhaDetalhe, { key: label, label, nota: origem }, valor))
    ))
  );
}
window.CpEntregaModal = CpEntregaModal;

// ===== cargoplanner/frontend/cargoplanner_ligacao.jsx =====
function CpSinalAoVivo({ ligacoes }) {
  const L = window.CargoplannerLogica;
  const [agora, setAgora] = React.useState(() => Date.now());
  const saude = L.saudeDaLigacao(ligacoes, agora);
  React.useEffect(() => {
    if (saude.vivo) return void 0;
    setAgora(Date.now());
    const relogio = setInterval(() => setAgora(Date.now()), 3e4);
    return () => clearInterval(relogio);
  }, [saude.vivo]);
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: `cp-ligacao ${saude.vivo ? "cp-ligacao--vivo" : "cp-ligacao--morto"}`,
      role: "status",
      title: saude.vivo ? "O ecr\xE3 est\xE1 ligado ao servidor: o que aqui aparece \xE9 de agora." : "Sem liga\xE7\xE3o ao servidor. A idade \xE9 a do \xFAltimo sinal \u2014 a \xFAltima mensagem recebida ou a \xFAltima leitura completa \u2014, n\xE3o a do momento em que a liga\xE7\xE3o caiu. Volta sozinho, e ao voltar rel\xEA o dia."
    },
    /* @__PURE__ */ React.createElement("span", { className: "cp-ligacao__ponto", "aria-hidden": "true" }),
    saude.texto
  );
}
window.CpSinalAoVivo = CpSinalAoVivo;

// ===== cargoplanner/frontend/cargoplanner.jsx =====
function cpMesmaRecolha(a, b) {
  if (!a || !b) return false;
  if (a.id != null && b.id != null) return a.id === b.id;
  return a.nome === b.nome && (a.referencia || "") === (b.referencia || "") && (a.morada || "") === (b.morada || "") && a.ordem === b.ordem;
}
function CpCargasView({
  entidade,
  params,
  navigate,
  onCargaConfirmada,
  onCargaMudou,
  onPreparador,
  registerLeaveGuard,
  ondas,
  dadosOndas,
  ligacaoShell,
  entregasGuardadas
}) {
  const D = window.CargoplannerDados;
  const L = window.CargoplannerLogica;
  const OL = window.OndasLogica;
  const [base] = React.useState(() => D.criar(D.hoje()));
  const [cargas, setCargas] = React.useState([]);
  const [camioes, setCamioes] = React.useState([]);
  const [tipos, setTipos] = React.useState([]);
  const [transportadoras, setTransportadoras] = React.useState([]);
  const [tarifas, setTarifas] = React.useState([]);
  const [unidades, setUnidades] = React.useState([]);
  const [cais, setCais] = React.useState([]);
  const [periodos, setPeriodos] = React.useState([]);
  const [parametrosPreparacao, setParametrosPreparacao] = React.useState(null);
  const [frotaEstado, setFrotaEstado] = React.useState({ aCarregar: true, erro: null });
  const [modalCamiao, setModalCamiao] = React.useState(false);
  const [modalRecolha, setModalRecolha] = React.useState(false);
  const [modalAmostra, setModalAmostra] = React.useState(false);
  const ateDoUrl = params && params.get && params.get("ate") || D.diaUtilMais(base.diaBase, 5);
  const guardadaAoMontar = React.useRef(
    L.entregasGuardadas(entregasGuardadas && entregasGuardadas.current, ateDoUrl)
  );
  const [entregasTodas, setEntregasErp] = React.useState(() => guardadaAoMontar.current || []);
  const mostrarNaoCarga = !!(params && params.get && params.get("naocarga") === "1");
  const entregasErp = React.useMemo(
    () => window.CargoplannerLogica.entregasVisiveis(entregasTodas, mostrarNaoCarga),
    [entregasTodas, mostrarNaoCarga]
  );
  const [entregasDe, setEntregasDe] = React.useState(
    () => guardadaAoMontar.current ? ateDoUrl : null
  );
  const [atribuidoMapa, setAtribuidoMapa] = React.useState(null);
  const [feriados, setFeriados] = React.useState([]);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.feriados().then((r) => {
      if (vivo) setFeriados(r || []);
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, []);
  const [entregasEstado, setEntregasEstado] = React.useState(
    () => ({ aCarregar: !guardadaAoMontar.current, erro: null })
  );
  const [recarga, setRecarga] = React.useState(0);
  const [recargaAtribuido, setRecargaAtribuido] = React.useState(0);
  const [aviso, setAviso] = React.useState(null);
  const dia = params && params.get && params.get("dia") || base.diaBase;
  const ate = ateDoUrl;
  const camiaoSel = entidade || camioes[0] && camioes[0].id;
  const viagemSel = Math.max(1, Number(params && params.get("viagem")) || 1);
  React.useEffect(() => {
    if (recarga === 0 && guardadaAoMontar.current) {
      guardadaAoMontar.current = null;
      return void 0;
    }
    guardadaAoMontar.current = null;
    let vivo = true;
    setEntregasEstado({ aCarregar: true, erro: null });
    window.CargoplannerAPI.entregas(ate).then((r) => {
      if (!vivo) return;
      setEntregasErp(r && r.entregas || []);
      setEntregasDe(ate);
      setEntregasEstado({ aCarregar: false, erro: null });
    }).catch((err) => {
      if (!vivo) return;
      if (entregasGuardadas) entregasGuardadas.current = null;
      setEntregasErp([]);
      setEntregasDe(null);
      setEntregasEstado({
        aCarregar: false,
        erro: window.CargoplannerAPI.erroMensagem(err, "N\xE3o foi poss\xEDvel ler as entregas do ERP.")
      });
    });
    return () => {
      vivo = false;
    };
  }, [ate, recarga, entregasGuardadas]);
  React.useEffect(() => {
    if (entregasGuardadas && entregasDe) {
      entregasGuardadas.current = { ate: entregasDe, entregas: entregasTodas };
    }
  }, [entregasGuardadas, entregasDe, entregasTodas]);
  React.useEffect(() => {
    if (!entregasErp.length) {
      setAtribuidoMapa({});
      return void 0;
    }
    let vivo = true;
    window.CargoplannerAPI.atribuido(entregasErp.map((e) => e.id)).then((r) => {
      if (vivo) setAtribuidoMapa(r && r.atribuido || {});
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, [entregasErp, dia, recargaAtribuido]);
  const [recargaFrota, setRecargaFrota] = React.useState(0);
  React.useEffect(() => {
    let vivo = true;
    setFrotaEstado({ aCarregar: true, erro: null });
    Promise.all([
      window.CargoplannerAPI.tirs({ ativos: 1 }),
      window.CargoplannerAPI.tiposTir(),
      window.CargoplannerAPI.unidades({ ativos: 1 })
    ]).then(([frota, catalogo, us]) => {
      if (!vivo) return;
      setCamioes(frota.map(L.camiaoDoTir));
      setTipos(catalogo);
      setUnidades((us || []).map((u) => ({
        id: u.codigo,
        nome: u.nome,
        local: u.local,
        morada: u.morada,
        cp: u.codigo_postal,
        lat: u.lat,
        lng: u.lng
      })));
      setFrotaEstado({ aCarregar: false, erro: null });
    }).catch((err) => {
      if (!vivo) return;
      setCamioes([]);
      setFrotaEstado({
        aCarregar: false,
        erro: window.CargoplannerAPI.erroMensagem(err, "N\xE3o foi poss\xEDvel ler a frota.")
      });
    });
    return () => {
      vivo = false;
    };
  }, [recargaFrota, L]);
  React.useEffect(() => {
    let vivo = true;
    Promise.all([
      window.CargoplannerAPI.transportadoras({ ativos: 1 }),
      window.CargoplannerAPI.tarifas()
    ]).then(([fs, ts]) => {
      if (!vivo) return;
      setTransportadoras(fs || []);
      setTarifas((ts || []).map(L.tarifaDoServidor));
    }).catch(() => {
      if (!vivo) return;
      setTransportadoras([]);
      setTarifas([]);
    });
    return () => {
      vivo = false;
    };
  }, [recargaFrota, L]);
  const [ligacaoCargas, setLigacaoCargas] = React.useState(
    { ligada: false, ultimoSinalMs: null }
  );
  const [recargaDia, setRecargaDia] = React.useState(0);
  const ultimoSinal = React.useRef(null);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.cargas(dia).then((r) => {
      if (!vivo) return;
      setCargas((r || []).map(L.cargaDoServidor));
      ultimoSinal.current = Date.now();
    }).catch(() => {
      if (vivo) setCargas([]);
    });
    return () => {
      vivo = false;
    };
  }, [dia, L, recargaDia]);
  const [gravacao, setGravacao] = React.useState({ estado: "limpo", erro: null, conflito: null });
  const gravacaoRef = React.useRef(gravacao);
  React.useEffect(() => {
    gravacaoRef.current = gravacao;
  }, [gravacao]);
  const cargasRef = React.useRef(cargas);
  const camioesRef = React.useRef(camioes);
  React.useEffect(() => {
    cargasRef.current = cargas;
  }, [cargas]);
  React.useEffect(() => {
    camioesRef.current = camioes;
  }, [camioes]);
  const camiaoSelRef = React.useRef(camiaoSel);
  const viagemSelRef = React.useRef(viagemSel);
  React.useEffect(() => {
    camiaoSelRef.current = camiaoSel;
  }, [camiaoSel]);
  React.useEffect(() => {
    viagemSelRef.current = viagemSel;
  }, [viagemSel]);
  const relogios = React.useRef({});
  const filas = React.useRef({});
  const porGravar = React.useRef(/* @__PURE__ */ new Set());
  const tentativas = React.useRef({});
  const descarregar = React.useCallback((cargaId, { keepalive } = {}) => {
    const anterior = filas.current[cargaId] || Promise.resolve();
    filas.current[cargaId] = anterior.then(async () => {
      const carga2 = cargasRef.current.find((c) => c.id === cargaId);
      if (!carga2) {
        porGravar.current.delete(cargaId);
        return;
      }
      const corpo = L.cargaParaServidor(carga2, camioesRef.current);
      if (!corpo.tir) {
        porGravar.current.delete(cargaId);
        return;
      }
      try {
        let resposta;
        if (carga2.servidorId) {
          resposta = await window.CargoplannerAPI.guardarCarga(carga2.servidorId, corpo, { keepalive });
        } else {
          resposta = await window.CargoplannerAPI.criarCarga(corpo, { keepalive });
          setCargas((prev) => prev.map((c) => c.id === cargaId ? { ...c, servidorId: resposta.id } : c));
        }
        if (resposta && resposta.atualizado_em) {
          setCargas((prev) => prev.map((c) => c.id === cargaId ? { ...c, versao: resposta.atualizado_em } : c));
        }
        porGravar.current.delete(cargaId);
        delete tentativas.current[cargaId];
        setGravacao({
          estado: porGravar.current.size ? "a_guardar" : "guardado",
          erro: null,
          conflito: null
        });
        setRecargaAtribuido((n) => n + 1);
      } catch (err) {
        if (err && err.status === 409) {
          setGravacao({
            estado: "conflito",
            erro: null,
            conflito: { cargaId, servidor: err.corpo }
          });
          return;
        }
        const n = (tentativas.current[cargaId] || 0) + 1;
        tentativas.current[cargaId] = n;
        setGravacao({
          estado: "erro",
          conflito: null,
          erro: window.CargoplannerAPI.erroMensagem(err, "N\xE3o foi poss\xEDvel gravar a carga.")
        });
        if (n <= 3 && !keepalive && window.CargoplannerAPI.erroTransitorio(err)) {
          clearTimeout(relogios.current[cargaId]);
          relogios.current[cargaId] = setTimeout(() => descarregar(cargaId), 2e3 * n);
        }
      }
    });
    return filas.current[cargaId];
  }, [L]);
  const resolverConflito = React.useCallback(async () => {
    const info = gravacaoRef.current.conflito;
    if (!info || !info.servidor) return;
    const ok = await window.hubConfirm({
      title: "Esta carga foi alterada por outra pessoa",
      message: "O que fizeste aqui desde a \xFAltima grava\xE7\xE3o ainda n\xE3o est\xE1 guardado e vai ser substitu\xEDdo pelo que est\xE1 agora no servidor. N\xE3o h\xE1 como recuperar depois de continuar.",
      confirmLabel: "Descartar a minha edi\xE7\xE3o e recarregar",
      danger: true
    });
    if (!ok) return;
    clearTimeout(relogios.current[info.cargaId]);
    porGravar.current.delete(info.cargaId);
    delete tentativas.current[info.cargaId];
    const daServidor = L.cargaDoServidor(info.servidor);
    setCargas((prev) => prev.map((c) => c.id === info.cargaId ? { ...daServidor, id: info.cargaId } : c));
    setGravacao({
      estado: porGravar.current.size ? "a_guardar" : "limpo",
      erro: null,
      conflito: null
    });
  }, [L]);
  const gravar = React.useCallback((cargaId, { jaJa } = {}) => {
    porGravar.current.add(cargaId);
    tentativas.current[cargaId] = 0;
    setGravacao({ estado: "a_guardar", erro: null, conflito: null });
    clearTimeout(relogios.current[cargaId]);
    if (jaJa) {
      descarregar(cargaId);
      return;
    }
    relogios.current[cargaId] = setTimeout(() => descarregar(cargaId), 500);
  }, [descarregar]);
  const descarregarTudo = React.useCallback((opcoes) => {
    const ids = [...porGravar.current];
    ids.forEach((id) => clearTimeout(relogios.current[id]));
    return Promise.all(ids.map((id) => descarregar(id, opcoes)));
  }, [descarregar]);
  React.useEffect(() => () => {
    descarregarTudo();
  }, [descarregarTudo]);
  React.useEffect(() => {
    const aoSair = (ev) => {
      if (!porGravar.current.size) return void 0;
      descarregarTudo({ keepalive: true });
      ev.preventDefault();
      ev.returnValue = "";
      return "";
    };
    const aoEsconder = () => {
      if (porGravar.current.size) descarregarTudo({ keepalive: true });
    };
    window.addEventListener("beforeunload", aoSair);
    window.addEventListener("pagehide", aoEsconder);
    return () => {
      window.removeEventListener("beforeunload", aoSair);
      window.removeEventListener("pagehide", aoEsconder);
    };
  }, [descarregarTudo]);
  React.useEffect(() => {
    if (!registerLeaveGuard) return void 0;
    return registerLeaveGuard(() => {
      if (!porGravar.current.size) return true;
      descarregarTudo();
      if (gravacaoRef.current.estado === "erro") {
        window.srToast?.("A carga n\xE3o gravou. Tenta outra vez antes de sair.", "error");
        return false;
      }
      if (gravacaoRef.current.estado === "conflito") {
        window.srToast?.("Esta carga foi alterada por outra pessoa. Resolve o conflito antes de sair.", "error");
        return false;
      }
      return true;
    });
  }, [registerLeaveGuard, descarregarTudo]);
  const idDaCarga = React.useCallback((camiaoId, viagem) => {
    const v = viagem == null ? viagemSel : viagem;
    const c = L.cargaDe(cargasRef.current, camiaoId, dia, v);
    return c ? c.id : `c-${camiaoId}-${dia}-${v}`;
  }, [dia, viagemSel, L]);
  React.useEffect(() => {
    let cancelado = false;
    let ws = null;
    let relogioReconectar = null;
    let relogioPing = null;
    let atraso = 1e3;
    let primeiraLigacao = true;
    const minhaLigacao = window.CargoplannerAPI.ligacao;
    const aoReceber = (evento) => {
      ultimoSinal.current = Date.now();
      let msg;
      try {
        msg = JSON.parse(evento.data);
      } catch (e) {
        return;
      }
      if (!msg || msg.type === "pong") return;
      if (msg.type === "carga.saved") {
        const r = L.fundirCargaSocket(
          cargasRef.current,
          msg.carga,
          { origem: msg.origem, minhaLigacao, porGravar: porGravar.current }
        );
        if (r.acao === "aplicar") {
          setCargas((prev) => {
            const base2 = r.deLimpar ? prev.filter((c) => c.id !== r.deLimpar) : prev;
            return base2.some((c) => c.id === r.cargaId) ? base2.map((c) => c.id === r.cargaId ? r.carga : c) : [...base2, r.carga];
          });
        } else if (r.acao === "conflito") {
          setGravacao({
            estado: "conflito",
            erro: null,
            conflito: { cargaId: r.cargaId, servidor: r.servidor }
          });
        }
      } else if (msg.type === "carga.deleted") {
        const r = L.removerCargaSocket(cargasRef.current, msg, { origem: msg.origem, minhaLigacao });
        if (r.acao !== "remover") return;
        clearTimeout(relogios.current[r.cargaId]);
        porGravar.current.delete(r.cargaId);
        delete tentativas.current[r.cargaId];
        if (gravacaoRef.current.conflito && gravacaoRef.current.conflito.cargaId === r.cargaId) {
          setGravacao({ estado: "limpo", erro: null, conflito: null });
        }
        setCargas((prev) => prev.filter((c) => c.id !== r.cargaId));
        const aberta = L.cargaDe(cargasRef.current, camiaoSelRef.current, dia, viagemSelRef.current);
        const idAberta = aberta ? aberta.id : `c-${camiaoSelRef.current}-${dia}-${viagemSelRef.current}`;
        if (r.cargaId === idAberta) {
          window.srToast?.("A carga que tinhas aberta foi apagada por outra pessoa.", "error");
        }
      }
    };
    const ligar = () => {
      if (cancelado) return;
      ws = window.CargoplannerAPI.abrirSocket(dia);
      ws.onopen = () => {
        atraso = 1e3;
        ultimoSinal.current = Date.now();
        setLigacaoCargas({ ligada: true, ultimoSinalMs: ultimoSinal.current });
        if (L.deveReler({ primeiraLigacao })) setRecargaDia((n) => n + 1);
        primeiraLigacao = false;
        relogioPing = setInterval(() => {
          if (ws && ws.readyState === 1) {
            try {
              ws.send(JSON.stringify({ type: "ping" }));
            } catch (e) {
            }
          }
        }, 25e3);
      };
      ws.onmessage = aoReceber;
      ws.onerror = () => {
      };
      ws.onclose = () => {
        if (relogioPing) {
          clearInterval(relogioPing);
          relogioPing = null;
        }
        setLigacaoCargas({ ligada: false, ultimoSinalMs: ultimoSinal.current });
        if (cancelado) return;
        relogioReconectar = setTimeout(ligar, atraso);
        atraso = Math.min(atraso * 2, 3e4);
      };
    };
    ligar();
    const aoVoltar = () => {
      if (document.visibilityState === "visible") setRecargaDia((n) => n + 1);
    };
    document.addEventListener("visibilitychange", aoVoltar);
    return () => {
      cancelado = true;
      document.removeEventListener("visibilitychange", aoVoltar);
      if (relogioReconectar) clearTimeout(relogioReconectar);
      if (relogioPing) clearInterval(relogioPing);
      if (ws) {
        try {
          ws.onclose = null;
          ws.close();
        } catch (e) {
        }
      }
    };
  }, [dia, L]);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.parametrosPreparacao().then((p) => {
      if (vivo) setParametrosPreparacao(p);
    }).catch(() => {
      if (vivo) setParametrosPreparacao(null);
    });
    return () => {
      vivo = false;
    };
  }, []);
  const dados = React.useMemo(
    () => ({
      ...base,
      cargas,
      camioes,
      unidades,
      cais,
      periodos,
      feriados,
      entregas: entregasErp,
      tiposTir: tipos,
      transportadoras,
      tarifas,
      parametrosPreparacao
    }),
    [
      base,
      cargas,
      camioes,
      unidades,
      cais,
      periodos,
      feriados,
      entregasErp,
      tipos,
      transportadoras,
      tarifas,
      parametrosPreparacao
    ]
  );
  React.useEffect(() => {
    if (onCargaMudou) onCargaMudou(cargas, dados);
  }, [cargas, dados, onCargaMudou]);
  const unidadesRef = React.useRef(unidades);
  React.useEffect(() => {
    unidadesRef.current = unidades;
  }, [unidades]);
  const origemPorOmissao = React.useCallback(
    () => (unidadesRef.current[0] || {}).id || "",
    []
  );
  const irPara = React.useCallback((camiaoId, novoDia, viagem) => {
    const p = new URLSearchParams(params || void 0);
    p.set("dia", novoDia || dia);
    if (viagem !== void 0) {
      if (viagem > 1) p.set("viagem", String(viagem));
      else p.delete("viagem");
    }
    navigate({ routeId: "cargoplanner", entidade: camiaoId || camiaoSel, params: p });
  }, [navigate, camiaoSel, dia, params]);
  const carga = React.useMemo(
    () => L.cargaDe(cargas, camiaoSel, dia, viagemSel),
    [cargas, camiaoSel, dia, viagemSel, L]
  );
  const camiaoFicha = React.useMemo(
    () => camioes.find((c) => c.id === camiaoSel) || null,
    [camioes, camiaoSel]
  );
  const comCarga = React.useCallback((fn, aEsperar) => {
    const camiao = camioesRef.current.find((c) => c.id === camiaoSel);
    setCargas((prev) => {
      let atual = L.cargaDe(prev, camiaoSel, dia, viagemSel);
      let lista = prev;
      if (!atual) {
        atual = {
          id: `c-${camiaoSel}-${dia}-${viagemSel}`,
          camiaoId: camiaoSel,
          tirId: camiao && camiao.tirId,
          dia,
          viagem: viagemSel,
          origemId: origemPorOmissao(),
          regressoId: null,
          estado: "em_planeamento",
          ordemClientes: [],
          linhas: []
        };
        lista = [...prev, atual];
      }
      return lista.map((c) => c.id === atual.id ? fn(c) : c);
    });
    gravar(idDaCarga(camiaoSel), { jaJa: !aEsperar });
  }, [camiaoSel, dia, viagemSel, gravar, idDaCarga, origemPorOmissao, L]);
  const comCargaId = React.useCallback((cargaId, fn) => {
    const nova = cargasRef.current.map((c) => c.id === cargaId ? fn(c) : c);
    cargasRef.current = nova;
    setCargas(nova);
    gravar(cargaId, { jaJa: true });
  }, [gravar]);
  const cargaVista = React.useMemo(() => carga || {
    id: `c-${camiaoSel}-${dia}-${viagemSel}`,
    camiaoId: camiaoSel,
    dia,
    viagem: viagemSel,
    origemId: (unidades[0] || {}).id || null,
    regressoId: null,
    estado: "em_planeamento",
    ordemClientes: [],
    linhas: []
  }, [carga, camiaoSel, dia, viagemSel, unidades]);
  const camiaoEfetivo = React.useMemo(
    () => L.camiaoDaCarga(cargaVista, dados),
    [cargaVista, dados, L]
  );
  const percursoEstimado = React.useMemo(() => L.percurso(cargaVista, dados), [cargaVista, dados, L]);
  const percursosDoDia = React.useMemo(() => {
    const doDia = cargas.filter((c) => c.dia === dia && (c.linhas || []).length);
    const comAtual = doDia.some((c) => c.id === cargaVista.id) ? doDia : [...doDia, cargaVista];
    return comAtual.map((c) => ({ carga: c, percurso: L.percurso(c, dados) })).filter((x) => x.percurso.pontos.length >= 2);
  }, [cargas, dia, cargaVista, dados, L]);
  const rotas = window.CpRotas.usarVarias(React.useMemo(
    () => percursosDoDia.filter((x) => !L.ehTransitario(L.camiaoDaCarga(x.carga, dados))).map((x) => ({ id: x.carga.id, pontos: x.percurso.pontos })),
    [percursosDoDia, dados, L]
  ));
  const rota = React.useMemo(() => {
    const r = rotas.porId[cargaVista.id];
    if (r) return { estado: "ok", rota: r, erro: null };
    if (rotas.falhas[cargaVista.id]) return { estado: "falhou", rota: null, erro: rotas.falhas[cargaVista.id] };
    if (rotas.aCarregar) return { estado: "a_carregar", rota: null, erro: null };
    return { estado: "vazio", rota: null, erro: null };
  }, [rotas, cargaVista.id]);
  const percurso = React.useMemo(
    () => rota.estado === "ok" ? L.aplicarRota(percursoEstimado, rota.rota) : percursoEstimado,
    [percursoEstimado, rota.estado, rota.rota, L]
  );
  const percursoPorCarga = React.useMemo(() => {
    const porId = {};
    for (const x of percursosDoDia) {
      const r = rotas.porId[x.carga.id];
      porId[x.carga.id] = r ? L.aplicarRota(x.percurso, r) : x.percurso;
    }
    return porId;
  }, [percursosDoDia, rotas.porId, L]);
  const cargasNoMapa = React.useMemo(() => percursosDoDia.map((x) => ({
    cargaId: x.carga.id,
    camiaoId: x.carga.camiaoId,
    cor: window.CpRotas.corDoCamiao(x.carga.camiaoId),
    pontos: x.carga.id === cargaVista.id ? percurso.pontos : x.percurso.pontos,
    rota: rotas.porId[x.carga.id] || null,
    selecionada: x.carga.id === cargaVista.id,
    transitario: L.ehTransitario(L.camiaoDaCarga(x.carga, dados))
  })), [percursosDoDia, rotas.porId, cargaVista.id, percurso.pontos, dados, L]);
  const linhaDaRota = React.useMemo(() => {
    if (rota.estado === "ok" && rota.rota && (rota.rota.geometria || []).length) {
      return rota.rota.geometria;
    }
    return (percurso.pontos || []).filter((p) => p && p.lat != null && p.lng != null).map((p) => [p.lat, p.lng]);
  }, [rota, percurso]);
  const paragens = React.useMemo(() => L.paragens(cargaVista, dados), [cargaVista, dados, L]);
  const camiaoVazio = !(cargaVista.linhas || []).length;
  const ocupacao = React.useMemo(() => L.ocupacao(cargaVista, dados), [cargaVista, dados, L]);
  const conflitosVeiculo = React.useMemo(() => L.conflitos(cargas, dados, dia), [cargas, dados, dia, L]);
  const validacaoVeiculo = React.useMemo(() => L.validar(cargaVista, dados), [cargaVista, dados, L]);
  const tempoPreparacao = React.useMemo(
    () => L.tempoPreparacao(cargaVista, dados),
    [L, cargaVista, dados]
  );
  const [agoraMs, setAgoraMs] = React.useState(() => Date.now());
  React.useEffect(() => {
    const t = setInterval(() => setAgoraMs(Date.now()), 6e4);
    return () => clearInterval(t);
  }, []);
  const previsaoPreparacaoDoDia = React.useMemo(() => {
    const doDia = (cargas || []).filter((c) => c.dia === dia);
    return doDia.map((c) => ({
      cargaId: c.id,
      previsao: OL.previsaoPreparacao(c, dados, ondas, dadosOndas, agoraMs)
    })).filter((x) => x.previsao.nivel === "aviso");
  }, [cargas, dados, dia, ondas, dadosOndas, OL, agoraMs]);
  const naoFechouDoDia = React.useMemo(() => {
    if (!ondas || !ondas.length || !dadosOndas || !dadosOndas.tarefas) return [];
    return (cargas || []).filter((c) => c.dia === dia && L.ESTADOS_QUE_FECHAM.includes(c.estado)).map((c) => ({
      cargaId: c.id,
      aviso: OL.avisoDeNaoFechou(OL.cargaPodeFechar(
        ondas,
        dadosOndas.tarefas,
        c,
        dados,
        dados.parametrosPreparacao
      ))
    })).filter((x) => x.aviso);
  }, [cargas, dia, ondas, dadosOndas, dados, OL, L]);
  const choquesDeCais = React.useMemo(() => {
    const doDia = (cargas || []).filter((c) => c.dia === dia);
    return OL.choquesDeCais(doDia, dados, ondas, dadosOndas);
  }, [cargas, dia, dados, ondas, dadosOndas, OL]);
  const caisOcupadoPor = React.useCallback(
    (codigo) => OL.caisOcupadoPor(
      codigo,
      cargaVista,
      (cargas || []).filter((c) => c.dia === dia),
      dados,
      ondas,
      dadosOndas
    ),
    [OL, cargaVista, cargas, dia, dados, ondas, dadosOndas]
  );
  const textoDoChoque = React.useCallback((lista) => {
    const dizQuando = (x) => {
      const d = new Date(x.de);
      const a2 = new Date(x.ate);
      const hh = (t) => `${String(t.getHours()).padStart(2, "0")}:${String(t.getMinutes()).padStart(2, "0")}`;
      const dd = (t) => `${String(t.getDate()).padStart(2, "0")}/${String(t.getMonth() + 1).padStart(2, "0")}`;
      const atravessa = d.toDateString() !== a2.toDateString();
      if (!x.inicioConhecido) return `sai \xE0s ${hh(a2)}${atravessa ? ` de ${dd(a2)}` : ""}`;
      return atravessa ? `prepara das ${hh(d)} de ${dd(d)} at\xE9 sair \xE0s ${hh(a2)} de ${dd(a2)}` : `prepara das ${hh(d)} at\xE9 sair \xE0s ${hh(a2)}`;
    };
    const um = (x) => `${x.rotulo} (${dizQuando(x)})`;
    const codigo = lista[0].cais;
    const doCatalogo = (dados && dados.cais || []).find(
      (c) => (c.codigo || "").toUpperCase() === codigo
    );
    const cais2 = doCatalogo && doCatalogo.nome || codigo;
    return `O ${cais2} est\xE1 ocupado: ${lista.map(um).join("; ")}. Um cais leva uma carga de cada vez, desde que a prepara\xE7\xE3o come\xE7a at\xE9 o cami\xE3o sair.`;
  }, [dados]);
  const conflitos = React.useMemo(() => [
    ...conflitosVeiculo,
    ...previsaoPreparacaoDoDia.map((x) => ({
      tipo: "preparacao",
      nivel: x.previsao.nivel,
      funcionarioId: null,
      cargaId: x.cargaId,
      msg: x.previsao.msg
    })),
    ...naoFechouDoDia.map((x) => ({
      tipo: "nao_fechou",
      nivel: x.aviso.nivel,
      funcionarioId: null,
      cargaId: x.cargaId,
      msg: x.aviso.msg
    })),
    ...Object.entries(choquesDeCais).map(([cargaId, lista]) => ({
      tipo: "cais",
      nivel: "aviso",
      funcionarioId: null,
      cargaId,
      msg: textoDoChoque(lista)
    }))
  ], [
    conflitosVeiculo,
    previsaoPreparacaoDoDia,
    naoFechouDoDia,
    choquesDeCais,
    textoDoChoque
  ]);
  const previsaoPreparacaoVista = React.useMemo(
    () => OL.previsaoPreparacao(cargaVista, dados, ondas, dadosOndas, agoraMs),
    [OL, cargaVista, dados, ondas, dadosOndas, agoraMs]
  );
  const preparadorDaCarga = React.useMemo(
    () => L.preparadorDaCarga(cargaVista, percurso.paragens, ondas, dadosOndas),
    [L, cargaVista, percurso.paragens, ondas, dadosOndas]
  );
  const preparadorDaParagem = React.useCallback(
    (clienteId) => L.preparadorDaParagem(cargaVista, clienteId, ondas, dadosOndas),
    [L, cargaVista, ondas, dadosOndas]
  );
  const naoFechouVista = React.useMemo(() => {
    const x = (naoFechouDoDia || []).find((y) => cargaVista && y.cargaId === cargaVista.id);
    return x ? x.aviso : null;
  }, [naoFechouDoDia, cargaVista]);
  const validacao = React.useMemo(() => {
    const extra = [];
    if (previsaoPreparacaoVista && previsaoPreparacaoVista.nivel === "aviso") {
      extra.push({ campo: "preparacao", nivel: "aviso", msg: previsaoPreparacaoVista.msg });
    }
    if (naoFechouVista) {
      extra.push({ campo: "nao_fechou", nivel: "aviso", msg: naoFechouVista.msg });
    }
    const choque = cargaVista && choquesDeCais[cargaVista.id];
    if (choque && choque.length) {
      extra.push({ campo: "cais", nivel: "aviso", msg: textoDoChoque(choque) });
    }
    if (!extra.length) return validacaoVeiculo;
    return {
      ok: false,
      bloqueado: validacaoVeiculo.bloqueado,
      problemas: [...validacaoVeiculo.problemas, ...extra]
    };
  }, [
    validacaoVeiculo,
    previsaoPreparacaoVista,
    naoFechouVista,
    cargaVista,
    choquesDeCais,
    textoDoChoque
  ]);
  const custo = React.useMemo(
    () => L.custoDaCarga(cargaVista, dados, percurso),
    [L, cargaVista, dados, percurso]
  );
  const transportadoraDaCarga = React.useMemo(() => {
    const id = cargaVista.transporte && cargaVista.transporte.transportadoraId || camiaoEfetivo && camiaoEfetivo.transportadoraId;
    return id ? (transportadoras || []).find((t) => t.id === id) || null : null;
  }, [cargaVista, camiaoEfetivo, transportadoras]);
  const motivoSemCusto = React.useMemo(
    () => custo ? null : L.motivoSemCusto(cargaVista, dados, percurso),
    [L, custo, cargaVista, dados, percurso]
  );
  const valorMercadoria = React.useMemo(
    () => cargaVista ? L.valorDaCarga(cargaVista, dados).valor : 0,
    [L, cargaVista, dados]
  );
  const racios = React.useMemo(
    () => L.raciosDaCarga(custo, ocupacao, valorMercadoria),
    [L, custo, ocupacao, valorMercadoria]
  );
  const idsErp = React.useMemo(
    () => new Set(entregasErp.map((e) => e && e.id || "").filter(Boolean)),
    [entregasErp]
  );
  const porAtribuir = React.useMemo(() => entregasErp.map((e) => {
    const linha = atribuidoMapa ? { ...e, atribuido: atribuidoMapa[e.id] || {} } : e;
    const atribuida = L.atribuidoDaLinha(linha, cargas);
    const noutrosDias = L.ondeEstaOResto(linha, cargas);
    const resta = e.qtdTotal - atribuida;
    if (resta <= 0) {
      const componenteDeKit = !!(e.kitBistamp && idsErp.has(e.kitBistamp));
      if (!noutrosDias.length && !componenteDeKit) return null;
      return {
        // `linha` e não `e`: é o mesmo objecto com o `atribuido` do servidor,
        // e é dele que o `cpKitPorAtribuir` do K volta a tirar a conta.
        ...linha,
        qtdTotal: 0,
        qtdDisponivel: 0,
        qtdPrevista: 0,
        paletes: null,
        qtdErp: e.qtdTotal,
        qtdAtribuida: atribuida,
        noutrosDias,
        presaNoutroDia: noutrosDias.length > 0
      };
    }
    const disponivel = Math.max(0, Math.min(e.qtdDisponivel - atribuida, resta));
    return {
      ...e,
      qtdTotal: resta,
      qtdDisponivel: disponivel,
      qtdPrevista: Math.max(0, resta - disponivel),
      paletes: e.unPorPalete ? Math.ceil(resta / e.unPorPalete) : null,
      // O que o ERP diz, e o que já está em camiões. A coluna «Por entregar»
      // mostra o RESTO (`resta`), que é o que interessa a quem está a
      // planear — mas então 2000 unidades com 1500 já carregadas aparecem
      // como 500, e não há no ecrã nada que explique a diferença. O detalhe
      // da linha precisa dos três números para a poder mostrar.
      qtdErp: e.qtdTotal,
      qtdAtribuida: atribuida,
      noutrosDias
    };
  }).filter(Boolean), [entregasErp, cargas, atribuidoMapa, L, idsErp]);
  const clienteDaEntrega = React.useCallback(
    (entregaId) => L.clienteIdDaEntrega(entregasErp, entregaId),
    [entregasErp, L]
  );
  const adicionarEm = React.useCallback((camiaoId, viagem, itens) => {
    if (!itens || !itens.length) return;
    const v = Number(viagem) || 1;
    const camiao = camioesRef.current.find((c) => c.id === camiaoId);
    setCargas((prev) => {
      let atual = L.cargaDe(prev, camiaoId, dia, v);
      let lista = prev;
      if (!atual) {
        atual = {
          id: `c-${camiaoId}-${dia}-${v}`,
          camiaoId,
          tirId: camiao && camiao.tirId,
          dia,
          viagem: v,
          origemId: origemPorOmissao(),
          regressoId: null,
          estado: "em_planeamento",
          ordemClientes: [],
          linhas: []
        };
        lista = [...prev, atual];
      }
      return lista.map((c) => {
        if (c.id !== atual.id) return c;
        const linhas = c.linhas.slice();
        const ordem = c.ordemClientes.slice();
        for (const it of itens) {
          const qtd = Number(it.qtd) || 0;
          if (qtd <= 0) continue;
          const i = linhas.findIndex((l) => l.entregaId === it.entregaId);
          if (i === -1) linhas.push({ entregaId: it.entregaId, qtd });
          else linhas[i] = { ...linhas[i], qtd: linhas[i].qtd + qtd };
          const cli = clienteDaEntrega(it.entregaId);
          if (cli && !ordem.includes(cli)) ordem.push(cli);
        }
        return { ...c, linhas, ordemClientes: ordem };
      });
    });
    gravar(idDaCarga(camiaoId, v), { jaJa: true });
  }, [dia, clienteDaEntrega, gravar, idDaCarga, origemPorOmissao, L]);
  const largarNoCamiao = React.useCallback((camiaoId, viagem, itens) => {
    if (camiaoId !== camiaoSel || viagem !== viagemSel) irPara(camiaoId, dia, viagem);
    adicionarEm(camiaoId, viagem, itens);
  }, [camiaoSel, viagemSel, dia, irPara, adicionarEm]);
  const adicionar = React.useCallback((itens) => {
    if (!itens || !itens.length) return;
    comCarga((c) => L.comItens(c, itens, dados));
    setAviso(L.avisoAoAdicionar(cargaVista, dados, itens));
  }, [comCarga, clienteDaEntrega, cargaVista, dados, L]);
  const limparOrdem = (c) => {
    const vivos = new Set(c.linhas.map((l) => clienteDaEntrega(l.entregaId)));
    return { ...c, ordemClientes: c.ordemClientes.filter((id) => vivos.has(id)) };
  };
  const remover = React.useCallback((entregaId) => {
    comCarga((c) => limparOrdem({ ...c, linhas: c.linhas.filter((l) => l.entregaId !== entregaId) }));
    setAviso(null);
  }, [comCarga]);
  const removerLinhas = React.useCallback((ids) => {
    const fora = new Set(ids || []);
    if (!fora.size) return;
    comCarga((c) => limparOrdem({ ...c, linhas: c.linhas.filter((l) => !fora.has(l.entregaId)) }));
    setAviso(null);
  }, [comCarga]);
  const removerCliente = React.useCallback((clienteId) => {
    comCarga((c) => ({
      ...c,
      linhas: c.linhas.filter((l) => clienteDaEntrega(l.entregaId) !== clienteId),
      ordemClientes: c.ordemClientes.filter((id) => id !== clienteId)
    }));
    setAviso(null);
  }, [comCarga, clienteDaEntrega]);
  const mudarQtd = React.useCallback((entregaId, qtd) => {
    const e = entregasErp.find((x) => x.id === entregaId);
    const max = e ? e.qtdTotal : Infinity;
    const val = Math.max(0, Math.min(max, Number(qtd) || 0));
    if (val === 0) {
      remover(entregaId);
      return;
    }
    comCarga((c) => ({
      ...c,
      linhas: c.linhas.map((l) => l.entregaId === entregaId ? { ...l, qtd: val } : l)
    }), true);
  }, [comCarga, entregasErp, remover]);
  const reordenar = React.useCallback((de, para) => {
    comCarga((c) => ({ ...c, ordemClientes: L.reordenar(paragens.map((p) => p.clienteId), de, para) }));
  }, [comCarga, paragens, L]);
  const acrescentarRecolha = React.useCallback((r) => {
    comCarga((c) => ({
      ...c,
      recolhas: [...c.recolhas || [], { ...r, ordem: (c.recolhas || []).length }]
    }));
    setModalRecolha(false);
  }, [comCarga]);
  const acrescentarAmostra = React.useCallback((a) => {
    comCarga((c) => ({
      ...c,
      entregasManuais: [
        ...c.entregasManuais || [],
        { ...a, ordem: (c.entregasManuais || []).length }
      ]
    }));
    setModalAmostra(false);
  }, [comCarga]);
  const removerAmostra = React.useCallback((i) => {
    comCarga((c) => ({
      ...c,
      entregasManuais: (c.entregasManuais || []).filter((_, idx) => idx !== i)
    }));
  }, [comCarga]);
  const removerRecolha = React.useCallback((alvo) => {
    comCarga((c) => ({
      ...c,
      recolhas: (c.recolhas || []).filter((r) => !cpMesmaRecolha(r, alvo)).map((r, i) => ({ ...r, ordem: i }))
    }));
  }, [comCarga]);
  const reordenarRecolhas = React.useCallback((de, para) => {
    comCarga((c) => {
      const lista = L.recolhasOrdenadas(c);
      const noPercurso = lista.filter((r) => r.lat != null && r.lng != null);
      const fora = lista.filter((r) => r.lat == null || r.lng == null);
      const nova = L.reordenar(noPercurso, de, para);
      return { ...c, recolhas: [...nova, ...fora].map((r, i) => ({ ...r, ordem: i })) };
    });
  }, [comCarga, L]);
  const mudarOrigem = React.useCallback((id) => comCarga((c) => ({ ...c, origemId: id })), [comCarga]);
  const mudarCais = React.useCallback(
    (v) => comCarga((c) => ({ ...c, localizacaoDestino: v })),
    [comCarga]
  );
  const mudarPreparador = React.useCallback((pessoaId) => {
    const quem = pessoaId || null;
    comCarga((c) => ({ ...c, preparadorId: quem, preparadoresPorCliente: {} }));
    if (onPreparador && cargaVista) onPreparador(cargaVista.id, quem, null);
  }, [comCarga, onPreparador, cargaVista]);
  const mudarPreparadorParagem = React.useCallback((clienteId, pessoaId) => {
    const chave = String(clienteId == null ? "" : clienteId);
    comCarga((c) => ({
      ...c,
      preparadoresPorCliente: {
        ...c.preparadoresPorCliente || {},
        [chave]: pessoaId || null
      }
    }));
    if (onPreparador && cargaVista) {
      onPreparador(cargaVista.id, pessoaId || null, chave);
    }
  }, [comCarga, onPreparador, cargaVista]);
  const mudarPacotesDaParagem = React.useCallback((paragem, fn, aEsperar) => {
    comCarga((c) => {
      const meus = L.pacotesDaParagem(c, paragem);
      const outros = (c.pacotes || []).filter((x) => !meus.includes(x));
      return { ...c, pacotes: [...outros, ...fn(meus)] };
    }, aEsperar);
  }, [comCarga, L]);
  const mudarJanelaDaParagem = React.useCallback((clienteId, janela) => {
    comCarga((c) => {
      const janelas = { ...c.janelas || {} };
      const inicio = janela.inicio || null;
      const fim = janela.fim || null;
      if (inicio == null && fim == null) delete janelas[clienteId];
      else janelas[clienteId] = { inicio, fim };
      return { ...c, janelas };
    }, true);
  }, [comCarga]);
  const moverCargaPara = React.useCallback(async ({ tir, dia: novoDia }) => {
    const alvo = cargaVista;
    if (!alvo || alvo.servidorId == null) {
      throw new Error("A carga ainda n\xE3o est\xE1 gravada \u2014 tenta daqui a um instante.");
    }
    const r = await window.CargoplannerAPI.moverCarga(
      alvo.servidorId,
      { tir, dia: novoDia }
    );
    const nova = L.cargaDoServidor(r);
    setCargas((prev) => {
      const sem = prev.filter((c) => c.id !== alvo.id && c.servidorId !== nova.servidorId);
      return nova.dia === dia ? [...sem, nova] : sem;
    });
    setMoverAberto(false);
    const om = r.onda_movida;
    const seguiram = om && om.seguiram || [];
    const ficaram = om && om.ficaram || [];
    const ondaMsg = [
      seguiram.length ? ` ${seguiram.join(", ")} ${seguiram.length > 1 ? "acompanharam" : "acompanhou"} para ${om.dia}.` : "",
      ficaram.length ? ` ${ficaram.join(", ")} ` + (ficaram.length > 1 ? "FICARAM onde estavam \u2014 j\xE1 t\xEAm trabalho feito." : "FICOU onde estava \u2014 j\xE1 tem trabalho feito.") : ""
    ].join("");
    window.srToast?.(`Carga movida para ${nova.camiaoId} \xB7 ${nova.dia}` + (nova.viagem > 1 ? ` (${nova.viagem}\xAA viagem).` : ".") + ondaMsg, "success");
    irPara(nova.camiaoId, nova.dia, nova.viagem);
    if (onCargaMudou) onCargaMudou(cargas, dados);
  }, [cargaVista, dia, cargas, dados, irPara, onCargaMudou, L]);
  const mudarRegresso = React.useCallback((id) => comCarga((c) => ({ ...c, regressoId: id })), [comCarga]);
  const alternarRegresso = React.useCallback(
    () => comCarga((c) => ({ ...c, regressoFaturado: !c.regressoFaturado })),
    [comCarga]
  );
  const [preparada, setPreparada] = React.useState(null);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.cais({ ativos: 1 }).then((r) => {
      if (vivo) setCais(r || []);
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, []);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.periodos().then((r) => {
      if (vivo) setPeriodos((r || []).map(window.CargoplannerLogica.periodoDoServidor));
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, []);
  const [motivosCarga, setMotivosCarga] = React.useState([]);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.motivosCarga().then((r) => {
      if (vivo) setMotivosCarga(r || []);
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, []);
  const mudarEstado = React.useCallback((id) => {
    if (id === "preparada" && cargaVista) {
      const ondasDaCarga = (ondas || []).filter(
        (o) => o.cargaId === cargaVista.id && o.dia === cargaVista.dia
      );
      const ef = OL.efetivadoDaCarga(ondasDaCarga, dadosOndas.tarefas, cargaVista, dados);
      if (ef && ef.linhas.length) {
        setPreparada(ef);
        return;
      }
    }
    comCarga((c) => ({ ...c, estado: id }));
    if (onCargaConfirmada && (id === "planeada" || id === "em_preparacao")) {
      onCargaConfirmada({ ...cargaVista, estado: id }, dados);
    }
  }, [comCarga, onCargaConfirmada, cargaVista, dados, ondas, dadosOndas, OL]);
  React.useEffect(() => {
    if (!ondas || !ondas.length || !dadosOndas || !dadosOndas.tarefas) return;
    for (const c of cargas) {
      if (c.dia !== dia || !L.ESTADOS_QUE_FECHAM.includes(c.estado)) continue;
      const r = OL.cargaPodeFechar(
        ondas,
        dadosOndas.tarefas,
        c,
        dados,
        dados.parametrosPreparacao
      );
      if (!r.podeFechar) continue;
      const retrato = OL.preparacaoParaServidor(r.efetivado);
      comCargaId(c.id, (x) => ({
        ...L.aplicarEfetivado(x, r.efetivado.ajustaveis),
        estado: "preparada",
        preparacao: retrato
      }));
      window.srToast?.(
        `${c.camiaoId}: o armaz\xE9m acabou e tudo ficou dentro da margem \u2014 a carga passou a \xABPreparada\xBB. Falta envi\xE1-la ao PHC.`,
        "success"
      );
    }
  }, [ondas, dadosOndas, cargas, dia, dados, OL, L, comCargaId]);
  const confirmarPreparada = React.useCallback(async () => {
    if (!preparada) return;
    const retrato = OL.preparacaoParaServidor(preparada);
    const carga2 = cargaVista;
    comCarga((c) => ({
      ...L.aplicarEfetivado(c, preparada.ajustaveis),
      estado: "preparada",
      preparacao: retrato
    }));
    const ajusta = (preparada.ajustaveis || []).length;
    window.srToast?.(ajusta ? `Prepara\xE7\xE3o fechada \u2014 ${ajusta} linha(s) corrigida(s) para o que foi picado.` : "Prepara\xE7\xE3o fechada \u2014 nada a corrigir.", "success");
    setPreparada(null);
    if (!carga2 || carga2.servidorId == null || carga2.phcEnviadaEm) return;
    try {
      await descarregarTudo();
    } catch {
    }
    try {
      const r = await window.CargoplannerAPI.criarCargaNoPhc(carga2.servidorId, {
        // **`metrosPct`, não `pct`.** O `pct` é a percentagem de PALETES, e
        // essa é sempre 0 na frota a sério: `capacidade` em paletes é `0`
        // («sem limite em paletes», ver `cpOcupacao`) porque os camiões
        // medem-se em METROS. Ia 0 para o PHC em todas as cargas — apanhado
        // em browser, no primeiro envio.
        //
        // Com linhas sem medida no ERP a conta é PARCIAL, como o hero já
        // avisa («+N s/ medida»): manda-se o que se sabe, que é melhor do
        // que o zero que lá estava — a coluna é `numeric` e não aceita
        // «não sei».
        //
        // **Num transitário `metrosPct` não mede nada** — não há capacidade
        // nenhuma a encher (`cpOcupacao` devolve `transitario: true` e não
        // calcula ocupação) — e este é o ÚNICO sítio onde o número sai do
        // hub para dentro do PHC, de forma irreversível. Manda-se 0 em vez
        // de inventar uma percentagem sobre uma capacidade que não existe.
        pocup: ocupacao && ocupacao.transitario ? 0 : Math.round(ocupacao && ocupacao.metrosPct || 0)
      });
      setCargas((prev) => prev.map((c) => c.id === carga2.id ? { ...c, phcEnviadaEm: r.enviada_em } : c));
      window.srToast?.(`Carga criada no PHC (${r.transportadora}).`, "success");
    } catch (e) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(
        e,
        "A carga ficou preparada, mas N\xC3O foi criada no PHC."
      ), "error");
    }
  }, [preparada, comCarga, cargaVista, ocupacao, descarregarTudo, L, OL]);
  const [urgenciaAberta, setUrgenciaAberta] = React.useState(false);
  const aoUrgencia = React.useCallback(async () => {
    if (!cargaVista) return;
    if (cargaVista.urgente) {
      const ok = await window.hubConfirm({
        title: "Deixar de ser urgente",
        message: "A carga deixa de aparecer marcada e volta ao seu lugar na lista.",
        confirmLabel: "Deixar de ser urgente"
      });
      if (!ok) return;
      comCarga((c) => ({
        ...c,
        urgente: false,
        motivoUrgenciaId: null,
        motivoUrgenciaNome: null,
        notaUrgencia: ""
      }));
      return;
    }
    setUrgenciaAberta(true);
  }, [cargaVista, comCarga]);
  const guardarUrgencia = React.useCallback(({ motivoId, motivoNome, nota }) => {
    setUrgenciaAberta(false);
    comCarga((c) => ({
      ...c,
      urgente: true,
      motivoUrgenciaId: motivoId,
      motivoUrgenciaNome: motivoNome,
      notaUrgencia: nota
    }));
  }, [comCarga]);
  const [transporteAberto, setTransporteAberto] = React.useState(false);
  const [moverAberto, setMoverAberto] = React.useState(false);
  const guardarTransporte = React.useCallback((t, custo2) => {
    setTransporteAberto(false);
    comCarga((c) => ({ ...c, transporte: t, custo: custo2 || null }));
  }, [comCarga]);
  const guardarLinha = React.useCallback(async (bistamp, dados2) => {
    try {
      const r = await window.CargoplannerAPI.guardarLinha(bistamp, dados2);
      setEntregasErp((prev) => prev.map((e) => e.id !== bistamp ? e : {
        ...e,
        dia: r.data_entrega || e.dataEntregaErp,
        observacoes: r.observacoes || "",
        alterada: !!r.data_entrega && r.data_entrega !== e.dataEntregaErp,
        vencida: !!(r.data_entrega || e.dataEntregaErp) && (r.data_entrega || e.dataEntregaErp) < D.hoje()
      }));
    } catch (err) {
      setEntregasEstado((e) => ({
        ...e,
        erro: window.CargoplannerAPI.erroMensagem(err, "N\xE3o foi poss\xEDvel guardar a altera\xE7\xE3o.")
      }));
    }
  }, [D]);
  const limpar = React.useCallback(async () => {
    const ok = await window.hubConfirm({
      title: "Limpar a carga",
      message: `Retirar todos os artigos do ${camiaoSel}? As entregas voltam \xE0 lista.`,
      confirmLabel: "Limpar",
      danger: true
    });
    if (!ok) return;
    comCarga((c) => ({ ...c, linhas: [], ordemClientes: [] }));
    setAviso(null);
  }, [comCarga, camiaoSel]);
  const mudarDeCamiao = React.useCallback((deId, viagemDe, paraId, viagemPara, filtro) => {
    if (!deId || !paraId || deId === paraId) return;
    const vDe = Number(viagemDe) || 1;
    const vPara = Number(viagemPara) || 1;
    const camiaoDestino = camioesRef.current.find((c) => c.id === paraId);
    const daOrigem = L.cargaDe(cargasRef.current, deId, dia, vDe);
    if (!daOrigem) return;
    const doDestino = L.cargaDe(cargasRef.current, paraId, dia, vPara);
    const idOrigem = daOrigem.id;
    const idDestino = doDestino ? doDestino.id : `c-${paraId}-${dia}-${vPara}`;
    setCargas((prev) => {
      const origem = L.cargaDe(prev, deId, dia, vDe);
      if (!origem) return prev;
      const levar = (origem.linhas || []).filter((l) => filtro ? filtro(l) : true);
      if (!levar.length) return prev;
      const ficam = (origem.linhas || []).filter((l) => !levar.includes(l));
      const levaRecolhas = !filtro;
      const urgenciaOrigem = L.urgenciaAoMudarDeCamiao(origem);
      const urgenciaVazia = L.urgenciaVazia();
      let lista = prev;
      let destino = L.cargaDe(prev, paraId, dia, vPara);
      if (!destino) {
        destino = {
          id: `c-${paraId}-${dia}-${vPara}`,
          camiaoId: paraId,
          viagem: vPara,
          tirId: camiaoDestino && camiaoDestino.tirId,
          dia,
          origemId: origem.origemId || origemPorOmissao(),
          regressoId: origem.regressoId,
          estado: "em_planeamento",
          ordemClientes: [],
          linhas: [],
          recolhas: []
        };
        lista = [...prev, destino];
      }
      const clientesQueVao = new Set(levar.map((l) => clienteDaEntrega(l.entregaId)).filter(Boolean));
      const clientesQueFicam = new Set(ficam.map((l) => clienteDaEntrega(l.entregaId)).filter(Boolean));
      return lista.map((c) => {
        if (c.id === origem.id) {
          return {
            ...c,
            linhas: ficam,
            ordemClientes: (c.ordemClientes || []).filter((id) => clientesQueFicam.has(id)),
            recolhas: levaRecolhas ? [] : c.recolhas || [],
            ...levaRecolhas ? urgenciaVazia : null
          };
        }
        if (c.id === destino.id) {
          const linhas = [...c.linhas || []];
          for (const l of levar) {
            const i = linhas.findIndex((x) => x.entregaId === l.entregaId);
            if (i === -1) linhas.push({ ...l });
            else linhas[i] = { ...linhas[i], qtd: linhas[i].qtd + l.qtd };
          }
          const ordem = [...c.ordemClientes || []];
          for (const cli of clientesQueVao) if (!ordem.includes(cli)) ordem.push(cli);
          const recolhas = levaRecolhas ? [...c.recolhas || [], ...origem.recolhas || []].map((r, i) => ({ ...r, ordem: i })) : c.recolhas || [];
          return {
            ...c,
            linhas,
            ordemClientes: ordem,
            recolhas,
            ...levaRecolhas ? urgenciaOrigem : null
          };
        }
        return c;
      });
    });
    gravar(idOrigem, { jaJa: true });
    gravar(idDestino, { jaJa: true });
    irPara(paraId, dia, vPara);
  }, [dia, clienteDaEntrega, gravar, irPara, origemPorOmissao, L]);
  const moverCarga = React.useCallback(
    (de, viagemDe, para, viagemPara) => mudarDeCamiao(de, viagemDe, para, viagemPara, null),
    [mudarDeCamiao]
  );
  const moverCliente = React.useCallback(
    (de, clienteId, para, viagemPara) => mudarDeCamiao(
      de,
      viagemSel,
      para,
      viagemPara,
      (l) => clienteDaEntrega(l.entregaId) === clienteId
    ),
    [mudarDeCamiao, clienteDaEntrega, viagemSel]
  );
  const criarCamiao = React.useCallback(async (f) => {
    const codigo = String(f.id || "").trim().toUpperCase();
    if (!codigo || !f.tipo) return;
    const porAlugar = f.aluguer === "por_alugar";
    try {
      const tir = await window.CargoplannerAPI.criarTir({
        codigo,
        tipo: Number(f.tipo),
        aluguer: f.aluguer || "proprio",
        // Um lugar por contratar não tem transportadora, viatura nem
        // motorista — e o vazio diz isso melhor do que um traço.
        transportadora: porAlugar ? null : f.transportadora ? Number(f.transportadora) : null,
        matricula: porAlugar ? "" : f.matricula || "",
        motorista: porAlugar ? "" : f.motorista || "",
        periodo: f.periodo || "",
        inicio: f.inicio || "08:00",
        fim: f.fim || "16:00"
      });
      setCamioes((prev) => [...prev, L.camiaoDoTir(tir)]);
      setModalCamiao(false);
      irPara(codigo, dia, 1);
      window.srToast?.(`${codigo} acrescentado \xE0 frota.`, "success");
    } catch (err) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(
        err,
        "N\xE3o foi poss\xEDvel acrescentar o cami\xE3o."
      ), "error");
    }
  }, [irPara, dia, L]);
  const removerCamiao = React.useCallback(async (camiaoId) => {
    const camiao = camioes.find((c) => c.id === camiaoId);
    if (!camiao) return;
    const temCarga = cargas.some((c) => c.camiaoId === camiaoId && (c.linhas || []).length);
    const ok = await window.hubConfirm({
      title: `Tirar o ${camiaoId} do planeamento`,
      message: temCarga ? `O ${camiaoId} tem uma carga montada. Desativ\xE1-lo tira-o da lista do dia; a carga fica guardada e volta a aparecer se o reativares em Defini\xE7\xF5es.` : `Desativar o ${camiaoId}? Sai da lista do dia e pode voltar em Defini\xE7\xF5es \u2192 \xABFrota\xBB.`,
      confirmLabel: "Desativar",
      danger: true
    });
    if (!ok) return;
    try {
      await window.CargoplannerAPI.guardarTir(camiao.tirId, {
        codigo: camiao.id,
        tipo: camiao.tipoId,
        aluguer: camiao.aluguer,
        matricula: camiao.matricula || "",
        motorista: camiao.motorista || "",
        periodo: camiao.periodo,
        inicio: camiao.inicio,
        fim: camiao.fim,
        ativo: false
      });
      setCamioes((prev) => prev.filter((c) => c.id !== camiaoId));
      if (camiaoId === camiaoSel) {
        const resto = camioes.filter((c) => c.id !== camiaoId);
        if (resto.length) irPara(resto[0].id, dia, 1);
      }
    } catch (err) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(
        err,
        "N\xE3o foi poss\xEDvel desativar o cami\xE3o."
      ), "error");
    }
  }, [cargas, camioes, camiaoSel, irPara, dia]);
  const criarViagem = React.useCallback((camiaoId) => {
    const camiao = camioesRef.current.find((c) => c.id === camiaoId);
    const proxima = L.proximaViagem(cargasRef.current, camiaoId, dia);
    const nova = {
      id: `c-${camiaoId}-${dia}-${proxima}`,
      camiaoId,
      tirId: camiao && camiao.tirId,
      dia,
      viagem: proxima,
      origemId: origemPorOmissao(),
      regressoId: null,
      estado: "em_planeamento",
      ordemClientes: [],
      linhas: []
    };
    setCargas((prev) => [...prev, nova]);
    gravar(nova.id, { jaJa: true });
    irPara(camiaoId, dia, proxima);
  }, [dia, gravar, irPara, origemPorOmissao]);
  const removerViagem = React.useCallback(async (camiaoId, viagem) => {
    const v = Number(viagem) || 1;
    if (v <= 1) return;
    const alvo = L.cargaDe(cargasRef.current, camiaoId, dia, v);
    if (!alvo) return;
    if ((alvo.linhas || []).length) {
      const ok = await window.hubConfirm({
        title: `Apagar a ${v}\xAA viagem do ${camiaoId}`,
        message: "Tem artigos carregados \u2014 voltam \xE0 lista de entregas por atribuir.",
        confirmLabel: "Apagar viagem",
        danger: true
      });
      if (!ok) return;
    }
    clearTimeout(relogios.current[alvo.id]);
    porGravar.current.delete(alvo.id);
    delete tentativas.current[alvo.id];
    try {
      if (alvo.servidorId) await window.CargoplannerAPI.apagarCarga(alvo.servidorId);
    } catch (err) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(
        err,
        "N\xE3o foi poss\xEDvel apagar a viagem."
      ), "error");
      return;
    }
    setCargas((prev) => prev.filter((c) => c.id !== alvo.id));
    if (camiaoId === camiaoSel && v === viagemSel) irPara(camiaoId, dia, v - 1);
  }, [dia, camiaoSel, viagemSel, irPara, L]);
  return /* @__PURE__ */ React.createElement("div", { className: "cp-board" }, /* @__PURE__ */ React.createElement("div", { className: "cp-board__camioes" }, frotaEstado.erro && /* @__PURE__ */ React.createElement("div", { className: "cp-aviso", role: "status" }, /* @__PURE__ */ React.createElement("span", null, frotaEstado.erro), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setRecargaFrota((n) => n + 1) }, "Tentar de novo")), /* @__PURE__ */ React.createElement(
    window.CpCamioes,
    {
      dados,
      cargas,
      dia,
      camiaoSel,
      viagemSel,
      conflitos,
      percursoPorCarga,
      ondas,
      dadosOndas,
      onSelecionar: (id, viagem) => irPara(id, dia, viagem),
      onDia: (d) => irPara(camiaoSel, d),
      onNovo: () => setModalCamiao(true),
      onNovaViagem: criarViagem,
      onRemoverViagem: removerViagem,
      onRemover: removerCamiao,
      onLargarArtigos: largarNoCamiao,
      onMoverCarga: moverCarga,
      onMoverCliente: moverCliente
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-board__cabecalho" }, /* @__PURE__ */ React.createElement("div", { className: "cp-board__ligacao" }, /* @__PURE__ */ React.createElement(window.CpSinalAoVivo, { ligacoes: [ligacaoCargas, ligacaoShell].filter(Boolean) })), /* @__PURE__ */ React.createElement(
    window.CpCabecalhoCarga,
    {
      camiao: camiaoEfetivo,
      carga: cargaVista,
      dados,
      percurso,
      ocupacao,
      validacao,
      gravacao,
      onResolverConflito: resolverConflito,
      custo,
      racios,
      motivoSemCusto,
      tempoPreparacao,
      onEstado: mudarEstado,
      onLimpar: limpar,
      onUrgencia: aoUrgencia,
      pessoas: dadosOndas && dadosOndas.pessoas || [],
      preparadorDaCarga,
      onCais: mudarCais,
      onPreparador: mudarPreparador,
      caisOcupadoPor,
      onMover: () => setMoverAberto(true),
      onTransporte: () => setTransporteAberto(true)
    }
  ), aviso && /* @__PURE__ */ React.createElement("div", { className: "cp-aviso", role: "status" }, /* @__PURE__ */ React.createElement("span", null, aviso), /* @__PURE__ */ React.createElement("button", { className: "btn ghost icon-only sm", onClick: () => setAviso(null), title: "Fechar aviso" }, /* @__PURE__ */ React.createElement(window.Ico.close, null)))), /* @__PURE__ */ React.createElement("div", { className: "cp-board__carga" }, /* @__PURE__ */ React.createElement(
    window.CpDetalheCarga,
    {
      carga: cargaVista,
      dados,
      percurso,
      rota,
      cargasNoMapa,
      onReordenar: reordenar,
      onOrigem: mudarOrigem,
      onRegresso: mudarRegresso,
      onAlternarRegresso: alternarRegresso,
      onRemoverCliente: removerCliente,
      onAdicionar: adicionar,
      onRemoverLinha: remover,
      onRemoverLinhas: removerLinhas,
      onQtd: mudarQtd,
      onNovaRecolha: () => setModalRecolha(true),
      onNovaAmostra: () => setModalAmostra(true),
      onRemoverAmostra: removerAmostra,
      onRemoverRecolha: removerRecolha,
      onReordenarRecolhas: reordenarRecolhas,
      pessoas: dadosOndas && dadosOndas.pessoas || [],
      preparadorDaParagem,
      onPreparadorParagem: mudarPreparadorParagem,
      onPacotes: mudarPacotesDaParagem,
      onJanela: mudarJanelaDaParagem,
      ocupacao
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-board__entregas" }, /* @__PURE__ */ React.createElement(
    window.CpEntregas,
    {
      dia: ate,
      diaPlaneamento: dia,
      entregas: porAtribuir,
      mostrarNaoCarga,
      nNaoCarga: entregasTodas.filter((e) => e && e.naoCarga).length,
      onMostrarNaoCarga: (v) => {
        const q = new URLSearchParams(params || void 0);
        if (v) q.set("naocarga", "1");
        else q.delete("naocarga");
        navigate({ routeId: "cargoplanner", entidade: camiaoSel, params: q });
      },
      feriados,
      linhaDaRota,
      camiaoVazio,
      aCarregar: entregasEstado.aCarregar,
      erro: entregasEstado.erro,
      onDia: (d) => {
        const q = new URLSearchParams(params || void 0);
        q.set("ate", d);
        navigate({ routeId: "cargoplanner", entidade: camiaoSel, params: q });
      },
      onAdicionar: adicionar,
      onLargarDaCarga: remover,
      onLargarCliente: removerCliente,
      cargas,
      ondas,
      dadosOndas,
      onRecarregar: () => setRecarga((n) => n + 1),
      onGuardarLinha: guardarLinha
    }
  )), urgenciaAberta && /* @__PURE__ */ React.createElement(
    window.CpUrgenciaModal,
    {
      carga: cargaVista,
      onFechar: () => setUrgenciaAberta(false),
      onGuardar: guardarUrgencia
    }
  ), moverAberto && /* @__PURE__ */ React.createElement(
    window.CpMoverModal,
    {
      carga: cargaVista,
      camioes,
      onFechar: () => setMoverAberto(false),
      onMover: moverCargaPara
    }
  ), transporteAberto && // A FICHA (`camiaoFicha`), não o efetivo: os placeholders mostram
  // «Do camião: …», ou seja, o que herdarias se deixasses o campo
  // vazio. Alimentá-los com o efetivo era circular — mostrariam a
  // própria sobreposição como se fosse o valor herdado.
  /* @__PURE__ */ React.createElement(
    window.CpTransporteModal,
    {
      carga: cargaVista,
      camiao: camiaoFicha,
      tipos: dados.tiposTir || [],
      transportadoras,
      tarifas,
      dados,
      percurso,
      onFechar: () => setTransporteAberto(false),
      onGuardar: guardarTransporte
    }
  ), preparada && /* @__PURE__ */ React.createElement(
    window.CpPreparadaModal,
    {
      camiao: camiaoEfetivo,
      efetivado: preparada,
      onFechar: () => setPreparada(null),
      onConfirmar: confirmarPreparada,
      phc: {
        motivos: motivosCarga,
        enviadaEm: cargaVista.phcEnviadaEm,
        transportadoraNome: camiaoEfetivo && camiaoEfetivo.transportadora,
        fornecedorNo: transportadoraDaCarga && transportadoraDaCarga.phc_no,
        fornecedorNome: transportadoraDaCarga && transportadoraDaCarga.phc_nome,
        // O previsto pela tarifa, como REFERÊNCIA ao lado do campo —
        // nunca preenchido: o preço é o certo, e tem de ser introduzido.
        previsto: custo ? custo.total : null,
        identificacao: cargaVista.identificacao,
        valorTransporte: cargaVista.valorTransporte,
        valorExtra: cargaVista.valorExtra,
        motivoCargaId: cargaVista.motivoCargaId,
        entregaSos: cargaVista.entregaSos,
        sos: L.entregaSos(cargaVista, dados),
        sosDasLinhas: L.entregaSos({ ...cargaVista, entregaSos: null }, dados)
      },
      onPhc: (patch) => comCarga((c) => ({ ...c, ...patch }), true)
    }
  ), modalRecolha && /* @__PURE__ */ React.createElement(
    window.CpRecolhaModal,
    {
      dados,
      onFechar: () => setModalRecolha(false),
      onCriar: acrescentarRecolha
    }
  ), modalAmostra && /* @__PURE__ */ React.createElement(
    window.CpAmostraModal,
    {
      dados,
      onFechar: () => setModalAmostra(false),
      onCriar: acrescentarAmostra
    }
  ), modalCamiao && /* @__PURE__ */ React.createElement(
    window.CpNovoCamiaoModal,
    {
      dados,
      tipos,
      onFechar: () => setModalCamiao(false),
      onCriar: criarCamiao
    }
  ));
}
window.CpCargasView = CpCargasView;

// ===== cargoplanner/frontend/ondas_pessoas.jsx =====
function OndBarraOcupacao({ pct, excede }) {
  return /* @__PURE__ */ React.createElement("div", { className: "ond-barra", title: `${pct}% de ocupa\xE7\xE3o` }, /* @__PURE__ */ React.createElement(
    "span",
    {
      className: `ond-barra__fill ${excede ? "is-excede" : ""}`,
      style: { width: `${Math.min(100, pct)}%` }
    }
  ), excede && /* @__PURE__ */ React.createElement("span", { className: "ond-barra__over", style: { width: "100%" } }));
}
function OndPessoaCard({ pessoa, ocupacao, conflitos, ativo, sobre, onSelecionar, onDrop, onDragOver, onDragLeave }) {
  const L = window.CargoplannerLogica;
  const comps = (pessoa.competencias || []).length;
  const armazemTxt = pessoa.armazemLabel || pessoa.armazem || "sem armaz\xE9m";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `ond-pessoa ${ativo ? "is-ativo" : ""} ${sobre ? "is-sobre" : ""} ${conflitos.length ? "tem-conflito" : ""}`,
      role: "button",
      tabIndex: 0,
      "aria-pressed": ativo,
      onClick: () => onSelecionar(pessoa.id),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelecionar(pessoa.id);
        }
      },
      onDragOver,
      onDragLeave,
      onDrop,
      title: `${pessoa.nome} \u2014 ${pessoa.funcao} \xB7 ${armazemTxt}
${comps} compet\xEAncia(s)
Larga aqui uma onda para lha atribuir`
    },
    /* @__PURE__ */ React.createElement("div", { className: "ond-pessoa__top" }, /* @__PURE__ */ React.createElement("span", { className: "ond-avatar", style: { background: ondCorDaPessoa(pessoa.id) } }, pessoa.iniciais), /* @__PURE__ */ React.createElement("div", { className: "ond-pessoa__id" }, /* @__PURE__ */ React.createElement("div", { className: "ond-pessoa__nome" }, pessoa.nome), /* @__PURE__ */ React.createElement("div", { className: "ond-pessoa__funcao" }, pessoa.funcao, " \xB7 ", pessoa.armazem ? pessoa.armazem : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "sem armaz\xE9m"))), conflitos.length > 0 && /* @__PURE__ */ React.createElement("span", { className: "ond-alerta", title: conflitos.map((c) => c.msg).join("\n") }, "!")),
    /* @__PURE__ */ React.createElement("div", { className: "ond-pessoa__nums" }, ocupacao.ondas, " ondas \xB7 ", ocupacao.tarefas, " tarefas"),
    /* @__PURE__ */ React.createElement("div", { className: "ond-pessoa__tempo" }, /* @__PURE__ */ React.createElement("span", null, L.duracao(ocupacao.planeadoMin), " / ", L.duracao(ocupacao.capacidadeMin)), /* @__PURE__ */ React.createElement("span", { className: ocupacao.excede ? "ond-erro-txt" : "" }, ocupacao.pct, "%")),
    /* @__PURE__ */ React.createElement(OndBarraOcupacao, { pct: ocupacao.pct, excede: ocupacao.excede })
  );
}
const OND_CORES_PESSOA = [
  "#2563eb",
  "#f97316",
  "#a855f7",
  "#16a34a",
  "#0891b2",
  "#db2777",
  "#f59e0b",
  "#14b8a6",
  "#6366f1"
];
function ondCorDaPessoa(id) {
  let h = 0;
  for (let i = 0; i < String(id).length; i++) h = (h * 31 + String(id).charCodeAt(i)) % 997;
  return OND_CORES_PESSOA[h % OND_CORES_PESSOA.length];
}
function OndPessoas({ dados, ondas, pessoaSel, onSelecionar, onAtribuir, conflitos, filtro, onFiltro, turnoFiltro, onTurnoFiltro, armazemFiltro, onArmazemFiltro }) {
  const L = window.OndasLogica;
  const [sobre, setSobre] = React.useState(null);
  const armazens = React.useMemo(
    () => L.armazensPresentes(dados.pessoas || []),
    [dados.pessoas, L]
  );
  const q = (filtro || "").trim().toLowerCase();
  const visiveis = (dados.pessoas || []).filter((p) => {
    if (turnoFiltro && p.turnoId !== turnoFiltro) return false;
    if (armazemFiltro) {
      const chave = p.armazemId || L.SEM_ARMAZEM;
      if (chave !== armazemFiltro) return false;
    }
    if (!q) return true;
    return `${p.nome} ${p.funcao}`.toLowerCase().includes(q);
  });
  const largar = (pessoaId) => (ev) => {
    ev.preventDefault();
    setSobre(null);
    const p = window.CpDnd.ler(ev);
    if (p && p.k === "onda") onAtribuir(p.ondaId, pessoaId);
  };
  return /* @__PURE__ */ React.createElement("section", { className: "panel ond-zona ond-zona--pessoas", "aria-label": "Pessoas" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h ond-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Pessoas (", visiveis.length, ")")), /* @__PURE__ */ React.createElement("div", { className: "ond-pessoas__filtros", style: { flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "search-input",
      placeholder: "Pesquisar pessoa\u2026",
      value: filtro,
      onChange: (e) => onFiltro(e.target.value),
      "aria-label": "Pesquisar pessoa",
      style: { flex: "1 0 100%", minWidth: 0 }
    }
  ), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "ond-select",
      value: turnoFiltro || "",
      onChange: (e) => onTurnoFiltro(e.target.value || null),
      "aria-label": "Filtrar por turno",
      style: { flex: "1 1 90px" }
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "Todos os turnos"),
    (dados.turnos || []).map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.label))
  ), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "ond-select",
      value: armazemFiltro || "",
      onChange: (e) => onArmazemFiltro(e.target.value || null),
      "aria-label": "Filtrar por armaz\xE9m",
      style: { flex: "1 1 90px" }
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "Todos os armaz\xE9ns"),
    armazens.map((a) => /* @__PURE__ */ React.createElement("option", { key: a.id, value: a.id }, a.label))
  )), /* @__PURE__ */ React.createElement("div", { className: "ond-zona__body" }, dados.aCarregarPessoal && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 12 } }, "A ler quem est\xE1 ao servi\xE7o\u2026"), dados.erroPessoal && /* @__PURE__ */ React.createElement("div", { className: "alert error", style: { margin: 12 } }, dados.erroPessoal), !dados.aCarregarPessoal && !dados.erroPessoal && (dados.pessoas || []).length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 12 } }, "Ningu\xE9m ao servi\xE7o neste dia. Em ", /* @__PURE__ */ React.createElement("b", null, "Defini\xE7\xF5es \u2192 Pessoal das ondas"), " ", "cria-se a ficha de quem trabalha e marcam-se as folgas \u2014 \xE9 o mesmo ecr\xE3."), (dados.turnos || []).map((turno) => {
    const doTurno = visiveis.filter((p) => p.turnoId === turno.id);
    if (!doTurno.length) return null;
    return /* @__PURE__ */ React.createElement("div", { key: turno.id, className: "ond-turno" }, /* @__PURE__ */ React.createElement("div", { className: "ond-turno__h" }, turno.label, " \xB7 ", turno.inicio, "\u2013", turno.fim), doTurno.map((p) => /* @__PURE__ */ React.createElement(
      OndPessoaCard,
      {
        key: p.id,
        pessoa: p,
        ocupacao: L.ocupacaoDaPessoa(p.id, ondas, dados),
        conflitos: conflitos.filter((c) => c.pessoaId === p.id),
        ativo: p.id === pessoaSel,
        sobre: sobre === p.id,
        onSelecionar,
        onDragOver: (ev) => {
          ev.preventDefault();
          setSobre(p.id);
        },
        onDragLeave: () => setSobre(null),
        onDrop: largar(p.id)
      }
    )));
  }), !visiveis.length && /* @__PURE__ */ React.createElement("div", { className: "ond-vazio" }, "Ningu\xE9m corresponde ao filtro.")));
}
window.OndPessoas = OndPessoas;
window.OndBarraOcupacao = OndBarraOcupacao;
window.ondCorDaPessoa = ondCorDaPessoa;

// ===== cargoplanner/frontend/ondas_trabalho.jsx =====
function OndKpi({ icone, valor, label, cor }) {
  return /* @__PURE__ */ React.createElement("div", { className: "ond-kpi" }, /* @__PURE__ */ React.createElement("span", { className: "ond-kpi__ico", style: cor ? { color: cor } : void 0 }, icone), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "ond-kpi__valor" }, valor), /* @__PURE__ */ React.createElement("div", { className: "ond-kpi__label" }, label)));
}
function OndDesvioPill({ desvio }) {
  const L = window.CargoplannerLogica;
  if (!desvio.comparavel) return /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "\u2014");
  const atraso = desvio.desvioMin > 0;
  const igual = desvio.desvioMin === 0;
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: `ond-desvio ${igual ? "is-igual" : atraso ? "is-atraso" : "is-adianto"}`,
      title: `Previsto ${L.duracao(desvio.previstoDasFeitasMin)} \xB7 real ${L.duracao(desvio.realMin)}`
    },
    atraso ? "+" : igual ? "" : "\u2212",
    L.duracao(Math.abs(desvio.desvioMin)),
    desvio.desvioPct != null && ` (${atraso ? "+" : ""}${desvio.desvioPct}%)`
  );
}
function OndTarefasTabela({ tarefas, dados }) {
  const estados = window.OndasLogica.indexar(dados.estadosTarefa);
  const estadosOrdem = React.useMemo(() => {
    const idx = {};
    (dados.estadosTarefa || []).forEach((e, i) => {
      idx[e.id] = i;
    });
    return idx;
  }, [dados.estadosTarefa]);
  const colunas = React.useMemo(() => [
    { key: "tipo", label: "Tarefa", width: 110, minWidth: 90 },
    { key: "artigo", label: "Artigo", width: 78, minWidth: 64, mono: true },
    {
      key: "descricao",
      label: "Descri\xE7\xE3o",
      width: 140,
      minWidth: 100,
      render: (t) => /* @__PURE__ */ React.createElement("span", { title: t.descricao }, t.descricao)
    },
    {
      key: "qtd",
      label: "Qtd.",
      width: 64,
      minWidth: 56,
      align: "right",
      mono: true,
      render: (t) => t.qtd ? t.qtd.toLocaleString("pt-PT") : "\u2014"
    },
    {
      key: "origem",
      label: "Origem",
      width: 82,
      minWidth: 68,
      mono: true,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, t.origem)
    },
    {
      key: "destino",
      label: "Destino",
      width: 88,
      minWidth: 68,
      mono: true,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, t.destino)
    },
    {
      key: "tempoPrevMin",
      label: "Tempo prev.",
      width: 108,
      minWidth: 92,
      align: "right",
      mono: true,
      render: (t) => window.CargoplannerLogica.duracao(t.tempoPrevMin)
    },
    {
      key: "tempoRealMin",
      label: "Tempo real",
      width: 104,
      minWidth: 88,
      align: "right",
      mono: true,
      render: (t) => t.tempoRealMin == null ? "\u2014" : window.CargoplannerLogica.duracao(t.tempoRealMin)
    },
    {
      key: "estado",
      label: "Estado",
      width: 96,
      minWidth: 84,
      sortValue: (t) => estadosOrdem[t.estado],
      render: (t) => {
        const est = estados[t.estado] || {};
        return /* @__PURE__ */ React.createElement("span", { className: "ond-estado-pill", style: { "--ond-cor": est.cor } }, est.label || t.estado);
      }
    }
  ], [estados, estadosOrdem]);
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "cargoplanner",
      viewId: "ondas-tarefas",
      columns: colunas,
      data: tarefas,
      rowKey: (t) => t.id,
      rowClassName: (t) => t.estado === "concluida" ? "ond-tarefa--feita" : "",
      pagination: "client",
      empty: "Sem tarefas."
    }
  );
}
function OndOndaCard({ item, dados, ondas, aberto, onAbrir, alvo, onDragStart, onDragOver, onDrop, onRetirar, onDetalhe }) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const onda = item.onda;
  const tipo = L.indexar(dados.tipos)[onda.tipoId] || {};
  const estado = L.indexar(dados.estados)[onda.estado] || {};
  const prio = L.indexar(dados.prioridades)[onda.prioridadeId] || {};
  const tarefas = L.tarefasDaOnda(onda.id, dados);
  const desvio = L.desvio(onda, dados);
  const dep = L.podeIniciar(onda, ondas);
  const rotuloCarga = L.rotuloDaOnda(onda);
  const percurso = L.percursoDaOnda(onda, tarefas);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `ond-onda ${alvo ? "is-alvo" : ""}`,
      draggable: true,
      onDragStart,
      onDragOver,
      onDrop,
      style: { "--ond-cor": tipo.cor }
    },
    /* @__PURE__ */ React.createElement("div", { className: "ond-onda__h", onClick: () => onAbrir(!aberto) }, /* @__PURE__ */ React.createElement("span", { className: "ond-num", style: { background: tipo.cor } }, item.ordem), /* @__PURE__ */ React.createElement("div", { className: "ond-onda__id" }, onDetalhe ? /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "ond-onda__codigo ond-onda__codigo--btn",
        style: { color: tipo.cor },
        title: "Ver o detalhe desta onda",
        onClick: (e) => {
          e.stopPropagation();
          onDetalhe(onda);
        }
      },
      onda.codigo
    ) : /* @__PURE__ */ React.createElement("div", { className: "ond-onda__codigo", style: { color: tipo.cor } }, onda.codigo), /* @__PURE__ */ React.createElement("div", { className: "ond-onda__sub" }, tipo.label, " | ", CL.min2hhmm(item.inicioMin), " - ", CL.min2hhmm(item.fimMin), " ", "(", L.textoDaBase(item.base, item.fimMin - item.inicioMin), ")")), /* @__PURE__ */ React.createElement("span", { className: "ond-estado-pill", style: { "--ond-cor": estado.cor } }, estado.label), /* @__PURE__ */ React.createElement("span", { className: "ond-prio", style: { "--ond-cor": prio.cor } }, prio.label), /* @__PURE__ */ React.createElement("div", { className: "ond-onda__dir" }, /* @__PURE__ */ React.createElement("div", { className: "ond-onda__tarefas" }, tarefas.length, " tarefas"), /* @__PURE__ */ React.createElement("div", { className: "ond-dim ond-onda__carga", title: rotuloCarga || "" }, rotuloCarga || "\u2014"), (percurso.origem.length > 0 || percurso.destino.length > 0) && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "ond-dim ond-onda__percurso",
        title: "De onde saiu o material e para onde foi. V\xE1rios s\xEDtios aparecem todos \u2014 nunca se escolhe um por todos."
      },
      /* @__PURE__ */ React.createElement("span", null, percurso.origem.join(", ") || "\u2014"),
      /* @__PURE__ */ React.createElement("span", { "aria-hidden": true }, " \u2192 "),
      /* @__PURE__ */ React.createElement("span", null, percurso.destino.join(", ") || "\u2014")
    )), /* @__PURE__ */ React.createElement("span", { className: "ond-desvio-cel" }, /* @__PURE__ */ React.createElement(OndDesvioPill, { desvio })), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        title: "Devolver a onda a \xABOndas dispon\xEDveis\xBB",
        onClick: (e) => {
          e.stopPropagation();
          onRetirar(onda.id);
        }
      },
      /* @__PURE__ */ React.createElement(window.Ico.close, null)
    ), /* @__PURE__ */ React.createElement(window.Ico.chevron, { style: { transform: aberto ? "none" : "rotate(-90deg)" } })),
    !dep.ok && /* @__PURE__ */ React.createElement("div", { className: "ond-bloqueio" }, "Bloqueada por ", dep.bloqueios.map((b) => b.codigo).join(", "), " \u2014 n\xE3o pode arrancar antes de estar(em) conclu\xEDda(s)."),
    aberto && /* @__PURE__ */ React.createElement(OndTarefasTabela, { tarefas, dados })
  );
}
function OndTrabalho({ dados, ondas, pessoa, conflitos, onReordenar, onRetirar, onAtribuir, onDetalhe, agoraMs }) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const [abertos, setAbertos] = React.useState(() => /* @__PURE__ */ new Set());
  const [alvo, setAlvo] = React.useState(null);
  const [sobre, setSobre] = React.useState(false);
  if (!pessoa) {
    return /* @__PURE__ */ React.createElement("section", { className: "panel ond-zona ond-zona--trabalho", "aria-label": "Trabalho planeado" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h ond-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Trabalho planeado")), /* @__PURE__ */ React.createElement("div", { className: "ond-vazio" }, "Escolhe uma pessoa \xE0 esquerda."));
  }
  const agenda = L.agendaDaPessoa(pessoa.id, ondas, dados, agoraMs);
  const oc = L.ocupacaoDaPessoa(pessoa.id, ondas, dados);
  const meusConflitos = conflitos.filter((c) => c.pessoaId === pessoa.id);
  const largarEm = (idx) => L.largarNaAgenda({
    ler: window.CpDnd.ler,
    idx,
    agenda,
    pessoaId: pessoa.id,
    onAtribuir,
    onReordenar,
    onAlvo: setAlvo,
    onSobre: setSobre
  });
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: `panel ond-zona ond-zona--trabalho ${sobre ? "is-sobre" : ""}`,
      "aria-label": "Trabalho planeado",
      onDragOver: (ev) => {
        ev.preventDefault();
        setSobre(true);
      },
      onDragLeave: () => setSobre(false),
      onDrop: largarEm(agenda.length)
    },
    /* @__PURE__ */ React.createElement("div", { className: "panel-h ond-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Trabalho planeado \u2014 ", pessoa.nome), /* @__PURE__ */ React.createElement("span", { className: "sub" }, pessoa.funcao)),
    /* @__PURE__ */ React.createElement("div", { className: "ond-kpis" }, /* @__PURE__ */ React.createElement(OndKpi, { icone: "\u2261", valor: oc.ondas, label: "Ondas atribu\xEDdas", cor: "#2563eb" }), /* @__PURE__ */ React.createElement(OndKpi, { icone: "\u2611", valor: oc.tarefas, label: "Tarefas", cor: "#16a34a" }), /* @__PURE__ */ React.createElement(OndKpi, { icone: "\u25F7", valor: CL.duracao(oc.planeadoMin), label: "Tempo planeado", cor: "#f59e0b" }), /* @__PURE__ */ React.createElement(OndKpi, { icone: "\u25D5", valor: `${oc.pct}%`, label: "Ocupa\xE7\xE3o", cor: oc.excede ? "#dc2626" : "#a855f7" })),
    meusConflitos.length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "ond-conflitos" }, meusConflitos.map((c, i) => /* @__PURE__ */ React.createElement("li", { key: i }, c.msg))),
    /* @__PURE__ */ React.createElement("div", { className: "ond-zona__body" }, agenda.map((item, i) => /* @__PURE__ */ React.createElement(
      OndOndaCard,
      {
        key: item.onda.id,
        item,
        dados,
        ondas,
        aberto: abertos.has(item.onda.id),
        onAbrir: (abrir) => setAbertos((s) => {
          const n = new Set(s);
          if (abrir) n.add(item.onda.id);
          else n.delete(item.onda.id);
          return n;
        }),
        alvo: alvo === i,
        onDragStart: (ev) => window.CpDnd.escrever(ev, { k: "onda", ondaId: item.onda.id }),
        onDragOver: (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          setAlvo(i);
        },
        onDrop: largarEm(i),
        onRetirar,
        onDetalhe
      }
    )), !agenda.length && /* @__PURE__ */ React.createElement("div", { className: "ond-vazio ond-vazio--drop" }, "Sem ondas atribu\xEDdas. Arrasta uma de \xABOndas dispon\xEDveis\xBB."))
  );
}
window.OndTrabalho = OndTrabalho;
window.OndDesvioPill = OndDesvioPill;

// ===== cargoplanner/frontend/ondas_disponiveis.jsx =====
function OndDestinoConfirmado({ texto }) {
  const [estado, setEstado] = React.useState(null);
  const relogio = React.useRef(null);
  React.useEffect(() => {
    const cod = String(texto || "").trim();
    if (relogio.current) clearTimeout(relogio.current);
    if (cod.length < 2) {
      setEstado(null);
      return void 0;
    }
    let vivo = true;
    relogio.current = setTimeout(() => {
      window.CargoplannerAPI.localizacao(cod).then((r) => {
        if (vivo) setEstado(r && r.encontrado ? r : { livre: true });
      }).catch(() => {
        if (vivo) setEstado(null);
      });
    }, 400);
    return () => {
      vivo = false;
      if (relogio.current) clearTimeout(relogio.current);
    };
  }, [texto]);
  if (!estado) return null;
  if (estado.livre) {
    return /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "N\xE3o \xE9 uma localiza\xE7\xE3o do armaz\xE9m \u2014 vai como texto.");
  }
  return /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, `zona ${estado.zona || "\u2014"}, prateleira ${estado.prateleira || "\u2014"}, coluna ${estado.coluna || "\u2014"}`, estado.observacoes ? ` \xB7 ${estado.observacoes}` : "", estado.empresa ? ` \xB7 ${estado.empresa.nome}` : "");
}
function OndNovaOndaModal({ dados, onFechar, onCriar }) {
  const [f, setF] = React.useState({
    // `dados.tipos` vem do servidor e pode estar vazio (a ler, ou sem
    // catálogo semeado) — `dados.tipos[0].id` rebentava o render inteiro do
    // modal. Quem abre o botão já está atrás da mesma guarda, mas a lista
    // pode esvaziar-se entre abrir e escolher.
    tipoId: ((dados.tipos || [])[0] || {}).id || "",
    motivoId: "",
    prioridadeId: "normal",
    dia: dados.dia,
    duracaoMin: 60,
    origem: "",
    destino: "",
    // Não há campo "Carga" escrito à mão: `Onda.carga` é uma FK a uma carga
    // a sério, e o texto livre do mockup ("TIR-17") era o CÓDIGO DO CAMIÃO,
    // não uma carga. A onda de uma carga nasce de confirmar a carga na aba
    // ao lado (RF-OND-31), que é o único sítio que sabe de qual se trata.
    clienteId: "",
    artigo: "",
    qtd: "",
    paletes: "",
    nTarefas: 1,
    observacoes: ""
  });
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const tipo = (dados.tipos || []).find((t) => t.id === f.tipoId) || {};
  const comp = (dados.competencias || []).find((c) => c.id === tipo.competencia);
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Nova onda",
      subtitle: "O tipo e o motivo s\xE3o campos separados \u2014 o motivo evita ter um tipo por cada raz\xE3o.",
      width: 640,
      onClose: onFechar,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary",
          onClick: () => onCriar(f),
          disabled: !f.tipoId || !(Number(f.duracaoMin) > 0)
        },
        "Criar onda"
      ))
    },
    /* @__PURE__ */ React.createElement("div", { className: "ond-form" }, /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Tipo *"), /* @__PURE__ */ React.createElement("select", { className: "ond-select", value: f.tipoId, onChange: set("tipoId") }, (dados.tipos || []).map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.label))), comp && /* @__PURE__ */ React.createElement("small", { className: "ond-dim" }, "Exige a compet\xEAncia \xAB", comp.label, "\xBB.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Motivo"), /* @__PURE__ */ React.createElement("select", { className: "ond-select", value: f.motivoId, onChange: set("motivoId") }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem motivo \u2014"), (dados.motivos || []).map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.label)))), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Prioridade"), /* @__PURE__ */ React.createElement("select", { className: "ond-select", value: f.prioridadeId, onChange: set("prioridadeId") }, (dados.prioridades || []).map((p) => /* @__PURE__ */ React.createElement("option", { key: p.id, value: p.id }, p.label)))), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Data"), /* @__PURE__ */ React.createElement("input", { className: "ond-select", type: "date", value: f.dia, onChange: set("dia") })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Dura\xE7\xE3o estimada (min) *"), /* @__PURE__ */ React.createElement("input", { className: "ond-select", type: "number", min: "1", value: f.duracaoMin, onChange: set("duracaoMin") })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "N\xBA de tarefas"), /* @__PURE__ */ React.createElement("input", { className: "ond-select", type: "number", min: "1", value: f.nTarefas, onChange: set("nTarefas") })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Origem"), /* @__PURE__ */ React.createElement("input", { className: "ond-select", value: f.origem, onChange: set("origem"), placeholder: "Cais 1, A-01-02\u2026" })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Destino"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "ond-select",
        value: f.destino,
        onChange: set("destino"),
        placeholder: "P010, A-02-01, Cais 3\u2026"
      }
    ), /* @__PURE__ */ React.createElement(OndDestinoConfirmado, { texto: f.destino })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Cliente"), /* @__PURE__ */ React.createElement("input", { className: "ond-select", value: f.clienteId, onChange: set("clienteId") })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Artigo"), /* @__PURE__ */ React.createElement("input", { className: "ond-select", value: f.artigo, onChange: set("artigo") })), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Quantidade"), /* @__PURE__ */ React.createElement("input", { className: "ond-select", type: "number", min: "0", value: f.qtd, onChange: set("qtd") })), /* @__PURE__ */ React.createElement("label", { className: "field ond-form__wide" }, /* @__PURE__ */ React.createElement("span", null, "Observa\xE7\xF5es"), /* @__PURE__ */ React.createElement("textarea", { className: "ond-select", rows: 2, value: f.observacoes, onChange: set("observacoes") })))
  );
}
function OndDisponiveis({
  dados,
  ondas,
  onAtribuirSel,
  onCriar,
  pessoaSel,
  onLargarNaLista,
  dia,
  ondasFora,
  erroFora,
  ambito,
  onAmbito,
  onDetalhe
}) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const [selecao, setSelecao] = React.useState(() => /* @__PURE__ */ new Set());
  const [modal, setModal] = React.useState(false);
  const [sobre, setSobre] = React.useState(false);
  const comTurno = React.useCallback((marca) => {
    if (!marca) return null;
    const t = (dados.turnos || []).find((x) => x.codigo === marca.turno || x.id === marca.turno);
    return { ...marca, turnoLabel: t && (t.nome || t.label) || marca.turno };
  }, [dados.turnos]);
  const tipos = L.indexar(dados.tipos);
  const prios = L.indexar(dados.prioridades);
  const estados = L.indexar(dados.estados);
  const rows = React.useMemo(() => [
    ...L.disponiveis(ondas),
    ...ondasFora || []
  ].map((o) => {
    const tipo = tipos[o.tipoId] || {};
    const dur = L.duracaoPrevista(o, dados) || o.duracaoMin || 0;
    return {
      id: o.id,
      onda: o,
      codigo: o.codigo,
      // O dia SÓ aparece quando não é o que se está a planear — pôr «hoje»
      // em todas as linhas era uma coluna de ruído.
      dia: o.dia === dia ? "" : o.dia,
      tipoId: o.tipoId,
      tipoLabel: tipo.label,
      tipoCor: tipo.cor,
      prioridadeId: o.prioridadeId,
      estadoId: o.estado,
      // O camião (e a viagem, se houver mais que uma) MAIS o cliente — nunca
      // o `cargaId`, que numa onda gerada da carga é o id interno. A coluna
      // chama-se «Cliente / carga» e, desde que há uma onda por cliente, tem
      // mesmo de dizer as duas coisas para as linhas não saírem iguais.
      clienteCarga: L.rotuloDaOnda(o) || "\u2014",
      qtdTotal: o.qtdTotal,
      paletes: o.paletes,
      nTarefas: L.tarefasDaOnda(o.id, dados).length,
      duracaoMin: dur,
      artigos: L.tarefasDaOnda(o.id, dados).map((t) => t.artigo).join(" "),
      // Quem a teve e não a acabou (#113). `null` na grande maioria — uma
      // onda que nunca transitou não tem nada a dizer sobre isto.
      //
      // **O rótulo do turno resolve-se aqui, não fica gravado.** O que a
      // transição guarda é o `codigo` («manha»), que é a chave estável — e foi
      // isso que o ecrã estava a mostrar, em browser: «turno manha», o nome
      // interno à vista de quem planeia. O nome bonito vive no catálogo, e
      // muda lá sem reescrever o histórico.
      marca: comTurno(L.marcaDaTransicao(o)),
      // Entra na pesquisa: procurar pelo nome de quem deixou a onda a meio é
      // exactamente a pergunta de quem vai redistribuir o trabalho.
      transitouDe: (L.marcaDaTransicao(o) || {}).nome || ""
    };
  }), [ondas, ondasFora, dia, dados, L, tipos, comTurno]);
  const arrastar = (ev, ondaId) => {
    const ids = selecao.has(ondaId) && selecao.size > 1 ? [...selecao] : [ondaId];
    window.CpDnd.escrever(ev, { k: "onda", ondaId, ondaIds: ids });
  };
  const columns = React.useMemo(() => [
    {
      key: "drag",
      label: "",
      width: 32,
      minWidth: 32,
      sortable: false,
      fixed: true,
      render: (r) => /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "ond-handle",
          draggable: true,
          onDragStart: (ev) => arrastar(ev, r.id),
          title: "Arrasta para uma pessoa"
        },
        "\u22EE\u22EE"
      )
    },
    {
      key: "codigo",
      label: "Onda",
      width: 150,
      minWidth: 120,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "ond-codigo" }, /* @__PURE__ */ React.createElement("span", { className: "ond-dot", style: { background: r.tipoCor } }), r.codigo, r.marca && /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "ond-transitou",
          title: `Come\xE7ada por ${r.marca.nome || "algu\xE9m de outro turno"}${r.marca.turnoLabel ? ` (${r.marca.turnoLabel})` : ""}${r.marca.dia && r.marca.dia !== dia ? `, a ${r.marca.dia}` : ""}${r.marca.vezes > 1 ? ` \u2014 j\xE1 passou de m\xE3os ${r.marca.vezes} vezes` : ""}. H\xE1 trabalho come\xE7ado nela.`
        },
        "\u21BB come\xE7ada",
        r.marca.nome ? ` \xB7 ${r.marca.nome.split(" ")[0]}` : "",
        r.marca.vezes > 1 ? ` \xD7${r.marca.vezes}` : ""
      ))
    },
    {
      key: "tipoLabel",
      label: "Tipo",
      width: 124,
      minWidth: 100,
      render: (r) => /* @__PURE__ */ React.createElement("span", { style: { color: r.tipoCor, fontWeight: 600 } }, r.tipoLabel)
    },
    { key: "clienteCarga", label: "Cliente / Carga", width: 112, minWidth: 92 },
    // Uma onda de outro dia tem de o dizer: atribuí-la aqui MUDA-A para o
    // dia que se está a planear (ver `atribuir`, no shell), e isso não pode
    // acontecer sem quem a arrasta saber de onde ela veio.
    {
      key: "dia",
      label: "Dia",
      width: 92,
      minWidth: 80,
      render: (r) => r.dia ? /* @__PURE__ */ React.createElement("span", { className: "ond-op__lida-aviso td-mono" }, r.dia) : /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "\u2014")
    },
    {
      key: "qtdTotal",
      label: "Qtd.",
      width: 72,
      minWidth: 60,
      align: "right",
      render: (r) => r.qtdTotal ? r.qtdTotal.toLocaleString("pt-PT") : "\u2014"
    },
    { key: "paletes", label: "Pal.", width: 56, minWidth: 48, align: "right" },
    { key: "nTarefas", label: "Tarefas", width: 64, minWidth: 54, align: "right" },
    {
      key: "prioridadeId",
      label: "Prioridade",
      width: 92,
      minWidth: 80,
      // Ordena por urgência, não por ordem alfabética do id.
      sortValue: (r) => (prios[r.prioridadeId] || {}).rank,
      render: (r) => {
        const p = prios[r.prioridadeId] || {};
        return /* @__PURE__ */ React.createElement("span", { className: "ond-prio", style: { "--ond-cor": p.cor } }, p.label);
      }
    },
    {
      key: "duracaoMin",
      label: "Dura\xE7\xE3o",
      width: 76,
      minWidth: 64,
      align: "right",
      render: (r) => CL.duracao(r.duracaoMin)
    },
    {
      key: "estadoId",
      label: "Estado",
      width: 96,
      minWidth: 84,
      render: (r) => {
        const e = estados[r.estadoId] || {};
        return /* @__PURE__ */ React.createElement("span", { className: "ond-estado-pill", style: { "--ond-cor": e.cor } }, e.label);
      }
    }
  ], [prios, estados, CL, selecao, dia]);
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: `panel ond-zona ond-zona--disponiveis ${sobre ? "is-sobre" : ""}`,
      "aria-label": "Ondas dispon\xEDveis",
      onDragOver: (ev) => {
        ev.preventDefault();
        setSobre(true);
      },
      onDragLeave: () => setSobre(false),
      onDrop: (ev) => {
        ev.preventDefault();
        setSobre(false);
        const p = window.CpDnd.ler(ev);
        if (p && p.k === "onda") onLargarNaLista(p.ondaId);
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: "panel-h ond-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Ondas dispon\xEDveis (", rows.length, ")"), /* @__PURE__ */ React.createElement("div", { className: "ond-zona__h-fim" }, /* @__PURE__ */ React.createElement("span", { className: "cp-ordem-clientes", role: "group", "aria-label": "Que ondas mostrar" }, [
      ["dia", "Deste dia", "S\xF3 as ondas do dia que est\xE1 a planear"],
      ["dias2", "+2 dias \xFAteis", "As deste dia e dos dois dias \xFAteis seguintes"],
      ["todas", "Todas", "Todas as ondas por atribuir, de qualquer dia"]
    ].map(([v, rot, dica]) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: v,
        type: "button",
        title: dica,
        className: `btn ghost sm${ambito === v ? " is-on" : ""}`,
        "aria-pressed": ambito === v,
        onClick: () => onAmbito && onAmbito(v)
      },
      rot
    ))), selecao.size > 0 && pessoaSel && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
      onAtribuirSel([...selecao]);
      setSelecao(/* @__PURE__ */ new Set());
    } }, "Atribuir ", selecao.size, " a ", pessoaSel.nome.split(" ")[0]), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        onClick: () => setModal(true),
        disabled: !(dados.tipos || []).length,
        title: (dados.tipos || []).length ? "" : "Sem tipos de onda no cat\xE1logo \u2014 Defini\xE7\xF5es \u2192 Turnos e armaz\xE9ns."
      },
      /* @__PURE__ */ React.createElement(window.Ico.plus, null),
      " Nova onda"
    ))),
    /* @__PURE__ */ React.createElement("div", { className: "ond-zona__body ond-zona__body--lista" }, React.createElement(window.HubList.List, {
      appLabel: "cargoplanner",
      viewId: "ondas_disponiveis",
      columns,
      data: rows,
      rowKey: (r) => r.id,
      // Carregar numa linha abre o DETALHE — a mesma decisão que a
      // procura do tablet tomou («carregar numa linha abre o detalhe do
      // lote»), e pela mesma razão: a lista diz o que a onda é, o modal
      // diz o que ela deu e se chegou ao PHC.
      onRowClick: onDetalhe ? (r) => onDetalhe(r.id) : void 0,
      pagination: "client",
      initialPageSize: 25,
      initialSort: [{ key: "prioridadeId", dir: "desc" }],
      selectable: true,
      selection: selecao,
      onSelection: setSelecao,
      search: {
        placeholder: "Pesquisar por onda, tipo, cliente, carga, artigo, quem a come\xE7ou\u2026",
        fields: ["codigo", "tipoLabel", "clienteCarga", "artigos", "transitouDe"]
      },
      filters: [
        {
          key: "tipoId",
          type: "chip",
          label: "Tipo",
          options: (dados.tipos || []).map((t) => ({ value: t.id, label: t.label, dot: t.cor }))
        },
        {
          key: "prioridadeId",
          type: "chip",
          label: "Prioridade",
          options: (dados.prioridades || []).map((p) => ({ value: p.id, label: p.label, dot: p.cor }))
        }
      ],
      // Três coisas diferentes, três mensagens — colapsá-las numa só
      // faria uma rede em baixo parecer um dia sem trabalho nenhum.
      empty: dados.erroOndas ? dados.erroOndas : dados.aCarregarOndas ? "A ler as ondas deste dia\u2026" : "N\xE3o h\xE1 ondas por atribuir."
    }), erroFora ? /* @__PURE__ */ React.createElement("div", { className: "ond-avisos", role: "alert" }, erroFora) : null),
    modal && /* @__PURE__ */ React.createElement(
      OndNovaOndaModal,
      {
        dados,
        onFechar: () => setModal(false),
        onCriar: (f) => {
          onCriar(f);
          setModal(false);
        }
      }
    )
  );
}
window.OndDestinoConfirmado = OndDestinoConfirmado;
window.OndDisponiveis = OndDisponiveis;
window.OndNovaOndaModal = OndNovaOndaModal;

// ===== cargoplanner/frontend/ondas_timeline.jsx =====
const OND_TL_INICIO = 6 * 60;
const OND_TL_FIM = 21 * 60;
function ondTlPct(min, ini, fim) {
  return (min - ini) / (fim - ini) * 100;
}
function OndLegenda({ tipos }) {
  return /* @__PURE__ */ React.createElement("div", { className: "ond-legenda" }, /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "Tipos de onda:"), tipos.map((t) => /* @__PURE__ */ React.createElement("span", { key: t.id, className: "ond-legenda__item" }, /* @__PURE__ */ React.createElement("span", { className: "ond-dot", style: { background: t.cor } }), t.label)));
}
function OndTimeline({ dados, ondas, conflitos, pessoaSel, vista, onVista, onSelecionar, onMover, verTodos, onVerTodos, agoraMs }) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const [sobre, setSobre] = React.useState(null);
  const semana = vista === "semana";
  const pessoas = React.useMemo(() => verTodos ? dados.pessoas || [] : (dados.pessoas || []).filter((p) => L.agendaDaPessoa(p.id, ondas, dados, agoraMs).length > 0), [verTodos, dados, ondas, agoraMs, L]);
  const { iniMin, fimMin } = React.useMemo(() => {
    if (semana) return { iniMin: OND_TL_INICIO, fimMin: OND_TL_FIM };
    const blocos = pessoas.flatMap((p) => L.agendaDaPessoa(p.id, ondas, dados, agoraMs));
    if (!blocos.length) return { iniMin: OND_TL_INICIO, fimMin: OND_TL_FIM };
    const min = Math.min(...blocos.map((b) => b.inicioMin));
    const max = Math.max(...blocos.map((b) => b.fimMin));
    return {
      iniMin: Math.max(0, Math.floor((min - 30) / 60) * 60),
      fimMin: Math.min(1440, Math.ceil((max + 30) / 60) * 60)
    };
  }, [semana, pessoas, ondas, dados, agoraMs, L]);
  const horas = [];
  const span = fimMin - iniMin;
  const passo = span > 10 * 60 ? 120 : 60;
  for (let h = iniMin; h <= fimMin; h += passo) horas.push(h);
  const largar = (pessoaId) => (ev) => {
    ev.preventDefault();
    setSobre(null);
    const p = window.CpDnd.ler(ev);
    if (p && p.k === "onda") onMover(p.ondaId, pessoaId);
  };
  return /* @__PURE__ */ React.createElement("section", { className: "panel ond-zona ond-zona--timeline", "aria-label": "Ocupa\xE7\xE3o das pessoas" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h ond-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Ocupa\xE7\xE3o das pessoas (planeamento)"), /* @__PURE__ */ React.createElement("div", { className: "ond-zona__h-fim" }, /* @__PURE__ */ React.createElement("div", { className: "ond-toggle" }, /* @__PURE__ */ React.createElement("button", { className: `btn sm ${!semana ? "primary" : "ghost"}`, onClick: () => onVista("dia") }, "Dia"), /* @__PURE__ */ React.createElement("button", { className: `btn sm ${semana ? "primary" : "ghost"}`, onClick: () => onVista("semana") }, "Semana")), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => onVerTodos(!verTodos) }, verTodos ? "S\xF3 com trabalho" : "Ver todos"))), /* @__PURE__ */ React.createElement("div", { className: "ond-tl" }, /* @__PURE__ */ React.createElement("div", { className: "ond-tl__grelha" }, /* @__PURE__ */ React.createElement("div", { className: "ond-tl__cantinho" }), /* @__PURE__ */ React.createElement("div", { className: "ond-tl__horas" }, horas.map((h) => /* @__PURE__ */ React.createElement("span", { key: h, className: "ond-tl__hora", style: { left: `${ondTlPct(h, iniMin, fimMin)}%` } }, CL.min2hhmm(h)))), /* @__PURE__ */ React.createElement("div", { className: "ond-tl__medidas ond-tl__medidas--h" }, /* @__PURE__ */ React.createElement("span", null, "Planeado"), /* @__PURE__ */ React.createElement("span", null, "Real"), /* @__PURE__ */ React.createElement("span", null, "Desvio")), pessoas.map((p) => {
    const agenda = L.agendaDaPessoa(p.id, ondas, dados, agoraMs);
    const oc = L.ocupacaoDaPessoa(p.id, ondas, dados);
    const meus = conflitos.filter((c) => c.pessoaId === p.id);
    return /* @__PURE__ */ React.createElement(React.Fragment, { key: p.id }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: `ond-tl__nome ${p.id === pessoaSel ? "is-ativo" : ""}`,
        onClick: () => onSelecionar(p.id),
        role: "button",
        tabIndex: 0,
        onKeyDown: (e) => {
          if (e.key === "Enter") onSelecionar(p.id);
        }
      },
      /* @__PURE__ */ React.createElement("span", { className: "ond-avatar ond-avatar--sm", style: { background: window.ondCorDaPessoa(p.id) } }, p.iniciais),
      p.nome
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: `ond-tl__faixa ${sobre === p.id ? "is-sobre" : ""}`,
        onDragOver: (ev) => {
          ev.preventDefault();
          setSobre(p.id);
        },
        onDragLeave: () => setSobre(null),
        onDrop: largar(p.id)
      },
      horas.map((h) => /* @__PURE__ */ React.createElement("span", { key: h, className: "ond-tl__risco", style: { left: `${ondTlPct(h, iniMin, fimMin)}%` } })),
      (p.indisponibilidades || []).map((ind, i) => /* @__PURE__ */ React.createElement(
        "span",
        {
          key: `i${i}`,
          className: "ond-tl__indisp",
          title: `${ind.motivo} (${ind.inicio}\u2013${ind.fim})`,
          style: {
            left: `${ondTlPct(CL.hhmm2min(ind.inicio), iniMin, fimMin)}%`,
            width: `${ondTlPct(CL.hhmm2min(ind.fim), iniMin, fimMin) - ondTlPct(CL.hhmm2min(ind.inicio), iniMin, fimMin)}%`
          }
        }
      )),
      agenda.map((a) => {
        const tipo = L.indexar(dados.tipos)[a.onda.tipoId] || {};
        const mau = meus.some((c) => c.ondaId === a.onda.id);
        const esq = ondTlPct(a.inicioMin, iniMin, fimMin);
        const dir = ondTlPct(a.fimMin, iniMin, fimMin);
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            key: a.onda.id,
            className: `ond-tl__bloco ${mau ? "is-mau" : ""}`,
            style: {
              left: `${esq}%`,
              width: `${Math.max(1.5, dir - esq)}%`,
              background: tipo.cor
            },
            draggable: true,
            onDragStart: (ev) => window.CpDnd.escrever(ev, { k: "onda", ondaId: a.onda.id }),
            title: `${a.onda.codigo} \xB7 ${tipo.label}
${CL.min2hhmm(a.inicioMin)}\u2013${CL.min2hhmm(a.fimMin)}
${L.textoDaBase(a.base, a.fimMin - a.inicioMin)}` + (a.onda.fimReal ? `
Conclu\xEDda \xE0s ${CL.min2hhmm(L.minDoDia(a.onda.fimReal))}` : "") + `
Prioridade: ${(L.indexar(dados.prioridades)[a.onda.prioridadeId] || {}).label}
Estado: ${(L.indexar(dados.estados)[a.onda.estado] || {}).label}` + (mau ? "\nEM CONFLITO" : "")
          },
          /* @__PURE__ */ React.createElement("b", null, a.onda.codigo),
          /* @__PURE__ */ React.createElement("span", null, tipo.label),
          /* @__PURE__ */ React.createElement("span", null, CL.min2hhmm(a.inicioMin), "\u2013", CL.min2hhmm(a.fimMin))
        );
      })
    ), /* @__PURE__ */ React.createElement("div", { className: "ond-tl__medidas" }, /* @__PURE__ */ React.createElement("span", null, CL.duracao(oc.planeadoMin)), /* @__PURE__ */ React.createElement("span", { className: "ond-medida-real" }, oc.realMin ? CL.duracao(oc.realMin) : "\u2014"), /* @__PURE__ */ React.createElement("span", null, oc.desvioMin == null ? /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "\u2014") : /* @__PURE__ */ React.createElement("span", { className: `ond-desvio ${oc.desvioMin > 0 ? "is-atraso" : oc.desvioMin === 0 ? "is-igual" : "is-adianto"}` }, oc.desvioMin > 0 ? "+" : oc.desvioMin === 0 ? "" : "\u2212", CL.duracao(Math.abs(oc.desvioMin))))));
  })), !pessoas.length && /* @__PURE__ */ React.createElement("div", { className: "ond-vazio" }, "Ningu\xE9m com trabalho planeado neste dia."), /* @__PURE__ */ React.createElement(OndLegenda, { tipos: dados.tipos })));
}
window.OndTimeline = OndTimeline;
window.OndTl = { INICIO: OND_TL_INICIO, FIM: OND_TL_FIM, pct: ondTlPct };

// ===== cargoplanner/frontend/ondas_modal.jsx =====
function ondPaletes(n) {
  return n === 1 ? "1 palete" : `${n} paletes`;
}
function OndModalPhc({ phc }) {
  if (!phc.total) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-modal__phc is-nada" }, "Esta onda n\xE3o tem paletes picadas \u2014 n\xE3o h\xE1 nada para lan\xE7ar no PHC.");
  }
  if (!phc.porLancar) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-modal__phc is-ok" }, /* @__PURE__ */ React.createElement("strong", null, ondPaletes(phc.lancadas), " no PHC."), " Est\xE1 tudo lan\xE7ado no dossier 82.");
  }
  return /* @__PURE__ */ React.createElement("div", { className: "ond-modal__phc is-falta" }, /* @__PURE__ */ React.createElement("strong", null, ondPaletes(phc.porLancar), " por lan\xE7ar no PHC"), phc.lancadas > 0 && ` (${phc.lancadas} j\xE1 l\xE1 est\xE3o)`, ".", phc.comErro > 0 && ` ${phc.comErro} falharam e algu\xE9m tem de repetir.`, " ", "O picking s\xF3 est\xE1 fechado quando todas estiverem no dossier 82.");
}
function OndModalTarefa({ tarefa, dados, onReabrir, kit }) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const estado = L.indexar(dados.estadosTarefa)[tarefa.estado] || { label: tarefa.estado, cor: "#6a7888" };
  const lotes = tarefa.lotes || [];
  const real = tarefa.tempoRealMin;
  return /* @__PURE__ */ React.createElement("li", { className: `ond-modal__tarefa${tarefa.estado === "concluida" ? " is-feita" : ""}` }, /* @__PURE__ */ React.createElement("div", { className: "ond-modal__tarefa-h" }, /* @__PURE__ */ React.createElement("span", { className: "ond-modal__artigo" }, tarefa.artigo || tarefa.tipo), kit && /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "cp-tag cp-tag--kit",
      title: `Componente ${kit.indice} de ${kit.total} do kit ${kit.ref}` + (kit.razao == null ? " (raz\xE3o por kit desconhecida no ERP)" : ` (\xD7${kit.razao} por kit)`) + ". O kit s\xF3 sai com os componentes todos."
    },
    "KIT ",
    kit.indice,
    "/",
    kit.total
  ), /* @__PURE__ */ React.createElement("span", { className: "ond-estado-pill", style: { "--ond-cor": estado.cor } }, estado.label), tarefa.foraDaCarga && /* @__PURE__ */ React.createElement("span", { className: "ond-modal__fora", title: "Esta linha j\xE1 n\xE3o est\xE1 na carga \u2014 o que foi picado fica registado." }, "j\xE1 n\xE3o est\xE1 na carga"), tarefa.estado === "concluida" && onReabrir && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm ond-modal__reabrir",
      onClick: () => onReabrir(tarefa.id)
    },
    "Reabrir"
  )), /* @__PURE__ */ React.createElement("div", { className: "ond-modal__tarefa-nums" }, /* @__PURE__ */ React.createElement("span", null, (Number(tarefa.qtd) || 0).toLocaleString("pt-PT"), " ", (tarefa.unidade || "").trim() || "un."), /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "previsto ", CL.duracao(tarefa.tempoPrevMin)), /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, real == null ? "real s/ medi\xE7\xE3o" : `real ${CL.duracao(real)}`), tarefa.destino && /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "\u2192 ", tarefa.destino)), lotes.length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "ond-modal__lotes" }, lotes.map((lote, i) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: lote.codigo || i,
      className: window.OndasLogica.estadoPhcDoLote(tarefa, lote) === "lancada" ? "is-lancada" : "is-por-lancar"
    },
    /* @__PURE__ */ React.createElement("span", { className: "ond-modal__lote-cod" }, lote.codigo),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, lote.qtd == null ? "qtd. desconhecida" : `${(Number(lote.qtd) || 0).toLocaleString("pt-PT")} ` + ((tarefa.unidade || "").trim() || "un.")),
    lote.destino ? /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "\u2192 ", lote.destino) : /* @__PURE__ */ React.createElement("span", { className: "ond-modal__poralocar" }, "por alocar"),
    (() => {
      const phc = window.OndasLogica.estadoPhcDoLote(tarefa, lote);
      if (phc === "lancada") {
        return /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "ond-modal__phc-ok",
            title: `Linha ${lote.phcBistamp} do dossier 82`
          },
          "PHC \u2713",
          lote.phcObrano ? ` n\xBA ${lote.phcObrano}` : ""
        );
      }
      if (phc === "falhou") {
        return /* @__PURE__ */ React.createElement("span", { className: "ond-modal__phc-falta", title: lote.phcErro }, "PHC falhou");
      }
      if (phc === "por_lancar") {
        return /* @__PURE__ */ React.createElement("span", { className: "ond-modal__phc-falta" }, "por lan\xE7ar no PHC");
      }
      return null;
    })()
  ))));
}
function OndOndaModal({ onda, dados, onFechar, onReabrir, onArquivar }) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  if (!onda) return null;
  const tarefas = L.tarefasDaOnda(onda.id, dados);
  const phc = L.phcDosLotes(tarefas);
  const percurso = L.percursoDaOnda(onda, tarefas);
  const tipo = L.indexar(dados.tipos)[onda.tipoId] || { label: onda.tipoId, cor: "#6a7888" };
  const estado = L.indexar(dados.estados)[onda.estado] || { label: onda.estado, cor: "#6a7888" };
  const rotulo = L.rotuloDaOnda(onda);
  const desvio = L.desvio(onda, dados);
  return React.createElement(window.ModalShell, {
    title: onda.codigo,
    subtitle: [tipo.label, rotulo].filter(Boolean).join(" \xB7 "),
    onClose: onFechar,
    width: "min(760px, 94vw)"
  }, /* @__PURE__ */ React.createElement("div", { className: "ond-modal" }, /* @__PURE__ */ React.createElement("div", { className: "ond-modal__cabecalho" }, /* @__PURE__ */ React.createElement("span", { className: "ond-estado-pill", style: { "--ond-cor": estado.cor } }, estado.label), /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, onda.dia), /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, onda.pessoaNome || (onda.pessoaId ? `#${onda.pessoaId}` : "por atribuir")), (percurso.origem.length > 0 || percurso.destino.length > 0) && /* @__PURE__ */ React.createElement("span", { className: "ond-dim ond-modal__percurso" }, percurso.origem.join(", ") || "\u2014", /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true" }, " \u2192 "), percurso.destino.join(", ") || "\u2014"), onArquivar && !L.foraDeCirculacao(onda) && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      style: { marginLeft: "auto" },
      onClick: () => onArquivar(onda.id)
    },
    "Arquivar"
  )), /* @__PURE__ */ React.createElement(OndModalPhc, { phc }), onda.servidorId != null && /* @__PURE__ */ React.createElement(
    window.CpReservasDaLista,
    {
      onda: onda.servidorId,
      titulo: "Paletes que esta onda segura"
    }
  ), onda.estado === "concluida" && phc.porLancar > 0 && /* @__PURE__ */ React.createElement("p", { className: "ond-modal__nota" }, "Esta onda est\xE1 dada por conclu\xEDda e ainda tem trabalho por lan\xE7ar. Reabrir uma tarefa aqui devolve-a a \xABpor fazer\xBB e guarda tudo o que \xE9 facto \u2014 o tempo medido, os lotes picados e as pausas."), phc.lancadas > 0 && /* @__PURE__ */ React.createElement("p", { className: "ond-modal__nota is-aviso" }, "Reabrir no hub ", /* @__PURE__ */ React.createElement("strong", null, "N\xC3O"), " tira do PHC o que j\xE1 l\xE1 est\xE1:", " ", ondPaletes(phc.lancadas), " ", phc.lancadas === 1 ? "continua" : "continuam", " ", "no dossier 82. Se for preciso anular, \xE9 no PHC."), /* @__PURE__ */ React.createElement("div", { className: "ond-modal__tempos" }, /* @__PURE__ */ React.createElement("span", null, "Previsto ", /* @__PURE__ */ React.createElement("strong", null, CL.duracao(L.duracaoPrevista(onda, dados)))), /* @__PURE__ */ React.createElement("span", null, "Real ", /* @__PURE__ */ React.createElement("strong", null, desvio.comparavel ? CL.duracao(desvio.realMin) : "s/ medi\xE7\xE3o")), desvio.desvioMin != null && /* @__PURE__ */ React.createElement("span", { className: desvio.desvioMin > 0 ? "cp-erro-txt" : "" }, "Desvio ", /* @__PURE__ */ React.createElement("strong", null, desvio.desvioMin > 0 ? "+" : "", desvio.desvioMin, " min")), onda.inicioReal && /* @__PURE__ */ React.createElement("span", null, "Come\xE7ou ", /* @__PURE__ */ React.createElement("strong", null, new Date(onda.inicioReal).toLocaleTimeString(
    "pt-PT",
    { hour: "2-digit", minute: "2-digit" }
  ))), onda.fimReal && /* @__PURE__ */ React.createElement("span", null, "Acabou ", /* @__PURE__ */ React.createElement("strong", null, new Date(onda.fimReal).toLocaleTimeString(
    "pt-PT",
    { hour: "2-digit", minute: "2-digit" }
  )))), /* @__PURE__ */ React.createElement("ul", { className: "ond-modal__tarefas" }, tarefas.map((t) => /* @__PURE__ */ React.createElement(
    OndModalTarefa,
    {
      key: t.id,
      tarefa: t,
      dados,
      onReabrir: L.foraDeCirculacao(onda) ? null : onReabrir,
      kit: L.kitDaTarefa(t, tarefas)
    }
  )), !tarefas.length && /* @__PURE__ */ React.createElement("li", { className: "ond-vazio" }, "Esta onda n\xE3o tem tarefas."))));
}
window.OndOndaModal = OndOndaModal;

// ===== cargoplanner/frontend/ondas_operador_etiqueta.jsx =====
const OP_ANO_MINIMO = 1950;
function opQtd(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return "\u2014";
  return n.toLocaleString("pt-PT", { maximumFractionDigits: 3 });
}
function opAlocacaoMeta(alocacao) {
  const quando = opDesdeQuando(alocacao && alocacao.desde);
  const quem = alocacao && alocacao.por || "";
  return [quando, quem].filter(Boolean).join(" \xB7 ");
}
function opDesdeQuando(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  if (d.getFullYear() < OP_ANO_MINIMO) return "";
  const dias = Math.floor((Date.now() - d.getTime()) / 864e5);
  if (dias <= 0) return "hoje";
  if (dias === 1) return "ontem";
  return `h\xE1 ${dias} dias`;
}
const OP_ETIQUETA_LINHAS = [
  ["N/ Ref.", "referencia"],
  ["Lote", "lote"],
  ["Designa\xE7\xE3o", "designacao", true],
  ["Cliente", "cliente", true],
  ["Quantidade", "quantidade"],
  ["Unidade", "unidade"],
  ["V/ Enc.", "po_cliente"],
  ["V/ Ref.", "ref_cliente", true],
  ["N/ Doc.", "n_doc"],
  ["OF", "of"],
  ["1.\xAA M\xE1q.", "maquina"],
  ["PO", "po"],
  ["Rece\xE7\xE3o", "n_rececao"],
  ["FSC", "fsc"],
  ["Data", "data"]
];
function ondOpComando(valor, { definir, aoEnter }) {
  const { comando, resto } = window.OndasLogica.comandoDoScanner(valor);
  if (!comando) return false;
  if (definir) definir(resto);
  if (comando === "enter") {
    if (aoEnter) aoEnter(resto);
    return true;
  }
  ondOpFocoSeguinte();
  return true;
}
function ondOpFocoSeguinte() {
  const ativo = document.activeElement;
  const raiz = ativo && ativo.closest && ativo.closest(".ond-op") || document.querySelector(".ond-op");
  if (!raiz) return;
  const campos = [...raiz.querySelectorAll("input, textarea")].filter((el) => !el.disabled && !el.readOnly && el.type !== "checkbox" && el.type !== "radio" && el.offsetParent !== null);
  if (!campos.length) return;
  const i = campos.indexOf(ativo);
  const alvo = campos[(i + 1) % campos.length];
  alvo.focus();
  if (alvo.select) alvo.select();
}
window.OndOpComando = ondOpComando;
function OndOpStockDaReferencia({ referencia, empresaId }) {
  const [estado, setEstado] = React.useState(null);
  React.useEffect(() => {
    let vivo = true;
    if (!referencia) {
      setEstado(null);
      return void 0;
    }
    setEstado({ aLer: true });
    window.CargoplannerAPI.stockPorArmazem(referencia, empresaId).then((r) => {
      if (vivo) setEstado({ dados: r || null });
    }).catch(() => {
      if (vivo) setEstado({ erro: true });
    });
    return () => {
      vivo = false;
    };
  }, [referencia, empresaId]);
  if (!referencia || !estado) return null;
  if (estado.aLer) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "A ver o stock de ", referencia, "\u2026");
  }
  if (estado.erro || !estado.dados) return null;
  const d = estado.dados;
  return /* @__PURE__ */ React.createElement("section", { className: "ond-op__lista ond-op__armazens" }, /* @__PURE__ */ React.createElement("h3", null, "Informa\xE7\xE3o do artigo"), /* @__PURE__ */ React.createElement("div", { className: "ond-op__campo-label ond-op__arm-nota" }, "Do artigo inteiro, n\xE3o desta palete"), d.armazens.length ? d.armazens.map((a) => /* @__PURE__ */ React.createElement("div", { key: a.armazem, className: "ond-op__arm" }, /* @__PURE__ */ React.createElement("span", { className: "ond-op__arm-nome" }, "Arm. ", a.armazem, a.nome ? ` \xB7 ${a.nome}` : ""), /* @__PURE__ */ React.createElement("span", { className: "ond-op__arm-qtd" }, opQtd(a.stock)))) : (
    /* Zero nos seis armazéns é um FACTO, e diz-se — não se deixa a lista
       vazia a parecer que o pedido falhou. */
    /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "Sem stock nos armaz\xE9ns da opera\xE7\xE3o.")
  ), /* @__PURE__ */ React.createElement("div", { className: "ond-op__arm is-total" }, /* @__PURE__ */ React.createElement("span", { className: "ond-op__arm-nome" }, "Total em armaz\xE9m"), /* @__PURE__ */ React.createElement("span", { className: "ond-op__arm-qtd" }, opQtd(d.total))), d.noutros ? /* @__PURE__ */ React.createElement("div", { className: "ond-dim ond-op__arm-noutros" }, opQtd(d.noutros), " noutros armaz\xE9ns (o artigo tem ", opQtd(d.total_artigo), " ao todo).") : null, /* @__PURE__ */ React.createElement("div", { className: "ond-op__campos" }, /* @__PURE__ */ React.createElement(OndOpCampo, { label: "Reservado a clientes", valor: opQtd(d.reservado_clientes) }), /* @__PURE__ */ React.createElement(
    OndOpCampo,
    {
      label: "Encomendado a fornecedores",
      valor: opQtd(d.encomendado_fornecedores)
    }
  )));
}
function OndOpLoteModal({ codigo, referencia, onFechar }) {
  const [estado, setEstado] = React.useState(null);
  React.useEffect(() => {
    let vivo = true;
    if (!codigo) {
      setEstado(null);
      return void 0;
    }
    setEstado({ aLer: true });
    window.CargoplannerAPI.etiqueta(codigo).then((r) => {
      if (vivo) setEstado({ dados: r });
    }).catch((e) => {
      if (vivo) setEstado({ erro: String(e && e.message || e) });
    });
    return () => {
      vivo = false;
    };
  }, [codigo]);
  const dados = estado && estado.dados;
  const encontrado = !!(dados && dados.encontrado);
  const ref = encontrado && dados.campos.referencia || referencia || "";
  return /* @__PURE__ */ React.createElement(window.ModalShell, { title: `Lote ${codigo}`, width: 640, onClose: onFechar }, !estado || estado.aLer ? /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "A ler o lote\u2026") : estado.erro ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, estado.erro) : !encontrado ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__vazio" }, "N\xE3o h\xE1 rece\xE7\xE3o para o lote ", /* @__PURE__ */ React.createElement("strong", null, codigo), ".") : /* @__PURE__ */ React.createElement("div", { className: "ond-op__atual" }, /* @__PURE__ */ React.createElement(OndOpDetalheLote, { resultado: dados })), ref && estado && !estado.aLer ? /* @__PURE__ */ React.createElement(
    OndOpStockDaReferencia,
    {
      referencia: ref,
      empresaId: dados && dados.empresa && dados.empresa.id
    }
  ) : null);
}
function OndOpDetalheLote({ resultado }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao" }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__campo-label" }, "Aloca\xE7\xE3o"), !resultado.alocacao ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao-valor" }, "Este lote n\xE3o existe no stock \u2014 n\xE3o h\xE1 aloca\xE7\xE3o para mostrar.") : resultado.alocacao.local ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao-valor is-forte" }, resultado.alocacao.local, opAlocacaoMeta(resultado.alocacao) ? /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "ond-op__alocacao-meta",
      title: String(resultado.alocacao.desde || "")
    },
    opAlocacaoMeta(resultado.alocacao)
  ) : null) : /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao-valor" }, "Por alocar.")), resultado.of ? /* @__PURE__ */ React.createElement(
    OndOpProducaoDaOf,
    {
      of: resultado.of,
      numero: resultado.campos.of
    }
  ) : null, /* @__PURE__ */ React.createElement("div", { className: "ond-op__campos" }, OP_ETIQUETA_LINHAS.map(([rotulo, chave, largo]) => /* @__PURE__ */ React.createElement(
    OndOpCampo,
    {
      key: chave,
      label: rotulo,
      largo,
      valor: resultado.campos[chave] || "\u2014"
    }
  ))));
}
function OndOpProducaoDaOf({ of, numero }) {
  const n = (v) => v == null ? "\u2014" : String(v).replace(/\.0+$/, "");
  if (!of.propria) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao" }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__campo-label" }, "OF ", numero || "\u2014", /* @__PURE__ */ React.createElement("span", { className: "ond-op__of-qtd" }, of.total != null ? `manda fazer ${n(of.total)}` : "quantidade por apurar")), /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao-valor" }, "Este material \xE9 para esta OF."));
  }
  const feito = of.paletes > 0;
  return /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao" }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__campo-label" }, "OF ", numero || "\u2014", " \u2014 produ\xE7\xE3o", feito ? /* @__PURE__ */ React.createElement("span", { className: "ond-op__of-qtd" }, n(of.produzido), of.total != null ? ` de ${n(of.total)}` : " \u2014 total da OF por apurar") : null), !feito ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao-valor" }, "Ainda sem paletes produzidas", of.total != null ? ` \u2014 a OF manda fazer ${n(of.total)}.` : ".") : /* @__PURE__ */ React.createElement("div", { className: "ond-op__alocacao-valor is-forte" }, of.paletes, " ", of.paletes === 1 ? "palete" : "paletes"));
}
function OndOpEtiqueta() {
  const { useState, useRef, useEffect } = React;
  const [codigo, setCodigo] = useState("");
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState("");
  const [ocupado, setOcupado] = useState(false);
  const entrada = useRef(null);
  const [minhaImpressora, setMinhaImpressora] = useState(void 0);
  const [impressorasDisponiveis, setImpressorasDisponiveis] = useState(null);
  const [aEscolherImpressora, setAEscolherImpressora] = useState(false);
  const [impressoraEscolhida, setImpressoraEscolhida] = useState("");
  const [aImprimir, setAImprimir] = useState(false);
  const [avisoImpressao, setAvisoImpressao] = useState(null);
  const [erroImpressao, setErroImpressao] = useState("");
  useEffect(() => {
    if (entrada.current) entrada.current.focus();
  }, []);
  useEffect(() => {
    let vivo = true;
    window.IVAPI.get("/api/cargoplanner/minha-impressora/").then((r) => {
      if (vivo) setMinhaImpressora(r.impressora);
    }).catch(() => {
      if (vivo) setMinhaImpressora(null);
    });
    return () => {
      vivo = false;
    };
  }, []);
  async function ler(valor) {
    const lote = String(valor == null ? codigo : valor).trim();
    if (!lote) return;
    setOcupado(true);
    setErro("");
    setResultado(null);
    setAEscolherImpressora(false);
    setAvisoImpressao(null);
    setErroImpressao("");
    try {
      setResultado(await window.CargoplannerAPI.etiqueta(lote));
    } catch (e) {
      setErro(String(e && e.message || e));
    } finally {
      setOcupado(false);
      if (entrada.current) {
        entrada.current.select();
        entrada.current.focus();
      }
    }
  }
  async function imprimirCom(idImpressora) {
    if (!resultado || !resultado.encontrado) return;
    setAImprimir(true);
    setErroImpressao("");
    setAvisoImpressao(null);
    try {
      const r = await window.IVImprimir({
        lote: resultado.lote,
        empresa: resultado.empresa.id,
        copias: resultado.copias,
        reimpressao: true
      });
      setAvisoImpressao(r.aviso || { tipo: "sucesso", texto: "Enviado para a impressora." });
    } catch (e) {
      setErroImpressao(String(e && e.message || e));
    } finally {
      setAImprimir(false);
    }
  }
  async function reimprimir() {
    if (aImprimir || minhaImpressora === void 0) return;
    if (minhaImpressora != null) {
      await imprimirCom(minhaImpressora);
      return;
    }
    setErroImpressao("");
    setAvisoImpressao(null);
    setAEscolherImpressora(true);
    if (!impressorasDisponiveis) {
      try {
        const lista = await window.IVAPI.get("/api/cargoplanner/impressoras/");
        setImpressorasDisponiveis((lista || []).filter((i) => i.ativa));
      } catch (e) {
        setErroImpressao(String(e && e.message || e));
      }
    }
  }
  async function confirmarImpressora() {
    const pk = Number(impressoraEscolhida);
    if (!pk) return;
    setAImprimir(true);
    setErroImpressao("");
    try {
      await window.IVAPI.put("/api/cargoplanner/minha-impressora/", { impressora: pk });
      setMinhaImpressora(pk);
      setAEscolherImpressora(false);
      await imprimirCom(pk);
    } catch (e) {
      setErroImpressao(String(e && e.message || e));
      setAImprimir(false);
    }
  }
  return /* @__PURE__ */ React.createElement("div", { className: "ond-op__etiqueta" }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement("label", { className: "ond-op__campo-label", htmlFor: "op-etiqueta-input" }, "Ler c\xF3digo de barras / QR da etiqueta")), /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id: "op-etiqueta-input",
      ref: entrada,
      className: "ond-select",
      value: codigo,
      onChange: (e) => {
        if (ondOpComando(e.target.value, {
          definir: setCodigo,
          aoEnter: (v) => ler(v)
        })) return;
        setCodigo(e.target.value);
      },
      onKeyDown: (e) => {
        if (e.key === "Enter") ler();
      },
      placeholder: "Ler c\xF3digo de barras / QR da etiqueta",
      "aria-label": "Ler c\xF3digo de barras / QR da etiqueta"
    }
  ), /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "ok",
      disabled: ocupado || !codigo.trim(),
      onClick: () => ler()
    },
    ocupado ? "A ler\u2026" : "Ver"
  )), erro ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, erro) : null, resultado && !resultado.encontrado ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__vazio" }, "N\xE3o h\xE1 rece\xE7\xE3o para o lote ", /* @__PURE__ */ React.createElement("strong", null, resultado.lote), ".") : null, resultado && resultado.encontrado ? /* @__PURE__ */ React.createElement("section", { className: "ond-op__atual" }, /* @__PURE__ */ React.createElement(OndOpDetalheLote, { resultado }), /* @__PURE__ */ React.createElement(
    OndOpStockDaReferencia,
    {
      referencia: resultado.campos.referencia,
      empresaId: resultado.empresa && resultado.empresa.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, !aEscolherImpressora ? /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "done",
      disabled: aImprimir || minhaImpressora === void 0,
      onClick: reimprimir
    },
    aImprimir ? "A imprimir\u2026" : `Reimprimir (${resultado.copias} ${resultado.copias === 1 ? "c\xF3pia" : "c\xF3pias"})`
  ) : /* @__PURE__ */ React.createElement("div", { className: "ond-op__escolher-impressora" }, /* @__PURE__ */ React.createElement("label", { className: "ond-op__campo-label", htmlFor: "op-escolher-impressora" }, "Escolha a impressora \u2014 fica guardada, n\xE3o volta a perguntar"), /* @__PURE__ */ React.createElement(
    "select",
    {
      id: "op-escolher-impressora",
      className: "ond-select",
      value: impressoraEscolhida,
      onChange: (e) => setImpressoraEscolhida(e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"),
    (impressorasDisponiveis || []).map((i) => /* @__PURE__ */ React.createElement("option", { key: i.id, value: i.id }, i.nome))
  ), impressorasDisponiveis && !impressorasDisponiveis.length ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, "N\xE3o h\xE1 impressoras ativas configuradas.") : null, /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "done",
      disabled: aImprimir || !impressoraEscolhida,
      onClick: confirmarImpressora
    },
    aImprimir ? "A imprimir\u2026" : "Confirmar e imprimir"
  ))), erroImpressao ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, erroImpressao) : null, avisoImpressao ? /* @__PURE__ */ React.createElement("div", { className: avisoImpressao.tipo === "sucesso" ? "ond-op__lido-ok" : "ond-op__bloqueio" }, avisoImpressao.texto) : null) : null);
}
window.OndOpProducaoDaOf = OndOpProducaoDaOf;
window.OndOpEtiqueta = OndOpEtiqueta;
function OndOpAlocar({ destinoPlaneado }) {
  const { useState, useRef, useEffect } = React;
  const [codigo, setCodigo] = useState("");
  const [lista, setLista] = useState([]);
  const inicioRef = useRef(null);
  const [loteAberto, setLoteAberto] = useState(null);
  const [aLer, setALer] = useState(false);
  const [erroLeitura, setErroLeitura] = useState("");
  const [local, setLocal] = useState("");
  const [localInfo, setLocalInfo] = useState(null);
  const [aValidarLocal, setAValidarLocal] = useState(false);
  const [erroLocal, setErroLocal] = useState("");
  const [aAlocar, setAAlocar] = useState(false);
  const aAlocarRef = useRef(false);
  const [resultado, setResultado] = useState(null);
  const entradaEtiqueta = useRef(null);
  const relogioLocal = useRef(null);
  const pedidoLocal = useRef(0);
  const localRef = useRef("");
  const fila = useRef([]);
  const aEscoar = useRef(false);
  const [porLer, setPorLer] = useState(0);
  const listaRef = useRef([]);
  useEffect(() => {
    if (entradaEtiqueta.current) entradaEtiqueta.current.focus();
    return () => {
      if (relogioLocal.current) clearTimeout(relogioLocal.current);
    };
  }, []);
  useEffect(() => {
    if (!destinoPlaneado) return;
    setLocal((atual) => atual ? atual : destinoPlaneado);
    localRef.current = localRef.current || destinoPlaneado;
  }, [destinoPlaneado]);
  useEffect(() => {
    listaRef.current = lista;
  }, [lista]);
  useEffect(() => {
    if (lista.length) return;
    setLocalInfo(null);
    setErroLocal("");
  }, [lista.length]);
  const empresaAtual = lista.length ? lista[0].empresa : null;
  useEffect(() => {
    if (!window.OndasLogica.deveAutoValidarLocal({
      temEmpresa: !!empresaAtual,
      localInfo,
      aValidarLocal,
      erroLocal,
      texto: localRef.current,
      textoVisivel: local
    })) return;
    validarLocal(localRef.current);
  }, [empresaAtual]);
  function ler(valor) {
    const cod = String(valor == null ? codigo : valor).trim().toUpperCase();
    setCodigo("");
    if (entradaEtiqueta.current) {
      entradaEtiqueta.current.select();
      entradaEtiqueta.current.focus();
    }
    if (!cod) return;
    setErroLeitura("");
    setResultado(null);
    if (listaRef.current.some((l) => l.codigo === cod)) return;
    if (fila.current.includes(cod)) return;
    fila.current.push(cod);
    setPorLer(fila.current.length);
    escoar();
  }
  async function escoar() {
    if (aEscoar.current) return;
    aEscoar.current = true;
    setALer(true);
    try {
      while (fila.current.length) {
        const cod = fila.current[0];
        await lerUma(cod);
        fila.current.shift();
        setPorLer(fila.current.length);
      }
    } finally {
      aEscoar.current = false;
      setALer(false);
    }
  }
  async function lerUma(cod) {
    try {
      const r = await window.CargoplannerAPI.etiqueta(cod);
      if (!r.encontrado) {
        setErroLeitura(`N\xE3o h\xE1 rece\xE7\xE3o para o lote ${cod}.`);
        return;
      }
      const jaLa = listaRef.current;
      if (!jaLa.length) inicioRef.current = Date.now();
      const empresa = jaLa.length ? jaLa[0].empresa : null;
      if (empresa && r.empresa.id !== empresa.id) {
        setErroLeitura(
          `"${cod}" \xE9 de ${r.empresa.nome} \u2014 as etiquetas desta lista s\xE3o de ${empresa.nome}. Etiquetas de empresas diferentes n\xE3o podem ir no mesmo lote.`
        );
        return;
      }
      const nova = {
        codigo: cod,
        // A referência é do ARTIGO e serve o bloco de informação do artigo,
        // por baixo da lista; a designação é o que se mostra na linha.
        referencia: r.campos.referencia || "",
        designacao: r.campos.designacao || r.campos.referencia || "",
        empresa: r.empresa,
        estavaEm: r.alocacao && r.alocacao.local || null
      };
      listaRef.current = [...jaLa, nova];
      setLista(listaRef.current);
    } catch (e) {
      setErroLeitura(String(e && e.message || e));
    }
  }
  function remover(cod) {
    setLista((l) => {
      const resto = l.filter((item) => item.codigo !== cod);
      if (!resto.length) inicioRef.current = null;
      return resto;
    });
  }
  function mudarLocal(valor) {
    localRef.current = String(valor || "");
    setLocal(valor);
    setLocalInfo(null);
    setErroLocal("");
    if (relogioLocal.current) clearTimeout(relogioLocal.current);
    pedidoLocal.current += 1;
    const cod = String(valor || "").trim();
    if (!cod || !empresaAtual) return;
    relogioLocal.current = setTimeout(() => validarLocal(cod), 400);
  }
  async function validarLocal(valor) {
    if (relogioLocal.current) {
      clearTimeout(relogioLocal.current);
      relogioLocal.current = null;
    }
    const cod = window.OndasLogica.comandoDoScanner(
      String(valor == null ? localRef.current : valor)
    ).resto.trim();
    if (!cod) return null;
    if (!empresaAtual) return null;
    const meu = pedidoLocal.current += 1;
    const atual = () => meu === pedidoLocal.current;
    setAValidarLocal(true);
    setErroLocal("");
    setLocalInfo(null);
    try {
      const r = await window.CargoplannerAPI.localizacao(cod, empresaAtual.id);
      if (!atual()) return null;
      if (!r.encontrado) {
        setErroLocal(`"${cod}" n\xE3o existe (ou est\xE1 inativa) no armaz\xE9m. Acrescente-a em \xABu_locais_arm\xBB antes de alocar.`);
        return null;
      }
      setLocalInfo(r);
      return r;
    } catch (e) {
      if (!atual()) return null;
      setErroLocal(String(e && e.message || e));
      return null;
    } finally {
      if (atual()) setAValidarLocal(false);
    }
  }
  async function validarEAlocar(valor) {
    const confirmada = await validarLocal(valor);
    if (confirmada) alocar(confirmada);
  }
  function enterNaLocalizacao(valor) {
    const { acao } = window.OndasLogica.gestoDeAlocar({
      aAlocar,
      aLer,
      porLer,
      etiquetas: lista.length,
      localInfo,
      aValidarLocal,
      erroLocal,
      texto: valor == null ? localRef.current : valor
    });
    if (acao === "alocar") {
      alocar();
      return;
    }
    if (acao === "validar_e_alocar") {
      validarEAlocar(valor);
      return;
    }
    if (aAlocar || aLer) return;
    validarLocal(valor);
  }
  async function alocar(info) {
    const alvo = info || localInfo;
    if (aEscoar.current || fila.current.length) return;
    if (aAlocar || !lista.length || !alvo) return;
    if (aAlocarRef.current) return;
    aAlocarRef.current = true;
    setAAlocar(true);
    setResultado(null);
    const destino = alvo.codigo;
    try {
      const planeado = String(destinoPlaneado || "").trim().toUpperCase();
      if (planeado && planeado !== String(destino || "").trim().toUpperCase()) {
        const confirma = await window.hubConfirm({
          title: "Destino fora do plano",
          message: `O planeado era ${destinoPlaneado} \u2014 vai alocar em ${destino}. Confirma?`,
          confirmLabel: "Alocar assim mesmo",
          danger: false
        });
        if (!confirma) return;
      }
      const r = await window.CargoplannerAPI.alocar({
        codigos: lista.map((item) => item.codigo),
        local: destino,
        empresa: empresaAtual.id,
        // O tempo desta alocação, medido no tablet. `null` quando não há
        // início (uma lista que veio de outro lado) — e `null` é «não se
        // mediu», que o servidor sabe distinguir de zero.
        duracao_min: inicioRef.current ? (Date.now() - inicioRef.current) / 6e4 : null
      });
      const onda = r.onda ? ` Registado em ${r.onda.codigo}${r.onda.pessoa ? "" : " (sem ficha de operador \u2014 a onda ficou sem dono)"}.` : "";
      setResultado({
        ok: true,
        msg: `Alocadas ${r.alocados.length} etiqueta${r.alocados.length === 1 ? "" : "s"} em ${destino}.${onda}`
      });
      inicioRef.current = null;
      setLista([]);
      setLocal("");
      setLocalInfo(null);
      localRef.current = "";
      if (relogioLocal.current) {
        clearTimeout(relogioLocal.current);
        relogioLocal.current = null;
      }
      pedidoLocal.current += 1;
      setErroLocal("");
    } catch (e) {
      setResultado({ ok: false, msg: String(e && e.message || e) });
    } finally {
      aAlocarRef.current = false;
      setAAlocar(false);
    }
  }
  const foraDoPlano = !!(destinoPlaneado && localInfo && String(localInfo.codigo).toUpperCase() !== String(destinoPlaneado).trim().toUpperCase());
  const gesto = window.OndasLogica.gestoDeAlocar({
    aAlocar,
    aLer,
    porLer,
    etiquetas: lista.length,
    localInfo,
    aValidarLocal,
    erroLocal,
    texto: local
  });
  const faltaParaAlocar = {
    fila: `A ler etiquetas\u2026 (${porLer} na fila)`,
    a_ler: "A ler a etiqueta\u2026",
    sem_etiquetas: "Leia pelo menos uma etiqueta.",
    a_validar: "A validar a localiza\xE7\xE3o\u2026",
    sem_local: "Leia a localiza\xE7\xE3o de destino."
  }[gesto.falta] || null;
  return /* @__PURE__ */ React.createElement("div", { className: "ond-op__etiqueta" }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement("label", { className: "ond-op__campo-label", htmlFor: "op-alocar-etiqueta" }, "Ler c\xF3digo de barras / QR das etiquetas a alocar")), /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id: "op-alocar-etiqueta",
      ref: entradaEtiqueta,
      className: "ond-select",
      value: codigo,
      onChange: (e) => {
        if (ondOpComando(e.target.value, {
          definir: setCodigo,
          aoEnter: (v) => ler(v)
        })) return;
        setCodigo(e.target.value);
      },
      onKeyDown: (e) => {
        if (e.key === "Enter") ler();
      },
      placeholder: "Ler c\xF3digo de barras / QR das etiquetas a alocar",
      "aria-label": "Ler c\xF3digo de barras / QR das etiquetas a alocar"
    }
  ), /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "ok",
      disabled: !codigo.trim(),
      onClick: () => ler()
    },
    "Ler"
  )), aLer ? /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "A ler\u2026", porLer > 0 ? ` (${porLer} na fila)` : "") : null, erroLeitura ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, erroLeitura) : null, /* @__PURE__ */ React.createElement("section", { className: "ond-op__lista" }, /* @__PURE__ */ React.createElement("h3", null, "Etiquetas lidas (", lista.length, ")"), !lista.length ? /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "Ainda n\xE3o leu nenhuma etiqueta.") : lista.map((item) => /* @__PURE__ */ React.createElement("div", { key: item.codigo, className: "ond-op__lida" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "ond-op__lida-abrir",
      title: `Ver o lote ${item.codigo}`,
      onClick: () => setLoteAberto(item)
    },
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, item.codigo),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, item.designacao || "\u2014"),
    item.estavaEm ? /* @__PURE__ */ React.createElement("span", { className: "ond-op__lida-aviso" }, "estava em ", item.estavaEm) : null
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "ond-op__lida-remover",
      title: "Remover esta etiqueta",
      "aria-label": `Remover ${item.codigo}`,
      onClick: () => remover(item.codigo)
    },
    "\u2715"
  )))), /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement("label", { className: "ond-op__campo-label", htmlFor: "op-alocar-local" }, "Ler c\xF3digo de barras / QR da localiza\xE7\xE3o")), /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id: "op-alocar-local",
      className: "ond-select",
      value: local,
      onChange: (e) => {
        if (ondOpComando(e.target.value, {
          definir: mudarLocal,
          aoEnter: (v) => enterNaLocalizacao(v)
        })) return;
        mudarLocal(e.target.value);
      },
      onKeyDown: (e) => {
        if (e.key === "Enter") enterNaLocalizacao();
      },
      onBlur: () => validarLocal(),
      placeholder: "Ler c\xF3digo de barras / QR da localiza\xE7\xE3o",
      "aria-label": "Ler c\xF3digo de barras / QR da localiza\xE7\xE3o"
    }
  ), aValidarLocal ? /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, "A validar\u2026") : null), erroLocal ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, erroLocal) : null, localInfo ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__local-confirmado" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, localInfo.codigo), ` \xB7 zona ${localInfo.zona || "\u2014"}, prateleira ${localInfo.prateleira || "\u2014"}, coluna ${localInfo.coluna || "\u2014"}`), localInfo.observacoes ? /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, localInfo.observacoes) : null) : null, foraDoPlano ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__lida-aviso" }, "O planeado era ", destinoPlaneado, " \u2014 vai para ", localInfo.codigo, ".") : null, /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "done",
      disabled: gesto.acao === "nada",
      onClick: () => gesto.acao === "alocar" ? alocar() : validarEAlocar()
    },
    aAlocar ? "A alocar\u2026" : `Alocar ${lista.length} etiqueta${lista.length === 1 ? "" : "s"}`
  ), !aAlocar && faltaParaAlocar ? /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, faltaParaAlocar) : null, resultado ? /* @__PURE__ */ React.createElement("div", { className: resultado.ok ? "ond-op__lido-ok" : "ond-op__bloqueio" }, resultado.msg) : null, loteAberto ? /* @__PURE__ */ React.createElement(
    OndOpLoteModal,
    {
      codigo: loteAberto.codigo,
      referencia: loteAberto.referencia,
      onFechar: () => setLoteAberto(null)
    }
  ) : null);
}
window.OndOpAlocar = OndOpAlocar;
function OndOpProcurar() {
  const { useState, useRef, useEffect } = React;
  const [texto, setTexto] = useState("");
  const [resultado, setResultado] = useState(null);
  const [aProcurar, setAProcurar] = useState(false);
  const [erro, setErro] = useState("");
  const [confirmado, setConfirmado] = useState(false);
  const [aberto, setAberto] = useState(null);
  const entrada = useRef(null);
  const temporizador = useRef(null);
  const vivoRef = useRef(true);
  useEffect(() => {
    if (entrada.current) entrada.current.focus();
    return () => {
      vivoRef.current = false;
    };
  }, []);
  async function buscar(q, { imediato } = {}) {
    if (temporizador.current) {
      clearTimeout(temporizador.current);
      temporizador.current = null;
    }
    if (imediato) setConfirmado(true);
    if (q.length < 2) {
      setResultado(null);
      setErro("");
      return;
    }
    setAProcurar(true);
    setErro("");
    try {
      const r = await window.CargoplannerAPI.procurarStock(q);
      if (vivoRef.current) setResultado(r);
    } catch (e) {
      if (vivoRef.current) setErro(String(e && e.message || e));
    } finally {
      if (vivoRef.current) setAProcurar(false);
    }
  }
  function mudarTexto(valor) {
    setTexto(valor);
    setErro("");
    setConfirmado(false);
    if (temporizador.current) clearTimeout(temporizador.current);
    const q = valor.trim();
    if (q.length < 2) {
      setResultado(null);
      return;
    }
    temporizador.current = setTimeout(() => buscar(q), 350);
  }
  function escolher(ref) {
    setTexto(ref);
    buscar(ref, { imediato: true });
  }
  const sugestoes = !confirmado && resultado && resultado.sugestoes || [];
  const linhas = resultado && resultado.linhas || [];
  const semStock = !!(resultado && resultado.ref && !linhas.length);
  const semNada = !!(resultado && !resultado.ref && !resultado.sugestoes.length);
  return /* @__PURE__ */ React.createElement("div", { className: "ond-op__etiqueta" }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement("label", { className: "ond-op__campo-label", htmlFor: "op-procurar-input" }, "C\xF3digo de etiqueta, refer\xEAncia ou designa\xE7\xE3o")), /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura ond-op__stock-caixa" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id: "op-procurar-input",
      ref: entrada,
      className: "ond-select",
      value: texto,
      onChange: (e) => {
        if (ondOpComando(e.target.value, {
          definir: mudarTexto,
          aoEnter: (v) => buscar(String(v).trim(), { imediato: true })
        })) return;
        mudarTexto(e.target.value);
      },
      onKeyDown: (e) => {
        if (e.key === "Enter") buscar(texto.trim(), { imediato: true });
      },
      placeholder: "C\xF3digo de etiqueta, refer\xEAncia ou designa\xE7\xE3o",
      "aria-label": "C\xF3digo de etiqueta, refer\xEAncia ou designa\xE7\xE3o"
    }
  ), /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "ok",
      disabled: aProcurar || texto.trim().length < 2,
      onClick: () => buscar(texto.trim(), { imediato: true })
    },
    aProcurar ? "A procurar\u2026" : "Ver"
  ), sugestoes.length > 0 && resultado.cortou ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__stock-cortou" }, "Mostra s\xF3 as primeiras ", sugestoes.length, " refer\xEAncias \u2014 escreva mais para afinar.") : null, sugestoes.length ? /* @__PURE__ */ React.createElement("ul", { className: "ond-op__sugestoes" }, sugestoes.map((s) => /* @__PURE__ */ React.createElement("li", { key: s.ref }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "ond-op__sugestao",
      onClick: () => escolher(s.ref)
    },
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, s.ref),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, s.designacao || "\u2014")
  )))) : null), erro ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, erro) : null, !aProcurar && !erro && semStock ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__vazio" }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, resultado.ref), " \u2014 sem stock em armaz\xE9m.") : null, !aProcurar && !erro && semNada ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__vazio" }, "N\xE3o encontrei nenhuma refer\xEAncia para \xAB", texto.trim(), "\xBB.") : null, linhas.length ? /* @__PURE__ */ React.createElement("section", { className: "ond-op__lista" }, /* @__PURE__ */ React.createElement("h3", null, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, resultado.ref), " ", /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, linhas[0].designacao || "\u2014")), /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, linhas.length, " ", linhas.length === 1 ? "palete" : "paletes", " com stock, por FIFO"), linhas.map((l, i) => /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      key: `${l.codigo}-${i}`,
      className: "ond-op__lida ond-op__stock-linha",
      onClick: () => setAberto(l.codigo),
      title: `Ver o detalhe do lote ${l.codigo || ""}`
    },
    /* @__PURE__ */ React.createElement("span", { className: "ond-op__stock-quantidade" }, l.stock),
    l.local ? /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, l.local) : /* @__PURE__ */ React.createElement("span", { className: "ond-op__stock-poralocar" }, "Por alocar"),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, l.data ? String(l.data).slice(0, 10) : "\u2014"),
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, l.codigo || "\u2014")
  ))) : null, aberto ? /* @__PURE__ */ React.createElement(
    OndOpLoteModal,
    {
      codigo: aberto,
      referencia: resultado && resultado.ref,
      onFechar: () => setAberto(null)
    }
  ) : null);
}
window.OndOpProcurar = OndOpProcurar;

// ===== cargoplanner/frontend/ondas_operador.jsx =====
function OndOpBotao({ children, onClick, tom, disabled, title }) {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `ond-op__btn ond-op__btn--${tom}`,
      onClick,
      disabled,
      title
    },
    children
  );
}
function OndOpCampo({ label, valor, forte, largo }) {
  return /* @__PURE__ */ React.createElement("div", { className: `ond-op__campo ${largo ? "ond-op__campo--largo" : ""}` }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__campo-label" }, label), /* @__PURE__ */ React.createElement("div", { className: `ond-op__campo-valor ${forte ? "is-forte" : ""}` }, valor));
}
function OndOpAbas({ aba, onAba }) {
  return /* @__PURE__ */ React.createElement("div", { className: "ond-op__abas ond-op__abas--quatro" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `ond-op__aba ${aba === "trabalho" ? "is-on" : ""}`,
      onClick: () => onAba("trabalho")
    },
    "Trabalho"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `ond-op__aba ${aba === "etiqueta" ? "is-on" : ""}`,
      onClick: () => onAba("etiqueta")
    },
    "Etiqueta"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `ond-op__aba ${aba === "alocar" ? "is-on" : ""}`,
      onClick: () => onAba("alocar")
    },
    "Alocar"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `ond-op__aba ${aba === "procurar" ? "is-on" : ""}`,
      onClick: () => onAba("procurar")
    },
    "Procurar"
  ));
}
function OndOpPausaModal({ dados, onFechar, onPausar }) {
  const motivos = (dados.motivosPausa || []).filter((m) => !m.automatico);
  const [motivo, setMotivo] = React.useState(motivos[0].id);
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Pausar tarefa",
      onClose: onFechar,
      width: 460,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary", onClick: () => onPausar(motivo) }, "Pausar"))
    },
    /* @__PURE__ */ React.createElement("div", { className: "ond-op__motivos" }, motivos.map((m) => /* @__PURE__ */ React.createElement("label", { key: m.id, className: `ond-op__motivo ${motivo === m.id ? "is-on" : ""}` }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        name: "motivo-pausa",
        value: m.id,
        checked: motivo === m.id,
        onChange: () => setMotivo(m.id)
      }
    ), m.label)))
  );
}
function OndOpProblemaModal({ dados, onFechar, onReportar }) {
  const motivos = (dados.motivosPausa || []).filter((m) => !m.automatico);
  const [motivo, setMotivo] = React.useState(motivos[0].id);
  const [nota, setNota] = React.useState("");
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Reportar problema",
      onClose: onFechar,
      width: 460,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn danger", onClick: () => onReportar(motivo, nota) }, "Reportar"))
    },
    /* @__PURE__ */ React.createElement("div", { className: "ond-op__motivos" }, motivos.map((m) => /* @__PURE__ */ React.createElement("label", { key: m.id, className: `ond-op__motivo ${motivo === m.id ? "is-on" : ""}` }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        name: "motivo-problema",
        value: m.id,
        checked: motivo === m.id,
        onChange: () => setMotivo(m.id)
      }
    ), m.label))),
    /* @__PURE__ */ React.createElement("label", { className: "field", style: { marginTop: 10 } }, /* @__PURE__ */ React.createElement("span", null, "Descri\xE7\xE3o (opcional)"), /* @__PURE__ */ React.createElement("textarea", { className: "ond-select", rows: 3, value: nota, onChange: (e) => setNota(e.target.value) }))
  );
}
const OND_PALETES_VISIVEIS = 6;
const OND_PALETES_FOLGA = 2;
function OndOpOfDaTarefa({ tarefaId }) {
  const [estado, setEstado] = React.useState(null);
  React.useEffect(() => {
    let vivo = true;
    if (!tarefaId) {
      setEstado(null);
      return void 0;
    }
    setEstado(null);
    window.CargoplannerAPI.ofDaTarefa(tarefaId).then((r) => {
      if (vivo) setEstado(r || null);
    }).catch(() => {
      if (vivo) setEstado(null);
    });
    return () => {
      vivo = false;
    };
  }, [tarefaId]);
  if (!estado || !estado.of) return null;
  return /* @__PURE__ */ React.createElement(window.OndOpProducaoDaOf, { of: estado.of, numero: estado.numero });
}
function OndOpKitChip({ kit }) {
  if (!kit) return null;
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "cp-tag cp-tag--kit",
      title: `Componente ${kit.indice} de ${kit.total} do kit ${kit.ref}` + (kit.razao == null ? "" : ` (\xD7${kit.razao} por kit)`) + ". O kit s\xF3 sai com os componentes todos."
    },
    "KIT ",
    kit.indice,
    "/",
    kit.total
  );
}
function ondOpUnidade(tarefa) {
  return (tarefa && tarefa.unidade || "").trim() || "un.";
}
function OndOpPaletesDoArtigo({
  artigo,
  qtdPedida,
  tarefa,
  onPicar,
  onTirar,
  onQtdDoLote,
  onQtds,
  tecto,
  avisoTecto
}) {
  const L = window.OndasLogica;
  const [estado, setEstado] = React.useState(null);
  const [todas, setTodas] = React.useState(false);
  const [escritas, setEscritas] = React.useState({});
  React.useEffect(() => {
    let vivo = true;
    setTodas(false);
    setEscritas({});
    if (!artigo) {
      setEstado(null);
      return void 0;
    }
    setEstado({ aLer: true });
    window.CargoplannerAPI.procurarStock(artigo).then((r) => {
      if (vivo) setEstado({ linhas: r && r.linhas || [] });
    }).catch((e) => {
      if (vivo) setEstado({ erro: String(e && e.message || e) });
    });
    return () => {
      vivo = false;
    };
  }, [artigo]);
  const tarefaId = tarefa && (tarefa.servidorId != null ? tarefa.servidorId : tarefa.id);
  const linhasLidas = estado && estado.linhas || null;
  React.useEffect(() => {
    if (!onQtds) return;
    const mapa = /* @__PURE__ */ new Map();
    const stocks = /* @__PURE__ */ new Map();
    (linhasLidas || []).forEach((l) => {
      const r = L.reservaDaPalete(l, { tarefaId });
      mapa.set(l.codigo, L.ecraDaPalete(escritas, l.codigo, r.qtdInicial));
      if (l.stock != null) stocks.set(l.codigo, Number(l.stock));
    });
    onQtds(mapa, stocks);
  }, [linhasLidas, escritas, tarefaId, onQtds, L]);
  if (!artigo || !estado) return null;
  if (estado.aLer) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "A ver as paletes de ", artigo, "\u2026");
  }
  if (estado.erro) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, estado.erro);
  }
  const linhas = estado.linhas || [];
  const p = L.picadoDaTarefa(tarefa);
  const picados = new Map((p.lotes || []).map((l) => [l.codigo, l]));
  const n = (v) => Number(v || 0).toLocaleString("pt-PT");
  if (!linhas.length && !picados.size) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-op__vazio" }, "Sem paletes com stock de ", /* @__PURE__ */ React.createElement("strong", null, artigo), ".");
  }
  let acumulado = 0;
  let livre = 0;
  let livreIncompleto = false;
  const comMarca = linhas.map((l) => {
    const reserva = L.reservaDaPalete(l, { tarefaId });
    acumulado += Number(l.stock) || 0;
    const antes = livre;
    if (reserva.disponivel == null) livreIncompleto = true;
    else livre += reserva.disponivel;
    return {
      ...l,
      reserva,
      // **«Chega aqui» é sobre o que se pode LEVAR, não sobre o que está na
      // prateleira.** Uma palete que outra pessoa já tem na mão não é onde o
      // operador pára de picar — marcá-la mandava-o parar cedo de mais.
      chegaAqui: qtdPedida > 0 && !livreIncompleto && antes < qtdPedida && livre >= qtdPedida
    };
  });
  const total = acumulado;
  const iChega = comMarca.findIndex((l) => l.chegaAqui);
  const corte = Math.max(
    OND_PALETES_VISIVEIS,
    iChega >= 0 ? iChega + 1 + OND_PALETES_FOLGA : 0
  );
  const mostradas = todas ? comMarca : comMarca.filter((l, i) => i < corte || picados.has(l.codigo));
  const escondidas = comMarca.length - mostradas.length;
  const orfas = [...picados.values()].filter(
    (l) => !linhas.some((s) => s.codigo === l.codigo)
  );
  const qtdNaCaixa = (codigo, qtd, lote, picado) => {
    if (picado && lote) return String(lote.qtd == null ? "" : lote.qtd);
    if (Object.prototype.hasOwnProperty.call(escritas, codigo)) return escritas[codigo];
    return qtd == null ? "" : String(qtd);
  };
  const escrever = (codigo, valor, picado) => {
    setEscritas((prev) => ({ ...prev, [codigo]: valor }));
    if (picado && onQtdDoLote) {
      const v = String(valor).replace(",", ".").trim();
      const num = Number(v);
      if (v && Number.isFinite(num) && num > 0) onQtdDoLote(codigo, num);
    }
  };
  const linha = ({ key, codigo, qtd, stock, local, data, picado, chegaAqui, lote, reserva }) => {
    const bloqueada = !picado && !reserva.podePicar;
    const noTecto = !picado && !!(tecto && !tecto.podePicar);
    return /* @__PURE__ */ React.createElement(
      "label",
      {
        key,
        className: "ond-op__lida ond-op__stock-linha ond-op__stock-linha--picking" + (picado ? lote && lote.destino ? " is-picado" : " is-por-alocar" : bloqueada ? " is-esgotada" : chegaAqui ? " is-on" : "")
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: !!picado,
          disabled: !!(lote && lote.phcBistamp) || bloqueada || noTecto,
          title: lote && lote.phcBistamp ? `J\xE1 lan\xE7ada no picking ${lote.phcObrano || ""} do PHC \u2014 n\xE3o se desmarca aqui.` : noTecto ? avisoTecto : void 0,
          "aria-label": picado ? `Tirar ${codigo}` : `Picar ${codigo}`,
          onChange: () => picado ? onTirar(codigo) : onPicar({
            codigo,
            ecra: L.ecraDaPalete(escritas, codigo, qtd),
            stockPalete: stock,
            local,
            data
          })
        }
      ),
      /* @__PURE__ */ React.createElement("span", { className: "td-mono ond-op__stock-lote" }, codigo || "\u2014"),
      /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "ond-op__stock-qtd-input",
          type: "text",
          inputMode: "decimal",
          value: qtdNaCaixa(codigo, qtd, lote, picado),
          disabled: !!(lote && lote.phcBistamp) || bloqueada,
          "aria-label": `Quantidade de ${codigo}`,
          onClick: (e) => e.stopPropagation(),
          onFocus: (e) => e.target.select(),
          onChange: (e) => escrever(codigo, e.target.value, picado)
        }
      ),
      local ? /* @__PURE__ */ React.createElement("span", { className: "td-mono ond-op__stock-local" }, local) : /* @__PURE__ */ React.createElement("span", { className: "ond-op__stock-poralocar" }, "Por alocar"),
      /* @__PURE__ */ React.createElement("span", { className: "ond-dim ond-op__stock-data" }, data ? String(data).slice(0, 10) : "\u2014"),
      picado && lote && lote.destino ? /* @__PURE__ */ React.createElement("span", { className: "ond-op__lido-ok" }, "\u2192 ", lote.destino) : null,
      picado && lote && !lote.destino && L.paleteSaiInteira(lote) === false ? /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "ond-op__lida-parcial",
          title: "Levaste s\xF3 parte desta palete \u2014 ela fica onde est\xE1, e o PHC n\xE3o muda."
        },
        "fica na prateleira"
      ) : null,
      picado && lote && !lote.destino && L.paleteSaiInteira(lote) !== false ? /* @__PURE__ */ React.createElement("span", { className: "ond-op__lida-aviso" }, "por alocar") : null,
      !picado && chegaAqui ? /* @__PURE__ */ React.createElement("span", { className: "ond-op__lida-aviso" }, "chega aqui") : null,
      picado && lote && (() => {
        const phc = window.OndasLogica.estadoPhcDoLote(tarefa, lote);
        if (phc === "falhou") {
          return /* @__PURE__ */ React.createElement("span", { className: "ond-op__lida-erro", title: lote.phcErro }, "PHC falhou");
        }
        if (phc === "por_lancar") {
          return /* @__PURE__ */ React.createElement("span", { className: "ond-op__lida-aviso" }, "por lan\xE7ar no PHC");
        }
        if (phc === "lancada") {
          return /* @__PURE__ */ React.createElement(
            "span",
            {
              className: "ond-op__lido-ok",
              title: `Lan\xE7ada no picking ${lote.phcObrano || ""} do PHC`
            },
            "PHC \u2713"
          );
        }
        return null;
      })(),
      reserva.texto ? /* @__PURE__ */ React.createElement("span", { className: "ond-op__reserva" + (reserva.nivel === "bloqueio" ? " is-bloqueio" : "") }, reserva.texto) : null
    );
  };
  const semReserva = L.reservaDaPalete(null);
  return /* @__PURE__ */ React.createElement("section", { className: "ond-op__lista ond-op__paletes" }, /* @__PURE__ */ React.createElement("h3", null, "Paletes de ", artigo, ", por FIFO (", linhas.length, ")", /* @__PURE__ */ React.createElement("span", { className: "ond-op__picado-conta" }, p.paletes, " picada(s) \xB7 ", n(p.picado), " de ", n(p.pedido), p.semQtd ? ` \xB7 ${p.semQtd} s/ quantidade` : "", p.porAlocar ? ` \xB7 ${p.porAlocar} por alocar` : "")), qtdPedida > 0 && total < qtdPedida ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, "Em armaz\xE9m h\xE1 ", total.toLocaleString("pt-PT"), " ", ondOpUnidade(tarefa), " e a tarefa pede", " ", qtdPedida.toLocaleString("pt-PT"), " \u2014 faltam", " ", (qtdPedida - total).toLocaleString("pt-PT"), ".") : null, mostradas.map((l, i) => linha({
    // **A caixa nasce com o que está LIVRE, não com o stock da palete**
    // — `qtdInicial`, que é `null` (caixa vazia) quando não se sabe
    // quanto sobra. Ver `ondReservaDaPalete`.
    key: `${l.codigo}-${i}`,
    codigo: l.codigo,
    qtd: l.reserva.qtdInicial,
    // **E o STOCK da palete, que é outra coisa.** `qtd` é o DISPONÍVEL
    // (já sem o que outra onda reservou); `stock` é o que a palete tem.
    // É o segundo que responde a «saiu inteira?» — com o primeiro, uma
    // palete de 100 com 60 reservados dava «inteira» ao picar 40, e o
    // hub dizia ao PHC que ela mudou de sítio com 60 lá dentro.
    stock: l.stock,
    local: l.local,
    data: l.data,
    chegaAqui: l.chegaAqui,
    picado: picados.has(l.codigo),
    lote: picados.get(l.codigo),
    reserva: l.reserva
  })), escondidas > 0 ? /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => setTodas(true)
    },
    "Ver as outras ",
    escondidas
  ) : null, orfas.map((l) => linha({
    // Uma órfã é uma palete JÁ picada que a procura já não devolve (o
    // stock foi a zero): o stock dela é o que o lote guardou, se guardou.
    key: `orfa-${l.codigo}`,
    codigo: l.codigo,
    qtd: l.qtd,
    stock: l.stockPalete,
    local: l.local,
    data: l.em,
    picado: true,
    lote: l,
    reserva: semReserva
  })), p.chega ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__lido-ok" }, "J\xE1 chega para esta tarefa", p.excesso ? ` (${n(p.excesso)} a mais)` : "", ".") : p.paletes && !p.semQtd ? /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "Faltam ", n(p.falta), ".") : null);
}
function OndOpFocoNaEtiqueta({ tarefaId, alvo }) {
  React.useEffect(() => {
    const el = alvo && alvo.current;
    if (el) el.focus();
  }, [tarefaId, alvo]);
  return null;
}
function OndOperador({
  dados,
  ondas,
  pessoaId,
  semFicha,
  tarefaSel,
  onPessoa,
  onEscolherTarefa,
  onIniciar,
  onPausar,
  onRetomar,
  onConcluir,
  onReabrir,
  onProblema,
  onPicarLote,
  onTirarLote,
  onAlocarLotes,
  onQtdDoLote
}) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const [modalPausa, setModalPausa] = React.useState(false);
  const [modalProblema, setModalProblema] = React.useState(false);
  const [leitura, setLeitura] = React.useState("");
  const [local, setLocal] = React.useState("");
  const [lido, setLido] = React.useState(null);
  const [ultimoLote, setUltimoLote] = React.useState(null);
  const [parametros, setParametros] = React.useState(null);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.parametrosPreparacao().then((p) => {
      if (vivo) setParametros(p);
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, []);
  const aposGravar = (promessa, fallback) => {
    Promise.resolve(promessa).then((res) => {
      const linha = L.linhaAposRecusa(res, fallback);
      if (linha) setLido(linha);
    });
  };
  const refLote = React.useRef(null);
  const refLocal = React.useRef(null);
  const focar = (ref) => {
    const el = ref && ref.current;
    if (el) {
      el.focus();
      el.select?.();
    }
  };
  const [aba, setAba] = React.useState("trabalho");
  const [verTodas, setVerTodas] = React.useState(false);
  const picosEmCursoRef = React.useRef(0);
  const picosTerminadosRef = React.useRef(0);
  const [, setTic] = React.useState(0);
  React.useEffect(() => {
    if (!picosTerminadosRef.current) return;
    picosEmCursoRef.current = Math.max(
      0,
      picosEmCursoRef.current - picosTerminadosRef.current
    );
    picosTerminadosRef.current = 0;
  });
  const caixasRef = React.useRef(/* @__PURE__ */ new Map());
  const stocksRef = React.useRef(/* @__PURE__ */ new Map());
  const guardarCaixas = React.useCallback((m, stocks) => {
    caixasRef.current = m || /* @__PURE__ */ new Map();
    stocksRef.current = stocks || /* @__PURE__ */ new Map();
  }, []);
  const pessoa = (dados.pessoas || []).find((p) => p.id === pessoaId) || null;
  const destinoPlaneado = (() => {
    if (!pessoa) return null;
    const t = L.trabalhoDoOperador(pessoa.id, ondas, dados, tarefaSel).atual;
    return t && t.tarefa && t.tarefa.destino || null;
  })();
  if (aba === "etiqueta") {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-op" }, /* @__PURE__ */ React.createElement(OndOpAbas, { aba, onAba: setAba }), /* @__PURE__ */ React.createElement(window.OndOpEtiqueta, null));
  }
  if (aba === "alocar") {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-op" }, /* @__PURE__ */ React.createElement(OndOpAbas, { aba, onAba: setAba }), /* @__PURE__ */ React.createElement(window.OndOpAlocar, { destinoPlaneado }));
  }
  if (aba === "procurar") {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-op" }, /* @__PURE__ */ React.createElement(OndOpAbas, { aba, onAba: setAba }), /* @__PURE__ */ React.createElement(window.OndOpProcurar, null));
  }
  if (!pessoa) {
    return /* @__PURE__ */ React.createElement("div", { className: "ond-op" }, /* @__PURE__ */ React.createElement(OndOpAbas, { aba, onAba: setAba }), /* @__PURE__ */ React.createElement("header", { className: "ond-op__topo" }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__ola" }, "Interface do operador")), semFicha && /* @__PURE__ */ React.createElement("div", { className: "alert warn" }, "N\xE3o tens ficha de operador nesta app \u2014 n\xE3o h\xE1 trabalho teu para mostrar. Escolhe um colega abaixo para ver o dele."), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "ond-select",
        value: "",
        onChange: (e) => e.target.value && onPessoa(e.target.value),
        "aria-label": "Quem est\xE1 a trabalhar"
      },
      /* @__PURE__ */ React.createElement("option", { value: "", disabled: true }, "Escolhe uma pessoa\u2026"),
      (dados.pessoas || []).map((p) => /* @__PURE__ */ React.createElement("option", { key: p.id, value: p.id }, p.nome, " \u2014 ", p.funcao))
    ));
  }
  const { atual, seguintes, pausadas, feitas, porFazer, emCursoOutra, chamada } = L.trabalhoDoOperador(pessoa.id, ondas, dados, tarefaSel);
  const tipos = L.indexar(dados.tipos);
  const prios = L.indexar(dados.prioridades);
  const kitDe = (t) => L.kitDaTarefa(t, dados.tarefas);
  const kitAtual = atual ? kitDe(atual.tarefa) : null;
  const deCarga = !!(atual && atual.onda && (atual.onda.cargaServidorId != null || atual.onda.cargaId));
  const porAlocar = atual ? L.picadoDaTarefa(atual.tarefa).porAlocar : 0;
  const tecto = L.tectoDePaletes(porFazer, parametros);
  const avisoTecto = L.textoDoTecto(tecto);
  const emCurso = atual && atual.tarefa.estado === "em_execucao";
  const pausada = atual && atual.tarefa.estado === "pausada";
  const dep = atual ? L.podeIniciar(atual.onda, ondas) : { ok: true, bloqueios: [] };
  const qtdDaEtiqueta = (texto) => {
    const limpo = String(texto == null ? "" : texto).replace(/\s/g, "").replace(",", ".");
    const n = Number(limpo);
    return Number.isFinite(n) && limpo !== "" ? n : null;
  };
  const arrancaAoPicar = () => {
    if (!atual || !dep.ok || emCursoOutra) return null;
    if (atual.tarefa.estado === "pendente") return "iniciar";
    if (atual.tarefa.estado === "pausada") return "retomar";
    return null;
  };
  const picarLote = async (v, ecra, stockPalete) => {
    const tectoJa = L.tectoComEmCurso(tecto, picosEmCursoRef.current);
    if (!tectoJa.podePicar) {
      setLido({ ok: false, msg: L.textoDoTecto(tectoJa) });
      return false;
    }
    picosEmCursoRef.current += 1;
    try {
      const r = await window.CargoplannerAPI.etiqueta(v);
      if (!r.encontrado) {
        setLido({ ok: false, msg: `"${v}" n\xE3o corresponde a esta tarefa nem \xE9 uma etiqueta conhecida.` });
        return false;
      }
      const ref = String(r.campos.referencia || "").toUpperCase();
      if (ref !== String(atual.tarefa.artigo).toUpperCase()) {
        setLido({
          ok: false,
          msg: `${r.lote} \xE9 da refer\xEAncia ${r.campos.referencia} \u2014 esta tarefa \xE9 de ${atual.tarefa.artigo}.`
        });
        return false;
      }
      if ((atual.tarefa.lotes || []).some((l) => l.codigo === r.lote)) {
        setLido({ ok: false, msg: `O lote ${r.lote} j\xE1 estava picado.` });
        return false;
      }
      const caixa = ecra || caixasRef.current.get(r.lote) || caixasRef.current.get(v) || null;
      const aGravar = onPicarLote(atual.tarefa.id, {
        codigo: r.lote,
        ref: r.campos.referencia || "",
        qtd: L.qtdAPicar(caixa, qtdDaEtiqueta(r.campos.quantidade)),
        // **Quanto a palete TEM** (não o que se leva, nem o disponível).
        // Sem ele não há como saber se ela saiu inteira, e o picking voltava
        // a alocá-la no PHC depois de se tirarem só umas caixas (#68).
        // `null` quando não se sabe — a lista pode não ter esta palete.
        stockPalete: stockPalete == null ? stocksRef.current.get(r.lote) ?? stocksRef.current.get(v) ?? null : stockPalete,
        // De onde veio — o que o ERP diz AGORA, antes de a alocação mexer.
        local: r.alocacao && r.alocacao.local || "",
        // Para onde vai: ainda não se sabe. É a leitura da localização que
        // o preenche, e é ela que escreve no PHC.
        destino: "",
        // **A etiqueta devolve a empresa como OBJETO** (`{id, nome}`), não
        // como id — é assim que a `EtiquetaView` a serializa, e é o que o
        // resto do tablet já lê (`OndOpAlocar` usa `empresa.id`). Guardar
        // `Number(r.empresa)` dava `NaN`, que passava pela guarda do `!=
        // null` e chegava ao servidor como «Empresa inválida». Apanhado em
        // browser, no primeiro pedido de alocação.
        empresa: r.empresa && r.empresa.id || null,
        em: (/* @__PURE__ */ new Date()).toISOString()
      }, arrancaAoPicar());
      setLido({ ok: true, msg: `Picado ${r.lote}. Leia a localiza\xE7\xE3o de destino.` });
      Promise.resolve(aGravar).then((res) => {
        const linha = L.linhaAposPicar(res);
        if (linha) setLido(linha);
      });
      return true;
    } catch (e) {
      setLido({ ok: false, msg: String(e && e.message || e) });
      return false;
    } finally {
      picosTerminadosRef.current += 1;
      setTic((t) => t + 1);
    }
  };
  const picarDaLista = async (l) => {
    if (!atual || !l || !l.codigo) return;
    if ((atual.tarefa.lotes || []).some((x) => x.codigo === l.codigo)) return;
    const ok = await picarLote(l.codigo, l.ecra, l.stockPalete);
    focar(ok ? refLocal : refLote);
  };
  const lerLocal = async (valor) => {
    const v = (valor || "").trim().toUpperCase();
    setLocal("");
    if (!v || !atual) return;
    const pendentes = L.lotesPorAlocar(atual.tarefa);
    if (!pendentes.length) {
      const soParciais = (atual.tarefa.lotes || []).some(
        (l) => !l.destino && L.paleteSaiInteira(l) === false
      );
      setLido({ ok: false, msg: soParciais ? "N\xE3o h\xE1 nada para alocar: as paletes picadas ficam na prateleira (levaste s\xF3 parte delas). Podes concluir." : `Leia primeiro a etiqueta da palete \u2014 "${v}" \xE9 uma localiza\xE7\xE3o.` });
      focar(refLote);
      return;
    }
    const bases = [...new Set(pendentes.map((l) => l.empresa).filter((x) => x != null))];
    if (bases.length !== 1) {
      setLido({ ok: false, msg: bases.length ? "As paletes por alocar s\xE3o de bases do PHC diferentes. Aloca-as uma a uma." : "N\xE3o se sabe de que base do PHC vieram estas paletes. Pica-as outra vez." });
      return;
    }
    const esperado = String(atual.tarefa.destino || "").trim().toUpperCase();
    setLido({ ok: true, msg: `A alocar ${pendentes.length} palete(s) em ${v}\u2026` });
    try {
      const r = await window.CargoplannerAPI.alocar({
        codigos: pendentes.map((l) => l.codigo),
        local: v,
        empresa: bases[0],
        // **A tarefa diz ao servidor para NÃO registar uma onda de
        // «Alocação»**: este trabalho já está contado na onda de preparação,
        // e uma segunda onda por palete duplicava o tempo do operador e
        // enchia o quadro. Ver `AlocarView`.
        tarefa: atual.tarefa.servidorId
      });
      const destino = r && r.local || v;
      const aMarcar = onAlocarLotes(
        atual.tarefa.id,
        pendentes.map((l) => l.codigo),
        destino
      );
      setLido({
        ok: true,
        msg: esperado && esperado !== destino.toUpperCase() ? `${pendentes.length} palete(s) em ${destino} \u2014 a carga \xE9 para ${atual.tarefa.destino}. Fica registado.` : `${pendentes.length} palete(s) alocada(s) em ${destino}.`
      });
      aposGravar(aMarcar, "O hub n\xE3o registou esta aloca\xE7\xE3o.");
    } catch (e) {
      setLido({ ok: false, msg: window.CargoplannerAPI.erroMensagem(
        e,
        `N\xE3o foi poss\xEDvel alocar em ${v}.`
      ) });
    }
    focar(refLote);
  };
  const lerCodigo = async (valor) => {
    const v = (valor || "").trim().toUpperCase();
    setLeitura("");
    if (!v || !atual) return;
    if (v === String(atual.tarefa.artigo).toUpperCase()) {
      setLido({ ok: true, msg: `\xC9 esta a refer\xEAncia: ${atual.tarefa.artigo}.` });
      return;
    }
    if (!deCarga) {
      setLido({ ok: false, msg: `"${v}" n\xE3o corresponde a esta tarefa.` });
      return;
    }
    setLido({ ok: true, msg: "A ler a etiqueta\u2026" });
    const ok = await picarLote(v);
    focar(ok ? refLocal : refLote);
  };
  const limparLeitura = () => {
    setLido(null);
    setUltimoLote(null);
    setLeitura("");
    setLocal("");
  };
  const chamar = (id) => {
    onEscolherTarefa(id);
    limparLeitura();
    setVerTodas(false);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "ond-op" }, /* @__PURE__ */ React.createElement(OndOpAbas, { aba, onAba: setAba }), /* @__PURE__ */ React.createElement("header", { className: "ond-op__topo" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "ond-op__ola" }, "A mostrar o trabalho de"), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "ond-select ond-op__quem",
      value: pessoa.id,
      onChange: (e) => {
        onPessoa(e.target.value);
        chamar(null);
      },
      "aria-label": "Quem est\xE1 a trabalhar"
    },
    (dados.pessoas || []).map((p) => /* @__PURE__ */ React.createElement("option", { key: p.id, value: p.id }, p.nome, " \u2014 ", p.funcao))
  )), /* @__PURE__ */ React.createElement("div", { className: "ond-op__contagem" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, porFazer.length), " por fazer"), pausadas.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "ond-op__contagem-pausa" }, /* @__PURE__ */ React.createElement("b", null, pausadas.length), " em pausa"), /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, /* @__PURE__ */ React.createElement("b", null, feitas.length), " conclu\xEDdas hoje"))), !atual && !feitas.length && /* @__PURE__ */ React.createElement("div", { className: "ond-op__vazio" }, "Sem trabalho atribu\xEDdo. Fala com o planeador."), !atual && feitas.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "ond-op__vazio" }, "Est\xE1 tudo feito. O que ficou para tr\xE1s est\xE1 aqui em baixo \u2014 e reabre-se, se for preciso."), chamada && atual && /* @__PURE__ */ React.createElement("div", { className: "ond-op__chamada" }, /* @__PURE__ */ React.createElement("span", null, "Tarefa chamada fora da ordem do plano."), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => chamar(null) }, "Voltar \xE0 ordem")), pausadas.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "ond-op__pausadas" }, /* @__PURE__ */ React.createElement("h3", null, "Em pausa (", pausadas.length, ")"), pausadas.map((x) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: x.tarefa.id,
      className: "ond-op__pausada",
      style: { "--ond-cor": (tipos[x.onda.tipoId] || {}).cor }
    },
    /* @__PURE__ */ React.createElement("span", { className: "ond-op__prox-tipo" }, x.tarefa.tipo),
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, x.tarefa.artigo),
    /* @__PURE__ */ React.createElement(OndOpKitChip, { kit: kitDe(x.tarefa) }),
    x.tarefa.foraDaCarga && /* @__PURE__ */ React.createElement("span", { className: "ond-op__fora-chip" }, "fora da carga"),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, x.onda.codigo),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, CL.duracao(L.acumuladoDeTarefa(x.tarefa)), " feitos", " \xB7 ", CL.duracao(x.tarefa.tempoPrevMin), " previstos"),
    /* @__PURE__ */ React.createElement("button", { className: "btn sm", onClick: () => chamar(x.tarefa.id) }, "Voltar a esta")
  ))), atual && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("section", { className: "ond-op__atual", style: { "--ond-cor": (tipos[atual.onda.tipoId] || {}).cor } }, /* @__PURE__ */ React.createElement("div", { className: "ond-op__atual-h" }, /* @__PURE__ */ React.createElement("span", { className: "ond-op__agora" }, emCurso ? "A DECORRER" : pausada ? "PAUSADA" : "A SEGUIR"), /* @__PURE__ */ React.createElement("span", { className: "ond-op__onda" }, atual.onda.codigo, " \xB7 ", (tipos[atual.onda.tipoId] || {}).label), /* @__PURE__ */ React.createElement("span", { className: "ond-prio", style: { "--ond-cor": (prios[atual.onda.prioridadeId] || {}).cor } }, (prios[atual.onda.prioridadeId] || {}).label)), /* @__PURE__ */ React.createElement("h2", { className: "ond-op__tarefa" }, atual.tarefa.tipo), atual.tarefa.foraDaCarga && /* @__PURE__ */ React.createElement("div", { className: "ond-op__fora" }, "Esta linha ", /* @__PURE__ */ React.createElement("b", null, "j\xE1 n\xE3o est\xE1 na carga"), ". O que j\xE1 picaste fica registado; n\xE3o v\xE1s buscar mais."), kitAtual && /* @__PURE__ */ React.createElement("div", { className: "ond-op__kit" }, /* @__PURE__ */ React.createElement("b", null, "Kit ", kitAtual.ref), " \xB7 ", "componente ", kitAtual.indice, " de ", kitAtual.total, kitAtual.razao != null && ` \xB7 \xD7${kitAtual.razao} por kit`, /* @__PURE__ */ React.createElement("span", { className: "ond-op__kit-nota" }, "O kit s\xF3 sai com os componentes todos, na propor\xE7\xE3o certa.")), /* @__PURE__ */ React.createElement("div", { className: "ond-op__campos" }, /* @__PURE__ */ React.createElement(OndOpCampo, { label: "Artigo", valor: atual.tarefa.artigo, forte: true }), /* @__PURE__ */ React.createElement(OndOpCampo, { label: "Descri\xE7\xE3o", valor: atual.tarefa.descricao }), /* @__PURE__ */ React.createElement(
    OndOpCampo,
    {
      label: "Quantidade",
      valor: `${(atual.tarefa.qtd || 0).toLocaleString("pt-PT")} ` + ondOpUnidade(atual.tarefa),
      forte: true
    }
  ), /* @__PURE__ */ React.createElement(OndOpCampo, { label: "Origem", valor: atual.tarefa.origem, forte: true }), /* @__PURE__ */ React.createElement(OndOpCampo, { label: "Destino", valor: atual.tarefa.destino, forte: true }), /* @__PURE__ */ React.createElement(
    OndOpCampo,
    {
      label: "Cliente / Carga",
      valor: L.rotuloDaOnda(atual.onda) || "\u2014"
    }
  ), /* @__PURE__ */ React.createElement(OndOpCampo, { label: "Tempo previsto", valor: CL.duracao(atual.tarefa.tempoPrevMin) })), /* @__PURE__ */ React.createElement(OndOpOfDaTarefa, { tarefaId: atual.tarefa.servidorId }), tecto.tecto != null ? /* @__PURE__ */ React.createElement("div", { className: "ond-op__tecto" + (tecto.podePicar ? "" : " is-cheio") }, avisoTecto || `${tecto.porAlocar} de ${tecto.tecto} paletes por alocar \u2014 contando todas as tuas tarefas`) : null, /* @__PURE__ */ React.createElement(
    OndOpPaletesDoArtigo,
    {
      artigo: atual.tarefa.artigo,
      qtdPedida: Number(atual.tarefa.qtd) || 0,
      tarefa: atual.tarefa,
      onPicar: deCarga ? picarDaLista : () => {
      },
      onQtds: guardarCaixas,
      tecto,
      avisoTecto,
      onTirar: (codigo) => aposGravar(
        onTirarLote(atual.tarefa.id, codigo),
        "O servidor recusou tirar esta palete."
      ),
      onQtdDoLote: onQtdDoLote ? (codigo, qtd) => aposGravar(
        onQtdDoLote(atual.tarefa.id, codigo, qtd),
        "O servidor recusou esta quantidade."
      ) : null
    }
  ), !dep.ok && /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, "N\xE3o podes come\xE7ar: falta concluir ", dep.bloqueios.map((b) => b.codigo).join(", "), "."), emCursoOutra && /* @__PURE__ */ React.createElement("div", { className: "ond-op__bloqueio" }, "Tens a ", /* @__PURE__ */ React.createElement("b", null, emCursoOutra.tarefa.tipo, " ", emCursoOutra.tarefa.artigo), " ", "a decorrer (", emCursoOutra.onda.codigo, "). Pausa-a antes de come\xE7ar esta.", /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      style: { marginLeft: 8 },
      onClick: () => chamar(emCursoOutra.tarefa.id)
    },
    "Ir para ela"
  )), /* @__PURE__ */ React.createElement(OndOpFocoNaEtiqueta, { tarefaId: atual.tarefa.id, alvo: refLote }), /* @__PURE__ */ React.createElement("div", { className: "ond-op__leitura" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "ond-select",
      ref: refLote,
      placeholder: "Ler etiqueta da palete\u2026",
      value: leitura,
      onChange: (e) => {
        if (window.OndOpComando(e.target.value, {
          definir: setLeitura,
          aoEnter: (v) => lerCodigo(v)
        })) return;
        setLeitura(e.target.value);
      },
      onKeyDown: (e) => {
        if (e.key === "Enter") lerCodigo(leitura);
      },
      "aria-label": "Ler etiqueta da palete"
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "ond-select ond-op__leitura-local",
      ref: refLocal,
      placeholder: atual.tarefa.destino ? `Localiza\xE7\xE3o de destino (${atual.tarefa.destino})\u2026` : "Ler localiza\xE7\xE3o de destino\u2026",
      value: local,
      onChange: (e) => {
        if (window.OndOpComando(e.target.value, {
          definir: setLocal,
          aoEnter: (v) => lerLocal(v)
        })) return;
        setLocal(e.target.value);
      },
      onKeyDown: (e) => {
        if (e.key === "Enter") lerLocal(local);
      },
      "aria-label": "Ler localiza\xE7\xE3o"
    }
  ), lido && /* @__PURE__ */ React.createElement("span", { className: lido.ok ? "ond-op__lido-ok" : "ond-op__lido-mal" }, lido.msg)), /* @__PURE__ */ React.createElement("div", { className: "ond-op__acoes" }, !emCurso && !pausada && /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "ok",
      disabled: !dep.ok || !!emCursoOutra,
      title: emCursoOutra ? `Pausa primeiro a ${emCursoOutra.tarefa.tipo} que tens a decorrer` : dep.ok ? "Come\xE7ar esta tarefa" : "Bloqueada por depend\xEAncia",
      onClick: () => {
        onIniciar(atual.tarefa.id);
        limparLeitura();
      }
    },
    "Iniciar"
  ), emCurso && /* @__PURE__ */ React.createElement(OndOpBotao, { tom: "warn", onClick: () => setModalPausa(true) }, "Pausar"), pausada && /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "ok",
      disabled: !!emCursoOutra,
      title: emCursoOutra ? `Pausa primeiro a ${emCursoOutra.tarefa.tipo} que tens a decorrer` : "Retomar de onde ficaste",
      onClick: () => onRetomar(atual.tarefa.id)
    },
    "Retomar"
  ), /* @__PURE__ */ React.createElement(
    OndOpBotao,
    {
      tom: "done",
      disabled: !emCurso || porAlocar > 0,
      title: !emCurso ? "Inicia a tarefa primeiro \u2014 ou pica a primeira palete" : porAlocar > 0 ? `${porAlocar} palete(s) picada(s) por alocar \u2014 l\xEA a localiza\xE7\xE3o de destino` : "Concluir",
      onClick: () => {
        onConcluir(atual.tarefa.id);
        chamar(null);
      }
    },
    "Concluir"
  ), /* @__PURE__ */ React.createElement(OndOpBotao, { tom: "bad", onClick: () => setModalProblema(true) }, "Reportar problema"))), /* @__PURE__ */ React.createElement("section", { className: "ond-op__lista" }, /* @__PURE__ */ React.createElement("h3", null, "A seguir (", seguintes.length, ")"), (verTodas ? seguintes : seguintes.slice(0, 8)).map((x) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: x.tarefa.id,
      className: "ond-op__prox",
      style: { "--ond-cor": (tipos[x.onda.tipoId] || {}).cor }
    },
    /* @__PURE__ */ React.createElement("span", { className: "ond-op__prox-tipo" }, x.tarefa.tipo),
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, x.tarefa.artigo),
    /* @__PURE__ */ React.createElement(OndOpKitChip, { kit: kitDe(x.tarefa) }),
    x.tarefa.foraDaCarga && /* @__PURE__ */ React.createElement("span", { className: "ond-op__fora-chip" }, "fora da carga"),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, x.tarefa.descricao),
    /* @__PURE__ */ React.createElement("span", { className: "ond-op__prox-qtd" }, (x.tarefa.qtd || 0).toLocaleString("pt-PT"), " ", ondOpUnidade(x.tarefa)),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, x.tarefa.origem, " \u2192 ", x.tarefa.destino),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, CL.duracao(x.tarefa.tempoPrevMin)),
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn sm ond-op__chamar",
        onClick: () => chamar(x.tarefa.id)
      },
      "Chamar"
    )
  )), seguintes.length > 8 && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm ond-op__ver-todas",
      onClick: () => setVerTodas((v) => !v)
    },
    verTodas ? "Mostrar s\xF3 as 8 seguintes" : `Ver as ${seguintes.length} todas`
  ), !seguintes.length && /* @__PURE__ */ React.createElement("div", { className: "ond-dim" }, "N\xE3o h\xE1 mais nada depois desta."))), feitas.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "ond-op__lista ond-op__feitas" }, /* @__PURE__ */ React.createElement("h3", null, "Feitas hoje (", feitas.length, ")"), feitas.map((x) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: x.tarefa.id,
      className: "ond-op__prox is-feita",
      style: { "--ond-cor": (tipos[x.onda.tipoId] || {}).cor }
    },
    /* @__PURE__ */ React.createElement("span", { className: "ond-op__prox-tipo" }, x.tarefa.tipo),
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, x.tarefa.artigo),
    /* @__PURE__ */ React.createElement(OndOpKitChip, { kit: kitDe(x.tarefa) }),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, x.tarefa.descricao),
    /* @__PURE__ */ React.createElement("span", { className: "ond-op__prox-qtd" }, (x.tarefa.qtd || 0).toLocaleString("pt-PT"), " ", ondOpUnidade(x.tarefa)),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, x.onda.codigo),
    /* @__PURE__ */ React.createElement("span", { className: "ond-dim" }, x.tarefa.tempoRealMin == null ? "s/ medi\xE7\xE3o" : CL.duracao(x.tarefa.tempoRealMin)),
    (() => {
      const phc = L.phcDosLotes(x.tarefa);
      if (!phc.porLancar) return null;
      return /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "ond-op__lida-aviso",
          title: "Estas paletes foram picadas e ainda n\xE3o est\xE3o no picking do PHC."
        },
        phc.porLancar,
        " por lan\xE7ar no PHC"
      );
    })(),
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm ond-op__reabrir",
        title: "Voltar a p\xF4r esta tarefa por fazer",
        onClick: () => onReabrir(x.tarefa.id)
      },
      "Reabrir"
    ),
    /* @__PURE__ */ React.createElement("span", { className: "ond-op__feita-marca" }, "\u2713")
  ))), modalPausa && /* @__PURE__ */ React.createElement(
    OndOpPausaModal,
    {
      dados,
      onFechar: () => setModalPausa(false),
      onPausar: (m) => {
        onPausar(atual.tarefa.id, m);
        setModalPausa(false);
        chamar(null);
      }
    }
  ), modalProblema && /* @__PURE__ */ React.createElement(
    OndOpProblemaModal,
    {
      dados,
      onFechar: () => setModalProblema(false),
      onReportar: (m, nota) => {
        onProblema(atual.tarefa.id, m, nota);
        setModalProblema(false);
        chamar(null);
      }
    }
  ));
}
window.OndOperador = OndOperador;

// ===== cargoplanner/frontend/ondas_desempenho.jsx =====
const OND_DESEMPENHO_DIAS = 7;
function OndDesempenho({ dados, dia, evento, ligacoes }) {
  const L = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const D = window.CargoplannerDados;
  const API = window.CargoplannerAPI;
  const [de, setDe] = React.useState(() => D.diaMais(dia, -OND_DESEMPENHO_DIAS));
  const [ate, setAte] = React.useState(dia);
  const [ondas, setOndas] = React.useState([]);
  const ondasRef = React.useRef([]);
  const [tarefas, setTarefas] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  React.useEffect(() => {
    ondasRef.current = ondas;
  }, [ondas]);
  const [erro, setErro] = React.useState(null);
  React.useEffect(() => {
    let morto = false;
    setACarregar(true);
    API.ondasNoPeriodo(de, ate).then((lista) => {
      if (morto) return;
      setOndas((lista || []).map(L.ondaDoServidor));
      setTarefas(L.tarefasDoServidor(lista));
      setErro(null);
      setACarregar(false);
    }).catch((e) => {
      if (morto) return;
      setOndas([]);
      setTarefas([]);
      setErro(API.erroMensagem(e, "N\xE3o foi poss\xEDvel ler o desempenho deste per\xEDodo."));
      setACarregar(false);
    });
    return () => {
      morto = true;
    };
  }, [de, ate, API, L]);
  React.useEffect(() => {
    if (!evento || !evento.n) return;
    const r2 = evento.tipo === "deleted" ? L.removerOndaDoPeriodo(ondasRef.current, { id: evento.id }) : L.fundirOndaNoPeriodo(ondasRef.current, evento.onda, { de, ate });
    if (r2.acao === "remover") {
      setOndas((prev) => prev.filter((o) => o.id !== r2.ondaId));
      setTarefas((prev) => prev.filter((t2) => t2.ondaId !== r2.ondaId));
      return;
    }
    if (r2.acao !== "aplicar") return;
    setOndas((prev) => prev.some((o) => o.id === r2.onda.id) ? prev.map((o) => o.id === r2.onda.id ? r2.onda : o) : [...prev, r2.onda]);
    setTarefas((prev) => [...prev.filter((t2) => t2.ondaId !== r2.onda.id), ...r2.tarefas]);
  }, [evento, de, ate, L]);
  const dadosDoPeriodo = React.useMemo(() => ({ ...dados, tarefas }), [dados, tarefas]);
  const r = React.useMemo(
    () => L.desempenhoPorPessoa(ondas, dadosDoPeriodo),
    [ondas, dadosDoPeriodo, L]
  );
  const dur = (min) => CL.duracao(Math.round(min || 0));
  const sinal = (v) => v > 0 ? "+" : v < 0 ? "\u2212" : "";
  const desvio = (min) => min == null ? null : `${sinal(min)}${dur(Math.abs(min))}`;
  const pct = (v) => v == null ? null : `${sinal(v)}${Math.abs(v)}%`;
  const linhas = React.useMemo(() => r.pessoas.map((p) => ({
    id: p.pessoaId || p.nome,
    ...p
  })), [r]);
  const colunas = React.useMemo(() => [
    {
      key: "nome",
      label: "Pessoa",
      width: 180,
      minWidth: 130,
      render: (p) => p.nome || /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "sem nome")
    },
    {
      key: "ondasConcluidas",
      label: "Ondas",
      width: 92,
      minWidth: 74,
      align: "right",
      render: (p) => /* @__PURE__ */ React.createElement("span", { title: `${p.ondasConcluidas} conclu\xEDdas de ${p.ondas} atribu\xEDdas` }, p.ondasConcluidas, /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "/", p.ondas))
    },
    {
      key: "tarefasConcluidas",
      label: "Tarefas",
      width: 96,
      minWidth: 78,
      align: "right",
      render: (p) => /* @__PURE__ */ React.createElement("span", { title: `${p.tarefasConcluidas} conclu\xEDdas de ${p.tarefas}` }, p.tarefasConcluidas, /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "/", p.tarefas))
    },
    // **O que ficou por acabar** (#113) — o requisito do João: «tem de ser
    // possível contabilizar as ondas não feitas e por quem não foram feitas».
    //
    // **Com o denominador ao lado**, como todas as outras colunas desta
    // vista: «1/4» é uma onda deixada de quatro que passaram pelas mãos dela,
    // e sem o 4 o 1 não quer dizer nada.
    //
    // Zero escreve-se, não se esconde: aqui o zero é um facto medido («não
    // deixou nada por acabar»), e é a leitura mais útil da coluna.
    {
      key: "naoTerminadas",
      label: "N\xE3o terminadas",
      width: 118,
      minWidth: 92,
      align: "right",
      render: (p) => /* @__PURE__ */ React.createElement("span", { title: p.naoTerminadas ? `${p.naoTerminadas} onda(s) que passaram para o turno seguinte sem estarem acabadas, de ${p.ondasQueTeve} que teve` + (p.transicoes > p.naoTerminadas ? ` \u2014 e ${p.transicoes} vezes ao todo: alguma caiu-lhe das m\xE3os mais do que uma vez` : "") : `nenhuma das ${p.ondasQueTeve} ondas que teve passou para outro turno` }, p.naoTerminadas, /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "/", p.ondasQueTeve), p.transicoes > p.naoTerminadas && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xD7", p.transicoes))
    },
    // O denominador de tudo o que vem a seguir. Sem esta coluna, as duas
    // seguintes pareciam falar de todo o trabalho feito.
    {
      key: "tarefasMedidas",
      label: "Medidas",
      width: 92,
      minWidth: 78,
      align: "right",
      render: (p) => /* @__PURE__ */ React.createElement("span", { title: p.concluidasSemMedida > 0 ? `${p.concluidasSemMedida} tarefa(s) foram dadas por conclu\xEDdas sem ningu\xE9m ter posto o cron\xF3metro a andar \u2014 n\xE3o entram nas colunas seguintes` : "todas as tarefas conclu\xEDdas foram cronometradas" }, p.tarefasMedidas, p.concluidasSemMedida > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " +", p.concluidasSemMedida, " s/ medida"))
    },
    // **Previsto, Real e Desvio falam todos das MESMAS tarefas** — as que
    // foram medidas E têm tempo previsto. Com o real TOTAL nesta coluna, o
    // desvio ao lado deixava de bater certo com a subtração que qualquer um
    // faz de cabeça (20 e 22 à vista, «−2 min» ao lado). O que fica de fora
    // é dito, não escondido: o `+N s/ previsto` conta os minutos medidos de
    // trabalho que ninguém estimou — hoje, as alocações.
    {
      key: "previstoMin",
      label: "Previsto",
      width: 92,
      minWidth: 78,
      align: "right",
      render: (p) => p.tarefasComparaveis ? dur(p.previstoComparavelMin) : "\u2014"
    },
    {
      key: "realMin",
      label: "Real",
      width: 108,
      minWidth: 90,
      align: "right",
      render: (p) => {
        const semPrevisto = (p.realMin || 0) - (p.realComparavelMin || 0);
        if (!p.tarefasMedidas) return "\u2014";
        return /* @__PURE__ */ React.createElement("span", { title: semPrevisto > 0 ? `Mais ${dur(semPrevisto)} medidos em tarefas sem tempo previsto (aloca\xE7\xF5es, por exemplo) \u2014 n\xE3o h\xE1 estimativa com que os comparar` : "" }, p.tarefasComparaveis ? dur(p.realComparavelMin) : "\u2014", semPrevisto > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " +", dur(semPrevisto), " s/ previsto"));
      }
    },
    {
      key: "desvioMin",
      label: "Desvio",
      width: 110,
      minWidth: 90,
      align: "right",
      render: (p) => p.desvioMin == null ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Sem tarefas cronometradas neste per\xEDodo \u2014 n\xE3o h\xE1 o que comparar" }, "\u2014") : /* @__PURE__ */ React.createElement("span", { className: p.desvioMin > 0 ? "cp-erro-txt" : "" }, desvio(p.desvioMin), p.desvioPct != null && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " (", pct(p.desvioPct), ")"))
    },
    {
      key: "pctDentroDoTempo",
      label: "Dentro do tempo",
      width: 128,
      minWidth: 104,
      align: "right",
      render: (p) => p.pctDentroDoTempo == null ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Sem tarefas cronometradas neste per\xEDodo" }, "\u2014") : /* @__PURE__ */ React.createElement("span", { title: `${p.dentroDoTempo} de ${p.tarefasComparaveis} tarefas medidas com tempo previsto` }, p.pctDentroDoTempo, "%")
    },
    {
      key: "pausas",
      label: "Pausas",
      width: 84,
      minWidth: 70,
      align: "right",
      render: (p) => p.pausas || 0
    }
  ], []);
  const t = r.total;
  return /* @__PURE__ */ React.createElement("div", { className: "ond-desemp" }, /* @__PURE__ */ React.createElement("header", { className: "ond-topo" }, /* @__PURE__ */ React.createElement("h2", { className: "ond-topo__titulo" }, "Desempenho"), L.periodoAlcancavel(dia, de, ate) && /* @__PURE__ */ React.createElement(window.CpSinalAoVivo, { ligacoes: ligacoes || [] }), /* @__PURE__ */ React.createElement("span", { className: "ond-topo__estado" }, aCarregar ? "A ler o per\xEDodo\u2026" : `${r.pessoas.length} pessoa(s) com trabalho`), /* @__PURE__ */ React.createElement("div", { className: "ond-topo__nav" }, /* @__PURE__ */ React.createElement("label", { className: "ond-desemp__campo" }, /* @__PURE__ */ React.createElement("span", null, "De"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "ond-select",
      type: "date",
      value: de,
      "aria-label": "In\xEDcio do per\xEDodo",
      onChange: (e) => e.target.value && setDe(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "ond-desemp__campo" }, /* @__PURE__ */ React.createElement("span", null, "at\xE9"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "ond-select",
      type: "date",
      value: ate,
      "aria-label": "Fim do per\xEDodo",
      onChange: (e) => e.target.value && setAte(e.target.value)
    }
  )))), erro && /* @__PURE__ */ React.createElement("div", { className: "ond-avisos", role: "alert" }, /* @__PURE__ */ React.createElement("ul", null, /* @__PURE__ */ React.createElement("li", { className: "is-erro" }, erro))), /* @__PURE__ */ React.createElement("div", { className: "ond-desemp__resumo" }, /* @__PURE__ */ React.createElement("div", { className: "ond-desemp__kpi" }, /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-v" }, t.ondasConcluidas, /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "/", t.ondas)), /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-l" }, "Ondas conclu\xEDdas")), /* @__PURE__ */ React.createElement("div", { className: "ond-desemp__kpi" }, /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-v" }, t.tarefasConcluidas, /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "/", t.tarefas)), /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-l" }, "Tarefas conclu\xEDdas")), /* @__PURE__ */ React.createElement("div", { className: "ond-desemp__kpi" }, /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-v" }, t.tarefasMedidas ? desvio(t.desvioMin) : "\u2014"), /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-l" }, "Desvio do previsto", t.tarefasMedidas > 0 && /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", t.tarefasMedidas, " tarefa(s) medidas"))), /* @__PURE__ */ React.createElement("div", { className: "ond-desemp__kpi" }, /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-v" }, t.pctDentroDoTempo == null ? "\u2014" : `${t.pctDentroDoTempo}%`), /* @__PURE__ */ React.createElement("span", { className: "ond-desemp__kpi-l" }, "Dentro do tempo previsto"))), t.concluidasSemMedida > 0 && /* @__PURE__ */ React.createElement("p", { className: "ond-desemp__ressalva" }, /* @__PURE__ */ React.createElement("b", null, t.concluidasSemMedida), " tarefa(s) foram dadas por conclu\xEDdas sem ningu\xE9m ter posto o cron\xF3metro a andar. N\xE3o entram no desvio nem na percentagem \u2014 um tempo inventado seria pior do que tempo nenhum."), r.semPessoa && r.semPessoa.ondas > 0 && /* @__PURE__ */ React.createElement("p", { className: "ond-desemp__ressalva" }, /* @__PURE__ */ React.createElement("b", null, r.semPessoa.ondas), " onda(s) do per\xEDodo nunca chegaram a ser atribu\xEDdas a ningu\xE9m. Ficam de fora desta tabela \u2014 s\xE3o trabalho planeado que n\xE3o foi feito, n\xE3o desempenho de algu\xE9m."), /* @__PURE__ */ React.createElement("div", { className: "ond-desemp__lista" }, React.createElement(window.HubList.List, {
    appLabel: "cargoplanner",
    viewId: "ondas_desempenho",
    columns: colunas,
    data: linhas,
    rowKey: (p) => p.id,
    pagination: "client",
    initialPageSize: 25,
    initialSort: [{ key: "nome", dir: "asc" }],
    search: { placeholder: "Pesquisar pessoa\u2026", fields: ["nome"] },
    empty: erro ? erro : aCarregar ? "A ler o per\xEDodo\u2026" : "Ningu\xE9m com trabalho atribu\xEDdo neste per\xEDodo."
  })), /* @__PURE__ */ React.createElement("p", { className: "ond-desemp__nota" }, "O tempo real \xE9 o cron\xF3metro do tablet, ", /* @__PURE__ */ React.createElement("b", null, "sem as pausas"), " \u2014 elas contam \xE0 parte. O previsto \xE9 o da tarefa no momento em que foi criada; os minutos por palete mudam-se em ", /* @__PURE__ */ React.createElement("b", null, "Defini\xE7\xF5es \u2192 Turnos e armaz\xE9ns"), ", e \xE9 a olhar para o desvio acima que se decide se o n\xFAmero continua certo."));
}
window.OndDesempenho = OndDesempenho;

// ===== cargoplanner/frontend/ondas.jsx =====
function OndasView({
  dados,
  ondas,
  dia,
  pessoaSel,
  vistaTl,
  verTodos,
  avisos,
  ondasFora,
  erroFora,
  ambito,
  onAmbito,
  onDia,
  onSelecionarPessoa,
  onAtribuir,
  onRetirar,
  onReordenar,
  onCriar,
  onVistaTl,
  onVerTodos,
  onFecharAviso,
  onReabrirTarefa,
  onArquivarOnda,
  ligacoes
}) {
  const L = window.OndasLogica;
  const D = window.CargoplannerDados;
  const [filtroPessoa, setFiltroPessoa] = React.useState("");
  const [turnoFiltro, setTurnoFiltro] = React.useState(null);
  const [armazemFiltro, setArmazemFiltro] = React.useState(null);
  const [detalheId, setDetalheId] = React.useState(null);
  const [agoraMs, setAgoraMs] = React.useState(() => Date.now());
  React.useEffect(() => {
    const t2 = setInterval(() => setAgoraMs(Date.now()), 6e4);
    return () => clearInterval(t2);
  }, []);
  const conflitos = React.useMemo(() => L.conflitos(ondas, dados), [ondas, dados, L]);
  const metricas = React.useMemo(() => L.metricas(ondas, dados), [ondas, dados, L]);
  const pessoa = (dados.pessoas || []).find((p) => p.id === pessoaSel) || null;
  return /* @__PURE__ */ React.createElement("div", { className: "ond-board" }, /* @__PURE__ */ React.createElement("header", { className: "ond-topo" }, /* @__PURE__ */ React.createElement("h2", { className: "ond-topo__titulo" }, "Ondas"), /* @__PURE__ */ React.createElement(window.CpSinalAoVivo, { ligacoes: ligacoes || [] }), /* @__PURE__ */ React.createElement("span", { className: "ond-topo__estado" }, dados.aCarregarOndas ? "A ler as ondas deste dia\u2026" : `${metricas.ondasPorAtribuir} por atribuir \xB7 ${metricas.ondasTotal} no plano`), /* @__PURE__ */ React.createElement("div", { className: "ond-topo__nav" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      title: "Dia anterior",
      onClick: () => onDia(D.diaMais(dia, -1))
    },
    "\u2039"
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "ond-select",
      type: "date",
      value: dia,
      onChange: (e) => e.target.value && onDia(e.target.value),
      "aria-label": "Dia de planeamento"
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      title: "Dia seguinte",
      onClick: () => onDia(D.diaMais(dia, 1))
    },
    "\u203A"
  )), /* @__PURE__ */ React.createElement("div", { className: "ond-topo__metricas" }, /* @__PURE__ */ React.createElement("span", { title: "Tarefas conclu\xEDdas dentro do tempo previsto" }, "Dentro do tempo: ", /* @__PURE__ */ React.createElement("b", null, metricas.pctDentroDoTempo == null ? "\u2014" : `${metricas.pctDentroDoTempo}%`)), /* @__PURE__ */ React.createElement("span", null, "Tarefas: ", /* @__PURE__ */ React.createElement("b", null, metricas.tarefasConcluidas, "/", metricas.tarefasTotal)), conflitos.length > 0 && /* @__PURE__ */ React.createElement("span", { className: "ond-conflitos-badge", title: conflitos.map((c) => c.msg).join("\n") }, conflitos.length, " conflito(s)"))), /* @__PURE__ */ React.createElement("div", { className: "ond-board__avisos" }, (dados.erroOndas || dados.erroCatalogos) && /* @__PURE__ */ React.createElement("div", { className: "ond-avisos", role: "alert" }, /* @__PURE__ */ React.createElement("ul", null, dados.erroOndas && /* @__PURE__ */ React.createElement("li", { className: "is-erro" }, dados.erroOndas), dados.erroCatalogos && /* @__PURE__ */ React.createElement("li", { className: "is-erro" }, dados.erroCatalogos))), avisos && avisos.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "ond-avisos", role: "status" }, /* @__PURE__ */ React.createElement("ul", null, avisos.map((a, i) => /* @__PURE__ */ React.createElement("li", { key: i, className: a.nivel === "erro" ? "is-erro" : "" }, a.msg))), /* @__PURE__ */ React.createElement("button", { className: "btn ghost icon-only sm", onClick: onFecharAviso, title: "Fechar" }, /* @__PURE__ */ React.createElement(window.Ico.close, null)))), /* @__PURE__ */ React.createElement("div", { className: "ond-board__pessoas" }, /* @__PURE__ */ React.createElement(
    window.OndPessoas,
    {
      dados,
      ondas,
      pessoaSel,
      conflitos,
      onSelecionar: onSelecionarPessoa,
      onAtribuir,
      filtro: filtroPessoa,
      onFiltro: setFiltroPessoa,
      turnoFiltro,
      onTurnoFiltro: setTurnoFiltro,
      armazemFiltro,
      onArmazemFiltro: setArmazemFiltro
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "ond-board__trabalho" }, /* @__PURE__ */ React.createElement(
    window.OndTrabalho,
    {
      dados,
      ondas,
      pessoa,
      agoraMs,
      conflitos,
      onReordenar,
      onRetirar,
      onAtribuir,
      onDetalhe: (o) => setDetalheId(o.id)
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "ond-board__disponiveis" }, /* @__PURE__ */ React.createElement(
    window.OndDisponiveis,
    {
      dados,
      ondas,
      pessoaSel: pessoa,
      dia,
      ondasFora,
      erroFora,
      ambito: ambito || "todas",
      onAmbito,
      onCriar,
      onLargarNaLista: onRetirar,
      onAtribuirSel: (ids) => pessoa && ids.forEach((id) => onAtribuir(id, pessoa.id)),
      onDetalhe: (id) => setDetalheId(id)
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "ond-board__timeline" }, /* @__PURE__ */ React.createElement(
    window.OndTimeline,
    {
      dados,
      ondas,
      conflitos,
      agoraMs,
      pessoaSel,
      vista: vistaTl,
      onVista: onVistaTl,
      onSelecionar: onSelecionarPessoa,
      onMover: onAtribuir,
      verTodos,
      onVerTodos
    }
  )), detalheId && (() => {
    const onda = [...ondas || [], ...ondasFora || []].find((o) => o.id === detalheId);
    if (!onda) return null;
    return /* @__PURE__ */ React.createElement(
      window.OndOndaModal,
      {
        onda,
        dados,
        onFechar: () => setDetalheId(null),
        onReabrir: onReabrirTarefa,
        onArquivar: onArquivarOnda
      }
    );
  })());
}
window.OndasView = OndasView;

// ===== cargoplanner/frontend/cargoplanner_config.jsx =====
function cpRotulo(lista, id) {
  const x = (lista || []).find((i) => i.id === id);
  return x ? x.label : id || "\u2014";
}
function cpOpcoes(linhas) {
  return (linhas || []).filter((l) => l.ativo).map((l) => ({ id: l.id, label: l.nome }));
}
function cpMetros(v) {
  const n = Number(v);
  if (!isFinite(n)) return "\u2014";
  return `${n.toFixed(2).replace(".", ",")} m`;
}
function CpTiposTirView() {
  const VAZIO = {
    nome: "",
    categoria: "",
    eixos: 3,
    comprimento_m: "13.60",
    largura_m: "2.45",
    altura_m: "2.70",
    peso_max_kg: 24e3,
    descargas: [],
    ordem: 0,
    ativo: true,
    transitario: false
  };
  const [itens, setItens] = React.useState([]);
  const [categorias, setCategorias] = React.useState([]);
  const [descargas, setDescargas] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const [aGuardar, setAGuardar] = React.useState(false);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      const [tipos, cats, descs] = await Promise.all([
        window.CargoplannerAPI.tiposTir(),
        window.CargoplannerAPI.categorias(),
        window.CargoplannerAPI.descargas()
      ]);
      setItens(tipos);
      setCategorias(cpOpcoes(cats));
      setDescargas(cpOpcoes(descs));
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel ler os tipos."));
    } finally {
      setACarregar(false);
    }
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(VAZIO);
  };
  const guardar = async () => {
    setAGuardar(true);
    setErro(null);
    try {
      if (!String(rascunho.nome).trim()) throw new Error("O nome \xE9 obrigat\xF3rio.");
      const corpo = {
        ...rascunho,
        nome: String(rascunho.nome).trim(),
        eixos: Number(rascunho.eixos) || 0,
        peso_max_kg: Number(rascunho.peso_max_kg) || 0,
        ordem: Number(rascunho.ordem) || 0,
        categoria: rascunho.categoria ? Number(rascunho.categoria) : null,
        descargas: (rascunho.descargas || []).map(Number),
        transitario: !!rascunho.transitario
      };
      if (aEditar) await window.CargoplannerAPI.guardarTipoTir(aEditar, corpo);
      else await window.CargoplannerAPI.criarTipoTir(corpo);
      cancelar();
      await carregar();
      window.srToast?.("Tipo de TIR gravado.", "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    } finally {
      setAGuardar(false);
    }
  };
  const apagar = async (it) => {
    const ok = await window.hubConfirm({
      title: "Apagar o tipo",
      message: `Apagar "${it.nome}"? Se houver TIRs deste tipo, o servidor recusa \u2014 desativa-o em vez de o apagar.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await window.CargoplannerAPI.apagarTipoTir(it.id);
      await carregar();
      window.srToast?.(`Tipo "${it.nome}" apagado.`, "success");
    } catch (e) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel apagar \u2014 provavelmente h\xE1 TIRs deste tipo."
      ), "error");
    }
  };
  const alternarDescarga = (id) => setRascunho((r) => {
    const tem = (r.descargas || []).includes(id);
    return { ...r, descargas: tem ? r.descargas.filter((d) => d !== id) : [...r.descargas || [], id] };
  });
  const colunas = [
    {
      key: "nome",
      label: "Tipo",
      width: 200,
      minWidth: 140,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome)
    },
    {
      key: "categoria",
      label: "Categoria",
      width: 130,
      sortValue: (it) => it.categoria_nome || "",
      render: (it) => it.categoria_nome || /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
    },
    {
      key: "comprimento_m",
      label: "Comprimento",
      width: 120,
      sortValue: (it) => Number(it.comprimento_m),
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, cpMetros(it.comprimento_m))
    },
    {
      key: "largura_m",
      label: "Largura \xFAtil",
      width: 110,
      sortValue: (it) => Number(it.largura_m),
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, cpMetros(it.largura_m))
    },
    {
      key: "altura_m",
      label: "Altura \xFAtil",
      width: 110,
      sortValue: (it) => Number(it.altura_m),
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, cpMetros(it.altura_m))
    },
    {
      key: "peso_max_kg",
      label: "Carga \xFAtil",
      width: 110,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, Number(it.peso_max_kg).toLocaleString("pt-PT"), " kg")
    },
    { key: "eixos", label: "Eixos", width: 80 },
    {
      key: "descargas",
      label: "Descarga",
      width: 160,
      sortable: false,
      render: (it) => (it.descargas_nomes || []).join(", ") || "\u2014"
    },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    // Paga-se ao volume, não à viagem: sem isto ninguém em Definições sabe
    // quais dos tipos são transitários sem abrir cada um para editar.
    {
      key: "transitario",
      label: "Transit\xE1rio",
      width: 100,
      render: (it) => it.transitario ? "\u2713" : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
    },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 160,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setAEditar(it.id);
        setRascunho({ ...it });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Tipos de TIR")), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "As medidas s\xE3o as ", /* @__PURE__ */ React.createElement("b", null, "\xFAteis"), " \u2014 o espa\xE7o de carga. O comprimento \xE9 o que a ocupa\xE7\xE3o de uma carga consome; a largura decide quantas paletes v\xE3o lado a lado; a altura diz se d\xE1 para empilhar."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "tipos-tir",
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id,
      search: { fields: ["nome", "categoria"], placeholder: "Procurar tipo\u2026" }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, aEditar ? "Editar tipo" : "Novo tipo")), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement("input", { value: rascunho.nome, onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value }) })), /* @__PURE__ */ React.createElement("label", null, "Categoria", /* @__PURE__ */ React.createElement("select", { value: rascunho.categoria, onChange: (e) => setRascunho({ ...rascunho, categoria: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), categorias.map((c) => /* @__PURE__ */ React.createElement("option", { key: c.id, value: c.id }, c.label)))), /* @__PURE__ */ React.createElement("label", null, "Comprimento (m)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "0.01",
      value: rascunho.comprimento_m,
      onChange: (e) => setRascunho({ ...rascunho, comprimento_m: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Largura \xFAtil (m)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "0.01",
      value: rascunho.largura_m,
      onChange: (e) => setRascunho({ ...rascunho, largura_m: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Altura \xFAtil (m)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "0.01",
      value: rascunho.altura_m,
      onChange: (e) => setRascunho({ ...rascunho, altura_m: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Carga \xFAtil (kg)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.peso_max_kg,
      onChange: (e) => setRascunho({ ...rascunho, peso_max_kg: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Eixos", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.eixos,
      onChange: (e) => setRascunho({ ...rascunho, eixos: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.ordem,
      onChange: (e) => setRascunho({ ...rascunho, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("fieldset", { className: "cp-cfg-descargas" }, /* @__PURE__ */ React.createElement("legend", null, "Descarga"), descargas.map((d) => /* @__PURE__ */ React.createElement("label", { key: d.id, className: "cp-cfg-check" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: (rascunho.descargas || []).includes(d.id),
      onChange: () => alternarDescarga(d.id)
    }
  ), d.label))), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check cp-cfg-check--nota" }, "Transit\xE1rio", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.transitario,
      onChange: (e) => setRascunho({ ...rascunho, transitario: e.target.checked })
    }
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Paga-se ao volume enviado, n\xE3o \xE0 viagem: sem ocupa\xE7\xE3o, sem avisos de capacidade e sem rota por estrada.")), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar, disabled: aGuardar }, aGuardar ? "A guardar\u2026" : aEditar ? "Guardar" : "Adicionar"))));
}
function CpFrotaView() {
  const VAZIO = {
    codigo: "",
    tipo: "",
    aluguer: "proprio",
    transportadora: "",
    matricula: "",
    motorista: "",
    periodo: "",
    inicio: "08:00",
    fim: "16:00",
    ativo: true
  };
  const [itens, setItens] = React.useState([]);
  const [tipos, setTipos] = React.useState([]);
  const [transportadoras, setTransportadoras] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const [aGuardar, setAGuardar] = React.useState(false);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      const [frota, cat, fs] = await Promise.all([
        window.CargoplannerAPI.tirs(),
        window.CargoplannerAPI.tiposTir(),
        window.CargoplannerAPI.transportadoras({ ativos: 1 })
      ]);
      setItens(frota);
      setTipos(cat);
      setTransportadoras(fs || []);
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel ler a frota."));
    } finally {
      setACarregar(false);
    }
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const [periodos, setPeriodos] = React.useState([]);
  React.useEffect(() => {
    let vivo = true;
    window.CargoplannerAPI.periodos().then((r) => {
      if (vivo) setPeriodos(r || []);
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, []);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(VAZIO);
  };
  const guardar = async () => {
    setAGuardar(true);
    setErro(null);
    try {
      const codigo = String(rascunho.codigo).trim().toUpperCase();
      if (!codigo) throw new Error("O c\xF3digo \xE9 obrigat\xF3rio.");
      if (!rascunho.tipo) throw new Error("Escolhe o tipo de TIR.");
      const porAlugar2 = rascunho.aluguer === "por_alugar";
      const corpo = {
        ...rascunho,
        codigo,
        tipo: Number(rascunho.tipo),
        transportadora: porAlugar2 || !rascunho.transportadora ? null : Number(rascunho.transportadora),
        matricula: porAlugar2 ? "" : rascunho.matricula,
        motorista: porAlugar2 ? "" : rascunho.motorista
      };
      if (aEditar) await window.CargoplannerAPI.guardarTir(aEditar, corpo);
      else await window.CargoplannerAPI.criarTir(corpo);
      cancelar();
      await carregar();
      window.srToast?.(`TIR ${codigo} gravado.`, "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    } finally {
      setAGuardar(false);
    }
  };
  const apagar = async (it) => {
    const ok = await window.hubConfirm({
      title: `Apagar o ${it.codigo}`,
      message: `Apagar o ${it.codigo} da frota? As cargas que j\xE1 lhe foram atribu\xEDdas desaparecem com ele. Para o tirar do planeamento sem perder o hist\xF3rico, desativa-o.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await window.CargoplannerAPI.apagarTir(it.id);
      await carregar();
      window.srToast?.(`${it.codigo} apagado.`, "success");
    } catch (e) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar."), "error");
    }
  };
  const semDados = /* @__PURE__ */ React.createElement("i", { className: "cp-porconfirmar" }, "Por atribuir");
  const colunas = [
    {
      key: "codigo",
      label: "TIR",
      width: 110,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.codigo)
    },
    { key: "tipo_nome", label: "Tipo", width: 190 },
    {
      key: "metros",
      label: "Comprimento",
      width: 120,
      sortValue: (it) => Number(it.metros),
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, cpMetros(it.metros))
    },
    {
      key: "aluguer",
      label: "Contrata\xE7\xE3o",
      width: 130,
      render: (it) => it.aluguer === "por_alugar" ? /* @__PURE__ */ React.createElement("span", { className: "cp-estado-pill cp-pill-aviso" }, "Por alugar") : cpRotulo([{ id: "proprio", label: "Frota pr\xF3pria" }, { id: "alugado", label: "Alugado" }], it.aluguer)
    },
    {
      key: "transportadora_nome",
      label: "Transportadora",
      width: 190,
      render: (it) => it.aluguer === "proprio" ? "\u2014" : it.transportadora_nome || semDados
    },
    {
      key: "matricula",
      label: "Matr\xEDcula",
      width: 110,
      render: (it) => it.matricula || semDados
    },
    {
      key: "motorista",
      label: "Motorista",
      width: 160,
      render: (it) => it.motorista || semDados
    },
    {
      key: "janela",
      label: "Janela",
      width: 130,
      sortValue: (it) => it.inicio,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, String(it.inicio).slice(0, 5), "\u2013", String(it.fim).slice(0, 5))
    },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 160,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setAEditar(it.id);
        setRascunho({
          ...it,
          tipo: it.tipo,
          inicio: String(it.inicio).slice(0, 5),
          fim: String(it.fim).slice(0, 5)
        });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  const porAlugar = rascunho.aluguer === "por_alugar";
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Frota (TIRs)")), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "Cada TIR nasce de um ", /* @__PURE__ */ React.createElement("b", null, "tipo"), ", e \xE9 o tipo que lhe d\xE1 as medidas. Um TIR inativo deixa de aparecer no planeamento mas mant\xE9m as cargas que j\xE1 levou."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "frota",
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id,
      search: {
        fields: ["codigo", "tipo_nome", "transportadora_nome", "motorista", "matricula"],
        placeholder: "Procurar TIR\u2026"
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, aEditar ? "Editar TIR" : "Novo TIR")), !tipos.length && !aCarregar && /* @__PURE__ */ React.createElement("div", { className: "alert" }, "Ainda n\xE3o h\xE1 tipos de TIR. Cria um em \xABTipos de TIR\xBB primeiro."), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "C\xF3digo", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.codigo,
      placeholder: "TIR-21",
      onChange: (e) => setRascunho({ ...rascunho, codigo: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Tipo", /* @__PURE__ */ React.createElement("select", { value: rascunho.tipo || "", onChange: (e) => setRascunho({ ...rascunho, tipo: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), tipos.filter((t) => t.ativo || t.id === rascunho.tipo).map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.nome, " \xB7 ", cpMetros(t.comprimento_m))))), /* @__PURE__ */ React.createElement("label", null, "Contrata\xE7\xE3o", /* @__PURE__ */ React.createElement("select", { value: rascunho.aluguer, onChange: (e) => setRascunho({ ...rascunho, aluguer: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "proprio" }, "Frota pr\xF3pria"), /* @__PURE__ */ React.createElement("option", { value: "por_alugar" }, "Por alugar"), /* @__PURE__ */ React.createElement("option", { value: "alugado", disabled: true }, "Alugado"))), /* @__PURE__ */ React.createElement("label", null, "Transportadora", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: rascunho.transportadora || "",
      disabled: porAlugar,
      onChange: (e) => setRascunho({ ...rascunho, transportadora: e.target.value })
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, rascunho.aluguer === "proprio" ? "Frota pr\xF3pria" : "\u2014 escolher \u2014"),
    transportadoras.filter((f) => f.ativo !== false).map((f) => /* @__PURE__ */ React.createElement("option", { key: f.id, value: f.id }, f.nome))
  )), /* @__PURE__ */ React.createElement("label", null, "Matr\xEDcula", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.matricula || "",
      disabled: porAlugar,
      placeholder: porAlugar ? "Ainda por contratar" : "",
      onChange: (e) => setRascunho({ ...rascunho, matricula: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Motorista", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.motorista || "",
      disabled: porAlugar,
      placeholder: porAlugar ? "Ainda por contratar" : "",
      onChange: (e) => setRascunho({ ...rascunho, motorista: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Per\xEDodo", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: rascunho.periodo,
      onChange: (e) => setRascunho({ ...rascunho, periodo: e.target.value })
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 (o grupo vem da hora de sa\xEDda)"),
    periodos.filter((p) => p.ativo !== false).map((p) => /* @__PURE__ */ React.createElement("option", { key: p.codigo, value: p.codigo }, p.nome))
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "S\xF3 vale quando o cami\xE3o n\xE3o tem hora de sa\xEDda. Com hora, \xE9 ela que decide o grupo.")), /* @__PURE__ */ React.createElement("label", null, "In\xEDcio", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: rascunho.inicio,
      onChange: (e) => setRascunho({ ...rascunho, inicio: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Fim", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: rascunho.fim,
      onChange: (e) => setRascunho({ ...rascunho, fim: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar, disabled: aGuardar || !tipos.length }, aGuardar ? "A guardar\u2026" : aEditar ? "Guardar" : "Adicionar"))));
}
function CpVocabulario({ titulo, nota, api, viewId, campoRef }) {
  const VAZIO = campoRef ? { ref: "", nome: "", ativo: true } : { nome: "", ordem: 0, ativo: true };
  const [itens, setItens] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      setItens(await api.listar());
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel ler a lista."));
    } finally {
      setACarregar(false);
    }
  }, [api]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(VAZIO);
  };
  const guardar = async () => {
    setErro(null);
    try {
      const nome = String(rascunho.nome).trim();
      const ref = campoRef ? String(rascunho.ref).trim() : "";
      if (campoRef ? !ref : !nome) throw new Error(campoRef ? "A refer\xEAncia \xE9 obrigat\xF3ria." : "O nome \xE9 obrigat\xF3rio.");
      const corpo = campoRef ? { ...rascunho, ref, nome } : { ...rascunho, nome, ordem: Number(rascunho.ordem) || 0 };
      if (aEditar) await api.guardar(aEditar, corpo);
      else await api.criar(corpo);
      cancelar();
      await carregar();
      window.srToast?.(`${titulo}: \xAB${campoRef ? ref : nome}\xBB gravado.`, "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    }
  };
  const apagar = async (it) => {
    const ok = await window.hubConfirm({
      title: "Apagar",
      message: `Apagar \xAB${campoRef ? it.ref : it.nome}\xBB? Se estiver em uso o servidor recusa \u2014 nesse caso desativa-o, que o tira das escolhas sem mexer no que j\xE1 l\xE1 est\xE1.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await api.apagar(it.id);
      await carregar();
    } catch (e) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel apagar \u2014 provavelmente est\xE1 em uso."
      ), "error");
    }
  };
  const colunas = [
    ...campoRef ? [{
      key: "ref",
      label: "Refer\xEAncia",
      width: 140,
      minWidth: 100,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", { className: "td-mono" }, it.ref)
    }] : [],
    {
      key: "nome",
      label: campoRef ? "Descri\xE7\xE3o" : "Nome",
      width: 220,
      minWidth: 140,
      fixed: !campoRef,
      render: (it) => campoRef ? it.nome : /* @__PURE__ */ React.createElement("strong", null, it.nome)
    },
    ...campoRef ? [] : [{
      key: "ordem",
      label: "Ordem",
      width: 80,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.ordem)
    }],
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setAEditar(it.id);
        setRascunho({ ...it });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "cp-vocab" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, titulo)), nota && /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, nota), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId,
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, campoRef && /* @__PURE__ */ React.createElement("label", null, "Refer\xEAncia", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.ref,
      onChange: (e) => setRascunho({ ...rascunho, ref: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, campoRef ? "Descri\xE7\xE3o" : "Nome", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nome,
      onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value })
    }
  )), !campoRef && /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.ordem,
      onChange: (e) => setRascunho({ ...rascunho, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, aEditar && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar }, aEditar ? "Guardar" : "Adicionar"))));
}
function CpCaisPainel() {
  const A = window.CargoplannerAPI;
  const VAZIO = { nome: "", codigo: "", empresa: "", ordem: 0, ativo: true };
  const [itens, setItens] = React.useState([]);
  const [empresas, setEmpresas] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      setItens(await A.cais());
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel ler os cais."));
    } finally {
      setACarregar(false);
    }
  }, [A]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  React.useEffect(() => {
    let vivo = true;
    A.empresas().then((r) => {
      if (vivo) setEmpresas(r || []);
    }).catch(() => {
      if (vivo) setEmpresas([]);
    });
    return () => {
      vivo = false;
    };
  }, [A]);
  React.useEffect(() => {
    if (!rascunho.empresa && empresas.length) {
      setRascunho((r) => r.empresa ? r : { ...r, empresa: empresas[0].id });
    }
  }, [empresas, rascunho.empresa]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho({ ...VAZIO, empresa: (empresas[0] || {}).id || "" });
  };
  const guardar = async () => {
    setErro(null);
    try {
      const nome = String(rascunho.nome).trim();
      const codigo = String(rascunho.codigo).trim();
      if (!nome) throw new Error("O nome \xE9 obrigat\xF3rio \u2014 \xE9 o que o planeador l\xEA no dropdown.");
      if (!codigo) throw new Error("Escolhe a localiza\xE7\xE3o do armaz\xE9m.");
      const corpo = {
        nome,
        codigo,
        empresa: rascunho.empresa,
        ordem: Number(rascunho.ordem) || 0,
        ativo: !!rascunho.ativo
      };
      if (aEditar) await A.guardarCais(aEditar, corpo);
      else await A.criarCais(corpo);
      cancelar();
      await carregar();
      window.srToast?.(`Cais \xAB${nome}\xBB gravado.`, "success");
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar o cais."));
    }
  };
  const apagar = async (it) => {
    const ok = await window.hubConfirm({
      title: "Apagar cais",
      message: `Apagar \xAB${it.nome}\xBB (${it.codigo})? As cargas que j\xE1 o t\xEAm gravado n\xE3o mudam \u2014 o c\xF3digo fica l\xE1. Para o tirar das escolhas sem mexer em nada, desativa-o.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await A.apagarCais(it.id);
      await carregar();
    } catch (e) {
      window.srToast?.(A.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar."), "error");
    }
  };
  const colunas = [
    {
      key: "nome",
      label: "Nome",
      width: 180,
      minWidth: 120,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome)
    },
    {
      key: "codigo",
      label: "Localiza\xE7\xE3o",
      width: 130,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, it.codigo)
    },
    {
      key: "empresa_nome",
      label: "Base do ERP",
      width: 130,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, it.empresa_nome)
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 80,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.ordem)
    },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => {
            setAEditar(it.id);
            setRascunho({ ...it, empresa: it.empresa });
          }
        },
        "Editar"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "cp-vocab" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Cais")), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "Onde uma carga se monta. Um cais tem de existir na ", /* @__PURE__ */ React.createElement("code", null, "u_locais_arm"), " do PHC \u2014 \xE9 contra ela que o tablet aloca cada palete ao picar \u2014, por isso escolhe-se da lista do ERP em vez de se escrever o c\xF3digo."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "cais",
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Base do ERP", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: rascunho.empresa || "",
      onChange: (e) => setRascunho({ ...rascunho, empresa: e.target.value, codigo: "" })
    },
    !empresas.length && /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem bases \u2014"),
    empresas.map((e) => /* @__PURE__ */ React.createElement("option", { key: e.id, value: e.id }, e.nome))
  )), /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nome,
      placeholder: "Cais 3",
      onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.ordem,
      onChange: (e) => setRascunho({ ...rascunho, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, aEditar && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar }, aEditar ? "Guardar" : "Adicionar"))), /* @__PURE__ */ React.createElement(
    CpLocalDoArmazem,
    {
      empresa: rascunho.empresa,
      valor: rascunho.codigo,
      onEscolher: (loc) => setRascunho((r) => ({
        ...r,
        codigo: loc ? loc.codigo : "",
        // Só preenche o nome enquanto está VAZIO: a partir do momento em
        // que alguém lá escreveu, é a decisão dele que manda — a mesma
        // regra do destino pré-preenchido no tablet e do fornecedor do PHC.
        nome: r.nome || (loc ? loc.observacoes || loc.codigo : "")
      }))
    }
  ));
}
function CpLocalDoArmazem({ empresa, valor, onEscolher }) {
  const A = window.CargoplannerAPI;
  const [texto, setTexto] = React.useState("");
  const [lista, setLista] = React.useState(null);
  const relogio = React.useRef(null);
  React.useEffect(() => {
    const q = texto.trim();
    if (relogio.current) clearTimeout(relogio.current);
    if (q.length < 2 || !empresa) {
      setLista(null);
      return void 0;
    }
    let vivo = true;
    relogio.current = setTimeout(() => {
      A.locaisArm(q, empresa).then((r) => {
        if (vivo) setLista(r && r.locais || []);
      }).catch(() => {
        if (vivo) setLista(null);
      });
    }, 400);
    return () => {
      vivo = false;
      if (relogio.current) clearTimeout(relogio.current);
    };
  }, [texto, empresa, A]);
  return /* @__PURE__ */ React.createElement("div", { className: "cp-fornecedor-phc" }, valor ? /* @__PURE__ */ React.createElement("div", { className: "cp-fornecedor-phc__atual" }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, valor), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: () => {
        onEscolher(null);
        setTexto("");
      }
    },
    "Trocar"
  )) : /* @__PURE__ */ React.createElement("div", { className: "cp-dim" }, "Sem localiza\xE7\xE3o escolhida \u2014 procura abaixo (\xABcais\xBB, \xABCAI\xBB, \xABV01\xBB\u2026)."), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: texto,
      placeholder: "Procurar localiza\xE7\xE3o no armaz\xE9m\u2026",
      "aria-label": "Procurar localiza\xE7\xE3o do armaz\xE9m",
      onChange: (e) => setTexto(e.target.value)
    }
  ), lista && lista.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "cp-dim" }, "Nenhuma localiza\xE7\xE3o ativa com esse texto."), lista && lista.length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "cp-fornecedor-phc__lista" }, lista.map((l) => /* @__PURE__ */ React.createElement("li", { key: l.codigo }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "cp-fornecedor-phc__op",
      onClick: () => {
        onEscolher(l);
        setTexto("");
        setLista(null);
      }
    },
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, l.codigo),
    /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", l.observacoes || "sem descri\xE7\xE3o", l.zona ? ` \xB7 zona ${l.zona}` : "")
  )))));
}
function CpPeriodosPainel() {
  const A = window.CargoplannerAPI;
  const VAZIO = { codigo: "", nome: "", desde: "08:00", ativo: true };
  const [itens, setItens] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      setItens(await A.periodos());
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel ler os per\xEDodos."));
    } finally {
      setACarregar(false);
    }
  }, [A]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(VAZIO);
  };
  const guardar = async () => {
    setErro(null);
    try {
      const nome = String(rascunho.nome).trim();
      const codigo = String(rascunho.codigo).trim().toLowerCase();
      if (!nome) throw new Error("O nome \xE9 obrigat\xF3rio.");
      if (!codigo) throw new Error("O c\xF3digo \xE9 obrigat\xF3rio.");
      if (!/^\d{1,2}:\d{2}/.test(String(rascunho.desde || ""))) {
        throw new Error("A hora \xE9 obrigat\xF3ria \u2014 \xE9 ela que decide o grupo.");
      }
      const corpo = { ...rascunho, nome, codigo };
      if (aEditar) await A.guardarPeriodo(aEditar, corpo);
      else await A.criarPeriodo(corpo);
      cancelar();
      await carregar();
      window.srToast?.(`Per\xEDodo \xAB${nome}\xBB gravado.`, "success");
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    }
  };
  const apagar = async (it) => {
    const ok = await window.hubConfirm({
      title: "Apagar per\xEDodo",
      message: `Apagar \xAB${it.nome}\xBB? N\xE3o desaparece nenhum cami\xE3o \u2014 o quadro reagrupa-os no per\xEDodo ANTERIOR (o \xFAltimo cuja hora de sa\xEDda j\xE1 passou), nunca em \xABSem hor\xE1rio\xBB: um cami\xE3o das 16:00 sem \xABTarde\xBB passa a aparecer debaixo de \xABManh\xE3\xBB.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await A.apagarPeriodo(it.id);
      await carregar();
    } catch (e) {
      window.srToast?.(A.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar."), "error");
    }
  };
  const colunas = [
    {
      key: "nome",
      label: "Nome",
      width: 180,
      minWidth: 120,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome)
    },
    {
      key: "desde",
      label: "A partir das",
      width: 120,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, String(it.desde || "").slice(0, 5))
    },
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 120,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.codigo)
    },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setAEditar(it.id);
        setRascunho({ ...it, desde: String(it.desde || "").slice(0, 5) });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "cp-vocab" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Per\xEDodos do dia")), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "Os grupos da coluna dos cami\xF5es. Um cami\xE3o cai no \xFAltimo per\xEDodo cuja hora j\xE1 passou \u2014 pela hora de sa\xEDda DAQUELE DIA se a houver, sen\xE3o pela da ficha. O c\xF3digo n\xE3o se muda depois de haver cami\xF5es a us\xE1-lo."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "periodos-dia",
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nome,
      onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "C\xF3digo", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.codigo,
      disabled: !!aEditar,
      placeholder: "manha",
      onChange: (e) => setRascunho({ ...rascunho, codigo: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "A partir das", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: rascunho.desde,
      onChange: (e) => setRascunho({ ...rascunho, desde: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, aEditar && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar }, aEditar ? "Guardar" : "Adicionar"))));
}
function CpFeriadosPainel() {
  const A = window.CargoplannerAPI;
  const VAZIO = { data: "", nome: "", ativo: true };
  const [itens, setItens] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      setItens(await A.feriados());
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel ler os feriados."));
    } finally {
      setACarregar(false);
    }
  }, [A]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(VAZIO);
  };
  async function guardar() {
    setErro(null);
    try {
      const corpo = {
        data: rascunho.data,
        nome: (rascunho.nome || "").trim(),
        ativo: !!rascunho.ativo
      };
      if (aEditar) await A.feriadoGuardar(aEditar, corpo);
      else await A.feriadoCriar(corpo);
      cancelar();
      await carregar();
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel guardar o feriado."));
    }
  }
  async function apagar(it) {
    const ok = await window.hubConfirm({
      title: "Apagar o feriado",
      message: `Apagar ${it.nome} de ${it.data}? Se s\xF3 quer dizer que este ano se trabalha, desative-o em vez de apagar \u2014 a linha volta a valer no ano seguinte.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await A.feriadoApagar(it.id);
      await carregar();
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar o feriado."));
    }
  }
  const colunas = [
    { key: "data", label: "Data", sortKey: "data" },
    { key: "nome", label: "Nome", sortKey: "nome" },
    {
      key: "ativo",
      label: "Ativo",
      // Uma bola não tem por onde ordenar sozinha — ver a convenção das
      // listas no CLAUDE.md da raiz.
      sortValue: (it) => it.ativo ? 1 : 0,
      render: (it) => it.ativo ? "Sim" : "N\xE3o"
    },
    {
      key: "acoes",
      label: "",
      sortable: false,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "cp-cfg-acoes" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setAEditar(it.id);
        setRascunho({ data: it.data, nome: it.nome, ativo: it.ativo });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-bloco" }, /* @__PURE__ */ React.createElement("h3", null, "Feriados"), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "Os dias em que n\xE3o se trabalha. O quadro marca-os ao lado da data \u2014", /* @__PURE__ */ React.createElement("b", null, " avisa, n\xE3o impede"), ": planear para um feriado continua a ser poss\xEDvel. V\xEAm semeados os ", /* @__PURE__ */ React.createElement("b", null, "nacionais"), " at\xE9 2032; os municipais diferem entre Guimar\xE3es e Vila Nova da Barquinha, por isso acrescentam-se aqui \xE0 m\xE3o."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "feriados",
      columns: colunas,
      data: itens,
      rowKey: (it) => it.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Data", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "date",
      value: rascunho.data,
      onChange: (e) => setRascunho({ ...rascunho, data: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nome,
      placeholder: "Feriado municipal de Guimar\xE3es",
      onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, aEditar && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      onClick: guardar,
      disabled: !rascunho.data || !(rascunho.nome || "").trim()
    },
    aEditar ? "Guardar" : "Adicionar"
  ))));
}
function CpVocabulariosView() {
  const A = window.CargoplannerAPI;
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "Estas listas eram valores fixos no c\xF3digo. Acrescentar uma categoria ou um tipo de descarga passou a ser uma linha aqui \u2014 n\xE3o um deploy."), /* @__PURE__ */ React.createElement(
    CpVocabulario,
    {
      titulo: "Categorias de transporte",
      viewId: "categorias",
      nota: "O que o ve\xEDculo \xE9: semirreboque, r\xEDgido, mega, frigor\xEDfico\u2026",
      api: {
        listar: A.categorias,
        criar: A.criarCategoria,
        guardar: A.guardarCategoria,
        apagar: A.apagarCategoria
      }
    }
  ), /* @__PURE__ */ React.createElement(
    CpVocabulario,
    {
      titulo: "Tipos de descarga",
      viewId: "descargas",
      nota: "Por onde o ve\xEDculo descarrega \u2014 cruza com o que a morada do cliente exige.",
      api: {
        listar: A.descargas,
        criar: A.criarDescarga,
        guardar: A.guardarDescarga,
        apagar: A.apagarDescarga
      }
    }
  ), /* @__PURE__ */ React.createElement(
    CpVocabulario,
    {
      titulo: "Motivos de urg\xEAncia",
      viewId: "motivos-urgencia",
      nota: "Porque \xE9 que uma carga \xE9 urgente. Marcar uma carga urgente obriga a escolher um destes.",
      api: {
        listar: A.motivosUrgencia,
        criar: A.criarMotivoUrgencia,
        guardar: A.guardarMotivoUrgencia,
        apagar: A.apagarMotivoUrgencia
      }
    }
  ), /* @__PURE__ */ React.createElement(
    CpVocabulario,
    {
      titulo: "Motivos de carga",
      viewId: "motivos-carga",
      nota: "O motivo com que a carga \xE9 criada no PHC \u2014 escolhe-se ao dar a carga por preparada. O texto vai TAL COMO EST\xC1 para o ERP.",
      api: {
        listar: A.motivosCarga,
        criar: A.criarMotivoCarga,
        guardar: A.guardarMotivoCarga,
        apagar: A.apagarMotivoCarga
      }
    }
  ), /* @__PURE__ */ React.createElement(
    CpVocabulario,
    {
      titulo: "Artigos que n\xE3o s\xE3o carga",
      viewId: "artigos-nao-carga",
      nota: "Portes e afins: linhas do ERP que n\xE3o s\xE3o mercadoria a carregar e ficam escondidas na lista de entregas (a refer\xEAncia do artigo, escrita como no PHC). As ferramentas n\xE3o est\xE3o aqui \u2014 reconhecem-se pelo tipo do artigo no ERP.",
      campoRef: true,
      api: {
        listar: A.artigosNaoCarga,
        criar: A.criarArtigoNaoCarga,
        guardar: A.guardarArtigoNaoCarga,
        apagar: A.apagarArtigoNaoCarga
      }
    }
  ), /* @__PURE__ */ React.createElement(CpFeriadosPainel, null), /* @__PURE__ */ React.createElement(CpCaisPainel, null), /* @__PURE__ */ React.createElement(CpPeriodosPainel, null));
}
function CpUnidadesView() {
  const VAZIO = {
    codigo: "",
    nome: "",
    local: "",
    morada: "",
    codigo_postal: "",
    lat: "",
    lng: "",
    ordem: 0,
    ativo: true
  };
  const [itens, setItens] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      setItens(await window.CargoplannerAPI.unidades());
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel ler as unidades."));
    } finally {
      setACarregar(false);
    }
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(VAZIO);
  };
  const guardar = async () => {
    setErro(null);
    try {
      const codigo = String(rascunho.codigo).trim().toLowerCase();
      if (!codigo) throw new Error("O c\xF3digo \xE9 obrigat\xF3rio \u2014 \xE9 ele que as cargas j\xE1 gravadas usam.");
      if (!String(rascunho.nome).trim()) throw new Error("O nome \xE9 obrigat\xF3rio.");
      const num = (v) => v === "" || v == null ? null : Number(v);
      const corpo = {
        ...rascunho,
        codigo,
        nome: String(rascunho.nome).trim(),
        lat: num(rascunho.lat),
        lng: num(rascunho.lng),
        ordem: Number(rascunho.ordem) || 0
      };
      if (aEditar) await window.CargoplannerAPI.guardarUnidade(aEditar, corpo);
      else await window.CargoplannerAPI.criarUnidade(corpo);
      cancelar();
      await carregar();
      window.srToast?.(`Unidade \xAB${corpo.nome}\xBB gravada.`, "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    }
  };
  const apagar = async (it) => {
    const ok = await window.hubConfirm({
      title: `Apagar ${it.nome}`,
      message: "As cargas que tenham esta unidade como origem ou regresso ficam a apontar para um c\xF3digo que j\xE1 n\xE3o existe. Desativar \xE9 quase sempre melhor.",
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await window.CargoplannerAPI.apagarUnidade(it.id);
      await carregar();
    } catch (e) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar."), "error");
    }
  };
  const semCoords = /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Sem coordenadas esta unidade n\xE3o entra no c\xE1lculo do percurso" }, "\u2014");
  const colunas = [
    {
      key: "nome",
      label: "Unidade",
      width: 220,
      minWidth: 150,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome)
    },
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 90,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.codigo)
    },
    { key: "local", label: "Localidade", width: 140 },
    { key: "morada", label: "Morada", width: 260 },
    { key: "codigo_postal", label: "C\xF3d. postal", width: 130 },
    {
      key: "coords",
      label: "Coordenadas",
      width: 150,
      sortable: false,
      render: (it) => it.lat == null || it.lng == null ? semCoords : /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, Number(it.lat).toFixed(4), ", ", Number(it.lng).toFixed(4))
    },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setAEditar(it.id);
        setRascunho({ ...it });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Unidades industriais")), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "A origem \u2014 e o regresso \u2014 de uma carga \xE9 sempre uma unidade do grupo, nunca um cliente (RF04). O ", /* @__PURE__ */ React.createElement("b", null, "c\xF3digo"), " \xE9 o que as cargas j\xE1 gravadas guardam: mud\xE1-lo desliga-as da unidade. ", /* @__PURE__ */ React.createElement("b", null, "Sem coordenadas"), " a unidade n\xE3o entra no c\xE1lculo do percurso, e o ecr\xE3 diz \xAB\u2014\xBB em vez de a tratar como (0,0)."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "unidades",
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id,
      search: { fields: ["nome", "local", "morada", "codigo"], placeholder: "Procurar unidade\u2026" }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, aEditar ? "Editar unidade" : "Nova unidade")), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "C\xF3digo", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.codigo,
      placeholder: "jn",
      onChange: (e) => setRascunho({ ...rascunho, codigo: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nome,
      onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Localidade", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.local,
      onChange: (e) => setRascunho({ ...rascunho, local: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Morada", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.morada,
      size: 34,
      onChange: (e) => setRascunho({ ...rascunho, morada: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "C\xF3digo postal", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.codigo_postal,
      onChange: (e) => setRascunho({ ...rascunho, codigo_postal: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Latitude", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "0.0000001",
      value: rascunho.lat ?? "",
      onChange: (e) => setRascunho({ ...rascunho, lat: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Longitude", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "0.0000001",
      value: rascunho.lng ?? "",
      onChange: (e) => setRascunho({ ...rascunho, lng: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.ordem,
      onChange: (e) => setRascunho({ ...rascunho, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, aEditar && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar }, aEditar ? "Guardar" : "Adicionar"))));
}
window.CpVocabulariosView = CpVocabulariosView;
window.CpUnidadesView = CpUnidadesView;
window.CpTiposTirView = CpTiposTirView;
window.CpFrotaView = CpFrotaView;

// ===== cargoplanner/frontend/cargoplanner_moradas.jsx =====
const CP_MORADA_MOTIVOS = {
  nivel: {
    etiqueta: "o endere\xE7o n\xE3o bate",
    ajuda: "O Mapbox encontrou a rua, mas o c\xF3digo postal ou a localidade que ele devolveu n\xE3o s\xE3o os da morada. Confirmar a morada no PHC \u2014 tipicamente \xE9 a rua que est\xE1 escrita de uma forma que existe noutra terra."
  },
  longe_do_cp4: {
    etiqueta: "longe dos vizinhos",
    ajuda: "O ponto est\xE1 longe das outras moradas com o mesmo c\xF3digo postal. Ou o c\xF3digo postal est\xE1 errado na morada, ou o ponto est\xE1 \u2014 e \xE9 a morada no PHC que decide qual."
  }
};
function CpMoradaMotivo({ motivo }) {
  const m = CP_MORADA_MOTIVOS[motivo];
  if (!m) return null;
  return /* @__PURE__ */ React.createElement("span", { className: `cp-tag cp-tag--morada cp-tag--${motivo}`, title: m.ajuda }, m.etiqueta);
}
function cpNaoCasou(matchCode) {
  if (!matchCode) return "";
  const NOMES = {
    postcode: "c\xF3digo postal",
    place: "localidade",
    region: "distrito",
    street: "rua",
    address_number: "n\xFAmero"
  };
  return Object.keys(NOMES).filter((k) => matchCode[k] === "unmatched").map((k) => NOMES[k]).join(", ");
}
function cpClienteDaMorada(it, lidos) {
  if (it && it.cliente_no != null) {
    const estab = Number(it.cliente_estab) || 0;
    return {
      numero: estab ? `${it.cliente_no}/${estab}` : String(it.cliente_no),
      nome: it.cliente_nome || "",
      falta: ""
    };
  }
  let falta;
  if (!it || !(it.descricao || "").trim()) falta = "sem descri\xE7\xE3o da morada";
  else if (it.cliente_ambiguo) falta = "v\xE1rias moradas com esta descri\xE7\xE3o no PHC \u2014 ver no PHC";
  else if (lidos === false) falta = "por apurar \u2014 o PHC n\xE3o respondeu";
  else falta = "sem cliente no PHC";
  return { numero: "", nome: "", falta };
}
function CpMoradasView() {
  const [itens, setItens] = React.useState([]);
  const [cobertura, setCobertura] = React.useState(null);
  const [clientesLidos, setClientesLidos] = React.useState(true);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      const r = await window.CargoplannerAPI.moradasPorCorrigir();
      setItens(r.moradas || []);
      setCobertura(r.cobertura || null);
      setClientesLidos(r.clientes_lidos !== false);
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel ler as moradas."
      ));
    } finally {
      setACarregar(false);
    }
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const colunas = React.useMemo(() => [
    // **A morada é o identificador, e por omissão vinha esmagada** — a
    // coluna mais importante do ecrã cortada a meio enquanto a do lado
    // ocupava largura a dizer «ainda não foi relida». O utilizador pode
    // sempre redimensionar; o que não deve é ter de o fazer à chegada.
    {
      key: "morada",
      label: "Morada (no PHC)",
      width: 340,
      render: (it) => {
        const p = (it.morada || "").match(/Morada:([^;]*)/);
        const l = (it.morada || "").match(/Local:([^;]*)/);
        const c = (it.morada || "").match(/Cod:([^;]*)/);
        return /* @__PURE__ */ React.createElement("div", { className: "cp-morada-cel" }, /* @__PURE__ */ React.createElement("div", { className: "cp-morada-cel__rua" }, p && p[1].trim() || it.morada), /* @__PURE__ */ React.createElement("div", { className: "cp-dim" }, [l && l[1].trim(), c && c[1].trim()].filter(Boolean).join(" \xB7 ")));
      }
    },
    // O nº e o nome do cliente, e a descrição da morada: é por eles que a
    // morada se encontra no PHC para a corrigir (cartão #146).
    {
      key: "cliente_no",
      label: "N\xBA cliente",
      width: 100,
      sortValue: (it) => it.cliente_no == null ? null : Number(it.cliente_no),
      render: (it) => {
        const c = cpClienteDaMorada(it, clientesLidos);
        return c.numero ? /* @__PURE__ */ React.createElement("b", null, c.numero) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014");
      }
    },
    {
      key: "cliente_nome",
      label: "Cliente",
      width: 220,
      render: (it) => {
        const c = cpClienteDaMorada(it, clientesLidos);
        return c.falta ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, c.falta) : /* @__PURE__ */ React.createElement("span", null, c.nome || "\u2014");
      }
    },
    {
      key: "descricao",
      label: "Descri\xE7\xE3o da morada",
      width: 200,
      render: (it) => it.descricao ? /* @__PURE__ */ React.createElement("span", null, it.descricao) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
    },
    {
      key: "morada_devolvida",
      label: "Onde o Mapbox a p\xF4s",
      width: 250,
      render: (it) => it.morada_devolvida ? /* @__PURE__ */ React.createElement("span", null, it.morada_devolvida) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014 ainda n\xE3o foi relida")
    },
    {
      key: "motivo",
      label: "Porqu\xEA",
      sortable: false,
      width: 150,
      render: (it) => /* @__PURE__ */ React.createElement(CpMoradaMotivo, { motivo: it.motivo })
    },
    {
      key: "km_do_cp4",
      label: "Dist\xE2ncia",
      width: 110,
      // CALCULADA — sem `sortValue` ordenava por `row.km_do_cp4` cru, e as
      // que não têm (as do motivo `nivel`) desapareciam no fim a fingir zero.
      sortValue: (it) => it.km_do_cp4 == null ? -1 : it.km_do_cp4,
      render: (it) => it.km_do_cp4 == null ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014") : /* @__PURE__ */ React.createElement("b", null, it.km_do_cp4, " km")
    },
    {
      key: "confianca",
      label: "Confian\xE7a",
      width: 100,
      render: (it) => it.confianca ? /* @__PURE__ */ React.createElement("span", { className: it.confianca === "low" ? "cp-aviso-inline" : "" }, it.confianca) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
    },
    {
      key: "nao_casou",
      label: "O que n\xE3o casou",
      sortable: false,
      width: 170,
      render: (it) => {
        const t = cpNaoCasou(it.match_code);
        return t ? /* @__PURE__ */ React.createElement("span", null, t) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014");
      }
    }
  ], [clientesLidos]);
  return /* @__PURE__ */ React.createElement("div", { className: "cp-cfg" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Moradas por corrigir"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, aCarregar ? "a ler\u2026" : `${itens.length} morada(s)`), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm cp-zona__h-fim",
      onClick: carregar,
      title: "Voltar a ler"
    },
    "Recarregar"
  )), /* @__PURE__ */ React.createElement("p", { className: "cp-dim cp-moradas-intro" }, "Moradas de entrega cujo ponto no mapa n\xE3o \xE9 de confian\xE7a. O planeador v\xEA-as marcadas \xABaprox.\xBB no pino; aqui v\xEA-se ", /* @__PURE__ */ React.createElement("b", null, "porqu\xEA"), ". Corrige-se a morada no PHC \u2014 na leitura seguinte o ponto resolve-se sozinho."), erro && /* @__PURE__ */ React.createElement("div", { className: "cp-aviso", role: "status" }, /* @__PURE__ */ React.createElement("span", null, erro), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: carregar }, "Tentar outra vez")), !erro && aCarregar && /* @__PURE__ */ React.createElement("div", { className: "cp-vazio" }, "A ler as moradas\u2026"), !erro && !aCarregar && !itens.length && /* @__PURE__ */ React.createElement("div", { className: "cp-vazio" }, "Nenhuma morada por corrigir."), !erro && !aCarregar && itens.length > 0 && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "cargoplanner",
      viewId: "moradas-por-corrigir",
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id,
      search: {
        fields: [
          "morada",
          "morada_devolvida",
          "local_devolvido",
          "cliente_no",
          "cliente_nome",
          "descricao"
        ],
        placeholder: "Procurar morada ou cliente\u2026"
      }
    }
  ), !erro && cobertura && /* @__PURE__ */ React.createElement("p", { className: "cp-dim cp-moradas-cobertura" }, "Examinadas ", /* @__PURE__ */ React.createElement("b", null, cobertura.examinadas), " de ", cobertura.com_ponto, " ", "moradas com ponto.", " ", cobertura.sozinhos > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, cobertura.sozinhos, " est\xE3o num c\xF3digo postal com um \xFAnico endere\xE7o (sem vizinhos n\xE3o h\xE1 com que comparar)", cobertura.sem_cp4 > 0 ? "; " : ". "), cobertura.sem_cp4 > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, cobertura.sem_cp4, " n\xE3o t\xEAm c\xF3digo postal portugu\xEAs. "), "Estas s\xF3 s\xE3o avaliadas quando a morada volta a ser lida."));
}
window.CpMoradasView = CpMoradasView;
window.CpMoradaMotivo = CpMoradaMotivo;
window.cpNaoCasou = cpNaoCasou;
window.cpClienteDaMorada = cpClienteDaMorada;
window.CP_MORADA_MOTIVOS = CP_MORADA_MOTIVOS;

// ===== cargoplanner/frontend/cargoplanner_reservas.jsx =====
function cpContarPorCodigo(itens) {
  const contagem = {};
  for (const it of itens) {
    contagem[it.codigo] = (contagem[it.codigo] || 0) + 1;
  }
  return contagem;
}
function CpReservasDaLista({ onda, carga, titulo, intro, onCobertura }) {
  const [itens, setItens] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [aLargar, setALargar] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      const r = await window.CargoplannerAPI.reservasDePalete({ onda, carga });
      setItens(r.reservas || []);
      onCobertura?.(r.cobertura || null);
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel ler as reservas."
      ));
      onCobertura?.(null);
    } finally {
      setACarregar(false);
    }
  }, [onda, carga, onCobertura]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const contagemPorCodigo = React.useMemo(
    () => cpContarPorCodigo(itens),
    [itens]
  );
  const largar = React.useCallback(async (it) => {
    const chave = `${it.tarefa}:${it.codigo}`;
    if (aLargar) return;
    const ok = await window.hubConfirm({
      title: "Largar esta reserva?",
      message: it.no_phc ? `A palete ${it.codigo} j\xE1 foi lan\xE7ada no PHC \u2014 esse registo fica, e a linha do dossier 82 n\xE3o se desfaz por aqui. A palete deixa s\xF3 de reservar: outra tarefa pode voltar a pic\xE1-la.` : `A palete ${it.codigo} sai desta tarefa como se nunca tivesse sido picada.`,
      confirmLabel: "Largar",
      danger: false
    });
    if (!ok) return;
    setALargar(chave);
    try {
      await window.CargoplannerAPI.largarReserva(it.tarefa, it.codigo);
      window.srToast?.(`Palete ${it.codigo} largada.`, "success");
      await carregar();
    } catch (e) {
      window.srToast?.(window.CargoplannerAPI.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel largar esta reserva."
      ), "error");
    } finally {
      setALargar(null);
    }
  }, [aLargar, carregar]);
  const colunas = React.useMemo(() => {
    const lista = [
      {
        key: "codigo",
        label: "Palete",
        width: 150,
        render: (it) => {
          const outras = (contagemPorCodigo[it.codigo] || 1) - 1;
          return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, it.codigo), outras > 0 && /* @__PURE__ */ React.createElement("div", { className: "cp-dim", title: "A mesma palete tem outra(s) reserva(s), noutra(s) tarefa(s) \u2014 cada uma larga-se \xE0 parte, na sua pr\xF3pria linha." }, "+", outras, " outra", outras > 1 ? "s" : "", " tarefa", outras > 1 ? "s" : ""));
        }
      },
      {
        key: "ref",
        label: "Artigo",
        width: 150,
        render: (it) => it.ref || /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
      },
      {
        key: "qtd",
        label: "Reservado",
        width: 110,
        // **`qtd` a `null` escreve «não se sabe», nunca `0`.** É «picou-se e
        // não se sabe quanto» — a mesma disciplina das paletes sem medida.
        render: (it) => it.qtd == null ? /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "Picou-se e n\xE3o se sabe quanto" }, "n\xE3o se sabe") : /* @__PURE__ */ React.createElement("b", null, it.qtd)
      },
      {
        key: "pessoa",
        label: "Quem a tem",
        width: 150,
        // **`pessoa` a `null` escreve «por atribuir», não «ninguém»**: a
        // onda existe e não tem dono, e «ninguém» faria quem precisa da
        // palete achar que a podia levar.
        render: (it) => it.pessoa ? /* @__PURE__ */ React.createElement("span", null, it.pessoa) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "por atribuir")
      },
      // **Fica nos DOIS recortes** — é ela que distingue duas reservas da
      // mesma palete, e dentro de uma onda é precisamente onde isso
      // acontece mais (duas tarefas da mesma onda a picar o mesmo código).
      {
        key: "tarefa_descricao",
        label: "Tarefa",
        width: 160,
        // **Sem esta coluna, duas reservas da mesma palete em tarefas
        // diferentes são linhas IDÊNTICAS** — mesma palete, artigo, pessoa,
        // onda e dia. O gesto é por (tarefa, código): largar uma deixava a
        // gémea no ecrã, lia-se como «não fez nada», e largava-se a
        // segunda, que ninguém tinha pedido. Apanhado na revisão final do
        // cartão #131.
        render: (it) => it.tarefa_descricao ? /* @__PURE__ */ React.createElement("span", { title: `Tarefa #${it.tarefa}` }, it.tarefa_descricao) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: `Tarefa #${it.tarefa}` }, "#", it.tarefa)
      }
    ];
    if (!onda) {
      lista.push({
        key: "onda_codigo",
        label: "Onda",
        width: 110,
        render: (it) => it.onda_codigo || /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
      });
    }
    if (!carga) {
      lista.push({
        key: "carga",
        label: "Carga",
        width: 110,
        render: (it) => it.carga ? /* @__PURE__ */ React.createElement("span", null, it.carga, it.viagem > 1 ? ` \xB7 ${it.viagem}\xAA` : "") : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
      });
    }
    lista.push(
      {
        key: "dia",
        label: "Dia",
        width: 110,
        render: (it) => it.dia ? /* @__PURE__ */ React.createElement("span", null, (/* @__PURE__ */ new Date(`${it.dia}T00:00:00`)).toLocaleDateString("pt-PT")) : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
      },
      {
        key: "dias",
        label: "H\xE1 quantos dias",
        width: 130,
        // **A idade é a pergunta que traz alguém a este ecrã.** Sem dia não
        // se inventa um: ordena-se para o fim, nunca como se fosse recente.
        sortValue: (it) => it.dias == null ? -1 : it.dias,
        render: (it) => {
          if (it.dias == null) return /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014");
          if (it.dias < 0) {
            const f = -it.dias;
            return /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "daqui a ", f, " dia", f === 1 ? "" : "s");
          }
          return /* @__PURE__ */ React.createElement("b", null, it.dias, " dia", it.dias === 1 ? "" : "s");
        }
      },
      {
        key: "no_phc",
        label: "PHC",
        width: 70,
        render: (it) => it.no_phc ? /* @__PURE__ */ React.createElement("span", { title: "J\xE1 est\xE1 no dossier 82" }, "\u2713") : /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, "\u2014")
      },
      {
        key: "gesto",
        label: "",
        width: 100,
        // **Uma coluna de botões não tem valor por que ordenar.** Sem isto
        // promete «Clique para ordenar» e não mexe uma linha.
        sortable: false,
        render: (it) => /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn ghost sm",
            disabled: !!aLargar,
            title: aLargar && aLargar !== `${it.tarefa}:${it.codigo}` ? "A largar outra palete \u2014 espera que termine." : void 0,
            onClick: () => largar(it)
          },
          "Largar"
        )
      }
    );
    return lista;
  }, [contagemPorCodigo, aLargar, largar, onda, carga]);
  const viewId = onda ? "reservas-de-palete-onda" : carga ? "reservas-de-palete-carga" : "reservas-de-palete";
  return /* @__PURE__ */ React.createElement("div", { className: "cp-reservas" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h cp-zona__h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, titulo), /* @__PURE__ */ React.createElement("span", { className: "sub" }, aCarregar ? "a ler\u2026" : `${itens.length} reserva(s)`), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm cp-zona__h-fim",
      onClick: carregar,
      title: "Voltar a ler"
    },
    "Recarregar"
  )), intro && /* @__PURE__ */ React.createElement("p", { className: "cp-dim cp-moradas-intro" }, intro), erro && /* @__PURE__ */ React.createElement("div", { className: "cp-aviso", role: "status" }, /* @__PURE__ */ React.createElement("span", null, erro), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: carregar }, "Tentar outra vez")), !erro && aCarregar && /* @__PURE__ */ React.createElement("div", { className: "cp-vazio" }, "A ler as reservas\u2026"), !erro && !aCarregar && !itens.length && /* @__PURE__ */ React.createElement("div", { className: "cp-vazio" }, "Nenhuma reserva de palete."), !erro && !aCarregar && itens.length > 0 && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "cargoplanner",
      viewId,
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => `${it.tarefa}:${it.codigo}`,
      initialSort: [{ key: "dias", dir: "desc" }],
      search: {
        fields: ["codigo", "ref", "pessoa", "onda_codigo", "carga"],
        placeholder: "Procurar palete\u2026"
      }
    }
  ));
}
function CpReservasView() {
  const [cobertura, setCobertura] = React.useState(null);
  return /* @__PURE__ */ React.createElement("div", { className: "cp-cfg" }, /* @__PURE__ */ React.createElement(
    window.CpReservasDaLista,
    {
      titulo: "Reservas de palete",
      intro: "As paletes que o picking tem presas, e em nome de quem. A linha de cada palete n\xE3o se desconta do PHC enquanto a tarefa n\xE3o lan\xE7a \u2014 \xE9 o hub que sabe, sozinho, quanto j\xE1 est\xE1 na m\xE3o de algu\xE9m. Ordenada pela mais velha, que \xE9 a que est\xE1 mais perto de ser esquecida.",
      onCobertura: setCobertura
    }
  ), cobertura && /* @__PURE__ */ React.createElement("p", { className: "cp-dim cp-moradas-cobertura" }, "Examinadas ", /* @__PURE__ */ React.createElement("b", null, cobertura.tarefas_com_lotes), " tarefa(s) com paletes picadas.", " ", cobertura.fora_da_janela > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, cobertura.fora_da_janela, " ficaram de fora por terem mais de 14 dias (prazo em que uma reserva caduca). "), cobertura.caducadas_por_carga > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, cobertura.caducadas_por_carga, " ficaram de fora porque a carga j\xE1 terminou. ")));
}
window.CpReservasView = CpReservasView;
window.CpReservasDaLista = CpReservasDaLista;
window.cpContarPorCodigo = cpContarPorCodigo;

// ===== cargoplanner/frontend/cargoplanner_custos.jsx =====
function CpTransportadorasView() {
  const A = window.CargoplannerAPI;
  const VAZIO = {
    nome: "",
    nif: "",
    contacto: "",
    notas: "",
    ordem: 10,
    ativo: true,
    phc_no: null,
    phc_nome: ""
  };
  const [transportadoras, setTransportadoras] = React.useState([]);
  const [tipos, setTipos] = React.useState([]);
  const [selId, setSelId] = React.useState(null);
  const [tarifas, setTarifas] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      const [fs, ts] = await Promise.all([A.transportadoras(), A.tiposTir()]);
      setTransportadoras(fs);
      setTipos(ts);
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel ler as transportadoras."));
    } finally {
      setACarregar(false);
    }
  }, [A]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const carregarTarifas = React.useCallback(async (id) => {
    if (id == null) {
      setTarifas([]);
      return;
    }
    try {
      setTarifas(await A.tarifas({ transportadora: id }));
    } catch (e) {
      window.srToast?.(A.erroMensagem(e, "N\xE3o foi poss\xEDvel ler as tarifas."), "error");
    }
  }, [A]);
  React.useEffect(() => {
    carregarTarifas(selId);
  }, [selId, carregarTarifas]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(VAZIO);
  };
  const guardar = async () => {
    setErro(null);
    try {
      const nome = String(rascunho.nome).trim();
      if (!nome) throw new Error("O nome \xE9 obrigat\xF3rio.");
      const corpo = { ...rascunho, nome, ordem: Number(rascunho.ordem) || 0 };
      if (aEditar) await A.guardarTransportadora(aEditar, corpo);
      else await A.criarTransportadora(corpo);
      cancelar();
      await carregar();
      window.srToast?.(`Transportadora \xAB${nome}\xBB gravada.`, "success");
    } catch (e) {
      setErro(A.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    }
  };
  const apagar = async (f) => {
    const ok = await window.hubConfirm({
      title: "Apagar transportadora",
      message: `Apagar \xAB${f.nome}\xBB? Se tiver tarifas ou ve\xEDculos agarrados o servidor recusa \u2014 nesse caso desativa-a, que o tira das escolhas sem mexer no que j\xE1 l\xE1 est\xE1.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await A.apagarTransportadora(f.id);
      if (selId === f.id) setSelId(null);
      await carregar();
    } catch (e) {
      window.srToast?.(A.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar \u2014 est\xE1 em uso."), "error");
    }
  };
  const colunas = [
    {
      key: "nome",
      label: "Transportadora",
      width: 240,
      minWidth: 160,
      fixed: true,
      render: (f) => /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, f.nome), f.interno && /* @__PURE__ */ React.createElement("span", { className: "cp-dim", title: "A frota do grupo. D\xE1 pre\xE7o \xE0s cargas pr\xF3prias." }, " \xB7 interno"))
    },
    { key: "contacto", label: "Contacto", width: 180 },
    { key: "nif", label: "NIF", width: 110 },
    {
      key: "phc_no",
      label: "Fornecedor PHC",
      width: 190,
      render: (f) => f.phc_no ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, "#", f.phc_no), " ", f.phc_nome || "") : /* @__PURE__ */ React.createElement("span", { className: "cp-alerta" }, "por ligar")
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 80,
      render: (f) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, f.ordem)
    },
    { key: "ativo", label: "Ativo", width: 70, render: (f) => f.ativo ? "\u2713" : "\u2014" },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 210,
      render: (f) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSelId(f.id) }, "Tarifas"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => {
            setAEditar(f.id);
            setRascunho({ ...f });
          }
        },
        "Editar"
      ), !f.interno && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(f) }, "Apagar"))
    }
  ];
  const selecionado = transportadoras.find((f) => f.id === selId) || null;
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "Os pre\xE7os de transporte, por transportadora e por tipo de ve\xEDculo. \xC9 daqui que o quadro de planeamento tira o pre\xE7o previsto de cada carga \u2014 e uma carga sem tarifa mostra \xABsem tarifa\xBB, nunca 0 \u20AC."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "transportadoras",
      columns: colunas,
      data: transportadoras,
      pagination: "none",
      rowKey: (f) => f.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nome,
      onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Contacto", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.contacto,
      onChange: (e) => setRascunho({ ...rascunho, contacto: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "NIF", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nif,
      onChange: (e) => setRascunho({ ...rascunho, nif: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Notas", /* @__PURE__ */ React.createElement(
    "textarea",
    {
      rows: 2,
      value: rascunho.notas,
      onChange: (e) => setRascunho({ ...rascunho, notas: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Fornecedor no PHC", /* @__PURE__ */ React.createElement(
    CpFornecedorPhc,
    {
      valor: rascunho.phc_no,
      nome: rascunho.phc_nome,
      onEscolher: (f) => setRascunho(cpComFornecedorPhc(rascunho, f))
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.ordem,
      onChange: (e) => setRascunho({ ...rascunho, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => setRascunho({ ...rascunho, ativo: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, aEditar && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar }, aEditar ? "Guardar" : "Adicionar"))), selecionado && // key=transportadora.id força a remontagem ao trocar de transportadora: sem
  // ela o componente ficava na mesma posição da árvore e o `rascunhos`
  // (useState) sobrevivia à troca — um €/km escrito para a transportadora A
  // e não gravado aparecia nos campos da transportadora B, e «Guardar»
  // gravava o preço de A na tarifa de B.
  /* @__PURE__ */ React.createElement(
    CpTarifasDaTransportadora,
    {
      key: selecionado.id,
      transportadora: selecionado,
      tipos,
      tarifas,
      onMudou: () => carregarTarifas(selId),
      onFechar: () => setSelId(null)
    }
  ));
}
function cpComFornecedorPhc(rascunho, f) {
  const r = { ...rascunho };
  if (!f) return { ...r, phc_no: null, phc_nome: "" };
  r.phc_no = f.no;
  r.phc_nome = f.nome || "";
  if (!String(r.nome || "").trim()) r.nome = f.nome || "";
  if (!String(r.nif || "").trim()) r.nif = f.nif || "";
  if (!String(r.contacto || "").trim()) {
    r.contacto = [f.contacto, f.telefone, f.telemovel, f.email].map((x) => String(x || "").trim()).filter(Boolean).join(" \xB7 ").slice(0, 120);
  }
  return r;
}
function CpFornecedorPhc({ valor, nome, onEscolher }) {
  const A = window.CargoplannerAPI;
  const [texto, setTexto] = React.useState("");
  const [lista, setLista] = React.useState(null);
  const relogio = React.useRef(null);
  React.useEffect(() => {
    const q = texto.trim();
    if (relogio.current) clearTimeout(relogio.current);
    if (q.length < 2) {
      setLista(null);
      return void 0;
    }
    let vivo = true;
    relogio.current = setTimeout(() => {
      A.fornecedoresPhc(q).then((r) => {
        if (vivo) setLista(r && r.fornecedores || []);
      }).catch(() => {
        if (vivo) setLista(null);
      });
    }, 400);
    return () => {
      vivo = false;
      if (relogio.current) clearTimeout(relogio.current);
    };
  }, [texto, A]);
  return /* @__PURE__ */ React.createElement("div", { className: "cp-fornecedor-phc" }, valor ? /* @__PURE__ */ React.createElement("div", { className: "cp-fornecedor-phc__atual" }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, "#", valor), " ", nome || "\u2014", /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: () => {
        onEscolher(null);
        setTexto("");
      }
    },
    "Desligar"
  )) : /* @__PURE__ */ React.createElement("div", { className: "cp-dim" }, "Sem fornecedor do PHC \u2014 a carga n\xE3o vai ao ERP."), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: texto,
      placeholder: "Procurar no PHC\u2026",
      "aria-label": "Procurar fornecedor no PHC",
      onChange: (e) => setTexto(e.target.value)
    }
  ), lista && lista.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "cp-dim" }, "Nenhum fornecedor ativo com esse nome."), lista && lista.length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "cp-fornecedor-phc__lista" }, lista.map((f) => /* @__PURE__ */ React.createElement("li", { key: f.no }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "cp-fornecedor-phc__op",
      onClick: () => {
        onEscolher(f);
        setTexto("");
        setLista(null);
      }
    },
    /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, "#", f.no),
    " ",
    f.nome,
    /* @__PURE__ */ React.createElement("span", { className: "cp-dim" }, " \xB7 ", f.local || "\u2014", " \xB7 ", f.nif || "s/ NIF", f.telefone || f.email ? ` \xB7 ${f.telefone || f.email}` : "")
  )))));
}
function CpTarifasDaTransportadora({ transportadora, tipos, tarifas, onMudou, onFechar }) {
  const A = window.CargoplannerAPI;
  const porTipo = new Map((tarifas || []).map((t) => [t.tipo_tir, t]));
  const [rascunhos, setRascunhos] = React.useState({});
  const valor = (tipoId, campo, omissao) => {
    const r = rascunhos[tipoId];
    if (r && r[campo] !== void 0) return r[campo];
    const t = porTipo.get(tipoId);
    return t ? t[campo] : omissao;
  };
  const mudar = (tipoId, campo, v) => setRascunhos((s) => ({ ...s, [tipoId]: { ...s[tipoId] || {}, [campo]: v } }));
  const gravar = async (tipo) => {
    const corpo = {
      transportadora: transportadora.id,
      tipo_tir: tipo.id,
      custo_aluguer: valor(tipo.id, "custo_aluguer", 0),
      aluguer_modo: valor(tipo.id, "aluguer_modo", "viagem"),
      custo_km: valor(tipo.id, "custo_km", 0),
      paragens_incluidas: Number(valor(tipo.id, "paragens_incluidas", 1)) || 0,
      custo_paragem: valor(tipo.id, "custo_paragem", 0),
      custo_regresso: valor(tipo.id, "custo_regresso", 0),
      sobretaxa_pct: valor(tipo.id, "sobretaxa_pct", 0),
      // O valor REAL do rascunho, nunca fixo: gravar `true` sempre reativava
      // em silêncio uma tarifa que tinha sido desativada — quem só queria
      // corrigir o €/km via API/admin via a tarifa a voltar a valer.
      ativo: !!valor(tipo.id, "ativo", true)
    };
    try {
      const existente = porTipo.get(tipo.id);
      if (existente) await A.guardarTarifa(existente.id, corpo);
      else await A.criarTarifa(corpo);
      setRascunhos((s) => ({ ...s, [tipo.id]: void 0 }));
      onMudou();
      window.srToast?.(`Tarifa de \xAB${transportadora.nome}\xBB para ${tipo.nome} gravada.`, "success");
    } catch (e) {
      window.srToast?.(A.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar a tarifa."), "error");
    }
  };
  const apagarTarifa = async (tipo) => {
    const t = porTipo.get(tipo.id);
    if (!t) return;
    const ok = await window.hubConfirm({
      title: "Apagar tarifa",
      message: `Apagar a tarifa de \xAB${transportadora.nome}\xBB para ${tipo.nome}? Os valores desaparecem. Se for s\xF3 para deixar de valer por agora sem perder os pre\xE7os, desativa-a em vez disso (coluna \xABAtiva\xBB).`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await A.apagarTarifa(t.id);
      setRascunhos((s) => ({ ...s, [tipo.id]: void 0 }));
      onMudou();
      window.srToast?.(`Tarifa de \xAB${transportadora.nome}\xBB para ${tipo.nome} apagada.`, "success");
    } catch (e) {
      window.srToast?.(A.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar a tarifa."), "error");
    }
  };
  const num = (tipoId, campo, passo, omissao) => /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "cp-select cp-tarifa-num",
      type: "number",
      step: passo,
      min: "0",
      value: valor(tipoId, campo, omissao),
      onChange: (e) => mudar(tipoId, campo, e.target.value)
    }
  );
  return /* @__PURE__ */ React.createElement("div", { className: "cp-tarifas" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Tarifas de ", transportadora.nome), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: onFechar }, "Fechar")), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "\xABPor dia\xBB reparte o aluguer pelas viagens que o cami\xE3o fizer nesse dia; \xABpor viagem\xBB cobra-o inteiro em cada volta. A sobretaxa de combust\xEDvel incide sobre o custo de km. \xABPor zona\xBB cobra o pre\xE7o da zona de destino mais distante, da tabela importada \u2014 a\xED o aluguer, os km e a sobretaxa n\xE3o entram, e o \u20AC/paragem \xE9 a descarga extra."), /* @__PURE__ */ React.createElement("table", { className: "cp-tarifas-grelha" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Tipo de ve\xEDculo"), /* @__PURE__ */ React.createElement("th", null, "Aluguer \u20AC"), /* @__PURE__ */ React.createElement("th", null, "Modo"), /* @__PURE__ */ React.createElement("th", null, "\u20AC/km"), /* @__PURE__ */ React.createElement("th", null, "Paragens incl."), /* @__PURE__ */ React.createElement("th", null, "\u20AC/paragem"), /* @__PURE__ */ React.createElement("th", null, "\u20AC regresso"), /* @__PURE__ */ React.createElement("th", null, "Combust\xEDvel %"), /* @__PURE__ */ React.createElement("th", null, "Ativa"), /* @__PURE__ */ React.createElement("th", null))), /* @__PURE__ */ React.createElement("tbody", null, (tipos || []).filter((t) => t.ativo !== false).map((tipo) => {
    const existente = porTipo.get(tipo.id);
    const classe = !existente ? "is-sem-tarifa" : existente.ativo === false ? "is-inativa" : "";
    return /* @__PURE__ */ React.createElement("tr", { key: tipo.id, className: classe }, /* @__PURE__ */ React.createElement("th", { scope: "row" }, tipo.nome), /* @__PURE__ */ React.createElement("td", null, num(tipo.id, "custo_aluguer", "0.01", 0)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "cp-select",
        value: valor(tipo.id, "aluguer_modo", "viagem"),
        onChange: (e) => mudar(tipo.id, "aluguer_modo", e.target.value)
      },
      /* @__PURE__ */ React.createElement("option", { value: "viagem" }, "Por viagem"),
      /* @__PURE__ */ React.createElement("option", { value: "dia" }, "Por dia"),
      /* @__PURE__ */ React.createElement("option", { value: "zona" }, "Por zona")
    )), /* @__PURE__ */ React.createElement("td", null, num(tipo.id, "custo_km", "0.001", 0)), /* @__PURE__ */ React.createElement("td", null, num(tipo.id, "paragens_incluidas", "1", 1)), /* @__PURE__ */ React.createElement("td", null, num(tipo.id, "custo_paragem", "0.01", 0)), /* @__PURE__ */ React.createElement("td", null, num(tipo.id, "custo_regresso", "0.01", 0)), /* @__PURE__ */ React.createElement("td", null, num(tipo.id, "sobretaxa_pct", "0.01", 0)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: !!valor(tipo.id, "ativo", true),
        onChange: (e) => mudar(tipo.id, "ativo", e.target.checked)
      }
    )), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: () => gravar(tipo) }, existente ? "Guardar" : "Criar"), existente && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagarTarifa(tipo) }, "Apagar")));
  }))), !(tipos || []).length && /* @__PURE__ */ React.createElement("p", { className: "muted" }, "N\xE3o h\xE1 tipos de ve\xEDculo. Cria-os em Defini\xE7\xF5es \u2192 \xABTipos de TIR\xBB."), /* @__PURE__ */ React.createElement(CpResumoDasZonas, { tipos, porTipo }));
}
function CpResumoDasZonas({ tipos, porTipo }) {
  const linhas = (tipos || []).map((tipo) => {
    const t = porTipo.get(tipo.id);
    if (!t || t.aluguer_modo !== "zona") return null;
    const zonas = t.zonas || [];
    const conta = (sit) => zonas.filter((z) => z.situacao === sit).length;
    return {
      tipo,
      total: zonas.length,
      preco: conta("preco"),
      naoServe: conta("nao_serve"),
      aDefinir: conta("a_definir")
    };
  }).filter(Boolean);
  if (!linhas.length) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-nota" }, /* @__PURE__ */ React.createElement("b", null, "Tabela por zona"), /* @__PURE__ */ React.createElement("ul", { className: "cp-zonas-resumo" }, linhas.map((l) => /* @__PURE__ */ React.createElement("li", { key: l.tipo.id }, l.tipo.nome, ": ", l.total ? `${l.total} zona(s) \u2014 ${l.preco} com pre\xE7o, ${l.naoServe} n\xE3o serve, ${l.aDefinir} a definir` : "nenhuma zona importada ainda \u2014 sem tabela, nenhuma carga tem pre\xE7o"))), /* @__PURE__ */ React.createElement("p", { className: "muted" }, "A tabela importa-se com ", /* @__PURE__ */ React.createElement("code", null, "manage.py importar_tarifa_zonas"), "."));
}
window.CpTransportadorasView = CpTransportadorasView;
window.CpComFornecedorPhc = cpComFornecedorPhc;

// ===== cargoplanner/frontend/cargoplanner_crud.jsx =====
function CpCrudCampo({ campo, valor, onChange }) {
  const set = (v) => onChange(campo.chave, v);
  if (campo.tipo === "select") {
    return /* @__PURE__ */ React.createElement("label", null, campo.label, /* @__PURE__ */ React.createElement("select", { value: valor == null ? "" : valor, onChange: (e) => set(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), (campo.opcoes || []).map((o) => /* @__PURE__ */ React.createElement("option", { key: o.id, value: o.id }, o.label))));
  }
  if (campo.tipo === "check") {
    return /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, campo.label, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: !!valor,
        onChange: (e) => set(e.target.checked)
      }
    ));
  }
  const html = campo.tipo === "numero" ? "number" : campo.tipo === "hora" ? "time" : "text";
  return /* @__PURE__ */ React.createElement("label", null, campo.label, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: html,
      step: campo.step,
      value: valor == null ? "" : valor,
      onChange: (e) => set(e.target.value)
    }
  ));
}
function cpCrudArtigo(genero) {
  return genero === "f" ? "Nova" : "Novo";
}
function cpCrudParticipio(genero, radical) {
  return genero === "f" ? `${radical}a` : `${radical}o`;
}
function CpCrudPainel({
  titulo,
  nota,
  viewId,
  campos,
  colunas,
  vazio,
  api,
  nomeSingular,
  genero,
  recarregarSinal,
  onMudou,
  procurar
}) {
  const [itens, setItens] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(vazio);
  const [aEditar, setAEditar] = React.useState(null);
  const [aGuardar, setAGuardar] = React.useState(false);
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    try {
      setItens(await api.listar());
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel ler a lista."));
    } finally {
      setACarregar(false);
    }
  }, [api]);
  React.useEffect(() => {
    carregar();
  }, [carregar, recarregarSinal]);
  const cancelar = () => {
    setAEditar(null);
    setRascunho(vazio);
  };
  const mudar = (chave, v) => setRascunho((r) => ({ ...r, [chave]: v }));
  const guardar = async () => {
    setAGuardar(true);
    setErro(null);
    try {
      const corpo = { ...rascunho };
      campos.forEach((c) => {
        if (c.tipo === "numero") corpo[c.chave] = Number(corpo[c.chave]) || 0;
        if (c.tipo === "select" && corpo[c.chave] === "") corpo[c.chave] = null;
      });
      if (aEditar) await api.guardar(aEditar, corpo);
      else await api.criar(corpo);
      cancelar();
      await carregar();
      if (onMudou) onMudou();
      window.srToast?.(`${nomeSingular} ${cpCrudParticipio(genero, "gravad")}.`, "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    } finally {
      setAGuardar(false);
    }
  };
  const apagar = async (it) => {
    const ok = await window.hubConfirm({
      title: `Apagar ${nomeSingular.toLowerCase()}`,
      message: `Apagar "${it.nome || it.label || it.codigo}"? Se houver coisas a apontar para aqui, o servidor recusa \u2014 desative em vez de apagar.`
    });
    if (!ok) return;
    try {
      await api.apagar(it.id);
      await carregar();
      if (onMudou) onMudou();
      window.srToast?.(`${nomeSingular} ${cpCrudParticipio(genero, "apagad")}.`, "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel apagar."));
    }
  };
  const editar = (it) => {
    setAEditar(it.id);
    setRascunho({ ...vazio, ...it });
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, titulo)), nota && /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, nota), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId,
      columns: colunas({ editar, apagar }),
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id,
      search: procurar
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, aEditar ? `Editar ${nomeSingular.toLowerCase()}` : `${cpCrudArtigo(genero)} ${nomeSingular.toLowerCase()}`)), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, campos.map((c) => /* @__PURE__ */ React.createElement(CpCrudCampo, { key: c.chave, campo: c, valor: rascunho[c.chave], onChange: mudar })), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar, disabled: aGuardar }, aGuardar ? "A guardar\u2026" : aEditar ? "Guardar" : "Adicionar"))));
}
function cpCrudAcoes({ editar, apagar }) {
  return {
    key: "acoes",
    label: "",
    sortable: false,
    width: 160,
    render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => editar(it) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
  };
}
window.CpCrud = { Painel: CpCrudPainel, acoes: cpCrudAcoes };

// ===== cargoplanner/frontend/cargoplanner_ondas_catalogos.jsx =====
const CP_API_ARMAZENS = {
  listar: () => window.CargoplannerAPI.armazens(),
  criar: (d) => window.CargoplannerAPI.criarArmazem(d),
  guardar: (id, d) => window.CargoplannerAPI.guardarArmazem(id, d),
  apagar: (id) => window.CargoplannerAPI.apagarArmazem(id)
};
const CP_API_TURNOS = {
  listar: () => window.CargoplannerAPI.turnos(),
  criar: (d) => window.CargoplannerAPI.criarTurno(d),
  guardar: (id, d) => window.CargoplannerAPI.guardarTurno(id, d),
  apagar: (id) => window.CargoplannerAPI.apagarTurno(id)
};
const CP_API_COMPETENCIAS = {
  listar: () => window.CargoplannerAPI.competencias(),
  criar: (d) => window.CargoplannerAPI.criarCompetencia(d),
  guardar: (id, d) => window.CargoplannerAPI.guardarCompetencia(id, d),
  apagar: (id) => window.CargoplannerAPI.apagarCompetencia(id)
};
function cpMinutos(hhmm) {
  const [h, m] = String(hhmm || "0:0").split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
}
function cpDuracaoTurno(turno) {
  const ini = cpMinutos(turno.inicio);
  const fim = cpMinutos(turno.fim);
  const min = fim >= ini ? fim - ini : 24 * 60 - ini + fim;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return { min, texto: m ? `${h}h${String(m).padStart(2, "0")}` : `${h}h` };
}
function CpTempoPreparacaoPainel() {
  const [valores, setValores] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(null);
  const [aGuardar, setAGuardar] = React.useState(false);
  const [erro, setErro] = React.useState(null);
  const carregar = React.useCallback(() => {
    setErro(null);
    window.CargoplannerAPI.parametrosPreparacao().then((p) => {
      setValores(p);
      setRascunho(p);
    }).catch((e) => setErro(
      window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel ler os par\xE2metros.")
    ));
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const mudar = (campo, v) => setRascunho((r) => ({ ...r, [campo]: v }));
  const tectoEscrito = rascunho && String(rascunho.max_paletes_por_alocar ?? "").trim() !== "";
  const mudou = !!(valores && rascunho && (Number(rascunho.minutos_por_palete) !== valores.minutos_por_palete || Number(rascunho.minutos_minimos_linha) !== valores.minutos_minimos_linha || Number(rascunho.margem_picking_pct) !== valores.margem_picking_pct || Number(rascunho.recuo_max_dias_uteis) !== valores.recuo_max_dias_uteis || tectoEscrito && Number(rascunho.max_paletes_por_alocar) !== valores.max_paletes_por_alocar));
  const guardar = async () => {
    setAGuardar(true);
    setErro(null);
    try {
      const corpo = {
        minutos_por_palete: Number(rascunho.minutos_por_palete) || 0,
        minutos_minimos_linha: Number(rascunho.minutos_minimos_linha) || 0,
        margem_picking_pct: Number(rascunho.margem_picking_pct) || 0,
        recuo_max_dias_uteis: Number(rascunho.recuo_max_dias_uteis) || 0
      };
      if (tectoEscrito) {
        corpo.max_paletes_por_alocar = Number(rascunho.max_paletes_por_alocar) || 0;
      }
      const salvo = await window.CargoplannerAPI.guardarParametrosPreparacao(corpo);
      setValores(salvo);
      setRascunho(salvo);
      window.srToast?.("Tempo de prepara\xE7\xE3o gravado.", "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar."));
    } finally {
      setAGuardar(false);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Tempo de prepara\xE7\xE3o")), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, "A previs\xE3o que aparece no cabe\xE7alho de cada carga e na tarefa de picking gerada para a onda: minutos por palete, mais um m\xEDnimo por LINHA de encomenda \u2014 o custo de abrir/picar uma refer\xEAncia, tenha ela uma palete ou vinte. Ajusta estes n\xFAmeros \xE0 medida que os tempos reais das ondas (previsto vs. real, na aba Ondas) o justificarem."), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, /* @__PURE__ */ React.createElement("strong", null, "A margem do picking"), " \xE9 com quanto se aceita que o picado fique longe do pedido: \xABnormalmente nunca vai a quantidade igual \xE0 encomenda, derivado do processo de fabrico\xBB. \xC9 ela que decide se a carga passa a \xABPreparada\xBB ", /* @__PURE__ */ React.createElement("strong", null, "sozinha"), " quando o armaz\xE9m acaba \u2014 dentro da margem n\xE3o h\xE1 nada a decidir; fora dela, \xE9 preciso algu\xE9m ver a diferen\xE7a. ", /* @__PURE__ */ React.createElement("strong", null, "N\xE3o se aplica \xE0s linhas de quantidade exata"), ", e essas s\xE3o a maioria: a\xED o cliente pediu o n\xFAmero que pediu."), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, /* @__PURE__ */ React.createElement("strong", null, "Preparar com que anteced\xEAncia"), " \xE9 at\xE9 quantos dias \xFAteis antes da sa\xEDda a onda de prepara\xE7\xE3o pode nascer. A busca anda para tr\xE1s a partir da hora de sa\xEDda e p\xE1ra no primeiro par (dia, pessoa) em que o trabalho ainda fica pronto a tempo \u2014 este n\xFAmero \xE9 o trav\xE3o de baixo: quanto mais alto, mais cedo se pode preparar, e mais tempo o material fica picado \xE0 espera a ocupar cais e espa\xE7o.", /* @__PURE__ */ React.createElement("strong", null, " Zero quer dizer \xABs\xF3 no pr\xF3prio dia da carga\xBB"), ", n\xE3o \xABsem limite\xBB."), /* @__PURE__ */ React.createElement("p", { className: "muted cp-cfg-nota" }, /* @__PURE__ */ React.createElement("strong", null, "M\xE1x. paletes picadas por alocar"), " \xE9 o tecto do operador no tablet: chegado a ele, tem de ler a localiza\xE7\xE3o de destino antes de poder picar mais. Conta as paletes de TODAS as tarefas dele, n\xE3o s\xF3 a que est\xE1 \xE0 frente \u2014 quem anda no armaz\xE9m com tr\xEAs paletes em m\xE3os tem tr\xEAs paletes em m\xE3os. Uma palete de que s\xF3 sa\xEDram caixas n\xE3o conta: essa fica na prateleira e n\xE3o tem de ser alocada. ", /* @__PURE__ */ React.createElement("strong", null, "Aqui, zero quer dizer \xABsem limite\xBB"), " \u2014 ao contr\xE1rio do campo acima. E deixar a caixa ", /* @__PURE__ */ React.createElement("strong", null, "vazia"), " n\xE3o grava nada: fica o que estava. Para desligar o tecto escreve-se", /* @__PURE__ */ React.createElement("strong", null, "0"), ", de prop\xF3sito."), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), !rascunho ? /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026") : /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Minutos por palete", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: "0",
      step: "1",
      value: rascunho.minutos_por_palete,
      onChange: (e) => mudar("minutos_por_palete", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "M\xEDnimo por linha (min)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: "0",
      step: "1",
      value: rascunho.minutos_minimos_linha,
      onChange: (e) => mudar("minutos_minimos_linha", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Margem do picking (%)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: "0",
      max: "100",
      step: "1",
      value: rascunho.margem_picking_pct,
      onChange: (e) => mudar("margem_picking_pct", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Preparar at\xE9 (dias \xFAteis antes)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: "0",
      max: "30",
      step: "1",
      value: rascunho.recuo_max_dias_uteis,
      onChange: (e) => mudar("recuo_max_dias_uteis", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "M\xE1x. paletes picadas por alocar", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: "0",
      max: "99",
      step: "1",
      value: rascunho.max_paletes_por_alocar,
      onChange: (e) => mudar("max_paletes_por_alocar", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setRascunho(valores), disabled: !mudou }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar, disabled: aGuardar || !mudou }, aGuardar ? "A guardar\u2026" : "Guardar"))));
}
function CpOndasCatalogosView() {
  const [unidades, setUnidades] = React.useState([]);
  const [sinal, setSinal] = React.useState(0);
  React.useEffect(() => {
    window.CargoplannerAPI.unidades().then(setUnidades).catch(() => setUnidades([]));
  }, [sinal]);
  const colunasArmazem = ({ editar, apagar }) => [
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 110,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, it.codigo)
    },
    { key: "nome", label: "Armaz\xE9m", width: 220, render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome) },
    { key: "unidade_nome", label: "Unidade", width: 220 },
    { key: "ordem", label: "Ordem", width: 80 },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    window.CpCrud.acoes({ editar, apagar })
  ];
  const colunasTurno = ({ editar, apagar }) => [
    { key: "nome", label: "Turno", width: 180, render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome) },
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 110,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, it.codigo)
    },
    {
      key: "inicio",
      label: "Entrada",
      width: 90,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, String(it.inicio || "").slice(0, 5))
    },
    {
      key: "fim",
      label: "Sa\xEDda",
      width: 90,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, String(it.fim || "").slice(0, 5))
    },
    {
      key: "duracao",
      label: "Dura\xE7\xE3o",
      width: 90,
      sortValue: (it) => cpDuracaoTurno(it).min,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, cpDuracaoTurno(it).texto)
    },
    { key: "ordem", label: "Ordem", width: 80 },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    window.CpCrud.acoes({ editar, apagar })
  ];
  const colunasCompetencia = ({ editar, apagar }) => [
    { key: "nome", label: "Compet\xEAncia", width: 220, render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome) },
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 110,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, it.codigo)
    },
    { key: "ordem", label: "Ordem", width: 80 },
    { key: "ativo", label: "Ativo", width: 70, render: (it) => it.ativo ? "\u2713" : "\u2014" },
    window.CpCrud.acoes({ editar, apagar })
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    window.CpCrud.Painel,
    {
      titulo: "Armaz\xE9ns",
      nota: "O s\xEDtio dentro da unidade onde uma pessoa trabalha. \xC9 isto que a ficha diz, e o que a escala pode sobrepor num dia.",
      viewId: "armazens",
      nomeSingular: "Armaz\xE9m",
      api: CP_API_ARMAZENS,
      recarregarSinal: sinal,
      procurar: { fields: ["nome", "codigo", "unidade_nome"], placeholder: "Procurar armaz\xE9m\u2026" },
      vazio: { unidade: "", codigo: "", nome: "", ordem: 0, ativo: true },
      campos: [
        {
          chave: "unidade",
          label: "Unidade",
          tipo: "select",
          opcoes: unidades.map((u) => ({ id: u.id, label: u.nome }))
        },
        { chave: "codigo", label: "C\xF3digo", tipo: "texto" },
        { chave: "nome", label: "Nome", tipo: "texto" },
        { chave: "ordem", label: "Ordem", tipo: "numero" },
        { chave: "ativo", label: "Ativo", tipo: "check" }
      ],
      colunas: colunasArmazem
    }
  ), /* @__PURE__ */ React.createElement(
    window.CpCrud.Painel,
    {
      titulo: "Turnos",
      nota: "Quando se trabalha. O c\xF3digo \xE9 a refer\xEAncia est\xE1vel que os tipos de onda usam \u2014 o nome pode mudar sem partir nada.",
      viewId: "turnos",
      nomeSingular: "Turno",
      api: CP_API_TURNOS,
      procurar: { fields: ["nome", "codigo"], placeholder: "Procurar turno\u2026" },
      vazio: { codigo: "", nome: "", inicio: "", fim: "", ordem: 0, ativo: true },
      campos: [
        { chave: "codigo", label: "C\xF3digo", tipo: "texto" },
        { chave: "nome", label: "Nome", tipo: "texto" },
        { chave: "inicio", label: "Entrada", tipo: "hora" },
        { chave: "fim", label: "Sa\xEDda", tipo: "hora" },
        { chave: "ordem", label: "Ordem", tipo: "numero" },
        { chave: "ativo", label: "Ativo", tipo: "check" }
      ],
      colunas: colunasTurno
    }
  ), /* @__PURE__ */ React.createElement(
    window.CpCrud.Painel,
    {
      titulo: "Compet\xEAncias",
      nota: "O que uma pessoa sabe fazer. Um tipo de onda pode exigi-la.",
      viewId: "competencias",
      nomeSingular: "Compet\xEAncia",
      genero: "f",
      api: CP_API_COMPETENCIAS,
      procurar: { fields: ["nome", "codigo"], placeholder: "Procurar compet\xEAncia\u2026" },
      vazio: { codigo: "", nome: "", ordem: 0, ativo: true },
      campos: [
        { chave: "codigo", label: "C\xF3digo", tipo: "texto" },
        { chave: "nome", label: "Nome", tipo: "texto" },
        { chave: "ordem", label: "Ordem", tipo: "numero" },
        { chave: "ativo", label: "Ativo", tipo: "check" }
      ],
      colunas: colunasCompetencia
    }
  ), /* @__PURE__ */ React.createElement(CpTempoPreparacaoPainel, null));
}
window.CpOndasCatalogosView = CpOndasCatalogosView;

// ===== cargoplanner/frontend/cargoplanner_pessoal.jsx =====
function cpPesISO(d) {
  return d.toISOString().slice(0, 10);
}
function cpPesHojeISO() {
  const d = /* @__PURE__ */ new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}
function cpPesData(iso) {
  const [y, m, d] = String(iso).split("-").map(Number);
  return new Date(Date.UTC(y, (m || 1) - 1, d || 1, 12));
}
function cpPesSegundaFeira(iso) {
  const d = cpPesData(iso);
  const diaSemana = d.getUTCDay();
  const offset = diaSemana === 0 ? -6 : 1 - diaSemana;
  d.setUTCDate(d.getUTCDate() + offset);
  return cpPesISO(d);
}
function cpPesDiasDaSemana(iso) {
  const inicio = cpPesData(iso);
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(inicio);
    d.setUTCDate(d.getUTCDate() + i);
    return cpPesISO(d);
  });
}
function cpPesHora(hhmmss) {
  if (!hhmmss) return null;
  return String(hhmmss).slice(0, 5);
}
function cpPesSomarDias(iso, n) {
  const d = cpPesData(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return cpPesISO(d);
}
function cpPesDiaMes(iso) {
  const [, m, d] = String(iso).split("-");
  return `${d}/${m}`;
}
function cpPesLinhas(resposta) {
  return Array.isArray(resposta) ? resposta : resposta && resposta.results || [];
}
function cpPesNomeUtilizador(u) {
  return u.nome || u.username;
}
function cpPesLabelArmazem(a) {
  return a.unidade_nome ? `${a.nome} \xB7 ${a.unidade_nome}` : a.nome;
}
const CP_PES_DIAS_LABEL = ["Seg", "Ter", "Qua", "Qui", "Sex", "S\xE1b", "Dom"];
const CP_PES_VAZIO = {
  user: "",
  funcao: "",
  turno: "",
  inicio_trabalho: "",
  armazem: "",
  competencias: [],
  pausas: [],
  ativo: true
};
const CP_PES_DIA_VAZIO = {
  estado: "trabalha",
  turno: "",
  inicio: "",
  fim: "",
  armazem: "",
  nota: "",
  indisponibilidades: []
};
function cpPesResumoDia(registo, itHabitual, turnosPorId) {
  if (!registo) return itHabitual.turno_label || "\u2014";
  if (registo.estado === "folga") return "Folga";
  if (registo.estado === "ausente") return "Ausente";
  const partes = [];
  if (registo.turno) {
    const t = turnosPorId[registo.turno];
    partes.push(t ? t.nome : "outro turno");
  }
  const inicio = cpPesHora(registo.inicio);
  const fim = cpPesHora(registo.fim);
  if (inicio || fim) partes.push(`${inicio || "?"}\u2013${fim || "?"}`);
  if (!partes.length) partes.push("Alterado");
  return partes.join(" \xB7 ");
}
const CP_PES_TH = { textAlign: "left", padding: "6px 8px", fontSize: 12, whiteSpace: "nowrap" };
const CP_PES_TD = { padding: "6px 8px", verticalAlign: "top", borderTop: "1px solid var(--border)" };
function CpPausas({ pausas, onChange, titulo }) {
  const linhas = pausas || [];
  const mudar = (i, campo, v) => {
    onChange(linhas.map((p, idx) => idx === i ? { ...p, [campo]: v } : p));
  };
  const remover = (i) => onChange(linhas.filter((_, idx) => idx !== i));
  const acrescentar = () => onChange([...linhas, { inicio: "", fim: "", motivo: "" }]);
  return /* @__PURE__ */ React.createElement("fieldset", { className: "cp-cfg-descargas", style: { flexDirection: "column", alignItems: "stretch", gap: 6, width: "100%" } }, /* @__PURE__ */ React.createElement("legend", null, titulo || "Pausas habituais"), linhas.map((p, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: p.inicio || "",
      onChange: (e) => mudar(i, "inicio", e.target.value)
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: p.fim || "",
      onChange: (e) => mudar(i, "fim", e.target.value)
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "Motivo",
      value: p.motivo || "",
      onChange: (e) => mudar(i, "motivo", e.target.value),
      style: { flex: 1 }
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => remover(i) }, "\u2715"))), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: acrescentar }, "+ Pausa"));
}
function CpPessoalView({ params }) {
  const semanaHoje = React.useMemo(() => cpPesSegundaFeira(cpPesHojeISO()), []);
  const semanaParam = params && params.get && params.get("semana");
  const semana = cpPesSegundaFeira(semanaParam || semanaHoje);
  const dias = React.useMemo(() => cpPesDiasDaSemana(semana), [semana]);
  const irParaSemana = (iso) => window.HubRouter.setParams({ semana: iso });
  const semanaAnterior = () => irParaSemana(cpPesSomarDias(semana, -7));
  const semanaSeguinte = () => irParaSemana(cpPesSomarDias(semana, 7));
  const estaSemana = () => irParaSemana(semanaHoje);
  const [operadores, setOperadores] = React.useState([]);
  const [turnos, setTurnos] = React.useState([]);
  const [armazens, setArmazens] = React.useState([]);
  const [competencias, setCompetencias] = React.useState([]);
  const [utilizadores, setUtilizadores] = React.useState([]);
  const [erroUtilizadores, setErroUtilizadores] = React.useState(null);
  const [escala, setEscala] = React.useState([]);
  const [aCarregar, setACarregar] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const [rascunho, setRascunho] = React.useState(CP_PES_VAZIO);
  const [aEditar, setAEditar] = React.useState(null);
  const [aGuardar, setAGuardar] = React.useState(false);
  const [diaSelecionado, setDiaSelecionado] = React.useState(null);
  const [rascunhoDia, setRascunhoDia] = React.useState(CP_PES_DIA_VAZIO);
  const [erroDia, setErroDia] = React.useState(null);
  const [aGuardarDia, setAGuardarDia] = React.useState(false);
  const mostrarFicha = diaSelecionado === null;
  const carregar = React.useCallback(async () => {
    setACarregar(true);
    setErro(null);
    const dias2 = cpPesDiasDaSemana(semana);
    try {
      const [ops, tur, arm, comp, esc] = await Promise.all([
        window.CargoplannerAPI.operadores(),
        window.CargoplannerAPI.turnos(),
        window.CargoplannerAPI.armazens(),
        window.CargoplannerAPI.competencias(),
        window.CargoplannerAPI.escala(dias2[0], dias2[6])
      ]);
      setOperadores(ops || []);
      setTurnos(tur || []);
      setArmazens(arm || []);
      setCompetencias(comp || []);
      setEscala(esc || []);
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel ler o pessoal das ondas."));
    } finally {
      setACarregar(false);
    }
  }, [semana]);
  const carregarUtilizadores = React.useCallback(async () => {
    setErroUtilizadores(null);
    try {
      const uts = await window.CargoplannerAPI.candidatosOperador();
      setUtilizadores(cpPesLinhas(uts));
    } catch (e) {
      setUtilizadores([]);
      setErroUtilizadores(window.CargoplannerAPI.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel ler os utilizadores para escolher."
      ));
    }
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  React.useEffect(() => {
    carregarUtilizadores();
  }, [carregarUtilizadores]);
  const turnosPorId = React.useMemo(
    () => Object.fromEntries(turnos.map((t) => [t.id, t])),
    [turnos]
  );
  const escalaPorChave = React.useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    (escala || []).forEach((e) => m.set(`${e.operador}|${e.dia}`, e));
    return m;
  }, [escala]);
  const idsComFicha = React.useMemo(
    () => new Set(operadores.filter((o) => o.id !== aEditar).map((o) => o.user)),
    [operadores, aEditar]
  );
  const semFicha = utilizadores.filter((u) => !idsComFicha.has(u.id));
  const novo = () => {
    setAEditar(null);
    setRascunho(CP_PES_VAZIO);
    setErro(null);
    setDiaSelecionado(null);
  };
  const editar = (it) => {
    setAEditar(it.id);
    setErro(null);
    setDiaSelecionado(null);
    setRascunho({
      user: it.user,
      funcao: it.funcao || "",
      turno: it.turno,
      inicio_trabalho: cpPesHora(it.inicio_trabalho) || "",
      armazem: it.armazem || "",
      competencias: it.competencias || [],
      pausas: it.pausas || [],
      ativo: it.ativo
    });
  };
  const mudar = (chave, v) => setRascunho((r) => ({ ...r, [chave]: v }));
  const alternarCompetencia = (id) => {
    const tem = (rascunho.competencias || []).includes(id);
    mudar("competencias", tem ? rascunho.competencias.filter((c) => c !== id) : [...rascunho.competencias || [], id]);
  };
  const guardar = async () => {
    if (!rascunho.user || !rascunho.turno) {
      setErro("Escolha um utilizador e um turno.");
      return;
    }
    setAGuardar(true);
    setErro(null);
    const corpo = {
      user: Number(rascunho.user),
      funcao: rascunho.funcao || "",
      turno: Number(rascunho.turno),
      // Vazio quer dizer "entra com o turno": mandar '' falha a validação
      // do servidor; null diz-lhe para usar a hora do turno.
      inicio_trabalho: rascunho.inicio_trabalho || null,
      armazem: rascunho.armazem ? Number(rascunho.armazem) : null,
      competencias: (rascunho.competencias || []).map(Number),
      pausas: rascunho.pausas || [],
      ativo: !!rascunho.ativo
    };
    try {
      if (aEditar) await window.CargoplannerAPI.guardarOperador(aEditar, corpo);
      else await window.CargoplannerAPI.criarOperador(corpo);
      novo();
      await carregar();
      window.srToast?.("Ficha gravada.", "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar a ficha."));
    } finally {
      setAGuardar(false);
    }
  };
  const desativar = async (it) => {
    const ok = await window.hubConfirm({
      title: "Desativar pessoa",
      message: `Desativar ${it.nome}? Deixa de aparecer para planeamento das ondas; as que j\xE1 fez continuam guardadas. Reative no formul\xE1rio quando for preciso.`
    });
    if (!ok) return;
    try {
      await window.CargoplannerAPI.guardarOperador(it.id, { ...it, ativo: false });
      await carregar();
      window.srToast?.("Pessoa desativada.", "success");
    } catch (e) {
      setErro(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel desativar."));
    }
  };
  const abrirDia = (it, diaIso) => {
    const registo = escalaPorChave.get(`${it.id}|${diaIso}`);
    setRascunhoDia(registo ? {
      estado: registo.estado,
      turno: registo.turno || "",
      inicio: cpPesHora(registo.inicio) || "",
      fim: cpPesHora(registo.fim) || "",
      armazem: registo.armazem || "",
      nota: registo.nota || "",
      indisponibilidades: registo.indisponibilidades || []
    } : CP_PES_DIA_VAZIO);
    setErroDia(null);
    setDiaSelecionado({
      operadorId: it.id,
      operadorNome: it.nome,
      dia: diaIso,
      temExcecao: !!registo
    });
  };
  const fecharDia = () => setDiaSelecionado(null);
  const mudarDia = (chave, v) => setRascunhoDia((r) => ({ ...r, [chave]: v }));
  const guardarDia = async () => {
    if (!diaSelecionado) return;
    setAGuardarDia(true);
    setErroDia(null);
    const corpo = {
      operador: diaSelecionado.operadorId,
      dia: diaSelecionado.dia,
      estado: rascunhoDia.estado,
      // Vazio = vale a ficha: mandar null, não ''.
      turno: rascunhoDia.turno ? Number(rascunhoDia.turno) : null,
      inicio: rascunhoDia.inicio || null,
      fim: rascunhoDia.fim || null,
      armazem: rascunhoDia.armazem ? Number(rascunhoDia.armazem) : null,
      indisponibilidades: rascunhoDia.indisponibilidades || [],
      nota: rascunhoDia.nota || ""
    };
    try {
      await window.CargoplannerAPI.guardarEscala(corpo);
      setDiaSelecionado(null);
      await carregar();
      window.srToast?.("Dia gravado.", "success");
    } catch (e) {
      setErroDia(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar o dia."));
    } finally {
      setAGuardarDia(false);
    }
  };
  const reporDia = async () => {
    if (!diaSelecionado) return;
    const ok = await window.hubConfirm({
      title: "Repor o hor\xE1rio da ficha",
      message: `Remover a exce\xE7\xE3o de ${diaSelecionado.operadorNome} em ${diaSelecionado.dia}? Volta a valer o hor\xE1rio da ficha.`
    });
    if (!ok) return;
    setAGuardarDia(true);
    setErroDia(null);
    try {
      await window.CargoplannerAPI.apagarEscala(diaSelecionado.operadorId, diaSelecionado.dia);
      setDiaSelecionado(null);
      await carregar();
      window.srToast?.("Dia reposto \u2014 volta a valer a ficha.", "success");
    } catch (e) {
      setErroDia(window.CargoplannerAPI.erroMensagem(e, "N\xE3o foi poss\xEDvel repor o dia."));
    } finally {
      setAGuardarDia(false);
    }
  };
  if (aCarregar) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Pessoal das ondas"), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: semanaAnterior }, "\u2039 Semana"), /* @__PURE__ */ React.createElement("span", { className: "muted", style: { whiteSpace: "nowrap" } }, cpPesDiaMes(dias[0]), " \u2013 ", cpPesDiaMes(dias[6])), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: semanaSeguinte }, "Semana \u203A"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: estaSemana, disabled: semana === semanaHoje }, "Esta semana"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: novo }, "+ Pessoa"))), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erro), !operadores.length ? /* @__PURE__ */ React.createElement("div", { className: "alert" }, "Ainda n\xE3o h\xE1 ningu\xE9m nas ondas. Comece por \xAB+ Pessoa\xBB.") : /* @__PURE__ */ React.createElement("div", { style: { overflowX: "auto" } }, /* @__PURE__ */ React.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", { style: CP_PES_TH }, "Pessoa"), /* @__PURE__ */ React.createElement("th", { style: CP_PES_TH }, "Turno / entrada"), dias.map((diaIso, i) => /* @__PURE__ */ React.createElement("th", { key: diaIso, style: CP_PES_TH }, CP_PES_DIAS_LABEL[i], " ", cpPesDiaMes(diaIso))), /* @__PURE__ */ React.createElement("th", { style: CP_PES_TH }))), /* @__PURE__ */ React.createElement("tbody", null, operadores.map((it) => /* @__PURE__ */ React.createElement("tr", { key: it.id, style: it.ativo ? void 0 : { opacity: 0.55 } }, /* @__PURE__ */ React.createElement("td", { style: CP_PES_TD }, /* @__PURE__ */ React.createElement("strong", null, it.nome), /* @__PURE__ */ React.createElement("div", { className: "muted" }, it.armazem_nome || "sem armaz\xE9m"), !it.ativo && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "inativo")), /* @__PURE__ */ React.createElement("td", { style: CP_PES_TD }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, it.turno_label), " \xB7 ", it.inicio_trabalho ? /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, cpPesHora(it.inicio_trabalho)) : /* @__PURE__ */ React.createElement("span", { className: "muted", title: "Entra com o turno" }, "com o turno")), dias.map((diaIso) => {
    const registo = escalaPorChave.get(`${it.id}|${diaIso}`);
    const marcado = !!registo;
    return /* @__PURE__ */ React.createElement("td", { key: diaIso, style: CP_PES_TD }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: `btn ghost sm ${marcado ? "cp-pes__excecao" : "cp-pes__habitual"}`,
        style: marcado ? {
          width: "100%",
          textAlign: "left",
          fontWeight: 700,
          background: "var(--accent-soft)",
          color: "var(--accent-ink)"
        } : {
          width: "100%",
          textAlign: "left",
          fontWeight: 400,
          color: "var(--muted)",
          background: "transparent"
        },
        onClick: () => abrirDia(it, diaIso)
      },
      cpPesResumoDia(registo, it, turnosPorId)
    ));
  }), /* @__PURE__ */ React.createElement("td", { style: CP_PES_TD }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => editar(it) }, "editar"), it.ativo && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => desativar(it) }, "\u2715"))))))), mostrarFicha && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, aEditar ? "Editar pessoa" : "Nova pessoa")), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Utilizador", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: rascunho.user,
      disabled: !!aEditar || !!erroUtilizadores,
      onChange: (e) => mudar("user", e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"),
    semFicha.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, cpPesNomeUtilizador(u)))
  ), !aEditar && erroUtilizadores && /* @__PURE__ */ React.createElement("span", { className: "muted", style: { color: "var(--danger, #c4434b)" } }, erroUtilizadores, " ", /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: carregarUtilizadores }, "Tentar de novo"))), /* @__PURE__ */ React.createElement("label", null, "Fun\xE7\xE3o", /* @__PURE__ */ React.createElement("input", { value: rascunho.funcao, onChange: (e) => mudar("funcao", e.target.value) })), /* @__PURE__ */ React.createElement("label", null, "Turno", /* @__PURE__ */ React.createElement("select", { value: rascunho.turno, onChange: (e) => mudar("turno", e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), turnos.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.nome)))), /* @__PURE__ */ React.createElement("label", null, "Entrada", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: rascunho.inicio_trabalho,
      onChange: (e) => mudar("inicio_trabalho", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Armaz\xE9m", /* @__PURE__ */ React.createElement("select", { value: rascunho.armazem, onChange: (e) => mudar("armazem", e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), armazens.map((a) => /* @__PURE__ */ React.createElement("option", { key: a.id, value: a.id }, cpPesLabelArmazem(a))))), /* @__PURE__ */ React.createElement("fieldset", { className: "cp-cfg-descargas" }, /* @__PURE__ */ React.createElement("legend", null, "Compet\xEAncias"), competencias.map((c) => /* @__PURE__ */ React.createElement("label", { key: c.id, className: "cp-cfg-check" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: (rascunho.competencias || []).includes(c.id),
      onChange: () => alternarCompetencia(c.id)
    }
  ), c.nome))), /* @__PURE__ */ React.createElement("label", { className: "cp-cfg-check" }, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativo,
      onChange: (e) => mudar("ativo", e.target.checked)
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: novo }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar, disabled: aGuardar }, aGuardar ? "A guardar\u2026" : aEditar ? "Guardar" : "Adicionar")), /* @__PURE__ */ React.createElement(CpPausas, { pausas: rascunho.pausas, onChange: (p) => mudar("pausas", p) }))), diaSelecionado && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, diaSelecionado.operadorNome, " \u2014 ", cpPesDiaMes(diaSelecionado.dia))), erroDia && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, erroDia), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-form" }, /* @__PURE__ */ React.createElement("label", null, "Estado", /* @__PURE__ */ React.createElement("select", { value: rascunhoDia.estado, onChange: (e) => mudarDia("estado", e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "trabalha" }, "Trabalha"), /* @__PURE__ */ React.createElement("option", { value: "folga" }, "Folga"), /* @__PURE__ */ React.createElement("option", { value: "ausente" }, "Ausente"))), /* @__PURE__ */ React.createElement("label", null, "Turno", /* @__PURE__ */ React.createElement("select", { value: rascunhoDia.turno, onChange: (e) => mudarDia("turno", e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 (o da ficha)"), turnos.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.nome)))), /* @__PURE__ */ React.createElement("label", null, "Entrada", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: rascunhoDia.inicio,
      onChange: (e) => mudarDia("inicio", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Sa\xEDda", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "time",
      value: rascunhoDia.fim,
      onChange: (e) => mudarDia("fim", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Armaz\xE9m", /* @__PURE__ */ React.createElement("select", { value: rascunhoDia.armazem, onChange: (e) => mudarDia("armazem", e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 (o da ficha)"), armazens.map((a) => /* @__PURE__ */ React.createElement("option", { key: a.id, value: a.id }, cpPesLabelArmazem(a))))), /* @__PURE__ */ React.createElement("label", null, "Nota", /* @__PURE__ */ React.createElement("input", { value: rascunhoDia.nota, onChange: (e) => mudarDia("nota", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "cp-cfg-botoes" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: fecharDia }, "Cancelar"), diaSelecionado.temExcecao && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: reporDia, disabled: aGuardarDia }, "Repor o hor\xE1rio da ficha"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardarDia, disabled: aGuardarDia }, aGuardarDia ? "A guardar\u2026" : "Guardar")), /* @__PURE__ */ React.createElement(
    CpPausas,
    {
      titulo: "Indisponibilidades deste dia",
      pausas: rascunhoDia.indisponibilidades,
      onChange: (p) => mudarDia("indisponibilidades", p)
    }
  ))));
}
window.CpPessoal = { segundaFeira: cpPesSegundaFeira, diasDaSemana: cpPesDiasDaSemana };
window.CpPessoalView = CpPessoalView;

// ===== cargoplanner/frontend/cargoplanner_shell.jsx =====
const OND_DIAS_DE_CARGAS = 14;
function CargoplannerView({ viewVariant, entidade, params, navigate, registerLeaveGuard, me }) {
  const D = window.CargoplannerDados;
  const OD = window.OndasDados;
  const OL = window.OndasLogica;
  const CL = window.CargoplannerLogica;
  const API = window.CargoplannerAPI;
  const [diaBase] = React.useState(() => D.hoje());
  const [ondasBase] = React.useState(() => OD.criar(D.hoje()));
  const [ondas, setOndas] = React.useState([]);
  const ondasRef = React.useRef(ondas);
  ondasRef.current = ondas;
  const cargasRef = React.useRef([]);
  const entregasGuardadas = React.useRef(null);
  const [tarefas, setTarefas] = React.useState([]);
  const [avisos, setAvisos] = React.useState([]);
  const [vistaTl, setVistaTl] = React.useState("dia");
  const [verTodos, setVerTodos] = React.useState(false);
  const [pessoal, setPessoal] = React.useState(null);
  const [ligacaoOndas, setLigacaoOndas] = React.useState(
    { ligada: false, ultimoSinalMs: null }
  );
  const [recargaDia, setRecargaDia] = React.useState(0);
  const ultimoSinal = React.useRef(null);
  const emDia = React.useCallback(() => {
    ultimoSinal.current = Date.now();
  }, []);
  const [eventoOnda, setEventoOnda] = React.useState(
    { n: 0, tipo: null, onda: null, id: null }
  );
  const [erroPessoal, setErroPessoal] = React.useState(null);
  const [catalogos, setCatalogos] = React.useState(null);
  const [erroCatalogos, setErroCatalogos] = React.useState(null);
  const [aCarregarOndas, setACarregarOndas] = React.useState(true);
  const [erroOndas, setErroOndas] = React.useState(null);
  const vista = viewVariant || "cargas";
  const dia = params && params.get && params.get("dia") || diaBase;
  const avisar = React.useCallback((nivel, msg) => setAvisos([{ nivel, msg }]), []);
  React.useEffect(() => {
    let vivo = true;
    Promise.all([API.tiposOnda(), API.motivosOnda(), API.prioridadesOnda()]).then(([tipos, motivos, prioridades]) => {
      if (!vivo) return;
      setCatalogos({
        tipos: OL.vocabDoServidor(tipos).filter((t) => t.ativo),
        motivos: OL.motivosDoServidor(motivos).filter((m) => m.ativo),
        prioridades: OL.vocabDoServidor(prioridades).filter((p) => p.ativo)
      });
      setErroCatalogos(null);
    }).catch((e) => {
      if (!vivo) return;
      setCatalogos({ tipos: [], motivos: [], prioridades: [] });
      setErroCatalogos(API.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel ler os tipos e prioridades das ondas."
      ));
    });
    return () => {
      vivo = false;
    };
  }, [API, OL]);
  React.useEffect(() => {
    let vivo = true;
    setPessoal(null);
    setErroPessoal(null);
    API.operadoresDoDia(dia).then((r) => {
      if (!vivo) return;
      setPessoal(r);
      setErroPessoal(null);
    }).catch((e) => {
      if (!vivo) return;
      setPessoal({ pessoas: [], turnos: [], competencias: [] });
      setErroPessoal(API.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel ler quem est\xE1 ao servi\xE7o."
      ));
    });
    return () => {
      vivo = false;
    };
  }, [dia, API, recargaDia]);
  const lerOndas = React.useCallback((diaALer, cancelado) => {
    setACarregarOndas(true);
    return API.ondas(diaALer).then((lista) => {
      if (cancelado && cancelado()) return null;
      const lidas = OL.tarefasDoServidor(lista);
      setOndas((lista || []).map(OL.ondaDoServidor));
      setTarefas(lidas);
      setErroOndas(null);
      setACarregarOndas(false);
      return lidas;
    }).catch((e) => {
      if (cancelado && cancelado()) return;
      setOndas([]);
      setTarefas([]);
      setErroOndas(API.erroMensagem(e, "N\xE3o foi poss\xEDvel ler as ondas deste dia."));
      setACarregarOndas(false);
      return null;
    });
  }, [API, OL]);
  React.useEffect(() => {
    let morto = false;
    lerOndas(dia, () => morto).then((r) => {
      if (r !== null && !morto) emDia();
    });
    return () => {
      morto = true;
    };
  }, [dia, lerOndas, recargaDia, emDia]);
  const ambito = params && params.get && params.get("ondas") || "todas";
  const ambitoRef = React.useRef(ambito);
  ambitoRef.current = ambito;
  const [ondasFora, setOndasFora] = React.useState([]);
  const ondasForaRef = React.useRef(ondasFora);
  ondasForaRef.current = ondasFora;
  const [erroFora, setErroFora] = React.useState(null);
  React.useEffect(() => {
    let morto = false;
    if (ambito === "dia") {
      setOndasFora([]);
      setErroFora(null);
      return void 0;
    }
    const pedido = ambito === "todas" ? API.ondasSemDono() : API.ondasSemDono(dia, D.diaUtilMais(dia, 2));
    pedido.then((lista) => {
      if (morto) return;
      const fora = (lista || []).map(OL.ondaDoServidor).filter((o) => o.dia !== dia && !o.pessoaId && !OL.foraDeCirculacao(o));
      setOndasFora(fora);
      const ids = new Set(fora.map((o) => o.id));
      setTarefas((prev) => [
        ...prev.filter((t) => !ids.has(t.ondaId)),
        ...OL.tarefasDoServidor((lista || []).filter((o) => ids.has(OL.ondaDoServidor(o).id)))
      ]);
      setErroFora(null);
    }).catch((e) => {
      if (morto) return;
      setOndasFora([]);
      setErroFora(API.erroMensagem(e, "N\xE3o foi poss\xEDvel ler as ondas dos outros dias."));
    });
    return () => {
      morto = true;
    };
  }, [ambito, dia, API, OL, D, recargaDia]);
  const [ondasDeCargas, setOndasDeCargas] = React.useState([]);
  const ondasDeCargasRef = React.useRef(ondasDeCargas);
  ondasDeCargasRef.current = ondasDeCargas;
  React.useEffect(() => {
    let morto = false;
    API.ondasNoPeriodo(D.diaMais(dia, -OND_DIAS_DE_CARGAS), D.diaMais(dia, -1)).then((cru) => {
      if (morto) return;
      const lidas = (cru || []).map(OL.ondaDoServidor).filter((o) => o.cargaId);
      setOndasDeCargas(lidas);
      const ids = new Set(lidas.map((o) => o.id));
      setTarefas((prev) => [
        ...prev.filter((t) => !ids.has(t.ondaId)),
        ...OL.tarefasDoServidor((cru || []).filter((o) => ids.has(OL.ondaDoServidor(o).id)))
      ]);
    }).catch(() => {
      if (!morto) setOndasDeCargas([]);
    });
    return () => {
      morto = true;
    };
  }, [dia, API, OL, D, recargaDia]);
  const [relogioTurno, setRelogioTurno] = React.useState(() => Date.now());
  React.useEffect(() => {
    const t = setInterval(() => setRelogioTurno(Date.now()), 5 * 6e4);
    return () => clearInterval(t);
  }, []);
  React.useEffect(() => {
    const pessoas = pessoal && pessoal.pessoas || [];
    if (!pessoas.length) return;
    const escala = { pessoas };
    const doDia = OL.comTransicoes(ondas, escala, relogioTurno);
    const deCargas = OL.comTransicoes(ondasDeCargas, escala, relogioTurno);
    const mudadas = [...doDia.mudadas, ...deCargas.mudadas];
    if (!mudadas.length) return;
    setOndas(doDia.ondas);
    setOndasDeCargas(deCargas.ondas);
    Promise.all(mudadas.map((o) => API.guardarOnda(
      o.servidorId,
      OL.transicaoParaServidor(o)
    ))).then(() => avisar("aviso", mudadas.length === 1 ? `${mudadas[0].codigo} passou para \xABOndas dispon\xEDveis\xBB: o turno de quem a tinha acabou e ela n\xE3o ficou terminada.` : `${mudadas.length} ondas passaram para \xABOndas dispon\xEDveis\xBB: o turno de quem as tinha acabou e n\xE3o ficaram terminadas.`)).catch((e) => {
      avisar("erro", `${API.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar a transi\xE7\xE3o de turno.")} O dia foi relido do servidor.`);
      lerOndas(dia);
    });
  }, [ondas, ondasDeCargas, pessoal, relogioTurno, OL, API, avisar, lerOndas, dia]);
  const dadosOndas = React.useMemo(() => ({
    ...ondasBase,
    dia,
    tarefas,
    tipos: catalogos && catalogos.tipos || [],
    motivos: catalogos && catalogos.motivos || [],
    prioridades: catalogos && catalogos.prioridades || [],
    pessoas: pessoal && pessoal.pessoas || [],
    turnos: pessoal && pessoal.turnos || [],
    competencias: pessoal && pessoal.competencias || [],
    aCarregarPessoal: pessoal === null,
    erroPessoal,
    aCarregarCatalogos: catalogos === null,
    erroCatalogos,
    aCarregarOndas,
    erroOndas
  }), [
    ondasBase,
    dia,
    tarefas,
    catalogos,
    erroCatalogos,
    pessoal,
    erroPessoal,
    aCarregarOndas,
    erroOndas
  ]);
  const dadosOndasRef = React.useRef(dadosOndas);
  dadosOndasRef.current = dadosOndas;
  const ondasParaCargas = React.useMemo(() => {
    const doDia = new Set((ondas || []).map((o) => o.id));
    return [...ondas || [], ...ondasDeCargas.filter((o) => !doDia.has(o.id))];
  }, [ondas, ondasDeCargas]);
  const pessoaSel = params && params.get && params.get("pessoa") || (dadosOndas.pessoas[0] || {}).id;
  React.useEffect(() => {
    if (!dia) return void 0;
    let ws = null;
    let fechado = false;
    let recuo = 1e3;
    let relogio = null;
    let primeiraLigacao = true;
    let ping = null;
    const aplicar2 = (rDia, rFora, rCargas) => {
      const rs = [rDia, rFora, rCargas];
      if (rs.every((r) => !r || r.acao === "ignorar")) return;
      const aplicado = rs.find((r) => r && r.acao === "aplicar");
      const ondaId = aplicado ? aplicado.onda.id : (rs.find((r) => r && r.acao === "remover") || {}).ondaId;
      if (ondaId == null) return;
      const mexer = (set, r) => {
        if (!r || r.acao === "ignorar") return;
        if (r.acao === "remover") {
          set((prev) => prev.filter((o) => o.id !== ondaId));
          return;
        }
        set((prev) => prev.some((o) => o.id === r.onda.id) ? prev.map((o) => o.id === r.onda.id ? r.onda : o) : [...prev, r.onda]);
      };
      mexer(setOndas, rDia);
      mexer(setOndasFora, rFora);
      mexer(setOndasDeCargas, rCargas);
      if (!aplicado) {
        setTarefas((prev) => prev.filter((t) => t.ondaId !== ondaId));
        return;
      }
      setTarefas((prev) => {
        const antes = {};
        prev.forEach((t) => {
          antes[t.id] = t;
        });
        return [...prev.filter((t) => t.ondaId !== ondaId), ...aplicado.tarefas.map((t) => {
          const a = antes[t.id];
          return a ? { ...t, _inicioReal: a._inicioReal, _acumulado: a._acumulado } : t;
        })];
      });
    };
    const ligar = () => {
      if (fechado) return;
      try {
        ws = API.abrirSocket(dia);
      } catch {
        return;
      }
      ws.onopen = () => {
        recuo = 1e3;
        ultimoSinal.current = Date.now();
        setLigacaoOndas({ ligada: true, ultimoSinalMs: ultimoSinal.current });
        if (CL.deveReler({ primeiraLigacao })) setRecargaDia((n) => n + 1);
        primeiraLigacao = false;
        ping = setInterval(() => {
          try {
            ws.send(JSON.stringify({ type: "ping" }));
          } catch {
          }
        }, 25e3);
      };
      ws.onmessage = (ev) => {
        emDia();
        let msg = null;
        try {
          msg = JSON.parse(ev.data);
        } catch {
          return;
        }
        const minhaLigacao = API.ligacao;
        const eco = { origem: msg.origem, minhaLigacao };
        const querFora = ambitoRef.current !== "dia";
        const janela = {
          desde: D.diaMais(dia, -OND_DIAS_DE_CARGAS),
          ate: D.diaMais(dia, -1)
        };
        if (msg.type === "onda.saved") {
          aplicar2(
            OL.fundirOndaSocket(ondasRef.current, msg.onda, { ...eco, dia }),
            querFora ? OL.fundirOndaFora(ondasForaRef.current, msg.onda, { ...eco, dia }) : null,
            OL.fundirOndaDeCargas(
              ondasDeCargasRef.current,
              msg.onda,
              { ...eco, ...janela }
            )
          );
          setEventoOnda((e) => ({ n: e.n + 1, tipo: "saved", onda: msg.onda, id: null }));
        } else if (msg.type === "onda.deleted") {
          const todas = [
            ...ondasRef.current,
            ...ondasForaRef.current,
            ...ondasDeCargasRef.current
          ];
          const r = OL.removerOndaSocket(todas, msg, eco);
          aplicar2(r, r, r);
          setEventoOnda((e) => ({ n: e.n + 1, tipo: "deleted", onda: null, id: msg.id }));
        }
      };
      ws.onclose = () => {
        if (ping) {
          clearInterval(ping);
          ping = null;
        }
        setLigacaoOndas({ ligada: false, ultimoSinalMs: ultimoSinal.current });
        if (fechado) return;
        relogio = setTimeout(ligar, recuo);
        recuo = Math.min(recuo * 2, 3e4);
      };
    };
    ligar();
    const aoVoltar = () => {
      if (document.visibilityState === "visible") setRecargaDia((n) => n + 1);
    };
    document.addEventListener("visibilitychange", aoVoltar);
    return () => {
      fechado = true;
      document.removeEventListener("visibilitychange", aoVoltar);
      if (relogio) clearTimeout(relogio);
      if (ping) clearInterval(ping);
      if (ws) {
        ws.onclose = null;
        try {
          ws.close();
        } catch {
        }
      }
    };
  }, [dia, API, OL, CL, D, emDia]);
  const minhaFicha = React.useMemo(
    () => CL.fichaPropria(dadosOndas.pessoas, me && me.id),
    [dadosOndas.pessoas, me, CL]
  );
  const operadorSel = params && params.get && params.get("op") || (minhaFicha ? minhaFicha.id : null);
  const tarefaSel = params && params.get && params.get("tarefa") || null;
  const setParam = React.useCallback((patch) => {
    window.HubRouter.setParams(patch);
  }, []);
  const aplicar = React.useCallback((nova) => {
    const mudadas = OL.alteradas(ondas, nova);
    setOndas(nova);
    if (!mudadas.length || !catalogos) return;
    Promise.all(mudadas.map((o) => API.guardarOnda(
      o.servidorId,
      OL.ondaParaServidor(o, catalogos)
    ))).catch((e) => {
      avisar("erro", `${API.erroMensagem(e, "N\xE3o foi poss\xEDvel gravar.")} O dia foi relido do servidor.`);
      lerOndas(dia);
    });
  }, [ondas, catalogos, API, OL, avisar, lerOndas, dia]);
  const atribuir = React.useCallback((ondaId, pessoaId, posicao) => {
    const pessoa = dadosOndas.pessoas.find((p) => p.id === pessoaId);
    if (!pessoa) return;
    let lista = ondas;
    let onda = ondas.find((o) => o.id === ondaId);
    if (!onda) {
      const deFora = ondasFora.find((o) => o.id === ondaId);
      if (!deFora) return;
      onda = { ...deFora, dia };
      lista = [...ondas, onda];
      setOndasFora((prev) => prev.filter((o) => o.id !== ondaId));
    }
    setAvisos(OL.validarAtribuicao(onda, pessoa, lista, { ...dadosOndas, ondas: lista }));
    aplicar(OL.atribuirOnda(lista, ondaId, pessoaId, posicao));
  }, [ondas, ondasFora, dia, dadosOndas, OL, aplicar]);
  const retirar = React.useCallback((ondaId) => {
    setAvisos([]);
    aplicar(OL.retirarOnda(ondas, ondaId));
  }, [ondas, OL, aplicar]);
  const reordenar = React.useCallback((pessoaId, de, para) => {
    aplicar(OL.reordenarOndas(ondas, pessoaId, de, para));
  }, [ondas, OL, aplicar]);
  const preparadorDaCarga = React.useCallback((cargaId, pessoaId, clientePhc) => {
    const alvo = ondas.filter((o) => o.cargaId === cargaId && !OL.foraDeCirculacao(o) && (clientePhc == null || String(o.clientePhc || "") === String(clientePhc)));
    if (!alvo.length) return;
    const pessoa = pessoaId ? (dadosOndas.pessoas || []).find((p) => String(p.id) === String(pessoaId)) : null;
    if (pessoaId && !pessoa) return;
    let lista = ondas;
    for (const onda of alvo) {
      lista = pessoaId ? OL.atribuirOnda(lista, onda.id, pessoaId) : OL.retirarOnda(lista, onda.id);
    }
    setAvisos(pessoa ? alvo.flatMap((o) => OL.validarAtribuicao(
      o,
      pessoa,
      lista,
      { ...dadosOndas, ondas: lista }
    )) : []);
    aplicar(lista);
  }, [ondas, dadosOndas, OL, aplicar]);
  const criar = React.useCallback((f) => {
    if (!catalogos) return;
    const nTarefas = Math.max(1, Number(f.nTarefas) || 1);
    const dur = Math.max(1, Number(f.duracaoMin) || 60);
    const porTarefa = Math.max(1, Math.round(dur / nTarefas));
    const rotulo = ((catalogos.tipos || []).find((t) => t.id === f.tipoId) || {}).label || "Tarefa";
    const novas = Array.from({ length: nTarefas }, () => ({
      tipo: rotulo,
      artigo: f.artigo || "",
      descricao: f.artigo ? `Artigo ${f.artigo}` : "Sem artigo",
      qtd: Number(f.qtd) || 0,
      origem: f.origem || "",
      destino: f.destino || "",
      tempoPrevMin: porTarefa,
      tempoRealMin: null,
      origemTempo: "manual",
      estado: "pendente",
      pausas: []
    }));
    const esboco = {
      tipoId: f.tipoId,
      motivoId: f.motivoId || null,
      prioridadeId: f.prioridadeId,
      dia: f.dia || dia,
      estado: "disponivel",
      pessoaId: null,
      ordem: 0,
      clienteId: f.clienteId || null,
      cargaServidorId: null,
      zona: null,
      qtdTotal: Number(f.qtd) || 0,
      paletes: Number(f.paletes) || 0,
      dependeDe: [],
      observacoes: f.observacoes || "",
      origemCarga: null
    };
    API.criarOnda(OL.ondaParaServidor(esboco, catalogos, novas)).then((criada) => {
      if (criada.dia !== dia) {
        avisar("aviso", `${criada.codigo} foi criada para ${criada.dia}.`);
        return;
      }
      setOndas((prev) => [...prev, OL.ondaDoServidor(criada)]);
      setTarefas((prev) => [...prev, ...OL.tarefasDoServidor([criada])]);
      avisar("aviso", `${criada.codigo} criada \u2014 est\xE1 em \xABOndas dispon\xEDveis\xBB.`);
    }).catch((e) => avisar("erro", API.erroMensagem(e, "N\xE3o foi poss\xEDvel criar a onda.")));
  }, [catalogos, dia, API, OL, avisar]);
  const colocarOndas = React.useCallback(async (novas, carga, dadosCargas) => {
    const agora = Date.now();
    const dias = OL.diasCandidatos(carga, dadosCargas, agora);
    if (!dias.length) return novas;
    const porDia = {};
    for (const d of dias) {
      if (d === dia) {
        porDia[d] = { dados: dadosOndasRef.current, ondas: ondasRef.current };
        continue;
      }
      try {
        const [pes, ond] = await Promise.all([API.operadoresDoDia(d), API.ondas(d)]);
        porDia[d] = {
          dados: {
            ...dadosOndasRef.current,
            dia: d,
            pessoas: pes && pes.pessoas || [],
            turnos: pes && pes.turnos || [],
            competencias: pes && pes.competencias || [],
            tarefas: OL.tarefasDoServidor(ond || [])
          },
          ondas: (ond || []).map(OL.ondaDoServidor)
        };
      } catch (e) {
      }
    }
    return OL.comColocacao(novas, carga, dadosCargas, porDia, agora);
  }, [API, OL, dia]);
  const criarOndas = React.useCallback((novas, carga, dadosCargas, motivo) => {
    const criarPorOrdem = async () => {
      const feitas = [];
      for (const r of novas) {
        const criada = await API.criarOnda(
          OL.ondaParaServidor(r.onda, catalogos, r.tarefas)
        );
        feitas.push(criada);
      }
      return feitas;
    };
    return criarPorOrdem().then((criadas) => {
      const lidas = criadas.map(OL.ondaDoServidor);
      const depois = OL.juntarSemRepetir(ondasRef.current, lidas);
      const houveNovidade = depois !== ondasRef.current;
      setOndas(depois);
      setTarefas((prev) => OL.juntarSemRepetir(prev, OL.tarefasDoServidor(criadas)));
      if (!houveNovidade) return;
      const rotulo = OL.rotuloCarga(lidas[0]) || carga.camiaoId;
      const onde = (novas || []).map((r, i) => {
        const t = OL.textoDaColocacao(r.onda && r.onda.colocacao, carga, dadosCargas);
        if (!t) return null;
        const quem = lidas[i] && lidas[i].codigo || r.onda.codigo || "";
        const resto = t.ressalvas.length ? ` \u2014 ${t.ressalvas.join(" ")}` : "";
        return `${quem}: ${t.texto}${resto}`;
      }).filter(Boolean);
      const msg = motivo === "cliente_novo" ? `${lidas.map((o) => o.codigo).join(", ")} \u2014 a carga ${rotulo} ganhou ${lidas.length === 1 ? "um cliente" : `${lidas.length} clientes`} e a prepara\xE7\xE3o dele ainda n\xE3o estava planeada.` : `${lidas.length} onda(s) de prepara\xE7\xE3o criadas a partir da carga ${rotulo}, uma por cliente.`;
      const completa = onde.length ? `${msg} ${onde.join(" \xB7 ")}` : msg;
      avisar("aviso", completa);
      window.srToast?.(completa, "success");
    }).catch((e) => avisar("erro", API.erroMensagem(
      e,
      "N\xE3o foi poss\xEDvel criar as ondas de prepara\xE7\xE3o."
    )));
  }, [catalogos, API, OL, avisar]);
  const cargaConfirmada = React.useCallback((carga, dadosCargas) => {
    if (!catalogos) return;
    const novas = OL.gerarOndasDeCarga(carga, dadosCargas, ondasParaCargas, dia);
    if (!novas.length) {
      const jaCa = ondasParaCargas.filter((o) => o.cargaId === carga.id);
      if (jaCa.length) {
        const difs = jaCa.flatMap(
          (o) => OL.cargaAlterada(o, carga, dadosCargas) || []
        );
        const rotulo = OL.rotuloCarga(jaCa[0]) || carga.camiaoId;
        avisar(difs.length ? "erro" : "aviso", difs.length ? `As ondas do ${rotulo} foram geradas de uma vers\xE3o anterior \u2014 ${difs.join("; ")}.` : `O ${rotulo} j\xE1 tem ${jaCa.length} onda(s) de prepara\xE7\xE3o.`);
      }
      return;
    }
    if (novas[0].onda.cargaServidorId == null) {
      avisar("erro", "A carga ainda n\xE3o est\xE1 gravada \u2014 confirma outra vez daqui a um instante.");
      return;
    }
    colocarOndas(novas, carga, dadosCargas).then((colocadas) => criarOndas(colocadas, carga, dadosCargas));
  }, [catalogos, ondasParaCargas, dia, OL, avisar, criarOndas, colocarOndas]);
  const cargaMudou = React.useCallback((cargas, dadosCargas) => {
    cargasRef.current = cargas;
    if (!catalogos) return;
    const deCarga = ondasParaCargas.filter((o) => o.origemCarga && o.cargaId && !OL.foraDeCirculacao(o));
    if (!deCarga.length) return;
    const jaTemOndas = new Set(deCarga.map((o) => o.cargaId));
    for (const cargaId of jaTemOndas) {
      const carga = (cargas || []).find((c) => c.id === cargaId);
      if (!carga) continue;
      const novas = OL.gerarOndasDeCarga(carga, dadosCargas, ondasParaCargas, carga.dia);
      if (!novas.length || novas[0].onda.cargaServidorId == null) continue;
      colocarOndas(novas, carga, dadosCargas).then((colocadas) => criarOndas(colocadas, carga, dadosCargas, "cliente_novo"));
    }
    for (const onda of deCarga) {
      const carga = (cargas || []).find((c) => c.id === onda.cargaId);
      if (!carga) continue;
      const largar = OL.largarOndaVazia(onda, tarefas, carga);
      if (largar.largar) {
        setOndas((prev) => prev.filter((o) => o.id !== onda.id));
        setTarefas((prev) => prev.filter((t) => t.ondaId !== onda.id));
        if (onda.servidorId != null) {
          API.apagarOnda(onda.servidorId).then(() => {
            const msg = `${onda.codigo} foi largada: a carga ${OL.rotuloCarga(onda) || carga.camiaoId} ficou sem artigos.`;
            avisar("aviso", msg);
            window.srToast?.(msg, "success");
          }).catch((e) => {
            avisar("erro", `${API.erroMensagem(e, "N\xE3o foi poss\xEDvel largar a onda vazia.")} O dia foi relido do servidor.`);
            lerOndas(dia);
          });
        }
        continue;
      }
      const r = OL.sincronizarOndaComCarga(onda, tarefas, carga, dadosCargas);
      if (!r) continue;
      setOndas((prev) => prev.map((o) => o.id === r.onda.id ? r.onda : o));
      setTarefas((prev) => [...prev.filter((t) => t.ondaId !== r.onda.id), ...r.tarefas]);
      API.guardarOnda(
        onda.servidorId,
        OL.sincronizacaoParaServidor(r.onda, catalogos, r.tarefas)
      ).then((guardada) => {
        const nova = OL.ondaDoServidor(guardada);
        const lidas = OL.tarefasDoServidor([guardada]);
        setOndas((prev) => prev.map((o) => o.id === nova.id ? nova : o));
        setTarefas((prev) => {
          const antes = {};
          prev.forEach((t) => {
            antes[t.id] = t;
          });
          return [...prev.filter((t) => t.ondaId !== nova.id), ...lidas.map((t) => {
            const a = antes[t.id];
            return a ? { ...t, _inicioReal: a._inicioReal, _acumulado: a._acumulado } : t;
          })];
        });
        const msg = `${nova.codigo} acompanhou a carga ${OL.rotuloCarga(nova) || carga.camiaoId}: ${r.difs.join("; ")}.`;
        avisar("aviso", msg);
        window.srToast?.(msg, "success");
      }).catch((e) => {
        avisar("erro", `${API.erroMensagem(e, "N\xE3o foi poss\xEDvel actualizar a onda de prepara\xE7\xE3o.")} O dia foi relido do servidor.`);
        lerOndas(dia);
      });
    }
  }, [
    catalogos,
    ondasParaCargas,
    tarefas,
    API,
    OL,
    avisar,
    lerOndas,
    dia,
    criarOndas,
    colocarOndas
  ]);
  const agoraMin = () => {
    const d = /* @__PURE__ */ new Date();
    return d.getHours() * 60 + d.getMinutes() + d.getSeconds() / 60;
  };
  const FILA_CHAVE = "cp.fila.v1";
  const [fila, setFila] = React.useState(() => {
    try {
      const bruto = window.localStorage.getItem(FILA_CHAVE);
      const lida = bruto ? JSON.parse(bruto) : [];
      return Array.isArray(lida) ? lida : [];
    } catch (e) {
      return [];
    }
  });
  const filaRef = React.useRef(fila);
  filaRef.current = fila;
  const tarefasRef = React.useRef(tarefas);
  tarefasRef.current = tarefas;
  const aEscoarRef = React.useRef(false);
  const cadeadoTarefaRef = React.useRef({});
  const escoarFilaRef = React.useRef(null);
  React.useEffect(() => {
    try {
      window.localStorage.setItem(FILA_CHAVE, JSON.stringify(fila));
    } catch (e) {
    }
  }, [fila]);
  const enfileirar = React.useCallback((tarefaServidorId, tipo, corpo) => {
    if (tarefaServidorId == null) return null;
    const id = `${tipo}-${tarefaServidorId}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    setFila((prev) => OL.filaEntrar(prev, { id, tarefa: tarefaServidorId, tipo, corpo }));
    return id;
  }, [OL]);
  const sairDaFila = React.useCallback((id) => {
    filaRef.current = OL.filaSair(filaRef.current, id);
    setFila((prev) => OL.filaSair(prev, id));
  }, [OL]);
  const filaDespachar = React.useCallback((id, tarefaServidorId, versao) => {
    const calcular = (prev) => {
      let f = OL.filaSair(prev, id);
      if (versao) f = OL.filaVersaoNova(f, tarefaServidorId, versao);
      return f;
    };
    filaRef.current = calcular(filaRef.current);
    setFila(calcular);
  }, [OL]);
  const mexerTarefa = React.useCallback((tarefaId, fn, tipo = "progresso") => {
    const atual = tarefas.find((t) => t.id === tarefaId);
    if (!atual) return Promise.resolve(null);
    const nova = fn(atual);
    setTarefas((prev) => prev.map((t) => t.id === tarefaId ? nova : t));
    if (nova.servidorId == null) return Promise.resolve(nova);
    const corpo = OL.tarefaProgressoParaServidor(nova);
    const pedidoId = enfileirar(nova.servidorId, tipo, corpo);
    if (cadeadoTarefaRef.current[nova.servidorId]) {
      return Promise.resolve(null);
    }
    cadeadoTarefaRef.current[nova.servidorId] = true;
    return API.guardarTarefa(nova.servidorId, corpo).then((r) => {
      const versao = r && r.atualizado_em;
      if (versao) {
        setTarefas((prev) => prev.map((t) => t.id === tarefaId ? { ...t, versao } : t));
      }
      filaDespachar(pedidoId, nova.servidorId, versao);
      delete cadeadoTarefaRef.current[nova.servidorId];
      if (escoarFilaRef.current) escoarFilaRef.current();
      return { ...nova, versao: versao || nova.versao };
    }).catch((e) => {
      if (e && e.status === 409) {
        sairDaFila(pedidoId);
        avisar("erro", "Outra pessoa gravou esta tarefa entretanto. O ecr\xE3 vai recarregar para mostrar o que est\xE1 no servidor.");
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return null;
      }
      if (!API.erroTransitorio(e)) {
        sairDaFila(pedidoId);
        avisar("erro", API.erroMensagem(e, "O servidor recusou esta grava\xE7\xE3o."));
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return null;
      }
      avisar("erro", `${API.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel gravar a tarefa."
      )} Fica guardado no tablet e tenta-se outra vez.`);
      delete cadeadoTarefaRef.current[nova.servidorId];
      return null;
    });
  }, [tarefas, API, OL, avisar, lerOndas, dia, enfileirar, filaDespachar, sairDaFila]);
  const estadoDaOnda = React.useCallback((ondaId, estado) => {
    const onda = ondas.find((o) => o.id === ondaId);
    if (!onda || onda.estado === estado) return;
    if (OL.foraDeCirculacao(onda)) return;
    setOndas((prev) => prev.map((o) => o.id === ondaId ? { ...o, estado } : o));
    if (onda.servidorId == null) return;
    API.guardarOnda(onda.servidorId, { estado }).catch((e) => avisar("erro", API.erroMensagem(
      e,
      "N\xE3o foi poss\xEDvel gravar o estado da onda."
    )));
  }, [ondas, API, avisar, OL]);
  const opIniciar = React.useCallback((tarefaId) => {
    mexerTarefa(tarefaId, (t2) => ({
      ...t2,
      estado: "em_execucao",
      _inicioReal: agoraMin(),
      _acumulado: OL.acumuladoDeTarefa(t2)
    }));
    const t = tarefas.find((x) => x.id === tarefaId);
    if (t) estadoDaOnda(t.ondaId, "em_execucao");
  }, [tarefas, mexerTarefa, estadoDaOnda, OL]);
  const opPausar = React.useCallback((tarefaId, motivoId) => {
    mexerTarefa(tarefaId, (t) => {
      const acumulado = OL.acumuladoAgora(t, agoraMin());
      return {
        ...t,
        estado: "pausada",
        _acumulado: acumulado,
        _inicioReal: null,
        pausas: [...t.pausas || [], {
          motivoId,
          em: (/* @__PURE__ */ new Date()).toISOString(),
          acumuladoMin: Math.round(acumulado)
        }]
      };
    });
  }, [mexerTarefa, OL]);
  const opRetomar = React.useCallback((tarefaId) => {
    mexerTarefa(tarefaId, (t2) => ({
      ...t2,
      estado: "em_execucao",
      _acumulado: OL.acumuladoDeTarefa(t2),
      _inicioReal: agoraMin()
    }));
    const t = tarefas.find((x) => x.id === tarefaId);
    if (t) estadoDaOnda(t.ondaId, "em_execucao");
  }, [tarefas, mexerTarefa, estadoDaOnda, OL]);
  const opReabrir = React.useCallback(async (tarefaId) => {
    const t = tarefas.find((x) => x.id === tarefaId);
    if (!t) return;
    const phc = OL.phcDosLotes(t);
    const ok = await window.hubConfirm({
      title: "Reabrir a tarefa",
      message: phc.lancadas ? `Esta tarefa volta a ficar por fazer. Aten\xE7\xE3o: ${phc.lancadas} palete(s) j\xE1 est\xE3o lan\xE7adas no picking do PHC, e reabrir aqui N\xC3O as tira de l\xE1 \u2014 se for preciso anul\xE1-las, \xE9 no PHC.` : "Esta tarefa volta a ficar por fazer. O tempo medido e as paletes picadas ficam como est\xE3o.",
      confirmLabel: "Reabrir"
    });
    if (!ok) return;
    mexerTarefa(tarefaId, (x) => ({ ...x, estado: "pendente", _inicioReal: null }));
    const onda = ondas.find((o) => o.id === t.ondaId);
    if (onda && onda.estado === "concluida") {
      estadoDaOnda(t.ondaId, onda.pessoaId ? "atribuida" : "disponivel");
    }
  }, [tarefas, ondas, OL, mexerTarefa, estadoDaOnda]);
  const opArquivar = React.useCallback(async (ondaId) => {
    const onda = [...ondas, ...ondasFora].find((o) => o.id === ondaId);
    if (!onda || OL.foraDeCirculacao(onda)) return;
    if (onda.servidorId == null) return;
    const todasAsOndas = [...ondas, ...ondasFora, ...ondasDeCargas];
    const cons = OL.consequenciasDeArquivar(
      onda,
      dadosOndas,
      cargasRef.current,
      todasAsOndas
    );
    const partes = [];
    if (cons.tarefas > 0) {
      partes.push(cons.tarefas === 1 ? "1 tarefa por fazer vai ser cancelada." : `${cons.tarefas} tarefas por fazer v\xE3o ser canceladas.`);
    }
    if (cons.emExecucao > 0) {
      partes.push(cons.emExecucao === 1 ? cons.tarefas === 1 ? "Essa tarefa est\xE1 a decorrer AGORA \u2014 algu\xE9m tem as m\xE3os nela neste momento." : "Uma delas est\xE1 a decorrer AGORA \u2014 algu\xE9m tem as m\xE3os nela neste momento." : `${cons.emExecucao} delas est\xE3o a decorrer AGORA \u2014 algu\xE9m tem as m\xE3os nelas neste momento.`);
    }
    partes.push("O tempo j\xE1 medido, os lotes picados e as pausas ficam como est\xE3o.");
    if (cons.phcLancadas > 0) {
      partes.push("Reabrir ou remontar N\xC3O tira do PHC o que j\xE1 l\xE1 est\xE1: " + (cons.phcLancadas === 1 ? "1 palete continua no dossier 82." : `${cons.phcLancadas} paletes continuam no dossier 82.`));
    }
    if (cons.carga === "sem_carga") {
      partes.push("Esta onda n\xE3o est\xE1 ligada a nenhuma carga.");
    } else if (cons.carga === "desconhecida") {
      partes.push("A carga desta onda n\xE3o est\xE1 neste ecr\xE3 \u2014 n\xE3o se sabe se ela vai recuar a \xABEm planeamento\xBB.");
    } else if (cons.carga === "ja_em_planeamento") {
    } else if (cons.carga === "nao_recua_estado") {
      const carga = cargasRef.current.find((c) => c.id === onda.cargaId);
      const estadoLabel = carga && (CL.indexar(D.ESTADOS)[carga.estado] || {}).label;
      partes.push(`O ${cons.cargaCodigo} n\xE3o recua a \xABEm planeamento\xBB` + (estadoLabel ? ` \u2014 est\xE1 ${estadoLabel.toLowerCase()}.` : "."));
    } else if (cons.carga === "nao_recua_outra_onda") {
      partes.push(`O ${cons.cargaCodigo} n\xE3o recua a \xABEm planeamento\xBB \u2014 ainda h\xE1 outra onda desta carga por fazer.`);
    } else if (cons.carga === "recua") {
      partes.push(`O ${cons.cargaCodigo} volta a \xABEm planeamento\xBB.`);
    }
    const ok = await window.hubConfirm({
      title: "Arquivar a onda",
      message: partes.join(" "),
      confirmLabel: "Arquivar",
      // Arquivar é arrumação legítima, não destruição — nada se apaga.
      danger: false
    });
    if (!ok) return;
    try {
      const r = await API.arquivarOnda(onda.servidorId);
      const ondaNova = OL.ondaDoServidor(r);
      const mexer = (set) => set((prev) => prev.some((o) => o.id === ondaNova.id) ? prev.map((o) => o.id === ondaNova.id ? ondaNova : o) : prev);
      mexer(setOndas);
      mexer(setOndasFora);
      mexer(setOndasDeCargas);
      const tarefasNovas = OL.tarefasDoServidor([r]);
      setTarefas((prev) => [...prev.filter((t) => t.ondaId !== ondaNova.id), ...tarefasNovas]);
      if (r.carga_recuou) {
        avisar("aviso", `${cons.cargaCodigo || "A carga"} voltou a \xABEm planeamento\xBB.`);
      } else if (r.carga_estado != null) {
        const estadoLabel = (CL.indexar(D.ESTADOS)[r.carga_estado] || {}).label;
        avisar("aviso", `Onda arquivada. ${cons.cargaCodigo || "A carga"} n\xE3o recuou` + (estadoLabel ? ` \u2014 est\xE1 ${estadoLabel.toLowerCase()}.` : "."));
      } else {
        avisar("aviso", "Onda arquivada.");
      }
    } catch (e) {
      avisar("erro", API.erroMensagem(e, "N\xE3o foi poss\xEDvel arquivar a onda."));
    }
  }, [ondas, ondasFora, ondasDeCargas, dadosOndas, OL, CL, D, API, avisar]);
  const opLancarPendentes = React.useCallback((tarefa) => {
    if (!tarefa || tarefa.servidorId == null) return Promise.resolve(null);
    return API.lancarPickingNoPhc(tarefa.servidorId, {}).then((r) => {
      setTarefas((prev) => prev.map((t) => {
        if (t.id !== tarefa.id) return t;
        const por = new Map((r.lancadas || []).map((x) => [x.codigo, x]));
        return { ...t, lotes: (t.lotes || []).map((l) => por.has(l.codigo) ? {
          ...l,
          phcBistamp: por.get(l.codigo).bistamp,
          phcObrano: por.get(l.codigo).obrano,
          phcErro: null
        } : l) };
      }));
      const falhou = (r.falhadas || []).length + (r.recusadas || []).length;
      if (falhou) {
        avisar("erro", `${falhou} palete(s) n\xE3o entraram no picking do PHC. Ficam por lan\xE7ar e o servidor volta a tentar.`);
      }
      return r;
    }).catch((e) => {
      avisar("erro", `${API.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel lan\xE7ar o picking no PHC."
      )} As paletes ficam por lan\xE7ar \u2014 o servidor volta a tentar.`);
      return null;
    });
  }, [API, avisar]);
  const opConcluir = React.useCallback((tarefaId) => {
    mexerTarefa(tarefaId, (t) => {
      const decorrido = OL.acumuladoAgora(t, agoraMin());
      const medido = decorrido > 0 ? Math.max(1, Math.round(decorrido)) : null;
      return {
        ...t,
        estado: "concluida",
        _inicioReal: null,
        tempoRealMin: medido != null ? medido : t.tempoRealMin != null ? t.tempoRealMin : null
      };
    }, "conclusao").then((nova) => {
      if (nova) opLancarPendentes(nova);
    });
  }, [mexerTarefa, OL, opLancarPendentes]);
  React.useEffect(() => {
    ondas.forEach((o) => {
      const ts = tarefas.filter((t) => t.ondaId === o.id);
      if (ts.length && o.estado !== "concluida" && ts.every((t) => t.estado === "concluida")) {
        estadoDaOnda(o.id, "concluida");
      }
    });
  }, [tarefas, ondas, estadoDaOnda]);
  const escolherTarefa = React.useCallback((id) => {
    const { emCursoOutra } = OL.trabalhoDoOperador(
      operadorSel,
      ondas,
      dadosOndas,
      id
    );
    if (emCursoOutra) opPausar(emCursoOutra.tarefa.id, OL.MOTIVO_TROCA);
    setParam({ tarefa: id || null });
  }, [OL, operadorSel, ondas, dadosOndas, opPausar, setParam]);
  const opPicarLote = React.useCallback((tarefaId, lote, arrancar) => {
    const aceite = { recusado: false, mensagem: null };
    const atual = tarefas.find((t) => t.id === tarefaId);
    if (!atual || !lote || !lote.codigo) return Promise.resolve(aceite);
    if ((atual.lotes || []).some((l) => l.codigo === lote.codigo)) return Promise.resolve(aceite);
    const comeca = arrancar === "iniciar" ? atual.estado === "pendente" : arrancar === "retomar" ? atual.estado === "pausada" : false;
    const semRelogio = atual.estado === "em_execucao" && atual._inicioReal == null;
    const agora = agoraMin();
    const relogio = comeca || semRelogio ? {
      _inicioReal: agora,
      _acumulado: OL.acumuladoDeTarefa(atual)
    } : {};
    const comRelogio = { ...atual, ...relogio };
    const nova = {
      ...comRelogio,
      lotes: [...atual.lotes || [], {
        ...lote,
        acumuladoMin: OL.arredondarAcumulado(OL.acumuladoAgora(comRelogio, agora))
      }],
      ...comeca ? { estado: "em_execucao" } : {}
    };
    setTarefas((prev) => prev.map((t) => t.id === tarefaId ? nova : t));
    if (comeca) estadoDaOnda(atual.ondaId, "em_execucao");
    if (nova.servidorId == null) return Promise.resolve(aceite);
    const corpo = OL.lotesParaServidor(nova);
    if (comeca) corpo.estado = "em_execucao";
    const pedidoId = enfileirar(nova.servidorId, "lotes", corpo);
    if (cadeadoTarefaRef.current[nova.servidorId]) return Promise.resolve(aceite);
    cadeadoTarefaRef.current[nova.servidorId] = true;
    return API.guardarTarefa(nova.servidorId, corpo).then((r) => {
      const versao = r && r.atualizado_em;
      if (versao) {
        setTarefas((prev) => prev.map((t) => t.id === tarefaId ? { ...t, versao } : t));
      }
      filaDespachar(pedidoId, nova.servidorId, versao);
      delete cadeadoTarefaRef.current[nova.servidorId];
      if (escoarFilaRef.current) escoarFilaRef.current();
      return aceite;
    }).catch((e) => {
      const conflito = "Outra pessoa gravou esta tarefa entretanto. O ecr\xE3 vai recarregar para mostrar o que est\xE1 no servidor.";
      if (e && e.status === 409) {
        sairDaFila(pedidoId);
        avisar("erro", conflito);
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return { recusado: true, mensagem: conflito };
      }
      if (!API.erroTransitorio(e)) {
        const mensagem = API.erroMensagem(
          e,
          "O servidor recusou esta palete. N\xE3o ficou picada."
        );
        sairDaFila(pedidoId);
        avisar("erro", mensagem);
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return { recusado: true, mensagem };
      }
      avisar("erro", `${API.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel guardar o lote picado."
      )} Fica guardado no tablet e tenta-se outra vez.`);
      delete cadeadoTarefaRef.current[nova.servidorId];
      return aceite;
    });
  }, [tarefas, API, OL, avisar, estadoDaOnda, lerOndas, dia, enfileirar, filaDespachar, sairDaFila]);
  const opAlocarLotes = React.useCallback((tarefaId, codigos, destino) => {
    const aceite = { recusado: false, mensagem: null };
    const atual = tarefas.find((t) => t.id === tarefaId);
    if (!atual || !(codigos || []).length) return Promise.resolve(aceite);
    const quais = new Set(codigos);
    const lotes = (atual.lotes || []).map((l) => quais.has(l.codigo) ? { ...l, destino } : l);
    const nova = { ...atual, lotes };
    setTarefas((prev) => prev.map((t) => t.id === tarefaId ? nova : t));
    if (nova.servidorId == null) return Promise.resolve(aceite);
    const marcar = (t) => ({ ...t, lotes: (t.lotes || []).map(
      (l) => quais.has(l.codigo) ? { ...l, destino } : l
    ) });
    const gravar = (alvo, pedidoId2) => {
      if (cadeadoTarefaRef.current[alvo.servidorId]) {
        return Promise.resolve();
      }
      cadeadoTarefaRef.current[alvo.servidorId] = true;
      return API.guardarTarefa(
        alvo.servidorId,
        OL.lotesParaServidor(alvo)
      ).then((r) => {
        const versao = r && r.atualizado_em;
        if (versao) {
          setTarefas((prev) => prev.map((t) => t.id === tarefaId ? { ...t, versao } : t));
        }
        filaDespachar(pedidoId2, alvo.servidorId, versao);
        delete cadeadoTarefaRef.current[alvo.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
      }).catch((e) => {
        delete cadeadoTarefaRef.current[alvo.servidorId];
        throw e;
      });
    };
    const pedidoId = enfileirar(nova.servidorId, "alocacao", OL.lotesParaServidor(nova));
    let pedidoVivo = pedidoId;
    return gravar(nova, pedidoId).then(() => aceite).catch((e) => {
      if (e && e.status === 409) {
        return lerOndas(dia).then((lidas) => {
          const fresca = (lidas || []).find((t) => t.id === tarefaId);
          if (!fresca || fresca.servidorId == null) throw e;
          const comDestino = marcar(fresca);
          setTarefas((prev) => prev.map((t) => t.id === tarefaId ? comDestino : t));
          const pedidoId2 = enfileirar(
            comDestino.servidorId,
            "alocacao",
            OL.lotesParaServidor(comDestino)
          );
          pedidoVivo = pedidoId2;
          return gravar(comDestino, pedidoId2).then(() => aceite);
        });
      }
      throw e;
    }).catch((e) => {
      if (!API.erroTransitorio(e)) {
        const mensagem = `${API.erroMensagem(
          e,
          "O servidor recusou registar esta aloca\xE7\xE3o."
        )} A aloca\xE7\xE3o est\xE1 no PHC, mas o hub n\xE3o a registou \u2014 e n\xE3o se volta a tentar.`;
        sairDaFila(pedidoVivo);
        avisar("erro", mensagem);
        if (escoarFilaRef.current) escoarFilaRef.current();
        return { recusado: true, mensagem };
      }
      avisar("erro", `${API.erroMensagem(
        e,
        "A aloca\xE7\xE3o foi escrita no PHC, mas o hub n\xE3o a registou."
      )} Fica guardado no tablet e tenta-se outra vez.`);
      return aceite;
    });
  }, [tarefas, API, OL, avisar, lerOndas, dia, enfileirar, filaDespachar, sairDaFila]);
  const opTirarLote = React.useCallback((tarefaId, codigo) => {
    const aceite = { recusado: false, mensagem: null };
    const atual = tarefas.find((t) => t.id === tarefaId);
    if (!atual) return Promise.resolve(aceite);
    const lote = (atual.lotes || []).find((l) => l.codigo === codigo);
    if (lote && lote.phcBistamp) {
      avisar("erro", `A palete ${codigo} j\xE1 foi lan\xE7ada no picking do PHC (dossier ${lote.phcObrano || "82"}) e n\xE3o se desmarca aqui.`);
      return Promise.resolve(aceite);
    }
    const nova = {
      ...atual,
      lotes: (atual.lotes || []).filter((l) => l.codigo !== codigo)
    };
    setTarefas((prev) => prev.map((t) => t.id === tarefaId ? nova : t));
    if (nova.servidorId == null) return Promise.resolve(aceite);
    const corpo = OL.lotesParaServidor(nova);
    const pedidoId = enfileirar(nova.servidorId, "lotes", corpo);
    if (cadeadoTarefaRef.current[nova.servidorId]) return Promise.resolve(aceite);
    cadeadoTarefaRef.current[nova.servidorId] = true;
    return API.guardarTarefa(nova.servidorId, corpo).then((r) => {
      const versao = r && r.atualizado_em;
      if (versao) {
        setTarefas((prev) => prev.map((t) => t.id === tarefaId ? { ...t, versao } : t));
      }
      filaDespachar(pedidoId, nova.servidorId, versao);
      delete cadeadoTarefaRef.current[nova.servidorId];
      if (escoarFilaRef.current) escoarFilaRef.current();
      return aceite;
    }).catch((e) => {
      const conflito = "Outra pessoa gravou esta tarefa entretanto. O ecr\xE3 vai recarregar para mostrar o que est\xE1 no servidor.";
      if (e && e.status === 409) {
        sairDaFila(pedidoId);
        avisar("erro", conflito);
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return { recusado: true, mensagem: conflito };
      }
      if (!API.erroTransitorio(e)) {
        const mensagem = API.erroMensagem(
          e,
          "O servidor recusou tirar esta palete. Ela continua picada."
        );
        sairDaFila(pedidoId);
        avisar("erro", mensagem);
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return { recusado: true, mensagem };
      }
      avisar("erro", `${API.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel tirar o lote."
      )} Fica guardado no tablet e tenta-se outra vez.`);
      delete cadeadoTarefaRef.current[nova.servidorId];
      return aceite;
    });
  }, [tarefas, API, OL, avisar, lerOndas, dia, enfileirar, filaDespachar, sairDaFila]);
  const opQtdDoLote = React.useCallback((tarefaId, codigo, qtd) => {
    const aceite = { recusado: false, mensagem: null };
    const atual = tarefas.find((t) => t.id === tarefaId);
    if (!atual) return Promise.resolve(aceite);
    const lote = (atual.lotes || []).find((l) => l.codigo === codigo);
    if (!lote) return Promise.resolve(aceite);
    if (lote.phcBistamp) {
      avisar("erro", `A palete ${codigo} j\xE1 foi lan\xE7ada no picking do PHC (dossier ${lote.phcObrano || "82"}) \u2014 a quantidade dela corrige-se l\xE1.`);
      return Promise.resolve(aceite);
    }
    if (Number(lote.qtd) === Number(qtd)) return Promise.resolve(aceite);
    const nova = {
      ...atual,
      lotes: (atual.lotes || []).map(
        (l) => l.codigo === codigo ? { ...l, qtd } : l
      )
    };
    setTarefas((prev) => prev.map((t) => t.id === tarefaId ? nova : t));
    if (nova.servidorId == null) return Promise.resolve(aceite);
    const corpo = OL.lotesParaServidor(nova);
    const pedidoId = enfileirar(nova.servidorId, "lotes", corpo);
    if (cadeadoTarefaRef.current[nova.servidorId]) return Promise.resolve(aceite);
    cadeadoTarefaRef.current[nova.servidorId] = true;
    return API.guardarTarefa(nova.servidorId, corpo).then((r) => {
      const versao = r && r.atualizado_em;
      if (versao) {
        setTarefas((prev) => prev.map((t) => t.id === tarefaId ? { ...t, versao } : t));
      }
      filaDespachar(pedidoId, nova.servidorId, versao);
      delete cadeadoTarefaRef.current[nova.servidorId];
      if (escoarFilaRef.current) escoarFilaRef.current();
      return aceite;
    }).catch((e) => {
      const conflito = "Outra pessoa gravou esta tarefa entretanto. O ecr\xE3 vai recarregar para mostrar o que est\xE1 no servidor.";
      if (e && e.status === 409) {
        sairDaFila(pedidoId);
        avisar("erro", conflito);
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return { recusado: true, mensagem: conflito };
      }
      if (!API.erroTransitorio(e)) {
        const mensagem = API.erroMensagem(
          e,
          "O servidor recusou esta quantidade. Ficou a que j\xE1 estava gravada."
        );
        sairDaFila(pedidoId);
        avisar("erro", mensagem);
        lerOndas(dia);
        delete cadeadoTarefaRef.current[nova.servidorId];
        if (escoarFilaRef.current) escoarFilaRef.current();
        return { recusado: true, mensagem };
      }
      avisar("erro", `${API.erroMensagem(
        e,
        "N\xE3o foi poss\xEDvel corrigir a quantidade."
      )} Fica guardado no tablet e tenta-se outra vez.`);
      delete cadeadoTarefaRef.current[nova.servidorId];
      return aceite;
    });
  }, [tarefas, API, OL, avisar, lerOndas, dia, enfileirar, filaDespachar, sairDaFila]);
  const opProblema = React.useCallback((tarefaId, motivoId, nota) => {
    mexerTarefa(tarefaId, (t) => ({
      ...t,
      estado: "bloqueada",
      pausas: [...t.pausas || [], { motivoId, nota, em: (/* @__PURE__ */ new Date()).toISOString(), problema: true }]
    }));
    const mot = (ondasBase.motivosPausa.find((m) => m.id === motivoId) || {}).label || motivoId;
    avisar("erro", `Problema reportado: ${mot}${nota ? ` \u2014 ${nota}` : ""}.`);
  }, [ondasBase, mexerTarefa, avisar]);
  const escoarFila = React.useCallback(() => {
    if (aEscoarRef.current) return;
    aEscoarRef.current = true;
    const seguinte = () => {
      const atual = filaRef.current;
      if (!atual.length) {
        aEscoarRef.current = false;
        return;
      }
      const pedido = atual.find((p) => !cadeadoTarefaRef.current[p.tarefa]);
      if (!pedido) {
        aEscoarRef.current = false;
        return;
      }
      cadeadoTarefaRef.current[pedido.tarefa] = true;
      API.guardarTarefa(pedido.tarefa, pedido.corpo).then((r) => {
        const versao = r && r.atualizado_em;
        filaDespachar(pedido.id, pedido.tarefa, versao);
        if (versao) {
          setTarefas((prev) => prev.map((t) => t.servidorId === pedido.tarefa ? { ...t, versao } : t));
        }
        if (pedido.tipo === "conclusao") {
          const t = tarefasRef.current.find((x) => x.servidorId === pedido.tarefa);
          opLancarPendentes(t ? { ...t, versao: versao || t.versao } : { servidorId: pedido.tarefa, versao });
        }
        delete cadeadoTarefaRef.current[pedido.tarefa];
        seguinte();
      }).catch((e) => {
        delete cadeadoTarefaRef.current[pedido.tarefa];
        if (e && e.status === 409) {
          sairDaFila(pedido.id);
          avisar("erro", `Uma tarefa que estava por enviar (${pedido.tipo}) foi gravada entretanto por outra pessoa. O ecr\xE3 vai recarregar.`);
          lerOndas(dia);
          seguinte();
          return;
        }
        aEscoarRef.current = false;
      });
    };
    seguinte();
  }, [API, avisar, lerOndas, dia, filaDespachar, opLancarPendentes, sairDaFila]);
  escoarFilaRef.current = escoarFila;
  React.useEffect(() => {
    escoarFila();
    window.addEventListener("online", escoarFila);
    const aoFicarVisivel = () => {
      if (document.visibilityState === "visible") escoarFila();
    };
    document.addEventListener("visibilitychange", aoFicarVisivel);
    return () => {
      window.removeEventListener("online", escoarFila);
      document.removeEventListener("visibilitychange", aoFicarVisivel);
    };
  }, [escoarFila]);
  if (vista === "ondas") {
    return /* @__PURE__ */ React.createElement(
      window.OndasView,
      {
        dados: dadosOndas,
        ondas,
        dia,
        pessoaSel,
        vistaTl,
        verTodos,
        avisos,
        ondasFora,
        erroFora,
        ambito,
        onAmbito: (v) => setParam({ ondas: v === "todas" ? null : v }),
        onDia: (d) => setParam({ dia: d }),
        onSelecionarPessoa: (id) => setParam({ pessoa: id }),
        onAtribuir: atribuir,
        onRetirar: retirar,
        onReordenar: reordenar,
        onCriar: criar,
        onVistaTl: setVistaTl,
        onVerTodos: setVerTodos,
        onFecharAviso: () => setAvisos([]),
        ligacoes: [ligacaoOndas],
        onReabrirTarefa: opReabrir,
        onArquivarOnda: opArquivar
      }
    );
  }
  if (vista === "desempenho") {
    return /* @__PURE__ */ React.createElement(
      window.OndDesempenho,
      {
        dados: dadosOndas,
        dia,
        evento: eventoOnda,
        ligacoes: [ligacaoOndas]
      }
    );
  }
  if (vista === "operador") {
    if (dadosOndas.aCarregarPessoal) {
      return /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 12 } }, "A ler quem est\xE1 ao servi\xE7o\u2026");
    }
    if (dadosOndas.erroPessoal) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert error", style: { margin: 12 } }, dadosOndas.erroPessoal);
    }
    if (!dadosOndas.pessoas.length) {
      return /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 12 } }, "Ningu\xE9m ao servi\xE7o neste dia. Em ", /* @__PURE__ */ React.createElement("b", null, "Defini\xE7\xF5es \u2192 Pessoal das ondas"), " ", "cria-se a ficha de quem trabalha e marcam-se as folgas \u2014 \xE9 o mesmo ecr\xE3.");
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, fila.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "ond-op-fila-aviso", style: {
      position: "fixed",
      top: 8,
      right: 8,
      zIndex: 50,
      background: "#fff3cd",
      color: "#7a5b00",
      border: "1px solid #e0c36a",
      borderRadius: 6,
      padding: "4px 10px",
      fontSize: 13,
      fontWeight: 600
    } }, fila.length, " por enviar"), /* @__PURE__ */ React.createElement(
      window.OndOperador,
      {
        dados: dadosOndas,
        ondas,
        pessoaId: operadorSel,
        semFicha: !minhaFicha,
        onPessoa: (id) => setParam({ op: id }),
        tarefaSel,
        onEscolherTarefa: (id) => escolherTarefa(id),
        onIniciar: opIniciar,
        onPausar: opPausar,
        onRetomar: opRetomar,
        onConcluir: opConcluir,
        onReabrir: opReabrir,
        onProblema: opProblema,
        onAlocarLotes: opAlocarLotes,
        onPicarLote: opPicarLote,
        onTirarLote: opTirarLote,
        onQtdDoLote: opQtdDoLote
      }
    ));
  }
  return /* @__PURE__ */ React.createElement(
    window.CpCargasView,
    {
      entidade,
      params,
      navigate,
      onCargaConfirmada: cargaConfirmada,
      onCargaMudou: cargaMudou,
      onPreparador: preparadorDaCarga,
      registerLeaveGuard,
      ligacaoShell: ligacaoOndas,
      ondas: ondasParaCargas,
      dadosOndas,
      entregasGuardadas
    }
  );
}
window.CargoplannerView = CargoplannerView;

// ===== cargoplanner/frontend/entry.jsx =====
window.CargoplannerView = window.CargoplannerView || (() => null);

// ===== cargoplanner/frontend/rececao_helpers.jsx =====
window.IVHelpers = {
  computeSaldo({ qtdRotulo, qtdContada, qtdDanificada }) {
    const dif = (qtdContada || 0) - (qtdDanificada || 0);
    const saldo = dif - (qtdRotulo || 0);
    const entregas = saldo < 0 ? "Forn deve" : saldo > 0 ? "cr\xE9dito" : "";
    return { dif, saldo, entregas };
  },
  temDiferenca({ qtdRotulo, qtdContada, qtdDanificada }) {
    return (qtdContada || 0) !== (qtdRotulo || 0) || (qtdDanificada || 0) > 0;
  }
};

// ===== cargoplanner/frontend/rececao_api.jsx =====
function _ivCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}
async function _ivSend(path, init) {
  const res = await fetch(path, { credentials: "include", ...init });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${init.method || "GET"} ${path} \u2192 ${res.status}: ${body}`);
  }
  if (res.status === 204) return null;
  return res.json();
}
function _ivJson(method) {
  return (path, body) => {
    const csrf = _ivCookie("csrftoken");
    return _ivSend(path, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...csrf ? { "X-CSRFToken": csrf } : {}
      },
      body: JSON.stringify(body)
    });
  };
}
window.IVAPI = {
  get: (path) => _ivSend(path, { method: "GET", headers: {} }),
  post: _ivJson("POST"),
  put: _ivJson("PUT"),
  patch: _ivJson("PATCH"),
  del: (path) => {
    const csrf = _ivCookie("csrftoken");
    return _ivSend(path, {
      method: "DELETE",
      headers: csrf ? { "X-CSRFToken": csrf } : {}
    });
  },
  upload: (path, formData) => {
    const csrf = _ivCookie("csrftoken");
    return _ivSend(path, {
      method: "POST",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
      body: formData
    });
  }
};

// ===== cargoplanner/frontend/rececao_impressao.jsx =====
function ivAvisoImpressao(resposta) {
  if (resposta.estado === "enviado") {
    const n = resposta.copias || 1;
    return {
      tipo: "sucesso",
      texto: `Enviado para ${resposta.impressora} (${n} etiqueta${n === 1 ? "" : "s"}).`
    };
  }
  return {
    tipo: "erro",
    texto: `N\xE3o saiu em ${resposta.impressora}: ${resposta.erro || "a impressora n\xE3o respondeu"}. O trabalho fica pendente \u2014 repete quando estiver resolvido.`
  };
}
function IVSeletorImpressora({ onEscolha }) {
  const { useEffect, useState } = React;
  const [impressoras, setImpressoras] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [atual, setAtual] = useState(null);
  const [erro, setErro] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => {
    let vivo = true;
    Promise.all([
      window.IVAPI.get("/api/cargoplanner/impressoras/"),
      window.IVAPI.get("/api/cargoplanner/minha-impressora/")
    ]).then(([lista, minha]) => {
      if (!vivo) return;
      const ativas = (lista || []).filter((i) => i.ativa);
      setImpressoras(ativas);
      setAtual(minha.impressora);
      if (onEscolha) {
        onEscolha(ativas.find((i) => i.id === minha.impressora) || null);
      }
    }).catch((e) => {
      if (vivo) setErro(String(e.message || e));
    });
    return () => {
      vivo = false;
    };
  }, []);
  useEffect(() => {
    let vivo = true;
    window.IVAPI.get("/api/cargoplanner/empresas/").then((listaEmpresas) => {
      if (vivo) setEmpresas(listaEmpresas || []);
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, []);
  function escolher(valor) {
    const anterior = atual;
    const pk = valor ? Number(valor) : null;
    setAtual(pk);
    setErro("");
    setMsg("");
    if (!pk) {
      if (onEscolha) onEscolha(null);
      return;
    }
    window.IVAPI.put("/api/cargoplanner/minha-impressora/", { impressora: pk }).then((r) => {
      setMsg(`A trabalhar com ${r.nome}.`);
      if (onEscolha) onEscolha(impressoras.find((i) => i.id === pk) || null);
    }).catch((e) => {
      setAtual(anterior);
      setErro(String(e.message || e));
    });
  }
  const impressoraAtual = impressoras.find((i) => i.id === atual) || null;
  const empresaAtual = impressoraAtual ? empresas.find((e) => e.id === impressoraAtual.empresa) : null;
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    flexWrap: "wrap",
    fontSize: 13
  } }, /* @__PURE__ */ React.createElement("label", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", null, "Impressora"), /* @__PURE__ */ React.createElement("select", { value: atual || "", onChange: (e) => escolher(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"), impressoras.map((i) => /* @__PURE__ */ React.createElement("option", { key: i.id, value: i.id }, i.nome)))), empresaAtual ? /* @__PURE__ */ React.createElement("span", { style: { opacity: 0.75 } }, "\xB7 empresa: ", empresaAtual.nome) : null, erro ? /* @__PURE__ */ React.createElement("span", { style: { color: "crimson" } }, erro) : null, !erro && msg ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--accent, #2c5d8a)" } }, msg) : null);
}
async function IVImprimir(opcoes) {
  const resposta = await window.IVAPI.post("/api/cargoplanner/imprimir/", opcoes);
  return { ...resposta, aviso: ivAvisoImpressao(resposta) };
}
window.IVSeletorImpressora = IVSeletorImpressora;
window.IVImprimir = IVImprimir;

// ===== cargoplanner/frontend/rececao_ocr-parser.jsx =====
function _ivFold(s) {
  return (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}
function _ivAfter(folded, keywords) {
  for (const kw of keywords) {
    const k = _ivFold(kw);
    const idx = folded.indexOf(k);
    if (idx !== -1) {
      return folded.slice(idx + k.length).replace(/^[:\s]+/, "");
    }
  }
  return "";
}
function _ivFirstToken(s) {
  const m = s.match(/[a-z0-9][a-z0-9._-]*/);
  return m ? m[0] : null;
}
function _ivFirstInt(s) {
  const m = s.match(/\d+/);
  return m ? Number(m[0]) : null;
}
function _ivFirstPair(s) {
  const m = s.match(/(\d+)\s*\/\s*(\d+)/);
  return m ? [Number(m[1]), Number(m[2])] : null;
}
function _ivExtract(folded, entry) {
  const after = _ivAfter(folded, entry.palavras_ancora || []);
  if (entry.tipo === "inteiro") return _ivFirstInt(after);
  if (entry.tipo === "par") return _ivFirstPair(after);
  return _ivFirstToken(after);
}
window.IVOcr = {
  parseEtiqueta(text, config) {
    const t = _ivFold(text);
    if (Array.isArray(config) && config.length) {
      const out = {};
      for (const entry of config) {
        out[entry.campo] = _ivExtract(t, entry);
      }
      return out;
    }
    const ri = _ivFirstToken(_ivAfter(t, ["PEDIDO CLIENTE", "Pedido do cliente"]));
    const pair = _ivFirstPair(_ivAfter(t, ["N\xBA PALETA", "N PALETA", "PALETA"]));
    const qtdRotulo = _ivFirstInt(
      _ivAfter(t, ["TOTAL UNIDADES", "QUANT POR PALETE", "Quant por palete"])
    );
    return {
      ri: ri || null,
      nPalete: pair ? pair[0] : null,
      totalPaletes: pair ? pair[1] : null,
      qtdRotulo
    };
  }
};

// ===== cargoplanner/frontend/rececao_ocr-engine.jsx =====
const IV_TESS_URL = "https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js";
let _ivTessPromise = null;
function _ivLoadTesseract() {
  if (window.Tesseract) return Promise.resolve(window.Tesseract);
  if (_ivTessPromise) return _ivTessPromise;
  _ivTessPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = IV_TESS_URL;
    s.async = true;
    s.onload = () => window.Tesseract ? resolve(window.Tesseract) : reject(new Error("Tesseract n\xE3o carregou."));
    s.onerror = () => {
      _ivTessPromise = null;
      reject(new Error("N\xE3o foi poss\xEDvel carregar o motor de OCR (rede?)."));
    };
    document.head.appendChild(s);
  });
  return _ivTessPromise;
}
window.IVOcrEngine = {
  async recognize(file) {
    const Tesseract = await _ivLoadTesseract();
    const { data } = await Tesseract.recognize(file, "por");
    return data && data.text ? data.text : "";
  }
};

// ===== cargoplanner/frontend/rececao_qr-parser.jsx =====
window.IVQr = {
  parse(text) {
    let obj;
    try {
      obj = JSON.parse(String(text).trim());
    } catch (e) {
      return null;
    }
    if (!obj || typeof obj !== "object" || Array.isArray(obj)) return null;
    if (!obj.rq) return null;
    return obj;
  }
};

// ===== cargoplanner/frontend/rececao_qr-engine.jsx =====
const IV_QR_URL = "https://cdn.jsdelivr.net/npm/html5-qrcode@2.3.8/html5-qrcode.min.js";
let _ivQrPromise = null;
let _ivQrInstance = null;
function _ivLoadHtml5Qrcode() {
  if (window.Html5Qrcode) return Promise.resolve(window.Html5Qrcode);
  if (_ivQrPromise) return _ivQrPromise;
  _ivQrPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = IV_QR_URL;
    s.async = true;
    s.onload = () => window.Html5Qrcode ? resolve(window.Html5Qrcode) : reject(new Error("html5-qrcode n\xE3o carregou."));
    s.onerror = () => {
      _ivQrPromise = null;
      reject(new Error("N\xE3o foi poss\xEDvel carregar o leitor de QR (rede?)."));
    };
    document.head.appendChild(s);
  });
  return _ivQrPromise;
}
window.IVQrEngine = {
  async startCamera(elementId, onText) {
    const Html5Qrcode = await _ivLoadHtml5Qrcode();
    _ivQrInstance = new Html5Qrcode(elementId);
    await _ivQrInstance.start(
      { facingMode: "environment" },
      { fps: 10, qrbox: 250 },
      (decodedText) => {
        if (onText) onText(decodedText);
      },
      () => {
      }
      // per-frame decode failures: ignore
    );
  },
  async stop() {
    if (!_ivQrInstance) return;
    try {
      await _ivQrInstance.stop();
    } catch (e) {
    }
    _ivQrInstance = null;
  }
};

// ===== cargoplanner/frontend/rececao_picar.jsx =====
const IV_TECLADO_US = { "\xAA": '"', "\xC7": ":", "'": "-", "*": "{", "`": "}" };
function ivTecladoTrocado(texto) {
  if (!texto || texto.indexOf("\xAA") < 0) return false;
  const reparado = String(texto).split("").map((c) => c in IV_TECLADO_US ? IV_TECLADO_US[c] : c).join("");
  try {
    const o = JSON.parse(reparado);
    return !!o && typeof o === "object";
  } catch (e) {
    return false;
  }
}
function ivDesdeQuando(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const dias = Math.floor((Date.now() - d.getTime()) / 864e5);
  if (dias <= 0) return "hoje";
  if (dias === 1) return "ontem";
  return `h\xE1 ${dias} dias`;
}
function IVPicarEtiqueta() {
  const { useState, useRef, useEffect } = React;
  const [codigo, setCodigo] = useState("");
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const [impressora, setImpressora] = useState(null);
  const entrada = useRef(null);
  useEffect(() => {
    if (entrada.current) entrada.current.focus();
  }, []);
  async function ver(valor) {
    const lote = String(valor == null ? codigo : valor).trim();
    if (!lote) return;
    if (ivTecladoTrocado(lote)) {
      setResultado(null);
      setErro("O scanner est\xE1 a escrever com o teclado errado \u2014 manda teclas de um teclado americano. Pique o c\xF3digo de configura\xE7\xE3o \xABPortuguese (Portugal)\xBB do manual do DS3678 (uma vez, e fica). At\xE9 l\xE1, tudo o que picar em qualquer ecr\xE3 vem trocado.");
      return;
    }
    setOcupado(true);
    setErro("");
    setAviso(null);
    setResultado(null);
    try {
      const q = new URLSearchParams({ lote });
      setResultado(await window.IVAPI.get(`/api/cargoplanner/etiqueta/?${q}`));
    } catch (e) {
      setErro(String(e && e.message || e));
    } finally {
      setOcupado(false);
      if (entrada.current) {
        entrada.current.select();
        entrada.current.focus();
      }
    }
  }
  async function reimprimir() {
    if (!resultado || !resultado.encontrado) return;
    if (!impressora) {
      setErro("Escolha primeiro a impressora.");
      return;
    }
    setOcupado(true);
    setErro("");
    setAviso(null);
    try {
      const r = await window.IVImprimir({
        lote: resultado.lote,
        empresa: impressora.empresa,
        copias: resultado.copias,
        reimpressao: true
      });
      setAviso(r.aviso || { tipo: "sucesso", texto: "Enviado para a impressora." });
    } catch (e) {
      setErro(String(e && e.message || e));
    } finally {
      setOcupado(false);
    }
  }
  const LINHAS = [
    ["N/ Ref.", "referencia"],
    ["Designa\xE7\xE3o", "designacao"],
    ["Lote", "lote"],
    ["Quantidade", "quantidade"],
    ["Unidade", "unidade"],
    ["Cliente", "cliente"],
    ["V/ Enc.", "po_cliente"],
    ["V/ Ref.", "ref_cliente"],
    ["N/ Doc.", "n_doc"],
    ["OF", "of"],
    ["1.\xAA M\xE1q.", "maquina"],
    ["PO", "po"],
    ["Rece\xE7\xE3o", "n_rececao"],
    ["FSC", "fsc"],
    ["Data", "data"]
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement("div", { className: "filters", style: { gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(window.IVSeletorImpressora, { onEscolha: setImpressora })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", margin: "14px 0" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: entrada,
      value: codigo,
      onChange: (e) => setCodigo(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") ver();
      },
      placeholder: "Pique a etiqueta ou escreva o lote",
      "aria-label": "Lote da etiqueta",
      style: { flex: 1, minWidth: 260, padding: "10px 12px", fontSize: 16 }
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary",
      disabled: ocupado || !codigo.trim(),
      onClick: () => ver()
    },
    ocupado ? "A ler\u2026" : "Ver"
  )), erro ? /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12.5 } }, erro) : null, aviso ? /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12.5,
    color: aviso.tipo === "sucesso" ? "#16a34a" : "crimson"
  } }, aviso.texto) : null, resultado && !resultado.encontrado ? /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, "N\xE3o h\xE1 rece\xE7\xE3o para o lote ", /* @__PURE__ */ React.createElement("strong", null, resultado.lote), " em", " ", resultado.empresa ? resultado.empresa.nome : "nenhuma empresa", ".", " ", "Confirme a impressora \u2014 \xE9 ela que diz de que empresa \xE9 a etiqueta.") : null, resultado && resultado.encontrado ? /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { style: {
    marginBottom: 14,
    paddingBottom: 12,
    borderBottom: "1px solid var(--border, #e2e2e2)"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12,
    opacity: 0.7,
    textTransform: "uppercase",
    letterSpacing: 0.4
  } }, "Aloca\xE7\xE3o"), !resultado.alocacao ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, marginTop: 4 } }, "Este lote n\xE3o existe no stock \u2014 n\xE3o h\xE1 aloca\xE7\xE3o para mostrar.") : resultado.alocacao.local ? /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "baseline",
    gap: 12,
    flexWrap: "wrap",
    marginTop: 2
  } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 30, letterSpacing: 1 } }, resultado.alocacao.local), resultado.alocacao.desde ? /* @__PURE__ */ React.createElement(
    "span",
    {
      style: { fontSize: 12.5, opacity: 0.75 },
      title: String(resultado.alocacao.desde)
    },
    ivDesdeQuando(resultado.alocacao.desde),
    resultado.alocacao.por ? ` \xB7 ${resultado.alocacao.por}` : ""
  ) : null) : (
    /* Existe, mas ainda não foi arrumado — que é diferente de não
       existir, e manda fazer outra coisa. */
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, marginTop: 4 } }, "Por alocar.")
  )), /* @__PURE__ */ React.createElement("table", { style: { borderCollapse: "collapse", width: "100%" } }, /* @__PURE__ */ React.createElement("tbody", null, LINHAS.map(([rotulo, chave]) => /* @__PURE__ */ React.createElement("tr", { key: chave }, /* @__PURE__ */ React.createElement("td", { style: {
    padding: "4px 12px 4px 0",
    opacity: 0.7,
    whiteSpace: "nowrap",
    verticalAlign: "top"
  } }, rotulo), /* @__PURE__ */ React.createElement("td", { style: { padding: "4px 0", fontWeight: 600 } }, resultado.campos[chave] || "\u2014"))))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14, display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary",
      disabled: ocupado || !impressora,
      onClick: reimprimir
    },
    "Reimprimir (",
    resultado.copias,
    " ",
    resultado.copias === 1 ? "c\xF3pia" : "c\xF3pias",
    ")"
  ), !impressora ? /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12.5, opacity: 0.75 } }, "Escolha a impressora para poder reimprimir.") : null)) : null);
}
window.IVPicarEtiqueta = IVPicarEtiqueta;

// ===== cargoplanner/frontend/rececao_definicoes.jsx =====
const IVD_INP = {
  flex: 1,
  padding: "8px 10px",
  fontSize: 13,
  color: "var(--text)",
  background: "var(--panel)",
  border: "1px solid var(--border)",
  borderRadius: "var(--radius)"
};
const IVD_ROW = { display: "flex", gap: 8, alignItems: "center", padding: "6px 0" };
function IVDefLinha({ item, campo, onRename, onToggle }) {
  const { useState } = React;
  const [editar, setEditar] = useState(false);
  const [rascunho, setRascunho] = useState(item[campo]);
  async function guardar() {
    const v = rascunho.trim();
    if (v && v !== item[campo]) await onRename(item, v);
    setEditar(false);
  }
  function cancelar() {
    setRascunho(item[campo]);
    setEditar(false);
  }
  if (editar) {
    return /* @__PURE__ */ React.createElement("div", { style: IVD_ROW }, /* @__PURE__ */ React.createElement(
      "input",
      {
        style: IVD_INP,
        value: rascunho,
        autoFocus: true,
        onChange: (e) => setRascunho(e.target.value),
        onKeyDown: (e) => {
          if (e.key === "Enter") guardar();
          if (e.key === "Escape") cancelar();
        }
      }
    ), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar }, "Guardar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar"));
  }
  return /* @__PURE__ */ React.createElement("div", { style: IVD_ROW }, /* @__PURE__ */ React.createElement("span", { style: { flex: 1, fontSize: 13, opacity: item.ativo ? 1 : 0.45 } }, item[campo]), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: () => {
        setRascunho(item[campo]);
        setEditar(true);
      }
    },
    "Editar"
  ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => onToggle(item) }, item.ativo ? "Desativar" : "Ativar"));
}
function IVDefLista({
  titulo,
  itens,
  campo,
  placeholder,
  novo,
  setNovo,
  onAdd,
  onRename,
  onToggle
}) {
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, titulo), itens.map((it) => /* @__PURE__ */ React.createElement(
    IVDefLinha,
    {
      key: it.id,
      item: it,
      campo,
      onRename,
      onToggle
    }
  )), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    paddingTop: 10,
    marginTop: 6,
    borderTop: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IVD_INP,
      value: novo,
      placeholder,
      onChange: (e) => setNovo(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") onAdd();
      }
    }
  ), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: onAdd }, "Adicionar")));
}
let _ivOcrRowSeq = 0;
const IVD_OCR_CAMPOS = [
  "rq",
  "linha",
  "ano",
  "qualidade",
  "medidas",
  "vincos",
  "unidade",
  "qtd_total",
  "total_paletes",
  "n_palete",
  "qtd_rotulo",
  "lote_fornecedor"
];
function ivOcrFormatValor(v) {
  if (v === null || v === void 0) return "\u2014";
  if (Array.isArray(v)) return v.join(" / ");
  return String(v);
}
const IVD_OCR_TESTE_COLUNAS = [
  { key: "campo", label: "Campo", width: 140, minWidth: 110, mono: true },
  {
    key: "valor",
    label: "Valor extra\xEDdo",
    width: 280,
    minWidth: 160,
    render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.valor }, r.valor)
  }
];
function IVOcrConfigPanel({ fornecedores, setErro, onSaved }) {
  const { useState } = React;
  const [selId, setSelId] = useState("");
  const [rows, setRows] = useState([]);
  const [extraido, setExtraido] = useState(null);
  const [rawText, setRawText] = useState("");
  const [aLer, setALer] = useState(false);
  function semearRows(forn) {
    const cfg = forn && forn.ocr_config || [];
    setRows(cfg.map((r) => ({
      _key: _ivOcrRowSeq++,
      campo: r.campo || "",
      palavras_ancora: (r.palavras_ancora || []).join(", "),
      tipo: r.tipo || "texto"
    })));
    setExtraido(null);
    setRawText("");
  }
  function handleSelForn(e) {
    const id = e.target.value;
    setSelId(id);
    const forn = fornecedores.find((f) => String(f.id) === id) || null;
    semearRows(forn);
  }
  function setRowField(idx, field, value) {
    setRows((rs) => rs.map((r, i) => i === idx ? { ...r, [field]: value } : r));
  }
  function addRow() {
    setRows((rs) => [...rs, { _key: _ivOcrRowSeq++, campo: "", palavras_ancora: "", tipo: "texto" }]);
  }
  function removeRow(idx) {
    setRows((rs) => rs.filter((_, i) => i !== idx));
  }
  function buildDraftConfig() {
    return rows.map((r) => ({
      campo: r.campo,
      palavras_ancora: r.palavras_ancora.split(",").map((s) => s.trim()).filter(Boolean),
      tipo: r.tipo
    }));
  }
  async function guardarOcr() {
    if (!selId) {
      setErro("Selecione um fornecedor antes de guardar.");
      return;
    }
    try {
      await window.IVAPI.patch(
        "/api/cargoplanner/fornecedores/" + selId + "/",
        { ocr_config: buildDraftConfig() }
      );
      onSaved();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function testarFoto(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    e.target.value = "";
    setExtraido(null);
    setRawText("");
    setALer(true);
    try {
      const text = await window.IVOcrEngine.recognize(file);
      const draft = buildDraftConfig();
      const result = draft.length > 0 ? window.IVOcr.parseEtiqueta(text, draft) : {};
      setRawText(text);
      setExtraido(result);
    } catch (e2) {
      setErro(String(e2));
    } finally {
      setALer(false);
    }
  }
  const selForn = fornecedores.find((f) => String(f.id) === selId) || null;
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "OCR por fornecedor"), /* @__PURE__ */ React.createElement("p", { style: { fontSize: 12.5, color: "var(--muted)", marginTop: 0, marginBottom: 12 } }, 'Configure as palavras-\xE2ncora para cada campo da etiqueta. Use "Testar com foto" para verificar a extra\xE7\xE3o antes de guardar.'), /* @__PURE__ */ React.createElement("div", { style: IVD_ROW }, /* @__PURE__ */ React.createElement(
    "select",
    {
      style: { ...IVD_INP, flex: "0 0 auto", minWidth: 220 },
      value: selId,
      onChange: handleSelForn
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 Escolha um fornecedor \u2014"),
    fornecedores.map((f) => /* @__PURE__ */ React.createElement("option", { key: f.id, value: String(f.id) }, f.nome))
  )), selForn && /* @__PURE__ */ React.createElement(React.Fragment, null, rows.length === 0 && /* @__PURE__ */ React.createElement("p", { style: { fontSize: 12.5, color: "var(--muted)", margin: "8px 0" } }, "Nenhuma linha configurada. Adicione uma linha abaixo."), rows.map((r, idx) => /* @__PURE__ */ React.createElement("div", { key: r._key, style: { ...IVD_ROW, flexWrap: "wrap", gap: 6 } }, /* @__PURE__ */ React.createElement(
    "select",
    {
      style: { ...IVD_INP, flex: "0 0 auto", minWidth: 150 },
      value: r.campo,
      onChange: (e) => setRowField(idx, "campo", e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 campo \u2014"),
    IVD_OCR_CAMPOS.map((c) => /* @__PURE__ */ React.createElement("option", { key: c, value: c }, c))
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      style: { ...IVD_INP, flex: 2, minWidth: 160 },
      value: r.palavras_ancora,
      placeholder: "palavras-\xE2ncora (v\xEDrgula)",
      onChange: (e) => setRowField(idx, "palavras_ancora", e.target.value)
    }
  ), /* @__PURE__ */ React.createElement(
    "select",
    {
      style: { ...IVD_INP, flex: "0 0 auto", minWidth: 100 },
      value: r.tipo,
      onChange: (e) => setRowField(idx, "tipo", e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "texto" }, "texto"),
    /* @__PURE__ */ React.createElement("option", { value: "inteiro" }, "inteiro"),
    /* @__PURE__ */ React.createElement("option", { value: "par" }, "par")
  ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => removeRow(idx) }, "\u2715"))), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 8,
    marginTop: 10,
    flexWrap: "wrap",
    borderTop: "1px solid var(--border)",
    paddingTop: 10
  } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: addRow }, "+ Adicionar linha"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardarOcr }, "Guardar OCR")), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 16, borderTop: "1px solid var(--border)", paddingTop: 12 } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12.5,
    fontWeight: 600,
    marginBottom: 8,
    color: "var(--text)"
  } }, "Testar com foto"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } }, /* @__PURE__ */ React.createElement("label", { className: "btn ghost sm", style: { cursor: "pointer" } }, "Escolher imagem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "file",
      accept: "image/*",
      style: { display: "none" },
      onChange: testarFoto
    }
  )), aLer && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "a ler\u2026")), extraido && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "cargoplanner",
      viewId: "definicoes-ocr-teste",
      columns: IVD_OCR_TESTE_COLUNAS,
      data: Object.entries(extraido).map(([campo, valor]) => ({ campo, valor: ivOcrFormatValor(valor) })),
      rowKey: (r) => r.campo,
      pagination: "client",
      empty: "Sem campos extra\xEDdos."
    }
  )), rawText && /* @__PURE__ */ React.createElement("details", { style: { marginTop: 10 } }, /* @__PURE__ */ React.createElement("summary", { style: {
    fontSize: 12,
    cursor: "pointer",
    color: "var(--muted)"
  } }, "Texto OCR"), /* @__PURE__ */ React.createElement("pre", { style: {
    fontSize: 11,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)",
    padding: 8,
    marginTop: 6,
    maxHeight: 240,
    overflowY: "auto"
  } }, rawText)))));
}
function ivMensagemDoErro(e) {
  const txt = String(e.message || e);
  const m = txt.match(/→ \d+: ([\s\S]*)$/);
  if (m) {
    try {
      const corpo = JSON.parse(m[1]);
      if (corpo && typeof corpo.detail === "string") return corpo.detail;
    } catch (_ignorado) {
    }
  }
  return txt;
}
function IVImpressorasPanel() {
  const { useState, useEffect, useCallback } = React;
  const VAZIO = {
    nome: "",
    empresa: "",
    host: "",
    porta: 9100,
    dpi: 203,
    largura_mm: 102,
    comprimento_mm: 150,
    velocidade_ips: 8,
    escuridao: 15,
    ativa: true,
    ordem: 0,
    notas: ""
  };
  const [itens, setItens] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [aCarregar, setACarregar] = useState(true);
  const [erro, setErro] = useState("");
  const [rascunho, setRascunho] = useState(VAZIO);
  const [aEditar, setAEditar] = useState(null);
  const [aGuardar, setAGuardar] = useState(false);
  const [aTestar, setATestar] = useState(null);
  const [teste, setTeste] = useState(null);
  const carregar = useCallback(async () => {
    setACarregar(true);
    setErro("");
    try {
      const [lista, listaEmpresas] = await Promise.all([
        window.IVAPI.get("/api/cargoplanner/impressoras/"),
        window.IVAPI.get("/api/cargoplanner/empresas/")
      ]);
      setItens(lista || []);
      setEmpresas(listaEmpresas || []);
    } catch (e) {
      setErro(String(e.message || e));
    } finally {
      setACarregar(false);
    }
  }, []);
  useEffect(() => {
    carregar();
  }, [carregar]);
  function nomeEmpresa(id) {
    const e = empresas.find((x) => x.id === id);
    return e ? e.nome : "\u2014";
  }
  function cancelar() {
    setAEditar(null);
    setRascunho(VAZIO);
  }
  async function guardar() {
    setAGuardar(true);
    setErro("");
    try {
      const nome = String(rascunho.nome).trim();
      if (!nome) throw new Error("O nome \xE9 obrigat\xF3rio.");
      if (!rascunho.empresa) throw new Error("Escolha a empresa.");
      const host = String(rascunho.host).trim();
      if (!host) throw new Error("O IP ou nome DNS \xE9 obrigat\xF3rio.");
      const corpo = {
        ...rascunho,
        nome,
        host,
        empresa: Number(rascunho.empresa),
        porta: Number(rascunho.porta) || 9100,
        dpi: Number(rascunho.dpi) || 203,
        largura_mm: Number(rascunho.largura_mm) || 102,
        comprimento_mm: Number(rascunho.comprimento_mm) || 150,
        velocidade_ips: Number(rascunho.velocidade_ips) || 8,
        escuridao: Number(rascunho.escuridao) || 15,
        ordem: Number(rascunho.ordem) || 0
      };
      if (aEditar) {
        await window.IVAPI.put(`/api/cargoplanner/impressoras/${aEditar}/`, corpo);
      } else {
        await window.IVAPI.post("/api/cargoplanner/impressoras/", corpo);
      }
      cancelar();
      await carregar();
    } catch (e) {
      setErro(String(e.message || e));
    } finally {
      setAGuardar(false);
    }
  }
  async function apagar(it) {
    const ok = await window.hubConfirm({
      title: `Apagar ${it.nome}`,
      message: `Apagar a impressora \xAB${it.nome}\xBB? Se j\xE1 houver trabalhos de impress\xE3o registados nela, o servidor recusa \u2014 desative-a em vez de a apagar.`,
      confirmLabel: "Apagar",
      danger: true
    });
    if (!ok) return;
    try {
      await window.IVAPI.del(`/api/cargoplanner/impressoras/${it.id}/`);
      await carregar();
    } catch (e) {
      setErro(ivMensagemDoErro(e));
    }
  }
  async function testar(it) {
    setTeste(null);
    setATestar(it.id);
    try {
      const r = await window.IVAPI.post(
        `/api/cargoplanner/impressoras/${it.id}/testar/`
      );
      setTeste(r.ok ? {
        tipo: "sucesso",
        texto: `Etiqueta de ensaio enviada para ${r.impressora}.`
      } : {
        tipo: "erro",
        texto: `${it.nome} n\xE3o respondeu: ${r.erro || "causa desconhecida"}.`
      });
    } catch (e) {
      setTeste({ tipo: "erro", texto: String(e.message || e) });
    } finally {
      setATestar(null);
    }
  }
  const colunas = [
    {
      key: "nome",
      label: "Nome",
      width: 170,
      minWidth: 130,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome)
    },
    {
      key: "empresa",
      label: "Empresa",
      width: 130,
      sortValue: (it) => nomeEmpresa(it.empresa),
      render: (it) => nomeEmpresa(it.empresa)
    },
    { key: "host", label: "Host", width: 140 },
    { key: "porta", label: "Porta", width: 80 },
    { key: "dpi", label: "DPI", width: 70 },
    { key: "velocidade_ips", label: "Velocidade (ips)", width: 130 },
    { key: "escuridao", label: "Escurid\xE3o", width: 100 },
    {
      key: "ativa",
      label: "Ativa",
      width: 70,
      render: (it) => it.ativa ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 220,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => {
            setAEditar(it.id);
            setRascunho({ ...VAZIO, ...it });
          }
        },
        "Editar"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          disabled: aTestar === it.id,
          onClick: () => testar(it)
        },
        aTestar === it.id ? "A testar\u2026" : "Testar"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Impressoras"), /* @__PURE__ */ React.createElement("p", { style: { fontSize: 12.5, color: "var(--muted)", marginTop: 0, marginBottom: 12 } }, "A velocidade e a escurid\xE3o s\xE3o de cada aparelho \u2014 dependem do papel e da fita que l\xE1 est\xE3o, n\xE3o do modelo da etiqueta. \xABTestar\xBB imprime a etiqueta de ensaio e o invent\xE1rio de mem\xF3ria."), erro ? /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12.5, marginBottom: 12 } }, erro) : null, teste ? /* @__PURE__ */ React.createElement("div", { style: {
    color: teste.tipo === "erro" ? "#c4434b" : "var(--accent, #2c5d8a)",
    fontSize: 12.5,
    marginBottom: 12
  } }, teste.texto) : null, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: aCarregar,
      appLabel: "cargoplanner",
      viewId: "impressoras",
      columns: colunas,
      data: itens,
      pagination: "none",
      rowKey: (it) => it.id,
      search: { fields: ["nome", "host"], placeholder: "Procurar impressora\u2026" }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginTop: 18 } }, aEditar ? "Editar impressora" : "Nova impressora"), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gap: 12,
    marginTop: 8,
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))"
  } }, /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.nome,
      onChange: (e) => setRascunho({ ...rascunho, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Empresa"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: rascunho.empresa,
      onChange: (e) => setRascunho({ ...rascunho, empresa: e.target.value })
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"),
    empresas.map((e) => /* @__PURE__ */ React.createElement("option", { key: e.id, value: e.id }, e.nome))
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Host (IP/DNS)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.host,
      onChange: (e) => setRascunho({ ...rascunho, host: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Porta"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.porta,
      onChange: (e) => setRascunho({ ...rascunho, porta: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "DPI"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.dpi,
      onChange: (e) => setRascunho({ ...rascunho, dpi: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Largura (mm)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.largura_mm,
      onChange: (e) => setRascunho({ ...rascunho, largura_mm: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Comprimento (mm)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.comprimento_mm,
      onChange: (e) => setRascunho({ ...rascunho, comprimento_mm: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Velocidade (ips)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.velocidade_ips,
      onChange: (e) => setRascunho({ ...rascunho, velocidade_ips: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Escurid\xE3o"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.escuridao,
      onChange: (e) => setRascunho({ ...rascunho, escuridao: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Ordem"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: rascunho.ordem,
      onChange: (e) => setRascunho({ ...rascunho, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { style: { display: "flex", gap: 8, alignItems: "center", paddingTop: 18 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!rascunho.ativa,
      onChange: (e) => setRascunho({ ...rascunho, ativa: e.target.checked })
    }
  ), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 13 } }, "Ativa"))), /* @__PURE__ */ React.createElement("label", { className: "field", style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Notas"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: rascunho.notas,
      onChange: (e) => setRascunho({ ...rascunho, notas: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: 16
  } }, aEditar ? /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelar }, "Cancelar") : null, /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: guardar, disabled: aGuardar }, aGuardar ? "A guardar\u2026" : aEditar ? "Guardar" : "Adicionar")));
}
function InboundVerumDefinicoes() {
  const { useState, useEffect } = React;
  const [data, setData] = useState({ fornecedores: [], locais_danos: [], tipos_acao: [] });
  const [novoForn, setNovoForn] = useState("");
  const [novoLocal, setNovoLocal] = useState("");
  const [novoTipo, setNovoTipo] = useState("");
  const [erro, setErro] = useState("");
  const SP_VAZIO = {
    is_enabled: false,
    graph_tenant_id: "",
    graph_client_id: "",
    graph_client_secret: "",
    tem_secret: false,
    sharepoint_site_id: "",
    sharepoint_drive_id: "",
    pasta_base: "InboundVerum/fotos",
    apagar_local_apos_sync: true
  };
  const [sp, setSp] = useState(SP_VAZIO);
  const [spMsg, setSpMsg] = useState("");
  async function load() {
    try {
      setData(await window.IVAPI.get("/api/cargoplanner/definicoes/"));
    } catch (e) {
      setErro(String(e));
    }
  }
  async function loadSp() {
    try {
      const cfg = await window.IVAPI.get(
        "/api/cargoplanner/sharepoint-settings/"
      );
      setSp({ ...SP_VAZIO, ...cfg, graph_client_secret: "" });
    } catch (e) {
      setErro(String(e));
    }
  }
  useEffect(() => {
    load();
    loadSp();
  }, []);
  function setSpField(k, v) {
    setSp((s) => ({ ...s, [k]: v }));
  }
  async function saveSp() {
    setSpMsg("");
    try {
      const payload = { ...sp };
      delete payload.tem_secret;
      if (!payload.graph_client_secret) delete payload.graph_client_secret;
      await window.IVAPI.put("/api/cargoplanner/sharepoint-settings/", payload);
      setSpMsg("Guardado.");
      loadSp();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function addForn() {
    if (!novoForn.trim()) return;
    try {
      await window.IVAPI.post(
        "/api/cargoplanner/fornecedores/",
        { nome: novoForn.trim() }
      );
      setNovoForn("");
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function toggleForn(f) {
    try {
      await window.IVAPI.patch(
        `/api/cargoplanner/fornecedores/${f.id}/`,
        { ativo: !f.ativo }
      );
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function renameForn(f, nome) {
    try {
      await window.IVAPI.patch(`/api/cargoplanner/fornecedores/${f.id}/`, { nome });
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function addLocal() {
    if (!novoLocal.trim()) return;
    try {
      await window.IVAPI.post(
        "/api/cargoplanner/locais-danos/",
        { label: novoLocal.trim() }
      );
      setNovoLocal("");
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function toggleLocal(l) {
    try {
      await window.IVAPI.patch(
        `/api/cargoplanner/locais-danos/${l.id}/`,
        { ativo: !l.ativo }
      );
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function renameLocal(l, label) {
    try {
      await window.IVAPI.patch(`/api/cargoplanner/locais-danos/${l.id}/`, { label });
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function addTipo() {
    if (!novoTipo.trim()) return;
    try {
      await window.IVAPI.post(
        "/api/cargoplanner/tipos-acao/",
        { label: novoTipo.trim() }
      );
      setNovoTipo("");
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function toggleTipo(t) {
    try {
      await window.IVAPI.patch(
        `/api/cargoplanner/tipos-acao/${t.id}/`,
        { ativo: !t.ativo }
      );
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function renameTipo(t, label) {
    try {
      await window.IVAPI.patch(`/api/cargoplanner/tipos-acao/${t.id}/`, { label });
      load();
    } catch (e) {
      setErro(String(e));
    }
  }
  const checkbox = {
    display: "flex",
    gap: 8,
    alignItems: "center",
    cursor: "pointer",
    padding: "6px 0",
    fontSize: 13
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, maxWidth: 860 } }, erro ? /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12.5, marginBottom: 12 } }, erro) : null, /* @__PURE__ */ React.createElement(
    IVDefLista,
    {
      titulo: "Fornecedores",
      itens: data.fornecedores,
      campo: "nome",
      placeholder: "Novo fornecedor",
      novo: novoForn,
      setNovo: setNovoForn,
      onAdd: addForn,
      onRename: renameForn,
      onToggle: toggleForn
    }
  ), /* @__PURE__ */ React.createElement(
    IVDefLista,
    {
      titulo: "Locais de danos",
      itens: data.locais_danos,
      campo: "label",
      placeholder: "Novo local de danos",
      novo: novoLocal,
      setNovo: setNovoLocal,
      onAdd: addLocal,
      onRename: renameLocal,
      onToggle: toggleLocal
    }
  ), /* @__PURE__ */ React.createElement(
    IVDefLista,
    {
      titulo: "Tipos de a\xE7\xE3o / tratamento",
      itens: data.tipos_acao,
      campo: "label",
      placeholder: "Novo tipo de a\xE7\xE3o",
      novo: novoTipo,
      setNovo: setNovoTipo,
      onAdd: addTipo,
      onRename: renameTipo,
      onToggle: toggleTipo
    }
  ), /* @__PURE__ */ React.createElement(
    IVOcrConfigPanel,
    {
      fornecedores: data.fornecedores,
      setErro,
      onSaved: load
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Armazenamento de fotos (SharePoint)"), /* @__PURE__ */ React.createElement("p", { style: { fontSize: 12.5, color: "var(--muted)", marginTop: 0 } }, "Enquanto desativado, as fotos ficam s\xF3 no servidor local e nada \xE9 enviado para o SharePoint."), /* @__PURE__ */ React.createElement("label", { style: checkbox }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: sp.is_enabled,
      onChange: (e) => setSpField("is_enabled", e.target.checked)
    }
  ), /* @__PURE__ */ React.createElement("span", null, "Ativar sincroniza\xE7\xE3o para o SharePoint")), /* @__PURE__ */ React.createElement("label", { style: checkbox }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: sp.apagar_local_apos_sync,
      onChange: (e) => setSpField("apagar_local_apos_sync", e.target.checked)
    }
  ), /* @__PURE__ */ React.createElement("span", null, "Apagar a c\xF3pia local ap\xF3s sincronizar")), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gap: 12,
    marginTop: 12,
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))"
  } }, [
    ["graph_tenant_id", "Directory (tenant) ID"],
    ["graph_client_id", "Application (client) ID"],
    ["sharepoint_site_id", "SharePoint site ID"],
    ["sharepoint_drive_id", "SharePoint drive ID"]
  ].map(([k, ph]) => /* @__PURE__ */ React.createElement("label", { key: k, className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, ph), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: sp[k] || "",
      placeholder: ph,
      onChange: (e) => setSpField(k, e.target.value)
    }
  )))), /* @__PURE__ */ React.createElement("label", { className: "field", style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Pasta base"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: sp.pasta_base || "",
      placeholder: "ex.: InboundVerum/fotos",
      onChange: (e) => setSpField("pasta_base", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field", style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Client secret"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: sp.graph_client_secret,
      placeholder: sp.tem_secret ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (guardado \u2014 deixar vazio para manter)" : "Client secret",
      onChange: (e) => setSpField("graph_client_secret", e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: 16
  } }, spMsg ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--accent)", fontSize: 12.5 } }, spMsg) : null, /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: saveSp }, "Guardar"))), /* @__PURE__ */ React.createElement(IVImpressorasPanel, null));
}
window.InboundVerumDefinicoes = InboundVerumDefinicoes;

// ===== cargoplanner/frontend/rececao_registo.jsx =====
function InboundVerumView() {
  const { useState, useEffect } = React;
  const [screen, setScreen] = useState("lotes");
  const [lotes, setLotes] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [locais, setLocais] = useState([]);
  const [lote, setLote] = useState(null);
  const [contagens, setContagens] = useState([]);
  const [tiposAcao, setTiposAcao] = useState([]);
  const [acoes, setAcoes] = useState([]);
  const [erro, setErro] = useState("");
  const [isStaff, setIsStaff] = useState(false);
  const [prefill, setPrefill] = useState(null);
  const [contagemId, setContagemId] = useState(null);
  const [impressora, setImpressora] = useState(null);
  async function loadLotes() {
    try {
      setLotes(await window.IVAPI.get(
        "/api/cargoplanner/lotes/?estado=em_contagem,contagem_total"
      ));
    } catch (e) {
      setErro(String(e));
    }
  }
  async function loadDefs() {
    try {
      const d = await window.IVAPI.get("/api/cargoplanner/definicoes/");
      setFornecedores(d.fornecedores.filter((f) => f.ativo));
      setLocais(d.locais_danos.filter((l) => l.ativo));
      setTiposAcao((d.tipos_acao || []).filter((t) => t.ativo));
    } catch (e) {
      setErro(String(e));
    }
  }
  useEffect(() => {
    loadLotes();
    loadDefs();
    window.IVAPI.get("/api/auth/me/").then((u) => setIsStaff(!!(u && u.is_staff))).catch(() => setIsStaff(false));
  }, []);
  async function openLote(l) {
    setLote(l);
    setContagens(await window.IVAPI.get(
      `/api/cargoplanner/contagens/?lote=${l.id}`
    ));
    setAcoes(await window.IVAPI.get(
      `/api/cargoplanner/acoes/?lote=${l.id}`
    ));
    setScreen("lote");
  }
  async function refreshLote() {
    const l = await window.IVAPI.get(`/api/cargoplanner/lotes/${lote.id}/`);
    setLote(l);
    setContagens(await window.IVAPI.get(
      `/api/cargoplanner/contagens/?lote=${l.id}`
    ));
    setAcoes(await window.IVAPI.get(
      `/api/cargoplanner/acoes/?lote=${l.id}`
    ));
  }
  async function scanQr(fornecedorId, qrObj) {
    try {
      const res = await window.IVAPI.post(
        "/api/cargoplanner/qr-scan/",
        { fornecedor: Number(fornecedorId), payload: qrObj }
      );
      const l = res.lote;
      setLote(l);
      setContagens(await window.IVAPI.get(
        `/api/cargoplanner/contagens/?lote=${l.id}`
      ));
      setAcoes(await window.IVAPI.get(
        `/api/cargoplanner/acoes/?lote=${l.id}`
      ));
      setPrefill(res.palete_prefill || null);
      setContagemId(res.contagem_existente || null);
      setScreen("contar");
      return res;
    } catch (e) {
      setErro(String(e));
      return null;
    }
  }
  let conteudo;
  if (screen === "lotes") {
    conteudo = React.createElement(LotesScreen, {
      lotes,
      fornecedores,
      erro,
      setErro,
      onOpen: openLote,
      onCreated: loadLotes,
      onScanQr: scanQr
    });
  } else if (screen === "lote") {
    conteudo = React.createElement(LoteScreen, {
      lote,
      contagens,
      tiposAcao,
      acoes,
      isStaff,
      erro,
      setErro,
      onBack: () => {
        setScreen("lotes");
        loadLotes();
      },
      onContar: () => {
        setPrefill(null);
        setContagemId(null);
        setScreen("contar");
      },
      onRefresh: refreshLote
    });
  } else {
    conteudo = React.createElement(ContarScreen, {
      lote,
      locais,
      erro,
      setErro,
      prefill,
      contagemId,
      impressora,
      onSaved: async () => {
        await refreshLote();
        setScreen("lote");
      },
      onCancel: () => setScreen("lote")
    });
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    padding: "10px 24px 0",
    display: "flex",
    justifyContent: "flex-end"
  } }, /* @__PURE__ */ React.createElement(window.IVSeletorImpressora, { onEscolha: setImpressora })), conteudo);
}
const IV_PAGE = { padding: "20px 24px", width: "100%", boxSizing: "border-box" };
const IV_GRID = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 12
};
const IV_FIELD = {
  display: "flex",
  flexDirection: "column",
  gap: 4,
  fontSize: 14,
  opacity: 0.95
};
const IV_BTN = {
  padding: "14px 18px",
  fontSize: 18,
  borderRadius: "var(--radius-lg,10px)",
  border: "none",
  background: "var(--accent,#2c5d8a)",
  color: "#fff",
  cursor: "pointer",
  display: "inline-block"
};
const IV_INP = {
  padding: 12,
  fontSize: 18,
  minHeight: 48,
  borderRadius: "var(--radius,6px)",
  border: "1px solid var(--border,#dde3ea)",
  width: "100%",
  boxSizing: "border-box"
};
const IV_CARD = {
  background: "var(--panel,#fff)",
  borderRadius: "var(--radius-lg,10px)",
  border: "1px solid var(--border,#dde3ea)",
  boxShadow: "var(--shadow-sm)",
  padding: 16,
  marginBottom: 12
};
function ErroBanner({ erro }) {
  if (!erro) return null;
  return React.createElement(
    "div",
    { style: {
      background: "#fee",
      color: "crimson",
      padding: 10,
      borderRadius: 8,
      marginBottom: 12
    } },
    erro
  );
}
function OcrTextoLido({ texto }) {
  if (!texto) return null;
  return /* @__PURE__ */ React.createElement("details", { style: { ...IV_CARD, padding: 12 } }, /* @__PURE__ */ React.createElement("summary", { style: { cursor: "pointer" } }, "Texto lido da etiqueta"), /* @__PURE__ */ React.createElement("pre", { style: { whiteSpace: "pre-wrap", margin: "8px 0 0", fontSize: 14 } }, texto));
}
function ConfirmModal({ texto, onConfirm, onCancel }) {
  return (
    // O fundo não fecha — só os botões (pedido do João, 2026-09-25).
    /* @__PURE__ */ React.createElement("div", { style: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1e3
    } }, /* @__PURE__ */ React.createElement("div", { onClick: (e) => e.stopPropagation(), style: {
      ...IV_CARD,
      maxWidth: 420,
      margin: 16
    } }, /* @__PURE__ */ React.createElement("p", { style: { marginTop: 0 } }, texto), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        style: { ...IV_BTN, background: "#888" },
        onClick: onCancel
      },
      "Cancelar"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        style: { ...IV_BTN, background: "#dc2626" },
        onClick: onConfirm
      },
      "Eliminar"
    ))))
  );
}
function LerQrPanel({ onScan, onClose, setErro }) {
  const { useState, useEffect, useRef } = React;
  const [wedge, setWedge] = useState("");
  const camId = "iv-qr-cam";
  const started = useRef(false);
  useEffect(() => {
    let alive = true;
    window.IVQrEngine.startCamera(camId, (text) => {
      const obj = window.IVQr.parse(text);
      if (obj && alive) onScan(obj);
    }).then(() => {
      started.current = true;
    }).catch((e) => setErro("C\xE2mara indispon\xEDvel \u2014 usa o leitor de m\xE3o. (" + String(e) + ")"));
    return () => {
      alive = false;
      window.IVQrEngine.stop();
    };
  }, []);
  function submitWedge() {
    const obj = window.IVQr.parse(wedge);
    if (obj) {
      onScan(obj);
      setWedge("");
    } else setErro("QR inv\xE1lido \u2014 verifica o c\xF3digo lido.");
  }
  return /* @__PURE__ */ React.createElement("div", { style: { ...IV_CARD } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8
  } }, /* @__PURE__ */ React.createElement("h3", { style: { margin: 0 } }, "Ler QR"), /* @__PURE__ */ React.createElement("button", { style: {
    ...IV_BTN,
    background: "#888",
    padding: "8px 12px",
    fontSize: 14
  }, onClick: onClose }, "Fechar")), /* @__PURE__ */ React.createElement("div", { id: camId, style: { width: "100%", maxWidth: 360 } }), /* @__PURE__ */ React.createElement("label", { style: { ...IV_FIELD, marginTop: 12 } }, "Leitor de m\xE3o (QR colado aqui)", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      value: wedge,
      autoFocus: true,
      onChange: (e) => setWedge(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") submitWedge();
      }
    }
  )));
}
function LotesScreen({ lotes, fornecedores, erro, setErro, onOpen, onCreated, onScanQr }) {
  const { useState } = React;
  const [forn, setForn] = useState("");
  const [rq, setRq] = useState("");
  const [linha, setLinha] = useState("");
  const [total, setTotal] = useState("");
  const [ocrText, setOcrText] = useState("");
  const [ocrBusy, setOcrBusy] = useState(false);
  const [showQr, setShowQr] = useState(false);
  async function lerEtiqueta(file) {
    if (!file) return;
    setOcrBusy(true);
    setErro("");
    try {
      const text = await window.IVOcrEngine.recognize(file);
      setOcrText(text);
      const parsed = window.IVOcr.parseEtiqueta(text);
      if (parsed.ri != null) setRq(parsed.ri);
      if (parsed.totalPaletes != null) setTotal(String(parsed.totalPaletes));
    } catch (e) {
      setErro("Leitura autom\xE1tica falhou \u2014 preenche \xE0 m\xE3o. (" + String(e) + ")");
    } finally {
      setOcrBusy(false);
    }
  }
  async function criar() {
    if (!forn || !rq.trim()) {
      setErro("Escolhe fornecedor e RQ.");
      return;
    }
    try {
      await window.IVAPI.post("/api/cargoplanner/lotes/", {
        fornecedor: Number(forn),
        rq: rq.trim(),
        linha: linha.trim(),
        total_paletes: total ? Number(total) : null
      });
      setRq("");
      setLinha("");
      setTotal("");
      setErro("");
      onCreated();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function handleQrScan(qrObj) {
    if (!forn) {
      setErro("Escolhe o fornecedor antes de ler o QR.");
      return;
    }
    setShowQr(false);
    await onScanQr(forn, qrObj);
  }
  return /* @__PURE__ */ React.createElement("div", { style: IV_PAGE }, /* @__PURE__ */ React.createElement(ErroBanner, { erro }), /* @__PURE__ */ React.createElement("div", { style: IV_CARD }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 12
  } }, /* @__PURE__ */ React.createElement("h3", { style: { margin: 0 } }, "Novo lote"), /* @__PURE__ */ React.createElement("label", { style: { ...IV_BTN, background: "#475569" } }, ocrBusy ? "A ler etiqueta\u2026" : "\u{1F4C4} Ler etiqueta", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "file",
      accept: "image/*",
      capture: "environment",
      style: { display: "none" },
      disabled: ocrBusy,
      onChange: (e) => {
        lerEtiqueta(e.target.files[0]);
        e.target.value = "";
      }
    }
  )), /* @__PURE__ */ React.createElement(
    "button",
    {
      style: { ...IV_BTN, background: "#0369a1" },
      onClick: () => {
        setErro("");
        setShowQr((v) => !v);
      }
    },
    showQr ? "Fechar QR" : "Ler QR"
  )), showQr ? /* @__PURE__ */ React.createElement(
    LerQrPanel,
    {
      onScan: handleQrScan,
      onClose: () => setShowQr(false),
      setErro
    }
  ) : null, /* @__PURE__ */ React.createElement(OcrTextoLido, { texto: ocrText }), /* @__PURE__ */ React.createElement("div", { style: IV_GRID }, /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Fornecedor", /* @__PURE__ */ React.createElement(
    "select",
    {
      style: IV_INP,
      value: forn,
      onChange: (e) => setForn(e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 fornecedor \u2014"),
    fornecedores.map((f) => /* @__PURE__ */ React.createElement("option", { key: f.id, value: f.id }, f.nome))
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "RQ (pedido)", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      value: rq,
      onChange: (e) => setRq(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Linha", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      value: linha,
      onChange: (e) => setLinha(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Total de paletes (opcional)", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      type: "number",
      inputMode: "numeric",
      value: total,
      onChange: (e) => setTotal(e.target.value)
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { height: 12 } }), /* @__PURE__ */ React.createElement("button", { style: IV_BTN, onClick: criar }, "Criar lote")), /* @__PURE__ */ React.createElement("h3", null, "Lotes em contagem"), /* @__PURE__ */ React.createElement("div", { style: IV_GRID }, lotes.map((l) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: l.id,
      style: { ...IV_CARD, cursor: "pointer", marginBottom: 0 },
      onClick: () => onOpen(l)
    },
    /* @__PURE__ */ React.createElement("strong", null, l.fornecedor_nome),
    " \xB7 RQ ",
    l.rq,
    l.linha ? "/" + l.linha : "",
    /* @__PURE__ */ React.createElement("div", { style: { opacity: 0.7 } }, l.paletes_contadas, l.total_paletes ? `/${l.total_paletes}` : "", " paletes", l.tem_diferenca ? " \xB7 \u26A0 diferen\xE7a" : "")
  ))));
}
function LoteScreen({
  lote,
  contagens,
  tiposAcao,
  acoes,
  isStaff,
  erro,
  setErro,
  onBack,
  onContar,
  onRefresh
}) {
  const { useState, useEffect, useCallback } = React;
  const [tipoAcao, setTipoAcao] = useState("");
  const [aEliminar, setAEliminar] = useState(null);
  const [logs, setLogs] = useState([]);
  const podeAmostra = !lote.tem_diferenca && lote.paletes_contadas === 1;
  const refreshLogs = useCallback(() => {
    if (!lote?.id) return;
    window.IVAPI.get(`/api/cargoplanner/lotes/${lote.id}/audit/`).then((rows) => setLogs((rows || []).map((e) => ({
      id: e.id,
      evento: e.verb,
      descricao: e.summary,
      actor_username: e.actor_name,
      criado_em: e.when
    })))).catch(() => setLogs([]));
  }, [lote?.id]);
  useEffect(() => {
    refreshLogs();
  }, [refreshLogs]);
  async function registarAcao() {
    if (!tipoAcao) {
      setErro("Escolhe um tipo de a\xE7\xE3o.");
      return;
    }
    try {
      await window.IVAPI.post(
        "/api/cargoplanner/acoes/",
        { lote: lote.id, tipo: Number(tipoAcao) }
      );
      setTipoAcao("");
      setErro("");
      onRefresh();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function eliminarContagem() {
    try {
      await window.IVAPI.del(
        `/api/cargoplanner/contagens/${aEliminar.id}/`
      );
      setAEliminar(null);
      setErro("");
      onRefresh();
    } catch (e) {
      setErro(String(e));
      setAEliminar(null);
    }
  }
  async function fecharConforme() {
    try {
      await window.IVAPI.patch(
        `/api/cargoplanner/lotes/${lote.id}/`,
        { estado: "amostra_conforme" }
      );
      onBack();
    } catch (e) {
      setErro(String(e));
    }
  }
  async function concluir() {
    try {
      await window.IVAPI.patch(
        `/api/cargoplanner/lotes/${lote.id}/`,
        { estado: "concluido" }
      );
      onBack();
    } catch (e) {
      setErro(String(e));
    }
  }
  return /* @__PURE__ */ React.createElement("div", { style: IV_PAGE }, /* @__PURE__ */ React.createElement(ErroBanner, { erro }), /* @__PURE__ */ React.createElement("button", { style: { ...IV_BTN, background: "#888" }, onClick: onBack }, "\u2190 Lotes"), /* @__PURE__ */ React.createElement("h2", null, lote.fornecedor_nome, " \xB7 RQ ", lote.rq, lote.linha ? "/" + lote.linha : ""), /* @__PURE__ */ React.createElement("p", { style: { opacity: 0.7 } }, "Estado: ", lote.estado, " \xB7", " ", lote.paletes_contadas, lote.total_paletes ? `/${lote.total_paletes}` : "", " paletes"), lote.tem_diferenca ? /* @__PURE__ */ React.createElement("div", { style: {
    background: "#fff4e5",
    padding: 12,
    borderRadius: 8,
    marginBottom: 12
  } }, "\u26A0 Diferen\xE7a detetada \u2014 contar as restantes paletes deste pedido.") : null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("button", { style: IV_BTN, onClick: onContar }, "+ Contar palete"), podeAmostra ? /* @__PURE__ */ React.createElement(
    "button",
    {
      style: { ...IV_BTN, background: "#16a34a" },
      onClick: fecharConforme
    },
    "Fechar lote (amostra conforme)"
  ) : null, /* @__PURE__ */ React.createElement(
    "button",
    {
      style: { ...IV_BTN, background: "#475569" },
      onClick: concluir
    },
    "Concluir lote"
  )), /* @__PURE__ */ React.createElement("h3", { style: { marginTop: 16 } }, "Paletes contadas"), /* @__PURE__ */ React.createElement("div", { style: IV_GRID }, contagens.map((c) => /* @__PURE__ */ React.createElement("div", { key: c.id, style: { ...IV_CARD, marginBottom: 0 } }, /* @__PURE__ */ React.createElement("strong", null, "Palete ", c.n_palete || "?"), " \u2014 r\xF3tulo ", c.qtd_rotulo, ", contada ", c.qtd_contada, ", danif. ", c.qtd_danificada, /* @__PURE__ */ React.createElement("div", { style: { color: c.saldo_placas_ok < 0 ? "crimson" : "#16a34a" } }, "saldo ", c.saldo_placas_ok, " ", c.saldo_entregas ? `\xB7 ${c.saldo_entregas}` : ""), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" } }, c.fotos.map((f) => /* @__PURE__ */ React.createElement("img", { key: f.id, src: f.imagem_url, alt: "", style: {
    width: 56,
    height: 56,
    objectFit: "cover",
    borderRadius: 6
  } }))), isStaff ? /* @__PURE__ */ React.createElement(
    "button",
    {
      style: {
        ...IV_BTN,
        background: "#dc2626",
        padding: "8px 12px",
        fontSize: 14,
        marginTop: 8
      },
      onClick: () => setAEliminar(c)
    },
    "Eliminar"
  ) : null))), /* @__PURE__ */ React.createElement("h3", { style: { marginTop: 16 } }, "A\xE7\xF5es / Tratamento"), /* @__PURE__ */ React.createElement("div", { style: IV_CARD }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    alignItems: "center"
  } }, /* @__PURE__ */ React.createElement(
    "select",
    {
      style: { ...IV_INP, maxWidth: 360 },
      value: tipoAcao,
      onChange: (e) => setTipoAcao(e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 tipo de a\xE7\xE3o \u2014"),
    tiposAcao.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.label))
  ), /* @__PURE__ */ React.createElement("button", { style: IV_BTN, onClick: registarAcao }, "Registar a\xE7\xE3o")), acoes.length ? /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12 } }, acoes.map((a) => /* @__PURE__ */ React.createElement("div", { key: a.id, style: {
    padding: "6px 0",
    borderBottom: "1px solid #eee"
  } }, /* @__PURE__ */ React.createElement("strong", null, a.tipo_label), a.responsavel_nome ? ` \xB7 ${a.responsavel_nome}` : "", " \xB7 ", (a.criado_em || "").slice(0, 10)))) : /* @__PURE__ */ React.createElement("p", { style: { opacity: 0.6, marginTop: 12 } }, "Sem a\xE7\xF5es registadas.")), aEliminar ? /* @__PURE__ */ React.createElement(
    ConfirmModal,
    {
      texto: `Eliminar a palete ${aEliminar.n_palete || "?"}? Esta a\xE7\xE3o remove a contagem e as suas fotos.`,
      onConfirm: eliminarContagem,
      onCancel: () => setAEliminar(null)
    }
  ) : null, lote?.id ? /* @__PURE__ */ React.createElement(
    window.HubActionTimeline,
    {
      appLabel: "cargoplanner",
      appSlug: "cargoplanner",
      resource: "lote",
      resourceId: lote.id,
      me: window.SR_ME,
      streams: { logs: { items: logs } },
      title: "Hist\xF3rico",
      defaultTab: "logs"
    }
  ) : null);
}
function ContarScreen({
  lote,
  locais,
  erro,
  setErro,
  onSaved,
  onCancel,
  prefill,
  contagemId,
  impressora
}) {
  const { useState, useMemo, useEffect } = React;
  const [nPalete, setNPalete] = useState(() => prefill?.n_palete ?? "");
  const [rotulo, setRotulo] = useState(() => prefill?.qtd_rotulo != null ? String(prefill.qtd_rotulo) : "");
  const [contada, setContada] = useState("");
  const [danif, setDanif] = useState("0");
  const [local, setLocal] = useState("");
  const [obs, setObs] = useState("");
  const [loteForn, setLoteForn] = useState(
    () => prefill?.lote_fornecedor ?? ""
  );
  const [files, setFiles] = useState([]);
  const [etiqueta, setEtiqueta] = useState(null);
  const [ocrText, setOcrText] = useState("");
  const [ocrBusy, setOcrBusy] = useState(false);
  const [saving, setSaving] = useState(false);
  const [avisoImpressao, setAvisoImpressao] = useState(null);
  const [imprimindo, setImprimindo] = useState(false);
  useEffect(() => {
    if (!contagemId) return;
    window.IVAPI.get("/api/cargoplanner/contagens/" + contagemId + "/").then((c) => {
      setNPalete(c.n_palete ?? "");
      setRotulo(c.qtd_rotulo != null ? String(c.qtd_rotulo) : "");
      setContada(c.qtd_contada != null ? String(c.qtd_contada) : "");
      setDanif(c.qtd_danificada != null ? String(c.qtd_danificada) : "0");
      setLocal(c.local_danos != null ? String(c.local_danos) : "");
      setObs(c.obs ?? "");
      setLoteForn(c.lote_fornecedor ?? "");
    }).catch((e) => setErro(String(e)));
  }, [contagemId]);
  const previews = useMemo(
    () => files.map((f) => URL.createObjectURL(f)),
    [files]
  );
  useEffect(
    () => () => previews.forEach((u) => URL.revokeObjectURL(u)),
    [previews]
  );
  async function lerEtiqueta(file) {
    if (!file) return;
    setEtiqueta(file);
    setOcrBusy(true);
    setErro("");
    try {
      const text = await window.IVOcrEngine.recognize(file);
      setOcrText(text);
      const parsed = window.IVOcr.parseEtiqueta(text);
      if (parsed.nPalete != null) setNPalete(String(parsed.nPalete));
      if (parsed.qtdRotulo != null) setRotulo(String(parsed.qtdRotulo));
    } catch (e) {
      setErro("Etiqueta guardada, mas leitura autom\xE1tica falhou \u2014 preenche \xE0 m\xE3o. (" + String(e) + ")");
    } finally {
      setOcrBusy(false);
    }
  }
  function addFotos(fileList) {
    setFiles((prev) => [...prev, ...Array.from(fileList)]);
  }
  function removeFoto(idx) {
    setFiles((prev) => prev.filter((_, i) => i !== idx));
  }
  const s = window.IVHelpers.computeSaldo({
    qtdRotulo: Number(rotulo),
    qtdContada: Number(contada),
    qtdDanificada: Number(danif)
  });
  async function guardar() {
    const danos = Number(danif) || 0;
    if (!contagemId && danos > 0 && files.length === 0) {
      setErro("H\xE1 danos \u2014 anexa pelo menos uma foto comprovativa.");
      return;
    }
    setSaving(true);
    setErro("");
    try {
      if (contagemId) {
        const body = {
          n_palete: nPalete,
          qtd_rotulo: Number(rotulo) || 0,
          qtd_contada: Number(contada) || 0,
          qtd_danificada: Number(danif) || 0,
          obs,
          lote_fornecedor: loteForn
        };
        if (local) body.local_danos = Number(local);
        await window.IVAPI.patch(
          "/api/cargoplanner/contagens/" + contagemId + "/",
          body
        );
      } else {
        const fd = new FormData();
        fd.append("lote", lote.id);
        fd.append("n_palete", nPalete);
        fd.append("qtd_rotulo", rotulo || "0");
        fd.append("qtd_contada", contada || "0");
        fd.append("qtd_danificada", danif || "0");
        if (local) fd.append("local_danos", local);
        if (obs) fd.append("obs", obs);
        if (loteForn) fd.append("lote_fornecedor", loteForn);
        files.forEach((f) => fd.append("fotos", f));
        if (etiqueta) fd.append("etiqueta", etiqueta);
        await window.IVAPI.upload("/api/cargoplanner/contagens/", fd);
      }
      onSaved();
    } catch (e) {
      setErro(String(e));
      setSaving(false);
    }
  }
  async function imprimirEtiqueta() {
    if (!loteForn.trim()) {
      setErro("Indica o lote do fornecedor antes de imprimir.");
      return;
    }
    if (!impressora) {
      setErro("Escolha primeiro a impressora onde est\xE1 a trabalhar.");
      return;
    }
    setImprimindo(true);
    setAvisoImpressao(null);
    setErro("");
    try {
      const resposta = await window.IVImprimir({
        lote: loteForn.trim(),
        empresa: impressora.empresa
      });
      setAvisoImpressao(resposta.aviso);
    } catch (e) {
      setErro(String(e));
    } finally {
      setImprimindo(false);
    }
  }
  return /* @__PURE__ */ React.createElement("div", { style: IV_PAGE }, /* @__PURE__ */ React.createElement(ErroBanner, { erro }), contagemId ? /* @__PURE__ */ React.createElement("div", { style: {
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 12px",
    borderRadius: 8,
    marginBottom: 12,
    fontSize: 14
  } }, "A editar contagem existente") : null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 12
  } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0 } }, "Contar palete \u2014 RQ ", lote.rq), /* @__PURE__ */ React.createElement("label", { style: { ...IV_BTN, background: "#475569" } }, ocrBusy ? "A ler etiqueta\u2026" : "\u{1F4C4} Ler etiqueta", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "file",
      accept: "image/*",
      capture: "environment",
      style: { display: "none" },
      disabled: ocrBusy,
      onChange: (e) => {
        lerEtiqueta(e.target.files[0]);
        e.target.value = "";
      }
    }
  )), etiqueta ? /* @__PURE__ */ React.createElement("span", { style: { opacity: 0.7 } }, "etiqueta anexada") : null), /* @__PURE__ */ React.createElement(OcrTextoLido, { texto: ocrText }), /* @__PURE__ */ React.createElement("div", { style: IV_GRID }, /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "N\xBA palete", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      value: nPalete,
      onChange: (e) => setNPalete(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Local de danos", /* @__PURE__ */ React.createElement(
    "select",
    {
      style: IV_INP,
      value: local,
      onChange: (e) => setLocal(e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 local danos \u2014"),
    locais.map((l) => /* @__PURE__ */ React.createElement("option", { key: l.id, value: l.id }, l.label))
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Qtd r\xF3tulo", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      type: "number",
      inputMode: "numeric",
      value: rotulo,
      onChange: (e) => setRotulo(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Qtd contada", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      type: "number",
      inputMode: "numeric",
      value: contada,
      onChange: (e) => setContada(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Qtd danificada", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      type: "number",
      inputMode: "numeric",
      value: danif,
      onChange: (e) => setDanif(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { style: IV_FIELD }, "Lote do fornecedor", /* @__PURE__ */ React.createElement(
    "input",
    {
      style: IV_INP,
      value: loteForn,
      onChange: (e) => setLoteForn(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", { style: { ...IV_FIELD, gridColumn: "1 / -1" } }, "Observa\xE7\xF5es", /* @__PURE__ */ React.createElement(
    "textarea",
    {
      style: { ...IV_INP, minHeight: 60 },
      value: obs,
      onChange: (e) => setObs(e.target.value)
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { ...IV_CARD, marginTop: 12, fontSize: 18 } }, "dif ", /* @__PURE__ */ React.createElement("strong", null, s.dif), " \xB7 saldo ", /* @__PURE__ */ React.createElement("strong", null, s.saldo), " ", s.entregas ? `\xB7 ${s.entregas}` : ""), /* @__PURE__ */ React.createElement("div", { style: {
    ...IV_CARD,
    display: "flex",
    gap: 12,
    alignItems: "center",
    flexWrap: "wrap"
  } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 14 } }, "Etiqueta de rece\xE7\xE3o"), /* @__PURE__ */ React.createElement("button", { style: {
    ...IV_BTN,
    background: "#0f766e",
    padding: "10px 16px",
    fontSize: 15
  }, disabled: imprimindo, onClick: imprimirEtiqueta }, imprimindo ? "A imprimir\u2026" : "\u{1F5A8} Imprimir etiqueta"), avisoImpressao ? /* @__PURE__ */ React.createElement("span", { style: {
    color: avisoImpressao.tipo === "sucesso" ? "#16a34a" : "crimson",
    fontSize: 14
  } }, avisoImpressao.texto) : null), !contagemId ? /* @__PURE__ */ React.createElement("div", { style: IV_CARD }, /* @__PURE__ */ React.createElement("label", { style: IV_BTN }, "\u{1F4F7} Foto de danos", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "file",
      accept: "image/*",
      capture: "environment",
      multiple: true,
      style: { display: "none" },
      onChange: (e) => {
        addFotos(e.target.files);
        e.target.value = "";
      }
    }
  )), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 8 } }, files.length, " foto(s)"), files.length ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 } }, previews.map((url, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: { position: "relative" } }, /* @__PURE__ */ React.createElement("img", { src: url, alt: "", style: {
    width: 88,
    height: 88,
    objectFit: "cover",
    borderRadius: 8
  } }), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => removeFoto(i),
      style: {
        position: "absolute",
        top: -8,
        right: -8,
        width: 26,
        height: 26,
        borderRadius: 13,
        border: "none",
        background: "#dc2626",
        color: "#fff",
        cursor: "pointer",
        fontSize: 16,
        lineHeight: "24px"
      }
    },
    "\xD7"
  )))) : null) : /* @__PURE__ */ React.createElement("div", { style: { ...IV_CARD, opacity: 0.6, fontSize: 14 } }, "Edi\xE7\xE3o de fotos n\xE3o dispon\xEDvel neste modo \u2014 as fotos existentes s\xE3o mantidas."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12 } }, /* @__PURE__ */ React.createElement("button", { style: IV_BTN, disabled: saving, onClick: guardar }, saving ? "A guardar\u2026" : "Guardar palete"), /* @__PURE__ */ React.createElement("button", { style: { ...IV_BTN, background: "#888" }, onClick: onCancel }, "Cancelar")));
}
window.InboundVerumView = InboundVerumView;

// ===== cargoplanner/frontend/rececao_consulta.jsx =====
function InboundVerumConsulta() {
  const { useState, useEffect } = React;
  const [fornecedores, setFornecedores] = useState([]);
  const [forn, setForn] = useState("");
  const [rq, setRq] = useState("");
  const [de, setDe] = useState("");
  const [ate, setAte] = useState("");
  const [rows, setRows] = useState([]);
  const [zoom, setZoom] = useState("");
  const [erro, setErro] = useState("");
  const [vista, setVista] = useState("registos");
  const [acoes, setAcoes] = useState([]);
  const [detalhe, setDetalhe] = useState(null);
  const [detErro, setDetErro] = useState("");
  useEffect(() => {
    window.IVAPI.get("/api/cargoplanner/definicoes/").then((d) => setFornecedores(d.fornecedores)).catch((e) => setErro(String(e)));
  }, []);
  function filtros() {
    const q = new URLSearchParams();
    if (forn) q.set("fornecedor", forn);
    if (rq) q.set("rq", rq);
    if (de) q.set("de", de);
    if (ate) q.set("ate", ate);
    return q;
  }
  async function buscar() {
    try {
      setRows(await window.IVAPI.get(`/api/cargoplanner/contagens/?${filtros()}`));
      setErro("");
    } catch (e) {
      setErro(String(e));
    }
  }
  async function buscarAcoes() {
    try {
      setAcoes(await window.IVAPI.get(`/api/cargoplanner/acoes/?${filtros()}`));
      setErro("");
    } catch (e) {
      setErro(String(e));
    }
  }
  async function abrirDetalhe(loteId) {
    setDetErro("");
    try {
      const [lote, paletes, acs] = await Promise.all([
        window.IVAPI.get(`/api/cargoplanner/lotes/${loteId}/`),
        window.IVAPI.get(`/api/cargoplanner/contagens/?lote=${loteId}`),
        window.IVAPI.get(`/api/cargoplanner/acoes/?lote=${loteId}`)
      ]);
      setDetalhe({ lote, paletes, acoes: acs });
    } catch (e) {
      setDetalhe({ lote: null, paletes: [], acoes: [] });
      setDetErro(String(e));
    }
  }
  useEffect(() => {
    buscar();
    buscarAcoes();
  }, []);
  const ctrl = {
    padding: "6px 10px",
    fontSize: 12.5,
    color: "var(--text)",
    background: "var(--bg)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)"
  };
  const REGISTOS_COLUNAS = [
    {
      key: "forn_rq",
      label: "Forn \xB7 RQ",
      width: 220,
      minWidth: 160,
      fixed: true,
      render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-tight" }, c.fornecedor_nome, " \xB7 ", c.rq, c.linha ? "/" + c.linha : "")
    },
    {
      key: "qtd_rotulo",
      label: "R\xF3tulo",
      width: 90,
      minWidth: 75,
      align: "right",
      mono: true,
      render: (c) => c.qtd_rotulo
    },
    {
      key: "qtd_contada",
      label: "Contada",
      width: 95,
      minWidth: 80,
      align: "right",
      mono: true,
      render: (c) => c.qtd_contada
    },
    {
      key: "qtd_danificada",
      label: "Danif.",
      width: 85,
      minWidth: 70,
      align: "right",
      mono: true,
      render: (c) => c.qtd_danificada
    },
    {
      key: "local_danos_label",
      label: "Local",
      width: 130,
      minWidth: 100,
      render: (c) => c.local_danos_label
    },
    {
      key: "dif",
      label: "Dif",
      width: 75,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (c) => c.dif
    },
    {
      key: "saldo_placas_ok",
      label: "Saldo",
      width: 90,
      minWidth: 75,
      align: "right",
      mono: true,
      render: (c) => /* @__PURE__ */ React.createElement("span", { style: {
        fontWeight: 600,
        color: c.saldo_placas_ok < 0 ? "#c4434b" : "#16a34a"
      } }, c.saldo_placas_ok)
    },
    {
      key: "saldo_entregas",
      label: "Entregas",
      width: 100,
      minWidth: 80,
      align: "right",
      mono: true,
      render: (c) => c.saldo_entregas
    },
    {
      key: "obs",
      label: "Obs",
      width: 200,
      minWidth: 140,
      render: (c) => c.obs
    },
    {
      key: "fotos",
      label: "Fotos",
      width: 220,
      minWidth: 160,
      render: (c) => c.fotos.map((f) => /* @__PURE__ */ React.createElement(
        "img",
        {
          key: f.id,
          src: f.imagem_url,
          alt: "",
          onClick: (e) => {
            e.stopPropagation();
            setZoom(f.imagem_url);
          },
          style: {
            width: 36,
            height: 36,
            objectFit: "cover",
            borderRadius: 4,
            cursor: "pointer",
            marginRight: 4
          }
        }
      ))
    },
    // Data (ISO YYYY-MM-DD, 10 carateres, vinda de DateTimeField cortado a 10).
    {
      key: "criado_em",
      label: "Data",
      width: 120,
      minWidth: 100,
      render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-tight" }, (c.criado_em || "").slice(0, 10))
    }
  ];
  const PALETES_COLUNAS = [
    {
      key: "n_palete",
      label: "Palete",
      width: 120,
      minWidth: 90,
      fixed: true,
      render: (p) => p.n_palete
    },
    {
      key: "qtd_rotulo",
      label: "R\xF3tulo",
      width: 90,
      minWidth: 75,
      align: "right",
      mono: true,
      render: (p) => p.qtd_rotulo
    },
    {
      key: "qtd_contada",
      label: "Contada",
      width: 95,
      minWidth: 80,
      align: "right",
      mono: true,
      render: (p) => p.qtd_contada
    },
    {
      key: "qtd_danificada",
      label: "Danif.",
      width: 85,
      minWidth: 70,
      align: "right",
      mono: true,
      render: (p) => p.qtd_danificada
    },
    {
      key: "dif",
      label: "Dif",
      width: 75,
      minWidth: 60,
      align: "right",
      mono: true,
      render: (p) => p.dif
    },
    {
      key: "saldo_placas_ok",
      label: "Saldo",
      width: 90,
      minWidth: 75,
      align: "right",
      mono: true,
      render: (p) => p.saldo_placas_ok
    },
    {
      key: "obs",
      label: "Obs",
      width: 200,
      minWidth: 140,
      render: (p) => p.obs
    }
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "filters" }, /* @__PURE__ */ React.createElement("select", { style: ctrl, value: forn, onChange: (e) => setForn(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 fornecedor \u2014"), fornecedores.map((f) => /* @__PURE__ */ React.createElement("option", { key: f.id, value: f.id }, f.nome))), /* @__PURE__ */ React.createElement(
    "input",
    {
      style: { ...ctrl, width: 90 },
      placeholder: "RQ",
      value: rq,
      onChange: (e) => setRq(e.target.value)
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      style: ctrl,
      type: "date",
      value: de,
      onChange: (e) => setDe(e.target.value),
      title: "De"
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      style: ctrl,
      type: "date",
      value: ate,
      onChange: (e) => setAte(e.target.value),
      title: "At\xE9"
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      onClick: () => {
        buscar();
        buscarAcoes();
      }
    },
    "Filtrar"
  ), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "filter-chip" + (vista === "registos" ? " active" : ""),
      onClick: () => setVista("registos")
    },
    "Registos"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "filter-chip" + (vista === "timeline" ? " active" : ""),
      onClick: () => setVista("timeline")
    },
    "Timeline"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "filter-chip" + (vista === "etiqueta" ? " active" : ""),
      onClick: () => setVista("etiqueta")
    },
    "Picar etiqueta"
  ))), /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, erro ? /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12.5, marginBottom: 12 } }, erro) : null, vista === "etiqueta" ? /* @__PURE__ */ React.createElement(window.IVPicarEtiqueta, null) : null, vista === "registos" ? /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "cargoplanner",
      viewId: "consulta-contagens",
      columns: REGISTOS_COLUNAS,
      data: rows,
      pagination: "none",
      rowKey: (c) => c.id,
      onRowClick: (c) => abrirDetalhe(c.lote),
      empty: "Sem registos para os filtros."
    }
  ) : vista === "timeline" ? /* @__PURE__ */ React.createElement("div", { className: "panel" }, acoes.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { padding: 24, textAlign: "center" } }, "Sem a\xE7\xF5es registadas.") : acoes.map((a) => /* @__PURE__ */ React.createElement("div", { key: a.id, style: {
    padding: "10px 16px",
    borderBottom: "1px solid var(--border)",
    fontSize: 13
  } }, /* @__PURE__ */ React.createElement("span", { className: "td-mono", style: { color: "var(--muted)" } }, (a.criado_em || "").slice(0, 10)), " \xB7 ", a.fornecedor_nome, " \xB7 RQ ", a.rq, " \xB7 ", /* @__PURE__ */ React.createElement("strong", null, a.tipo_label), a.responsavel_nome ? ` \xB7 ${a.responsavel_nome}` : ""))) : null), detalhe ? (
    // O ModalShell do hub, e não um overlay à mão: este fechava SÓ ao
    // carregar no fundo — sem ✕ e sem Esc —, e o fundo deixou de fechar
    // modais (pedido do João, 2026-09-25).
    /* @__PURE__ */ React.createElement(
      window.ModalShell,
      {
        title: detalhe.lote ? `${detalhe.lote.fornecedor_nome} \xB7 RQ ${detalhe.lote.rq}` + (detalhe.lote.linha ? "/" + detalhe.lote.linha : "") : "Rece\xE7\xE3o",
        width: "min(720px, 92vw)",
        onClose: () => {
          setDetalhe(null);
          setDetErro("");
        }
      },
      detErro ? /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12.5, marginBottom: 12 } }, detErro) : null,
      detalhe.lote ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: "var(--muted)", marginBottom: 14 } }, "Estado: ", detalhe.lote.estado, " \xB7 Rece\xE7\xE3o:", " ", (detalhe.lote.data_rececao || "").slice(0, 10), detalhe.lote.qtd_total != null ? ` \xB7 Total: ${detalhe.lote.qtd_total}` : ""), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, fontWeight: 600, margin: "8px 0 4px" } }, "Paletes"), /* @__PURE__ */ React.createElement(
        window.HubList.List,
        {
          appLabel: "cargoplanner",
          viewId: "consulta-acoes",
          columns: PALETES_COLUNAS,
          data: detalhe.paletes,
          pagination: "none",
          rowKey: (p) => p.id,
          rowStyle: () => ({ cursor: "default" }),
          empty: "Sem paletes."
        }
      ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, fontWeight: 600, margin: "16px 0 4px" } }, "Timeline de a\xE7\xF5es"), detalhe.acoes.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5 } }, "Sem a\xE7\xF5es registadas.") : detalhe.acoes.map((a) => /* @__PURE__ */ React.createElement("div", { key: a.id, style: {
        fontSize: 12.5,
        padding: "4px 0",
        borderBottom: "1px solid var(--border)"
      } }, /* @__PURE__ */ React.createElement("span", { className: "td-mono", style: { color: "var(--muted)" } }, (a.criado_em || "").slice(0, 10)), " \xB7 ", /* @__PURE__ */ React.createElement("strong", null, a.tipo_label), a.responsavel_nome ? ` \xB7 ${a.responsavel_nome}` : ""))) : null
    )
  ) : null, zoom ? /* @__PURE__ */ React.createElement(window.ModalShell, { title: "Foto", width: "auto", onClose: () => setZoom("") }, /* @__PURE__ */ React.createElement("img", { src: zoom, alt: "", style: {
    maxWidth: "86vw",
    maxHeight: "78vh",
    display: "block",
    borderRadius: "var(--radius-lg)"
  } })) : null);
}
window.InboundVerumConsulta = InboundVerumConsulta;

// ===== cargoplanner/frontend/rececao_dashboard-metrics.jsx =====
(function() {
  function fornecedorOf(r) {
    return r.fornecedor;
  }
  function mesOf(r) {
    return (r.data_rececao || "").slice(0, 7);
  }
  function localOf(r) {
    return r.local_danos || "Sem local";
  }
  function tratamentosOf(r) {
    return r.acoes && r.acoes.length ? r.acoes : ["Sem tratamento"];
  }
  const DIMS = {
    fornecedor: (r, v) => fornecedorOf(r) === v,
    mes: (r, v) => mesOf(r) === v,
    local: (r, v) => localOf(r) === v,
    tratamento: (r, v) => tratamentosOf(r).includes(v)
  };
  function applyCrossfilter(rows, filtros, except) {
    return rows.filter((r) => {
      for (const dim of Object.keys(DIMS)) {
        const v = filtros[dim];
        if (v == null || dim === except) continue;
        if (!DIMS[dim](r, v)) return false;
      }
      return true;
    });
  }
  function computeKpis(rows) {
    const lotes = /* @__PURE__ */ new Set();
    let volume = 0, danificadas = 0, saldo = 0, fiaveis = 0;
    rows.forEach((r) => {
      lotes.add(r.lote_id);
      volume += r.qtd_contada;
      danificadas += r.qtd_danificada;
      saldo += r.saldo_placas_ok;
      if (r.qtd_contada === r.qtd_rotulo) fiaveis += 1;
    });
    const nPaletes = rows.length;
    return {
      nPaletes,
      nLotes: lotes.size,
      volume,
      fiabilidade: nPaletes ? fiaveis / nPaletes : 0,
      taxaDanos: volume ? danificadas / volume : 0,
      saldo
    };
  }
  function groupBy(rows, keyFn) {
    const m = /* @__PURE__ */ new Map();
    rows.forEach((r) => {
      const keys = keyFn(r);
      (Array.isArray(keys) ? keys : [keys]).forEach((k) => {
        const g = m.get(k) || { key: k, volume: 0, danificadas: 0, paletes: 0, fiaveis: 0 };
        g.volume += r.qtd_contada;
        g.danificadas += r.qtd_danificada;
        g.paletes += 1;
        if (r.qtd_contada === r.qtd_rotulo) g.fiaveis += 1;
        m.set(k, g);
      });
    });
    return Array.from(m.values());
  }
  function byVolumeDesc(a, b) {
    return b.volume - a.volume;
  }
  function byKeyAsc(a, b) {
    return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
  }
  window.IVDashboardMetrics = {
    fornecedorOf,
    mesOf,
    localOf,
    tratamentosOf,
    applyCrossfilter,
    computeKpis,
    porFornecedor: (rows) => groupBy(rows, fornecedorOf).sort(byVolumeDesc),
    porMes: (rows) => groupBy(rows, mesOf).sort(byKeyAsc),
    porLocalDanos: (rows) => groupBy(rows, localOf).sort(byVolumeDesc),
    porTratamento: (rows) => groupBy(rows, tratamentosOf).sort(byVolumeDesc)
  };
})();

// ===== cargoplanner/frontend/rececao_dashboard.jsx =====
function InboundVerumDashboard() {
  const { useState, useEffect } = React;
  const M = window.IVDashboardMetrics;
  const [fornecedores, setFornecedores] = useState([]);
  const [forn, setForn] = useState("");
  const [de, setDe] = useState("");
  const [ate, setAte] = useState("");
  const [rows, setRows] = useState([]);
  const [erro, setErro] = useState("");
  const [filtros, setFiltros] = useState({});
  useEffect(() => {
    window.IVAPI.get("/api/cargoplanner/definicoes/").then((d) => setFornecedores(d.fornecedores)).catch((e) => setErro(String(e)));
  }, []);
  async function carregar() {
    try {
      const q = new URLSearchParams();
      if (forn) q.set("fornecedor", forn);
      if (de) q.set("de", de);
      if (ate) q.set("ate", ate);
      setRows(await window.IVAPI.get(
        `/api/cargoplanner/dashboard-dataset/?${q}`
      ));
      setErro("");
    } catch (e) {
      setErro(String(e));
    }
  }
  useEffect(() => {
    carregar();
  }, []);
  function pick(dim, key) {
    setFiltros((f) => ({ ...f, [dim]: f[dim] === key ? void 0 : key }));
  }
  const temFiltro = Object.values(filtros).some((v) => v != null);
  const filtered = M.applyCrossfilter(rows, filtros);
  const kpis = M.computeKpis(filtered);
  const byForn = M.porFornecedor(M.applyCrossfilter(rows, filtros, "fornecedor"));
  const byMes = M.porMes(M.applyCrossfilter(rows, filtros, "mes"));
  const byLocal = M.porLocalDanos(M.applyCrossfilter(rows, filtros, "local"));
  const byTrat = M.porTratamento(M.applyCrossfilter(rows, filtros, "tratamento"));
  const ctrl = {
    padding: "6px 10px",
    fontSize: 12.5,
    color: "var(--text)",
    background: "var(--bg)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)"
  };
  const pct = (n) => `${(n * 100).toFixed(1)}%`;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "filters" }, /* @__PURE__ */ React.createElement("select", { style: ctrl, value: forn, onChange: (e) => setForn(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 fornecedor \u2014"), fornecedores.map((f) => /* @__PURE__ */ React.createElement("option", { key: f.id, value: f.id }, f.nome))), /* @__PURE__ */ React.createElement(
    "input",
    {
      style: ctrl,
      type: "date",
      value: de,
      onChange: (e) => setDe(e.target.value),
      title: "De"
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      style: ctrl,
      type: "date",
      value: ate,
      onChange: (e) => setAte(e.target.value),
      title: "At\xE9"
    }
  ), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: carregar }, "Aplicar"), temFiltro ? /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "filter-chip active",
      style: { marginLeft: "auto" },
      onClick: () => setFiltros({})
    },
    "Limpar filtros"
  ) : null), /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, erro ? /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12.5, marginBottom: 12 } }, erro) : null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gap: 12,
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    marginBottom: 16
  } }, /* @__PURE__ */ React.createElement(KPI, { titulo: "Fiabilidade etiqueta", valor: pct(kpis.fiabilidade) }), /* @__PURE__ */ React.createElement(KPI, { titulo: "Taxa de danos", valor: pct(kpis.taxaDanos) }), /* @__PURE__ */ React.createElement(
    KPI,
    {
      titulo: "Volume recebido",
      valor: kpis.volume.toLocaleString("pt-PT"),
      sub: `${kpis.nPaletes} paletes \xB7 ${kpis.nLotes} lotes`
    }
  ), /* @__PURE__ */ React.createElement(
    KPI,
    {
      titulo: "Saldo (placas)",
      valor: kpis.saldo,
      cor: kpis.saldo < 0 ? "#c4434b" : "#16a34a"
    }
  )), rows.length === 0 ? /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "panel td-muted",
      style: { padding: 24, textAlign: "center" }
    },
    "Sem dados para os filtros."
  ) : /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gap: 12,
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))"
  } }, /* @__PURE__ */ React.createElement(
    Barras,
    {
      titulo: "Por fornecedor",
      dados: byForn,
      dim: "fornecedor",
      ativo: filtros.fornecedor,
      onPick: pick,
      valor: (d) => d.volume
    }
  ), /* @__PURE__ */ React.createElement(
    Barras,
    {
      titulo: "Por m\xEAs (rece\xE7\xE3o)",
      dados: byMes,
      dim: "mes",
      ativo: filtros.mes,
      onPick: pick,
      valor: (d) => d.volume
    }
  ), /* @__PURE__ */ React.createElement(
    Barras,
    {
      titulo: "Por local de danos",
      dados: byLocal,
      dim: "local",
      ativo: filtros.local,
      onPick: pick,
      valor: (d) => d.danificadas
    }
  ), /* @__PURE__ */ React.createElement(
    Barras,
    {
      titulo: "Por tratamento",
      dados: byTrat,
      dim: "tratamento",
      ativo: filtros.tratamento,
      onPick: pick,
      valor: (d) => d.paletes
    }
  ))));
}
function KPI({ titulo, valor, sub, cor }) {
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: "12px 14px" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: "var(--muted)" } }, titulo), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 700, color: cor || "var(--text)" } }, valor), sub ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, sub) : null);
}
function Barras({ titulo, dados, dim, ativo, onPick, valor }) {
  const max = Math.max(1, ...dados.map((d) => valor(d)));
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, fontWeight: 600, marginBottom: 8 } }, titulo), dados.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 11.5 } }, "Sem dados.") : dados.map((d) => {
    const on = ativo === d.key;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: d.key,
        onClick: () => onPick(dim, d.key),
        style: {
          cursor: "pointer",
          marginBottom: 5,
          opacity: ativo && !on ? 0.45 : 1
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: 11.5,
        marginBottom: 2
      } }, /* @__PURE__ */ React.createElement("span", null, d.key), /* @__PURE__ */ React.createElement("span", { className: "td-num" }, valor(d).toLocaleString("pt-PT"))),
      /* @__PURE__ */ React.createElement("div", { style: { height: 8, background: "var(--bg)", borderRadius: 4 } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: `${valor(d) / max * 100}%`,
        height: 8,
        background: on ? "#0f766e" : "rgba(15,118,110,0.55)",
        borderRadius: 4
      } }))
    );
  }));
}
window.InboundVerumDashboard = InboundVerumDashboard;

// ===== cargoplanner/frontend/rececao_entry.jsx =====

// ===== cargoplanner/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "cargoplanner",
  order: 11,
  name: "CARGO PLANNER",
  sub: "Planeamento de cargas",
  accent: "#c2410c",
  brandLogo: "/static/assets/cargoplanner-logo.png?v=2",
  brandEmoji: "\u{1F69A}",
  home: "cargoplanner",
  launcher: true,
  // Um perfil pode aterrar num sítio diferente da home normal — o "Operador
  // logístico" cai direto no tablet, não no planeamento. Casa pelo NOME do
  // UserType (a opção mais frágil, escolhida conscientemente: um nome vem
  // de Administração e pode ser mudado ou apagado sem que isto avise — se
  // não corresponder a nada, `homeView` cai sozinho na home de sempre, ver
  // design/src/registry.js). Os dois outros perfis da logística (Responsável
  // e Operador de armazém) não estão aqui de propósito: o Responsável quer
  // mesmo o planeamento, e o Operador de armazém já não vê `cargoplanner`
  // (a rota está escondida para ele — ver migration 0008_perfis_logistica).
  homePorPerfil: { "Log\xEDstica \u2014 Operador log\xEDstico": "cargoplanner_operador" },
  frontendFiles: [
    // Ordem obrigatória: dados e lógica primeiro (os componentes leem-nos
    // do window), zonas a seguir, e o shell que compõe as vistas no fim.
    "frontend/cargoplanner_api.js",
    "frontend/cargoplanner_dados.js",
    "frontend/cargoplanner_logica.js",
    "frontend/ondas_dados.js",
    "frontend/ondas_logica.js",
    "frontend/cargoplanner_rotas.js",
    "frontend/cargoplanner_mapa.jsx",
    "frontend/cargoplanner_morada.jsx",
    "frontend/cargoplanner_recolhas.jsx",
    "frontend/cargoplanner_amostra.jsx",
    "frontend/cargoplanner_carga.jsx",
    "frontend/cargoplanner_seletor_dia.jsx",
    "frontend/cargoplanner_camioes.jsx",
    "frontend/cargoplanner_entregas.jsx",
    "frontend/cargoplanner_ligacao.jsx",
    "frontend/cargoplanner.jsx",
    "frontend/ondas_pessoas.jsx",
    "frontend/ondas_trabalho.jsx",
    "frontend/ondas_disponiveis.jsx",
    "frontend/ondas_timeline.jsx",
    // Antes de ondas.jsx, que o renderiza. O bundle é uma concatenação
    // plana: um ficheiro que não esteja NESTA lista simplesmente não entra,
    // e a referência a `window.OndOndaModal` ficava `undefined` — React #130,
    // sem nada a dizer qual era o componente em falta.
    "frontend/ondas_modal.jsx",
    // Antes de ondas_operador.jsx: usa OndOpBotao/OndOpCampo (bare, mesmo
    // bundle) e é usado por ele (window.OndOpEtiqueta).
    "frontend/ondas_operador_etiqueta.jsx",
    "frontend/ondas_operador.jsx",
    "frontend/ondas_desempenho.jsx",
    "frontend/ondas.jsx",
    "frontend/cargoplanner_config.jsx",
    "frontend/cargoplanner_moradas.jsx",
    "frontend/cargoplanner_reservas.jsx",
    "frontend/cargoplanner_custos.jsx",
    "frontend/cargoplanner_crud.jsx",
    "frontend/cargoplanner_ondas_catalogos.jsx",
    "frontend/cargoplanner_pessoal.jsx",
    "frontend/cargoplanner_shell.jsx",
    "frontend/entry.jsx",
    // Receção (ex-Inbound Verum, programa SP-1) — mesma ordem relativa que
    // tinha no manifesto antigo: helpers → api → impressao → ocr-parser →
    // ocr-engine → qr-parser → qr-engine → picar → definicoes → registo →
    // consulta → dashboard-metrics → dashboard → entry.
    "frontend/rececao_helpers.jsx",
    "frontend/rececao_api.jsx",
    "frontend/rececao_impressao.jsx",
    "frontend/rececao_ocr-parser.jsx",
    "frontend/rececao_ocr-engine.jsx",
    "frontend/rececao_qr-parser.jsx",
    "frontend/rececao_qr-engine.jsx",
    "frontend/rececao_picar.jsx",
    "frontend/rececao_definicoes.jsx",
    "frontend/rececao_registo.jsx",
    "frontend/rececao_consulta.jsx",
    "frontend/rececao_dashboard-metrics.jsx",
    "frontend/rececao_dashboard.jsx",
    "frontend/rececao_entry.jsx"
  ],
  routes: [
    // As abas do topo são o seletor de vistas do próprio shell (como a
    // Primustrack faz com Lista/Kanban/Dashboard): a vista chega em
    // `ctx.viewVariant` e o hub persiste-a por rota.
    {
      id: "cargoplanner",
      section: "Planeamento",
      icon: "dot",
      label: "Planeamento",
      adminOnly: false,
      scoped: true,
      title: "Planeamento",
      tooltip: "Planeamento de cargas e ondas",
      views: [
        { id: "cargas", icon: "list", label: "Cargas" },
        { id: "ondas", icon: "kanban", label: "Ondas" },
        // Vista, e não rota própria: quem planeia as ondas é quem quer medir
        // o que elas deram. Uma rota nova obrigava a `SCOPED_RESOURCES` e a
        // uma migração de deny-rule para não mudar nada sobre quem vê o quê.
        { id: "desempenho", icon: "chart", label: "Desempenho" }
      ],
      defaultView: "cargas"
    },
    // O operador de armazém tem rota própria, e não uma aba dentro do
    // planeamento, porque o gate de acesso do hub é por ROTA (`scoped` +
    // AccessRule com resource = id da rota). Enquanto foi uma aba, não havia
    // como dar-lhe o tablet sem lhe dar também o ecrã de planeamento.
    {
      id: "cargoplanner_operador",
      section: "Planeamento",
      icon: "warehouse",
      label: "Operador",
      adminOnly: false,
      scoped: true,
      title: "Operador",
      tooltip: "A tarefa a fazer agora, para quem est\xE1 no armaz\xE9m"
    },
    // Definições. O catálogo (tipos) antes da frota: um TIR não existe sem um
    // tipo que lhe dê as medidas.
    {
      id: "cargoplanner_tipos_tir",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Tipos de TIR",
      adminOnly: false,
      scoped: true,
      title: "Tipos de TIR",
      tooltip: "Medidas e caracter\xEDsticas de cada tipo de ve\xEDculo"
    },
    {
      id: "cargoplanner_frota",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Frota (TIRs)",
      adminOnly: false,
      scoped: true,
      title: "Frota",
      tooltip: "Os ve\xEDculos concretos, criados a partir de um tipo"
    },
    {
      id: "cargoplanner_transportadoras",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Transportadoras",
      adminOnly: false,
      scoped: true,
      title: "Transportadoras",
      tooltip: "Quem transporta e quanto cobra, por tipo de ve\xEDculo"
    },
    {
      id: "cargoplanner_unidades",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Unidades industriais",
      adminOnly: false,
      scoped: true,
      title: "Unidades industriais",
      tooltip: "A origem e o regresso de uma carga (RF04)"
    },
    {
      id: "cargoplanner_vocabularios",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Vocabul\xE1rios",
      adminOnly: false,
      scoped: true,
      title: "Vocabul\xE1rios",
      tooltip: "Categorias de transporte e tipos de descarga"
    },
    {
      id: "cargoplanner_moradas",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Moradas por corrigir",
      adminOnly: false,
      scoped: true,
      title: "Moradas por corrigir",
      tooltip: "Moradas de entrega cujo ponto no mapa n\xE3o \xE9 de confian\xE7a"
    },
    {
      id: "cargoplanner_reservas",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Reservas de palete",
      adminOnly: false,
      scoped: true,
      title: "Reservas de palete",
      tooltip: "As paletes que o picking tem presas, e em nome de quem"
    },
    {
      id: "cargoplanner_ondas_catalogos",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Turnos e armaz\xE9ns",
      adminOnly: false,
      scoped: true,
      title: "Turnos e armaz\xE9ns",
      tooltip: "Os turnos, as compet\xEAncias e os armaz\xE9ns das ondas"
    },
    {
      id: "cargoplanner_pessoal",
      section: "Defini\xE7\xF5es",
      icon: "dot",
      label: "Pessoal das ondas",
      adminOnly: false,
      scoped: true,
      title: "Pessoal das ondas",
      tooltip: "Quem trabalha nas ondas, em que turno e onde"
    },
    // Receção (ex-Inbound Verum, programa SP-1): o backend já respondia no
    // prefixo da Cargo (tarefas 1-5); estas quatro rotas entram na
    // interface. Nenhuma é `adminOnly` — quem as vê é quem tiver a
    // `AccessRule` (já semeada pela migração 0025_rececao_acessos).
    {
      id: "cargoplanner_rececao",
      section: "Planeamento",
      icon: "list",
      label: "Rece\xE7\xE3o",
      adminOnly: false,
      scoped: true,
      title: "RECE\xC7\xC3O",
      tooltip: "Registo de contagem"
    },
    {
      id: "cargoplanner_rececao_consulta",
      section: "Planeamento",
      icon: "search",
      label: "Consulta da rece\xE7\xE3o",
      adminOnly: false,
      scoped: true,
      title: "RECE\xC7\xC3O \u2014 Consulta",
      tooltip: "Consulta de registos"
    },
    {
      id: "cargoplanner_rececao_dashboard",
      section: "Planeamento",
      icon: "dashboard",
      label: "Fornecedores",
      adminOnly: false,
      scoped: true,
      title: "RECE\xC7\xC3O \u2014 Dashboard",
      tooltip: "Desempenho de fornecedores"
    },
    {
      id: "cargoplanner_rececao_definicoes",
      section: "Defini\xE7\xF5es",
      icon: "cog",
      label: "Rece\xE7\xE3o",
      adminOnly: false,
      scoped: true,
      title: "RECE\xC7\xC3O \u2014 Defini\xE7\xF5es",
      tooltip: "Fornecedores, locais de danos e impressoras"
    }
  ],
  render: {
    // O camião selecionado é a entidade da rota; o dia, a pessoa e o operador
    // são parâmetros de vista — ver "Navegação: o URL é a fonte de verdade".
    cargoplanner: (ctx) => React.createElement(window.CargoplannerView, {
      viewVariant: ctx && ctx.viewVariant,
      entidade: ctx && ctx.entidade,
      params: ctx && ctx.params,
      navigate: ctx && ctx.navigate,
      // O guard de saída: a app tem rascunhos por gravar e o "voltar" do
      // browser não pode deitá-los fora (ver `descarregarTudo`).
      registerLeaveGuard: ctx && ctx.registerLeaveGuard,
      // O utilizador autenticado — para a vista Operador saber por omissão
      // de quem é a ficha (a sua própria, não a de outra pessoa qualquer).
      me: ctx && ctx.me
    }),
    cargoplanner_operador: (ctx) => React.createElement(window.CargoplannerView, {
      viewVariant: "operador",
      params: ctx && ctx.params,
      navigate: ctx && ctx.navigate,
      me: ctx && ctx.me
    }),
    cargoplanner_tipos_tir: () => React.createElement(window.CpTiposTirView),
    cargoplanner_frota: () => React.createElement(window.CpFrotaView),
    cargoplanner_transportadoras: () => React.createElement(window.CpTransportadorasView),
    cargoplanner_unidades: () => React.createElement(window.CpUnidadesView),
    cargoplanner_vocabularios: () => React.createElement(window.CpVocabulariosView),
    cargoplanner_moradas: () => React.createElement(window.CpMoradasView),
    cargoplanner_reservas: () => React.createElement(window.CpReservasView),
    cargoplanner_ondas_catalogos: () => React.createElement(window.CpOndasCatalogosView),
    cargoplanner_pessoal: (ctx) => React.createElement(window.CpPessoalView, {
      params: ctx && ctx.params
    }),
    // Os globais `window.InboundVerum*` mantêm-se como estão — renomeá-los
    // é limpeza da tarefa 7, fora do âmbito desta (só o frontend muda de
    // app; os componentes continuam os mesmos).
    cargoplanner_rececao: () => React.createElement(window.InboundVerumView),
    cargoplanner_rececao_consulta: () => React.createElement(window.InboundVerumConsulta),
    cargoplanner_rececao_dashboard: () => React.createElement(window.InboundVerumDashboard),
    cargoplanner_rececao_definicoes: () => React.createElement(window.InboundVerumDefinicoes)
  }
});

// ===== chat/frontend/view.jsx =====
function ChatAvatarLocal({ url, label, size = 28 }) {
  const initial = ((label || "?").trim()[0] || "?").toUpperCase();
  return /* @__PURE__ */ React.createElement("span", { style: {
    width: size,
    height: size,
    borderRadius: "50%",
    flexShrink: 0,
    overflow: "hidden",
    background: "var(--brand-navy, #2c5d8a)",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: Math.round(size * 0.42),
    fontWeight: 600,
    position: "relative"
  } }, initial, url && /* @__PURE__ */ React.createElement(
    "img",
    {
      src: url,
      alt: "",
      draggable: false,
      onError: (e) => {
        e.currentTarget.style.display = "none";
      },
      style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
    }
  ));
}
function ChatBell({ onOpen }) {
  const [unread, setUnread] = useState(0);
  const refresh = useCallback(async () => {
    try {
      const r = await window.API.chatUnreadCount();
      setUnread(r.unread || 0);
    } catch (e) {
    }
  }, []);
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 3e4);
    return () => clearInterval(t);
  }, [refresh]);
  useEffect(() => {
    const onRealtime = (e) => {
      const d = e.detail;
      if (d && d.type === "notification.new" && d.notification?.link_view === "chat") {
        refresh();
      }
    };
    window.addEventListener("sr:realtime", onRealtime);
    return () => window.removeEventListener("sr:realtime", onRealtime);
  }, [refresh]);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      onClick: onOpen,
      title: "Chat",
      style: { position: "relative" }
    },
    /* @__PURE__ */ React.createElement(Ico.chat, null),
    unread > 0 && /* @__PURE__ */ React.createElement("span", { style: {
      position: "absolute",
      top: -2,
      right: -2,
      background: "#dc2626",
      color: "#fff",
      fontSize: 10,
      fontWeight: 700,
      lineHeight: 1,
      padding: "2px 5px",
      borderRadius: 10,
      minWidth: 16,
      border: "2px solid var(--panel)"
    } }, unread > 99 ? "99+" : unread)
  );
}
function ChatDrawer({ onClose, currentUserId, users = [], userTypes = [], initialConvId, initialTs }) {
  const [convs, setConvs] = useState([]);
  const [openConvId, setOpenConvId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [showAnexos, setShowAnexos] = useState(false);
  useEffect(() => {
    if (initialConvId) setOpenConvId(Number(initialConvId));
  }, [initialConvId, initialTs]);
  useEffect(() => {
    setShowAnexos(false);
  }, [openConvId]);
  const anexosEnabled = window.HubFeatures?.enabled("chat", "anexos") !== false;
  const reload = async () => {
    try {
      const r = await window.API.chatConversations();
      setConvs(r.results || r || []);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    reload();
  }, []);
  const [online, setOnline] = useState(/* @__PURE__ */ new Set());
  useEffect(() => {
    const ws = window.API.openPresenceSocket();
    ws.onmessage = (evt) => {
      try {
        const data = JSON.parse(evt.data);
        if (data.type === "presence.snapshot") {
          setOnline(new Set(data.user_ids));
        } else if (data.type === "member.online") {
          setOnline((prev) => new Set(prev).add(data.user_id));
        } else if (data.type === "member.offline") {
          setOnline((prev) => {
            const n = new Set(prev);
            n.delete(data.user_id);
            return n;
          });
        }
      } catch (e) {
      }
    };
    return () => {
      try {
        ws.close();
      } catch (e) {
      }
    };
  }, []);
  return /* @__PURE__ */ React.createElement(
    DrawerShell,
    {
      title: "Chat",
      onClose,
      headerExtra: /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn primary sm",
          onClick: () => setShowNew(true)
        },
        /* @__PURE__ */ React.createElement(Ico.plus, null),
        " Nova"
      ),
      bodyStyle: { padding: 0 }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "chat-cols" + (openConvId ? " has-open" : ""),
        style: {
          display: "grid",
          gridTemplateColumns: openConvId ? "320px 1fr" : "1fr",
          height: "100%",
          overflow: "hidden"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "chat-conv-list", style: { overflow: "hidden" } }, /* @__PURE__ */ React.createElement(
        ConversationList,
        {
          convs,
          loading,
          openConvId,
          onPick: (c) => setOpenConvId(c.id),
          currentUserId,
          online
        }
      )),
      openConvId && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minHeight: 0, height: "100%" } }, /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: 8
      } }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm chat-back",
          onClick: () => setOpenConvId(null)
        },
        /* @__PURE__ */ React.createElement(Ico.arrowLeft, null),
        " Conversas"
      ), anexosEnabled && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn sm " + (showAnexos ? "primary" : "ghost"),
          onClick: () => setShowAnexos((s) => !s),
          title: "Anexos"
        },
        "\u{1F4CE} Anexos"
      )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flex: 1, minHeight: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column" } }, /* @__PURE__ */ React.createElement(
        window.HubChatEmbed,
        {
          convId: openConvId,
          currentUserId,
          users,
          userTypes,
          onSent: reload
        }
      )), anexosEnabled && showAnexos && /* @__PURE__ */ React.createElement("div", { style: {
        width: 300,
        flexShrink: 0,
        borderLeft: "1px solid var(--border)",
        overflow: "auto",
        padding: 12
      } }, /* @__PURE__ */ React.createElement(
        window.AnexosPanel,
        {
          app: "chat",
          resource: "conversation",
          id: openConvId,
          me: { id: currentUserId }
        }
      ))))
    ),
    showNew && /* @__PURE__ */ React.createElement(
      NewConversationModal,
      {
        users: users.filter((u) => u.id !== currentUserId),
        onClose: () => setShowNew(false),
        onCreated: (c) => {
          setShowNew(false);
          reload();
          setOpenConvId(c.id);
        }
      }
    )
  );
}
function ConversationList({ convs, loading, openConvId, onPick, currentUserId, online = /* @__PURE__ */ new Set() }) {
  if (loading) return /* @__PURE__ */ React.createElement("div", { style: { padding: 16, color: "var(--muted)" } }, "A carregar\u2026");
  const byRecency = (a, b) => {
    const ta = a.last_message?.created_at || a.created_at || "";
    const tb = b.last_message?.created_at || b.created_at || "";
    return tb.localeCompare(ta);
  };
  const dms = convs.filter((c) => c.kind === "dm").sort(byRecency);
  const channels = convs.filter((c) => c.kind === "channel").sort(byRecency);
  const fmtWhen = (s) => {
    if (!s) return "";
    const d = new Date(s);
    const diff = (Date.now() - d.getTime()) / 1e3;
    if (diff < 60) return "agora";
    if (diff < 3600) return `${Math.floor(diff / 60)}m`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
    return d.toLocaleDateString("pt-PT");
  };
  const Row = ({ c, title }) => /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: () => onPick(c),
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "10px 14px",
        border: "none",
        borderBottom: "1px solid var(--border)",
        background: openConvId === c.id ? "var(--bg-2)" : "transparent",
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline"
    } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: c.unread_count ? 600 : 500, fontSize: 13 } }, title), /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 11,
      color: "var(--muted)",
      fontFamily: "var(--font-mono)"
    } }, fmtWhen(c.last_message?.created_at))),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginTop: 2 } }, /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 12,
      color: "var(--muted)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: 220
    } }, c.last_message?.body || "\u2014"), c.unread_count > 0 && /* @__PURE__ */ React.createElement("span", { style: {
      background: "#dc2626",
      color: "#fff",
      borderRadius: 10,
      padding: "0 6px",
      fontSize: 11,
      fontWeight: 700
    } }, c.unread_count))
  );
  return /* @__PURE__ */ React.createElement("div", { style: { borderRight: "1px solid var(--border)", overflow: "auto" } }, dms.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    padding: "6px 14px",
    fontSize: 10.5,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    background: "var(--bg-2)"
  } }, "DMs"), dms.map((c) => {
    const name = c.other_user ? `${c.other_user.first_name || ""} ${c.other_user.last_name || ""}`.trim() || c.other_user.username : "DM";
    return /* @__PURE__ */ React.createElement(
      Row,
      {
        key: c.id,
        c,
        title: /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("span", { style: { position: "relative", display: "inline-flex" } }, /* @__PURE__ */ React.createElement(ChatAvatarLocal, { url: c.other_user?.photo_url, label: name, size: 26 }), /* @__PURE__ */ React.createElement("span", { style: {
          position: "absolute",
          right: -1,
          bottom: -1,
          width: 9,
          height: 9,
          borderRadius: "50%",
          border: "2px solid var(--panel)",
          background: online.has(c.other_user?.id) ? "#16a34a" : "var(--muted-2, #9aa)"
        } })), name)
      }
    );
  }), channels.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    padding: "6px 14px",
    fontSize: 10.5,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    background: "var(--bg-2)"
  } }, "Canais"), channels.map((c) => /* @__PURE__ */ React.createElement(Row, { key: c.id, c, title: "# " + c.name })), convs.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: 20, color: "var(--muted)", fontSize: 12.5 } }, 'Sem conversas. Carrega em "Nova" para come\xE7ar.'));
}
function NewConversationModal({ users, onClose, onCreated }) {
  const [tab, setTab] = useState("dm");
  const [pick, setPick] = useState("");
  const [name, setName] = useState("");
  const [members, setMembers] = useState(/* @__PURE__ */ new Set());
  const [error, setError] = useState(null);
  const submit = async () => {
    setError(null);
    try {
      if (tab === "dm") {
        if (!pick) return;
        const c = await window.API.chatCreateDM(Number(pick));
        onCreated(c);
      } else {
        if (!name.trim() || members.size === 0) {
          setError("Nome + pelo menos 1 membro.");
          return;
        }
        const c = await window.API.chatCreateChannel({
          name: name.trim(),
          description: "",
          member_ids: Array.from(members)
        });
        onCreated(c);
      }
    } catch (e) {
      setError(e.message);
    }
  };
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: "Nova conversa",
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: submit }, "Criar"))
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginBottom: 12 } }, [["dm", "DM"], ["channel", "Canal"]].map(([k, label]) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: k,
        className: "btn " + (tab === k ? "primary" : "ghost") + " sm",
        onClick: () => setTab(k)
      },
      label
    ))),
    error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12, marginBottom: 8 } }, error),
    tab === "dm" && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Utilizador"), /* @__PURE__ */ React.createElement("select", { value: pick, onChange: (e) => setPick(e.target.value), autoFocus: true }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"), users.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username, " (@", u.username, ")")))),
    tab === "channel" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome do canal"), /* @__PURE__ */ React.createElement(
      "input",
      {
        value: name,
        onChange: (e) => setName(e.target.value),
        autoFocus: true,
        placeholder: "ex: whale-ops"
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Membros"), /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      flexWrap: "wrap",
      gap: 4,
      padding: 6,
      maxHeight: 160,
      overflow: "auto",
      border: "1px solid var(--border)",
      borderRadius: "var(--radius)"
    } }, users.map((u) => {
      const on = members.has(u.id);
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: u.id,
          type: "button",
          onClick: () => setMembers((s) => {
            const n = new Set(s);
            if (n.has(u.id)) n.delete(u.id);
            else n.add(u.id);
            return n;
          }),
          style: {
            padding: "4px 10px",
            borderRadius: 14,
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            border: "1px solid transparent",
            background: on ? "var(--accent)" : "var(--bg)",
            color: on ? "#fff" : "var(--text)",
            borderColor: on ? "transparent" : "var(--border)"
          }
        },
        on ? "\u2713 " : "",
        u.username
      );
    }))))
  );
}
window.ChatBell = ChatBell;
window.ChatDrawer = ChatDrawer;

// ===== chat/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "chat",
  order: 100,
  name: "CHAT",
  sub: "Conversas em tempo real",
  accent: "#7a7a7a",
  launcher: false,
  frontendFiles: [
    "frontend/view.jsx"
  ],
  routes: [],
  render: {}
});

// ===== edi/frontend/edi-api.jsx =====
(function() {
  function getCookie(name) {
    const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? m.pop() : "";
  }
  function req(path, { method = "GET", body, params } = {}) {
    let url = path;
    if (params) {
      const q = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v !== void 0 && v !== null && v !== "") q.append(k, v);
      });
      const s = q.toString();
      if (s) url += (url.includes("?") ? "&" : "?") + s;
    }
    const opts = { method, credentials: "same-origin", headers: {} };
    if (body !== void 0) {
      opts.headers["Content-Type"] = "application/json";
      opts.headers["X-CSRFToken"] = getCookie("csrftoken");
      opts.body = JSON.stringify(body);
    } else if (method !== "GET") {
      opts.headers["X-CSRFToken"] = getCookie("csrftoken");
    }
    return fetch(url, opts).then((r) => {
      if (r.status === 204) return null;
      if (!r.ok) {
        return r.json().then((e) => Promise.reject(e)).catch(() => Promise.reject({ status: r.status }));
      }
      return r.json();
    });
  }
  const BASE = "/api/edi";
  window.EdiAPI = {
    // Devolve {rows,total} — a forma que o HubList.List espera em modo server.
    // ATENÇÃO: os chips do HubList guardam os valores num **Set**, não num
    // array (ver hubListToggleSet em packages/hub_shell/src/components.jsx).
    // Espalhar com [...set] e enviar separados por vírgula — o backend faz __in.
    mensagens({ page = 1, pageSize, search = "", filtros = {}, ordering = "" } = {}) {
      const f = filtros || {};
      const lista = (k) => [...f[k] || []].join(",");
      return req(`${BASE}/mensagens/`, {
        params: {
          page,
          page_size: pageSize,
          search,
          ordering,
          parceiro: lista("parceiro"),
          direcao: lista("direcao"),
          tipo: lista("tipo"),
          estado: lista("estado")
        }
      }).then((r) => ({
        rows: r.results || r,
        total: r.count != null ? r.count : (r.results || r).length
      }));
    },
    mensagem(id) {
      return req(`${BASE}/mensagens/${id}/`);
    },
    brutoMensagem(id) {
      return req(`${BASE}/mensagens/${id}/bruto/`);
    },
    reprocessar(id) {
      return req(`${BASE}/mensagens/${id}/reprocessar/`, { method: "POST" });
    },
    reenviar(id) {
      return req(`${BASE}/mensagens/${id}/reenviar/`, { method: "POST" });
    },
    planos({ page = 1, pageSize, search = "", filtros = {}, ordering = "" } = {}) {
      const f = filtros || {};
      const lista = (k) => [...f[k] || []].join(",");
      return req(`${BASE}/planos/`, {
        params: { page, page_size: pageSize, search, ordering, parceiro: lista("parceiro"), tipo: lista("tipo") }
      }).then((r) => ({
        rows: r.results || r,
        total: r.count != null ? r.count : (r.results || r).length
      }));
    },
    parceiros() {
      return req(`${BASE}/parceiros/`).then((r) => r.results || r);
    },
    // URL de download do CSV com os mesmos filtros da lista. O HubList não
    // expõe o estado dos filtros ao pai — quem chama guarda o último `q`
    // recebido no `fetch` e passa-o aqui.
    planosCsvUrl({ search = "", filtros = {} } = {}) {
      const f = filtros || {};
      const q = new URLSearchParams();
      if (search) q.append("search", search);
      const parceiro = [...f.parceiro || []].join(",");
      const tipo = [...f.tipo || []].join(",");
      if (parceiro) q.append("parceiro", parceiro);
      if (tipo) q.append("tipo", tipo);
      const s = q.toString();
      return `${BASE}/planos/csv/${s ? `?${s}` : ""}`;
    },
    // Leitura pontual ao ERP, disparada por um humano em Definições — o
    // ciclo automático nunca chama isto.
    clientePHC(no) {
      return req(`${BASE}/clientes-phc/${encodeURIComponent(no)}/`);
    },
    // O log do motor. Devolve a forma crua (results/count/dias/sessoes) e
    // não {rows,total}: a vista precisa dos dias e das sessões, não só das
    // linhas, e é ela que converte para o que o HubList espera.
    motorLog({ page = 1, pageSize, search = "", dia = "", sessao = "" } = {}) {
      return req(`${BASE}/motor-log/`, {
        params: { page, page_size: pageSize, search, dia, sessao }
      });
    },
    config() {
      return req(`${BASE}/config/`);
    },
    gravarConfig(body) {
      return req(`${BASE}/config/`, { method: "PUT", body });
    },
    criarParceiro(body) {
      return req(`${BASE}/parceiros/`, { method: "POST", body });
    },
    editarParceiro(id, body) {
      return req(`${BASE}/parceiros/${id}/`, { method: "PUT", body });
    },
    apagarParceiro(id) {
      return req(`${BASE}/parceiros/${id}/`, { method: "DELETE" });
    },
    textoTeste(id) {
      return req(`${BASE}/parceiros/${id}/teste/`);
    },
    enviarTeste(id, texto) {
      return req(`${BASE}/parceiros/${id}/teste/`, { method: "POST", body: { texto } });
    }
  };
})();

// ===== edi/frontend/edi_mensagem_drawer.jsx =====
function EdiMensagemDrawer({ mensagem, onClose, onMudou }) {
  const [detalhe, setDetalhe] = React.useState(mensagem);
  const [aReprocessar, setAReprocessar] = React.useState(false);
  const [bruto, setBruto] = React.useState(null);
  const [aCarregarBruto, setACarregarBruto] = React.useState(false);
  const [aReenviar, setAReenviar] = React.useState(false);
  const id = mensagem && mensagem.id;
  React.useEffect(() => {
    if (!id) return;
    setBruto(null);
    window.EdiAPI.mensagem(id).then(setDetalhe).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar a mensagem.", "error"));
  }, [id]);
  function avisoReenvio(estado) {
    if (estado === "erro_envio") {
      return "A escrita falhou da primeira vez, por isso nada chegou ao parceiro. Reenviar vai tentar outra vez. Continuar?";
    }
    if (estado === "enviado") {
      return "O parceiro J\xC1 CONFIRMOU que recebeu esta mensagem. Reenviar vai dar-lhe um documento duplicado. Continuar?";
    }
    if (estado === "entregue_motor") {
      return "Esta mensagem j\xE1 foi entregue ao motor e pode j\xE1 ter seguido. O parceiro pode receber o mesmo documento duas vezes. Continuar?";
    }
    return "Reenviar esta mensagem ao parceiro?";
  }
  function reenviar() {
    window.hubConfirm({ message: avisoReenvio(d.estado) }).then((ok) => {
      if (!ok) return;
      setAReenviar(true);
      window.EdiAPI.reenviar(id).then((r) => {
        setDetalhe(r);
        window.srToast?.("Reenviado \u2014 entregue ao motor.", "success");
        onMudou?.();
      }).catch((e) => window.srToast?.(
        e && e.detail || "N\xE3o foi poss\xEDvel reenviar.",
        "error"
      )).finally(() => setAReenviar(false));
    });
  }
  function verBruto() {
    setACarregarBruto(true);
    window.EdiAPI.brutoMensagem(id).then(setBruto).catch((e) => window.srToast?.(
      e && e.detail || "N\xE3o foi poss\xEDvel ler o conte\xFAdo bruto.",
      "error"
    )).finally(() => setACarregarBruto(false));
  }
  const d = detalhe || mensagem;
  const quando = (v) => v ? String(v).slice(0, 16).replace("T", " ") : "";
  function reprocessar() {
    setAReprocessar(true);
    window.EdiAPI.reprocessar(id).then((r) => {
      setDetalhe(r);
      if (r.is_erro) {
        window.srToast?.("Reprocessado, mas continua em erro.", "error");
      } else {
        window.srToast?.("Mensagem reprocessada.", "success");
      }
      onMudou?.();
    }).catch((e) => window.srToast?.(
      e && e.detail || "N\xE3o foi poss\xEDvel reprocessar.",
      "error"
    )).finally(() => setAReprocessar(false));
  }
  const linha = (label, valor) => /* @__PURE__ */ React.createElement(React.Fragment, { key: label }, /* @__PURE__ */ React.createElement("div", { className: "muted" }, label), /* @__PURE__ */ React.createElement("div", null, valor != null && valor !== "" ? String(valor) : "\u2014"));
  return /* @__PURE__ */ React.createElement(
    window.DrawerShell,
    {
      title: d.ficheiro_nome,
      subtitle: `${d.direcao_label || d.direcao} \xB7 ${d.tipo} \xB7 ${d.parceiro_nome || ""}`,
      onClose
    },
    /* @__PURE__ */ React.createElement("div", { className: "kv-grid", style: { display: "grid", gridTemplateColumns: "auto 1fr", gap: "6px 16px" } }, linha("Estado", d.estado_label || d.estado), linha("Parceiro", d.parceiro_nome), linha("Documento PHC", d.doc_phc), linha("Recebido em", quando(d.recebido_em)), linha("Enviado em", quando(d.enviado_em)), linha(
      d.estado === "rejeitado" ? "Recusado em (NERP)" : "Recibo EERP",
      quando(d.eerp_em)
    ), linha("SHA-256", d.raw_sha256)),
    d.is_erro && /* @__PURE__ */ React.createElement("div", { className: "alert error", style: { marginTop: 16, whiteSpace: "pre-wrap" } }, d.erro || "Erro sem detalhe registado."),
    d.direcao === "out" ? /* @__PURE__ */ React.createElement("div", { style: { marginTop: 16, display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn",
        onClick: reenviar,
        disabled: aReenviar || !d.tem_bruto
      },
      aReenviar ? "A reenviar\u2026" : "Reenviar"
    ), /* @__PURE__ */ React.createElement("span", { className: "muted", style: { fontSize: 12 } }, d.tem_bruto ? "Volta a p\xF4r o documento na pasta de sa\xEDda do parceiro." : "Sem conte\xFAdo arquivado \u2014 este documento nunca chegou a ser constru\xEDdo.")) : /* @__PURE__ */ React.createElement("div", { style: { marginTop: 16, display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn",
        onClick: reprocessar,
        disabled: aReprocessar || !d.raw_sha256
      },
      aReprocessar ? "A reprocessar\u2026" : "Reprocessar"
    ), /* @__PURE__ */ React.createElement("span", { className: "muted", style: { fontSize: 12 } }, "Volta a correr o parser sobre o conte\xFAdo bruto arquivado.")),
    /* @__PURE__ */ React.createElement("div", { style: { marginTop: 16 } }, bruto === null ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost",
        onClick: verBruto,
        disabled: aCarregarBruto || !d.tem_bruto
      },
      aCarregarBruto ? "A carregar\u2026" : "Ver conte\xFAdo bruto"
    ), /* @__PURE__ */ React.createElement("span", { className: "muted", style: { fontSize: 12 } }, d.tem_bruto ? "O que o parceiro enviou, tal como chegou." : "Sem conte\xFAdo arquivado para esta mensagem.")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 13 } }, "Conte\xFAdo bruto"), /* @__PURE__ */ React.createElement("span", { className: "muted", style: { fontSize: 12 } }, bruto.bytes, " bytes", bruto.truncado ? " \xB7 mostrado s\xF3 o in\xEDcio" : ""), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setBruto(null) }, "Esconder")), /* @__PURE__ */ React.createElement("pre", { style: {
      marginTop: 8,
      padding: 8,
      maxHeight: 300,
      overflow: "auto",
      fontSize: 12,
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
      background: "var(--surface-2, #f6f6f6)",
      borderRadius: 4
    } }, bruto.conteudo)))
  );
}
window.EdiMensagemDrawer = EdiMensagemDrawer;

// ===== edi/frontend/edi.jsx =====
function EdiEstadoBadge({ row }) {
  const ok = row.estado === "integrado" || row.estado === "enviado";
  const cor = row.is_erro ? "#c0392b" : ok ? "#2fa25a" : "#9aa3ad";
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    padding: "1px 8px",
    borderRadius: 10,
    fontSize: 12,
    color: "#fff",
    background: cor
  } }, row.estado_label || row.estado);
}
function ediIntOr(v, dflt) {
  const n = parseInt(v, 10);
  return Number.isFinite(n) && n > 0 ? n : dflt;
}
function ediParseSort(raw) {
  if (!raw) return [];
  return raw.split(",").filter(Boolean).map((k) => {
    const dir = k.startsWith("-") ? "desc" : "asc";
    return { key: k.replace(/^-/, ""), dir };
  });
}
function EdiView() {
  const [parceiros, setParceiros] = React.useState([]);
  const [aberta, setAberta] = React.useState(null);
  const [refetch, setRefetch] = React.useState(0);
  const initialParams = window.HubRouter.current().params;
  const initialPage = ediIntOr(initialParams.get("page"), 1);
  const initialPageSize = ediIntOr(initialParams.get("pageSize"), 50);
  const initialSort = ediParseSort(initialParams.get("sort"));
  const [viewState, setViewState] = React.useState({
    page: initialPage,
    pageSize: initialPageSize,
    sort: initialSort
  });
  React.useEffect(() => {
    window.HubRouter.setParams({
      page: viewState.page > 1 ? String(viewState.page) : null,
      pageSize: viewState.pageSize !== 50 ? String(viewState.pageSize) : null,
      sort: viewState.sort.length ? viewState.sort.map((s) => (s.dir === "desc" ? "-" : "") + s.key).join(",") : null
    });
  }, [viewState]);
  React.useEffect(() => {
    window.EdiAPI.parceiros().then(setParceiros).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar os parceiros.", "error"));
  }, []);
  const columns = [
    { key: "criado_em", label: "Quando", width: 150, fixed: true, sortKey: "criado_em", render: (r) => (r.criado_em || "").slice(0, 16).replace("T", " ") },
    { key: "direcao", label: "Dire\xE7\xE3o", width: 100, sortKey: "direcao", render: (r) => r.direcao_label || r.direcao },
    { key: "tipo", label: "Tipo", width: 100, sortKey: "tipo" },
    { key: "parceiro_nome", label: "Parceiro", width: 180, sortKey: "parceiro__nome" },
    { key: "ficheiro_nome", label: "Ficheiro", width: 220, mono: true, sortKey: "ficheiro_nome" },
    { key: "doc_phc", label: "Doc. PHC", width: 130, mono: true, sortKey: "doc_phc" },
    { key: "estado", label: "Estado", width: 130, sortKey: "estado", render: (r) => /* @__PURE__ */ React.createElement(EdiEstadoBadge, { row: r }) }
  ];
  const filters = [
    {
      key: "parceiro",
      type: "chip",
      label: "Parceiro",
      options: parceiros.map((p) => ({ value: String(p.id), label: p.nome }))
    },
    {
      key: "direcao",
      type: "chip",
      label: "Dire\xE7\xE3o",
      options: [{ value: "in", label: "Recebidas" }, { value: "out", label: "Enviadas" }]
    },
    {
      key: "tipo",
      type: "chip",
      label: "Tipo",
      options: [{ value: "DELFOR", label: "DELFOR" }, { value: "DESADV", label: "DESADV" }]
    }
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Mensagens",
      columns,
      filters,
      search: { placeholder: "Pesquisar ficheiro ou documento PHC\u2026" },
      fetch: (q) => window.EdiAPI.mensagens(q),
      pagination: "server",
      refetchToken: refetch,
      rowKey: (r) => r.id,
      onRowClick: (r) => setAberta(r),
      initialPage,
      initialPageSize,
      initialSort,
      onViewState: setViewState,
      empty: "Ainda n\xE3o h\xE1 mensagens EDI.",
      appLabel: "edi",
      viewId: "mensagens"
    }
  ), aberta && /* @__PURE__ */ React.createElement(
    window.EdiMensagemDrawer,
    {
      mensagem: aberta,
      onClose: () => setAberta(null),
      onMudou: () => setRefetch((n) => n + 1)
    }
  ));
}
window.EdiView = EdiView;

// ===== edi/frontend/edi_plano_de_entregas.jsx =====
function EdiPlanodeentregasView() {
  const [parceiros, setParceiros] = React.useState([]);
  const ultimoQuery = React.useRef({});
  const initialParams = window.HubRouter.current().params;
  const initialPage = ediIntOr(initialParams.get("page"), 1);
  const initialPageSize = ediIntOr(initialParams.get("pageSize"), 50);
  const initialSort = ediParseSort(initialParams.get("sort"));
  const [viewState, setViewState] = React.useState({
    page: initialPage,
    pageSize: initialPageSize,
    sort: initialSort
  });
  React.useEffect(() => {
    window.HubRouter.setParams({
      page: viewState.page > 1 ? String(viewState.page) : null,
      pageSize: viewState.pageSize !== 50 ? String(viewState.pageSize) : null,
      sort: viewState.sort.length ? viewState.sort.map((s) => (s.dir === "desc" ? "-" : "") + s.key).join(",") : null
    });
  }, [viewState]);
  React.useEffect(() => {
    window.EdiAPI.parceiros().then(setParceiros).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar os parceiros.", "error"));
  }, []);
  const columns = [
    { key: "data_pedida", label: "Data pedida", width: 120, fixed: true, sortKey: "data_pedida" },
    { key: "referencia", label: "Artigo", width: 140, mono: true, sortKey: "referencia" },
    { key: "quantidade", label: "Quantidade", width: 110, align: "right", sortKey: "quantidade" },
    {
      key: "tipo",
      label: "Tipo",
      width: 100,
      sortKey: "tipo",
      render: (r) => /* @__PURE__ */ React.createElement("span", { style: { color: r.tipo === "firme" ? "inherit" : "var(--muted)" } }, r.tipo_label || r.tipo)
    },
    { key: "parceiro_nome", label: "Parceiro", width: 170, sortKey: "plano__parceiro__nome" },
    { key: "num_encomenda_cliente", label: "Enc. cliente", width: 140, mono: true, sortKey: "num_encomenda_cliente" },
    { key: "referencia_documento", label: "Documento", width: 160, mono: true, sortKey: "plano__referencia_documento" }
  ];
  const filters = [
    {
      key: "parceiro",
      type: "chip",
      label: "Parceiro",
      options: parceiros.map((p) => ({ value: String(p.id), label: p.nome }))
    },
    {
      key: "tipo",
      type: "chip",
      label: "Tipo",
      options: [{ value: "firme", label: "Firme" }, { value: "previsao", label: "Previs\xE3o" }]
    }
  ];
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Plano de entregas",
      toolbar: /* @__PURE__ */ React.createElement("button", { className: "btn", onClick: () => {
        window.open(window.EdiAPI.planosCsvUrl(ultimoQuery.current), "_blank");
      } }, "Exportar CSV"),
      columns,
      filters,
      search: { placeholder: "Pesquisar artigo ou encomenda\u2026" },
      fetch: (q) => {
        ultimoQuery.current = q;
        return window.EdiAPI.planos(q);
      },
      pagination: "server",
      rowKey: (r) => r.id,
      initialPage,
      initialPageSize,
      initialSort,
      onViewState: setViewState,
      empty: "Ainda n\xE3o h\xE1 linhas de plano \u2014 chegam com o primeiro DELFOR.",
      appLabel: "edi",
      viewId: "plano-entregas"
    }
  );
}
window.EdiPlanodeentregasView = EdiPlanodeentregasView;

// ===== edi/frontend/edi_parceiros.jsx =====
function EdiParceiroForm({ inicial, onGravar, onCancelar }) {
  const [f, setF] = React.useState(inicial || {
    nome: "",
    oftp_id: "",
    unb_id: "",
    cliente_phc: "",
    dialeto: "delins_v3",
    pasta_in: "",
    pasta_out: "",
    armazem_nome: "",
    armazem_morada: "",
    is_active: true
  });
  const [aBuscar, setABuscar] = React.useState(false);
  const set = (k) => (e) => setF({
    ...f,
    [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  });
  function buscarDoErp() {
    if (!String(f.cliente_phc || "").trim()) {
      window.srToast?.("Escreve primeiro o n\xBA de cliente PHC.", "error");
      return;
    }
    setABuscar(true);
    window.EdiAPI.clientePHC(f.cliente_phc).then((c) => {
      setF({ ...f, nome: c.nome });
      window.srToast?.(`Nome do ERP: ${c.nome}`, "success");
    }).catch((e) => window.srToast?.(
      e && e.detail || "N\xE3o foi poss\xEDvel consultar o ERP.",
      "error"
    )).finally(() => setABuscar(false));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 12, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 } }, /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement("input", { value: f.nome, onChange: set("nome") })), /* @__PURE__ */ React.createElement("label", null, "OFTP ID (SSID)", /* @__PURE__ */ React.createElement("input", { value: f.oftp_id, onChange: set("oftp_id") })), /* @__PURE__ */ React.createElement("label", null, "Identificador UNB", /* @__PURE__ */ React.createElement("input", { value: f.unb_id || "", onChange: set("unb_id"), placeholder: "por f\xE1brica" })), /* @__PURE__ */ React.createElement("label", null, "N\xBA cliente PHC", /* @__PURE__ */ React.createElement("span", { style: { display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement("input", { value: f.cliente_phc, onChange: set("cliente_phc") }), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn small",
      onClick: buscarDoErp,
      disabled: aBuscar,
      title: "Preencher o nome tal como est\xE1 no ERP"
    },
    aBuscar ? "\u2026" : "Buscar"
  ))), /* @__PURE__ */ React.createElement("label", null, "Dialeto", /* @__PURE__ */ React.createElement("input", { value: f.dialeto, onChange: set("dialeto") })), /* @__PURE__ */ React.createElement("label", null, "Pasta in", /* @__PURE__ */ React.createElement("input", { value: f.pasta_in, onChange: set("pasta_in") })), /* @__PURE__ */ React.createElement("label", null, "Pasta out", /* @__PURE__ */ React.createElement("input", { value: f.pasta_out, onChange: set("pasta_out") })), /* @__PURE__ */ React.createElement("label", { style: { alignSelf: "end" } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: f.is_active, onChange: set("is_active") }), " Ativo")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 8 } }, /* @__PURE__ */ React.createElement("label", null, "Pasta de entrada (motor)", /* @__PURE__ */ React.createElement("input", { value: f.pasta_in || "", onChange: set("pasta_in"), placeholder: "deixar vazio = conven\xE7\xE3o" })), /* @__PURE__ */ React.createElement("label", null, "Pasta de sa\xEDda (motor)", /* @__PURE__ */ React.createElement("input", { value: f.pasta_out || "", onChange: set("pasta_out"), placeholder: "ex. /opt/oftp2/messages/SIMOLDES/outbox" }))), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12, marginTop: 4 } }, "Em branco, usa-se ", /* @__PURE__ */ React.createElement("code", null, "<raiz>/in/<OFTP ID>/"), " e", " ", /* @__PURE__ */ React.createElement("code", null, "out/"), ". Preencher quando o motor tiver estrutura pr\xF3pria \u2014 o mendelson usa ", /* @__PURE__ */ React.createElement("code", null, "<instala\xE7\xE3o>/messages/<parceiro>/inbox|outbox"), "."), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 2fr", gap: 8, marginTop: 8 } }, /* @__PURE__ */ React.createElement("label", null, "Armaz\xE9m (nome)", /* @__PURE__ */ React.createElement("input", { value: f.armazem_nome || "", onChange: set("armazem_nome"), placeholder: "AME" })), /* @__PURE__ */ React.createElement("label", null, "Armaz\xE9m (morada)", /* @__PURE__ */ React.createElement("input", { value: f.armazem_morada || "", onChange: set("armazem_morada"), placeholder: "PARQUE INDUSTRIAL\u2026, LOCALIDADE, PORTUGAL" }))), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12, marginTop: 4 } }, "O armaz\xE9m vai nas colunas ", /* @__PURE__ */ React.createElement("code", null, "Warehouse Name"), " e", " ", /* @__PURE__ */ React.createElement("code", null, "Warehouse Address"), " do ficheiro que o PHC importa."), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement("button", { className: "btn primary", onClick: () => onGravar(f) }, "Gravar"), /* @__PURE__ */ React.createElement("button", { className: "btn", onClick: onCancelar }, "Cancelar")));
}
function EdiTesteDialog({ parceiro, onFechar, onEnviado }) {
  const [texto, setTexto] = React.useState("");
  const [aCarregar, setACarregar] = React.useState(true);
  const [aEnviar, setAEnviar] = React.useState(false);
  React.useEffect(() => {
    window.EdiAPI.textoTeste(parceiro.id).then((r) => setTexto(r.texto || "")).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel preparar o teste.", "error")).finally(() => setACarregar(false));
  }, [parceiro.id]);
  function enviar() {
    setAEnviar(true);
    window.EdiAPI.enviarTeste(parceiro.id, texto).then((m) => {
      window.srToast?.(`Teste entregue ao motor (${m.ficheiro_nome}).`, "success");
      onEnviado?.();
      onFechar();
    }).catch((e) => window.srToast?.(
      e && e.detail || "N\xE3o foi poss\xEDvel enviar o teste.",
      "error"
    )).finally(() => setAEnviar(false));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginBottom: 12 } }, /* @__PURE__ */ React.createElement("h3", { style: { marginTop: 0 } }, "Testar envio a ", parceiro.nome), /* @__PURE__ */ React.createElement("p", { className: "muted", style: { fontSize: 12, marginTop: 0 } }, "Escreve um ficheiro de texto na pasta de sa\xEDda deste parceiro. O motor OFTP2 recolhe-o e envia-o \u2014 o monitor dir\xE1 \xABEntregue ao motor\xBB, que \xE9 o mais longe que se pode afirmar daqui."), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      value: texto,
      onChange: (e) => setTexto(e.target.value),
      disabled: aCarregar,
      rows: 4,
      style: { width: "100%", fontFamily: "monospace", fontSize: 13 }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary",
      onClick: enviar,
      disabled: aCarregar || aEnviar || !texto.trim()
    },
    aEnviar ? "A enviar\u2026" : "Enviar"
  ), /* @__PURE__ */ React.createElement("button", { className: "btn", onClick: onFechar }, "Cancelar")));
}
function EdiParceirosView() {
  const [rows, setRows] = React.useState([]);
  const [edicao, setEdicao] = React.useState(null);
  const [teste, setTeste] = React.useState(null);
  const carregar = React.useCallback(() => {
    window.EdiAPI.parceiros().then(setRows).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar os parceiros.", "error"));
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  function gravar(f) {
    if (!f.nome.trim() || !f.oftp_id.trim()) {
      window.srToast?.("Nome e OFTP ID s\xE3o obrigat\xF3rios.", "error");
      return;
    }
    const p = f.id ? window.EdiAPI.editarParceiro(f.id, f) : window.EdiAPI.criarParceiro(f);
    p.then(() => {
      window.srToast?.(f.id ? "Parceiro atualizado." : "Parceiro criado.", "success");
      setEdicao(null);
      carregar();
    }).catch((e) => window.srToast?.(
      e && e.oftp_id ? "J\xE1 existe um parceiro com esse OFTP ID." : "N\xE3o foi poss\xEDvel gravar.",
      "error"
    ));
  }
  function apagar(row) {
    window.hubConfirm({ message: `Apagar o parceiro "${row.nome}"?` }).then((ok) => {
      if (!ok) return;
      window.EdiAPI.apagarParceiro(row.id).then(() => {
        window.srToast?.("Parceiro apagado.", "success");
        carregar();
      }).catch(() => window.srToast?.(
        "N\xE3o foi poss\xEDvel apagar \u2014 h\xE1 mensagens associadas.",
        "error"
      ));
    });
  }
  const columns = [
    { key: "nome", label: "Nome", width: 200, fixed: true },
    { key: "oftp_id", label: "OFTP ID", width: 130, mono: true },
    { key: "unb_id", label: "UNB", width: 110, mono: true },
    { key: "cliente_phc", label: "Cliente PHC", width: 130, mono: true },
    { key: "dialeto", label: "Dialeto", width: 120 },
    { key: "is_active", label: "Ativo", width: 80, render: (r) => r.is_active ? "Sim" : "N\xE3o" },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 250,
      render: (r) => /* @__PURE__ */ React.createElement("span", { style: { display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement("button", { className: "btn small", onClick: (e) => {
        e.stopPropagation();
        setEdicao(r);
      } }, "Editar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn small",
          title: r.is_active ? "Enviar um ficheiro de teste pela liga\xE7\xE3o OFTP2" : "O parceiro est\xE1 inativo",
          disabled: !r.is_active,
          onClick: (e) => {
            e.stopPropagation();
            setTeste(r);
          }
        },
        "Testar envio"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn small", onClick: (e) => {
        e.stopPropagation();
        apagar(r);
      } }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, edicao ? /* @__PURE__ */ React.createElement(
    EdiParceiroForm,
    {
      inicial: edicao === "novo" ? null : edicao,
      onGravar: gravar,
      onCancelar: () => setEdicao(null)
    }
  ) : null, teste ? /* @__PURE__ */ React.createElement(
    EdiTesteDialog,
    {
      parceiro: teste,
      onFechar: () => setTeste(null),
      onEnviado: carregar
    }
  ) : null, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Parceiros",
      toolbar: /* @__PURE__ */ React.createElement("button", { className: "btn primary", onClick: () => setEdicao("novo") }, "Novo parceiro"),
      columns,
      data: rows,
      search: { fields: ["nome", "oftp_id", "cliente_phc"], placeholder: "Pesquisar parceiro\u2026" },
      pagination: "client",
      rowKey: (r) => r.id,
      empty: "Ainda n\xE3o h\xE1 parceiros EDI configurados.",
      appLabel: "edi",
      viewId: "parceiros"
    }
  ));
}
window.EdiParceirosView = EdiParceirosView;

// ===== edi/frontend/edi_ligacoes.jsx =====
function EdiSaudePainel({ saude }) {
  if (!saude) return null;
  const cartao = (label, valor, alerta) => /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 12, minWidth: 150 } }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, label), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, color: alerta ? "#c0392b" : "inherit" } }, valor));
  const ultima = saude.ultima_mensagem_em ? String(saude.ultima_mensagem_em).slice(0, 16).replace("T", " ") : "\u2014";
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 } }, cartao("Mensagens", saude.total), cartao("Em erro", saude.em_erro, saude.em_erro > 0), cartao("Parceiros ativos", saude.parceiros_ativos), cartao("\xDAltima mensagem", ultima));
}
function EdiLigacoesView() {
  const [cfg, setCfg] = React.useState(null);
  const [saude, setSaude] = React.useState(null);
  const [aGravar, setAGravar] = React.useState(false);
  const carregar = React.useCallback(() => {
    window.EdiAPI.config().then((r) => {
      const { saude: s, ...resto } = r;
      setCfg(resto);
      setSaude(s);
    }).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar a configura\xE7\xE3o.", "error"));
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  if (!cfg) return /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 12 } }, "A carregar\u2026");
  const set = (k) => (e) => setCfg({
    ...cfg,
    [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  });
  function gravar() {
    setAGravar(true);
    window.EdiAPI.gravarConfig({
      motor_raiz: cfg.motor_raiz,
      arquivo_raiz: cfg.arquivo_raiz,
      motor_log_raiz: cfg.motor_log_raiz,
      is_enabled: cfg.is_enabled,
      nosso_oftp_id: cfg.nosso_oftp_id,
      nosso_unb_id: cfg.nosso_unb_id,
      phc_doc_guia: cfg.phc_doc_guia,
      phc_doc_picking: cfg.phc_doc_picking,
      phc_import_dir: cfg.phc_import_dir,
      phc_formato: cfg.phc_formato,
      dias_retroativos: cfg.dias_retroativos
    }).then((r) => {
      setSaude(r.saude);
      window.srToast?.("Configura\xE7\xE3o gravada.", "success");
    }).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel gravar.", "error")).finally(() => setAGravar(false));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EdiSaudePainel, { saude }), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Motor OFTP2")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 10, maxWidth: 640, marginTop: 8 } }, /* @__PURE__ */ React.createElement("label", null, "Raiz das pastas do motor", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.motor_raiz || "",
      onChange: set("motor_raiz"),
      placeholder: "/var/edi"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "A pasta que cont\xE9m ", /* @__PURE__ */ React.createElement("code", null, "in/<OFTP ID>/"), " e ", /* @__PURE__ */ React.createElement("code", null, "out/<OFTP ID>/"), ".")), /* @__PURE__ */ React.createElement("label", null, "Pasta de arquivo do conte\xFAdo bruto", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.arquivo_raiz || "",
      onChange: set("arquivo_raiz"),
      placeholder: "/var/edi/arquivo"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "Onde o hub guarda cada ficheiro recebido, para poder reprocessar. Fora do reposit\xF3rio.")), /* @__PURE__ */ React.createElement("label", null, "Pasta do log do motor", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.motor_log_raiz || "",
      onChange: set("motor_log_raiz"),
      placeholder: "/var/edi/log"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "Onde o motor escreve ", /* @__PURE__ */ React.createElement("code", null, "<AAAAMMDD>/oftp2.log"), ". \xC9 daqui que se sabe se o parceiro aceitou (EERP) ou recusou (NERP) cada ficheiro. Em branco, as mensagens de sa\xEDda ficam em \xABEntregue ao motor\xBB e nunca avan\xE7am.")), /* @__PURE__ */ React.createElement("label", null, "O nosso OFTP ID", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.nosso_oftp_id || "",
      onChange: set("nosso_oftp_id"),
      placeholder: "O0013PT0001"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "Vai como remetente nos ficheiros que enviamos.")), /* @__PURE__ */ React.createElement("label", null, "O nosso identificador UNB", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.nosso_unb_id || "",
      onChange: set("nosso_unb_id"),
      placeholder: "igual ao SSID, se n\xE3o houver outro"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "Vai dentro das mensagens (segmento UNB). \xC9 diferente do SSID, que identifica a esta\xE7\xE3o OFTP2.")), /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!cfg.is_enabled, onChange: set("is_enabled") }), " ", "Watcher ativo", /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "Desligado, os ciclos de entrada e de sa\xEDda n\xE3o fazem nada.")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn primary", onClick: gravar, disabled: aGravar }, aGravar ? "A gravar\u2026" : "Gravar"))), /* @__PURE__ */ React.createElement("p", { className: "muted", style: { marginTop: 16, fontSize: 12 } }, "O estado dos timers ", /* @__PURE__ */ React.createElement("code", null, "edi-poll-inbox.timer"), " e", /* @__PURE__ */ React.createElement("code", null, " edi-scan-phc.timer"), " aparece na Administra\xE7\xE3o \u2192 Tarefas agendadas.")), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 12, marginTop: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Sa\xEDda (PHC \u2192 cliente)")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 10, maxWidth: 640, marginTop: 8 } }, /* @__PURE__ */ React.createElement("label", null, "Nome do documento de guia de remessa no PHC", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.phc_doc_guia || "",
      onChange: set("phc_doc_guia"),
      placeholder: "Guia de Remessa"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "Tem de ser exatamente como est\xE1 no PHC (", /* @__PURE__ */ React.createElement("code", null, "bo.nmdos"), "). Em branco, o scan de sa\xEDda n\xE3o procura nada.")), /* @__PURE__ */ React.createElement("label", null, "Dossier de picking no PHC", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.phc_doc_picking || "",
      onChange: set("phc_doc_picking"),
      placeholder: "08 - picking 2"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "De onde saem os volumes e lotes do AVIEXP (", /* @__PURE__ */ React.createElement("code", null, "bo.nmdos"), "). Um lote = um volume, e o n\xBA de lote \xE9 a etiqueta. Em branco, o canal ODETTE n\xE3o procura nada.")), /* @__PURE__ */ React.createElement("label", null, "Pasta de importa\xE7\xE3o do PHC", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: cfg.phc_import_dir || "",
      onChange: set("phc_import_dir"),
      placeholder: "//servidor/phc/importacao"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "A pasta da rede que o PHC vigia. \xC9 aqui que o hub larga o", /* @__PURE__ */ React.createElement("code", null, " .xls"), ' gerado a partir de cada DELFOR. Em branco, o plano fica em "parseado" e nada \xE9 entregue ao ERP.')), /* @__PURE__ */ React.createElement("label", null, "Formato do ficheiro para o PHC", /* @__PURE__ */ React.createElement("select", { value: cfg.phc_formato || "xls", onChange: set("phc_formato") }, /* @__PURE__ */ React.createElement("option", { value: "xls" }, "Excel 97-2003 (.xls)"), /* @__PURE__ */ React.createElement("option", { value: "csv" }, "CSV (.csv)")), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "O ", /* @__PURE__ */ React.createElement("code", null, ".xls"), " \xE9 o formato que o importador do PHC recebe hoje. O CSV (separador ", /* @__PURE__ */ React.createElement("code", null, ";"), ", UTF-8 com BOM) ainda n\xE3o foi confirmado com o PHC.")), /* @__PURE__ */ React.createElement("label", null, "Dias para tr\xE1s em cada scan", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: "1",
      max: "365",
      value: cfg.dias_retroativos ?? 7,
      onChange: set("dias_retroativos")
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 12 } }, "Janela que o ciclo de 5 minutos varre \xE0 procura de guias novas.")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn primary", onClick: gravar, disabled: aGravar }, aGravar ? "A gravar\u2026" : "Gravar")))));
}
window.EdiLigacoesView = EdiLigacoesView;

// ===== edi/frontend/edi_log_do_motor.jsx =====
function ediLogTom(texto) {
  if (/\(NERP\)|não pode ser alcançado|protegido contra escrita/i.test(texto)) {
    return { cor: "#c0392b", peso: 600 };
  }
  if (/\(EERP\)/.test(texto)) return { cor: "#2fa25a", peso: 600 };
  if (/Exame do certificado TLS/i.test(texto)) return { cor: "#b7791f" };
  return {};
}
function EdiLogdomotorView() {
  const initialParams = window.HubRouter.current().params;
  const [dias, setDias] = React.useState([]);
  const [dia, setDia] = React.useState(initialParams.get("dia") || "");
  const [sessoes, setSessoes] = React.useState([]);
  const [sessao, setSessao] = React.useState(initialParams.get("sessao") || "");
  const [erro, setErro] = React.useState("");
  const initialPage = ediIntOr(initialParams.get("page"), 1);
  const initialPageSize = ediIntOr(initialParams.get("pageSize"), 100);
  const [viewState, setViewState] = React.useState({
    page: initialPage,
    pageSize: initialPageSize,
    sort: []
  });
  const [refetch, setRefetch] = React.useState(0);
  const montado = React.useRef(false);
  React.useEffect(() => {
    if (!montado.current) {
      montado.current = true;
      return;
    }
    setRefetch((n) => n + 1);
  }, [dia, sessao]);
  React.useEffect(() => {
    window.HubRouter.setParams({
      dia: dia || null,
      sessao: sessao || null,
      page: viewState.page > 1 ? String(viewState.page) : null,
      pageSize: viewState.pageSize !== 100 ? String(viewState.pageSize) : null
    });
  }, [dia, sessao, viewState]);
  function carregar(q) {
    return window.EdiAPI.motorLog({ ...q, dia, sessao }).then((r) => {
      setErro("");
      setDias(r.dias || []);
      if (r.dia && r.dia !== dia) setDia(r.dia);
      setSessoes(r.sessoes || []);
      return { rows: r.results || [], total: r.count || 0 };
    }).catch((e) => {
      setErro(e && e.detail || "N\xE3o foi poss\xEDvel ler o log do motor.");
      return { rows: [], total: 0 };
    });
  }
  const columns = [
    {
      key: "quando",
      label: "Hora",
      width: 90,
      fixed: true,
      sortable: false,
      render: (r) => (r.quando || "").slice(11, 19)
    },
    {
      key: "sessao",
      label: "Sess\xE3o",
      width: 170,
      mono: true,
      sortable: false,
      render: (r) => r.sessao ? /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          title: "Ver s\xF3 esta sess\xE3o",
          onClick: (ev) => {
            ev.stopPropagation();
            setSessao(r.sessao);
          }
        },
        r.sessao
      ) : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    {
      key: "contexto",
      label: "Origem",
      width: 150,
      sortable: false,
      render: (r) => r.contexto || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    {
      key: "texto",
      label: "Mensagem",
      width: 620,
      sortable: false,
      render: (r) => {
        const tom = ediLogTom(r.texto);
        return /* @__PURE__ */ React.createElement("span", { style: {
          color: tom.cor,
          fontWeight: tom.peso,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word"
        } }, r.texto);
      }
    }
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 12, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("label", { style: { display: "flex", gap: 6, alignItems: "center" } }, "Dia", /* @__PURE__ */ React.createElement("select", { value: dia, onChange: (e) => setDia(e.target.value) }, !dias.length && /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), dias.map((d) => /* @__PURE__ */ React.createElement("option", { key: d, value: d }, d)))), sessao ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Sess\xE3o"), /* @__PURE__ */ React.createElement("code", null, sessao), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSessao("") }, "Ver o dia todo")) : /* @__PURE__ */ React.createElement("span", { className: "muted", style: { fontSize: 12 } }, sessoes.length ? `${sessoes.length} sess\xF5es neste dia \u2014 carrega numa para a isolar.` : "Carrega numa sess\xE3o para ver s\xF3 as linhas dela.")), erro && /* @__PURE__ */ React.createElement("div", { className: "alert error", style: { marginTop: 10 } }, erro)), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Log do motor",
      columns,
      search: { placeholder: "Pesquisar no texto, na origem ou na transa\xE7\xE3o\u2026" },
      fetch: carregar,
      pagination: "server",
      refetchToken: refetch,
      rowKey: (r) => r.id,
      initialPage,
      initialPageSize,
      onViewState: setViewState,
      empty: "Sem linhas para este dia.",
      appLabel: "edi",
      viewId: "log-motor"
    }
  ));
}
window.EdiLogdomotorView = EdiLogdomotorView;

// ===== edi/frontend/entry.jsx =====
window.EdiView = window.EdiView || (() => null);
window.EdiPlanodeentregasView = window.EdiPlanodeentregasView || (() => null);
window.EdiParceirosView = window.EdiParceirosView || (() => null);
window.EdiLigacoesView = window.EdiLigacoesView || (() => null);

// ===== edi/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "edi",
  order: 10,
  name: "EDI",
  sub: "Broker EDI OFTP2",
  accent: "#6b4fbb",
  brandLogo: "/static/assets/edi-logo.png?v=3",
  home: "edi",
  launcher: true,
  frontendFiles: [
    "frontend/edi-api.jsx",
    "frontend/edi_mensagem_drawer.jsx",
    "frontend/edi.jsx",
    "frontend/edi_plano_de_entregas.jsx",
    "frontend/edi_parceiros.jsx",
    "frontend/edi_ligacoes.jsx",
    "frontend/edi_log_do_motor.jsx",
    "frontend/entry.jsx"
  ],
  routes: [
    { id: "edi", section: "Mensagens", icon: "dot", label: "Mensagens", adminOnly: false, title: "Mensagens", tooltip: "Mensagens" },
    { id: "edi_plano_de_entregas", section: "Plano de entregas", icon: "dot", label: "Plano de entregas", adminOnly: false, title: "Plano de entregas", tooltip: "Plano de entregas" },
    { id: "edi_parceiros", section: "Defini\xE7\xF5es", icon: "dot", label: "Parceiros", adminOnly: true, title: "Parceiros", tooltip: "Parceiros" },
    { id: "edi_ligacoes", section: "Defini\xE7\xF5es", icon: "dot", label: "Liga\xE7\xF5es", adminOnly: true, title: "Liga\xE7\xF5es", tooltip: "Liga\xE7\xF5es" },
    { id: "edi_log_do_motor", section: "Defini\xE7\xF5es", icon: "dot", label: "Log do motor", adminOnly: true, title: "Log do motor", tooltip: "O que o motor OFTP2 andou a fazer" }
  ],
  render: {
    edi: () => React.createElement(window.EdiView),
    edi_plano_de_entregas: () => React.createElement(window.EdiPlanodeentregasView),
    edi_parceiros: () => React.createElement(window.EdiParceirosView),
    edi_ligacoes: () => React.createElement(window.EdiLigacoesView),
    edi_log_do_motor: () => React.createElement(window.EdiLogdomotorView)
  }
});

// ===== hivebox/frontend/dev-board-forms.jsx =====
function devbErroApi(e) {
  if (window.API.isNetworkError(e)) return { campos: null, texto: "Sem liga\xE7\xE3o ao servidor." };
  const msg = String(e && e.message || e);
  const m = msg.match(/^(.*?→\s*(\d+)):\s*([\s\S]*)$/);
  if (!m) return { campos: null, texto: msg.slice(0, 120) };
  const [, cabecalho, estado, corpoTxt] = m;
  let corpo = null;
  try {
    corpo = JSON.parse(corpoTxt);
  } catch (_) {
  }
  const ehObjeto = corpo && typeof corpo === "object" && !Array.isArray(corpo);
  if (estado === "400" && ehObjeto) {
    const entradas = Object.entries(corpo);
    const texto = entradas.length === 1 ? String(entradas[0][1]) : entradas.map(([k, v]) => `${k}: ${v}`).join("; ");
    return { campos: corpo, texto: texto || "Pedido inv\xE1lido." };
  }
  if (ehObjeto && typeof corpo.detail === "string") {
    return { campos: null, texto: corpo.detail.slice(0, 200) };
  }
  return { campos: null, texto: cabecalho.slice(0, 120) };
}
function devbCorpoCartao(inicial, form) {
  const normalizado = (valor) => valor === null || valor === void 0 ? "" : valor;
  const editar = !!(inicial && inicial.id);
  const campos = {
    titulo: form.titulo,
    rotulo: form.rotulo,
    app: form.app || "",
    fase: form.fase,
    motivo: form.motivo,
    descricao: form.descricao
  };
  const programaNovo = form.programa ? Number(form.programa) : null;
  if (!editar) {
    return { ...campos, programa: programaNovo };
  }
  const corpo = {};
  Object.keys(campos).forEach((k) => {
    if (normalizado(campos[k]) !== normalizado(inicial[k])) corpo[k] = campos[k];
  });
  const programaInicial = inicial.programa_id != null ? inicial.programa_id : null;
  if (programaNovo !== programaInicial) corpo.programa = programaNovo;
  return corpo;
}
function DevBoardCartaoModal({ inicial, fases, programas, onClose, onGuardado }) {
  const [erro, setErro] = React.useState("");
  const roster = window.HUB_REG.appRoster();
  const editar = !!(inicial && inicial.id);
  const programaAtualArquivado = editar && inicial.programa_id != null && !(programas || []).some((p) => p.id === inicial.programa_id);
  const fields = [
    { key: "titulo", label: "T\xEDtulo", required: true, autoFocus: true },
    { key: "rotulo", label: "R\xF3tulo" },
    {
      key: "programa",
      label: "Programa",
      type: "select",
      options: [
        { value: "", label: "\u2014 sem programa \u2014" },
        ...(programas || []).map((p) => ({ value: String(p.id), label: p.titulo })),
        ...programaAtualArquivado ? [{ value: String(inicial.programa_id), label: `${inicial.programa} (arquivado)` }] : []
      ]
    },
    {
      key: "app",
      label: "App",
      type: "select",
      options: [
        { value: "", label: "\u2014 nenhuma \u2014" },
        ...roster.map((a) => ({ value: a.app_label, label: a.name }))
      ]
    },
    {
      key: "fase",
      label: "Fase",
      type: "select",
      options: (fases || []).map((f) => ({ value: f.id, label: f.label }))
    },
    { key: "motivo", label: "Motivo (bloqueio)" },
    { key: "descricao", label: "Descri\xE7\xE3o", type: "textarea" }
  ];
  const initial = {
    titulo: inicial && inicial.titulo || "",
    rotulo: inicial && inicial.rotulo || "",
    programa: inicial && inicial.programa_id != null ? String(inicial.programa_id) : "",
    app: inicial && inicial.app || "",
    fase: inicial && inicial.fase || ((fases || [])[0] || {}).id || "ideia",
    motivo: inicial && inicial.motivo || "",
    descricao: inicial && inicial.descricao || ""
  };
  const onSubmit = async (form) => {
    const patch = devbCorpoCartao(inicial, form);
    if (editar && Object.keys(patch).length === 0) {
      onClose();
      return;
    }
    try {
      if (editar) await window.API.devBoardEditarCard(inicial.id, patch);
      else await window.API.devBoardCriarCard(patch);
      onGuardado();
    } catch (e) {
      setErro(devbErroApi(e).texto);
    }
  };
  return /* @__PURE__ */ React.createElement(
    SimpleFormModal,
    {
      title: editar ? "Editar cart\xE3o" : "Novo cart\xE3o",
      fields,
      initial,
      onClose,
      onSubmit,
      erro
    }
  );
}
function DevBoardProgramaModal({ inicial, onClose, onGuardado }) {
  const [erro, setErro] = React.useState("");
  const editar = !!(inicial && inicial.id);
  const fields = [
    { key: "titulo", label: "T\xEDtulo", required: true, autoFocus: true },
    { key: "objetivo", label: "Objetivo", type: "textarea" },
    { key: "spec", label: "Spec" }
  ];
  const initial = {
    titulo: inicial && inicial.titulo || "",
    objetivo: inicial && inicial.objetivo || "",
    spec: inicial && inicial.spec || ""
  };
  const onSubmit = async (form) => {
    const patch = { titulo: form.titulo, objetivo: form.objetivo, spec: form.spec };
    try {
      if (editar) await window.API.devBoardEditarPrograma(inicial.id, patch);
      else await window.API.devBoardCriarPrograma(patch);
      onGuardado();
    } catch (e) {
      setErro(devbErroApi(e).texto);
    }
  };
  return /* @__PURE__ */ React.createElement(
    SimpleFormModal,
    {
      title: editar ? "Editar programa" : "Novo programa",
      fields,
      initial,
      onClose,
      onSubmit,
      erro
    }
  );
}
function DevBoardTextoModal({ titulo, rotulo, inicial, obrigatorio, onClose, onGuardar }) {
  const [erro, setErro] = React.useState("");
  const fields = [{ key: "valor", label: rotulo, required: !!obrigatorio, autoFocus: true }];
  const initial = { valor: inicial || "" };
  const onSubmit = async (form) => {
    try {
      await onGuardar(form.valor);
      onClose();
    } catch (e) {
      setErro(devbErroApi(e).texto);
    }
  };
  return /* @__PURE__ */ React.createElement(
    SimpleFormModal,
    {
      title: titulo,
      fields,
      initial,
      onClose,
      onSubmit,
      erro
    }
  );
}
function DevBoardLigarModal({ papeis, onClose, onGuardar }) {
  const [erro, setErro] = React.useState("");
  const fields = [
    { key: "branch", label: "Branch", required: true, autoFocus: true },
    {
      key: "papel",
      label: "Papel",
      type: "select",
      options: (papeis || []).map((p) => ({ value: p.id, label: p.label }))
    },
    { key: "worktree_maquina", label: "M\xE1quina (worktree)" },
    { key: "worktree_caminho", label: "Caminho da worktree" }
  ];
  const initial = { branch: "", papel: "entrega", worktree_maquina: "", worktree_caminho: "" };
  const onSubmit = async (form) => {
    const data = {
      branch: form.branch,
      papel: form.papel,
      worktree_maquina: form.worktree_maquina,
      worktree_caminho: form.worktree_caminho
    };
    try {
      await onGuardar(data);
      onClose();
    } catch (e) {
      setErro(devbErroApi(e).texto);
    }
  };
  return /* @__PURE__ */ React.createElement(
    SimpleFormModal,
    {
      title: "Ligar branch",
      fields,
      initial,
      onClose,
      onSubmit,
      erro
    }
  );
}
window.devbErroApi = devbErroApi;
window.DevBoardCartaoModal = DevBoardCartaoModal;
window.DevBoardProgramaModal = DevBoardProgramaModal;
window.DevBoardTextoModal = DevBoardTextoModal;
window.DevBoardLigarModal = DevBoardLigarModal;

// ===== hivebox/frontend/dev-board-arrastar.js =====
function devbNovaOrdem(ids, arrastado, antesDe) {
  const sem = ids.filter((id) => id !== arrastado);
  const idx = antesDe == null || antesDe === arrastado ? -1 : sem.indexOf(antesDe);
  if (idx === -1) {
    sem.push(arrastado);
    return sem;
  }
  sem.splice(idx, 0, arrastado);
  return sem;
}
function devbDestinoValido(origem, destino, variante) {
  if (!origem || !destino) return false;
  if (origem.coluna !== destino.coluna) return false;
  if (variante === "plano" && origem.faixa !== destino.faixa) return false;
  return true;
}
function devbAplicarLocal(faixas, arrastadoId, destino, idsDestino) {
  let cartao = null;
  const semArrastado = faixas.map((f) => ({
    ...f,
    colunas: f.colunas.map((c) => {
      if (!c.cards.some((k) => k.id === arrastadoId)) return c;
      cartao = c.cards.find((k) => k.id === arrastadoId);
      return { ...c, cards: c.cards.filter((k) => k.id !== arrastadoId) };
    })
  }));
  if (!cartao) return faixas;
  const chaveFaixa = (f) => f.programa ? f.programa.id : null;
  return semArrastado.map((f) => {
    if (chaveFaixa(f) !== destino.faixa) return f;
    return {
      ...f,
      colunas: f.colunas.map((c) => {
        if (c.id !== destino.coluna) return c;
        const porId = new Map(c.cards.map((k) => [k.id, k]));
        porId.set(arrastadoId, cartao);
        return { ...c, cards: idsDestino.map((id) => porId.get(id)).filter(Boolean) };
      })
    };
  });
}
function devbRespeitaBloqueados(idsFinal, bloqueadosIds) {
  let viuNaoBloqueado = false;
  for (const id of idsFinal) {
    const bloqueado = bloqueadosIds.has(id);
    if (bloqueado && viuNaoBloqueado) return false;
    if (!bloqueado) viuNaoBloqueado = true;
  }
  return true;
}
window.DevbArrastar = {
  novaOrdem: devbNovaOrdem,
  destinoValido: devbDestinoValido,
  aplicarLocal: devbAplicarLocal,
  respeitaBloqueados: devbRespeitaBloqueados
};

// ===== hivebox/frontend/dev-board-conflitos.js =====
function devbContarEmCurso(faixas, idEmCurso) {
  const porApp = {};
  (faixas || []).forEach((f) => {
    (f.colunas || []).forEach((c) => {
      if (c.id !== idEmCurso) return;
      (c.cards || []).forEach((k) => {
        if (!k.app) return;
        porApp[k.app] = (porApp[k.app] || 0) + 1;
      });
    });
  });
  return Object.fromEntries(Object.entries(porApp).filter(([, n]) => n >= 2));
}
window.DevbConflitos = {
  contarEmCurso: devbContarEmCurso
};

// ===== hivebox/frontend/dev-board-vista-verificacao.jsx =====
function DevBoardVistaVerificacao({
  topicos,
  estados,
  estadoFiltro,
  setEstadoFiltro,
  onAbrirCartao,
  onMarcar
}) {
  const lista = topicos || [];
  const rotulo = (id) => ((estados || []).find((e) => e.id === id) || {}).label || id;
  const colunas = [
    {
      key: "cartao",
      label: "Cart\xE3o",
      width: 240,
      minWidth: 160,
      sortValue: (t) => `${t.card_titulo} ${t.numero}`,
      render: (t) => /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)", color: "var(--muted)" } }, `#${t.card_id}`), " ", t.card_rotulo ? `${t.card_rotulo} \xB7 ` : "", t.card_titulo)
    },
    {
      key: "texto",
      label: "T\xF3pico",
      width: 360,
      minWidth: 200,
      render: (t) => /* @__PURE__ */ React.createElement("span", null, t.numero, ". ", t.texto)
    },
    {
      key: "estado",
      label: "Estado",
      width: 200,
      minWidth: 140,
      sortValue: (t) => t.estado,
      render: (t) => /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { style: { color: t.estado === "falhou" ? "var(--danger, #c4434b)" : void 0 } }, t.estado_label || rotulo(t.estado)), t.estado === "falhou" && t.motivo && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { color: "var(--danger, #c4434b)" } }, t.motivo))
    },
    {
      key: "quem",
      label: "Verificado por",
      width: 160,
      minWidth: 120,
      sortValue: (t) => t.verificado_em || "",
      render: (t) => t.verificado_por ? /* @__PURE__ */ React.createElement("span", null, t.verificado_por, t.verificado_em && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub" }, window.fmtAgo(t.verificado_em))) : /* @__PURE__ */ React.createElement("span", { className: "kanban-card__vazio" }, "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      // Uma coluna de botões não tem por onde ordenar: sem isto o cabeçalho
      // prometia uma ordenação que não faz (convenção "Sortable tables").
      sortable: false,
      width: 220,
      minWidth: 180,
      render: (t) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, t.estado !== "ok" && /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          onClick: () => onMarcar({ card_id: t.card_id, numero: t.numero, estado: "ok" })
        },
        "OK"
      ), t.estado !== "falhou" && /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          style: { marginLeft: 6 },
          onClick: () => onMarcar({ card_id: t.card_id, numero: t.numero, estado: "falhou" })
        },
        "N\xE3o passou"
      ), t.estado !== "por_verificar" && /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          style: { marginLeft: 6 },
          onClick: () => onMarcar({
            card_id: t.card_id,
            numero: t.numero,
            estado: "por_verificar"
          })
        },
        "Repor"
      ))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minHeight: 0, flex: 1 } }, /* @__PURE__ */ React.createElement(window.HubList.Bar, null, /* @__PURE__ */ React.createElement(
    window.HubList.ChipFilter,
    {
      label: "Estado",
      value: estadoFiltro,
      setValue: setEstadoFiltro,
      options: (estados || []).map((e) => ({ value: e.id, label: e.label }))
    }
  )), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "hivebox",
      viewId: "dev-board-verificacao",
      columns: colunas,
      data: lista,
      pagination: "none",
      rowKey: (t) => `${t.card_id}:${t.numero}`,
      onRowClick: (t) => onAbrirCartao(t.card_id),
      empty: "Nada por verificar."
    }
  ));
}
window.DevBoardVistaVerificacao = DevBoardVistaVerificacao;

// ===== hivebox/frontend/dev-board-vista-recursos.jsx =====
function devbLinhasRecursos(dados) {
  const d = dados || { bases: [], portas: [], fila: [] };
  const bases = (d.bases || []).map((b) => ({
    chave: b.nome,
    recurso: b.nome,
    tipo: "Base de teste",
    // Uma base de teste pode estar a servir um `orq servidor --base-vazia`.
    estado: b.ocupado ? b.uso === "servidor" ? "servidor" : "ocupada" : "livre",
    ramo: b.ocupado ? b.ramo : null,
    cartao: b.ocupado ? b.cartao : null,
    desde: b.ocupado ? b.desde : b.livre_desde,
    detalhe: b.hash ? `esquema ${b.hash}` : ""
  }));
  const portas = (d.portas || []).map((p) => ({
    chave: `porta-${p.porta}`,
    recurso: `:${p.porta}`,
    tipo: "Servidor",
    estado: "ocupada",
    ramo: p.ramo,
    cartao: p.cartao,
    desde: p.desde,
    detalhe: p.url || ""
  }));
  const devHub = (d.dev_hub || []).map((h, i) => ({
    chave: `dev_hub-${i}`,
    recurso: "dev_hub",
    tipo: "Base de verifica\xE7\xE3o",
    estado: h.modo === "suja" ? "suja" : h.modo,
    ramo: h.ramo || (h.ramos && h.ramos.length ? h.ramos.join(", ") : null),
    cartao: h.cartao,
    desde: h.desde,
    detalhe: h.modo === "suja" ? `${h.app}: ${(h.migracoes || []).join(", ")}` : h.modo === "restos" ? `${(h.migracoes || []).join(", ")} \u2014 desfazem-se no pr\xF3ximo orq servidor` : ""
  }));
  const fila = (d.fila || []).map((f, i) => ({
    chave: `fila-${f.pid}-${i}`,
    recurso: "\u2014",
    tipo: "Fila",
    estado: "\xE0 espera",
    ramo: f.ramo,
    cartao: f.cartao,
    desde: f.desde,
    detalhe: ""
  }));
  const sobre = (d.sobreposicoes || []).map((x) => {
    const [c1, c2] = x.cartoes || [];
    const mig = (x.migracoes || []).length > 0;
    const n = (x.ficheiros || []).length;
    return {
      chave: `sob-${x.ramos.join("|")}`,
      recurso: mig ? "migra\xE7\xF5es" : `${n} ficheiro${n === 1 ? "" : "s"}`,
      tipo: "Sobreposi\xE7\xE3o",
      estado: mig ? "colis\xE3o" : "em comum",
      ramo: x.ramos.join(" \u2194 "),
      ramos: x.ramos,
      cartao: c1 || c2 || null,
      desde: null,
      detalhe: [
        c1 && c2 ? `com #${c2.id} ${c2.titulo}` : "",
        ...x.migracoes || [],
        ...x.ficheiros || []
      ].filter(Boolean).join(", ")
    };
  });
  return [...bases, ...portas, ...devHub, ...fila, ...sobre];
}
function devbLinhaCopia(cp) {
  if (!cp) return { tom: "nenhum", texto: "dev_hub: a c\xF3pia noturna ainda n\xE3o correu." };
  const quando = cp.fim ? window.fmtAgo(cp.fim) : "?";
  const d = cp.dump_data || "";
  const dump = d ? ` \xB7 dump de ${d.slice(8, 10)}/${d.slice(5, 7)}` : "";
  if (cp.estado === "copiado") return { tom: "verde", texto: `dev_hub: copiada do hub ${quando}${dump}` };
  if (cp.estado === "saltou") return { tom: "aviso", texto: `dev_hub: a c\xF3pia saltou ${quando} \u2014 ${cp.motivo || "?"}` };
  return { tom: "vermelho", texto: `dev_hub: a c\xF3pia falhou ${quando} \u2014 ${cp.motivo || "?"}` };
}
const DEVB_SUITE_ATRASADA_MS = 26 * 3600 * 1e3;
function devbLinhaSuiteMain(sm, agora) {
  if (!sm) return { tom: "nenhum", texto: "Suite do main: ainda n\xE3o correu.", detalhe: "" };
  const commit = (sm.sha || "").slice(0, 8);
  const quando = sm.fim ? window.fmtAgo(sm.fim) : "?";
  const atrasada = sm.fim && (agora || Date.now()) - Date.parse(sm.fim) > DEVB_SUITE_ATRASADA_MS ? " \xB7 a \xFAltima corrida tem mais de um dia \u2014 o timer est\xE1 a correr?" : "";
  const estado = sm.estado || (sm.verde ? "verde" : "vermelho");
  if (estado === "verde") {
    return { tom: "verde", texto: `main: verde \u2014 ${sm.resumo || "suite completa"} \xB7 commit ${commit} \xB7 ${quando}${atrasada}`, detalhe: "" };
  }
  if (estado === "nao_concluiu") {
    return { tom: "aviso", texto: `main: a suite n\xE3o concluiu \u2014 ${sm.motivo || `c\xF3digo ${sm.rc}`} \xB7 ${quando}${atrasada}`, detalhe: "" };
  }
  const prs = (sm.prs_desde_verde || []).map((n) => `#${n}`).join(", ");
  let desde = "ainda n\xE3o houve nenhuma verde";
  if (sm.ultima_verde) {
    desde = prs ? `PRs desde a \xFAltima verde (${window.fmtAgo(sm.ultima_verde.fim)}): ${prs}` : "nenhum PR desde a \xFAltima verde";
  }
  return {
    tom: "vermelho",
    texto: `main: vermelho \u2014 ${sm.resumo || `c\xF3digo ${sm.rc}`} \xB7 commit ${commit} \xB7 ${quando} \xB7 ${desde}${atrasada}`,
    detalhe: (sm.falhados || []).join("\n")
  };
}
const DEVB_COR_SUITE = { verde: "var(--brand-green)", vermelho: "#c4434b", aviso: "var(--warn)" };
function DevBoardVistaRecursos({ dados, onAbrirCartao }) {
  const linhas = devbLinhasRecursos(dados);
  const colunas = [
    {
      key: "recurso",
      label: "Recurso",
      width: 140,
      minWidth: 100,
      render: (l) => /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)" } }, l.recurso)
    },
    { key: "tipo", label: "Tipo", width: 130, minWidth: 100 },
    { key: "estado", label: "Estado", width: 110, minWidth: 90 },
    {
      key: "ramo",
      label: "Ramo",
      width: 260,
      minWidth: 160,
      // Numa sobreposição são dois ramos: um por linha, senão o segundo — o
      // que interessa — ficava sempre cortado.
      render: (l) => l.ramos ? /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)", display: "flex", flexDirection: "column", fontSize: 12, lineHeight: 1.3 } }, l.ramos.map((r) => /* @__PURE__ */ React.createElement("span", { key: r, title: r }, r))) : l.ramo ? /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)" } }, l.ramo) : /* @__PURE__ */ React.createElement("span", { className: "kanban-card__vazio" }, "\u2014")
    },
    {
      key: "cartao",
      label: "Cart\xE3o",
      width: 240,
      minWidth: 140,
      sortValue: (l) => l.cartao ? l.cartao.titulo : "",
      render: (l) => l.cartao ? /* @__PURE__ */ React.createElement("span", null, `#${l.cartao.id} `, l.cartao.titulo) : /* @__PURE__ */ React.createElement("span", { className: "kanban-card__vazio" }, "\u2014")
    },
    {
      key: "desde",
      label: "Desde",
      width: 130,
      minWidth: 100,
      render: (l) => l.desde ? window.fmtAgo(l.desde) : "\u2014"
    },
    { key: "detalhe", label: "Detalhe", width: 240, minWidth: 140 }
  ];
  const quando = dados && dados.atualizado_em;
  const suite = devbLinhaSuiteMain(dados && dados.suite_main);
  const copia = devbLinhaCopia(dados && dados.dev_hub_copia);
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minHeight: 0, flex: 1 } }, /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { padding: "6px 12px" } }, quando ? `\xDAltimo retrato do orquestrador ${window.fmtAgo(quando)}.` : "O orquestrador ainda n\xE3o enviou nenhum retrato.", " ", "Na m\xE1quina, ", /* @__PURE__ */ React.createElement("code", null, "scripts/orq.py estado"), " \xE9 a verdade."), /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { padding: "0 12px 6px" }, title: suite.detalhe || void 0 }, /* @__PURE__ */ React.createElement("span", { style: { color: DEVB_COR_SUITE[suite.tom] } }, "\u25CF"), " ", suite.texto), /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { padding: "0 12px 6px" } }, /* @__PURE__ */ React.createElement("span", { style: { color: DEVB_COR_SUITE[copia.tom] } }, "\u25CF"), " ", copia.texto), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "hivebox",
      viewId: "dev-board-recursos",
      columns: colunas,
      data: linhas,
      pagination: "none",
      rowKey: (l) => l.chave,
      onRowClick: (l) => l.cartao && onAbrirCartao(l.cartao.id),
      empty: "Sem recursos."
    }
  ));
}
window.DevBoardVistaRecursos = DevBoardVistaRecursos;

// ===== hivebox/frontend/dev-board.jsx =====
const DEVB_REFRESH_MS = 3e4;
const DEVB_LS_FAIXAS = "devb.faixasRecolhidas";
const DEVB_LS_COLUNAS = "devb.colunasRecolhidas";
function devbRotuloRecurso(r) {
  if (r.startsWith(":")) return `servidor ${r}`;
  if (r === "dev_hub") return "dev_hub exclusiva";
  return `testes em ${r}`;
}
function devbTituloSobreposicao(x) {
  const linhas = [`Sobrep\xF5e-se a ${x.ramo}${x.cartao ? ` (#${x.cartao})` : ""}:`];
  x.migracoes.forEach((m) => linhas.push(`  migra\xE7\xF5es na mesma app \u2014 ${m}`));
  x.ficheiros.forEach((f) => linhas.push(`  ${f}`));
  return linhas.join("\n");
}
function devbDistintivosSobreposicao(lista) {
  const nome = (x) => x.cartao ? `#${x.cartao}` : x.ramo;
  const mig = lista.filter((x) => x.migracoes.length);
  const resto = lista.filter((x) => !x.migracoes.length);
  const out = [];
  if (mig.length) {
    out.push({
      chave: "sob-migracoes",
      texto: `\u26A0 migra\xE7\xF5es com ${mig.map(nome).join(", ")}`,
      titulo: mig.map(devbTituloSobreposicao).join("\n\n")
    });
  }
  if (resto.length) {
    out.push({
      chave: "sob-ficheiros",
      texto: `\u26A0 mesmos ficheiros que ${resto.length === 1 ? nome(resto[0]) : `${resto.length} ramos`}`,
      titulo: ["Mexem nos mesmos ficheiros:", ...resto.map(devbTituloSobreposicao)].join("\n\n")
    });
  }
  return out;
}
function devbLerLS(chave) {
  try {
    return new Set(JSON.parse(window.localStorage.getItem(chave) || "[]"));
  } catch (_) {
    return /* @__PURE__ */ new Set();
  }
}
function devbGravarLS(chave, set) {
  try {
    window.localStorage.setItem(chave, JSON.stringify([...set]));
  } catch (_) {
  }
}
function devbSetDoParam(params, k) {
  return new Set((params.get(k) || "").split(",").filter(Boolean));
}
const DEVB_ESTADO_TODOS = "todos";
function devbEstadosDoParam(params) {
  const bruto = params.get("estado");
  if (bruto === null) return /* @__PURE__ */ new Set(["por_verificar"]);
  if (bruto === DEVB_ESTADO_TODOS) return /* @__PURE__ */ new Set();
  return new Set(bruto.split(",").filter(Boolean));
}
function devbAlternar(set, v) {
  const n = new Set(set);
  if (n.has(v)) n.delete(v);
  else n.add(v);
  return n;
}
function devbFiltrarTopicos(topicos, { apps, programas, q, estados }) {
  const texto = (q || "").trim().toLowerCase();
  return (topicos || []).filter((t) => {
    if (apps && apps.size && !apps.has(t.app)) return false;
    if (programas && programas.size && !programas.has(String(t.programa_id))) return false;
    if (estados && estados.size && !estados.has(t.estado)) return false;
    if (!texto) return true;
    return `${t.card_titulo} ${t.card_rotulo} ${t.texto}`.toLowerCase().includes(texto);
  });
}
function devbErro(e) {
  if (window.API.isNetworkError(e)) return "Sem liga\xE7\xE3o ao servidor.";
  const msg = String(e && e.message || e);
  const m = msg.match(/^(.*?→\s*\d+)/);
  return (m ? m[1] : msg).slice(0, 120);
}
function useDevBoard(q, mostrar, producao) {
  const [dados, setDados] = React.useState(null);
  const [erro, setErro] = React.useState("");
  const [aCarregar, setACarregar] = React.useState(false);
  const [aCarregarManual, setACarregarManual] = React.useState(false);
  const [lidoEm, setLidoEm] = React.useState(null);
  const [mudaram, setMudaram] = React.useState(() => /* @__PURE__ */ new Set());
  const anterior = React.useRef({});
  const seq = React.useRef(0);
  const destacarTimeout = React.useRef(null);
  const manualEmVoo = React.useRef(0);
  const carregar = React.useCallback(async (forcar = false) => {
    const meu = ++seq.current;
    setACarregar(true);
    if (forcar) {
      setACarregarManual(true);
      manualEmVoo.current += 1;
    }
    try {
      const d = await window.API.devBoard({ q, mostrar, producao, forcar: forcar ? "1" : "" });
      if (meu !== seq.current) return;
      const agora = {};
      d.faixas.forEach((f) => f.colunas.forEach((c) => c.cards.forEach((k) => {
        agora[k.id] = c.id;
      })));
      const mud = new Set(Object.keys(agora).filter((id) => anterior.current[id] && anterior.current[id] !== agora[id]).map(Number));
      anterior.current = agora;
      setMudaram(mud);
      clearTimeout(destacarTimeout.current);
      if (mud.size) destacarTimeout.current = setTimeout(() => setMudaram(/* @__PURE__ */ new Set()), 2e3);
      setDados(d);
      setErro("");
      setLidoEm((/* @__PURE__ */ new Date()).toISOString());
    } catch (e) {
      if (meu !== seq.current) return;
      setErro(devbErro(e));
    } finally {
      if (forcar) manualEmVoo.current -= 1;
      if (meu === seq.current) {
        setACarregar(false);
        setACarregarManual(false);
      }
    }
  }, [q, mostrar, producao]);
  const carregarFundo = React.useCallback(() => {
    if (manualEmVoo.current > 0) return;
    carregar();
  }, [carregar]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  React.useEffect(() => () => clearTimeout(destacarTimeout.current), []);
  React.useEffect(() => {
    let t = null;
    const arrancar = () => {
      clearInterval(t);
      if (!document.hidden) t = setInterval(() => carregarFundo(), DEVB_REFRESH_MS);
    };
    const onVis = () => {
      if (!document.hidden) carregarFundo();
      arrancar();
    };
    arrancar();
    document.addEventListener("visibilitychange", onVis);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [carregarFundo]);
  React.useEffect(() => {
    let t = null;
    const on = (e) => {
      if (!e.detail || e.detail.type !== "dev_board.changed") return;
      clearTimeout(t);
      t = setTimeout(() => carregarFundo(), 500);
    };
    window.addEventListener("sr:realtime", on);
    return () => {
      clearTimeout(t);
      window.removeEventListener("sr:realtime", on);
    };
  }, [carregarFundo]);
  return { dados, erro, aCarregar, aCarregarManual, lidoEm, mudaram, carregar };
}
function DevBoardCartao({
  card,
  appNome,
  mudou,
  mostrarPrograma,
  onOpen,
  onArquivar,
  arquivado,
  arrastavel,
  onDragStart,
  onDragEnd,
  onCardDragOver,
  onCardDrop
}) {
  const bloqueado = card.fase === "bloqueado";
  const pct = card.tarefas.total ? Math.round(100 * card.tarefas.feitas / card.tarefas.total) : 0;
  const verif = card.verificacao || { ok: 0, falhou: 0, total: 0 };
  const cls = "kanban-card kanban-card--uniforme" + (bloqueado ? " is-bloqueado" : "") + (mudou ? " is-mudou" : "");
  const abrirTeclado = (e) => {
    if (e.target !== e.currentTarget) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onOpen(card);
    }
  };
  const metaTitulo = [
    mostrarPrograma && card.programa,
    card.app && appNome(card.app),
    bloqueado ? card.motivo || card.fase_label : card.fase_label
  ].filter(Boolean).join(" \xB7 ");
  const prsTitulo = card.prs.map((pr) => `#${pr.numero} ${pr.papel === "desenho" ? "desenho \xB7 " : ""}${pr.estado_label}`).join(", ");
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cls,
      role: "button",
      tabIndex: 0,
      draggable: !!arrastavel,
      onDragStart,
      onDragEnd,
      onDragOver: onCardDragOver,
      onDrop: onCardDrop,
      onClick: () => onOpen(card),
      onKeyDown: abrirTeclado
    },
    /* @__PURE__ */ React.createElement("div", { className: "kanban-card__ref", style: { display: "flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("span", { style: {
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    } }, "#", card.id, card.rotulo ? ` \xB7 ${card.rotulo}` : ""), /* @__PURE__ */ React.createElement(
      "span",
      {
        onClick: (e) => e.stopPropagation(),
        onDragStart: (e) => {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      /* @__PURE__ */ React.createElement(Popover, { align: "right", trigger: /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost icon-only sm",
          "aria-label": "A\xE7\xF5es do cart\xE3o",
          draggable: false
        },
        "\u22EF"
      ) }, (close) => arquivado ? /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
        close();
        onArquivar(card, false);
      } }, "Repor") : /* @__PURE__ */ React.createElement(MenuItem, { danger: true, onClick: () => {
        close();
        onArquivar(card, true);
      } }, "Arquivar"))
    )),
    /* @__PURE__ */ React.createElement("div", { className: "kanban-card__titulo kanban-card__titulo--2l", title: card.titulo }, card.titulo),
    mostrarPrograma && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "kanban-card__sub" + (card.programa ? "" : " kanban-card__vazio"),
        title: card.programa || void 0,
        style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }
      },
      card.programa || "sem programa"
    ),
    /* @__PURE__ */ React.createElement("div", { className: "kanban-card__meta kanban-card__linha", title: metaTitulo }, card.app && /* @__PURE__ */ React.createElement("span", { className: "chip" }, appNome(card.app)), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "pill" + (bloqueado ? " is-bloqueado" : ""),
        title: bloqueado ? card.motivo || card.fase_label : void 0
      },
      /* @__PURE__ */ React.createElement("span", { className: "dot" }),
      /* @__PURE__ */ React.createElement("span", { style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 } }, bloqueado ? card.motivo || card.fase_label : card.fase_label)
    )),
    card.tarefas.total > 0 ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "hub-barra" }, /* @__PURE__ */ React.createElement("div", { className: "hub-barra__fill", style: { width: `${pct}%` } })), /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub" }, card.tarefas.feitas, "/", card.tarefas.total, " tarefas")) : /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "hub-barra" }), /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub kanban-card__vazio" }, "sem plano")),
    /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub" + (verif.falhou ? " kanban-card__sub--falhou" : "") + (verif.total ? "" : " kanban-card__vazio") }, verif.total ? `${verif.ok}/${verif.total} verificado${verif.falhou ? ` \xB7 ${verif.falhou} n\xE3o passou` : ""}` : "sem verifica\xE7\xE3o"),
    ((card.recursos || []).length > 0 || (card.espera_por || []).length > 0 || (card.sobreposicoes || []).length > 0) && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__meta" }, (card.recursos || []).map((r) => /* @__PURE__ */ React.createElement("span", { key: r, className: "badge", title: "Reservado pelo orquestrador" }, devbRotuloRecurso(r))), (card.espera_por || []).map((x) => /* @__PURE__ */ React.createElement(
      "span",
      {
        key: `dep-${x.id}`,
        className: "badge",
        style: { color: "var(--warn)" },
        title: `Espera pelo #${x.id} \xAB${x.titulo}\xBB \u2014 ${x.coluna_label || "por entrar"}`,
        "aria-label": `Espera pelo #${x.id} \u2014 ${x.coluna_label || "por entrar"}`
      },
      /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true" }, `\u26D3 espera por #${x.id}`)
    )), devbDistintivosSobreposicao(card.sobreposicoes || []).map((d) => /* @__PURE__ */ React.createElement("span", { key: d.chave, className: "badge", style: { color: "var(--warn)" }, title: d.titulo }, d.texto))),
    /* @__PURE__ */ React.createElement("div", { className: "kanban-card__meta kanban-card__linha", title: card.prs.length > 0 ? prsTitulo : void 0 }, card.prs.length > 0 ? card.prs.map((pr) => /* @__PURE__ */ React.createElement(
      "a",
      {
        key: pr.numero,
        className: "badge",
        href: pr.url,
        target: "_blank",
        rel: "noreferrer",
        title: pr.titulo,
        onClick: (e) => e.stopPropagation()
      },
      "#",
      pr.numero,
      " ",
      pr.papel === "desenho" ? "desenho \xB7 " : "",
      pr.estado_label
    )) : /* @__PURE__ */ React.createElement("span", { className: "kanban-card__vazio" }, "sem PR")),
    /* @__PURE__ */ React.createElement("div", { className: "kanban-card__meta kanban-card__linha" }, card.worktree_ativa && /* @__PURE__ */ React.createElement("span", { title: "H\xE1 uma worktree aberta para este cart\xE3o" }, /* @__PURE__ */ React.createElement("span", { className: "sync-dot", style: { color: "var(--brand-green)", marginLeft: 0 } }, "\u25CF"), " worktree ativa"), card.sessao_viva && /* @__PURE__ */ React.createElement(
      "span",
      {
        title: `a trabalhar numa sess\xE3o do Claude (n\xE3o \xE9 a tripula\xE7\xE3o) \u2014 \xFAltima atividade ${window.fmtAgo(card.sessao_viva)}`,
        "aria-label": "a trabalhar numa sess\xE3o do Claude"
      },
      /* @__PURE__ */ React.createElement(
        "img",
        {
          src: "/static/assets/hivebox-abelha.png",
          alt: "",
          width: 14,
          height: 14,
          style: { filter: window.HIVEBOX_FILTRO_SESSAO, verticalAlign: "middle" }
        }
      ),
      " sess\xE3o"
    ), /* @__PURE__ */ React.createElement("span", { title: card.ultimo_sinal ? "\xDAltimo sinal de uma sess\xE3o" : "\xDAltima altera\xE7\xE3o" }, window.fmtAgo(card.ultimo_sinal || card.atualizado_em)))
  );
}
function DevBoardColunas({
  meta,
  colunas,
  mudaram,
  recolhidas,
  alternarColuna,
  appNome,
  mostrarPrograma,
  onOpen,
  onArquivar,
  arquivado,
  idProducao,
  producaoTodos,
  alternarProducao,
  podeVerMaisProducao,
  faixaId,
  arrastavel,
  dragOverColKey,
  iniciarArrasto,
  sobreDestino,
  saiDestino,
  largarEm,
  finalizarArrasto,
  faixaDoCorpo,
  idEmCurso,
  conflitosEmCurso = {}
}) {
  const porId = Object.fromEntries(colunas.map((c) => [c.id, c.cards]));
  return /* @__PURE__ */ React.createElement("div", { className: "kanban-board" }, meta.map((m) => {
    const cards = porId[m.id] || [];
    const fechada = recolhidas.has(m.id);
    const colKey = `${faixaId}:${m.id}`;
    const appsConflito = idEmCurso && m.id === idEmCurso ? [...new Set(cards.map((k) => k.app))].filter((a) => conflitosEmCurso[a]) : [];
    const temConflito = appsConflito.length > 0;
    const arrastavelAqui = arrastavel && !(m.id === idProducao && !producaoTodos);
    const cabecalhoTeclado = (e) => {
      if (e.target !== e.currentTarget) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        alternarColuna(m.id);
      }
    };
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: m.id,
        className: "kanban-col" + (fechada ? " is-recolhida" : "") + (dragOverColKey === colKey ? " drag-over" : "") + (temConflito ? " is-conflito" : ""),
        style: { "--kanban-dot": m.cor },
        onClick: fechada ? () => alternarColuna(m.id) : void 0,
        onDragLeave: (e) => {
          if (!e.currentTarget.contains(e.relatedTarget)) saiDestino(colKey);
        }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "kanban-col-h",
          role: "button",
          tabIndex: 0,
          onClick: fechada ? void 0 : () => alternarColuna(m.id),
          onKeyDown: cabecalhoTeclado,
          title: fechada ? "Expandir coluna" : "Recolher coluna"
        },
        /* @__PURE__ */ React.createElement("span", { className: "kanban-col-h__dot" }),
        /* @__PURE__ */ React.createElement("span", { className: "kanban-col-h__label" }, m.label),
        /* @__PURE__ */ React.createElement("span", { className: "kanban-col-h__n" }, cards.length),
        appsConflito.map((a) => /* @__PURE__ */ React.createElement(
          "span",
          {
            key: a,
            className: "kanban-col-h__aviso",
            title: `H\xE1 ${conflitosEmCurso[a]} cart\xF5es em curso na mesma app \u2014 risco de conflitos.`
          },
          "\u26A0 ",
          conflitosEmCurso[a],
          "\xD7 ",
          appNome(a)
        ))
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "kanban-col-body",
          onDragOver: (e) => sobreDestino(e, { faixa: faixaDoCorpo(faixaId), coluna: m.id }, colKey),
          onDrop: (e) => {
            e.preventDefault();
            largarEm({ faixa: faixaDoCorpo(faixaId), coluna: m.id }, null);
          }
        },
        cards.map((c) => /* @__PURE__ */ React.createElement(
          DevBoardCartao,
          {
            key: c.id,
            card: c,
            appNome,
            mudou: mudaram.has(c.id),
            mostrarPrograma,
            onOpen,
            onArquivar,
            arquivado,
            arrastavel: arrastavelAqui,
            onDragStart: (e) => {
              e.dataTransfer.effectAllowed = "move";
              e.dataTransfer.setData("text/plain", String(c.id));
              iniciarArrasto({
                id: c.id,
                faixa: c.programa_id,
                coluna: m.id,
                bloqueado: c.fase === "bloqueado"
              });
            },
            onDragEnd: finalizarArrasto,
            onCardDragOver: (e) => {
              e.stopPropagation();
              sobreDestino(e, { faixa: c.programa_id, coluna: m.id }, colKey);
            },
            onCardDrop: (e) => {
              e.preventDefault();
              e.stopPropagation();
              largarEm({ faixa: c.programa_id, coluna: m.id }, c.id);
            }
          }
        )),
        cards.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "Nada nesta fase."),
        podeVerMaisProducao && idProducao && m.id === idProducao && /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            className: "btn ghost sm",
            onClick: (e) => {
              e.stopPropagation();
              alternarProducao();
            }
          },
          producaoTodos ? "S\xF3 \xFAltimos 14 dias" : "Ver mais antigos"
        )
      )
    );
  }));
}
function DevBoardView({ ctx }) {
  const params = ctx.params;
  const variante = ctx.viewVariant || "faixas";
  const qURL = params.get("q") || "";
  const mostrar = params.get("mostrar") || "";
  const apps = devbSetDoParam(params, "app");
  const programas = devbSetDoParam(params, "programa");
  const producaoTodos = params.get("producao") === "todos";
  const [qLocal, setQLocal] = React.useState(qURL);
  const [faixasFechadas, setFaixasFechadas] = React.useState(() => devbLerLS(DEVB_LS_FAIXAS));
  const [colunasFechadas, setColunasFechadas] = React.useState(() => devbLerLS(DEVB_LS_COLUNAS));
  const [, setTique] = React.useState(0);
  const [modalCartao, setModalCartao] = React.useState(null);
  const [modalPrograma, setModalPrograma] = React.useState(null);
  const [programasTodos, setProgramasTodos] = React.useState(null);
  const [motivoDe, setMotivoDe] = React.useState(null);
  const { dados, erro, aCarregar, aCarregarManual, lidoEm, mudaram, carregar } = useDevBoard(qURL, mostrar, producaoTodos ? "todos" : "");
  const [verif, setVerif] = React.useState(null);
  const estadoFiltro = devbEstadosDoParam(params);
  const carregarVerif = React.useCallback(async () => {
    try {
      setVerif(await window.API.devBoardVerificacoesTodas());
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  }, []);
  React.useEffect(() => {
    if (variante === "verificacao") carregarVerif();
  }, [variante, carregarVerif]);
  const [recursos, setRecursos] = React.useState(null);
  const carregarRecursos = React.useCallback(async () => {
    try {
      setRecursos(await window.API.devBoardRecursos());
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  }, []);
  React.useEffect(() => {
    if (variante === "recursos") carregarRecursos();
  }, [variante, carregarRecursos]);
  React.useEffect(() => {
    const on = (e) => {
      if (!e.detail || e.detail.type !== "dev_board.changed") return;
      if (variante === "recursos") carregarRecursos();
    };
    window.addEventListener("sr:realtime", on);
    return () => window.removeEventListener("sr:realtime", on);
  }, [variante, carregarRecursos]);
  const marcarDaLista = async ({ card_id: cardId, numero, estado }) => {
    if (estado === "falhou") {
      setMotivoDe({ cardId, numero });
      return;
    }
    try {
      await window.API.devBoardMarcarVerificacao(cardId, numero, { estado, motivo: "" });
      carregarVerif();
      carregar();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const [sobreposto, setSobreposto] = React.useState(null);
  React.useEffect(() => {
    setSobreposto(null);
  }, [lidoEm]);
  const arrastandoRef = React.useRef(null);
  const [dragOverColKey, setDragOverColKey] = React.useState(null);
  const invalidoRef = React.useRef(null);
  React.useEffect(() => {
    if (!modalCartao) return void 0;
    let vivo = true;
    window.API.devBoardProgramas().then((ps) => {
      if (vivo) setProgramasTodos(ps.filter((p) => !p.arquivado));
    }).catch(() => {
      if (vivo) setProgramasTodos([]);
    });
    return () => {
      vivo = false;
    };
  }, [modalCartao]);
  React.useEffect(() => {
    const t = setInterval(() => setTique((n) => n + 1), 15e3);
    return () => clearInterval(t);
  }, []);
  React.useEffect(() => {
    setQLocal(qURL);
  }, [qURL]);
  React.useEffect(() => {
    if (qLocal === qURL) return void 0;
    const t = setTimeout(() => window.HubRouter.setParams({ q: qLocal || null }), 300);
    return () => clearTimeout(t);
  }, [qLocal, qURL]);
  const setEstadoFiltro = (upd) => {
    const atual = devbEstadosDoParam(window.HubRouter.current().params);
    const novo = typeof upd === "function" ? upd(atual) : upd;
    window.HubRouter.setParams({
      estado: novo.size ? [...novo].join(",") : DEVB_ESTADO_TODOS
    });
  };
  const setConjunto = (k) => (upd) => {
    const atual = devbSetDoParam(window.HubRouter.current().params, k);
    const novo = typeof upd === "function" ? upd(atual) : upd;
    window.HubRouter.setParams({ [k]: novo.size ? [...novo].join(",") : null });
  };
  const roster = window.HUB_REG.appRoster();
  const appNome = (label) => (roster.find((a) => a.app_label === label) || {}).name || label;
  const faixasBrutas = sobreposto || (dados ? dados.faixas : []);
  const faixas = faixasBrutas.filter((f) => !programas.size || f.programa && programas.has(String(f.programa.id))).map((f) => ({
    ...f,
    colunas: f.colunas.map((c) => ({
      ...c,
      cards: c.cards.filter((k) => !apps.size || apps.has(k.app))
    }))
  })).filter((f) => f.colunas.some((c) => c.cards.length));
  const todos = faixas.flatMap((f) => f.colunas.flatMap((c) => c.cards));
  const appsPresentes = [...new Set(faixasBrutas.flatMap((f) => f.colunas.flatMap((c) => c.cards.map((k) => k.app))).filter(Boolean))];
  const programasPresentes = faixasBrutas.filter((f) => f.programa).map((f) => f.programa);
  const appsOptions = [.../* @__PURE__ */ new Set([...appsPresentes, ...apps])].map((a) => ({ value: a, label: appNome(a) }));
  const programasOptions = (() => {
    const titulos = new Map(programasPresentes.map((p) => [String(p.id), p.titulo]));
    const ids = /* @__PURE__ */ new Set([...programasPresentes.map((p) => String(p.id)), ...programas]);
    return [...ids].map((id) => ({ value: id, label: titulos.get(id) || `Programa ${id}` }));
  })();
  const programasParaModal = programasTodos !== null ? programasTodos : programasPresentes;
  const arquivarPrograma = async (programa) => {
    const ok = await window.hubConfirm({ message: `Arquivar o programa \xAB${programa.titulo}\xBB?` });
    if (!ok) return;
    try {
      await window.API.devBoardEditarPrograma(programa.id, { arquivado: true });
      carregar();
    } catch (e) {
      window.srToast(devbErroApi(e).texto, "error");
    }
  };
  const arquivarCartao = async (card, arquivar) => {
    if (arquivar) {
      const ok = await window.hubConfirm({ message: `Arquivar o cart\xE3o \xAB${card.titulo}\xBB?` });
      if (!ok) return;
    }
    try {
      await window.API.devBoardEditarCard(card.id, { arquivado: arquivar });
      carregar();
    } catch (e) {
      window.srToast(devbErroApi(e).texto, "error");
    }
  };
  const abrir = (card) => ctx.navigate({ routeId: ctx.view, entidade: String(card.id), params });
  const fechar = () => ctx.navigate({ routeId: ctx.view, params });
  const abertoIdBruto = ctx.entidade ? Number(ctx.entidade) : null;
  const abertoId = Number.isFinite(abertoIdBruto) ? abertoIdBruto : null;
  const colunaDoAberto = abertoId && faixas.flatMap((f) => f.colunas).find((c) => c.cards.some((k) => k.id === abertoId));
  const navList = colunaDoAberto ? colunaDoAberto.cards.map((k) => ({ id: k.id })) : [];
  const alternarFaixa = (chave) => setFaixasFechadas((s) => {
    const n = devbAlternar(s, chave);
    devbGravarLS(DEVB_LS_FAIXAS, n);
    return n;
  });
  const alternarColuna = (id) => setColunasFechadas((s) => {
    const n = devbAlternar(s, id);
    devbGravarLS(DEVB_LS_COLUNAS, n);
    return n;
  });
  const alternarProducao = () => window.HubRouter.setParams({ producao: producaoTodos ? null : "todos" });
  const faixaDoCorpo = (faixaId) => variante === "plano" ? arrastandoRef.current ? arrastandoRef.current.faixa : null : faixaId;
  const cartoesDaCelula = (faixaAlvo, colId) => {
    const f = faixasBrutas.find((x) => (x.programa ? x.programa.id : null) === faixaAlvo);
    const c = f && f.colunas.find((x) => x.id === colId);
    return c ? c.cards : [];
  };
  const idsDaCelula = (faixaAlvo, colId) => cartoesDaCelula(faixaAlvo, colId).map((k) => k.id);
  const mensagemInvalida = (origem, destino) => {
    if (!origem || !destino) return null;
    if (origem.coluna !== destino.coluna) {
      return "A coluna vem do GitHub e do deploy \u2014 n\xE3o se muda \xE0 m\xE3o.";
    }
    if (variante === "plano" && origem.faixa !== destino.faixa) {
      return "Na vista Plano s\xF3 se ordena dentro do mesmo programa.";
    }
    return null;
  };
  const iniciarArrasto = (origem) => {
    arrastandoRef.current = origem;
    invalidoRef.current = null;
  };
  const saiDestino = (colKey) => setDragOverColKey((k) => k === colKey ? null : k);
  const sobreDestino = (e, destino, colKey) => {
    const valido = window.DevbArrastar.destinoValido(arrastandoRef.current, destino, variante);
    if (valido) {
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = "move";
      setDragOverColKey(colKey);
      invalidoRef.current = null;
    } else {
      invalidoRef.current = mensagemInvalida(arrastandoRef.current, destino);
      setDragOverColKey((k) => k === colKey ? null : k);
    }
  };
  const finalizarArrasto = (e) => {
    if (e && e.dataTransfer && e.dataTransfer.dropEffect === "none" && invalidoRef.current) {
      window.srToast(invalidoRef.current, "info");
    }
    invalidoRef.current = null;
    arrastandoRef.current = null;
    setDragOverColKey(null);
  };
  const largarEm = async (destino, antesDeId) => {
    const origem = arrastandoRef.current;
    setDragOverColKey(null);
    arrastandoRef.current = null;
    invalidoRef.current = null;
    if (!origem) return;
    if (antesDeId === origem.id) return;
    if (!window.DevbArrastar.destinoValido(origem, destino, variante)) return;
    const idsAtuais = idsDaCelula(destino.faixa, destino.coluna);
    const idsFinal = window.DevbArrastar.novaOrdem(idsAtuais, origem.id, antesDeId);
    if (origem.faixa === destino.faixa && idsAtuais.length === idsFinal.length && idsAtuais.every((id, i) => id === idsFinal[i])) return;
    const bloqueados = new Set(cartoesDaCelula(destino.faixa, destino.coluna).filter((k) => k.fase === "bloqueado").map((k) => k.id));
    if (origem.bloqueado) bloqueados.add(origem.id);
    if (!window.DevbArrastar.respeitaBloqueados(idsFinal, bloqueados)) {
      window.srToast("Os cart\xF5es bloqueados ficam sempre no topo.", "info");
      return;
    }
    setSobreposto(window.DevbArrastar.aplicarLocal(faixasBrutas, origem.id, destino, idsFinal));
    try {
      await window.API.devBoardReordenar(destino.faixa, idsFinal);
    } catch (e) {
      setSobreposto(null);
      window.srToast(devbErroApi(e).texto, "error");
    }
  };
  const gh = dados && dados.github;
  const idProducao = dados && dados.colunas.length ? dados.colunas[dados.colunas.length - 1].id : null;
  const idEmCurso = dados && dados.colunas.length > 1 ? dados.colunas[1].id : null;
  const conflitosEmCurso = window.DevbConflitos.contarEmCurso(faixasBrutas, idEmCurso);
  const arrastavelGlobal = !qURL && !mostrar;
  const comum = {
    meta: dados ? dados.colunas : [],
    mudaram,
    recolhidas: colunasFechadas,
    alternarColuna,
    appNome,
    onOpen: abrir,
    idProducao,
    producaoTodos,
    alternarProducao,
    dragOverColKey,
    iniciarArrasto,
    sobreDestino,
    saiDestino,
    largarEm,
    finalizarArrasto,
    faixaDoCorpo,
    idEmCurso,
    conflitosEmCurso,
    onArquivar: arquivarCartao,
    arquivado: mostrar === "arquivados"
  };
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden", flex: 1 } }, /* @__PURE__ */ React.createElement(window.HubList.Bar, null, /* @__PURE__ */ React.createElement(
    window.HubList.Search,
    {
      value: qLocal,
      onChange: setQLocal,
      placeholder: "Pesquisar t\xEDtulo, r\xF3tulo ou branch\u2026"
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.ChipFilter,
    {
      label: "App",
      value: apps,
      setValue: setConjunto("app"),
      options: appsOptions
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.ChipFilter,
    {
      label: "Programa",
      value: programas,
      setValue: setConjunto("programa"),
      options: programasOptions
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "chips" }, [["arquivados", "Arquivados"], ["descartados", "Descartados"]].map(([v, rotulo]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: v,
      type: "button",
      className: "chip" + (mostrar === v ? " chip-on" : ""),
      onClick: () => window.HubRouter.setParams({ mostrar: mostrar === v ? null : v })
    },
    rotulo
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn primary sm",
      disabled: !dados,
      onClick: () => setModalCartao({}),
      title: dados ? void 0 : "A carregar o quadro\u2026"
    },
    "Novo cart\xE3o"
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setModalPrograma({}) }, "Novo programa"), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", fontSize: 11.5, color: "var(--muted)" } }, lidoEm ? `atualizado ${window.fmtAgo(lidoEm)}` : ""), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => carregar(true),
      disabled: aCarregar,
      title: "Atualizar agora (ignora a cache do GitHub)"
    },
    /* @__PURE__ */ React.createElement(window.Ico.refresh, null),
    " Atualizar"
  )), aCarregar && (dados === null || aCarregarManual) && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar" }), erro && /* @__PURE__ */ React.createElement("div", { className: "erro" }, "N\xE3o foi poss\xEDvel ler o quadro: ", erro), gh && gh.erro && /* @__PURE__ */ React.createElement("div", { className: "erro" }, gh.erro, gh.stale && gh.atualizado_em ? ` \u2014 dados do GitHub de ${window.fmtAgo(gh.atualizado_em)}` : ""), variante === "recursos" ? /* @__PURE__ */ React.createElement(DevBoardVistaRecursos, { dados: recursos, onAbrirCartao: (id) => abrir({ id }) }) : variante === "verificacao" ? /* @__PURE__ */ React.createElement(
    DevBoardVistaVerificacao,
    {
      topicos: devbFiltrarTopicos(verif && verif.topicos, { apps, programas, q: qURL, estados: estadoFiltro }),
      estados: verif && verif.estados || [],
      estadoFiltro,
      setEstadoFiltro,
      onAbrirCartao: (id) => abrir({ id }),
      onMarcar: marcarDaLista
    }
  ) : /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden" } }, dados && todos.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio", style: { padding: 40 } }, mostrar || qURL || apps.size || programas.size ? "Nenhum cart\xE3o com estes filtros." : "Ainda n\xE3o h\xE1 cart\xF5es \u2014 as sess\xF5es do Claude criam-nos com scripts/dev_card.py."), variante === "plano" && todos.length > 0 && // Sem faixaId: a coluna do Plano mistura cartões de vários
  // programas — a faixa-alvo de um largar resolve-se por cartão
  // (`card.programa_id`) ou, no corpo vazio, pela própria origem
  // (`faixaDoCorpo`), nunca por esta coluna combinada.
  /* @__PURE__ */ React.createElement(
    DevBoardColunas,
    {
      ...comum,
      mostrarPrograma: true,
      podeVerMaisProducao: true,
      arrastavel: arrastavelGlobal,
      colunas: comum.meta.map((m) => ({
        id: m.id,
        cards: faixas.flatMap((f) => (f.colunas.find((c) => c.id === m.id) || { cards: [] }).cards)
      }))
    }
  ), variante === "faixas" && // O quadro inteiro faz scroll horizontal como uma só peça — sem
  // este invólucro, cada faixa ganhava o seu próprio scroll (o
  // `.kanban-board` de dentro) e as colunas deixavam de alinhar
  // entre faixas. Ver design/src/styles.css, bloco "Kanban partilhado".
  /* @__PURE__ */ React.createElement("div", { className: "kanban-faixas" }, faixas.map((f, i) => {
    const chave = f.programa ? String(f.programa.id) : "avulsos";
    const fechada = faixasFechadas.has(chave);
    const bloq = f.colunas.reduce((acc, c) => acc + c.cards.filter((k) => k.fase === "bloqueado").length, 0);
    const contadores = comum.meta.map((m) => ({ label: m.label, n: (f.colunas.find((c) => c.id === m.id) || { cards: [] }).cards.length })).filter((x) => x.n > 0).map((x) => `${x.label} ${x.n}`).join(" \xB7 ");
    const faixaTeclado = (e) => {
      if (e.target !== e.currentTarget) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        alternarFaixa(chave);
      }
    };
    return /* @__PURE__ */ React.createElement("section", { key: chave, className: "kanban-faixa" + (fechada ? " is-recolhida" : "") }, /* @__PURE__ */ React.createElement("div", { className: "kanban-faixa-h" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "kanban-faixa-h__toggle",
        role: "button",
        tabIndex: 0,
        onClick: () => alternarFaixa(chave),
        onKeyDown: faixaTeclado,
        title: f.programa && f.programa.objetivo ? f.programa.objetivo : void 0
      },
      /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", transform: fechada ? "rotate(-90deg)" : "none" } }, /* @__PURE__ */ React.createElement(window.Ico.chevron, null)),
      /* @__PURE__ */ React.createElement("span", { className: "kanban-faixa-h__titulo" }, f.programa ? f.programa.titulo : "Avulsos"),
      /* @__PURE__ */ React.createElement("span", { className: "kanban-faixa-h__n" }, contadores, bloq ? `${contadores ? " \xB7 " : ""}${bloq} bloqueado${bloq > 1 ? "s" : ""}` : "")
    ), f.programa && /* @__PURE__ */ React.createElement(Popover, { align: "right", trigger: /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost icon-only sm",
        "aria-label": "A\xE7\xF5es do programa"
      },
      "\u22EF"
    ) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
      close();
      setModalPrograma(f.programa);
    } }, "Editar programa"), !f.programa.arquivado && (mostrar === "arquivados" ? /* @__PURE__ */ React.createElement(MenuItem, { danger: true, onClick: () => {
      close();
      arquivarPrograma(f.programa);
    } }, "Arquivar programa") : (
      // Fora da vista Arquivados, a faixa só aparece
      // quando TEM cartões ativos (`faixas` esconde as
      // vazias) — arquivar dava sempre 400 aqui. Em
      // vez de deixar o utilizador descobrir isso pelo
      // erro, o item fica visível mas inerte, com o
      // caminho certo no tooltip; o `MenuItem`
      // partilhado não tem estado disabled, por isso
      // é uma linha muda com o mesmo desenho.
      /* @__PURE__ */ React.createElement(
        "div",
        {
          title: "O programa tem cart\xF5es ativos \u2014 arquiva-os ou muda-os de programa; depois arquiva o programa na vista Arquivados.",
          style: {
            padding: "7px 10px",
            borderRadius: 4,
            fontSize: 12.5,
            color: "var(--muted)",
            cursor: "default",
            display: "flex",
            alignItems: "center",
            gap: 8
          }
        },
        "Arquivar (tem cart\xF5es ativos)"
      )
    ))))), /* @__PURE__ */ React.createElement(
      DevBoardColunas,
      {
        ...comum,
        colunas: f.colunas,
        podeVerMaisProducao: i === 0,
        faixaId: f.programa ? f.programa.id : null,
        arrastavel: arrastavelGlobal && !fechada
      }
    ));
  }))), abertoId && window.DevBoardDrawer && /* @__PURE__ */ React.createElement(
    window.DevBoardDrawer,
    {
      id: abertoId,
      navList,
      onNavigate: (x) => ctx.navigate({ routeId: ctx.view, entidade: String(x.id), params }),
      onClose: fechar,
      reportCrumb: ctx.reportCrumb
    }
  ), modalCartao && /* @__PURE__ */ React.createElement(
    DevBoardCartaoModal,
    {
      inicial: modalCartao,
      fases: dados ? dados.fases : [],
      programas: programasParaModal,
      onClose: () => setModalCartao(null),
      onGuardado: () => {
        setModalCartao(null);
        carregar();
      }
    }
  ), modalPrograma && /* @__PURE__ */ React.createElement(
    DevBoardProgramaModal,
    {
      inicial: modalPrograma,
      onClose: () => setModalPrograma(null),
      onGuardado: () => {
        setModalPrograma(null);
        carregar();
      }
    }
  ), motivoDe && /* @__PURE__ */ React.createElement(
    DevBoardTextoModal,
    {
      titulo: "N\xE3o passou",
      rotulo: "Motivo",
      obrigatorio: true,
      onClose: () => setMotivoDe(null),
      onGuardar: async (valor) => {
        await window.API.devBoardMarcarVerificacao(
          motivoDe.cardId,
          motivoDe.numero,
          { estado: "falhou", motivo: valor }
        );
        carregarVerif();
        carregar();
      }
    }
  ));
}
window.DevBoardView = DevBoardView;

// ===== hivebox/frontend/dev-board-drawer-acoes.jsx =====
function devbCodigoInline(texto) {
  const t = String(texto);
  const contagem = (t.match(/`/g) || []).length;
  if (contagem % 2 !== 0) return [t];
  const partes = t.split("`");
  if (partes.length === 1) return [t];
  return partes.map((seg, i) => i % 2 === 1 ? React.createElement("code", { key: i, style: { fontFamily: "var(--font-mono)", fontSize: 12 } }, seg) : seg).filter((seg) => seg !== "");
}
function DevBoardLigacoesSecao({ id, papeis, ligacoes, onGuardado }) {
  const [modalLigar, setModalLigar] = React.useState(false);
  const outroPapel = (papel) => {
    const outro = (papeis || []).find((p) => p.id !== papel);
    return outro ? outro.id : papel;
  };
  const rotuloPapel = (pid) => ((papeis || []).find((p) => p.id === pid) || {}).label || pid;
  const mudarPapel = async (lg) => {
    try {
      await window.API.devBoardEditarLigacao(lg.id, { papel: outroPapel(lg.papel) });
      onGuardado();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const limparWorktree = async (lg) => {
    try {
      await window.API.devBoardEditarLigacao(lg.id, { worktree_maquina: "", worktree_caminho: "" });
      onGuardado();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const desligar = async (lg) => {
    const ok = await window.hubConfirm({ message: `Desligar o branch ${lg.branch}?` });
    if (!ok) return;
    try {
      await window.API.devBoardDesligar(lg.id);
      onGuardado();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const ligar = async (data) => {
    await window.API.devBoardLigar(id, data);
    onGuardado();
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Liga\xE7\xF5es"), (!ligacoes || ligacoes.length === 0) && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "Ainda sem branch \u2014 est\xE1 no Backlog."), /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, (ligacoes || []).map((lg) => /* @__PURE__ */ React.createElement(React.Fragment, { key: lg.id }, /* @__PURE__ */ React.createElement("span", { className: "k" }, rotuloPapel(lg.papel)), /* @__PURE__ */ React.createElement("span", { className: "v", style: { minWidth: 0, overflowWrap: "anywhere" } }, lg.branch, " ", lg.pr && /* @__PURE__ */ React.createElement("a", { className: "badge", href: lg.pr.url, target: "_blank", rel: "noreferrer", title: lg.pr.titulo }, "#", lg.pr.numero, " ", lg.pr.estado_label), lg.em_producao && /* @__PURE__ */ React.createElement("span", { className: "badge", style: { marginLeft: 4 } }, "em produ\xE7\xE3o"), lg.worktree_caminho && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", title: lg.worktree_caminho }, "worktree em ", lg.worktree_maquina || "?", ": ", lg.worktree_caminho), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6, justifyContent: "flex-end", marginTop: 4 } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => mudarPapel(lg) }, "Tornar ", rotuloPapel(outroPapel(lg.papel)).toLowerCase()), lg.worktree_caminho && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => limparWorktree(lg) }, "Limpar worktree"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => desligar(lg) }, "Desligar")))))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end", marginTop: 8 } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setModalLigar(true) }, "+ Ligar branch")), modalLigar && /* @__PURE__ */ React.createElement(DevBoardLigarModal, { papeis, onClose: () => setModalLigar(false), onGuardar: ligar }));
}
function DevBoardTarefasSecao({ id, tarefas, onGuardado }) {
  const [renomear, setRenomear] = React.useState(null);
  const [novaTarefa, setNovaTarefa] = React.useState(false);
  const lista = tarefas || [];
  const rodarEstado = async (t) => {
    const proximo = devbProximoEstado(t.estado);
    if (proximo === t.estado) return;
    try {
      await window.API.devBoardEditarTarefa(id, t.numero, { estado: proximo });
      onGuardado();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const alternarRemovida = async (t) => {
    const estado = t.estado === "removida" ? "por_fazer" : "removida";
    try {
      await window.API.devBoardEditarTarefa(id, t.numero, { estado });
      onGuardado();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const renomearGuardar = async (valor) => {
    await window.API.devBoardEditarTarefa(id, renomear.numero, { titulo: valor });
    onGuardado();
  };
  const criarGuardar = async (valor) => {
    await window.API.devBoardCriarTarefa(id, valor);
    onGuardado();
  };
  const feitas = lista.filter((t) => t.estado === "feita").length;
  const total = lista.filter((t) => t.estado !== "removida").length;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Tarefas ", lista.length > 0 && `(${feitas}/${total})`), lista.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "Sem plano ligado."), lista.map((t) => /* @__PURE__ */ React.createElement("div", { key: t.numero, style: { display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", fontSize: 13, padding: "2px 0" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost icon-only sm",
      title: "Mudar estado",
      onClick: () => rodarEstado(t),
      disabled: t.estado === "removida",
      style: { fontFamily: "var(--font-mono)" }
    },
    t.estado === "feita" ? "\u2713" : t.estado === "em_curso" ? "\u25D0" : "\u25CB"
  ), /* @__PURE__ */ React.createElement("span", { style: {
    flex: 1,
    minWidth: 160,
    color: t.estado === "removida" ? "var(--muted)" : "var(--text)",
    textDecoration: t.estado === "removida" ? "line-through" : "none"
  } }, t.numero, ". ", devbCodigoInline(t.titulo), t.origem === "manual" && /* @__PURE__ */ React.createElement("span", { className: "chip", style: { marginLeft: 6 } }, "manual")), t.origem === "manual" && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6 } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setRenomear(t) }, "Renomear"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => alternarRemovida(t) }, t.estado === "removida" ? "Repor" : "Remover")))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end", marginTop: 8 } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setNovaTarefa(true) }, "+ Tarefa")), renomear && /* @__PURE__ */ React.createElement(
    DevBoardTextoModal,
    {
      titulo: "Renomear tarefa",
      rotulo: "T\xEDtulo",
      inicial: renomear.titulo,
      obrigatorio: true,
      onClose: () => setRenomear(null),
      onGuardar: renomearGuardar
    }
  ), novaTarefa && /* @__PURE__ */ React.createElement(
    DevBoardTextoModal,
    {
      titulo: "Nova tarefa",
      rotulo: "T\xEDtulo",
      obrigatorio: true,
      onClose: () => setNovaTarefa(false),
      onGuardar: criarGuardar
    }
  ));
}
window.DevBoardLigacoesSecao = DevBoardLigacoesSecao;
window.DevBoardTarefasSecao = DevBoardTarefasSecao;

// ===== hivebox/frontend/dev-board-documento.jsx =====
function DevBoardDocumentoModal({ cardId, tipo, onClose }) {
  const [d, setD] = React.useState(null);
  const [erro, setErro] = React.useState("");
  const seq = React.useRef(0);
  React.useEffect(() => {
    setD(null);
    setErro("");
    const meu = ++seq.current;
    window.API.devBoardDocumento(cardId, tipo).then((dados) => {
      if (meu === seq.current) setD(dados);
    }).catch((e) => {
      if (meu === seq.current) setErro(window.devbErroApi(e).texto);
    });
  }, [cardId, tipo]);
  const titulo = d ? d.caminho.split("/").pop() : tipo === "spec" ? "Spec" : "Plano";
  const subtitulo = d ? d.ref === "main" ? "main" : `branch ${d.ref}` : "";
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: titulo,
      subtitle: subtitulo,
      onClose,
      width: "min(900px, 92vw)",
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, d && /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "btn sm",
          style: { textDecoration: "none" },
          href: d.url_github,
          target: "_blank",
          rel: "noopener noreferrer"
        },
        "Abrir no GitHub"
      ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", onClick: onClose }, "Fechar"))
    },
    erro && /* @__PURE__ */ React.createElement("div", { className: "erro" }, erro),
    !d && !erro && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar" }),
    d && // O HTML já vem limpo pelo servidor (markdown + nh3, allowlist fixa)
    // — nunca é construído no cliente. É o único sítio deste ficheiro
    // que injeta HTML diretamente.
    /* @__PURE__ */ React.createElement("div", { className: "hub-markdown", dangerouslySetInnerHTML: { __html: d.html } })
  );
}
window.DevBoardDocumentoModal = DevBoardDocumentoModal;

// ===== hivebox/frontend/dev-board-verificacao.jsx =====
const DEVB_ICONE_VERIF = { por_verificar: "\u25CB", ok: "\u2713", falhou: "\u2717" };
function DevBoardVerificacaoSecao({ id, verificacoes, coluna, reabertoAEspera, onGuardado }) {
  const [motivoDe, setMotivoDe] = React.useState(null);
  const [aEnviar, setAEnviar] = React.useState(false);
  const lista = verificacoes || [];
  const ok = lista.filter((x) => x.estado === "ok").length;
  const falhados = lista.filter((x) => x.estado === "falhou").length;
  const marcar = async (x, estado, motivo) => {
    await window.API.devBoardMarcarVerificacao(id, x.numero, { estado, motivo: motivo || "" });
    onGuardado();
  };
  const semRebentar = async (fn) => {
    try {
      await fn();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const guardarMotivo = async (valor) => {
    await marcar(motivoDe, "falhou", valor);
  };
  const enviarParaBacklog = () => semRebentar(async () => {
    const tarefas = falhados === 1 ? "1 tarefa" : `${falhados} tarefas`;
    const sim = await window.hubConfirm({
      message: `Enviar o cart\xE3o para o backlog? Cria ${tarefas} \xABCorrigir: \u2026\xBB com o motivo de cada t\xF3pico que n\xE3o passou.`
    });
    if (!sim) return;
    setAEnviar(true);
    try {
      await window.API.devBoardReabrir(id);
      onGuardado();
    } finally {
      setAEnviar(false);
    }
  });
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Verifica\xE7\xE3o ", lista.length > 0 && `(${ok}/${lista.length})`), lista.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "Ainda sem t\xF3picos \u2014 a sess\xE3o escreve-os ao abrir o PR."), lista.map((x) => /* @__PURE__ */ React.createElement("div", { key: x.numero, style: { display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", fontSize: 13, padding: "2px 0" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost icon-only sm",
      title: x.estado === "ok" ? "Repor por verificar" : "Marcar como ok",
      onClick: () => semRebentar(() => marcar(x, x.estado === "ok" ? "por_verificar" : "ok")),
      style: {
        fontFamily: "var(--font-mono)",
        color: x.estado === "falhou" ? "var(--danger, #c4434b)" : void 0
      }
    },
    DEVB_ICONE_VERIF[x.estado] || "\u25CB"
  ), /* @__PURE__ */ React.createElement("span", { style: { flex: 1, minWidth: 160 } }, x.numero, ". ", x.texto, x.estado === "falhou" && x.motivo && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { color: "var(--danger, #c4434b)" } }, x.motivo), x.verificado_por && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub" }, x.verificado_por, x.verificado_em ? ` \xB7 ${window.fmtAgo(x.verificado_em)}` : "")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6 } }, x.estado === "falhou" ? /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => semRebentar(() => marcar(x, "por_verificar"))
    },
    "Repor"
  ) : /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setMotivoDe(x) }, "N\xE3o passou")))), falhados > 0 && coluna === "por_verificar" && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8 } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", disabled: aEnviar, onClick: enviarParaBacklog }, "Enviar para backlog")), falhados > 0 && reabertoAEspera && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { marginTop: 8 } }, "No backlog \u2014 \xE0 espera da corre\xE7\xE3o. Sai daqui quando uma sess\xE3o ligar uma entrega nova, ou quando voltares a marcar os t\xF3picos que n\xE3o passaram (se a corre\xE7\xE3o se fez noutro cart\xE3o)."), motivoDe && /* @__PURE__ */ React.createElement(
    DevBoardTextoModal,
    {
      titulo: "N\xE3o passou",
      rotulo: "Motivo",
      obrigatorio: true,
      onClose: () => setMotivoDe(null),
      onGuardar: guardarMotivo
    }
  ));
}
window.DevBoardVerificacaoSecao = DevBoardVerificacaoSecao;

// ===== hivebox/frontend/dev-board-dependencias.jsx =====
const DEVB_DEP_FIM = {
  main: { glifo: "\u2713", cor: "var(--brand-green)", texto: "J\xE1 entrou no main" },
  descartado: { glifo: "\u2014", cor: "var(--muted)", texto: "Descartado \u2014 j\xE1 n\xE3o se espera" },
  arquivado: { glifo: "\u2014", cor: "var(--muted)", texto: "Arquivado \u2014 j\xE1 n\xE3o se espera" }
};
const DEVB_DEP_ESPERA = { glifo: "\u26D3", cor: "var(--warn)", texto: "Ainda n\xE3o entrou no main" };
function DevBoardDependenciasSecao({ id, dependeDe, bloqueia, onGuardado, onAbrir }) {
  const [novo, setNovo] = React.useState("");
  const [aGuardar, setAGuardar] = React.useState(false);
  const deps = dependeDe || [];
  const quem = bloqueia || [];
  const guardar = async (ids) => {
    setAGuardar(true);
    try {
      await window.API.devBoardEditarCard(id, { depende_de: ids });
      setNovo("");
      onGuardado();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    } finally {
      setAGuardar(false);
    }
  };
  const acrescentar = (e) => {
    e.preventDefault();
    const n = Number(String(novo).replace("#", "").trim());
    if (!Number.isInteger(n) || n <= 0) return;
    guardar([...deps.map((d) => d.id), n]);
  };
  const linha = (d, remover) => /* @__PURE__ */ React.createElement("div", { key: d.id, style: { display: "flex", gap: 8, alignItems: "center", fontSize: 13, padding: "2px 0" } }, remover && (() => {
    const e = DEVB_DEP_FIM[d.fim] || DEVB_DEP_ESPERA;
    return /* @__PURE__ */ React.createElement("span", { role: "img", "aria-label": e.texto, title: e.texto, style: { color: e.cor, width: 14 } }, /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true" }, e.glifo));
  })(), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => onAbrir(d.id),
      style: { whiteSpace: "normal", textAlign: "left" }
    },
    `#${d.id} ${[d.rotulo, d.titulo].filter(Boolean).join(" \xB7 ")}`
  ), /* @__PURE__ */ React.createElement("span", { className: "kanban-card__sub" }, d.coluna_label), remover && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost icon-only sm",
      title: "Tirar a depend\xEAncia",
      "aria-label": `Tirar a depend\xEAncia do #${d.id}`,
      disabled: aGuardar,
      onClick: () => guardar(deps.filter((x) => x.id !== d.id).map((x) => x.id))
    },
    "\xD7"
  ));
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Depend\xEAncias"), /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { marginBottom: 4 } }, "Depende de"), deps.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "N\xE3o depende de nenhum cart\xE3o."), deps.map((d) => linha(d, true)), /* @__PURE__ */ React.createElement("form", { onSubmit: acrescentar, style: { display: "flex", gap: 8, marginTop: 6 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input",
      style: { width: 110 },
      placeholder: "n\xBA do cart\xE3o",
      value: novo,
      "aria-label": "N\xFAmero do cart\xE3o de que este depende",
      onChange: (e) => setNovo(e.target.value)
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn ghost sm", disabled: aGuardar || !novo.trim() }, "Acrescentar")), quem.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { margin: "8px 0 4px" } }, "Bloqueia"), quem.map((d) => linha(d, false))));
}
window.DevBoardDependenciasSecao = DevBoardDependenciasSecao;

// ===== hivebox/frontend/dev-board-sobreposicoes.jsx =====
const DEVB_SOB_FICHEIROS_VISIVEIS = 6;
function DevBoardSobreposicaoLinha({ x, onAbrir }) {
  const [tudo, setTudo] = React.useState(false);
  const ficheiros = x.ficheiros || [];
  const visiveis = tudo ? ficheiros : ficheiros.slice(0, DEVB_SOB_FICHEIROS_VISIVEIS);
  const escondidos = ficheiros.length - visiveis.length;
  return /* @__PURE__ */ React.createElement("div", { className: "hub-card compact", style: { display: "flex", flexDirection: "column", gap: 4 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 8, alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("span", null, "Com"), x.cartao ? /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => onAbrir(x.cartao),
      style: { whiteSpace: "normal", textAlign: "left" }
    },
    `#${x.cartao} ${x.cartao_titulo || ""}`.trim()
  ) : /* @__PURE__ */ React.createElement("span", null, "um ramo sem cart\xE3o"), /* @__PURE__ */ React.createElement("span", { className: "kanban-card__sub", style: { fontFamily: "var(--font-mono)" } }, x.ramo)), (x.migracoes || []).map((m) => /* @__PURE__ */ React.createElement("div", { key: m, style: { color: "var(--warn)", fontWeight: 600 } }, `\u26A0 Os dois acrescentam migra\xE7\xF5es em ${m} \u2014 quem entrar depois tem de renumerar a sua.`)), ficheiros.length > 0 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub" }, ficheiros.length === 1 ? "1 ficheiro em comum:" : `${ficheiros.length} ficheiros em comum:`), visiveis.map((f) => /* @__PURE__ */ React.createElement("div", { key: f, style: { fontFamily: "var(--font-mono)", fontSize: 12, overflowWrap: "anywhere" } }, f)), escondidos > 0 && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setTudo(true) }, `mais ${escondidos}`)));
}
function DevBoardSobreposicoesSecao({ sobreposicoes, recursos, onAbrir }) {
  const lista = sobreposicoes || [];
  const reservas = recursos || [];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Sobreposi\xE7\xF5es"), lista.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "Nenhum outro ramo em curso mexe nos mesmos ficheiros."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, lista.map((x) => /* @__PURE__ */ React.createElement(DevBoardSobreposicaoLinha, { key: x.cartao || x.ramo, x, onAbrir }))), reservas.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-card__sub", style: { marginTop: 8 } }, `Reservado agora pelo orquestrador: ${reservas.join(", ")}`));
}
window.DevBoardSobreposicoesSecao = DevBoardSobreposicoesSecao;

// ===== hivebox/frontend/perguntas.jsx =====
function hiveboxQuandoPergunta(p) {
  return window.hiveboxHa ? window.hiveboxHa(p.criada_em) : window.fmtAgo(p.criada_em);
}
function HiveboxPerguntaCaixa({ p, aoResponder }) {
  const [resposta, setResposta] = React.useState("");
  const [aEnviar, setAEnviar] = React.useState(false);
  const responder = async () => {
    const texto = resposta.trim();
    if (!texto) return;
    setAEnviar(true);
    try {
      await window.API.hiveboxResponderPergunta(p.id, texto);
      setResposta("");
      window.srToast("Resposta enviada \u2014 a c\xE9lula volta \xE0 tripula\xE7\xE3o.", "success");
      if (aoResponder) aoResponder();
    } catch (e) {
      window.srToast(window.devbErroApi ? window.devbErroApi(e).texto : String(e.message || e), "error");
    } finally {
      setAEnviar(false);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "hub-card compact", style: { display: "flex", flexDirection: "column", gap: 6 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12 } }, /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true" }, "\u2753 "), /* @__PURE__ */ React.createElement("b", null, p.posto_nome || p.posto || "A tripula\xE7\xE3o"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, " pergunta \xB7 ", hiveboxQuandoPergunta(p))), /* @__PURE__ */ React.createElement("div", { style: { whiteSpace: "pre-wrap", fontSize: 12.5 } }, p.texto), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      "aria-label": `Resposta \xE0 pergunta ${p.id}`,
      rows: 3,
      value: resposta,
      placeholder: "A tua resposta (o pr\xF3ximo turno l\xEA-a no prompt)",
      onChange: (e) => setResposta(e.target.value),
      style: { width: "100%", resize: "vertical", font: "inherit", fontSize: 12.5 }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", disabled: aEnviar || !resposta.trim(), onClick: responder }, "Responder")));
}
function HiveboxPerguntaRespondida({ p }) {
  return /* @__PURE__ */ React.createElement("div", { className: "hub-card compact", style: { fontSize: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "\u2753 ", p.posto_nome || p.posto, " \xB7 ", hiveboxQuandoPergunta(p)), /* @__PURE__ */ React.createElement("div", { style: { whiteSpace: "pre-wrap" } }, p.texto), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 4, whiteSpace: "pre-wrap" } }, /* @__PURE__ */ React.createElement("b", null, "\u21B3 ", p.respondida_por, ":"), " ", p.resposta));
}
function HiveboxPerguntas({ perguntas, aoResponder }) {
  if (!perguntas || perguntas.length === 0) return null;
  const abertas = perguntas.filter((p) => !p.respondida_em);
  const respondidas = perguntas.filter((p) => p.respondida_em);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Perguntas"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, abertas.map((p) => /* @__PURE__ */ React.createElement(HiveboxPerguntaCaixa, { key: p.id, p, aoResponder })), respondidas.map((p) => /* @__PURE__ */ React.createElement(HiveboxPerguntaRespondida, { key: p.id, p }))));
}
window.HiveboxPerguntaCaixa = HiveboxPerguntaCaixa;
window.HiveboxPerguntas = HiveboxPerguntas;

// ===== hivebox/frontend/pedidos-suite.jsx =====
function hiveboxSuiteHa(p) {
  if (window.hiveboxHa) return window.hiveboxHa(p.criado_em);
  const min = Math.max(0, Math.round((p.ha_s || 0) / 60));
  return min < 60 ? `h\xE1 ${min} min` : `h\xE1 ${Math.round(min / 60)} h`;
}
function HiveboxPedidosSuite({ pedidos, abrir }) {
  const [aberta, setAberta] = React.useState(false);
  const [aEnviar, setAEnviar] = React.useState(null);
  const lista = pedidos || [];
  const n = lista.length;
  if (!n) return null;
  const decidir = async (p, decisao) => {
    setAEnviar(p.id);
    try {
      await window.API.hiveboxDecidirPedidoSuite(p.id, decisao);
      window.srToast(decisao === "autorizar" ? `Suite completa autorizada para o PR #${p.pr} \u2014 o port\xE3o corre-a na pr\xF3xima tentativa.` : `Suite completa recusada para o PR #${p.pr}.`, "success");
    } catch (e) {
      window.srToast(window.devbErroApi ? window.devbErroApi(e).texto : String(e.message || e), "error");
    } finally {
      setAEnviar(null);
    }
  };
  return /* @__PURE__ */ React.createElement("span", { style: { position: "relative" } }, " \xB7 ", /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-expanded": aberta,
      title: "Pedidos de autoriza\xE7\xE3o da suite completa do pytest",
      style: { color: "var(--warn)" },
      onClick: () => setAberta((x) => !x)
    },
    "\u{1F9EA} ",
    n
  ), aberta && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "panel",
      role: "list",
      "aria-label": "Pedidos da suite completa",
      style: {
        position: "absolute",
        zIndex: 5,
        top: "100%",
        left: 0,
        marginTop: 4,
        width: 460,
        maxWidth: "calc(100vw - 32px)",
        padding: "6px 10px",
        boxShadow: "0 6px 18px rgba(0,0,0,.18)"
      }
    },
    lista.map((p, i) => /* @__PURE__ */ React.createElement(
      "div",
      {
        key: p.id,
        role: "listitem",
        style: { padding: "6px 0", borderBottom: i < n - 1 ? "1px solid var(--border)" : "none", fontSize: 12 }
      },
      /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "PR #", p.pr), " ", /* @__PURE__ */ React.createElement("code", { className: "muted" }, (p.sha || "").slice(0, 8)), " ", p.titulo),
      /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5, wordBreak: "break-all" } }, "partilhados: ", (p.ficheiros || []).slice(0, 4).join(", ") || "\u2014", (p.ficheiros || []).length > 4 ? ` (+${p.ficheiros.length - 4})` : ""),
      /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5 } }, "~", p.estimativa_min, " min de suite \xB7 pedido ", hiveboxSuiteHa(p)),
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 4 } }, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn sm",
          disabled: aEnviar === p.id,
          onClick: () => decidir(p, "autorizar")
        },
        "Autorizar"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          disabled: aEnviar === p.id,
          onClick: () => decidir(p, "recusar")
        },
        "Recusar"
      ))
    ))
  ));
}
window.HiveboxPedidosSuite = HiveboxPedidosSuite;

// ===== hivebox/frontend/missoes.jsx =====
function hiveboxErro(e) {
  return window.devbErroApi ? window.devbErroApi(e).texto : String(e.message || e);
}
function HiveboxNovaMissao({ aoFechar }) {
  const [titulo, setTitulo] = React.useState("");
  const [objetivo, setObjetivo] = React.useState("");
  const [criterios, setCriterios] = React.useState("");
  const [aEnviar, setAEnviar] = React.useState(false);
  const pronto = titulo.trim() && objetivo.trim();
  const gravar = async () => {
    setAEnviar(true);
    try {
      await window.API.hiveboxCriarMissao({ titulo, objetivo, criterios });
      window.srToast("Miss\xE3o escrita \u2014 a rainha pega nela na pr\xF3xima volta.", "success");
      aoFechar();
    } catch (e) {
      window.srToast(hiveboxErro(e), "error");
    } finally {
      setAEnviar(false);
    }
  };
  const campo = { width: "100%", font: "inherit", fontSize: 13 };
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Nova miss\xE3o",
      subtitle: "A rainha desenha-a sozinha: spec, assun\xE7\xF5es e c\xE9lulas.",
      onClose: aoFechar,
      width: 560,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost", onClick: aoFechar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn", disabled: !pronto || aEnviar, onClick: gravar }, "Escrever miss\xE3o"))
    },
    /* @__PURE__ */ React.createElement("label", { className: "muted", style: { fontSize: 11.5 } }, "T\xEDtulo"),
    /* @__PURE__ */ React.createElement("input", { "aria-label": "T\xEDtulo da miss\xE3o", value: titulo, onChange: (e) => setTitulo(e.target.value), style: campo }),
    /* @__PURE__ */ React.createElement("label", { className: "muted", style: { fontSize: 11.5 } }, "Objetivo"),
    /* @__PURE__ */ React.createElement(
      "textarea",
      {
        "aria-label": "Objetivo da miss\xE3o",
        rows: 4,
        value: objetivo,
        onChange: (e) => setObjetivo(e.target.value),
        style: campo
      }
    ),
    /* @__PURE__ */ React.createElement("label", { className: "muted", style: { fontSize: 11.5 } }, "Crit\xE9rios de pronto (um por linha)"),
    /* @__PURE__ */ React.createElement(
      "textarea",
      {
        "aria-label": "Crit\xE9rios de pronto",
        rows: 4,
        value: criterios,
        onChange: (e) => setCriterios(e.target.value),
        style: campo
      }
    )
  );
}
const HB_ESTADO_MISSAO = {
  por_decompor: "\xE0 espera da rainha",
  a_decompor: "a rainha est\xE1 a desenh\xE1-la",
  decomposta: "desenhada",
  falhou: "a decomposi\xE7\xE3o falhou"
};
function HiveboxMissaoDetalhe({ m, celulas }) {
  const [aEnviar, setAEnviar] = React.useState(false);
  const agir = async (fn, ok) => {
    setAEnviar(true);
    try {
      await fn();
      window.srToast(ok, "success");
    } catch (e) {
      window.srToast(hiveboxErro(e), "error");
    } finally {
      setAEnviar(false);
    }
  };
  const bloco = { padding: "8px 14px", fontSize: 12.5, whiteSpace: "pre-wrap" };
  return /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: bloco }, /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Miss\xE3o \xB7 ", HB_ESTADO_MISSAO[m.estado] || m.estado), m.motivo && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b" } }, m.motivo)), /* @__PURE__ */ React.createElement("div", { style: bloco }, /* @__PURE__ */ React.createElement("b", null, "Objetivo"), /* @__PURE__ */ React.createElement("div", null, m.objetivo)), m.criterios && /* @__PURE__ */ React.createElement("div", { style: bloco }, /* @__PURE__ */ React.createElement("b", null, "Crit\xE9rios de pronto"), /* @__PURE__ */ React.createElement("div", null, m.criterios)), m.assuncoes && /* @__PURE__ */ React.createElement("div", { style: bloco }, /* @__PURE__ */ React.createElement("b", null, "Assun\xE7\xF5es"), /* @__PURE__ */ React.createElement("div", null, m.assuncoes)), m.pr_spec && /* @__PURE__ */ React.createElement("div", { style: bloco }, /* @__PURE__ */ React.createElement("b", null, "Spec"), " ", /* @__PURE__ */ React.createElement("a", { href: `https://github.com/joaogalvaojn/stockreborn/pull/${m.pr_spec}`, target: "_blank", rel: "noreferrer" }, "PR #", m.pr_spec), m.spec_entrou ? " \xB7 entrou no main" : "", m.merge_motivo && /* @__PURE__ */ React.createElement("span", { style: { color: "#c4434b" } }, " \xB7 merge parado: ", m.merge_motivo)), /* @__PURE__ */ React.createElement("div", { style: { ...bloco, display: "flex", gap: 8, alignItems: "center" } }, m.estado === "decomposta" && !m.aprovada_em && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn",
      disabled: aEnviar,
      onClick: () => agir(
        () => window.API.hiveboxAprovarMissao(m.id),
        "Miss\xE3o entregue \xE0 tripula\xE7\xE3o."
      )
    },
    "Entregar a miss\xE3o \xE0 tripula\xE7\xE3o (",
    celulas,
    " c\xE9lulas)"
  ), m.aprovada_em && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "aprovada por ", m.aprovada_por, " \xB7 ", window.fmtAgo ? window.fmtAgo(m.aprovada_em) : m.aprovada_em), m.estado === "falhou" && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost",
      disabled: aEnviar,
      onClick: () => agir(() => window.API.hiveboxRepetirMissao(m.id), "A rainha volta a tentar.")
    },
    "Repetir"
  )));
}
window.HiveboxNovaMissao = HiveboxNovaMissao;
window.HiveboxMissaoDetalhe = HiveboxMissaoDetalhe;

// ===== hivebox/frontend/dev-board-drawer.jsx =====
function devbProximoEstado(estado) {
  if (estado === "por_fazer") return "em_curso";
  if (estado === "em_curso") return "feita";
  if (estado === "feita") return "por_fazer";
  return estado;
}
function DevBoardDrawer({ id, navList, onNavigate, onClose, reportCrumb }) {
  const [d, setD] = React.useState(null);
  const [erro, setErro] = React.useState("");
  const [modalCartao, setModalCartao] = React.useState(null);
  const [programas, setProgramas] = React.useState(null);
  const [modalBloquear, setModalBloquear] = React.useState(null);
  const [modalDocumento, setModalDocumento] = React.useState(null);
  const onCloseRef = React.useRef(onClose);
  onCloseRef.current = onClose;
  const seq = React.useRef(0);
  const carregar = React.useCallback(async () => {
    const meu = ++seq.current;
    try {
      const dados = await window.API.devBoardCard(id);
      if (meu !== seq.current) return;
      setD(dados);
      setErro("");
    } catch (e) {
      if (meu !== seq.current) return;
      const msg = String(e && e.message || e);
      if (/→ 404/.test(msg)) {
        onCloseRef.current();
        return;
      }
      setErro(msg);
    }
  }, [id]);
  const carregarRef = React.useRef(carregar);
  carregarRef.current = carregar;
  React.useEffect(() => {
    setD(null);
    setErro("");
    setModalCartao(null);
    setModalBloquear(null);
    setModalDocumento(null);
    carregar();
  }, [carregar]);
  React.useEffect(() => {
    let t = null;
    const on = (e) => {
      if (!e.detail || e.detail.type !== "dev_board.changed") return;
      clearTimeout(t);
      t = setTimeout(carregar, 500);
    };
    window.addEventListener("sr:realtime", on);
    return () => {
      clearTimeout(t);
      window.removeEventListener("sr:realtime", on);
    };
  }, [carregar]);
  const tituloCrumb = d ? d.titulo : null;
  React.useEffect(() => {
    if (reportCrumb) reportCrumb(tituloCrumb);
    return () => {
      if (reportCrumb) reportCrumb(null);
    };
  }, [tituloCrumb, reportCrumb]);
  React.useEffect(() => {
    if (!modalCartao) return void 0;
    let vivo = true;
    window.API.devBoardProgramas().then((ps) => {
      if (vivo) setProgramas(ps.filter((p) => !p.arquivado));
    }).catch(() => {
      if (vivo) setProgramas([]);
    });
    return () => {
      vivo = false;
    };
  }, [modalCartao]);
  const titulo = d ? [d.rotulo, d.titulo].filter(Boolean).join(" \xB7 ") : "A carregar\u2026";
  const subtitulo = d ? [d.programa, d.fase_label].filter(Boolean).join(" \u203A ") : "";
  const bloqueado = d && d.fase === "bloqueado";
  const arquivar = async () => {
    if (!d.arquivado) {
      const ok = await window.hubConfirm({ message: `Arquivar o cart\xE3o \xAB${d.titulo}\xBB?` });
      if (!ok) return;
    }
    try {
      await window.API.devBoardEditarCard(id, { arquivado: !d.arquivado });
      carregarRef.current();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const escolherFase = async (fase) => {
    if (!d || fase === d.fase) return;
    try {
      await window.API.devBoardEditarCard(id, { fase });
      carregarRef.current();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const entregarATripulacao = async () => {
    try {
      await window.API.devBoardEditarCard(id, { aprovado_tripulacao: true });
      carregarRef.current();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const desbloquear = async () => {
    try {
      await window.API.devBoardEditarCard(id, { fase: "implementacao" });
      carregarRef.current();
    } catch (e) {
      window.srToast(window.devbErroApi(e).texto, "error");
    }
  };
  const bloquear = async (motivo) => {
    await window.API.devBoardEditarCard(modalBloquear, { fase: "bloqueado", motivo });
    carregarRef.current();
  };
  const lateral = d && /* @__PURE__ */ React.createElement("div", { style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Hist\xF3rico"), /* @__PURE__ */ React.createElement("div", { className: "timeline" }, d.logs.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "Sem hist\xF3rico."), d.logs.map((l) => /* @__PURE__ */ React.createElement("div", { key: l.id, className: "hub-card compact" }, /* @__PURE__ */ React.createElement("div", { className: "tl-head" }, /* @__PURE__ */ React.createElement("span", { className: "tl-type" }, l.actor_name), /* @__PURE__ */ React.createElement("span", { className: "tl-meta", title: new Date(l.when).toLocaleString("pt-PT") }, window.fmtAgo(l.when))), /* @__PURE__ */ React.createElement("div", { className: "tl-body" }, l.summary)))));
  return /* @__PURE__ */ React.createElement(
    DrawerShell,
    {
      title: titulo,
      subtitle: subtitulo,
      onClose,
      navList,
      currentId: id,
      onNavigate,
      side: lateral,
      headerExtra: d && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", marginRight: 8 } }, d.app && /* @__PURE__ */ React.createElement("span", { className: "chip" }, (window.HUB_REG.appRoster().find((x) => x.app_label === d.app) || {}).name || d.app), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setModalCartao(d) }, "Editar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: arquivar }, d.arquivado ? "Desarquivar" : "Arquivar"))
    },
    /* @__PURE__ */ React.createElement("div", { className: "hb-dev-drawer", style: { padding: 16, display: "flex", flexDirection: "column", gap: 16 } }, erro && /* @__PURE__ */ React.createElement("div", { className: "erro" }, erro), !d && !erro && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar" }), d && /* @__PURE__ */ React.createElement(React.Fragment, null, bloqueado && /* @__PURE__ */ React.createElement("div", { className: "erro" }, /* @__PURE__ */ React.createElement("strong", null, "Bloqueado"), d.motivo ? ` \u2014 ${d.motivo}` : ""), d.aprovado_tripulacao === false && /* @__PURE__ */ React.createElement("div", { className: "hub-card compact", style: { display: "flex", gap: 10, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true" }, "\u{1F464}"), /* @__PURE__ */ React.createElement("span", { style: { flex: 1 } }, "Criado por uma sess\xE3o do Claude: a tripula\xE7\xE3o s\xF3 lhe pega depois de algu\xE9m o entregar."), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", onClick: entregarATripulacao }, "Entregar \xE0 tripula\xE7\xE3o")), window.HiveboxPerguntas && /* @__PURE__ */ React.createElement(window.HiveboxPerguntas, { perguntas: d.perguntas, aoResponder: () => carregarRef.current() }), d.descricao && /* @__PURE__ */ React.createElement("div", { style: { whiteSpace: "pre-wrap", color: "var(--text-2)" } }, d.descricao), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Fase"), /* @__PURE__ */ React.createElement(DevBoardFases, { fases: d.fases, atual: d.fase, onEscolher: escolherFase }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end" } }, bloqueado ? /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: desbloquear }, "Desbloquear") : /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setModalBloquear(id) }, "Bloquear"))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Documentos"), /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, /* @__PURE__ */ React.createElement("span", { className: "k" }, "Spec"), /* @__PURE__ */ React.createElement("span", { className: "v" }, d.spec ? /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        title: d.spec,
        onClick: () => setModalDocumento("spec"),
        style: { whiteSpace: "normal", overflowWrap: "anywhere", textAlign: "left" }
      },
      d.spec.split("/").pop()
    ) : "\u2014"), /* @__PURE__ */ React.createElement("span", { className: "k" }, "Plano"), /* @__PURE__ */ React.createElement("span", { className: "v" }, d.plano ? /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        title: d.plano,
        onClick: () => setModalDocumento("plano"),
        style: { whiteSpace: "normal", overflowWrap: "anywhere", textAlign: "left" }
      },
      d.plano.split("/").pop()
    ) : "\u2014"))), /* @__PURE__ */ React.createElement(
      DevBoardLigacoesSecao,
      {
        id,
        papeis: d.papeis_ligacao,
        ligacoes: d.ligacoes,
        onGuardado: () => carregarRef.current()
      }
    ), /* @__PURE__ */ React.createElement(
      DevBoardSobreposicoesSecao,
      {
        sobreposicoes: d.sobreposicoes,
        recursos: d.recursos,
        onAbrir: (cid) => onNavigate({ id: cid })
      }
    ), /* @__PURE__ */ React.createElement(DevBoardTarefasSecao, { id, tarefas: d.tarefas, onGuardado: () => carregarRef.current() }), /* @__PURE__ */ React.createElement(
      DevBoardDependenciasSecao,
      {
        id,
        dependeDe: d.depende_de,
        bloqueia: d.bloqueia,
        onGuardado: () => carregarRef.current(),
        onAbrir: (cid) => onNavigate({ id: cid })
      }
    ), /* @__PURE__ */ React.createElement(
      DevBoardVerificacaoSecao,
      {
        id,
        verificacoes: d.verificacoes,
        coluna: d.coluna,
        reabertoAEspera: d.reaberto_a_espera,
        onGuardado: () => carregarRef.current()
      }
    ), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Sess\xF5es"), d.sessoes.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "kanban-vazio" }, "Nenhuma sess\xE3o registada."), /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, d.sessoes.map((s) => /* @__PURE__ */ React.createElement(React.Fragment, { key: s.url }, /* @__PURE__ */ React.createElement("span", { className: "k" }, s.papel), /* @__PURE__ */ React.createElement("span", { className: "v txt" }, /* @__PURE__ */ React.createElement("a", { href: s.url, target: "_blank", rel: "noreferrer" }, "abrir sess\xE3o"), s.subagentes ? ` \xB7 ${window.hiveboxSubagentes(s.subagentes)}` : "", " \xB7 \xFAltimo sinal ", window.fmtAgo(s.ultimo_sinal)))))))),
    modalCartao && /* @__PURE__ */ React.createElement(
      DevBoardCartaoModal,
      {
        inicial: modalCartao,
        fases: d ? d.fases : [],
        programas: programas || [],
        onClose: () => setModalCartao(null),
        onGuardado: () => {
          setModalCartao(null);
          carregarRef.current();
        }
      }
    ),
    modalBloquear != null && /* @__PURE__ */ React.createElement(
      DevBoardTextoModal,
      {
        titulo: "Bloquear cart\xE3o",
        rotulo: "Motivo",
        obrigatorio: true,
        onClose: () => setModalBloquear(null),
        onGuardar: bloquear
      }
    ),
    modalDocumento && /* @__PURE__ */ React.createElement(DevBoardDocumentoModal, { cardId: id, tipo: modalDocumento, onClose: () => setModalDocumento(null) })
  );
}
function DevBoardFases({ fases: todas, atual, onEscolher }) {
  const fases = todas.filter((f) => f.id !== "bloqueado");
  const idx = fases.findIndex((f) => f.id === atual);
  const teclado = (f) => (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onEscolher(f.id);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "workflow" }, fases.map((f, i) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: f.id,
      className: "wf-step" + (f.id === atual ? " current" : i < idx ? " done" : ""),
      role: "button",
      tabIndex: 0,
      "aria-current": f.id === atual ? "step" : void 0,
      onClick: () => onEscolher(f.id),
      onKeyDown: teclado(f)
    },
    f.label
  )));
}
window.DevBoardDrawer = DevBoardDrawer;

// ===== hivebox/frontend/portoes.jsx =====
const HIVEBOX_QUEM = [
  // Rótulos de apresentação dos três valores que a API aceita (QUEM, no
  // backend) — não é uma lista de regras de acesso nem de apps.
  { valor: "auto", rotulo: "auto" },
  { valor: "it", rotulo: "IT" },
  { valor: "joao", rotulo: "Jo\xE3o" }
];
function HiveboxPortaoLinha({ p, pendente, onMudar }) {
  const quem = pendente.quem ?? p.quem;
  const condicao = pendente.condicao ?? p.condicao;
  return /* @__PURE__ */ React.createElement("div", { className: `hivebox-portao${p.fixo ? " hivebox-portao--fixo" : ""}` }, /* @__PURE__ */ React.createElement("div", { className: "hivebox-portao__t" }, /* @__PURE__ */ React.createElement("b", null, p.titulo), /* @__PURE__ */ React.createElement("div", { className: "muted" }, p.descricao)), p.fixo ? /* @__PURE__ */ React.createElement("div", { className: "hivebox-portao__fixo" }, "\u{1F512} ", p.quem === "nunca" ? "nunca" : p.quem, " \xB7 ", p.motivo_fixo) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "hivebox-portao__quem", role: "radiogroup", "aria-label": `Quem abre ${p.titulo}` }, HIVEBOX_QUEM.map((q) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: q.valor,
      type: "button",
      role: "radio",
      "aria-checked": quem === q.valor,
      className: `btn${quem === q.valor ? " primary" : " ghost"}`,
      onClick: () => onMudar({ quem: q.valor })
    },
    q.rotulo
  ))), /* @__PURE__ */ React.createElement("div", { className: "hivebox-portao__cond" }, p.modos.length > 0 && /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "input",
      value: condicao.modo || "",
      "aria-label": "Condi\xE7\xE3o",
      onChange: (e) => onMudar({ condicao: { ...condicao, modo: e.target.value } })
    },
    p.modos.map((m) => /* @__PURE__ */ React.createElement("option", { key: m, value: m }, m.replace(/_/g, " ")))
  ), "janela" in condicao && /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input",
      "aria-label": "Janela de deploy",
      value: condicao.janela,
      onChange: (e) => onMudar({ condicao: { ...condicao, janela: e.target.value } })
    }
  ), p.atualizado_por && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "por ", p.atualizado_por))));
}
function HiveboxPortoesView() {
  const [dados, setDados] = React.useState(null);
  const [pendentes, setPendentes] = React.useState({});
  const [aGravar, setAGravar] = React.useState(false);
  const carregar = React.useCallback(async () => {
    try {
      setDados(await window.API.hiveboxPortoes());
    } catch (e) {
      window.srToast(String(e.message || e), "error");
    }
  }, []);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const mudar = (chave, patch) => setPendentes((s) => ({ ...s, [chave]: { ...s[chave] || {}, ...patch } }));
  const gravar = async () => {
    setAGravar(true);
    try {
      for (const [chave, patch] of Object.entries(pendentes)) {
        await window.API.hiveboxPortaoEditar(chave, patch);
      }
      window.srToast("Port\xF5es gravados.", "success");
      setPendentes({});
      await carregar();
    } catch (e) {
      window.srToast(String(e.message || e), "error");
    } finally {
      setAGravar(false);
    }
  };
  if (!dados) return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 16 } }, "A carregar\u2026"));
  const configuraveis = dados.portoes.filter((p) => !p.fixo || p.quem !== "nunca");
  const fixos = dados.portoes.filter((p) => p.quem === "nunca");
  const haMudancas = Object.keys(pendentes).length > 0;
  return /* @__PURE__ */ React.createElement("div", { className: "hivebox-portoes" }, /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("h2", null, "Port\xF5es da linha"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, "quem abre cada um")), configuraveis.map((p) => /* @__PURE__ */ React.createElement(HiveboxPortaoLinha, { key: p.chave, p, pendente: pendentes[p.chave] || {}, onMudar: (patch) => mudar(p.chave, patch) })), /* @__PURE__ */ React.createElement("div", { className: "hivebox-portoes__acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost", disabled: !haMudancas || aGravar, onClick: () => setPendentes({}) }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary", disabled: !haMudancas || aGravar, onClick: gravar }, "Gravar port\xF5es"))), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("h2", null, "Fixos no c\xF3digo"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, "n\xE3o aparecem como op\xE7\xE3o, por decis\xE3o")), fixos.map((p) => /* @__PURE__ */ React.createElement(HiveboxPortaoLinha, { key: p.chave, p, pendente: {}, onMudar: () => {
  } }))), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("h2", null, "Hist\xF3rico")), dados.historico.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 12 } }, "Ainda ningu\xE9m mudou um port\xE3o."), dados.historico.map((h, i) => /* @__PURE__ */ React.createElement("div", { key: i, className: "hivebox-portao__hist" }, /* @__PURE__ */ React.createElement("span", { className: "muted" }, window.fmtAgo ? window.fmtAgo(h.when) : h.when), " \xB7 ", /* @__PURE__ */ React.createElement("b", null, h.actor_name), " \xB7 ", h.summary))));
}
window.HiveboxPortoesView = HiveboxPortoesView;

// ===== hivebox/frontend/tripulacao.jsx =====
const HIVEBOX_RECARGA_MS = 3e4;
const HIVEBOX_RELOGIO_MS = 15e3;
const HIVEBOX_DEBOUNCE_MS = 2e3;
const HIVEBOX_ESTADOS = {
  a_trabalhar: { rotulo: "a trabalhar", cor: "var(--brand-green)" },
  encalhado: { rotulo: "encalhado", cor: "#c4434b" },
  a_descansar: { rotulo: "a descansar", cor: "var(--muted, #888)" }
};
const HIVEBOX_ESTADOS_RAINHA = {
  a_coordenar: { rotulo: "a coordenar", cor: "var(--brand-green)" },
  em_pausa: { rotulo: "em pausa", cor: "#c27c0e" },
  parada: { rotulo: "parada", cor: "var(--muted, #888)" }
};
function hiveboxHa(iso) {
  if (!iso) return "";
  const seg = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1e3));
  return seg < 60 ? `h\xE1 ${seg} s` : window.fmtAgo(iso);
}
function hiveboxSubagentes(n) {
  if (!n) return "";
  return n === 1 ? "1 subagente" : `${n} subagentes`;
}
function hiveboxAlvoTurno(t) {
  if (t.card != null) return `#${t.card}`;
  return [t.alvo || `miss\xE3o ${t.programa}`, t.programa_titulo].filter(Boolean).join(" ");
}
const HIVEBOX_FILTRO_SESSAO = "hue-rotate(200deg) saturate(1.4)";
function hiveboxLogoDaApp(appLabel) {
  const a = (window.__HUB_APPS || []).find((x) => (x.appLabel || x.slug) === appLabel);
  return a ? a.brandLogo : null;
}
function HiveboxAbelha({ posto }) {
  const logo = posto.papel === "rainha" ? null : hiveboxLogoDaApp(posto.app_label);
  return /* @__PURE__ */ React.createElement("span", { style: { position: "relative", display: "inline-block", width: 22, height: 22, flex: "none" } }, /* @__PURE__ */ React.createElement("img", { src: "/static/assets/hivebox-abelha.png", alt: "", width: 22, height: 22 }), posto.papel === "rainha" && /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true", style: { position: "absolute", top: -8, right: -6, fontSize: 11, lineHeight: 1 } }, "\u{1F451}"), logo && /* @__PURE__ */ React.createElement(
    "img",
    {
      src: logo,
      alt: "",
      width: 12,
      height: 12,
      style: { position: "absolute", right: -5, bottom: -3, objectFit: "contain" }
    }
  ));
}
function hiveboxContagens(postos) {
  const n = (e) => postos.filter((p) => p.estado === e).length;
  const nectares = postos.map((p) => p.turno && p.turno.nectar_semana).filter((v) => typeof v === "number");
  return {
    trabalhar: n("a_trabalhar"),
    descansar: n("a_descansar"),
    encalhados: n("encalhado"),
    nectar: nectares.length ? Math.round(Math.max(...nectares) * 100) : null
  };
}
function hiveboxNomeDaApp(appLabel) {
  if (!appLabel) return "";
  const a = (window.HUB_REG.appRoster() || []).find((x) => x.app_label === appLabel);
  return a ? a.name : appLabel;
}
function HiveboxPerguntasAEspera({ perguntas, ctx }) {
  if (!perguntas || perguntas.length === 0) return null;
  const colunas = [
    {
      key: "texto",
      label: "Pergunta",
      width: 420,
      minWidth: 200,
      render: (p) => /* @__PURE__ */ React.createElement("span", { title: p.texto }, "\u2753 ", p.texto.split("\n")[0])
    },
    {
      key: "card",
      label: "Cart\xE3o",
      width: 240,
      minWidth: 140,
      sortValue: (p) => p.card,
      render: (p) => /* @__PURE__ */ React.createElement("span", null, `#${p.card} `, p.card_titulo)
    },
    { key: "posto_nome", label: "Abelha", width: 140, minWidth: 100 },
    {
      key: "criada_em",
      label: "H\xE1 quanto",
      width: 120,
      minWidth: 90,
      sortValue: (p) => Date.parse(p.criada_em),
      render: (p) => hiveboxHa(p.criada_em)
    }
  ];
  return (
    // flex: none — numa coluna flex com a lista dos postos, encolhia até só sobrar o cabeçalho.
    /* @__PURE__ */ React.createElement("div", { style: { flex: "none", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: 260, overflow: "hidden", marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "4px 12px" } }, /* @__PURE__ */ React.createElement("b", null, "Perguntas \xE0 espera"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", perguntas.length, " \xB7 clica para responder")), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "hivebox",
        viewId: "tripulacao-perguntas",
        columns: colunas,
        data: perguntas,
        pagination: "none",
        rowKey: (p) => p.id,
        onRowClick: (p) => ctx.navigate({ routeId: "hivebox_colmeia", entidade: String(p.card) }),
        empty: "Sem perguntas."
      }
    ))
  );
}
function HiveboxTripulacaoView({ ctx }) {
  const [postos, setPostos] = React.useState(null);
  const [perguntas, setPerguntas] = React.useState([]);
  const [, setRelogio] = React.useState(0);
  const falhou = React.useRef(false);
  const pedido = React.useRef(0);
  const carregar = React.useCallback(async () => {
    const meu = ++pedido.current;
    try {
      const [dados, pergs] = await Promise.all([window.API.hiveboxPostos(), window.API.hiveboxPerguntas()]);
      if (meu !== pedido.current) return;
      falhou.current = false;
      setPostos(dados.postos);
      setPerguntas(pergs.perguntas);
    } catch (e) {
      if (meu !== pedido.current || falhou.current) return;
      falhou.current = true;
      window.srToast(String(e.message || e), "error");
    }
  }, []);
  React.useEffect(() => {
    carregar();
    const intervalo = setInterval(carregar, HIVEBOX_RECARGA_MS);
    let adiado = null;
    const aoSinal = (e) => {
      if (!e.detail || e.detail.type !== "dev_board.changed") return;
      clearTimeout(adiado);
      adiado = setTimeout(carregar, HIVEBOX_DEBOUNCE_MS);
    };
    window.addEventListener("sr:realtime", aoSinal);
    return () => {
      clearInterval(intervalo);
      clearTimeout(adiado);
      window.removeEventListener("sr:realtime", aoSinal);
    };
  }, [carregar]);
  React.useEffect(() => {
    const id = setInterval(() => setRelogio((t) => t + 1), HIVEBOX_RELOGIO_MS);
    return () => clearInterval(id);
  }, []);
  if (!postos) return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 16 } }, "A carregar\u2026"));
  const c = hiveboxContagens(postos);
  const ninguem = !postos.some((p) => p.turno);
  const abrirCartao = (p) => p.turno && p.turno.card && ctx.navigate({ routeId: "hivebox", entidade: String(p.turno.card) });
  const colunas = [
    {
      key: "nome",
      label: "Abelha",
      width: 190,
      minWidth: 140,
      render: (p) => /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement(HiveboxAbelha, { posto: p }), /* @__PURE__ */ React.createElement("b", null, p.nome))
    },
    {
      key: "app_label",
      label: "App",
      width: 120,
      minWidth: 90,
      sortValue: (p) => hiveboxNomeDaApp(p.app_label),
      render: (p) => hiveboxNomeDaApp(p.app_label) || "\u2014"
    },
    { key: "papel", label: "Papel", width: 100, minWidth: 80 },
    {
      key: "estado",
      label: "Estado",
      width: 130,
      minWidth: 100,
      sortable: false,
      render: (p) => {
        const e = p.rainha && HIVEBOX_ESTADOS_RAINHA[p.rainha.estado] || HIVEBOX_ESTADOS[p.estado] || { rotulo: p.estado, cor: "var(--muted, #888)" };
        return /* @__PURE__ */ React.createElement("span", { style: { color: e.cor, whiteSpace: "nowrap" } }, "\u25CF ", e.rotulo);
      }
    },
    {
      key: "ultimo_sinal",
      label: "A fazer",
      width: 340,
      minWidth: 180,
      sortValue: (p) => p.turno && p.turno.ultimo_sinal ? Date.parse(p.turno.ultimo_sinal) : null,
      render: (p) => {
        const t = p.turno;
        if (p.rainha) return /* @__PURE__ */ React.createElement("span", null, p.rainha.texto);
        if (!t) return /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014");
        const texto = t.ultimo_sinal_texto || "";
        const quando = hiveboxHa(t.ultimo_sinal);
        return /* @__PURE__ */ React.createElement("span", null, [texto, quando].filter(Boolean).join(" \xB7 "));
      }
    },
    {
      key: "subagentes",
      label: "Subagentes",
      width: 120,
      minWidth: 90,
      sortValue: (p) => p.turno ? p.turno.subagentes : null,
      render: (p) => p.turno ? hiveboxSubagentes(p.turno.subagentes) || "0" : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    {
      key: "card",
      label: "Cart\xE3o",
      width: 240,
      minWidth: 140,
      sortValue: (p) => p.turno ? p.turno.card_titulo || p.turno.programa_titulo || "" : "",
      render: (p) => {
        const t = p.turno;
        if (!t) return /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014");
        if (t.card == null) return /* @__PURE__ */ React.createElement("span", null, hiveboxAlvoTurno(t));
        return /* @__PURE__ */ React.createElement("span", null, `#${t.card} `, t.card_titulo);
      }
    },
    { key: "modelo", label: "Modelo", width: 130, minWidth: 90 },
    {
      key: "nivel",
      label: "N\xEDvel",
      width: 80,
      minWidth: 60,
      render: (p) => p.nivel == null ? "\u2014" : p.nivel
    },
    {
      key: "tokens_hoje",
      label: "Tokens hoje",
      width: 120,
      minWidth: 90,
      render: (p) => p.tokens_hoje == null ? "\u2014" : Number(p.tokens_hoje).toLocaleString("pt-PT")
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minHeight: 0, flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "8px 12px" } }, /* @__PURE__ */ React.createElement("b", null, c.trabalhar, " a trabalhar \xB7 ", c.descansar, " a descansar \xB7 ", c.encalhados, " encalhados"), c.nectar != null && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 16 } }, "\u{1F36F} n\xE9ctar da semana ", c.nectar, " %")), /* @__PURE__ */ React.createElement(HiveboxPerguntasAEspera, { perguntas, ctx }), ninguem && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: "0 12px 8px" } }, "Ainda ningu\xE9m pousou. Lan\xE7a um turno com ", /* @__PURE__ */ React.createElement("code", null, "scripts/mc.py lan\xE7ar <cart\xE3o> --posto <posto>"), "."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "hivebox",
      viewId: "tripulacao",
      columns: colunas,
      data: postos,
      pagination: "none",
      rowKey: (p) => p.chave,
      onRowClick: (p) => p.turno ? abrirCartao(p) : void 0,
      empty: "Sem postos."
    }
  ));
}
window.HiveboxAbelha = HiveboxAbelha;
window.hiveboxHa = hiveboxHa;
window.hiveboxLogoDaApp = hiveboxLogoDaApp;
window.hiveboxSubagentes = hiveboxSubagentes;
window.hiveboxAlvoTurno = hiveboxAlvoTurno;
window.HIVEBOX_FILTRO_SESSAO = HIVEBOX_FILTRO_SESSAO;
window.HiveboxTripulacaoView = HiveboxTripulacaoView;

// ===== hivebox/frontend/colmeia-layout.js =====
(function() {
  const R = 28;
  const PASSO_X = Math.sqrt(3) * 30;
  const PASSO_Y = 45;
  const MARGEM = 16;
  const MARGEM_TOPO = 52;
  const FOLGA_FAVOS = 22;
  const NUCLEO = PASSO_X + R + 12;
  const ROTULO_ALTURA = 28;
  const FOGUETAO_ALTURA = 20;
  const ROTULO_MAX = 24;
  const LETRA = 9.2;
  const ESTICAR = 1.6;
  const DIRECOES = [[1, 0], [1, -1], [0, -1], [-1, 0], [-1, 1], [0, 1]];
  function axialParaXY(q, r) {
    return { x: PASSO_X * (q + r / 2), y: PASSO_Y * r };
  }
  function espiral(n) {
    const out = [[0, 0]];
    for (let anel = 1; out.length < n; anel++) {
      let q = -anel;
      let r = anel;
      for (let i = 0; i < 6 && out.length < n; i++) {
        for (let j = 0; j < anel && out.length < n; j++) {
          out.push([q, r]);
          q += DIRECOES[i][0];
          r += DIRECOES[i][1];
        }
      }
    }
    return out.slice(0, n);
  }
  function anelDe(n) {
    let anel = 0;
    let total = 1;
    while (total < n) {
      anel += 1;
      total += 6 * anel;
    }
    return anel;
  }
  function pontos(cx, cy, raio) {
    const p = [];
    for (let i = 0; i < 6; i++) {
      const a = Math.PI / 180 * (60 * i - 90);
      p.push(`${(cx + raio * Math.cos(a)).toFixed(1)},${(cy + raio * Math.sin(a)).toFixed(1)}`);
    }
    return p.join(" ");
  }
  function servico(i) {
    const [q, r] = espiral(7)[i + 1];
    return axialParaXY(q, r);
  }
  function raioFavo(n) {
    return anelDe(Math.max(n, 1)) * PASSO_X + R;
  }
  function sinal(c) {
    if (c.pergunta) return "\u2753";
    if (c.fase === "bloqueado") return "\u23F8\uFE0F";
    if (c.a_espera_aprovacao) return "\u{1F464}";
    if (c.coluna === "a_espera_deploy") return "\u{1F680}";
    return null;
  }
  function contarSinais(celulas) {
    const n = { deploy: 0, standby: 0, aprovacao: 0, pergunta: 0 };
    for (const c of celulas) {
      const s = sinal(c);
      if (s === "\u{1F680}") n.deploy += 1;
      else if (s === "\u23F8\uFE0F") n.standby += 1;
      else if (s === "\u{1F464}") n.aprovacao += 1;
      else if (s === "\u2753") n.pergunta += 1;
    }
    return n;
  }
  function tituloSinal(c) {
    const s = sinal(c);
    if (s === "\u2753") return `pergunta ao Jo\xE3o: ${c.pergunta.texto}`;
    if (s === "\u23F8\uFE0F") return `em standby: ${c.motivo || "sem motivo escrito"}`;
    if (s === "\u{1F464}") return "\xE0 espera de aprova\xE7\xE3o para a tripula\xE7\xE3o";
    if (s === "\u{1F680}") return "\xE0 espera de deploy";
    return null;
  }
  function rotuloDoFavo(f) {
    const t = f.titulo.length > ROTULO_MAX ? `${f.titulo.slice(0, ROTULO_MAX - 1)}\u2026` : f.titulo;
    return `${t} \xB7 ${f.percentagem} %${f.escondidas ? ` \xB7 +${f.escondidas} escondidas` : ""}`;
  }
  function ocupa(f) {
    const raio = raioFavo(f.celulas.length);
    return Math.max(raio + ROTULO_ALTURA, rotuloDoFavo(f).length * LETRA / 2 + 6);
  }
  function encaixar(raios) {
    const postos = [{ x: 0, y: 0, r: NUCLEO }];
    return raios.map((r) => {
      for (let d = NUCLEO + r + FOLGA_FAVOS; ; d += 6) {
        const passos = Math.max(24, Math.ceil(2 * Math.PI * d / 8));
        for (let k = 0; k < passos; k++) {
          const a = -Math.PI / 2 + 2 * Math.PI * k / passos;
          const x = ESTICAR * d * Math.cos(a);
          const y = d * Math.sin(a);
          if (postos.every((p) => Math.hypot(p.x - x, p.y - y) >= p.r + r + FOLGA_FAVOS)) {
            postos.push({ x, y, r });
            return { x, y };
          }
        }
      }
    });
  }
  function layout(favos) {
    const centros = encaixar(favos.map(ocupa));
    const out = favos.map((f, i) => {
      const { x: cx, y: cy } = centros[i];
      const pos = espiral(f.celulas.length);
      const celulas = f.celulas.map((c, j) => {
        const p = axialParaXY(pos[j][0], pos[j][1]);
        return { ...c, x: cx + p.x, y: cy + p.y };
      });
      const alto = celulas.length ? Math.min(...celulas.map((c) => c.y)) : cy;
      const foguetao = celulas.some((c) => c.y === alto && sinal(c));
      const topo = alto - R - (foguetao ? FOGUETAO_ALTURA : 0);
      return {
        ...f,
        cx,
        cy,
        raio: raioFavo(f.celulas.length),
        rotulo: rotuloDoFavo(f),
        rotuloLarg: rotuloDoFavo(f).length * LETRA,
        rotuloY: topo - 10,
        celulas
      };
    });
    let [x0, y0, x1, y1] = [-NUCLEO, -NUCLEO, NUCLEO, NUCLEO];
    for (const f of out) {
      const meia = Math.max(f.raio, f.rotulo.length * LETRA / 2);
      x0 = Math.min(x0, f.cx - meia);
      x1 = Math.max(x1, f.cx + meia);
      y0 = Math.min(y0, f.rotuloY - ROTULO_ALTURA);
      y1 = Math.max(y1, f.cy + f.raio);
    }
    x0 -= MARGEM;
    x1 += MARGEM;
    y0 -= MARGEM_TOPO;
    y1 += MARGEM;
    return { favos: out, viewBox: [x0, y0, x1 - x0, y1 - y0] };
  }
  function mel(x, y, pct) {
    const p = Math.max(0, Math.min(100, Number(pct) || 0));
    const h = 2 * R * p / 100;
    const w = Math.sqrt(3) * R;
    return { x: x - w / 2, y: y + R - h, width: w, height: h };
  }
  function lerSelecao(params) {
    const bruto = params && params.get("celulas") || "";
    const ids = bruto.split(",").map(Number).filter((n) => Number.isInteger(n) && n > 0);
    const favo = params && params.get("favo");
    const missao = Number(params && params.get("missao"));
    return {
      celulas: [...new Set(ids)],
      favo: favo || null,
      missao: Number.isInteger(missao) && missao > 0 ? missao : null
    };
  }
  function clicarCelula(sel, id, juntar) {
    let ids;
    if (!juntar) ids = sel.celulas.length === 1 && sel.celulas[0] === id ? [] : [id];
    else ids = sel.celulas.includes(id) ? sel.celulas.filter((x) => x !== id) : [...sel.celulas, id];
    return { celulas: ids.length ? ids.join(",") : null, favo: null };
  }
  window.HiveboxColmeia = {
    R,
    PASSO_X,
    PASSO_Y,
    ROTULO_ALTURA,
    FOGUETAO_ALTURA,
    sinal,
    contarSinais,
    tituloSinal,
    espiral,
    axialParaXY,
    pontos,
    servico,
    layout,
    mel,
    lerSelecao,
    clicarCelula
  };
})();

// ===== hivebox/frontend/colmeia-lancar.jsx =====
const LANCAR_TURNOS_MAX = 5;
function hbComandoLancar(card, posto) {
  return `.venv/bin/python scripts/mc.py lan\xE7ar ${card} --posto ${posto}`;
}
function hbComandoCiclo(card) {
  return `.venv/bin/python scripts/mc.py ciclo ${card}`;
}
function hbComandoFechar(turno) {
  return `.venv/bin/python scripts/mc.py fechar ${turno} --motivo "o mc morreu"`;
}
function hbPostoPorOmissao(c, postos) {
  const papel = c.coluna === "em_revisao" ? "qa" : "dev";
  const daApp = (papel_) => postos.find((p) => p.app_label === c.app_label && p.papel === papel_);
  return (daApp(papel) || daApp("dev") || postos[0] || {}).chave || "";
}
async function hbCopiar(texto, campo) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(texto);
    } else {
      campo.select();
      if (!document.execCommand("copy")) throw new Error("copy");
    }
    window.srToast("Comando copiado", "success");
  } catch (e) {
    if (campo) campo.select();
    window.srToast("N\xE3o consegui copiar \u2014 o comando ficou selecionado, usa Ctrl+C", "error");
  }
}
function HbComando({ texto }) {
  const campo = React.useRef(null);
  return /* @__PURE__ */ React.createElement("span", { style: { display: "flex", gap: 6, alignItems: "center", marginTop: 4 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: campo,
      readOnly: true,
      value: texto,
      "aria-label": "Comando",
      onFocus: (e) => e.target.select(),
      style: { flex: 1, minWidth: 0, fontFamily: '"IBM Plex Mono", monospace', fontSize: 11 }
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => hbCopiar(texto, campo.current) }, "Copiar"));
}
function hbEstadoTurno(t) {
  if (t.estado !== "terminado") return t.encalhado ? "\u26A0 encalhado" : t.estado.replace("_", " ");
  return t.resultado.replace("_", " ") + (t.motivo ? ` \u2014 ${t.motivo}` : "");
}
function HiveboxColmeiaLancar({ c, tripulacao }) {
  const postos = tripulacao.filter((p) => ["dev", "qa"].includes(p.papel) && p.ativo);
  const [posto, setPosto] = React.useState(() => hbPostoPorOmissao(c, postos));
  const [turnos, setTurnos] = React.useState(null);
  const abelhas = c.abelhas.length;
  React.useEffect(() => {
    let vivo = true;
    window.API.devBoardCard(c.card).then((d) => {
      if (vivo) setTurnos(d.turnos || []);
    }).catch(() => {
      if (vivo) setTurnos([]);
    });
    return () => {
      vivo = false;
    };
  }, [c.card, abelhas]);
  const a = c.abelhas[0];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: "0 14px 12px 118px", fontSize: 12 } }, a ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "Turno ", a.turno), " de ", a.nome, " a correr nesta c\xE9lula.", a.encalhado && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", marginTop: 4 } }, "\u26A0 Encalhado. Confirma na m\xE1quina dos turnos que o ", /* @__PURE__ */ React.createElement("code", null, "mc"), " dele j\xE1 n\xE3o corre \u2014 fechar n\xE3o mata processos \u2014 e fecha-o (a worktree fica para o pr\xF3ximo turno):", /* @__PURE__ */ React.createElement(HbComando, { texto: hbComandoFechar(a.turno) }))) : /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Lan\xE7ar turno com", " ", /* @__PURE__ */ React.createElement("select", { value: posto, onChange: (e) => setPosto(e.target.value), "aria-label": "Posto" }, postos.map((p) => /* @__PURE__ */ React.createElement("option", { key: p.chave, value: p.chave }, p.nome, " (", p.chave, ")")))), posto && /* @__PURE__ */ React.createElement(HbComando, { texto: hbComandoLancar(c.card, posto) }), c.app_label && c.percentagem < 80 && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6 } }, "Ou o ciclo inteiro (dev \u2192 QA at\xE9 80 %):", /* @__PURE__ */ React.createElement(HbComando, { texto: hbComandoCiclo(c.card) })), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5, marginTop: 2 } }, "O hub n\xE3o lan\xE7a processos: corre isto na m\xE1quina dos turnos.")), turnos && turnos.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8 } }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5 } }, "Turnos desta c\xE9lula"), turnos.slice(0, LANCAR_TURNOS_MAX).map((t) => /* @__PURE__ */ React.createElement("div", { key: t.id, style: { fontSize: 11.5 } }, "#", t.id, " \xB7 ", t.posto_nome, " \xB7 ", hbEstadoTurno(t), " \xB7 ", window.fmtAgo(t.inicio)))));
}
window.HiveboxColmeiaLancar = HiveboxColmeiaLancar;

// ===== hivebox/frontend/colmeia-detalhe.jsx =====
function HbAnel({ p, tam = 46 }) {
  const dentro = tam - 10;
  return /* @__PURE__ */ React.createElement("span", { style: {
    width: tam,
    height: tam,
    borderRadius: "50%",
    flex: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: `conic-gradient(#2c5d8a ${p}%, #e6ebf0 0)`
  } }, /* @__PURE__ */ React.createElement("i", { style: {
    width: dentro,
    height: dentro,
    borderRadius: "50%",
    background: "var(--panel, #fff)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: tam > 42 ? 11 : 9.5,
    fontFamily: '"IBM Plex Mono", monospace'
  } }, p, " %"));
}
function HbCaixa({ appLabel, p, larg = 56, alt = 62 }) {
  const logo = window.hiveboxLogoDaApp(appLabel) || "/static/assets/hivebox-logo.png";
  const base = Math.round(alt * 0.52);
  return /* @__PURE__ */ React.createElement("span", { style: {
    width: larg,
    height: alt,
    position: "relative",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    flex: "none"
  } }, /* @__PURE__ */ React.createElement("span", { style: {
    position: "absolute",
    bottom: 0,
    width: larg,
    overflow: "hidden",
    height: base + (alt - base) * p / 100,
    display: "flex",
    alignItems: "flex-end"
  } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: logo,
      alt: "",
      width: larg,
      height: alt,
      style: {
        objectFit: "contain",
        objectPosition: "bottom",
        display: "block",
        filter: p === 0 ? "grayscale(1) opacity(.45)" : "drop-shadow(0 4px 8px rgba(21,50,79,.25))"
      }
    }
  )));
}
function HbPassos({ colunas, coluna }) {
  const i = colunas.findIndex((c) => c.id === coluna);
  return /* @__PURE__ */ React.createElement("span", { style: { display: "flex", gap: 4, flexWrap: "wrap", marginTop: 6 } }, colunas.map((c, j) => /* @__PURE__ */ React.createElement("span", { key: c.id, style: {
    fontSize: 9.5,
    borderRadius: 999,
    padding: "1px 7px",
    background: j < i ? "#e2f2e6" : j === i ? "#e3edf7" : "#eef1f4",
    color: j < i ? "#3a8a4d" : j === i ? "#2c5d8a" : "var(--muted, #6a7888)",
    fontWeight: j === i ? 600 : 400
  } }, c.label)));
}
function HbAbelhaLinha({ a, sessoes = 0 }) {
  if (!a) return /* @__PURE__ */ React.createElement("span", { className: "muted" }, sessoes ? "sem abelha da tripula\xE7\xE3o" : "sem abelha");
  return /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement("img", { src: "/static/assets/hivebox-abelha.png", alt: "", width: 16, height: 16 }), a.nome, a.sinal ? ` \xB7 ${a.sinal}` : "", a.subagentes ? ` \xB7 ${window.hiveboxSubagentes(a.subagentes)}` : "", " \xB7 ", window.hiveboxHa(a.ultimo_sinal), a.encalhado ? " \xB7 \u26A0 encalhada" : "");
}
function HbSessaoLinha({ s }) {
  return /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: "/static/assets/hivebox-abelha.png",
      alt: "",
      width: 16,
      height: 16,
      style: { filter: window.HIVEBOX_FILTRO_SESSAO }
    }
  ), s.rotulo, s.subagentes ? ` \xB7 ${window.hiveboxSubagentes(s.subagentes)}` : "", " \xB7 ", window.hiveboxHa(s.ultimo_sinal), /^https:\/\//.test(s.url) && /* @__PURE__ */ React.createElement(React.Fragment, null, " \xB7 ", /* @__PURE__ */ React.createElement(
    "a",
    {
      href: s.url,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: (e) => e.stopPropagation()
    },
    "abrir sess\xE3o"
  )));
}
function HbInspecao({ i }) {
  const qa = i.qa === "aprovado" ? "\u2713 QA aprovado" : "\u21A9 QA devolveu";
  const docs = i.docs === "ok" ? " \xB7 docs em dia" : i.docs === "em_falta" ? " \xB7 docs em falta" : "";
  return /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, marginTop: 2 } }, /* @__PURE__ */ React.createElement("b", null, qa), docs, " \xB7 ", i.sha.slice(0, 7), i.motivo ? ` \u2014 ${i.motivo}` : "", /^https:\/\//.test(i.comentario) && /* @__PURE__ */ React.createElement(React.Fragment, null, " \xB7 ", /* @__PURE__ */ React.createElement("a", { href: i.comentario, target: "_blank", rel: "noopener noreferrer" }, "ver no PR")));
}
function HbCapitulo({ c, favo, colunas, abrir }) {
  const a = c.abelhas[0];
  const col = colunas.find((x) => x.id === c.coluna);
  return /* @__PURE__ */ React.createElement("div", { className: "hb-capitulo", style: {
    display: "grid",
    gridTemplateColumns: "92px 1fr auto",
    gap: 12,
    alignItems: "center",
    padding: "12px 14px",
    borderTop: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement(HbCaixa, { appLabel: c.app_label, p: c.percentagem, larg: 84, alt: 92 }), /* @__PURE__ */ React.createElement("div", { style: { minWidth: 0 } }, /* @__PURE__ */ React.createElement("b", { style: { fontSize: 15 } }, c.titulo), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 11.5 } }, "#", c.card, c.rotulo ? ` \xB7 ${c.rotulo}` : "", " \xB7 ", favo.titulo, c.programa ? ` \xB7 programa: ${c.programa.titulo}` : "", " \xB7 ", col ? col.label : c.coluna, " \xB7 ", c.fase_label), c.pergunta && window.HiveboxPerguntaCaixa && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6 } }, /* @__PURE__ */ React.createElement(window.HiveboxPerguntaCaixa, { key: c.pergunta.id, p: c.pergunta })), !c.pergunta && c.fase === "bloqueado" && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, marginTop: 4, color: "var(--warn)" } }, "\u23F8\uFE0F em standby: ", c.motivo || "sem motivo escrito"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, marginTop: 4 } }, /* @__PURE__ */ React.createElement(HbAbelhaLinha, { a, sessoes: c.sessoes.length })), c.sessoes.map((s) => /* @__PURE__ */ React.createElement("div", { key: s.url, style: { fontSize: 12, marginTop: 2 } }, /* @__PURE__ */ React.createElement(HbSessaoLinha, { s }))), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 11.5, marginTop: 2 } }, "tarefas ", c.tarefas.feitas, "/", c.tarefas.total, a ? ` \xB7 ${a.modelo} \xB7 ${Number(a.tokens).toLocaleString("pt-PT")} tokens` : "", c.cadeado ? ` \xB7 \u{1F512} \xE0 espera de ${c.espera_por.map((x) => `#${x}`).join(", ")}` : ""), /* @__PURE__ */ React.createElement(HbPassos, { colunas, coluna: c.coluna }), c.inspecao && /* @__PURE__ */ React.createElement(HbInspecao, { i: c.inspecao })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement(HbAnel, { p: c.percentagem }), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => abrir(c.card) }, "Abrir cart\xE3o")));
}
function HbCartao({ c, onClick, abrir }) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      onClick,
      onKeyDown: (e) => {
        if (e.key === "Enter") onClick();
      },
      style: {
        border: "1px solid var(--border)",
        borderRadius: 10,
        padding: 10,
        display: "grid",
        gridTemplateColumns: "56px 1fr",
        gap: 8,
        alignItems: "center",
        position: "relative",
        fontSize: 12,
        cursor: "pointer",
        background: "var(--panel, #fff)"
      }
    },
    /* @__PURE__ */ React.createElement(HbCaixa, { appLabel: c.app_label, p: c.percentagem }),
    /* @__PURE__ */ React.createElement("div", { style: { minWidth: 0, paddingRight: 46 } }, /* @__PURE__ */ React.createElement("b", null, c.titulo), c.programa && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5 } }, "programa: ", c.programa.titulo), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5 } }, "#", c.card, " \xB7 ", /* @__PURE__ */ React.createElement(HbAbelhaLinha, { a: c.abelhas[0], sessoes: c.sessoes.length })), c.sessoes.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5 } }, /* @__PURE__ */ React.createElement(HbSessaoLinha, { s: c.sessoes[0] })), abrir && /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        style: { marginTop: 4 },
        onClick: (e) => {
          e.stopPropagation();
          abrir(c.card);
        }
      },
      "Abrir cart\xE3o"
    )),
    /* @__PURE__ */ React.createElement("span", { style: { position: "absolute", top: 8, right: 8 } }, /* @__PURE__ */ React.createElement(HbAnel, { p: c.percentagem, tam: 40 }))
  );
}
const HB_GRELHA = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: 10,
  padding: "0 14px 12px"
};
function HiveboxColmeiaDetalhe({ dados, sel, escrever, abrir }) {
  const so = (id) => escrever({ celulas: String(id), favo: null });
  if (sel.favo) {
    const f = dados.favos.find((x) => x.chave === sel.favo);
    if (f) {
      const operc = f.celulas.filter((c) => c.operculada).length;
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        alignItems: "center",
        gap: 14,
        padding: "12px 14px",
        borderTop: "1px solid var(--border)"
      } }, /* @__PURE__ */ React.createElement(HbAnel, { p: f.percentagem, tam: 58 }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", { style: { fontSize: 15 } }, f.titulo), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 11.5 } }, f.celulas.length, " c\xE9lulas \xB7 ", operc, " operculadas"))), /* @__PURE__ */ React.createElement("div", { style: HB_GRELHA }, f.celulas.map((c) => /* @__PURE__ */ React.createElement(HbCartao, { key: c.card, c, onClick: () => so(c.card) }))));
    }
  }
  const todas = dados.favos.flatMap((f) => f.celulas.map((c) => ({ c, f })));
  const escolhidas = sel.celulas.map((id) => todas.find((x) => x.c.card === id)).filter(Boolean);
  if (escolhidas.length === 1) {
    const { c, f } = escolhidas[0];
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(HbCapitulo, { c, favo: f, colunas: dados.colunas, abrir }), /* @__PURE__ */ React.createElement(window.HiveboxColmeiaLancar, { key: c.card, c, tripulacao: dados.tripulacao }));
  }
  const m = sel.missao && (dados.missoes || []).find((x) => x.id === sel.missao);
  if (m && escolhidas.length === 0 && window.HiveboxMissaoDetalhe) {
    const dela = todas.filter((x) => x.c.missao === m.id).map((x) => x.c);
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { padding: "12px 14px", borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("b", { style: { fontSize: 15 } }, m.titulo), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 11.5 } }, "miss\xE3o \xB7 ", dela.length, " c\xE9lulas")), /* @__PURE__ */ React.createElement(window.HiveboxMissaoDetalhe, { m, celulas: dela.length }), /* @__PURE__ */ React.createElement("div", { style: HB_GRELHA }, dela.map((c) => /* @__PURE__ */ React.createElement(HbCartao, { key: c.card, c, onClick: () => so(c.card), abrir }))));
  }
  if (escolhidas.length > 1) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 14px", borderTop: "1px solid var(--border)", fontSize: 12 } }, /* @__PURE__ */ React.createElement("b", null, escolhidas.length, " c\xE9lulas selecionadas"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 shift-clique junta ou tira \xB7 Esc limpa")), /* @__PURE__ */ React.createElement("div", { style: HB_GRELHA }, escolhidas.map(({ c }) => /* @__PURE__ */ React.createElement(HbCartao, { key: c.card, c, onClick: () => so(c.card), abrir }))));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: "12px 14px", borderTop: "1px solid var(--border)", fontSize: 12 } }, "Clica numa c\xE9lula para ver o cap\xEDtulo; shift-clique junta v\xE1rias; o nome de um favo mostra a app inteira.");
}
window.HiveboxColmeiaDetalhe = HiveboxColmeiaDetalhe;

// ===== hivebox/frontend/colmeia.jsx =====
const COLMEIA_RECARGA_MS = 3e4;
const COLMEIA_TECTO_MS = 2e3;
const COLMEIA_RELOGIO_MS = 15e3;
const COLMEIA_ZOOM_MAX = 4;
function colmeiaCorDaApp(appLabel) {
  const a = (window.__HUB_APPS || []).find((x) => (x.appLabel || x.slug) === appLabel);
  return a && a.accent || "#94a3b8";
}
function colmeiaNomeDaApp(appLabel) {
  const a = (window.__HUB_APPS || []).find((x) => (x.appLabel || x.slug) === appLabel);
  return a && a.name || appLabel;
}
function colmeiaComNomes(d) {
  return { ...d, favos: d.favos.map((f) => f.app_label ? { ...f, titulo: colmeiaNomeDaApp(f.app_label) } : f) };
}
function ColmeiaCelula({ c, selecionada, clicar, missao }) {
  const M = window.HiveboxColmeia;
  const p = M.pontos(c.x, c.y, M.R);
  const cor = c.encalhado ? "#c4434b" : colmeiaCorDaApp(c.app_label);
  const sinal = M.tituloSinal(c);
  const realce = !!missao && c.missao === missao;
  const esbatida = !!missao && !realce;
  return /* @__PURE__ */ React.createElement(
    "g",
    {
      role: "button",
      tabIndex: 0,
      "aria-pressed": selecionada,
      "aria-label": `#${c.card} ${c.titulo} \u2014 ${c.percentagem} %`,
      onClick: (e) => clicar(c, e.shiftKey || e.ctrlKey || e.metaKey),
      onKeyDown: (e) => {
        if (e.key === "Enter") clicar(c, e.shiftKey);
      },
      style: { cursor: "pointer", outline: "none", opacity: esbatida ? 0.3 : 1 }
    },
    /* @__PURE__ */ React.createElement("title", null, `#${c.card} ${c.titulo} \u2014 ${c.percentagem} %${c.programa ? ` \xB7 programa: ${c.programa.titulo}` : ""}${sinal ? ` \xB7 ${sinal}` : ""}`),
    /* @__PURE__ */ React.createElement(
      "polygon",
      {
        points: p,
        fill: c.percentagem ? "#fff8e6" : "#f8fafc",
        stroke: cor,
        strokeWidth: selecionada ? 4 : realce ? 3.6 : 2.4,
        strokeDasharray: c.cadeado ? "4 3" : void 0
      }
    ),
    c.percentagem > 0 && /* @__PURE__ */ React.createElement(
      "polygon",
      {
        points: p,
        fill: c.operculada ? "#d98c06" : "#f2b134",
        opacity: 0.92,
        clipPath: `url(#hb-mel-${c.card})`
      }
    ),
    c.operculada ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("polygon", { points: M.pontos(c.x, c.y, M.R * 0.72), fill: "#fde68a", stroke: "#b8860b", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("text", { x: c.x, y: c.y + 4, fontSize: 12, fontWeight: 700, textAnchor: "middle", fill: "#7a4f12" }, "\u2713")) : c.percentagem > 0 && /* @__PURE__ */ React.createElement("text", { x: c.x, y: c.y + 6, fontSize: 16, fontWeight: 700, textAnchor: "middle", fill: "#15314f" }, c.percentagem),
    c.cadeado && /* @__PURE__ */ React.createElement("text", { x: c.x + 9, y: c.y - 11, fontSize: 11 }, "\u{1F512}"),
    c.abelhas.length > 0 && /* @__PURE__ */ React.createElement("image", { href: "/static/assets/hivebox-abelha.png", x: c.x + 4, y: c.y - 42, width: 30, height: 30 }),
    c.sessoes.length > 0 && /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("title", null, `a trabalhar numa sess\xE3o do Claude (n\xE3o \xE9 a tripula\xE7\xE3o) \u2014 \xFAltima atividade ${window.hiveboxHa(c.sessoes[0].ultimo_sinal)}`), /* @__PURE__ */ React.createElement("circle", { cx: c.x - 19, cy: c.y - 27, r: 17, fill: "none", stroke: "#7a4fd0", strokeWidth: 1.6, strokeDasharray: "3 2.5" }), /* @__PURE__ */ React.createElement(
      "image",
      {
        href: "/static/assets/hivebox-abelha.png",
        x: c.x - 34,
        y: c.y - 42,
        width: 30,
        height: 30,
        style: { filter: window.HIVEBOX_FILTRO_SESSAO },
        "aria-label": "Claude \xB7 sess\xE3o"
      }
    ))
  );
}
function ColmeiaSinal({ c }) {
  const M = window.HiveboxColmeia;
  return /* @__PURE__ */ React.createElement(
    "text",
    {
      x: c.x,
      y: c.y - M.R - 4,
      fontSize: 18,
      textAnchor: "middle",
      "aria-hidden": "true",
      style: { pointerEvents: "none" }
    },
    M.sinal(c)
  );
}
function colmeiaTextoBalao(c) {
  const a = c.abelhas[0];
  if (a) {
    return [a.nome, a.sinal, window.hiveboxSubagentes(a.subagentes), window.hiveboxHa(a.ultimo_sinal)].filter(Boolean).join(" \xB7 ");
  }
  const s = c.sessoes[0];
  return [s.rotulo, window.hiveboxSubagentes(s.subagentes), window.hiveboxHa(s.ultimo_sinal)].filter(Boolean).join(" \xB7 ");
}
function ColmeiaBalao({ c, viewBox, fator }) {
  const texto = colmeiaTextoBalao(c);
  const fundo = c.abelhas.length ? "#15324f" : "#4c2a85";
  const [vx, , vw] = viewBox;
  const w = Math.min(vw - 8, (20 + texto.length * 7.6) * fator);
  const alto = 26 * fator;
  const x = Math.min(Math.max(c.x, vx + w / 2 + 4), vx + vw - w / 2 - 4);
  const y = c.y - 48 - alto;
  return /* @__PURE__ */ React.createElement("g", { pointerEvents: "none" }, /* @__PURE__ */ React.createElement("rect", { x: x - w / 2, y, width: w, height: alto, rx: 10 * fator, fill: fundo }), /* @__PURE__ */ React.createElement("polygon", { points: `${c.x - 6},${y + alto} ${c.x + 6},${y + alto} ${c.x},${y + alto + 7}`, fill: fundo }), /* @__PURE__ */ React.createElement("text", { x, y: y + alto * 0.69, fontSize: 14 * fator, textAnchor: "middle", fill: "#fff" }, texto));
}
const colmeiaAbrirFavo = (f) => f.missao ? { missao: String(f.missao.id), favo: null, celulas: null } : { favo: f.chave, celulas: null };
function ColmeiaSvg({ dados, sel, clicar, escrever }) {
  const M = window.HiveboxColmeia;
  const lay = React.useMemo(() => window.HiveboxColmeia.layout(dados.favos), [dados]);
  const [vista, setVista] = React.useState({ z: 1, dx: 0, dy: 0 });
  const svg = React.useRef(null);
  const arrasto = React.useRef(null);
  const [tamanho, setTamanho] = React.useState(null);
  React.useEffect(() => {
    const el = svg.current;
    if (!el || typeof ResizeObserver === "undefined") return void 0;
    const ro = new ResizeObserver(() => setTamanho({ w: el.clientWidth, h: el.clientHeight }));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  const [bx, by, bw, bh] = lay.viewBox;
  const w = bw / vista.z;
  const h = bh / vista.z;
  const vb = [bx + (bw - w) / 2 + vista.dx, by + (bh - h) / 2 + vista.dy, w, h];
  const escala = tamanho && tamanho.w && tamanho.h ? Math.min(tamanho.w / w, tamanho.h / h) : 1;
  const fator = Math.max(1, 0.95 / escala);
  const zoom = (f) => setVista((v) => {
    const z = Math.min(COLMEIA_ZOOM_MAX, Math.max(1, v.z * f));
    return z === 1 ? { z: 1, dx: 0, dy: 0 } : { ...v, z };
  });
  const baixo = (e) => {
    if (vista.z === 1) return;
    arrasto.current = { x: e.clientX, y: e.clientY, dx: vista.dx, dy: vista.dy, moveu: false };
  };
  const mover = (e) => {
    const a = arrasto.current;
    if (!a || !svg.current) return;
    const escala2 = Math.max(w / svg.current.clientWidth, h / svg.current.clientHeight);
    const mx = e.clientX - a.x;
    const my = e.clientY - a.y;
    if (Math.hypot(mx, my) > 4) a.moveu = true;
    setVista((v) => ({ ...v, dx: a.dx - mx * escala2, dy: a.dy - my * escala2 }));
  };
  const cima = () => {
    setTimeout(() => {
      arrasto.current = null;
    }, 0);
  };
  const engolirClique = (e) => {
    if (arrasto.current && arrasto.current.moveu) e.stopPropagation();
  };
  const unica = sel.celulas.length === 1 ? lay.favos.flatMap((f) => f.celulas).find((c) => c.card === sel.celulas[0]) : null;
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 6, right: 6, display: "flex", gap: 4, zIndex: 1 } }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", "aria-label": "Aproximar", onClick: () => zoom(1.4) }, "+"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", "aria-label": "Afastar", onClick: () => zoom(1 / 1.4) }, "\u2212"), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-label": "Repor a vista",
      onClick: () => setVista({ z: 1, dx: 0, dy: 0 })
    },
    "\u27F2"
  )), /* @__PURE__ */ React.createElement(
    "svg",
    {
      ref: svg,
      viewBox: vb.join(" "),
      width: "100%",
      role: "group",
      "aria-label": "A colmeia",
      style: { display: "block", maxHeight: "74vh", cursor: vista.z > 1 ? "grab" : "default", touchAction: "none" },
      onPointerDown: baixo,
      onPointerMove: mover,
      onPointerUp: cima,
      onPointerLeave: cima,
      onClickCapture: engolirClique
    },
    /* @__PURE__ */ React.createElement("defs", null, lay.favos.flatMap((f) => f.celulas).map((c) => {
      const m = M.mel(c.x, c.y, c.percentagem);
      return /* @__PURE__ */ React.createElement("clipPath", { key: c.card, id: `hb-mel-${c.card}` }, /* @__PURE__ */ React.createElement("rect", { ...m }));
    })),
    lay.favos.map((f) => /* @__PURE__ */ React.createElement("line", { key: `fio-${f.chave}`, x1: 0, y1: 0, x2: f.cx, y2: f.cy, stroke: "#c2cbd5", strokeDasharray: "3 4" })),
    /* @__PURE__ */ React.createElement("polygon", { points: M.pontos(0, 0, M.R), fill: "#fde68a", stroke: "#b8860b", strokeWidth: 2.5 }, /* @__PURE__ */ React.createElement("title", null, `${dados.rainha.nome} \u2014 ${dados.rainha.texto}`)),
    /* @__PURE__ */ React.createElement("image", { href: "/static/assets/hivebox-abelha.png", x: -15, y: -13, width: 30, height: 30 }),
    /* @__PURE__ */ React.createElement("text", { x: 8, y: -10, fontSize: 11 }, "\u{1F451}"),
    dados.servico.map((s, i) => {
      const p = M.servico(i);
      return /* @__PURE__ */ React.createElement("g", { key: s.id }, /* @__PURE__ */ React.createElement("title", null, `${s.rotulo}: ${s.valor} \u2014 ${s.detalhe}`), /* @__PURE__ */ React.createElement("polygon", { points: M.pontos(p.x, p.y, M.R), fill: "#fff8e6", stroke: "#d4a574", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("text", { x: p.x, y: p.y + 7, fontSize: 20, textAnchor: "middle" }, s.icone));
    }),
    lay.favos.map((f) => /* @__PURE__ */ React.createElement("g", { key: f.chave }, f.missao && f.celulas.length === 0 && /* @__PURE__ */ React.createElement(
      "polygon",
      {
        points: M.pontos(f.cx, f.cy, M.R),
        fill: "none",
        stroke: f.missao.estado === "falhou" ? "#c4434b" : "#c9a227",
        strokeWidth: 2,
        strokeDasharray: "6 4",
        className: f.rainha_a_desenhar ? "hb-a-desenhar" : void 0
      },
      /* @__PURE__ */ React.createElement("title", null, f.missao.estado === "falhou" ? "a decomposi\xE7\xE3o falhou" : f.rainha_a_desenhar ? "a rainha est\xE1 a desenhar esta miss\xE3o" : "\xE0 espera da rainha")
    ), f.app_label && /* @__PURE__ */ React.createElement(React.Fragment, null, window.hiveboxLogoDaApp(f.app_label) && /* @__PURE__ */ React.createElement(
      "image",
      {
        href: window.hiveboxLogoDaApp(f.app_label),
        x: f.cx - f.rotuloLarg / 2 - 24,
        y: f.rotuloY - 17,
        width: 22,
        height: 22,
        preserveAspectRatio: "xMidYMid meet",
        style: { pointerEvents: "none" }
      }
    ), /* @__PURE__ */ React.createElement(
      "line",
      {
        x1: f.cx - f.rotuloLarg / 2,
        x2: f.cx + f.rotuloLarg / 2,
        y1: f.rotuloY + 6,
        y2: f.rotuloY + 6,
        stroke: colmeiaCorDaApp(f.app_label),
        strokeWidth: 3,
        strokeLinecap: "round",
        style: { pointerEvents: "none" }
      }
    )), /* @__PURE__ */ React.createElement(
      "text",
      {
        x: f.cx,
        y: f.rotuloY,
        fontSize: 16,
        fontWeight: 700,
        textAnchor: "middle",
        fill: sel.favo === f.chave || f.missao && sel.missao === f.missao.id ? "#2c5d8a" : "var(--text, #15314f)",
        role: "button",
        tabIndex: 0,
        "aria-label": `${f.titulo} \xB7 ${f.percentagem} %`,
        stroke: "var(--panel, #fff)",
        strokeWidth: 4,
        paintOrder: "stroke",
        style: { cursor: "pointer" },
        onClick: () => escrever(colmeiaAbrirFavo(f)),
        onKeyDown: (e) => {
          if (e.key === "Enter") escrever(colmeiaAbrirFavo(f));
        }
      },
      /* @__PURE__ */ React.createElement("title", null, `${f.titulo} \xB7 ${f.percentagem} %${f.escondidas ? ` \xB7 +${f.escondidas} ${f.escondidas === 1 ? "cart\xE3o por verificar ou em produ\xE7\xE3o n\xE3o desenhado" : "cart\xF5es por verificar ou em produ\xE7\xE3o n\xE3o desenhados"} (no m\xE1ximo 15 alv\xE9olos por favo; escondem-se primeiro os mais antigos)` : ""}`),
      f.rotulo
    ), f.celulas.map((c) => /* @__PURE__ */ React.createElement(
      ColmeiaCelula,
      {
        key: c.card,
        c,
        selecionada: sel.celulas.includes(c.card),
        clicar,
        missao: sel.missao
      }
    )))),
    lay.favos.flatMap((f) => f.celulas).filter((c) => window.HiveboxColmeia.sinal(c)).map((c) => /* @__PURE__ */ React.createElement(ColmeiaSinal, { key: `sinal-${c.card}`, c })),
    unica && (unica.abelhas.length > 0 || unica.sessoes.length > 0) && /* @__PURE__ */ React.createElement(ColmeiaBalao, { c: unica, viewBox: vb, fator })
  ));
}
const COLMEIA_COR_RAINHA = { a_coordenar: "#b8860b", em_pausa: "#c27c0e", parada: "#8a94a3" };
function ColmeiaRainha({ rainha }) {
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      title: "o escalonador (scripts/mc.py escalonador)",
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontSize: 11.5,
        padding: "2px 9px",
        border: `1px solid ${COLMEIA_COR_RAINHA[rainha.estado] || "var(--border)"}`,
        borderRadius: 999,
        background: "var(--panel)"
      }
    },
    /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true" }, "\u{1F451}"),
    /* @__PURE__ */ React.createElement("span", { className: "muted" }, rainha.nome),
    /* @__PURE__ */ React.createElement("b", null, rainha.texto)
  );
}
function ColmeiaServico({ servico, rainha }) {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6, padding: "2px 14px 6px" } }, rainha && /* @__PURE__ */ React.createElement(ColmeiaRainha, { rainha }), servico.map((s) => /* @__PURE__ */ React.createElement(
    "span",
    {
      key: s.id,
      title: s.detalhe,
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontSize: 11.5,
        padding: "2px 9px",
        border: "1px solid var(--border)",
        borderRadius: 999,
        background: "var(--panel, #fff)"
      }
    },
    /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true" }, s.icone),
    /* @__PURE__ */ React.createElement("span", { className: "muted" }, s.rotulo),
    /* @__PURE__ */ React.createElement("b", null, s.valor)
  )));
}
function ColmeiaTripulacao({ tripulacao, escrever }) {
  const ativos = tripulacao.filter((p) => p.turno);
  const descansam = tripulacao.filter((p) => !p.turno);
  const abrir = (p) => p.turno.card != null ? escrever({ celulas: String(p.turno.card), favo: null }) : escrever({ missao: String(p.turno.programa), favo: null, celulas: null });
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: "10px 12px" } }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5, letterSpacing: ".16em", textTransform: "uppercase", marginBottom: 6 } }, "Tripula\xE7\xE3o ", /* @__PURE__ */ React.createElement("span", { style: { letterSpacing: 0, textTransform: "none" } }, "\xB7 ", ativos.length, " de ", tripulacao.length, " a trabalhar")), ativos.map((p) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: p.chave,
      role: "button",
      tabIndex: 0,
      onClick: () => abrir(p),
      onKeyDown: (e) => {
        if (e.key === "Enter") abrir(p);
      },
      style: {
        display: "grid",
        gridTemplateColumns: "30px 1fr",
        gap: 8,
        alignItems: "center",
        padding: "5px 0",
        borderBottom: "1px solid var(--border)",
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ React.createElement(window.HiveboxAbelha, { posto: p }),
    /* @__PURE__ */ React.createElement("div", { style: { minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12 } }, /* @__PURE__ */ React.createElement("b", null, p.nome), " ", /* @__PURE__ */ React.createElement("span", { className: "muted", style: { fontSize: 10.5 } }, p.papel)), /* @__PURE__ */ React.createElement("div", { className: "muted", style: {
      fontSize: 10.5,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: p.estado === "encalhado" ? "#c4434b" : void 0
    } }, `${p.estado === "encalhado" ? "\u26A0 encalhada \xB7 " : ""}${window.hiveboxAlvoTurno(p.turno)} \xB7 ${p.turno.ultimo_sinal_texto || "\u2026"}${p.turno.subagentes ? ` \xB7 ${window.hiveboxSubagentes(p.turno.subagentes)}` : ""} \xB7 ${window.hiveboxHa(p.turno.ultimo_sinal)}`))
  )), descansam.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8 } }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5, marginBottom: 4 } }, "A descansar"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 8 } }, descansam.map((p) => /* @__PURE__ */ React.createElement(
    "span",
    {
      key: p.chave,
      title: `${p.nome} \xB7 ${p.papel}${p.app_label ? ` \xB7 ${p.app_label}` : ""}`,
      style: { display: "inline-flex", opacity: 0.75 }
    },
    /* @__PURE__ */ React.createElement(window.HiveboxAbelha, { posto: p })
  )))));
}
const COLMEIA_ICONE_EVENTO = {
  turno_arrancou: "\u{1F41D}",
  pr_aberto: "\u{1F500}",
  turno_sem_pr: "\u23F8",
  encalhado: "\u26A0",
  qa_aprovou: "\u2705",
  qa_devolveu: "\u21A9\uFE0F",
  docs_em_falta: "\u{1F4DA}",
  ciclo_pronta: "\u{1F36F}",
  ciclo_parou: "\u26D4",
  ciclo_suspenso: "\u{1F4A4}",
  escalonador: "\u{1F451}",
  merge_feito: "\u{1F7E3}",
  merge_recusado: "\u{1F6AB}",
  merge_pessoa: "\u{1F464}",
  ronda: "\u{1F514}",
  pergunta: "\u2753",
  resposta: "\u{1F4AC}",
  missao_criada: "\u{1F4DC}",
  missao_decomposta: "\u{1F451}",
  missao_falhou: "\u2717",
  missao_aprovada: "\u2705"
};
function colmeiaHora(iso) {
  const d = new Date(iso);
  const hoje = d.toDateString() === (/* @__PURE__ */ new Date()).toDateString();
  return hoje ? d.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" }) : d.toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit" });
}
function ColmeiaDiario({ diario, escrever }) {
  const abrir = (e) => {
    if (e.card) escrever({ celulas: String(e.card), favo: null });
    else if (e.programa) escrever({ missao: String(e.programa), favo: null, celulas: null });
  };
  const clicavel = (e) => !!(e.card || e.programa);
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: "10px 12px" } }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5, letterSpacing: ".16em", textTransform: "uppercase", marginBottom: 6 } }, "Di\xE1rio ", /* @__PURE__ */ React.createElement("span", { style: { letterSpacing: 0, textTransform: "none" } }, "\xB7 ao vivo")), diario.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 11.5 } }, "Ainda nada aconteceu."), diario.map((e) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: e.id,
      role: clicavel(e) ? "button" : void 0,
      tabIndex: clicavel(e) ? 0 : void 0,
      onClick: () => abrir(e),
      onKeyDown: (k) => {
        if (k.key === "Enter") abrir(e);
      },
      style: {
        display: "grid",
        gridTemplateColumns: "40px 1fr",
        gap: 4,
        fontSize: 11.5,
        padding: "4px 0",
        borderBottom: "1px solid var(--border)",
        cursor: clicavel(e) ? "pointer" : "default",
        color: e.tipo === "encalhado" ? "#c4434b" : void 0
      }
    },
    /* @__PURE__ */ React.createElement("span", { className: "muted", style: { fontFamily: '"IBM Plex Mono", monospace', fontSize: 10.5 } }, colmeiaHora(e.em)),
    /* @__PURE__ */ React.createElement("span", null, COLMEIA_ICONE_EVENTO[e.tipo] || "\u2022", " ", e.texto)
  )));
}
function ColmeiaRonda({ ronda, abrir }) {
  const [aberta, setAberta] = React.useState(false);
  const sits = ronda && ronda.situacoes || [];
  const n = sits.length;
  if (!n) return null;
  return /* @__PURE__ */ React.createElement("span", { style: { position: "relative" } }, " \xB7 ", /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-expanded": aberta,
      title: ronda.em ? `\xFAltima ronda \xE0s ${colmeiaHora(ronda.em)}` : void 0,
      style: { color: "var(--warn)" },
      onClick: () => setAberta((x) => !x)
    },
    "\u{1F514} ",
    n,
    " situa\xE7",
    n === 1 ? "\xE3o" : "\xF5es"
  ), aberta && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "panel",
      role: "list",
      "aria-label": "Situa\xE7\xF5es da ronda",
      style: {
        position: "absolute",
        zIndex: 5,
        top: "100%",
        left: 0,
        marginTop: 4,
        width: 420,
        maxWidth: "calc(100vw - 32px)",
        padding: "6px 10px",
        boxShadow: "0 6px 18px rgba(0,0,0,.18)"
      }
    },
    sits.map((s, i) => /* @__PURE__ */ React.createElement(
      "div",
      {
        key: `${s.tipo}-${s.card}-${i}`,
        role: "listitem",
        style: { padding: "5px 0", borderBottom: i < n - 1 ? "1px solid var(--border)" : "none", fontSize: 12 }
      },
      /* @__PURE__ */ React.createElement("div", null, s.texto),
      /* @__PURE__ */ React.createElement("div", { className: "muted", style: { fontSize: 10.5 } }, "desde ", colmeiaHora(s.desde), s.card ? /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          style: { marginLeft: 6 },
          onClick: () => {
            setAberta(false);
            abrir(s.card);
          }
        },
        "abrir #",
        s.card
      ) : null)
    ))
  ));
}
function ColmeiaEstado({ leitura }) {
  const [, tic] = React.useState(0);
  React.useEffect(() => {
    const id = setInterval(() => tic((t) => t + 1), 1e3);
    return () => clearInterval(id);
  }, []);
  const { lida, falha } = leitura;
  const seg = lida ? Math.max(0, Math.floor((Date.now() - lida) / 1e3)) : null;
  const ha = seg === null ? "" : seg < 60 ? `${seg}s` : `${Math.floor(seg / 60)} min`;
  return /* @__PURE__ */ React.createElement("div", { style: { padding: "0 14px 4px", fontSize: 11 } }, ha && /* @__PURE__ */ React.createElement("span", { className: "muted", "data-testid": "colmeia-atualizado" }, "atualizado h\xE1 ", ha), falha && /* @__PURE__ */ React.createElement("div", { role: "alert", style: { color: "#c4434b", marginTop: 2 } }, falha.sessao ? "A sess\xE3o expirou \u2014 entra de novo para a colmeia voltar a atualizar." : `Sem liga\xE7\xE3o desde ${colmeiaHora(new Date(falha.desde).toISOString())} \u2014 a tentar.`));
}
function HiveboxColmeiaView({ ctx }) {
  const [dados, setDados] = React.useState(null);
  const [, setRelogio] = React.useState(0);
  const [leitura, setLeitura] = React.useState({ lida: null, falha: null });
  const [novaMissao, setNovaMissao] = React.useState(false);
  const pedido = React.useRef(0);
  const carregar = React.useCallback(async () => {
    const meu = ++pedido.current;
    try {
      const d = await window.API.hiveboxColmeia();
      if (meu !== pedido.current) return;
      setDados(colmeiaComNomes(d));
      setLeitura({ lida: Date.now(), falha: null });
    } catch (e) {
      if (meu !== pedido.current) return;
      const sessao = /→ (401|403):/.test(String(e && e.message || ""));
      setLeitura((l) => ({ ...l, falha: { desde: l.falha && l.falha.desde || Date.now(), sessao } }));
    }
  }, []);
  React.useEffect(() => {
    carregar();
    const intervalo = setInterval(carregar, COLMEIA_RECARGA_MS);
    let pendente = null;
    const aoSinal = (e) => {
      if (!e.detail || e.detail.type !== "dev_board.changed") return;
      if (pendente) return;
      pendente = setTimeout(() => {
        pendente = null;
        carregar();
      }, COLMEIA_TECTO_MS);
    };
    window.addEventListener("sr:realtime", aoSinal);
    return () => {
      clearInterval(intervalo);
      clearTimeout(pendente);
      window.removeEventListener("sr:realtime", aoSinal);
    };
  }, [carregar]);
  React.useEffect(() => {
    const id = setInterval(() => setRelogio((t) => t + 1), COLMEIA_RELOGIO_MS);
    return () => clearInterval(id);
  }, []);
  const sel = window.HiveboxColmeia.lerSelecao(ctx.params);
  const escrever = (p) => window.HubRouter.setParams(p);
  const haSelecao = sel.celulas.length > 0 || sel.favo !== null || sel.missao !== null;
  const abertoBruto = ctx.entidade ? Number(ctx.entidade) : null;
  const abertoId = Number.isInteger(abertoBruto) && abertoBruto > 0 ? abertoBruto : null;
  const abrirCartao = (id) => ctx.navigate({ routeId: ctx.view, entidade: String(id), params: ctx.params });
  const fecharCartao = () => ctx.navigate({ routeId: ctx.view, params: ctx.params });
  React.useEffect(() => {
    const tecla = (e) => {
      if (e.defaultPrevented) return;
      const t = e.target;
      if (t && (t.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(t.tagName))) return;
      if (e.key === "Escape" && haSelecao && !abertoId) window.HubRouter.setParams({ celulas: null, favo: null, missao: null });
    };
    window.addEventListener("keydown", tecla);
    return () => window.removeEventListener("keydown", tecla);
  }, [haSelecao, abertoId]);
  if (!dados) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement(ColmeiaEstado, { leitura }), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: 16 } }, leitura.falha ? "Ainda sem dados da colmeia." : "A carregar\u2026"));
  }
  const celulas = dados.favos.flatMap((f) => f.celulas);
  const operculadas = celulas.filter((c) => c.operculada).length;
  const abelhas = celulas.reduce((n, c) => n + c.abelhas.length, 0);
  const encalhadas = celulas.filter((c) => c.encalhado).length;
  const sinais = window.HiveboxColmeia.contarSinais(celulas);
  const clicar = (c, juntar) => escrever(window.HiveboxColmeia.clicarCelula(sel, c.card, juntar));
  const favoDoAberto = abertoId && dados.favos.find((f) => f.celulas.some((c) => c.card === abertoId));
  const navList = favoDoAberto ? favoDoAberto.celulas.map((c) => ({ id: c.card })) : [];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "hb-colmeia-grade", style: {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    padding: 12,
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 290px",
    gap: 12,
    alignItems: "start"
  } }, /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 0, overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 14px 4px", fontSize: 11.5 } }, /* @__PURE__ */ React.createElement("b", null, "A colmeia"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", style: { float: "right" }, onClick: () => setNovaMissao(true) }, "Nova miss\xE3o"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", celulas.length, " c\xE9lulas \xB7 ", operculadas, " operculadas \xB7 ", abelhas, " abelhas a trabalhar"), sinais.pergunta > 0 && /* @__PURE__ */ React.createElement("span", { style: { color: "var(--warn)" } }, " \xB7 \u2753 ", sinais.pergunta, " com pergunta ao Jo\xE3o"), sinais.deploy > 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", sinais.deploy, " \xE0 espera de deploy"), sinais.standby > 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", sinais.standby, " em standby"), sinais.aprovacao > 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", sinais.aprovacao, " \xE0 espera de aprova\xE7\xE3o"), sel.missao && /* @__PURE__ */ React.createElement("span", null, " \xB7 miss\xE3o: ", /* @__PURE__ */ React.createElement("b", null, (dados.missoes.find((m) => m.id === sel.missao) || {}).titulo || `#${sel.missao}`), " ", /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => escrever({ missao: null })
    },
    "limpar filtro"
  )), encalhadas > 0 && /* @__PURE__ */ React.createElement("span", { style: { color: "#c4434b" } }, " \xB7 \u26A0 ", encalhadas, " encalhadas"), /* @__PURE__ */ React.createElement(ColmeiaRonda, { ronda: dados.ronda, abrir: (id) => abrirCartao(id) }), window.HiveboxPedidosSuite && /* @__PURE__ */ React.createElement(window.HiveboxPedidosSuite, { pedidos: dados.pedidos_suite })), celulas.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted", style: { padding: "4px 14px", fontSize: 12 } }, "Ainda n\xE3o h\xE1 c\xE9lulas: cria um cart\xE3o no quadro e ele aparece aqui."), /* @__PURE__ */ React.createElement(ColmeiaEstado, { leitura }), /* @__PURE__ */ React.createElement(ColmeiaServico, { servico: dados.servico, rainha: dados.rainha }), /* @__PURE__ */ React.createElement(ColmeiaSvg, { dados, sel, clicar, escrever }), /* @__PURE__ */ React.createElement("div", { className: "muted", style: { display: "flex", gap: 12, flexWrap: "wrap", fontSize: 10.5, padding: "4px 14px 10px" } }, /* @__PURE__ */ React.createElement("span", null, "um favo por app"), /* @__PURE__ */ React.createElement("span", null, "mel = percentagem"), /* @__PURE__ */ React.createElement("span", null, "\u2713 operculada = verificada"), /* @__PURE__ */ React.createElement("span", null, "\u{1F512} \xE0 espera de outra c\xE9lula"), /* @__PURE__ */ React.createElement("span", null, "\u2753 pergunta ao Jo\xE3o por responder"), /* @__PURE__ */ React.createElement("span", null, "\u{1F680} \xE0 espera de deploy"), /* @__PURE__ */ React.createElement("span", null, "\u23F8\uFE0F em standby"), /* @__PURE__ */ React.createElement("span", null, "\u{1F41D} roxa tracejada = a trabalhar numa sess\xE3o do Claude (n\xE3o a tripula\xE7\xE3o)"), /* @__PURE__ */ React.createElement("span", null, "\u{1F464} \xE0 espera de aprova\xE7\xE3o para a tripula\xE7\xE3o"), /* @__PURE__ */ React.createElement("span", null, "contorno = cor da app"), /* @__PURE__ */ React.createElement("span", null, "\xE0 volta da rainha: as c\xE9lulas de servi\xE7o")), /* @__PURE__ */ React.createElement(
    window.HiveboxColmeiaDetalhe,
    {
      dados,
      sel,
      escrever,
      abrir: (id) => abrirCartao(id)
    }
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 12, minWidth: 0 } }, /* @__PURE__ */ React.createElement(ColmeiaTripulacao, { tripulacao: dados.tripulacao, escrever }), /* @__PURE__ */ React.createElement(ColmeiaDiario, { diario: dados.diario, escrever }))), novaMissao && window.HiveboxNovaMissao && /* @__PURE__ */ React.createElement(window.HiveboxNovaMissao, { aoFechar: () => setNovaMissao(false) }), abertoId && window.DevBoardDrawer && /* @__PURE__ */ React.createElement(
    window.DevBoardDrawer,
    {
      id: abertoId,
      navList,
      onNavigate: (x) => abrirCartao(x.id),
      onClose: fecharCartao,
      reportCrumb: ctx.reportCrumb
    }
  ));
}
window.HiveboxColmeiaView = HiveboxColmeiaView;

// ===== hivebox/frontend/entry.jsx =====
window.DevBoardView = window.DevBoardView || (() => null);
window.HiveboxPortoesView = window.HiveboxPortoesView || (() => null);
window.HiveboxTripulacaoView = window.HiveboxTripulacaoView || (() => null);
window.HiveboxColmeiaView = window.HiveboxColmeiaView || (() => null);

// ===== hivebox/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "hivebox",
  order: 11,
  name: "HIVEBOX",
  sub: "Mission Control: quadro, tripula\xE7\xE3o e port\xF5es",
  accent: "#b8860b",
  brandLogo: "/static/assets/hivebox-logo.png?v=2",
  brandEmoji: "\u{1F41D}",
  home: "hivebox_colmeia",
  launcher: true,
  frontendFiles: [
    "frontend/dev-board-forms.jsx",
    "frontend/dev-board-arrastar.js",
    "frontend/dev-board-conflitos.js",
    "frontend/dev-board-vista-verificacao.jsx",
    "frontend/dev-board-vista-recursos.jsx",
    "frontend/dev-board.jsx",
    "frontend/dev-board-drawer-acoes.jsx",
    "frontend/dev-board-documento.jsx",
    "frontend/dev-board-verificacao.jsx",
    "frontend/dev-board-dependencias.jsx",
    "frontend/dev-board-sobreposicoes.jsx",
    "frontend/perguntas.jsx",
    "frontend/pedidos-suite.jsx",
    "frontend/missoes.jsx",
    "frontend/dev-board-drawer.jsx",
    "frontend/portoes.jsx",
    "frontend/tripulacao.jsx",
    "frontend/colmeia-layout.js",
    "frontend/colmeia-lancar.jsx",
    "frontend/colmeia-detalhe.jsx",
    "frontend/colmeia.jsx",
    "frontend/entry.jsx"
  ],
  routes: [
    {
      id: "hivebox_colmeia",
      section: "HIVEBOX",
      icon: "circleHalf",
      label: "Colmeia",
      adminOnly: true,
      title: "HIVEBOX \u2014 Colmeia",
      tooltip: "Os favos, as c\xE9lulas a encher-se de mel e as abelhas a trabalhar"
    },
    {
      id: "hivebox",
      section: "HIVEBOX",
      icon: "kanban",
      label: "Quadro",
      adminOnly: true,
      title: "HIVEBOX \u2014 Quadro de desenvolvimentos",
      tooltip: "Estado dos desenvolvimentos das sess\xF5es do Claude",
      views: [
        { id: "faixas", icon: "kanban", label: "Faixas" },
        { id: "plano", icon: "list", label: "Plano" },
        { id: "verificacao", icon: "circleHalf", label: "Verifica\xE7\xE3o" },
        { id: "recursos", icon: "cog", label: "Recursos" }
      ],
      defaultView: "faixas"
    },
    {
      id: "hivebox_tripulacao",
      section: "HIVEBOX",
      icon: "user",
      label: "Tripula\xE7\xE3o",
      adminOnly: true,
      title: "HIVEBOX \u2014 Tripula\xE7\xE3o",
      tooltip: "Cada abelha, o que faz agora e h\xE1 quanto tempo deu sinal"
    },
    {
      id: "hivebox_portoes",
      section: "Opera\xE7\xE3o",
      icon: "cog",
      label: "Port\xF5es",
      adminOnly: true,
      title: "HIVEBOX \u2014 Port\xF5es",
      tooltip: "Quem abre cada passagem da linha, e em que condi\xE7\xF5es"
    }
  ],
  render: {
    hivebox_colmeia: (ctx) => React.createElement(window.HiveboxColmeiaView, { ctx }),
    hivebox: (ctx) => React.createElement(window.DevBoardView, { ctx }),
    hivebox_tripulacao: (ctx) => React.createElement(window.HiveboxTripulacaoView, { ctx }),
    hivebox_portoes: (ctx) => React.createElement(window.HiveboxPortoesView, { ctx })
  }
});

// ===== orderretriever/frontend/orderretriever-api.jsx =====
(function() {
  function getCookie(name) {
    const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? m.pop() : "";
  }
  function req(path, { method = "GET", body, params } = {}) {
    let url = path;
    if (params) {
      const q = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v !== void 0 && v !== null && v !== "") q.append(k, v);
      });
      const s = q.toString();
      if (s) url += (url.includes("?") ? "&" : "?") + s;
    }
    const opts = { method, credentials: "same-origin", headers: {} };
    if (method !== "GET") opts.headers["X-CSRFToken"] = getCookie("csrftoken");
    if (body !== void 0) {
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then((r) => {
      if (r.status === 204) return null;
      if (!r.ok) {
        return r.json().then((e) => Promise.reject({ status: r.status, ...e })).catch((e) => Promise.reject(e && e.status ? e : { status: r.status }));
      }
      return r.json();
    });
  }
  const B = "/api/orderretriever";
  function erroDRF(e, dflt) {
    if (!e) return dflt;
    if (e.detail) return e.detail;
    if (e.mensagem) return e.mensagem;
    const k = Object.keys(e).find((x) => x !== "status");
    const v = k && e[k];
    return (Array.isArray(v) ? v[0] : v) || dflt;
  }
  function textoDuplicada(d) {
    if (!d) return "";
    const quando = d.desde ? new Date(d.desde) : null;
    const dia = quando && !Number.isNaN(quando.getTime()) ? `${String(quando.getDate()).padStart(2, "0")}/${String(quando.getMonth() + 1).padStart(2, "0")}` : "";
    const estado = d.estado === "aprovada" ? "aprovada" : "por validar";
    const prep = d.estado === "aprovada" ? " a " : " desde ";
    return `J\xE1 existe a ${d.numero || `#${d.id}`}, ${estado}${dia ? prep + dia : ""}.`;
  }
  function ligarFila({ onMudou, onEstado } = {}) {
    let ws = null;
    let parado = false;
    let atraso = 1e3;
    let relogio = null;
    let ping = null;
    const estado = (ligada) => {
      if (onEstado) onEstado(ligada);
    };
    const ligar = () => {
      if (parado) return;
      const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
      try {
        ws = new WebSocket(`${proto}//${window.location.host}/ws/orderretriever/fila/`);
      } catch (e) {
        relogio = setTimeout(ligar, atraso);
        return;
      }
      ws.onopen = () => {
        atraso = 1e3;
        estado(true);
        ping = setInterval(() => {
          try {
            ws.send(JSON.stringify({ type: "ping" }));
          } catch (e) {
          }
        }, 25e3);
      };
      ws.onmessage = (ev) => {
        let msg;
        try {
          msg = JSON.parse(ev.data);
        } catch (e) {
          return;
        }
        if (msg && msg.type === "fila.mudou" && onMudou) onMudou(msg);
      };
      ws.onclose = (ev) => {
        clearInterval(ping);
        estado(false);
        if (parado || ev && (ev.code === 4401 || ev.code === 4403)) return;
        relogio = setTimeout(ligar, atraso);
        atraso = Math.min(atraso * 2, 3e4);
      };
    };
    ligar();
    return () => {
      parado = true;
      clearTimeout(relogio);
      clearInterval(ping);
      if (ws) {
        try {
          ws.close();
        } catch (e) {
        }
      }
    };
  }
  const TODOS = "todos";
  const FILTROS_POR_OMISSAO = { estado: "por_validar", sac: "eu" };
  function filtrosIniciais(params, chaves) {
    const algum = chaves.some((k) => params.has(k));
    const f = {};
    chaves.forEach((k) => {
      f[k] = algum ? params.get(k) || "" : FILTROS_POR_OMISSAO[k] || "";
    });
    return f;
  }
  function filtrosParaApi(filtros) {
    const f = {};
    Object.entries(filtros || {}).forEach(([k, v]) => {
      if (v && v !== TODOS) f[k] = v;
    });
    return f;
  }
  function conjuntoDoFiltro(valor) {
    if (!valor || valor === TODOS) return /* @__PURE__ */ new Set();
    return new Set(String(valor).split(",").filter(Boolean));
  }
  function filtroDoConjunto(conjunto) {
    return conjunto && conjunto.size ? [...conjunto].join(",") : TODOS;
  }
  function escolhaUnica(antes, depois) {
    const nova = [...depois].find((v) => !antes.has(v));
    if (nova) return nova;
    return depois.size ? [...depois][0] : "";
  }
  function filtrosAtivosN(filtros) {
    return Object.keys(filtrosParaApi(filtros)).length;
  }
  const ATALHOS = { a: "aprovar", r: "rejeitar", s: "seguinte" };
  function atalhoValidacao(ev) {
    if (!ev || ev.ctrlKey || ev.metaKey || ev.altKey || ev.repeat) return null;
    const t = ev.target || {};
    if (t.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(t.tagName)) return null;
    if (document.querySelector(".modal-overlay, .drawer-overlay")) return null;
    return ATALHOS[String(ev.key || "").toLowerCase()] || null;
  }
  function campoLido(jsonLido, caminho) {
    const m = /^(Header)\.(\w+)$|^Lines\.(\d+)\.(\w+)$/.exec(caminho || "");
    if (!m || !jsonLido) return null;
    const c = m[1] ? (jsonLido.Header || {})[m[2]] : ((jsonLido.Lines || [])[Number(m[3])] || {})[m[4]];
    if (c === void 0 || c === null) return null;
    return typeof c === "object" ? c : { valor: c, origem: [], confianca: null };
  }
  const textoDe = (v) => v === null || v === void 0 ? "" : String(v).split(/\s+/).filter(Boolean).join(" ");
  function alterado(atual, lido) {
    return textoDe(atual) !== textoDe(lido);
  }
  function confiancaBaixa(campo, limiar) {
    const c = campo && campo.confianca;
    return typeof c === "number" && c < limiar;
  }
  function indicesLidos(dados, nLidas) {
    const linhas = dados && dados.Lines || [];
    const gravados = dados && dados.IndicesLidos;
    if (!Array.isArray(gravados) || gravados.length !== linhas.length) {
      return linhas.map((_, i) => i < nLidas ? i : null);
    }
    const vistos = /* @__PURE__ */ new Set();
    return gravados.map((i) => {
      if (!Number.isInteger(i) || i < 0 || i >= nLidas || vistos.has(i)) return null;
      vistos.add(i);
      return i;
    });
  }
  function numeroDe(v) {
    if (typeof v === "number") return Number.isFinite(v) ? v : null;
    const t = textoDe(v);
    if (!/^-?\d+([.,]\d+)?$/.test(t)) return null;
    return Number(t.replace(",", "."));
  }
  function campoNumerico(v) {
    return textoDe(v) === "" || numeroDe(v) !== null;
  }
  function valorInputNumerico(v) {
    const t = textoDe(v);
    if (t === "" || /^-?\d+(\.\d+)?$/.test(t)) return t;
    const n = numeroDe(v);
    return n === null ? t : String(n);
  }
  function totalLinha(linha) {
    const q = numeroDe(linha && linha.Quantity);
    const p = numeroDe(linha && linha.UnitPrice);
    return q === null || p === null ? null : Math.round(q * p * 1e4) / 1e4;
  }
  function valorInputData(v) {
    const t = textoDe(v);
    if (t === "") return "";
    let a;
    let m;
    let d;
    let r = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(t);
    if (r) [, a, m, d] = r;
    else {
      r = /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/.exec(t);
      if (!r) return null;
      [, d, m, a] = r;
    }
    const data = new Date(Date.UTC(Number(a), Number(m) - 1, Number(d)));
    if (data.getUTCFullYear() !== Number(a) || data.getUTCMonth() !== Number(m) - 1 || data.getUTCDate() !== Number(d)) return null;
    return data.toISOString().slice(0, 10);
  }
  function totaisEncomenda(linhas) {
    let quantidade = 0;
    let total = null;
    let semTotal = 0;
    (linhas || []).forEach((l) => {
      const q = numeroDe(l && l.Quantity);
      if (q !== null) quantidade += q;
      const t = totalLinha(l);
      if (t === null) semTotal += 1;
      else total = (total || 0) + t;
    });
    const arred = (n) => Math.round(n * 1e4) / 1e4;
    return {
      linhas: (linhas || []).length,
      quantidade: arred(quantidade),
      total: total === null ? null : arred(total),
      semTotal
    };
  }
  function erroDeCampo(e) {
    const m = /^Header\.(\w+)$|^Lines\.(\d+)\.(\w+)$/.exec(e && e.campo || "");
    if (!m) return null;
    const mensagem = erroDRF(e, "Valor inv\xE1lido.");
    return m[1] ? { linha: null, campo: m[1], mensagem } : { linha: Number(m[2]), campo: m[3], mensagem };
  }
  function percentagem(c) {
    return typeof c === "number" ? `${Math.round(c * 100)} %` : "";
  }
  const ZOOMS = [50, 75, 100, 125, 150, 200, 300];
  function zoomDoUrl(v) {
    const z = parseInt(v, 10);
    return ZOOMS.includes(z) ? z : null;
  }
  function dpiPagina(larguraPx, larguraPt, densidade) {
    if (!(larguraPx > 0) || !(larguraPt > 0)) return 110;
    const dpi = larguraPx * (densidade || 1) * 72 / larguraPt;
    return Math.min(300, Math.max(75, Math.ceil(dpi / 25) * 25));
  }
  const ARRASTO_MIN_PX = 4;
  function podeArrastar(el) {
    if (!el) return false;
    return el.scrollWidth - el.clientWidth > 1 || el.scrollHeight - el.clientHeight > 1;
  }
  function ligarArrasto(el, janela) {
    let inicio = null;
    let aMover = false;
    let engolirClique = false;
    const acabar = () => {
      if (!inicio) return;
      if (aMover) {
        engolirClique = true;
        el.classList.remove("is-a-arrastar");
        try {
          el.releasePointerCapture(inicio.id);
        } catch (_) {
        }
      }
      inicio = null;
      aMover = false;
    };
    const down = (e) => {
      engolirClique = false;
      if (e.button !== 0 || e.pointerType === "touch" || !podeArrastar(el)) return;
      e.preventDefault();
      inicio = { id: e.pointerId, x: e.clientX, y: e.clientY, left: el.scrollLeft, top: el.scrollTop };
    };
    const move = (e) => {
      if (!inicio) {
        if (podeArrastar(el)) el.classList.add("is-arrastavel");
        else el.classList.remove("is-arrastavel");
        return;
      }
      const dx = e.clientX - inicio.x;
      const dy = e.clientY - inicio.y;
      if (!aMover) {
        if (Math.hypot(dx, dy) < ARRASTO_MIN_PX) return;
        aMover = true;
        el.classList.add("is-a-arrastar");
        try {
          el.setPointerCapture(inicio.id);
        } catch (_) {
        }
      }
      el.scrollLeft = inicio.left - dx;
      el.scrollTop = inicio.top - dy;
    };
    const clique = (e) => {
      if (!engolirClique) return;
      engolirClique = false;
      e.stopPropagation();
      e.preventDefault();
    };
    const dragstart = (e) => e.preventDefault();
    el.addEventListener("pointerdown", down);
    el.addEventListener("pointermove", move);
    el.addEventListener("pointerup", acabar);
    el.addEventListener("pointercancel", acabar);
    el.addEventListener("click", clique, true);
    el.addEventListener("dragstart", dragstart);
    janela.addEventListener("pointerup", acabar);
    janela.addEventListener("pointercancel", acabar);
    return () => {
      el.removeEventListener("pointerdown", down);
      el.removeEventListener("pointermove", move);
      el.removeEventListener("pointerup", acabar);
      el.removeEventListener("pointercancel", acabar);
      el.removeEventListener("click", clique, true);
      el.removeEventListener("dragstart", dragstart);
      janela.removeEventListener("pointerup", acabar);
      janela.removeEventListener("pointercancel", acabar);
    };
  }
  function rotuloCampo(caminho, campos) {
    const m = /^Header\.(\w+)$|^Lines\.(\d+)(?:\.(\w+))?$/.exec(caminho || "");
    if (!m) return caminho || "";
    const rotulo = (lista, k) => ((lista || []).find((c) => c.campo === k) || {}).label || k;
    if (m[1]) return rotulo(campos && campos.header, m[1]);
    const linha = Number(m[2]) + 1;
    return m[3] ? `${rotulo(campos && campos.linha, m[3])}, linha ${linha}` : `Linha ${linha}`;
  }
  function abaPropria(enc) {
    return enc && enc.anexo ? `a${enc.anexo}` : "documento";
  }
  function abasDoDocumento(enc) {
    const anexos = (enc && enc.email && enc.email.anexos || []).filter((a) => !a.inline);
    const irmas = enc && enc.irmas || [];
    const abas = anexos.map((a) => ({
      chave: `a${a.id}`,
      nome: a.nome,
      anexo: a,
      propria: a.id === enc.anexo,
      irma: irmas.find((o) => o.anexo === a.id) || null
    }));
    if (!enc.anexo) {
      abas.unshift({ chave: "documento", nome: "Corpo do email", anexo: null, propria: true, irma: null });
    }
    abas.push({ chave: "email", nome: "Email", anexo: null, propria: false, irma: null });
    return abas;
  }
  function anexoHtml(anexo) {
    if (!anexo) return false;
    return /\.html?$/i.test(anexo.nome || "") || (anexo.tipo || "").toLowerCase() === "text/html";
  }
  function srcdocCorpo(html) {
    const csp = "default-src 'none'; img-src data:; style-src 'unsafe-inline'; font-src data:";
    return `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="${csp}"><base target="_blank"><style>body{margin:12px;font:13px/1.45 system-ui,sans-serif;color:#222;background:#fff;}img{max-width:100%;height:auto;}</style></head><body>${html || ""}</body></html>`;
  }
  const numeroPt = (n) => Number(n).toLocaleString("pt-PT", { maximumFractionDigits: 4 });
  const dataPt = (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
    return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
  };
  function infoDaLinha(val, n) {
    const info = val && val.linhas && val.linhas[n] && val.linhas[n].info;
    return info && Object.keys(info).length ? info : null;
  }
  function faixaDaLinha(info) {
    if (!info) return [];
    const out = [];
    if (info.qtd_palete) out.push(`Qtd. por palete ${numeroPt(info.qtd_palete)}`);
    if (info.qtd_otima) out.push(`Qtd. \xF3tima de produ\xE7\xE3o ${numeroPt(info.qtd_otima)}`);
    if (info.stock_guimaraes != null) out.push(`Guimar\xE3es ${numeroPt(info.stock_guimaraes)}`);
    if (info.stock_barquinha != null) out.push(`Barquinha ${numeroPt(info.stock_barquinha)}`);
    if (info.stock_total != null) out.push(`total ${numeroPt(info.stock_total)}`);
    if (info.reservado_total > 0) {
      const esta = info.reservado_esta > 0 ? ` (dos quais ${numeroPt(info.reservado_esta)} por esta encomenda)` : "";
      out.push(`reservado ${numeroPt(info.reservado_total)}${esta} \xB7 dispon\xEDvel ${numeroPt(info.disponivel_total)}`);
    }
    if (info.fabrica) out.push(`f\xE1brica ${info.fabrica}`);
    if (info.lead_time != null) {
      out.push(`lead time ${numeroPt(info.lead_time)} ${info.lead_time === 1 ? "dia \xFAtil" : "dias \xFAteis"}`);
    }
    const gb = [info.gerido_g ? "G" : null, info.gerido_b ? "B" : null].filter(Boolean).join("/");
    if (gb) out.push(`gerido por stock ${gb}`);
    else if (info.gerido_stock) out.push("gerido por stock");
    if (info.ppwr) out.push(`PPWR ${info.ppwr}`);
    if (info.mono) out.push("pode ser feito com MP mono");
    return out;
  }
  const SEM_QTD_PALETE = "sem quantidade por palete no PHC";
  function textoPaletes(pal) {
    if (!pal) return "";
    const p = `${numeroPt(pal.paletes)} ${pal.paletes === 1 ? "palete" : "paletes"}`;
    return pal.multiplo ? p : `${p} e ${numeroPt(pal.resto)} un. \u2014 n\xE3o \xE9 m\xFAltiplo`;
  }
  function programacaoDaLinha(val, n) {
    return val && val.linhas && val.linhas[n] && val.linhas[n].programacao || null;
  }
  const semanaPt = (s) => s ? `semana ${Number(String(s).split("-W")[1])}` : "";
  const obranosDe = (p) => [...new Set((p.encomendas || []).map((e) => e.obrano))];
  const diaMes = (iso) => dataPt(iso).slice(0, 5);
  const adiadosPt = (p) => [...new Set((p.adiados || []).map((a) => `${diaMes(a.data)} (enc. ${a.obrano})`))].join(", ");
  const cobrePt = (p) => (p.cobre || []).map((c) => `${numeroPt(c.qtd)} cobrem a ${semanaPt(c.semana)}`).join(", ");
  function textoQuadro(p) {
    const adiado = (p.adiados || []).reduce((s, a) => s + Number(a.qtd), 0);
    if (p.coberto) {
      if (adiado) {
        return `coberta \u2014 adiada para ${adiadosPt(p)}${Number(p.ja_lancado) > 0 ? ` \xB7 ${numeroPt(p.ja_lancado)} j\xE1 lan\xE7adas na ${semanaPt(p.semana)}` : ""} \xB7 nada a lan\xE7ar`;
      }
      const ns = obranosDe(p);
      const sobra = cobrePt(p);
      return `j\xE1 lan\xE7ada na${ns.length > 1 ? "s" : ""} encomenda${ns.length > 1 ? "s" : ""} ${ns.join(", ")} (${numeroPt(p.ja_lancado)} na ${semanaPt(p.semana)}${sobra ? `, dos quais ${sobra}` : ""}) \xB7 nada a lan\xE7ar`;
    }
    return `a lan\xE7ar ${textoALancar(p)} \xB7 quadro ${numeroPt(p.pedido)} \u2212 j\xE1 lan\xE7ado ${numeroPt(p.ja_lancado)} na ${semanaPt(p.semana)}` + (obranosDe(p).length ? ` (encomenda ${obranosDe(p).join(", ")})` : "") + (adiado ? ` \u2212 adiado ${numeroPt(adiado)} para ${adiadosPt(p)}` : "");
  }
  const quadroCoberto = (val, n) => {
    const p = programacaoDaLinha(val, n);
    return !!p && p.tipo === "quadro" && !!p.coberto;
  };
  const aZero = (l) => textoDe(l.Quantity) === "" || numeroDe(l.Quantity) === 0;
  function linhasForaDoXls(linhas, val) {
    const out = { cobertas: 0, lancadas: 0, a_mao: 0, total: 0, todas: false };
    const ls = linhas || [];
    ls.forEach((l, n) => {
      if (!aZero(l)) return;
      out.total += 1;
      if (l.QuantidadePedida == null || l.QuantidadePedida === "") {
        out.a_mao += 1;
        return;
      }
      const p = programacaoDaLinha(val, n);
      const tipo = p && p.tipo || val && val.programacao && val.programacao.tipo;
      if (tipo === "quadro") out.lancadas += 1;
      else out.cobertas += 1;
    });
    out.todas = ls.length > 0 && out.total === ls.length;
    return out;
  }
  function textoForaDoXls(linhas, val) {
    const f = linhasForaDoXls(linhas, val);
    const um = (n, s, p) => `${n} ${n === 1 ? s : p} fora do .xls.`;
    return [
      f.cobertas && um(f.cobertas, "linha a 0 (coberta pelo stock) fica", "linhas a 0 (cobertas pelo stock) ficam"),
      f.lancadas && um(f.lancadas, "j\xE1 lan\xE7ada fica", "j\xE1 lan\xE7adas ficam"),
      f.a_mao && um(f.a_mao, "linha com quantidade 0 fica", "linhas com quantidade 0 ficam")
    ].filter(Boolean).join(" ");
  }
  function textoProgramacao(p) {
    if (!p) return "";
    if (p.tipo === "quadro") return textoQuadro(p);
    if (p.tipo === "kit") {
      return p.coberto ? "kit: a lan\xE7ar 0 \xB7 os constituintes cobrem o pedido" : `kit: a lan\xE7ar ${textoALancar(p)}${p.manda ? ` (manda ${p.manda})` : ""}`;
    }
    const conta = `pedido ${numeroPt(p.pedido)} \u2212 stock dispon\xEDvel ${numeroPt(p.stock)} \u2212 enc. stock por produzir ${numeroPt(p.enc_stock_aberta)}`;
    return `a lan\xE7ar ${textoALancar(p)} \xB7 ${conta}${p.coberto ? " \xB7 o pedido j\xE1 est\xE1 coberto" : ""}`;
  }
  function textoALancar(p) {
    const pal = p && p.palete;
    if (!pal) return p ? numeroPt(p.a_lancar) : "";
    const paletes = `(${numeroPt(pal.paletes)} ${pal.paletes === 1 ? "palete" : "paletes"} de ${numeroPt(pal.qtd_palete)})`;
    return Number(pal.a_lancar_conta) === Number(p.a_lancar) ? `${numeroPt(p.a_lancar)} ${paletes}` : `${numeroPt(pal.a_lancar_conta)} \u2192 ${numeroPt(p.a_lancar)} ${paletes}`;
  }
  const programacaoMuda = (p) => !!p && Number(p.a_lancar) !== Number(p.pedido);
  function comQuantidadeCalculada(l, p) {
    if (!p || numeroDe(l.Quantity) === Number(p.a_lancar)) return null;
    const pedida = l.QuantidadePedida != null && l.QuantidadePedida !== "" ? l.QuantidadePedida : p.pedido;
    return { ...l, Quantity: p.a_lancar, QuantidadePedida: pedida };
  }
  function usarQuantidadesCalculadas(linhas, val) {
    let mudadas = 0;
    const out = (linhas || []).map((l, n) => {
      const p = programacaoDaLinha(val, n);
      const nova = p && p.semana_passada ? null : comQuantidadeCalculada(l, p);
      if (!nova) return l;
      mudadas += 1;
      return nova;
    });
    return { linhas: out, mudadas };
  }
  const chaveDesignacao = (l) => l._orig != null ? `o${l._orig}` : `k${l._k}`;
  const designacaoDaLinha = (val, n) => {
    const f = val && val.linhas && val.linhas[n] && val.linhas[n].ficha;
    return f && f.designacao || null;
  };
  function preencherPelaDesignacao(linhas, val, feitas) {
    const mudadas = [];
    const out = (linhas || []).map((l, n) => {
      const d = designacaoDaLinha(val, n);
      const e = d && d.escolhida;
      if (!e || !e.na_tabela || feitas.has(chaveDesignacao(l)) || String(l.RefPHC || "").trim()) return l;
      mudadas.push(chaveDesignacao(l));
      const vazia = !String(l.Reference == null ? "" : l.Reference).trim();
      return {
        ...l,
        RefPHC: e.ref,
        ...vazia && e.ref_cliente ? { Reference: e.ref_cliente } : {},
        _designacao: { design: e.design, semelhanca: e.semelhanca }
      };
    });
    return { linhas: out, mudadas };
  }
  const DESIGNACAO_CHAVE = "orderretriever:designacao-feitas";
  const DESIGNACAO_MAX_ENCOMENDAS = 200;
  const lerDesignacaoGuardada = () => {
    try {
      const v = JSON.parse(window.localStorage.getItem(DESIGNACAO_CHAVE) || "[]");
      return Array.isArray(v) ? v.filter((e) => Array.isArray(e) && Array.isArray(e[1])) : [];
    } catch (e) {
      return [];
    }
  };
  function designacaoFeitasDe(id) {
    const e = lerDesignacaoGuardada().find(([i]) => String(i) === String(id));
    return new Set(e ? e[1] : []);
  }
  function guardarDesignacaoFeitas(id, feitas) {
    const resto = lerDesignacaoGuardada().filter(([i]) => String(i) !== String(id));
    const lista = [...resto, [id, [...feitas]]].slice(-DESIGNACAO_MAX_ENCOMENDAS);
    try {
      window.localStorage.setItem(DESIGNACAO_CHAVE, JSON.stringify(lista));
    } catch (e) {
    }
  }
  const candidatosDaDesignacao = (val, n) => {
    const d = designacaoDaLinha(val, n);
    return d && d.candidatos || [];
  };
  function usarQuantidadeCalculada(linhas, val, k) {
    const n = (linhas || []).findIndex((l) => l._k === k);
    if (n < 0) return null;
    const p = programacaoDaLinha(val, n);
    const nova = comQuantidadeCalculada(linhas[n], p);
    if (!nova) return null;
    return { linhas: linhas.map((l, i) => i === n ? nova : l), n, pedido: linhas[n].Quantity, a_lancar: p.a_lancar };
  }
  const qPorAplicar = (p, quantidade) => programacaoMuda(p) && numeroDe(quantidade) !== Number(p.a_lancar);
  function textoEncomendaProgramacao(e) {
    const dia = e.data ? dataPt(e.data) : "sem data";
    if (e.data_encomenda !== void 0) {
      return `entrega ${dia} \xB7 ${numeroPt(e.qtd)} un.${e.data_encomenda ? ` \xB7 lan\xE7ada a ${dataPt(e.data_encomenda)}` : ""}`;
    }
    if (e.tipo === "stock" && e.quantidade != null) {
      return `${dia} \xB7 ${numeroPt(e.quantidade)} encomendadas \xB7 ${numeroPt(e.produzida)} produzidas \xB7 ${numeroPt(e.por_produzir)} por produzir`;
    }
    return `${dia} \xB7 ${numeroPt(e.qtd)} por entregar`;
  }
  const TIPO_ENCOMENDA_PROGRAMACAO = { stock: "encomenda \xABStock\xBB", lancada: "lan\xE7ada" };
  window.OrderretrieverAPI = {
    TODOS,
    programacaoDaLinha,
    textoALancar,
    textoPaletes,
    SEM_QTD_PALETE,
    textoProgramacao,
    adiadosPt,
    cobrePt,
    quadroCoberto,
    linhasForaDoXls,
    textoForaDoXls,
    semanaPt,
    programacaoMuda,
    usarQuantidadesCalculadas,
    designacaoDaLinha,
    chaveDesignacao,
    preencherPelaDesignacao,
    designacaoFeitasDe,
    guardarDesignacaoFeitas,
    candidatosDaDesignacao,
    usarQuantidadeCalculada,
    qPorAplicar,
    TIPO_ENCOMENDA_PROGRAMACAO,
    textoEncomendaProgramacao,
    anexoHtml,
    srcdocCorpo,
    abaPropria,
    abasDoDocumento,
    ZOOMS,
    zoomDoUrl,
    dpiPagina,
    podeArrastar,
    ligarArrasto,
    rotuloCampo,
    campoLido,
    alterado,
    confiancaBaixa,
    indicesLidos,
    numeroDe,
    campoNumerico,
    valorInputNumerico,
    totalLinha,
    valorInputData,
    totaisEncomenda,
    erroDeCampo,
    percentagem,
    filtrosIniciais,
    filtrosParaApi,
    conjuntoDoFiltro,
    filtroDoConjunto,
    escolhaUnica,
    filtrosAtivosN,
    atalhoValidacao,
    // Por estado que pede alguém: {por_validar, com_erro, a_processar}.
    contadores: (filtros = {}) => req(`${B}/encomendas/contadores/`, { params: filtrosParaApi(filtros) }),
    // A seguinte por validar da fila, com os filtros da lista: {id|null, restantes}.
    seguinte: (atual, filtros = {}) => req(
      `${B}/encomendas/seguinte/`,
      { params: { ...filtrosParaApi(filtros), atual } }
    ),
    erroDRF,
    textoDuplicada,
    ligarFila,
    // Devolve {rows,total} — a forma que o HubList.List espera em modo server.
    encomendas({ page = 1, pageSize, ordering = "", filtros = {} } = {}) {
      return req(`${B}/encomendas/`, {
        params: { page, page_size: pageSize, ordering, ...filtros }
      }).then((r) => ({ rows: r.results || [], total: r.count || 0 }));
    },
    encomenda: (id) => req(`${B}/encomendas/${encodeURIComponent(id)}/`),
    reprocessar: (id, refazerTexto = false) => req(
      `${B}/encomendas/${encodeURIComponent(id)}/reprocessar/`,
      { method: "POST", body: { refazer_texto: refazerTexto } }
    ),
    // «Reprocessar todas»: as paradas por a IA ter falhado voltam a ser lidas,
    // em fundo (202 com {marcadas}).
    reprocessarComErro: () => req(`${B}/encomendas/reprocessar-com-erro/`, { method: "POST" }),
    // Validar (fatia 3): `dados` = {Header: {campo: valor}, Lines: [{…}]}.
    editar: (id, dados) => req(
      `${B}/encomendas/${encodeURIComponent(id)}/editar/`,
      { method: "POST", body: { dados } }
    ),
    mudarCliente: (id, clienteNo) => req(
      `${B}/encomendas/${encodeURIComponent(id)}/cliente/`,
      { method: "POST", body: { cliente_no: clienteNo } }
    ),
    // Validação PHC (ORD-32): alertas por linha/cabeçalho + ficha do artigo.
    // `refrescar` (#277, «Reprocessar PHC»): ignora a cache do servidor — o PHC mudou.
    validacaoPhc: (id, dados, { refrescar = false } = {}) => req(
      `${B}/encomendas/${encodeURIComponent(id)}/validacao-phc/`,
      { method: "POST", body: refrescar ? { dados, refrescar: true } : { dados } }
    ),
    infoDaLinha,
    faixaDaLinha,
    dataPt,
    alertasDaLinha: (val, n) => val && val.linhas && val.linhas[n] && val.linhas[n].alertas || [],
    // #269: a linha já está lançada no PHC (alerta X, campo = a linha inteira).
    jaLancada: (val, n) => !!(val && val.linhas && val.linhas[n] && (val.linhas[n].alertas || []).some((a) => a.id === "X")),
    fichaDaLinha: (val, n) => val && val.linhas && val.linhas[n] && val.linhas[n].ficha || null,
    alertasDoCampo: (val, caminho) => {
      if (!val) return [];
      const todos = [
        ...val.cabecalho && val.cabecalho.alertas || [],
        ...(val.linhas || []).flatMap((l) => l.alertas || [])
      ];
      return todos.filter((a) => a.campo === caminho);
    },
    apagar: (id, motivo = "") => req(
      `${B}/encomendas/${encodeURIComponent(id)}/apagar/`,
      { method: "POST", body: { motivo } }
    ),
    repor: (id) => req(`${B}/encomendas/${encodeURIComponent(id)}/repor/`, { method: "POST", body: {} }),
    apagadas: () => req(`${B}/encomendas/apagadas/`),
    aprovar: (id, dados) => req(
      `${B}/encomendas/${encodeURIComponent(id)}/aprovar/`,
      { method: "POST", body: { dados } }
    ),
    rejeitar: (id, motivo, nota = "") => req(
      `${B}/encomendas/${encodeURIComponent(id)}/rejeitar/`,
      { method: "POST", body: { motivo, nota } }
    ),
    historico: (id) => req(`${B}/encomendas/${encodeURIComponent(id)}/historico/`),
    ficheiroUrl: (id, tipo) => `${B}/encomendas/${encodeURIComponent(id)}/ficheiros/${tipo}/`,
    clientes: (q) => req(`${B}/clientes/`, { params: { q } }),
    // «Ref. PHC» das linhas: histórico do cliente + catálogo do PHC (#228).
    referencias: (clienteNo, q) => req(`${B}/referencias/`, { params: { cliente_no: clienteNo, q } }),
    saida: () => req(`${B}/saida/`),
    gravarSaida: (d) => req(`${B}/saida/`, { method: "PUT", body: d }),
    // A página n (base 1) de um anexo PDF/imagem, em PNG (`dpi` de dpiPagina).
    // O que o separador de um anexo mostra: {modo: paginas|ficheiro|nenhum,
    // paginas: [{largura, altura}], convertido, erro} (Excel/Word convertem-se).
    previsaoAnexo: (anexoId) => req(`${B}/anexos/${anexoId}/previsao/`),
    // {html, imagens_externas}: o corpo higienizado (`html` vazio = só texto).
    corpoEmail: (emailId) => req(`${B}/emails/${emailId}/corpo/`),
    corpoAnexo: (anexoId) => req(`${B}/anexos/${anexoId}/corpo/`),
    paginaUrl: (anexoId, n, dpi = 110) => `${B}/anexos/${anexoId}/paginas/${n}/?dpi=${dpi}`,
    ia: () => req(`${B}/ia/`),
    gravarIa: (d) => req(`${B}/ia/`, { method: "PUT", body: d }),
    testarIa: () => req(`${B}/ia/testar/`, { method: "POST" }),
    estadoIa: () => req(`${B}/ia/estado/`),
    contaIa: () => req(`${B}/ia/conta/`),
    faixaIa: () => req(`${B}/ia/faixa/`),
    // Aprendizagem (ORD-13): {dias, cliente_no} → o painel (5 min de cache).
    aprendizagem: (params = {}) => req(`${B}/aprendizagem/`, { params }),
    faixaPoller: () => req(`${B}/poller/faixa/`),
    opcoes: () => req(`${B}/opcoes/`),
    graph: () => req(`${B}/graph/`),
    gravarGraph: (d) => req(`${B}/graph/`, { method: "PUT", body: d }),
    testarGraph: () => req(`${B}/graph/testar/`, { method: "POST" }),
    motivos: () => req(`${B}/motivos/`),
    // Triagem: {rejeitadas: [ids], recusadas: [{id, motivo}]}.
    rejeitarEmLote: (ids, motivo, nota = "") => req(
      `${B}/encomendas/rejeitar-em-lote/`,
      { method: "POST", body: { ids, motivo, nota } }
    ),
    criarMotivo: (d) => req(`${B}/motivos/`, { method: "POST", body: d }),
    editarMotivo: (id, d) => req(`${B}/motivos/${id}/`, { method: "PATCH", body: d }),
    apagarMotivo: (id) => req(`${B}/motivos/${id}/`, { method: "DELETE" }),
    dominiosInternos: () => req(`${B}/dominios-internos/`),
    criarDominioInterno: (d) => req(`${B}/dominios-internos/`, { method: "POST", body: d }),
    editarDominioInterno: (id, d) => req(`${B}/dominios-internos/${id}/`, { method: "PATCH", body: d }),
    apagarDominioInterno: (id) => req(`${B}/dominios-internos/${id}/`, { method: "DELETE" }),
    mapaSac: () => req(`${B}/mapa-sac/`),
    porMapear: () => req(`${B}/mapa-sac/por-mapear/`),
    nomesPhc: () => req(`${B}/mapa-sac/nomes-phc/`),
    criarMapa: (d) => req(`${B}/mapa-sac/`, { method: "POST", body: d }),
    editarMapa: (id, d) => req(`${B}/mapa-sac/${id}/`, { method: "PATCH", body: d }),
    apagarMapa: (id) => req(`${B}/mapa-sac/${id}/`, { method: "DELETE" }),
    utilizadores: () => req(`${B}/utilizadores/`),
    // Ensinar (fatia 4): regras por cliente e prompt base.
    // regras() → {regras, pode_editar, sem_correcao?} (o chip, com `cliente_no`).
    regras: (params = {}) => req(`${B}/regras/`, { params }),
    criarRegra: (d) => req(`${B}/regras/`, { method: "POST", body: d }),
    editarRegra: (id, d) => req(`${B}/regras/${id}/`, { method: "PATCH", body: d }),
    apagarRegra: (id) => req(`${B}/regras/${id}/`, { method: "DELETE" }),
    historicoRegra: (id) => req(`${B}/regras/${id}/historico/`),
    // #271: opções por cliente (a programação mensal).
    opcoesCliente: (params = {}) => req(`${B}/opcoes-cliente/`, { params }),
    gravarOpcaoCliente: (d) => req(`${B}/opcoes-cliente/`, { method: "POST", body: d }),
    // #229: os exemplos que entram na próxima leitura (os mais parecidos, já
    // cortados pelo orçamento) → {orcamento_tokens, tokens, exemplos}.
    exemplosEncomenda: (id) => req(`${B}/encomendas/${id}/exemplos/`),
    promptBase: () => req(`${B}/prompt-base/`),
    gravarPromptBase: (texto) => req(`${B}/prompt-base/`, { method: "PUT", body: { texto } }),
    versaoPromptBase: (id) => req(`${B}/prompt-base/${id}/`)
  };
})();

// ===== orderretriever/frontend/orderretriever_util.jsx =====
(function() {
  function EstadoBadge({ estado, label }) {
    return /* @__PURE__ */ React.createElement("span", { className: `pill or-estado or-estado--${estado}` }, /* @__PURE__ */ React.createElement("span", { className: "dot" }), label || estado);
  }
  function dataHora(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "\u2014";
    const p = (n) => String(n).padStart(2, "0");
    return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
  }
  function tamanho(bytes) {
    if (!bytes) return "0 KB";
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  }
  function Aviso({ tipo = "info", children, title }) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        role: tipo === "erro" ? "alert" : "status",
        title,
        className: `or-aviso or-aviso--${tipo === "erro" ? "erro" : "info"}`
      },
      children
    );
  }
  function Alerta() {
    return /* @__PURE__ */ React.createElement("span", { className: "or-alerta", "aria-hidden": "true" }, " \u26A0");
  }
  window.OrderretrieverUtil = { EstadoBadge, dataHora, tamanho, Aviso, Alerta };
})();

// ===== orderretriever/frontend/orderretriever_documento.jsx =====
function orConfiancaOcr(documento) {
  const confs = (documento.paginas || []).filter((p) => p.fonte === "ocr" && p.qualidade && typeof p.qualidade.conf === "number").map((p) => p.qualidade.conf);
  if (!confs.length) return "";
  const media = confs.reduce((a, b) => a + b, 0) / confs.length;
  return ` \xB7 confian\xE7a ${Math.round(media)} %`;
}
function orNaSelecao(c, selecionado) {
  if (!selecionado) return false;
  return c === selecionado || c.startsWith(`${selecionado}.`);
}
function orCaixaEstilo(caixa, pagina) {
  const [x0, y0, x1, y1] = caixa;
  const folga = 2;
  const pct = (v, total) => `${100 * v / total}%`;
  return {
    left: pct(x0 - folga, pagina.largura),
    top: pct(y0 - folga, pagina.altura),
    width: pct(x1 - x0 + 2 * folga, pagina.largura),
    height: pct(y1 - y0 + 2 * folga, pagina.altura)
  };
}
const OR_PX_POR_PT = 96 / 72;
function OrderretrieverPaginas({ anexoId, paginas, realces, campos, selecionado, onSelecionar, pagina, onPagina, zoom, onZoom }) {
  const Ico = window.Ico;
  const API = window.OrderretrieverAPI;
  const caixaRef = React.useRef(null);
  const maiorDpi = React.useRef({});
  const [larguraFolha, setLarguraFolha] = React.useState(null);
  const [carregada, setCarregada] = React.useState("");
  const n = Math.min(Math.max(1, pagina || 1), paginas.length);
  const pag = paginas[n - 1];
  React.useLayoutEffect(() => {
    const el = caixaRef.current;
    if (!el) return void 0;
    const medir = () => {
      const estilo = window.getComputedStyle(el);
      const pad = parseFloat(estilo.paddingLeft || 0) + parseFloat(estilo.paddingRight || 0);
      setLarguraFolha(Math.max(0, el.clientWidth - pad));
    };
    medir();
    if (typeof window.ResizeObserver !== "function") return void 0;
    const ro = new window.ResizeObserver(medir);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  const larguraReal = pag.largura * OR_PX_POR_PT;
  const larguraPx = zoom ? larguraReal * zoom / 100 : larguraFolha || 0;
  const zoomEfetivo = zoom || (larguraFolha ? Math.round(100 * larguraFolha / larguraReal) : 100);
  const menor = [...API.ZOOMS].reverse().find((v) => v < zoomEfetivo);
  const maior = API.ZOOMS.find((v) => v > zoomEfetivo);
  const chave = `${anexoId}:${n}`;
  const medido = larguraPx > 0 ? API.dpiPagina(larguraPx, pag.largura, window.devicePixelRatio || 1) : 0;
  const dpi = Math.max(maiorDpi.current[chave] || 0, medido) || 110;
  if (medido) maiorDpi.current[chave] = dpi;
  const src = API.paginaUrl(anexoId, n, dpi);
  const aCarregar = !larguraFolha || carregada !== src;
  const realcesPag = [];
  Object.entries(realces || {}).forEach(([campo, r]) => {
    (r.caixas || []).forEach((c, k) => {
      if (c.pagina === n) {
        realcesPag.push({ campo, caixa: c.caixa, ativo: orNaSelecao(campo, selecionado), k });
      }
    });
  });
  React.useEffect(() => {
    const el = caixaRef.current;
    return el ? window.OrderretrieverAPI.ligarArrasto(el, window) : void 0;
  }, []);
  React.useEffect(() => {
    const el = caixaRef.current && caixaRef.current.querySelector('[data-ativo="1"]');
    if (el && el.scrollIntoView) el.scrollIntoView({ block: "center", inline: "nearest" });
  }, [selecionado, n]);
  return /* @__PURE__ */ React.createElement("div", { className: "or-paginas" }, /* @__PURE__ */ React.createElement("div", { className: "or-paginas__barra" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-label": "P\xE1gina anterior",
      disabled: n <= 1,
      onClick: () => onPagina(n - 1)
    },
    /* @__PURE__ */ React.createElement(Ico.chevron, { className: "or-ico-esq" })
  ), /* @__PURE__ */ React.createElement("span", { "aria-live": "polite" }, "P\xE1g. ", n, "/", paginas.length), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-label": "P\xE1gina seguinte",
      disabled: n >= paginas.length,
      onClick: () => onPagina(n + 1)
    },
    /* @__PURE__ */ React.createElement(Ico.chevron, { className: "or-ico-dir" })
  ), /* @__PURE__ */ React.createElement("span", { className: "muted", "aria-live": "polite" }, aCarregar ? "A carregar\u2026" : ""), /* @__PURE__ */ React.createElement("span", { className: "or-espaco" }), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-label": "Diminuir zoom",
      disabled: !menor,
      onClick: () => onZoom(menor)
    },
    "\u2212"
  ), /* @__PURE__ */ React.createElement("span", { "aria-live": "polite" }, zoomEfetivo, " %"), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-label": "Aumentar zoom",
      disabled: !maior,
      onClick: () => onZoom(maior)
    },
    /* @__PURE__ */ React.createElement(Ico.plus, null)
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: `btn sm ${zoom ? "ghost" : "primary"}`,
      "aria-pressed": !zoom,
      onClick: () => onZoom(null)
    },
    "Ajustar \xE0 largura"
  )), /* @__PURE__ */ React.createElement("div", { ref: caixaRef, className: "or-paginas__folha" }, /* @__PURE__ */ React.createElement("div", { className: "or-paginas__pagina", style: { width: zoom ? `${larguraPx}px` : "100%" } }, !!larguraFolha && /* @__PURE__ */ React.createElement(
    "img",
    {
      src,
      alt: `P\xE1gina ${n} do documento`,
      className: "or-paginas__img",
      draggable: false,
      onLoad: () => setCarregada(src),
      onError: () => setCarregada(src)
    }
  ), realcesPag.map((r) => {
    const rotulo = API.rotuloCampo(r.campo, campos);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: `${r.campo}:${r.k}`,
        type: "button",
        title: rotulo,
        "aria-label": `Realce: ${rotulo}`,
        "data-ativo": r.ativo ? "1" : "0",
        className: `or-realce${r.ativo ? " is-ativo" : ""}`,
        style: orCaixaEstilo(r.caixa, pag),
        onClick: () => onSelecionar(r.campo)
      }
    );
  }))));
}
function orOrigens(realces, selecionado) {
  const ativas = /* @__PURE__ */ new Set();
  const todas = /* @__PURE__ */ new Map();
  Object.entries(realces || {}).forEach(([campo, r]) => {
    (r.origem || []).forEach((i) => {
      if (!todas.has(i)) todas.set(i, campo);
      if (orNaSelecao(campo, selecionado)) ativas.add(i);
    });
  });
  return { ativas, todas };
}
function orPalavraClasse(ativa, realcada) {
  if (ativa) return "or-palavra is-ativa";
  if (realcada) return "or-palavra is-realcada";
  return void 0;
}
function OrderretrieverTexto({ documento, realces, campos, selecionado, onSelecionar }) {
  const caixaRef = React.useRef(null);
  const { ativas, todas } = orOrigens(realces, selecionado);
  const palavras = documento.palavras || [];
  React.useEffect(() => {
    const el = caixaRef.current && caixaRef.current.querySelector('[data-ativo="1"]');
    if (el && el.scrollIntoView) el.scrollIntoView({ block: "center", inline: "nearest" });
  }, [selecionado]);
  const marca = (p, conteudo) => {
    const ativa = ativas.has(p.i);
    const campo = todas.get(p.i);
    const rotulo = campo ? window.OrderretrieverAPI.rotuloCampo(campo, campos) : void 0;
    const tecla = (e) => {
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      onSelecionar(campo);
    };
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        key: p.i,
        "data-ativo": ativa ? "1" : "0",
        title: rotulo,
        className: orPalavraClasse(ativa, !!campo),
        role: campo ? "button" : void 0,
        tabIndex: campo ? 0 : void 0,
        "aria-label": campo ? `${p.texto} (${rotulo})` : void 0,
        "aria-pressed": campo ? ativa : void 0,
        onKeyDown: campo ? tecla : void 0,
        onClick: campo ? () => onSelecionar(campo) : void 0
      },
      conteudo
    );
  };
  if (documento.fonte_texto === "excel") {
    const folhas = (documento.folhas || []).map((f) => {
      const cel = /* @__PURE__ */ new Map();
      palavras.filter((p) => p.folha === f.nome).forEach((p) => cel.set(`${p.celula[0]}:${p.celula[1]}`, p));
      return { ...f, cel };
    });
    return /* @__PURE__ */ React.createElement("div", { ref: caixaRef, className: "or-doc__corpo" }, folhas.map((f) => /* @__PURE__ */ React.createElement("section", { key: f.nome, "aria-label": `Folha ${f.nome}`, className: "or-folha" }, /* @__PURE__ */ React.createElement("div", { className: "muted or-folha__nome" }, "Folha \xAB", f.nome, "\xBB"), /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "grid",
        className: "or-grelha",
        style: { gridTemplateColumns: `repeat(${Math.max(1, f.colunas)}, minmax(70px, max-content))` }
      },
      Array.from({ length: f.linhas }).map((_, r) => Array.from({ length: f.colunas }).map((__, c) => {
        const p = f.cel.get(`${r}:${c}`);
        return /* @__PURE__ */ React.createElement("div", { key: `${r}:${c}`, role: "gridcell", className: "or-grelha__celula" }, p ? marca(p, p.texto) : null);
      }))
    ))));
  }
  const linhas = [];
  palavras.forEach((p) => {
    const ultima = linhas[linhas.length - 1];
    if (ultima && ultima.linha === p.linha) ultima.palavras.push(p);
    else linhas.push({ linha: p.linha, palavras: [p] });
  });
  return /* @__PURE__ */ React.createElement("div", { ref: caixaRef, className: "or-doc__corpo or-doc__corpo--texto" }, linhas.length === 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Sem texto."), linhas.map((l) => /* @__PURE__ */ React.createElement("div", { key: l.linha }, l.palavras.map((p, k) => /* @__PURE__ */ React.createElement(React.Fragment, { key: p.i }, k > 0 ? " " : "", marca(p, p.texto))))));
}
function OrderretrieverCorpo({ pedir, texto, textoRealces }) {
  const API = window.OrderretrieverAPI;
  const [modo, setModo] = React.useState(textoRealces ? "texto" : "formatado");
  const [corpo, setCorpo] = React.useState(null);
  const [erro, setErro] = React.useState("");
  const pedirRef = React.useRef(pedir);
  React.useEffect(() => {
    let vivo = true;
    pedirRef.current().then((r) => {
      if (vivo) setCorpo(r);
    }).catch((e) => {
      if (vivo) setErro(e && e.message || "N\xE3o deu para mostrar o corpo formatado.");
    });
    return () => {
      vivo = false;
    };
  }, []);
  if (erro) {
    return /* @__PURE__ */ React.createElement("div", { className: "or-corpo" }, /* @__PURE__ */ React.createElement("div", { className: "muted or-pequeno or-corpo__nota", role: "alert" }, erro), textoRealces || texto);
  }
  if (!corpo) return /* @__PURE__ */ React.createElement("div", { className: "muted or-doc__corpo--vazio", role: "status" }, "A carregar\u2026");
  if (!corpo.html) return textoRealces || texto;
  return /* @__PURE__ */ React.createElement("div", { className: "or-corpo" }, /* @__PURE__ */ React.createElement("div", { className: "or-corpo__barra" }, /* @__PURE__ */ React.createElement("div", { role: "group", "aria-label": "Vista do corpo", className: "or-corpo__vistas" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: `btn sm ${modo === "formatado" ? "primary" : "ghost"}`,
      "aria-pressed": modo === "formatado",
      onClick: () => setModo("formatado")
    },
    "Formatado"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: `btn sm ${modo === "texto" ? "primary" : "ghost"}`,
      "aria-pressed": modo === "texto",
      onClick: () => setModo("texto")
    },
    textoRealces ? "Texto com realces" : "Texto"
  )), modo === "formatado" && corpo.imagens_externas > 0 && /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno", title: "Imagens carregadas da internet (podem avisar quem enviou de que o email foi aberto)." }, corpo.imagens_externas, " ", corpo.imagens_externas === 1 ? "imagem externa bloqueada" : "imagens externas bloqueadas")), modo === "formatado" ? /* @__PURE__ */ React.createElement(
    "iframe",
    {
      title: "Corpo do email (formatado)",
      className: "or-doc__iframe or-corpo__iframe",
      sandbox: "allow-popups allow-popups-to-escape-sandbox",
      srcDoc: API.srcdocCorpo(corpo.html)
    }
  ) : textoRealces || texto);
}
const OR_PREVIEW_DOC = /^(application\/pdf|image\/(png|jpeg|gif|webp|bmp))$/;
function OrderretrieverAbrirDescarregar({ anexo }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("a", { className: "btn ghost sm", href: anexo.url, target: "_blank", rel: "noopener noreferrer" }, "Abrir"), /* @__PURE__ */ React.createElement("a", { className: "btn ghost sm", href: `${anexo.url}?download=1` }, "Descarregar"));
}
function OrderretrieverAnexoOutro({ anexo, irma, campos, onAbrir }) {
  const API = window.OrderretrieverAPI;
  const [prev, setPrev] = React.useState(null);
  const [erro, setErro] = React.useState("");
  const [pagina, setPagina] = React.useState(1);
  const [zoom, setZoom] = React.useState(null);
  const converte = /\.(xlsx?|docx?)$/i.test(anexo.nome || "");
  const html = API.anexoHtml(anexo);
  React.useEffect(() => {
    if (html) return void 0;
    let vivo = true;
    window.OrderretrieverAPI.previsaoAnexo(anexo.id).then((r) => {
      if (vivo) setPrev(r);
    }).catch((e) => {
      if (vivo) setErro(e && e.message || "N\xE3o deu para pr\xE9-visualizar.");
    });
    return () => {
      vivo = false;
    };
  }, [anexo.id, html]);
  let corpo;
  if (html) {
    corpo = /* @__PURE__ */ React.createElement(
      OrderretrieverCorpo,
      {
        pedir: () => API.corpoAnexo(anexo.id),
        texto: /* @__PURE__ */ React.createElement("div", { className: "muted or-doc__corpo--vazio" }, "Sem texto.")
      }
    );
  } else if (erro) {
    corpo = /* @__PURE__ */ React.createElement("div", { className: "muted or-doc__corpo--vazio", role: "alert" }, erro);
  } else if (!prev) {
    corpo = /* @__PURE__ */ React.createElement("div", { className: "muted or-doc__corpo--vazio", role: "status" }, converte ? "A converter para PDF\u2026" : "A carregar\u2026");
  } else if (prev.modo === "paginas") {
    corpo = /* @__PURE__ */ React.createElement(
      OrderretrieverPaginas,
      {
        anexoId: anexo.id,
        paginas: prev.paginas,
        realces: {},
        campos,
        selecionado: null,
        onSelecionar: () => {
        },
        pagina,
        onPagina: setPagina,
        zoom,
        onZoom: setZoom
      }
    );
  } else if (prev.modo === "ficheiro") {
    corpo = /* @__PURE__ */ React.createElement("iframe", { title: `Anexo ${anexo.nome}`, src: anexo.url, className: "or-doc__iframe" });
  } else {
    corpo = /* @__PURE__ */ React.createElement("div", { className: "muted or-doc__corpo--vazio" }, prev.erro || "Este tipo de ficheiro n\xE3o se pr\xE9-visualiza.", " Usa \xABAbrir\xBB ou \xABDescarregar\xBB.");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "or-doc__anexo" }, /* @__PURE__ */ React.createElement("span", { className: "or-doc__anexo-nome", title: anexo.nome }, anexo.nome), prev && prev.convertido && /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, "convertido para PDF"), irma && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, "\xE9 da encomenda ", irma.id), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => onAbrir(irma.id) }, "Abrir a encomenda ", irma.id)), /* @__PURE__ */ React.createElement("span", { className: "or-espaco" }), /* @__PURE__ */ React.createElement(OrderretrieverAbrirDescarregar, { anexo })), corpo);
}
function OrderretrieverDocumento({ enc, selecionado, onSelecionar, pagina, onPagina, zoom, onZoom, onAbrir }) {
  const API = window.OrderretrieverAPI;
  const email = enc.email || {};
  const abas = API.abasDoDocumento(enc);
  const propria = API.abaPropria(enc);
  const [escolha, setEscolha] = React.useState({ enc: enc.id, aba: propria });
  const escolhida = escolha.enc === enc.id ? escolha.aba : propria;
  const aba = abas.some((a) => a.chave === escolhida) ? escolhida : propria;
  const atual = abas.find((a) => a.chave === aba) || abas[0];
  const doc = abas.find((a) => a.propria && a.anexo);
  const anexoProprio = doc ? doc.anexo : null;
  const documento = enc.documento;
  const comPaginas = anexoProprio && documento && (documento.paginas || []).length > 0;
  const abaRefs = React.useRef({});
  const idAba = (chave) => `or-doc-aba-${chave}`;
  const escolher = (chave) => setEscolha({ enc: enc.id, aba: chave });
  const teclaAbas = (e) => {
    const chaves = abas.map((a) => a.chave);
    const i = chaves.indexOf(aba);
    const destino = {
      ArrowRight: chaves[(i + 1) % chaves.length],
      ArrowLeft: chaves[(i - 1 + chaves.length) % chaves.length],
      Home: chaves[0],
      End: chaves[chaves.length - 1]
    }[e.key];
    if (!destino) return;
    e.preventDefault();
    escolher(destino);
    if (abaRefs.current[destino]) abaRefs.current[destino].focus();
  };
  React.useEffect(() => {
    const el = abaRefs.current[aba];
    if (el && el.scrollIntoView) el.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [aba]);
  let corpo;
  const comTexto = documento && (documento.palavras || []).length > 0;
  const textoComRealces = comTexto ? /* @__PURE__ */ React.createElement(
    OrderretrieverTexto,
    {
      documento,
      realces: enc.realces,
      campos: enc.campos,
      selecionado,
      onSelecionar
    }
  ) : null;
  if (aba === "email") {
    const texto = /* @__PURE__ */ React.createElement("div", { className: "or-doc__corpo or-doc__corpo--email" }, email.corpo_texto || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Sem corpo."));
    corpo = /* @__PURE__ */ React.createElement(
      OrderretrieverCorpo,
      {
        key: `email-${email.id}-${enc.id}`,
        pedir: () => API.corpoEmail(email.id),
        texto,
        textoRealces: !enc.anexo ? textoComRealces : null
      }
    );
  } else if (!atual.propria) {
    corpo = /* @__PURE__ */ React.createElement(
      OrderretrieverAnexoOutro,
      {
        key: atual.anexo.id,
        anexo: atual.anexo,
        irma: atual.irma,
        campos: enc.campos,
        onAbrir
      }
    );
  } else if (comPaginas) {
    corpo = /* @__PURE__ */ React.createElement(
      OrderretrieverPaginas,
      {
        anexoId: anexoProprio.id,
        paginas: documento.paginas,
        realces: enc.realces,
        campos: enc.campos,
        selecionado,
        onSelecionar,
        pagina,
        onPagina,
        zoom,
        onZoom
      }
    );
  } else if (anexoProprio && API.anexoHtml(anexoProprio)) {
    corpo = /* @__PURE__ */ React.createElement(
      OrderretrieverCorpo,
      {
        key: `anexo-${anexoProprio.id}`,
        pedir: () => API.corpoAnexo(anexoProprio.id),
        texto: textoComRealces || /* @__PURE__ */ React.createElement("div", { className: "muted or-doc__corpo--vazio" }, "Sem texto."),
        textoRealces: textoComRealces
      }
    );
  } else if (comTexto) {
    corpo = textoComRealces;
  } else if (anexoProprio && OR_PREVIEW_DOC.test((anexoProprio.tipo || "").toLowerCase())) {
    corpo = /* @__PURE__ */ React.createElement("iframe", { title: `Documento ${anexoProprio.nome}`, src: anexoProprio.url, className: "or-doc__iframe" });
  } else {
    corpo = /* @__PURE__ */ React.createElement("div", { className: "muted or-doc__corpo--vazio" }, anexoProprio ? "Este tipo de ficheiro n\xE3o se pr\xE9-visualiza \u2014 usa \xABAbrir\xBB ou \xABDescarregar\xBB \xE0 esquerda." : "Sem texto.");
  }
  return /* @__PURE__ */ React.createElement("section", { className: "panel or-doc", "aria-label": "Documento" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h or-doc__cabeca" }, /* @__PURE__ */ React.createElement("div", { role: "tablist", "aria-label": "Anexos e email", className: "or-doc__abas", onKeyDown: teclaAbas }, abas.map((a) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: a.chave,
      type: "button",
      role: "tab",
      id: idAba(a.chave),
      "aria-selected": aba === a.chave,
      "aria-controls": `${idAba(a.chave)}-painel`,
      tabIndex: aba === a.chave ? 0 : -1,
      ref: (el) => {
        abaRefs.current[a.chave] = el;
      },
      title: a.nome,
      className: `btn sm or-doc__aba ${aba === a.chave ? "primary" : "ghost"}`,
      onClick: () => escolher(a.chave)
    },
    /* @__PURE__ */ React.createElement("span", { className: "or-doc__aba-nome" }, a.nome),
    a.propria && a.anexo && /* @__PURE__ */ React.createElement("span", { className: "or-doc__aba-marca" }, "esta encomenda"),
    a.irma && /* @__PURE__ */ React.createElement("span", { className: "or-doc__aba-marca" }, "enc. ", a.irma.id)
  ))), documento && documento.fonte_texto && atual.propria && /* @__PURE__ */ React.createElement("span", { className: "muted or-doc__fonte" }, "texto: ", documento.fonte_texto, orConfiancaOcr(documento))), /* @__PURE__ */ React.createElement(
    "div",
    {
      role: "tabpanel",
      id: `${idAba(aba)}-painel`,
      "aria-labelledby": idAba(aba),
      className: "or-doc__painel"
    },
    corpo
  ));
}
window.OrderretrieverDocumento = OrderretrieverDocumento;

// ===== orderretriever/frontend/orderretriever_decisao.jsx =====
function OrderretrieverMenuEncomenda({ bloqueio, onApagar }) {
  const [aberto, setAberto] = React.useState(false);
  const raiz = React.useRef(null);
  React.useEffect(() => {
    if (!aberto) return void 0;
    const fora = (e) => {
      if (raiz.current && !raiz.current.contains(e.target)) setAberto(false);
    };
    const tecla = (e) => {
      if (e.key === "Escape") setAberto(false);
    };
    document.addEventListener("mousedown", fora);
    document.addEventListener("keydown", tecla);
    return () => {
      document.removeEventListener("mousedown", fora);
      document.removeEventListener("keydown", tecla);
    };
  }, [aberto]);
  return /* @__PURE__ */ React.createElement("div", { className: "or-menu", ref: raiz }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-label": "Mais a\xE7\xF5es",
      "aria-haspopup": "menu",
      "aria-expanded": aberto,
      onClick: () => setAberto((a) => !a)
    },
    "\u22EF"
  ), aberto && /* @__PURE__ */ React.createElement("div", { className: "or-menu__lista", role: "menu" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      role: "menuitem",
      className: "or-menu__item",
      disabled: !!bloqueio,
      onClick: () => {
        setAberto(false);
        onApagar();
      }
    },
    "Apagar"
  ), bloqueio && /* @__PURE__ */ React.createElement("p", { className: "muted or-menu__nota" }, bloqueio)));
}
function OrderretrieverMudarCliente({ enc, onMudou }) {
  const API = window.OrderretrieverAPI;
  const [aberto, setAberto] = React.useState(false);
  const [q, setQ] = React.useState("");
  const [res, setRes] = React.useState([]);
  const [estado, setEstado] = React.useState("");
  const [aGravar, setAGravar] = React.useState(false);
  React.useEffect(() => {
    if (!aberto || q.trim().length < 2) {
      setRes([]);
      setEstado("");
      return void 0;
    }
    let vivo = true;
    const t = setTimeout(() => {
      setEstado("a_procurar");
      API.clientes(q.trim()).then((r) => {
        if (vivo) {
          setRes(r || []);
          setEstado("");
        }
      }).catch((e) => {
        if (vivo) {
          setRes([]);
          setEstado(API.erroDRF(e, "N\xE3o foi poss\xEDvel pesquisar."));
        }
      });
    }, 300);
    return () => {
      vivo = false;
      clearTimeout(t);
    };
  }, [q, aberto, API]);
  const escolher = (c) => {
    setAGravar(true);
    API.mudarCliente(enc.id, c.no).then((d) => {
      setAberto(false);
      setQ("");
      onMudou(d);
      window.srToast?.(`Cliente: ${c.nome}.`, "success");
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel mudar o cliente."), "error")).finally(() => setAGravar(false));
  };
  if (!aberto) {
    return /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setAberto(true) }, "Mudar");
  }
  return /* @__PURE__ */ React.createElement("div", { className: "or-mudar" }, /* @__PURE__ */ React.createElement("div", { className: "or-pesquisa" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      "aria-label": "Pesquisar cliente",
      type: "text",
      autoFocus: true,
      placeholder: "Nome, NIF ou n\xBA PHC",
      value: q,
      onChange: (e) => setQ(e.target.value)
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => {
    setAberto(false);
    setQ("");
  } }, "Cancelar")), estado === "a_procurar" && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "A procurar no PHC\u2026"), estado && estado !== "a_procurar" && /* @__PURE__ */ React.createElement("span", { className: "muted" }, estado), !estado && q.trim().length >= 2 && res.length === 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Nenhum cliente encontrado."), res.length > 0 && /* @__PURE__ */ React.createElement("ul", { "aria-label": "Clientes encontrados", className: "or-resultados" }, res.map((c) => /* @__PURE__ */ React.createElement("li", { key: c.no }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-resultado", disabled: aGravar, onClick: () => escolher(c) }, /* @__PURE__ */ React.createElement("span", { className: "mono" }, c.no), /* @__PURE__ */ React.createElement("span", { className: "or-resultado__nome" }, c.nome), /* @__PURE__ */ React.createElement("span", { className: "muted" }, c.nif, c.local ? ` \xB7 ${c.local}` : ""))))));
}
function OrderretrieverRejeitar({ enc, onFeito, onFechar }) {
  const API = window.OrderretrieverAPI;
  const [motivos, setMotivos] = React.useState(null);
  const [motivo, setMotivo] = React.useState("");
  const [nota, setNota] = React.useState("");
  const [aGravar, setAGravar] = React.useState(false);
  React.useEffect(() => {
    API.motivos().then((r) => setMotivos((r || []).filter((m) => m.is_active))).catch(() => setMotivos([]));
  }, [API]);
  const rejeitar = () => {
    if (!motivo) {
      window.srToast?.("Escolhe o motivo.", "warning");
      return;
    }
    setAGravar(true);
    API.rejeitar(enc.id, Number(motivo), nota).then((d) => {
      onFeito(d);
      window.srToast?.("Encomenda rejeitada.", "success");
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel rejeitar."), "error")).finally(() => setAGravar(false));
  };
  const rodape = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger", disabled: aGravar || !motivo, onClick: rejeitar }, aGravar ? "A rejeitar\u2026" : "Rejeitar"));
  return /* @__PURE__ */ React.createElement(window.ModalShell, { title: "Rejeitar encomenda", onClose: onFechar, footer: rodape, width: 440 }, /* @__PURE__ */ React.createElement("div", { className: "or-campos" }, motivos === null && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "A carregar os motivos\u2026"), motivos && motivos.length === 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "N\xE3o h\xE1 motivos ativos \u2014 acrescenta-os em Defini\xE7\xF5es \u203A Motivos de rejei\xE7\xE3o."), motivos && motivos.length > 0 && /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Motivo", /* @__PURE__ */ React.createElement("select", { "aria-label": "Motivo", value: motivo, onChange: (e) => setMotivo(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"), motivos.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.label)))), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Nota (opcional)", /* @__PURE__ */ React.createElement("textarea", { "aria-label": "Nota", rows: 3, value: nota, onChange: (e) => setNota(e.target.value) })), enc.email && enc.email.modo === "ativo" && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Quando o email n\xE3o tiver mais nada por decidir, vai para a pasta ERROR.")));
}
const OR_NOMES_FICHEIRO = { xls: "Excel (.xls)", json: "JSON", eml: "Email (.eml)" };
function OrderretrieverResultado({ enc }) {
  const { dataHora, Aviso } = window.OrderretrieverUtil;
  const email = enc.email || {};
  const quem = `${enc.decidida_por_nome || "Sistema"} \xB7 ${dataHora(enc.decidida_em)}`;
  if (enc.estado === "rejeitada") {
    return /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Decis\xE3o" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Rejeitada"), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, enc.motivo_rejeicao_label), enc.rejeicao_nota ? ` \u2014 ${enc.rejeicao_nota}` : ""), /* @__PURE__ */ React.createElement("div", { className: "muted" }, quem), email.mover_erro && /* @__PURE__ */ React.createElement(Aviso, { tipo: "erro" }, "Email por mover: ", email.mover_erro));
  }
  if (enc.estado !== "aprovada") return null;
  const ficheiros = enc.ficheiros || {};
  return /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Decis\xE3o" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Aprovada"), /* @__PURE__ */ React.createElement("div", { className: "muted" }, quem), /* @__PURE__ */ React.createElement("div", { className: "or-paragrafo" }, enc.saida_modo === "ativo" ? "Ficheiros na pasta de rede do importador do PHC." : "Modo sombra: ficheiros no diret\xF3rio de sombra \u2014 o servi\xE7o antigo continua a entregar."), /* @__PURE__ */ React.createElement("ul", { className: "or-lista" }, ["xls", "json", "eml"].filter((t) => ficheiros[t]).map((t) => /* @__PURE__ */ React.createElement("li", { key: t, className: "or-linha or-linha--quebra" }, /* @__PURE__ */ React.createElement("span", { className: "or-ficheiro__tipo" }, OR_NOMES_FICHEIRO[t]), /* @__PURE__ */ React.createElement("span", { className: "mono or-ficheiro__nome" }, ficheiros[t]), /* @__PURE__ */ React.createElement("a", { className: "btn ghost sm", href: window.OrderretrieverAPI.ficheiroUrl(enc.id, t) }, "Descarregar")))), email.modo === "ativo" && (email.pasta === "inbox" ? email.mover_erro ? /* @__PURE__ */ React.createElement(Aviso, { tipo: "erro" }, "Email ainda na Inbox: ", email.mover_erro, " (volta a tentar-se a cada minuto)") : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "O email sai da Inbox quando as outras encomendas dele estiverem decididas.") : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Email movido para ", (email.pasta || "").toUpperCase(), " ", dataHora(email.movido_em), ".")));
}
function OrderretrieverHistorico({ id, versao }) {
  const { dataHora } = window.OrderretrieverUtil;
  const Ico = window.Ico;
  const [itens, setItens] = React.useState(null);
  const [aberto, setAberto] = React.useState(false);
  React.useEffect(() => {
    let vivo = true;
    window.OrderretrieverAPI.historico(id).then((r) => {
      if (vivo) setItens(r || []);
    }).catch(() => {
      if (vivo) setItens([]);
    });
    return () => {
      vivo = false;
    };
  }, [id, versao]);
  return /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-dobra", "aria-expanded": aberto, onClick: () => setAberto((a) => !a) }, /* @__PURE__ */ React.createElement(Ico.chevron, { className: "or-dobra__ico" }), /* @__PURE__ */ React.createElement("span", { className: "section-label" }, "Hist\xF3rico", itens ? ` (${itens.length})` : "")), aberto && /* @__PURE__ */ React.createElement("div", { className: "or-dobra__corpo" }, itens === null && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"), itens && itens.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem registos."), itens && itens.length > 0 && /* @__PURE__ */ React.createElement("ol", { "aria-label": "Hist\xF3rico", className: "or-lista" }, itens.map((x) => /* @__PURE__ */ React.createElement("li", { key: x.id, className: "or-registo" }, /* @__PURE__ */ React.createElement("div", null, x.resumo), /* @__PURE__ */ React.createElement("div", { className: "muted or-pequeno" }, x.autor, " \xB7 ", dataHora(x.quando)))))));
}
window.OrderretrieverMenuEncomenda = OrderretrieverMenuEncomenda;
window.OrderretrieverDecisao = {
  MudarCliente: OrderretrieverMudarCliente,
  Rejeitar: OrderretrieverRejeitar,
  Resultado: OrderretrieverResultado,
  Historico: OrderretrieverHistorico
};

// ===== orderretriever/frontend/orderretriever_ensinar.jsx =====
function orTextoCurto(t, n = 140) {
  const s = (t || "").replace(/\s+/g, " ").trim();
  return s.length > n ? `${s.slice(0, n - 1)}\u2026` : s;
}
function OrderretrieverChipSemCorrecao({ dados }) {
  if (!dados) return null;
  const { sem_correcao: n, aprovadas: m } = dados;
  const titulo = m ? `Das ${m} encomendas aprovadas deste cliente, ${n} sa\xEDram tal como a IA as leu.` : "Ainda n\xE3o h\xE1 encomendas aprovadas deste cliente.";
  return /* @__PURE__ */ React.createElement("span", { title: titulo, className: "pill" }, "Sem corre\xE7\xE3o ", m ? `${n}/${m}` : "\u2014");
}
function OrderretrieverHistoricoEnsinar({ titulo, linhas, onClose }) {
  const { dataHora } = window.OrderretrieverUtil;
  return /* @__PURE__ */ React.createElement(window.ModalShell, { title: titulo, onClose }, linhas === null && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"), linhas && linhas.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem hist\xF3rico."), /* @__PURE__ */ React.createElement("ul", { className: "or-hist" }, (linhas || []).map((h, i) => {
    const antes = h.diff && h.diff.antes;
    const depois = h.diff && h.diff.depois;
    return /* @__PURE__ */ React.createElement("li", { key: i, className: "or-hist__item" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, h.resumo)), /* @__PURE__ */ React.createElement("div", { className: "muted or-pequeno" }, dataHora(h.quando), " \xB7 ", h.autor), antes && antes.texto !== (depois && depois.texto) && /* @__PURE__ */ React.createElement("div", { className: "or-bloco or-bloco--antes", "aria-label": "Antes" }, antes.texto), depois && (!antes || antes.texto !== depois.texto) && /* @__PURE__ */ React.createElement("div", { className: "or-bloco or-bloco--depois", "aria-label": "Depois" }, depois.texto));
  })));
}
function useOrHistorico() {
  const [hist, setHist] = React.useState(null);
  const abrir = (titulo, promessa) => {
    setHist({ titulo, linhas: null });
    promessa.then((linhas) => setHist({ titulo, linhas })).catch(() => {
      setHist(null);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar o hist\xF3rico.", "error");
    });
  };
  const modal = hist && /* @__PURE__ */ React.createElement(OrderretrieverHistoricoEnsinar, { titulo: hist.titulo, linhas: hist.linhas, onClose: () => setHist(null) });
  return [abrir, modal];
}
function orConfirmarApagar(regra) {
  return window.hubConfirm({
    title: "Apagar regra",
    message: `Apagar esta regra de ${regra.cliente_nome || `n\xBA ${regra.cliente_no}`}?

${regra.texto}

Fica no hist\xF3rico. Para a tirar do prompt sem a perder, desativa-a.`,
    confirmLabel: "Apagar"
  });
}
function OrderretrieverRegrasCliente({ clienteNo, clienteNome, encomendaId, onDados }) {
  const API = window.OrderretrieverAPI;
  const { dataHora } = window.OrderretrieverUtil;
  const [dados, setDados] = React.useState(null);
  const [novo, setNovo] = React.useState("");
  const [edicao, setEdicao] = React.useState(null);
  const [aGravar, setAGravar] = React.useState(false);
  const [abrirHistorico, modalHistorico] = useOrHistorico();
  const temCliente = clienteNo !== null && clienteNo !== void 0;
  const carregar = React.useCallback(() => {
    if (!temCliente) return Promise.resolve();
    return API.regras({ cliente_no: clienteNo }).then((d) => {
      setDados(d);
      if (onDados) onDados(d);
    }).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar as regras do cliente.", "error"));
  }, [API, clienteNo, temCliente, onDados]);
  React.useEffect(() => {
    setDados(null);
    carregar();
  }, [carregar]);
  const falhou = (e, dflt) => window.srToast?.(e && e.status === 403 ? "Sem permiss\xE3o para ensinar regras." : API.erroDRF(e, dflt), "error");
  function adicionar() {
    if (!novo.trim()) {
      window.srToast?.("Escreve a regra.", "warning");
      return;
    }
    setAGravar(true);
    API.criarRegra({ cliente_no: clienteNo, cliente_nome: clienteNome || "", texto: novo, encomenda: encomendaId }).then(() => {
      setNovo("");
      window.srToast?.("Regra gravada \u2014 entra na pr\xF3xima leitura deste cliente.", "success");
      return carregar();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel gravar a regra.")).finally(() => setAGravar(false));
  }
  function guardarEdicao() {
    if (!edicao.texto.trim()) {
      window.srToast?.("Escreve a regra.", "warning");
      return;
    }
    API.editarRegra(edicao.id, { texto: edicao.texto, encomenda: encomendaId }).then(() => {
      setEdicao(null);
      window.srToast?.("Regra gravada.", "success");
      return carregar();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel gravar a regra."));
  }
  function alternar(r) {
    API.editarRegra(r.id, { ativa: !r.ativa, encomenda: encomendaId }).then(carregar).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel mudar a regra."));
  }
  async function apagar(r) {
    if (!await orConfirmarApagar(r)) return;
    API.apagarRegra(r.id).then(() => {
      window.srToast?.("Regra apagada.", "success");
      return carregar();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel apagar a regra."));
  }
  const regras = dados && dados.regras || [];
  const ativas = regras.filter((r) => r.ativa).length;
  const podeEditar = !!(dados && dados.pode_editar);
  return /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Ensinar" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Ensinar: regras para este cliente", temCliente && dados && /* @__PURE__ */ React.createElement("span", { className: "or-seccao__n" }, ativas, " ", ativas === 1 ? "ativa" : "ativas")), !temCliente && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Identifica o cliente para lhe escrever regras."), temCliente && !dados && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"), temCliente && dados && /* @__PURE__ */ React.createElement(React.Fragment, null, regras.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Ainda n\xE3o h\xE1 regras para este cliente."), /* @__PURE__ */ React.createElement("ul", { className: "or-lista" }, regras.map((r) => /* @__PURE__ */ React.createElement("li", { key: r.id, className: `or-regra${r.ativa ? "" : " is-inativa"}` }, edicao && edicao.id === r.id ? /* @__PURE__ */ React.createElement("div", { className: "or-editar" }, /* @__PURE__ */ React.createElement(
    "textarea",
    {
      "aria-label": "Texto da regra",
      rows: 4,
      value: edicao.texto,
      onChange: (e) => setEdicao({ ...edicao, texto: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: guardarEdicao }, "Guardar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setEdicao(null) }, "Cancelar"))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "or-pre" }, r.texto), /* @__PURE__ */ React.createElement("div", { className: "or-acoes or-regra__meta" }, /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, r.ativa ? "" : "desativada \xB7 ", r.autor_nome, " \xB7 ", dataHora(r.criada_em)), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => abrirHistorico("Hist\xF3rico da regra", API.historicoRegra(r.id))
    },
    "Hist\xF3rico"
  ), podeEditar && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setEdicao({ id: r.id, texto: r.texto }) }, "Editar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => alternar(r) }, r.ativa ? "Desativar" : "Ativar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger sm", onClick: () => apagar(r) }, "Apagar"))))))), podeEditar && /* @__PURE__ */ React.createElement("div", { className: "or-editar or-editar--topo" }, /* @__PURE__ */ React.createElement(
    "textarea",
    {
      "aria-label": "Nova regra para este cliente",
      rows: 3,
      value: novo,
      placeholder: "Ex.: a quantidade vem em milhares; a data de entrega \xE9 a da coluna \xABLiefertermin\xBB.",
      onChange: (e) => setNovo(e.target.value)
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", disabled: aGravar, onClick: adicionar }, aGravar ? "A gravar\u2026" : "Adicionar regra"), /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, "Entra no prompt s\xF3 deste cliente, a partir da pr\xF3xima leitura (\xABReprocessar IA\xBB aplica j\xE1).")))), modalHistorico);
}
function OrderretrieverExemplosLeitura({ encomendaId, clienteNo, onAbrir }) {
  const API = window.OrderretrieverAPI;
  const [dados, setDados] = React.useState(null);
  const [aberto, setAberto] = React.useState(null);
  const [dobrado, setDobrado] = React.useState(true);
  const Ico = window.Ico;
  const temCliente = clienteNo !== null && clienteNo !== void 0;
  React.useEffect(() => {
    if (!temCliente) return;
    API.exemplosEncomenda(encomendaId).then(setDados).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar os exemplos.", "error"));
  }, [API, encomendaId, temCliente]);
  if (!temCliente) return null;
  const lista = dados && dados.exemplos || [];
  return /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Exemplos na pr\xF3xima leitura" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-dobra", "aria-expanded": !dobrado, onClick: () => setDobrado((d) => !d) }, /* @__PURE__ */ React.createElement(Ico.chevron, { className: "or-dobra__ico" }), /* @__PURE__ */ React.createElement("span", { className: "section-label" }, "Corre\xE7\xF5es que a IA v\xEA na pr\xF3xima leitura (", dados ? lista.length : "\u2026", ")")), !dobrado && /* @__PURE__ */ React.createElement("div", { className: "or-dobra__corpo" }, !dados && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"), dados && lista.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Ainda n\xE3o h\xE1 encomendas aprovadas deste cliente com corre\xE7\xF5es."), dados && lista.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "muted or-pequeno or-paragrafo" }, "As mais parecidas com esta encomenda (layout e nome do anexo); ~", dados.tokens, " de ", dados.orcamento_tokens, " tokens."), /* @__PURE__ */ React.createElement("ul", { className: "or-lista" }, lista.map((e) => /* @__PURE__ */ React.createElement("li", { key: e.encomenda, className: "or-regra" }, /* @__PURE__ */ React.createElement("div", { className: "or-acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => onAbrir(e.encomenda) }, "Encomenda ", e.encomenda), /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, e.porque, e.semelhanca ? ` (${e.semelhanca}%)` : "", " \xB7 ", e.correcoes === 1 ? "1 corre\xE7\xE3o" : `${e.correcoes} corre\xE7\xF5es`, e.cortadas ? ` \xB7 ${e.cortadas === 1 ? "1 cortada" : `${e.cortadas} cortadas`} para caber` : ""), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-expanded": aberto === e.encomenda,
      onClick: () => setAberto(aberto === e.encomenda ? null : e.encomenda)
    },
    aberto === e.encomenda ? "Esconder" : "Ver o que vai"
  )), aberto === e.encomenda && /* @__PURE__ */ React.createElement("pre", { className: "or-pre or-pequeno or-exemplo__texto" }, e.texto))))));
}
function OrderretrieverEscolherCliente({ rotulo, valor, onEscolher, autoFocus = false }) {
  const API = window.OrderretrieverAPI;
  const [q, setQ] = React.useState("");
  const [res, setRes] = React.useState([]);
  const [estado, setEstado] = React.useState("");
  const [phcEmBaixo, setPhcEmBaixo] = React.useState(false);
  const [trocar, setTrocar] = React.useState(!valor);
  React.useEffect(() => {
    const texto = q.trim();
    if (texto.length < 2) {
      setRes([]);
      setEstado("");
      return void 0;
    }
    let vivo = true;
    const t = setTimeout(() => {
      setEstado("a_procurar");
      API.clientes(texto).then((r) => {
        if (vivo) {
          setRes(r || []);
          setEstado("");
          setPhcEmBaixo(false);
        }
      }).catch((e) => {
        if (!vivo) return;
        setRes([]);
        const emBaixo = !!(e && e.status === 502);
        setPhcEmBaixo(emBaixo);
        setEstado(emBaixo ? "PHC indispon\xEDvel \u2014 podes escrever o n\xBA do cliente \xE0 m\xE3o." : API.erroDRF(e, "N\xE3o foi poss\xEDvel pesquisar."));
      });
    }, 300);
    return () => {
      vivo = false;
      clearTimeout(t);
    };
  }, [q, API]);
  const escolher = (c) => {
    onEscolher(c);
    setQ("");
    setRes([]);
    setTrocar(false);
  };
  if (valor && !trocar) {
    return /* @__PURE__ */ React.createElement("div", { className: "or-campo" }, /* @__PURE__ */ React.createElement("span", null, rotulo), /* @__PURE__ */ React.createElement("div", { className: "or-acoes" }, /* @__PURE__ */ React.createElement("span", null, valor.nome || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "(sem nome)"), " ", /* @__PURE__ */ React.createElement("span", { className: "muted mono" }, "n\xBA ", valor.no)), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setTrocar(true) }, "Trocar")));
  }
  const numero = /^\d+$/.test(q.trim());
  return /* @__PURE__ */ React.createElement("div", { className: "or-campo or-mudar" }, /* @__PURE__ */ React.createElement("span", null, rotulo), /* @__PURE__ */ React.createElement("div", { className: "or-pesquisa" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      "aria-label": `${rotulo}: pesquisar no PHC`,
      type: "text",
      autoFocus,
      placeholder: "Nome, NIF ou n\xBA PHC",
      value: q,
      onChange: (e) => setQ(e.target.value)
    }
  ), valor && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => {
    setTrocar(false);
    setQ("");
  } }, "Cancelar")), estado === "a_procurar" && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "A procurar no PHC\u2026"), estado && estado !== "a_procurar" && /* @__PURE__ */ React.createElement("span", { className: "muted" }, estado), !estado && q.trim().length >= 2 && res.length === 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Nenhum cliente encontrado."), phcEmBaixo && numero && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => escolher({ no: parseInt(q.trim(), 10), nome: "" })
    },
    "Usar o n\xBA ",
    q.trim()
  )), res.length > 0 && /* @__PURE__ */ React.createElement("ul", { "aria-label": "Clientes encontrados", className: "or-resultados" }, res.map((c) => /* @__PURE__ */ React.createElement("li", { key: c.no }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-resultado", onClick: () => escolher(c) }, /* @__PURE__ */ React.createElement("span", { className: "mono" }, c.no), /* @__PURE__ */ React.createElement("span", { className: "or-resultado__nome" }, c.nome), /* @__PURE__ */ React.createElement("span", { className: "muted" }, c.nif, c.local ? ` \xB7 ${c.local}` : ""))))));
}
function OrderretrieverRegrasView() {
  const API = window.OrderretrieverAPI;
  const { dataHora } = window.OrderretrieverUtil;
  const [regras, setRegras] = React.useState(null);
  const [novo, setNovo] = React.useState({ cliente: null, texto: "" });
  const [edicao, setEdicao] = React.useState(null);
  const [mudarCliente, setMudarCliente] = React.useState(null);
  const [abrirHistorico, modalHistorico] = useOrHistorico();
  const carregar = React.useCallback(() => API.regras().then((d) => setRegras(d.regras || [])).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar as regras.", "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const falhou = (e, dflt) => window.srToast?.(API.erroDRF(e, dflt), "error");
  function adicionar() {
    if (!novo.cliente) {
      window.srToast?.("Escolhe o cliente.", "warning");
      return;
    }
    if (!novo.texto.trim()) {
      window.srToast?.("Escreve a regra.", "warning");
      return;
    }
    API.criarRegra({ cliente_no: novo.cliente.no, cliente_nome: novo.cliente.nome, texto: novo.texto }).then(() => {
      setNovo({ cliente: null, texto: "" });
      window.srToast?.("Regra gravada.", "success");
      return carregar();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel gravar a regra."));
  }
  function guardarEdicao() {
    API.editarRegra(edicao.id, { texto: edicao.texto }).then(() => {
      setEdicao(null);
      window.srToast?.("Regra gravada.", "success");
      return carregar();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel gravar a regra."));
  }
  function trocarCliente(c) {
    API.editarRegra(mudarCliente.id, { cliente_no: c.no, cliente_nome: c.nome }).then(() => {
      setMudarCliente(null);
      window.srToast?.(`Regra passou para ${c.nome || `o n\xBA ${c.no}`}.`, "success");
      return carregar();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel mudar o cliente."));
  }
  function alternar(r) {
    API.editarRegra(r.id, { ativa: !r.ativa }).then(carregar).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel mudar a regra."));
  }
  async function apagar(r) {
    if (!await orConfirmarApagar(r)) return;
    API.apagarRegra(r.id).then(() => {
      window.srToast?.("Regra apagada.", "success");
      return carregar();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel apagar a regra."));
  }
  const columns = [
    {
      key: "cliente_nome",
      label: "Cliente",
      width: 220,
      render: (r) => r.cliente_nome || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "(sem nome)")
    },
    { key: "cliente_no", label: "N\xBA PHC", width: 90, mono: true },
    {
      key: "texto",
      label: "Regra",
      width: 420,
      render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.texto }, orTextoCurto(r.texto))
    },
    {
      key: "ativa",
      label: "Ativa",
      width: 70,
      sortValue: (r) => r.ativa ? 1 : 0,
      render: (r) => r.ativa ? "Sim" : "N\xE3o"
    },
    { key: "autor_nome", label: "Autor", width: 140 },
    { key: "criada_em", label: "Criada", width: 140, render: (r) => dataHora(r.criada_em) },
    { key: "acoes", label: "", sortable: false, width: 370, render: (r) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setEdicao({ id: r.id, texto: r.texto, rotulo: r.cliente_nome || `n\xBA ${r.cliente_no}` }) }, "Editar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setMudarCliente(r) }, "Cliente\u2026"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => alternar(r) }, r.ativa ? "Desativar" : "Ativar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => abrirHistorico(`Hist\xF3rico \u2014 ${r.cliente_nome || r.cliente_no}`, API.historicoRegra(r.id)) }, "Hist\xF3rico"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger sm", onClick: () => apagar(r) }, "Apagar")) }
  ];
  const rodapeEdicao = edicao && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setEdicao(null) }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: guardarEdicao }, "Guardar"));
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina" }, /* @__PURE__ */ React.createElement("p", { className: "muted or-nota or-nota--justa" }, "Cada regra entra no prompt s\xF3 das encomendas desse cliente. Quem valida tamb\xE9m as escreve, no ecr\xE3 da encomenda. Desativar tira-a do prompt sem a perder."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: regras === null,
      title: `Regras por cliente (${(regras || []).length})`,
      appLabel: "orderretriever",
      viewId: "regras",
      columns,
      data: regras || [],
      rowKey: (r) => r.id,
      search: { fields: ["cliente_nome", "cliente_no", "texto"], placeholder: "Cliente, n\xBA ou texto\u2026" },
      pagination: "client",
      pageSize: 50,
      empty: "Ainda n\xE3o h\xE1 regras. O orderretriever_importar_prompt semeia-as a partir do prompt antigo."
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel or-painel or-painel--grid or-pagina--estreita" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Nova regra")), /* @__PURE__ */ React.createElement(
    OrderretrieverEscolherCliente,
    {
      rotulo: "Cliente",
      valor: novo.cliente,
      onEscolher: (c) => setNovo({ ...novo, cliente: c })
    }
  ), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Regra", /* @__PURE__ */ React.createElement("textarea", { rows: 4, value: novo.texto, onChange: (e) => setNovo({ ...novo, texto: e.target.value }) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: adicionar }, "Adicionar"))), edicao && /* @__PURE__ */ React.createElement(window.ModalShell, { title: `Editar regra \u2014 ${edicao.rotulo}`, onClose: () => setEdicao(null), footer: rodapeEdicao }, /* @__PURE__ */ React.createElement(
    "textarea",
    {
      "aria-label": "Texto da regra",
      rows: 8,
      className: "or-largo",
      value: edicao.texto,
      onChange: (e) => setEdicao({ ...edicao, texto: e.target.value })
    }
  )), mudarCliente && /* @__PURE__ */ React.createElement(window.ModalShell, { title: "Mudar o cliente da regra", onClose: () => setMudarCliente(null), width: 520 }, /* @__PURE__ */ React.createElement("p", { className: "muted or-pequeno or-paragrafo" }, "Agora: ", mudarCliente.cliente_nome || "(sem nome)", " (n\xBA ", mudarCliente.cliente_no, "). O texto fica igual e a mudan\xE7a fica no hist\xF3rico."), /* @__PURE__ */ React.createElement("div", { className: "or-pre or-paragrafo" }, orTextoCurto(mudarCliente.texto, 300)), /* @__PURE__ */ React.createElement(OrderretrieverEscolherCliente, { rotulo: "Novo cliente", valor: null, autoFocus: true, onEscolher: trocarCliente })), /* @__PURE__ */ React.createElement(OrderretrieverOpcoesCliente, null), modalHistorico);
}
function OrderretrieverOpcoesCliente() {
  const API = window.OrderretrieverAPI;
  const { dataHora } = window.OrderretrieverUtil;
  const [opcoes, setOpcoes] = React.useState(null);
  const [cliente, setCliente] = React.useState(null);
  const carregar = React.useCallback(() => API.opcoesCliente().then(setOpcoes).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar as op\xE7\xF5es por cliente.", "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const NOMES = { programacao_mensal: ["Programa\xE7\xE3o mensal", "a"], quadro_semanal: ["Quadro semanal", "o"] };
  function gravar(no, nome, opcao, ligada) {
    const [rotulo, g] = NOMES[opcao];
    return API.gravarOpcaoCliente({ cliente_no: no, cliente_nome: nome || "", [opcao]: ligada }).then(() => {
      window.srToast?.(`${rotulo} ${ligada ? "ligad" : "desligad"}${g} para ${nome || `o n\xBA ${no}`}.`, "success");
      return carregar();
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar a op\xE7\xE3o."), "error"));
  }
  function ligar(opcao) {
    if (!cliente) {
      window.srToast?.("Escolhe o cliente.", "warning");
      return;
    }
    gravar(cliente.no, cliente.nome, opcao, true).then(() => setCliente(null));
  }
  const columns = [
    {
      key: "cliente_nome",
      label: "Cliente",
      width: 240,
      render: (o) => o.cliente_nome || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "(sem nome)")
    },
    { key: "cliente_no", label: "N\xBA PHC", width: 90, mono: true },
    {
      key: "programacao_mensal",
      label: "Programa\xE7\xE3o mensal",
      width: 170,
      sortable: false,
      render: (o) => /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          "aria-label": `${o.programacao_mensal ? "Desligar" : "Ligar"} a programa\xE7\xE3o mensal de ${o.cliente_nome || o.cliente_no}`,
          onClick: () => gravar(o.cliente_no, o.cliente_nome, "programacao_mensal", !o.programacao_mensal)
        },
        o.programacao_mensal ? "Ligada \xB7 desligar" : "Desligada \xB7 ligar"
      )
    },
    {
      key: "quadro_semanal",
      label: "Quadro semanal",
      width: 170,
      sortable: false,
      render: (o) => /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          "aria-label": `${o.quadro_semanal ? "Desligar" : "Ligar"} o quadro semanal de ${o.cliente_nome || o.cliente_no}`,
          onClick: () => gravar(o.cliente_no, o.cliente_nome, "quadro_semanal", !o.quadro_semanal)
        },
        o.quadro_semanal ? "Ligado \xB7 desligar" : "Desligado \xB7 ligar"
      )
    },
    { key: "atualizado_em", label: "Mudada", width: 140, render: (o) => dataHora(o.atualizado_em) }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel or-painel or-painel--grid" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Op\xE7\xF5es por cliente")), /* @__PURE__ */ React.createElement("p", { className: "muted or-nota or-nota--justa" }, "Quantidade por programa\xE7\xE3o mensal: para o cliente que manda uma encomenda por m\xEAs, cada linha mostra a quantidade a lan\xE7ar \u2014 pedido \u2212 stock (1 e 1001) \u2212 encomenda \xABStock\xBB por produzir. As lan\xE7adas (encomendas abertas dessas refer\xEAncias, de qualquer cliente) n\xE3o entram na conta: a ficha da linha mostra-as s\xF3 para ver, as at\xE9 ao fim do m\xEAs e todas. Desligada por omiss\xE3o."), /* @__PURE__ */ React.createElement("p", { className: "muted or-nota or-nota--justa" }, "Quadro semanal no corpo do email: para o cliente que manda no corpo uma tabela refer\xEAncia \xD7 dia de entrega, a encomenda l\xEA-se sempre do corpo (sem IA; os anexos ficam de consulta) e cada linha mostra o que falta lan\xE7ar \u2014 quantidade do quadro \u2212 o j\xE1 lan\xE7ado no PHC para a mesma refer\xEAncia na mesma semana. Desligado por omiss\xE3o."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading: opcoes === null,
      title: `Clientes com op\xE7\xF5es (${(opcoes || []).length})`,
      appLabel: "orderretriever",
      viewId: "opcoes_cliente",
      columns,
      data: opcoes || [],
      rowKey: (o) => o.id,
      pagination: "none",
      empty: "Nenhum cliente tem op\xE7\xF5es ligadas."
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-pagina--estreita" }, /* @__PURE__ */ React.createElement(OrderretrieverEscolherCliente, { rotulo: "Cliente", valor: cliente, onEscolher: setCliente }), /* @__PURE__ */ React.createElement("div", { className: "or-acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: () => ligar("programacao_mensal") }, "Ligar a programa\xE7\xE3o mensal"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: () => ligar("quadro_semanal") }, "Ligar o quadro semanal"))));
}
function OrderretrieverPromptBaseView() {
  const API = window.OrderretrieverAPI;
  const { dataHora } = window.OrderretrieverUtil;
  const [dados, setDados] = React.useState(null);
  const [texto, setTexto] = React.useState("");
  const [aGravar, setAGravar] = React.useState(false);
  const [vendo, setVendo] = React.useState(null);
  const carregar = React.useCallback(() => API.promptBase().then((d) => {
    setDados(d);
    setTexto(d.atual ? d.atual.texto : "");
  }).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar o prompt base.", "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  if (!dados) return /* @__PURE__ */ React.createElement("div", { className: "muted or-carregar" }, "A carregar\u2026");
  const atual = dados.atual;
  const mudou = texto.trim() !== (atual && atual.texto || "").trim();
  function gravar() {
    setAGravar(true);
    API.gravarPromptBase(texto).then((r) => {
      window.srToast?.(r.gravado ? `Gravado \u2014 vers\xE3o ${r.atual.versao}.` : "Igual \xE0 vers\xE3o atual; nada mudou.", "success");
      return carregar();
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar."), "error")).finally(() => setAGravar(false));
  }
  function ver(v) {
    setVendo({ ...v, texto: null, historico: null });
    API.versaoPromptBase(v.id).then(setVendo).catch(() => {
      setVendo(null);
      window.srToast?.("N\xE3o foi poss\xEDvel abrir a vers\xE3o.", "error");
    });
  }
  const columns = [
    { key: "versao", label: "Vers\xE3o", width: 80, mono: true },
    { key: "ativo", label: "Em uso", width: 80, sortValue: (r) => r.ativo ? 1 : 0, render: (r) => r.ativo ? "Sim" : "" },
    { key: "autor_nome", label: "Autor", width: 160 },
    { key: "criado_em", label: "Gravada", width: 150, render: (r) => dataHora(r.criado_em) },
    { key: "caracteres", label: "Caracteres", width: 110, mono: true },
    { key: "acoes", label: "", sortable: false, width: 80, render: (r) => /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => ver(r) }, "Ver") }
  ];
  const rodapeVersao = vendo && vendo.texto !== null && /* @__PURE__ */ React.createElement(React.Fragment, null, !vendo.ativo && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => {
        setTexto(vendo.texto);
        setVendo(null);
        window.srToast?.("Texto copiado para o editor \u2014 grava para o repor.", "info");
      }
    },
    "Copiar para o editor"
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setVendo(null) }, "Fechar"));
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina" }, /* @__PURE__ */ React.createElement("div", { className: "panel or-painel or-painel--grid" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Prompt base"), /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, atual ? `vers\xE3o ${atual.versao} \xB7 ${atual.autor_nome} \xB7 ${dataHora(atual.criado_em)}` : "ainda sem prompt base \u2014 vai s\xF3 o m\xEDnimo")), /* @__PURE__ */ React.createElement("p", { className: "muted or-nota or-nota--justa" }, "As regras gerais (datas, quantidades, JIT/Firme, moradas), iguais para todos os clientes. O formato da resposta e o esquema juntam-se sozinhos. Gravar cria uma vers\xE3o nova; as anteriores ficam abaixo."), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      "aria-label": "Prompt base",
      rows: 22,
      value: texto,
      onChange: (e) => setTexto(e.target.value),
      className: "or-textarea-mono"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", disabled: !mudou || aGravar || !texto.trim(), onClick: gravar }, aGravar ? "A gravar\u2026" : `Gravar como vers\xE3o ${(dados.versoes[0] && dados.versoes[0].versao || 0) + 1}`), mudou && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setTexto(atual ? atual.texto : "") }, "Desfazer"), mudou && /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, "Altera\xE7\xF5es por gravar."))), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Vers\xF5es",
      appLabel: "orderretriever",
      viewId: "prompt_versoes",
      columns,
      data: dados.versoes,
      rowKey: (r) => r.id,
      pagination: "none",
      empty: "Sem vers\xF5es."
    }
  ), vendo && /* @__PURE__ */ React.createElement(window.ModalShell, { title: `Prompt base \u2014 vers\xE3o ${vendo.versao}`, onClose: () => setVendo(null), footer: rodapeVersao }, vendo.texto === null ? /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "muted or-pequeno or-paragrafo" }, vendo.autor_nome, " \xB7 ", dataHora(vendo.criado_em)), /* @__PURE__ */ React.createElement("pre", { className: "or-pre-modal" }, vendo.texto))));
}
window.OrderretrieverRegrasCliente = OrderretrieverRegrasCliente;
window.OrderretrieverChipSemCorrecao = OrderretrieverChipSemCorrecao;
window.OrderretrieverExemplosLeitura = OrderretrieverExemplosLeitura;
window.OrderretrieverRegrasView = OrderretrieverRegrasView;
window.OrderretrieverEscolherCliente = OrderretrieverEscolherCliente;
window.OrderretrieverPromptBaseView = OrderretrieverPromptBaseView;

// ===== orderretriever/frontend/orderretriever_ficha_temas.jsx =====
(function() {
  const A = () => window.OrderretrieverAPI;
  const TEMAS = {
    resumo: "Resumo",
    artigo: "Artigo",
    stock: "Stock e encomendas",
    preco: "Pre\xE7o",
    leitura: "Leitura",
    morada: "Morada de descarga"
  };
  const TEMA_DO_ALERTA = {
    P: "preco",
    M: "preco",
    E: "stock",
    X: "stock",
    A: "artigo",
    I: "artigo",
    V: "artigo",
    F: "artigo",
    N: "artigo"
  };
  const temaDoAlerta = (id) => TEMA_DO_ALERTA[id] || "resumo";
  const GRAVIDADE = { A: "erro", I: "erro", X: "erro", B: "erro", N: "info" };
  const gravidadeDoAlerta = (id) => GRAVIDADE[id] || "aviso";
  const PORQUE = {
    A: "Nem a Ref. PHC nem a refer\xEAncia do cliente (dossier 11 ou hist\xF3rico) d\xE3o exatamente um artigo do PHC.",
    P: "O pre\xE7o lido n\xE3o \xE9 o da tabela do cliente para esta quantidade (diferen\xE7a acima de 0,5 %).",
    M: "A quantidade \xE9 inferior ao m\xEDnimo da tabela do cliente.",
    I: "O artigo est\xE1 inativo no PHC.",
    V: "\xC9 um artigo de produ\xE7\xE3o que a produ\xE7\xE3o ainda n\xE3o validou.",
    F: "O artigo est\xE1 marcado como fim de vida no PHC.",
    N: "Nenhuma encomenda de cliente (de nenhum cliente) teve ainda este artigo.",
    E: "O cliente j\xE1 tem este artigo numa encomenda aberta, com entrega marcada.",
    X: "O PHC j\xE1 tem uma linha deste cliente com o mesmo artigo, quantidade e data \u2014 esta encomenda pode j\xE1 estar lan\xE7ada.",
    B: "O estado do cliente no PHC.",
    D: "A morada de descarga lida n\xE3o casa com nenhuma morada de descarga do cliente no PHC."
  };
  const ORIGEM_ARTIGO = {
    ref_phc: "pela Ref. PHC escolhida",
    dossier_11: "pela ref. do cliente no dossier 11",
    historico: "pela ref. do cliente no hist\xF3rico",
    dossier_11_parte: "pela ref. do cliente dentro da do dossier 11",
    designacao: "pela designa\xE7\xE3o na tabela do cliente",
    designacao_historico: "pela designa\xE7\xE3o no hist\xF3rico do cliente (n\xE3o est\xE1 na tabela)",
    sem_ref: "sem artigo",
    sem_match: "sem artigo"
  };
  const FABRICA_POR = {
    roteiro: "pelo roteiro",
    morada: "pelo distrito da morada de descarga",
    cliente: "pelo distrito do cliente"
  };
  const ARMAZENS = [
    ["guimaraes", 1, "Guimar\xE3es"],
    ["transito_guimaraes", 1011, "Tr\xE2nsito p/ Guimar\xE3es"],
    ["barquinha", 1001, "Barquinha"],
    ["transito_barquinha", 11, "Tr\xE2nsito p/ Barquinha"]
  ];
  const vazio = (v) => v === null || v === void 0 || String(v).trim() === "";
  const valorDe = (v) => v && typeof v === "object" ? v.valor : v;
  const num = (n) => Number(n).toLocaleString("pt-PT", { maximumFractionDigits: 4 });
  const euros = (n) => `${Number(n).toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 4 })} \u20AC`;
  const qtdTexto = (v) => {
    const n = A().numeroDe(v);
    return n === null ? String(v) : num(n);
  };
  const precoTexto = (v) => {
    const n = A().numeroDe(v);
    return n === null ? String(v) : euros(n);
  };
  const dataTexto = (v) => {
    const iso = A().valorInputData(v);
    return iso ? A().dataPt(iso) : String(v);
  };
  const percentagemDif = (lido, tabela) => lido == null || !tabela ? null : (lido - tabela) / tabela * 100;
  const textoDif = (d) => `${d > 0 ? "+" : ""}${d.toLocaleString("pt-PT", { maximumFractionDigits: 1 })} %`;
  const curto = (texto) => String(texto || "").replace(/ \(.*$/, "").replace(/ na encomenda .*$/, "");
  const chip = (a) => ({
    id: a.id,
    texto: a.texto,
    curto: curto(a.texto),
    gravidade: gravidadeDoAlerta(a.id),
    tema: temaDoAlerta(a.id)
  });
  function escalaoAplicavel(escaloes, quantidade) {
    if (!escaloes.length) return -1;
    let i = 0;
    if (quantidade != null) escaloes.forEach((e, j) => {
      if (e.qtt <= quantidade) i = j;
    });
    return i;
  }
  function campos(pares) {
    return pares.filter(([, v]) => !vazio(v)).map(([rotulo, valor]) => ({ rotulo, valor: String(valor) }));
  }
  function explicarAlertaLinha(a, { linha, ficha, info }) {
    const base = { ...chip(a), porque: PORQUE[a.id] || "", lido: null, phc: null };
    const q = linha.Quantity;
    const d = linha.ExpectedDeliveryDate;
    switch (a.id) {
      case "A": {
        const ref = !vazio(linha.RefPHC) ? linha.RefPHC : linha.Reference;
        const cands = ficha && ficha.candidatas || [];
        return {
          ...base,
          lido: vazio(ref) ? null : String(ref),
          phc: cands.length > 1 ? `${cands.length} candidatas: ${cands.join(", ")}` : "nenhum artigo"
        };
      }
      case "P":
        return {
          ...base,
          lido: vazio(linha.UnitPrice) ? null : precoTexto(linha.UnitPrice),
          phc: ficha && ficha.preco_tabela != null ? euros(ficha.preco_tabela) : null
        };
      case "M":
        return {
          ...base,
          lido: vazio(q) ? null : qtdTexto(q),
          phc: ficha && ficha.minimo != null ? `m\xEDnimo ${num(ficha.minimo)}` : null
        };
      case "E":
        return {
          ...base,
          lido: vazio(d) ? null : dataTexto(d),
          phc: info && info.entrega ? `${A().dataPt(info.entrega.data)} \xB7 encomenda ${info.entrega.obrano}` : null
        };
      case "X":
        return { ...base, lido: vazio(q) || vazio(d) ? null : `${qtdTexto(q)} un. para ${dataTexto(d)}` };
      case "V":
        return { ...base, phc: info && info.tipo ? `tipo ${info.tipo}` : null };
      default: {
        const art = ficha && ficha.artigo;
        return { ...base, phc: art ? `${art.ref} \xB7 ${art.design}` : null };
      }
    }
  }
  function temaArtigo(ficha, info) {
    if (!ficha && !info) return null;
    const art = ficha && ficha.artigo;
    const geridoPor = info && (info.gerido_g || info.gerido_b) ? [info.gerido_g ? "Guimar\xE3es" : null, info.gerido_b ? "Barquinha" : null].filter(Boolean).join(" e ") : info && info.gerido_stock ? "Sim" : null;
    const fabrica = info && info.fabrica ? `${info.fabrica}${FABRICA_POR[info.fabrica_por] ? ` \u2014 ${FABRICA_POR[info.fabrica_por]}` : ""}${info.fabrica_por === "roteiro" && (info.maquinas || []).length ? ` (${info.maquinas.join(", ")})` : ""}` : null;
    const lista = campos([
      ["Artigo", art ? `${art.ref} \xB7 ${art.design}` : null],
      ["Encontrado", ficha ? ORIGEM_ARTIGO[ficha.origem] || ficha.origem : null],
      ["Candidatas", ficha && (ficha.candidatas || []).length > 1 ? ficha.candidatas.join(", ") : null],
      // #332: a designação do PHC por que se achou (ou os candidatos dela), para conferir.
      ["Pela designa\xE7\xE3o", ficha && ficha.designacao ? ficha.designacao.escolhida ? `${ficha.designacao.escolhida.design} (${ficha.designacao.escolhida.semelhanca} % parecida com \xAB${ficha.designacao.lida}\xBB)` : ficha.designacao.candidatos.map((c) => `${c.ref} \xB7 ${c.design} (${c.semelhanca} %)`).join("; ") : null],
      ["Tipo", info && info.tipo],
      // «Validado pela produção» só nos de produção (o indicador do backend, nunca o texto do tipo).
      ["Validado pela produ\xE7\xE3o", info && info.producao ? info.validado_producao ? "Sim" : "N\xE3o" : null],
      ["Fim de vida", info && info.fim_de_vida ? "Sim" : null],
      ["Gerido por stock", geridoPor],
      ["PPWR", info && info.ppwr],
      // `u_mpmono`: pode ser feito com uma MP mono — não «é um mono» (João, 2026-10-23).
      ["Pode ser feito com MP mono", info && info.mono ? "Sim" : null],
      // #279: a quantidade de uma palete (`st.u_qtcxpl`) e em quantas paletes dá a quantidade.
      // #281: a ótima de produção (`stobs.u_nrbobpal`) é outro valor; sem ele (0/vazio) não aparece.
      ["Qtd. por palete", info ? info.qtd_palete != null ? num(info.qtd_palete) : A().SEM_QTD_PALETE : null],
      ["Paletes da quantidade", ficha && ficha.paletes ? A().textoPaletes(ficha.paletes) : null],
      ["Qtd. \xF3tima de produ\xE7\xE3o", info && info.qtd_otima ? num(info.qtd_otima) : null],
      ["Lead time", info && info.lead_time != null ? `${num(info.lead_time)} ${info.lead_time === 1 ? "dia \xFAtil" : "dias \xFAteis"}` : null],
      ["F\xE1brica", fabrica]
    ]);
    return lista.length ? { id: "artigo", campos: lista } : null;
  }
  function textoKitDesdobrado(e, constituintes) {
    const ja = e.ja_nos_constituintes || [];
    const resto = (constituintes || []).map((c) => c.ref).filter((r) => !ja.includes(r));
    if (!ja.length) return "\xD7 qtd. por kit em cada constituinte";
    if (!resto.length) return "j\xE1 desdobrada nos constituintes: conta pelas linhas deles";
    return `\xD7 qtd. por kit em ${resto.join(", ")}; ${ja.join(", ")} j\xE1 desdobrado`;
  }
  function detalheDisponivel(p) {
    if (!p || p.stock_fisico == null || p.reservado == null) return null;
    const bate = Number(p.stock_fisico) - Number(p.reservado) === Number(p.stock);
    const esta = Number(p.reservado_esta) > 0 ? ` (sem os ${num(p.reservado_esta)} reservados por esta encomenda)` : "";
    return `stock ${num(p.stock_fisico)} \u2212 reservado a clientes ${num(p.reservado)}${esta}${bate ? "" : " (cada armaz\xE9m conta pelo menos 0)"}`;
  }
  function temaStock(info, prog, alertas, fimMes) {
    const stock = info && info.stock || {};
    const armazens = ARMAZENS.filter(([k]) => stock[k] != null).map(([k, codigo, rotulo]) => {
      const reservado = info[`reservado_${k}`];
      const disponivel = info[`disponivel_${k}`];
      const acima = disponivel === 0 && reservado > 0 && reservado > Math.max(stock[k], 0);
      return {
        rotulo,
        codigo,
        valor: stock[k],
        reservado,
        disponivel,
        acima,
        texto: stock[k] < 0 ? `${num(stock[k])} (conta 0)` : num(stock[k]),
        textoReservado: reservado == null ? "" : num(reservado),
        textoDisponivel: disponivel == null ? "" : `${num(disponivel)}${acima ? " (reservado acima do stock)" : ""}`
      };
    });
    const encomendas = [];
    if (info && info.entrega) {
      encomendas.push({
        tipo: "Pr\xF3xima entrega",
        obrano: info.entrega.obrano,
        data: A().dataPt(info.entrega.data),
        detalhe: "encomenda aberta deste cliente"
      });
    }
    const quadro = !!prog && prog.tipo === "quadro";
    const kit = !!prog && prog.tipo === "kit";
    const encomendasProg = kit ? (prog.constituintes || []).flatMap((c) => (c.encomendas || []).filter((e) => !e.kit).map((e) => ({ ...e, ref: c.ref }))).concat((prog.encomendas || []).map((e) => ({ ...e, doKit: true }))) : prog && prog.encomendas || [];
    const lancadasProg = [];
    encomendasProg.forEach((e) => {
      if (quadro) {
        encomendas.push({
          tipo: "Lan\xE7ada",
          obrano: e.obrano,
          data: e.data ? A().dataPt(e.data) : "sem data",
          detalhe: A().textoEncomendaProgramacao(e)
        });
        return;
      }
      const stockAberta = e.tipo === "stock";
      const sufixo = e.doKit ? " \xB7 kit" : e.ref ? ` \xB7 ${e.ref}` : "";
      const data = e.data ? A().dataPt(e.data) : "sem data";
      const desdobrado = e.doKit ? ` (${textoKitDesdobrado(e, prog.constituintes)})` : "";
      if (!stockAberta) {
        lancadasProg.push({
          artigo: e.doKit ? "kit" : e.ref || "",
          obrano: e.obrano,
          cliente: e.cliente ? e.cliente_no != null ? `${e.cliente} (n\xBA ${e.cliente_no})` : e.cliente : e.cliente_no != null ? `n\xBA ${e.cliente_no}` : "",
          data,
          detalhe: `${num(e.qtd)} ${e.doKit ? "kits " : ""}por entregar${desdobrado}`,
          ateFimMes: e.ate_fim_mes !== false
        });
        return;
      }
      encomendas.push({
        tipo: `Encomenda \xABStock\xBB${sufixo}`,
        obrano: e.obrano,
        data,
        detalhe: (e.quantidade != null ? `${num(e.por_produzir)} ${e.doKit ? "kits " : ""}por produzir de ${num(e.quantidade)} (${num(e.produzida)} ${e.doKit ? "produzidos" : "produzidas"})` : `${num(e.qtd)} ${e.doKit ? "kits " : ""}por entregar`) + desdobrado
      });
    });
    const totalLancadas = (lista, valor) => kit ? `${lista.length} ${lista.length === 1 ? "linha" : "linhas"}` : num(valor || 0);
    const doMes = lancadasProg.filter((e) => e.ateFimMes);
    const lancadasVer = prog && !quadro ? [
      {
        id: "mes",
        rotulo: fimMes ? `Lan\xE7adas at\xE9 ${A().dataPt(fimMes)}` : "Lan\xE7adas at\xE9 ao fim do m\xEAs",
        total: totalLancadas(doMes, prog.lancadas_ate_fim_mes),
        encomendas: doMes
      },
      {
        id: "todas",
        rotulo: "Lan\xE7adas todas",
        total: totalLancadas(lancadasProg, prog.lancadas_todas),
        encomendas: lancadasProg
      }
    ] : null;
    const lancadas = alertas.filter((a) => a.id === "X").map((a) => a.texto);
    const conta = kit ? {
      titulo: "Programa\xE7\xE3o mensal \u2014 kit",
      parcelas: [{ sinal: "", rotulo: "Pedido (kits)", valor: prog.pedido }],
      constituintes: (prog.constituintes || []).map((c) => ({ ...c, manda: c.ref === prog.manda })),
      nota: "O stock do kit n\xE3o conta (sai sem entrar). Cada constituinte: pedido \xD7 qtd. por kit \u2212 stock dispon\xEDvel \u2212 \xABStock\xBB por produzir; as encomendas \xABStock\xBB do kit contam \xD7 qtd. por kit em cada constituinte (as que o PHC j\xE1 desdobrou nele contam pela linha dele). As lan\xE7adas n\xE3o contam. O kit lan\xE7a os kits que faltam ao que mais falta.",
      resultado: prog.a_lancar,
      coberto: !!prog.coberto,
      cobertoTexto: "os constituintes cobrem o pedido",
      muda: A().programacaoMuda(prog)
    } : quadro ? {
      titulo: "Quadro semanal",
      parcelas: [
        { sinal: "", rotulo: "Pedido no quadro", valor: prog.pedido },
        { sinal: "\u2212", rotulo: `J\xE1 lan\xE7ado na ${A().semanaPt(prog.semana)}`, valor: prog.ja_lancado },
        // #302: o que uma semana posterior traz a mais e cobre esta
        ...(prog.adiados || []).map((a) => ({
          sinal: "\u2212",
          rotulo: `Adiado para a ${A().semanaPt(a.semana)} (enc. ${a.obrano})`,
          valor: a.qtd
        }))
      ],
      nota: [
        prog.semana_passada ? "Semana passada: a data de entrega j\xE1 l\xE1 vai. \xABUsar as quantidades calculadas\xBB n\xE3o mexe nesta linha \u2014 decide tu." : "",
        (prog.cobre || []).length ? `Do j\xE1 lan\xE7ado, ${A().cobrePt(prog)}.` : ""
      ].filter(Boolean).join(" "),
      resultado: prog.a_lancar,
      coberto: !!prog.coberto,
      cobertoTexto: (prog.adiados || []).length ? `adiada para ${A().adiadosPt(prog)}` : "j\xE1 est\xE1 lan\xE7ada",
      muda: A().programacaoMuda(prog)
    } : prog ? {
      titulo: "Programa\xE7\xE3o mensal",
      cobertoTexto: "o pedido j\xE1 est\xE1 coberto",
      parcelas: [
        { sinal: "", rotulo: "Pedido", valor: prog.pedido },
        {
          sinal: "\u2212",
          rotulo: "Stock dispon\xEDvel (Guimar\xE3es 1 + Barquinha 1001)",
          valor: prog.stock,
          detalhe: detalheDisponivel(prog)
        },
        { sinal: "\u2212", rotulo: "Encomendas \xABStock\xBB por produzir", valor: prog.enc_stock_aberta }
      ],
      resultado: prog.a_lancar,
      coberto: !!prog.coberto,
      muda: A().programacaoMuda(prog)
    } : null;
    if (!armazens.length && !encomendas.length && !lancadas.length && !conta) return null;
    const esta = info && Number(info.reservado_esta) > 0 ? `Reservado: dos quais ${num(info.reservado_esta)} por esta encomenda, que n\xE3o descontam no dispon\xEDvel.` : null;
    return {
      id: "stock",
      armazens,
      total: info && info.stock_total != null ? info.stock_total : null,
      reservadoTotal: info && info.reservado_total != null ? info.reservado_total : null,
      disponivelTotal: info && info.disponivel_total != null ? info.disponivel_total : null,
      notaReservado: esta,
      encomendas,
      lancadas,
      conta,
      lancadasVer
    };
  }
  function temaPreco(ficha, linha) {
    if (!ficha) return null;
    const escaloes = ficha.escaloes || [];
    if (!escaloes.length && ficha.preco_tabela == null) return null;
    const qtd = A().numeroDe(linha.Quantity);
    const i = escalaoAplicavel(escaloes, qtd);
    const lido = A().numeroDe(linha.UnitPrice);
    return {
      id: "preco",
      escaloes: escaloes.map((e, j) => ({ qtt: e.qtt, preco: e.preco, aplica: j === i })),
      quantidade: qtd,
      minimo: ficha.minimo,
      lido,
      tabela: ficha.preco_tabela,
      diferenca: percentagemDif(lido, ficha.preco_tabela)
    };
  }
  function temaLeitura(linha, enc) {
    if (!enc || !enc.json_lido || linha._orig === null || linha._orig === void 0) return null;
    const cs = enc.campos && enc.campos.linha || [];
    const limiar = enc.campos && enc.campos.confianca_baixa;
    const lista = [];
    cs.forEach((c) => {
      const caminho = `Lines.${linha._orig}.${c.campo}`;
      const lido = A().campoLido(enc.json_lido, caminho);
      if (!lido) return;
      const atual = valorDe(linha[c.campo]);
      const realce = (enc.realces || {})[caminho];
      lista.push({
        campo: c.campo,
        rotulo: c.label,
        caminho,
        ia: vazio(lido.valor) ? "" : String(lido.valor),
        atual: vazio(atual) ? "" : String(atual),
        alterado: A().alterado(atual, lido.valor),
        confianca: A().percentagem(lido.confianca),
        baixa: limiar != null && A().confiancaBaixa(lido, limiar),
        temOrigem: !!(realce && realce.fonte)
      });
    });
    return lista.length ? { id: "leitura", campos: lista } : null;
  }
  function numerosDaLinha(linha, alertas, prog, ficha) {
    const tem = (id) => alertas.some((a) => a.id === id);
    const out = [];
    const q = linha.Quantity;
    if (!vazio(q)) {
      const pedida = linha.QuantidadePedida;
      out.push({
        rotulo: "Quantidade",
        valor: qtdTexto(q),
        sub: !vazio(pedida) && A().alterado(pedida, q) ? `pedido ${qtdTexto(pedida)}` : "",
        gravidade: tem("M") ? "aviso" : ""
      });
    }
    if (prog) {
      out.push({
        rotulo: "A lan\xE7ar",
        valor: num(prog.a_lancar),
        sub: prog.semana_passada ? "semana passada" : prog.coberto ? { quadro: (prog.adiados || []).length ? `adiada para ${A().adiadosPt(prog)}` : "j\xE1 est\xE1 lan\xE7ada", kit: "os constituintes cobrem o pedido" }[prog.tipo] || "o pedido j\xE1 est\xE1 coberto" : prog.tipo === "kit" ? `kit${prog.manda ? ` \xB7 manda ${prog.manda}` : ""}` : prog.palete ? A().textoALancar(prog) : prog.tipo === "quadro" ? "quadro semanal" : "programa\xE7\xE3o mensal",
        gravidade: prog.semana_passada ? "aviso" : A().programacaoMuda(prog) ? "prog" : ""
      });
    }
    if (!vazio(linha.UnitPrice)) {
      const lido = A().numeroDe(linha.UnitPrice);
      const tabela = ficha && ficha.preco_tabela;
      const d = percentagemDif(lido, tabela);
      out.push({
        rotulo: "Pre\xE7o",
        valor: precoTexto(linha.UnitPrice),
        sub: tabela != null ? `tabela ${euros(tabela)}${d !== null && Math.abs(d) >= 0.05 ? ` \xB7 ${textoDif(d)}` : ""}` : "",
        gravidade: tem("P") ? "aviso" : ""
      });
    }
    if (!vazio(linha.ExpectedDeliveryDate)) {
      out.push({
        rotulo: "Entrega pedida",
        valor: dataTexto(linha.ExpectedDeliveryDate),
        sub: "",
        gravidade: tem("E") ? "aviso" : ""
      });
    }
    return out;
  }
  function fichaDaLinha({ validacao, n, linha, enc }) {
    const API = A();
    const alertas = API.alertasDaLinha(validacao, n);
    const ficha = API.fichaDaLinha(validacao, n);
    const info = API.infoDaLinha(validacao, n);
    const prog = API.programacaoDaLinha(validacao, n);
    const fimMes = validacao && validacao.programacao && validacao.programacao.fim_mes;
    const art = ficha && ficha.artigo;
    const refCliente = vazio(linha.Reference) ? "" : String(linha.Reference);
    const refPhc = art ? art.ref : vazio(linha.RefPHC) ? "" : String(linha.RefPHC);
    const titulo = [`Linha ${n + 1}`, [refCliente, refPhc].filter(Boolean).join(" \u2192 ")].filter(Boolean).join(" \xB7 ");
    const temas = [
      alertas.length ? { id: "resumo", alertas: alertas.map((a) => explicarAlertaLinha(a, { linha, ficha, info })) } : null,
      temaArtigo(ficha, info),
      temaStock(info, prog, alertas, fimMes),
      temaPreco(ficha, linha),
      temaLeitura(linha, enc)
    ].filter(Boolean).map((t) => ({ ...t, rotulo: TEMAS[t.id] }));
    return {
      titulo,
      subtitulo: art ? art.design : vazio(linha.ProductDescription) ? "" : String(linha.ProductDescription),
      chips: alertas.map(chip),
      numeros: numerosDaLinha(linha, alertas, prog, ficha),
      temas
    };
  }
  function fichaDoCabecalho({ validacao, header }) {
    const cab = validacao && validacao.cabecalho || {};
    const alertas = cab.alertas || [];
    const morada = cab.morada;
    const h = header || {};
    const explicados = alertas.map((a) => {
      const base = { ...chip(a), porque: PORQUE[a.id] || "", lido: null, phc: null };
      if (a.id === "D") {
        return {
          ...base,
          lido: vazio(h.WarehouseAddress) ? null : String(h.WarehouseAddress),
          phc: morada && morada.descricao ? `${morada.descricao}${morada.pontos != null ? ` (${morada.pontos} pontos)` : ""}` : null
        };
      }
      if (a.id === "B") return { ...base, phc: a.texto };
      return base;
    });
    let temaMorada = null;
    if (morada) {
      const distrito = morada.distrito ? `${morada.distrito} (${morada.distrito_de === "morada" ? "da morada" : "do cliente"})` : null;
      const lista = morada.falhou ? campos([
        ["Morada", "n\xE3o verificada (a fun\xE7\xE3o do PHC falhou)"],
        ["Distrito", distrito],
        ["F\xE1brica do distrito", morada.fabrica]
      ]) : campos([
        [morada.reconhecida ? "Escolhida pelo PHC" : "Melhor candidata (n\xE3o reconhecida)", morada.descricao],
        ["Morada", morada.morada],
        ["Pontos", morada.pontos != null ? String(morada.pontos) : null],
        ["Distrito", distrito],
        ["F\xE1brica do distrito", morada.fabrica]
      ]);
      if (lista.length) temaMorada = { id: "morada", campos: lista };
    }
    const temas = [
      explicados.length ? { id: "resumo", alertas: explicados } : null,
      temaMorada
    ].filter(Boolean).map((t) => ({ ...t, rotulo: TEMAS[t.id] }));
    return {
      titulo: "Cabe\xE7alho",
      subtitulo: vazio(h.CustomerName) ? "" : String(valorDe(h.CustomerName)),
      chips: alertas.map(chip),
      numeros: [],
      temas
    };
  }
  function temaInicial(temas, pedido) {
    if (!temas.length) return null;
    return temas.some((t) => t.id === pedido) ? pedido : temas[0].id;
  }
  window.OrderretrieverFichaTemas = {
    TEMAS,
    temaDoAlerta,
    gravidadeDoAlerta,
    fichaDaLinha,
    fichaDoCabecalho,
    temaInicial,
    escalaoAplicavel,
    euros,
    num
  };
})();

// ===== orderretriever/frontend/orderretriever_ficha.jsx =====
const OR_FICHA_GRAVIDADE = { erro: "is-erro", aviso: "is-aviso", info: "is-info", prog: "is-prog" };
function OrderretrieverFichaKv({ campos }) {
  return /* @__PURE__ */ React.createElement("div", { className: "kv-grid or-kv or-ficha__kv" }, campos.map((c) => /* @__PURE__ */ React.createElement(React.Fragment, { key: c.rotulo }, /* @__PURE__ */ React.createElement("span", { className: "k" }, c.rotulo), /* @__PURE__ */ React.createElement("span", { className: "v txt" }, c.valor))));
}
function OrderretrieverFichaGrelha({ rotulo, colunas, linhas, classe }) {
  return /* @__PURE__ */ React.createElement("div", { role: "table", "aria-label": rotulo, className: `or-ficha-grelha ${classe}` }, /* @__PURE__ */ React.createElement("div", { role: "row", className: "or-ficha-grelha__cabeca" }, colunas.map((c) => /* @__PURE__ */ React.createElement("span", { key: c, role: "columnheader" }, c))), linhas.map((l) => /* @__PURE__ */ React.createElement("div", { role: "row", key: l.chave, className: l.classe || void 0 }, l.celulas.map((c, i) => /* @__PURE__ */ React.createElement("span", { key: i, role: "cell" }, c)))));
}
function OrderretrieverFichaResumo({ tema, onTema }) {
  const { TEMAS } = window.OrderretrieverFichaTemas;
  return /* @__PURE__ */ React.createElement("ul", { className: "or-ficha-alertas" }, tema.alertas.map((a, i) => /* @__PURE__ */ React.createElement("li", { key: `${a.id}-${i}`, className: `or-ficha-alerta ${OR_FICHA_GRAVIDADE[a.gravidade]}` }, /* @__PURE__ */ React.createElement("div", { className: "or-ficha-alerta__titulo" }, /* @__PURE__ */ React.createElement("span", { className: "or-ficha-letra" }, a.id), /* @__PURE__ */ React.createElement("strong", null, a.texto), a.tema !== "resumo" && TEMAS[a.tema] && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm or-ficha-alerta__ir", onClick: () => onTema(a.tema) }, TEMAS[a.tema], " \u2192")), a.porque && /* @__PURE__ */ React.createElement("div", { className: "muted" }, a.porque), (a.lido || a.phc) && /* @__PURE__ */ React.createElement("div", { className: "or-ficha-alerta__compara" }, a.lido && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Na encomenda"), " ", a.lido), a.phc && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "muted" }, "No PHC"), " ", a.phc)))));
}
function OrderretrieverFichaLancadas({ grupos }) {
  const [aberto, setAberto] = React.useState(null);
  const comArtigo = grupos.some((g) => g.encomendas.some((e) => e.artigo));
  return /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Lan\xE7adas \u2014 s\xF3 para ver (n\xE3o entram na conta)"), grupos.map((g) => /* @__PURE__ */ React.createElement("div", { key: g.id, className: "or-ficha-lancadas" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "or-dobra",
      "aria-expanded": aberto === g.id,
      disabled: !g.encomendas.length,
      onClick: () => setAberto((a) => a === g.id ? null : g.id)
    },
    /* @__PURE__ */ React.createElement(Ico.chevron, { className: "or-dobra__ico" }),
    /* @__PURE__ */ React.createElement("span", null, g.rotulo),
    /* @__PURE__ */ React.createElement("strong", { className: "or-ficha-lancadas__total" }, g.total)
  ), aberto === g.id && g.encomendas.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "or-dobra__corpo" }, /* @__PURE__ */ React.createElement(
    OrderretrieverFichaGrelha,
    {
      rotulo: g.rotulo,
      classe: `or-ficha-grelha--lancadas${comArtigo ? " or-ficha-grelha--lancadas-kit" : ""}`,
      colunas: ["N\xBA", ...comArtigo ? ["Artigo"] : [], "Cliente", "Entrega", "Quantidade"],
      linhas: g.encomendas.map((e, i) => ({
        chave: `${e.obrano}-${i}`,
        celulas: [e.obrano, ...comArtigo ? [e.artigo] : [], e.cliente, e.data, e.detalhe]
      }))
    }
  )))));
}
function OrderretrieverFichaStock({ tema }) {
  const { num } = window.OrderretrieverFichaTemas;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, tema.armazens.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Stock por armaz\xE9m"), /* @__PURE__ */ React.createElement(
    OrderretrieverFichaGrelha,
    {
      rotulo: "Stock por armaz\xE9m",
      classe: "or-ficha-grelha--stock",
      colunas: ["Armaz\xE9m", "N\xBA", "Quantidade", "Reservado", "Dispon\xEDvel"],
      linhas: [
        ...tema.armazens.map((a) => ({
          chave: a.codigo,
          classe: a.acima ? "is-baixa" : void 0,
          celulas: [a.rotulo, a.codigo, a.texto, a.textoReservado, a.textoDisponivel]
        })),
        ...tema.total != null ? [{
          chave: "total",
          classe: "is-total",
          celulas: [
            "Total",
            "",
            num(tema.total),
            tema.reservadoTotal != null ? num(tema.reservadoTotal) : "",
            tema.disponivelTotal != null ? num(tema.disponivelTotal) : ""
          ]
        }] : []
      ]
    }
  ), tema.notaReservado && /* @__PURE__ */ React.createElement("div", { className: "muted" }, tema.notaReservado)), tema.conta && /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, tema.conta.titulo), /* @__PURE__ */ React.createElement("div", { className: "or-ficha-conta", role: "group", "aria-label": `Conta: ${tema.conta.titulo.toLowerCase()}` }, tema.conta.parcelas.map((p, i) => /* @__PURE__ */ React.createElement("div", { key: `${p.rotulo}-${i}`, className: "or-ficha-conta__linha" }, /* @__PURE__ */ React.createElement("span", { className: "or-ficha-conta__sinal" }, p.sinal), /* @__PURE__ */ React.createElement("span", null, p.rotulo, p.detalhe && /* @__PURE__ */ React.createElement("span", { className: "or-ficha-conta__detalhe muted" }, p.detalhe)), /* @__PURE__ */ React.createElement("span", { className: "or-ficha-conta__valor" }, num(p.valor)))), /* @__PURE__ */ React.createElement("div", { className: `or-ficha-conta__linha or-ficha-conta__resultado${tema.conta.muda ? " is-muda" : ""}` }, /* @__PURE__ */ React.createElement("span", { className: "or-ficha-conta__sinal" }, "="), /* @__PURE__ */ React.createElement("span", null, "A lan\xE7ar", tema.conta.coberto ? ` \u2014 ${tema.conta.cobertoTexto}` : ""), /* @__PURE__ */ React.createElement("span", { className: "or-ficha-conta__valor" }, num(tema.conta.resultado)))), tema.conta.constituintes && /* @__PURE__ */ React.createElement(
    OrderretrieverFichaGrelha,
    {
      rotulo: "Constituintes do kit",
      classe: "or-ficha-grelha--kit",
      colunas: ["Constituinte", "Por kit", "Precisa", "Stock dispon\xEDvel", "\xABStock\xBB por produzir", "A lan\xE7ar", "Kits"],
      linhas: tema.conta.constituintes.map((c) => ({
        chave: c.ref,
        classe: c.manda ? "is-aplica" : void 0,
        celulas: [
          c.manda ? `${c.ref} \u2014 manda` : c.ref,
          num(c.qtt_por_kit),
          num(c.necessario),
          c.reservado ? `${num(c.stock)} (${num(c.stock_fisico)} \u2212 ${num(c.reservado)} res.)` : num(c.stock),
          num(c.enc_stock_aberta),
          num(c.a_lancar),
          num(c.kits)
        ]
      }))
    }
  ), tema.conta.nota && /* @__PURE__ */ React.createElement("div", { className: "muted" }, tema.conta.nota)), tema.lancadasVer && /* @__PURE__ */ React.createElement(OrderretrieverFichaLancadas, { grupos: tema.lancadasVer }), tema.encomendas.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Encomendas abertas deste artigo"), /* @__PURE__ */ React.createElement(
    OrderretrieverFichaGrelha,
    {
      rotulo: "Encomendas abertas",
      classe: "or-ficha-grelha--encomendas",
      colunas: ["", "N\xBA", "Data", "Quantidade"],
      linhas: tema.encomendas.map((e, i) => ({
        chave: `${e.tipo}-${e.obrano}-${i}`,
        celulas: [e.tipo, e.obrano, e.data, e.detalhe]
      }))
    }
  )), tema.lancadas.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "J\xE1 lan\xE7ada no PHC"), /* @__PURE__ */ React.createElement("ul", { className: "or-ficha-lista" }, tema.lancadas.map((t, i) => /* @__PURE__ */ React.createElement("li", { key: i, className: "or-ficha-alerta is-erro" }, t)))));
}
function OrderretrieverFichaPreco({ tema }) {
  const { euros, num } = window.OrderretrieverFichaTemas;
  const campos = [
    tema.minimo != null ? { rotulo: "M\xEDnimo", valor: num(tema.minimo) } : null,
    tema.lido != null ? { rotulo: "Pre\xE7o lido", valor: euros(tema.lido) } : null,
    tema.tabela != null ? { rotulo: "Pre\xE7o da tabela", valor: euros(tema.tabela) } : null,
    tema.diferenca != null ? {
      rotulo: "Diferen\xE7a",
      valor: `${tema.diferenca > 0 ? "+" : ""}${tema.diferenca.toLocaleString("pt-PT", { maximumFractionDigits: 1 })} %`
    } : null
  ].filter(Boolean);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, tema.escaloes.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Escal\xF5es da tabela do cliente"), /* @__PURE__ */ React.createElement(
    OrderretrieverFichaGrelha,
    {
      rotulo: "Escal\xF5es da tabela do cliente",
      classe: "or-ficha-grelha--escaloes",
      colunas: ["A partir de", "Pre\xE7o", ""],
      linhas: tema.escaloes.map((e) => ({
        chave: e.qtt,
        classe: e.aplica ? "is-aplica" : void 0,
        celulas: [
          num(e.qtt),
          euros(e.preco),
          e.aplica ? tema.quantidade != null ? `\u2190 ${num(tema.quantidade)} un.` : "\u2190" : ""
        ]
      }))
    }
  )), campos.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement(OrderretrieverFichaKv, { campos })));
}
function OrderretrieverFichaLeitura({ tema, onVerNoDocumento }) {
  return /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement(
    OrderretrieverFichaGrelha,
    {
      rotulo: "Leitura da IA",
      classe: "or-ficha-grelha--leitura",
      colunas: ["Campo", "A IA leu", "Agora", "Confian\xE7a", ""],
      linhas: tema.campos.map((c) => ({
        chave: c.campo,
        classe: c.baixa ? "is-baixa" : void 0,
        celulas: [
          c.rotulo,
          c.ia || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014"),
          c.alterado ? /* @__PURE__ */ React.createElement("strong", null, "\u270E ", c.atual || "\u2014") : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "igual"),
          c.confianca ? /* @__PURE__ */ React.createElement("span", { className: `or-chip${c.baixa ? " is-baixa" : ""}` }, c.confianca) : "",
          c.temOrigem && onVerNoDocumento ? /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => onVerNoDocumento(c.caminho) }, "ver no documento") : /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, "sem origem")
        ]
      }))
    }
  ));
}
function OrderretrieverFicha({ ficha, tema, onTema, navList, currentId, onNavigate, onClose, onVerNoDocumento, aviso }) {
  const { temaInicial } = window.OrderretrieverFichaTemas;
  const ativo = temaInicial(ficha.temas, tema);
  const abaRefs = React.useRef({});
  const idAba = (t) => `or-ficha-aba-${t}`;
  const teclaAbas = (e) => {
    const ids = ficha.temas.map((t) => t.id);
    const i = ids.indexOf(ativo);
    const destino = {
      ArrowRight: ids[(i + 1) % ids.length],
      ArrowLeft: ids[(i - 1 + ids.length) % ids.length],
      Home: ids[0],
      End: ids[ids.length - 1]
    }[e.key];
    if (!destino) return;
    e.preventDefault();
    onTema(destino);
    if (abaRefs.current[destino]) abaRefs.current[destino].focus();
  };
  const atual = ficha.temas.find((t) => t.id === ativo);
  let corpo = null;
  if (atual) {
    if (atual.id === "resumo") corpo = /* @__PURE__ */ React.createElement(OrderretrieverFichaResumo, { tema: atual, onTema });
    else if (atual.id === "stock") corpo = /* @__PURE__ */ React.createElement(OrderretrieverFichaStock, { tema: atual });
    else if (atual.id === "preco") corpo = /* @__PURE__ */ React.createElement(OrderretrieverFichaPreco, { tema: atual });
    else if (atual.id === "leitura") corpo = /* @__PURE__ */ React.createElement(OrderretrieverFichaLeitura, { tema: atual, onVerNoDocumento });
    else corpo = /* @__PURE__ */ React.createElement("section", { className: "or-ficha__bloco" }, /* @__PURE__ */ React.createElement(OrderretrieverFichaKv, { campos: atual.campos }));
  }
  return /* @__PURE__ */ React.createElement(
    window.DrawerShell,
    {
      title: ficha.titulo,
      subtitle: ficha.subtitulo || void 0,
      onClose,
      navList: navList || [],
      currentId,
      onNavigate,
      largura: "min(760px, 100vw)"
    },
    /* @__PURE__ */ React.createElement("div", { className: "or-ficha" }, ficha.chips.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "or-ficha__chips", "aria-label": "Alertas" }, ficha.chips.map((c, i) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: `${c.id}-${i}`,
        type: "button",
        title: c.texto,
        className: `or-ficha-chip ${OR_FICHA_GRAVIDADE[c.gravidade]}`,
        onClick: () => onTema(c.tema)
      },
      /* @__PURE__ */ React.createElement("strong", null, c.id),
      " ",
      c.curto
    ))), ficha.numeros.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "or-ficha__numeros" }, ficha.numeros.map((x) => /* @__PURE__ */ React.createElement("div", { key: x.rotulo, className: `or-ficha-num ${OR_FICHA_GRAVIDADE[x.gravidade] || ""}` }, /* @__PURE__ */ React.createElement("span", { className: "or-ficha-num__rotulo" }, x.rotulo), /* @__PURE__ */ React.createElement("span", { className: "or-ficha-num__valor" }, x.valor), x.sub && /* @__PURE__ */ React.createElement("span", { className: "or-ficha-num__sub" }, x.sub)))), aviso && /* @__PURE__ */ React.createElement("div", { className: "muted or-ficha__aviso", role: "status" }, aviso), ficha.temas.length === 0 && !aviso && /* @__PURE__ */ React.createElement("div", { className: "muted or-ficha__aviso" }, "Sem mais nada a dizer sobre esta linha."), ficha.temas.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { role: "tablist", "aria-label": "Temas", className: "or-ficha__abas", onKeyDown: teclaAbas }, ficha.temas.map((t) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: t.id,
        type: "button",
        role: "tab",
        id: idAba(t.id),
        "aria-selected": ativo === t.id,
        "aria-controls": `${idAba(t.id)}-painel`,
        tabIndex: ativo === t.id ? 0 : -1,
        ref: (el) => {
          abaRefs.current[t.id] = el;
        },
        className: `btn sm ${ativo === t.id ? "primary" : "ghost"}`,
        onClick: () => onTema(t.id)
      },
      t.rotulo
    ))), /* @__PURE__ */ React.createElement("div", { role: "tabpanel", id: `${idAba(ativo)}-painel`, "aria-labelledby": idAba(ativo), className: "or-ficha__painel" }, corpo)))
  );
}
window.OrderretrieverFicha = OrderretrieverFicha;

// ===== orderretriever/frontend/orderretriever_encomenda.jsx =====
const OR_FILTROS_FILA = ["sac", "cliente", "triagem", "de", "ate"];
const OR_DIVISORIA_CHAVE = "orderretriever:divisoria";
function orLerDivisoria() {
  try {
    const v = parseFloat(window.localStorage.getItem(OR_DIVISORIA_CHAVE));
    return v >= 25 && v <= 75 ? v : 45;
  } catch (e) {
    return 45;
  }
}
function orGravarDivisoria(v) {
  try {
    window.localStorage.setItem(OR_DIVISORIA_CHAVE, String(v));
  } catch (e) {
  }
}
function orValor(campo) {
  if (campo && typeof campo === "object") return campo.valor;
  return campo;
}
function orNumero(n, minimo = 0) {
  return n.toLocaleString("pt-PT", { minimumFractionDigits: minimo, maximumFractionDigits: 4 });
}
function orQtd(v) {
  const n = typeof v === "number" ? v : Number(String(v ?? "").trim().replace(",", "."));
  return String(v ?? "").trim() !== "" && Number.isFinite(n) ? orNumero(n) : String(v ?? "\u2014");
}
function orMostra(v) {
  if (v === null || v === void 0 || v === "") return /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014");
  return String(v);
}
let orProximaChave = 1;
function orRascunho(enc) {
  const d = enc.dados || { Header: {}, Lines: [] };
  const nLidas = (enc.json_lido && enc.json_lido.Lines || []).length;
  const indices = window.OrderretrieverAPI.indicesLidos(d, nLidas);
  return {
    Header: { ...d.Header || {} },
    Lines: (d.Lines || []).map((l, i) => ({
      ...l,
      _orig: indices[i],
      _k: orProximaChave++
    }))
  };
}
function orParaApi(r) {
  return {
    Header: { ...r.Header },
    IndicesLidos: r.Lines.map((l) => l._orig),
    Lines: r.Lines.map((l) => {
      const o = { ...l };
      delete o._orig;
      delete o._k;
      delete o._designacao;
      return o;
    })
  };
}
function orComCampo(l, campo, v) {
  const nova = { ...l, [campo]: v };
  if (campo === "RefPHC") delete nova._designacao;
  return nova;
}
function orTextoInput(v) {
  return v === null || v === void 0 ? "" : String(v);
}
function OrderretrieverConfianca({ campo, limiar, semOrigem, soBaixa }) {
  const { percentagem, confiancaBaixa } = window.OrderretrieverAPI;
  const baixa = confiancaBaixa(campo, limiar);
  const pct = percentagem(campo && campo.confianca);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, pct && (!soBaixa || baixa) && /* @__PURE__ */ React.createElement(
    "span",
    {
      title: baixa ? `Confian\xE7a da IA baixa (abaixo de ${percentagem(limiar)})` : "Confian\xE7a da IA neste valor",
      className: `or-chip${baixa ? " is-baixa" : ""}`
    },
    pct
  ), semOrigem && /* @__PURE__ */ React.createElement("span", { className: "muted or-chip or-chip--simples", title: "A IA n\xE3o indicou de onde leu este valor no documento" }, "sem origem"));
}
function OrderretrieverIaLeu({ valor }) {
  return /* @__PURE__ */ React.createElement("div", { className: "muted or-ia-leu", title: "Alterado \xE0 m\xE3o \u2014 o valor que a IA leu" }, "\u270E IA leu: ", orMostra(valor));
}
function OrderretrieverCampo({ rotulo, children }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "k" }, rotulo), /* @__PURE__ */ React.createElement("span", { className: "v txt" }, children));
}
let orProximaLista = 1;
function OrderretrieverRefPhc({
  clienteNo,
  valor,
  onChange,
  rotulo,
  className,
  onFocus,
  distintivo,
  candidatos = [],
  pelaDesignacao = null,
  designacao = null
}) {
  const [sugestoes, setSugestoes] = React.useState([]);
  const [erro, setErro] = React.useState("");
  const listaId = React.useMemo(() => `or-refphc-${orProximaLista++}`, []);
  const pedido = React.useRef(0);
  const temporizador = React.useRef(null);
  React.useEffect(() => () => clearTimeout(temporizador.current), []);
  const procurar = (q) => {
    if (clienteNo == null) {
      setSugestoes([]);
      setErro("");
      return;
    }
    clearTimeout(temporizador.current);
    temporizador.current = setTimeout(() => {
      const n = ++pedido.current;
      window.OrderretrieverAPI.referencias(clienteNo, q).then((d) => {
        if (n === pedido.current) {
          setSugestoes(Array.isArray(d) ? d : []);
          setErro("");
        }
      }).catch((e) => {
        if (n === pedido.current) setErro(e && e.detail || "PHC indispon\xEDvel");
      });
    }, 250);
  };
  const doisLados = [...candidatos, ...sugestoes.filter((s) => !candidatos.some((c) => c.ref === s.ref))];
  const escolhida = doisLados.find((s) => s.ref === orTextoInput(valor).trim());
  const rotuloDe = (s) => [
    s.design,
    s.ref_cliente ? `ref. cliente ${s.ref_cliente}` : "",
    s.semelhanca != null ? `${s.semelhanca} % parecida` : "",
    s.na_tabela === false ? "s\xF3 no hist\xF3rico \u2014 n\xE3o est\xE1 na tabela do cliente" : ""
  ].filter(Boolean).join(" \xB7 ");
  const vazia = !orTextoInput(valor).trim();
  const doHistorico = vazia && designacao && designacao.escolhida && !designacao.escolhida.na_tabela ? designacao.escolhida : null;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: `or-entrada${distintivo ? " tem-phc" : ""}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      "aria-label": rotulo,
      type: "text",
      list: listaId,
      value: orTextoInput(valor),
      autoComplete: "off",
      placeholder: clienteNo == null ? "escolhe primeiro o cliente" : "procurar na tabela do cliente\u2026",
      onClick: (e) => e.stopPropagation(),
      onFocus: (e) => {
        procurar(e.target.value.trim());
        if (onFocus) onFocus();
      },
      onChange: (e) => {
        onChange(e.target.value);
        procurar(e.target.value.trim());
      },
      className
    }
  ), distintivo), /* @__PURE__ */ React.createElement("datalist", { id: listaId }, doisLados.map((s) => /* @__PURE__ */ React.createElement("option", { key: s.ref, value: s.ref }, rotuloDe(s)))), pelaDesignacao && /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "pill or-pela-designacao",
      title: `Designa\xE7\xE3o no PHC: ${pelaDesignacao.design} (${pelaDesignacao.semelhanca} % parecida com a lida)`
    },
    "pela designa\xE7\xE3o"
  ), doHistorico && /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "pill or-pela-designacao or-pela-designacao--historico",
      title: `Designa\xE7\xE3o no PHC: ${doHistorico.design} (${doHistorico.semelhanca} % parecida). S\xF3 est\xE1 no hist\xF3rico do cliente, n\xE3o na tabela \u2014 a Ref. PHC n\xE3o a aceita.`
    },
    "pela designa\xE7\xE3o (hist\xF3rico): ",
    doHistorico.ref
  ), vazia && !doHistorico && designacao && !designacao.escolhida && candidatos.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "muted or-ia-leu" }, candidatos.length, " ", candidatos.length === 1 ? "candidato" : "candidatos", " pela designa\xE7\xE3o \u2014 escolhe na lista"), escolhida && /* @__PURE__ */ React.createElement("div", { className: "muted or-ia-leu" }, escolhida.design), erro && /* @__PURE__ */ React.createElement("div", { className: "or-ia-leu or-erro", role: "alert" }, erro));
}
function orPaginaDe(realces, sel) {
  if (!sel || !realces) return null;
  for (const [campo, r] of Object.entries(realces)) {
    if (campo === sel || campo.startsWith(`${sel}.`)) {
      const c = (r.caixas || [])[0];
      if (c) return c.pagina;
    }
  }
  return null;
}
function OrderretrieverEncomenda({ id, routeId, params, navigate, reportCrumb, registerLeaveGuard }) {
  const [enc, setEncBruta] = React.useState(null);
  const [erro, setErro] = React.useState(null);
  const [aReprocessar, setAReprocessar] = React.useState(false);
  const [lancadaAqui, setLancadaAqui] = React.useState(false);
  const [rascunho, setRascunho] = React.useState(null);
  const [base, setBase] = React.useState("");
  const [aGravar, setAGravar] = React.useState("");
  const [aRejeitar, setARejeitar] = React.useState(false);
  const [versao, setVersao] = React.useState(0);
  const { MudarCliente, Rejeitar, Resultado, Historico } = window.OrderretrieverDecisao;
  const [divisoria, setDivisoria] = React.useState(orLerDivisoria);
  const [ensinar, setEnsinar] = React.useState(null);
  const [emailAberto, setEmailAberto] = React.useState(false);
  const [notasAbertas, setNotasAbertas] = React.useState(false);
  const [erroAcao, setErroAcao] = React.useState(null);
  const gradeRef = React.useRef(null);
  const { EstadoBadge, dataHora, tamanho, Aviso, Alerta } = window.OrderretrieverUtil;
  const Ico = window.Ico;
  const p = params && typeof params.get === "function" ? params : window.HubRouter.current().params;
  const selecionado = p.get("campo") || "";
  const soBaixa = p.get("baixa") === "1";
  const pagina = parseInt(p.get("pag"), 10) || 1;
  const zoom = window.OrderretrieverAPI.zoomDoUrl(p.get("zoom"));
  const setSel = (campo, pag) => window.HubRouter.setParams({
    campo: campo || null,
    pag: pag && pag > 1 ? String(pag) : null
  });
  const setEnc = React.useCallback((d) => {
    setEncBruta(d);
    setErroAcao(null);
    if (!d || d.estado !== "a_processar") setLancadaAqui(false);
    if (d) {
      const r = orRascunho(d);
      setRascunho(r);
      setBase(JSON.stringify(orParaApi(r)));
      setVersao((v) => v + 1);
    } else {
      setRascunho(null);
      setBase("");
    }
  }, []);
  const editavel = !!(enc && enc.pode_validar && enc.estado === "por_validar" && rascunho);
  const sujo = editavel && JSON.stringify(orParaApi(rascunho)) !== base;
  const [validacaoResp, setValidacao] = React.useState(null);
  const [fichaAberta, setFichaAberta] = React.useState(null);
  const pedidoPhc = React.useRef(0);
  const phcSemCache = React.useRef(false);
  const [aPhc, setAPhc] = React.useState(false);
  const validarPhc = !!(enc && enc.estado === "por_validar" && rascunho);
  const chavePhc = validarPhc ? JSON.stringify([enc.cliente_no, rascunho.Header.WarehouseName, rascunho.Header.WarehouseAddress, rascunho.Header.OrderNumber, rascunho.Lines.map((l) => [l.Reference, l.RefPHC, l.Quantity, l.UnitPrice, l.ExpectedDeliveryDate, l.QuantidadePedida, String(l.RefPHC || "").trim() ? "" : l.ProductDescription])]) : "";
  const chavesLinhas = rascunho ? rascunho.Lines.map((l) => l._k).join("|") : "";
  const clienteNoAtual = enc ? enc.cliente_no : null;
  const validacao = validacaoResp && validacaoResp._ks === chavesLinhas && validacaoResp._cliente === clienteNoAtual ? validacaoResp : null;
  const porUsar = validacao && validacao._chave === chavePhc && rascunho ? window.OrderretrieverAPI.usarQuantidadesCalculadas(rascunho.Lines, validacao).mudadas : 0;
  React.useEffect(() => {
    setValidacao(null);
    setFichaAberta(null);
    pedidoPhc.current += 1;
  }, [id]);
  const designacaoFeitas = React.useRef(/* @__PURE__ */ new Set());
  React.useEffect(() => {
    designacaoFeitas.current = window.OrderretrieverAPI.designacaoFeitasDe(id);
  }, [id]);
  React.useEffect(() => {
    if (!editavel || !validacao || validacao._chave !== chavePhc) return;
    const { linhas: novas, mudadas } = window.OrderretrieverAPI.preencherPelaDesignacao(
      rascunho.Lines,
      validacao,
      designacaoFeitas.current
    );
    if (!mudadas.length) return;
    mudadas.forEach((c) => designacaoFeitas.current.add(c));
    window.OrderretrieverAPI.guardarDesignacaoFeitas(id, designacaoFeitas.current);
    setRascunho((r) => ({ ...r, Lines: novas }));
    window.srToast?.(`${mudadas.length === 1 ? "Uma linha" : `${mudadas.length} linhas`} sem refer\xEAncia ${mudadas.length === 1 ? "ganhou" : "ganharam"} a Ref. PHC pela designa\xE7\xE3o \u2014 confere e grava.`, "info");
  }, [validacao, chavePhc, editavel]);
  React.useEffect(() => {
    pedidoPhc.current += 1;
    if (!validarPhc) {
      setValidacao(null);
      return void 0;
    }
    const marca = { _ks: chavesLinhas, _cliente: enc.cliente_no, _id: enc.id, _chave: chavePhc };
    if (validacaoResp && !validacaoResp.indisponivel && validacaoResp._id === enc.id && validacaoResp._chave === chavePhc) {
      setValidacao({ ...validacaoResp, ...marca });
      return void 0;
    }
    const t = setTimeout(() => {
      const n = ++pedidoPhc.current;
      const opcoes = { refrescar: phcSemCache.current };
      phcSemCache.current = false;
      window.OrderretrieverAPI.validacaoPhc(enc.id, orParaApi(rascunho), opcoes).then((v) => {
        if (n === pedidoPhc.current) setValidacao({ ...v, ...marca });
      }).catch(() => {
        if (n === pedidoPhc.current) setValidacao({ indisponivel: "Valida\xE7\xE3o PHC indispon\xEDvel", cabecalho: { alertas: [] }, linhas: [], ...marca });
      });
    }, 500);
    return () => clearTimeout(t);
  }, [chavePhc, chavesLinhas, validarPhc]);
  React.useEffect(() => {
    if (typeof registerLeaveGuard !== "function") return void 0;
    return registerLeaveGuard((destino) => {
      if (!sujo || !destino) return true;
      const alvo = window.HubRouter.parse(destino);
      if (alvo && alvo.routeId === routeId && String(alvo.entidade || "") === String(id)) return true;
      window.hubConfirm({ title: "Altera\xE7\xF5es por gravar", message: "Sair sem gravar as altera\xE7\xF5es a esta encomenda?", confirmLabel: "Sair sem gravar" }).then((ok) => {
        if (ok) {
          setBase(JSON.stringify(orParaApi(rascunho)));
          window.HubRouter.navigate(alvo);
        }
      });
      return false;
    });
  }, [registerLeaveGuard, sujo, rascunho, routeId, id]);
  React.useEffect(() => {
    let vivo = true;
    setEnc(null);
    setErro(null);
    window.OrderretrieverAPI.encomenda(id).then((d) => {
      if (vivo) setEnc(d);
    }).catch((e) => {
      if (vivo) setErro(e && e.status === 404 ? "Esta encomenda n\xE3o existe." : "N\xE3o foi poss\xEDvel carregar a encomenda.");
    });
    return () => {
      vivo = false;
    };
  }, [id, setEnc]);
  const aLer = !!(enc && enc.estado === "a_processar" && !enc.proxima_tentativa);
  const ocupado = !!(aReprocessar || aLer && lancadaAqui || aGravar);
  const aFazer = aGravar === "aprovar" ? "A gerar os ficheiros\u2026" : aGravar === "gravar" ? "A gravar\u2026" : ocupado ? "A reprocessar \u2014 a IA est\xE1 a ler o documento\u2026" : "";
  React.useEffect(() => {
    if (!aLer) return void 0;
    let vivo = true;
    const parar = window.OrderretrieverAPI.ligarFila({
      onMudou: (msg) => {
        const minha = (msg.encomendas || []).find((e) => String(e.id) === String(id));
        if (!minha || minha.estado === "a_processar") return;
        window.OrderretrieverAPI.encomenda(id).then((d) => {
          if (!vivo) return;
          setEnc(d);
          window.srToast?.(
            d.estado === "com_erro" ? "Reprocessada \u2014 continua com erro." : "Reprocessada.",
            d.estado === "com_erro" ? "error" : "success"
          );
        }).catch(() => {
        });
      }
    });
    return () => {
      vivo = false;
      parar();
    };
  }, [aLer, id, setEnc]);
  React.useEffect(() => {
    if (!reportCrumb) return void 0;
    reportCrumb(enc ? `Encomenda ${enc.numero || enc.id} \xB7 ${enc.cliente_nome || "por identificar"}` : null);
    return () => reportCrumb(null);
  }, [enc, reportCrumb]);
  const arrastar = (ev) => {
    if (ev.button !== void 0 && ev.button !== 0) return;
    ev.preventDefault();
    const alvo = ev.currentTarget;
    alvo.focus();
    const grade = gradeRef.current;
    if (!grade) return;
    const rect = grade.getBoundingClientRect();
    if (alvo.setPointerCapture) alvo.setPointerCapture(ev.pointerId);
    let ultimo = divisoria;
    const mover = (e) => {
      ultimo = Math.min(75, Math.max(25, (e.clientX - rect.left) / rect.width * 100));
      setDivisoria(ultimo);
    };
    const largar = () => {
      alvo.removeEventListener("pointermove", mover);
      alvo.removeEventListener("pointerup", largar);
      alvo.removeEventListener("pointercancel", largar);
      orGravarDivisoria(ultimo);
    };
    alvo.addEventListener("pointermove", mover);
    alvo.addEventListener("pointerup", largar);
    alvo.addEventListener("pointercancel", largar);
  };
  const teclaDivisoria = (e) => {
    const d = e.key === "ArrowLeft" ? -5 : e.key === "ArrowRight" ? 5 : 0;
    if (!d) return;
    e.preventDefault();
    const v = Math.min(75, Math.max(25, divisoria + d));
    setDivisoria(v);
    orGravarDivisoria(v);
  };
  const confirmarSaida = (fn) => {
    if (!sujo) {
      fn();
      return;
    }
    window.hubConfirm({ title: "Altera\xE7\xF5es por gravar", message: "Sair sem gravar as altera\xE7\xF5es a esta encomenda?", confirmLabel: "Sair sem gravar" }).then((ok) => {
      if (ok) fn();
    });
  };
  const irParaLista = () => {
    const q = new URLSearchParams(window.HubRouter.current().params);
    q.delete("campo");
    q.delete("pag");
    q.delete("zoom");
    q.delete("baixa");
    navigate({ routeId, params: q });
  };
  const voltar = () => confirmarSaida(irParaLista);
  const abrir = (outro) => confirmarSaida(() => navigate({ routeId, entidade: String(outro) }));
  const [aProcurar, setAProcurar] = React.useState(false);
  const seguinte = () => confirmarSaida(() => {
    const q = new URLSearchParams(window.HubRouter.current().params);
    q.delete("campo");
    q.delete("pag");
    const filtros = {};
    OR_FILTROS_FILA.forEach((k) => {
      filtros[k] = q.get(k) || "";
    });
    setAProcurar(true);
    window.OrderretrieverAPI.seguinte(id, filtros).then((r) => {
      if (r && r.id) navigate({ routeId, entidade: String(r.id), params: q });
      else window.srToast?.("N\xE3o h\xE1 mais encomendas por validar com estes filtros.", "info");
    }).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel encontrar a seguinte.", "error")).finally(() => setAProcurar(false));
  });
  const erroApi = (e, dflt) => e && e.status === 403 ? "Sem permiss\xE3o para validar encomendas." : window.OrderretrieverAPI.erroDRF(e, dflt);
  const falhou = (e, dflt) => {
    const ec = window.OrderretrieverAPI.erroDeCampo(e);
    if (ec) {
      const linha = ec.linha === null ? null : rascunho.Lines[ec.linha];
      if (ec.linha === null || linha) {
        setErroAcao({ k: linha ? linha._k : null, campo: ec.campo, mensagem: ec.mensagem });
        return;
      }
    }
    setErroAcao({ mensagem: erroApi(e, dflt) });
  };
  function gravar() {
    setAGravar("gravar");
    setErroAcao(null);
    window.OrderretrieverAPI.editar(enc.id, orParaApi(rascunho)).then((d) => {
      setEnc(d);
      window.srToast?.("Altera\xE7\xF5es gravadas.", "success");
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel gravar.")).finally(() => setAGravar(""));
  }
  async function aprovar() {
    const ativo = enc.email && enc.email.modo === "ativo";
    const API = window.OrderretrieverAPI;
    const fora = API.textoForaDoXls(rascunho.Lines, validacao);
    const nada = API.linhasForaDoXls(rascunho.Lines, validacao).todas;
    const ok = await window.hubConfirm({
      title: "Aprovar e gerar Excel",
      message: nada ? `Todas as ${rascunho.Lines.length} linhas t\xEAm quantidade 0 \u2014 n\xE3o h\xE1 linhas para lan\xE7ar. ${fora}
Rejeita a encomenda, ou corrige as quantidades.` : `Gera o .xls, o .json e o .eml desta encomenda (${rascunho.Lines.length} linhas, cliente ${enc.cliente_no ?? "\u2014"}).` + (fora ? ` ${fora}` : "") + (ativo ? "\nModo ativo: os ficheiros v\xE3o para a pasta do importador do PHC." : "\nModo sombra: os ficheiros v\xE3o para o diret\xF3rio de sombra."),
      confirmLabel: "Aprovar",
      danger: false,
      confirmDisabled: nada
    });
    if (!ok) return;
    setAGravar("aprovar");
    setErroAcao(null);
    window.OrderretrieverAPI.aprovar(enc.id, orParaApi(rascunho)).then((d) => {
      setEnc(d);
      window.srToast?.("Encomenda aprovada \u2014 ficheiros gerados.", "success");
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel aprovar.")).finally(() => setAGravar(""));
  }
  async function apagar() {
    const motivo = { texto: "" };
    const ok = await window.hubConfirm({
      title: "Apagar encomenda",
      message: /* @__PURE__ */ React.createElement(React.Fragment, null, "Sai da lista, dos contadores e do sino. Fica guardada e pode-se repor em Defini\xE7\xF5es \u203A Apagadas.", sujo && "\nAs altera\xE7\xF5es por gravar perdem-se.", /* @__PURE__ */ React.createElement("label", { className: "or-campo or-apagar-motivo" }, "Motivo (opcional)", /* @__PURE__ */ React.createElement("textarea", { rows: 2, maxLength: 500, onChange: (e) => {
        motivo.texto = e.target.value;
      } }))),
      confirmLabel: "Apagar"
    });
    if (!ok) return;
    window.OrderretrieverAPI.apagar(enc.id, motivo.texto).then(() => {
      window.srToast?.("Encomenda apagada.", "success");
      irParaLista();
    }).catch((e) => falhou(e, "N\xE3o foi poss\xEDvel apagar."));
  }
  const limparErro = (k, campo) => setErroAcao((e) => e && e.campo === campo && e.k === k ? null : e);
  const mudarHeader = (campo, v) => {
    limparErro(null, campo);
    setRascunho((r) => ({ ...r, Header: { ...r.Header, [campo]: v } }));
  };
  const mudarLinha = (k, campo, v) => {
    limparErro(k, campo);
    setRascunho((r) => ({
      ...r,
      Lines: r.Lines.map((l) => l._k === k ? orComCampo(l, campo, v) : l)
    }));
  };
  const usarCalculadas = () => {
    const { linhas: novas, mudadas } = window.OrderretrieverAPI.usarQuantidadesCalculadas(rascunho.Lines, validacao);
    if (!mudadas) return;
    setRascunho((r) => ({ ...r, Lines: novas }));
    window.srToast?.(`${mudadas} ${mudadas === 1 ? "quantidade mudada" : "quantidades mudadas"} para a calculada \u2014 grava para ficar.`, "info");
  };
  const aplicarQ = (k, campo) => {
    if (!validacao || validacao._chave !== chavePhc) {
      window.srToast?.("A conta ainda est\xE1 a ser refeita com os valores atuais \u2014 tenta daqui a um instante.", "info");
      return;
    }
    const r = window.OrderretrieverAPI.usarQuantidadeCalculada(rascunho.Lines, validacao, k);
    if (!r) return;
    limparErro(k, campo);
    setRascunho((x) => ({ ...x, Lines: r.linhas }));
    window.srToast?.(`Quantidade da linha ${r.n + 1}: ${orQtd(r.pedido)} \u2192 ${orQtd(r.a_lancar)} \u2014 grava para ficar.`, "info");
  };
  const tirarLinha = (k) => setRascunho((r) => ({ ...r, Lines: r.Lines.filter((l) => l._k !== k) }));
  const novaLinha = () => setRascunho((r) => ({
    ...r,
    Lines: [...r.Lines, { _orig: null, _k: orProximaChave++ }]
  }));
  function reprocessarPhc() {
    if (!validarPhc || aPhc) return;
    const marca = { _ks: chavesLinhas, _cliente: enc.cliente_no, _id: enc.id, _chave: chavePhc };
    const n = ++pedidoPhc.current;
    setAPhc(true);
    window.OrderretrieverAPI.validacaoPhc(enc.id, orParaApi(rascunho), { refrescar: true }).then((v) => {
      if (n !== pedidoPhc.current) return;
      if (v && v.indisponivel) {
        window.srToast?.("PHC indispon\xEDvel \u2014 a valida\xE7\xE3o n\xE3o mudou.", "error");
        return;
      }
      setValidacao({ ...v, ...marca });
      window.srToast?.("Valida\xE7\xE3o PHC atualizada.", "success");
    }).catch(() => {
      if (n === pedidoPhc.current) window.srToast?.("N\xE3o foi poss\xEDvel validar no PHC.", "error");
    }).finally(() => setAPhc(false));
  }
  function reprocessar() {
    setAReprocessar(true);
    setErroAcao(null);
    phcSemCache.current = true;
    window.OrderretrieverAPI.reprocessar(enc.id).then((d) => {
      setEnc(d);
      if (d.estado !== "a_processar") return;
      setLancadaAqui(true);
      window.srToast?.("A reprocessar \u2014 o resultado aparece aqui sozinho.", "info");
    }).catch((e) => {
      phcSemCache.current = false;
      setErroAcao({ mensagem: e && e.status === 403 ? "Sem permiss\xE3o para reprocessar." : window.OrderretrieverAPI.erroDRF(e, "N\xE3o foi poss\xEDvel reprocessar.") });
    }).finally(() => setAReprocessar(false));
  }
  async function pedirReprocessar() {
    if (sujo && !await window.hubConfirm({ title: "Reprocessar IA", message: "Ler outra vez com a IA deita fora as altera\xE7\xF5es por gravar. Continuar?", confirmLabel: "Reprocessar IA" })) return;
    reprocessar();
  }
  const atalhos = React.useRef({});
  atalhos.current = {
    aprovar: () => {
      if (enc && podeAprovarAgora(enc)) aprovar();
    },
    rejeitar: () => {
      if (enc && podeRejeitarAgora(enc)) setARejeitar(true);
    },
    seguinte: () => {
      if (!aProcurar) seguinte();
    }
  };
  React.useEffect(() => {
    const tecla = (e) => {
      const acao = window.OrderretrieverAPI.atalhoValidacao(e);
      if (!acao) return;
      e.preventDefault();
      atalhos.current[acao]();
    };
    window.addEventListener("keydown", tecla);
    return () => window.removeEventListener("keydown", tecla);
  }, []);
  function podeAprovarAgora(e) {
    return !!(editavel && !ocupado && !aRejeitar && e.cliente_no != null && rascunho.Lines.length > 0);
  }
  function podeRejeitarAgora(e) {
    return !!(e.pode_validar && ["por_validar", "com_erro", "a_processar"].includes(e.estado) && !aGravar);
  }
  if (erro) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: voltar }, "\u2190 Encomendas"), /* @__PURE__ */ React.createElement("p", null, erro));
  }
  if (!enc) return /* @__PURE__ */ React.createElement("div", { className: "muted or-carregar" }, "A carregar\u2026");
  const email = enc.email || {};
  const anexos = email.anexos || [];
  const lido = enc.json_lido;
  const header = rascunho && rascunho.Header || {};
  const linhas = rascunho && rascunho.Lines || [];
  const campos = enc.campos || { header: [], linha: [] };
  const avisos = enc.avisos || [];
  const notasIa = enc.notas_ia || [];
  const avisosDe = (prefixo) => avisos.filter((a) => a.campo === prefixo || a.campo.startsWith(`${prefixo}.`));
  const selecionar = (campo) => {
    const pag = orPaginaDe(enc.realces, campo);
    setSel(campo === selecionado ? "" : campo, pag || pagina);
  };
  const temRealce = (campo) => {
    const r = (enc.realces || {})[campo];
    return !!(r && r.fonte);
  };
  const {
    campoLido,
    alterado,
    confiancaBaixa,
    campoNumerico,
    valorInputNumerico,
    valorInputData,
    totalLinha
  } = window.OrderretrieverAPI;
  const erroEm = (k, campo) => erroAcao && erroAcao.campo === campo && erroAcao.k === k ? erroAcao.mensagem : "";
  const ErroCampo = ({ mensagem }) => mensagem ? /* @__PURE__ */ React.createElement("div", { className: "or-ia-leu or-erro or-erro-campo", role: "alert" }, mensagem) : null;
  const limiar = campos.confianca_baixa;
  const lidoDe = (caminho) => caminho ? campoLido(lido, caminho) : null;
  const baixaEm = (caminho) => confiancaBaixa(lidoDe(caminho), limiar);
  const semOrigem = (caminho) => {
    const c = lidoDe(caminho);
    return !!(c && c.valor !== null && c.valor !== void 0 && c.valor !== "" && !temRealce(caminho));
  };
  const iaLeu = (caminho, atual) => {
    const c = lidoDe(caminho);
    return c && alterado(atual, c.valor) ? { valor: c.valor } : null;
  };
  const linhaBaixa = (r) => r._orig !== null && campos.linha.some((c) => baixaEm(`Lines.${r._orig}.${c.campo}`));
  const nBaixa = lido && limiar != null ? campos.header.filter((c) => baixaEm(`Header.${c.campo}`)).length + linhas.reduce((n, r) => n + (r._orig === null ? 0 : campos.linha.filter((c) => baixaEm(`Lines.${r._orig}.${c.campo}`)).length), 0) : 0;
  const mudarSoBaixa = (v) => window.HubRouter.setParams({ baixa: v ? "1" : null });
  const linhaSel = (r) => r._orig === null ? "" : `Lines.${r._orig}`;
  const F = window.OrderretrieverFichaTemas;
  const abrirFicha = (k, tema) => {
    setFichaAberta({ k, tema: tema || null });
    const l = k === "cabecalho" ? null : linhas.find((x) => x._k === k);
    const alvo = l && linhaSel(l);
    if (alvo && selecionado !== alvo) setSel(alvo, orPaginaDe(enc.realces, alvo) || pagina);
  };
  const campoProg = (validacao && validacao.linhas || []).map((l) => l.programacao).find(Boolean)?.campo;
  const colunas = [
    {
      key: "_n",
      label: "#",
      width: 52,
      mono: true,
      sortValue: (r) => r._n,
      render: (r) => {
        const aviso = r._orig === null ? null : avisos.find((a) => a.campo === `Lines.${r._orig}`);
        return /* @__PURE__ */ React.createElement("span", { title: aviso ? aviso.mensagem : void 0 }, r._n + 1, aviso ? /* @__PURE__ */ React.createElement(Alerta, null) : null);
      }
    },
    ...campos.linha.map((c) => ({
      // #275: com a programação ligada, a caixa da quantidade leva o «M» e o «Q»
      // lado a lado — com 120 px um «500» aparecia «50» (reparo do QA).
      key: c.campo,
      label: c.label,
      width: c.campo === "ProductDescription" ? 220 : c.tipo === "data" ? 160 : c.campo === campoProg ? 140 : 120,
      sortValue: (r) => orValor(r[c.campo]),
      render: (r) => {
        const caminho = r._orig === null ? "" : `Lines.${r._orig}.${c.campo}`;
        const aviso = caminho ? avisos.find((a) => a.campo === caminho) : null;
        const baixa = baixaEm(caminho);
        const leu = iaLeu(caminho, orValor(r[c.campo]));
        const extra = (baixa || leu) && /* @__PURE__ */ React.createElement(React.Fragment, null, baixa && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(OrderretrieverConfianca, { campo: lidoDe(caminho), limiar })), leu && /* @__PURE__ */ React.createElement(OrderretrieverIaLeu, { valor: leu.valor }));
        const erroAqui = erroEm(r._k, c.campo);
        const phc = window.OrderretrieverAPI.alertasDoCampo(validacao, `Lines.${r._n}.${c.campo}`);
        const linhaX = window.OrderretrieverAPI.jaLancada(validacao, r._n);
        const prog = window.OrderretrieverAPI.programacaoDaLinha(validacao, r._n);
        const q = !!prog && prog.campo === c.campo && window.OrderretrieverAPI.qPorAplicar(prog, r[c.campo]);
        const passada = !!prog && prog.campo === c.campo && !!prog.semana_passada;
        const classeCelula = `or-celula-input${erroAqui ? " is-erro" : aviso || passada ? " is-aviso" : baixa ? " is-baixa" : ""}${phc.length || linhaX ? " is-phc" : q ? " is-prog" : ""}`;
        const letras = phc.map((a) => a.texto).join(" \xB7 ");
        const botaoPhc = phc.length > 0 && /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            className: "or-phc-id",
            title: letras,
            "aria-label": letras,
            onClick: (e) => {
              e.stopPropagation();
              abrirFicha(r._k, F.temaDoAlerta(phc[0].id));
            }
          },
          phc.map((a) => a.id).join("")
        );
        const rotuloQ = q && `Usar a quantidade calculada: ${window.OrderretrieverAPI.textoProgramacao(prog)}`;
        const botaoQ = q && /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            className: "or-phc-id or-phc-id--prog",
            title: rotuloQ,
            "aria-label": rotuloQ,
            onClick: (e) => {
              e.stopPropagation();
              aplicarQ(r._k, c.campo);
            }
          },
          "Q"
        );
        const idPhc = (botaoPhc || botaoQ) && (botaoPhc && botaoQ ? /* @__PURE__ */ React.createElement("span", { className: "or-phc-ids" }, botaoPhc, botaoQ) : botaoPhc || botaoQ);
        if (editavel && c.tipo === "ref_phc") {
          return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
            OrderretrieverRefPhc,
            {
              clienteNo: enc.cliente_no,
              valor: r[c.campo],
              rotulo: `${c.label}, linha ${r._n + 1}`,
              className: classeCelula,
              distintivo: idPhc,
              candidatos: window.OrderretrieverAPI.candidatosDaDesignacao(validacao, r._n),
              pelaDesignacao: r._designacao || null,
              designacao: window.OrderretrieverAPI.designacaoDaLinha(validacao, r._n),
              onChange: (v) => mudarLinha(r._k, c.campo, v)
            }
          ), /* @__PURE__ */ React.createElement(ErroCampo, { mensagem: erroAqui }));
        }
        if (editavel) {
          const numerico = c.tipo === "numero" && campoNumerico(r[c.campo]);
          const data = c.tipo === "data" && valorInputData(r[c.campo]) !== null;
          const valorInput = numerico ? valorInputNumerico(r[c.campo]) : data ? valorInputData(r[c.campo]) : orTextoInput(r[c.campo]);
          return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: `or-entrada${idPhc ? " tem-phc" : ""}` }, /* @__PURE__ */ React.createElement(
            "input",
            {
              "aria-label": `${c.label}, linha ${r._n + 1}`,
              value: valorInput,
              type: data ? "date" : numerico ? "number" : "text",
              step: numerico ? "any" : void 0,
              title: aviso ? aviso.mensagem : void 0,
              "aria-invalid": erroAqui ? true : void 0,
              className: classeCelula,
              onClick: (e) => e.stopPropagation(),
              onFocus: () => {
                if (caminho && caminho !== selecionado) selecionar(caminho);
              },
              onChange: (e) => mudarLinha(r._k, c.campo, e.target.value)
            }
          ), idPhc), /* @__PURE__ */ React.createElement(ErroCampo, { mensagem: erroAqui }), extra);
        }
        return /* @__PURE__ */ React.createElement(
          "span",
          {
            role: "button",
            tabIndex: 0,
            title: aviso ? aviso.mensagem : void 0,
            className: `or-valor${selecionado === caminho ? " is-ativo" : ""}`,
            onClick: (e) => {
              e.stopPropagation();
              if (caminho) selecionar(caminho);
            },
            onKeyDown: (e) => {
              if (e.key === "Enter" && caminho) {
                e.stopPropagation();
                selecionar(caminho);
              }
            }
          },
          orMostra(orValor(r[c.campo])),
          aviso ? /* @__PURE__ */ React.createElement(Alerta, null) : null,
          extra
        );
      }
    })),
    {
      key: "_total",
      label: "Total",
      width: 100,
      mono: true,
      sortValue: (r) => totalLinha(r),
      render: (r) => {
        const t = totalLinha(r);
        return t === null ? /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014") : orNumero(t, 2);
      }
    },
    ...editavel ? [{
      key: "_tirar",
      label: "",
      width: 44,
      sortable: false,
      render: (r) => /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          "aria-label": `Tirar a linha ${r._n + 1}`,
          title: "Tirar esta linha",
          onClick: (e) => {
            e.stopPropagation();
            tirarLinha(r._k);
          }
        },
        /* @__PURE__ */ React.createElement(Ico.close, null)
      )
    }] : []
  ];
  const totais = window.OrderretrieverAPI.totaisEncomenda(linhas);
  const linhasDados = linhas.map((l, n) => ({ ...l, _n: n })).filter((r) => !soBaixa || linhaBaixa(r));
  const podeMudarCliente = enc.pode_validar && ["por_validar", "com_erro", "a_processar"].includes(enc.estado);
  const podeRejeitar = enc.pode_validar && ["por_validar", "com_erro", "a_processar"].includes(enc.estado);
  const decidida = enc.estado === "aprovada" || enc.estado === "rejeitada";
  return /* @__PURE__ */ React.createElement("div", { className: "or-vista or-vista--detalhe" }, /* @__PURE__ */ React.createElement("div", { className: "panel or-barra" }, /* @__PURE__ */ React.createElement("div", { className: "or-barra__titulo" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: voltar }, "\u2190 Encomendas"), /* @__PURE__ */ React.createElement("strong", null, "Encomenda ", enc.numero || enc.id, " \xB7 ", enc.cliente_nome || "Cliente por identificar"), /* @__PURE__ */ React.createElement(EstadoBadge, { estado: enc.estado, label: enc.estado_label }), /* @__PURE__ */ React.createElement(window.OrderretrieverChipSemCorrecao, { dados: ensinar && ensinar.sem_correcao }), enc.pode_apagar && /* @__PURE__ */ React.createElement(window.OrderretrieverMenuEncomenda, { bloqueio: enc.bloqueio_apagar, onApagar: apagar })), /* @__PURE__ */ React.createElement("div", { className: "kv-grid or-kv or-meta" }, /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "SAC" }, enc.sac_label || "\u2014"), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Chegou" }, dataHora(enc.recebido_em)), enc.modelo && /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "IA" }, /* @__PURE__ */ React.createElement("span", { title: `${enc.tokens_entrada} tokens de entrada \xB7 ${enc.tokens_saida} de sa\xEDda` }, enc.modelo, enc.custo_eur != null ? ` \xB7 ${Number(enc.custo_eur).toFixed(3)} \u20AC` : "")))), aRejeitar && /* @__PURE__ */ React.createElement(
    Rejeitar,
    {
      enc,
      onFechar: () => setARejeitar(false),
      onFeito: (d) => {
        setARejeitar(false);
        setEnc(d);
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { ref: gradeRef, className: "or-grade", style: { "--or-divisoria": `${divisoria}%` } }, /* @__PURE__ */ React.createElement("div", { className: "or-grade__esq", "aria-busy": ocupado ? true : void 0 }, ocupado && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar", role: "progressbar", "aria-label": aFazer }), /* @__PURE__ */ React.createElement("fieldset", { className: "or-form", disabled: ocupado }, enc.erro && /* @__PURE__ */ React.createElement(Aviso, { tipo: "erro" }, enc.erro), /* @__PURE__ */ React.createElement(Resultado, { enc }), enc.estado === "a_processar" && !enc.proxima_tentativa && /* @__PURE__ */ React.createElement(Aviso, null, "\xC0 espera da extra\xE7\xE3o \u2014 o processamento corre a seguir ao poller."), enc.estado === "a_processar" && enc.proxima_tentativa && /* @__PURE__ */ React.createElement(Aviso, null, "A IA n\xE3o respondeu (tentativa ", enc.tentativas, ") \u2014 volta a tentar sozinha a partir de ", dataHora(enc.proxima_tentativa), ". \xABReprocessar IA\xBB l\xEA-a j\xE1."), enc.e_encomenda === false && /* @__PURE__ */ React.createElement(Aviso, null, "A IA acha que isto ", /* @__PURE__ */ React.createElement("strong", null, "n\xE3o \xE9 uma encomenda"), enc.e_encomenda_confianca != null ? ` (confian\xE7a ${Math.round(enc.e_encomenda_confianca * 100)} %)` : "", "."), enc.duplicada && /* @__PURE__ */ React.createElement(Aviso, null, /* @__PURE__ */ React.createElement("strong", null, "Poss\xEDvel duplicada."), " ", window.OrderretrieverAPI.textoDuplicada(enc.duplicada), " ", /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => abrir(enc.duplicada.id)
    },
    "Abrir a outra"
  )), avisos.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Avisos" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, /* @__PURE__ */ React.createElement("span", { className: "or-alerta", "aria-hidden": "true" }, "\u26A0"), " ", avisos.length, " ", avisos.length === 1 ? "aviso" : "avisos"), /* @__PURE__ */ React.createElement("ul", { className: "or-lista" }, avisos.map((a, i) => /* @__PURE__ */ React.createElement("li", { key: `${i}:${a.campo}:${a.codigo}`, className: "or-linha" }, /* @__PURE__ */ React.createElement("span", null, a.codigo === "ia" ? /* @__PURE__ */ React.createElement("span", { className: "muted", title: "Aviso da verifica\xE7\xE3o da IA" }, "IA \xB7 ") : null, a.mensagem, a.confianca != null && /* @__PURE__ */ React.createElement("span", { className: "muted", title: "Confian\xE7a da IA neste aviso" }, " \xB7 ", window.OrderretrieverAPI.percentagem(a.confianca))), /^(Header|Lines)\.\w/.test(a.campo || "") && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => selecionar(a.campo.replace(/^(Lines\.\d+)\..*$/, "$1")) }, "ver no doc."))))), notasIa.length > 0 && /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Notas da IA" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-dobra", "aria-expanded": notasAbertas, onClick: () => setNotasAbertas((a) => !a) }, /* @__PURE__ */ React.createElement(Ico.chevron, { className: "or-dobra__ico" }), /* @__PURE__ */ React.createElement("span", { className: "section-label" }, "\u2139 ", notasIa.length, " ", notasIa.length === 1 ? "nota" : "notas", " da IA \u2014 o que o c\xF3digo descartou da resposta")), notasAbertas && /* @__PURE__ */ React.createElement("ul", { className: "muted or-dobra__corpo or-notas" }, notasIa.map((n, i) => /* @__PURE__ */ React.createElement("li", { key: i }, n)))), lido && limiar != null && /* @__PURE__ */ React.createElement(
    "label",
    {
      className: "or-caixa or-nota",
      title: `Mostra s\xF3 os campos em que a IA tem menos de ${window.OrderretrieverAPI.percentagem(limiar)} de confian\xE7a`
    },
    /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: soBaixa, onChange: (e) => mudarSoBaixa(e.target.checked) }),
    "S\xF3 os de confian\xE7a baixa (",
    nBaixa,
    ")"
  ), /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Cabe\xE7alho" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Cabe\xE7alho"), !lido && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Ainda n\xE3o foi lido pela IA."), lido && soBaixa && !campos.header.some((c) => baixaEm(`Header.${c.campo}`)) && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Nenhum campo do cabe\xE7alho com confian\xE7a baixa."), lido && campos.header.filter((c) => !soBaixa || baixaEm(`Header.${c.campo}`)).map((c) => {
    const caminho = `Header.${c.campo}`;
    const aviso = avisosDe(caminho)[0];
    const ativo = selecionado === caminho;
    const leu = iaLeu(caminho, header[c.campo]);
    const chip = /* @__PURE__ */ React.createElement(OrderretrieverConfianca, { campo: lidoDe(caminho), limiar, semOrigem: semOrigem(caminho) });
    const erroAqui = erroEm(null, c.campo);
    const data = c.tipo === "data" && valorInputData(header[c.campo]) !== null;
    const phc = window.OrderretrieverAPI.alertasDoCampo(validacao, caminho);
    return editavel ? /* @__PURE__ */ React.createElement("div", { key: c.campo, className: `or-cabecalho-campo${ativo ? " is-ativo" : ""}` }, /* @__PURE__ */ React.createElement("label", { className: "muted", htmlFor: `or-h-${c.campo}` }, c.label, aviso ? /* @__PURE__ */ React.createElement(Alerta, null) : null), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: `or-entrada${phc.length ? " tem-phc" : ""}` }, /* @__PURE__ */ React.createElement(
      "input",
      {
        id: `or-h-${c.campo}`,
        type: data ? "date" : "text",
        value: data ? valorInputData(header[c.campo]) : orTextoInput(header[c.campo]),
        title: aviso ? aviso.mensagem : void 0,
        "aria-invalid": erroAqui ? true : void 0,
        className: `or-cabecalho-input${erroAqui ? " is-erro" : aviso ? " is-aviso" : ""}${phc.length ? " is-phc" : ""}`,
        onFocus: () => {
          if (caminho !== selecionado) selecionar(caminho);
        },
        onChange: (e) => mudarHeader(c.campo, e.target.value)
      }
    ), phc.length > 0 && /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "or-phc-id",
        title: phc.map((a) => a.texto).join(" \xB7 "),
        "aria-label": phc.map((a) => a.texto).join(" \xB7 "),
        onClick: () => abrirFicha("cabecalho")
      },
      phc.map((a) => a.id).join("")
    )), /* @__PURE__ */ React.createElement("div", { className: "or-caixa or-sob-caixa" }, chip), /* @__PURE__ */ React.createElement(ErroCampo, { mensagem: erroAqui }), leu && /* @__PURE__ */ React.createElement(OrderretrieverIaLeu, { valor: leu.valor }))) : /* @__PURE__ */ React.createElement(
      "button",
      {
        key: c.campo,
        type: "button",
        "aria-pressed": ativo,
        onClick: () => selecionar(caminho),
        title: aviso ? aviso.mensagem : temRealce(caminho) ? "Ver no documento" : "Sem origem no documento",
        className: `or-cabecalho-campo or-cabecalho-campo--botao${ativo ? " is-ativo" : ""}`
      },
      /* @__PURE__ */ React.createElement("span", { className: "muted" }, c.label),
      /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "or-caixa or-caixa--quebra" }, /* @__PURE__ */ React.createElement("span", null, orMostra(orValor(header[c.campo])), aviso ? /* @__PURE__ */ React.createElement(Alerta, null) : null), chip), leu && /* @__PURE__ */ React.createElement(OrderretrieverIaLeu, { valor: leu.valor }))
    );
  })), lido && /* @__PURE__ */ React.createElement("section", { "aria-label": "Linhas", className: "or-linhas" }, validacao && validacao.indisponivel && /* @__PURE__ */ React.createElement(Aviso, null, "Valida\xE7\xE3o PHC indispon\xEDvel \u2014 os alertas n\xE3o est\xE3o a ser calculados."), validacao && validacao.programacao && validacao.programacao.falhou && /* @__PURE__ */ React.createElement(Aviso, null, validacao.programacao.tipo === "quadro" ? "Quadro semanal" : "Programa\xE7\xE3o mensal", ": o PHC n\xE3o respondeu \u2014 a quantidade a lan\xE7ar n\xE3o est\xE1 calculada."), validacao && validacao.cabecalho && validacao.cabecalho.alertas.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "or-phc-linha" }, validacao.cabecalho.alertas.map((a, i) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: `${a.id}-${a.campo}-${i}`,
      type: "button",
      className: "or-phc-alerta",
      onClick: () => abrirFicha("cabecalho")
    },
    /* @__PURE__ */ React.createElement("strong", null, a.id),
    " \xB7 ",
    a.texto
  ))), validacao && validacao.cabecalho && validacao.cabecalho.morada && validacao.cabecalho.morada.reconhecida && /* @__PURE__ */ React.createElement("div", { className: "or-phc-info" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-phc-morada", onClick: () => abrirFicha("cabecalho", "morada") }, "morada de descarga no PHC: ", validacao.cabecalho.morada.descricao, " (", validacao.cabecalho.morada.pontos, " pontos)")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: soBaixa ? `Linhas (${linhasDados.length} de ${linhas.length})` : `Linhas (${linhas.length})`,
      columns: colunas,
      data: linhasDados,
      rowKey: (r) => r._k,
      renderRowExtra: (r) => {
        const al = window.OrderretrieverAPI.alertasDaLinha(validacao, r._n);
        const faixa = window.OrderretrieverAPI.faixaDaLinha(window.OrderretrieverAPI.infoDaLinha(validacao, r._n));
        const prog = window.OrderretrieverAPI.programacaoDaLinha(validacao, r._n);
        if (!al.length && !faixa.length && !prog) return null;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, al.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "or-phc-linha" }, al.map((a, i) => /* @__PURE__ */ React.createElement(
          "button",
          {
            key: `${a.id}-${a.campo}-${i}`,
            type: "button",
            className: "or-phc-alerta",
            onClick: () => abrirFicha(r._k, F.temaDoAlerta(a.id))
          },
          /* @__PURE__ */ React.createElement("strong", null, a.id),
          " \xB7 ",
          a.texto
        ))), prog && /* @__PURE__ */ React.createElement("div", { className: "or-phc-info" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            className: `or-phc-programacao${window.OrderretrieverAPI.programacaoMuda(prog) ? " is-muda" : ""}${prog.semana_passada ? " is-passada" : ""}`,
            onClick: () => abrirFicha(r._k, "stock")
          },
          prog.semana_passada && /* @__PURE__ */ React.createElement("span", { className: "pill or-phc-passada" }, "semana passada"),
          window.OrderretrieverAPI.textoProgramacao(prog)
        )), faixa.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "or-phc-info" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-phc-faixa", onClick: () => abrirFicha(r._k, "artigo") }, faixa.join(" \xB7 "))));
      },
      onRowClick: (r) => abrirFicha(r._k),
      rowClassName: (r) => [
        linhaSel(r) && (selecionado === linhaSel(r) || selecionado.startsWith(`${linhaSel(r)}.`)) ? "selected" : null,
        window.OrderretrieverAPI.jaLancada(validacao, r._n) ? "or-ja-lancada" : null,
        window.OrderretrieverAPI.quadroCoberto(validacao, r._n) ? "or-quadro-coberta" : null
      ].filter(Boolean).join(" ") || void 0,
      empty: soBaixa ? "Nenhuma linha com confian\xE7a baixa." : editavel ? "Sem linhas \u2014 acrescenta uma." : "A IA n\xE3o leu nenhuma linha.",
      appLabel: "orderretriever",
      viewId: "linhas"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-totais" }, editavel && !soBaixa && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", "aria-label": "Acrescentar linha", onClick: novaLinha }, /* @__PURE__ */ React.createElement(Ico.plus, null), " linha"), /* @__PURE__ */ React.createElement("span", { className: "or-espaco" }), /* @__PURE__ */ React.createElement("div", { className: "kv-grid or-kv or-totais__kv", "aria-label": "Totais da encomenda" }, /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Quantidade total" }, orNumero(totais.quantidade)), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Total da encomenda" }, totais.total === null ? "\u2014" : orNumero(totais.total, 2), totais.semTotal > 0 && totais.total !== null && /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 sem ", totais.semTotal, " ", totais.semTotal === 1 ? "linha" : "linhas", " (falta quantidade ou pre\xE7o)"))))), /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Cliente" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Cliente"), /* @__PURE__ */ React.createElement("div", { className: "kv-grid or-kv" }, /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Nome" }, enc.cliente_nome || "Por identificar"), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "N\xBA PHC" }, enc.cliente_no ?? "\u2014"), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "NIF" }, enc.cliente_nif || "\u2014"), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Identificado por" }, enc.identificado_por_label)), podeMudarCliente && /* @__PURE__ */ React.createElement(MudarCliente, { enc, onMudou: (d) => {
    const r = rascunho;
    setEnc(d);
    if (sujo && r) setRascunho(r);
  } })), /* @__PURE__ */ React.createElement(
    window.OrderretrieverRegrasCliente,
    {
      key: `${enc.cliente_no}:${enc.estado}`,
      clienteNo: enc.cliente_no,
      clienteNome: enc.cliente_nome,
      encomendaId: enc.id,
      onDados: setEnsinar
    }
  ), /* @__PURE__ */ React.createElement(
    window.OrderretrieverExemplosLeitura,
    {
      key: `ex:${enc.cliente_no}:${enc.estado}`,
      encomendaId: enc.id,
      clienteNo: enc.cliente_no,
      onAbrir: abrir
    }
  ), /* @__PURE__ */ React.createElement("section", { className: "panel or-painel or-seccao", "aria-label": "Email e anexos" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "or-dobra", "aria-expanded": emailAberto, onClick: () => setEmailAberto((a) => !a) }, /* @__PURE__ */ React.createElement(Ico.chevron, { className: "or-dobra__ico" }), /* @__PURE__ */ React.createElement("span", { className: "section-label" }, "Email e anexos (", anexos.length, ")")), emailAberto && /* @__PURE__ */ React.createElement("div", { className: "or-dobra__corpo" }, /* @__PURE__ */ React.createElement("div", { className: "kv-grid or-kv" }, email.remetente_original && /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Original de" }, email.remetente_original), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Enviado pelo cliente" }, email.enviado_original_em ? dataHora(email.enviado_original_em) : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "n\xE3o se percebeu no email")), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: email.remetente_original ? "Reencaminhado por" : "De" }, email.remetente_nome ? `${email.remetente_nome} <${email.remetente}>` : email.remetente), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Assunto" }, email.assunto || "\u2014"), /* @__PURE__ */ React.createElement(OrderretrieverCampo, { rotulo: "Pasta" }, (email.pasta || "").toUpperCase(), " \xB7 modo ", email.modo)), /* @__PURE__ */ React.createElement("ul", { className: "or-lista or-lista--topo" }, anexos.map((a) => /* @__PURE__ */ React.createElement("li", { key: a.id, className: "or-linha or-linha--quebra" }, /* @__PURE__ */ React.createElement("span", { className: `or-linha__nome${a.id === enc.anexo ? " is-esta" : ""}` }, a.nome), /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, tamanho(a.tamanho)), a.inline && /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, "assinatura/log\xF3tipo"), a.id === enc.anexo && /* @__PURE__ */ React.createElement("span", { className: "or-pequeno" }, "esta encomenda"), /* @__PURE__ */ React.createElement("a", { className: "btn ghost sm", href: a.url, target: "_blank", rel: "noopener noreferrer" }, "Abrir"), /* @__PURE__ */ React.createElement("a", { className: "btn ghost sm", href: `${a.url}?download=1` }, "Descarregar")))), (enc.irmas || []).length > 0 && /* @__PURE__ */ React.createElement("div", { className: "or-irmas" }, /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Outras encomendas deste email: "), enc.irmas.map((o) => /* @__PURE__ */ React.createElement("button", { key: o.id, type: "button", className: "btn ghost sm", onClick: () => abrir(o.id) }, o.id, " \xB7 ", o.origem))))), /* @__PURE__ */ React.createElement(Historico, { id: enc.id, versao }))), /* @__PURE__ */ React.createElement(
    "div",
    {
      role: "separator",
      "aria-orientation": "vertical",
      "aria-label": "Divis\xF3ria",
      "aria-valuenow": Math.round(divisoria),
      "aria-valuemin": 25,
      "aria-valuemax": 75,
      tabIndex: 0,
      onPointerDown: arrastar,
      onKeyDown: teclaDivisoria,
      className: "or-divisoria"
    },
    /* @__PURE__ */ React.createElement("div", { className: "or-divisoria__traco" })
  ), /* @__PURE__ */ React.createElement("div", { className: "or-grade__dir" }, /* @__PURE__ */ React.createElement(
    window.OrderretrieverDocumento,
    {
      enc,
      selecionado,
      onSelecionar: selecionar,
      pagina,
      onPagina: (n) => setSel(selecionado, n),
      zoom,
      onZoom: (z) => window.HubRouter.setParams({ zoom: z }),
      onAbrir: abrir
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "panel or-rodape", "aria-busy": ocupado ? true : void 0 }, /* @__PURE__ */ React.createElement("div", { className: "or-rodape__estado" }, aFazer && /* @__PURE__ */ React.createElement("span", { role: "status" }, aFazer), !aFazer && sujo && /* @__PURE__ */ React.createElement("span", { className: "muted", role: "status" }, "Altera\xE7\xF5es por gravar"), erroAcao && /* @__PURE__ */ React.createElement("span", { className: "or-erro", role: "alert" }, erroAcao.campo ? `Corrige o campo assinalado: ${erroAcao.mensagem}` : erroAcao.mensagem), !aFazer && !sujo && !erroAcao && /* @__PURE__ */ React.createElement("span", { className: "muted or-atalhos" }, "Atalhos: ", /* @__PURE__ */ React.createElement("kbd", null, "A"), " aprovar \xB7 ", /* @__PURE__ */ React.createElement("kbd", null, "R"), " rejeitar \xB7 ", /* @__PURE__ */ React.createElement("kbd", null, "S"), " seguinte por validar")), /* @__PURE__ */ React.createElement("div", { className: "or-rodape__acoes" }, validarPhc && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: ocupado || aPhc,
      onClick: reprocessarPhc,
      "aria-busy": aPhc ? true : void 0,
      title: "Volta a conferir as linhas no PHC agora, sem a cache (n\xE3o l\xEA o documento com a IA)"
    },
    aPhc ? "A validar no PHC\u2026" : "Reprocessar PHC"
  ), !decidida && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: ocupado || aLer,
      onClick: pedirReprocessar,
      "aria-busy": aReprocessar || aLer && lancadaAqui ? true : void 0,
      title: "L\xEA outra vez o documento com a IA (tem custo); depois volta a validar no PHC"
    },
    aReprocessar || aLer ? "A reprocessar\u2026" : "Reprocessar IA"
  ), editavel && porUsar > 0 && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: ocupado,
      onClick: usarCalculadas,
      title: "A Quantidade de cada linha passa a ser a calculada pela programa\xE7\xE3o mensal; o pedido fica guardado e podes corrigir \xE0 m\xE3o"
    },
    "Usar as quantidades calculadas"
  ), editavel && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: !sujo || ocupado, onClick: gravar }, aGravar === "gravar" ? "A gravar\u2026" : "Gravar altera\xE7\xF5es"), podeRejeitar && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: !!aGravar || aReprocessar,
      onClick: () => setARejeitar(true),
      title: "Atalho: R",
      "aria-keyshortcuts": "R"
    },
    "Rejeitar\u2026"
  ), editavel && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn primary sm",
      disabled: ocupado || enc.cliente_no == null || linhas.length === 0,
      title: enc.cliente_no == null ? "Escolhe o cliente antes de aprovar" : "Atalho: A",
      "aria-keyshortcuts": "A",
      onClick: aprovar
    },
    aGravar === "aprovar" ? "A gerar\u2026" : "Aprovar e gerar Excel"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: decidida ? "btn primary sm" : "btn ghost sm",
      disabled: aProcurar || !!aGravar,
      onClick: seguinte,
      title: "A seguinte por validar, com os filtros da lista (atalho: S)",
      "aria-keyshortcuts": "S"
    },
    aProcurar ? "A procurar\u2026" : "Seguinte por validar \u2192"
  ))), fichaAberta && (fichaAberta.k === "cabecalho" || linhas.some((l) => l._k === fichaAberta.k)) && (() => {
    const n = linhas.findIndex((l) => l._k === fichaAberta.k);
    const ficha = fichaAberta.k === "cabecalho" ? F.fichaDoCabecalho({ validacao, header }) : F.fichaDaLinha({ validacao, n, linha: linhas[n], enc });
    const avisoFicha = !validarPhc ? "A confer\xEAncia com o PHC s\xF3 corre nas encomendas por validar." : !validacao ? "A conferir no PHC\u2026" : validacao.indisponivel ? "Valida\xE7\xE3o PHC indispon\xEDvel \u2014 s\xF3 a leitura da IA." : "";
    return /* @__PURE__ */ React.createElement(
      window.OrderretrieverFicha,
      {
        ficha,
        tema: fichaAberta.tema,
        aviso: avisoFicha,
        onTema: (t) => setFichaAberta((f) => f ? { ...f, tema: t } : f),
        navList: fichaAberta.k === "cabecalho" ? [] : linhasDados.map((r) => ({ id: r._k })),
        currentId: fichaAberta.k,
        onNavigate: (o) => setFichaAberta((f) => ({ k: o.id, tema: f && f.tema })),
        onVerNoDocumento: (caminho) => {
          setFichaAberta(null);
          setSel(caminho, orPaginaDe(enc.realces, caminho) || pagina);
        },
        onClose: () => setFichaAberta(null)
      }
    );
  })());
}
window.OrderretrieverEncomenda = OrderretrieverEncomenda;

// ===== orderretriever/frontend/orderretriever_triagem.jsx =====
function OrderretrieverRejeitarLote({ ids, onFeito, onFechar }) {
  const API = window.OrderretrieverAPI;
  const [motivos, setMotivos] = React.useState(null);
  const [motivo, setMotivo] = React.useState("");
  const [nota, setNota] = React.useState("");
  const [aGravar, setAGravar] = React.useState(false);
  const [resultado, setResultado] = React.useState(null);
  const n = ids.length;
  React.useEffect(() => {
    API.motivos().then((r) => setMotivos((r || []).filter((m) => m.is_active))).catch(() => setMotivos([]));
  }, [API]);
  const rejeitar = () => {
    if (!motivo) {
      window.srToast?.("Escolhe o motivo.", "warning");
      return;
    }
    setAGravar(true);
    API.rejeitarEmLote(ids, Number(motivo), nota).then((r) => {
      const ok = (r.rejeitadas || []).length;
      const nao = r.recusadas || [];
      window.srToast?.(`${ok} ${ok === 1 ? "encomenda rejeitada" : "encomendas rejeitadas"}.`, "success");
      if (nao.length) setResultado(r);
      else onFeito(r);
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel rejeitar."), "error")).finally(() => setAGravar(false));
  };
  if (resultado) {
    return /* @__PURE__ */ React.createElement(OrderretrieverResumoLote, { resultado, onFechar: () => onFeito(resultado) });
  }
  const rodape = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost", onClick: onFechar }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger", disabled: aGravar || !motivo, onClick: rejeitar }, aGravar ? "A rejeitar\u2026" : `Rejeitar ${n}`));
  return /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: `Rejeitar ${n} ${n === 1 ? "encomenda" : "encomendas"}`,
      onClose: onFechar,
      footer: rodape,
      width: 440
    },
    /* @__PURE__ */ React.createElement("div", { className: "or-campos" }, motivos === null && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "A carregar os motivos\u2026"), motivos && motivos.length === 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "N\xE3o h\xE1 motivos ativos \u2014 acrescenta-os em Defini\xE7\xF5es \u203A Motivos de rejei\xE7\xE3o."), motivos && motivos.length > 0 && /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Motivo", /* @__PURE__ */ React.createElement("select", { "aria-label": "Motivo", value: motivo, onChange: (e) => setMotivo(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"), motivos.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.label)))), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Nota (opcional)", /* @__PURE__ */ React.createElement("textarea", { "aria-label": "Nota", rows: 3, value: nota, onChange: (e) => setNota(e.target.value) })), /* @__PURE__ */ React.createElement("span", { className: "muted" }, "As que j\xE1 foram decididas entretanto ficam de fora. Um email que fique sem nada por decidir vai para a pasta ERROR (s\xF3 em modo ativo)."))
  );
}
function OrderretrieverResumoLote({ resultado, onFechar }) {
  const ok = (resultado.rejeitadas || []).length;
  const recusadas = resultado.recusadas || [];
  const rodape = /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn", onClick: onFechar }, "Fechar");
  return /* @__PURE__ */ React.createElement(window.ModalShell, { title: "Rejei\xE7\xE3o em lote", onClose: onFechar, footer: rodape, width: 480 }, /* @__PURE__ */ React.createElement("div", { className: "or-campos" }, /* @__PURE__ */ React.createElement("span", null, ok, " ", ok === 1 ? "encomenda rejeitada" : "encomendas rejeitadas", ";", " ", recusadas.length, " ", recusadas.length === 1 ? "ficou de fora" : "ficaram de fora", ":"), /* @__PURE__ */ React.createElement("ul", { className: "or-resumo-lote" }, recusadas.map((x) => /* @__PURE__ */ React.createElement("li", { key: x.id }, /* @__PURE__ */ React.createElement("span", { className: "mono" }, "#", x.id), " \u2014 ", x.motivo)))));
}
window.OrderretrieverRejeitarLote = OrderretrieverRejeitarLote;

// ===== orderretriever/frontend/orderretriever.jsx =====
const OR_FILTROS = ["estado", "triagem", "sac", "cliente", "de", "ate"];
const OR_PAGE_SIZE = 50;
function orIntOr(v, dflt) {
  const n = parseInt(v, 10);
  return Number.isFinite(n) && n > 0 ? n : dflt;
}
function orParseSort(raw) {
  if (!raw) return [];
  return raw.split(",").filter(Boolean).map((k) => ({
    key: k.replace(/^-/, ""),
    dir: k.startsWith("-") ? "desc" : "asc"
  }));
}
function orLerParams(params) {
  const p = params && typeof params.get === "function" ? params : window.HubRouter.current().params;
  return {
    filtros: window.OrderretrieverAPI.filtrosIniciais(p, OR_FILTROS),
    page: orIntOr(p.get("page"), 1),
    pageSize: orIntOr(p.get("pageSize"), OR_PAGE_SIZE),
    sort: orParseSort(p.get("sort"))
  };
}
const OR_LIMPOS = { estado: "todos", triagem: "", sac: "todos", cliente: "", de: "", ate: "" };
function OrderretrieverFiltros({ filtros, opcoes, onChange }) {
  const [cliente, setCliente] = React.useState(filtros.cliente);
  React.useEffect(() => {
    setCliente(filtros.cliente);
  }, [filtros.cliente]);
  React.useEffect(() => {
    if (cliente === filtros.cliente) return void 0;
    const t = setTimeout(() => onChange({ cliente }), 300);
    return () => clearTimeout(t);
  }, [cliente]);
  const API = window.OrderretrieverAPI;
  const { ChipFilter, Clear } = window.HubList;
  const chip = (chave, unica) => {
    const atual = API.conjuntoDoFiltro(filtros[chave]);
    return {
      value: atual,
      setValue: (f) => {
        const novo = typeof f === "function" ? f(atual) : f;
        onChange({ [chave]: unica ? API.escolhaUnica(atual, novo) : API.filtroDoConjunto(novo) });
      }
    };
  };
  return /* @__PURE__ */ React.createElement("div", { className: "filters or-filtros" }, /* @__PURE__ */ React.createElement("div", { className: "search-input or-filtros__cliente" }, /* @__PURE__ */ React.createElement(Ico.search, null), /* @__PURE__ */ React.createElement(
    "input",
    {
      "aria-label": "Cliente",
      type: "text",
      value: cliente,
      placeholder: "Cliente: nome, n\xBA, NIF ou email",
      onChange: (e) => setCliente(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(ChipFilter, { label: "Estado", ...chip("estado"), options: opcoes.estados || [] }), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "SAC",
      ...chip("sac"),
      options: [{ value: "eu", label: "As minhas" }, ...opcoes.sacs || []]
    }
  ), /* @__PURE__ */ React.createElement(ChipFilter, { label: "Triagem", ...chip("triagem", true), options: opcoes.triagens || [] }), /* @__PURE__ */ React.createElement("label", { className: "or-filtro" }, "De", /* @__PURE__ */ React.createElement(
    "input",
    {
      "aria-label": "De",
      type: "date",
      value: filtros.de,
      onChange: (e) => onChange({ de: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "or-filtro" }, "At\xE9", /* @__PURE__ */ React.createElement(
    "input",
    {
      "aria-label": "At\xE9",
      type: "date",
      value: filtros.ate,
      onChange: (e) => onChange({ ate: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement(Clear, { active: API.filtrosAtivosN(filtros), onClear: () => onChange(OR_LIMPOS) }));
}
function OrderretrieverVazio({ comFiltros, onLimpar }) {
  if (!comFiltros) return "Ainda n\xE3o chegou nenhuma encomenda.";
  return /* @__PURE__ */ React.createElement("span", { className: "or-vazio" }, "Nenhuma encomenda com estes filtros.", /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onLimpar }, "Limpar filtros"));
}
function OrderretrieverContadores({ contadores, estados, estado, onChange }) {
  if (!contadores) return null;
  const rotulo = Object.fromEntries((estados || []).map((o) => [o.value, o.label]));
  const { EstadoBadge } = window.OrderretrieverUtil;
  return /* @__PURE__ */ React.createElement("span", { role: "group", "aria-label": "Contadores por estado", className: "or-contadores" }, Object.entries(contadores).map(([valor, n]) => ({ estado: valor, n })).map((c) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: c.estado,
      type: "button",
      "aria-pressed": estado === c.estado,
      className: `btn ghost sm or-contador${estado === c.estado ? " is-ativo" : ""}`,
      title: `Mostrar s\xF3 \xAB${rotulo[c.estado] || c.estado}\xBB`,
      onClick: () => onChange({ estado: c.estado })
    },
    /* @__PURE__ */ React.createElement(EstadoBadge, { estado: c.estado, label: rotulo[c.estado] }),
    " ",
    c.n
  )));
}
function OrderretrieverFaixaIA({ podeValidar }) {
  const [faixa, setFaixa] = React.useState(null);
  const [aLancar, setALancar] = React.useState(false);
  const reler = () => window.OrderretrieverAPI.faixaIa().then(setFaixa).catch(() => {
  });
  React.useEffect(() => {
    let vivo = true;
    const ler = () => window.OrderretrieverAPI.faixaIa().then((f) => {
      if (vivo) setFaixa(f);
    }).catch(() => {
    });
    ler();
    const t = setInterval(ler, 6e4);
    return () => {
      vivo = false;
      clearInterval(t);
    };
  }, []);
  if (!faixa) return null;
  const indisponivel = !!faixa.indisponivel_desde;
  const paradas = faixa.com_erro_ia || 0;
  if (!indisponivel && !faixa.suspensa && !(podeValidar && paradas)) return null;
  const { dataHora, Aviso } = window.OrderretrieverUtil;
  const aEspera = `${faixa.a_espera} ${faixa.a_espera === 1 ? "encomenda \xE0 espera" : "encomendas \xE0 espera"}`;
  const reprocessarTodas = () => {
    setALancar(true);
    window.OrderretrieverAPI.reprocessarComErro().then((r) => window.srToast?.(r.marcadas ? `${r.marcadas} ${r.marcadas === 1 ? "encomenda volta" : "encomendas voltam"} a ser lidas \u2014 o resultado aparece na lista.` : "N\xE3o h\xE1 encomendas paradas pela IA.", "success")).catch((e) => window.srToast?.(window.OrderretrieverAPI.erroDRF(e, "N\xE3o foi poss\xEDvel reprocessar."), "error")).finally(() => {
      setALancar(false);
      reler();
    });
  };
  const botao = podeValidar && paradas > 0 && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm or-faixa__botao",
      disabled: aLancar,
      onClick: reprocessarTodas
    },
    aLancar ? "A pedir\u2026" : "Reprocessar todas"
  );
  if (faixa.suspensa) {
    return /* @__PURE__ */ React.createElement(Aviso, { tipo: "info" }, "IA suspensa: atingiu o limite di\xE1rio de ", Number(faixa.custo_maximo_dia).toFixed(2), " \u20AC", " ", "(hoje ", Number(faixa.custo_hoje).toFixed(2), " \u20AC) \u2014 ", aEspera, ".");
  }
  if (!indisponivel) {
    return /* @__PURE__ */ React.createElement(Aviso, { tipo: "info" }, paradas, " ", paradas === 1 ? "encomenda parada" : "encomendas paradas", " por a IA ter falhado", " ", "\u2014 reprocessar para voltar a ler.", botao);
  }
  return /* @__PURE__ */ React.createElement(Aviso, { tipo: "erro", title: faixa.mensagem || void 0 }, "IA indispon\xEDvel desde ", dataHora(faixa.indisponivel_desde), faixa.codigo ? ` (erro ${faixa.codigo})` : "", " \u2014 ", aEspera, ".", botao);
}
function OrderretrieverFaixaPoller() {
  const [faixa, setFaixa] = React.useState(null);
  React.useEffect(() => {
    let vivo = true;
    const ler = () => window.OrderretrieverAPI.faixaPoller().then((f) => {
      if (vivo) setFaixa(f);
    }).catch(() => {
    });
    ler();
    const t = setInterval(ler, 6e4);
    return () => {
      vivo = false;
      clearInterval(t);
    };
  }, []);
  if (!faixa || !faixa.estado) return null;
  const { dataHora, Aviso } = window.OrderretrieverUtil;
  const quando = faixa.ultima_corrida_em ? dataHora(faixa.ultima_corrida_em) : null;
  const motivo = (faixa.mensagem || "").split("\n")[0].slice(0, 160);
  if (faixa.estado === "parcial") {
    const n = faixa.com_erro || 0;
    return /* @__PURE__ */ React.createElement(Aviso, { tipo: "info", title: faixa.mensagem || void 0 }, "A leitura de emails est\xE1 a correr, mas a \xFAltima volta (em ", quando, ") n\xE3o guardou", " ", n === 1 ? "1 mensagem" : `${n} mensagens`, motivo ? `: ${motivo}` : "", ".");
  }
  return /* @__PURE__ */ React.createElement(Aviso, { tipo: "erro", title: faixa.mensagem || void 0 }, faixa.estado === "parado" ? /* @__PURE__ */ React.createElement(React.Fragment, null, "Leitura de emails parada \u2014 ", quando ? `a \xFAltima volta do poller foi em ${quando}` : "o poller ainda n\xE3o correu", ". Encomendas novas n\xE3o est\xE3o a entrar.") : /* @__PURE__ */ React.createElement(React.Fragment, null, "Leitura de emails a falhar (\xFAltima tentativa em ", quando, ")", motivo ? `: ${motivo}` : "", ". Encomendas novas n\xE3o est\xE3o a entrar."));
}
function OrderretrieverLista({ params, navigate, routeId }) {
  const inicial = React.useMemo(() => orLerParams(params), []);
  const [filtros, setFiltros] = React.useState(inicial.filtros);
  const [viewState, setViewState] = React.useState({
    page: inicial.page,
    pageSize: inicial.pageSize,
    sort: inicial.sort
  });
  const [opcoes, setOpcoes] = React.useState({ estados: [], triagens: [], sacs: [] });
  const [refetch, setRefetch] = React.useState(0);
  const [aoVivo, setAoVivo] = React.useState(false);
  const [selecao, setSelecao] = React.useState(() => /* @__PURE__ */ new Set());
  const [aRejeitar, setARejeitar] = React.useState(false);
  const [contadores, setContadores] = React.useState(null);
  const { EstadoBadge, dataHora } = window.OrderretrieverUtil;
  React.useEffect(() => {
    window.OrderretrieverAPI.opcoes().then(setOpcoes).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar os filtros.", "error"));
  }, []);
  React.useEffect(() => {
    window.HubRouter.setParams({
      ...filtros,
      page: viewState.page > 1 ? String(viewState.page) : null,
      pageSize: viewState.pageSize !== OR_PAGE_SIZE ? String(viewState.pageSize) : null,
      sort: viewState.sort.length ? viewState.sort.map((s) => (s.dir === "desc" ? "-" : "") + s.key).join(",") : null
    });
  }, [filtros, viewState]);
  React.useEffect(() => {
    let t = null;
    const parar = window.OrderretrieverAPI.ligarFila({
      onMudou: () => {
        clearTimeout(t);
        t = setTimeout(() => setRefetch((n) => n + 1), 400);
      },
      onEstado: setAoVivo
    });
    return () => {
      clearTimeout(t);
      parar();
    };
  }, []);
  const mudarFiltros = (patch) => setFiltros((f) => ({ ...f, ...patch }));
  const limparFiltros = () => mudarFiltros(OR_LIMPOS);
  const columns = [
    {
      key: "recebido_em",
      label: "Chegada",
      width: 140,
      fixed: true,
      sortKey: "email__recebido_em",
      render: (r) => dataHora(r.recebido_em)
    },
    // #305: num reencaminhado pelo SAC, a data do email original; sem ela,
    // o servidor põe-na no fim nos dois sentidos.
    {
      key: "enviado_original_em",
      label: "Enviado pelo cliente",
      width: 150,
      sortKey: "email__enviado_original_em",
      render: (r) => r.enviado_original_em ? dataHora(r.enviado_original_em) : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    {
      key: "cliente_nome",
      label: "Cliente",
      width: 240,
      sortKey: "cliente_nome",
      render: (r) => r.cliente_nome ? r.cliente_nome : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Por identificar")
    },
    { key: "cliente_no", label: "N\xBA cliente", width: 90, mono: true, sortKey: "cliente_no" },
    {
      key: "sac_label",
      label: "SAC",
      width: 140,
      sortKey: "sac_nome",
      render: (r) => r.sac_label || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    {
      key: "numero",
      label: "N\xBA encomenda",
      width: 130,
      mono: true,
      sortKey: "numero",
      render: (r) => r.numero || /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    // Remetente, Assunto e Documento escondidos por omissão (voltam no ⚙):
    // treze colunas não cabiam, e quem valida decide pelo cliente e estado.
    // Lidos do JSON da IA: não há coluna na base por onde ordenar no servidor.
    {
      key: "n_linhas",
      label: "Linhas",
      width: 70,
      sortable: false,
      render: (r) => r.n_linhas == null ? /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014") : r.n_linhas
    },
    {
      key: "n_avisos",
      label: "Avisos",
      width: 80,
      sortable: false,
      render: (r) => r.n_avisos ? /* @__PURE__ */ React.createElement("span", { className: "or-alerta" }, "\u26A0 ", r.n_avisos) : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    { key: "remetente", label: "Remetente", width: 220, sortKey: "email__remetente", hidden: true },
    { key: "assunto", label: "Assunto", width: 260, sortable: false, hidden: true },
    { key: "origem", label: "Documento", width: 180, sortable: false, hidden: true },
    {
      key: "estado",
      label: "Estado",
      width: 150,
      sortKey: "estado",
      render: (r) => /* @__PURE__ */ React.createElement(EstadoBadge, { estado: r.estado, label: r.estado_label })
    },
    // Rótulos de triagem (spec §4): avisos, não estados — não bloqueiam nada.
    {
      key: "rotulos",
      label: "R\xF3tulos",
      width: 200,
      sortable: false,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "or-rotulos" }, r.duplicada && /* @__PURE__ */ React.createElement("span", { className: "pill or-rotulo", title: window.OrderretrieverAPI.textoDuplicada(r.duplicada) }, "duplicada?"), r.e_encomenda === false && /* @__PURE__ */ React.createElement("span", { className: "pill or-rotulo" }, "n\xE3o \xE9 encomenda?"))
    }
  ];
  const filtrosAtivos = window.OrderretrieverAPI.filtrosParaApi(filtros);
  const semEstado = JSON.stringify({ ...filtrosAtivos, estado: void 0 });
  React.useEffect(() => {
    let vivo = true;
    window.OrderretrieverAPI.contadores(JSON.parse(semEstado)).then((c) => {
      if (vivo) setContadores(c);
    }).catch(() => {
    });
    return () => {
      vivo = false;
    };
  }, [semEstado, refetch]);
  return /* @__PURE__ */ React.createElement("div", { className: "or-vista" }, /* @__PURE__ */ React.createElement(OrderretrieverFaixaPoller, null), /* @__PURE__ */ React.createElement(OrderretrieverFaixaIA, { podeValidar: !!opcoes.pode_validar }), /* @__PURE__ */ React.createElement(OrderretrieverFiltros, { filtros, opcoes, onChange: mudarFiltros }), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Encomendas",
      toolbar: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: aoVivo ? "or-vivo" : "or-vivo muted",
          title: aoVivo ? "A lista atualiza-se sozinha quando chega ou muda uma encomenda." : "Sem liga\xE7\xE3o ao vivo \u2014 a lista atualiza com F5."
        },
        aoVivo ? "\u25CF ao vivo" : "\u25CB sem liga\xE7\xE3o ao vivo"
      ), /* @__PURE__ */ React.createElement(
        OrderretrieverContadores,
        {
          contadores,
          estados: opcoes.estados,
          estado: filtros.estado,
          onChange: mudarFiltros
        }
      ), opcoes.pode_validar && selecao.size > 0 && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger sm", onClick: () => setARejeitar(true) }, "Rejeitar ", selecao.size, " ", selecao.size === 1 ? "selecionada" : "selecionadas", "\u2026")),
      columns,
      fetch: (q) => window.OrderretrieverAPI.encomendas({
        page: q.page,
        pageSize: q.pageSize,
        ordering: q.ordering,
        filtros: filtrosAtivos
      }),
      fetchDeps: [JSON.stringify(filtrosAtivos)],
      refetchToken: refetch,
      selectable: !!opcoes.pode_validar,
      selection: selecao,
      onSelection: setSelecao,
      pagination: "server",
      rowKey: (r) => r.id,
      onRowClick: (r) => navigate({ routeId, entidade: String(r.id), params: window.HubRouter.current().params }),
      initialPage: inicial.page,
      initialPageSize: inicial.pageSize,
      initialSort: inicial.sort,
      onViewState: setViewState,
      empty: /* @__PURE__ */ React.createElement(
        OrderretrieverVazio,
        {
          comFiltros: Object.keys(filtrosAtivos).length > 0,
          onLimpar: limparFiltros
        }
      ),
      appLabel: "orderretriever",
      viewId: "fila"
    }
  ), aRejeitar && /* @__PURE__ */ React.createElement(
    window.OrderretrieverRejeitarLote,
    {
      ids: [...selecao],
      onFechar: () => setARejeitar(false),
      onFeito: () => {
        setARejeitar(false);
        setSelecao(/* @__PURE__ */ new Set());
        setRefetch((n) => n + 1);
      }
    }
  ));
}
function OrderretrieverView({ routeId = "orderretriever", entidade, params, navigate, reportCrumb, registerLeaveGuard } = {}) {
  const nav = navigate || ((to) => window.HubRouter.navigate(to));
  if (entidade) {
    return /* @__PURE__ */ React.createElement(
      window.OrderretrieverEncomenda,
      {
        id: entidade,
        routeId,
        params,
        navigate: nav,
        reportCrumb,
        registerLeaveGuard
      }
    );
  }
  return /* @__PURE__ */ React.createElement(OrderretrieverLista, { params, navigate: nav, routeId });
}
window.OrderretrieverView = OrderretrieverView;

// ===== orderretriever/frontend/orderretriever_ligacao_ao_graph.jsx =====
function OrderretrieverEstadoLinha({ titulo, em, ok, msg }) {
  const { dataHora } = window.OrderretrieverUtil;
  const classe = ok == null ? "muted" : ok ? "or-ok" : "or-erro";
  return /* @__PURE__ */ React.createElement("div", { className: "or-estado-linha" }, /* @__PURE__ */ React.createElement("strong", null, titulo, ": "), /* @__PURE__ */ React.createElement("span", { className: classe }, em ? `${ok ? "OK" : "falhou"} \xB7 ${dataHora(em)}` : "nunca"), msg && /* @__PURE__ */ React.createElement("div", { className: "muted or-pequeno or-pre" }, msg));
}
function OrderretrieverLigacaoaographView() {
  const [cfg, setCfg] = React.useState(null);
  const [secret, setSecret] = React.useState("");
  const [aGravar, setAGravar] = React.useState(false);
  const [aTestar, setATestar] = React.useState(false);
  const [teste, setTeste] = React.useState(null);
  const API = window.OrderretrieverAPI;
  const carregar = React.useCallback(() => API.graph().then(setCfg).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar a liga\xE7\xE3o.", "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  if (!cfg) return /* @__PURE__ */ React.createElement("div", { className: "muted or-carregar" }, "A carregar\u2026");
  const set = (k) => (e) => setCfg({
    ...cfg,
    [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  });
  function gravar() {
    setAGravar(true);
    const dias = parseInt(cfg.dias_retroativos, 10);
    API.gravarGraph({
      tenant_id: cfg.tenant_id,
      client_id: cfg.client_id,
      caixa: cfg.caixa,
      pasta_sombra: cfg.pasta_sombra,
      ativo: cfg.ativo,
      dias_retroativos: Number.isFinite(dias) && dias >= 0 ? dias : 7,
      ...secret ? { client_secret: secret } : {}
    }).then((r) => {
      setCfg(r);
      setSecret("");
      window.srToast?.("Liga\xE7\xE3o gravada.", "success");
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar."), "error")).finally(() => setAGravar(false));
  }
  function testar() {
    setATestar(true);
    API.testarGraph().then((r) => setTeste(r)).catch((e) => setTeste({ ok: false, mensagem: API.erroDRF(e, "O teste falhou."), pastas: [] })).finally(() => {
      setATestar(false);
      carregar();
    });
  }
  const campo = (rotulo, k, extra = {}) => /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, rotulo, /* @__PURE__ */ React.createElement("input", { type: "text", value: cfg[k] ?? "", onChange: set(k), ...extra }));
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina or-pagina--estreita" }, /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Liga\xE7\xE3o ao Microsoft Graph")), /* @__PURE__ */ React.createElement("p", { className: "muted or-nota" }, "Modo ", /* @__PURE__ */ React.createElement("strong", null, "sombra"), ": o hub s\xF3 l\xEA a pasta indicada (as encomendas que o servi\xE7o antigo j\xE1 tratou). Nunca move, apaga nem marca emails como lidos. O modo (sombra/ativo) escolhe-se em Defini\xE7\xF5es \u203A Sa\xEDda e modo."), /* @__PURE__ */ React.createElement("div", { className: "or-campos" }, campo("Tenant ID", "tenant_id", { autoComplete: "off" }), campo("Client ID", "client_id", { autoComplete: "off" }), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Client secret", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: secret,
      autoComplete: "new-password",
      placeholder: cfg.tem_secret ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (guardado \u2014 deixa vazio para manter)" : "por preencher",
      onChange: (e) => setSecret(e.target.value)
    }
  )), campo("Caixa de correio", "caixa", { placeholder: "donotreply@\u2026" }), campo("Pasta lida em modo sombra", "pasta_sombra"), campo("Janela de leitura: dias para tr\xE1s (em cada volta)", "dias_retroativos", { type: "number", min: 0 }), /* @__PURE__ */ React.createElement("label", { className: "or-caixa" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!cfg.ativo, onChange: set("ativo") }), "Ativo \u2014 o poller (", /* @__PURE__ */ React.createElement("code", null, "orderretriever_poll"), ") l\xEA a caixa")), /* @__PURE__ */ React.createElement("div", { className: "or-acoes or-formulario--topo" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", disabled: aGravar, onClick: gravar }, aGravar ? "A gravar\u2026" : "Gravar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: aTestar, onClick: testar }, aTestar ? "A testar\u2026" : "Testar liga\xE7\xE3o")), teste && /* @__PURE__ */ React.createElement("div", { role: "status", className: "or-teste" }, /* @__PURE__ */ React.createElement("strong", { className: teste.ok ? "or-ok" : "or-erro" }, teste.mensagem), /* @__PURE__ */ React.createElement("ul", { className: "or-teste__pastas" }, (teste.pastas || []).map((p) => /* @__PURE__ */ React.createElement("li", { key: p.nome }, p.nome, p.nome_real && p.nome_real !== p.nome ? ` (\xAB${p.nome_real}\xBB)` : "", ":", " ", p.encontrada ? `encontrada (${p.total ?? "?"} emails)` : "n\xE3o encontrada"))))), /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Estado")), /* @__PURE__ */ React.createElement(
    OrderretrieverEstadoLinha,
    {
      titulo: "\xDAltimo teste",
      em: cfg.ultimo_teste_em,
      ok: cfg.ultimo_teste_ok,
      msg: cfg.ultimo_teste_msg
    }
  ), /* @__PURE__ */ React.createElement(
    OrderretrieverEstadoLinha,
    {
      titulo: "\xDAltima corrida do poller",
      em: cfg.ultima_corrida_em,
      ok: cfg.ultima_corrida_ok,
      msg: cfg.ultima_corrida_msg
    }
  )));
}
window.OrderretrieverLigacaoaographView = OrderretrieverLigacaoaographView;

// ===== orderretriever/frontend/orderretriever_motivos_de_rejeicao.jsx =====
function OrderretrieverMotivosderejeicaoView() {
  const VAZIO = { label: "", ordem: 100, is_active: true };
  const API = window.OrderretrieverAPI;
  const [itens, setItens] = React.useState([]);
  const [draft, setDraft] = React.useState(VAZIO);
  const [editId, setEditId] = React.useState(null);
  const carregar = React.useCallback(() => API.motivos().then((r) => setItens(r || [])).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar os motivos.", "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const cancelar = () => {
    setDraft(VAZIO);
    setEditId(null);
  };
  const gravar = () => {
    if (!draft.label.trim()) {
      window.srToast?.("Indica o motivo.", "warning");
      return;
    }
    const ordem = Number.isFinite(Number(draft.ordem)) ? Number(draft.ordem) : 100;
    const d = { label: draft.label.trim(), ordem, is_active: !!draft.is_active };
    (editId ? API.editarMotivo(editId, d) : API.criarMotivo(d)).then(() => {
      cancelar();
      return carregar();
    }).then(() => window.srToast?.("Gravado.", "success")).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar."), "error"));
  };
  const apagar = async (r) => {
    const ok = await window.hubConfirm({ title: "Apagar motivo", message: `Apagar \xAB${r.label}\xBB?`, confirmLabel: "Apagar" });
    if (!ok) return;
    API.apagarMotivo(r.id).then(() => carregar()).then(() => window.srToast?.("Apagado.", "success")).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel apagar."), "error"));
  };
  const columns = [
    { key: "label", label: "Motivo", width: 260, fixed: true },
    { key: "ordem", label: "Ordem", width: 90 },
    {
      key: "is_active",
      label: "Ativo",
      width: 80,
      sortValue: (r) => r.is_active ? 1 : 0,
      render: (r) => r.is_active ? "Sim" : "N\xE3o"
    },
    { key: "acoes", label: "", sortable: false, width: 170, render: (r) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => {
      setEditId(r.id);
      setDraft({ ...r });
    } }, "Editar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger sm", onClick: () => apagar(r) }, "Apagar")) }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina" }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Motivos de rejei\xE7\xE3o",
      appLabel: "orderretriever",
      viewId: "motivos",
      columns,
      data: itens,
      pagination: "none",
      rowKey: (r) => r.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-formulario" }, /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Motivo", /* @__PURE__ */ React.createElement("input", { type: "text", value: draft.label, onChange: (e) => setDraft({ ...draft, label: e.target.value }) })), /* @__PURE__ */ React.createElement("label", { className: "or-campo or-campo--numero" }, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.ordem,
      onChange: (e) => setDraft({ ...draft, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "or-caixa" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_active,
      onChange: (e) => setDraft({ ...draft, is_active: e.target.checked })
    }
  ), " Ativo"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: gravar }, editId ? "Guardar" : "Adicionar"), editId && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: cancelar }, "Cancelar")));
}
window.OrderretrieverMotivosderejeicaoView = OrderretrieverMotivosderejeicaoView;

// ===== orderretriever/frontend/orderretriever_mapa_sac.jsx =====
const OUTRO = "__outro__";
function OrderretrieverMapasacView() {
  const API = window.OrderretrieverAPI;
  const [itens, setItens] = React.useState([]);
  const [porMapear, setPorMapear] = React.useState([]);
  const [nomesPhc, setNomesPhc] = React.useState(null);
  const [phcErro, setPhcErro] = React.useState("");
  const [outro, setOutro] = React.useState(false);
  const [users, setUsers] = React.useState([]);
  const [draft, setDraft] = React.useState({ naturalid: "", user: "" });
  const [editId, setEditId] = React.useState(null);
  const carregar = React.useCallback(() => Promise.all([
    API.mapaSac(),
    API.porMapear(),
    API.nomesPhc().then((n) => {
      setPhcErro("");
      return n || [];
    }).catch((e) => {
      setPhcErro(API.erroDRF(e, "PHC indispon\xEDvel."));
      return null;
    })
  ]).then(([m, p, n]) => {
    setItens(m || []);
    setPorMapear(p || []);
    setNomesPhc(n);
  }).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar o mapa.", "error")), [API]);
  React.useEffect(() => {
    carregar();
    API.utilizadores().then(setUsers).catch(() => {
    });
  }, [carregar, API]);
  const cancelar = () => {
    setDraft({ naturalid: "", user: "" });
    setEditId(null);
    setOutro(false);
  };
  const doPhc = (nome) => (nomesPhc || []).some((n) => n.naturalid === nome);
  const escolher = (nome, id = null, user = "") => {
    setEditId(id);
    setDraft({ naturalid: nome, user });
    setOutro(!!nome && !doPhc(nome));
  };
  const faltam = nomesPhc ? nomesPhc.filter((n) => !n.mapeado).map((n) => ({ naturalid: n.naturalid, conta: n.clientes })) : porMapear.map((p) => ({ naturalid: p.naturalid, conta: p.encomendas }));
  const gravar = () => {
    if (!draft.naturalid.trim() || !draft.user) {
      window.srToast?.("Indica o nome no PHC e o utilizador.", "warning");
      return;
    }
    const d = { naturalid: draft.naturalid.trim(), user: Number(draft.user) };
    (editId ? API.editarMapa(editId, d) : API.criarMapa(d)).then(() => {
      cancelar();
      return carregar();
    }).then(() => window.srToast?.("Gravado.", "success")).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar."), "error"));
  };
  const apagar = async (r) => {
    const ok = await window.hubConfirm({
      title: "Apagar do mapa",
      message: `Apagar \xAB${r.naturalid}\xBB \u2192 ${r.user_nome}?`,
      confirmLabel: "Apagar"
    });
    if (!ok) return;
    API.apagarMapa(r.id).then(() => carregar()).then(() => window.srToast?.("Apagado.", "success")).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel apagar."), "error"));
  };
  const columns = [
    { key: "naturalid", label: "Nome no PHC", width: 200, fixed: true },
    { key: "user_nome", label: "Utilizador do hub", width: 240 },
    { key: "acoes", label: "", sortable: false, width: 170, render: (r) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        onClick: () => escolher(r.naturalid, r.id, String(r.user))
      },
      "Editar"
    ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger sm", onClick: () => apagar(r) }, "Apagar")) }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina" }, faltam.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "panel or-painel", "aria-label": "Por mapear" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Por mapear")), /* @__PURE__ */ React.createElement("div", { className: "muted or-nota or-paragrafo" }, nomesPhc ? "Nomes de respons\xE1vel no PHC (clientes ativos) que ainda n\xE3o t\xEAm utilizador \u2014 as encomendas desses clientes ficam sem SAC." : "Nomes que chegaram em encomendas e ainda n\xE3o t\xEAm utilizador \u2014 essas encomendas ficam sem SAC."), faltam.map((p) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: p.naturalid,
      type: "button",
      className: "btn ghost sm",
      title: nomesPhc ? `${p.conta} cliente(s) no PHC` : `${p.conta} encomenda(s)`,
      onClick: () => escolher(p.naturalid)
    },
    p.naturalid,
    " (",
    p.conta,
    ")"
  ))), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Mapa SAC",
      appLabel: "orderretriever",
      viewId: "mapa_sac",
      columns,
      data: itens,
      pagination: "none",
      rowKey: (r) => r.id,
      empty: "Ainda n\xE3o h\xE1 nomes mapeados."
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-formulario" }, nomesPhc && /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Nome no PHC", /* @__PURE__ */ React.createElement(
    "select",
    {
      "aria-label": "Nome no PHC",
      value: outro ? OUTRO : draft.naturalid,
      onChange: (e) => {
        const v = e.target.value;
        setOutro(v === OUTRO);
        setDraft({ ...draft, naturalid: v === OUTRO ? "" : v });
      }
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"),
    nomesPhc.map((n) => {
      const ocupado = n.mapeado && !(editId && n.naturalid === draft.naturalid);
      return /* @__PURE__ */ React.createElement("option", { key: n.naturalid, value: n.naturalid, disabled: ocupado }, n.naturalid, " (", n.clientes, ")", n.mapeado ? ` \u2014 mapeado: ${n.user_nome}` : "");
    }),
    /* @__PURE__ */ React.createElement("option", { value: OUTRO }, "outro\u2026")
  )), (!nomesPhc || outro) && /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, nomesPhc ? "Outro nome" : "Nome no PHC", /* @__PURE__ */ React.createElement("input", { type: "text", value: draft.naturalid, onChange: (e) => setDraft({ ...draft, naturalid: e.target.value }) })), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Utilizador", /* @__PURE__ */ React.createElement("select", { value: draft.user, onChange: (e) => setDraft({ ...draft, user: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), users.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: String(u.id) }, u.nome)))), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: gravar }, editId ? "Guardar" : "Adicionar"), (editId || draft.naturalid || outro) && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: cancelar }, "Cancelar")), phcErro && /* @__PURE__ */ React.createElement("div", { className: "muted or-nota", role: "status" }, "N\xE3o deu para ler os nomes do PHC (", phcErro, ") \u2014 escreve o nome \xE0 m\xE3o."));
}
window.OrderretrieverMapasacView = OrderretrieverMapasacView;

// ===== orderretriever/frontend/orderretriever_dominios_internos.jsx =====
function OrderretrieverDominiosinternosView() {
  const VAZIO = { dominio: "", ativo: true };
  const API = window.OrderretrieverAPI;
  const [itens, setItens] = React.useState([]);
  const [draft, setDraft] = React.useState(VAZIO);
  const [editId, setEditId] = React.useState(null);
  const carregar = React.useCallback(() => API.dominiosInternos().then((r) => setItens(r || [])).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar os dom\xEDnios.", "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const cancelar = () => {
    setDraft(VAZIO);
    setEditId(null);
  };
  const gravar = () => {
    if (!draft.dominio.trim()) {
      window.srToast?.("Indica o dom\xEDnio.", "warning");
      return;
    }
    const d = { dominio: draft.dominio.trim(), ativo: !!draft.ativo };
    (editId ? API.editarDominioInterno(editId, d) : API.criarDominioInterno(d)).then(() => {
      cancelar();
      return carregar();
    }).then(() => window.srToast?.("Gravado.", "success")).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar."), "error"));
  };
  const apagar = async (r) => {
    const ok = await window.hubConfirm({ title: "Apagar dom\xEDnio", message: `Apagar \xAB${r.dominio}\xBB?`, confirmLabel: "Apagar" });
    if (!ok) return;
    API.apagarDominioInterno(r.id).then(() => carregar()).then(() => window.srToast?.("Apagado.", "success")).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel apagar."), "error"));
  };
  const columns = [
    { key: "dominio", label: "Dom\xEDnio", width: 260, fixed: true },
    {
      key: "ativo",
      label: "Ativo",
      width: 80,
      sortValue: (r) => r.ativo ? 1 : 0,
      render: (r) => r.ativo ? "Sim" : "N\xE3o"
    },
    { key: "acoes", label: "", sortable: false, width: 170, render: (r) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => {
      setEditId(r.id);
      setDraft({ ...r });
    } }, "Editar"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn danger sm", onClick: () => apagar(r) }, "Apagar")) }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina" }, /* @__PURE__ */ React.createElement("p", { className: "muted" }, "Um email que chega de um destes dom\xEDnios foi reencaminhado por algu\xE9m da casa: o cliente identifica-se pelo remetente original (o primeiro \xABDe:\xBB de fora no corpo do email). Um subdom\xEDnio conta como o dom\xEDnio."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Dom\xEDnios da casa",
      appLabel: "orderretriever",
      viewId: "dominios-internos",
      columns,
      data: itens,
      pagination: "none",
      rowKey: (r) => r.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "or-formulario" }, /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Dom\xEDnio", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      value: draft.dominio,
      placeholder: "empresa.pt",
      onChange: (e) => setDraft({ ...draft, dominio: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "or-caixa" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.ativo,
      onChange: (e) => setDraft({ ...draft, ativo: e.target.checked })
    }
  ), " Ativo"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", onClick: gravar }, editId ? "Guardar" : "Adicionar"), editId && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: cancelar }, "Cancelar")));
}
window.OrderretrieverDominiosinternosView = OrderretrieverDominiosinternosView;

// ===== orderretriever/frontend/orderretriever_apagadas.jsx =====
function OrderretrieverApagadasView() {
  const API = window.OrderretrieverAPI;
  const { EstadoBadge, dataHora } = window.OrderretrieverUtil;
  const [itens, setItens] = React.useState([]);
  const [aRepor, setARepor] = React.useState(null);
  const carregar = React.useCallback(() => API.apagadas().then((r) => setItens(r || [])).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel carregar as apagadas."), "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  const repor = (r) => {
    setARepor(r.id);
    API.repor(r.id).then(() => carregar()).then(() => window.srToast?.(`Encomenda ${r.numero || r.id} reposta.`, "success")).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel repor."), "error")).finally(() => setARepor(null));
  };
  const columns = [
    { key: "numero", label: "Encomenda", width: 140, fixed: true, render: (r) => r.numero || `#${r.id}` },
    { key: "cliente_nome", label: "Cliente", width: 240, render: (r) => r.cliente_nome || "Por identificar" },
    { key: "recebido_em", label: "Chegou", width: 140, render: (r) => dataHora(r.recebido_em) },
    {
      key: "estado",
      label: "Estado",
      width: 130,
      render: (r) => /* @__PURE__ */ React.createElement(EstadoBadge, { estado: r.estado, label: r.estado_label })
    },
    { key: "escondida_em", label: "Apagada em", width: 140, render: (r) => dataHora(r.escondida_em) },
    { key: "escondida_por_nome", label: "Por", width: 160 },
    { key: "escondida_motivo", label: "Motivo", width: 260 },
    { key: "acoes", label: "", sortable: false, width: 90, render: (r) => /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: aRepor === r.id, onClick: () => repor(r) }, aRepor === r.id ? "A repor\u2026" : "Repor") }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina" }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Apagadas",
      appLabel: "orderretriever",
      viewId: "apagadas",
      columns,
      data: itens,
      pagination: "client",
      rowKey: (r) => r.id,
      empty: /* @__PURE__ */ React.createElement("span", { className: "muted" }, "N\xE3o h\xE1 encomendas apagadas.")
    }
  ));
}
window.OrderretrieverApagadasView = OrderretrieverApagadasView;

// ===== orderretriever/frontend/orderretriever_ia.jsx =====
function orEur(v) {
  return v == null ? "\u2014" : `${Number(v).toFixed(4)} \u20AC`;
}
function orNum(v) {
  return v == null ? "\u2014" : Number(v).toLocaleString("pt-PT");
}
function orPct(v) {
  return v == null ? "\u2014" : `${(Number(v) * 100).toLocaleString("pt-PT", { maximumFractionDigits: 1 })} %`;
}
function orMs(v) {
  return v == null ? "\u2014" : `${Number(v).toLocaleString("pt-PT")} ms`;
}
function OrderretrieverLigacaoIaView() {
  const [cfg, setCfg] = React.useState(null);
  const [chave, setChave] = React.useState("");
  const [chaveAdmin, setChaveAdmin] = React.useState("");
  const [precos, setPrecos] = React.useState([]);
  const [aGravar, setAGravar] = React.useState(false);
  const API = window.OrderretrieverAPI;
  const Ico = window.Ico;
  const aplicar = React.useCallback((c) => {
    setCfg(c);
    setPrecos(Object.entries(c.precos || {}).map(([modelo, p]) => ({
      modelo,
      entrada: String(p.entrada_1m_eur ?? ""),
      saida: String(p.saida_1m_eur ?? "")
    })));
  }, []);
  React.useEffect(() => {
    API.ia().then(aplicar).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar a liga\xE7\xE3o \xE0 IA.", "error"));
  }, [API, aplicar]);
  if (!cfg) return /* @__PURE__ */ React.createElement("div", { className: "muted or-carregar" }, "A carregar\u2026");
  const set = (k) => (e) => setCfg({ ...cfg, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const setPreco = (n, k) => (e) => setPrecos(precos.map((p, i) => i === n ? { ...p, [k]: e.target.value } : p));
  function gravar() {
    const tabela = {};
    for (const p of precos) {
      if (!p.modelo.trim()) continue;
      const entrada = parseFloat(String(p.entrada).replace(",", "."));
      const saida = parseFloat(String(p.saida).replace(",", "."));
      if (!(entrada >= 0) || !(saida >= 0)) {
        window.srToast?.(`Pre\xE7os de \xAB${p.modelo}\xBB: dois n\xFAmeros \u2265 0.`, "error");
        return;
      }
      tabela[p.modelo.trim()] = { entrada_1m_eur: entrada, saida_1m_eur: saida };
    }
    setAGravar(true);
    API.gravarIa({
      fornecedor: cfg.fornecedor,
      modelo: cfg.modelo,
      url_base: cfg.url_base,
      ativo: cfg.ativo,
      verificar: !!cfg.verificar,
      saida_estruturada: !!cfg.saida_estruturada,
      max_tokens: parseInt(cfg.max_tokens, 10) || 8192,
      precos: tabela,
      custo_maximo_dia: String(cfg.custo_maximo_dia ?? "0").replace(",", ".") || "0",
      tentativas_sdk: parseInt(cfg.tentativas_sdk, 10) || 0,
      temperatura: String(cfg.temperatura ?? "").trim() === "" ? null : parseFloat(String(cfg.temperatura).replace(",", ".")),
      ...chave ? { chave_api: chave } : {},
      ...chaveAdmin ? { chave_admin: chaveAdmin } : {}
    }).then((r) => {
      aplicar(r);
      setChave("");
      setChaveAdmin("");
      window.srToast?.("Liga\xE7\xE3o \xE0 IA gravada.", "success");
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar."), "error")).finally(() => setAGravar(false));
  }
  async function removerChaveAdmin() {
    const ok = await window.hubConfirm({
      title: "Remover a chave de administra\xE7\xE3o",
      message: "O Estado da IA passa a mostrar s\xF3 o consumo do hub. Continuar?",
      confirmLabel: "Remover"
    });
    if (!ok) return;
    setAGravar(true);
    API.gravarIa({ remover_chave_admin: true }).then((r) => {
      aplicar(r);
      setChaveAdmin("");
      window.srToast?.("Chave de administra\xE7\xE3o removida.", "success");
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel remover."), "error")).finally(() => setAGravar(false));
  }
  const anthropic = cfg.fornecedor === "anthropic";
  const rotuloFornecedor = (cfg.fornecedores || []).find((f) => f.valor === cfg.fornecedor)?.rotulo || cfg.fornecedor;
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina or-pagina--estreita" }, /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Liga\xE7\xE3o \xE0 IA (", rotuloFornecedor, ")")), /* @__PURE__ */ React.createElement("p", { className: "muted or-nota" }, "A chave fica cifrada e nunca volta a aparecer. O teste e o consumo est\xE3o em", " ", /* @__PURE__ */ React.createElement("strong", null, "Estado da IA"), ". A chave, o modelo e o URL valem para o fornecedor escolhido: ao mudar de fornecedor, muda-os tamb\xE9m."), /* @__PURE__ */ React.createElement("div", { className: "or-campos" }, /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Fornecedor", /* @__PURE__ */ React.createElement("select", { value: cfg.fornecedor || "", onChange: set("fornecedor") }, (cfg.fornecedores || []).map((f) => /* @__PURE__ */ React.createElement("option", { key: f.valor, value: f.valor }, f.rotulo)))), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Chave da API", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: chave,
      autoComplete: "new-password",
      placeholder: cfg.tem_chave ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (guardada \u2014 deixa vazio para manter)" : "por preencher",
      onChange: (e) => setChave(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "or-campo" }, /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Chave de administra\xE7\xE3o da ", rotuloFornecedor, " (opcional)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: chaveAdmin,
      autoComplete: "new-password",
      placeholder: cfg.tem_chave_admin ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (guardada \u2014 deixa vazio para manter)" : `${anthropic ? "sk-ant-admin\u2026" : "sk-admin\u2026"} \u2014 s\xF3 para ver a conta no Estado da IA`,
      onChange: (e) => setChaveAdmin(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("span", { className: "muted or-pequeno" }, "S\xF3 l\xEA o uso e o custo da organiza\xE7\xE3o (Admin API); nunca \xE9 usada para extrair. Cada fornecedor guarda a sua: mudar de fornecedor n\xE3o apaga a do outro.", cfg.tem_chave_admin && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: aGravar, onClick: removerChaveAdmin }, "Remover a chave de administra\xE7\xE3o")))), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Modelo", /* @__PURE__ */ React.createElement("input", { type: "text", value: cfg.modelo || "", onChange: set("modelo"), placeholder: "nome do modelo, tal como a API o aceita" })), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "URL da API (vazio = a p\xFAblica)", /* @__PURE__ */ React.createElement("input", { type: "text", value: cfg.url_base || "", onChange: set("url_base") })), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "M\xE1ximo de tokens de resposta", /* @__PURE__ */ React.createElement("input", { type: "number", min: 256, max: 64e3, value: cfg.max_tokens ?? 8192, onChange: set("max_tokens") })), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Custo m\xE1ximo por dia (\u20AC; 0 = sem limite \u2014 atingido, a extra\xE7\xE3o fica suspensa at\xE9 ao dia seguinte)", /* @__PURE__ */ React.createElement("input", { type: "text", inputMode: "decimal", value: cfg.custo_maximo_dia ?? "0", onChange: set("custo_maximo_dia") })), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Repeti\xE7\xF5es por chamada (429, 5xx, rede; 0 a 5)", /* @__PURE__ */ React.createElement("input", { type: "number", min: 0, max: 5, value: cfg.tentativas_sdk ?? 2, onChange: set("tentativas_sdk") })), /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, "Temperatura (vazio = n\xE3o enviar; os modelos atuais recusam o par\xE2metro)", /* @__PURE__ */ React.createElement("input", { type: "text", inputMode: "decimal", value: cfg.temperatura ?? "", onChange: set("temperatura"), placeholder: "vazio" })), /* @__PURE__ */ React.createElement("label", { className: "or-caixa" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!cfg.ativo, onChange: set("ativo") }), "Ativa \u2014 o ", /* @__PURE__ */ React.createElement("code", null, "orderretriever_processar"), " extrai as encomendas que chegam"), /* @__PURE__ */ React.createElement("label", { className: "or-caixa" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!cfg.verificar, onChange: set("verificar") }), "Verificar \u2014 depois de ler, a IA confere a leitura contra as p\xE1ginas (uma segunda chamada por encomenda) e deixa avisos por campo"), /* @__PURE__ */ React.createElement("label", { className: "or-caixa" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!cfg.saida_estruturada, onChange: set("saida_estruturada") }), "Sa\xEDda estruturada \u2014 a API obriga a resposta a seguir o esquema (desligar s\xF3 se o modelo escolhido n\xE3o a suportar)"))), /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Pre\xE7os (\u20AC por milh\xE3o de tokens)")), /* @__PURE__ */ React.createElement("p", { className: "muted or-nota" }, "O custo de cada chamada calcula-se com o pre\xE7o do momento e fica gravado; mudar um pre\xE7o n\xE3o reescreve o passado."), precos.map((p, n) => /* @__PURE__ */ React.createElement("div", { key: n, className: "or-preco" }, /* @__PURE__ */ React.createElement("input", { "aria-label": "Modelo do pre\xE7o", type: "text", value: p.modelo, onChange: setPreco(n, "modelo"), placeholder: "modelo" }), /* @__PURE__ */ React.createElement("input", { "aria-label": "Entrada", type: "text", value: p.entrada, onChange: setPreco(n, "entrada"), placeholder: "entrada" }), /* @__PURE__ */ React.createElement("input", { "aria-label": "Sa\xEDda", type: "text", value: p.saida, onChange: setPreco(n, "saida"), placeholder: "sa\xEDda" }), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setPrecos(precos.filter((_, i) => i !== n)) }, "Remover"))), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "aria-label": "Acrescentar pre\xE7o",
      onClick: () => setPrecos([...precos, { modelo: cfg.modelo || "", entrada: "", saida: "" }])
    },
    /* @__PURE__ */ React.createElement(Ico.plus, null),
    " pre\xE7o"
  )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", disabled: aGravar, onClick: gravar }, aGravar ? "A gravar\u2026" : "Gravar")));
}
function OrderretrieverChamada({ titulo, c }) {
  const { dataHora } = window.OrderretrieverUtil;
  if (!c) return /* @__PURE__ */ React.createElement("div", { className: "or-estado-linha" }, /* @__PURE__ */ React.createElement("strong", null, titulo, ":"), " ", /* @__PURE__ */ React.createElement("span", { className: "muted" }, "nunca"));
  return /* @__PURE__ */ React.createElement("div", { className: "or-estado-linha" }, /* @__PURE__ */ React.createElement("strong", null, titulo, ":"), " ", /* @__PURE__ */ React.createElement("span", { className: c.ok ? "or-ok" : "or-erro" }, c.ok ? "OK" : `erro${c.codigo ? ` ${c.codigo}` : ""}`, " \xB7 ", dataHora(c.em)), c.latencia_ms != null && /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", c.latencia_ms, " ms"), c.modelo && /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", c.modelo), !c.ok && c.mensagem && /* @__PURE__ */ React.createElement("div", { className: "muted or-pequeno or-pre" }, c.mensagem));
}
function OrderretrieverContaFornecedor({ conta }) {
  if (!conta) return /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A ler a conta no fornecedor\u2026");
  const f = conta.fornecedor;
  const h = conta.hub;
  const hub = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Medido pelo hub (", h.mes, ")"), /* @__PURE__ */ React.createElement("strong", null, h.chamadas, " chamadas \xB7 ", orNum(h.tokens_entrada), " / ", orNum(h.tokens_saida), " tok \xB7 ", orEur(h.custo_eur)));
  if (!f.tem_chave_admin) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "or-kpis" }, hub), /* @__PURE__ */ React.createElement("p", { className: "muted or-nota or-acoes--topo" }, "Sem chave de administra\xE7\xE3o, s\xF3 se v\xEA o consumo medido pelo hub: a API de mensagens n\xE3o devolve o saldo nem os limites da conta. Com uma chave de administra\xE7\xE3o (em", " ", /* @__PURE__ */ React.createElement("strong", null, "Liga\xE7\xE3o \xE0 IA"), ") aparece aqui o custo da organiza\xE7\xE3o, de hoje e do m\xEAs.", " ", f.como_criar, " ", /* @__PURE__ */ React.createElement("a", { href: f.criar_chave, target: "_blank", rel: "noopener noreferrer" }, "Criar a chave"), " ", "\xB7 ", /* @__PURE__ */ React.createElement("a", { href: f.portal, target: "_blank", rel: "noopener noreferrer" }, "portal da ", f.fornecedor), "."));
  }
  if (!f.ok) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "or-kpis" }, hub), /* @__PURE__ */ React.createElement("div", { role: "alert", className: "or-erro or-acoes--topo" }, "N\xE3o foi poss\xEDvel ler a conta: ", f.erro));
  }
  const usd = (v) => v == null ? "\u2014" : `${Number(v).toFixed(2)} ${f.moeda}`;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "or-kpis" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, f.fornecedor, " \u2014 custo de hoje"), /* @__PURE__ */ React.createElement("strong", null, usd(f.custo_hoje))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, f.fornecedor, " \u2014 custo do m\xEAs (", f.mes, ")"), /* @__PURE__ */ React.createElement("strong", null, usd(f.custo_total))), hub), /* @__PURE__ */ React.createElement("p", { className: "muted or-pequeno or-acoes--topo" }, "O custo da organiza\xE7\xE3o \xE9 o que o fornecedor fatura (todas as chaves, n\xE3o s\xF3 a do hub), em", " ", f.moeda, "; o do hub \xE9 estimado com os pre\xE7os das Defini\xE7\xF5es, em \u20AC. \xABHoje\xBB \xE9 o dia em UTC, como o fornecedor o conta.", " ", /* @__PURE__ */ React.createElement("a", { href: f.portal, target: "_blank", rel: "noopener noreferrer" }, "Portal da ", f.fornecedor)), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Organiza\xE7\xE3o por modelo (m\xEAs corrente)",
      data: f.por_modelo,
      rowKey: (r) => r.modelo,
      empty: "Sem uso este m\xEAs.",
      appLabel: "orderretriever",
      viewId: "ia-conta-modelos",
      columns: [
        { key: "modelo", label: "Modelo", width: 220 },
        { key: "custo", label: "Custo", width: 110, render: (r) => usd(r.custo) },
        { key: "tokens_entrada", label: "Tokens entrada", width: 130, render: (r) => orNum(r.tokens_entrada) },
        { key: "tokens_cache_leitura", label: "Cache (leitura)", width: 130, render: (r) => orNum(r.tokens_cache_leitura) },
        { key: "tokens_cache_escrita", label: "Cache (escrita)", width: 130, render: (r) => orNum(r.tokens_cache_escrita) },
        { key: "tokens_saida", label: "Tokens sa\xEDda", width: 120, render: (r) => orNum(r.tokens_saida) }
      ]
    }
  ));
}
function OrderretrieverEstadoIaView({ navigate } = {}) {
  const [estado, setEstado] = React.useState(null);
  const [teste, setTeste] = React.useState(null);
  const [aTestar, setATestar] = React.useState(false);
  const [conta, setConta] = React.useState(null);
  const API = window.OrderretrieverAPI;
  const { dataHora, Aviso } = window.OrderretrieverUtil;
  React.useEffect(() => {
    API.contaIa().then(setConta).catch((e) => setConta({
      fornecedor: { tem_chave_admin: true, ok: false, erro: API.erroDRF(e, "pedido falhou.") },
      hub: { mes: "\u2014", chamadas: 0, tokens_entrada: 0, tokens_saida: 0, custo_eur: null }
    }));
  }, [API]);
  const carregar = React.useCallback(() => API.estadoIa().then(setEstado).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar o estado da IA.", "error")), [API]);
  React.useEffect(() => {
    carregar();
  }, [carregar]);
  function testar() {
    setATestar(true);
    API.testarIa().then(setTeste).catch((e) => setTeste({ ok: false, erro: API.erroDRF(e, "O teste falhou.") })).finally(() => {
      setATestar(false);
      carregar();
    });
  }
  if (!estado) return /* @__PURE__ */ React.createElement("div", { className: "muted or-carregar" }, "A carregar\u2026");
  const c = estado.consumo;
  const abrir = (id) => (navigate || window.HubRouter.navigate)({ routeId: "orderretriever", entidade: String(id) });
  const consumoCols = (rotulo) => [
    { key: "periodo", label: rotulo, width: 110, mono: true },
    { key: "chamadas", label: "Chamadas", width: 90 },
    { key: "tokens_entrada", label: "Tokens entrada", width: 130, render: (r) => orNum(r.tokens_entrada) },
    { key: "tokens_saida", label: "Tokens sa\xEDda", width: 120, render: (r) => orNum(r.tokens_saida) },
    { key: "custo_eur", label: "Custo", width: 110, render: (r) => orEur(r.custo_eur) }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina" }, estado.faixa && estado.faixa.suspensa && /* @__PURE__ */ React.createElement(Aviso, { tipo: "info" }, "IA suspensa: atingiu o limite di\xE1rio de ", Number(estado.faixa.custo_maximo_dia).toFixed(2), " \u20AC", " ", "(hoje ", Number(estado.faixa.custo_hoje).toFixed(2), " \u20AC) \u2014 ", estado.faixa.a_espera, " \xE0 espera."), estado.faixa && estado.faixa.indisponivel_desde && /* @__PURE__ */ React.createElement(Aviso, { tipo: "erro" }, "IA indispon\xEDvel desde ", dataHora(estado.faixa.indisponivel_desde), " \u2014 ", estado.faixa.a_espera, " \xE0 espera."), /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Liga\xE7\xE3o")), /* @__PURE__ */ React.createElement("div", { className: "muted or-nota or-paragrafo" }, estado.config.fornecedor, " \xB7 Modelo: ", estado.config.modelo || "por configurar", " \xB7 ", estado.config.ativo ? "ativa" : "desligada", !estado.config.completa && " \xB7 falta a chave ou o modelo (Liga\xE7\xE3o \xE0 IA)"), /* @__PURE__ */ React.createElement(OrderretrieverChamada, { titulo: "\xDAltima resposta OK", c: estado.ultimo_ok }), /* @__PURE__ */ React.createElement(OrderretrieverChamada, { titulo: "\xDAltimo erro", c: estado.ultimo_erro }), /* @__PURE__ */ React.createElement(OrderretrieverChamada, { titulo: "\xDAltimo teste", c: estado.ultimo_teste }), /* @__PURE__ */ React.createElement("div", { className: "or-acoes or-acoes--topo" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: aTestar, onClick: testar }, aTestar ? "A testar\u2026" : "Testar"), teste && /* @__PURE__ */ React.createElement("span", { role: "status", className: teste.ok ? "or-ok" : "or-erro" }, teste.ok ? `OK \xB7 ${teste.modelo} \xB7 ${teste.latencia_ms} ms` : `${teste.codigo ? `${teste.codigo} \u2014 ` : ""}${teste.erro}`))), /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Consumo do hub (\xFAltimos ", c.janela_dias, " dias)")), /* @__PURE__ */ React.createElement("div", { className: "or-kpis" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Hoje"), /* @__PURE__ */ React.createElement("strong", null, c.hoje ? `${c.hoje.chamadas} chamadas \xB7 ${orEur(c.hoje.custo_eur)}` : "\u2014")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Encomendas"), /* @__PURE__ */ React.createElement("strong", null, c.total.encomendas)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Tokens (entrada / sa\xEDda)"), /* @__PURE__ */ React.createElement("strong", null, orNum(c.total.tokens_entrada), " / ", orNum(c.total.tokens_saida))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Custo estimado"), /* @__PURE__ */ React.createElement("strong", null, orEur(c.total.custo_eur))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "M\xE9dia por encomenda"), /* @__PURE__ */ React.createElement("strong", null, orNum(c.media_por_encomenda.tokens_entrada), " tok \xB7 ", orEur(c.media_por_encomenda.custo_eur))))), /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Conta no fornecedor")), /* @__PURE__ */ React.createElement(OrderretrieverContaFornecedor, { conta })), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: `Desempenho (\xFAltimos ${estado.desempenho.janela_dias} dias)`,
      data: estado.desempenho.por_tipo,
      rowKey: (r) => r.tipo,
      empty: "Sem chamadas.",
      appLabel: "orderretriever",
      viewId: "ia-desempenho",
      columns: [
        { key: "rotulo", label: "Chamada", width: 120 },
        { key: "chamadas", label: "Chamadas", width: 90 },
        { key: "latencia_media_ms", label: "Lat\xEAncia m\xE9dia", width: 130, render: (r) => orMs(r.latencia_media_ms) },
        { key: "latencia_p95_ms", label: "Lat\xEAncia p95", width: 120, render: (r) => orMs(r.latencia_p95_ms) },
        { key: "taxa_repeticao", label: "Com repeti\xE7\xE3o", width: 130, render: (r) => r.chamadas ? `${r.com_repeticao} \xB7 ${orPct(r.taxa_repeticao)}` : "\u2014" },
        { key: "cache_lida", label: "Cache lida (tok)", width: 140, render: (r) => orNum(r.cache_lida) },
        { key: "cache_escrita", label: "Cache escrita (tok)", width: 150, render: (r) => orNum(r.cache_escrita) },
        { key: "fracao_cache", label: "Entrada lida da cache", width: 170, render: (r) => orPct(r.fracao_cache) }
      ]
    }
  ), /* @__PURE__ */ React.createElement("p", { className: "muted or-pequeno" }, "A lat\xEAncia s\xF3 conta as chamadas que responderam. \xABCom repeti\xE7\xE3o\xBB = a IA respondeu fora do formato e foi pedida outra vez. As chamadas de antes da medi\xE7\xE3o da cache contam 0 tokens de cache."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Por dia",
      columns: consumoCols("Dia"),
      data: c.por_dia,
      rowKey: (r) => r.periodo,
      empty: "Sem chamadas.",
      appLabel: "orderretriever",
      viewId: "ia-por-dia"
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Por m\xEAs",
      columns: consumoCols("M\xEAs"),
      data: c.por_mes,
      rowKey: (r) => r.periodo,
      empty: "Sem chamadas.",
      appLabel: "orderretriever",
      viewId: "ia-por-mes"
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Por cliente",
      data: c.por_cliente,
      rowKey: (r) => r.cliente,
      empty: "Sem encomendas extra\xEDdas.",
      appLabel: "orderretriever",
      viewId: "ia-por-cliente",
      columns: [
        { key: "cliente", label: "Cliente", width: 240 },
        { key: "encomendas", label: "Encomendas", width: 100 },
        { key: "tokens_entrada", label: "Tokens entrada", width: 130, render: (r) => orNum(r.tokens_entrada) },
        { key: "tokens_saida", label: "Tokens sa\xEDda", width: 120, render: (r) => orNum(r.tokens_saida) },
        { key: "custo_eur", label: "Custo", width: 110, render: (r) => orEur(r.custo_eur) }
      ]
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "As 10 mais caras",
      data: c.mais_caras,
      rowKey: (r) => r.id,
      onRowClick: (r) => abrir(r.id),
      empty: "Sem encomendas extra\xEDdas.",
      appLabel: "orderretriever",
      viewId: "ia-mais-caras",
      columns: [
        { key: "id", label: "Encomenda", width: 90, mono: true },
        { key: "cliente_nome", label: "Cliente", width: 220 },
        { key: "origem", label: "Documento", width: 180 },
        { key: "tokens_entrada", label: "Tokens entrada", width: 130, render: (r) => orNum(r.tokens_entrada) },
        { key: "custo_eur", label: "Custo", width: 110, render: (r) => orEur(r.custo_eur) }
      ]
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Erros recentes (\xFAltimos 50)",
      data: estado.erros_recentes,
      rowKey: (r) => `${r.em}:${r.encomenda}:${r.codigo}`,
      onRowClick: (r) => r.encomenda ? abrir(r.encomenda) : null,
      empty: "Sem erros.",
      appLabel: "orderretriever",
      viewId: "ia-erros",
      columns: [
        { key: "em", label: "Quando", width: 140, render: (r) => dataHora(r.em) },
        { key: "encomenda", label: "Encomenda", width: 90, mono: true, render: (r) => r.encomenda || "\u2014" },
        { key: "codigo", label: "C\xF3digo", width: 80, render: (r) => r.codigo || "\u2014" },
        { key: "mensagem", label: "Mensagem", width: 420 }
      ]
    }
  ));
}
window.OrderretrieverLigacaoIaView = OrderretrieverLigacaoIaView;
window.OrderretrieverEstadoIaView = OrderretrieverEstadoIaView;

// ===== orderretriever/frontend/orderretriever_aprendizagem.jsx =====
function orApPct(v) {
  return v == null ? "\u2014" : `${Number(v).toLocaleString("pt-PT", { maximumFractionDigits: 1 })} %`;
}
function orApMinutos(min) {
  if (min == null) return "\u2014";
  const m = Math.round(min);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (h < 24) return r ? `${h} h ${r} min` : `${h} h`;
  const d = Math.floor(h / 24);
  const hr = h % 24;
  return hr ? `${d} d ${hr} h` : `${d} d`;
}
function orApDia(iso) {
  if (!iso) return "";
  const [, m, d] = iso.split("-");
  return `${d}/${m}`;
}
function orApLerParams(params) {
  const p = params && typeof params.get === "function" ? params : window.HubRouter.current().params;
  const dias = parseInt(p.get("dias"), 10);
  const cliente = parseInt(p.get("cliente"), 10);
  return {
    dias: Number.isFinite(dias) && dias > 0 ? dias : null,
    cliente: Number.isFinite(cliente) ? cliente : null
  };
}
function OrderretrieverBarrasSemana({ semanas }) {
  const n = (semanas || []).length;
  if (!n) return /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem semanas no per\xEDodo.");
  const W = 720;
  const H = 160;
  const padL = 36;
  const padR = 8;
  const padT = 10;
  const padB = 22;
  const innerW = W - padL - padR;
  const innerH = H - padT - padB;
  const slot = innerW / n;
  const barW = Math.max(2, slot - Math.min(6, slot * 0.3));
  const y = (pct) => padT + innerH - pct / 100 * innerH;
  const passoRotulo = Math.max(1, Math.ceil(n / 12));
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox: `0 0 ${W} ${H}`,
      width: "100%",
      height: H,
      role: "img",
      "aria-label": "Percentagem de encomendas aprovadas sem corre\xE7\xE3o, por semana"
    },
    [0, 50, 100].map((p) => /* @__PURE__ */ React.createElement("g", { key: p }, /* @__PURE__ */ React.createElement(
      "line",
      {
        x1: padL,
        x2: W - padR,
        y1: y(p),
        y2: y(p),
        stroke: "currentColor",
        opacity: p === 0 ? 0.35 : 0.12
      }
    ), /* @__PURE__ */ React.createElement(
      "text",
      {
        x: padL - 6,
        y: y(p) + 3,
        textAnchor: "end",
        fontSize: "10",
        fill: "currentColor",
        opacity: "0.6"
      },
      p,
      " %"
    ))),
    semanas.map((s, i) => {
      const x = padL + slot * i + (slot - barW) / 2;
      const tem = s.aprovadas > 0;
      const pct = tem ? s.pct_sem_correcao || 0 : 0;
      const alt = tem ? Math.max(1, pct / 100 * innerH) : 2;
      const titulo = tem ? `Semana de ${orApDia(s.semana)}: ${s.sem_correcao}/${s.aprovadas} sem corre\xE7\xE3o (${orApPct(pct)})` : `Semana de ${orApDia(s.semana)}: sem aprova\xE7\xF5es`;
      return /* @__PURE__ */ React.createElement("g", { key: s.semana }, /* @__PURE__ */ React.createElement("title", null, titulo), /* @__PURE__ */ React.createElement(
        "rect",
        {
          x,
          y: padT + innerH - alt,
          width: barW,
          height: alt,
          rx: "2",
          fill: "currentColor",
          opacity: tem ? 0.8 : 0.15
        }
      ), i % passoRotulo === 0 && /* @__PURE__ */ React.createElement(
        "text",
        {
          x: x + barW / 2,
          y: H - 6,
          textAnchor: "middle",
          fontSize: "10",
          fill: "currentColor",
          opacity: "0.6"
        },
        orApDia(s.semana)
      ));
    })
  );
}
function OrderretrieverApKpi({ rotulo, valor, sub }) {
  return /* @__PURE__ */ React.createElement("div", { className: "kpi" }, /* @__PURE__ */ React.createElement("div", { className: "kpi-label" }, rotulo), /* @__PURE__ */ React.createElement("div", { className: "kpi-value" }, valor), sub && /* @__PURE__ */ React.createElement("div", { className: "kpi-sub" }, sub));
}
function OrderretrieverApCliente({ cliente, linha, onFechar }) {
  const nome = linha && linha.cliente_nome || cliente.cliente_nome || `Cliente n\xBA ${cliente.cliente_no}`;
  const top = linha && linha.campos_top || [];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, nome), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "n\xBA ", cliente.cliente_no), /* @__PURE__ */ React.createElement(window.OrderretrieverChipSemCorrecao, { dados: cliente.sem_correcao_total }), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onFechar }, "Voltar ao geral")), /* @__PURE__ */ React.createElement("div", { className: "modal-body" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Onde ensinar \u2014 o que este cliente mais corrige no per\xEDodo"), top.length === 0 ? /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Sem corre\xE7\xF5es no per\xEDodo.") : /* @__PURE__ */ React.createElement("div", { className: "chips" }, top.map((c) => /* @__PURE__ */ React.createElement("span", { key: c.campo, className: "pill", title: `${c.encomendas} ${c.encomendas === 1 ? "encomenda corrigida" : "encomendas corrigidas"} neste campo` }, c.rotulo, " \xB7 ", c.encomendas)))), /* @__PURE__ */ React.createElement(
    window.OrderretrieverRegrasCliente,
    {
      key: cliente.cliente_no,
      clienteNo: cliente.cliente_no,
      clienteNome: cliente.cliente_nome
    }
  )));
}
function OrderretrieverAprendizagemView({ routeId = "orderretriever_aprendizagem", params } = {}) {
  const API = window.OrderretrieverAPI;
  const { dataHora } = window.OrderretrieverUtil;
  const inicial = React.useMemo(() => orApLerParams(params), []);
  const [dias, setDias] = React.useState(inicial.dias);
  const [cliente, setCliente] = React.useState(inicial.cliente);
  const [dados, setDados] = React.useState(null);
  const [falhou, setFalhou] = React.useState(false);
  React.useEffect(() => {
    window.HubRouter.setParams({
      dias: dias ? String(dias) : null,
      cliente: cliente != null ? String(cliente) : null
    });
  }, [dias, cliente]);
  React.useEffect(() => window.HubRouter.subscribe((loc) => {
    if (loc.view !== routeId) return;
    const lido = orApLerParams(loc.params);
    setDias(lido.dias);
    setCliente(lido.cliente);
  }), [routeId]);
  React.useEffect(() => {
    let vivo = true;
    setDados(null);
    setFalhou(false);
    API.aprendizagem({ dias, cliente_no: cliente }).then((d) => {
      if (vivo) setDados(d);
    }).catch(() => {
      if (!vivo) return;
      setFalhou(true);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar o painel de aprendizagem.", "error");
    });
    return () => {
      vivo = false;
    };
  }, [API, dias, cliente]);
  if (falhou) return /* @__PURE__ */ React.createElement("div", { className: "modal-body" }, /* @__PURE__ */ React.createElement("span", { className: "muted" }, "N\xE3o foi poss\xEDvel carregar o painel."));
  if (!dados) return /* @__PURE__ */ React.createElement("div", { className: "modal-body" }, /* @__PURE__ */ React.createElement("span", { className: "muted" }, "A carregar\u2026"));
  const r = dados.resumo;
  const periodos = dados.periodo.periodos || [];
  const linhaCliente = cliente != null ? dados.clientes.find((c) => c.cliente_no === cliente) : null;
  const abrirCliente = (no) => {
    if (no != null) setCliente(no);
  };
  const colunasClientes = [
    {
      key: "cliente_nome",
      label: "Cliente",
      width: 240,
      render: (c) => c.cliente_nome ? c.cliente_nome : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Por identificar")
    },
    {
      key: "cliente_no",
      label: "N\xBA PHC",
      width: 90,
      mono: true,
      render: (c) => c.cliente_no == null ? /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014") : c.cliente_no
    },
    { key: "aprovadas", label: "Aprovadas", width: 100 },
    {
      key: "sem_correcao",
      label: "Sem corre\xE7\xE3o",
      width: 130,
      render: (c) => c.aprovadas ? /* @__PURE__ */ React.createElement("span", { className: "pill" }, "Sem corre\xE7\xE3o ", c.sem_correcao, "/", c.aprovadas) : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    {
      key: "pct_sem_correcao",
      label: "% sem corre\xE7\xE3o",
      width: 120,
      render: (c) => orApPct(c.pct_sem_correcao)
    },
    { key: "por_validar", label: "Por validar", width: 100 },
    {
      key: "campos_top",
      label: "Campos mais corrigidos",
      width: 320,
      sortable: false,
      render: (c) => c.campos_top.length ? c.campos_top.map((x) => `${x.rotulo} (${x.encomendas})`).join(" \xB7 ") : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014")
    },
    {
      key: "ensinar",
      label: "Ensinar",
      width: 100,
      sortable: false,
      render: (c) => c.cliente_no == null ? null : /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          onClick: (e) => {
            e.stopPropagation();
            abrirCliente(c.cliente_no);
          }
        },
        "Ensinar"
      )
    }
  ];
  const colunasCampos = [
    { key: "rotulo", label: "Campo", width: 240 },
    { key: "encomendas", label: "Encomendas corrigidas", width: 160 },
    { key: "pct_encomendas", label: "% das aprovadas", width: 130, render: (c) => orApPct(c.pct_encomendas) },
    { key: "correcoes", label: "Valores corrigidos", width: 140 }
  ];
  const colunasSacs = [
    { key: "nome", label: "SAC", width: 200 },
    { key: "por_validar", label: "Por validar agora", width: 140 },
    { key: "aprovadas", label: "Aprovou (per\xEDodo)", width: 140 },
    { key: "media_min", label: "Chegada \u2192 aprova\xE7\xE3o (m\xE9dia)", width: 200, render: (s) => orApMinutos(s.media_min) },
    { key: "p90_min", label: "p90", width: 110, render: (s) => orApMinutos(s.p90_min) }
  ];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "filters" }, /* @__PURE__ */ React.createElement("span", { className: "section-label" }, "Per\xEDodo"), /* @__PURE__ */ React.createElement("div", { className: "chips", role: "group", "aria-label": "Per\xEDodo" }, periodos.map((d) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: d,
      type: "button",
      className: `chip${dados.periodo.dias === d ? " chip-on" : ""}`,
      "aria-pressed": dados.periodo.dias === d,
      onClick: () => setDias(d)
    },
    d,
    " dias"
  ))), /* @__PURE__ */ React.createElement("span", { className: "muted" }, "desde ", dataHora(dados.periodo.desde), " \xB7 dados em cache 5 min")), /* @__PURE__ */ React.createElement("div", { className: "modal-body" }, dados.cliente && /* @__PURE__ */ React.createElement(
    OrderretrieverApCliente,
    {
      cliente: dados.cliente,
      linha: linhaCliente,
      onFechar: () => setCliente(null)
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "kpi-row" }, /* @__PURE__ */ React.createElement(OrderretrieverApKpi, { rotulo: "Aprovadas no per\xEDodo", valor: r.aprovadas }), /* @__PURE__ */ React.createElement(
    OrderretrieverApKpi,
    {
      rotulo: "Sem corre\xE7\xE3o",
      valor: orApPct(r.pct_sem_correcao),
      sub: r.aprovadas ? `${r.sem_correcao} de ${r.aprovadas} tal como a IA leu` : "sem aprova\xE7\xF5es no per\xEDodo"
    }
  ), /* @__PURE__ */ React.createElement(
    OrderretrieverApKpi,
    {
      rotulo: "Com corre\xE7\xE3o",
      valor: r.com_correcao,
      sub: dados.campos.length ? `campo mais corrigido: ${dados.campos[0].rotulo}` : null
    }
  ), /* @__PURE__ */ React.createElement(
    OrderretrieverApKpi,
    {
      rotulo: "Por validar agora",
      valor: r.por_validar,
      sub: dados.sacs.length ? `${dados.sacs.filter((s) => s.por_validar).length} ${dados.sacs.filter((s) => s.por_validar).length === 1 ? "SAC com fila" : "SACs com fila"}` : null
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Sem corre\xE7\xE3o, por semana"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "% das aprovadas que sa\xEDram tal como a IA as leu")), /* @__PURE__ */ React.createElement("div", { className: "modal-body" }, /* @__PURE__ */ React.createElement(OrderretrieverBarrasSemana, { semanas: dados.por_semana }))), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Campos mais corrigidos",
      columns: colunasCampos,
      data: dados.campos,
      rowKey: (c) => c.campo,
      initialSort: [{ key: "encomendas", dir: "desc" }],
      empty: "Nenhuma corre\xE7\xE3o no per\xEDodo.",
      appLabel: "orderretriever",
      viewId: "aprendizagem-campos"
    }
  ), !dados.cliente && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Por cliente",
      columns: colunasClientes,
      data: dados.clientes,
      rowKey: (c) => c.cliente_no == null ? "sem" : c.cliente_no,
      onRowClick: (c) => abrirCliente(c.cliente_no),
      initialSort: [{ key: "aprovadas", dir: "desc" }],
      empty: "Sem encomendas no per\xEDodo.",
      appLabel: "orderretriever",
      viewId: "aprendizagem-clientes"
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Por SAC",
      columns: colunasSacs,
      data: dados.sacs,
      rowKey: (s) => s.chave,
      initialSort: [{ key: "por_validar", dir: "desc" }],
      empty: "Sem aprova\xE7\xF5es nem fila.",
      appLabel: "orderretriever",
      viewId: "aprendizagem-sacs"
    }
  )));
}
window.OrderretrieverAprendizagemView = OrderretrieverAprendizagemView;

// ===== orderretriever/frontend/orderretriever_saida.jsx =====
const OR_REDE_ESTADO = {
  vazia: "por preencher",
  nao_existe: "n\xE3o existe neste servidor (montada?)",
  sem_escrita: "existe, mas o hub n\xE3o tem permiss\xE3o de escrita",
  ok: "montada, com escrita"
};
function OrderretrieverSaidaView() {
  const API = window.OrderretrieverAPI;
  const [cfg, setCfg] = React.useState(null);
  const [aGravar, setAGravar] = React.useState(false);
  React.useEffect(() => {
    API.saida().then(setCfg).catch(() => window.srToast?.("N\xE3o foi poss\xEDvel carregar a configura\xE7\xE3o.", "error"));
  }, [API]);
  if (!cfg) return /* @__PURE__ */ React.createElement("div", { className: "muted or-carregar" }, "A carregar\u2026");
  const set = (k) => (e) => setCfg({ ...cfg, [k]: e.target.value });
  async function gravar() {
    if (cfg.modo === "ativo") {
      const ok = await window.hubConfirm({
        title: "Modo ativo",
        message: "Em modo ativo o hub l\xEA a Inbox, escreve o Excel na pasta do importador do PHC e move os emails para OUT/ERROR.\nO servi\xE7o antigo tem de estar parado. Continuar?",
        confirmLabel: "Gravar em modo ativo"
      });
      if (!ok) return;
    }
    setAGravar(true);
    API.gravarSaida({
      modo: cfg.modo,
      diretorio_rede: cfg.diretorio_rede,
      diretorio_sombra: cfg.diretorio_sombra,
      pasta_entrada: cfg.pasta_entrada,
      pasta_out: cfg.pasta_out,
      pasta_error: cfg.pasta_error
    }).then((r) => {
      setCfg(r);
      window.srToast?.("Gravado.", "success");
    }).catch((e) => window.srToast?.(API.erroDRF(e, "N\xE3o foi poss\xEDvel gravar."), "error")).finally(() => setAGravar(false));
  }
  const campo = (rotulo, k, extra = {}) => /* @__PURE__ */ React.createElement("label", { className: "or-campo" }, rotulo, /* @__PURE__ */ React.createElement("input", { type: "text", value: cfg[k] ?? "", onChange: set(k), ...extra }));
  return /* @__PURE__ */ React.createElement("div", { className: "or-pagina or-pagina--estreita" }, /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Modo")), /* @__PURE__ */ React.createElement("div", { role: "radiogroup", "aria-label": "Modo", className: "or-opcoes" }, /* @__PURE__ */ React.createElement("label", { className: "or-caixa or-caixa--topo" }, /* @__PURE__ */ React.createElement("input", { type: "radio", name: "or-modo", value: "sombra", checked: cfg.modo === "sombra", onChange: set("modo") }), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, "Sombra"), " \u2014 l\xEA a pasta OUT (o que o servi\xE7o antigo j\xE1 tratou); aprovar escreve os ficheiros no diret\xF3rio de sombra e nenhum email se move.")), /* @__PURE__ */ React.createElement("label", { className: "or-caixa or-caixa--topo" }, /* @__PURE__ */ React.createElement("input", { type: "radio", name: "or-modo", value: "ativo", checked: cfg.modo === "ativo", onChange: set("modo") }), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, "Ativo"), " \u2014 l\xEA a Inbox; aprovar escreve na pasta de rede do importador do PHC e move o email para OUT; rejeitar move-o para ERROR. S\xF3 funciona na base de produ\xE7\xE3o.")))), /* @__PURE__ */ React.createElement("div", { className: "panel or-painel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Pastas")), /* @__PURE__ */ React.createElement("div", { className: "or-campos" }, campo("Pasta de rede (modo ativo) \u2014 caminho montado da OUT do JNOrder", "diretorio_rede", { placeholder: "/mnt/jnorder/OUT" }), /* @__PURE__ */ React.createElement("span", { className: "muted or-nota" }, "Estado: ", OR_REDE_ESTADO[cfg.rede_estado] || cfg.rede_estado), campo("Diret\xF3rio de sombra (vazio = o do hub)", "diretorio_sombra", { placeholder: cfg.diretorio_sombra_efetivo }), /* @__PURE__ */ React.createElement("span", { className: "muted or-nota" }, "Em uso: ", /* @__PURE__ */ React.createElement("code", null, cfg.diretorio_sombra_efetivo)), campo("Pasta do email lida em modo ativo", "pasta_entrada"), campo("Pasta do email aprovado", "pasta_out"), campo("Pasta do email rejeitado", "pasta_error")), /* @__PURE__ */ React.createElement("div", { className: "or-acoes or-formulario--topo" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", disabled: aGravar, onClick: gravar }, aGravar ? "A gravar\u2026" : "Gravar"))));
}
window.OrderretrieverSaidaView = OrderretrieverSaidaView;

// ===== orderretriever/frontend/entry.jsx =====
window.OrderretrieverView = window.OrderretrieverView || (() => null);
window.OrderretrieverLigacaoaographView = window.OrderretrieverLigacaoaographView || (() => null);
window.OrderretrieverMotivosderejeicaoView = window.OrderretrieverMotivosderejeicaoView || (() => null);
window.OrderretrieverApagadasView = window.OrderretrieverApagadasView || (() => null);
window.OrderretrieverMapasacView = window.OrderretrieverMapasacView || (() => null);
window.OrderretrieverLigacaoIaView = window.OrderretrieverLigacaoIaView || (() => null);
window.OrderretrieverEstadoIaView = window.OrderretrieverEstadoIaView || (() => null);
window.OrderretrieverAprendizagemView = window.OrderretrieverAprendizagemView || (() => null);
window.OrderretrieverDocumento = window.OrderretrieverDocumento || (() => null);
window.OrderretrieverSaidaView = window.OrderretrieverSaidaView || (() => null);
window.OrderretrieverPromptBaseView = window.OrderretrieverPromptBaseView || (() => null);
window.OrderretrieverRegrasView = window.OrderretrieverRegrasView || (() => null);
window.OrderretrieverRegrasCliente = window.OrderretrieverRegrasCliente || (() => null);
window.OrderretrieverChipSemCorrecao = window.OrderretrieverChipSemCorrecao || (() => null);

// ===== orderretriever/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "orderretriever",
  order: 10,
  name: "OrderRetriever",
  sub: "Leitor de encomendas por email",
  accent: "#2f7d6d",
  brandLogo: "/static/assets/orderretriever-logo.png?v=1",
  home: "orderretriever",
  launcher: true,
  frontendFiles: [
    "frontend/orderretriever-api.jsx",
    "frontend/orderretriever_util.jsx",
    "frontend/orderretriever_documento.jsx",
    "frontend/orderretriever_decisao.jsx",
    "frontend/orderretriever_ensinar.jsx",
    "frontend/orderretriever_ficha_temas.jsx",
    "frontend/orderretriever_ficha.jsx",
    "frontend/orderretriever_encomenda.jsx",
    "frontend/orderretriever_triagem.jsx",
    "frontend/orderretriever.jsx",
    "frontend/orderretriever_ligacao_ao_graph.jsx",
    "frontend/orderretriever_motivos_de_rejeicao.jsx",
    "frontend/orderretriever_mapa_sac.jsx",
    "frontend/orderretriever_dominios_internos.jsx",
    "frontend/orderretriever_apagadas.jsx",
    "frontend/orderretriever_ia.jsx",
    "frontend/orderretriever_aprendizagem.jsx",
    "frontend/orderretriever_saida.jsx",
    "frontend/entry.jsx"
  ],
  routes: [
    { id: "orderretriever", section: "Encomendas", icon: "list", label: "Encomendas", adminOnly: false, title: "Encomendas", tooltip: "Encomendas recebidas por email" },
    { id: "orderretriever_saida", section: "Defini\xE7\xF5es", icon: "cog", label: "Sa\xEDda e modo", adminOnly: true, title: "Sa\xEDda e modo", tooltip: "Modo sombra/ativo, pasta de sa\xEDda do Excel e pastas do email" },
    { id: "orderretriever_ligacao_ao_graph", section: "Defini\xE7\xF5es", icon: "cog", label: "Liga\xE7\xE3o ao Graph", adminOnly: true, title: "Liga\xE7\xE3o ao Graph", tooltip: "Caixa de correio e credenciais do Microsoft Graph" },
    { id: "orderretriever_motivos_de_rejeicao", section: "Defini\xE7\xF5es", icon: "dot", label: "Motivos de rejei\xE7\xE3o", adminOnly: true, title: "Motivos de rejei\xE7\xE3o", tooltip: "Motivos de rejei\xE7\xE3o" },
    { id: "orderretriever_mapa_sac", section: "Defini\xE7\xF5es", icon: "dot", label: "Mapa SAC", adminOnly: true, title: "Mapa SAC", tooltip: "Nome do respons\xE1vel no PHC \u2192 utilizador do hub" },
    { id: "orderretriever_dominios_internos", section: "Defini\xE7\xF5es", icon: "dot", label: "Dom\xEDnios da casa", adminOnly: true, title: "Dom\xEDnios da casa", tooltip: "Dom\xEDnios de email nossos: um email deles foi reencaminhado e o cliente \xE9 o do remetente original" },
    { id: "orderretriever_apagadas", section: "Defini\xE7\xF5es", icon: "dot", label: "Apagadas", adminOnly: false, scoped: true, title: "Apagadas", tooltip: "As encomendas apagadas, para as repor" },
    { id: "orderretriever_ligacao_ia", section: "Defini\xE7\xF5es", icon: "cog", label: "Liga\xE7\xE3o \xE0 IA", adminOnly: true, title: "Liga\xE7\xE3o \xE0 IA", tooltip: "Chave, modelo e pre\xE7os da API de IA" },
    { id: "orderretriever_estado_ia", section: "Defini\xE7\xF5es", icon: "dot", label: "Estado da IA", adminOnly: true, title: "Estado da IA", tooltip: "Liga\xE7\xE3o, consumo e erros da API de IA" },
    { id: "orderretriever_aprendizagem", section: "Defini\xE7\xF5es", icon: "dot", label: "Aprendizagem", adminOnly: true, title: "Aprendizagem", tooltip: "Corre\xE7\xF5es por campo e por cliente, tempo chegada\u2192aprova\xE7\xE3o por SAC" },
    { id: "orderretriever_prompt_base", section: "Defini\xE7\xF5es", icon: "dot", label: "Prompt base", adminOnly: true, title: "Prompt base", tooltip: "As regras gerais da leitura, com as vers\xF5es anteriores" },
    { id: "orderretriever_regras", section: "Defini\xE7\xF5es", icon: "dot", label: "Regras por cliente", adminOnly: true, title: "Regras por cliente", tooltip: "As regras escritas para cada cliente, com hist\xF3rico" }
  ],
  render: {
    orderretriever: (ctx) => React.createElement(window.OrderretrieverView, {
      routeId: ctx && ctx.view,
      entidade: ctx && ctx.entidade,
      params: ctx && ctx.params,
      navigate: ctx && ctx.navigate,
      reportCrumb: ctx && ctx.reportCrumb,
      registerLeaveGuard: ctx && ctx.registerLeaveGuard
    }),
    orderretriever_saida: () => React.createElement(window.OrderretrieverSaidaView),
    orderretriever_ligacao_ao_graph: () => React.createElement(window.OrderretrieverLigacaoaographView),
    orderretriever_motivos_de_rejeicao: () => React.createElement(window.OrderretrieverMotivosderejeicaoView),
    orderretriever_mapa_sac: () => React.createElement(window.OrderretrieverMapasacView),
    orderretriever_dominios_internos: () => React.createElement(window.OrderretrieverDominiosinternosView),
    orderretriever_apagadas: () => React.createElement(window.OrderretrieverApagadasView),
    orderretriever_ligacao_ia: () => React.createElement(window.OrderretrieverLigacaoIaView),
    orderretriever_estado_ia: (ctx) => React.createElement(window.OrderretrieverEstadoIaView, {
      navigate: ctx && ctx.navigate
    }),
    orderretriever_aprendizagem: (ctx) => React.createElement(window.OrderretrieverAprendizagemView, {
      routeId: ctx && ctx.view,
      params: ctx && ctx.params
    }),
    orderretriever_prompt_base: () => React.createElement(window.OrderretrieverPromptBaseView),
    orderretriever_regras: () => React.createElement(window.OrderretrieverRegrasView)
  }
});

// ===== primustrack/frontend/primustrack-api.jsx =====
(function() {
  function getCookie(name) {
    const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? m.pop() : "";
  }
  function req(path, { method = "GET", body, params } = {}) {
    let url = path;
    if (params) {
      const q = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v !== void 0 && v !== null && v !== "") q.append(k, v);
      });
      const s = q.toString();
      if (s) url += (url.includes("?") ? "&" : "?") + s;
    }
    const opts = { method, credentials: "same-origin", headers: {} };
    if (body !== void 0) {
      opts.headers["Content-Type"] = "application/json";
      opts.headers["X-CSRFToken"] = getCookie("csrftoken");
      opts.body = JSON.stringify(body);
    } else if (method !== "GET") {
      opts.headers["X-CSRFToken"] = getCookie("csrftoken");
    }
    return fetch(url, opts).then((r) => {
      if (r.status === 204) return null;
      if (!r.ok) return r.json().then((e) => Promise.reject(e)).catch(() => Promise.reject({ status: r.status }));
      return r.json();
    });
  }
  function erroMensagem(err, fallback) {
    const d = err && typeof err.detail === "string" ? err.detail.trim() : "";
    return d || fallback;
  }
  const B = "/api/primustrack";
  window.PrimustrackAPI = {
    req,
    erroMensagem,
    casos: (params) => req(`${B}/casos/`, { params }),
    casoFases: (ref) => req(`${B}/casos/${encodeURIComponent(ref)}/fases/`),
    casosFasesBulk: (referencias) => req(`${B}/casos/fases/`, { method: "POST", body: { referencias } }),
    casosSlaBulk: (referencias) => req(`${B}/casos/sla/`, { method: "POST", body: { referencias } }),
    putChecklist: (ref, body) => req(`${B}/casos/${encodeURIComponent(ref)}/checklist/`, { method: "PUT", body }),
    putAvaliacao: (ref, body) => req(`${B}/casos/${encodeURIComponent(ref)}/avaliacao/`, { method: "PUT", body }),
    casoDetalhe: (ref) => req(`${B}/casos/${encodeURIComponent(ref)}/detalhe/`),
    casoErp: (ref) => req(`${B}/casos/${encodeURIComponent(ref)}/erp/`),
    putCasoDatas: (ref, body) => req(`${B}/casos/${encodeURIComponent(ref)}/datas/`, { method: "PUT", body }),
    auditUrl: (ref) => `${B}/casos/${encodeURIComponent(ref)}/audit/`,
    casoAcoes: (ref) => req(`${B}/casos/${encodeURIComponent(ref)}/acoes/`),
    addCasoAcao: (ref, tipo_id_slug, descricao, atribuido_id = null, data_limite = null) => req(`${B}/casos/${encodeURIComponent(ref)}/acoes/`, { method: "POST", body: { tipo_id_slug, descricao, atribuido_id, data_limite } }),
    deleteCasoAcao: (ref, id) => req(`${B}/casos/${encodeURIComponent(ref)}/acoes/${id}/`, { method: "DELETE" }),
    tratarCasoAcao: (ref, id) => req(`${B}/casos/${encodeURIComponent(ref)}/acoes/${id}/tratar/`, { method: "POST", body: {} }),
    prazoCasoAcao: (ref, id, data_limite) => req(
      `${B}/casos/${encodeURIComponent(ref)}/acoes/${id}/prazo/`,
      { method: "POST", body: { data_limite } }
    ),
    checklistItens: () => req(`${B}/checklist-itens/`),
    createChecklistItem: (data) => req(`${B}/checklist-itens/`, { method: "POST", body: data }),
    updateChecklistItem: (id, patch) => req(`${B}/checklist-itens/${id}/`, { method: "PATCH", body: patch }),
    deleteChecklistItem: (id) => req(`${B}/checklist-itens/${id}/`, { method: "DELETE" }),
    motivos: () => req(`${B}/motivos/`),
    createMotivo: (data) => req(`${B}/motivos/`, { method: "POST", body: data }),
    updateMotivo: (id, patch) => req(`${B}/motivos/${id}/`, { method: "PATCH", body: patch }),
    deleteMotivo: (id) => req(`${B}/motivos/${id}/`, { method: "DELETE" }),
    kanbanEstados: () => req(`${B}/kanban-estados/`),
    createKanbanEstado: (data) => req(`${B}/kanban-estados/`, { method: "POST", body: data }),
    updateKanbanEstado: (id, patch) => req(`${B}/kanban-estados/${id}/`, { method: "PATCH", body: patch }),
    deleteKanbanEstado: (id) => req(`${B}/kanban-estados/${id}/`, { method: "DELETE" }),
    putCasoEstado: (ref, estado) => req(`${B}/casos/${encodeURIComponent(ref)}/estado/`, { method: "PUT", body: { estado } }),
    casoAnexos: (ref) => req(`${B}/casos/${encodeURIComponent(ref)}/anexos/`),
    anexoDownloadUrl: (ref, anexosstamp) => `${B}/casos/${encodeURIComponent(ref)}/anexo/${encodeURIComponent(anexosstamp)}/download/`,
    milestones: () => req(`${B}/milestones/`),
    slas: () => req(`${B}/slas/`),
    createSla: (data) => req(`${B}/slas/`, { method: "POST", body: data }),
    updateSla: (id, patch) => req(`${B}/slas/${id}/`, { method: "PATCH", body: patch }),
    deleteSla: (id) => req(`${B}/slas/${id}/`, { method: "DELETE" }),
    feriados: () => req(`${B}/feriados/`),
    createFeriado: (data) => req(`${B}/feriados/`, { method: "POST", body: data }),
    deleteFeriado: (id) => req(`${B}/feriados/${id}/`, { method: "DELETE" })
  };
})();

// ===== primustrack/frontend/primustrack_slas.jsx =====
function primustrackErrMsg(e) {
  if (!e) return "Erro";
  if (e.detail) return e.detail;
  const firstList = Object.values(e).find((v) => Array.isArray(v) && v.length);
  if (firstList) return firstList[0];
  return e.message || "Erro";
}
function PrimustrackSlasView() {
  const EMPTY_SLA = { de_milestone: "", ate_milestone: "", dias_uteis: 1, is_active: true };
  const EMPTY_FERIADO = { data: "", label: "" };
  const [milestones, setMilestones] = React.useState([]);
  const [slas, setSlas] = React.useState([]);
  const [feriados, setFeriados] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [slaDraft, setSlaDraft] = React.useState(EMPTY_SLA);
  const [slaEditingId, setSlaEditingId] = React.useState(null);
  const [slaSaving, setSlaSaving] = React.useState(false);
  const [slaPendingDelete, setSlaPendingDelete] = React.useState(null);
  const [feriadoDraft, setFeriadoDraft] = React.useState(EMPTY_FERIADO);
  const [feriadoSaving, setFeriadoSaving] = React.useState(false);
  const [feriadoPendingDelete, setFeriadoPendingDelete] = React.useState(null);
  const labelOf = (key) => (milestones.find((m) => m.key === key) || {}).label || key;
  const SLA_COLUNAS = [
    {
      key: "de_milestone",
      label: "De",
      width: 230,
      minWidth: 180,
      fixed: true,
      render: (it) => labelOf(it.de_milestone)
    },
    {
      key: "ate_milestone",
      label: "At\xE9",
      width: 230,
      minWidth: 180,
      render: (it) => labelOf(it.ate_milestone)
    },
    {
      key: "dias_uteis",
      label: "Dias \xFAteis",
      width: 110,
      minWidth: 95,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.dias_uteis)
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 80,
      minWidth: 65,
      render: (it) => it.is_active ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 150,
      minWidth: 130,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setSlaEditingId(it.id);
        setSlaDraft({ ...it });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSlaPendingDelete(it), style: { marginLeft: 6 } }, "Apagar"))
    }
  ];
  const FERIADO_COLUNAS = [
    {
      key: "data",
      label: "Data",
      width: 130,
      minWidth: 105,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, it.data)
    },
    {
      key: "label",
      label: "Label",
      width: 240,
      minWidth: 150,
      render: (it) => it.label || "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 110,
      minWidth: 95,
      render: (it) => /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setFeriadoPendingDelete(it) }, "Apagar")
    }
  ];
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const [ms, sl, fe] = await Promise.all([
        window.PrimustrackAPI.milestones(),
        window.PrimustrackAPI.slas(),
        window.PrimustrackAPI.feriados()
      ]);
      setMilestones(ms.results || ms || []);
      setSlas(sl.results || sl || []);
      setFeriados(fe.results || fe || []);
    } catch (e) {
      setError(primustrackErrMsg(e));
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    load();
  }, []);
  const cancelSlaEdit = () => {
    setSlaEditingId(null);
    setSlaDraft(EMPTY_SLA);
  };
  const saveSla = async () => {
    if (!slaDraft.de_milestone || !slaDraft.ate_milestone) {
      window.srToast?.("Escolhe os dois milestones.", "warning");
      return;
    }
    if (slaDraft.de_milestone === slaDraft.ate_milestone) {
      window.srToast?.('"De" e "At\xE9" t\xEAm de ser diferentes.', "warning");
      return;
    }
    setSlaSaving(true);
    try {
      const payload = {
        de_milestone: slaDraft.de_milestone,
        ate_milestone: slaDraft.ate_milestone,
        dias_uteis: Number(slaDraft.dias_uteis) || 1,
        is_active: !!slaDraft.is_active
      };
      if (slaEditingId) await window.PrimustrackAPI.updateSla(slaEditingId, payload);
      else await window.PrimustrackAPI.createSla(payload);
      cancelSlaEdit();
      await load();
      window.srToast?.("SLA gravado.", "success");
    } catch (e) {
      window.srToast?.(primustrackErrMsg(e), "error");
    } finally {
      setSlaSaving(false);
    }
  };
  const doDeleteSla = async () => {
    const it = slaPendingDelete;
    setSlaPendingDelete(null);
    try {
      await window.PrimustrackAPI.deleteSla(it.id);
      await load();
      window.srToast?.("SLA apagado.", "success");
    } catch (e) {
      window.srToast?.(primustrackErrMsg(e), "error");
    }
  };
  const cancelFeriadoEdit = () => {
    setFeriadoDraft(EMPTY_FERIADO);
  };
  const saveFeriado = async () => {
    if (!feriadoDraft.data) {
      window.srToast?.("Escolhe uma data.", "warning");
      return;
    }
    setFeriadoSaving(true);
    try {
      await window.PrimustrackAPI.createFeriado({ data: feriadoDraft.data, label: feriadoDraft.label || "" });
      cancelFeriadoEdit();
      await load();
      window.srToast?.("Feriado adicionado.", "success");
    } catch (e) {
      window.srToast?.(primustrackErrMsg(e), "error");
    } finally {
      setFeriadoSaving(false);
    }
  };
  const doDeleteFeriado = async () => {
    const it = feriadoPendingDelete;
    setFeriadoPendingDelete(null);
    try {
      await window.PrimustrackAPI.deleteFeriado(it.id);
      await load();
      window.srToast?.("Feriado apagado.", "success");
    } catch (e) {
      window.srToast?.(primustrackErrMsg(e), "error");
    }
  };
  return /* @__PURE__ */ React.createElement("div", null, error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "primustrack",
      viewId: "slas",
      title: "SLAs",
      columns: SLA_COLUNAS,
      data: slas,
      pagination: "none",
      rowKey: (it) => it.id,
      empty: "Ainda sem SLAs configurados."
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, slaEditingId ? "Editar SLA" : "Novo SLA")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "De", /* @__PURE__ */ React.createElement("select", { value: slaDraft.de_milestone, onChange: (e) => setSlaDraft({ ...slaDraft, de_milestone: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), milestones.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.key, value: m.key }, m.label)))), /* @__PURE__ */ React.createElement("label", null, "At\xE9", /* @__PURE__ */ React.createElement("select", { value: slaDraft.ate_milestone, onChange: (e) => setSlaDraft({ ...slaDraft, ate_milestone: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), milestones.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.key, value: m.key }, m.label)))), /* @__PURE__ */ React.createElement("label", null, "Dias \xFAteis", /* @__PURE__ */ React.createElement("input", { type: "number", min: "1", value: slaDraft.dias_uteis, onChange: (e) => setSlaDraft({ ...slaDraft, dias_uteis: e.target.value }) })), /* @__PURE__ */ React.createElement("label", null, "Ativo", /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!slaDraft.is_active, onChange: (e) => setSlaDraft({ ...slaDraft, is_active: e.target.checked }) })), slaEditingId && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelSlaEdit }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: saveSla, disabled: slaSaving }, slaSaving ? "A guardar\u2026" : slaEditingId ? "Guardar" : "Adicionar"))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "primustrack",
      viewId: "slas-feriados",
      title: "Feriados",
      columns: FERIADO_COLUNAS,
      data: feriados,
      pagination: "none",
      rowKey: (it) => it.id,
      empty: "Ainda sem feriados configurados."
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Novo feriado")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "Data", /* @__PURE__ */ React.createElement("input", { type: "date", value: feriadoDraft.data, onChange: (e) => setFeriadoDraft({ ...feriadoDraft, data: e.target.value }) })), /* @__PURE__ */ React.createElement("label", null, "Label (opcional)", /* @__PURE__ */ React.createElement("input", { value: feriadoDraft.label, onChange: (e) => setFeriadoDraft({ ...feriadoDraft, label: e.target.value }) })), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: saveFeriado, disabled: feriadoSaving }, feriadoSaving ? "A guardar\u2026" : "Adicionar"))), slaPendingDelete && /* @__PURE__ */ React.createElement(window.ModalShell, { title: "Apagar SLA", onClose: () => setSlaPendingDelete(null) }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar o SLA ", /* @__PURE__ */ React.createElement("strong", null, labelOf(slaPendingDelete.de_milestone), " \u2192 ", labelOf(slaPendingDelete.ate_milestone)), "?"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSlaPendingDelete(null) }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { background: "#c4434b" }, onClick: doDeleteSla }, "Apagar"))), feriadoPendingDelete && /* @__PURE__ */ React.createElement(window.ModalShell, { title: "Apagar feriado", onClose: () => setFeriadoPendingDelete(null) }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar o feriado ", /* @__PURE__ */ React.createElement("strong", null, feriadoPendingDelete.data), feriadoPendingDelete.label ? ` (${feriadoPendingDelete.label})` : "", "?"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setFeriadoPendingDelete(null) }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { background: "#c4434b" }, onClick: doDeleteFeriado }, "Apagar"))));
}
window.PrimustrackSlasView = PrimustrackSlasView;

// ===== primustrack/frontend/primustrack_kanban.jsx =====
function ptKanbanColumns(estados) {
  const active = (estados || []).filter((e) => e.is_active).slice().sort((a, b) => a.ordem - b.ordem || a.label.localeCompare(b.label));
  return [{ id: "_unset", label: "Por classificar", color: "var(--muted)" }].concat(active);
}
function ptGroupByEstado(casos, validIds) {
  const isValid = validIds ? (k) => validIds.has ? validIds.has(k) : validIds.includes(k) : null;
  const g = { _unset: [] };
  (casos || []).forEach((c) => {
    let k = c.estado && c.estado.id != null ? String(c.estado.id) : "_unset";
    if (isValid && !isValid(k)) k = "_unset";
    (g[k] = g[k] || []).push(c);
  });
  return g;
}
window.ptKanbanColumns = ptKanbanColumns;
window.ptGroupByEstado = ptGroupByEstado;
const PT_KSEM = { verde: "#15803d", amarelo: "#ca8a04", vermelho: "#b91c1c", sem_dados: "var(--border)" };
const PT_KSEM_LABEL = { verde: "No prazo", amarelo: "Em risco", vermelho: "Atrasado", sem_dados: "Sem data" };
const ell = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
function PtKanbanCard({ caso, fases, onOpen, onDragStart }) {
  const ent = fases[caso.referencia] && fases[caso.referencia].entrega;
  const estado = ent && ent.estado || "sem_dados";
  const dataMeta = caso.data_entrega || caso.data_solicitada || null;
  const dataTitle = caso.data_entrega ? "Data de entrega" : "Data solicitada";
  return React.createElement(
    "div",
    {
      draggable: true,
      onDragStart,
      onClick: () => onOpen(caso.referencia),
      style: {
        background: "var(--panel)",
        border: "1px solid var(--border)",
        borderRadius: 6,
        padding: 8,
        cursor: "pointer",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        display: "flex",
        flexDirection: "column",
        gap: 6
      }
    },
    // header: referência + semáforo de entrega
    React.createElement(
      "div",
      { style: { display: "flex", alignItems: "baseline", gap: 6 } },
      React.createElement("strong", { className: "td-mono", style: Object.assign({ fontSize: 12.5, lineHeight: 1.3, flex: 1, minWidth: 0 }, ell) }, caso.referencia),
      React.createElement("span", {
        title: ent ? ent.detalhe : PT_KSEM_LABEL[estado],
        style: { display: "inline-block", width: 9, height: 9, borderRadius: "50%", background: PT_KSEM[estado], flex: "0 0 auto" }
      })
    ),
    // sub-linha: descrição
    caso.descricao ? React.createElement("div", { style: Object.assign({ fontSize: 11.5, color: "var(--muted)", lineHeight: 1.3 }, ell) }, caso.descricao) : null,
    // meta: responsável + data
    React.createElement(
      "div",
      { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "var(--text-2)" } },
      React.createElement("span", { style: Object.assign({ flex: 1, minWidth: 0 }, ell) }, caso.responsavel || "sem respons\xE1vel"),
      dataMeta ? React.createElement("span", { className: "td-mono", title: dataTitle, style: { color: "var(--muted)", flex: "0 0 auto" } }, dataMeta) : null
    )
  );
}
window.PtKanbanCard = PtKanbanCard;
function PtKanbanView({ casos, fases, estados, onOpen, onMoved }) {
  const [rows, setRows] = React.useState(casos);
  const [dragOver, setDragOver] = React.useState(null);
  const draggingRef = React.useRef(null);
  React.useEffect(() => {
    setRows(casos);
  }, [casos]);
  const columns = ptKanbanColumns(estados);
  const grouped = ptGroupByEstado(rows, new Set(columns.map((c) => String(c.id))));
  const onDrop = async (colId) => {
    setDragOver(null);
    const ref = draggingRef.current;
    draggingRef.current = null;
    if (!ref) return;
    const target = colId === "_unset" ? null : Number(colId);
    const prev = rows;
    const est = target == null ? null : estados.find((e) => e.id === target) || null;
    setRows(rows.map((c) => c.referencia === ref ? { ...c, estado: est ? { id: est.id, label: est.label, color: est.color } : null } : c));
    try {
      await window.PrimustrackAPI.putCasoEstado(ref, target);
      if (onMoved) onMoved(ref, est);
    } catch (e) {
      setRows(prev);
      window.srToast?.("N\xE3o foi poss\xEDvel mover o caso.", "error");
    }
  };
  return React.createElement(
    "div",
    { style: { display: "flex", gap: 10, overflowX: "auto", padding: 12, alignItems: "stretch" } },
    columns.map((col) => {
      const items = grouped[col.id] || [];
      const drop = dragOver === col.id;
      return React.createElement(
        "div",
        {
          key: col.id,
          style: {
            flex: "0 0 280px",
            minWidth: 280,
            background: drop ? "var(--panel)" : "var(--bg)",
            border: `1px solid ${drop ? "var(--accent)" : "var(--border)"}`,
            borderRadius: 8,
            padding: 8,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            maxHeight: "calc(100vh - 180px)"
          },
          onDragOver: (e) => {
            e.preventDefault();
            setDragOver(col.id);
          },
          onDragLeave: () => setDragOver(null),
          onDrop: () => onDrop(col.id)
        },
        // cabeçalho da coluna: bolinha da stage + label + contagem
        React.createElement(
          "div",
          { style: { display: "flex", alignItems: "center", gap: 6, marginBottom: 8, padding: "2px 4px" } },
          React.createElement("span", { style: { display: "inline-block", width: 10, height: 10, borderRadius: 5, background: col.color || "#9aa3ad", flex: "0 0 auto" } }),
          React.createElement("span", { style: { fontSize: 12.5, fontWeight: 700 } }, col.label),
          React.createElement("span", { style: { fontSize: 11, color: "var(--muted)", fontWeight: 500 } }, items.length)
        ),
        // corpo com scroll
        React.createElement(
          "div",
          { style: { flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: 6 } },
          items.map((c) => React.createElement(PtKanbanCard, {
            key: c.referencia,
            caso: c,
            fases,
            onOpen,
            onDragStart: () => {
              draggingRef.current = c.referencia;
            }
          })),
          items.length === 0 ? React.createElement("div", { style: { fontSize: 11.5, color: "var(--muted)", textAlign: "center", padding: 8 } }, "Solta aqui um cart\xE3o.") : null
        )
      );
    })
  );
}
window.PtKanbanView = PtKanbanView;

// ===== primustrack/frontend/primustrack_crossfilter.jsx =====
(function() {
  const DIMS = ["estado", "tipoArtigo", "entrega", "sla"];
  const LABELS = { estado: "Estado", tipoArtigo: "Tipo artigo", entrega: "Entrega", sla: "SLA" };
  function empty() {
    return { estado: /* @__PURE__ */ new Set(), tipoArtigo: /* @__PURE__ */ new Set(), entrega: /* @__PURE__ */ new Set(), sla: /* @__PURE__ */ new Set() };
  }
  function valueOf(caso, dim, fases) {
    if (dim === "tipoArtigo") return caso.tipo_artigo || "";
    if (dim === "estado") return caso.estado && caso.estado.id != null ? String(caso.estado.id) : "_unset";
    if (dim === "entrega") {
      const e = fases[caso.referencia] && fases[caso.referencia].entrega;
      return e && e.estado || "sem_dados";
    }
    if (dim === "sla") return caso.sla?.estado || "na";
    return "";
  }
  function apply(casos, cf, fases) {
    return (casos || []).filter((c) => DIMS.every((dim) => {
      const set = cf[dim];
      return !set || set.size === 0 || set.has(valueOf(c, dim, fases || {}));
    }));
  }
  function toggle(cf, dim, value) {
    const next = { estado: new Set(cf.estado), tipoArtigo: new Set(cf.tipoArtigo), entrega: new Set(cf.entrega), sla: new Set(cf.sla) };
    if (next[dim].has(value)) next[dim].delete(value);
    else next[dim].add(value);
    return next;
  }
  window.PtCrossFilter = { empty, apply, toggle, DIMS, LABELS };
  window.PtCrossFilterChips = function({ cf, estados, onRemove, onClear }) {
    const estadoLabel = (v) => v === "_unset" ? "Por classificar" : ((estados || []).find((e) => String(e.id) === v) || {}).label || v;
    const chips = [];
    DIMS.forEach((dim) => (cf[dim] || /* @__PURE__ */ new Set()).forEach((v) => {
      const text = dim === "estado" ? estadoLabel(v) : v;
      chips.push(React.createElement("button", {
        key: `${dim}:${v}`,
        className: "filter-chip active",
        style: { padding: "1px 6px", gap: 4 },
        onClick: () => onRemove(dim, v)
      }, `${LABELS[dim]}: ${text}`, " \xD7"));
    }));
    if (chips.length === 0) return null;
    return React.createElement(
      "div",
      { style: { display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", margin: "6px 0" } },
      chips,
      React.createElement("button", { className: "btn ghost sm", onClick: onClear }, "Limpar tudo")
    );
  };
})();

// ===== primustrack/frontend/primustrack_dashboard.jsx =====
function ptCountBy(rows, keyFn) {
  const order = [];
  const m = /* @__PURE__ */ new Map();
  (rows || []).forEach((r) => {
    const k = keyFn(r);
    if (!m.has(k)) {
      m.set(k, 0);
      order.push(k);
    }
    m.set(k, m.get(k) + 1);
  });
  return order.map((k) => ({ key: k, n: m.get(k) }));
}
window.ptCountBy = ptCountBy;
function ptMonthEntregaRows(casos, fases) {
  const m = /* @__PURE__ */ new Map();
  (casos || []).forEach((c) => {
    const mes = (c.primeira_encomenda || "").slice(0, 7);
    if (!mes) return;
    if (!m.has(mes)) m.set(mes, { mes, verde: 0, vermelho: 0, total: 0 });
    const row = m.get(mes);
    const est = fases[c.referencia] && fases[c.referencia].entrega && fases[c.referencia].entrega.estado || "";
    if (est === "verde") row.verde += 1;
    else if (est === "vermelho") row.vermelho += 1;
    row.total += 1;
  });
  return Array.from(m.values()).sort((a, b) => a.mes < b.mes ? -1 : a.mes > b.mes ? 1 : 0);
}
window.ptMonthEntregaRows = ptMonthEntregaRows;
const PT_DSEM = { verde: "#15803d", amarelo: "#ca8a04", vermelho: "#b91c1c", sem_dados: "var(--border)" };
const PT_ENTREGA_LABEL = { verde: "No prazo", amarelo: "Em risco", vermelho: "Atrasado", sem_dados: "Sem data" };
const PT_DSLA_TO_SEM = { cumprido: "verde", em_curso: "amarelo", estourado: "vermelho", em_atraso: "vermelho", na: "sem_dados" };
const PT_DSLA_LABEL = { cumprido: "Cumprido", em_curso: "Em curso", estourado: "Estourado", em_atraso: "Em atraso", na: "Sem SLA" };
const PT_SLA_ORDER = ["cumprido", "em_curso", "estourado", "em_atraso", "na"];
function PtBarRow({ label, dot, n, max, active, onClick }) {
  return React.createElement(
    "div",
    {
      onClick,
      style: { display: "flex", alignItems: "center", gap: 8, cursor: "pointer", padding: "2px 0", opacity: active === false ? 0.45 : 1 }
    },
    dot ? React.createElement("span", { style: { width: 9, height: 9, borderRadius: "50%", background: dot, flex: "0 0 auto" } }) : null,
    React.createElement("span", { style: { fontSize: 12.5, width: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, label),
    React.createElement(
      "div",
      { style: { flex: 1, background: "var(--bg)", borderRadius: 4, height: 14 } },
      React.createElement("div", { style: { width: `${max ? n / max * 100 : 0}%`, background: dot || "var(--accent)", height: "100%", borderRadius: 4 } })
    ),
    React.createElement("span", { className: "td-mono", style: { fontSize: 12, width: 34, textAlign: "right" } }, n)
  );
}
function PtMonthRow({ mes, verde, vermelho, total, max }) {
  const outros = Math.max(0, total - verde - vermelho);
  const pctOf = (n) => max ? n / max * 100 : 0;
  return React.createElement(
    "div",
    { style: { display: "flex", alignItems: "center", gap: 8, padding: "2px 0" } },
    React.createElement("span", { style: { fontSize: 12.5, width: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, mes),
    React.createElement(
      "div",
      { style: { flex: 1, background: "var(--bg)", borderRadius: 4, height: 14, display: "flex", overflow: "hidden" } },
      verde ? React.createElement("div", { style: { width: `${pctOf(verde)}%`, background: PT_DSEM.verde, height: "100%" } }) : null,
      vermelho ? React.createElement("div", { style: { width: `${pctOf(vermelho)}%`, background: PT_DSEM.vermelho, height: "100%" } }) : null,
      outros ? React.createElement("div", { style: { width: `${pctOf(outros)}%`, background: "var(--border)", height: "100%" } }) : null
    ),
    React.createElement("span", { className: "td-mono", style: { fontSize: 12, width: 34, textAlign: "right" } }, total)
  );
}
function PtCard({ title, children }) {
  return React.createElement(
    "div",
    { className: "panel", style: { padding: 14, flex: "1 1 300px", minWidth: 280 } },
    React.createElement("div", { className: "section-label", style: { marginBottom: 8 } }, title),
    children
  );
}
function PtDashboardView({ casos, fases, estados }) {
  const [cf, setCf] = React.useState(() => window.PtCrossFilter.empty());
  const filtered = window.PtCrossFilter.apply(casos, cf, fases);
  const toggle = (dim, value) => setCf((prev) => window.PtCrossFilter.toggle(prev, dim, value));
  const clear = () => setCf(window.PtCrossFilter.empty());
  const colById = {};
  (estados || []).forEach((e) => {
    colById[String(e.id)] = e;
  });
  const stageRows = ptCountBy(filtered, (c) => c.estado && c.estado.id != null ? String(c.estado.id) : "_unset");
  const stageMax = Math.max(1, ...stageRows.map((r) => r.n));
  const tipoRows = ptCountBy(filtered, (c) => c.tipo_artigo || "\u2014");
  const tipoMax = Math.max(1, ...tipoRows.map((r) => r.n));
  const entRows = ["verde", "amarelo", "vermelho", "sem_dados"].map((k) => ({
    key: k,
    n: filtered.filter((c) => (fases[c.referencia] && fases[c.referencia].entrega && fases[c.referencia].entrega.estado || "sem_dados") === k).length
  }));
  const entMax = Math.max(1, ...entRows.map((r) => r.n));
  const slaRows = ptCountBy(filtered, (c) => c.sla?.estado || "na").sort((a, b) => PT_SLA_ORDER.indexOf(a.key) - PT_SLA_ORDER.indexOf(b.key));
  const slaMax = Math.max(1, ...slaRows.map((r) => r.n));
  const monthRows = ptMonthEntregaRows(filtered, fases);
  const monthMax = Math.max(1, ...monthRows.map((r) => r.total));
  const atrasados = filtered.filter((c) => (fases[c.referencia] && fases[c.referencia].entrega && fases[c.referencia].entrega.estado || "") === "vermelho");
  const motivoRows = ptCountBy(atrasados, (c) => c.motivo || "sem motivo");
  const motivoMax = Math.max(1, ...motivoRows.map((r) => r.n));
  const total = filtered.length;
  const nAtraso = entRows.find((r) => r.key === "vermelho").n;
  const nEntregue = entRows.find((r) => r.key === "verde").n;
  const pct = (n) => total ? Math.round(n / total * 100) : 0;
  return React.createElement(
    "div",
    { style: { padding: 12 } },
    React.createElement(
      "div",
      { style: { display: "flex", gap: 16, marginBottom: 8, fontSize: 13 } },
      React.createElement("span", null, React.createElement("strong", null, total), " casos"),
      React.createElement("span", { style: { color: PT_DSEM.verde } }, `${pct(nEntregue)}% no prazo`),
      React.createElement("span", { style: { color: PT_DSEM.vermelho } }, `${pct(nAtraso)}% atrasado`)
    ),
    React.createElement(window.PtCrossFilterChips, { cf, estados, onRemove: toggle, onClear: clear }),
    React.createElement(
      "div",
      { style: { display: "flex", flexWrap: "wrap", gap: 12, marginTop: 8 } },
      React.createElement(
        PtCard,
        { title: "Por stage" },
        stageRows.map((r) => React.createElement(PtBarRow, {
          key: r.key,
          label: r.key === "_unset" ? "Por classificar" : colById[r.key] ? colById[r.key].label : r.key,
          dot: r.key === "_unset" ? "var(--muted)" : colById[r.key] ? colById[r.key].color : "var(--accent)",
          n: r.n,
          max: stageMax,
          active: cf.estado.size === 0 || cf.estado.has(r.key),
          onClick: () => toggle("estado", r.key)
        }))
      ),
      React.createElement(
        PtCard,
        { title: "Por tipo de artigo" },
        tipoRows.map((r) => React.createElement(PtBarRow, {
          key: r.key,
          label: r.key,
          n: r.n,
          max: tipoMax,
          active: cf.tipoArtigo.size === 0 || cf.tipoArtigo.has(r.key),
          onClick: () => toggle("tipoArtigo", r.key)
        }))
      ),
      React.createElement(
        PtCard,
        { title: "Por SLA" },
        slaRows.map((r) => React.createElement(PtBarRow, {
          key: r.key,
          label: PT_DSLA_LABEL[r.key] || r.key,
          dot: PT_DSEM[PT_DSLA_TO_SEM[r.key] || "sem_dados"],
          n: r.n,
          max: slaMax,
          active: cf.sla.size === 0 || cf.sla.has(r.key),
          onClick: () => toggle("sla", r.key)
        }))
      ),
      React.createElement(
        PtCard,
        { title: "Entrega: no prazo vs atrasado" },
        entRows.map((r) => React.createElement(PtBarRow, {
          key: r.key,
          label: PT_ENTREGA_LABEL[r.key],
          dot: PT_DSEM[r.key],
          n: r.n,
          max: entMax,
          active: cf.entrega.size === 0 || cf.entrega.has(r.key),
          onClick: () => toggle("entrega", r.key)
        })),
        monthRows.length ? React.createElement(
          "div",
          { style: { marginTop: 10 } },
          React.createElement("div", { className: "section-label", style: { marginBottom: 6 } }, "Evolu\xE7\xE3o por m\xEAs"),
          monthRows.map((r) => React.createElement(PtMonthRow, {
            key: r.mes,
            mes: r.mes,
            verde: r.verde,
            vermelho: r.vermelho,
            total: r.total,
            max: monthMax
          }))
        ) : null,
        motivoRows.length ? React.createElement(
          "div",
          { style: { marginTop: 10 } },
          React.createElement("div", { className: "section-label", style: { marginBottom: 6 } }, "Motivo dos atrasados"),
          motivoRows.map((r) => React.createElement(PtBarRow, { key: r.key, label: r.key, n: r.n, max: motivoMax }))
        ) : null
      )
    )
  );
}
window.PtDashboardView = PtDashboardView;

// ===== primustrack/frontend/primustrack.jsx =====
const PT_SEM = { verde: "#15803d", amarelo: "#ca8a04", vermelho: "#b91c1c", sem_dados: "var(--border)" };
const PT_ANO = (/* @__PURE__ */ new Date()).getFullYear();
const PT_FILTROS = [
  { key: "desde-2026-07-01", label: "A partir de 01/07/2026", params: { desde: "2026-07-01" } },
  { key: "dias-30", label: "\xDAltimos 30 dias", params: { janela: 30 } },
  { key: "dias-60", label: "\xDAltimos 60 dias", params: { janela: 60 } },
  { key: "dias-90", label: "\xDAltimos 90 dias", params: { janela: 90 } },
  { key: `ano-${PT_ANO}`, label: `A partir de ${PT_ANO}`, params: { ano: PT_ANO } }
];
const PT_FILTRO_DEFAULT = "desde-2026-07-01";
const PT_PAGE_SIZE = 50;
const PT_ERRO_FALLBACK = "N\xE3o foi poss\xEDvel carregar os casos. Verifica a liga\xE7\xE3o ao ERP.";
const PT_ENTREGA_OPTS = [
  { value: "verde", label: "Verde", dot: PT_SEM.verde },
  { value: "amarelo", label: "Amarelo", dot: PT_SEM.amarelo },
  { value: "vermelho", label: "Vermelho", dot: PT_SEM.vermelho },
  { value: "sem_dados", label: "Sem data", dot: "var(--muted)" }
];
const PT_SLA_TO_SEM = { cumprido: "verde", em_curso: "amarelo", estourado: "vermelho", em_atraso: "vermelho", na: "sem_dados" };
const PT_SLA_LABEL = { cumprido: "Cumprido", em_curso: "Em curso", estourado: "Estourado", em_atraso: "Em atraso", na: "Sem SLA" };
const PT_SLA_OPTS = ["cumprido", "em_curso", "estourado", "em_atraso", "na"].map((v) => ({ value: v, label: PT_SLA_LABEL[v], dot: PT_SEM[PT_SLA_TO_SEM[v]] }));
const PT_SEM_RANK = { vermelho: 0, amarelo: 1, verde: 2, sem_dados: 3 };
const PT_SLA_RANK = { estourado: 0, em_atraso: 0, em_curso: 1, cumprido: 2, na: 3 };
const NONE = "__none__";
function PtDot({ estado, title }) {
  return React.createElement("span", {
    title: title || estado,
    style: {
      display: "inline-block",
      width: 10,
      height: 10,
      borderRadius: "50%",
      background: PT_SEM[estado] || "var(--border)"
    }
  });
}
function PtSemaforo({ fase, loading }) {
  if (fase) return React.createElement(PtDot, { estado: fase.estado, title: fase.detalhe });
  return React.createElement(
    "span",
    { style: { color: "var(--muted)", fontSize: 12 } },
    loading ? "a calcular\u2026" : "\u2014"
  );
}
function PtChipFilter({ label, value, setValue, options, emptyLabel }) {
  const set = value;
  const selected = options.filter((o) => set.has(o.value));
  const toggle = (v) => setValue((prev) => {
    const n = new Set(prev);
    if (n.has(v)) n.delete(v);
    else n.add(v);
    return n;
  });
  const summary = selected.length === 0 ? emptyLabel || "Todos" : selected.length === 1 ? selected[0].label : `${selected.length} selecionados`;
  return React.createElement(window.Popover, {
    trigger: React.createElement(
      "button",
      { className: "filter-chip" + (set.size ? " active" : "") },
      React.createElement("span", { style: { color: "var(--muted)" } }, `${label}: `),
      summary,
      window.Ico && window.Ico.chevron ? React.createElement(window.Ico.chevron) : null
    )
  }, () => React.createElement(
    React.Fragment,
    null,
    React.createElement(window.MenuItem, { onClick: () => setValue(/* @__PURE__ */ new Set()) }, "Limpar (todos)"),
    options.map((o) => React.createElement(
      window.MenuItem,
      { key: o.value, onClick: () => toggle(o.value) },
      React.createElement("span", { style: { width: 14, display: "inline-block" } }, set.has(o.value) ? "\u2713" : ""),
      o.dot ? React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: o.dot, display: "inline-block", marginRight: 5 } }) : null,
      o.label
    ))
  ));
}
function PtSearchChips({ terms, setTerms, text, setText, placeholder }) {
  const commit = () => {
    const t = text.trim();
    if (t && !terms.includes(t)) setTerms(terms.concat(t));
    setText("");
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit();
    } else if (e.key === "Backspace" && !text && terms.length) setTerms(terms.slice(0, -1));
  };
  return React.createElement(
    "div",
    { className: "search-input", style: { flexWrap: "wrap", gap: 4 } },
    window.Ico && window.Ico.search ? React.createElement(window.Ico.search) : null,
    terms.map((t) => React.createElement(
      "span",
      {
        key: t,
        className: "filter-chip active",
        style: { padding: "1px 6px", gap: 4, cursor: "default" }
      },
      t,
      React.createElement("button", {
        onClick: () => setTerms(terms.filter((x) => x !== t)),
        title: "Remover",
        style: { border: "none", background: "none", cursor: "pointer", color: "inherit", padding: 0, lineHeight: 1 }
      }, "\xD7")
    )),
    React.createElement("input", {
      type: "text",
      placeholder: terms.length ? "Adicionar termo\u2026" : placeholder,
      value: text,
      onChange: (e) => setText(e.target.value),
      onKeyDown,
      onBlur: commit,
      style: { flex: 1, minWidth: 120, border: "none", outline: "none", background: "transparent" }
    })
  );
}
function PtListaView({ casos, fases, fasesLoading, onOpen }) {
  const [searchTerms, setSearchTerms] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [fEntrega, setFEntrega] = React.useState(/* @__PURE__ */ new Set());
  const [fResp, setFResp] = React.useState(/* @__PURE__ */ new Set());
  const [fMotivo, setFMotivo] = React.useState(/* @__PURE__ */ new Set());
  const [fTipo, setFTipo] = React.useState(/* @__PURE__ */ new Set());
  const [fSla, setFSla] = React.useState(/* @__PURE__ */ new Set());
  const respOpts = [{ value: NONE, label: "\u2014 Sem respons\xE1vel" }].concat(
    [...new Set(casos.map((c) => c.responsavel).filter(Boolean))].sort().map((v) => ({ value: v, label: v }))
  );
  const motivoOpts = [{ value: NONE, label: "\u2014 Sem motivo" }].concat(
    [...new Set(casos.map((c) => c.motivo).filter(Boolean))].sort().map((v) => ({ value: v, label: v }))
  );
  const tipoOpts = [...new Set(casos.map((c) => c.tipo_artigo).filter(Boolean))].sort().map((v) => ({ value: v, label: v }));
  let base = casos;
  if (fTipo.size) base = base.filter((c) => fTipo.has(c.tipo_artigo));
  const searchAll = searchTerms.concat(searchText.trim() ? [searchText.trim()] : []);
  if (searchAll.length) {
    base = base.filter((c) => {
      const hay = `${c.referencia || ""} ${c.descricao || ""} ${c.responsavel || ""} ${c.motivo || ""}`.toLowerCase();
      return searchAll.every((t) => hay.includes(t.toLowerCase()));
    });
  }
  if (fEntrega.size) base = base.filter((c) => fEntrega.has(fases[c.referencia]?.entrega?.estado || "sem_dados"));
  if (fResp.size) base = base.filter((c) => fResp.has(c.responsavel || NONE));
  if (fMotivo.size) base = base.filter((c) => fMotivo.has(c.motivo || NONE));
  if (fSla.size) base = base.filter((c) => fSla.has(c.sla?.estado || "na"));
  const activeFilters = searchTerms.length + (searchText.trim() ? 1 : 0) + fEntrega.size + fResp.size + fMotivo.size + fTipo.size + fSla.size;
  const clearFilters = () => {
    setSearchTerms([]);
    setSearchText("");
    setFEntrega(/* @__PURE__ */ new Set());
    setFResp(/* @__PURE__ */ new Set());
    setFMotivo(/* @__PURE__ */ new Set());
    setFTipo(/* @__PURE__ */ new Set());
    setFSla(/* @__PURE__ */ new Set());
  };
  const columns = React.useMemo(() => {
    const faseSortValue = (k) => (c) => {
      const e = fases[c.referencia]?.[k]?.estado;
      return e ? PT_SEM_RANK[e] : null;
    };
    const semaforo = (k) => ({
      render: (c) => React.createElement(PtSemaforo, { fase: fases[c.referencia]?.[k], loading: fasesLoading }),
      sortValue: faseSortValue(k)
    });
    return [
      // A referência é o identificador: fica presa à esquerda, porque a soma
      // das larguras é maior que o ecrã e a tabela rola na horizontal.
      { key: "referencia", label: "Refer\xEAncia", width: 170, minWidth: 130, fixed: true },
      // A descrição é o único texto livre longo desta lista: precisa de 398px e
      // tem 280, por isso trunca em cerca de metade das linhas. Truncar texto
      // livre é o desenho a funcionar — mas antes desta migração a célula
      // enrolava em 2-3 linhas e lia-se tudo, por isso sem o title no hover a
      // migração tirava informação a quem a usa.
      {
        key: "descricao",
        label: "Descri\xE7\xE3o",
        width: 280,
        minWidth: 160,
        render: (c) => React.createElement("span", { title: c.descricao || "" }, c.descricao || "")
      },
      {
        key: "num_encomenda",
        label: "N\xBA enc.",
        width: 95,
        title: "N\xFAmero da encomenda",
        render: (c) => c.num_encomenda != null ? c.ano_encomenda ? `${c.num_encomenda}/${c.ano_encomenda}` : String(c.num_encomenda) : "\u2014"
      },
      { key: "primeira_encomenda", label: "Data encomenda", width: 155 },
      {
        key: "data_solicitada",
        label: "Data solicitada",
        width: 150,
        title: "Data solicitada pelo cliente (objetivo)"
      },
      {
        key: "data_confirmada",
        label: "Data confirmada",
        width: 158,
        title: "Data de confirma\xE7\xE3o do fornecedor de MP"
      },
      { key: "data_entrega", label: "Data entrega", width: 145, title: "Data de entrega real" },
      { key: "producao", label: "Produ\xE7\xE3o", width: 108, ...semaforo("producao") },
      { key: "requisicao_mp", label: "Req. MP", width: 90, ...semaforo("requisicao_mp") },
      { key: "chegada", label: "Chegada", width: 98, ...semaforo("chegada") },
      { key: "entrega", label: "Entrega", width: 96, ...semaforo("entrega") },
      {
        key: "sla",
        label: "SLA",
        width: 60,
        title: "Cumprimento do SLA entre milestones",
        render: (c) => React.createElement(PtDot, {
          estado: PT_SLA_TO_SEM[c.sla?.estado || "na"],
          title: PT_SLA_LABEL[c.sla?.estado || "na"]
        }),
        sortValue: (c) => PT_SLA_RANK[c.sla?.estado || "na"]
      },
      {
        key: "checklist",
        label: "Checklist",
        width: 108,
        align: "right",
        render: (c) => c.checklist ? `${c.checklist.ok}/${c.checklist.total}` : "\u2014",
        sortValue: (c) => c.checklist ? c.checklist.ok : null
      },
      { key: "responsavel", label: "Respons\xE1vel", width: 130 },
      { key: "motivo", label: "Motivo", width: 90 }
    ];
  }, [fases, fasesLoading]);
  return React.createElement(
    "div",
    { className: "pt-casos", style: { padding: 12 } },
    React.createElement(
      "div",
      { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 8 } },
      React.createElement(
        "span",
        { style: { fontSize: 13, color: "var(--muted)" } },
        activeFilters ? `${base.length}/${casos.length} refs` : `${casos.length} refs`
      ),
      fasesLoading && React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "a calcular sem\xE1foros\u2026")
    ),
    // barra de filtros
    React.createElement(
      "div",
      { className: "filters", style: { padding: "8px 0", borderBottom: "1px solid var(--border)", marginBottom: 8 } },
      React.createElement(PtSearchChips, {
        terms: searchTerms,
        setTerms: setSearchTerms,
        text: searchText,
        setText: setSearchText,
        placeholder: "Pesquisar por ref, descri\xE7\xE3o, respons\xE1vel ou motivo\u2026"
      }),
      React.createElement(PtChipFilter, { label: "Tipo artigo", value: fTipo, setValue: setFTipo, options: tipoOpts }),
      React.createElement(PtChipFilter, { label: "Entrega", value: fEntrega, setValue: setFEntrega, options: PT_ENTREGA_OPTS }),
      React.createElement(PtChipFilter, { label: "SLA", value: fSla, setValue: setFSla, options: PT_SLA_OPTS }),
      React.createElement(PtChipFilter, { label: "Respons\xE1vel", value: fResp, setValue: setFResp, options: respOpts }),
      React.createElement(PtChipFilter, { label: "Motivo", value: fMotivo, setValue: setFMotivo, options: motivoOpts }),
      activeFilters > 0 && React.createElement(
        "button",
        { className: "btn ghost sm", onClick: clearFilters },
        `Limpar (${activeFilters})`
      )
    ),
    React.createElement(window.HubList.List, {
      appLabel: "primustrack",
      viewId: "casos",
      columns,
      data: base,
      pagination: "client",
      initialPageSize: PT_PAGE_SIZE,
      initialSort: [{ key: "data_entrega", dir: "asc" }],
      rowKey: (c) => c.referencia,
      onRowClick: (c) => onOpen(c.referencia),
      // A filtragem é feita aqui em cima; é por aqui que o componente sabe
      // que ela mudou e repõe a página 1 (senão ficaria numa página vazia).
      fetchDeps: [searchTerms, searchText, fEntrega, fResp, fMotivo, fTipo, fSla],
      empty: "Nenhum caso corresponde aos filtros."
    })
  );
}
function PrimustrackView({ view: viewProp, routeId, entidade, params, navigate }) {
  const [casos, setCasos] = React.useState(null);
  const [fases, setFases] = React.useState({});
  const [fasesLoading, setFasesLoading] = React.useState(false);
  const [slaByRef, setSlaByRef] = React.useState({});
  const [estados, setEstados] = React.useState([]);
  const [erro, setErro] = React.useState(false);
  const [filtroKey, setFiltroKey] = React.useState(PT_FILTRO_DEFAULT);
  const view = viewProp || "list";
  const load = React.useCallback(() => {
    const filtro = PT_FILTROS.find((f) => f.key === filtroKey) || PT_FILTROS[0];
    setFases({});
    window.PrimustrackAPI.casos(filtro.params).then((r) => {
      setErro(false);
      setCasos(r.casos || []);
    }).catch((e) => {
      const msg = window.PrimustrackAPI.erroMensagem(e, PT_ERRO_FALLBACK);
      setErro(msg);
      setCasos([]);
      window.srToast?.(msg, "error");
    });
  }, [filtroKey]);
  React.useEffect(() => {
    load();
  }, [load]);
  React.useEffect(() => {
    window.PrimustrackAPI.kanbanEstados().then((r) => setEstados(r.results || r)).catch(() => setEstados([]));
  }, []);
  React.useEffect(() => {
    if (!casos || casos.length === 0) return;
    let alive = true;
    setFasesLoading(true);
    window.PrimustrackAPI.casosFasesBulk(casos.map((c) => c.referencia)).then((r) => {
      if (alive) setFases(r.fases || {});
    }).catch(() => {
      if (alive) window.srToast?.("Erro a calcular os sem\xE1foros (ERP indispon\xEDvel?)", "error");
    }).finally(() => {
      if (alive) setFasesLoading(false);
    });
    return () => {
      alive = false;
    };
  }, [casos]);
  React.useEffect(() => {
    if (!casos || casos.length === 0) {
      setSlaByRef({});
      return;
    }
    let alive = true;
    window.PrimustrackAPI.casosSlaBulk(casos.map((c) => c.referencia)).then((r) => {
      if (alive) setSlaByRef(r.sla || {});
    }).catch(() => {
      if (alive) window.srToast?.("Erro a calcular os SLAs", "error");
    });
    return () => {
      alive = false;
    };
  }, [casos]);
  const casosComSla = React.useMemo(
    () => (casos || []).map((c) => ({ ...c, sla: slaByRef[c.referencia] || { estado: "na" } })),
    [casos, slaByRef]
  );
  if (casos === null) return React.createElement("div", { style: { color: "var(--muted)", fontSize: 13, padding: 16 } }, "A calcular\u2026");
  const selected = entidade || null;
  const openCaso = (ref) => navigate({ routeId, entidade: ref, params });
  const closeCaso = () => navigate({ routeId, params });
  const onMoved = (ref, est) => setCasos((cs) => cs.map((c) => c.referencia === ref ? { ...c, estado: est ? { id: est.id, label: est.label, color: est.color } : null } : c));
  return React.createElement(
    "div",
    { className: "pt-casos", style: { padding: 12 } },
    React.createElement(
      "div",
      { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 8 } },
      React.createElement("h1", { style: { margin: 0 } }, "Casos"),
      React.createElement(
        "label",
        { style: { fontSize: 13, color: "var(--muted)", marginLeft: "auto" } },
        "Estreia: ",
        React.createElement(
          "select",
          { value: filtroKey, onChange: (e) => setFiltroKey(e.target.value), style: { marginLeft: 4 } },
          PT_FILTROS.map((f) => React.createElement("option", { key: f.key, value: f.key }, f.label))
        )
      ),
      fasesLoading && React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "a calcular sem\xE1foros\u2026")
    ),
    erro && React.createElement("div", { style: { color: "#b91c1c", padding: 12 } }, erro),
    view === "kanban" ? React.createElement(window.PtKanbanView, { casos, fases, estados, onOpen: openCaso, onMoved }) : view === "dashboard" && window.PtDashboardView ? React.createElement(window.PtDashboardView, { casos: casosComSla, fases, estados, onOpen: openCaso }) : React.createElement(PtListaView, { casos: casosComSla, fases, fasesLoading, onOpen: openCaso }),
    selected && React.createElement(window.PrimustrackCasoDrawer, {
      referencia: selected,
      fases: fases[selected],
      casos,
      onNavigate: openCaso,
      onClose: closeCaso,
      onSaved: load
    })
  );
}
window.PrimustrackView = PrimustrackView;

// ===== primustrack/frontend/primustrack_caso_drawer.jsx =====
const PT_APP = "primustrack";
const PT_RES = "caso";
const PT_SEM_COR = { verde: "#15803d", amarelo: "#ca8a04", vermelho: "#b91c1c", sem_dados: "var(--border)" };
const PT_ESTADO_OPTS = [["", "Por validar"], ["ok", "Dispon\xEDvel"], ["falta", "Em falta"], ["n_a", "N/A"]];
const PT_MILESTONES = [
  { key: "data_email_cliente", label: "Email do cliente", manual: true, seed: "data_rececao_cliente" },
  { key: "data_criacao_projeto", label: "Cria\xE7\xE3o do projeto", manual: true, opcional: true },
  { key: "data_envio_maquete", label: "Envio da maquete", manual: true, opcional: true },
  { key: "data_aprovacao_maquete", label: "Aprova\xE7\xE3o da maquete", manual: true, opcional: true },
  { key: "data_criacao_codigo", label: "Cria\xE7\xE3o do c\xF3digo", manual: true },
  { key: "data_encomenda", label: "Encomenda", erp: true },
  { key: "data_validacao_codigo", label: "Valida\xE7\xE3o do c\xF3digo", manual: true },
  { key: "data_requisicao_mp", label: "Requisi\xE7\xE3o MP", erp: true },
  { key: "data_confirmacao_fornecedor", label: "Confirma\xE7\xE3o de fornecedor", erp: true },
  { key: "data_rececao_mp", label: "Rece\xE7\xE3o MP", erp: true },
  { key: "data_fabrico", label: "Fabrico", erp: true },
  { key: "data_entrega", label: "Entrega", erp: true }
];
const PT_MILESTONE_LABEL = Object.fromEntries(PT_MILESTONES.map((m) => [m.key, m.label]));
const PT_SLA_COR = { cumprido: "verde", em_curso: "amarelo", estourado: "vermelho", em_atraso: "vermelho", na: "sem_dados" };
function ptEur(v) {
  return v != null ? `${Number(v).toFixed(2)} \u20AC` : "\u2014";
}
function ptOrDash(v) {
  return v === null || v === void 0 || v === "" ? "\u2014" : v;
}
function PtAnexoLinha({ referencia, a }) {
  const nome = `${a.fname || "anexo"}${a.fext ? "." + a.fext : ""}`;
  const isLink = !!a.url;
  const href = isLink ? a.url : window.PrimustrackAPI.anexoDownloadUrl(referencia, a.anexosstamp);
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      title: a.descricao || nome,
      style: { display: "flex", alignItems: "baseline", gap: 6, padding: "3px 0", fontSize: 12.5, textDecoration: "none" }
    },
    /* @__PURE__ */ React.createElement("span", { style: { flex: "0 0 auto", color: "var(--muted)" } }, isLink ? "\u2197" : "\u2B07"),
    /* @__PURE__ */ React.createElement("span", { style: { color: "var(--accent)", flex: "0 0 auto", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, nome),
    a.descricao ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11, flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, a.descricao) : null
  );
}
function PtAnexosTab({ referencia, anexos }) {
  if (anexos === null) {
    return /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12.5, padding: "8px 0" } }, "A carregar anexos\u2026");
  }
  const grupo = (titulo, lista) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginBottom: 4 } }, titulo), (lista || []).length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12 } }, "Sem anexos.") : lista.map((a) => /* @__PURE__ */ React.createElement(PtAnexoLinha, { key: a.anexosstamp, referencia, a })));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, grupo("Encomenda", anexos.encomenda), grupo("Artigo", anexos.artigo));
}
function PtSlaSecao({ sla }) {
  return /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 18 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "SLAs"), /* @__PURE__ */ React.createElement("div", null, sla.itens.map((it) => {
    const cor = PT_SLA_COR[it.estado] || "sem_dados";
    const deLabel = PT_MILESTONE_LABEL[it.de_milestone] || it.de_milestone;
    const ateLabel = PT_MILESTONE_LABEL[it.ate_milestone] || it.ate_milestone;
    return /* @__PURE__ */ React.createElement("div", { key: it.id, style: { display: "flex", alignItems: "center", gap: 8, padding: "3px 0", fontSize: 12.5 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 10, height: 10, borderRadius: "50%", background: PT_SEM_COR[cor] || "var(--border)", flex: "0 0 auto" } }), /* @__PURE__ */ React.createElement("span", null, deLabel, " \u2192 ", ateLabel, ": ", it.dias != null ? it.dias : "\u2014", "/", it.alvo != null ? it.alvo : "\u2014", " dias \xFAteis"));
  })));
}
function PtKv({ pairs }) {
  return /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, pairs.map(([k, v], i) => /* @__PURE__ */ React.createElement(React.Fragment, { key: i }, /* @__PURE__ */ React.createElement("div", { className: "k" }, k), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, v))));
}
function PrimustrackCasoDrawer({ referencia, fases, casos = [], onNavigate, onClose, onSaved }) {
  const me = window.SR_ME || null;
  const users = window.SR_USERS || [];
  const caso = casos.find((c) => c.referencia === referencia) || { referencia };
  const resParams = { app_label: PT_APP, resource: PT_RES, resource_id: referencia };
  const [erp, setErp] = React.useState(null);
  const [itens, setItens] = React.useState([]);
  const [estados, setEstados] = React.useState({});
  const [motivos, setMotivos] = React.useState([]);
  const [aval, setAval] = React.useState({ motivo: null, nota: "", responsavel: null });
  const [saving, setSaving] = React.useState(false);
  const [notas, setNotas] = React.useState([]);
  const [followers, setFollowers] = React.useState([]);
  const [logs, setLogs] = React.useState([]);
  const [acoes, setAcoes] = React.useState([]);
  const [datas, setDatas] = React.useState({});
  const [anexos, setAnexos] = React.useState(null);
  const [sla, setSla] = React.useState(null);
  const refreshNotas = React.useCallback(() => {
    window.API.notes(resParams).then((r) => setNotas(r.results || r || [])).catch(() => setNotas([]));
  }, [referencia]);
  const refreshAcoes = React.useCallback(() => {
    window.PrimustrackAPI.casoAcoes(referencia).then((r) => setAcoes((r.results || r || []).map((a) => ({
      id: a.id,
      source: "acao",
      tipo: a.tipo?.id_slug,
      tipoNome: a.tipo?.nome || a.tipo?.id_slug,
      autor: a.autor_username,
      atribuido: a.atribuido_username || null,
      criadoEm: a.criado_em ? new Date(a.criado_em) : null,
      descricao: a.descricao,
      tratada: !!a.tratada_em,
      tratadaEm: a.tratada_em ? new Date(a.tratada_em) : null,
      tratadaPor: a.tratada_por_username || null,
      prazo: a.data_limite || null
    })))).catch(() => setAcoes([]));
  }, [referencia]);
  const refreshFollowers = React.useCallback(() => {
    window.API.followers(resParams).then((r) => setFollowers(r.results || r || [])).catch(() => setFollowers([]));
  }, [referencia]);
  const refreshLogs = React.useCallback(() => {
    fetch(window.PrimustrackAPI.auditUrl(referencia), { credentials: "same-origin" }).then((r) => r.json()).then((rows) => setLogs((rows || []).map((a) => ({
      id: a.id,
      evento: a.verb,
      descricao: a.summary,
      actor_username: a.actor_name,
      criado_em: a.when
    })))).catch(() => setLogs([]));
  }, [referencia]);
  React.useEffect(() => {
    setErp(null);
    window.PrimustrackAPI.casoErp(referencia).then(setErp).catch(() => setErp(null));
    window.PrimustrackAPI.checklistItens().then((r) => setItens(r.results || r || []));
    window.PrimustrackAPI.motivos().then((r) => setMotivos(r.results || r || []));
    window.PrimustrackAPI.casoDetalhe(referencia).then((d2) => {
      const map = {};
      (d2.checklist || []).forEach((c) => {
        map[c.item_def] = { estado: c.estado, nota: c.nota };
      });
      setEstados(map);
      setAval({ motivo: d2.avaliacao?.motivo ?? null, nota: d2.avaliacao?.nota || "", responsavel: d2.avaliacao?.responsavel ?? null });
      setDatas(d2.datas || {});
      setSla(d2.sla || null);
    }).catch(() => {
    });
    setAnexos(null);
    window.PrimustrackAPI.casoAnexos(referencia).then((r) => setAnexos({ encomenda: r.encomenda || [], artigo: r.artigo || [] })).catch(() => setAnexos({ encomenda: [], artigo: [] }));
    refreshNotas();
    refreshFollowers();
    refreshLogs();
    refreshAcoes();
  }, [referencia]);
  const setCell = (itemId, patch) => setEstados((s) => ({ ...s, [itemId]: { ...s[itemId], ...patch } }));
  const saveCell = (item) => {
    const cell = estados[item.id] || {};
    window.PrimustrackAPI.putChecklist(referencia, { item_def: item.id, estado: cell.estado || "", nota: cell.nota || "" }).then(() => {
      window.srToast?.("Checklist gravada.", "success");
      refreshLogs();
    }).catch((e) => window.srToast?.(e.detail || "Erro", "error"));
  };
  const saveAval = () => {
    setSaving(true);
    window.PrimustrackAPI.putAvaliacao(referencia, aval).then(() => {
      window.srToast?.("Avalia\xE7\xE3o gravada.", "success");
      refreshLogs();
      onSaved && onSaved();
    }).catch((e) => window.srToast?.(e.detail || "Erro", "error")).finally(() => setSaving(false));
  };
  const setResponsavel = (uid) => {
    const val = uid ? Number(uid) : null;
    setAval((a) => ({ ...a, responsavel: val }));
    window.PrimustrackAPI.putAvaliacao(referencia, { responsavel: val }).then(() => {
      window.srToast?.("Respons\xE1vel atualizado.", "success");
      refreshLogs();
      onSaved && onSaved();
    }).catch((e) => window.srToast?.(e.detail || "Erro", "error"));
  };
  const setData = (key, val) => {
    const v = val || null;
    setDatas((prev) => ({ ...prev, [key]: v }));
    window.PrimustrackAPI.putCasoDatas(referencia, { [key]: v }).then(() => {
      window.srToast?.("Data gravada.", "success");
      refreshLogs();
    }).catch((e) => window.srToast?.(e.detail || "Erro", "error"));
  };
  const todayISO = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
  const userLabel = (u) => u.nome || `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username;
  const notasApi = {
    onAdd: (descricao) => window.API.createNote({ ...resParams, descricao }).then(refreshNotas),
    onUpdate: (id, descricao) => window.API.updateNote(id, { descricao }).then(refreshNotas),
    onDelete: (id) => window.API.deleteNote(id).then(refreshNotas)
  };
  const acoesApi = {
    onAdd: (tipoIdSlug, descricao, atribuidoId, prazo) => window.PrimustrackAPI.addCasoAcao(
      referencia,
      tipoIdSlug,
      descricao,
      atribuidoId,
      prazo
    ).then(refreshAcoes),
    onDelete: (a) => window.PrimustrackAPI.deleteCasoAcao(referencia, a.id).then(refreshAcoes),
    onToggleTratada: (a) => window.PrimustrackAPI.tratarCasoAcao(referencia, a.id).then(refreshAcoes),
    onSetPrazo: (a, iso) => window.PrimustrackAPI.prazoCasoAcao(referencia, a.id, iso).then(refreshAcoes)
  };
  const seguidores = {
    items: followers,
    me,
    canManage: !!(me && me.is_staff),
    users,
    onFollow: () => window.API.follow(resParams).then(refreshFollowers),
    onUnfollow: (id) => window.API.unfollow(id).then(refreshFollowers),
    onAddOther: (uid) => window.API.follow({ ...resParams, user_id: uid }).then(refreshFollowers)
  };
  const navList = casos.map((c) => ({ id: c.referencia, codigo: c.referencia, descricao: c.descricao }));
  const d = erp || {};
  const detalhePairs = [
    ["Refer\xEAncia", ptOrDash(d.referencia || referencia)],
    ["Descri\xE7\xE3o", ptOrDash(d.descricao || caso.descricao)],
    ["Cliente", d.cliente ? `${d.cliente}${d.ncliente ? ` (${d.ncliente})` : ""}` : "\u2014"],
    ["Tipo artigo", ptOrDash(d.tipoartigo)],
    ["Qtd enc / ent", `${ptOrDash(d.qtd_encomendada)} / ${ptOrDash(d.qtd_entregue)}`],
    ["Cond. pag.", ptOrDash(d.cond_pagamento)],
    ["N\xBA encomenda", d.num_encomenda ? `${d.num_encomenda}${d.ano_encomenda ? `/${d.ano_encomenda}` : ""}` : "\u2014"],
    ["Total venda", ptEur(d.total_venda)],
    ["MP", d.ref_mp ? `${d.ref_mp}${d.design_mp ? ` \u2014 ${d.design_mp}` : ""}` : "\u2014"],
    ["Fornecedor MP", ptOrDash(d.fornecedor_mp)],
    ["Data solicitada", ptOrDash(d.data_solicitada)]
  ];
  const milestoneVal = (m) => m.manual ? datas[m.key] || (m.seed ? d[m.seed] || null : null) : d[m.key] || null;
  const milestoneEstado = (m) => {
    const v = milestoneVal(m);
    if (v) return "verde";
    const prazo = d.data_entrega_inicial || d.data_solicitada;
    if (m.key === "data_entrega" && prazo && prazo < todayISO) return "vermelho";
    return "sem_dados";
  };
  const assignableUsers = window.HubAtribuicoes.eligibleUsers(users, "primustrack");
  const respOptions = aval.responsavel && !assignableUsers.some((u) => u.id === aval.responsavel) ? assignableUsers.concat(users.filter((u) => u.id === aval.responsavel)) : assignableUsers;
  const side = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Respons\xE1vel"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: aval.responsavel || "",
      onChange: (e) => setResponsavel(e.target.value),
      style: { width: "100%", marginBottom: 16 }
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem respons\xE1vel \u2014"),
    respOptions.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, userLabel(u)))
  ), /* @__PURE__ */ React.createElement(
    window.HubActionTimeline,
    {
      streams: {
        acoes: { items: acoes, api: acoesApi },
        notas: { items: notas, api: notasApi },
        logs: { items: logs }
      },
      seguidores,
      users,
      me,
      assignable: !!(me && me.is_staff),
      appLabel: PT_APP,
      appSlug: "primustrack",
      resource: PT_RES,
      resourceId: referencia,
      defaultTab: "acoes",
      title: "Atividade",
      extraTabs: [{
        key: "anexos_phc",
        label: "Anexos PHC",
        count: anexos ? anexos.encomenda.length + anexos.artigo.length : null,
        render: () => /* @__PURE__ */ React.createElement(PtAnexosTab, { referencia, anexos })
      }]
    }
  ));
  const footer = /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: saveAval, disabled: saving }, saving ? "A guardar\u2026" : "Guardar avalia\xE7\xE3o");
  return /* @__PURE__ */ React.createElement(
    window.DrawerShell,
    {
      title: referencia,
      subtitle: caso.descricao || "Primeira encomenda",
      onClose,
      navList,
      currentId: referencia,
      onNavigate: (it) => onNavigate && onNavigate(it.id),
      footer,
      side
    },
    /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 18 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Timeline"), /* @__PURE__ */ React.createElement("div", { style: { borderLeft: "2px solid var(--border)", marginLeft: 5, paddingLeft: 14 } }, PT_MILESTONES.map((m) => {
      const v = milestoneVal(m);
      const est = milestoneEstado(m);
      return /* @__PURE__ */ React.createElement("div", { key: m.key, style: { display: "flex", alignItems: "center", gap: 10, padding: "4px 0", position: "relative" } }, /* @__PURE__ */ React.createElement("span", { style: {
        position: "absolute",
        left: -20,
        width: 11,
        height: 11,
        borderRadius: "50%",
        background: PT_SEM_COR[est] || "var(--border)",
        border: "2px solid var(--panel, #fff)"
      } }), /* @__PURE__ */ React.createElement("span", { style: { flex: 1, fontSize: 13 } }, m.label, m.opcional ? /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, " (opcional)") : null), m.manual ? /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "date",
          value: v || "",
          onChange: (e) => setData(m.key, e.target.value),
          style: { fontSize: 12, padding: "2px 4px", width: 148 }
        }
      ) : /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12.5, color: v ? "var(--text)" : "var(--muted)", width: 148, textAlign: "right" } }, v || "\u2014"));
    })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: "var(--muted)", marginTop: 6, display: "flex", flexWrap: "wrap", gap: 14 } }, /* @__PURE__ */ React.createElement("span", null, "Data solicitada (objetivo): ", /* @__PURE__ */ React.createElement("strong", null, d.data_solicitada || "\u2014")), /* @__PURE__ */ React.createElement("span", null, "Entrega inicial (prazo): ", /* @__PURE__ */ React.createElement("strong", null, d.data_entrega_inicial || "\u2014")))),
    sla && sla.itens && sla.itens.length ? /* @__PURE__ */ React.createElement(PtSlaSecao, { sla }) : null,
    /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, alignItems: "start" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Detalhe"), /* @__PURE__ */ React.createElement(PtKv, { pairs: detalhePairs })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Checklist"), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 14 } }, itens.map((item) => /* @__PURE__ */ React.createElement("div", { key: item.id, style: { display: "flex", gap: 6, alignItems: "center", margin: "3px 0" } }, /* @__PURE__ */ React.createElement("span", { style: { flex: 1, fontSize: 12.5 } }, item.label), /* @__PURE__ */ React.createElement(
      "select",
      {
        value: estados[item.id]?.estado || "",
        onChange: (e) => setCell(item.id, { estado: e.target.value }),
        style: { fontSize: 11.5, padding: "2px 4px", width: "auto" }
      },
      PT_ESTADO_OPTS.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        style: { padding: "2px 6px" },
        title: "Guardar",
        onClick: () => saveCell(item)
      },
      "\u2713"
    )))), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Motivo de incumprimento"), /* @__PURE__ */ React.createElement(
      "select",
      {
        value: aval.motivo || "",
        style: { width: "100%" },
        onChange: (e) => setAval((a) => ({ ...a, motivo: e.target.value ? Number(e.target.value) : null }))
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem motivo \u2014"),
      motivos.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.label))
    )))
  );
}
window.PrimustrackCasoDrawer = PrimustrackCasoDrawer;

// ===== primustrack/frontend/primustrack_config_crud.jsx =====
window.PtConfigCrud = function PtConfigCrud({ title, api, viewId }) {
  return function ConfigCrudView() {
    const EMPTY = { label: "", ordem: 100, is_active: true };
    const [items, setItems] = React.useState([]);
    const [draft, setDraft] = React.useState(EMPTY);
    const [editingId, setEditingId] = React.useState(null);
    const [pendingDelete, setPendingDelete] = React.useState(null);
    const load = () => api.list().then((r) => setItems(r.results || r || []));
    React.useEffect(() => {
      load();
    }, []);
    const cancelEdit = () => {
      setDraft(EMPTY);
      setEditingId(null);
    };
    const save = () => {
      if (!draft.label.trim()) {
        window.srToast?.("Indica um nome.", "warning");
        return;
      }
      const on = draft.ordem === "" || draft.ordem == null ? 100 : Number(draft.ordem);
      const ordem = Number.isNaN(on) ? 100 : on;
      const payload = { label: draft.label.trim(), ordem, is_active: !!draft.is_active };
      const p = editingId ? api.update(editingId, payload) : api.create(payload);
      p.then(() => {
        cancelEdit();
        return load();
      }).then(() => window.srToast?.("Gravado.", "success")).catch((e) => window.srToast?.(e.detail || "Erro", "error"));
    };
    const doDelete = () => {
      const it = pendingDelete;
      api.remove(it.id).then(() => {
        setPendingDelete(null);
        return load();
      }).then(() => window.srToast?.("Apagado.", "success")).catch((e) => window.srToast?.(e.detail || "Erro", "error"));
    };
    const columns = [
      {
        key: "label",
        label: "Nome",
        width: 200,
        minWidth: 140,
        fixed: true,
        render: (it) => it.label
      },
      {
        key: "ordem",
        label: "Ordem",
        width: 90,
        render: (it) => it.ordem
      },
      {
        key: "is_active",
        label: "Ativo",
        width: 80,
        render: (it) => it.is_active ? "Sim" : "N\xE3o"
      },
      {
        key: "acoes",
        label: "",
        sortable: false,
        width: 170,
        render: (it) => React.createElement(
          React.Fragment,
          null,
          React.createElement("button", { className: "btn ghost sm", onClick: () => {
            setEditingId(it.id);
            setDraft({ ...it });
          } }, "Editar"),
          React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(it) }, "Apagar")
        )
      }
    ];
    return React.createElement(
      "div",
      { style: { padding: 12 } },
      React.createElement("h1", null, title),
      React.createElement(window.HubList.List, {
        appLabel: "primustrack",
        viewId,
        columns,
        data: items,
        pagination: "none",
        rowKey: (it) => it.id
      }),
      React.createElement(
        "div",
        { style: { display: "flex", gap: 8, alignItems: "flex-end", marginTop: 12 } },
        React.createElement(
          "label",
          null,
          "Nome",
          React.createElement("input", { value: draft.label, onChange: (e) => setDraft({ ...draft, label: e.target.value }) })
        ),
        React.createElement(
          "label",
          null,
          "Ordem",
          React.createElement("input", { type: "number", value: draft.ordem, onChange: (e) => setDraft({ ...draft, ordem: e.target.value }) })
        ),
        React.createElement(
          "label",
          null,
          "Ativo",
          React.createElement("input", { type: "checkbox", checked: draft.is_active, onChange: (e) => setDraft({ ...draft, is_active: e.target.checked }) })
        ),
        React.createElement("button", { className: "btn primary sm", onClick: save }, editingId ? "Guardar" : "Adicionar"),
        editingId && React.createElement("button", { className: "btn ghost sm", onClick: cancelEdit }, "Cancelar")
      ),
      pendingDelete && React.createElement(
        window.ModalShell,
        { title: "Apagar", onClose: () => setPendingDelete(null) },
        React.createElement("div", { style: { marginBottom: 16 } }, `Apagar "${pendingDelete.label}"?`),
        React.createElement(
          "div",
          { style: { display: "flex", gap: 6, justifyContent: "flex-end" } },
          React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(null) }, "Cancelar"),
          React.createElement("button", { className: "btn primary sm", style: { background: "#c4434b" }, onClick: doDelete }, "Apagar")
        )
      )
    );
  };
};

// ===== primustrack/frontend/primustrack_checklist.jsx =====
window.PrimustrackChecklistView = window.PtConfigCrud({
  title: "Checklist \u2014 itens de prontid\xE3o",
  viewId: "checklist",
  api: {
    list: () => window.PrimustrackAPI.checklistItens(),
    create: (d) => window.PrimustrackAPI.createChecklistItem(d),
    update: (id, p) => window.PrimustrackAPI.updateChecklistItem(id, p),
    remove: (id) => window.PrimustrackAPI.deleteChecklistItem(id)
  }
});

// ===== primustrack/frontend/primustrack_motivos.jsx =====
window.PrimustrackMotivosView = window.PtConfigCrud({
  title: "Motivos de incumprimento",
  viewId: "motivos",
  api: {
    list: () => window.PrimustrackAPI.motivos(),
    create: (d) => window.PrimustrackAPI.createMotivo(d),
    update: (id, p) => window.PrimustrackAPI.updateMotivo(id, p),
    remove: (id) => window.PrimustrackAPI.deleteMotivo(id)
  }
});

// ===== primustrack/frontend/primustrack_estados.jsx =====
function PrimustrackEstadosView() {
  const EMPTY = { label: "", color: "#9aa3ad", ordem: 100, is_active: true, is_terminal: false };
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [draft, setDraft] = React.useState(EMPTY);
  const [editingId, setEditingId] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [pendingDelete, setPendingDelete] = React.useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.PrimustrackAPI.kanbanEstados();
      setItems(r.results || r);
    } catch (e) {
      setError(e.message || "Erro");
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    load();
  }, []);
  const cancelEdit = () => {
    setEditingId(null);
    setDraft(EMPTY);
  };
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = { ...draft, ordem: Number(draft.ordem) || 100 };
      if (editingId) await window.PrimustrackAPI.updateKanbanEstado(editingId, payload);
      else {
        if (!payload.label) throw new Error("Label \xE9 obrigat\xF3rio.");
        await window.PrimustrackAPI.createKanbanEstado(payload);
      }
      cancelEdit();
      await load();
      window.srToast?.("Estado gravado.", "success");
    } catch (e) {
      setError(e.message || "Erro");
    } finally {
      setSaving(false);
    }
  };
  const doDelete = async () => {
    const it = pendingDelete;
    setPendingDelete(null);
    try {
      await window.PrimustrackAPI.deleteKanbanEstado(it.id);
      await load();
      window.srToast?.(`Estado "${it.label}" apagado.`, "success");
    } catch (e) {
      window.srToast?.(e.message || "Erro", "error");
    }
  };
  const columns = [
    {
      key: "label",
      label: "Label",
      width: 200,
      minWidth: 140,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.label)
    },
    {
      key: "color",
      label: "Cor",
      width: 70,
      render: (it) => /* @__PURE__ */ React.createElement("span", { style: { display: "inline-block", width: 14, height: 14, borderRadius: 3, background: it.color || "var(--muted)" } })
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.ordem)
    },
    { key: "is_active", label: "Ativo", width: 80, render: (it) => it.is_active ? "\u2713" : "\u2014" },
    { key: "is_terminal", label: "Terminal", width: 90, render: (it) => it.is_terminal ? "\u2713" : "\u2014" },
    {
      key: "acoes",
      label: "",
      sortable: false,
      width: 170,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
        setEditingId(it.id);
        setDraft({ ...it });
      } }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Estados do Kanban")), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "primustrack",
      viewId: "kanban-estados",
      columns,
      data: items,
      pagination: "none",
      rowKey: (it) => it.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, editingId ? "Editar estado" : "Novo estado")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "Label", /* @__PURE__ */ React.createElement("input", { value: draft.label, onChange: (e) => setDraft({ ...draft, label: e.target.value }) })), /* @__PURE__ */ React.createElement("label", null, "Cor", /* @__PURE__ */ React.createElement("input", { type: "color", value: draft.color || "#9aa3ad", onChange: (e) => setDraft({ ...draft, color: e.target.value }) })), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement("input", { type: "number", value: draft.ordem, onChange: (e) => setDraft({ ...draft, ordem: e.target.value }) })), /* @__PURE__ */ React.createElement("label", null, "Ativo", /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!draft.is_active, onChange: (e) => setDraft({ ...draft, is_active: e.target.checked }) })), /* @__PURE__ */ React.createElement("label", null, "Terminal", /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: !!draft.is_terminal, onChange: (e) => setDraft({ ...draft, is_terminal: e.target.checked }) })), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: cancelEdit }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: save, disabled: saving }, saving ? "A guardar\u2026" : editingId ? "Guardar" : "Adicionar")), pendingDelete && /* @__PURE__ */ React.createElement(window.ModalShell, { title: "Apagar estado", onClose: () => setPendingDelete(null) }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar o estado ", /* @__PURE__ */ React.createElement("strong", null, pendingDelete.label), '? Os casos que estejam nele ficam em "Por classificar".'), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(null) }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { background: "#c4434b" }, onClick: doDelete }, "Apagar"))));
}
window.PrimustrackEstadosView = PrimustrackEstadosView;

// ===== primustrack/frontend/entry.jsx =====
window.PrimustrackView = window.PrimustrackView || (() => null);
window.PrimustrackChecklistView = window.PrimustrackChecklistView || (() => null);
window.PrimustrackMotivosView = window.PrimustrackMotivosView || (() => null);

// ===== primustrack/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "primustrack",
  order: 9,
  // Deprecated (decisão do João, 2026-10-27): o TRAKKER substitui-a e ficou com o logo dela.
  name: "PRIMUSTRACK",
  sub: "Deprecated \u2014 usar o TRAKKER",
  accent: "#2fa25a",
  home: "primustrack",
  launcher: true,
  frontendFiles: [
    "frontend/primustrack-api.jsx",
    "frontend/primustrack_slas.jsx",
    "frontend/primustrack_kanban.jsx",
    "frontend/primustrack_crossfilter.jsx",
    "frontend/primustrack_dashboard.jsx",
    "frontend/primustrack.jsx",
    "frontend/primustrack_caso_drawer.jsx",
    "frontend/primustrack_config_crud.jsx",
    "frontend/primustrack_checklist.jsx",
    "frontend/primustrack_motivos.jsx",
    "frontend/primustrack_estados.jsx",
    "frontend/entry.jsx"
  ],
  routes: [
    {
      id: "primustrack",
      section: "Casos",
      icon: "dot",
      label: "Casos",
      adminOnly: false,
      title: "Casos",
      tooltip: "Casos",
      views: [
        { id: "list", icon: "list", label: "Lista" },
        { id: "kanban", icon: "kanban", label: "Kanban" },
        { id: "dashboard", icon: "dashboard", label: "Dashboard" }
      ],
      defaultView: "list"
    },
    { id: "primustrack_checklist", section: "Defini\xE7\xF5es", icon: "dot", label: "Checklist", adminOnly: true, title: "Checklist", tooltip: "Checklist" },
    { id: "primustrack_motivos", section: "Defini\xE7\xF5es", icon: "dot", label: "Motivos", adminOnly: true, title: "Motivos", tooltip: "Motivos" },
    { id: "primustrack_kanban_estados", section: "Defini\xE7\xF5es", icon: "dot", label: "Estados (Kanban)", adminOnly: true, title: "Estados do Kanban", tooltip: "Estados do Kanban" },
    { id: "primustrack_slas", section: "Defini\xE7\xF5es", icon: "dot", label: "SLAs", adminOnly: true, title: "SLAs", tooltip: "SLAs e Feriados" },
    { id: "primustrack_atribuiveis", section: "Defini\xE7\xF5es", icon: "dot", label: "Utilizadores atribu\xEDveis", adminOnly: true, title: "Utilizadores atribu\xEDveis", tooltip: "Utilizadores atribu\xEDveis" }
  ],
  render: {
    primustrack: (ctx) => React.createElement(window.PrimustrackView, {
      view: ctx && ctx.viewVariant,
      routeId: ctx && ctx.view,
      entidade: ctx && ctx.entidade,
      params: ctx && ctx.params,
      navigate: ctx && ctx.navigate
    }),
    primustrack_checklist: () => React.createElement(window.PrimustrackChecklistView),
    primustrack_motivos: () => React.createElement(window.PrimustrackMotivosView),
    primustrack_kanban_estados: () => React.createElement(window.PrimustrackEstadosView),
    primustrack_slas: () => React.createElement(window.PrimustrackSlasView),
    primustrack_atribuiveis: () => React.createElement(window.HubAssignableUsers, { appLabel: "primustrack", appName: "Primustrack" })
  }
});

// ===== procurement/frontend/procurement.jsx =====
function _getCsrfCookie() {
  const m = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}
const NEXUM_PERIODOS = [
  { value: 7, label: "\xDAltimos 7 dias" },
  { value: 30, label: "\xDAltimos 30 dias" },
  { value: 90, label: "\xDAltimos 90 dias" },
  { value: 180, label: "\xDAltimos 180 dias" },
  { value: 365, label: "\xDAltimos 12 meses" }
];
const NEXUM_ESTADOS = [
  { value: "em_aberto", label: "S\xF3 em aberto (por receber)", dot: "#0ea5e9" },
  { value: "frameable", label: "S\xF3 frameable", dot: "#059669" },
  { value: "nao_frameable", label: "S\xF3 n\xE3o frameable", dot: "var(--muted)" },
  { value: "discrepancia", label: "Sem saving \u20AC", dot: "#c4434b" },
  { value: "ativa", label: "J\xE1 ativas", dot: "#155e75" },
  { value: "sos", label: "SOS", dot: "#eab308" },
  { value: "antecipacao", label: "Antecipa\xE7\xE3o", dot: "#7c3aed" }
];
const NEXUM_TIPOS_ACAO = [
  { id: "nota", nome: "Nota", cor: "#155e75" },
  { id: "tarefa", nome: "Tarefa", cor: "#eab308" },
  { id: "email", nome: "Email", cor: "#0ea5e9" },
  { id: "telefone", nome: "Telefone", cor: "#059669" },
  { id: "reuniao", nome: "Reuni\xE3o", cor: "#7c3aed" }
];
const NEXUM_OPP_STATUS = [
  { value: "nova", label: "Nova", dot: "#0ea5e9", bg: "rgba(14,165,233,0.14)", fg: "#0369a1" },
  { value: "atribuida", label: "Atribu\xEDda", dot: "#7c3aed", bg: "rgba(124,58,237,0.14)", fg: "#5b21b6" },
  { value: "em_curso", label: "Em curso", dot: "#eab308", bg: "rgba(234,179,8,0.16)", fg: "#854d0e" },
  { value: "fechada", label: "Fechada", dot: "#059669", bg: "rgba(5,150,105,0.14)", fg: "#065f46" },
  { value: "cancelada", label: "Cancelada", dot: "#c4434b", bg: "rgba(196,67,75,0.14)", fg: "#991b1b" }
];
function NexumStatusPill({ status, size = "sm", statuses }) {
  const list = statuses || NEXUM_OPP_STATUS;
  const s = list.find((x) => x.value === status);
  if (!s) return null;
  const isSm = size === "sm";
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: isSm ? "1px 6px" : "3px 10px",
    borderRadius: 999,
    background: s.bg,
    color: s.fg,
    fontSize: isSm ? 10.5 : 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.4
  } }, /* @__PURE__ */ React.createElement("span", { style: { width: 5, height: 5, borderRadius: "50%", background: s.dot } }), s.label);
}
const NEXUM_GRUPOS = [
  { value: "cliente", label: "Cliente" },
  { value: "canal", label: "Canal" },
  { value: "qualidade", label: "Qualidade" },
  { value: "ref", label: "Refer\xEAncia" }
];
const NEXUM_ORDEM_NAV = [{ key: "datareq", dir: "desc" }];
function RececoesPanel({ row }) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  React.useEffect(() => {
    setLoading(true);
    setError("");
    setData(null);
    const qs = new URLSearchParams({ obrano: String(row.obrano), ref: row.ref }).toString();
    fetch("/api/procurement/rececoes/?" + qs, { credentials: "same-origin" }).then((r) => r.ok ? r.json() : r.text().then((t) => Promise.reject(new Error(t || r.status)))).then(setData).catch((e) => setError(String(e.message || e))).finally(() => setLoading(false));
  }, [row.obrano, row.ref]);
  const colunas = [
    {
      key: "datarec",
      label: "data",
      width: 110,
      minWidth: 90,
      sortKey: "datarec",
      render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, h.datarec ? String(h.datarec).slice(0, 10) : "\u2014")
    },
    {
      key: "guia",
      label: "guia do fornecedor",
      width: 200,
      minWidth: 140,
      sortValue: (h) => `${h.tdocforn || ""} ${h.ndocforn || ""}`.trim(),
      render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, `${h.tdocforn || ""} ${h.ndocforn || ""}`.trim() || "\u2014")
    },
    {
      key: "qtdrec",
      label: "qtd rec",
      width: 100,
      minWidth: 80,
      align: "right",
      sortValue: (h) => h.qtdrec != null && h.qtdrec !== "" ? Number(h.qtdrec) : null,
      render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, h.qtdrec != null && h.qtdrec !== "" ? Number(h.qtdrec).toFixed(0) : "\u2014")
    },
    {
      key: "nrec",
      label: "n\xBA rec",
      width: 90,
      minWidth: 70,
      align: "right",
      render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, h.nrec ?? "\u2014")
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Rece\xE7\xF5es"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, data ? `\xB7 ${data.row_count} rece\xE7${data.row_count === 1 ? "\xE3o" : "\xF5es"} \xB7 ${Number(data.total_qtdrec).toFixed(0)} recebidas` : "")), loading && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar", role: "progressbar", "aria-label": "A carregar" }), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 12, color: "#c4434b", fontSize: 12.5 } }, error), data && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "rececoes-requisicao",
      columns: colunas,
      data: data.rows,
      pagination: "client",
      pageSize: 10,
      rowKey: (h) => `${h.nrec}-${h.datarec}-${h.ndocforn}`,
      empty: "Sem rece\xE7\xF5es registadas para esta requisi\xE7\xE3o."
    }
  ));
}
function HistoricoRefPanel({ row }) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  React.useEffect(() => {
    if (!row.ref) return;
    setLoading(true);
    setError("");
    const qs = new URLSearchParams({
      ref: row.ref,
      limit: "100"
    }).toString();
    fetch("/api/procurement/historico/?" + qs, { credentials: "same-origin" }).then((r) => r.ok ? r.json() : r.text().then((t) => Promise.reject(new Error(t || r.status)))).then(setData).catch((e) => setError(String(e.message || e))).finally(() => setLoading(false));
  }, [row.ref]);
  const stats = React.useMemo(() => {
    if (!data || !data.rows || data.rows.length === 0) return null;
    const rows = data.rows;
    const m2Values = rows.map((r) => Number(r.m2preq || 0)).filter((v) => v > 0);
    const avgM2 = m2Values.length ? m2Values.reduce((s, v) => s + v, 0) / m2Values.length : 0;
    const dates = rows.map((r) => r.datareq).filter(Boolean).map((d) => new Date(d)).filter((d) => !isNaN(d.getTime())).sort((a, b) => a - b);
    let avgDaysBetween = null;
    if (dates.length >= 2) {
      const diffs = [];
      for (let i = 1; i < dates.length; i++) {
        diffs.push((dates[i] - dates[i - 1]) / (1e3 * 60 * 60 * 24));
      }
      avgDaysBetween = diffs.reduce((s, v) => s + v, 0) / diffs.length;
    }
    const byMonth = /* @__PURE__ */ new Map();
    for (const d of dates) {
      const k = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
      byMonth.set(k, (byMonth.get(k) || 0) + 1);
    }
    const months = [...byMonth.entries()].sort((a, b) => a[0].localeCompare(b[0]));
    const totalReqs = rows.length;
    return { avgM2, avgDaysBetween, months, totalReqs };
  }, [data]);
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Hist\xF3rico do artigo"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ref ", /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.ref), data ? ` \xB7 ${data.row_count} requisi\xE7\xF5es em hist\xF3rico` : "")), loading && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar", role: "progressbar", "aria-label": "A carregar" }), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 12, color: "#c4434b", fontSize: 12.5 } }, error), data && data.rows.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: 24, textAlign: "center", color: "var(--muted)", fontSize: 13 } }, "Sem requisi\xE7\xF5es desta ref no hist\xF3rico."), stats && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 16,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    borderBottom: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 8, gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))" } }, /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel-2)",
    border: "1px solid var(--border)",
    borderRadius: 8,
    padding: "10px 12px"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    fontWeight: 500
  } }, "Total de requisi\xE7\xF5es"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: "#155e75", marginTop: 4 } }, stats.totalReqs)), /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel-2)",
    border: "1px solid var(--border)",
    borderRadius: 8,
    padding: "10px 12px"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    fontWeight: 500
  } }, "m\xB2 m\xE9dio por requisi\xE7\xE3o"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: "#155e75", marginTop: 4 } }, stats.avgM2.toFixed(1), " m\xB2")), /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel-2)",
    border: "1px solid var(--border)",
    borderRadius: 8,
    padding: "10px 12px"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    fontWeight: 500
  } }, "Taxa m\xE9dia entre encomendas"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: "#155e75", marginTop: 4 } }, stats.avgDaysBetween != null ? `${stats.avgDaysBetween.toFixed(0)} dias` : "\u2014"))), stats.months.length > 0 && (() => {
    const maxCount = Math.max(...stats.months.map((m) => m[1]));
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginBottom: 6 } }, "Encomendas por m\xEAs"), /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      gap: 4,
      alignItems: "flex-end",
      height: 80,
      borderBottom: "1px solid var(--border)",
      paddingBottom: 4
    } }, stats.months.map(([month, count]) => {
      const h = count / maxCount * 70;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: month,
          style: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2
          },
          title: `${month}: ${count} encomenda${count === 1 ? "" : "s"}`
        },
        /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: "var(--muted)" } }, count),
        /* @__PURE__ */ React.createElement("div", { style: {
          width: "100%",
          height: h,
          background: "#155e75",
          borderRadius: "3px 3px 0 0"
        } })
      );
    })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4, marginTop: 4, fontSize: 10, color: "var(--muted)" } }, stats.months.map(([month]) => /* @__PURE__ */ React.createElement("div", { key: month, style: { flex: 1, textAlign: "center", fontFamily: "var(--font-mono)" } }, month.slice(5), "/", month.slice(2, 4)))));
  })()), data && data.rows.length > 0 && (() => {
    const histGetters = {
      fc: (h) => h.fc != null && h.fc !== "" ? Number(h.fc) : null,
      artigos: (h) => {
        const fc = h.fc != null && h.fc !== "" ? Number(h.fc) : null;
        const qtt = h.qtt != null && h.qtt !== "" ? Number(h.qtt) : null;
        return fc != null && fc > 0 && qtt != null ? qtt / fc : null;
      },
      margem: (h) => {
        const pc = h.pcusto != null && h.pcusto !== "" ? Number(h.pcusto) : null;
        const pv = h.pv_final != null && h.pv_final !== "" ? Number(h.pv_final) : null;
        const fc = h.fc != null && h.fc !== "" ? Number(h.fc) : null;
        return pv != null && pv > 0 && pc != null && fc != null && fc > 0 ? (pv - pc * fc) / pv * 100 : null;
      },
      qtt: (h) => h.qtt != null && h.qtt !== "" ? Number(h.qtt) : null,
      qtdrec: (h) => h.qtdrec != null && h.qtdrec !== "" ? Number(h.qtdrec) : null,
      m2preq: (h) => h.m2preq != null && h.m2preq !== "" ? Number(h.m2preq) : null,
      pcusto: (h) => h.pcusto != null && h.pcusto !== "" ? Number(h.pcusto) : null,
      pv_final: (h) => h.pv_final != null && h.pv_final !== "" ? Number(h.pv_final) : null
    };
    const historicoColunas = [
      {
        key: "datareq",
        label: "datareq",
        width: 100,
        minWidth: 90,
        fixed: true,
        render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, h.datareq)
      },
      {
        key: "obrano",
        label: "obrano",
        width: 100,
        minWidth: 80,
        render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, h.obrano)
      },
      {
        key: "nome",
        label: "fornecedor",
        width: 220,
        minWidth: 140,
        render: (h) => /* @__PURE__ */ React.createElement("span", { title: h.nome }, /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, "#", h.no), " ", h.nome)
      },
      {
        key: "cliente",
        label: "cliente",
        width: 180,
        minWidth: 120,
        render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", title: h.cliente }, h.cliente)
      },
      {
        key: "qtt",
        label: "qtt",
        width: 80,
        minWidth: 60,
        align: "right",
        sortValue: histGetters.qtt,
        render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, h.qtt != null ? Number(h.qtt).toFixed(0) : "\u2014")
      },
      {
        key: "m2preq",
        label: "m\xB2 req",
        width: 90,
        minWidth: 70,
        align: "right",
        sortValue: histGetters.m2preq,
        render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, h.m2preq != null ? Number(h.m2preq).toFixed(1) : "\u2014")
      },
      {
        key: "fc",
        label: "fc",
        width: 80,
        minWidth: 60,
        align: "right",
        sortValue: histGetters.fc,
        render: (h) => {
          const v = histGetters.fc(h);
          return /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, v != null ? v.toFixed(4).replace(/\.?0+$/, "") : "\u2014");
        }
      },
      {
        key: "artigos",
        label: "artigos",
        width: 90,
        minWidth: 70,
        align: "right",
        sortValue: histGetters.artigos,
        render: (h) => {
          const v = histGetters.artigos(h);
          return /* @__PURE__ */ React.createElement("span", { className: "td-num" }, v != null ? v.toFixed(0) : "\u2014");
        }
      },
      {
        key: "pcusto",
        label: "pcusto \u20AC/placa",
        width: 150,
        minWidth: 120,
        align: "right",
        sortValue: histGetters.pcusto,
        render: (h) => {
          const v = histGetters.pcusto(h);
          return /* @__PURE__ */ React.createElement("span", { className: "td-num" }, v != null ? v.toFixed(4) : "\u2014");
        }
      },
      {
        key: "pv_final",
        label: "pv_final \u20AC/artigo",
        width: 170,
        minWidth: 140,
        align: "right",
        sortValue: histGetters.pv_final,
        render: (h) => {
          const v = histGetters.pv_final(h);
          return /* @__PURE__ */ React.createElement("span", { className: "td-num" }, v != null ? v.toFixed(4) : "\u2014");
        }
      },
      {
        key: "margem",
        label: "margem %",
        width: 100,
        minWidth: 80,
        align: "right",
        sortValue: histGetters.margem,
        render: (h) => {
          const mb = histGetters.margem(h);
          return /* @__PURE__ */ React.createElement("span", { className: "td-num", style: mb != null && mb < 5 ? { color: "#c4434b", fontWeight: 600 } : void 0 }, mb != null ? `${mb.toFixed(1)}%` : "\u2014");
        }
      },
      {
        key: "qtdrec",
        label: "qtd rec",
        width: 90,
        minWidth: 70,
        align: "right",
        sortValue: histGetters.qtdrec,
        render: (h) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, h.qtdrec != null && h.qtdrec !== "" ? Number(h.qtdrec).toFixed(0) : "\u2014")
      },
      // «Por receber» = qtdrec < qtt (backend, `por_receber`); a
      // dataultrec já não vem vazia, mesmo numa receção parcial.
      {
        key: "dataultrec",
        label: "rececionada",
        width: 130,
        minWidth: 110,
        render: (h) => h.por_receber ? /* @__PURE__ */ React.createElement("span", { style: { color: "#eab308" }, title: h.dataultrec ? `\xFAltima rece\xE7\xE3o ${h.dataultrec}` : void 0 }, "em aberto") : h.dataultrec ? /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, h.dataultrec) : /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014")
      }
    ];
    return /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "procurement",
        viewId: "historico-artigo",
        columns: historicoColunas,
        data: data.rows,
        pagination: "client",
        pageSize: 5,
        rowKey: (h) => `${h.obrano}-${h.datareq}`,
        empty: "Sem requisi\xE7\xF5es."
      }
    );
  })());
}
function savingFromFrame(frame) {
  if (!frame || frame.saving_eur == null) return null;
  const n = Number(frame.saving_eur);
  return Number.isFinite(n) ? n : null;
}
function nexumEntidade(row) {
  return `${row.obrano}~${row.ref}`;
}
window.nexumEntidade = nexumEntidade;
function nexumParseEntidade(entidade) {
  if (!entidade) return null;
  const sep = entidade.includes("~") ? "~" : entidade.includes("/") ? "/" : null;
  if (!sep) return null;
  const idx = entidade.indexOf(sep);
  const obrano = entidade.slice(0, idx);
  const ref = entidade.slice(idx + 1);
  if (!obrano || !ref) return null;
  return { obrano, ref };
}
window.nexumParseEntidade = nexumParseEntidade;
function OpportunityDrawer({
  row,
  position,
  total,
  navList,
  onNavigate,
  onClose,
  onOppChanged,
  estadosTratamento,
  tiposAcao
}) {
  const estados = estadosTratamento || NEXUM_OPP_STATUS;
  const tipos = tiposAcao || NEXUM_TIPOS_ACAO;
  const [detail, setDetail] = React.useState(null);
  const [changingStatus, setChangingStatus] = React.useState(false);
  const [acoes, setAcoes] = React.useState([]);
  const [logs, setLogs] = React.useState([]);
  const reloadDetail = React.useCallback(() => {
    if (!row._opportunity_id) {
      setDetail(null);
      return;
    }
    fetch(`/api/procurement/oportunidades/${row._opportunity_id}/`, { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error(r.status))).then(setDetail).catch(() => {
    });
  }, [row._opportunity_id]);
  React.useEffect(() => {
    reloadDetail();
  }, [reloadDetail]);
  const reloadAcoes = React.useCallback(() => {
    if (!row.obrano || !row.ref) {
      setAcoes([]);
      return;
    }
    const qs = new URLSearchParams({ obrano: String(row.obrano), ref: row.ref }).toString();
    fetch("/api/procurement/acoes/?" + qs, { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error(r.status))).then(setAcoes).catch(() => setAcoes([]));
  }, [row.obrano, row.ref]);
  React.useEffect(() => {
    reloadAcoes();
  }, [reloadAcoes]);
  React.useEffect(() => {
    if (!row._opportunity_id) {
      setLogs([]);
      return;
    }
    let cancelled = false;
    fetch(
      `/api/procurement/oportunidades/${row._opportunity_id}/audit/`,
      { credentials: "same-origin" }
    ).then((r) => r.ok ? r.json() : []).then((events) => {
      if (!cancelled) setLogs((events || []).map((e) => ({
        id: e.id,
        evento: e.verb,
        descricao: e.summary,
        actor_username: e.actor_name,
        criado_em: e.when
      })));
    }).catch(() => {
      if (!cancelled) setLogs([]);
    });
    return () => {
      cancelled = true;
    };
  }, [row._opportunity_id, acoes]);
  const addAcao = async (tipo, texto, atribuidoId, prazo = null) => {
    try {
      const r = await fetch("/api/procurement/acoes/", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-CSRFToken": _getCsrfCookie() },
        body: JSON.stringify({
          obrano: String(row.obrano),
          ref: row.ref,
          tipo,
          texto,
          atribuido_a: atribuidoId || null,
          data_limite: prazo || null
        })
      });
      if (!r.ok) {
        const b = await r.json().catch(() => ({}));
        window.srToast?.(`Falha: ${b.detail || r.status}`);
      } else {
        reloadAcoes();
      }
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const deleteAcao = async (a) => {
    try {
      const r = await fetch(`/api/procurement/acoes/${a.id}/`, {
        method: "DELETE",
        credentials: "same-origin",
        headers: { "X-CSRFToken": _getCsrfCookie() }
      });
      if (!r.ok && r.status !== 204) {
        const b = await r.json().catch(() => ({}));
        window.srToast?.(`Falha: ${b.detail || r.status}`);
      } else {
        reloadAcoes();
      }
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const toggleTratadaAcao = async (a) => {
    try {
      const r = await fetch(`/api/procurement/acoes/${a.id}/`, {
        method: "PATCH",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-CSRFToken": _getCsrfCookie() },
        body: JSON.stringify({ tratada: !a.tratada })
      });
      if (!r.ok) {
        const b = await r.json().catch(() => ({}));
        window.srToast?.(`Falha: ${b.detail || r.status}`);
      } else {
        reloadAcoes();
      }
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const setPrazoAcao = async (a, iso) => {
    try {
      const r = await fetch(`/api/procurement/acoes/${a.id}/`, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": _getCsrfCookie()
        },
        body: JSON.stringify({ data_limite: iso })
      });
      if (!r.ok) {
        const b = await r.json().catch(() => ({}));
        throw new Error(b.detail || r.status);
      }
      reloadAcoes();
    } catch (e) {
      window.srToast?.(`Prazo: ${e.message}`);
    }
  };
  const changeStatus = async (newStatus) => {
    if (!row._opportunity_id || newStatus === (detail && detail.status)) return;
    setChangingStatus(true);
    try {
      const r = await fetch(`/api/procurement/oportunidades/${row._opportunity_id}/`, {
        method: "PATCH",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-CSRFToken": _getCsrfCookie() },
        body: JSON.stringify({ status: newStatus })
      });
      if (!r.ok) {
        const body = await r.json().catch(() => ({}));
        window.srToast?.(`Falha: ${body.detail || r.status}`);
      } else {
        const updated = await r.json();
        setDetail(updated);
        window.srToast?.(`Status \u2192 ${newStatus}`);
        if (onOppChanged) onOppChanged();
      }
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    } finally {
      setChangingStatus(false);
    }
  };
  const fmtWhen = (iso) => {
    if (!iso) return null;
    try {
      return new Date(iso).toLocaleString("pt-PT");
    } catch (_) {
      return String(iso);
    }
  };
  const userLabel = (u) => {
    if (!u) return null;
    const found = (window.SR_USERS || []).find((x) => x.id === u);
    return found ? found.first_name ? `${found.first_name} ${found.last_name || ""}`.trim() : found.username : `#${u}`;
  };
  const frame = row._frame || {};
  const mb = row._margem_bruta_pct != null ? Number(row._margem_bruta_pct) : null;
  const pvf = row.pv_final != null && row.pv_final !== "" ? Number(row.pv_final) : null;
  const pc = row.pcusto != null && row.pcusto !== "" ? Number(row.pcusto) : null;
  const qttNum = row.qtt != null && row.qtt !== "" ? Number(row.qtt) : null;
  const fcNum = row.fc != null && row.fc !== "" ? Number(row.fc) : null;
  const artigosProd = fcNum != null && fcNum > 0 && qttNum != null ? qttNum / fcNum : null;
  const custoTotal = pc != null && qttNum != null ? pc * qttNum : null;
  const custoPorArtigo = pc != null && fcNum != null && fcNum > 0 ? pc * fcNum : null;
  const receitaTotal = pvf != null && artigosProd != null ? pvf * artigosProd : null;
  const margemAbs = receitaTotal != null && custoTotal != null ? receitaTotal - custoTotal : null;
  const fc = fcNum;
  const artigos = artigosProd;
  const desperdicioPct = frame.desperdicio_pct != null ? Number(frame.desperdicio_pct) * 100 : null;
  const pcustoErpM2 = frame.pcusto_erp_m2 != null ? Number(frame.pcusto_erp_m2) : null;
  const precoCfgM2 = frame.preco_compra_m2_config != null ? Number(frame.preco_compra_m2_config) : null;
  const savingEur = pcustoErpM2 != null && precoCfgM2 != null && row.m2preq != null ? (pcustoErpM2 - precoCfgM2) * Number(row.m2preq) : null;
  const canAssign = window.SR_ME?.access_actions?.procurement?.includes("assign") ?? false;
  const assignUser = async (userId) => {
    if (!canAssign) {
      console.warn("assignUser blocked: user lacks assign action");
      return;
    }
    if (!row._opportunity_id) return;
    try {
      const r = await fetch(`/api/procurement/oportunidades/${row._opportunity_id}/`, {
        method: "PATCH",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-CSRFToken": _getCsrfCookie() },
        body: JSON.stringify({ atribuida_a: userId })
      });
      if (!r.ok) {
        const body = await r.json().catch(() => ({}));
        window.srToast?.(`Falha atribui\xE7\xE3o: ${body.detail || r.status}`);
      } else {
        setDetail(await r.json());
        window.srToast?.(userId ? "Atribu\xEDdo" : "Atribui\xE7\xE3o removida");
        if (onOppChanged) onOppChanged();
      }
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const users = window.SR_USERS || [];
  const userById = (id) => id != null ? users.find((u) => u.id === id) : null;
  const atribuidoUsername = userById(detail?.atribuida_a)?.username;
  const combinedAcoes = React.useMemo(() => {
    const out = [];
    if (detail) {
      const criador = userById(detail.criada_por);
      out.push({
        id: `opp-${detail.id}-created`,
        criadoEm: new Date(detail.criada_em),
        autor: criador?.username || null,
        tipo: "system",
        descricao: "Ativou a oportunidade",
        system: true
      });
      if (detail.atribuida_a) {
        const atr = userById(detail.atribuida_a);
        out.push({
          id: `opp-${detail.id}-assigned`,
          criadoEm: new Date(detail.criada_em),
          autor: criador?.username || null,
          atribuido: atr?.username || null,
          tipo: "system",
          descricao: "Atribu\xEDda",
          system: true
        });
      }
      if (detail.fechada_em) {
        const fech = userById(detail.fechada_por);
        out.push({
          id: `opp-${detail.id}-closed`,
          criadoEm: new Date(detail.fechada_em),
          autor: fech?.username || null,
          tipo: "system",
          descricao: detail.status === "cancelada" ? "Cancelada" : "Fechada",
          system: true
        });
      }
    }
    for (const a of acoes) {
      out.push({
        id: a.id,
        criadoEm: new Date(a.criada_em),
        autor: a.criada_por_username,
        atribuido: a.atribuido_a_username,
        tipo: a.tipo,
        descricao: a.texto,
        tratada: a.tratada,
        prazo: a.data_limite || null,
        system: false
      });
    }
    return out;
  }, [detail, acoes, users]);
  const sidePanel = /* @__PURE__ */ React.createElement(React.Fragment, null, row._opportunity_id && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Atribu\xEDdo ao tratamento"), /* @__PURE__ */ React.createElement(Popover, { align: "right", trigger: /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn",
      style: { width: "100%", justifyContent: "space-between" },
      disabled: !canAssign,
      title: canAssign ? "" : "Sem permiss\xE3o para reatribuir (requer action assign)"
    },
    window.UserPill ? /* @__PURE__ */ React.createElement(window.UserPill, { username: atribuidoUsername, users }) : /* @__PURE__ */ React.createElement("span", null, atribuidoUsername || "\u2014 N\xE3o atribu\xEDdo \u2014"),
    /* @__PURE__ */ React.createElement(Ico.chevron, null)
  ) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    assignUser(null);
    close();
  } }, "\u2014 Remover atribui\xE7\xE3o"), users.filter((u) => u.is_active && (u.is_staff || (u.apps || []).includes("procurement"))).map((u) => /* @__PURE__ */ React.createElement(MenuItem, { key: u.id, onClick: () => {
    assignUser(u.id);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { className: "com-avatar", style: { background: "#155e75", width: 16, height: 16, fontSize: 8 } }, (u.first_name ? u.first_name[0] : u.username[0]).toUpperCase()) }, `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username)))), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } })), window.HubActionTimeline && /* @__PURE__ */ React.createElement(
    window.HubActionTimeline,
    {
      streams: {
        acoes: {
          items: combinedAcoes,
          api: {
            onAdd: (tipoId, descricao, atribuidoId, prazo) => addAcao(tipoId, descricao, atribuidoId, prazo),
            onDelete: (a) => deleteAcao(a),
            onToggleTratada: (a) => toggleTratadaAcao(a),
            onSetPrazo: (a, iso) => setPrazoAcao(a, iso)
          }
        },
        logs: { items: logs }
      },
      users,
      me: window.SR_ME,
      appLabel: "procurement",
      appSlug: "procurement",
      resource: "opportunity",
      resourceId: row._opportunity_id,
      assignable: true,
      title: "Notas gerais e tarefas",
      tiposAcao: tipos,
      canDelete: (a) => !a.system
    }
  ));
  const rowKey = `${row.obrano}-${row.ref}`;
  return /* @__PURE__ */ React.createElement(
    DrawerShell,
    {
      title: `${position ? `#${position} \xB7 ` : ""}${row.obrano} / ${row.ref}`,
      subtitle: row.design || row.cliente || "",
      onClose,
      side: sidePanel,
      navList: navList ? navList.map((r) => ({ ...r, id: `${r.obrano}-${r.ref}` })) : [],
      currentId: rowKey,
      onNavigate
    },
    /* @__PURE__ */ React.createElement("div", { style: { padding: 20, display: "flex", flexDirection: "column", gap: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" } }, row._opportunity_id && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(NexumStatusPill, { status: detail?.status || row._opportunity_status, size: "lg", statuses: estados }), /* @__PURE__ */ React.createElement("span", { style: { width: 1, height: 18, background: "var(--border)", margin: "0 4px" } })), /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "var(--bg)", borderColor: "var(--border)", color: "var(--text-2)" } }, row.qualidade, " \xB7 ", row.canal), /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "var(--bg)", borderColor: "var(--border)", color: "var(--text-2)" } }, row.larg, "\xD7", row.comp, " mm"), row.vincoflat && /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "#fbf2e3", borderColor: "#e8c896", color: "#7a4f12" } }, "Vinco flat"), row.reqsos && /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "rgba(234,179,8,0.15)", borderColor: "#eab308", color: "#854d0e" } }, "SOS"), row.antecipacao && /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "rgba(124,58,237,0.15)", borderColor: "#7c3aed", color: "#5b21b6" } }, "Antecipa\xE7\xE3o"), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 10, fontSize: 11.5 } }, /* @__PURE__ */ React.createElement(
      "span",
      {
        style: { display: "inline-flex", alignItems: "center", gap: 4 },
        title: frame.frameable ? "Auto-frameable" : `N\xE3o frameable \u2014 ${frame.reason || ""}`
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: frame.frameable ? "#059669" : "#c4434b",
        opacity: frame.frameable == null ? 0.3 : 1
      } }),
      "Frameable"
    ), (() => {
      const s = savingFromFrame(frame);
      const hasCfg = frame.preco_compra_m2_config != null;
      const color = !hasCfg || s == null || s === 0 ? "#059669" : s > 0 ? "#059669" : "#c4434b";
      const opacity = !hasCfg || s == null || s === 0 ? 0.3 : 1;
      const tip = !hasCfg ? "Sem pre\xE7o config para comparar" : s == null ? "Sem pcusto ERP convert\xEDvel" : s > 0 ? `Saving positivo \u2014 target \xE9 mais barato (${s.toFixed(2)} \u20AC)` : s < 0 ? `Sem saving \u2014 target \xE9 mais caro (${s.toFixed(2)} \u20AC)` : "Pre\xE7o igual";
      return /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 4 }, title: tip }, /* @__PURE__ */ React.createElement("span", { style: { width: 10, height: 10, borderRadius: "50%", background: color, opacity } }), "Pre\xE7o");
    })(), /* @__PURE__ */ React.createElement(
      "span",
      {
        style: { display: "inline-flex", alignItems: "center", gap: 4 },
        title: row._m2_flag ? "m\xB2 acima do threshold" : "m\xB2 abaixo do threshold"
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: row._m2_flag ? "#059669" : "#c4434b"
      } }),
      "m\xB2"
    ), /* @__PURE__ */ React.createElement(
      "span",
      {
        style: { display: "inline-flex", alignItems: "center", gap: 4 },
        title: row.vincoflat ? "Vinco flat" : "Sem vinco flat"
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: row.vincoflat ? "#c4434b" : "var(--muted)",
        opacity: row.vincoflat ? 1 : 0.3
      } }),
      "VF"
    ))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { padding: 10, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.05em" } }, "Desperd\xEDcio"), /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 18,
      fontWeight: 600,
      marginTop: 2,
      color: desperdicioPct != null && desperdicioPct > 15 ? "#c4434b" : desperdicioPct != null && desperdicioPct > 8 ? "#eab308" : "#059669"
    } }, desperdicioPct != null ? `${desperdicioPct.toFixed(2)}%` : "\u2014"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "papel escolhido")), /* @__PURE__ */ React.createElement("div", { style: { padding: 10, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.05em" } }, "Saving estimado"), /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 18,
      fontWeight: 600,
      marginTop: 2,
      color: savingEur != null ? savingEur > 0 ? "#059669" : "#c4434b" : "var(--text)"
    } }, savingEur != null ? `${savingEur.toFixed(2)} \u20AC` : "\u2014"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "vs pre\xE7o target")), /* @__PURE__ */ React.createElement("div", { style: { padding: 10, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.05em" } }, "Valor m\xE9dio"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 600, marginTop: 2 } }, pcustoErpM2 != null ? `${pcustoErpM2.toFixed(4)}` : "\u2014"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "\u20AC/m\xB2 pcusto real"))), row._opportunity_id && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Estado de tratamento"), /* @__PURE__ */ React.createElement("div", { className: "workflow" }, estados.map((s, i) => {
      const curStatus = detail?.status || row._opportunity_status;
      const curIdx = estados.findIndex((x) => x.value === curStatus);
      const cls = s.value === curStatus ? "current" : i < curIdx ? "done" : "";
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: s.value,
          className: "wf-step " + cls,
          onClick: () => changeStatus(s.value),
          style: {
            borderColor: s.value === curStatus ? s.dot : void 0,
            opacity: changingStatus ? 0.6 : 1
          }
        },
        /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "center", gap: 5, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: s.dot } }), /* @__PURE__ */ React.createElement("span", null, s.label))
      );
    }))), /* @__PURE__ */ React.createElement("div", { style: {
      display: "grid",
      gap: 16,
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))"
    } }, /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Identifica\xE7\xE3o"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "grid", gridTemplateColumns: "auto 1fr", gap: 6, fontSize: 13, alignItems: "baseline" } }, position != null && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Linha:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, position, total != null ? ` de ${total}` : "")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "obrano:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, /* @__PURE__ */ React.createElement("strong", null, row.obrano)), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "ref:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.ref), row.design && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Designa\xE7\xE3o:"), /* @__PURE__ */ React.createElement("span", null, row.design)), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Fornecedor:"), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, row.nome), " ", /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, "#", row.no)), row.cliente && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Cliente:"), /* @__PURE__ */ React.createElement("span", null, row.cliente)))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Encomenda"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "grid", gridTemplateColumns: "auto 1fr", gap: 6, fontSize: 13, alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Qualidade / Canal:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.qualidade, " \xB7 ", row.canal), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Dimens\xF5es da placa:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.larg, "\xD7", row.comp, " mm", row.vincoflat && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 8, color: "#f97316" } }, "\xB7 vinco flat")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Quantidade (qtt):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.qtt != null && row.qtt !== "" ? `${Number(row.qtt).toFixed(0)} un.` : /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "m\xB2 requisitados:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, Number(row.m2preq || 0).toFixed(2)), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Fator de convers\xE3o (fc):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, fc != null ? fc.toFixed(4).replace(/\.?0+$/, "") : /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014"), fc === 0 && /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, " (sem fc definido)")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Artigos a produzir:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, artigos != null ? `${artigos.toFixed(0)} un.` : /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Pre\xE7o de custo (pcusto):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, pc != null ? `${pc.toFixed(4)} \u20AC/placa` : "\u2014"), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Pre\xE7o de venda final (pv_final):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, pvf != null ? `${pvf.toFixed(4)} \u20AC/artigo` : "\u2014"), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Custo por artigo (pc \xD7 fc):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, custoPorArtigo != null ? `${custoPorArtigo.toFixed(4)} \u20AC/artigo` : /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014 (sem fc)")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Custo total (placas):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, custoTotal != null ? `${custoTotal.toFixed(2)} \u20AC` : "\u2014"), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Receita total (artigos):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, receitaTotal != null ? `${receitaTotal.toFixed(2)} \u20AC` : /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014 (sem fc)")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Margem bruta:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono", style: mb != null && mb < 5 ? { color: "#c4434b", fontWeight: 600 } : mb != null && mb >= 20 ? { color: "#059669" } : void 0 }, mb != null ? `${mb.toFixed(2)} % (${margemAbs != null ? margemAbs.toFixed(2) + " \u20AC" : "\u2014"})` : "\u2014"), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Data req:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.datareq), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Qtd recebida:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.qtdrec != null && row.qtdrec !== "" ? Number(row.qtdrec).toFixed(0) : "\u2014", row.por_receber && /* @__PURE__ */ React.createElement("span", { style: { color: "#eab308" } }, " \xB7 por receber")), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Data \xFAltima rece\xE7\xE3o:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, row.dataultrec || /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014")), (row.reqsos || row.antecipacao) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Sinaliza\xE7\xF5es:"), /* @__PURE__ */ React.createElement("span", null, row.reqsos && /* @__PURE__ */ React.createElement("span", { style: { color: "#eab308" } }, "SOS "), row.antecipacao && /* @__PURE__ */ React.createElement("span", { style: { color: "#7c3aed" } }, "Antecipa\xE7\xE3o ")))))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Auto-enquadramento (config do target)"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", gap: 8, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12 } }, /* @__PURE__ */ React.createElement("span", { style: {
      width: 12,
      height: 12,
      borderRadius: "50%",
      background: frame.frameable ? "#059669" : "#c4434b",
      opacity: frame.frameable == null ? 0.3 : 1
    } }), "Frameable"), (() => {
      const s = savingFromFrame(frame);
      const hasCfg = frame.preco_compra_m2_config != null;
      const color = !hasCfg || s == null || s === 0 ? "#059669" : s > 0 ? "#059669" : "#c4434b";
      const opacity = !hasCfg || s == null || s === 0 ? 0.3 : 1;
      return /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 12, height: 12, borderRadius: "50%", background: color, opacity } }), "Pre\xE7o vs config");
    })(), /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12 } }, /* @__PURE__ */ React.createElement("span", { style: {
      width: 12,
      height: 12,
      borderRadius: "50%",
      background: row._m2_flag ? "#059669" : "#c4434b"
    } }), "m\xB2 acima do threshold")), frame.frameable ? /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "auto 1fr", gap: 6, fontSize: 13, alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Papel escolhido:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, frame.paper_width_mm, " mm"), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "N\xBA placas / rolo:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, frame.n_placas), /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Desperd\xEDcio:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono", style: { color: "#059669" } }, Number(frame.desperdicio_pct).toFixed(4), " (", (Number(frame.desperdicio_pct) * 100).toFixed(2), "%)"), frame.preco_compra_m2_config != null && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Pre\xE7o config (target):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, Number(frame.preco_compra_m2_config).toFixed(4), " \u20AC/m\xB2")), frame.pcusto_erp_m2 != null && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "pcusto ERP convertido:"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, Number(frame.pcusto_erp_m2).toFixed(4), " \u20AC/m\xB2", /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11.5, marginLeft: 6 } }, "(pcusto \xD7 qtt \xF7 m\xB2preq)"))), frame.custo_estimado != null && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Custo estimado (target):"), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, Number(frame.custo_estimado).toFixed(2), " \u20AC")), (() => {
      const s = savingFromFrame(frame);
      if (s == null) return null;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "Saving:"), /* @__PURE__ */ React.createElement("span", { style: { color: s > 0 ? "#059669" : s < 0 ? "#c4434b" : "var(--text)" } }, s.toFixed(2), " \u20AC", s < 0 ? " \u2014 target \xE9 mais caro" : s > 0 ? " \u2014 target \xE9 mais barato" : ""));
    })()) : /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 13 } }, /* @__PURE__ */ React.createElement("strong", null, "N\xE3o frameable"), frame.reason ? ` \u2014 ${frame.reason}` : ".")), row.obrano && row.ref && /* @__PURE__ */ React.createElement(RececoesPanel, { row }), row.ref && /* @__PURE__ */ React.createElement(HistoricoRefPanel, { row }))
  );
}
window.OpportunityDrawer = OpportunityDrawer;
function ProcurementView({ entidade, params, navigate, routeId, reportCrumb }) {
  const [periodo, setPeriodo] = React.useState(90);
  const [targetNo, setTargetNo] = React.useState(null);
  const [suppliers, setSuppliers] = React.useState([]);
  const [tiposAcao, setTiposAcao] = React.useState(NEXUM_TIPOS_ACAO);
  const [estadosTratamento, setEstadosTratamento] = React.useState(NEXUM_OPP_STATUS);
  React.useEffect(() => {
    fetch("/api/procurement/tipos-acao/", { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error(r.status))).then((list) => {
      const active = list.filter((t) => t.is_active).map((t) => ({
        id: t.codigo,
        nome: t.nome,
        cor: t.cor
      }));
      if (active.length) setTiposAcao(active);
    }).catch(() => {
    });
    fetch("/api/procurement/estados-tratamento/", { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error(r.status))).then((list) => {
      const mapped = list.filter((e) => e.is_active).map((e) => ({
        value: e.codigo,
        label: e.nome,
        dot: e.cor,
        // heurísticas para bg/fg suaves derivadas da cor primária
        bg: e.cor + "22",
        fg: e.cor
      }));
      if (mapped.length) setEstadosTratamento(mapped);
    }).catch(() => {
    });
  }, []);
  const [rows, setRows] = React.useState([]);
  const [meta, setMeta] = React.useState({ row_count: 0, truncated: false, elapsed_ms: 0 });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [search, setSearch] = React.useState("");
  const [searchTokens, setSearchTokens] = React.useState([]);
  const [fFornecedor, setFFornecedor] = React.useState(/* @__PURE__ */ new Set());
  const [fQualidade, setFQualidade] = React.useState(/* @__PURE__ */ new Set());
  const [fCanal, setFCanal] = React.useState(/* @__PURE__ */ new Set());
  const [fEstado, setFEstado] = React.useState(/* @__PURE__ */ new Set());
  const [fStatus, setFStatus] = React.useState(/* @__PURE__ */ new Set());
  const [groupBy, setGroupBy] = React.useState("");
  const [searchAttempted, setSearchAttempted] = React.useState(false);
  const parsedEntidade = React.useMemo(() => nexumParseEntidade(entidade), [entidade]);
  const entidadePendingRef = React.useRef(!!entidade);
  const entidadeCaiuPendenteRef = React.useRef(false);
  React.useEffect(() => {
    if (entidade || !entidadePendingRef.current) return;
    entidadePendingRef.current = false;
    entidadeCaiuPendenteRef.current = true;
  }, [entidade]);
  const [openedRows, setOpenedRows] = React.useState({});
  const cacheRow = React.useCallback((ent, row) => {
    if (!ent || !row) return;
    setOpenedRows((prev) => prev[ent] === row ? prev : { ...prev, [ent]: row });
  }, []);
  React.useEffect(() => {
    if (!parsedEntidade) return;
    const found = rows.find((r) => String(r.obrano) === parsedEntidade.obrano && String(r.ref) === parsedEntidade.ref);
    if (found) cacheRow(entidade, found);
  }, [parsedEntidade, entidade, rows, cacheRow]);
  const selectedRow = React.useMemo(() => {
    if (!parsedEntidade) return null;
    return openedRows[entidade] || rows.find((r) => String(r.obrano) === parsedEntidade.obrano && String(r.ref) === parsedEntidade.ref) || null;
  }, [parsedEntidade, entidade, rows, openedRows]);
  const abrirLinha = (row) => {
    cacheRow(nexumEntidade(row), row);
    navigate({ routeId, entidade: nexumEntidade(row), params });
  };
  const fecharLinha = () => navigate({ routeId, params });
  React.useEffect(() => {
    reportCrumb && reportCrumb(selectedRow ? `${selectedRow.obrano}/${selectedRow.ref}` : null);
    return () => {
      reportCrumb && reportCrumb(null);
    };
  }, [selectedRow, reportCrumb]);
  React.useEffect(() => {
    fetch("/api/procurement/suppliers/", { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error(r.status))).then((list) => {
      setSuppliers(list);
      if (list.length && targetNo == null) {
        const ond = list.find((s) => (s.nome_cache || "").toLowerCase().includes("ondupack"));
        setTargetNo((ond || list[0]).no);
      }
    }).catch(() => {
    });
  }, []);
  const [targetQualidades, setTargetQualidades] = React.useState([]);
  React.useEffect(() => {
    if (targetNo == null) {
      setTargetQualidades([]);
      return;
    }
    fetch(`/api/procurement/suppliers/${targetNo}/qualidades/`, { credentials: "same-origin" }).then((r) => r.ok ? r.json() : Promise.reject(new Error(r.status))).then((list) => {
      setTargetQualidades(list);
      const active = list.filter((q) => q.is_active).map((q) => q.codigo);
      setFQualidade(new Set(active));
    }).catch(() => {
    });
  }, [targetNo]);
  const runSearch = React.useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const from = /* @__PURE__ */ new Date();
      from.setDate(from.getDate() - periodo);
      const iso = from.toISOString().slice(0, 10);
      const qsObj = { datareq_from: iso, excluir_recebidas: "0" };
      if (targetNo != null) qsObj.target_no = String(targetNo);
      if (fQualidade.size && !entidadePendingRef.current) qsObj.qualidades = [...fQualidade].join(",");
      const qs = new URLSearchParams(qsObj).toString();
      const r = await fetch("/api/procurement/pesquisa/?" + qs, { credentials: "same-origin" });
      if (!r.ok) throw new Error(await r.text() || `HTTP ${r.status}`);
      const data = await r.json();
      setRows(data.rows || []);
      setMeta({
        row_count: data.row_count || 0,
        truncated: !!data.truncated,
        elapsed_ms: data.elapsed_ms || 0
      });
    } catch (e) {
      setError(String(e.message || e));
      setRows([]);
      setMeta({ row_count: 0, truncated: false, elapsed_ms: 0 });
    } finally {
      setLoading(false);
      setSearchAttempted(true);
    }
  }, [periodo, targetNo, fQualidade]);
  React.useEffect(() => {
    if (!selectedRow || !entidadePendingRef.current) return;
    entidadePendingRef.current = false;
    runSearch();
  }, [selectedRow, runSearch]);
  React.useEffect(() => {
    if (!entidadeCaiuPendenteRef.current) return;
    entidadeCaiuPendenteRef.current = false;
    runSearch();
  }, [entidade, runSearch]);
  React.useEffect(() => {
    if (targetNo == null) return;
    const t = setTimeout(runSearch, 200);
    return () => clearTimeout(t);
  }, [runSearch, targetNo]);
  React.useEffect(() => {
    if (!entidade || !searchAttempted || loading || error) return;
    if (selectedRow) return;
    window.srToast?.("Linha n\xE3o encontrada.", "error");
    navigate({ routeId, params }, { replace: true });
  }, [entidade, searchAttempted, loading, error, selectedRow, routeId, params]);
  const activate = async (row) => {
    try {
      const r = await fetch("/api/procurement/oportunidades/", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-CSRFToken": _getCsrfCookie() },
        body: JSON.stringify({
          obrano: row.obrano,
          ref: row.ref,
          target_no: targetNo
        })
      });
      if (!r.ok) {
        const body = await r.json().catch(() => ({}));
        window.srToast?.(`Falha: ${body.detail || r.status}`);
        return;
      }
      window.srToast?.("Oportunidade ativada.");
      runSearch();
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const opcoesFornecedor = React.useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    rows.forEach((r) => {
      if (r.no != null) m.set(r.no, r.nome || `#${r.no}`);
    });
    return [...m.entries()].sort((a, b) => String(a[1]).localeCompare(String(b[1]))).map(([no, nome]) => ({ value: String(no), label: `${nome} (${no})` }));
  }, [rows]);
  const opcoesQualidade = React.useMemo(() => {
    return targetQualidades.map((q) => q.codigo).sort().map((q) => ({ value: q, label: q }));
  }, [targetQualidades]);
  const opcoesCanal = React.useMemo(() => {
    const s = /* @__PURE__ */ new Set();
    rows.forEach((r) => {
      if (r.canal) s.add(r.canal);
    });
    return [...s].sort().map((c) => ({ value: c, label: c }));
  }, [rows]);
  const sortGetters = React.useMemo(() => ({
    paper_width_mm: (r) => r._frame && r._frame.paper_width_mm != null ? Number(r._frame.paper_width_mm) : null,
    desperdicio_pct: (r) => r._frame && r._frame.desperdicio_pct != null ? Number(r._frame.desperdicio_pct) : null,
    margem_bruta: (r) => r._margem_bruta_pct != null ? Number(r._margem_bruta_pct) : null,
    frameable: (r) => r._frame && r._frame.frameable ? 1 : 0,
    estado_ativa: (r) => {
      if (!r._opportunity_status) return 0;
      const idx = NEXUM_OPP_STATUS.findIndex((s) => s.value === r._opportunity_status);
      return idx >= 0 ? idx + 1 : 0;
    },
    qtt: (r) => r.qtt != null && r.qtt !== "" ? Number(r.qtt) : null,
    qtdrec: (r) => r.qtdrec != null && r.qtdrec !== "" ? Number(r.qtdrec) : null,
    m2preq: (r) => r.m2preq != null && r.m2preq !== "" ? Number(r.m2preq) : null,
    larg: (r) => r.larg != null ? Number(r.larg) : null,
    obrano: (r) => r.obrano != null ? Number(r.obrano) : null,
    vincoflat: (r) => r.vincoflat ? 1 : 0,
    // Nº de semáforos verdes (0..3): frameable + saving positivo + m² acima do threshold.
    green_count: (r) => {
      const f = r._frame || {};
      let n = 0;
      if (f.frameable) n += 1;
      const s = f.saving_eur != null ? Number(f.saving_eur) : null;
      if (s != null && s > 0) n += 1;
      if (r._m2_flag) n += 1;
      return n;
    },
    saving_eur: (r) => {
      const f = r._frame || {};
      if (f.saving_eur == null) return null;
      const n = Number(f.saving_eur);
      return Number.isFinite(n) ? n : null;
    }
  }), []);
  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    const tokens = searchTokens.map((t) => t.toLowerCase());
    return rows.filter((r) => {
      if (q || tokens.length) {
        const hay = [
          r.obrano,
          r.ref,
          r.design,
          r.nome,
          r.cliente,
          r.qualidade,
          r.canal,
          r.larg,
          r.comp,
          r.m2preq
        ].map((x) => x == null ? "" : String(x).toLowerCase()).join(" ");
        if (q && !hay.includes(q)) return false;
        for (const t of tokens) {
          if (!hay.includes(t)) return false;
        }
      }
      if (fFornecedor.size && !fFornecedor.has(String(r.no))) return false;
      if (fQualidade.size && !fQualidade.has(r.qualidade)) return false;
      if (fCanal.size && !fCanal.has(r.canal)) return false;
      if (fEstado.size) {
        const frame = r._frame || {};
        if (fEstado.has("em_aberto") && !r.por_receber) return false;
        if (fEstado.has("frameable") && !frame.frameable) return false;
        if (fEstado.has("nao_frameable") && frame.frameable) return false;
        if (fEstado.has("discrepancia") && !frame.discrepancia_flag) return false;
        if (fEstado.has("ativa") && !r._opportunity_id) return false;
        if (fEstado.has("sos") && !r.reqsos) return false;
        if (fEstado.has("antecipacao") && !r.antecipacao) return false;
      }
      if (fStatus.size) {
        if (!r._opportunity_status) return false;
        if (!fStatus.has(r._opportunity_status)) return false;
      }
      return true;
    });
  }, [rows, search, searchTokens, fFornecedor, fQualidade, fCanal, fEstado, fStatus]);
  const filteredSorted = React.useMemo(
    () => window.HubTable.applySort(filtered, NEXUM_ORDEM_NAV, sortGetters),
    [filtered, sortGetters]
  );
  const selectedPosition = React.useMemo(() => {
    if (!selectedRow) return null;
    const idx = filteredSorted.findIndex((r) => r.obrano === selectedRow.obrano && r.ref === selectedRow.ref);
    return idx >= 0 ? idx + 1 : null;
  }, [selectedRow, filteredSorted]);
  const searchSuggestions = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q || q.length < 2) return [];
    const seen = /* @__PURE__ */ new Set();
    const already = new Set(searchTokens);
    const out = [];
    for (const r of rows) {
      const vals = [r.obrano, r.ref, r.design, r.nome, r.cliente, r.qualidade, r.canal];
      for (const v of vals) {
        if (v == null || v === "") continue;
        const s = String(v).trim();
        if (!s || seen.has(s) || already.has(s)) continue;
        if (s.toLowerCase().includes(q)) {
          seen.add(s);
          out.push(s);
          if (out.length >= 20) return out;
        }
      }
    }
    return out;
  }, [search, searchTokens, rows]);
  const hasAnyFilter = search.trim() !== "" || searchTokens.length > 0 || fFornecedor.size > 0 || fQualidade.size > 0 || fCanal.size > 0 || fEstado.size > 0 || fStatus.size > 0 || groupBy !== "";
  const clearAllFilters = () => {
    setSearch("");
    setSearchTokens([]);
    setFFornecedor(/* @__PURE__ */ new Set());
    setFQualidade(/* @__PURE__ */ new Set());
    setFCanal(/* @__PURE__ */ new Set());
    setFEstado(/* @__PURE__ */ new Set());
    setFStatus(/* @__PURE__ */ new Set());
    setGroupBy("");
  };
  const commitSearchToken = (val) => {
    const t = String(val || "").trim();
    if (!t) {
      setSearch("");
      return;
    }
    if (!searchTokens.includes(t)) setSearchTokens([...searchTokens, t]);
    setSearch("");
  };
  const removeSearchToken = (idx) => {
    setSearchTokens(searchTokens.filter((_, i) => i !== idx));
  };
  const grouped = React.useMemo(() => {
    if (!groupBy) return [];
    const m = /* @__PURE__ */ new Map();
    filtered.forEach((r) => {
      const key = r[groupBy] || "\u2014";
      if (!m.has(key)) {
        m.set(key, { key, count: 0, m2: 0, custo: 0, frameable: 0, discrepancia: 0, fornecedores: /* @__PURE__ */ new Set() });
      }
      const g = m.get(key);
      g.count += 1;
      g.m2 += Number(r.m2preq || 0);
      const c = r._frame && r._frame.custo_estimado;
      if (c) g.custo += Number(c);
      if (r._frame && r._frame.frameable) g.frameable += 1;
      if (r._frame && r._frame.discrepancia_flag) g.discrepancia += 1;
      if (r.no != null) g.fornecedores.add(r.no);
    });
    return [...m.values()].sort((a, b) => b.count - a.count);
  }, [filtered, groupBy]);
  const totM2 = filtered.reduce((s, r) => s + Number(r.m2preq || 0), 0);
  const totCusto = filtered.reduce((s, r) => {
    const c = r._frame && r._frame.custo_estimado;
    return s + (c ? Number(c) : 0);
  }, 0);
  const frameable = filtered.filter((r) => r._frame && r._frame.frameable).length;
  const nexumColunas = [
    {
      key: "obrano",
      label: "obrano",
      width: 100,
      minWidth: 80,
      fixed: true,
      sortValue: sortGetters.obrano,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, r.obrano)
    },
    // AAAA-MM-DD em fonte monoespaçada (10 carateres) — 100px cortava o dia
    // do mês em todas as linhas; 112px dá folga ao formato + padding da célula.
    {
      key: "datareq",
      label: "datareq",
      width: 112,
      minWidth: 100,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, r.datareq)
    },
    {
      key: "nome",
      label: "fornecedor",
      width: 200,
      minWidth: 140,
      render: (r) => /* @__PURE__ */ React.createElement("span", { title: r.nome }, r.nome)
    },
    {
      key: "cliente",
      label: "cliente",
      width: 180,
      minWidth: 120,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", title: r.cliente }, r.cliente)
    },
    {
      key: "ref",
      label: "ref",
      width: 120,
      minWidth: 90,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, r.ref)
    },
    {
      key: "qualidade",
      label: "qualidade",
      width: 110,
      minWidth: 90,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, r.qualidade)
    },
    {
      key: "canal",
      label: "canal",
      width: 90,
      minWidth: 70,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, r.canal)
    },
    {
      key: "larg",
      label: "larg\xD7comp",
      width: 120,
      minWidth: 100,
      sortValue: sortGetters.larg,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, r.larg, "\xD7", r.comp)
    },
    {
      key: "qtt",
      label: "qtt",
      width: 80,
      minWidth: 60,
      align: "right",
      sortValue: sortGetters.qtt,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, r.qtt != null && r.qtt !== "" ? Number(r.qtt).toFixed(0) : "\u2014")
    },
    {
      key: "qtdrec",
      label: "qtd rec",
      width: 90,
      minWidth: 70,
      align: "right",
      sortValue: sortGetters.qtdrec,
      render: (r) => /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "td-num",
          style: r.por_receber ? { color: "#eab308" } : void 0,
          title: r.por_receber ? "Por receber (qtd recebida < qtt)" : void 0
        },
        r.qtdrec != null && r.qtdrec !== "" ? Number(r.qtdrec).toFixed(0) : "\u2014"
      )
    },
    {
      key: "m2preq",
      label: "m\xB2 req",
      width: 90,
      minWidth: 70,
      align: "right",
      sortValue: sortGetters.m2preq,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, Number(r.m2preq || 0).toFixed(1))
    },
    {
      key: "paper_width_mm",
      label: "papel",
      width: 90,
      minWidth: 70,
      align: "right",
      sortValue: sortGetters.paper_width_mm,
      render: (r) => {
        const frame = r._frame || {};
        return /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "td-num td-mono td-muted",
            title: frame.frameable ? `${frame.n_placas} placa(s) por rolo` : frame.reason || "n\xE3o frameable"
          },
          frame.frameable && frame.paper_width_mm != null ? `${frame.paper_width_mm}` : "\u2014"
        );
      }
    },
    {
      key: "desperdicio_pct",
      label: "desperd.",
      width: 90,
      minWidth: 70,
      align: "right",
      sortValue: sortGetters.desperdicio_pct,
      render: (r) => {
        const frame = r._frame || {};
        return /* @__PURE__ */ React.createElement("span", { className: "td-num", style: frame.frameable && frame.desperdicio_pct != null ? { color: Number(frame.desperdicio_pct) > 0.15 ? "#c4434b" : Number(frame.desperdicio_pct) > 0.08 ? "#eab308" : "#059669" } : void 0 }, frame.frameable && frame.desperdicio_pct != null ? `${(Number(frame.desperdicio_pct) * 100).toFixed(1)}%` : "\u2014");
      }
    },
    {
      key: "margem_bruta",
      label: "margem",
      width: 90,
      minWidth: 70,
      align: "right",
      sortValue: sortGetters.margem_bruta,
      render: (r) => {
        const mb = r._margem_bruta_pct != null ? Number(r._margem_bruta_pct) : null;
        const mbBaixa = mb != null && mb < 5;
        return /* @__PURE__ */ React.createElement("span", { className: "td-num", style: mbBaixa ? {
          background: "rgba(196,67,75,0.12)",
          color: "#c4434b",
          fontWeight: 600
        } : void 0, title: mb == null ? "Sem pv_final ou pcusto" : `Margem bruta ${mb.toFixed(2)}%` }, mb == null ? "\u2014" : `${mb.toFixed(1)}%`);
      }
    },
    {
      key: "saving_eur",
      label: "saving \u20AC",
      width: 100,
      minWidth: 80,
      align: "right",
      sortValue: sortGetters.saving_eur,
      render: (r) => {
        const s = savingFromFrame(r._frame || {});
        return /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "td-num td-mono",
            style: {
              color: s == null ? "var(--muted)" : s > 0 ? "#059669" : s < 0 ? "#c4434b" : "var(--text)"
            },
            title: s == null ? "Sem dados para calcular saving" : `Saving ${s.toFixed(2)} \u20AC`
          },
          s == null ? "\u2014" : `${s.toFixed(2)}`
        );
      }
    },
    // 4 pontos de 10px + 3 espaços de 3px entre eles (29px de gaps) = 49px de
    // conteúdo — 70px cortava-o em todas as linhas; 90px dá folga + padding.
    {
      key: "green_count",
      label: "\u{1F6A6}",
      width: 90,
      minWidth: 76,
      sortValue: sortGetters.green_count,
      render: (r) => {
        const frame = r._frame || {};
        return /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", gap: 3 } }, /* @__PURE__ */ React.createElement(
          "span",
          {
            title: frame.frameable ? "Auto-frameable" : `N\xE3o frameable \u2014 ${frame.reason || ""}`,
            style: {
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: frame.frameable ? "#059669" : "#c4434b",
              opacity: frame.frameable == null ? 0.3 : 1
            }
          }
        ), (() => {
          const s = savingFromFrame(frame);
          const hasCfg = frame.preco_compra_m2_config != null;
          const color = !hasCfg || s == null || s === 0 ? "#059669" : s > 0 ? "#059669" : "#c4434b";
          const opacity = !hasCfg || s == null || s === 0 ? 0.3 : 1;
          const tip = !hasCfg ? "Sem pre\xE7o config" : s == null ? "Sem pcusto ERP convert\xEDvel" : s > 0 ? "Saving positivo \u2014 target mais barato" : s < 0 ? "Sem saving \u2014 target mais caro" : "Pre\xE7o igual";
          return /* @__PURE__ */ React.createElement(
            "span",
            {
              title: tip,
              style: {
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: color,
                opacity
              }
            }
          );
        })(), /* @__PURE__ */ React.createElement(
          "span",
          {
            title: r._m2_flag ? "m\xB2 acima do threshold do target" : "m\xB2 abaixo do threshold do target",
            style: {
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: r._m2_flag ? "#059669" : "#c4434b",
              opacity: 1
            }
          }
        ), /* @__PURE__ */ React.createElement(
          "span",
          {
            title: r.vincoflat ? "Vinco flat" : "Sem vinco flat",
            style: {
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: r.vincoflat ? "#c4434b" : "var(--muted)",
              opacity: r.vincoflat ? 1 : 0.3
            }
          }
        ));
      }
    },
    {
      key: "estado_ativa",
      label: "estado",
      width: 110,
      minWidth: 90,
      sortValue: sortGetters.estado_ativa,
      render: (r) => r._opportunity_status ? /* @__PURE__ */ React.createElement(NexumStatusPill, { status: r._opportunity_status, statuses: estadosTratamento }) : /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11.5 } }, "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 110,
      minWidth: 90,
      render: (r) => {
        const frame = r._frame || {};
        return frame.frameable && !r._opportunity_id ? /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: (e) => {
          e.stopPropagation();
          activate(r);
        } }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Ativar") : null;
      }
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Pesquisa Ondupack"), /* @__PURE__ */ React.createElement("p", { style: { margin: "4px 0 0", fontSize: 13, color: "var(--muted)" } }, "Consulta live do ERP (Trino) com c\xE1lculo per-linha de auto-enquadramento. Pesquisa livre e chips para filtrar.")), /* @__PURE__ */ React.createElement("div", { className: "filters" }, /* @__PURE__ */ React.createElement("div", { className: "search-input", style: {
    minWidth: 320,
    flex: "1 1 320px",
    flexWrap: "wrap",
    gap: 4,
    alignItems: "center"
  } }, /* @__PURE__ */ React.createElement(Ico.search, null), searchTokens.map((t, idx) => /* @__PURE__ */ React.createElement("span", { key: idx, className: "filter-chip active", style: {
    padding: "2px 4px 2px 8px",
    fontSize: 12,
    gap: 4,
    cursor: "default"
  } }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, t), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => removeSearchToken(idx),
      title: "Remover",
      style: {
        background: "none",
        border: 0,
        cursor: "pointer",
        color: "inherit",
        padding: "0 4px",
        lineHeight: 1,
        fontSize: 14,
        fontWeight: 600
      }
    },
    "\xD7"
  ))), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      list: "nexum-search-suggestions",
      placeholder: searchTokens.length ? "Adicionar filtro\u2026" : "Pesquisar por obrano, ref, design, fornecedor, cliente, qualidade, canal\u2026",
      value: search,
      onChange: (e) => {
        const val = e.target.value;
        if (e.nativeEvent && e.nativeEvent.inputType === "insertReplacementText") {
          commitSearchToken(val);
        } else {
          setSearch(val);
        }
      },
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          if (search.trim()) commitSearchToken(search);
        } else if (e.key === "Backspace" && !search && searchTokens.length) {
          e.preventDefault();
          removeSearchToken(searchTokens.length - 1);
        }
      },
      autoFocus: true,
      style: { flex: 1, minWidth: 140 }
    }
  ), /* @__PURE__ */ React.createElement("datalist", { id: "nexum-search-suggestions" }, searchSuggestions.map((s) => /* @__PURE__ */ React.createElement("option", { key: s, value: s })))), /* @__PURE__ */ React.createElement(
    "label",
    {
      className: "filter-chip" + (targetNo != null ? " active" : ""),
      style: { display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 8px", cursor: "pointer" }
    },
    /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "Target:"),
    /* @__PURE__ */ React.createElement(
      "select",
      {
        value: targetNo != null ? String(targetNo) : "",
        onChange: (e) => setTargetNo(Number(e.target.value)),
        style: { border: 0, background: "transparent", fontSize: 12.5, padding: "0 4px", cursor: "pointer" },
        disabled: suppliers.length === 0,
        title: suppliers.length === 0 ? "Adiciona um fornecedor em Configura\xE7\xF5es" : "Fornecedor contra o qual testar o enquadramento"
      },
      suppliers.length === 0 && /* @__PURE__ */ React.createElement("option", { value: "" }, "(sem fornecedores)"),
      suppliers.map((s) => /* @__PURE__ */ React.createElement("option", { key: s.no, value: String(s.no) }, s.nome_cache || "?", " (#", s.no, ")"))
    )
  ), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Per\xEDodo",
      value: /* @__PURE__ */ new Set([String(periodo)]),
      setValue: (next) => {
        const set = typeof next === "function" ? next(/* @__PURE__ */ new Set([String(periodo)])) : next;
        const arr = [...set].filter((v) => v !== String(periodo));
        if (arr.length) setPeriodo(Number(arr[arr.length - 1]));
      },
      options: NEXUM_PERIODOS.map((p) => ({ value: String(p.value), label: p.label }))
    }
  ), /* @__PURE__ */ React.createElement(ChipFilter, { label: "Fornecedor", value: fFornecedor, setValue: setFFornecedor, options: opcoesFornecedor }), /* @__PURE__ */ React.createElement(ChipFilter, { label: "Qualidade", value: fQualidade, setValue: setFQualidade, options: opcoesQualidade }), /* @__PURE__ */ React.createElement(ChipFilter, { label: "Canal", value: fCanal, setValue: setFCanal, options: opcoesCanal }), /* @__PURE__ */ React.createElement(ChipFilter, { label: "Estado", value: fEstado, setValue: setFEstado, options: NEXUM_ESTADOS }), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Status Opp",
      value: fStatus,
      setValue: setFStatus,
      options: estadosTratamento.map((s) => ({ value: s.value, label: s.label, dot: s.dot }))
    }
  ), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Agrupar por",
      value: new Set(groupBy ? [groupBy] : []),
      setValue: (next) => {
        const set = typeof next === "function" ? next(new Set(groupBy ? [groupBy] : [])) : next;
        const arr = [...set].filter((v) => v !== groupBy);
        if (arr.length) setGroupBy(arr[arr.length - 1]);
        else if (set.size === 0) setGroupBy("");
      },
      options: NEXUM_GRUPOS
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 8, alignItems: "center", fontSize: 12.5, color: "var(--muted)" } }, loading ? /* @__PURE__ */ React.createElement("span", null, "A carregar\u2026") : /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--text)" } }, filtered.length), " de ", rows.length, " linhas \xB7 ", meta.elapsed_ms, " ms"), hasAnyFilter && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: clearAllFilters,
      title: "Limpa search, tokens e chips (mant\xE9m per\xEDodo e target)"
    },
    "Limpar filtros"
  ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: runSearch, disabled: loading }, "Atualizar"))), error && /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 12,
    padding: 10,
    background: "rgba(196,67,75,0.08)",
    border: "1px solid rgba(196,67,75,0.35)",
    borderRadius: 6,
    color: "#c4434b",
    fontSize: 12.5
  } }, error), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginTop: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Resultados"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", filtered.length, " linhas \xB7 ", totM2.toFixed(1), " m\xB2 \xB7 ", totCusto.toFixed(2), " \u20AC \xB7 ", frameable, " frameable")), filtered.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { padding: 40, textAlign: "center", color: "var(--muted)" } }, loading ? "A carregar\u2026" : rows.length === 0 ? "Sem resultados no per\xEDodo selecionado. Alarga o per\xEDodo no chip acima." : "Nenhuma linha bate certo com os filtros. Ajusta ou limpa os chips.") : groupBy ? (() => {
    const resumoColunas = [
      {
        key: "key",
        label: NEXUM_GRUPOS.find((g) => g.value === groupBy)?.label || groupBy,
        width: 220,
        minWidth: 140,
        fixed: true,
        render: (g) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, /* @__PURE__ */ React.createElement("strong", null, g.key))
      },
      {
        key: "count",
        label: "N\xBA linhas",
        width: 100,
        minWidth: 80,
        align: "right",
        render: (g) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, g.count)
      },
      {
        key: "fornecedores",
        label: "Fornecedores",
        width: 120,
        minWidth: 90,
        align: "right",
        render: (g) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, g.fornecedores.size)
      },
      {
        key: "m2",
        label: "m\xB2 req",
        width: 100,
        minWidth: 80,
        align: "right",
        render: (g) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, g.m2.toFixed(1))
      },
      {
        key: "custo",
        label: "Custo est. \u20AC",
        width: 120,
        minWidth: 90,
        align: "right",
        render: (g) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, g.custo.toFixed(2))
      },
      {
        key: "frameable",
        label: "Frameable",
        width: 100,
        minWidth: 80,
        align: "right",
        render: (g) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { color: g.frameable > 0 ? "#059669" : "var(--muted)" } }, g.frameable)
      },
      {
        key: "discrepancia",
        label: "Sem saving",
        width: 110,
        minWidth: 90,
        align: "right",
        render: (g) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { color: g.discrepancia > 0 ? "#c4434b" : "var(--muted)" } }, g.discrepancia)
      }
    ];
    return /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "procurement",
        viewId: "resumo-enquadramento",
        columns: resumoColunas,
        data: grouped,
        rowKey: (g) => g.key,
        onRowClick: (g) => {
          if (groupBy === "ref") commitSearchToken(g.key);
          else if (groupBy === "qualidade") setFQualidade(/* @__PURE__ */ new Set([g.key]));
          else if (groupBy === "canal") setFCanal(/* @__PURE__ */ new Set([g.key]));
          else if (groupBy === "cliente") commitSearchToken(g.key);
          setGroupBy("");
        },
        empty: "Sem grupos."
      }
    );
  })() : /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "pesquisa",
      columns: nexumColunas,
      data: filtered,
      pagination: "client",
      rowKey: (r) => `${r.obrano}-${r.ref}`,
      onRowClick: abrirLinha,
      empty: "Sem resultados."
    }
  ), meta.truncated && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, textAlign: "center", color: "var(--muted)", fontSize: 12, borderTop: "1px solid var(--border)" } }, "Backend truncou a ", rows.length, " linhas \u2014 encurta o per\xEDodo se precisares de mais precis\xE3o.")), selectedRow && /* @__PURE__ */ React.createElement(
    OpportunityDrawer,
    {
      row: selectedRow,
      position: selectedPosition,
      total: filtered.length,
      navList: filteredSorted,
      estadosTratamento,
      tiposAcao,
      onNavigate: abrirLinha,
      onClose: fecharLinha,
      onOppChanged: runSearch
    }
  ));
}
window.ProcurementView = ProcurementView;

// ===== procurement/frontend/procurement_dashboard.jsx =====
const NEXUM_ACCENT = "#155e75";
const fmtM2 = (n) => `${Number(n || 0).toLocaleString("fr-FR").replace(/\s/g, " ")} m\xB2`;
const fmtInt = (n) => Number(n || 0).toLocaleString("fr-FR").replace(/\s/g, " ");
const kpiLabel = (k) => ({
  candidatos_frameable: "Candidatos frameable (30d)",
  ativadas: "Oportunidades ativadas (30d)",
  fechadas: "Fechadas (30d)",
  m2_poupados: "m\xB2 poupados (30d)",
  alertas_discrepancia_abertos: "Sem saving em aberto"
})[k] || k;
function ProcurementKpiCard({ label, value, accent }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 10,
    padding: "12px 16px",
    minWidth: 180
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    fontWeight: 500
  } }, label), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 24, fontWeight: 700, color: accent || "var(--text)", marginTop: 6 } }, value));
}
window.ProcurementKpiCard = ProcurementKpiCard;
function StatusPill({ status }) {
  const map = {
    nova: { label: "Nova", bg: "rgba(37,99,235,0.12)", fg: "#1d4ed8" },
    atribuida: { label: "Atribu\xEDda", bg: "rgba(147,51,234,0.12)", fg: "#7e22ce" },
    em_curso: { label: "Em curso", bg: "rgba(234,88,12,0.12)", fg: "#c2410c" },
    fechada: { label: "Fechada", bg: "rgba(5,150,105,0.12)", fg: "#047857" },
    cancelada: { label: "Cancelada", bg: "rgba(107,114,128,0.15)", fg: "#4b5563" }
  };
  const it = map[status] || { label: status, bg: "var(--panel-2)", fg: "var(--text)" };
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 999,
    background: it.bg,
    color: it.fg,
    fontSize: 11.5,
    fontWeight: 600
  } }, it.label);
}
window.NexumStatusPill = StatusPill;
function nexumFmtDate(iso) {
  if (!iso) return "\u2014";
  try {
    return new Date(iso).toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch (e) {
    return String(iso).slice(0, 10);
  }
}
function ProcurementDashboardView() {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const reload = React.useCallback(async () => {
    setError("");
    setLoading(true);
    try {
      const r = await fetch("/api/procurement/dashboard/", { credentials: "same-origin" });
      if (!r.ok) throw new Error(await r.text() || `HTTP ${r.status}`);
      setData(await r.json());
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setLoading(false);
    }
  }, []);
  React.useEffect(() => {
    reload();
  }, [reload]);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Dashboard"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 KPIs, tend\xEAncias e \xFAltimas oportunidades (\xFAltimos 30 dias)"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", style: { marginLeft: "auto" }, onClick: reload, disabled: loading }, loading ? "A atualizar\u2026" : "Atualizar")), error && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 10,
    background: "rgba(196,67,75,0.08)",
    border: "1px solid rgba(196,67,75,0.35)",
    borderRadius: 6,
    color: "#c4434b",
    fontSize: 12.5,
    marginBottom: 16
  } }, error), !data && !error ? /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 40, textAlign: "center", color: "var(--muted)" } }, "A carregar\u2026") : data && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gap: 12,
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))"
  } }, /* @__PURE__ */ React.createElement(
    ProcurementKpiCard,
    {
      label: kpiLabel("candidatos_frameable"),
      value: fmtInt(data.kpis.candidatos_frameable),
      accent: NEXUM_ACCENT
    }
  ), /* @__PURE__ */ React.createElement(
    ProcurementKpiCard,
    {
      label: kpiLabel("ativadas"),
      value: fmtInt(data.kpis.ativadas),
      accent: NEXUM_ACCENT
    }
  ), /* @__PURE__ */ React.createElement(
    ProcurementKpiCard,
    {
      label: kpiLabel("fechadas"),
      value: fmtInt(data.kpis.fechadas),
      accent: "#059669"
    }
  ), /* @__PURE__ */ React.createElement(
    ProcurementKpiCard,
    {
      label: kpiLabel("m2_poupados"),
      value: fmtM2(data.kpis.m2_poupados),
      accent: NEXUM_ACCENT
    }
  ), /* @__PURE__ */ React.createElement(
    ProcurementKpiCard,
    {
      label: kpiLabel("alertas_discrepancia_abertos"),
      value: fmtInt(data.kpis.alertas_discrepancia_abertos),
      accent: data.kpis.alertas_discrepancia_abertos > 0 ? "#c4434b" : "var(--muted)"
    }
  )), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gap: 16,
    marginTop: 16,
    gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))"
  } }, /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Top 10 fornecedores"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 candidatos frameable")), data.charts.top_fornecedores.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { padding: 24, textAlign: "center", color: "var(--muted)", fontSize: 13 } }, "Sem candidatos frameable no per\xEDodo. Corre ", /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, "procurement_refresh_candidates"), " para gerar.") : (() => {
    const max = Math.max(...data.charts.top_fornecedores.map((r) => r.n));
    const fornecedoresColunas = [
      {
        key: "supplier_no",
        label: "Fornecedor #",
        width: 140,
        minWidth: 100,
        fixed: true,
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, r.supplier_no)
      },
      {
        key: "n",
        label: "Candidatos",
        width: 110,
        minWidth: 90,
        align: "right",
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, fmtInt(r.n))
      },
      {
        key: "dist",
        label: "Distribui\xE7\xE3o",
        width: 220,
        minWidth: 140,
        sortable: false,
        render: (r) => /* @__PURE__ */ React.createElement("div", { style: { background: "var(--bg)", borderRadius: 3, height: 8, overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: {
          width: `${r.n / max * 100}%`,
          height: "100%",
          background: NEXUM_ACCENT
        } }))
      }
    ];
    return /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "procurement",
        viewId: "dashboard-fornecedores",
        columns: fornecedoresColunas,
        data: data.charts.top_fornecedores,
        pagination: "client",
        rowKey: (r) => r.supplier_no,
        empty: "Sem candidatos frameable."
      }
    );
  })()), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Desperd\xEDcio m\xE9dio por qualidade"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 das oportunidades no per\xEDodo")), data.charts.waste_por_qualidade.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { padding: 24, textAlign: "center", color: "var(--muted)", fontSize: 13 } }, "Ainda n\xE3o h\xE1 oportunidades ativadas para calcular.") : (() => {
    const max = Math.max(...data.charts.waste_por_qualidade.map((r) => Number(r.desperdicio_medio || 0)));
    const qualidadeColunas = [
      {
        key: "qualidade_codigo",
        label: "Qualidade",
        width: 140,
        minWidth: 100,
        fixed: true,
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, /* @__PURE__ */ React.createElement("strong", null, r.qualidade_codigo || "\u2014"))
      },
      {
        key: "desperdicio_medio",
        label: "Desperd\xEDcio m\xE9dio",
        width: 150,
        minWidth: 120,
        align: "right",
        render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, Number(r.desperdicio_medio || 0).toFixed(4))
      },
      {
        key: "dist",
        label: "Distribui\xE7\xE3o",
        width: 220,
        minWidth: 140,
        sortable: false,
        render: (r) => {
          const v = Number(r.desperdicio_medio || 0);
          return /* @__PURE__ */ React.createElement("div", { style: { background: "var(--bg)", borderRadius: 3, height: 8, overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: {
            width: `${max > 0 ? v / max * 100 : 0}%`,
            height: "100%",
            background: v > 0.05 ? "#c4434b" : NEXUM_ACCENT
          } }));
        }
      }
    ];
    return /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "procurement",
        viewId: "dashboard-qualidade",
        columns: qualidadeColunas,
        data: data.charts.waste_por_qualidade,
        pagination: "client",
        rowKey: (r) => r.qualidade_codigo || "\u2014",
        empty: "Sem dados de desperd\xEDcio."
      }
    );
  })())), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginTop: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "\xDAltimas oportunidades ativadas"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 mais recentes primeiro")), data.ultimas_ativadas.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { padding: 24, textAlign: "center", color: "var(--muted)", fontSize: 13 } }, "Sem oportunidades ativadas ainda. Abre a Pesquisa Ondupack e ativa a primeira.") : /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "dashboard-atribuicoes",
      columns: [
        {
          key: "id",
          label: "#",
          width: 80,
          minWidth: 60,
          fixed: true,
          render: (o) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, o.id)
        },
        {
          key: "supplier_no",
          label: "Fornecedor",
          width: 120,
          minWidth: 90,
          render: (o) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, o.supplier_no)
        },
        {
          key: "obrano",
          label: "obrano / ref",
          width: 160,
          minWidth: 120,
          render: (o) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, o.obrano, " / ", o.ref)
        },
        {
          key: "status",
          label: "Status",
          width: 120,
          minWidth: 90,
          render: (o) => /* @__PURE__ */ React.createElement(StatusPill, { status: o.status })
        },
        {
          key: "atribuida_a",
          label: "Atribu\xEDda a",
          width: 150,
          minWidth: 100,
          render: (o) => o.atribuida_a || /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014")
        },
        {
          key: "criada_em",
          label: "Criada em",
          width: 120,
          minWidth: 100,
          render: (o) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, nexumFmtDate(o.criada_em))
        }
      ],
      data: data.ultimas_ativadas,
      pagination: "client",
      rowKey: (o) => o.id,
      empty: "Sem oportunidades ativadas."
    }
  ))));
}
window.ProcurementDashboardView = ProcurementDashboardView;

// ===== procurement/frontend/procurement_configuracoes.jsx =====
function _getCsrfCookie() {
  const m = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}
async function apiGet(path) {
  const r = await fetch(path, { credentials: "same-origin" });
  if (!r.ok) throw new Error(await r.text() || String(r.status));
  return r.json();
}
async function apiSend(method, path, body) {
  const r = await fetch(path, {
    method,
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", "X-CSRFToken": _getCsrfCookie() },
    body: body === void 0 ? void 0 : JSON.stringify(body)
  });
  if (!r.ok) throw new Error(await r.text() || String(r.status));
  return r.status === 204 ? null : r.json();
}
function NovoFornecedorModal({ onClose, onSubmit }) {
  const [no, setNo] = React.useState("");
  const submit = (e) => {
    e.preventDefault();
    const n = parseInt(no, 10);
    if (!Number.isFinite(n) || n <= 0) return;
    onSubmit(n);
  };
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title: "Novo fornecedor",
      subtitle: "Introduz o n\xBA ERP do fornecedor. O nome \xE9 preenchido automaticamente da \xFAltima linha do reqs quando dispon\xEDvel.",
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "novo-fornecedor-form", className: "btn primary sm" }, "Criar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: "novo-fornecedor-form",
        onSubmit: submit,
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "N\xBA ERP"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "number",
          value: no,
          onChange: (e) => setNo(e.target.value),
          autoFocus: true,
          required: true,
          min: 1,
          placeholder: "ex. 353"
        }
      ))
    )
  );
}
window.NovoFornecedorModal = NovoFornecedorModal;
function SupplierListView({ suppliers, error, onNovo, onEditar, onApagar }) {
  const columns = [
    {
      key: "no",
      label: "N\xBA ERP",
      width: 90,
      minWidth: 75,
      fixed: true,
      mono: true,
      render: (s) => s.no
    },
    {
      // 270 e não 230: o nome mais longo ("DS SMITH PACKAGING PORTUGAL, SA.")
      // precisa de 265px, e a soma das colunas ainda cabe no contentor — cortar
      // um nome de fornecedor havendo folga não se justifica.
      key: "nome",
      label: "Nome",
      width: 270,
      minWidth: 200,
      render: (s) => /* @__PURE__ */ React.createElement("strong", null, s.nome_cache || "\u2014")
    },
    {
      // "Desperdício médio" (17 carateres) leva 150/120 em
      // procurement_dashboard.jsx — mesma ordem de grandeza deste rótulo.
      // 175: aqui quem manda é o CABEÇALHO, não a célula — "Margem desperdício"
      // precisa de 162px e o valor é uma percentagem curta. Subiu de 158 quando
      // alargar a coluna Nome tirou o esticamento do colgroup que a safava.
      key: "margem",
      label: "Margem desperd\xEDcio",
      width: 175,
      minWidth: 150,
      align: "right",
      mono: true,
      render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, Number(s.margem_desperdicio).toFixed(3))
    },
    {
      key: "larguras",
      label: "Larguras de papel",
      width: 155,
      minWidth: 125,
      align: "right",
      mono: true,
      render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, s._paper_count ?? "\u2014")
    },
    {
      key: "qualidades",
      label: "Qualidades",
      width: 115,
      minWidth: 95,
      align: "right",
      mono: true,
      render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, s._qualidade_count ?? "\u2014")
    },
    {
      key: "ativo",
      label: "Ativo",
      width: 75,
      minWidth: 60,
      render: (s) => s.is_active ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 170,
      minWidth: 150,
      render: (s) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => onEditar(s.no) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => onApagar(s) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 1100 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Fornecedores"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 config de auto-enquadramento por fornecedor"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: onNovo }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Novo fornecedor")), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "config-fornecedores",
      columns,
      data: suppliers,
      pagination: "none",
      rowKey: (s) => s.no,
      empty: "Sem fornecedores configurados. Cria um para come\xE7ar o auto-enquadramento."
    }
  ));
}
window.SupplierListView = SupplierListView;
function GeralPanel({ supplier, onSaved }) {
  const [form, setForm] = React.useState(supplier);
  React.useEffect(() => {
    setForm(supplier);
  }, [supplier.no]);
  const save = async () => {
    try {
      const s = await apiSend("PATCH", `/api/procurement/suppliers/${supplier.no}/`, form);
      window.srToast?.("Guardado.");
      onSaved(s);
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const refrescar = async () => {
    try {
      const s = await apiSend("POST", `/api/procurement/suppliers/${supplier.no}/refrescar-nome/`);
      setForm((f) => ({ ...f, nome_cache: s.nome_cache }));
      onSaved(s);
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Geral"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", style: { marginLeft: "auto" }, onClick: refrescar }, "Refrescar nome do ERP")), /* @__PURE__ */ React.createElement("div", { style: { padding: 16, display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "N\xBA ERP"), /* @__PURE__ */ React.createElement("input", { value: form.no, readOnly: true })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { flex: 2 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: form.nome_cache || "",
      onChange: (e) => setForm((f) => ({ ...f, nome_cache: e.target.value }))
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Margem de desperd\xEDcio (0..1)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "0.001",
      min: "0",
      max: "1",
      value: form.margem_desperdicio,
      onChange: (e) => setForm((f) => ({ ...f, margem_desperdicio: e.target.value }))
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Threshold de m\xB2 por linha (sem\xE1foro verde)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "0.01",
      min: "0",
      value: form.m2_media_threshold || 0,
      onChange: (e) => setForm((f) => ({ ...f, m2_media_threshold: e.target.value }))
    }
  ))), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: form.is_active,
      onChange: (e) => setForm((f) => ({ ...f, is_active: e.target.checked }))
    }
  ), "Ativo"), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: save }, "Guardar Geral"))));
}
window.GeralPanel = GeralPanel;
function MaquinaPanel({ supplier, onSaved }) {
  const [form, setForm] = React.useState(supplier);
  React.useEffect(() => {
    setForm(supplier);
  }, [supplier.no]);
  const save = async () => {
    try {
      const s = await apiSend("PATCH", `/api/procurement/suppliers/${supplier.no}/`, form);
      window.srToast?.("Guardado.");
      onSaved(s);
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const fields = [
    ["maquina_larg_min_mm", "Largura m\xEDn (mm)"],
    ["maquina_larg_max_mm", "Largura m\xE1x (mm)"],
    ["maquina_comp_min_mm", "Comprimento m\xEDn (mm)"],
    ["maquina_comp_max_mm", "Comprimento m\xE1x (mm)"]
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "M\xE1quina"), /* @__PURE__ */ React.createElement("span", { className: "sub", style: { marginLeft: 8 } }, "\xB7 limites que a placa cortada tem que respeitar")), /* @__PURE__ */ React.createElement("div", { style: { padding: 16, display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field-row" }, fields.slice(0, 2).map(([k, label]) => /* @__PURE__ */ React.createElement("div", { key: k, className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: 0,
      value: form[k],
      onChange: (e) => setForm((f) => ({ ...f, [k]: Number(e.target.value) }))
    }
  )))), /* @__PURE__ */ React.createElement("div", { className: "field-row" }, fields.slice(2).map(([k, label]) => /* @__PURE__ */ React.createElement("div", { key: k, className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: 0,
      value: form[k],
      onChange: (e) => setForm((f) => ({ ...f, [k]: Number(e.target.value) }))
    }
  )))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: save }, "Guardar M\xE1quina"))));
}
window.MaquinaPanel = MaquinaPanel;
function PaperWidthsPanel({ supplier }) {
  const [list, setList] = React.useState([]);
  const [novo, setNovo] = React.useState("");
  const reload = React.useCallback(async () => {
    try {
      setList(await apiGet(`/api/procurement/suppliers/${supplier.no}/paper-widths/`));
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  }, [supplier.no]);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const add = async (e) => {
    e?.preventDefault?.();
    const v = Number(novo);
    if (!v || v <= 0) return;
    try {
      await apiSend("POST", `/api/procurement/suppliers/${supplier.no}/paper-widths/`, { largura_mm: v });
      setNovo("");
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  const del = async (id) => {
    if (!await window.hubConfirm({ message: "Apagar esta largura?" })) return;
    try {
      await apiSend("DELETE", `/api/procurement/suppliers/${supplier.no}/paper-widths/${id}/`);
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  const columns = [
    {
      key: "largura",
      label: "Largura (mm)",
      width: 145,
      minWidth: 125,
      fixed: true,
      align: "right",
      mono: true,
      render: (p) => p.largura_mm
    },
    {
      key: "ativa",
      label: "Ativa",
      width: 90,
      minWidth: 75,
      render: (p) => p.is_active ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 130,
      minWidth: 110,
      render: (p) => /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => del(p.id) }, /* @__PURE__ */ React.createElement(Ico.trash, null), " Apagar")
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Larguras de papel"), /* @__PURE__ */ React.createElement("span", { className: "sub", style: { marginLeft: 8 } }, "\xB7 medidas discretas dos rolos que o fornecedor vende")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "config-larguras-papel",
      columns,
      data: list,
      pagination: "none",
      rowKey: (p) => p.id,
      empty: "Sem larguras. Adiciona pelo menos uma para o auto-enquadramento funcionar."
    }
  ), /* @__PURE__ */ React.createElement("form", { onSubmit: add, style: { display: "flex", gap: 8, padding: 12, borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: novo,
      onChange: (e) => setNovo(e.target.value),
      placeholder: "ex. 2500",
      min: 1,
      style: { maxWidth: 200 }
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn primary sm" }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Adicionar")));
}
window.PaperWidthsPanel = PaperWidthsPanel;
function CanaisEditor({ supplier, qualidade }) {
  const [canais, setCanais] = React.useState([]);
  const [novo, setNovo] = React.useState("");
  const reload = React.useCallback(async () => {
    try {
      setCanais(await apiGet(`/api/procurement/suppliers/${supplier.no}/qualidades/${qualidade.id}/canais/`));
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  }, [supplier.no, qualidade.id]);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const add = async (e) => {
    e?.preventDefault?.();
    if (!novo.trim()) return;
    try {
      await apiSend("POST", `/api/procurement/suppliers/${supplier.no}/qualidades/${qualidade.id}/canais/`, { canal: novo.trim() });
      setNovo("");
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  const del = async (cid) => {
    try {
      await apiSend("DELETE", `/api/procurement/suppliers/${supplier.no}/qualidades/${qualidade.id}/canais/${cid}/`);
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" } }, canais.map((c) => /* @__PURE__ */ React.createElement("span", { key: c.id, style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 6px 2px 8px",
    borderRadius: 999,
    background: "var(--panel-2)",
    border: "1px solid var(--border)",
    fontSize: 12,
    fontFamily: "var(--font-mono)"
  } }, c.canal, /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: () => del(c.id),
      title: "Remover",
      style: { background: "transparent", border: 0, cursor: "pointer", color: "var(--muted)", padding: "0 4px" }
    },
    "\xD7"
  ))), /* @__PURE__ */ React.createElement("form", { onSubmit: add, style: { display: "inline-flex", gap: 4 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: novo,
      onChange: (e) => setNovo(e.target.value),
      placeholder: "+ canal (ex. B)",
      style: { width: 100, fontSize: 12 }
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn ghost sm", style: { padding: "2px 8px" } }, "+")));
}
function QualidadeFormModal({ initial, onClose, onSubmit, title }) {
  const [codigo, setCodigo] = React.useState(initial?.codigo || "");
  const [preco, setPreco] = React.useState(initial?.preco_compra_m2 ?? "");
  const [isActive, setIsActive] = React.useState(initial?.is_active ?? true);
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "qualidade-form", className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement("form", { id: "qualidade-form", onSubmit: (e) => {
      e.preventDefault();
      if (!codigo.trim()) return;
      onSubmit({ codigo: codigo.trim(), preco_compra_m2: preco || "0", is_active: isActive });
    }, style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "C\xF3digo"), /* @__PURE__ */ React.createElement(
      "input",
      {
        value: codigo,
        onChange: (e) => setCodigo(e.target.value),
        required: true,
        autoFocus: true,
        placeholder: "ex. BC1"
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Pre\xE7o de compra (\u20AC/m\xB2)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        step: "0.0001",
        min: "0",
        value: preco,
        onChange: (e) => setPreco(e.target.value),
        placeholder: "ex. 0.4200"
      }
    )), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: isActive, onChange: (e) => setIsActive(e.target.checked) }), "Ativa"))
  );
}
window.QualidadeFormModal = QualidadeFormModal;
function QualidadesPanel({ supplier }) {
  const [list, setList] = React.useState([]);
  const [creating, setCreating] = React.useState(false);
  const [editing, setEditing] = React.useState(null);
  const reload = React.useCallback(async () => {
    try {
      setList(await apiGet(`/api/procurement/suppliers/${supplier.no}/qualidades/`));
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  }, [supplier.no]);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const create = async (data) => {
    try {
      await apiSend("POST", `/api/procurement/suppliers/${supplier.no}/qualidades/`, data);
      setCreating(false);
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  const update = async (qid, data) => {
    try {
      await apiSend("PATCH", `/api/procurement/suppliers/${supplier.no}/qualidades/${qid}/`, data);
      setEditing(null);
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  const del = async (q) => {
    if (!await window.hubConfirm({ message: `Apagar qualidade "${q.codigo}"? Os canais associados s\xE3o apagados tamb\xE9m.` })) return;
    try {
      await apiSend("DELETE", `/api/procurement/suppliers/${supplier.no}/qualidades/${q.id}/`);
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  const columns = [
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 130,
      minWidth: 110,
      fixed: true,
      mono: true,
      render: (q) => /* @__PURE__ */ React.createElement("strong", null, q.codigo)
    },
    {
      key: "preco",
      label: "Pre\xE7o \u20AC/m\xB2",
      width: 150,
      minWidth: 130,
      align: "right",
      mono: true,
      render: (q) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, Number(q.preco_compra_m2).toFixed(4))
    },
    {
      key: "canais",
      label: "Canais",
      width: 270,
      minWidth: 200,
      render: (q) => /* @__PURE__ */ React.createElement(CanaisEditor, { supplier, qualidade: q })
    },
    {
      key: "ativa",
      label: "Ativa",
      width: 90,
      minWidth: 75,
      render: (q) => q.is_active ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 170,
      minWidth: 150,
      render: (q) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(q) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => del(q) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Qualidades de cart\xE3o"), /* @__PURE__ */ React.createElement("span", { className: "sub", style: { marginLeft: 8 } }, "\xB7 cada uma tem N canais + pre\xE7o \u20AC/m\xB2"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Nova qualidade")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "config-qualidades",
      columns,
      data: list,
      pagination: "none",
      rowKey: (q) => q.id,
      empty: "Sem qualidades. Adiciona pelo menos uma (ex. BC1)."
    }
  ), creating && /* @__PURE__ */ React.createElement(
    QualidadeFormModal,
    {
      title: "Nova qualidade",
      onClose: () => setCreating(false),
      onSubmit: create
    }
  ), editing && /* @__PURE__ */ React.createElement(
    QualidadeFormModal,
    {
      title: `Editar ${editing.codigo}`,
      initial: editing,
      onClose: () => setEditing(null),
      onSubmit: (d) => update(editing.id, d)
    }
  ));
}
window.QualidadesPanel = QualidadesPanel;
function TruckMaxPanel({ supplier }) {
  const [list, setList] = React.useState([]);
  const [canal, setCanal] = React.useState("");
  const [m2max, setM2Max] = React.useState("");
  const reload = React.useCallback(async () => {
    try {
      setList(await apiGet(`/api/procurement/suppliers/${supplier.no}/truck-max/`));
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  }, [supplier.no]);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const add = async (e) => {
    e?.preventDefault?.();
    if (!canal.trim() || !m2max) return;
    try {
      await apiSend(
        "POST",
        `/api/procurement/suppliers/${supplier.no}/truck-max/`,
        { canal: canal.trim(), m2_max: Number(m2max) }
      );
      setCanal("");
      setM2Max("");
      reload();
    } catch (err) {
      window.srToast?.(`Erro: ${err.message}`);
    }
  };
  const columns = [
    {
      key: "canal",
      label: "Canal",
      width: 130,
      minWidth: 110,
      fixed: true,
      mono: true,
      render: (t) => t.canal
    },
    {
      key: "m2max",
      label: "m\xB2 m\xE1x",
      width: 130,
      minWidth: 110,
      align: "right",
      mono: true,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, t.m2_max)
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Cami\xE3o \u2014 m\xB2 m\xE1x por canal"), /* @__PURE__ */ React.createElement("span", { className: "sub", style: { marginLeft: 8 } }, "\xB7 limite log\xEDstico por expedi\xE7\xE3o (usado em Fase 2)")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "config-canais",
      columns,
      data: list,
      pagination: "none",
      rowKey: (t) => t.id,
      empty: "Sem limites definidos."
    }
  ), /* @__PURE__ */ React.createElement("form", { onSubmit: add, style: { display: "flex", gap: 8, padding: 12, borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: canal,
      onChange: (e) => setCanal(e.target.value),
      placeholder: "Canal (ex. B)",
      style: { maxWidth: 140 }
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: m2max,
      onChange: (e) => setM2Max(e.target.value),
      placeholder: "m\xB2 m\xE1x",
      style: { maxWidth: 140 },
      min: 1
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn primary sm" }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Adicionar")));
}
window.TruckMaxPanel = TruckMaxPanel;
function SupplierDetailView({ supplier, onBack, onSaved }) {
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 1100 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: onBack }, "\u2190 Voltar"), /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, supplier.nome_cache || "\u2014"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)", fontFamily: "var(--font-mono)" } }, "#", supplier.no)), /* @__PURE__ */ React.createElement(GeralPanel, { supplier, onSaved }), /* @__PURE__ */ React.createElement("div", { style: { height: 16 } }), /* @__PURE__ */ React.createElement(MaquinaPanel, { supplier, onSaved }), /* @__PURE__ */ React.createElement("div", { style: { height: 16 } }), /* @__PURE__ */ React.createElement(PaperWidthsPanel, { supplier }), /* @__PURE__ */ React.createElement("div", { style: { height: 16 } }), /* @__PURE__ */ React.createElement(QualidadesPanel, { supplier }), /* @__PURE__ */ React.createElement("div", { style: { height: 16 } }), /* @__PURE__ */ React.createElement(TruckMaxPanel, { supplier }));
}
window.SupplierDetailView = SupplierDetailView;
function TiposAcaoEditor() {
  const [items, setItems] = React.useState([]);
  const [creating, setCreating] = React.useState({ codigo: "", nome: "", cor: "#155e75" });
  const reload = React.useCallback(async () => {
    try {
      setItems(await apiGet("/api/procurement/tipos-acao/"));
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  }, []);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const patch = async (id, changes) => {
    try {
      await apiSend("PATCH", `/api/procurement/tipos-acao/${id}/`, changes);
      reload();
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const remove = async (id) => {
    if (!await window.hubConfirm({ message: "Apagar este tipo?" })) return;
    try {
      const r = await apiSend("DELETE", `/api/procurement/tipos-acao/${id}/`);
      reload();
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const create = async () => {
    if (!creating.codigo.trim() || !creating.nome.trim()) return;
    try {
      await apiSend("POST", "/api/procurement/tipos-acao/", creating);
      setCreating({ codigo: "", nome: "", cor: "#155e75" });
      reload();
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const columns = [
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 150,
      minWidth: 130,
      fixed: true,
      mono: true,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, t.codigo)
    },
    {
      key: "nome",
      label: "Nome",
      width: 210,
      minWidth: 160,
      render: (t) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          defaultValue: t.nome,
          onBlur: (e) => e.target.value !== t.nome && patch(t.id, { nome: e.target.value }),
          style: { width: "100%" }
        }
      )
    },
    {
      key: "cor",
      label: "Cor",
      width: 90,
      minWidth: 75,
      render: (t) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "color",
          defaultValue: t.cor,
          onBlur: (e) => e.target.value !== t.cor && patch(t.id, { cor: e.target.value })
        }
      )
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 75,
      render: (t) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "number",
          defaultValue: t.ordem,
          onBlur: (e) => Number(e.target.value) !== t.ordem && patch(t.id, { ordem: Number(e.target.value) }),
          style: { width: 60 }
        }
      )
    },
    {
      key: "ativo",
      label: "Ativo",
      width: 80,
      minWidth: 65,
      render: (t) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: t.is_active,
          onChange: (e) => patch(t.id, { is_active: e.target.checked })
        }
      )
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 100,
      minWidth: 90,
      render: (t) => /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => remove(t.id) }, "Apagar")
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 820 } }, /* @__PURE__ */ React.createElement("h3", { style: { marginTop: 0 } }, "Tipos de ac\xE7\xE3o"), /* @__PURE__ */ React.createElement("p", { style: { color: "var(--muted)", fontSize: 12.5, marginTop: 0 } }, 'Aparecem no dropdown de "Adicionar" no timeline do drawer da Pesquisa. Se algum tipo estiver em uso por ac\xE7\xF5es existentes, o Apagar marca-o como inactivo em vez de o eliminar.'), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "config-tipos-acao",
      columns,
      data: items,
      pagination: "none",
      rowKey: (t) => t.id
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, padding: "12px 0", borderTop: "1px solid var(--border)", marginTop: 4 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "ex: acompanhamento",
      value: creating.codigo,
      onChange: (e) => setCreating({ ...creating, codigo: e.target.value }),
      style: { maxWidth: 220 }
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "Nome",
      value: creating.nome,
      onChange: (e) => setCreating({ ...creating, nome: e.target.value }),
      style: { maxWidth: 220 }
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "color",
      value: creating.cor,
      onChange: (e) => setCreating({ ...creating, cor: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      onClick: create,
      disabled: !creating.codigo.trim() || !creating.nome.trim()
    },
    /* @__PURE__ */ React.createElement(Ico.plus, null),
    " Adicionar"
  )));
}
window.TiposAcaoEditor = TiposAcaoEditor;
function EstadosTratamentoEditor() {
  const [items, setItems] = React.useState([]);
  const reload = React.useCallback(async () => {
    try {
      setItems(await apiGet("/api/procurement/estados-tratamento/"));
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  }, []);
  React.useEffect(() => {
    reload();
  }, [reload]);
  const patch = async (id, changes) => {
    try {
      await apiSend("PATCH", `/api/procurement/estados-tratamento/${id}/`, changes);
      reload();
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const columns = [
    {
      key: "codigo",
      label: "C\xF3digo",
      width: 150,
      minWidth: 130,
      fixed: true,
      mono: true,
      render: (e) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, e.codigo)
    },
    {
      key: "nome",
      label: "Nome",
      width: 280,
      minWidth: 200,
      render: (e) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          defaultValue: e.nome,
          onBlur: (ev) => ev.target.value !== e.nome && patch(e.id, { nome: ev.target.value }),
          style: { width: "100%" }
        }
      )
    },
    {
      key: "cor",
      label: "Cor",
      width: 90,
      minWidth: 75,
      render: (e) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "color",
          defaultValue: e.cor,
          onBlur: (ev) => ev.target.value !== e.cor && patch(e.id, { cor: ev.target.value })
        }
      )
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 75,
      render: (e) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "number",
          defaultValue: e.ordem,
          onBlur: (ev) => Number(ev.target.value) !== e.ordem && patch(e.id, { ordem: Number(ev.target.value) }),
          style: { width: 60 }
        }
      )
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement("h3", { style: { marginTop: 0 } }, "Estados de tratamento"), /* @__PURE__ */ React.createElement("p", { style: { color: "var(--muted)", fontSize: 12.5, marginTop: 0 } }, "Os 5 c\xF3digos (nova / atribuida / em_curso / fechada / cancelada) s\xE3o fixos porque est\xE3o codificados no fluxo da Opportunity. Podes editar apenas o nome exibido, a cor e a ordem."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "procurement",
      viewId: "config-estados",
      columns,
      data: items,
      pagination: "none",
      rowKey: (e) => e.id
    }
  ));
}
window.EstadosTratamentoEditor = EstadosTratamentoEditor;
function ProcurementConfiguracoesView() {
  const [tab, setTab] = React.useState("fornecedores");
  const [suppliers, setSuppliers] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [selectedNo, setSelectedNo] = React.useState(null);
  const [detail, setDetail] = React.useState(null);
  const [creating, setCreating] = React.useState(false);
  const reloadList = React.useCallback(async () => {
    try {
      setError(null);
      setSuppliers(await apiGet("/api/procurement/suppliers/"));
    } catch (e) {
      setError(e.message);
    }
  }, []);
  React.useEffect(() => {
    reloadList();
  }, [reloadList]);
  React.useEffect(() => {
    if (!selectedNo) {
      setDetail(null);
      return;
    }
    apiGet(`/api/procurement/suppliers/${selectedNo}/`).then(setDetail).catch((e) => setError(e.message));
  }, [selectedNo]);
  const criar = async (no) => {
    try {
      const created = await apiSend("POST", "/api/procurement/suppliers/", { no });
      window.srToast?.("Fornecedor criado.");
      setCreating(false);
      await reloadList();
      setSelectedNo(created.no);
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const apagar = async (s) => {
    if (!await window.hubConfirm({ message: `Apagar fornecedor "${s.nome_cache || s.no}"?
Toda a config associada (larguras, qualidades, canais, cami\xE3o) \xE9 apagada.` })) return;
    try {
      await apiSend("DELETE", `/api/procurement/suppliers/${s.no}/`);
      window.srToast?.("Apagado.");
      reloadList();
    } catch (e) {
      window.srToast?.(`Erro: ${e.message}`);
    }
  };
  const onSaved = (s) => setDetail(s);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !selectedNo && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, padding: "12px 20px 0", borderBottom: "1px solid var(--border)", marginBottom: -1 } }, [
    { id: "fornecedores", label: "Fornecedores" },
    { id: "tipos", label: "Tipos de ac\xE7\xE3o" },
    { id: "estados", label: "Estados de tratamento" }
  ].map((t) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: t.id,
      className: "btn ghost sm" + (tab === t.id ? " active" : ""),
      onClick: () => setTab(t.id),
      style: {
        borderRadius: "4px 4px 0 0",
        borderBottom: tab === t.id ? "2px solid var(--accent)" : "2px solid transparent",
        fontWeight: tab === t.id ? 600 : 400
      }
    },
    t.label
  ))), /* @__PURE__ */ React.createElement("div", { style: { padding: !selectedNo && tab !== "fornecedores" ? "20px" : 0 } }, selectedNo && detail ? /* @__PURE__ */ React.createElement(
    SupplierDetailView,
    {
      supplier: detail,
      onBack: () => {
        setSelectedNo(null);
        reloadList();
      },
      onSaved
    }
  ) : tab === "tipos" ? /* @__PURE__ */ React.createElement(TiposAcaoEditor, null) : tab === "estados" ? /* @__PURE__ */ React.createElement(EstadosTratamentoEditor, null) : /* @__PURE__ */ React.createElement(
    SupplierListView,
    {
      suppliers,
      error,
      onNovo: () => setCreating(true),
      onEditar: (no) => setSelectedNo(no),
      onApagar: apagar
    }
  )), creating && /* @__PURE__ */ React.createElement(
    NovoFornecedorModal,
    {
      onClose: () => setCreating(false),
      onSubmit: criar
    }
  ));
}
window.ProcurementConfiguracoesView = ProcurementConfiguracoesView;

// ===== procurement/frontend/entry.jsx =====
window.ProcurementView = window.ProcurementView || (() => null);
window.ProcurementDashboardView = window.ProcurementDashboardView || (() => null);
window.ProcurementConfiguracoesView = window.ProcurementConfiguracoesView || (() => null);

// ===== procurement/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "procurement",
  order: 8,
  name: "NEXUM",
  sub: "Auto-enquadramento de placa",
  accent: "#155e75",
  brandLogo: "/static/assets/nexum-logo.png?v=2",
  home: "procurement",
  launcher: true,
  frontendFiles: [
    "frontend/procurement.jsx",
    "frontend/procurement_dashboard.jsx",
    "frontend/procurement_configuracoes.jsx",
    "frontend/entry.jsx"
  ],
  routes: [
    { id: "procurement", section: "Pesquisa Ondupack", icon: "dot", label: "Pesquisa Ondupack", adminOnly: false, title: "Pesquisa Ondupack", tooltip: "Pesquisa Ondupack" },
    { id: "procurement_dashboard", section: "Dashboard", icon: "dashboard", label: "Dashboard", adminOnly: false, title: "Dashboard", tooltip: "Dashboard" },
    { id: "procurement_configuracoes", section: "Configura\xE7\xF5es", icon: "cog", label: "Configura\xE7\xF5es", adminOnly: false, title: "Configura\xE7\xF5es", tooltip: "Configura\xE7\xF5es" },
    { id: "procurement_atribuiveis", section: "Configura\xE7\xF5es", icon: "cog", label: "Utilizadores atribu\xEDveis", adminOnly: true, title: "Utilizadores atribu\xEDveis", tooltip: "Utilizadores atribu\xEDveis" }
  ],
  render: {
    procurement: (ctx) => React.createElement(window.ProcurementView, {
      entidade: ctx && ctx.entidade,
      params: ctx && ctx.params,
      navigate: ctx && ctx.navigate,
      routeId: ctx && ctx.view,
      reportCrumb: ctx && ctx.reportCrumb
    }),
    procurement_dashboard: () => React.createElement(window.ProcurementDashboardView),
    procurement_configuracoes: () => React.createElement(window.ProcurementConfiguracoesView),
    procurement_atribuiveis: () => React.createElement(window.HubAssignableUsers, { appLabel: "procurement", appName: "Nexum" })
  }
});

// ===== prospecao/frontend/scout-api.jsx =====
async function scoutReq(path, { method = "GET", body, params } = {}) {
  const url = new URL(path, window.location.origin);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (Array.isArray(v)) v.forEach((x) => url.searchParams.append(k, x));
      else if (v != null && v !== "") url.searchParams.set(k, v);
    });
  }
  const headers = { "Content-Type": "application/json" };
  const csrf = document.cookie.match(/(?:^|; )csrftoken=([^;]*)/);
  if (csrf && method !== "GET") headers["X-CSRFToken"] = decodeURIComponent(csrf[1]);
  const res = await fetch(url, {
    method,
    headers,
    credentials: "include",
    body: body ? JSON.stringify(body) : void 0
  });
  if (!res.ok) throw new Error(`${method} ${path} \u2192 ${res.status}: ${await res.text()}`);
  if (res.status === 204) return null;
  return res.json();
}
const B = "/api/prospecao";
const O = "/api/outlook";
window.ScoutAPI = {
  req: scoutReq,
  // Contas
  contas: (params) => scoutReq(`${B}/contas/`, { params }),
  conta: (id) => scoutReq(`${B}/contas/${id}/`),
  createConta: (data) => scoutReq(`${B}/contas/`, { method: "POST", body: data }),
  updateConta: (id, patch) => scoutReq(`${B}/contas/${id}/`, { method: "PATCH", body: patch }),
  deleteConta: (id) => scoutReq(`${B}/contas/${id}/`, { method: "DELETE" }),
  contaLookup: (nifs) => scoutReq(`${B}/contas/lookup/`, { params: { nif: nifs } }),
  // Contas live do PHC (2c) — zona (distrito do overlay local) e
  // ultima_compra_de/ate (agregado ft do PHC) filtram server-side (2c/SP3 T4).
  contasLive: (search, inativos, page, pageSize, filtros = {}) => scoutReq(`${B}/contas/live/`, { params: {
    search,
    ...inativos ? { inativos: "1" } : {},
    page,
    page_size: pageSize,
    donos: filtros.donos || [],
    localidades: filtros.localidades || [],
    zona: filtros.zona || "",
    ultima_compra_de: filtros.ultima_compra_de || "",
    ultima_compra_ate: filtros.ultima_compra_ate || ""
  } }),
  contaEnsure: (nif, nome, local) => scoutReq(`${B}/contas/ensure/`, { method: "POST", body: { nif, nome, local } }),
  contasFiltros: () => scoutReq(`${B}/contas/filtros/`),
  contasLocalidades: (q) => scoutReq(`${B}/contas/localidades/`, { params: { q } }),
  // Faturação em lote (Whales-style) para a lista de Contas — SP3 T5, ≤20 NIFs.
  contasFaturacaoBatch: (nifs) => scoutReq(`${B}/contas/faturacao-batch/`, { params: { nif: nifs } }),
  // Contactos
  contactos: (params) => scoutReq(`${B}/contactos/`, { params }),
  createContacto: (data) => scoutReq(`${B}/contactos/`, { method: "POST", body: data }),
  updateContacto: (id, patch) => scoutReq(`${B}/contactos/${id}/`, { method: "PATCH", body: patch }),
  deleteContacto: (id) => scoutReq(`${B}/contactos/${id}/`, { method: "DELETE" }),
  // Negócios
  negocios: (params) => scoutReq(`${B}/negocios/`, { params }),
  negociosBoard: (params) => scoutReq(`${B}/negocios/board/`, { params }),
  createNegocio: (data) => scoutReq(`${B}/negocios/`, { method: "POST", body: data }),
  updateNegocio: (id, patch) => scoutReq(`${B}/negocios/${id}/`, { method: "PATCH", body: patch }),
  deleteNegocio: (id) => scoutReq(`${B}/negocios/${id}/`, { method: "DELETE" }),
  // Fases do pipeline de negócios
  negocioEstados: () => scoutReq(`${B}/negocio-estados/`),
  createNegocioEstado: (data) => scoutReq(`${B}/negocio-estados/`, { method: "POST", body: data }),
  updateNegocioEstado: (slug, patch) => scoutReq(`${B}/negocio-estados/${slug}/`, { method: "PATCH", body: patch }),
  deleteNegocioEstado: (slug) => scoutReq(`${B}/negocio-estados/${slug}/`, { method: "DELETE" }),
  // Conversão
  converterLead: (id) => scoutReq(`${B}/leads/${id}/converter/`, { method: "POST", body: {} }),
  // Saúde financeira (PHC)
  contasSaude: (nifs) => scoutReq(`${B}/contas/saude/`, { params: { nif: nifs } }),
  contaSaude: (id, refresh) => scoutReq(`${B}/contas/${id}/saude/`, { params: refresh ? { refresh: "1" } : {} }),
  phcSaudeCampos: () => scoutReq(`${B}/phc-saude-campos/`),
  createPhcSaudeCampo: (data) => scoutReq(`${B}/phc-saude-campos/`, { method: "POST", body: data }),
  updatePhcSaudeCampo: (conceito, patch) => scoutReq(`${B}/phc-saude-campos/${conceito}/`, { method: "PATCH", body: patch }),
  deletePhcSaudeCampo: (conceito) => scoutReq(`${B}/phc-saude-campos/${conceito}/`, { method: "DELETE" }),
  phcSaudeTestar: (nif) => scoutReq(`${B}/phc-saude-campos/testar/`, { params: { nif } }),
  saudeConfigGet: () => scoutReq(`${B}/saude-config/`),
  saudeConfigPut: (data) => scoutReq(`${B}/saude-config/`, { method: "PUT", body: data }),
  // Documentos PHC (2b)
  contaDocumentos: (id, vista, refresh) => scoutReq(`${B}/contas/${id}/documentos/`, { params: { vista, ...refresh ? { refresh: "1" } : {} } }),
  contaDocumentosDrill: (id, pai, chave) => scoutReq(`${B}/contas/${id}/documentos/drill/`, { params: { pai, chave } }),
  phcVistas: () => scoutReq(`${B}/phc-vistas/`),
  createPhcVista: (data) => scoutReq(`${B}/phc-vistas/`, { method: "POST", body: data }),
  updatePhcVista: (slug, patch) => scoutReq(`${B}/phc-vistas/${slug}/`, { method: "PATCH", body: patch }),
  deletePhcVista: (slug) => scoutReq(`${B}/phc-vistas/${slug}/`, { method: "DELETE" }),
  phcVistaTestar: (nif, vista) => scoutReq(`${B}/phc-vistas/testar/`, { params: { nif, vista } }),
  // Vendedor PHC ↔ utilizador do hub (2d)
  phcVendedores: () => scoutReq(`${B}/phc-vendedores/`),
  updatePhcVendedor: (vendedor, patch) => scoutReq(`${B}/phc-vendedores/${vendedor}/`, { method: "PATCH", body: patch }),
  // Faturação (Whales account detail, reutilizado no separador da Conta)
  contaFaturacao: (id, params) => scoutReq(`${B}/contas/${id}/faturacao/`, { params }),
  // Relatório estrutural DBInforma (PLESTRUT), reutilizado no separador da Conta
  contaEstrutura: (id) => scoutReq(`${B}/contas/${id}/estrutura/`),
  contaEstruturaCarregar: (id) => scoutReq(`${B}/contas/${id}/estrutura/carregar/`, { method: "POST" }),
  // Notas + Atividades da Conta (SP2-B)
  contaNotas: (id) => scoutReq(`${B}/contas/${id}/notas/`),
  createContaNota: (id, descricao) => scoutReq(`${B}/contas/${id}/notas/`, { method: "POST", body: { descricao } }),
  deleteContaNota: (id, nid) => scoutReq(`${B}/contas/${id}/notas/${nid}/`, { method: "DELETE" }),
  // Ações/tarefas da Conta (timeline) — espelho das de Lead do window.API
  contaAcoes: (id) => scoutReq(`${B}/contas/${id}/acoes/`),
  addContaAcao: (id, tipo_id_slug, descricao, atribuido_id = null, data_limite = null) => scoutReq(`${B}/contas/${id}/acoes/`, {
    method: "POST",
    body: { tipo_id_slug, descricao, atribuido_id, data_limite }
  }),
  deleteContaAcao: (id, aid) => scoutReq(`${B}/contas/${id}/acoes/${aid}/`, { method: "DELETE" }),
  tratarContaAcao: (id, aid) => scoutReq(`${B}/contas/${id}/acoes/${aid}/tratar/`, { method: "POST" }),
  prazoContaAcao: (id, aid, data_limite) => scoutReq(`${B}/contas/${id}/acoes/${aid}/prazo/`, { method: "POST", body: { data_limite } }),
  contaAtividades: (id) => scoutReq(`${B}/contas/${id}/atividades/`),
  createContaAtividade: (id, data) => scoutReq(`${B}/contas/${id}/atividades/`, { method: "POST", body: data }),
  realizarAtividade: (id, aid, data) => scoutReq(`${B}/contas/${id}/atividades/${aid}/realizar/`, { method: "POST", body: data ? { data } : {} }),
  contaTiposAtividade: () => scoutReq(`${B}/contas/tipos-atividade/`),
  // Admin dos tipos de ação da Conta — API core config-gated (app-acao-tipos)
  contaAcaoTipos: () => scoutReq("/api/app-acao-tipos/", { params: { app_label: "prospecao", contexto: "conta" } }),
  createContaAcaoTipo: (data) => scoutReq("/api/app-acao-tipos/", { method: "POST", body: { ...data, app_label: "prospecao", contexto: "conta" } }),
  updateContaAcaoTipo: (id, patch) => scoutReq(`/api/app-acao-tipos/${id}/`, { method: "PATCH", body: patch }),
  deleteContaAcaoTipo: (id) => scoutReq(`/api/app-acao-tipos/${id}/`, { method: "DELETE" }),
  // Calendário (SP4) — calendarioEventos morreu com o calendário do SCOUT
  // (SP-C, programa "Atividades do hub"); o hub tem o seu próprio
  // GET /api/calendario/ (window.API.meuCalendario).
  createContaEvento: (contaId, data) => scoutReq(`${B}/contas/${contaId}/atividades/`, { method: "POST", body: data }),
  updateContaEvento: (contaId, aid, patch) => scoutReq(`${B}/contas/${contaId}/atividades/${aid}/`, { method: "PATCH", body: patch }),
  cancelarContaEvento: (contaId, aid) => scoutReq(`${B}/contas/${contaId}/atividades/${aid}/cancelar/`, { method: "POST" }),
  // Outlook — minhaOutlookLigacao/ligarOutlook/desligarOutlook mudaram
  // para window.API.* (SP-C: o painel de opt-in pessoal vive agora no
  // calendário do hub, packages/hub_shell/features/atividades/frontend.jsx).
  // O ecrã de administração (config, lista de ligações, âmbito) continua nas
  // Definições do SCOUT, mas os endpoints saíram do prefixo do SCOUT com o
  // motor (SP-C, Task 4) — daí `O`, e não `B`.
  outlookConfig: () => scoutReq(`${O}/config/`),
  saveOutlookConfig: (d) => scoutReq(`${O}/config/`, { method: "PUT", body: d }),
  outlookLigacoes: () => scoutReq(`${O}/ligacoes/`),
  testarAmbitoOutlook: () => scoutReq(`${O}/ambito/`, { method: "POST" }),
  // Ligar/desligar a caixa de outro utilizador (administração)
  ligarCaixaOutlook: (username) => scoutReq(`${O}/ligacoes/`, { method: "POST", body: { username } }),
  desligarCaixaOutlook: (username) => scoutReq(
    `${O}/ligacoes/?username=${encodeURIComponent(username)}`,
    { method: "DELETE" }
  )
};

// ===== prospecao/frontend/dbinforma-panel.jsx =====
const INDICATOR_BG = {
  green: { background: "#e8f6ec", color: "#1f7a3a" },
  amber: { background: "#fff4e0", color: "#9a6d12" },
  red: { background: "#fce8e8", color: "#a82a2a" },
  neutral: { background: "transparent", color: "inherit" }
};
function ScoutDBInformaIndicadores({ report, indicators, onOpenFull }) {
  const indicSec = (report?.sections || []).find(
    (s) => (s.title || "").toLowerCase().includes("indicadores")
  );
  if (!indicSec) return null;
  return /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--border)", paddingTop: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", marginBottom: 6 } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 12.5 } }, "Indicadores financeiros"), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      style: { marginLeft: "auto" },
      onClick: onOpenFull,
      title: "Abrir o relat\xF3rio completo formatado"
    },
    "Abrir relat\xF3rio completo"
  )), /* @__PURE__ */ React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: 12.5 } }, /* @__PURE__ */ React.createElement("tbody", null, indicSec.rows.map(([label, val]) => {
    const ind = Object.values(indicators || {}).find(
      (i) => i.label.toLowerCase() === label.toLowerCase()
    );
    const bg = ind ? INDICATOR_BG[ind.color] || INDICATOR_BG.neutral : INDICATOR_BG.neutral;
    return /* @__PURE__ */ React.createElement("tr", { key: label }, /* @__PURE__ */ React.createElement("td", { style: {
      padding: "2px 8px 2px 0",
      color: "var(--muted)",
      whiteSpace: "nowrap",
      verticalAlign: "top"
    } }, label), /* @__PURE__ */ React.createElement("td", { style: { padding: "2px 0", textAlign: "right" } }, /* @__PURE__ */ React.createElement(
      "span",
      {
        title: ind?.tooltip || "",
        style: {
          display: "inline-block",
          padding: "1px 8px",
          borderRadius: 6,
          fontWeight: 500,
          ...bg
        }
      },
      val
    )));
  }))));
}
function LeadDBInformaModal({ report, indicators, fetchedAt, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  const [tab, setTab] = useState("overview");
  const sections = report.sections || [];
  const balancos = report.balancos || [];
  const notificacoes = report.notificacoes || [];
  const acionistas = report.acionistas || [];
  const pessoas = report.pessoas || {};
  const fields = report.fields || {};
  const eurBalanco = (v) => v == null ? "\u2014" : `${(v / 1e3).toLocaleString("pt-PT")} K\u20AC`;
  const pctBalanco = (v) => v == null ? "\u2014" : `${v.toFixed(2)} %`;
  const balancoColumns = [
    { key: "ano", label: "Ano", align: "right", mono: true, width: 70, minWidth: 60 },
    {
      key: "vendas",
      label: "Vendas",
      align: "right",
      mono: true,
      width: 120,
      minWidth: 100,
      render: (b) => eurBalanco(b.vendas)
    },
    {
      key: "compras",
      label: "Compras",
      align: "right",
      mono: true,
      width: 120,
      minWidth: 100,
      render: (b) => eurBalanco(b.compras)
    },
    {
      key: "ativo",
      label: "Ativo",
      align: "right",
      mono: true,
      width: 120,
      minWidth: 100,
      render: (b) => eurBalanco(b.ativo)
    },
    {
      key: "capital_proprio",
      label: "Cap. pr\xF3prio",
      align: "right",
      mono: true,
      width: 130,
      minWidth: 110,
      render: (b) => eurBalanco(b.capital_proprio)
    },
    {
      key: "resultado_liq",
      label: "Resultado",
      align: "right",
      mono: true,
      width: 120,
      minWidth: 100,
      render: (b) => eurBalanco(b.resultado_liq)
    },
    {
      key: "empregados",
      label: "Empregados",
      align: "right",
      mono: true,
      width: 110,
      minWidth: 90,
      render: (b) => b.empregados ?? "\u2014"
    },
    {
      key: "autonomia_pct",
      label: "Autonomia",
      align: "right",
      mono: true,
      width: 100,
      minWidth: 90,
      render: (b) => pctBalanco(b.autonomia_pct)
    },
    {
      key: "solvabilidade_pct",
      label: "Solvabilidade",
      align: "right",
      mono: true,
      width: 120,
      minWidth: 100,
      render: (b) => pctBalanco(b.solvabilidade_pct)
    }
  ];
  const acionistaColumns = [
    {
      key: "nome",
      label: "Nome",
      width: 240,
      minWidth: 160,
      render: (a) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 500 }, title: a.nome }, a.nome)
    },
    {
      key: "tipo",
      label: "Tipo",
      width: 100,
      minWidth: 90,
      render: (a) => /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, a.tipo === "empresa" ? "Empresa" : "Pessoa")
    },
    {
      key: "valor",
      label: "Valor",
      align: "right",
      mono: true,
      width: 120,
      minWidth: 100,
      render: (a) => a.valor != null ? `${a.valor.toLocaleString("pt-PT")} \u20AC` : "\u2014"
    },
    {
      key: "pct",
      label: "%",
      align: "right",
      mono: true,
      width: 90,
      minWidth: 70,
      render: (a) => a.pct != null ? `${a.pct.toFixed(2)} %` : "\u2014"
    }
  ];
  const notificacaoColumns = [
    { key: "data", label: "Data", width: 112, minWidth: 96, mono: true },
    {
      key: "modulo",
      label: "M\xF3dulo",
      width: 130,
      minWidth: 100,
      render: (n) => /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, n.modulo || "\u2014")
    },
    {
      key: "texto",
      label: "Texto",
      width: 620,
      minWidth: 240,
      render: (n) => /* @__PURE__ */ React.createElement("span", { title: n.texto || "" }, n.texto || "\u2014")
    }
  ];
  const statusKind = fields.status_kind;
  const statusPalette = statusKind === "good" ? { bg: "#e8f6ec", fg: "#1f7a3a", border: "#bce0c6" } : statusKind === "bad" ? { bg: "#fce8e8", fg: "#a82a2a", border: "#f0bcbc" } : { bg: "#f3f3f5", fg: "var(--text-2)", border: "var(--border)" };
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1e3
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--bg)",
    maxWidth: 1180,
    width: "95%",
    height: "92vh",
    borderRadius: 8,
    padding: 20,
    boxShadow: "0 12px 48px rgba(0,0,0,0.35)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  }, onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 14,
    flex: "0 0 auto"
  } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 17 } }, "Relat\xF3rio Estrutural (PLESTRUT)"), fields.status_label && /* @__PURE__ */ React.createElement("span", { style: {
    padding: "3px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    background: statusPalette.bg,
    color: statusPalette.fg,
    border: `1px solid ${statusPalette.border}`
  } }, fields.status_label), /* @__PURE__ */ React.createElement("span", { style: {
    marginLeft: "auto",
    fontSize: 11.5,
    color: "var(--muted)",
    display: "flex",
    gap: 14,
    flexWrap: "wrap",
    justifyContent: "flex-end"
  } }, fields.ultimo_balanco && /* @__PURE__ */ React.createElement("span", null, "\xDAltimo balan\xE7o: ", /* @__PURE__ */ React.createElement("strong", null, fields.ultimo_balanco)), fields.rating_calculo && /* @__PURE__ */ React.createElement("span", { title: "Quando a Informa recalculou o Rating (Capacidade Financeira, Indicador de Risco, etc.)." }, "Rating recalculado: ", /* @__PURE__ */ React.createElement("strong", null, fields.rating_calculo)), fetchedAt && /* @__PURE__ */ React.createElement("span", { title: "Quando o XML foi puxado da API (cache local)." }, "Atualizado: ", /* @__PURE__ */ React.createElement("strong", null, new Date(fetchedAt).toLocaleString("pt-PT")))), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      "data-shortcut": "c",
      onClick: onClose,
      "aria-label": "Fechar",
      title: "Fechar (Alt+C, Esc)"
    },
    "\u2715",
    /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
  )), /* @__PURE__ */ React.createElement("div", { role: "tablist", style: {
    display: "inline-flex",
    gap: 4,
    marginBottom: 14,
    borderBottom: "1px solid var(--border)",
    flex: "0 0 auto"
  } }, [
    ["overview", "Vis\xE3o geral"],
    ["acionistas", `Acionistas (${acionistas.length})`],
    ["notificacoes", `Notifica\xE7\xF5es (${notificacoes.length})`]
  ].map(([id, label]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: id,
      type: "button",
      role: "tab",
      "aria-selected": tab === id,
      onClick: () => setTab(id),
      style: {
        padding: "6px 14px",
        fontSize: 12.5,
        border: "none",
        cursor: "pointer",
        background: tab === id ? "var(--bg)" : "transparent",
        color: tab === id ? "var(--text)" : "var(--muted)",
        borderBottom: tab === id ? "2px solid var(--accent)" : "2px solid transparent",
        fontWeight: tab === id ? 600 : 400
      }
    },
    label
  ))), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflowY: "auto", minHeight: 0 } }, tab === "overview" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr)",
    gap: 16
  } }, sections.map((sec) => /* @__PURE__ */ React.createElement("div", { key: sec.title, style: { minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    fontWeight: 600,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    marginBottom: 6
  } }, sec.title), /* @__PURE__ */ React.createElement("table", { style: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 12.5,
    tableLayout: "fixed"
  } }, /* @__PURE__ */ React.createElement("tbody", null, sec.rows.map(([label, val]) => {
    const ind = Object.values(indicators || {}).find(
      (i) => i.label.toLowerCase() === label.toLowerCase()
    );
    const bg = ind ? INDICATOR_BG[ind.color] || INDICATOR_BG.neutral : INDICATOR_BG.neutral;
    return /* @__PURE__ */ React.createElement("tr", { key: label }, /* @__PURE__ */ React.createElement("td", { style: {
      padding: "3px 8px 3px 0",
      color: "var(--muted)",
      verticalAlign: "top",
      wordBreak: "break-word"
    } }, label), /* @__PURE__ */ React.createElement("td", { style: {
      padding: "3px 0",
      textAlign: "right",
      wordBreak: "break-word"
    } }, /* @__PURE__ */ React.createElement("span", { title: ind?.tooltip || "", style: {
      display: "inline-block",
      padding: "2px 8px",
      borderRadius: 6,
      fontWeight: 500,
      ...bg
    } }, val)));
  })))))), balancos.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    fontWeight: 600,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    marginBottom: 6
  } }, "Balan\xE7os"), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "dbinforma-balancos",
      columns: balancoColumns,
      data: balancos,
      pagination: "client",
      rowKey: (b) => b.ano,
      empty: "Sem balan\xE7os."
    }
  ))), tab === "acionistas" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "dbinforma-acionistas",
      columns: acionistaColumns,
      data: acionistas.map((a, i) => ({ ...a, _idx: i })),
      pagination: "client",
      rowKey: (a) => a._idx,
      empty: "Sem acionistas no relat\xF3rio."
    }
  )), tab === "notificacoes" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11.5,
    color: "var(--muted)",
    fontStyle: "italic",
    marginBottom: 10
  } }, "Hist\xF3rico de eventos da Informa \u2014 marcos no tempo. Para o estado actual ver os Indicadores."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "dbinforma-notificacoes",
      columns: notificacaoColumns,
      data: notificacoes.map((n, i) => ({ ...n, _idx: i })),
      pagination: "client",
      rowKey: (n) => n._idx,
      empty: "Sem notifica\xE7\xF5es no relat\xF3rio."
    }
  )))));
}
window.ScoutDBInformaIndicadores = ScoutDBInformaIndicadores;
window.LeadDBInformaModal = LeadDBInformaModal;

// ===== prospecao/frontend/view.jsx =====
const SECTORS = [
  { id: "e_commerce", label: "E-commerce" },
  { id: "construction", label: "Construction Materials" },
  { id: "cosmetics", label: "Cosmetic & Perfums" },
  { id: "health_sport", label: "Health & Sport Equipments" },
  { id: "hardware_it", label: "Hardware for IT" },
  { id: "home_equip", label: "Home Equipments and Furniture" },
  { id: "light_mfg", label: "Light Equipments Manufacturers" },
  { id: "transports", label: "Transports (non-automotive)" }
];
const STATUS_LABELS = {
  active: "Active",
  closed: "Closed",
  insolvency: "Insolvency",
  liquidation: "Liquidation",
  unverified: "Unverified"
};
const CONFIDENCE_LABELS = { alta: "Alta", media: "M\xE9dia", baixa: "Baixa" };
function isValidLegalEntityNif(s) {
  if (!/^\d{9}$/.test(s || "")) return false;
  if (!"5689".includes(s[0])) return false;
  const w = [9, 8, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 8; i++) sum += parseInt(s[i], 10) * w[i];
  const r = sum % 11;
  const check = r < 2 ? 0 : 11 - r;
  return check === parseInt(s[8], 10);
}
function tierColor(t) {
  return t === "A" ? "#3a8a4d" : t === "B" ? "#d4a574" : "#9aa3ad";
}
function fmtEurCompact(n) {
  if (n == null) return "\u2014";
  if (Math.abs(n) >= 1e6)
    return `${(n / 1e6).toLocaleString("pt-PT", { maximumFractionDigits: 2 })} M\u20AC`;
  if (Math.abs(n) >= 1e3)
    return `${(n / 1e3).toLocaleString("pt-PT", { maximumFractionDigits: 0 })} K\u20AC`;
  return `${Number(n).toLocaleString("pt-PT")} \u20AC`;
}
const PERFIL_BG = {
  transformacao: { background: "#e8f6ec", color: "#1f7a3a" },
  revenda: { background: "#e6efff", color: "#22518c" },
  servicos: { background: "#f3f3f5", color: "var(--text-2)" },
  indefinido: { background: "transparent", color: "var(--muted)" }
};
function getUserByUsername(username) {
  if (!username) return null;
  const list = window.SR_USERS || [];
  return list.find((u) => u.username === username) || null;
}
function getUserDisplayName(user, fallback) {
  if (!user) return fallback || "";
  const full = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  return full || user.username || fallback || "";
}
function getUserInitials(user, fallback) {
  const name = user ? [user.first_name, user.last_name].filter(Boolean).join(" ") : fallback || "";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return "\u2014";
}
function getUserColor(username) {
  if (!username) return "#9aa3ad";
  let h = 0;
  for (let i = 0; i < username.length; i++) h = h * 31 + username.charCodeAt(i) >>> 0;
  return `hsl(${h % 360}, 45%, 45%)`;
}
function UserChip({ username, size = 18, showName = true }) {
  const user = getUserByUsername(username);
  const initials = getUserInitials(user, username);
  const color = getUserColor(username);
  const name = getUserDisplayName(user, username);
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      title: username ? `${name} (${username})` : "sem owner",
      style: { display: "inline-flex", alignItems: "center", gap: 5, minWidth: 0 }
    },
    /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true", style: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: size,
      height: size,
      borderRadius: "50%",
      background: username ? color : "var(--muted)",
      color: "#fff",
      fontSize: Math.max(8, Math.round(size * 0.5)),
      fontWeight: 700,
      lineHeight: 1,
      flex: "0 0 auto"
    } }, initials),
    showName && /* @__PURE__ */ React.createElement("span", { style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      minWidth: 0
    } }, username ? name : "sem owner")
  );
}
async function apiReq(path, { method = "GET", body, params } = {}) {
  const url = new URL(path, window.location.origin);
  if (params) Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") url.searchParams.set(k, v);
  });
  const headers = { "Content-Type": "application/json" };
  const csrfMatch = document.cookie.match(/(?:^|; )csrftoken=([^;]*)/);
  if (csrfMatch && method !== "GET") {
    headers["X-CSRFToken"] = decodeURIComponent(csrfMatch[1]);
  }
  const res = await fetch(url, {
    method,
    headers,
    credentials: "include",
    body: body ? JSON.stringify(body) : void 0
  });
  if (!res.ok) {
    throw new Error(`${method} ${path} \u2192 ${res.status}: ${await res.text()}`);
  }
  if (res.status === 204) return null;
  return res.json();
}
const LEAD_ESTADOS_API = {
  list: () => apiReq("/api/prospecao/lead-estados/"),
  create: (data) => apiReq("/api/prospecao/lead-estados/", { method: "POST", body: data }),
  update: (slug, patch) => apiReq(`/api/prospecao/lead-estados/${slug}/`, { method: "PATCH", body: patch }),
  remove: (slug) => apiReq(`/api/prospecao/lead-estados/${slug}/`, { method: "DELETE" })
};
const LEADS_STATS_API = {
  get: () => apiReq("/api/prospecao/leads-stats/")
};
const LEAD_CELLS = {
  name: (l) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, l.name), l.won_at && /* @__PURE__ */ React.createElement("span", { style: {
    marginLeft: 6,
    padding: "1px 7px",
    borderRadius: 999,
    fontSize: 10,
    fontWeight: 700,
    background: "#1f7a3a",
    color: "#fff"
  } }, "\u2605 Ganho"), l.archived_at && /* @__PURE__ */ React.createElement("span", { style: {
    marginLeft: 6,
    padding: "1px 7px",
    borderRadius: 999,
    fontSize: 10,
    fontWeight: 700,
    background: "var(--muted)",
    color: "#fff"
  } }, "Arquivado")),
  nif: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, l.nif || "\u2014"),
  sector: (l) => {
    const slug = l.sector || l.dbinforma?.sector || "";
    return SECTORS.find((s) => s.id === slug)?.label || "\u2014";
  },
  loc: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-tight" }, [l.district, l.county].filter(Boolean).join(" \xB7 ") || "\u2014"),
  volume: (l) => {
    const v = l.turnover ?? l.dbinforma?.vendas;
    return /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, v ? `${(v / 1e6).toFixed(1)} M\u20AC` : "\u2014");
  },
  vab: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, fmtEurCompact(l.dbinforma?.vab)),
  vpf: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, fmtEurCompact(l.dbinforma?.vendas_por_func)),
  perfil: (l) => l.dbinforma?.perfil_label ? /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    padding: "1px 8px",
    borderRadius: 6,
    fontSize: 11,
    fontWeight: 500,
    ...PERFIL_BG[l.dbinforma.perfil] || PERFIL_BG.indefinido
  } }, l.dbinforma.perfil_label) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014"),
  tier: (l) => l.tier ? /* @__PURE__ */ React.createElement("span", { className: "pill", style: {
    background: tierColor(l.tier),
    color: "#fff",
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 11
  } }, l.tier) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014"),
  etapa: (l) => l.lead_estado ? /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    color: "#fff",
    background: l.lead_estado.color || "#9aa3ad"
  } }, l.lead_estado.label) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014"),
  // DBInforma-derived state takes priority over the manually-set Lead.status;
  // fall back to STATUS_LABELS when no cache exists.
  estado: (l) => {
    const dbi = l.dbinforma || null;
    const stateLabel = dbi?.status_label || STATUS_LABELS[l.status] || "\u2014";
    const statePalette = dbi?.status_kind === "good" ? { bg: "#e8f6ec", fg: "#1f7a3a", border: "#bce0c6" } : dbi?.status_kind === "bad" ? { bg: "#fce8e8", fg: "#a82a2a", border: "#f0bcbc" } : { bg: "transparent", fg: "var(--muted)", border: "transparent" };
    return /* @__PURE__ */ React.createElement("span", { style: {
      display: "inline-block",
      padding: "1px 8px",
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 600,
      background: statePalette.bg,
      color: statePalette.fg,
      border: `1px solid ${statePalette.border}`
    } }, stateLabel);
  },
  credito: (l) => {
    const dbi = l.dbinforma || null;
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "td-num",
        title: dbi?.tipo_opiniao_credito ? `Opini\xE3o de cr\xE9dito (${dbi.tipo_opiniao_credito})` : ""
      },
      dbi?.opiniao_credito != null ? `${dbi.opiniao_credito.toLocaleString("pt-PT")} \u20AC` : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    );
  },
  owner: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, l.owner_username || "\u2014")
};
const LEAD_COLUMNS = [
  { key: "name", label: "Nome", width: 240, fixed: true, sortKey: "name", render: LEAD_CELLS.name },
  { key: "nif", label: "NIF", width: 110, mono: true, sortKey: "nif", render: LEAD_CELLS.nif },
  { key: "sector", label: "Setor", width: 150, sortKey: "sector", render: LEAD_CELLS.sector },
  { key: "loc", label: "Localidade", width: 170, sortKey: "district", render: LEAD_CELLS.loc },
  { key: "volume", label: "Volume", width: 110, align: "right", sortKey: "turnover", render: LEAD_CELLS.volume },
  { key: "vab", label: "VAB", width: 100, align: "right", render: LEAD_CELLS.vab },
  { key: "vpf", label: "V/Func.", width: 100, align: "right", render: LEAD_CELLS.vpf },
  { key: "perfil", label: "Perfil", width: 120, render: LEAD_CELLS.perfil },
  { key: "tier", label: "Tier", width: 70, sortKey: "tier", render: LEAD_CELLS.tier },
  { key: "etapa", label: "Etapa", width: 130, sortKey: "lead_estado__ordem", render: LEAD_CELLS.etapa },
  { key: "estado", label: "Estado", width: 120, sortKey: "status", render: LEAD_CELLS.estado },
  { key: "credito", label: "Cr\xE9dito", width: 90, align: "right", render: LEAD_CELLS.credito },
  { key: "owner", label: "Respons\xE1vel", width: 140, sortKey: "owner__username", render: LEAD_CELLS.owner }
];
function ProspecaoApp({
  me,
  view,
  entidade,
  params,
  navigate,
  reportCrumb,
  registerLeaveGuard
}) {
  const effectiveView = entidade ? "list" : view;
  if (effectiveView === "kanban") {
    return /* @__PURE__ */ React.createElement(ProspecaoKanbanView, { registerLeaveGuard });
  }
  if (effectiveView === "dashboard") return /* @__PURE__ */ React.createElement(ProspecaoDashboardView, null);
  return /* @__PURE__ */ React.createElement(
    ProspecaoListView,
    {
      me,
      entidade,
      params,
      navigate,
      reportCrumb,
      registerLeaveGuard
    }
  );
}
function isoWeekKey(d) {
  const tmp = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  tmp.setUTCDate(tmp.getUTCDate() + 4 - (tmp.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((tmp - yearStart) / 864e5 + 1) / 7);
  return `${tmp.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
}
const PERFIL_COLORS_FLAT = {
  transformacao: "#3a8a4d",
  revenda: "#22518c",
  servicos: "#9aa3ad",
  indefinido: "#c2c8cf"
};
const PROSPECAO_DASHBOARD_SETORES_COLUNAS = [
  {
    key: "sector",
    label: "Setor",
    width: 200,
    minWidth: 140,
    fixed: true,
    render: (s) => s.label
  },
  {
    key: "count",
    label: "Leads",
    width: 75,
    minWidth: 65,
    align: "right",
    render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, s.count.toLocaleString("pt-PT"))
  },
  {
    key: "ganha",
    label: "Ganhas",
    width: 80,
    minWidth: 65,
    align: "right",
    render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, s.ganha.toLocaleString("pt-PT"))
  },
  {
    key: "conversion_pct",
    label: "Conv.",
    width: 75,
    minWidth: 65,
    align: "right",
    render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: {
      color: s.conversion_pct >= 25 ? "#3a8a4d" : s.conversion_pct >= 10 ? "#9a6d12" : "var(--muted)",
      fontWeight: s.conversion_pct >= 25 ? 700 : 500
    } }, s.conversion_pct.toFixed(1), "%")
  }
];
function ProspecaoDashboardView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    etapa: null,
    tier: null,
    perfil: null,
    sector: null
  });
  const [leadEstados, setLeadEstados] = useState([]);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await LEADS_STATS_API.get());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  useEffect(() => {
    LEAD_ESTADOS_API.list().then((r) => setLeadEstados(r.results || r)).catch(() => {
    });
  }, []);
  const terminalSlugs = useMemo(
    () => new Set(leadEstados.filter((e) => e.is_terminal).map((e) => e.id_slug)),
    [leadEstados]
  );
  const toggleFilter = (key, val) => setFilters((f) => ({
    ...f,
    [key]: f[key] === val ? null : val
  }));
  const clearFilters = () => setFilters({
    etapa: null,
    tier: null,
    perfil: null,
    sector: null
  });
  const weekWindow = useMemo(() => {
    const today = /* @__PURE__ */ new Date();
    today.setHours(0, 0, 0, 0);
    const start = new Date(today);
    start.setDate(start.getDate() - 7 * 11);
    const keys = [];
    const d = new Date(start);
    for (let i = 0; i < 12; i++) {
      keys.push(isoWeekKey(d));
      d.setDate(d.getDate() + 7);
    }
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastMonthEnd = new Date(monthStart);
    lastMonthEnd.setDate(0);
    const lastMonthStart = new Date(
      lastMonthEnd.getFullYear(),
      lastMonthEnd.getMonth(),
      1
    );
    return {
      today,
      weekStart: start,
      keys,
      monthStart,
      lastMonthStart,
      lastMonthEnd
    };
  }, []);
  const filtered = useMemo(() => {
    if (!data) return [];
    return data.leads.filter((l) => {
      if (filters.etapa !== null && (l.estado || "_unset") !== filters.etapa) return false;
      if (filters.tier !== null && (l.tier || "_none") !== filters.tier) return false;
      if (filters.perfil !== null && l.perfil !== filters.perfil) return false;
      if (filters.sector !== null && (l.sector || "_unset") !== filters.sector) return false;
      return true;
    });
  }, [data, filters]);
  const agg = useMemo(() => {
    if (!data) return null;
    const funnelBuckets = /* @__PURE__ */ new Map();
    funnelBuckets.set("_unset", 0);
    data.lead_estados.forEach((e) => funnelBuckets.set(e.id_slug, 0));
    const tierCount = {};
    const perfilCount = {};
    const sectorBuckets = /* @__PURE__ */ new Map();
    let active = 0;
    let pipelineValue = 0;
    const wonDurations = [];
    const newPw = Object.fromEntries(weekWindow.keys.map((k) => [k, 0]));
    const wonPw = Object.fromEntries(weekWindow.keys.map((k) => [k, 0]));
    let thisMonthNew = 0;
    let lastMonthNew = 0;
    for (const l of filtered) {
      const estado = l.estado || "_unset";
      funnelBuckets.set(estado, (funnelBuckets.get(estado) || 0) + 1);
      const tierKey = l.tier || "_none";
      tierCount[tierKey] = (tierCount[tierKey] || 0) + 1;
      if (l.perfil) perfilCount[l.perfil] = (perfilCount[l.perfil] || 0) + 1;
      const secKey = l.sector || "_unset";
      const sb = sectorBuckets.get(secKey) || { total: 0, ganha: 0 };
      sb.total += 1;
      if (estado === "ganha") sb.ganha += 1;
      sectorBuckets.set(secKey, sb);
      if (!terminalSlugs.has(estado) && estado !== "_unset") {
        active += 1;
      } else if (estado === "_unset") {
        active += 1;
      }
      if (l.potencial && !terminalSlugs.has(estado)) {
        pipelineValue += l.potencial;
      }
      const created = new Date(l.created_at);
      if (created >= weekWindow.weekStart) {
        const k = isoWeekKey(created);
        if (k in newPw) newPw[k] += 1;
      }
      if (created >= weekWindow.monthStart) thisMonthNew += 1;
      else if (created >= weekWindow.lastMonthStart && created <= weekWindow.lastMonthEnd) lastMonthNew += 1;
      if (l.won_at) {
        const won = new Date(l.won_at);
        if (won >= weekWindow.weekStart) {
          const k = isoWeekKey(won);
          if (k in wonPw) wonPw[k] += 1;
        }
        wonDurations.push(
          Math.round((won - created) / 864e5)
        );
      }
    }
    const total = filtered.length;
    const ganha = funnelBuckets.get("ganha") || 0;
    const funnel = [];
    const unsetCount = funnelBuckets.get("_unset") || 0;
    if (unsetCount) {
      funnel.push({
        id_slug: "_unset",
        label: "Por classificar",
        color: "#9aa3ad",
        count: unsetCount
      });
    }
    for (const est of data.lead_estados) {
      funnel.push({
        id_slug: est.id_slug,
        label: est.label,
        color: est.color,
        count: funnelBuckets.get(est.id_slug) || 0
      });
    }
    const sectors = Array.from(sectorBuckets.entries()).filter(([s]) => s !== "_unset").map(([s, v]) => ({
      sector: s,
      label: data.sectors[s] || s || "\u2014",
      count: v.total,
      ganha: v.ganha,
      conversion_pct: v.total ? Math.round(v.ganha / v.total * 1e3) / 10 : 0
    })).sort((a, b) => b.count - a.count).slice(0, 12);
    const avgDaysToWin = wonDurations.length ? Math.round(wonDurations.reduce((s, d) => s + d, 0) / wonDurations.length * 10) / 10 : null;
    return {
      total,
      active,
      ganha,
      conversion_pct: total ? Math.round(ganha / total * 1e3) / 10 : 0,
      pipeline_value_eur: pipelineValue,
      this_month_new: thisMonthNew,
      last_month_new: lastMonthNew,
      avg_days_to_win: avgDaysToWin,
      funnel,
      tier_count: tierCount,
      perfil_count: perfilCount,
      sectors_top: sectors,
      new_per_week: weekWindow.keys.map((k) => newPw[k]),
      won_per_week: weekWindow.keys.map((k) => wonPw[k])
    };
  }, [data, filtered, weekWindow, terminalSlugs]);
  if (loading && !data) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026");
  if (error) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "#c4434b" } }, error);
  if (!data || !agg) return null;
  const monthlyDeltaPct = agg.last_month_new ? Math.round((agg.this_month_new - agg.last_month_new) / agg.last_month_new * 1e3) / 10 : null;
  const funnelMax = Math.max(1, ...agg.funnel.map((f) => f.count));
  const funnelTotal = agg.funnel.reduce((s, f) => s + f.count, 0) || 1;
  const weeklyMax = Math.max(1, ...agg.new_per_week, ...agg.won_per_week);
  const tierOrder = ["A", "B", "C", "_none"];
  const tierBars = tierOrder.map((k) => ({
    key: k,
    label: k === "_none" ? "Sem classifica\xE7\xE3o" : `Tier ${k}`,
    count: agg.tier_count[k] || 0,
    color: k === "_none" ? "#9aa3ad" : tierColor(k)
  })).filter((b) => b.count > 0);
  const tierMax = Math.max(1, ...tierBars.map((b) => b.count));
  const perfilOrder = ["transformacao", "revenda", "servicos", "indefinido"];
  const perfilBars = perfilOrder.map((k) => ({
    key: k,
    label: data.perfil_labels[k] || k,
    count: agg.perfil_count[k] || 0,
    color: PERFIL_COLORS_FLAT[k] || "#9aa3ad"
  })).filter((b) => b.count > 0);
  const perfilMax = Math.max(1, ...perfilBars.map((b) => b.count));
  const KPI_STYLE = {
    padding: 14,
    background: "var(--panel)",
    borderRadius: 8,
    border: "1px solid var(--border)"
  };
  const KPI_LABEL = {
    fontSize: 11,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em"
  };
  const KPI_VALUE = {
    fontSize: 28,
    fontWeight: 600,
    marginTop: 6,
    fontVariantNumeric: "tabular-nums",
    lineHeight: 1.1
  };
  const KPI_SUB = { fontSize: 11.5, color: "var(--muted)", marginTop: 6 };
  const deltaPill = (() => {
    if (monthlyDeltaPct == null) return null;
    const up = monthlyDeltaPct > 0;
    const down = monthlyDeltaPct < 0;
    if (!up && !down) return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11.5 } }, "= vs m\xEAs passado");
    const sign = up ? "\u25B2" : "\u25BC";
    const color = up ? "#3a8a4d" : "#c4434b";
    return /* @__PURE__ */ React.createElement("span", { style: { color, fontSize: 11.5, fontWeight: 600 } }, sign, " ", Math.abs(monthlyDeltaPct), "% vs m\xEAs passado");
  })();
  const activeFilters = Object.entries(filters).filter(([, v]) => v !== null);
  const filterLabel = {
    etapa: "Etapa",
    tier: "Tier",
    perfil: "Perfil",
    sector: "Setor"
  };
  const valueLabel = (key, val) => {
    if (key === "etapa") {
      const e = data.lead_estados.find((x) => x.id_slug === val);
      return e ? e.label : val === "_unset" ? "Por classificar" : val;
    }
    if (key === "tier") return val === "_none" ? "Sem" : val;
    if (key === "perfil") return data.perfil_labels[val] || val;
    if (key === "sector") return data.sectors[val] || val;
    return val;
  };
  const interactiveBar = (key, filterKey, label, count, max, color) => {
    const isActive = filters[filterKey] === key;
    const isOther = filters[filterKey] != null && !isActive;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key,
        onClick: () => toggleFilter(filterKey, key),
        style: {
          display: "grid",
          gridTemplateColumns: "140px 1fr 50px",
          alignItems: "center",
          gap: 8,
          padding: "3px 6px",
          borderRadius: 4,
          cursor: "pointer",
          background: isActive ? "var(--bg)" : "transparent",
          border: `1px solid ${isActive ? "var(--accent)" : "transparent"}`,
          opacity: isOther ? 0.4 : 1,
          transition: "opacity 0.15s, background 0.15s"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12 } }, label),
      /* @__PURE__ */ React.createElement("div", { style: {
        height: 16,
        background: "var(--bg)",
        borderRadius: 3,
        border: "1px solid var(--border)",
        position: "relative",
        overflow: "hidden"
      } }, /* @__PURE__ */ React.createElement("div", { style: {
        position: "absolute",
        inset: 0,
        width: `${count / max * 100}%`,
        background: color,
        borderRadius: 3
      } })),
      /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { fontSize: 12, textAlign: "right" } }, count.toLocaleString("pt-PT"))
    );
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, width: "100%", boxSizing: "border-box" } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 14,
    flexWrap: "wrap"
  } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "SCOUT \u2014 Pipeline"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 agregados sobre ", filtered.length.toLocaleString("pt-PT"), " leads n\xE3o-arquivados", activeFilters.length > 0 && " (filtrado)"), activeFilters.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    display: "inline-flex",
    gap: 6,
    alignItems: "center",
    flexWrap: "wrap"
  } }, activeFilters.map(([k, v]) => /* @__PURE__ */ React.createElement("span", { key: k, style: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 8px",
    borderRadius: 999,
    fontSize: 11.5,
    background: "var(--accent)",
    color: "#fff",
    fontWeight: 600
  } }, filterLabel[k], ": ", valueLabel(k, v), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => toggleFilter(k, v),
      style: {
        border: "none",
        background: "transparent",
        color: "#fff",
        cursor: "pointer",
        fontSize: 14,
        padding: "0 2px",
        lineHeight: 1
      }
    },
    "\xD7"
  ))), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: clearFilters }, "Limpar tudo")), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      "data-shortcut": "r",
      style: { marginLeft: "auto" },
      onClick: load
    },
    /* @__PURE__ */ React.createElement(Ico.refresh, null),
    " Atualizar",
    /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "R")
  )), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 12,
    marginBottom: 16
  } }, /* @__PURE__ */ React.createElement("div", { style: KPI_STYLE }, /* @__PURE__ */ React.createElement("div", { style: KPI_LABEL }, "Leads ativas"), /* @__PURE__ */ React.createElement("div", { style: KPI_VALUE }, agg.active.toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("div", { style: KPI_SUB }, "de ", agg.total.toLocaleString("pt-PT"), " no total")), /* @__PURE__ */ React.createElement("div", { style: KPI_STYLE }, /* @__PURE__ */ React.createElement("div", { style: KPI_LABEL }, "Convers\xE3o"), /* @__PURE__ */ React.createElement("div", { style: KPI_VALUE }, agg.conversion_pct.toFixed(1), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 16, fontWeight: 500 } }, "%")), /* @__PURE__ */ React.createElement("div", { style: KPI_SUB }, agg.avg_days_to_win != null ? `${agg.avg_days_to_win} dias em m\xE9dia at\xE9 ganhar` : "sem ganhas neste recorte")), /* @__PURE__ */ React.createElement("div", { style: KPI_STYLE }, /* @__PURE__ */ React.createElement("div", { style: KPI_LABEL }, "Valor em pipeline"), /* @__PURE__ */ React.createElement("div", { style: KPI_VALUE }, fmtEurCompact(agg.pipeline_value_eur)), /* @__PURE__ */ React.createElement("div", { style: KPI_SUB }, "\u03A3 estimativa anual de vendas \xB7 ", agg.active, " leads ativos")), /* @__PURE__ */ React.createElement("div", { style: KPI_STYLE }, /* @__PURE__ */ React.createElement("div", { style: KPI_LABEL }, "Novas este m\xEAs"), /* @__PURE__ */ React.createElement("div", { style: KPI_VALUE }, agg.this_month_new.toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("div", { style: KPI_SUB }, deltaPill || `${agg.last_month_new} no m\xEAs anterior`))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 14, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", gap: 8, marginBottom: 10 } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 13 } }, "Pipeline por etapa"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5, color: "var(--muted)" } }, "\xB7 clica numa barra para filtrar")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 4 } }, agg.funnel.map((f) => {
    const isActive = filters.etapa === f.id_slug;
    const isOther = filters.etapa != null && !isActive;
    const pct = f.count > 0 ? f.count / funnelTotal * 100 : 0;
    const widthPct = Math.max(1, f.count / funnelMax * 100);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: f.id_slug,
        onClick: () => toggleFilter("etapa", f.id_slug),
        style: {
          display: "grid",
          gridTemplateColumns: "180px 1fr 130px",
          alignItems: "center",
          gap: 8,
          padding: "3px 6px",
          borderRadius: 4,
          cursor: "pointer",
          background: isActive ? "var(--bg)" : "transparent",
          border: `1px solid ${isActive ? "var(--accent)" : "transparent"}`,
          opacity: isOther ? 0.4 : 1,
          transition: "opacity 0.15s, background 0.15s"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12.5 } }, f.label),
      /* @__PURE__ */ React.createElement("div", { style: {
        position: "relative",
        height: 22,
        background: "var(--bg)",
        borderRadius: 4,
        border: "1px solid var(--border)"
      } }, /* @__PURE__ */ React.createElement("div", { style: {
        position: "absolute",
        inset: 0,
        width: `${widthPct}%`,
        background: f.color || "#9aa3ad",
        borderRadius: 4
      } })),
      /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { fontSize: 12, color: "var(--text-2)" } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--text)" } }, f.count.toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, " \xB7 ", pct.toFixed(1), "%"))
    );
  }))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 14, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", gap: 10, marginBottom: 10 } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 13 } }, "Cad\xEAncia semanal \xB7 \xFAltimas 12 semanas"), /* @__PURE__ */ React.createElement("span", { style: {
    fontSize: 11.5,
    display: "inline-flex",
    alignItems: "center",
    gap: 4
  } }, /* @__PURE__ */ React.createElement("span", { style: { width: 9, height: 9, borderRadius: 2, background: "var(--accent)" } }), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "novas")), /* @__PURE__ */ React.createElement("span", { style: {
    fontSize: 11.5,
    display: "inline-flex",
    alignItems: "center",
    gap: 4
  } }, /* @__PURE__ */ React.createElement("span", { style: { width: 9, height: 9, borderRadius: 2, background: "#3a8a4d" } }), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "ganhas"))), (() => {
    const W = 1200, H = 200, padL = 38, padR = 12, padT = 12, padB = 28;
    const innerW = W - padL - padR;
    const innerH = H - padT - padB;
    const slot = innerW / weekWindow.keys.length;
    const barW = Math.max(2, Math.min(20, slot / 2 - 2));
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "100%",
        height: H,
        viewBox: `0 0 ${W} ${H}`,
        preserveAspectRatio: "none",
        style: { display: "block" }
      },
      [0, 0.5, 1].map((p) => {
        const y = padT + innerH - p * innerH;
        return /* @__PURE__ */ React.createElement(
          "line",
          {
            key: p,
            x1: padL,
            y1: y,
            x2: W - padR,
            y2: y,
            stroke: "var(--border)",
            strokeDasharray: p === 0 ? "0" : "2 3"
          }
        );
      }),
      [0, 0.5, 1].map((p) => {
        const y = padT + innerH - p * innerH;
        return /* @__PURE__ */ React.createElement(
          "text",
          {
            key: p,
            x: padL - 4,
            y: y + 3,
            fontSize: "10",
            fill: "var(--muted)",
            textAnchor: "end",
            fontFamily: "var(--font-mono)"
          },
          Math.round(p * weeklyMax)
        );
      }),
      weekWindow.keys.map((w, i) => {
        const cx = padL + i * slot + slot / 2;
        const nh = agg.new_per_week[i] / weeklyMax * innerH;
        const wh = agg.won_per_week[i] / weeklyMax * innerH;
        const gap = 2;
        const xNew = cx - barW - gap / 2;
        const xWon = cx + gap / 2;
        return /* @__PURE__ */ React.createElement("g", { key: w }, /* @__PURE__ */ React.createElement(
          "rect",
          {
            x: xNew,
            y: padT + innerH - nh,
            width: barW,
            height: nh,
            fill: "var(--accent)",
            opacity: "0.8",
            rx: "1"
          },
          /* @__PURE__ */ React.createElement("title", null, w, " \xB7 ", agg.new_per_week[i], " novas")
        ), /* @__PURE__ */ React.createElement(
          "rect",
          {
            x: xWon,
            y: padT + innerH - wh,
            width: barW,
            height: wh,
            fill: "#3a8a4d",
            opacity: "0.85",
            rx: "1"
          },
          /* @__PURE__ */ React.createElement("title", null, w, " \xB7 ", agg.won_per_week[i], " ganhas")
        ), (i === 0 || i === weekWindow.keys.length - 1 || i === Math.floor(weekWindow.keys.length / 2)) && /* @__PURE__ */ React.createElement(
          "text",
          {
            x: cx,
            y: H - 8,
            fontSize: "10",
            textAnchor: "middle",
            fill: "var(--muted)",
            fontFamily: "var(--font-mono)"
          },
          w.slice(5)
        ));
      })
    );
  })()), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.6fr)",
    gap: 12
  } }, /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 14 } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 13 } }, "Por Tier"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", flexDirection: "column", gap: 2 } }, tierBars.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12 } }, "Sem leads neste recorte."), tierBars.map((b) => interactiveBar(
    b.key,
    "tier",
    b.label,
    b.count,
    tierMax,
    b.color
  )))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 14 } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 13 } }, "Por Perfil DBInforma"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", flexDirection: "column", gap: 2 } }, perfilBars.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12 } }, "Sem relat\xF3rios DBInforma neste recorte."), perfilBars.map((b) => interactiveBar(
    b.key,
    "perfil",
    b.label,
    b.count,
    perfilMax,
    b.color
  )))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 14 } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 13 } }, "Top setores \xB7 taxa de convers\xE3o"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, fontSize: 12 } }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "dashboard-setores",
      columns: PROSPECAO_DASHBOARD_SETORES_COLUNAS,
      data: agg.sectors_top,
      pagination: "none",
      rowKey: (s) => s.sector,
      onRowClick: (s) => toggleFilter("sector", s.sector),
      rowStyle: (s) => {
        const isActive = filters.sector === s.sector;
        const isOther = filters.sector != null && !isActive;
        return {
          background: isActive ? "var(--bg)" : void 0,
          opacity: isOther ? 0.4 : 1,
          outline: isActive ? "1px solid var(--accent)" : "none"
        };
      },
      empty: "Sem dados de setor neste recorte."
    }
  )))));
}
window.ProspecaoDashboardView = ProspecaoDashboardView;
function ProspecaoListView({
  me,
  entidade,
  params,
  navigate,
  reportCrumb,
  registerLeaveGuard
}) {
  const initialParams = window.HubRouter.current().params;
  const intOr = (v, dflt) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) && n > 0 ? n : dflt;
  };
  const parseSort = (raw) => {
    if (!raw) return [];
    return raw.split(",").filter(Boolean).map((k) => {
      const dir = k.startsWith("-") ? "desc" : "asc";
      return { key: k.replace(/^-/, ""), dir };
    });
  };
  const parseSet = (raw) => new Set((raw || "").split(",").filter(Boolean));
  const initialPage = intOr(initialParams.get("page"), 1);
  const initialPageSize = intOr(initialParams.get("pageSize"), 50);
  const initialSort = parseSort(initialParams.get("sort"));
  const [leads, setLeads] = useState([]);
  const [count, setCount] = useState(0);
  const [error, setError] = useState(null);
  const [includeAll, setIncludeAll] = useState(initialParams.get("includeAll") === "1");
  const [search, setSearch] = useState(initialParams.get("search") || "");
  const [filterSector, setFilterSector] = useState(parseSet(initialParams.get("sector")));
  const [filterTier, setFilterTier] = useState(parseSet(initialParams.get("tier")));
  const [filterEtapa, setFilterEtapa] = useState(parseSet(initialParams.get("estado")));
  const [leadEstados, setLeadEstados] = useState([]);
  const [creating, setCreating] = useState(false);
  const [editing, setEditing] = useState(null);
  const [selected, setSelected] = useState(/* @__PURE__ */ new Set());
  const [viewState, setViewState] = useState({
    page: initialPage,
    pageSize: initialPageSize,
    sort: initialSort
  });
  const [refetchToken, setRefetchToken] = useState(0);
  const load = () => setRefetchToken((t) => t + 1);
  const paginaAtual = useRef(null);
  const exportSelectedCsv = () => {
    const rows = leads.filter((l) => selected.has(l.id));
    if (!rows.length) return;
    const sep = ";";
    const esc = (v) => {
      if (v == null) return "";
      const s = String(v).replace(/"/g, '""');
      return /["\n;]/.test(s) ? `"${s}"` : s;
    };
    const header = [
      "NIF",
      "Nome",
      "Setor",
      "CAE",
      "Distrito",
      "Concelho",
      "Morada",
      "Telefone",
      "Website",
      "Volume (EUR)",
      "VAB (EUR)",
      "Vendas/Func (EUR)",
      "Perfil",
      "Tier",
      "Etapa",
      "Estado (DBInforma)",
      "Cr\xE9dito (EUR)",
      "Confian\xE7a",
      "Estado Lead"
    ];
    const body = rows.map((l) => [
      l.nif,
      l.name,
      SECTORS.find((s) => s.id === l.sector)?.label || l.sector,
      l.cae,
      l.district,
      l.county,
      l.address,
      l.phone,
      l.website,
      l.turnover ?? "",
      l.dbinforma?.vab ?? "",
      l.dbinforma?.vendas_por_func ?? "",
      l.dbinforma?.perfil_label || "",
      l.tier || "",
      l.lead_estado?.label || "",
      l.dbinforma?.status_label || "",
      l.dbinforma?.opiniao_credito ?? "",
      CONFIDENCE_LABELS[l.confidence] || l.confidence,
      STATUS_LABELS[l.status] || l.status
    ].map(esc).join(sep));
    const csv = "\uFEFF" + [header.join(sep), ...body].join("\r\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const today = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
    a.href = url;
    a.download = `leads-${today}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  const carregarPagina = ({ page, pageSize, ordering }) => {
    const chavePagina = `${page}|${pageSize}`;
    if (paginaAtual.current !== null && paginaAtual.current !== chavePagina) setSelected(/* @__PURE__ */ new Set());
    paginaAtual.current = chavePagina;
    const qp = {
      limit: pageSize,
      offset: (page - 1) * pageSize
    };
    if (search) qp.search = search;
    if (filterSector.size) qp.sector = [...filterSector].join(",");
    if (filterTier.size) qp.tier = [...filterTier].join(",");
    if (filterEtapa.size) qp.lead_estado__id_slug = [...filterEtapa].join(",");
    if (ordering) qp.ordering = ordering;
    if (includeAll) qp.include_all = "1";
    setError(null);
    return window.API.leads(qp).then((r) => {
      const results = r.results || r;
      const total = typeof r.count === "number" ? r.count : results.length;
      setCount(total);
      return { rows: results, total };
    }).catch((e) => {
      setError(e.message);
      setCount(0);
      return { rows: [], total: 0 };
    });
  };
  useEffect(() => {
    window.HubRouter.setParams({
      page: viewState.page > 1 ? String(viewState.page) : null,
      pageSize: viewState.pageSize !== 50 ? String(viewState.pageSize) : null,
      search: search || null,
      sector: filterSector.size ? [...filterSector].join(",") : null,
      tier: filterTier.size ? [...filterTier].join(",") : null,
      estado: filterEtapa.size ? [...filterEtapa].join(",") : null,
      includeAll: includeAll ? "1" : null,
      sort: viewState.sort.length ? viewState.sort.map((s) => (s.dir === "desc" ? "-" : "") + s.key).join(",") : null
    });
  }, [viewState, search, filterSector, filterTier, filterEtapa, includeAll]);
  useEffect(() => {
    LEAD_ESTADOS_API.list().then((r) => setLeadEstados(r.results || r)).catch(() => {
    });
  }, []);
  const [entidadeError, setEntidadeError] = useState(null);
  useEffect(() => {
    if (!entidade) {
      setEditing(null);
      setEntidadeError(null);
      return;
    }
    const leadId = Number(entidade);
    if (!leadId) {
      setEntidadeError({ entidade, message: "Notifica\xE7\xE3o inv\xE1lida.", tipo: "error" });
      return;
    }
    setEntidadeError(null);
    setEditing(null);
    let cancelado = false;
    window.API.getLead(leadId).then((lead) => {
      if (!cancelado) {
        setEditing(lead);
      }
    }).catch((e) => {
      if (cancelado) return;
      if (window.API.isNetworkError(e)) {
        window.srToast?.("Sem liga\xE7\xE3o ao servidor \u2014 n\xE3o foi poss\xEDvel verificar esta lead.", "error");
        return;
      }
      setEntidadeError({
        entidade,
        message: "Lead n\xE3o encontrada ou sem acesso. Pede acesso ao owner.",
        tipo: "warning"
      });
    });
    return () => {
      cancelado = true;
    };
  }, [entidade]);
  useEffect(() => {
    reportCrumb && reportCrumb(editing ? editing.name : null);
    return () => {
      reportCrumb && reportCrumb(null);
    };
  }, [editing, reportCrumb]);
  useEffect(() => {
    if (!entidadeError || entidadeError.entidade !== entidade) return;
    window.srToast?.(entidadeError.message, entidadeError.tipo);
    navigate({ routeId: "prospecao", params }, { replace: true });
  }, [entidade, entidadeError, params]);
  const onCreate = async (data) => {
    try {
      const created = await window.API.createLead(data);
      load();
      setCreating(false);
      navigate({ routeId: "prospecao", entidade: String(created.id), params });
      return created;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  };
  const onUpdate = async (id, patch) => {
    try {
      const updated = await window.API.updateLead(id, patch);
      load();
      setEditing(updated);
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  };
  const onDelete = async (lead) => {
    if (!await window.hubConfirm({ message: `Apagar lead "${lead.name}"?` })) return;
    try {
      await window.API.deleteLead(lead.id);
      load();
    } catch (e) {
      setError(e.message);
    }
  };
  const columns = [...LEAD_COLUMNS, {
    key: "acoes",
    label: "A\xE7\xF5es",
    sortable: false,
    width: 70,
    fixed: true,
    render: (l) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => onDelete(l) }, /* @__PURE__ */ React.createElement(Ico.trash, null)))
  }];
  return (
    // Coluna flex: o painel do HubList é `flex: 1 1 auto; min-height: 0` e
    // precisa de um pai que lhe dê altura, senão o `.dt-wrap` cresce com a
    // tabela e o scroll (e a barra de paginação por cima) saem do sítio.
    /* @__PURE__ */ React.createElement("div", { style: {
      padding: 20,
      display: "flex",
      flexDirection: "column",
      flex: "1 1 auto",
      minHeight: 0
    } }, /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      marginBottom: 14,
      flexWrap: "wrap",
      flexShrink: 0
    } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Prospe\xE7\xE3o B2B"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 ", count, " leads", selected.size > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, " \xB7 ", /* @__PURE__ */ React.createElement("strong", null, selected.size, " selecionados nesta p\xE1gina"))), selected.size > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setSelected(/* @__PURE__ */ new Set()) }, "Limpar sele\xE7\xE3o"), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn sm",
        style: { marginLeft: "auto" },
        "data-shortcut": "e",
        onClick: exportSelectedCsv
      },
      /* @__PURE__ */ React.createElement(Ico.download, null),
      " Exportar ",
      selected.size,
      " (CSV)",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "E")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        "data-shortcut": "a",
        onClick: () => setCreating(true)
      },
      /* @__PURE__ */ React.createElement(Ico.plus, null),
      " Novo lead",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "A")
    )), selected.size === 0 && /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        "data-shortcut": "a",
        style: { marginLeft: "auto" },
        onClick: () => setCreating(true)
      },
      /* @__PURE__ */ React.createElement(Ico.plus, null),
      " Novo lead",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "A")
    )), /* @__PURE__ */ React.createElement("div", { className: "filters", style: { marginBottom: 10, flexShrink: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "search-input" }, /* @__PURE__ */ React.createElement(Ico.search, null), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        placeholder: "Pesquisar nome, NIF, distrito\u2026",
        value: search,
        onChange: (e) => setSearch(e.target.value)
      }
    )), /* @__PURE__ */ React.createElement(
      ChipFilter,
      {
        label: "Setor",
        value: filterSector,
        setValue: setFilterSector,
        options: SECTORS.map((s) => ({ value: s.id, label: s.label }))
      }
    ), /* @__PURE__ */ React.createElement(
      ChipFilter,
      {
        label: "Tier",
        value: filterTier,
        setValue: setFilterTier,
        options: [
          { value: "A", label: "A", dot: "#3a8a4d" },
          { value: "B", label: "B", dot: "#d4a574" },
          { value: "C", label: "C", dot: "#9aa3ad" }
        ]
      }
    ), leadEstados.length > 0 && /* @__PURE__ */ React.createElement(
      ChipFilter,
      {
        label: "Etapa",
        value: filterEtapa,
        setValue: setFilterEtapa,
        options: leadEstados.filter((e) => e.is_active).map((e) => ({
          value: e.id_slug,
          label: e.label,
          dot: e.color || "#9aa3ad"
        }))
      }
    ), /* @__PURE__ */ React.createElement("label", { style: { display: "flex", alignItems: "center", gap: 5, fontSize: 12.5, marginLeft: 12 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: includeAll, onChange: (e) => setIncludeAll(e.target.checked) }), "Incluir n\xE3o-ativos")), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "prospecao",
        viewId: "leads",
        columns,
        pagination: "server",
        selectable: true,
        selection: selected,
        onSelection: setSelected,
        rowKey: (l) => l.id,
        onRowClick: (l) => navigate({ routeId: "prospecao", entidade: String(l.id), params }),
        onRows: setLeads,
        fetch: carregarPagina,
        fetchDeps: [search, includeAll, filterSector, filterTier, filterEtapa],
        refetchToken,
        initialPage,
        initialPageSize,
        initialSort,
        onViewState: setViewState,
        empty: count === 0 ? "Sem leads. Cria o primeiro." : "Nenhum lead nesta p\xE1gina com os filtros aplicados."
      }
    ), (creating || editing) && /* @__PURE__ */ React.createElement(
      LeadDrawer,
      {
        key: editing?.id || "new",
        title: editing ? editing.name : "Novo lead",
        subtitle: editing ? editing.nif ? `NIF ${editing.nif}` : "sem NIF" : "Criar manualmente",
        initial: editing || {},
        navList: editing ? leads : [],
        currentId: editing?.id,
        leadEstados,
        registerLeaveGuard,
        onLeaveTo: (destino) => {
          if (!editing) setCreating(false);
          window.HubRouter.navigate(window.HubRouter.parse(destino || ""));
        },
        onNavigate: (l) => navigate({ routeId: "prospecao", entidade: String(l.id), params }),
        onClose: () => {
          if (!editing) {
            setCreating(false);
            return;
          }
          navigate({ routeId: "prospecao", params });
        },
        onSubmit: (data) => editing ? onUpdate(editing.id, data) : onCreate(data)
      }
    ))
  );
}
function scoutContaAvisoTexto(match) {
  if (!match) return "";
  if (!match.visivel) {
    return "J\xE1 existe uma conta para este NIF (sem permiss\xE3o para a ver).";
  }
  const estado = window.scoutContaEstadoLabel ? window.scoutContaEstadoLabel(match.estado_relacao) : match.estado_relacao;
  return `J\xE1 existe uma conta para este NIF: \xAB${match.nome}\xBB (estado: ${estado}).`;
}
window.scoutContaAvisoTexto = scoutContaAvisoTexto;
function LeadDrawer({
  title,
  subtitle,
  initial,
  onClose,
  onSubmit,
  navList,
  onNavigate,
  currentId,
  leadEstados = [],
  registerLeaveGuard,
  onLeaveTo
}) {
  const buildPristine = () => ({
    nif: initial.nif || "",
    name: initial.name || "",
    sector: initial.sector || "",
    cae: initial.cae || "",
    district: initial.district || "",
    county: initial.county || "",
    address: initial.address || "",
    phone: initial.phone || "",
    website: initial.website || "",
    turnover: initial.turnover || "",
    vendas_estimadas_eur: initial.vendas_estimadas_eur || "",
    source: initial.source || "",
    confidence: initial.confidence || "media",
    status: initial.status || "unverified",
    notes: initial.notes || "",
    tier: initial.tier || "",
    lead_estado_id_slug: initial.lead_estado?.id_slug || "",
    owner_id: initial.owner_id ?? null
  });
  const [form, setForm] = useState(buildPristine);
  const [pristine, setPristine] = useState(buildPristine);
  const isDirty = JSON.stringify(form) !== JSON.stringify(pristine);
  const canAssign = window.SR_ME?.access_actions?.prospecao?.includes("assign") ?? false;
  const [users, setUsers] = useState(() => window.SR_USERS || []);
  const [viesLoading, setViesLoading] = useState(false);
  const [viesResult, setViesResult] = useState(initial.vies || null);
  const [enrichLoading, setEnrichLoading] = useState(false);
  const [enrichMsg, setEnrichMsg] = useState(null);
  const [enrichReport, setEnrichReport] = useState(null);
  const [enrichXml, setEnrichXml] = useState(null);
  const [dbinformaFetchedAt, setDbinformaFetchedAt] = useState(null);
  const [dbinformaIndicators, setDbinformaIndicators] = useState({});
  const [dbinformaAnalytics, setDbinformaAnalytics] = useState(() => {
    const s = initial.dbinforma;
    if (!s) return null;
    return {
      vab: s.vab ?? null,
      vendas: s.vendas ?? null,
      empregados: s.empregados ?? null,
      vendas_por_func: s.vendas_por_func ?? null,
      perfil: s.perfil || "indefinido",
      perfil_label: s.perfil_label || ""
    };
  });
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyVersion, setHistoryVersion] = useState(0);
  const [notas, setNotas] = useState([]);
  const [notasVersion, setNotasVersion] = useState(0);
  const [logs, setLogs] = useState([]);
  const [archivedAt, setArchivedAt] = useState(initial.archived_at || null);
  const [wonAt, setWonAt] = useState(initial.won_at || null);
  const [pendingLeave, setPendingLeave] = useState(null);
  const [contaMatch, setContaMatch] = useState(null);
  const [converting, setConverting] = useState(false);
  const [confirmConvert, setConfirmConvert] = useState(false);
  useEffect(() => {
    const nif = (form.nif || "").trim();
    if (nif.length !== 9) {
      setContaMatch(null);
      return;
    }
    let cancelled = false;
    window.ScoutAPI.contaLookup([nif]).then((r) => {
      if (!cancelled) setContaMatch(r[nif] || null);
    }).catch(() => {
      if (!cancelled) setContaMatch(null);
    });
    return () => {
      cancelled = true;
    };
  }, [form.nif]);
  const refreshHistory = () => setHistoryVersion((v) => v + 1);
  const refreshNotas = () => setNotasVersion((v) => v + 1);
  useEffect(() => {
    if (users.length > 0) return;
    if (typeof window.API?.users !== "function") return;
    window.API.users().then((r) => setUsers(r.results || r)).catch(() => {
    });
  }, []);
  useEffect(() => {
    if (!initial.id) return;
    window.API.dbinformaReport(initial.id).then((r) => {
      setEnrichReport(r.report || null);
      setEnrichXml(r.raw_xml || null);
      setDbinformaFetchedAt(r.fetched_at || null);
      setDbinformaIndicators(r.indicators || {});
      if (r.analytics) setDbinformaAnalytics(r.analytics);
      if (r.fields) applyDbinforma(r.fields);
    }).catch(() => {
    });
  }, [initial.id]);
  useEffect(() => {
    if (!initial.id) return;
    let cancelled = false;
    window.API.getLead(initial.id).then((lead) => {
      if (cancelled) return;
      setArchivedAt(lead.archived_at || null);
      setWonAt(lead.won_at || null);
      const mapped = (lead.acoes || []).map((a) => ({
        id: a.id,
        source: "acao",
        tipo: a.tipo?.id_slug,
        tipoNome: a.tipo?.nome || a.tipo?.id_slug,
        autor: a.autor_username,
        atribuido: a.atribuido_username || null,
        criadoEm: a.criado_em ? new Date(a.criado_em) : null,
        descricao: a.descricao,
        tratada: !!a.tratada_em,
        tratadaEm: a.tratada_em ? new Date(a.tratada_em) : null,
        tratadaPor: a.tratada_por_username || null,
        prazo: a.data_limite || null
      }));
      setHistory(mapped);
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, [initial.id, historyVersion]);
  useEffect(() => {
    if (!initial.id) return;
    let cancelled = false;
    fetch(
      `/api/prospecao/leads/${initial.id}/audit/`,
      { credentials: "same-origin" }
    ).then((r) => r.json()).then((events) => {
      if (!cancelled) setLogs((events || []).map((e) => ({
        id: e.id,
        evento: e.verb,
        descricao: e.summary,
        actor_username: e.actor_name,
        criado_em: e.when
      })));
    }).catch(() => {
      if (!cancelled) setLogs([]);
    });
    return () => {
      cancelled = true;
    };
  }, [initial.id, historyVersion]);
  useEffect(() => {
    if (!initial.id) return;
    let cancelled = false;
    window.API.leadNotas(initial.id).then((r) => {
      if (cancelled) return;
      setNotas(Array.isArray(r) ? r : r.results || []);
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, [initial.id, notasVersion]);
  const addLeadAcao = async (tipoIdSlug, descricao, atribuidoId, prazo = null) => {
    if (!initial.id) return;
    try {
      await window.API.addLeadAcao(
        initial.id,
        tipoIdSlug,
        descricao,
        atribuidoId,
        prazo
      );
      refreshHistory();
    } catch (e) {
      window.srToast?.(`A\xE7\xE3o: ${e.message}`);
    }
  };
  const deleteLeadAcao = async (a) => {
    if (!initial.id) return;
    try {
      await window.API.deleteLeadAcao(initial.id, a.id);
      refreshHistory();
    } catch (e) {
      window.srToast?.(`Apagar: ${e.message}`);
    }
  };
  const toggleLeadAcaoTratada = async (a) => {
    if (!initial.id) return;
    try {
      await window.API.tratarLeadAcao(initial.id, a.id);
      refreshHistory();
    } catch (e) {
      window.srToast?.(`Tratar: ${e.message}`);
    }
  };
  const setLeadAcaoPrazo = async (a, iso) => {
    if (!initial.id) return;
    try {
      await window.API.prazoLeadAcao(initial.id, a.id, iso);
      refreshHistory();
    } catch (e) {
      window.srToast?.(`Prazo: ${e.message}`);
    }
  };
  const addLeadNota = async (descricao) => {
    if (!initial.id) return;
    try {
      await window.API.leadNotaCreate(initial.id, descricao);
      refreshNotas();
    } catch (e) {
      window.srToast?.(`Nota: ${e.message}`);
    }
  };
  const updateLeadNota = async (notaId, descricao) => {
    if (!initial.id) return;
    try {
      await window.API.leadNotaUpdate(initial.id, notaId, descricao);
      refreshNotas();
    } catch (e) {
      window.srToast?.(`Nota: ${e.message}`);
    }
  };
  const deleteLeadNota = async (notaId) => {
    if (!initial.id) return;
    try {
      await window.API.leadNotaDelete(initial.id, notaId);
      refreshNotas();
    } catch (e) {
      window.srToast?.(`Nota: ${e.message}`);
    }
  };
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const nifValid = !form.nif || isValidLegalEntityNif(form.nif);
  const checkVies = async () => {
    if (!isValidLegalEntityNif(form.nif)) {
      window.srToast("NIF inv\xE1lido (m\xF3dulo 11).", "error");
      return;
    }
    setViesLoading(true);
    try {
      const r = await window.API.viesCheck(form.nif);
      setViesResult({
        status: r.valid ? "v\xE1lido" : "inv\xE1lido",
        name: r.name,
        address: r.address,
        date: r.requestDate
      });
    } catch (e) {
      window.srToast(`VIES: ${e.message}`, "error");
    } finally {
      setViesLoading(false);
    }
  };
  const applyDbinforma = (data) => {
    const merge = (cur) => ({
      ...cur,
      name: cur.name || data.name || "",
      sector: cur.sector || data.sector || "",
      cae: cur.cae || data.cae || "",
      address: cur.address || data.address || "",
      district: cur.district || data.district || "",
      county: cur.county || data.county || "",
      phone: cur.phone || data.phone || "",
      website: cur.website || data.website || "",
      turnover: cur.turnover || data.turnover || "",
      status: data.status && data.status !== "unverified" ? data.status : cur.status
    });
    setForm(merge);
    setPristine(merge);
  };
  const validateLead = async () => {
    if (!isValidLegalEntityNif(form.nif)) {
      window.srToast("NIF inv\xE1lido (m\xF3dulo 11).", "error");
      return;
    }
    setEnrichLoading(true);
    setEnrichMsg(null);
    try {
      const r = await window.API.validateLead(form.nif);
      if (r.error) throw new Error(r.error);
      if (r.configured === false) throw new Error(r.detail);
      applyDbinforma(r);
      setEnrichMsg(`Validado \xB7 ${r.name || form.nif} (gratuito)`);
    } catch (e) {
      setEnrichMsg(`Valida\xE7\xE3o: ${e.message}`);
    } finally {
      setEnrichLoading(false);
    }
  };
  const enrichLead = async () => {
    if (!isValidLegalEntityNif(form.nif)) {
      window.srToast?.("NIF inv\xE1lido (m\xF3dulo 11).");
      return;
    }
    if (!initial.id) {
      window.srToast?.("Guarda a Lead primeiro para usar Atualizar relat\xF3rio.");
      return;
    }
    if (!await window.hubConfirm({ message: "Pedido pago \xE0 Apinforma (Relat\xF3rio Estrutural PLESTRUT). Continuar?" })) return;
    setEnrichLoading(true);
    setEnrichMsg(null);
    try {
      const r = await window.API.dbinformaRefresh(initial.id);
      if (r.fields) applyDbinforma(r.fields);
      setEnrichReport(r.report || null);
      setEnrichXml(r.raw_xml || null);
      setDbinformaFetchedAt(r.fetched_at || null);
      setDbinformaIndicators(r.indicators || {});
      if (r.analytics) setDbinformaAnalytics(r.analytics);
      setEnrichMsg("Relat\xF3rio atualizado.");
    } catch (e) {
      setEnrichMsg(`Atualiza\xE7\xE3o: ${e.message}`);
    } finally {
      setEnrichLoading(false);
    }
  };
  const guardLeave = (action) => {
    if (!isDirty) {
      action();
      return;
    }
    setPendingLeave(() => action);
  };
  const guardedClose = () => guardLeave(onClose);
  const guardedNavigate = (l) => guardLeave(() => onNavigate && onNavigate(l));
  useEffect(() => {
    if (typeof registerLeaveGuard !== "function") return void 0;
    const sairPara = typeof onLeaveTo === "function" ? onLeaveTo : (destino) => {
      if (!destino) return;
      window.HubRouter.navigate(window.HubRouter.parse(destino));
    };
    return registerLeaveGuard((destino) => {
      if (!isDirty) return true;
      setPendingLeave(() => () => sairPara(destino));
      return false;
    });
  }, [registerLeaveGuard, isDirty, onLeaveTo]);
  const submit = async (e) => {
    e.preventDefault();
    if (!isDirty) return false;
    const data = { ...form };
    data.turnover = data.turnover === "" ? null : Number(data.turnover);
    data.vendas_estimadas_eur = data.vendas_estimadas_eur === "" ? null : Number(data.vendas_estimadas_eur);
    data.lead_estado_id_slug = data.lead_estado_id_slug || null;
    data.owner_id = data.owner_id || null;
    if (viesResult) data.vies = viesResult;
    try {
      await onSubmit(data);
      setPristine({ ...form });
      return true;
    } catch (_) {
      return false;
    }
  };
  const formId = "lead-form";
  const headerPills = (() => {
    const fields = enrichReport?.fields || {};
    const label = fields.status_label;
    const kind = fields.status_kind;
    const credito = fields.opiniao_credito;
    const a = dbinformaAnalytics || {};
    const volume = form.turnover !== "" && form.turnover != null ? Number(form.turnover) : a.vendas ?? null;
    const etapaObj = form.lead_estado_id_slug ? leadEstados.find((es) => es.id_slug === form.lead_estado_id_slug) : null;
    const hasAnything = label || wonAt || archivedAt || credito != null || a.vab != null || a.perfil_label || volume != null || a.empregados != null || a.vendas_por_func != null || etapaObj || isDirty;
    if (!hasAnything) return null;
    const palette = kind === "good" ? { bg: "#e8f6ec", fg: "#1f7a3a", border: "#bce0c6" } : kind === "bad" ? { bg: "#fce8e8", fg: "#a82a2a", border: "#f0bcbc" } : { bg: "#f3f3f5", fg: "var(--text-2)", border: "var(--border)" };
    const statPill = (key, label2, value, title2) => /* @__PURE__ */ React.createElement("span", { key, title: title2, style: {
      padding: "2px 10px",
      borderRadius: 6,
      fontSize: 11.5,
      fontWeight: 600,
      background: "var(--panel)",
      color: "var(--text-2)",
      border: "1px solid var(--border)"
    } }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontWeight: 500 } }, label2, ": "), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--text)", fontWeight: 700 } }, value));
    const perfilPalette = PERFIL_BG[a.perfil] || PERFIL_BG.indefinido;
    return /* @__PURE__ */ React.createElement("div", { style: { display: "inline-flex", alignItems: "center", gap: 6, flexWrap: "wrap" } }, isDirty && /* @__PURE__ */ React.createElement("span", { title: "Tens edi\xE7\xF5es por guardar (Alt+S)", style: {
      padding: "2px 10px",
      borderRadius: 999,
      fontSize: 11.5,
      fontWeight: 700,
      background: "rgba(196, 67, 75, 0.12)",
      color: "#c4434b",
      border: "1px solid rgba(196, 67, 75, 0.3)"
    } }, "\u25CF Por guardar"), etapaObj && /* @__PURE__ */ React.createElement("span", { title: "Etapa da lead (pipeline interno)", style: {
      padding: "2px 10px",
      borderRadius: 999,
      fontSize: 11.5,
      fontWeight: 700,
      background: etapaObj.color || "#9aa3ad",
      color: "#fff"
    } }, etapaObj.label), label && /* @__PURE__ */ React.createElement("span", { style: {
      padding: "2px 10px",
      borderRadius: 999,
      fontSize: 11.5,
      fontWeight: 700,
      background: palette.bg,
      color: palette.fg,
      border: `1px solid ${palette.border}`
    } }, label), wonAt && /* @__PURE__ */ React.createElement("span", { style: {
      padding: "2px 10px",
      borderRadius: 999,
      fontSize: 11.5,
      fontWeight: 700,
      background: "#1f7a3a",
      color: "#fff"
    } }, "\u2605 Ganho"), archivedAt && /* @__PURE__ */ React.createElement("span", { style: {
      padding: "2px 10px",
      borderRadius: 999,
      fontSize: 11.5,
      fontWeight: 700,
      background: "var(--muted)",
      color: "#fff"
    } }, "Arquivado"), credito != null && /* @__PURE__ */ React.createElement(
      "span",
      {
        title: fields.tipo_opiniao_credito ? `Opini\xE3o de cr\xE9dito (${fields.tipo_opiniao_credito})` : "Limite de cr\xE9dito recomendado pela Informa",
        style: {
          padding: "2px 10px",
          borderRadius: 6,
          fontSize: 11.5,
          fontWeight: 700,
          background: "rgba(31, 122, 58, 0.12)",
          color: "#1f7a3a",
          border: "1px solid rgba(31, 122, 58, 0.25)"
        }
      },
      "Cr\xE9dito: ",
      credito.toLocaleString("pt-PT"),
      " \u20AC"
    ), volume != null && statPill(
      "vol",
      "Volume",
      fmtEurCompact(volume),
      "Volume manual no Lead, ou vendas do \xFAltimo balan\xE7o quando n\xE3o preenchido"
    ), a.vab != null && statPill(
      "vab",
      "VAB",
      fmtEurCompact(a.vab),
      "Vendas \u2212 Compras \u2212 FSE do \xFAltimo balan\xE7o"
    ), a.perfil_label && /* @__PURE__ */ React.createElement(
      "span",
      {
        key: "perfil",
        title: "Perfil derivado de Compras \xD7 Compras/Empregado (limiares em Configura\xE7\xF5es)",
        style: {
          padding: "2px 10px",
          borderRadius: 6,
          fontSize: 11.5,
          fontWeight: 700,
          ...perfilPalette,
          border: "1px solid var(--border)"
        }
      },
      a.perfil_label
    ), a.empregados != null && statPill(
      "emp",
      "Funcion\xE1rios",
      a.empregados.toLocaleString("pt-PT"),
      "N\xBA de empregados no \xFAltimo balan\xE7o"
    ), a.vendas_por_func != null && statPill(
      "vpf",
      "Vendas/Func",
      fmtEurCompact(a.vendas_por_func),
      "Vendas \xF7 Empregados do \xFAltimo balan\xE7o"
    ));
  })();
  const sidePanel = initial.id && window.HubActionTimeline ? window.React.createElement(window.HubActionTimeline, {
    streams: {
      acoes: {
        items: history,
        api: {
          onAdd: addLeadAcao,
          onDelete: deleteLeadAcao,
          onToggleTratada: toggleLeadAcaoTratada,
          onSetPrazo: setLeadAcaoPrazo
        }
      },
      notas: {
        items: notas,
        api: {
          onAdd: addLeadNota,
          onUpdate: updateLeadNota,
          onDelete: deleteLeadNota
        }
      },
      logs: { items: logs }
    },
    appSlug: "prospecao",
    users: window.SR_USERS || [],
    me: window.SR_ME || null,
    appLabel: "prospecao",
    assignable: true,
    defaultTab: "acoes"
  }) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    DrawerShell,
    {
      title,
      subtitle,
      onClose: guardedClose,
      navList,
      currentId,
      onNavigate: guardedNavigate,
      headerExtra: headerPills,
      side: sidePanel,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, initial.won_at && !initial.conta && /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          onClick: () => setConfirmConvert(true),
          disabled: converting
        },
        "Converter em Conta"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          "data-shortcut": "c",
          onClick: guardedClose
        },
        "Cancelar",
        /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "submit",
          form: formId,
          className: "btn primary sm",
          "data-shortcut": "s",
          disabled: !isDirty,
          title: isDirty ? "Guardar altera\xE7\xF5es (Alt+S)" : "Sem altera\xE7\xF5es por guardar"
        },
        "Guardar",
        /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S")
      ))
    },
    /* @__PURE__ */ React.createElement("form", { id: formId, onSubmit: submit, style: { display: "flex", flexDirection: "column", gap: 14, padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome *"), /* @__PURE__ */ React.createElement(
      "input",
      {
        value: form.name,
        onChange: (e) => set("name", e.target.value),
        required: true,
        autoFocus: !initial.id
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "NIF"), /* @__PURE__ */ React.createElement(
      "input",
      {
        value: form.nif,
        onChange: (e) => set("nif", e.target.value),
        style: { borderColor: nifValid ? void 0 : "#c4434b" },
        maxLength: 9
      }
    )), contaMatch && /* @__PURE__ */ React.createElement("div", { className: "alert warn", style: { marginTop: 6 } }, scoutContaAvisoTexto(contaMatch), contaMatch.visivel && contaMatch.id && /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        style: { marginLeft: 8 },
        onClick: () => {
          window.HubRouter.navigate({ routeId: "prospecao_contas" });
        }
      },
      "Ver conta"
    )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Setor"), /* @__PURE__ */ React.createElement("select", { value: form.sector, onChange: (e) => set("sector", e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014"), SECTORS.map((s) => /* @__PURE__ */ React.createElement("option", { key: s.id, value: s.id }, s.label)))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "CAE"), /* @__PURE__ */ React.createElement("input", { value: form.cae, onChange: (e) => set("cae", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Distrito"), /* @__PURE__ */ React.createElement("input", { value: form.district, onChange: (e) => set("district", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Concelho"), /* @__PURE__ */ React.createElement("input", { value: form.county, onChange: (e) => set("county", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { gridColumn: "span 2" } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Morada"), /* @__PURE__ */ React.createElement("input", { value: form.address, onChange: (e) => set("address", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Telefone"), /* @__PURE__ */ React.createElement("input", { value: form.phone, onChange: (e) => set("phone", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Website"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4 } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        value: form.website,
        onChange: (e) => set("website", e.target.value),
        style: { flex: 1, minWidth: 0 }
      }
    ), /* @__PURE__ */ React.createElement(
      "a",
      {
        href: form.website ? /^https?:\/\//i.test(form.website) ? form.website : `https://${form.website}` : void 0,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "btn ghost icon-only sm",
        title: "Abrir em novo separador",
        onClick: (e) => {
          if (!form.website) e.preventDefault();
        },
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          textDecoration: "none",
          pointerEvents: form.website ? "auto" : "none",
          opacity: form.website ? 1 : 0.35
        }
      },
      /* @__PURE__ */ React.createElement(Ico.external, null)
    ))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Volume anual (EUR)"), /* @__PURE__ */ React.createElement("input", { type: "number", value: form.turnover, onChange: (e) => set("turnover", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label", title: "Quanto estimamos vender por ano a esta empresa \u2014 entra no valor em pipeline do Dashboard." }, "Estimativa anual de vendas (EUR)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        value: form.vendas_estimadas_eur,
        onChange: (e) => set("vendas_estimadas_eur", e.target.value)
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Confian\xE7a"), /* @__PURE__ */ React.createElement("select", { value: form.confidence, onChange: (e) => set("confidence", e.target.value) }, Object.entries(CONFIDENCE_LABELS).map(([k, v]) => /* @__PURE__ */ React.createElement("option", { key: k, value: k }, v)))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Estado"), /* @__PURE__ */ React.createElement("select", { value: form.status, onChange: (e) => set("status", e.target.value) }, Object.entries(STATUS_LABELS).map(([k, v]) => /* @__PURE__ */ React.createElement("option", { key: k, value: k }, v)))), /* @__PURE__ */ React.createElement("div", { className: "field", style: { gridColumn: "span 2" } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Fonte (cita\xE7\xE3o)"), /* @__PURE__ */ React.createElement("input", { value: form.source, onChange: (e) => set("source", e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { gridColumn: "span 2" } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Owner"), /* @__PURE__ */ React.createElement(
      "select",
      {
        value: form.owner_id ?? "",
        disabled: !canAssign,
        title: canAssign ? "" : "Sem permiss\xE3o para reatribuir (requer action assign)",
        onChange: (e) => set("owner_id", e.target.value ? Number(e.target.value) : null)
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 Sem owner \u2014"),
      (() => {
        const HA = window.HubAtribuicoes;
        let opts = HA ? HA.eligibleUsers(users, "prospecao") : users;
        if (form.owner_id && !opts.some((u) => u.id === form.owner_id)) {
          const cur = users.find((u) => u.id === form.owner_id);
          if (cur) opts = opts.concat(cur);
        }
        return opts.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.username));
      })()
    )), initial.id && initial.created_by_username && /* @__PURE__ */ React.createElement("div", { style: {
      gridColumn: "span 2",
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontSize: 11.5,
      color: "var(--muted)"
    } }, /* @__PURE__ */ React.createElement("span", null, "Criado por"), /* @__PURE__ */ React.createElement(UserChip, { username: initial.created_by_username, size: 16 }), initial.created_at && /* @__PURE__ */ React.createElement("span", null, "\xB7 ", new Date(initial.created_at).toLocaleDateString("pt-PT")))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8, padding: "8px 0", borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 12.5 } }, "VIES:"), viesResult && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12.5, color: viesResult.status === "v\xE1lido" ? "#3a8a4d" : "#c4434b" } }, viesResult.status, viesResult.name ? ` \xB7 ${viesResult.name}` : ""), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        style: { marginLeft: "auto" },
        onClick: checkVies,
        disabled: viesLoading || !form.nif
      },
      viesLoading ? "A verificar\u2026" : "Verificar VIES"
    )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8, padding: "8px 0", borderTop: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 12.5 } }, "DBInforma:"), enrichMsg && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, enrichMsg), dbinformaFetchedAt && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "\xB7 \xDAltima atualiza\xE7\xE3o: ", new Date(dbinformaFetchedAt).toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        onClick: validateLead,
        disabled: enrichLoading || !form.nif,
        title: "Lookup company-file (gratuito)"
      },
      enrichLoading ? "\u2026" : "Validar"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        "data-shortcut": "r",
        onClick: enrichLead,
        disabled: enrichLoading || !form.nif || !initial.id,
        title: "Atualizar relat\xF3rio PLESTRUT (pago) \u2014 Alt+R"
      },
      enrichLoading ? "\u2026" : "Atualizar relat\xF3rio",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "R")
    ))), /* @__PURE__ */ React.createElement(
      window.ScoutDBInformaIndicadores,
      {
        report: enrichReport,
        indicators: dbinformaIndicators,
        onOpenFull: () => setReportModalOpen(true)
      }
    ), /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--border)", paddingTop: 8 } }, /* @__PURE__ */ React.createElement("div", { style: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 220px) minmax(0, 200px) 1fr",
      gap: 16,
      alignItems: "start"
    } }, /* @__PURE__ */ React.createElement("div", { className: "field", style: { margin: 0 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Etapa"), /* @__PURE__ */ React.createElement(
      "select",
      {
        value: form.lead_estado_id_slug,
        onChange: (e) => set("lead_estado_id_slug", e.target.value),
        style: { width: "100%" },
        disabled: leadEstados.length === 0
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 Por classificar \u2014"),
      leadEstados.filter((es) => es.is_active || es.id_slug === form.lead_estado_id_slug).map((es) => /* @__PURE__ */ React.createElement("option", { key: es.id_slug, value: es.id_slug }, es.label))
    )), /* @__PURE__ */ React.createElement("div", { className: "field", style: { margin: 0 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Classifica\xE7\xE3o"), /* @__PURE__ */ React.createElement("div", { style: { display: "inline-flex", gap: 4, marginTop: 2 } }, [
      ["", "\u2014"],
      ["A", "A"],
      ["B", "B"],
      ["C", "C"]
    ].map(([val, label]) => {
      const active = (form.tier || "") === val;
      const bg = active ? val ? tierColor(val) : "var(--muted)" : "transparent";
      const fg = active ? "#fff" : "var(--text-2)";
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: val || "_none",
          type: "button",
          onClick: () => set("tier", val),
          style: {
            padding: "4px 12px",
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            border: "1px solid var(--border)",
            background: bg,
            color: fg
          }
        },
        label
      );
    }))), /* @__PURE__ */ React.createElement("div", { className: "field", style: { margin: 0 } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Notas"), /* @__PURE__ */ React.createElement(
      "textarea",
      {
        value: form.notes,
        onChange: (e) => set("notes", e.target.value),
        rows: 5,
        style: { width: "100%", boxSizing: "border-box" }
      }
    )))), reportModalOpen && enrichReport && /* @__PURE__ */ React.createElement(
      window.LeadDBInformaModal,
      {
        report: enrichReport,
        indicators: dbinformaIndicators,
        fetchedAt: dbinformaFetchedAt,
        onClose: () => setReportModalOpen(false)
      }
    ))
  ), pendingLeave && // O fundo não fecha: sai-se por um dos três botões (pedido do João,
  // 2026-09-25 — os modais fechavam-se por engano ao carregar fora).
  /* @__PURE__ */ React.createElement("div", { style: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1100
  } }, /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: (e) => e.stopPropagation(),
      role: "dialog",
      "aria-modal": "true",
      style: {
        background: "var(--bg)",
        borderRadius: 8,
        padding: 20,
        maxWidth: 440,
        width: "90%",
        boxShadow: "0 12px 48px rgba(0, 0, 0, 0.35)",
        border: "1px solid var(--border)"
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600, marginBottom: 8 } }, "Altera\xE7\xF5es por guardar"),
    /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 13,
      color: "var(--text-2)",
      marginBottom: 18,
      lineHeight: 1.45
    } }, "Tens edi\xE7\xF5es neste lead que ainda n\xE3o foram gravadas. Se sa\xEDres agora perdes essas altera\xE7\xF5es."),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn primary sm",
        "data-shortcut": "s",
        onClick: async () => {
          const fn = pendingLeave;
          const ok = await submit({ preventDefault: () => {
          } });
          setPendingLeave(null);
          if (ok) fn();
        },
        disabled: !isDirty
      },
      "Guardar e sair",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        style: { color: "#c4434b" },
        onClick: () => {
          const fn = pendingLeave;
          setPendingLeave(null);
          fn();
        }
      },
      "Sair sem guardar"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        "data-shortcut": "c",
        onClick: () => setPendingLeave(null)
      },
      "Continuar a editar",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
    ))
  )), confirmConvert && /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Converter em Conta",
      onClose: () => setConfirmConvert(false)
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Vai ser criada a conta ", /* @__PURE__ */ React.createElement("strong", null, form.name), " com o NIF", " ", /* @__PURE__ */ React.createElement("strong", null, form.nif || "\u2014"), ", copiando identifica\xE7\xE3o, dono e os dados VIES/DBInforma. Os contactos desta lead passam para a conta, e a lead fica arquivada e s\xF3 de leitura.", !form.nif && /* @__PURE__ */ React.createElement("div", { className: "alert error", style: { marginTop: 10 } }, "A lead n\xE3o tem NIF \u2014 preenche-o antes de converter."), contaMatch && /* @__PURE__ */ React.createElement("div", { className: "alert warn", style: { marginTop: 10 } }, scoutContaAvisoTexto(contaMatch), " A lead vai ser ligada a essa conta em vez de criar uma nova.")),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        "data-shortcut": "c",
        onClick: () => setConfirmConvert(false)
      },
      "Cancelar",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn primary sm",
        disabled: !form.nif || converting,
        onClick: async () => {
          setConverting(true);
          try {
            const r = await window.ScoutAPI.converterLead(initial.id);
            setConfirmConvert(false);
            window.srToast?.(
              r.criada ? `Conta ${r.conta.name} criada.` : `Lead ligada \xE0 conta ${r.conta.name}.`,
              "success"
            );
            onClose();
          } catch (e) {
            window.srToast?.(e.message, "error");
          } finally {
            setConverting(false);
          }
        }
      },
      converting ? "A converter\u2026" : "Converter"
    ))
  ));
}
const DISTRITOS_PT = [
  "Aveiro",
  "Beja",
  "Braga",
  "Bragan\xE7a",
  "Castelo Branco",
  "Coimbra",
  "\xC9vora",
  "Faro",
  "Guarda",
  "Leiria",
  "Lisboa",
  "Portalegre",
  "Porto",
  "Santar\xE9m",
  "Set\xFAbal",
  "Viana do Castelo",
  "Vila Real",
  "Viseu",
  "Madeira",
  "A\xE7ores"
];
const SCOUT_DBINFORMA_PREVIEW_COLUNAS = [
  {
    key: "nif",
    label: "NIF",
    width: 110,
    minWidth: 95,
    fixed: true,
    mono: true,
    render: (l) => l.nif
  },
  {
    key: "nome",
    label: "Nome",
    width: 220,
    minWidth: 160,
    render: (l) => /* @__PURE__ */ React.createElement("strong", null, l.name)
  },
  {
    key: "setor",
    label: "Setor",
    width: 190,
    minWidth: 140,
    render: (l) => SECTORS.find((s) => s.id === l.sector)?.label || l.sector || "\u2014"
  },
  {
    key: "local",
    label: "Distrito \xB7 Concelho",
    width: 180,
    minWidth: 140,
    render: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-tight" }, [l.district, l.county].filter(Boolean).join(" \xB7 ") || "\u2014")
  },
  {
    key: "volume",
    label: "Volume",
    width: 100,
    minWidth: 85,
    align: "right",
    render: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, l.turnover ? `${(l.turnover / 1e6).toFixed(1)}M\u20AC` : "\u2014")
  },
  {
    key: "tier",
    label: "Tier",
    width: 70,
    minWidth: 60,
    render: (l) => /* @__PURE__ */ React.createElement("span", { className: "pill", style: {
      background: tierColor(l.tier_hint),
      color: "#fff",
      padding: "2px 8px",
      borderRadius: 10,
      fontSize: 11
    } }, l.tier_hint)
  },
  {
    key: "confianca",
    label: "Confian\xE7a",
    width: 90,
    minWidth: 80,
    render: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, CONFIDENCE_LABELS[l.confidence] || l.confidence)
  },
  {
    key: "fonte",
    label: "Fonte",
    width: 220,
    minWidth: 140,
    render: (l) => /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "td-muted",
        style: { fontSize: 11, maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis" },
        title: l.source
      },
      l.source || "\u2014"
    )
  }
];
function ScoutSearchView() {
  const [districtOptions, setDistrictOptions] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [districts, setDistricts] = useState(/* @__PURE__ */ new Set());
  const [sectors, setSectors] = useState(/* @__PURE__ */ new Set());
  const [batchSize, setBatchSize] = useState(12);
  const [manualRaw, setManualRaw] = useState("");
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    window.API.scoutDistricts().then((r) => {
      const list = (r.results || r).filter((d) => d.is_active);
      setDistrictOptions(list);
    });
    window.API.scoutSectors().then((r) => {
      const list = (r.results || r).filter((s) => s.is_active);
      setSectorOptions(list);
    });
  }, []);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(/* @__PURE__ */ new Set());
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const toggle = (set, setter, v) => {
    const n = new Set(set);
    if (n.has(v)) n.delete(v);
    else n.add(v);
    setter(n);
  };
  const phrases = React.useMemo(() => {
    if (!sectors.size || !districts.size) return [];
    const lines = [];
    for (const sectorSlug of sectors) {
      const sectorNome = sectorOptions.find((s) => s.id_slug === sectorSlug)?.nome || sectorSlug;
      for (const districtName of districts) {
        lines.push(`Entrega ${batchSize} empresas do ${sectorNome} do distrito de ${districtName}`);
      }
    }
    return lines;
  }, [sectors, districts, sectorOptions, batchSize]);
  const copyPhrases = () => {
    navigator.clipboard.writeText(phrases.join("\n"));
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  const importManual = async () => {
    if (!manualRaw.trim()) return;
    setLoading(true);
    setError(null);
    setResult(null);
    setSelected(/* @__PURE__ */ new Set());
    setImportResult(null);
    try {
      const r = await window.API.scoutImport({
        raw: manualRaw,
        districts: [...districts],
        sectors: [...sectors],
        batch_size: batchSize
      });
      setResult({
        leads: r.leads || [],
        model: r.model,
        tokens_in: 0,
        tokens_out: 0,
        web_searches: 0,
        cost_eur: 0
      });
      setSelected(new Set((r.leads || []).map((l) => l.nif)));
      if (r.warning) setError(r.warning);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  const doImport = async () => {
    if (!result?.leads?.length) return;
    setImporting(true);
    setImportResult(null);
    try {
      const items = result.leads.filter((l) => selected.has(l.nif)).map((l) => ({
        nif: l.nif,
        name: l.name,
        sector: l.sector,
        cae: l.cae,
        district: l.district,
        county: l.county,
        address: l.address,
        phone: l.phone,
        website: l.website,
        turnover: l.turnover,
        source: l.source,
        confidence: l.confidence,
        notes: l.notes,
        status: "unverified"
      }));
      const r = await window.API.bulkImportLeads(items);
      setImportResult(r);
    } catch (e) {
      setError(e.message);
    } finally {
      setImporting(false);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 1200 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "SCOUT \u2014 Pesquisar empresas"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 gera a frase para o Claude.ai e importa o CSV")), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 120px", gap: 12, alignItems: "end" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    textTransform: "uppercase",
    fontFamily: "var(--font-mono)",
    letterSpacing: "0.04em",
    marginBottom: 4
  } }, "Distritos"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 4 } }, districtOptions.map((d) => /* @__PURE__ */ React.createElement("label", { key: d.id, style: {
    fontSize: 11.5,
    padding: "3px 8px",
    borderRadius: 12,
    cursor: "pointer",
    background: districts.has(d.name) ? "var(--accent)" : "var(--bg)",
    color: districts.has(d.name) ? "#fff" : "var(--text-2)",
    border: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: districts.has(d.name),
      onChange: () => toggle(districts, setDistricts, d.name),
      style: { display: "none" }
    }
  ), d.name)))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    textTransform: "uppercase",
    fontFamily: "var(--font-mono)",
    letterSpacing: "0.04em",
    marginBottom: 4
  } }, "Setores"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 4 } }, sectorOptions.map((s) => /* @__PURE__ */ React.createElement("label", { key: s.id_slug, style: {
    fontSize: 11.5,
    padding: "3px 8px",
    borderRadius: 12,
    cursor: "pointer",
    background: sectors.has(s.id_slug) ? "var(--accent)" : "var(--bg)",
    color: sectors.has(s.id_slug) ? "#fff" : "var(--text-2)",
    border: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: sectors.has(s.id_slug),
      onChange: () => toggle(sectors, setSectors, s.id_slug),
      style: { display: "none" }
    }
  ), s.nome)))), /* @__PURE__ */ React.createElement("label", null, "Lote", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min: 1,
      max: 50,
      value: batchSize,
      onChange: (e) => setBatchSize(Number(e.target.value))
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14, marginTop: 8, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "Setores vazios = todos. NIFs j\xE1 no sistema s\xE3o exclu\xEDdos."))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    textTransform: "uppercase",
    fontFamily: "var(--font-mono)",
    letterSpacing: "0.04em",
    marginBottom: 8
  } }, "Frases para o Claude.ai"), phrases.length > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("pre", { style: {
    margin: 0,
    padding: "10px 12px",
    background: "var(--bg)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    fontFamily: "var(--font-mono)",
    fontSize: 12,
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
    maxHeight: 260,
    overflowY: "auto"
  } }, phrases.join("\n")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end", marginTop: 10 } }, /* @__PURE__ */ React.createElement("button", { className: "btn primary", onClick: copyPhrases }, copied ? "Copiado!" : "Copiar"))) : /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)" } }, "Seleciona pelo menos um setor e um distrito para gerar as frases.")), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement(ScoutManualPanel, { value: manualRaw, onChange: setManualRaw, disabled: loading }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end", marginTop: 10 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary",
      onClick: importManual,
      disabled: loading || !manualRaw.trim()
    },
    loading ? "A importar\u2026" : "Importar CSV"
  ))), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), result && /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, result.leads?.length || 0, " leads encontradas"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 modelo ", result.model, " \xB7 tokens ", result.tokens_in || 0, "/", result.tokens_out || 0), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSelected(new Set(result.leads.map((l) => l.nif))) }, "Selecionar todos"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSelected(/* @__PURE__ */ new Set()) }, "Limpar"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: doImport, disabled: importing || !selected.size }, importing ? "A importar\u2026" : `Importar ${selected.size}`))), importResult && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, fontSize: 12, color: "#3a8a4d" } }, "Importados: ", importResult.created, " \xB7 Ignorados (j\xE1 existem): ", importResult.skipped, importResult.errors?.length > 0 && ` \xB7 Erros: ${importResult.errors.length}`), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "dbinforma-previa",
      columns: SCOUT_DBINFORMA_PREVIEW_COLUNAS,
      data: result.leads || [],
      pagination: "none",
      rowKey: (l) => l.nif,
      selectable: true,
      selection: selected,
      onSelection: setSelected,
      rowStyle: (l) => selected.has(l.nif) ? void 0 : { opacity: 0.5 },
      empty: "Sem leads v\xE1lidas (NIFs n\xE3o passaram a valida\xE7\xE3o m\xF3dulo 11 ou agente devolveu vazio)."
    }
  )));
}
function ScoutManualPanel({ value, onChange, disabled }) {
  const CSV_HEADER = "NIF;Nome;Setor;CAE;Distrito;Concelho;Morada;Telefone;Website;ProdutosGJN;VolumeEUR;Tier;Fonte;Confian\xE7a";
  const CSV_EXAMPLE = "500000000;Empresa Exemplo, Lda;cosmetics;20420;Porto;Maia;Rua A, 123;220000000;exemplo.pt;Caixas, divis\xF3rias;1500000;B;dnb.com;M\xE9dia";
  return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 12 } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    textTransform: "uppercase",
    fontFamily: "var(--font-mono)",
    letterSpacing: "0.04em",
    marginBottom: 6
  } }, "CSV do Claude.ai"), /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--bg)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: "8px 10px",
    marginBottom: 8,
    fontSize: 11.5,
    color: "var(--text-2)"
  } }, /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 6 } }, /* @__PURE__ */ React.createElement("strong", null, "Formato esperado"), " \u2014 14 colunas, separador ", /* @__PURE__ */ React.createElement("code", null, ";"), " (tamb\xE9m aceita ", /* @__PURE__ */ React.createElement("code", null, ","), " e tab), cabe\xE7alho opcional."), /* @__PURE__ */ React.createElement("pre", { style: {
    margin: 0,
    padding: "8px 10px",
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 4,
    fontFamily: "var(--font-mono)",
    fontSize: 11,
    overflowX: "auto",
    whiteSpace: "pre"
  } }, CSV_HEADER, "\n", CSV_EXAMPLE), /* @__PURE__ */ React.createElement("ul", { style: { margin: "6px 0 0", paddingLeft: 18, lineHeight: 1.5 } }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Tier"), " \u2208 ", "{A, B, C}", " \xB7 ", /* @__PURE__ */ React.createElement("strong", null, "Confian\xE7a"), " \u2208 ", "{Alta, M\xE9dia, Baixa}", " \xB7", /* @__PURE__ */ React.createElement("strong", null, " VolumeEUR"), " inteiro ou vazio"), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Setor"), ": ", /* @__PURE__ */ React.createElement("code", null, "e_commerce"), ", ", /* @__PURE__ */ React.createElement("code", null, "construction"), ", ", /* @__PURE__ */ React.createElement("code", null, "cosmetics"), ",", /* @__PURE__ */ React.createElement("code", null, " health_sport"), ", ", /* @__PURE__ */ React.createElement("code", null, "hardware_it"), ", ", /* @__PURE__ */ React.createElement("code", null, "home_equip"), ",", /* @__PURE__ */ React.createElement("code", null, " light_mfg"), ", ", /* @__PURE__ */ React.createElement("code", null, "transports"), " (tamb\xE9m aceita os nomes em ingl\xEAs)."), /* @__PURE__ */ React.createElement("li", null, "Campos sem dado \u2192 ", /* @__PURE__ */ React.createElement("code", null, "N/D"), ". NIFs inv\xE1lidos (mod-11) s\xE3o descartados."))), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      value,
      onChange: (e) => onChange(e.target.value),
      disabled,
      placeholder: "Cola aqui o CSV gerado no Claude.ai\u2026",
      style: {
        width: "100%",
        minHeight: 220,
        padding: 10,
        fontSize: 12,
        fontFamily: "var(--font-mono)",
        border: "1px solid var(--border)",
        borderRadius: 6,
        resize: "vertical",
        boxSizing: "border-box"
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 6 } }, "O parser aceita texto \xE0 volta e blocos ```csv```."));
}
function ScoutStatsView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [openQuery, setOpenQuery] = useState(null);
  const reload = async () => {
    setError(null);
    try {
      setData(await window.API.scoutStats());
    } catch (e) {
      setError(e.message);
    }
  };
  useEffect(() => {
    reload();
  }, []);
  if (error) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "#c4434b" } }, error);
  if (!data) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026");
  const t = data.totals, m = data.this_month, h = data.today;
  const fmtEur = (v) => `${(v || 0).toFixed(2)} \u20AC`;
  const fmtN = (v) => (v || 0).toLocaleString("pt-PT");
  const HISTORICO_COLUNAS = [
    {
      key: "created_at",
      label: "Quando",
      width: 170,
      minWidth: 150,
      fixed: true,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 11 } }, new Date(r.created_at).toLocaleString("pt-PT"))
    },
    {
      key: "created_by__username",
      label: "User",
      width: 120,
      minWidth: 100,
      mono: true,
      render: (r) => r.created_by__username || "\u2014"
    },
    {
      key: "districts",
      label: "Distritos",
      width: 170,
      minWidth: 130,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-tight", style: { fontSize: 11 } }, (r.districts || []).join(", ") || "\u2014")
    },
    {
      key: "sectors",
      label: "Setores",
      width: 170,
      minWidth: 130,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-tight", style: { fontSize: 11 } }, (r.sectors || []).join(", ") || "todos")
    },
    {
      key: "batch_size",
      label: "Lote",
      width: 65,
      minWidth: 55,
      align: "right",
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, r.batch_size)
    },
    {
      key: "leads_returned",
      label: "Leads",
      width: 65,
      minWidth: 55,
      align: "right",
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, r.leads_returned)
    },
    {
      key: "tokens",
      label: "Tokens (in/out)",
      width: 150,
      minWidth: 130,
      align: "right",
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted", style: { fontSize: 11 } }, fmtN(r.tokens_in), " / ", fmtN(r.tokens_out))
    },
    {
      key: "web_searches",
      label: "Web",
      width: 60,
      minWidth: 50,
      align: "right",
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, r.web_searches)
    },
    {
      key: "cost_eur",
      label: "Custo",
      width: 90,
      minWidth: 75,
      align: "right",
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, fmtEur(r.cost_eur))
    },
    {
      key: "error",
      label: "Erro",
      width: 220,
      minWidth: 140,
      render: (r) => /* @__PURE__ */ React.createElement("span", { style: { color: "#c4434b", fontSize: 11, maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis" } }, r.error ? r.error.slice(0, 40) + "\u2026" : "")
    }
  ];
  const w = 800, hgt = 200, padL = 40, padR = 16, padT = 14, padB = 28;
  const innerW = w - padL - padR, innerH = hgt - padT - padB;
  const slot = innerW / data.daily.length;
  const maxCount = Math.max(1, ...data.daily.map((d) => d.count));
  const maxCost = Math.max(0.5, ...data.daily.map((d) => d.cost_eur));
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, width: "100%", boxSizing: "border-box" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "SCOUT \u2014 Estat\xEDsticas"), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      "data-shortcut": "r",
      style: { marginLeft: "auto" },
      onClick: reload
    },
    /* @__PURE__ */ React.createElement(Ico.refresh, null),
    " Atualizar",
    /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "R")
  )), /* @__PURE__ */ React.createElement("div", { className: "m-kpi4", style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 16 } }, [
    { label: "Pesquisas (total)", value: fmtN(t.count), sub: `${fmtN(m.count)} este m\xEAs \xB7 ${fmtN(h.count)} hoje` },
    { label: "Custo (total)", value: fmtEur(t.cost_eur), sub: `${fmtEur(m.cost_eur)} este m\xEAs \xB7 ${fmtEur(h.cost_eur)} hoje` },
    { label: "Tokens IN", value: fmtN(t.tokens_in), sub: `OUT: ${fmtN(t.tokens_out)}` },
    { label: "Leads geradas", value: fmtN(t.leads_returned), sub: `${fmtN(t.web_searches)} web searches` }
  ].map((k, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: {
    padding: 14,
    background: "var(--panel)",
    borderRadius: "var(--radius)",
    border: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em"
  } }, k.label), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 600, marginTop: 4, fontVariantNumeric: "tabular-nums" } }, k.value), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: "var(--muted)", marginTop: 4 } }, k.sub)))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Evolu\xE7\xE3o \xB7 \xFAltimos 30 dias"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 barras: n\xBA pesquisas \xB7 linha: custo \u20AC")), /* @__PURE__ */ React.createElement("div", { style: { padding: 12, overflowX: "auto" } }, /* @__PURE__ */ React.createElement("svg", { width: w, height: hgt, viewBox: `0 0 ${w} ${hgt}`, style: { display: "block", maxWidth: "100%" } }, [0, 0.5, 1].map((p) => {
    const y = padT + innerH - p * innerH;
    return /* @__PURE__ */ React.createElement(
      "line",
      {
        key: p,
        x1: padL,
        y1: y,
        x2: w - padR,
        y2: y,
        stroke: "var(--border)",
        strokeDasharray: p === 0 ? "0" : "2 3"
      }
    );
  }), data.daily.map((d, i) => {
    const x = padL + i * slot;
    const bh = d.count / maxCount * innerH;
    return /* @__PURE__ */ React.createElement(
      "rect",
      {
        key: i,
        x: x + 2,
        y: padT + innerH - bh,
        width: slot - 4,
        height: bh,
        fill: "var(--accent)",
        opacity: "0.7"
      },
      /* @__PURE__ */ React.createElement("title", null, d.date, ": ", d.count, " pesquisas \xB7 ", (d.cost_eur || 0).toFixed(3), " \u20AC")
    );
  }), /* @__PURE__ */ React.createElement(
    "polyline",
    {
      fill: "none",
      stroke: "#c4434b",
      strokeWidth: "1.8",
      points: data.daily.map((d, i) => {
        const x = padL + i * slot + slot / 2;
        const y = padT + innerH - d.cost_eur / maxCost * innerH;
        return `${x},${y}`;
      }).join(" ")
    }
  ), /* @__PURE__ */ React.createElement("text", { x: padL, y: hgt - 8, fontSize: "10", fill: "var(--muted)", fontFamily: "var(--font-mono)" }, data.daily[0]?.date.slice(5)), /* @__PURE__ */ React.createElement("text", { x: w - padR, y: hgt - 8, fontSize: "10", fill: "var(--muted)", fontFamily: "var(--font-mono)", textAnchor: "end" }, data.daily.at(-1)?.date.slice(5))))), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "\xDAltimas pesquisas")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "dbinforma-historico",
      columns: HISTORICO_COLUNAS,
      data: data.recent,
      pagination: "none",
      rowKey: (r) => r.id,
      onRowClick: (r) => r.leads_returned > 0 && setOpenQuery(r),
      rowStyle: (r) => r.leads_returned > 0 ? void 0 : { cursor: "default" },
      empty: "Sem pesquisas registadas ainda."
    }
  )), openQuery && /* @__PURE__ */ React.createElement(
    ScoutQueryDrawer,
    {
      queryId: openQuery.id,
      onClose: () => setOpenQuery(null)
    }
  ));
}
function ScoutQueryDrawer({ queryId, onClose }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(/* @__PURE__ */ new Set());
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [showRaw, setShowRaw] = useState(false);
  useEffect(() => {
    window.API.scoutQueryLeads(queryId).then((d) => {
      setData(d);
      setSelected(new Set((d.leads || []).map((l) => l.nif)));
    }).catch((e) => setError(e.message));
  }, [queryId]);
  const doImport = async () => {
    if (!data?.leads?.length) return;
    setImporting(true);
    setImportResult(null);
    try {
      const items = data.leads.filter((l) => selected.has(l.nif)).map((l) => ({
        nif: l.nif,
        name: l.name,
        sector: l.sector,
        cae: l.cae,
        district: l.district,
        county: l.county,
        address: l.address,
        phone: l.phone,
        website: l.website,
        turnover: l.turnover,
        source: l.source,
        confidence: l.confidence,
        notes: l.notes,
        status: "unverified"
      }));
      setImportResult(await window.API.bulkImportLeads(items));
    } catch (e) {
      setError(e.message);
    } finally {
      setImporting(false);
    }
  };
  return /* @__PURE__ */ React.createElement(
    DrawerShell,
    {
      title: `Pesquisa #${queryId}`,
      subtitle: data ? `${new Date(data.created_at).toLocaleString("pt-PT")} \xB7 ${data.model}` : null,
      onClose,
      bodyStyle: { padding: 14 }
    },
    error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error),
    !data && !error && /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026"),
    data && /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflow: "auto" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 10 } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12 } }, /* @__PURE__ */ React.createElement("strong", null, data.leads.length), " leads \xB7 custo ", (data.cost_eur || 0).toFixed(3), " \u20AC"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "Distritos: ", (data.districts || []).join(", ") || "\u2014", " \xB7 Setores: ", (data.sectors || []).join(", ") || "todos"), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 6 } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSelected(new Set(data.leads.map((l) => l.nif))) }, "Selecionar todos"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setSelected(/* @__PURE__ */ new Set()) }, "Limpar"), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        "data-shortcut": "s",
        onClick: doImport,
        disabled: importing || !selected.size
      },
      importing ? "\u2026" : `Importar ${selected.size}`,
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S")
    ))), importResult && /* @__PURE__ */ React.createElement("div", { style: {
      padding: 10,
      fontSize: 12,
      marginBottom: 8,
      color: importResult.errors?.length ? "#c4434b" : "#3a8a4d"
    } }, "Importados: ", importResult.created, " \xB7 Ignorados (j\xE1 existem): ", importResult.skipped, importResult.errors?.length > 0 && /* @__PURE__ */ React.createElement("details", { style: { marginTop: 4 } }, /* @__PURE__ */ React.createElement("summary", null, importResult.errors.length, " erros (clica)"), /* @__PURE__ */ React.createElement("ul", { style: { margin: 4, paddingLeft: 16, fontSize: 11 } }, importResult.errors.map((e, i) => /* @__PURE__ */ React.createElement("li", { key: i }, e.nif, ": ", JSON.stringify(e.errors)))))), (data.error || data.raw_response) && /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setShowRaw((s) => !s) }, showRaw ? "Esconder" : "Ver", " resposta do modelo (debug)"), data.error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12, marginTop: 4 } }, "Erro: ", data.error), showRaw && /* @__PURE__ */ React.createElement("pre", { style: {
      background: "var(--bg)",
      border: "1px solid var(--border)",
      padding: 10,
      borderRadius: 6,
      fontSize: 11,
      lineHeight: 1.4,
      maxHeight: 320,
      overflow: "auto",
      marginTop: 6,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      fontFamily: "var(--font-mono)"
    } }, data.raw_response || "(sem raw response guardado)")), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "prospecao",
        viewId: "dbinforma-cache",
        columns: SCOUT_DBINFORMA_PREVIEW_COLUNAS.filter((c) => c.key !== "confianca"),
        data: data.leads,
        pagination: "none",
        rowKey: (l) => l.nif,
        selectable: true,
        selection: selected,
        onSelection: setSelected,
        rowStyle: (l) => selected.has(l.nif) ? void 0 : { opacity: 0.5 }
      }
    ))
  );
}
function DBInformaIndicatorsView() {
  const [indicators, setIndicators] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    Promise.all([
      window.API.dbinformaIndicators(),
      fetch("/api/prospecao/settings/", { credentials: "same-origin" }).then((r) => r.ok ? r.json() : null).catch(() => null)
    ]).then(([inds, s]) => {
      setIndicators(inds.results || []);
      setSettings(s);
    }).catch((e) => setError(e.message)).finally(() => setLoading(false));
  }, []);
  const directionLabel = {
    higher: "\u2191 maior \xE9 melhor",
    lower: "\u2193 menor \xE9 melhor",
    none: "\u2014 sem dire\xE7\xE3o"
  };
  const kindLabel = {
    pct: "Percentagem",
    eur: "Euros",
    int: "Num\xE9rico",
    rating: "Rating",
    text: "Texto"
  };
  const colorPalette = {
    green: { bg: "#e8f6ec", fg: "#1f7a3a", border: "#bce0c6" },
    amber: { bg: "#fff4e0", fg: "#9a6d12", border: "#f0d9aa" },
    red: { bg: "#fce8e8", fg: "#a82a2a", border: "#f0bcbc" },
    neutral: { bg: "transparent", fg: "var(--muted)", border: "var(--border)" }
  };
  const Pill = ({ color, children }) => {
    const p = colorPalette[color] || colorPalette.neutral;
    return /* @__PURE__ */ React.createElement("span", { style: {
      display: "inline-block",
      padding: "1px 8px",
      borderRadius: 999,
      fontSize: 11.5,
      fontWeight: 600,
      background: p.bg,
      color: p.fg,
      border: `1px solid ${p.border}`
    } }, children);
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: "min(100%, 1600px)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Indicadores DBInforma"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 refer\xEAncia de cada indicador surfaceado no detalhe da Lead")), /* @__PURE__ */ React.createElement("div", { style: {
    padding: 12,
    marginBottom: 16,
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    fontSize: 12.5,
    lineHeight: 1.5
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 600, marginBottom: 4 } }, "Como ler as cores"), "Verde = bom \xB7 \xC2mbar = aten\xE7\xE3o \xB7 Vermelho = preocupante \xB7 Cinza = neutro/sem dados. Os umbrais e mapeamentos por valor podem ser ajustados em ", /* @__PURE__ */ React.createElement("em", null, "Django Admin \u2192 Indicadores DBInforma"), "."), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12 } }, error), loading && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), settings && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 14,
    marginBottom: 16,
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 8
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 10,
    flexWrap: "wrap"
  } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 13 } }, "Configura\xE7\xF5es activas \u2014 Score de interesse"), /* @__PURE__ */ React.createElement("span", { style: {
    marginLeft: "auto",
    fontSize: 11.5,
    color: "var(--muted)",
    fontStyle: "italic"
  } }, "Edit\xE1veis em ", /* @__PURE__ */ React.createElement("strong", null, "Configura\xE7\xF5es \u2192 Prospe\xE7\xE3o"), " (sidebar).")), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "6px 18px",
    fontSize: 12.5
  } }, [
    ['Compras "alto" (\u20AC)', Number(settings.compras_alto_threshold_eur).toLocaleString("pt-PT")],
    ['Compras/Empregado "alto" (\u20AC)', Number(settings.compras_por_func_alto_eur).toLocaleString("pt-PT")],
    ["Cap do score (\u20AC)", Number(settings.score_compras_cap_eur).toLocaleString("pt-PT")],
    ["Peso \u2014 Transforma\xE7\xE3o", settings.peso_transformacao],
    ["Peso \u2014 Revenda", settings.peso_revenda],
    ["Peso \u2014 Servi\xE7os", settings.peso_servicos],
    ["Peso \u2014 Indefinido", settings.peso_indefinido],
    ["Banda Alto \u2265", settings.score_alto_threshold],
    ["Banda M\xE9dio \u2265", settings.score_medio_threshold]
  ].map(([k, v]) => /* @__PURE__ */ React.createElement("div", { key: k, style: {
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    borderBottom: "1px dashed var(--border)",
    padding: "3px 0"
  } }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, k), /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 500 } }, v))))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 14 } }, indicators.map((ind) => /* @__PURE__ */ React.createElement("div", { key: ind.field_key, style: {
    padding: 14,
    background: "var(--panel)",
    border: "1px solid var(--border)",
    borderRadius: 8
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("strong", { style: { fontSize: 14 } }, ind.label), /* @__PURE__ */ React.createElement("span", { className: "td-mono", style: { fontSize: 11, color: "var(--muted)" } }, ind.field_key), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "\xB7"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5 } }, kindLabel[ind.kind] || ind.kind), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "\xB7"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5 } }, directionLabel[ind.direction] || ind.direction)), ind.scale_legend && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: "var(--text-2)", marginTop: 6 } }, ind.scale_legend), ["pct", "eur", "int"].includes(ind.kind) && (ind.threshold_amber != null || ind.threshold_red != null) && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap", fontSize: 12 } }, ind.direction === "higher" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Pill, { color: "red" }, "< ", ind.threshold_red), /* @__PURE__ */ React.createElement(Pill, { color: "amber" }, ind.threshold_red, " \u2013 ", ind.threshold_amber), /* @__PURE__ */ React.createElement(Pill, { color: "green" }, "\u2265 ", ind.threshold_amber)) : ind.direction === "lower" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Pill, { color: "green" }, "\u2264 ", ind.threshold_amber), /* @__PURE__ */ React.createElement(Pill, { color: "amber" }, ind.threshold_amber, " \u2013 ", ind.threshold_red), /* @__PURE__ */ React.createElement(Pill, { color: "red" }, "> ", ind.threshold_red)) : /* @__PURE__ */ React.createElement(Pill, { color: "neutral" }, "Sem cor (informativo)")), ind.kind === "rating" && Object.keys(ind.color_map || {}).length > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", flexWrap: "wrap", gap: 4 } }, Object.entries(ind.color_map).map(([value, color]) => /* @__PURE__ */ React.createElement(Pill, { key: value, color }, value))), ind.kind === "eur" && ind.direction === "none" && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, fontSize: 11.5, color: "var(--muted)", fontStyle: "italic" } }, 'Sem cor: o valor \xE9 apresentado em \u20AC sem colora\xE7\xE3o (\xE9 informativo, n\xE3o tem "bom/mau").'), (ind.formula || ind.xml_source) && /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 12,
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
    gap: 12
  } }, ind.formula && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    fontWeight: 600,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    marginBottom: 4
  } }, "F\xF3rmula"), /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12,
    color: "var(--text-2)",
    whiteSpace: "pre-wrap",
    lineHeight: 1.5
  } }, ind.formula)), ind.xml_source && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    fontWeight: 600,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    marginBottom: 4
  } }, "Origem no XML"), /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11.5,
    color: "var(--text-2)",
    whiteSpace: "pre-wrap",
    lineHeight: 1.5,
    fontFamily: "var(--font-mono)"
  } }, ind.xml_source)))))));
}
window.ProspecaoApp = ProspecaoApp;
window.ScoutSearchView = ScoutSearchView;
window.ScoutStatsView = ScoutStatsView;
function ProspecaoSettingsField({ label, value, onChange, hint }) {
  return /* @__PURE__ */ React.createElement("label", { style: { display: "grid", gap: 4 } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5, color: "var(--muted)" } }, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: value ?? "",
      onChange: (e) => onChange(e.target.value),
      style: {
        padding: "6px 8px",
        border: "1px solid var(--border)",
        borderRadius: 4,
        fontSize: 13
      }
    }
  ), hint && /* @__PURE__ */ React.createElement("span", { style: {
    fontSize: 11,
    color: "var(--muted)",
    fontStyle: "italic"
  } }, hint));
}
function ProspecaoSettingsView() {
  const [form, setForm] = useState(null);
  const [saved, setSaved] = useState(null);
  const [preview, setPreview] = useState(null);
  const [savingState, setSavingState] = useState("idle");
  const [err, setErr] = useState("");
  useEffect(() => {
    fetch("/api/prospecao/settings/", { credentials: "same-origin" }).then((r) => r.json()).then((d) => {
      setForm(d);
      setSaved(d);
    });
  }, []);
  useEffect(() => {
    if (!form) return;
    const id = setTimeout(() => {
      fetch("/api/prospecao/settings/preview/", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": document.cookie.match(/csrftoken=([^;]+)/)?.[1] || ""
        },
        body: JSON.stringify(form)
      }).then((r) => r.ok ? r.json() : null).then(setPreview);
    }, 300);
    return () => clearTimeout(id);
  }, [form]);
  if (!form) return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, color: "var(--muted)" } }, "A carregar\u2026");
  const update = (k, v) => setForm({ ...form, [k]: v });
  const onSave = () => {
    setSavingState("saving");
    setErr("");
    fetch("/api/prospecao/settings/", {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": document.cookie.match(/csrftoken=([^;]+)/)?.[1] || ""
      },
      body: JSON.stringify(form)
    }).then(async (r) => {
      const d = await r.json();
      if (!r.ok) throw new Error(JSON.stringify(d));
      setSaved(d);
      setForm(d);
      setSavingState("ok");
      setTimeout(() => setSavingState("idle"), 2e3);
    }).catch((e) => {
      setErr(e.message);
      setSavingState("err");
    });
  };
  const PERFIL_COLOR = {
    transformacao: "#1f7a3a",
    revenda: "#22518c",
    servicos: "var(--muted)",
    indefinido: "var(--muted)"
  };
  const previewColumns = [
    {
      key: "nome",
      label: "Lead",
      width: 200,
      minWidth: 150,
      render: (l) => /* @__PURE__ */ React.createElement("span", { title: l.nome }, l.nome)
    },
    {
      key: "compras",
      label: "Compras",
      align: "right",
      mono: true,
      width: 145,
      minWidth: 120,
      render: (l) => l.compras == null ? "\u2014" : `${(l.compras / 1e3).toLocaleString("pt-PT")} K\u20AC`
    },
    {
      key: "empregados",
      label: "Empregados",
      align: "right",
      mono: true,
      width: 118,
      minWidth: 106,
      render: (l) => l.empregados ?? "\u2014"
    },
    {
      key: "perfil_label",
      label: "Perfil",
      width: 138,
      minWidth: 118,
      render: (l) => /* @__PURE__ */ React.createElement("span", { style: { color: PERFIL_COLOR[l.perfil] } }, l.perfil_label)
    },
    { key: "score", label: "Score", align: "right", mono: true, width: 80, minWidth: 70 },
    { key: "band", label: "Banda", width: 90, minWidth: 80 }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: 20,
    maxWidth: "min(100%, 1600px)",
    display: "grid",
    gridTemplateColumns: "minmax(0, 360px) minmax(0, 1fr)",
    gap: 24,
    alignItems: "start"
  } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", { style: { margin: "0 0 14px", fontSize: 16 } }, "Configura\xE7\xF5es \u2014 Score de interesse"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", marginBottom: 14 } }, "Edita os limiares e pesos do score. O painel \xE0 direita mostra como ficam os leads em cache em tempo real."), /* @__PURE__ */ React.createElement("fieldset", { style: {
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: 12,
    marginBottom: 12
  } }, /* @__PURE__ */ React.createElement("legend", { style: { fontSize: 11.5, padding: "0 6px", color: "var(--muted)" } }, "Limiares de perfil"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 10 } }, /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: 'Compras "alto" (\u20AC)',
      value: form.compras_alto_threshold_eur,
      onChange: (v) => update("compras_alto_threshold_eur", v)
    }
  ), /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: 'Compras/Empregado "alto" (\u20AC)',
      value: form.compras_por_func_alto_eur,
      onChange: (v) => update("compras_por_func_alto_eur", v)
    }
  ))), /* @__PURE__ */ React.createElement("fieldset", { style: {
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: 12,
    marginBottom: 12
  } }, /* @__PURE__ */ React.createElement("legend", { style: { fontSize: 11.5, padding: "0 6px", color: "var(--muted)" } }, "Pesos do score"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 10 } }, /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: "Peso \u2014 Transforma\xE7\xE3o",
      value: form.peso_transformacao,
      onChange: (v) => update("peso_transformacao", v)
    }
  ), /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: "Peso \u2014 Revenda",
      value: form.peso_revenda,
      onChange: (v) => update("peso_revenda", v)
    }
  ), /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: "Peso \u2014 Servi\xE7os",
      value: form.peso_servicos,
      onChange: (v) => update("peso_servicos", v)
    }
  ), /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: "Peso \u2014 Indefinido",
      value: form.peso_indefinido,
      onChange: (v) => update("peso_indefinido", v)
    }
  ))), /* @__PURE__ */ React.createElement("fieldset", { style: {
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: 12,
    marginBottom: 14
  } }, /* @__PURE__ */ React.createElement("legend", { style: { fontSize: 11.5, padding: "0 6px", color: "var(--muted)" } }, "Escala do score"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 10 } }, /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: "Cap de compras (\u20AC)",
      value: form.score_compras_cap_eur,
      onChange: (v) => update("score_compras_cap_eur", v),
      hint: "Compras a partir das quais o size_score satura em 100."
    }
  ), /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: "Banda Alto \u2265",
      value: form.score_alto_threshold,
      onChange: (v) => update("score_alto_threshold", v)
    }
  ), /* @__PURE__ */ React.createElement(
    ProspecaoSettingsField,
    {
      label: "Banda M\xE9dio \u2265",
      value: form.score_medio_threshold,
      onChange: (v) => update("score_medio_threshold", v)
    }
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn primary",
      disabled: savingState === "saving",
      onClick: onSave
    },
    savingState === "saving" ? "A guardar\u2026" : savingState === "ok" ? "Guardado \u2713" : savingState === "err" ? "Erro \u2014 tentar de novo" : "Guardar"
  ), err && /* @__PURE__ */ React.createElement("div", { style: {
    color: "#c4434b",
    fontSize: 12,
    marginTop: 8,
    whiteSpace: "pre-wrap"
  } }, err), saved?.updated_at && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 10 } }, "\xDAltima edi\xE7\xE3o: ", new Date(saved.updated_at).toLocaleString("pt-PT"), saved.updated_by_username && ` por ${saved.updated_by_username}`)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { style: { margin: "0 0 10px", fontSize: 14 } }, "Pr\xE9-visualiza\xE7\xE3o sobre leads em cache"), !preview && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", fontSize: 12 } }, "A calcular\u2026"), preview && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 14, marginBottom: 14, flexWrap: "wrap" } }, [
    ["Transforma\xE7\xE3o", preview.counts.transformacao],
    ["Revenda", preview.counts.revenda],
    ["Servi\xE7os", preview.counts.servicos],
    ["Indefinido", preview.counts.indefinido]
  ].map(([label, n]) => /* @__PURE__ */ React.createElement("div", { key: label, style: {
    padding: "6px 12px",
    border: "1px solid var(--border)",
    borderRadius: 6,
    fontSize: 12.5
  } }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, label, ": "), /* @__PURE__ */ React.createElement("strong", null, n)))), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "settings-preview-leads",
      columns: previewColumns,
      data: preview.leads,
      pagination: "client",
      rowKey: (l) => l.lead_id,
      empty: "Sem leads em cache."
    }
  ))));
}
window.ProspecaoSettingsView = ProspecaoSettingsView;
function ProspecaoEstadosView() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [draft, setDraft] = useState({
    id_slug: "",
    label: "",
    color: "#9aa3ad",
    ordem: 100,
    is_folded: false,
    is_active: true
  });
  const [saving, setSaving] = useState(false);
  const [editingSlug, setEditingSlug] = useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await LEAD_ESTADOS_API.list();
      setItems(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const startEdit = (it) => {
    setEditingSlug(it.id_slug);
    setDraft({ ...it });
  };
  const cancelEdit = () => {
    setEditingSlug(null);
    setDraft({
      id_slug: "",
      label: "",
      color: "#9aa3ad",
      ordem: 100,
      is_folded: false,
      is_active: true
    });
  };
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = { ...draft, ordem: Number(draft.ordem) || 100 };
      if (editingSlug) {
        await LEAD_ESTADOS_API.update(editingSlug, payload);
      } else {
        if (!payload.id_slug || !payload.label) {
          throw new Error("Slug e Label s\xE3o obrigat\xF3rios.");
        }
        await LEAD_ESTADOS_API.create(payload);
      }
      cancelEdit();
      await load();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };
  const remove = async (slug) => {
    if (!await window.hubConfirm({ message: `Apagar o estado "${slug}"? As leads neste estado ficam sem etapa.` })) return;
    try {
      await LEAD_ESTADOS_API.remove(slug);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const ESTADOS_COLUNAS = [
    {
      key: "ordem",
      label: "Ordem",
      width: 70,
      minWidth: 60,
      align: "right",
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, it.ordem)
    },
    {
      key: "label",
      label: "Label",
      width: 160,
      minWidth: 120,
      render: (it) => /* @__PURE__ */ React.createElement("span", { style: {
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        color: "#fff",
        background: it.color || "#9aa3ad"
      } }, it.label)
    },
    {
      key: "id_slug",
      label: "Slug",
      width: 150,
      minWidth: 110,
      mono: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, it.id_slug)
    },
    {
      key: "color",
      label: "Cor",
      width: 60,
      minWidth: 55,
      render: (it) => /* @__PURE__ */ React.createElement("span", { style: {
        display: "inline-block",
        width: 18,
        height: 18,
        borderRadius: 4,
        background: it.color || "#9aa3ad",
        border: "1px solid var(--border)"
      } })
    },
    {
      key: "is_folded",
      label: "Folded",
      width: 70,
      minWidth: 60,
      render: (it) => it.is_folded ? "Sim" : "\u2014"
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 70,
      minWidth: 60,
      render: (it) => it.is_active ? "Sim" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 150,
      minWidth: 130,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => startEdit(it) }, "Editar"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => remove(it.id_slug),
          style: { marginLeft: 6, color: "#c4434b" }
        },
        "Apagar"
      ))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 900 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: "0 0 14px", fontSize: 16, fontWeight: 600 } }, "Estados da Lead"), /* @__PURE__ */ React.createElement("p", { style: { margin: "0 0 14px", fontSize: 12.5, color: "var(--muted)" } }, "Pipeline interno da prospe\xE7\xE3o (independente do estado da empresa devolvido pela DBInforma). A propriedade ", /* @__PURE__ */ React.createElement("em", null, "Folded"), " controla se a coluna do Kanban fica colapsada por defeito."), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12, marginBottom: 10 } }, error), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "admin-lead-estados",
      columns: ESTADOS_COLUNAS,
      data: items,
      pagination: "none",
      rowKey: (it) => it.id_slug,
      empty: "Ainda sem estados configurados."
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, marginBottom: 10 } }, editingSlug ? `Editar "${editingSlug}"` : "Novo estado"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 80px 60px", gap: 10, alignItems: "end" } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Label"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.label,
      onChange: (e) => setDraft({ ...draft, label: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Slug"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.id_slug,
      disabled: !!editingSlug,
      onChange: (e) => setDraft({ ...draft, id_slug: e.target.value }),
      placeholder: "ex: contactada"
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Ordem"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.ordem,
      onChange: (e) => setDraft({ ...draft, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Cor"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "color",
      value: draft.color || "#9aa3ad",
      onChange: (e) => setDraft({ ...draft, color: e.target.value }),
      style: { width: "100%", height: 32, padding: 0 }
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 16, marginTop: 10, fontSize: 12.5, alignItems: "center" } }, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 5 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_folded,
      onChange: (e) => setDraft({ ...draft, is_folded: e.target.checked })
    }
  ), "Folded (Kanban colapsado)"), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 5 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_active,
      onChange: (e) => setDraft({ ...draft, is_active: e.target.checked })
    }
  ), "Ativo"), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 6 } }, editingSlug && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", "data-shortcut": "c", onClick: cancelEdit }, "Cancelar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      "data-shortcut": "s",
      onClick: save,
      disabled: saving
    },
    saving ? "A guardar\u2026" : editingSlug ? "Guardar" : "Adicionar",
    /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S")
  )))));
}
window.ProspecaoEstadosView = ProspecaoEstadosView;
function reconcileFullLoad(full, pendingMoves, leadEstados) {
  if (!pendingMoves || pendingMoves.size === 0) return full;
  return full.map((l) => {
    if (!pendingMoves.has(l.id)) return l;
    const slug = pendingMoves.get(l.id);
    const est = leadEstados.find((e) => e.id_slug === slug) || null;
    return { ...l, lead_estado: est };
  });
}
window.reconcileFullLoad = reconcileFullLoad;
function ProspecaoKanbanView({ registerLeaveGuard } = {}) {
  const [leads, setLeads] = useState([]);
  const [leadEstados, setLeadEstados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [counts, setCounts] = useState({});
  const [phase2Loading, setPhase2Loading] = useState(false);
  const pendingMovesRef = useRef(/* @__PURE__ */ new Map());
  const [foldedToggle, setFoldedToggle] = useState(/* @__PURE__ */ new Set());
  const [editing, setEditing] = useState(null);
  const [includeAll, setIncludeAll] = useState(false);
  const [query, setQuery] = useState("");
  const [dragOverSlug, setDragOverSlug] = useState(null);
  const draggingIdRef = useRef(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    const fullParams = { card: "1", limit: 1e3, ...includeAll ? { include_all: "1" } : {} };
    let board = null;
    try {
      const q = includeAll ? "?include_all=1" : "";
      board = await apiReq(`/api/prospecao/leads/board/${q}`);
    } catch (e) {
    }
    if (!board) {
      try {
        const r = await window.API.leads(fullParams);
        setLeads(r.results || r);
      } catch (e2) {
        setError(e2.message);
      } finally {
        setLoading(false);
      }
      return;
    }
    setCounts(board.counts || {});
    setLeads(board.cards || []);
    setLoading(false);
    setPhase2Loading(true);
    try {
      const r = await window.API.leads(fullParams);
      const full = r.results || r;
      setLeads(reconcileFullLoad(full, pendingMovesRef.current, leadEstados));
    } catch (e2) {
      setError(e2.message);
    } finally {
      setPhase2Loading(false);
    }
  };
  useEffect(() => {
    load();
  }, [includeAll]);
  useEffect(() => {
    LEAD_ESTADOS_API.list().then((r) => setLeadEstados((r.results || r).filter((e) => e.is_active))).catch(() => {
    });
  }, []);
  const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  const filteredLeads = useMemo(() => {
    const q = norm(query).trim();
    if (!q) return leads;
    return leads.filter((l) => norm(l.name).includes(q) || norm(l.nif).includes(q) || norm(l.district).includes(q));
  }, [leads, query]);
  const grouped = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    m.set("_unset", []);
    leadEstados.forEach((e) => m.set(e.id_slug, []));
    filteredLeads.forEach((l) => {
      const slug = l.lead_estado?.id_slug || "_unset";
      if (!m.has(slug)) m.set(slug, []);
      m.get(slug).push(l);
    });
    return m;
  }, [filteredLeads, leadEstados]);
  const isFolded = (slug, defaultFolded) => {
    const flipped = foldedToggle.has(slug);
    return flipped ? !defaultFolded : defaultFolded;
  };
  const toggleFold = (slug) => setFoldedToggle((prev) => {
    const next = new Set(prev);
    if (next.has(slug)) next.delete(slug);
    else next.add(slug);
    return next;
  });
  const onDragStart = (e, leadId) => {
    draggingIdRef.current = leadId;
    e.dataTransfer.effectAllowed = "move";
    try {
      e.dataTransfer.setData("text/plain", String(leadId));
    } catch (_) {
    }
  };
  const onDragOver = (e, slug) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (dragOverSlug !== slug) setDragOverSlug(slug);
  };
  const onDragLeave = (slug) => {
    if (dragOverSlug === slug) setDragOverSlug(null);
  };
  const onDrop = async (slug) => {
    setDragOverSlug(null);
    const id = draggingIdRef.current;
    draggingIdRef.current = null;
    if (!id) return;
    const target = slug === "_unset" ? null : slug;
    const lead = leads.find((l) => l.id === id);
    if (lead && (lead.lead_estado?.id_slug || null) === target) return;
    const prevLeads = leads;
    const sourceSlug = lead?.lead_estado?.id_slug || "_unset";
    const targetSlug = target || "_unset";
    const targetEstado = target ? leadEstados.find((e) => e.id_slug === target) : null;
    setLeads(leads.map((l) => l.id === id ? { ...l, lead_estado: targetEstado } : l));
    pendingMovesRef.current.set(id, target);
    setCounts((c) => ({
      ...c,
      [sourceSlug]: Math.max(0, (c[sourceSlug] ?? 1) - 1),
      [targetSlug]: (c[targetSlug] ?? 0) + 1
    }));
    try {
      await window.API.updateLead(id, { lead_estado_id_slug: target });
      pendingMovesRef.current.delete(id);
    } catch (e) {
      setLeads(prevLeads);
      setError(e.message);
      pendingMovesRef.current.delete(id);
      setCounts((c) => ({
        ...c,
        [sourceSlug]: (c[sourceSlug] ?? 0) + 1,
        [targetSlug]: Math.max(0, (c[targetSlug] ?? 1) - 1)
      }));
    }
  };
  const columns = [
    {
      id_slug: "_unset",
      label: "Por classificar",
      color: "var(--muted)",
      is_folded: false,
      ordem: -1
    },
    ...leadEstados
  ];
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 60px)"
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "SCOUT \u2014 Kanban"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 arrasta os cart\xF5es entre colunas para mudar a etapa"), /* @__PURE__ */ React.createElement("label", { style: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    fontSize: 12.5,
    marginLeft: "auto"
  } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: includeAll,
      onChange: (e) => setIncludeAll(e.target.checked)
    }
  ), "Incluir n\xE3o-ativos")), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      value: query,
      onChange: (e) => setQuery(e.target.value),
      placeholder: "Pesquisar por nome, NIF ou distrito\u2026",
      style: {
        width: 320,
        maxWidth: "100%",
        padding: "6px 10px",
        fontSize: 12.5,
        border: "1px solid var(--border)",
        borderRadius: 6
      }
    }
  ), query.trim() && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 10, fontSize: 12, color: "var(--muted)" } }, filteredLeads.length, " de ", leads.length), phase2Loading && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 10, fontSize: 12, color: "var(--muted)" } }, "a carregar todos os leads\u2026")), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", fontSize: 12, marginBottom: 8 } }, error), loading ? /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)", padding: 12 } }, "A carregar\u2026") : /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 10,
    overflowX: "auto",
    flex: 1,
    alignItems: "stretch"
  } }, columns.map((col) => {
    const items = grouped.get(col.id_slug) || [];
    const total = counts[col.id_slug] ?? items.length;
    const stillLoading = phase2Loading && total > items.length;
    const folded = isFolded(col.id_slug, !!col.is_folded);
    const isDropTarget = dragOverSlug === col.id_slug;
    const baseStyle = {
      flex: folded ? "0 0 44px" : "0 0 280px",
      minWidth: folded ? 44 : 280,
      background: isDropTarget ? "var(--panel)" : "var(--bg)",
      border: `1px solid ${isDropTarget ? "var(--accent)" : "var(--border)"}`,
      borderRadius: 8,
      padding: 8,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      transition: "flex-basis 0.15s ease"
    };
    if (folded) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: col.id_slug,
          style: baseStyle,
          onDragOver: (e) => onDragOver(e, col.id_slug),
          onDragLeave: () => onDragLeave(col.id_slug),
          onDrop: () => onDrop(col.id_slug)
        },
        /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            onClick: () => toggleFold(col.id_slug),
            title: `${col.label} (${total})${stillLoading ? " \u2014 a carregar\u2026" : ""}`,
            style: {
              border: "none",
              background: "transparent",
              cursor: "pointer",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 6,
              padding: "6px 0"
            }
          },
          /* @__PURE__ */ React.createElement("span", { style: {
            display: "inline-block",
            width: 10,
            height: 10,
            borderRadius: 5,
            background: col.color || "#9aa3ad"
          } }),
          /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, fontWeight: 700, color: "var(--muted)" } }, total),
          /* @__PURE__ */ React.createElement("span", { style: {
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            fontSize: 11,
            fontWeight: 600,
            color: "var(--text-2)",
            whiteSpace: "nowrap"
          } }, col.label)
        )
      );
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: col.id_slug,
        style: baseStyle,
        onDragOver: (e) => onDragOver(e, col.id_slug),
        onDragLeave: () => onDragLeave(col.id_slug),
        onDrop: () => onDrop(col.id_slug)
      },
      /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginBottom: 8,
        padding: "2px 4px"
      } }, /* @__PURE__ */ React.createElement("span", { style: {
        display: "inline-block",
        width: 10,
        height: 10,
        borderRadius: 5,
        background: col.color || "#9aa3ad"
      } }), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12.5, fontWeight: 700 } }, col.label), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)", fontWeight: 500 } }, total), stillLoading && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, color: "var(--muted)", fontStyle: "italic" } }, "a carregar\u2026"), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          onClick: () => toggleFold(col.id_slug),
          title: "Colapsar coluna",
          style: {
            marginLeft: "auto",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            color: "var(--muted)",
            fontSize: 14,
            padding: "0 4px"
          }
        },
        "\xAB"
      )),
      /* @__PURE__ */ React.createElement("div", { style: {
        flex: 1,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 6
      } }, items.map((l) => /* @__PURE__ */ React.createElement(
        KanbanCard,
        {
          key: l.id,
          lead: l,
          onDragStart,
          onClick: () => setEditing(l)
        }
      )), items.length === 0 && /* @__PURE__ */ React.createElement("div", { style: {
        fontSize: 11.5,
        color: "var(--muted)",
        textAlign: "center",
        padding: 8
      } }, "Solta aqui um cart\xE3o."))
    );
  })), editing && /* @__PURE__ */ React.createElement(
    LeadDrawer,
    {
      key: editing.id,
      title: editing.name,
      subtitle: editing.nif ? `NIF ${editing.nif}` : "sem NIF",
      initial: editing,
      navList: [],
      currentId: editing.id,
      leadEstados,
      registerLeaveGuard,
      onLeaveTo: (destino) => {
        setEditing(null);
        window.HubRouter.navigate(window.HubRouter.parse(destino || ""));
      },
      onNavigate: (l) => setEditing(l),
      onClose: () => setEditing(null),
      onSubmit: async (data) => {
        try {
          const updated = await window.API.updateLead(editing.id, data);
          setLeads((prev) => prev.map((l) => l.id === editing.id ? updated : l));
          setEditing(null);
        } catch (e) {
          setError(e.message);
        }
      }
    }
  ));
}
function KanbanCard({ lead, onDragStart, onClick }) {
  const dbi = lead.dbinforma || {};
  const tierBg = lead.tier ? tierColor(lead.tier) : null;
  const perfilBg = dbi.perfil ? PERFIL_BG[dbi.perfil] || PERFIL_BG.indefinido : null;
  const credito = dbi.opiniao_credito;
  const volume = lead.turnover ?? dbi.vendas ?? null;
  const stateLabel = dbi.status_label || null;
  const statePalette = dbi.status_kind === "good" ? { bg: "#e8f6ec", fg: "#1f7a3a", border: "#bce0c6" } : dbi.status_kind === "bad" ? { bg: "#fce8e8", fg: "#a82a2a", border: "#f0bcbc" } : { bg: "#f3f3f5", fg: "var(--text-2)", border: "var(--border)" };
  const metric = (label, value) => /* @__PURE__ */ React.createElement("div", { style: { minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 9.5,
    color: "var(--muted)",
    textTransform: "uppercase",
    letterSpacing: 0.3,
    lineHeight: 1.2
  } }, label), /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    fontWeight: 600,
    lineHeight: 1.2,
    color: value === "\u2014" ? "var(--muted)" : "var(--text)",
    fontVariantNumeric: "tabular-nums"
  } }, value));
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      draggable: true,
      onDragStart: (e) => onDragStart(e, lead.id),
      onClick,
      style: {
        background: "var(--panel)",
        border: "1px solid var(--border)",
        borderRadius: 6,
        padding: 8,
        cursor: "pointer",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        display: "flex",
        flexDirection: "column",
        gap: 6
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", gap: 6 } }, /* @__PURE__ */ React.createElement("strong", { style: {
      fontSize: 12.5,
      lineHeight: 1.3,
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    } }, lead.name), lead.tier && /* @__PURE__ */ React.createElement("span", { title: `Classifica\xE7\xE3o ${lead.tier}`, style: {
      background: tierBg,
      color: "#fff",
      padding: "1px 6px",
      borderRadius: 8,
      fontSize: 10,
      fontWeight: 700
    } }, lead.tier)),
    /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontSize: 11,
      color: "var(--muted)",
      fontFamily: "var(--font-mono)"
    } }, lead.nif || "\u2014", lead.district && /* @__PURE__ */ React.createElement("span", null, "\xB7 ", lead.district)),
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--text-2)", fontWeight: 500 } }, /* @__PURE__ */ React.createElement(UserChip, { username: lead.owner_username, size: 16 })),
    (stateLabel || perfilBg) && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4, flexWrap: "wrap" } }, stateLabel && /* @__PURE__ */ React.createElement("span", { title: "Estado da empresa (DBInforma)", style: {
      padding: "1px 6px",
      borderRadius: 999,
      fontSize: 10,
      fontWeight: 600,
      background: statePalette.bg,
      color: statePalette.fg,
      border: `1px solid ${statePalette.border}`
    } }, stateLabel), perfilBg && /* @__PURE__ */ React.createElement("span", { title: "Perfil DBInforma", style: {
      padding: "1px 6px",
      borderRadius: 6,
      fontSize: 10,
      fontWeight: 500,
      ...perfilBg
    } }, dbi.perfil_label)),
    lead.vendas_estimadas_eur != null && /* @__PURE__ */ React.createElement(
      "div",
      {
        title: "Estimativa anual de vendas para esta empresa",
        style: {
          paddingTop: 4,
          borderTop: "1px dashed var(--border)",
          display: "flex",
          alignItems: "baseline",
          gap: 6
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        fontSize: 9.5,
        color: "var(--muted)",
        textTransform: "uppercase",
        letterSpacing: 0.3
      } }, "Potencial"),
      /* @__PURE__ */ React.createElement("strong", { style: {
        fontSize: 12.5,
        color: "var(--accent)",
        fontVariantNumeric: "tabular-nums"
      } }, fmtEurCompact(lead.vendas_estimadas_eur))
    ),
    /* @__PURE__ */ React.createElement("div", { style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      columnGap: 8,
      rowGap: 4,
      paddingTop: 4,
      borderTop: lead.vendas_estimadas_eur != null ? "none" : "1px dashed var(--border)"
    } }, metric("Volume", fmtEurCompact(volume)), metric("VAB", fmtEurCompact(dbi.vab)), metric("Vendas/Func", fmtEurCompact(dbi.vendas_por_func)), metric("Func.", dbi.empregados != null ? dbi.empregados.toLocaleString("pt-PT") : "\u2014")),
    credito != null && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement("span", { title: "Opini\xE3o de cr\xE9dito", style: {
      padding: "1px 6px",
      borderRadius: 6,
      fontSize: 10.5,
      fontWeight: 700,
      background: "rgba(31, 122, 58, 0.12)",
      color: "#1f7a3a"
    } }, "Cr\xE9dito: ", fmtEurCompact(credito)))
  );
}
window.ProspecaoKanbanView = ProspecaoKanbanView;
window.DBInformaIndicatorsView = DBInformaIndicatorsView;

// ===== prospecao/frontend/admin.jsx =====
function ProspeccaoAdminView() {
  const [prompt, setPrompt] = useState(null);
  const [error, setError] = useState(null);
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    window.API.scoutPrompt().then(setPrompt).catch((e) => setError(e.message));
  }, []);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 1100 } }, /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginBottom: 20 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Prompt do SCOUT"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 system prompt enviado ao Claude"), prompt && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      style: { marginLeft: "auto" },
      onClick: () => setExpanded((x) => !x)
    },
    expanded ? "Recolher" : "Expandir"
  )), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), !prompt && !error && /* @__PURE__ */ React.createElement("div", { style: { padding: 16, color: "var(--muted)" } }, "A carregar\u2026"), prompt && /* @__PURE__ */ React.createElement("div", { style: { padding: 16, display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, "Modelo: "), /* @__PURE__ */ React.createElement("strong", { className: "td-mono", style: { fontSize: 12 } }, prompt.default_model)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, "Web search m\xE1x.: "), /* @__PURE__ */ React.createElement("strong", null, prompt.web_search_max_uses)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 11 } }, "Setores: "), /* @__PURE__ */ React.createElement("strong", null, Object.keys(prompt.sector_xml_chunks || {}).length))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    marginBottom: 6
  } }, "System prompt"), /* @__PURE__ */ React.createElement("pre", { style: {
    background: "var(--bg)",
    border: "1px solid var(--border)",
    padding: 12,
    borderRadius: 6,
    fontSize: 11.5,
    lineHeight: 1.5,
    maxHeight: expanded ? "none" : 280,
    overflow: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontFamily: "var(--font-mono)"
  } }, prompt.system_prompt), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 6 } }, "Placeholders ", /* @__PURE__ */ React.createElement("code", null, "{{DISTRITOS}}"), " e ", /* @__PURE__ */ React.createElement("code", null, "{{SECTORS}}"), " s\xE3o substitu\xEDdos em runtime pelos valores escolhidos na pesquisa.")), expanded && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    marginBottom: 6
  } }, "Sectors XML (injetado conforme escolha)"), /* @__PURE__ */ React.createElement("pre", { style: {
    background: "var(--bg)",
    border: "1px solid var(--border)",
    padding: 12,
    borderRadius: 6,
    fontSize: 11.5,
    lineHeight: 1.5,
    maxHeight: 240,
    overflow: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontFamily: "var(--font-mono)"
  } }, Object.entries(prompt.sector_xml_chunks || {}).map(([k, v]) => `[${k}]
${v}`).join("\n\n"))))), /* @__PURE__ */ React.createElement(ScoutDistrictsPanel, null), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(ScoutSectorsPanel, null));
}
window.ProspeccaoAdminView = ProspeccaoAdminView;

// ===== prospecao/frontend/admin-outlook.jsx =====
function ProspecaoOutlookAdminView() {
  const { useState, useEffect } = React;
  const [cfg, setCfg] = useState(null);
  const [segredo, setSegredo] = useState("");
  const [clientState, setClientState] = useState("");
  const [tipos, setTipos] = useState([]);
  const [ligacoes, setLigacoes] = useState([]);
  const [aGravar, setAGravar] = useState(false);
  const [aTestarAmbito, setATestarAmbito] = useState(false);
  const [novoUsername, setNovoUsername] = useState("");
  const [aLigar, setALigar] = useState("");
  const carregar = () => {
    window.ScoutAPI.outlookConfig().then(setCfg).catch(() => setCfg(null));
    window.ScoutAPI.outlookLigacoes().then(setLigacoes).catch(() => setLigacoes([]));
    window.ScoutAPI.contaTiposAtividade().then(setTipos).catch(() => setTipos([]));
  };
  useEffect(carregar, []);
  if (!cfg) return /* @__PURE__ */ React.createElement("div", { className: "content" }, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"));
  const campo = (k, label, tipo = "text") => /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: tipo,
      value: cfg[k] || "",
      onChange: (e) => setCfg({ ...cfg, [k]: e.target.value })
    }
  ));
  async function gravar() {
    setAGravar(true);
    try {
      const novo = await window.ScoutAPI.saveOutlookConfig({
        graph_tenant_id: cfg.graph_tenant_id,
        graph_client_id: cfg.graph_client_id,
        graph_client_secret: segredo,
        notification_url: cfg.notification_url,
        client_state: clientState,
        tipo_default: cfg.tipo_default,
        is_enabled: cfg.is_enabled,
        dominio_interno: cfg.dominio_interno,
        canary_mailbox: cfg.canary_mailbox
      });
      setCfg(novo);
      setSegredo("");
      setClientState("");
      window.srToast?.("Configura\xE7\xE3o gravada.", "success");
    } catch (e) {
      window.srToast?.(String(e.message || e), "error");
    } finally {
      setAGravar(false);
    }
  }
  async function testarAmbito() {
    setATestarAmbito(true);
    try {
      const resultado = await window.ScoutAPI.testarAmbitoOutlook();
      await window.ScoutAPI.outlookConfig().then(setCfg);
      const tipo = resultado.estado === "nao_restringe" ? "error" : resultado.estado === "erro" ? "error" : resultado.estado === "nao_verificado" ? "warning" : "success";
      window.srToast?.(resultado.detalhe, tipo);
    } catch (e) {
      window.srToast?.(String(e.message || e), "error");
    } finally {
      setATestarAmbito(false);
    }
  }
  async function ligarCaixa(username) {
    if (!username) return;
    setALigar(username);
    try {
      await window.ScoutAPI.ligarCaixaOutlook(username);
      window.ScoutAPI.outlookLigacoes().then(setLigacoes).catch(() => {
      });
      setNovoUsername("");
      window.srToast?.(`Caixa de ${username} ligada ao calend\xE1rio.`, "success");
    } catch (e) {
      window.srToast?.(String(e.message || e), "error");
    } finally {
      setALigar("");
    }
  }
  async function desligarCaixa(username) {
    const ok = await window.hubConfirm({
      message: `Desligar a caixa de ${username} do calend\xE1rio do SCOUT?`
    });
    if (!ok) return;
    setALigar(username);
    try {
      await window.ScoutAPI.desligarCaixaOutlook(username);
      window.ScoutAPI.outlookLigacoes().then(setLigacoes).catch(() => {
      });
      window.srToast?.(`Caixa de ${username} desligada.`, "success");
    } catch (e) {
      window.srToast?.(String(e.message || e), "error");
    } finally {
      setALigar("");
    }
  }
  function textoDoAmbito() {
    if (cfg.ambito_estado === "verificado") {
      const d = cfg.ambito_verificado_em ? new Date(cfg.ambito_verificado_em) : null;
      const quando = d ? `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}` : "";
      return `\xC2mbito verificado${quando ? ` a ${quando}` : ""}`;
    }
    if (cfg.ambito_estado === "nao_restringe") return "\xC2mbito N\xC3O restringe";
    if (cfg.ambito_estado === "erro") return `Erro a verificar o \xE2mbito: ${cfg.ambito_detalhe || ""}`;
    return "\xC2mbito n\xE3o verificado";
  }
  const columnsLigacoes = [
    {
      key: "username",
      label: "Utilizador",
      width: 160,
      minWidth: 120,
      fixed: true,
      render: (l) => l.username
    },
    {
      key: "mailbox",
      label: "Caixa",
      width: 200,
      minWidth: 150,
      render: (l) => l.mailbox
    },
    {
      key: "ativo",
      label: "Ativa",
      width: 70,
      minWidth: 60,
      render: (l) => l.ativo ? "Sim" : "N\xE3o"
    },
    {
      key: "subscription_expira_em",
      label: "Subscri\xE7\xE3o at\xE9",
      width: 230,
      minWidth: 200,
      render: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, l.subscription_expira_em || "\u2014")
    },
    {
      key: "ultimo_sync",
      label: "\xDAltimo sync",
      width: 230,
      minWidth: 200,
      render: (l) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, l.ultimo_sync || "\u2014")
    },
    {
      key: "estado",
      label: "Estado",
      width: 140,
      minWidth: 100,
      render: (l) => l.estado === "erro" ? /* @__PURE__ */ React.createElement("span", { className: "erro" }, l.erro) : l.estado
    },
    {
      key: "acao",
      label: "A\xE7\xE3o",
      sortable: false,
      width: 150,
      minWidth: 120,
      render: (l) => l.ativo ? /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn",
          disabled: aLigar === l.username,
          onClick: () => desligarCaixa(l.username)
        },
        aLigar === l.username ? "A desligar\u2026" : "Desligar"
      ) : /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn",
          disabled: aLigar === l.username,
          onClick: () => ligarCaixa(l.username)
        },
        aLigar === l.username ? "A ligar\u2026" : "Ligar"
      )
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "content" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Registo de app (Microsoft Graph)"), campo("graph_tenant_id", "Tenant ID"), campo("graph_client_id", "Client ID"), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Client secret"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: segredo,
      onChange: (e) => setSegredo(e.target.value),
      placeholder: cfg.tem_segredo ? "\u2022\u2022\u2022\u2022\u2022\u2022 (gravado)" : "por definir"
    }
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Deixar vazio mant\xE9m o segredo atual.")), campo("notification_url", "URL do webhook"), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Dom\xEDnio interno"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      value: cfg.dominio_interno || "",
      onChange: (e) => setCfg({ ...cfg, dominio_interno: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Dom\xEDnio de email da empresa. Participantes deste dom\xEDnio n\xE3o contam como externos, logo n\xE3o servem para casar o evento com uma Conta. N\xE3o pode ficar vazio \u2014 sem ele, ningu\xE9m conta como colega e o casamento por dom\xEDnio deixa de funcionar para toda a gente.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "clientState (segredo partilhado)"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: clientState,
      onChange: (e) => setClientState(e.target.value),
      placeholder: cfg.tem_client_state ? "\u2022\u2022\u2022\u2022\u2022\u2022 (gravado)" : "por definir"
    }
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Autentica as notifica\xE7\xF5es do webhook. Deixar vazio mant\xE9m o atual.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Tipo dos eventos importados"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: cfg.tipo_default || "",
      onChange: (e) => setCfg({
        ...cfg,
        tipo_default: e.target.value ? Number(e.target.value) : null
      })
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem tipo \u2014"),
    tipos.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id, value: t.id }, t.nome))
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Dado \xE0s atividades que entram do Outlook. Sem tipo, um evento importado nunca conta como visita na lista de Contas.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!cfg.is_enabled,
      onChange: (e) => setCfg({ ...cfg, is_enabled: e.target.checked })
    }
  ), "Integra\xE7\xE3o ativa"), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Desligada, o hub n\xE3o envia nem importa eventos (o webhook aceita e deita fora as notifica\xE7\xF5es).")), /* @__PURE__ */ React.createElement("button", { className: "btn btn-primary", disabled: aGravar, onClick: gravar }, aGravar ? "A gravar\u2026" : "Gravar"), /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginTop: 20 } }, "\xC2mbito do Exchange"), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Caixa-can\xE1rio"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      value: cfg.canary_mailbox || "",
      onChange: (e) => setCfg({ ...cfg, canary_mailbox: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "UPN de uma caixa que nunca deve estar no grupo de \xE2mbito (ex.: uma conta de servi\xE7o, ou algu\xE9m de uma \xE1rea claramente fora). O health-check espera 403 aqui \u2014 \xE9 o que prova que o \xE2mbito restringe.")), /* @__PURE__ */ React.createElement("div", null, textoDoAmbito()), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn",
      disabled: aTestarAmbito,
      onClick: testarAmbito,
      style: { marginTop: 8 }
    },
    aTestarAmbito ? "A testar\u2026" : "Testar \xE2mbito"
  ), /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginTop: 20 } }, "Liga\xE7\xF5es dos comerciais"), /* @__PURE__ */ React.createElement("div", { className: "field-row", style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      value: novoUsername,
      placeholder: "username a ligar",
      onChange: (e) => setNovoUsername(e.target.value)
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn",
      disabled: !novoUsername || !!aLigar,
      onClick: () => ligarCaixa(novoUsername)
    },
    aLigar === novoUsername && aLigar ? "A ligar\u2026" : "Ligar"
  ), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Liga a caixa do email do utilizador ao calend\xE1rio \u2014 a pessoa \xE9 avisada por notifica\xE7\xE3o. N\xE3o h\xE1 passo de consentimento na autentica\xE7\xE3o, por isso o aviso \xE9 obrigat\xF3rio.")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "admin-outlook-ligacoes",
      columns: columnsLigacoes,
      data: ligacoes,
      pagination: "none",
      rowKey: (l) => l.username,
      empty: "Ningu\xE9m ligou a caixa ainda."
    }
  ));
}
window.ProspecaoOutlookAdminView = ProspecaoOutlookAdminView;

// ===== prospecao/frontend/admin-scout-districts.jsx =====
function ScoutDistrictsPanel() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const load = () => window.API.scoutDistricts().then((r) => setItems(r.results || r));
  useEffect(() => {
    load();
  }, []);
  const save = async (data, isNew) => {
    if (isNew) await window.API.createScoutDistrict(data);
    else await window.API.updateScoutDistrict(editing.id, data);
    setEditing(null);
    setCreating(false);
    load();
  };
  const del = async (it) => {
    if (!await window.hubConfirm({ message: `Apagar distrito "${it.name}"?` })) return;
    await window.API.deleteScoutDistrict(it.id);
    load();
  };
  const columns = [
    {
      key: "name",
      label: "Nome",
      width: 220,
      minWidth: 160,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.name)
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 70,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.ordem)
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 80,
      minWidth: 60,
      render: (it) => it.is_active ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 160,
      minWidth: 140,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(it) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => del(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Distritos dispon\xEDveis no SCOUT"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Novo")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "admin-distritos",
      columns,
      data: items,
      pagination: "none",
      rowKey: (it) => it.id
    }
  ), (creating || editing) && /* @__PURE__ */ React.createElement(
    SimpleFormModal,
    {
      title: creating ? "Novo distrito" : `Editar ${editing.name}`,
      fields: [
        { key: "name", label: "Nome", required: true, autoFocus: true },
        { key: "ordem", label: "Ordem", type: "number" },
        { key: "is_active", label: "Ativo", type: "checkbox" }
      ],
      initial: editing || { name: "", ordem: 100, is_active: true },
      onClose: () => {
        setEditing(null);
        setCreating(false);
      },
      onSubmit: (data) => save(data, creating)
    }
  ));
}
window.ScoutDistrictsPanel = ScoutDistrictsPanel;

// ===== prospecao/frontend/admin-scout-sectors.jsx =====
function ScoutSectorsPanel() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const load = () => window.API.scoutSectors().then((r) => setItems(r.results || r));
  useEffect(() => {
    load();
  }, []);
  const save = async (data, isNew) => {
    if (isNew) {
      if (!data.id_slug) data.id_slug = (data.nome || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
      await window.API.createScoutSector(data);
    } else {
      await window.API.updateScoutSector(editing.id_slug, data);
    }
    setEditing(null);
    setCreating(false);
    load();
  };
  const del = async (it) => {
    if (!await window.hubConfirm({ message: `Apagar setor "${it.nome}"?` })) return;
    await window.API.deleteScoutSector(it.id_slug);
    load();
  };
  const columns = [
    {
      // Célula composta (nome + descrição por baixo, truncada a 70 carateres):
      // 386px é o que a linha mais larga precisa ("Health & Sport Equipments" +
      // descrição) — 460/420 dá margem para não cortar ao primeiro caráter a
      // mais numa descrição futura.
      key: "nome",
      label: "Nome",
      width: 460,
      minWidth: 420,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, it.nome), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, (it.description || "").slice(0, 70), (it.description || "").length > 70 ? "\u2026" : ""))
    },
    {
      key: "id_slug",
      label: "id_slug",
      width: 150,
      minWidth: 110,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.id_slug)
    },
    {
      // Lista de códigos CAE — identificadores, um corte torna-os inúteis.
      // 206px é o que a linha mais larga precisa; 270/240 dá margem.
      key: "cae_codes",
      label: "CAE",
      width: 270,
      minWidth: 240,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted", style: { fontSize: 11 } }, it.cae_codes || "\u2014")
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 70,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.ordem)
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 80,
      minWidth: 60,
      render: (it) => it.is_active ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 160,
      minWidth: 140,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(it) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => del(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Setores do SCOUT"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 id_slug deve manter-se igual ao usado nas leads"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Novo")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "admin-setores",
      columns,
      data: items,
      pagination: "none",
      rowKey: (it) => it.id_slug
    }
  ), (creating || editing) && /* @__PURE__ */ React.createElement(
    SimpleFormModal,
    {
      title: creating ? "Novo setor" : `Editar ${editing.nome}`,
      fields: [
        { key: "nome", label: "Nome", required: true, autoFocus: true },
        ...creating ? [{ key: "id_slug", label: "id_slug (auto se vazio)" }] : [],
        { key: "cae_codes", label: "CAE codes (separados por v\xEDrgula)" },
        { key: "description", label: "Descri\xE7\xE3o", type: "textarea" },
        { key: "ordem", label: "Ordem", type: "number" },
        { key: "is_active", label: "Ativo", type: "checkbox" }
      ],
      initial: editing || { nome: "", id_slug: "", cae_codes: "", description: "", ordem: 100, is_active: true },
      onClose: () => {
        setEditing(null);
        setCreating(false);
      },
      onSubmit: (data) => save(data, creating)
    }
  ));
}
window.ScoutSectorsPanel = ScoutSectorsPanel;

// ===== prospecao/frontend/admin-negocio-estados.jsx =====
function ProspecaoNegocioEstadosView() {
  const EMPTY = {
    id_slug: "",
    label: "",
    color: "#9aa3ad",
    ordem: 100,
    is_folded: false,
    is_active: true,
    is_terminal: false
  };
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [draft, setDraft] = useState(EMPTY);
  const [editingSlug, setEditingSlug] = useState(null);
  const [saving, setSaving] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.ScoutAPI.negocioEstados();
      setItems(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const cancelEdit = () => {
    setEditingSlug(null);
    setDraft(EMPTY);
  };
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = { ...draft, ordem: Number(draft.ordem) || 100 };
      if (editingSlug) {
        await window.ScoutAPI.updateNegocioEstado(editingSlug, payload);
      } else {
        if (!payload.id_slug || !payload.label) {
          throw new Error("Slug e Label s\xE3o obrigat\xF3rios.");
        }
        await window.ScoutAPI.createNegocioEstado(payload);
      }
      cancelEdit();
      await load();
      window.srToast?.("Fase gravada.", "success");
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };
  const doDelete = async () => {
    const it = pendingDelete;
    setPendingDelete(null);
    try {
      await window.ScoutAPI.deleteNegocioEstado(it.id_slug);
      await load();
      window.srToast?.(`Fase "${it.label}" apagada.`, "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    }
  };
  const columns = [
    {
      key: "id_slug",
      label: "Slug",
      width: 150,
      minWidth: 110,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.id_slug)
    },
    {
      key: "label",
      label: "Label",
      width: 180,
      minWidth: 130,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.label)
    },
    {
      key: "color",
      label: "Cor",
      width: 70,
      minWidth: 60,
      render: (it) => /* @__PURE__ */ React.createElement("span", { style: {
        display: "inline-block",
        width: 14,
        height: 14,
        borderRadius: 3,
        background: it.color || "var(--muted)"
      } })
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 70,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.ordem)
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 80,
      minWidth: 60,
      render: (it) => it.is_active ? "\u2713" : "\u2014"
    },
    {
      key: "is_terminal",
      label: "Terminal",
      width: 90,
      minWidth: 75,
      render: (it) => it.is_terminal ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 170,
      minWidth: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => {
            setEditingSlug(it.id_slug);
            setDraft({ ...it });
          }
        },
        "Editar"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Fases do pipeline de neg\xF3cios")), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "admin-negocio-estados",
      columns,
      data: items,
      pagination: "none",
      rowKey: (it) => it.id_slug
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, editingSlug ? `Editar ${editingSlug}` : "Nova fase")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "Slug", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.id_slug,
      disabled: !!editingSlug,
      onChange: (e) => setDraft({ ...draft, id_slug: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Label", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.label,
      onChange: (e) => setDraft({ ...draft, label: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Cor", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "color",
      value: draft.color || "#9aa3ad",
      onChange: (e) => setDraft({ ...draft, color: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.ordem,
      onChange: (e) => setDraft({ ...draft, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_active,
      onChange: (e) => setDraft({ ...draft, is_active: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Terminal", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_terminal,
      onChange: (e) => setDraft({ ...draft, is_terminal: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", "data-shortcut": "c", onClick: cancelEdit }, "Cancelar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", "data-shortcut": "s", onClick: save, disabled: saving }, saving ? "A guardar\u2026" : editingSlug ? "Guardar" : "Adicionar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S"))), pendingDelete && /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Apagar fase",
      onClose: () => setPendingDelete(null)
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar a fase ", /* @__PURE__ */ React.createElement("strong", null, pendingDelete.label), '? Os neg\xF3cios que estejam nela ficam sem fase (aparecem em "Por classificar").'),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        "data-shortcut": "c",
        onClick: () => setPendingDelete(null)
      },
      "Cancelar",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        style: { background: "#c4434b" },
        onClick: doDelete
      },
      "Apagar"
    ))
  ));
}
window.ProspecaoNegocioEstadosView = ProspecaoNegocioEstadosView;

// ===== prospecao/frontend/admin-phc-saude.jsx =====
const PHC_SAUDE_FONTES = [
  ["coluna", "Coluna"],
  ["indicador", "Indicador u_indiccl"],
  ["medida", "Medida derivada"]
];
const PHC_SAUDE_TABELAS = [
  ["", "(nenhuma)"],
  ["cl", "cl"],
  ["cl2", "cl2"],
  ["cc", "cc"],
  ["u_indiccl", "u_indiccl"],
  ["u_indicst", "u_indicst"]
];
const PHC_SAUDE_AGREGACOES = [
  ["nenhuma", "Nenhuma"],
  ["soma", "Soma"],
  ["media", "M\xE9dia"],
  ["maximo", "M\xE1ximo"],
  ["contagem", "Contagem"]
];
const PHC_SAUDE_TIPOS = [
  ["escalar_num", "N\xFAmero"],
  ["escalar_txt", "Texto"],
  ["serie", "S\xE9rie"]
];
const PHC_SAUDE_GRUPOS = [
  ["financeiro", "Financeiro"],
  ["vendas", "Vendas"],
  ["qualidade", "Qualidade"],
  ["identificacao", "Identifica\xE7\xE3o"]
];
const PHC_SAUDE_SCORE_TIPOS = [
  ["maior_pior", "Maior = pior"],
  ["maior_melhor", "Maior = melhor"],
  ["booleano", "Booleano (0=mau)"],
  ["escala", "Escala (mau\u2192bom)"],
  ["neutro", "Neutro (presen\xE7a)"]
];
function ProspecaoPhcSaudeView() {
  const EMPTY = {
    conceito: "",
    label: "",
    fonte: "coluna",
    tabela: "",
    coluna: "",
    agregacao: "nenhuma",
    tipo: "escalar_num",
    unidade: "",
    grupo: "financeiro",
    entra_no_score: false,
    score_tipo: "neutro",
    score_bom: "",
    score_mau: "",
    ordem: 100,
    is_active: true
  };
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [draft, setDraft] = useState(EMPTY);
  const [editingConceito, setEditingConceito] = useState(null);
  const [saving, setSaving] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const [nif, setNif] = useState("");
  const [testando, setTestando] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [testError, setTestError] = useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.ScoutAPI.phcSaudeCampos();
      setItems(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const cancelEdit = () => {
    setEditingConceito(null);
    setDraft(EMPTY);
  };
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = {
        ...draft,
        ordem: Number(draft.ordem) || 100,
        score_bom: draft.entra_no_score && draft.score_bom !== "" ? Number(draft.score_bom) : null,
        score_mau: draft.entra_no_score && draft.score_mau !== "" ? Number(draft.score_mau) : null
      };
      if (editingConceito) {
        await window.ScoutAPI.updatePhcSaudeCampo(editingConceito, payload);
      } else {
        if (!payload.conceito || !payload.label) {
          throw new Error("Conceito e Label s\xE3o obrigat\xF3rios.");
        }
        await window.ScoutAPI.createPhcSaudeCampo(payload);
      }
      cancelEdit();
      await load();
      window.srToast?.("Campo gravado.", "success");
    } catch (e) {
      setError(e.message);
      window.srToast?.(e.message, "error");
    } finally {
      setSaving(false);
    }
  };
  const doDelete = async () => {
    const it = pendingDelete;
    setPendingDelete(null);
    try {
      await window.ScoutAPI.deletePhcSaudeCampo(it.conceito);
      await load();
      window.srToast?.(`Campo "${it.label}" apagado.`, "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    }
  };
  const testar = async () => {
    if (!nif.trim()) {
      window.srToast?.("Indica um NIF para testar.", "error");
      return;
    }
    setTestando(true);
    setTestError(null);
    setTestResult(null);
    try {
      const r = await window.ScoutAPI.phcSaudeTestar(nif.trim());
      setTestResult(r);
    } catch (e) {
      setTestError(e.message);
    } finally {
      setTestando(false);
    }
  };
  const columns = [
    {
      key: "conceito",
      label: "Conceito",
      width: 140,
      minWidth: 110,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.conceito)
    },
    {
      key: "label",
      label: "Label",
      width: 170,
      minWidth: 130,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.label)
    },
    {
      key: "fonte",
      label: "Fonte",
      width: 90,
      minWidth: 75,
      render: (it) => it.fonte
    },
    {
      // Alargar COLUNA (abaixo) rouba espaço a esta pela mesma mecânica de
      // table-layout:fixed que lhe dava a folga: a tabela não cresce, o
      // browser reparte o excesso à mesma proporcionalmente por todas as
      // colunas, por isso alargar uma estreita a de todas. 90px chegava
      // só à custa do bónus de repartição que a COLUNA mais larga agora
      // absorve — sem este ajuste, "u_indiccl"/"u_indicst" (9 carateres,
      // o valor mais longo do enum de tabelas) passaria a cortar. 115/100
      // repõe a margem.
      key: "tabela",
      label: "Tabela",
      width: 115,
      minWidth: 100,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.tabela)
    },
    {
      // Nome de coluna da base de dados (ex. u_indicst_regularidade) —
      // identificador, um corte torna-o ilegível. 200px é o que a linha mais
      // larga precisa; 260/230 dá margem.
      key: "coluna",
      label: "Coluna",
      width: 260,
      minWidth: 230,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.coluna)
    },
    {
      key: "agregacao",
      label: "Agrega\xE7\xE3o",
      width: 105,
      minWidth: 90,
      render: (it) => it.agregacao
    },
    {
      key: "grupo",
      label: "Grupo",
      width: 110,
      minWidth: 90,
      render: (it) => it.grupo
    },
    {
      key: "score",
      label: "Score",
      width: 115,
      minWidth: 95,
      render: (it) => it.entra_no_score ? it.score_tipo : "\u2014"
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 75,
      minWidth: 60,
      render: (it) => it.is_active ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 170,
      minWidth: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => {
            setEditingConceito(it.conceito);
            setDraft({ ...EMPTY, ...it });
          }
        },
        "Editar"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Mapeamento PHC \u2014 Sa\xFAde financeira"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 selects fechados \u2014 sem SQL livre")), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "admin-phc-saude",
      columns,
      data: items,
      pagination: "none",
      rowKey: (it) => it.conceito
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, editingConceito ? `Editar ${editingConceito}` : "Novo campo")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "Conceito", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.conceito,
      disabled: !!editingConceito,
      onChange: (e) => setDraft({ ...draft, conceito: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Label", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.label,
      onChange: (e) => setDraft({ ...draft, label: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Fonte", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.fonte,
      onChange: (e) => setDraft({ ...draft, fonte: e.target.value })
    },
    PHC_SAUDE_FONTES.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Tabela", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.tabela,
      onChange: (e) => setDraft({ ...draft, tabela: e.target.value })
    },
    PHC_SAUDE_TABELAS.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Coluna", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.coluna,
      placeholder: "nome da coluna / indicador / medida",
      onChange: (e) => setDraft({ ...draft, coluna: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Agrega\xE7\xE3o", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.agregacao,
      onChange: (e) => setDraft({ ...draft, agregacao: e.target.value })
    },
    PHC_SAUDE_AGREGACOES.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Tipo", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.tipo,
      onChange: (e) => setDraft({ ...draft, tipo: e.target.value })
    },
    PHC_SAUDE_TIPOS.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Unidade", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.unidade,
      style: { width: 60 },
      onChange: (e) => setDraft({ ...draft, unidade: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Grupo", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.grupo,
      onChange: (e) => setDraft({ ...draft, grupo: e.target.value })
    },
    PHC_SAUDE_GRUPOS.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.ordem,
      style: { width: 70 },
      onChange: (e) => setDraft({ ...draft, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_active,
      onChange: (e) => setDraft({ ...draft, is_active: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Entra no score", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.entra_no_score,
      onChange: (e) => setDraft({ ...draft, entra_no_score: e.target.checked })
    }
  )), draft.entra_no_score && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", null, "Regra de pontua\xE7\xE3o", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.score_tipo,
      onChange: (e) => setDraft({ ...draft, score_tipo: e.target.value })
    },
    PHC_SAUDE_SCORE_TIPOS.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Valor bom (100 pts)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.score_bom,
      style: { width: 90 },
      onChange: (e) => setDraft({ ...draft, score_bom: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Valor mau (0 pts)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.score_mau,
      style: { width: 90 },
      onChange: (e) => setDraft({ ...draft, score_mau: e.target.value })
    }
  ))), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", "data-shortcut": "c", onClick: cancelEdit }, "Cancelar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", "data-shortcut": "s", onClick: save, disabled: saving }, saving ? "A guardar\u2026" : editingConceito ? "Guardar" : "Adicionar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S"))), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 24 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Testar contra um NIF"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 mostra os valores brutos devolvidos pelo mapeamento activo")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", marginBottom: 12 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: nif,
      placeholder: "NIF a testar",
      onChange: (e) => setNif(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") testar();
      }
    }
  ), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: testar, disabled: testando }, testando ? "A testar\u2026" : "Testar")), testError && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, testError), testResult && /* @__PURE__ */ React.createElement("pre", { style: {
    background: "var(--bg)",
    border: "1px solid var(--border)",
    padding: 12,
    borderRadius: 6,
    fontSize: 11.5,
    lineHeight: 1.5,
    maxHeight: 360,
    overflow: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontFamily: "var(--font-mono)"
  } }, JSON.stringify(testResult, null, 2)), pendingDelete && /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Apagar campo",
      onClose: () => setPendingDelete(null)
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar o campo ", /* @__PURE__ */ React.createElement("strong", null, pendingDelete.label), "? Deixa de entrar na avalia\xE7\xE3o de sa\xFAde financeira."),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        "data-shortcut": "c",
        onClick: () => setPendingDelete(null)
      },
      "Cancelar",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        style: { background: "#c4434b" },
        onClick: doDelete
      },
      "Apagar"
    ))
  ));
}
window.ProspecaoPhcSaudeView = ProspecaoPhcSaudeView;

// ===== prospecao/frontend/admin-saude-config.jsx =====
function ProspecaoSaudeConfigView() {
  const [campos, setCampos] = useState([]);
  const [pesos, setPesos] = useState({});
  const [limiarVerde, setLimiarVerde] = useState(70);
  const [limiarAmarelo, setLimiarAmarelo] = useState(40);
  const [mesesInatividade, setMesesInatividade] = useState(12);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const [cfg, camposResp] = await Promise.all([
        window.ScoutAPI.saudeConfigGet(),
        window.ScoutAPI.phcSaudeCampos()
      ]);
      setPesos(cfg.pesos || {});
      setLimiarVerde(cfg.limiar_verde ?? 70);
      setLimiarAmarelo(cfg.limiar_amarelo ?? 40);
      setMesesInatividade(cfg.meses_inatividade ?? 12);
      setCampos((camposResp.results || camposResp).filter((c) => c.entra_no_score));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const setPeso = (conceito, v) => setPesos({ ...pesos, [conceito]: v });
  const somaPesos = campos.reduce(
    (acc, c) => acc + (Number(pesos[c.conceito]) || 0),
    0
  );
  const somaOk = Math.abs(somaPesos - 100) <= 0.5;
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const pesosNum = {};
      Object.entries(pesos).forEach(([k, v]) => {
        pesosNum[k] = Number(v) || 0;
      });
      await window.ScoutAPI.saudeConfigPut({
        pesos: pesosNum,
        limiar_verde: Number(limiarVerde) || 0,
        limiar_amarelo: Number(limiarAmarelo) || 0,
        meses_inatividade: Number(mesesInatividade) || 0
      });
      window.srToast?.("Configura\xE7\xE3o de sa\xFAde gravada.", "success");
      await load();
    } catch (e) {
      setError(e.message);
      window.srToast?.(e.message, "error");
    } finally {
      setSaving(false);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Score de sa\xFAde financeira"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 pesos, limiares de cor e inatividade")), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), loading ? /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026") : /* @__PURE__ */ React.createElement("div", { style: { padding: 16, display: "flex", flexDirection: "column", gap: 18 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 11,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    marginBottom: 8
  } }, "Pesos por conceito (soma deve ser ~100)"), campos.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, 'Nenhum campo marcado "entra no score" \u2014 configura o mapeamento primeiro.'), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, flexWrap: "wrap" } }, campos.map((c) => /* @__PURE__ */ React.createElement("label", { key: c.conceito }, c.label, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      style: { width: 80 },
      value: pesos[c.conceito] ?? "",
      onChange: (e) => setPeso(c.conceito, e.target.value)
    }
  )))), campos.length > 0 && /* @__PURE__ */ React.createElement("div", { className: somaOk ? "muted" : "alert error", style: { marginTop: 8 } }, "Soma atual: ", somaPesos, !somaOk && " \u2014 os pesos dos conceitos com score devem somar ~100 para o score ficar entre 0 e 100.")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "Limiar verde (\u2265)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      style: { width: 80 },
      value: limiarVerde,
      onChange: (e) => setLimiarVerde(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Limiar amarelo (\u2265)", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      style: { width: 80 },
      value: limiarAmarelo,
      onChange: (e) => setLimiarAmarelo(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Meses de inatividade", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      style: { width: 80 },
      value: mesesInatividade,
      onChange: (e) => setMesesInatividade(e.target.value)
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, 'Score \u2265 limiar verde \u2192 verde. Entre limiar amarelo e limiar verde \u2192 amarelo. Abaixo do limiar amarelo \u2192 vermelho. Sem movimento h\xE1 mais que "meses de inatividade" conta como sinal de alerta na avalia\xE7\xE3o.'), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", "data-shortcut": "s", onClick: save, disabled: saving }, saving ? "A guardar\u2026" : "Guardar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S")))));
}
window.ProspecaoSaudeConfigView = ProspecaoSaudeConfigView;

// ===== prospecao/frontend/admin-phc-vistas.jsx =====
const PHC_VISTA_ENTIDADES = [
  ["documento", "Documento"],
  ["linha", "Linha"],
  ["anexo", "Anexo/Desenho"],
  ["produto", "Produto"]
];
const PHC_VISTA_TABELAS = [
  ["bo", "bo"],
  ["bo2", "bo2"],
  ["bi", "bi"],
  ["ft", "ft"],
  ["ft2", "ft2"],
  ["fi", "fi"],
  ["st", "st"],
  ["anexos", "anexos"]
];
const PHC_VISTA_CHAVES = [
  ["", "\u2014 (\xE9 filha)"],
  ["ncont", "NIF (ncont)"],
  ["no", "N\xBA cliente (no)"]
];
const PHC_VISTA_JOINS = [
  ["bi_bo", "bi \u2192 bo"],
  ["fi_ft", "fi \u2192 ft"],
  ["st_bi", "st \u2192 bi"],
  ["st_fi", "st \u2192 fi"],
  ["anexos_st", "anexos \u2192 st (desenho de artigo)"],
  ["anexos_bo", "anexos \u2192 bo (desenho de documento)"]
];
function scoutValoresParaTexto(valores) {
  return (valores || []).join(", ");
}
function scoutTextoParaValores(texto) {
  return (texto || "").split(",").map((v) => v.trim()).filter((v) => v !== "").map((v) => /^-?\d+(\.\d+)?$/.test(v) ? Number(v) : v);
}
function ProspecaoPhcVistasView() {
  const EMPTY = {
    slug: "",
    label: "",
    entidade: "documento",
    tabela_base: "bo",
    chave_cliente: "",
    colunas: [],
    joins: [],
    anchor_tabela: "bo",
    anchor_coluna: "",
    filtros: [],
    drill_para: "",
    ordenar_por: "",
    ordem: 100,
    is_active: true
  };
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [draft, setDraft] = useState(EMPTY);
  const [editingSlug, setEditingSlug] = useState(null);
  const [saving, setSaving] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const [nif, setNif] = useState("");
  const [testVista, setTestVista] = useState("");
  const [testando, setTestando] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [testError, setTestError] = useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.ScoutAPI.phcVistas();
      setItems(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const cancelEdit = () => {
    setEditingSlug(null);
    setDraft(EMPTY);
  };
  const setColuna = (i, patch) => {
    const colunas = draft.colunas.map((c, idx) => idx === i ? { ...c, ...patch } : c);
    setDraft({ ...draft, colunas });
  };
  const addColuna = () => setDraft({ ...draft, colunas: [...draft.colunas, { coluna: "", label: "", unidade: "" }] });
  const removeColuna = (i) => setDraft({ ...draft, colunas: draft.colunas.filter((_, idx) => idx !== i) });
  const setFiltro = (i, patch) => {
    const filtros = draft.filtros.map((f, idx) => idx === i ? { ...f, ...patch } : f);
    setDraft({ ...draft, filtros });
  };
  const addFiltro = () => setDraft({ ...draft, filtros: [...draft.filtros, { coluna: "", valores: [] }] });
  const removeFiltro = (i) => setDraft({ ...draft, filtros: draft.filtros.filter((_, idx) => idx !== i) });
  const toggleJoin = (key) => {
    const joins = draft.joins.includes(key) ? draft.joins.filter((j) => j !== key) : [...draft.joins, key];
    setDraft({ ...draft, joins });
  };
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = {
        ...draft,
        ordem: Number(draft.ordem) || 100,
        colunas: draft.colunas.filter((c) => c.coluna.trim() !== ""),
        filtros: draft.filtros.filter((f) => f.coluna.trim() !== "")
      };
      if (editingSlug) {
        await window.ScoutAPI.updatePhcVista(editingSlug, payload);
      } else {
        if (!payload.slug || !payload.label) {
          throw new Error("Slug e Label s\xE3o obrigat\xF3rios.");
        }
        await window.ScoutAPI.createPhcVista(payload);
      }
      cancelEdit();
      await load();
      window.srToast?.("Vista gravada.", "success");
    } catch (e) {
      setError(e.message);
      window.srToast?.(e.message, "error");
    } finally {
      setSaving(false);
    }
  };
  const doDelete = async () => {
    const it = pendingDelete;
    setPendingDelete(null);
    try {
      await window.ScoutAPI.deletePhcVista(it.slug);
      await load();
      window.srToast?.(`Vista "${it.label}" apagada.`, "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    }
  };
  const testar = async () => {
    if (!nif.trim() || !testVista) {
      window.srToast?.("Indica um NIF e uma vista para testar.", "error");
      return;
    }
    setTestando(true);
    setTestError(null);
    setTestResult(null);
    try {
      const r = await window.ScoutAPI.phcVistaTestar(nif.trim(), testVista);
      setTestResult(r);
    } catch (e) {
      setTestError(e.message);
    } finally {
      setTestando(false);
    }
  };
  const columnsVistas = [
    {
      key: "slug",
      label: "Slug",
      width: 130,
      minWidth: 100,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.slug)
    },
    {
      key: "label",
      label: "Label",
      width: 170,
      minWidth: 130,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.label)
    },
    {
      key: "entidade",
      label: "Entidade",
      width: 100,
      minWidth: 85,
      render: (it) => it.entidade
    },
    {
      key: "tabela_base",
      label: "Tabela",
      width: 90,
      minWidth: 75,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.tabela_base)
    },
    {
      key: "chave_cliente",
      label: "Chave cliente",
      width: 120,
      minWidth: 95,
      render: (it) => it.chave_cliente || "\u2014"
    },
    {
      key: "drill_para",
      label: "Drill para",
      width: 130,
      minWidth: 100,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.drill_para || "\u2014")
    },
    {
      key: "is_active",
      label: "Ativa",
      width: 75,
      minWidth: 60,
      render: (it) => it.is_active ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 170,
      minWidth: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => {
            setEditingSlug(it.slug);
            setDraft({ ...EMPTY, ...it });
          }
        },
        "Editar"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Vistas PHC \u2014 Documentos/linhas/anexos/produtos"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 selects fechados \u2014 sem SQL livre")), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "admin-phc-vistas",
      columns: columnsVistas,
      data: items,
      pagination: "none",
      rowKey: (it) => it.slug
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, editingSlug ? `Editar ${editingSlug}` : "Nova vista")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "Slug", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.slug,
      disabled: !!editingSlug,
      onChange: (e) => setDraft({ ...draft, slug: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Label", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.label,
      onChange: (e) => setDraft({ ...draft, label: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Entidade", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.entidade,
      onChange: (e) => setDraft({ ...draft, entidade: e.target.value })
    },
    PHC_VISTA_ENTIDADES.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Tabela base", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.tabela_base,
      onChange: (e) => setDraft({ ...draft, tabela_base: e.target.value })
    },
    PHC_VISTA_TABELAS.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Chave cliente", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.chave_cliente,
      onChange: (e) => setDraft({ ...draft, chave_cliente: e.target.value })
    },
    PHC_VISTA_CHAVES.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Tabela \xE2ncora", /* @__PURE__ */ React.createElement(
    "select",
    {
      value: draft.anchor_tabela,
      onChange: (e) => setDraft({ ...draft, anchor_tabela: e.target.value })
    },
    PHC_VISTA_TABELAS.map(([v, l]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l))
  )), /* @__PURE__ */ React.createElement("label", null, "Coluna \xE2ncora", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.anchor_coluna,
      placeholder: "ncont / no / bostamp / ref",
      onChange: (e) => setDraft({ ...draft, anchor_coluna: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Drill para (slug filho)", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.drill_para,
      onChange: (e) => setDraft({ ...draft, drill_para: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordenar por", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.ordenar_por,
      onChange: (e) => setDraft({ ...draft, ordenar_por: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.ordem,
      style: { width: 70 },
      onChange: (e) => setDraft({ ...draft, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ativa", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_active,
      onChange: (e) => setDraft({ ...draft, is_active: e.target.checked })
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Colunas"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 colunas da tabela_base a devolver")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 6 } }, draft.colunas.map((c, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: c.coluna,
      placeholder: "coluna",
      onChange: (e) => setColuna(i, { coluna: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: c.label,
      placeholder: "label",
      onChange: (e) => setColuna(i, { label: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: c.unidade || "",
      placeholder: "unidade",
      style: { width: 70 },
      onChange: (e) => setColuna(i, { unidade: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => removeColuna(i) }, "Remover"))), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: addColuna }, "+ Coluna")), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Filtros"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 coluna IN (valores) \u2014 bound, nunca concatenado")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 6 } }, draft.filtros.map((f, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: { display: "flex", gap: 6, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: f.coluna,
      placeholder: "coluna",
      onChange: (e) => setFiltro(i, { coluna: e.target.value })
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: scoutValoresParaTexto(f.valores),
      placeholder: "valores separados por v\xEDrgula",
      style: { flex: 1 },
      onChange: (e) => setFiltro(i, { valores: scoutTextoParaValores(e.target.value) })
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => removeFiltro(i) }, "Remover"))), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: addFiltro }, "+ Filtro")), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Joins"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 do registry (core.erp_clientes.VISTA_JOINS)")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, flexWrap: "wrap" } }, PHC_VISTA_JOINS.map(([v, l]) => /* @__PURE__ */ React.createElement("label", { key: v, style: { display: "flex", gap: 4, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: draft.joins.includes(v),
      onChange: () => toggleJoin(v)
    }
  ), l))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 14 } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", "data-shortcut": "c", onClick: cancelEdit }, "Cancelar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", "data-shortcut": "s", onClick: save, disabled: saving }, saving ? "A guardar\u2026" : editingSlug ? "Guardar" : "Adicionar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S"))), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 24 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Testar contra um NIF"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 corre a vista escolhida e mostra as linhas devolvidas")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", marginBottom: 12 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      value: nif,
      placeholder: "NIF a testar",
      onChange: (e) => setNif(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") testar();
      }
    }
  ), /* @__PURE__ */ React.createElement("select", { value: testVista, onChange: (e) => setTestVista(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 vista \u2014"), items.map((it) => /* @__PURE__ */ React.createElement("option", { key: it.slug, value: it.slug }, it.label))), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", onClick: testar, disabled: testando }, testando ? "A testar\u2026" : "Testar")), testError && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, testError), testResult && /* @__PURE__ */ React.createElement("pre", { style: {
    background: "var(--bg)",
    border: "1px solid var(--border)",
    padding: 12,
    borderRadius: 6,
    fontSize: 11.5,
    lineHeight: 1.5,
    maxHeight: 360,
    overflow: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontFamily: "var(--font-mono)"
  } }, JSON.stringify(testResult, null, 2)), pendingDelete && /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Apagar vista",
      onClose: () => setPendingDelete(null)
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar a vista ", /* @__PURE__ */ React.createElement("strong", null, pendingDelete.label), "? Deixa de estar dispon\xEDvel nos separadores Documentos/Produtos."),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        "data-shortcut": "c",
        onClick: () => setPendingDelete(null)
      },
      "Cancelar",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        style: { background: "#c4434b" },
        onClick: doDelete
      },
      "Apagar"
    ))
  ));
}
window.ProspecaoPhcVistasView = ProspecaoPhcVistasView;

// ===== prospecao/frontend/admin-phc-vendedores.jsx =====
function scoutVendedorUserLabel(u) {
  const full = [u.first_name, u.last_name].filter(Boolean).join(" ").trim();
  return full || u.username;
}
function ProspecaoPhcVendedoresView() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [savingId, setSavingId] = useState(null);
  const users = window.SR_USERS || [];
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.ScoutAPI.phcVendedores();
      setItems(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const patch = async (it, changes) => {
    setSavingId(it.vendedor);
    try {
      const updated = await window.ScoutAPI.updatePhcVendedor(it.vendedor, changes);
      setItems((prev) => prev.map((row) => row.vendedor === it.vendedor ? { ...row, ...updated } : row));
      window.srToast?.(`Vendedor ${it.vendedor} atualizado.`, "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    } finally {
      setSavingId(null);
    }
  };
  const columns = [
    {
      key: "vendedor",
      label: "Vendedor",
      width: 110,
      minWidth: 90,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.vendedor)
    },
    {
      key: "vendnm",
      label: "Nome (PHC)",
      width: 190,
      minWidth: 150,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.vendnm)
    },
    {
      key: "user",
      label: "Utilizador",
      width: 220,
      minWidth: 180,
      render: (it) => /* @__PURE__ */ React.createElement(
        "select",
        {
          value: it.user || "",
          disabled: savingId === it.vendedor,
          onChange: (e) => patch(it, { user: e.target.value ? Number(e.target.value) : null })
        },
        /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem owner \u2014"),
        users.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.username, value: u.id }, scoutVendedorUserLabel(u)))
      )
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 80,
      minWidth: 65,
      render: (it) => /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: !!it.is_active,
          disabled: savingId === it.vendedor,
          onChange: (e) => patch(it, { is_active: e.target.checked })
        }
      )
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Vendedor PHC \u2014 Utilizador do hub"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 o owner de cada Conta deriva daqui \u2014 PHC manda, nunca auto-associa\xE7\xE3o")), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "admin-phc-vendedores",
      columns,
      data: items,
      pagination: "none",
      rowKey: (it) => it.vendedor
    }
  ));
}
window.ProspecaoPhcVendedoresView = ProspecaoPhcVendedoresView;

// ===== prospecao/frontend/admin-conta-acoes.jsx =====
function ProspecaoContaAcoesView() {
  const EMPTY = {
    id_slug: "",
    nome: "",
    key: "",
    agendavel: false,
    tarefavel: false,
    ordem: 100,
    is_active: true
  };
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [draft, setDraft] = useState(EMPTY);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.ScoutAPI.contaAcaoTipos();
      setItems(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const cancelEdit = () => {
    setEditingId(null);
    setDraft(EMPTY);
  };
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = {
        ...draft,
        ordem: Number(draft.ordem) || 100
      };
      if (editingId) {
        await window.ScoutAPI.updateContaAcaoTipo(editingId, payload);
      } else {
        if (!payload.id_slug || !payload.nome) {
          throw new Error("id_slug e Nome s\xE3o obrigat\xF3rios.");
        }
        await window.ScoutAPI.createContaAcaoTipo(payload);
      }
      cancelEdit();
      await load();
      window.srToast?.("Tipo de a\xE7\xE3o gravado.", "success");
    } catch (e) {
      setError(e.message);
      window.srToast?.(e.message, "error");
    } finally {
      setSaving(false);
    }
  };
  const doDelete = async () => {
    const it = pendingDelete;
    setPendingDelete(null);
    try {
      await window.ScoutAPI.deleteContaAcaoTipo(it.id);
      await load();
      window.srToast?.(`Tipo "${it.nome}" apagado.`, "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    }
  };
  const columns = [
    {
      key: "nome",
      label: "Nome",
      width: 200,
      minWidth: 150,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement("strong", null, it.nome)
    },
    {
      key: "id_slug",
      label: "id_slug",
      width: 150,
      minWidth: 110,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.id_slug)
    },
    {
      key: "key",
      label: "key",
      width: 120,
      minWidth: 90,
      render: (it) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, it.key)
    },
    {
      key: "agendavel",
      label: "Agend\xE1vel",
      width: 100,
      minWidth: 85,
      render: (it) => it.agendavel ? "\u2713" : "\u2014"
    },
    {
      key: "tarefavel",
      label: "Tarefa",
      width: 90,
      minWidth: 75,
      render: (it) => it.tarefavel ? "\u2713" : "\u2014"
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 70,
      render: (it) => it.ordem
    },
    {
      key: "is_active",
      label: "Ativo",
      width: 80,
      minWidth: 60,
      render: (it) => it.is_active ? "\u2713" : "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 170,
      minWidth: 150,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn ghost sm",
          onClick: () => {
            setEditingId(it.id);
            setDraft({ ...EMPTY, ...it });
          }
        },
        "Editar"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "A\xE7\xF5es da Conta"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 tipos de a\xE7\xE3o/atividade usados no drawer da Conta")), /* @__PURE__ */ React.createElement("div", { className: "alert", style: { marginBottom: 12 } }, "O tipo com key ", /* @__PURE__ */ React.createElement("code", null, "visita"), ' \xE9 o usado pelo bot\xE3o "Marcar visita" do drawer \u2014 mant\xE9m pelo menos um tipo ativo com essa key.', /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6 } }, /* @__PURE__ */ React.createElement("strong", null, "Agend\xE1vel"), ": a atividade leva hora e aparece no calend\xE1rio. ", /* @__PURE__ */ React.createElement("strong", null, "Tarefa"), ": a atividade leva respons\xE1vel e prazo, e entra no sino de tarefas. Um tipo pode ser as duas coisas, ou nenhuma (fica s\xF3 um registo no hist\xF3rico).")), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "admin-conta-acoes",
      columns,
      data: items,
      pagination: "none",
      rowKey: (it) => it.id
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "panel-h", style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("span", { className: "title" }, editingId ? `Editar ${draft.nome}` : "Novo tipo de a\xE7\xE3o")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" } }, /* @__PURE__ */ React.createElement("label", null, "id_slug", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.id_slug,
      disabled: !!editingId,
      onChange: (e) => setDraft({ ...draft, id_slug: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Nome", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.nome,
      onChange: (e) => setDraft({ ...draft, nome: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "key", /* @__PURE__ */ React.createElement(
    "input",
    {
      value: draft.key,
      placeholder: "ex. visita",
      onChange: (e) => setDraft({ ...draft, key: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Agend\xE1vel", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.agendavel,
      onChange: (e) => setDraft({ ...draft, agendavel: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Tarefa", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.tarefavel,
      onChange: (e) => setDraft({ ...draft, tarefavel: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ordem", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value: draft.ordem,
      style: { width: 70 },
      onChange: (e) => setDraft({ ...draft, ordem: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("label", null, "Ativo", /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: !!draft.is_active,
      onChange: (e) => setDraft({ ...draft, is_active: e.target.checked })
    }
  )), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", "data-shortcut": "c", onClick: cancelEdit }, "Cancelar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", "data-shortcut": "s", onClick: save, disabled: saving }, saving ? "A guardar\u2026" : editingId ? "Guardar" : "Adicionar", /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S"))), pendingDelete && /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Apagar tipo de a\xE7\xE3o",
      onClose: () => setPendingDelete(null)
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar o tipo ", /* @__PURE__ */ React.createElement("strong", null, pendingDelete.nome), "? Deixa de estar dispon\xEDvel para registar novas a\xE7\xF5es da Conta."),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        "data-shortcut": "c",
        onClick: () => setPendingDelete(null)
      },
      "Cancelar",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        style: { background: "#c4434b" },
        onClick: doDelete
      },
      "Apagar"
    ))
  ));
}
window.ProspecaoContaAcoesView = ProspecaoContaAcoesView;

// ===== prospecao/frontend/contactos.jsx =====
function ScoutContactosPanel({ leadId = null, contaId = null, readOnly = false }) {
  const EMPTY = {
    nome: "",
    cargo: "",
    email: "",
    phone: "",
    notas: "",
    is_principal: false
  };
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const parent = contaId ? { conta: contaId } : { lead: leadId };
  const params = contaId ? { conta: contaId } : { lead: leadId };
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.ScoutAPI.contactos(params);
      setItems(r.results || r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (leadId || contaId) load();
  }, [leadId, contaId]);
  const save = async (data) => {
    try {
      if (editing) await window.ScoutAPI.updateContacto(editing.id, data);
      else await window.ScoutAPI.createContacto({ ...data, ...parent });
      setEditing(null);
      setCreating(false);
      await load();
      window.srToast?.("Contacto gravado.", "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    }
  };
  const doDelete = async () => {
    const it = pendingDelete;
    setPendingDelete(null);
    try {
      await window.ScoutAPI.deleteContacto(it.id);
      await load();
      window.srToast?.(`Contacto "${it.nome}" apagado.`, "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    }
  };
  const FIELDS = [
    { key: "nome", label: "Nome", required: true, autoFocus: true },
    { key: "cargo", label: "Cargo" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Telefone" },
    { key: "notas", label: "Notas", type: "textarea" },
    { key: "is_principal", label: "Contacto principal", type: "checkbox" }
  ];
  const COLUNAS = [
    {
      key: "nome",
      label: "Nome",
      width: 200,
      minWidth: 140,
      fixed: true,
      render: (it) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, it.nome), it.is_principal && /* @__PURE__ */ React.createElement("span", { className: "badge", style: { marginLeft: 6 } }, "principal"))
    },
    {
      key: "cargo",
      label: "Cargo",
      width: 160,
      minWidth: 110,
      render: (it) => it.cargo || "\u2014"
    },
    {
      key: "email",
      label: "Email",
      width: 200,
      minWidth: 140,
      render: (it) => it.email || "\u2014"
    },
    {
      key: "phone",
      label: "Telefone",
      width: 130,
      minWidth: 110,
      mono: true,
      render: (it) => it.phone || "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 150,
      minWidth: 130,
      render: (it) => !readOnly && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(it) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setPendingDelete(it) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Contactos"), !readOnly && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      style: { marginLeft: "auto" },
      onClick: () => setCreating(true)
    },
    "Novo"
  )), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "contactos",
      columns: COLUNAS,
      data: items,
      pagination: "none",
      rowKey: (it) => it.id,
      empty: "Sem contactos."
    }
  ), (creating || editing) && /* @__PURE__ */ React.createElement(
    SimpleFormModal,
    {
      title: creating ? "Novo contacto" : `Editar ${editing.nome}`,
      fields: FIELDS,
      initial: editing || EMPTY,
      onClose: () => {
        setEditing(null);
        setCreating(false);
      },
      onSubmit: save
    }
  ), pendingDelete && /* @__PURE__ */ React.createElement(
    window.ModalShell,
    {
      title: "Apagar contacto",
      onClose: () => setPendingDelete(null)
    },
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, lineHeight: 1.45, marginBottom: 18 } }, "Apagar o contacto ", /* @__PURE__ */ React.createElement("strong", null, pendingDelete.nome), "?"),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost sm",
        "data-shortcut": "c",
        onClick: () => setPendingDelete(null)
      },
      "Cancelar",
      /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn primary sm",
        style: { background: "#c4434b" },
        onClick: doDelete
      },
      "Apagar"
    ))
  ));
}
window.ScoutContactosPanel = ScoutContactosPanel;

// ===== prospecao/frontend/conta-drawer.jsx =====
function scoutContaEstadoLabel(estado) {
  return { potencial: "Potencial", ativo: "Ativo", inativo: "Inativo" }[estado] || estado;
}
window.scoutContaEstadoLabel = scoutContaEstadoLabel;
function ScoutSection({ label, children, style }) {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 8, ...style } }, label && /* @__PURE__ */ React.createElement("div", { className: "section-label" }, label), children);
}
function ScoutOutlookIndicador({ estado }) {
  const info = {
    pendente: { classe: "sync-dot-pendente", titulo: "A sincronizar com o Outlook\u2026" },
    erro: { classe: "sync-dot-erro", titulo: "Erro a sincronizar com o Outlook \u2014 ver Atividades." },
    nao_sincronizado: { classe: "sync-dot-off", titulo: "S\xF3 no hub \u2014 n\xE3o foi para o Outlook (o autor n\xE3o tem a caixa ligada)." }
  }[estado];
  if (!info) return null;
  return /* @__PURE__ */ React.createElement("span", { className: `sync-dot ${info.classe}`, title: info.titulo }, "\u25CF");
}
function ContaRailAtividades({ contaId, contaNome }) {
  const [items, setItems] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tipo, setTipo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [dataAgendada, setDataAgendada] = useState("");
  const [realizarDatas, setRealizarDatas] = useState({});
  const [realizando, setRealizando] = useState(null);
  const [reuniao, setReuniao] = useState(null);
  const load = () => {
    setLoading(true);
    Promise.all([
      window.ScoutAPI.contaAtividades(contaId).then((r) => r.results || r).catch(() => []),
      window.ScoutAPI.contaTiposAtividade().catch(() => [])
    ]).then(([a, t]) => {
      setItems(a);
      setTipos(t);
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    load();
  }, [contaId]);
  const tipoAtual = tipos.find((t) => t.id_slug === tipo);
  const tipoVisita = tipos.find((t) => t.key === "visita");
  const agora = /* @__PURE__ */ new Date();
  const proximas = items.filter((a) => a.inicio && !a.cancelado_em && new Date(a.inicio) >= agora).sort((a, b) => new Date(a.inicio) - new Date(b.inicio)).slice(0, 5);
  const submit = async () => {
    if (!tipo || !descricao.trim()) return;
    setSaving(true);
    try {
      await window.ScoutAPI.createContaAtividade(contaId, {
        tipo,
        descricao: descricao.trim(),
        ...tipoAtual?.agendavel ? { data_agendada: dataAgendada } : {}
      });
      setDescricao("");
      setDataAgendada("");
      load();
      window.srToast?.("Atividade registada.", "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    } finally {
      setSaving(false);
    }
  };
  const marcarVisita = () => {
    if (!tipoVisita) return;
    setTipo(tipoVisita.id_slug);
  };
  const marcarRealizada = async (atividade) => {
    setRealizando(atividade.id);
    try {
      await window.ScoutAPI.realizarAtividade(contaId, atividade.id, realizarDatas[atividade.id] || void 0);
      load();
      window.srToast?.("Atividade marcada como realizada.", "success");
    } catch (e) {
      window.srToast?.(e.message, "error");
    } finally {
      setRealizando(null);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { display: "flex", alignItems: "center", gap: 8 } }, "Pr\xF3ximas reuni\xF5es", /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setReuniao({}) }, "Marcar reuni\xE3o")), proximas.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem reuni\xF5es agendadas."), proximas.map((ev) => /* @__PURE__ */ React.createElement("button", { key: ev.id, type: "button", className: "row-line", onClick: () => setReuniao(ev) }, /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, new Date(ev.inicio).toLocaleString("pt-PT", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  })), " ", /* @__PURE__ */ React.createElement("strong", null, ev.titulo), /* @__PURE__ */ React.createElement(ScoutOutlookIndicador, { estado: ev.outlook_estado }), ev.negocios_titulos?.length > 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", ev.negocios_titulos.join(", ")))), reuniao && /* @__PURE__ */ React.createElement(
    window.ScoutEventoModal,
    {
      conta: { id: contaId, name: contaNome },
      evento: reuniao.id ? reuniao : null,
      onFechar: () => setReuniao(null),
      onGravado: () => {
        setReuniao(null);
        load();
      }
    }
  ), /* @__PURE__ */ React.createElement(ScoutSection, { label: "Atividades" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: !tipoVisita,
      title: tipoVisita ? void 0 : "Defina um tipo de visita em Defini\xE7\xF5es \u2192 A\xE7\xF5es da Conta",
      onClick: marcarVisita
    },
    "Marcar visita"
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 6 } }, /* @__PURE__ */ React.createElement("select", { value: tipo, onChange: (e) => setTipo(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Tipo\u2026"), tipos.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id_slug, value: t.id_slug }, t.nome))), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      rows: 2,
      value: descricao,
      placeholder: "Descri\xE7\xE3o\u2026",
      onChange: (e) => setDescricao(e.target.value)
    }
  ), tipoAtual?.agendavel && /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "date",
      value: dataAgendada,
      onChange: (e) => setDataAgendada(e.target.value)
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn primary sm",
      disabled: saving || !tipo || !descricao.trim(),
      onClick: submit
    },
    "Registar"
  )), /* @__PURE__ */ React.createElement("ul", { className: "timeline-list" }, !loading && items.length === 0 && /* @__PURE__ */ React.createElement("li", { className: "empty" }, "Sem atividades"), items.map((a) => /* @__PURE__ */ React.createElement("li", { key: a.id }, /* @__PURE__ */ React.createElement("span", { className: "when" }, new Date(a.criado_em).toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("span", { className: "verb badge" }, a.tipo_nome), /* @__PURE__ */ React.createElement(ScoutOutlookIndicador, { estado: a.outlook_estado }), a.inicio && /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setReuniao(a) }, a.cancelado_em ? "Ver cancelamento" : "Editar evento"), /* @__PURE__ */ React.createElement("span", { className: "summary" }, a.descricao), a.data_agendada && /* @__PURE__ */ React.createElement("span", { className: "when" }, a.data_agendada), a.realizada_em ? /* @__PURE__ */ React.createElement("span", { className: "badge success" }, "Realizada em ", a.realizada_em) : /* @__PURE__ */ React.createElement("span", { className: "badge" }, "Agendada"), !a.realizada_em && /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", gap: 4, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "date",
      value: realizarDatas[a.id] || "",
      onChange: (e) => setRealizarDatas((prev) => ({ ...prev, [a.id]: e.target.value }))
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      disabled: realizando === a.id,
      onClick: () => marcarRealizada(a)
    },
    "Marcar realizada"
  )))))));
}
function ContaRail({ conta }) {
  const [logs, setLogs] = useState([]);
  const [acoes, setAcoes] = useState([]);
  const [acoesVersion, setAcoesVersion] = useState(0);
  const [tiposAcao, setTiposAcao] = useState(null);
  const refreshAcoes = () => setAcoesVersion((v) => v + 1);
  useEffect(() => {
    fetch(
      `/api/prospecao/audit/?resource=conta&resource_id=${conta.id}`,
      { credentials: "same-origin" }
    ).then((r) => r.json()).then((events) => setLogs((events || []).map((e) => ({
      id: e.id,
      evento: e.verb,
      descricao: e.summary,
      actor_username: e.actor_name,
      criado_em: e.when
    })))).catch(() => setLogs([]));
  }, [conta.id]);
  useEffect(() => {
    let cancelled = false;
    window.ScoutAPI.contaTiposAtividade().then((rows) => {
      if (cancelled) return;
      setTiposAcao((rows || []).filter((t) => t.tarefavel).map((t) => ({ id: t.id_slug, nome: t.nome })));
    }).catch(() => {
      if (!cancelled) setTiposAcao([]);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {
    let cancelled = false;
    window.ScoutAPI.contaAcoes(conta.id).then((rows) => {
      if (cancelled) return;
      setAcoes((Array.isArray(rows) ? rows : rows.results || []).map((a) => ({
        id: a.id,
        source: "acao",
        tipo: a.tipo?.id_slug,
        tipoNome: a.tipo?.nome || a.tipo?.id_slug,
        autor: a.autor_username,
        atribuido: a.atribuido_username || null,
        criadoEm: a.criado_em ? new Date(a.criado_em) : null,
        descricao: a.descricao,
        tratada: !!a.tratada_em,
        tratadaEm: a.tratada_em ? new Date(a.tratada_em) : null,
        tratadaPor: a.tratada_por_username || null,
        prazo: a.data_limite || null
      })));
    }).catch(() => {
      if (!cancelled) setAcoes([]);
    });
    return () => {
      cancelled = true;
    };
  }, [conta.id, acoesVersion]);
  const addAcao = async (tipoIdSlug, descricao, atribuidoId, prazo = null) => {
    try {
      await window.ScoutAPI.addContaAcao(
        conta.id,
        tipoIdSlug,
        descricao,
        atribuidoId,
        prazo
      );
      refreshAcoes();
    } catch (e) {
      window.srToast?.(`A\xE7\xE3o: ${e.message}`, "error");
    }
  };
  const deleteAcao = async (a) => {
    try {
      await window.ScoutAPI.deleteContaAcao(conta.id, a.id);
      refreshAcoes();
    } catch (e) {
      window.srToast?.(`Apagar: ${e.message}`, "error");
    }
  };
  const toggleAcaoTratada = async (a) => {
    try {
      await window.ScoutAPI.tratarContaAcao(conta.id, a.id);
      refreshAcoes();
    } catch (e) {
      window.srToast?.(`Tratar: ${e.message}`, "error");
    }
  };
  const setAcaoPrazo = async (a, iso) => {
    try {
      await window.ScoutAPI.prazoContaAcao(conta.id, a.id, iso);
      refreshAcoes();
    } catch (e) {
      window.srToast?.(`Prazo: ${e.message}`, "error");
    }
  };
  return /* @__PURE__ */ React.createElement(
    window.HubActionTimeline,
    {
      appLabel: "prospecao",
      appSlug: "prospecao",
      resource: "conta",
      resourceId: conta.id,
      me: window.SR_ME,
      users: window.SR_USERS || [],
      tiposAcao,
      assignable: true,
      title: "Hist\xF3rico",
      defaultTab: "acoes",
      streams: {
        acoes: {
          items: acoes,
          api: {
            onAdd: addAcao,
            onDelete: deleteAcao,
            onToggleTratada: toggleAcaoTratada,
            onSetPrazo: setAcaoPrazo
          }
        },
        logs: { items: logs }
      },
      extraTabs: [{
        key: "atividades",
        label: "Atividades",
        render: () => /* @__PURE__ */ React.createElement(ContaRailAtividades, { contaId: conta.id, contaNome: conta.name })
      }]
    }
  );
}
const CONTA_NEGOCIOS_COLUNAS = [
  {
    key: "titulo",
    label: "T\xEDtulo",
    width: 220,
    minWidth: 140,
    fixed: true,
    render: (n) => /* @__PURE__ */ React.createElement("strong", null, n.titulo)
  },
  {
    key: "fase",
    label: "Fase",
    width: 140,
    minWidth: 100,
    sortValue: (n) => n.estado ? n.estado.label : null,
    render: (n) => n.estado ? n.estado.label : "\u2014"
  },
  {
    key: "valor",
    label: "Valor",
    width: 110,
    minWidth: 90,
    render: (n) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, n.valor_eur != null ? `${n.valor_eur} \u20AC` : "\u2014")
  },
  {
    key: "data_fecho_previsto",
    label: "Fecho previsto",
    width: 150,
    minWidth: 130,
    render: (n) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, n.data_fecho_previsto || "\u2014")
  }
];
function ContaNegociosTab({ contaId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    window.ScoutAPI.negocios({ conta: contaId }).then((r) => setItems(r.results || r)).catch(() => setItems([]));
  }, [contaId]);
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "conta-negocios",
      columns: CONTA_NEGOCIOS_COLUNAS,
      data: items,
      pagination: "none",
      rowKey: (n) => n.id,
      empty: "Sem neg\xF3cios."
    }
  );
}
const CONTA_SAUDE_KV_COLUNAS = [
  {
    key: "chave",
    label: "Indicador",
    width: 200,
    minWidth: 140,
    fixed: true,
    render: (r) => r.chave
  },
  {
    key: "valor",
    label: "Valor",
    width: 160,
    minWidth: 100,
    render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, r.valor)
  }
];
function ScoutSaudeVistaGrupo({ grupo, itens }) {
  const rows = (itens || []).map((it, i) => ({
    __k: i,
    chave: it.label,
    valor: `${it.valor}${it.unidade ? ` ${it.unidade}` : ""}`
  }));
  return /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { className: "muted", style: { textTransform: "capitalize" } }, grupo), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "conta-saude-vista",
      columns: CONTA_SAUDE_KV_COLUNAS,
      data: rows,
      pagination: "none",
      rowKey: (r) => r.__k,
      empty: "Sem dados."
    }
  ));
}
function ContaSaudeTab({ conta }) {
  const [loading, setLoading] = useState(true);
  const [saude, setSaude] = useState(null);
  const [error, setError] = useState(null);
  const load = (refresh) => {
    setLoading(true);
    setError(null);
    window.ScoutAPI.contaSaude(conta.id, refresh).then((r) => {
      setSaude(r);
      if (refresh) window.srToast?.("Sa\xFAde atualizada.", "success");
    }).catch((e) => {
      setError(e.message);
      window.srToast?.("N\xE3o foi poss\xEDvel atualizar a sa\xFAde.", "error");
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    load(false);
  }, [conta.id]);
  if (loading && !saude) return /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026");
  if (error && !saude) return /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error);
  if (!saude) return null;
  const cor = (window.scoutCorSaude || ((c) => ({ label: c || "\u2014", className: "badge", style: {} })))(saude.cor);
  const porque = saude.porque || [];
  const maxPontos = Math.max(1, ...porque.map((p) => Math.abs(p.pontos || 0)));
  const inputs = saude.inputs || {};
  const vista = saude.vista || {};
  return /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("span", { className: cor.className, style: cor.style }, cor.label), saude.score != null && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "score ", saude.score), saude.avaliado_em && /* @__PURE__ */ React.createElement("span", { className: "muted", style: { marginLeft: "auto" } }, "avaliado em ", new Date(saude.avaliado_em).toLocaleString("pt-PT")), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => load(true), disabled: loading }, loading ? "A atualizar\u2026" : "Atualizar agora")), /* @__PURE__ */ React.createElement(ScoutSection, { label: "Porqu\xEA" }, porque.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem contribui\xE7\xF5es."), /* @__PURE__ */ React.createElement("ul", { className: "list", style: { display: "grid", gap: 6 } }, porque.map((p) => /* @__PURE__ */ React.createElement("li", { key: p.conceito, style: { display: "grid", gridTemplateColumns: "160px 1fr 60px", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("span", null, p.label || p.conceito), /* @__PURE__ */ React.createElement("div", { style: { background: "var(--muted-bg, #eee)", borderRadius: 4, height: 8 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: `${Math.min(100, Math.abs((p.pontos || 0) / maxPontos) * 100)}%`,
    height: "100%",
    borderRadius: 4,
    background: (p.pontos || 0) < 0 ? "#c0392b" : "#1f7a3d"
  } })), /* @__PURE__ */ React.createElement("span", { className: "td-mono", style: { textAlign: "right" } }, p.pontos, " ", /* @__PURE__ */ React.createElement("span", { className: "muted" }, "(", p.peso_efetivo, ")")))))), /* @__PURE__ */ React.createElement(ScoutSection, { label: "Indicadores" }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "conta-saude-indicadores",
      columns: CONTA_SAUDE_KV_COLUNAS,
      data: Object.entries(inputs).map(([k, v]) => ({ chave: k, valor: String(v) })),
      pagination: "none",
      rowKey: (r) => r.chave,
      empty: "Sem indicadores."
    }
  )), /* @__PURE__ */ React.createElement(ScoutSection, { label: "Vista alargada" }, Object.entries(vista).map(([grupo, itens]) => /* @__PURE__ */ React.createElement(ScoutSaudeVistaGrupo, { key: grupo, grupo, itens })), Object.keys(vista).length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem vista alargada.")));
}
function scoutDesenhoLink(row) {
  return `${row.fname || "Desenho"}${row.fext ? "." + row.fext : ""}`;
}
window.scoutDesenhoLink = scoutDesenhoLink;
const SCOUT_DOC_TIPOS = [
  ["orcamentos", "Or\xE7amentos"],
  ["encomendas", "Encomendas"],
  ["faturas", "Faturas"],
  ["guias", "Guias"]
];
function scoutRowColumns(rows) {
  if (!rows || rows.length === 0) return [];
  return Object.keys(rows[0]).filter((k) => !/stamp$/i.test(k));
}
function scoutFmtVistaCell(value, unidade) {
  if (value == null || value === "") return "\u2014";
  if (unidade === "eur3") {
    return Number(value).toLocaleString("pt-PT", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    });
  }
  if (unidade === "eur") {
    return Number(value).toLocaleString("pt-PT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  return String(value);
}
function scoutVistaColWidth(coluna, unidade) {
  if (unidade === "eur" || unidade === "eur3") return { width: 110, minWidth: 90 };
  if (/data/i.test(coluna)) return { width: 110, minWidth: 95 };
  if (/^(obrano|fno|qtt)$/i.test(coluna)) return { width: 80, minWidth: 60 };
  if (/^(design|descricao|fullname)$/i.test(coluna)) return { width: 240, minWidth: 140 };
  if (coluna === "fechada") return { width: 90, minWidth: 70 };
  return { width: 140, minWidth: 100 };
}
function ScoutDocRowsTable({ rows, colunas, onSelect, empty, viewId }) {
  const meta = colunas && colunas.length ? colunas : null;
  const cols = meta ? meta.map((c) => c.coluna).filter((k) => !/stamp$/i.test(k)) : scoutRowColumns(rows);
  const metaOf = (c) => meta ? meta.find((m) => m.coluna === c) : null;
  const COLUNAS = cols.map((c, i) => {
    const m = metaOf(c);
    return {
      key: c,
      label: m && m.label || c,
      mono: true,
      fixed: i === 0,
      ...scoutVistaColWidth(c, m && m.unidade),
      render: (row) => meta ? scoutFmtVistaCell(row[c], (m || {}).unidade) : row[c] != null && row[c] !== "" ? String(row[c]) : "\u2014"
    };
  });
  const data = (rows || []).map((row, i) => ({ ...row, __k: i }));
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId,
      columns: COLUNAS,
      data,
      pagination: "client",
      rowKey: (row) => row.__k,
      onRowClick: onSelect,
      empty
    }
  );
}
function ContaDocumentosTab({ conta }) {
  const [tipo, setTipo] = useState("orcamentos");
  const [loading, setLoading] = useState(false);
  const [docs, setDocs] = useState([]);
  const [doc, setDoc] = useState(null);
  const [linhas, setLinhas] = useState([]);
  const [linha, setLinha] = useState(null);
  const [desenhos, setDesenhos] = useState([]);
  const [docsColunas, setDocsColunas] = useState([]);
  const [linhasColunas, setLinhasColunas] = useState([]);
  useEffect(() => {
    setDoc(null);
    setLinhas([]);
    setLinha(null);
    setDesenhos([]);
    setLoading(true);
    window.ScoutAPI.contaDocumentos(conta.id, tipo).then((r) => {
      setDocs(r.rows || []);
      setDocsColunas(r.colunas || []);
    }).catch(() => {
      setDocs([]);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar os documentos.", "error");
    }).finally(() => setLoading(false));
  }, [conta.id, tipo]);
  const abrirDoc = (row) => {
    setDoc(row);
    setLinha(null);
    setDesenhos([]);
    setLoading(true);
    const chave = row.bostamp || row.ftstamp;
    window.ScoutAPI.contaDocumentosDrill(conta.id, tipo, chave).then((r) => {
      setLinhas(r.rows || []);
      setLinhasColunas(r.colunas || []);
    }).catch(() => {
      setLinhas([]);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar as linhas.", "error");
    }).finally(() => setLoading(false));
  };
  const abrirLinha = (row) => {
    setLinha(row);
    setLoading(true);
    const paiLinhas = tipo === "faturas" ? "linhas_ft" : "linhas_bo";
    window.ScoutAPI.contaDocumentosDrill(conta.id, paiLinhas, row.ref).then((r) => setDesenhos(r.rows || [])).catch(() => {
      setDesenhos([]);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar os desenhos.", "error");
    }).finally(() => setLoading(false));
  };
  return /* @__PURE__ */ React.createElement(ScoutSection, { label: "Documentos", style: { gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, SCOUT_DOC_TIPOS.map(([id, label]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: id,
      type: "button",
      className: `btn ghost sm${tipo === id ? " active" : ""}`,
      disabled: loading,
      onClick: () => setTipo(id)
    },
    label
  ))), loading && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"), !doc && !loading && /* @__PURE__ */ React.createElement(ScoutDocRowsTable, { rows: docs, colunas: docsColunas, onSelect: abrirDoc, empty: "Sem documentos.", viewId: "conta-docs" }), doc && !linha && /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 8 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => {
        setDoc(null);
        setLinhas([]);
      }
    },
    "\u2039 Documentos"
  ), !loading && /* @__PURE__ */ React.createElement(ScoutDocRowsTable, { rows: linhas, colunas: linhasColunas, onSelect: abrirLinha, empty: "Sem linhas.", viewId: "conta-linhas" })), linha && /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gap: 8 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => {
        setLinha(null);
        setDesenhos([]);
      }
    },
    "\u2039 Linhas"
  ), !loading && desenhos.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem desenhos."), /* @__PURE__ */ React.createElement("ul", { className: "list", style: { display: "grid", gap: 4 } }, desenhos.map((row, i) => /* @__PURE__ */ React.createElement("li", { key: i }, /* @__PURE__ */ React.createElement("a", { href: row.fullname, target: "_blank", rel: "noopener noreferrer" }, scoutDesenhoLink(row)))))));
}
function scoutFormatEuros(v) {
  if (v == null || v === "") return "\u2014";
  const n = Number(v);
  if (Number.isNaN(n)) return "\u2014";
  return new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(n);
}
function scoutFormatData(v) {
  if (!v) return "\u2014";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "\u2014";
  return d.toLocaleDateString("pt-PT");
}
function ContaProdutoDesenhoCell({ conta, row }) {
  const [aberto, setAberto] = useState(false);
  const [loading, setLoading] = useState(false);
  const [desenhos, setDesenhos] = useState(null);
  const toggle = () => {
    if (aberto) {
      setAberto(false);
      return;
    }
    setAberto(true);
    if (desenhos !== null) return;
    setLoading(true);
    window.ScoutAPI.contaDocumentosDrill(conta.id, "linhas_ft", row.ref).then((r) => setDesenhos(r.rows || [])).catch(() => {
      setDesenhos([]);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar os desenhos.", "error");
    }).finally(() => setLoading(false));
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: toggle }, aberto ? "Fechar" : "Ver desenho(s)"), aberto && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 4 } }, loading && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"), !loading && desenhos && desenhos.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem desenhos."), !loading && desenhos && desenhos.length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "list", style: { display: "grid", gap: 4 } }, desenhos.map((d, i) => /* @__PURE__ */ React.createElement("li", { key: i }, /* @__PURE__ */ React.createElement("a", { href: d.fullname, target: "_blank", rel: "noopener noreferrer" }, scoutDesenhoLink(d)))))));
}
function ContaProdutosTab({ conta }) {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setLoading(true);
    window.ScoutAPI.contaDocumentos(conta.id, "produtos").then((r) => setRows(r.rows || [])).catch(() => {
      setRows([]);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar os produtos.", "error");
    }).finally(() => setLoading(false));
  }, [conta.id]);
  const COLUNAS = [
    // 152 e não 136: o código mais longo que medi precisa de 136px exatos, e uma
    // largura sem margem volta a cortar no primeiro código com mais um carácter.
    // O minWidth acompanha — abaixo de 136 o arrasto repunha o corte.
    {
      key: "ref",
      label: "Artigo",
      width: 152,
      minWidth: 136,
      fixed: true,
      mono: true,
      render: (row) => row.ref || "\u2014"
    },
    {
      key: "design",
      label: "Descri\xE7\xE3o",
      width: 260,
      minWidth: 160,
      render: (row) => row.design || "\u2014"
    },
    {
      key: "total_qtt",
      label: "Qtd total",
      width: 100,
      minWidth: 80,
      mono: true,
      render: (row) => row.total_qtt != null ? row.total_qtt : "\u2014"
    },
    {
      key: "total_valor",
      label: "Total",
      width: 120,
      minWidth: 100,
      mono: true,
      render: (row) => scoutFormatEuros(row.total_valor)
    },
    {
      key: "n_faturas",
      label: "Faturas",
      width: 90,
      minWidth: 75,
      mono: true,
      render: (row) => row.n_faturas != null ? row.n_faturas : "\u2014"
    },
    {
      key: "ultima",
      label: "\xDAltima compra",
      width: 140,
      minWidth: 120,
      mono: true,
      render: (row) => scoutFormatData(row.ultima)
    },
    {
      key: "desenho",
      label: "Desenho",
      width: 150,
      minWidth: 120,
      render: (row) => row.ref ? /* @__PURE__ */ React.createElement(ContaProdutoDesenhoCell, { conta, row }) : "\u2014"
    }
  ];
  return /* @__PURE__ */ React.createElement(ScoutSection, { label: "Produtos" }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "conta-artigos",
      columns: COLUNAS,
      data: rows,
      pagination: "client",
      rowKey: (row) => row.ref,
      empty: "Sem produtos."
    }
  ));
}
function scoutFaturacaoFmt(v) {
  return Number(v || 0).toLocaleString("pt-PT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function ScoutArtTypeSparkline({ t }) {
  const sw = 160, sh = 36, sp = 3;
  const hm = t.series.slice(0, 12);
  const cur = t.series.slice(12, 24);
  const max = Math.max(0.01, ...t.series);
  const xStep = (sw - sp * 2) / Math.max(1, 11);
  const toPts = (arr) => arr.map((v, i) => `${sp + i * xStep},${sh - sp - v / max * (sh - sp * 2)}`).join(" ");
  return /* @__PURE__ */ React.createElement("span", { title: "Linha grossa: \xFAltimos 12m \xB7 Linha clara tracejada: 12m hom\xF3logo" }, /* @__PURE__ */ React.createElement("svg", { width: sw, height: sh, viewBox: `0 0 ${sw} ${sh}`, style: { display: "block" } }, /* @__PURE__ */ React.createElement(
    "polyline",
    {
      points: toPts(hm),
      fill: "none",
      stroke: "var(--muted)",
      strokeWidth: "1",
      strokeDasharray: "2 2",
      opacity: "0.7"
    }
  ), /* @__PURE__ */ React.createElement("polyline", { points: toPts(cur), fill: "none", stroke: "var(--accent)", strokeWidth: "1.8" })));
}
function ContaFaturacaoTab({ conta }) {
  const [range, setRange] = useState(() => {
    const r = window.HubCharts.resolvePreset("last-12m", /* @__PURE__ */ new Date());
    return { preset: "last-12m", from: r.from, to: r.to };
  });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [forbidden, setForbidden] = useState(false);
  useEffect(() => {
    setLoading(true);
    setForbidden(false);
    setData(null);
    window.ScoutAPI.contaFaturacao(conta.id, { from: range.from, to: range.to }).then(setData).catch((e) => {
      if (String(e.message).includes("\u2192 403")) setForbidden(true);
      else window.srToast?.("N\xE3o foi poss\xEDvel carregar a fatura\xE7\xE3o.", "error");
    }).finally(() => setLoading(false));
  }, [conta.id, range.from, range.to]);
  const fmt = scoutFaturacaoFmt;
  const TIPO_ARTIGO_COLUNAS = [
    {
      key: "tipoart",
      label: "Tipo artigo",
      width: 160,
      minWidth: 120,
      fixed: true,
      render: (t) => /* @__PURE__ */ React.createElement("strong", null, t.tipoart || "\u2014")
    },
    {
      key: "vlr_ano",
      label: "Vendas ano",
      width: 120,
      minWidth: 100,
      align: "right",
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { fontWeight: 500 } }, fmt(t.vlr_ano), " \u20AC")
    },
    {
      key: "vlr_ano_hm",
      label: "Hom\xF3logo",
      width: 120,
      minWidth: 100,
      align: "right",
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-num td-muted" }, fmt(t.vlr_ano_hm), " \u20AC")
    },
    {
      key: "delta_pct",
      label: "\u0394%",
      width: 100,
      minWidth: 80,
      align: "right",
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: t.delta_pct }))
    },
    {
      key: "qtd_l12m",
      label: "Qtd 12m",
      width: 90,
      minWidth: 75,
      align: "right",
      title: "Quantidade \xFAltimos 12 meses",
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, Number(t.qtd_l12m).toLocaleString("pt-PT", { maximumFractionDigits: 0 }))
    },
    {
      key: "skus",
      label: "SKUs",
      width: 70,
      minWidth: 55,
      align: "right",
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, t.skus)
    },
    {
      key: "evolucao",
      label: "Evolu\xE7\xE3o 24m",
      width: 175,
      minWidth: 150,
      render: (t) => /* @__PURE__ */ React.createElement(ScoutArtTypeSparkline, { t })
    }
  ];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end", marginBottom: 12 } }, /* @__PURE__ */ React.createElement(window.HubCharts.DateFilter, { value: range, onChange: setRange })), loading && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"), !loading && forbidden && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem acesso \xE0 fatura\xE7\xE3o desta conta."), !loading && !forbidden && data && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ScoutSection, { label: "Dados ERP", style: { marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12,
    color: "var(--muted)",
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap"
  } }, /* @__PURE__ */ React.createElement(window.HubCharts.TrendPill, { arrow: data.trend_arrow }), data.trend_text && /* @__PURE__ */ React.createElement(
    "span",
    {
      style: { fontFamily: "var(--font-mono)", fontSize: 11 },
      title: "F\xF3rmula de regress\xE3o"
    },
    data.trend_text
  )), data.kpis?.length > 0 && (() => {
    const visibleKpis = data.kpis.filter((k) => k.value != null);
    const hasDonut = (data.tipoart_sales || []).some((t) => Number(t.vlr_ano) > 0);
    return /* @__PURE__ */ React.createElement("div", { className: "m-kpi4", style: {
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      gridAutoRows: "1fr",
      gap: 8,
      marginBottom: 16
    } }, hasDonut && /* @__PURE__ */ React.createElement("div", { style: {
      gridColumn: "3 / span 2",
      gridRow: "1 / span 2",
      padding: 10,
      background: "var(--bg)",
      borderRadius: 6,
      border: "1px solid var(--border)",
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    } }, /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 10.5,
      color: "var(--muted)",
      fontFamily: "var(--font-mono)",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      marginBottom: 8
    } }, "Mix por tipo de artigo"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      window.HubCharts.Donut,
      {
        fmt,
        items: data.tipoart_sales.filter((t) => Number(t.vlr_ano) > 0).map((t) => ({ label: t.tipoart || "\u2014", value: t.vlr_ano })),
        size: 130
      }
    ))), visibleKpis.map((k) => /* @__PURE__ */ React.createElement(window.HubCharts.KpiCard, { key: k.indicator, kpi: k, fmt })));
  })()), /* @__PURE__ */ React.createElement(ScoutSection, { label: "Evolu\xE7\xE3o mensal \xB7 \xFAltimos 12m vs hom\xF3logo", style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement(window.HubCharts.Rolling12m, { data: data.rolling_12m, fmt })), /* @__PURE__ */ React.createElement(ScoutSection, { label: "Vendas por tipo de artigo \xB7 \xFAltimos 24 meses" }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "prospecao",
      viewId: "conta-tipos-artigo",
      columns: TIPO_ARTIGO_COLUNAS,
      data: data.tipoart_sales || [],
      pagination: "none",
      rowKey: (t) => t.tipoart,
      empty: "Sem dados em u_indicst."
    }
  ))));
}
function ContaEstruturaTab({ conta }) {
  const [loading, setLoading] = useState(true);
  const [loadingReport, setLoadingReport] = useState(false);
  const [report, setReport] = useState(void 0);
  const [indicators, setIndicators] = useState({});
  const [fetchedAt, setFetchedAt] = useState(null);
  const [full, setFull] = useState(false);
  useEffect(() => {
    setLoading(true);
    setReport(void 0);
    window.ScoutAPI.contaEstrutura(conta.id).then((r) => {
      setReport(r.report ?? null);
      setIndicators(r.indicators || {});
      setFetchedAt(r.fetched_at || null);
    }).catch(() => {
      setReport(null);
      window.srToast?.("N\xE3o foi poss\xEDvel carregar o relat\xF3rio estrutural.", "error");
    }).finally(() => setLoading(false));
  }, [conta.id]);
  const carregar = async () => {
    if (!await window.hubConfirm({ message: "Pedido pago \xE0 Apinforma (Relat\xF3rio Estrutural PLESTRUT). Continuar?" })) return;
    setLoadingReport(true);
    try {
      const r = await window.ScoutAPI.contaEstruturaCarregar(conta.id);
      setReport(r.report ?? null);
      setIndicators(r.indicators || {});
      setFetchedAt(r.fetched_at || null);
      window.srToast?.("Relat\xF3rio estrutural carregado.", "success");
    } catch (e) {
      window.srToast?.("N\xE3o foi poss\xEDvel carregar o relat\xF3rio estrutural.", "error");
    } finally {
      setLoadingReport(false);
    }
  };
  if (loading) return /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026");
  if (report == null) {
    return /* @__PURE__ */ React.createElement(ScoutSection, { label: "Informa\xE7\xE3o financeira", style: { gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem relat\xF3rio estrutural."), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: "btn ghost sm",
        onClick: carregar,
        disabled: loadingReport
      },
      loadingReport ? "A carregar\u2026" : "Carregar relat\xF3rio"
    )));
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ScoutSection, { label: "Informa\xE7\xE3o financeira" }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: carregar,
      disabled: loadingReport,
      title: "Volta a pedir o relat\xF3rio \xE0 Apinforma (pedido pago)"
    },
    loadingReport ? "A atualizar\u2026" : "Atualizar relat\xF3rio"
  )), /* @__PURE__ */ React.createElement(
    window.ScoutDBInformaIndicadores,
    {
      report,
      indicators,
      onOpenFull: () => setFull(true)
    }
  )), full && /* @__PURE__ */ React.createElement(
    window.LeadDBInformaModal,
    {
      report,
      indicators,
      fetchedAt,
      onClose: () => setFull(false)
    }
  ));
}
function ContaChips({ conta }) {
  const [fat, setFat] = useState(null);
  const [saude, setSaude] = useState(null);
  useEffect(() => {
    let alive = true;
    window.ScoutAPI.contasFaturacaoBatch([conta.nif]).then((r) => {
      if (alive) setFat(r && r[conta.nif] || null);
    }).catch(() => {
      if (alive) setFat(null);
    });
    window.ScoutAPI.contasSaude([conta.nif]).then((r) => {
      if (alive) setSaude(r && r[conta.nif] || null);
    }).catch(() => {
      if (alive) setSaude(null);
    });
    return () => {
      alive = false;
    };
  }, [conta.nif]);
  const dash = "\u2014";
  const delta = fat && fat.delta_pct != null ? fat.delta_pct : null;
  const vendasColor = delta == null ? void 0 : delta >= 0 ? "#1f7a3d" : "#c0392b";
  const arrow = delta == null ? "" : delta >= 0 ? "\u2191" : "\u2193";
  const cor = (window.scoutCorSaude || ((c) => ({ label: c || dash, className: "badge", style: {} })))(saude && saude.cor);
  const box = {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "4px 10px",
    borderRadius: 8,
    background: "var(--panel-2, #f4f5f7)",
    minWidth: 84
  };
  const chip = (label, value, style) => /* @__PURE__ */ React.createElement("div", { style: box }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, label), /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600, ...style || {} } }, value));
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: box }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: "var(--muted)" } }, "Sa\xFAde"), /* @__PURE__ */ React.createElement("span", { className: cor.className, style: cor.style }, cor.label)), chip("Vendas (ano)", fat && fat.total != null ? `${scoutFormatEuros(fat.total)} \u20AC` : dash, { color: vendasColor }), chip("Tend\xEAncia", delta == null ? dash : `${arrow} ${delta}%`, { color: vendasColor }), chip("N\xBA faturas", fat && fat.n_faturas != null ? fat.n_faturas : dash), chip("\xDAlt. compra", fat && fat.ultima_compra ? scoutFormatData(fat.ultima_compra) : dash), chip("\xDAlt. encomenda", fat && fat.ultima_encomenda ? scoutFormatData(fat.ultima_encomenda) : dash), chip("\xDAlt. contacto", conta.ultimo_contacto ? scoutFormatData(conta.ultimo_contacto) : dash));
}
function ScoutContaDrawer({ conta, onClose, onSaved, navList, currentId, onNavigate }) {
  const [tab, setTab] = useState(window.SR_ME?.apps?.includes("whale") ? "faturacao" : "detalhes");
  const [form, setForm] = useState({ ...conta });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const patch = {
        name: form.name,
        sector: form.sector,
        cae: form.cae,
        district: form.district,
        county: form.county,
        address: form.address,
        phone: form.phone,
        website: form.website,
        estado_relacao: form.estado_relacao
      };
      const updated = await window.ScoutAPI.updateConta(conta.id, patch);
      window.srToast?.("Conta gravada.", "success");
      onSaved?.(updated);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };
  const TABS = [
    ["detalhes", "Detalhes"],
    ["contactos", "Contactos"],
    ["negocios", "Neg\xF3cios"],
    ["saude", "PHC / Sa\xFAde"],
    ["documentos", "Documentos"],
    ["produtos", "Produtos"],
    ["estrutura", "Informa\xE7\xE3o financeira"],
    ...window.SR_ME?.apps?.includes("whale") ? [["faturacao", "Fatura\xE7\xE3o"]] : []
  ];
  return /* @__PURE__ */ React.createElement(
    DrawerShell,
    {
      title: conta.name,
      subtitle: `${conta.nif} \xB7 ${scoutContaEstadoLabel(conta.estado_relacao)}`,
      navList,
      currentId,
      onNavigate,
      onClose,
      side: /* @__PURE__ */ React.createElement(ContaRail, { conta }),
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn ghost sm",
          "data-shortcut": "c",
          onClick: onClose
        },
        "Cancelar",
        /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "C")
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn primary sm",
          "data-shortcut": "s",
          onClick: save,
          disabled: saving || tab !== "detalhes"
        },
        saving ? "A guardar\u2026" : "Guardar",
        /* @__PURE__ */ React.createElement("span", { className: "kbd-hint" }, "S")
      ))
    },
    /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), /* @__PURE__ */ React.createElement(ContaChips, { conta }), /* @__PURE__ */ React.createElement("div", { className: "tabs", style: { display: "flex", gap: 6, marginBottom: 12 } }, TABS.map(([id, label]) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: id,
        className: `btn ghost sm${tab === id ? " active" : ""}`,
        style: tab === id ? { borderBottom: "2px solid var(--accent, #1f7a3d)", fontWeight: 600 } : void 0,
        onClick: () => setTab(id)
      },
      label
    ))), tab === "detalhes" && /* @__PURE__ */ React.createElement(ScoutSection, { label: "Dados da conta" }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "NIF"), /* @__PURE__ */ React.createElement("input", { value: form.nif, disabled: true })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement("input", { value: form.name || "", onChange: set("name") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Estado"), /* @__PURE__ */ React.createElement("select", { value: form.estado_relacao, onChange: set("estado_relacao") }, /* @__PURE__ */ React.createElement("option", { value: "potencial" }, "Potencial"), /* @__PURE__ */ React.createElement("option", { value: "ativo" }, "Ativo"), /* @__PURE__ */ React.createElement("option", { value: "inativo" }, "Inativo"))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "CAE"), /* @__PURE__ */ React.createElement("input", { value: form.cae || "", onChange: set("cae") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Distrito"), /* @__PURE__ */ React.createElement("input", { value: form.district || "", onChange: set("district") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Concelho"), /* @__PURE__ */ React.createElement("input", { value: form.county || "", onChange: set("county") })), /* @__PURE__ */ React.createElement("div", { className: "field", style: { gridColumn: "span 2" } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Morada"), /* @__PURE__ */ React.createElement("input", { value: form.address || "", onChange: set("address") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Telefone"), /* @__PURE__ */ React.createElement("input", { value: form.phone || "", onChange: set("phone") })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Website"), /* @__PURE__ */ React.createElement("input", { value: form.website || "", onChange: set("website") })))), tab === "contactos" && /* @__PURE__ */ React.createElement(ScoutContactosPanel, { contaId: conta.id }), tab === "negocios" && /* @__PURE__ */ React.createElement(ContaNegociosTab, { contaId: conta.id }), tab === "saude" && /* @__PURE__ */ React.createElement(ContaSaudeTab, { conta }), tab === "documentos" && /* @__PURE__ */ React.createElement(ContaDocumentosTab, { conta }), tab === "produtos" && /* @__PURE__ */ React.createElement(ContaProdutosTab, { conta }), tab === "estrutura" && /* @__PURE__ */ React.createElement(ContaEstruturaTab, { conta }), tab === "faturacao" && /* @__PURE__ */ React.createElement(ContaFaturacaoTab, { conta }))
  );
}
window.ScoutContaDrawer = ScoutContaDrawer;

// ===== prospecao/frontend/contas.jsx =====
const SCOUT_CONTAS_PAGE_SIZE = 50;
function scoutCorSaude(cor) {
  const M = {
    verde: { label: "Saud\xE1vel", bg: "#1f7a3d", fg: "#ffffff" },
    amarelo: { label: "Aten\xE7\xE3o", bg: "#b7791f", fg: "#ffffff" },
    vermelho: { label: "Risco", bg: "#c0392b", fg: "#ffffff" },
    sem_dados: { label: "Sem dados", bg: "var(--muted, #9aa3ad)", fg: "#ffffff" }
  };
  const m = M[cor] || { label: cor || "\u2014", bg: "var(--muted, #9aa3ad)", fg: "#ffffff" };
  return {
    label: m.label,
    className: `badge saude-${cor || "none"}`,
    style: { background: m.bg, color: m.fg }
  };
}
window.scoutCorSaude = scoutCorSaude;
function scoutContasIntOr(v, dflt) {
  const n = parseInt(v, 10);
  return Number.isFinite(n) && n > 0 ? n : dflt;
}
function scoutContasParseSort(raw) {
  if (!raw) return [];
  return raw.split(",").filter(Boolean).map((k) => {
    const dir = k.startsWith("-") ? "desc" : "asc";
    return { key: k.replace(/^-/, ""), dir };
  });
}
function ScoutContasView() {
  const [inativos, setInativos] = useState(false);
  const initialContasParams = window.HubRouter.current().params;
  const initialPage = scoutContasIntOr(initialContasParams.get("page"), 1);
  const initialPageSize = scoutContasIntOr(initialContasParams.get("pageSize"), SCOUT_CONTAS_PAGE_SIZE);
  const initialSort = scoutContasParseSort(initialContasParams.get("sort"));
  const [viewState, setViewState] = useState({
    page: initialPage,
    pageSize: initialPageSize,
    sort: initialSort
  });
  useEffect(() => {
    window.HubRouter.setParams({
      page: viewState.page > 1 ? String(viewState.page) : null,
      pageSize: viewState.pageSize !== SCOUT_CONTAS_PAGE_SIZE ? String(viewState.pageSize) : null,
      sort: viewState.sort.length ? viewState.sort.map((s) => (s.dir === "desc" ? "-" : "") + s.key).join(",") : null
    });
  }, [viewState]);
  const [saude, setSaude] = useState({});
  const [fat, setFat] = useState({});
  const [selected, setSelected] = useState(null);
  const [reloadTok, setReloadTok] = useState(0);
  const [donoOpts, setDonoOpts] = useState([]);
  const [pageRows, setPageRows] = useState([]);
  const [zonaInput, setZonaInput] = useState("");
  const [zona, setZona] = useState("");
  const [ultimaCompraDe, setUltimaCompraDe] = useState("");
  const [ultimaCompraAte, setUltimaCompraAte] = useState("");
  useEffect(() => {
    window.ScoutAPI.contasFiltros().then((r) => setDonoOpts(r.donos || [])).catch(() => {
    });
  }, []);
  useEffect(() => {
    const t = setTimeout(() => setZona(zonaInput.trim()), 300);
    return () => clearTimeout(t);
  }, [zonaInput]);
  const loadSaude = (rows) => {
    (async () => {
      for (let i = 0; i < rows.length; i += 20) {
        const nifs = rows.slice(i, i + 20).map((r) => r.nif).filter(Boolean);
        if (!nifs.length) continue;
        try {
          const batch = await window.ScoutAPI.contasSaude(nifs);
          setSaude((prev) => ({ ...prev, ...batch }));
        } catch (e) {
        }
      }
    })();
  };
  const loadFaturacao = (rows) => {
    (async () => {
      for (let i = 0; i < rows.length; i += 20) {
        const nifs = rows.slice(i, i + 20).map((r) => r.nif).filter(Boolean);
        if (!nifs.length) continue;
        try {
          const batch = await window.ScoutAPI.contasFaturacaoBatch(nifs);
          setFat((prev) => ({ ...prev, ...batch }));
        } catch (e) {
        }
      }
    })();
  };
  const abrir = async (row) => {
    try {
      const conta = await window.ScoutAPI.contaEnsure(row.nif, row.nome, row.local);
      setSelected(conta);
    } catch (e) {
      window.srToast?.("N\xE3o foi poss\xEDvel abrir a conta.", "error");
    }
  };
  const columns = [
    { key: "nome", label: "Nome", width: 200, fixed: true, render: (r) => /* @__PURE__ */ React.createElement("strong", null, r.nome) },
    { key: "nif", label: "NIF", width: 110, mono: true },
    { key: "district", label: "Zona", width: 100, render: (r) => r.district || "\u2014" },
    { key: "local", label: "Localidade", width: 140, render: (r) => r.local || "\u2014" },
    { key: "contacto_nome", label: "Contacto", width: 150, render: (r) => r.contacto_nome || "\u2014" },
    {
      key: "estado_relacao",
      label: "Estado",
      width: 110,
      render: (r) => r.estado_relacao ? /* @__PURE__ */ React.createElement("span", { className: "badge" }, window.scoutContaEstadoLabel(r.estado_relacao)) : "\u2014"
    },
    {
      key: "saude",
      label: "Sa\xFAde",
      width: 110,
      render: (r) => {
        const s = scoutCorSaude(saude[r.nif]?.cor);
        return /* @__PURE__ */ React.createElement("span", { className: s.className, style: s.style }, s.label);
      }
    },
    // Faturação (Whales-style, batch por NIF) — n_faturas/total/delta_pct/ultima_encomenda
    // vêm de fat[nif] (null fora do scope SCOUT do utilizador → "—").
    {
      key: "n_faturas",
      label: "Faturas",
      width: 90,
      align: "right",
      mono: true,
      render: (r) => fat[r.nif]?.n_faturas ?? "\u2014"
    },
    {
      key: "total",
      label: "Total (\u20AC)",
      width: 130,
      align: "right",
      mono: true,
      render: (r) => fat[r.nif]?.total != null ? `${fat[r.nif].total.toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} \u20AC` : "\u2014"
    },
    {
      key: "delta_pct",
      label: "\u0394%",
      width: 90,
      align: "right",
      mono: true,
      render: (r) => {
        const d = fat[r.nif]?.delta_pct;
        return d == null ? "\u2014" : `${d > 0 ? "+" : ""}${d.toLocaleString("pt-PT")}%`;
      }
    },
    {
      key: "ultima_encomenda",
      label: "\xDAlt. encomenda",
      width: 130,
      mono: true,
      render: (r) => scoutFormatData(fat[r.nif]?.ultima_encomenda)
    },
    // Datas + contacto do overlay local (já vêm na row, sem depender do batch).
    {
      key: "ultima_compra",
      label: "\xDAlt. compra",
      width: 120,
      mono: true,
      render: (r) => scoutFormatData(r.ultima_compra)
    },
    {
      key: "ultima_visita",
      label: "\xDAlt. visita",
      width: 120,
      mono: true,
      render: (r) => scoutFormatData(r.ultima_visita)
    },
    {
      key: "ultimo_contacto",
      label: "\xDAlt. contacto",
      width: 120,
      mono: true,
      render: (r) => scoutFormatData(r.ultimo_contacto)
    },
    { key: "n_negocios", label: "Neg\xF3cios", width: 100, align: "right", mono: true },
    { key: "n_contactos", label: "Contactos", width: 100, align: "right", mono: true },
    { key: "owner_username", label: "Dono", width: 120, render: (r) => r.owner_username || "\u2014" }
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      title: "Contas",
      toolbar: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 13 } }, "Zona:", /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          placeholder: "Distrito\u2026",
          value: zonaInput,
          onChange: (e) => setZonaInput(e.target.value),
          style: { width: 120 }
        }
      )), /* @__PURE__ */ React.createElement("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 13 } }, "\xDAltima compra:", /* @__PURE__ */ React.createElement("input", { type: "date", value: ultimaCompraDe, onChange: (e) => setUltimaCompraDe(e.target.value) }), /* @__PURE__ */ React.createElement("span", { className: "muted" }, "a"), /* @__PURE__ */ React.createElement("input", { type: "date", value: ultimaCompraAte, onChange: (e) => setUltimaCompraAte(e.target.value) })), /* @__PURE__ */ React.createElement("label", { style: { marginLeft: "auto", display: "flex", alignItems: "center", gap: 6, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: inativos, onChange: (e) => setInativos(e.target.checked) }), " Incluir inativos")),
      columns,
      search: { placeholder: "Pesquisar nome ou NIF\u2026" },
      filters: [
        { key: "dono", label: "Dono", type: "chip", options: donoOpts },
        {
          key: "localidade",
          label: "Localidade",
          type: "typeahead",
          loadOptions: (q) => window.ScoutAPI.contasLocalidades(q).then((r) => (r.localidades || []).map((l) => ({ value: l, label: l })))
        }
      ],
      fetch: ({ page, pageSize, search, filtros }) => window.ScoutAPI.contasLive(search, inativos, page, pageSize, {
        donos: [...filtros?.dono || []],
        localidades: [...filtros?.localidade || []],
        zona,
        ultima_compra_de: ultimaCompraDe,
        ultima_compra_ate: ultimaCompraAte
      }),
      fetchDeps: [inativos, zona, ultimaCompraDe, ultimaCompraAte],
      refetchToken: reloadTok,
      onRows: (rows) => {
        setPageRows(rows);
        loadSaude(rows);
        loadFaturacao(rows);
      },
      pagination: "server",
      rowKey: (r) => r.no,
      onRowClick: abrir,
      initialPage,
      initialPageSize,
      initialSort,
      onViewState: setViewState,
      empty: "Sem contas.",
      appLabel: "prospecao",
      viewId: "contas"
    }
  ), selected && /* @__PURE__ */ React.createElement(
    ScoutContaDrawer,
    {
      conta: selected,
      navList: pageRows.map((r) => ({ ...r, id: r.nif })),
      currentId: selected.nif,
      onNavigate: abrir,
      onClose: () => setSelected(null),
      onSaved: () => {
        setSelected(null);
        setReloadTok((t) => t + 1);
      }
    }
  ));
}
window.ScoutContasView = ScoutContasView;

// ===== prospecao/frontend/negocios.jsx =====
function scoutReconcileNegocios(full, pendingMoves, estados) {
  if (!pendingMoves || pendingMoves.size === 0) return full;
  return full.map((n) => {
    if (!pendingMoves.has(n.id)) return n;
    const slug = pendingMoves.get(n.id);
    const est = slug ? estados.find((e) => e.id_slug === slug) || null : null;
    return { ...n, estado: est };
  });
}
window.scoutReconcileNegocios = scoutReconcileNegocios;
const NEGOCIOS_COLUNAS = [
  {
    key: "titulo",
    label: "T\xEDtulo",
    width: 220,
    minWidth: 140,
    fixed: true,
    render: (n) => /* @__PURE__ */ React.createElement("strong", null, n.titulo)
  },
  {
    key: "conta_nome",
    label: "Conta",
    width: 170,
    minWidth: 120,
    render: (n) => n.conta_nome
  },
  {
    key: "fase",
    label: "Fase",
    width: 140,
    minWidth: 110,
    sortValue: (n) => n.estado ? n.estado.label : null,
    render: (n) => n.estado ? /* @__PURE__ */ React.createElement("span", { className: "badge", style: { background: n.estado.color || void 0 } }, n.estado.label) : "\u2014"
  },
  {
    key: "valor_eur",
    label: "Valor",
    width: 110,
    minWidth: 90,
    align: "right",
    render: (n) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, n.valor_eur != null ? `${n.valor_eur} \u20AC` : "\u2014")
  },
  {
    key: "data_fecho_previsto",
    label: "Fecho previsto",
    width: 140,
    minWidth: 120,
    render: (n) => /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, n.data_fecho_previsto || "\u2014")
  },
  {
    key: "owner_username",
    label: "Dono",
    width: 130,
    minWidth: 100,
    render: (n) => n.owner_username || "\u2014"
  }
];
function ScoutNegociosView() {
  const [view, setView] = useState("list");
  const [items, setItems] = useState([]);
  const [estados, setEstados] = useState([]);
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState("");
  const pendingMovesRef = useRef(/* @__PURE__ */ new Map());
  const [dragOverSlug, setDragOverSlug] = useState(null);
  const draggingIdRef = useRef(null);
  useEffect(() => {
    window.ScoutAPI.negocioEstados().then((r) => setEstados((r.results || r).filter((e) => e.is_active))).catch(() => {
    });
  }, []);
  const load = async () => {
    setLoading(true);
    setError(null);
    const fullParams = { card: "1", limit: 1e3 };
    let board = null;
    try {
      board = await window.ScoutAPI.negociosBoard();
    } catch (e) {
    }
    if (!board) {
      try {
        const r = await window.ScoutAPI.negocios(fullParams);
        setItems(r.results || r);
      } catch (e2) {
        setError(e2.message);
      } finally {
        setLoading(false);
      }
      return;
    }
    setCounts(board.counts || {});
    setItems(board.cards || []);
    setLoading(false);
    try {
      const r = await window.ScoutAPI.negocios(fullParams);
      const full = r.results || r;
      setItems(scoutReconcileNegocios(full, pendingMovesRef.current, estados));
    } catch (e2) {
      setError(e2.message);
    }
  };
  useEffect(() => {
    load();
  }, []);
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((n) => `${n.titulo} ${n.conta_nome}`.toLowerCase().includes(q));
  }, [items, query]);
  const columns = [
    { id_slug: "_unset", label: "Por classificar", color: "var(--muted)", ordem: -1 },
    ...estados
  ];
  const grouped = useMemo(() => {
    const out = {};
    columns.forEach((c) => {
      out[c.id_slug] = [];
    });
    filtered.forEach((n) => {
      const slug = n.estado ? n.estado.id_slug : "_unset";
      (out[slug] = out[slug] || []).push(n);
    });
    return out;
  }, [filtered, estados]);
  const onDrop = async (slug) => {
    setDragOverSlug(null);
    const id = draggingIdRef.current;
    draggingIdRef.current = null;
    if (!id) return;
    const target = slug === "_unset" ? null : slug;
    const neg = items.find((n) => n.id === id);
    if (neg && (neg.estado?.id_slug || null) === target) return;
    const prev = items;
    const sourceSlug = neg?.estado?.id_slug || "_unset";
    const targetSlug = target || "_unset";
    const targetEstado = target ? estados.find((e) => e.id_slug === target) : null;
    setItems(items.map((n) => n.id === id ? { ...n, estado: targetEstado } : n));
    pendingMovesRef.current.set(id, target);
    setCounts((c) => ({
      ...c,
      [sourceSlug]: Math.max(0, (c[sourceSlug] ?? 1) - 1),
      [targetSlug]: (c[targetSlug] ?? 0) + 1
    }));
    try {
      await window.ScoutAPI.updateNegocio(id, { estado_id_slug: target });
      pendingMovesRef.current.delete(id);
    } catch (e) {
      setItems(prev);
      pendingMovesRef.current.delete(id);
      setCounts((c) => ({
        ...c,
        [sourceSlug]: (c[sourceSlug] ?? 0) + 1,
        [targetSlug]: Math.max(0, (c[targetSlug] ?? 1) - 1)
      }));
      window.srToast?.(e.message, "error");
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Neg\xF3cios"), /* @__PURE__ */ React.createElement(
    "input",
    {
      placeholder: "Pesquisar t\xEDtulo ou conta\u2026",
      value: query,
      onChange: (e) => setQuery(e.target.value),
      style: { marginLeft: "auto", minWidth: 240 }
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `btn ghost sm${view === "list" ? " active" : ""}`,
      onClick: () => setView("list")
    },
    "Lista"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `btn ghost sm${view === "kanban" ? " active" : ""}`,
      onClick: () => setView("kanban")
    },
    "Kanban"
  )), error && /* @__PURE__ */ React.createElement("div", { className: "alert error" }, error), loading && view !== "list" && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar", role: "progressbar", "aria-label": "A carregar" }), view === "list" ? /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "prospecao",
      viewId: "negocios",
      columns: NEGOCIOS_COLUNAS,
      data: filtered,
      initialSort: [{ key: "titulo", dir: "asc" }],
      pagination: "none",
      rowKey: (n) => n.id,
      onRowClick: () => {
      },
      empty: "Sem neg\xF3cios."
    }
  ) : /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, overflowX: "auto" } }, columns.map((col) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: col.id_slug,
      className: `kanban-col${dragOverSlug === col.id_slug ? " drag-over" : ""}`,
      style: { minWidth: 240 },
      onDragOver: (e) => {
        e.preventDefault();
        setDragOverSlug(col.id_slug);
      },
      onDragLeave: () => setDragOverSlug(null),
      onDrop: () => onDrop(col.id_slug)
    },
    /* @__PURE__ */ React.createElement("div", { className: "kanban-col-h" }, /* @__PURE__ */ React.createElement("span", { style: { color: col.color } }, col.label), /* @__PURE__ */ React.createElement("span", { className: "badge" }, counts[col.id_slug] ?? (grouped[col.id_slug] || []).length)),
    (grouped[col.id_slug] || []).map((n) => /* @__PURE__ */ React.createElement(
      "div",
      {
        key: n.id,
        className: "kanban-card",
        draggable: true,
        onDragStart: () => {
          draggingIdRef.current = n.id;
        }
      },
      /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, n.titulo)),
      /* @__PURE__ */ React.createElement("div", { className: "muted" }, n.conta_nome),
      n.valor_eur != null && /* @__PURE__ */ React.createElement("div", { className: "td-mono" }, n.valor_eur, " \u20AC")
    ))
  ))));
}
window.ScoutNegociosView = ScoutNegociosView;

// ===== prospecao/frontend/evento-modal.jsx =====
function _localInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}
function _paraISO(valor) {
  return valor ? new Date(valor).toISOString() : null;
}
function ScoutEventoModal({ conta, evento, inicioSugerido, onFechar, onGravado }) {
  const { useState, useEffect } = React;
  const [assunto, setAssunto] = useState(evento?.assunto || "");
  const [tipo, setTipo] = useState(evento?.tipo || "");
  const [inicio, setInicio] = useState(_localInput(evento?.inicio || inicioSugerido));
  const [fim, setFim] = useState(_localInput(evento?.fim));
  const [diaInteiro, setDiaInteiro] = useState(!!evento?.dia_inteiro);
  const [local, setLocal] = useState(evento?.local || "");
  const [descricao, setDescricao] = useState(evento?.descricao || "");
  const [negocios, setNegocios] = useState(evento?.negocios || []);
  const [participantes, setParticipantes] = useState(evento?.participantes || []);
  const [convidar, setConvidar] = useState(!!evento?.convidar);
  const [tipos, setTipos] = useState([]);
  const [opcoesNegocio, setOpcoesNegocio] = useState([]);
  const [opcoesContacto, setOpcoesContacto] = useState([]);
  const [erro, setErro] = useState("");
  const [aGravar, setAGravar] = useState(false);
  const [aCancelar, setACancelar] = useState(false);
  useEffect(() => {
    window.ScoutAPI.contaTiposAtividade().then((ts) => {
      const agendaveis = ts.filter((t) => t.agendavel);
      setTipos(agendaveis);
      if (!tipo && agendaveis.length) setTipo(agendaveis[0].id_slug);
    }).catch(() => setTipos([]));
  }, []);
  useEffect(() => {
    if (!conta?.id) return;
    window.ScoutAPI.negocios({ conta: conta.id }).then((r) => setOpcoesNegocio(r.results || r)).catch(() => {
    });
    window.ScoutAPI.contactos({ conta: conta.id }).then((r) => setOpcoesContacto(r.results || r)).catch(() => {
    });
  }, [conta?.id]);
  function alternar(lista, setLista, id) {
    setLista(lista.includes(id) ? lista.filter((x) => x !== id) : [...lista, id]);
  }
  async function gravar() {
    setErro("");
    setAGravar(true);
    const payload = {
      tipo: tipo || null,
      assunto,
      local,
      descricao,
      inicio: _paraISO(inicio),
      fim: _paraISO(fim),
      dia_inteiro: diaInteiro,
      negocios,
      participantes,
      convidar
    };
    try {
      const guardado = evento?.id ? await window.ScoutAPI.updateContaEvento(conta.id, evento.id, payload) : await window.ScoutAPI.createContaEvento(conta.id, payload);
      onGravado && onGravado(guardado);
      onFechar && onFechar();
    } catch (e) {
      setErro(String(e.message || e));
    } finally {
      setAGravar(false);
    }
  }
  async function cancelarReuniao() {
    const ok = await window.hubConfirm({
      title: "Cancelar reuni\xE3o",
      message: evento?.cancelado_em ? "O \xFAltimo pedido de cancelamento n\xE3o chegou a sincronizar com o Outlook. Repetir o pedido?" : "A reuni\xE3o sai do calend\xE1rio (fica na timeline da conta) e \xE9 apagada do Outlook. Esta a\xE7\xE3o n\xE3o pode ser desfeita pela interface.",
      confirmLabel: "Cancelar reuni\xE3o"
    });
    if (!ok) return;
    setErro("");
    setACancelar(true);
    try {
      const atualizado = await window.ScoutAPI.cancelarContaEvento(conta.id, evento.id);
      onGravado && onGravado(atualizado);
      onFechar && onFechar();
    } catch (e) {
      setErro(String(e.message || e));
    } finally {
      setACancelar(false);
    }
  }
  const onFecharRef = React.useRef(onFechar);
  onFecharRef.current = onFechar;
  useEffect(() => window.HubLayers.push(
    () => {
      onFecharRef.current && onFecharRef.current();
    }
  ), []);
  return /* @__PURE__ */ React.createElement("div", { className: "modal-backdrop" }, /* @__PURE__ */ React.createElement("div", { className: "modal", onClick: (e) => e.stopPropagation(), style: { maxWidth: 560 } }, /* @__PURE__ */ React.createElement("div", { className: "modal-head" }, /* @__PURE__ */ React.createElement("strong", null, evento?.id ? "Editar reuni\xE3o" : "Marcar reuni\xE3o"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, conta?.name)), /* @__PURE__ */ React.createElement("div", { className: "modal-body", style: { display: "grid", gap: 10 } }, /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Assunto"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: assunto,
      onChange: (e) => setAssunto(e.target.value),
      placeholder: "Vazio \u2192 tipo + nome da conta"
    }
  )), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Tipo"), /* @__PURE__ */ React.createElement("select", { value: tipo, onChange: (e) => setTipo(e.target.value) }, tipos.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.id_slug, value: t.id_slug }, t.nome)))), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: diaInteiro,
      onChange: (e) => setDiaInteiro(e.target.checked)
    }
  ), " Dia inteiro")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement("label", { className: "field", style: { flex: 1 } }, /* @__PURE__ */ React.createElement("span", null, "In\xEDcio"), /* @__PURE__ */ React.createElement("input", { type: "datetime-local", value: inicio, onChange: (e) => setInicio(e.target.value) })), /* @__PURE__ */ React.createElement("label", { className: "field", style: { flex: 1 } }, /* @__PURE__ */ React.createElement("span", null, "Fim"), /* @__PURE__ */ React.createElement("input", { type: "datetime-local", value: fim, onChange: (e) => setFim(e.target.value) }))), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Local"), /* @__PURE__ */ React.createElement("input", { value: local, onChange: (e) => setLocal(e.target.value) })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Neg\xF3cios"), /* @__PURE__ */ React.createElement("div", { className: "chips" }, opcoesNegocio.map((n) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: n.id,
      type: "button",
      className: negocios.includes(n.id) ? "chip chip-on" : "chip",
      onClick: () => alternar(negocios, setNegocios, n.id)
    },
    n.titulo
  )), !opcoesNegocio.length && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Sem neg\xF3cios nesta conta."))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Participantes"), /* @__PURE__ */ React.createElement("div", { className: "chips" }, opcoesContacto.map((c) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: c.id,
      type: "button",
      className: participantes.includes(c.id) ? "chip chip-on" : "chip",
      onClick: () => alternar(participantes, setParticipantes, c.id)
    },
    c.nome,
    c.email ? "" : " (sem email)"
  )), !opcoesContacto.length && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Sem contactos nesta conta."))), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: convidar,
      onChange: (e) => setConvidar(e.target.checked)
    }
  ), " Enviar convite ao cliente"), /* @__PURE__ */ React.createElement("small", { className: "muted" }, "Desligado: o evento fica s\xF3 na tua agenda.")), /* @__PURE__ */ React.createElement("label", { className: "field" }, /* @__PURE__ */ React.createElement("span", null, "Notas"), /* @__PURE__ */ React.createElement("textarea", { rows: 3, value: descricao, onChange: (e) => setDescricao(e.target.value) })), erro && /* @__PURE__ */ React.createElement("div", { className: "erro" }, erro)), /* @__PURE__ */ React.createElement("div", { className: "modal-foot" }, evento?.id && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn danger sm",
      disabled: aCancelar || aGravar,
      style: { marginRight: "auto" },
      onClick: cancelarReuniao
    },
    aCancelar ? "A cancelar\u2026" : evento?.cancelado_em ? "Repetir cancelamento" : "Cancelar reuni\xE3o"
  ), /* @__PURE__ */ React.createElement("button", { className: "btn", onClick: onFechar, disabled: aCancelar }, "Fechar"), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-primary",
      disabled: aGravar || aCancelar || !inicio,
      onClick: gravar
    },
    aGravar ? "A gravar\u2026" : "Gravar"
  ))));
}
window.ScoutEventoModal = ScoutEventoModal;

// ===== prospecao/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "prospecao",
  order: 2,
  name: "SCOUT",
  sub: "Prospe\xE7\xE3o B2B",
  accent: "#0e766e",
  brandLogo: "/static/assets/scout-icon.png",
  brandEmoji: "\u{1F52D}",
  brandLogoFallback: {
    src: "/static/assets/scout-logo.png",
    imgStyles: { width: "60px", height: "auto", objectPosition: "top", objectFit: "cover" },
    containerHeight: "38px"
  },
  home: "prospecao",
  launcher: true,
  frontendFiles: [
    "frontend/scout-api.jsx",
    "frontend/dbinforma-panel.jsx",
    "frontend/view.jsx",
    "frontend/admin.jsx",
    "frontend/admin-outlook.jsx",
    "frontend/admin-scout-districts.jsx",
    "frontend/admin-scout-sectors.jsx",
    "frontend/admin-negocio-estados.jsx",
    "frontend/admin-phc-saude.jsx",
    "frontend/admin-saude-config.jsx",
    "frontend/admin-phc-vistas.jsx",
    "frontend/admin-phc-vendedores.jsx",
    "frontend/admin-conta-acoes.jsx",
    "frontend/contactos.jsx",
    "frontend/conta-drawer.jsx",
    "frontend/contas.jsx",
    "frontend/negocios.jsx",
    "frontend/evento-modal.jsx"
  ],
  routes: [
    {
      id: "prospecao",
      section: "SCOUT",
      icon: "list",
      label: "Leads",
      adminOnly: false,
      title: "SCOUT \u2014 Leads",
      tooltip: "Leads",
      views: [
        { id: "list", icon: "list", label: "Lista" },
        { id: "kanban", icon: "kanban", label: "Kanban" },
        { id: "dashboard", icon: "dashboard", label: "Dashboard" }
      ],
      defaultView: "list"
    },
    { id: "prospecao_contas", section: "SCOUT", icon: "list", label: "Contas", adminOnly: false, title: "SCOUT \u2014 Contas", tooltip: "Contas (clientes e potenciais)" },
    {
      id: "prospecao_negocios",
      section: "SCOUT",
      icon: "kanban",
      label: "Neg\xF3cios",
      adminOnly: false,
      title: "SCOUT \u2014 Neg\xF3cios",
      tooltip: "Oportunidades por conta",
      views: [
        { id: "list", icon: "list", label: "Lista" },
        { id: "kanban", icon: "kanban", label: "Kanban" }
      ],
      defaultView: "list"
    },
    // SP-C: o calendário deixou de ser uma vista do SCOUT — a rota fica
    // (links antigos, este item da sidebar) mas resolveRoute() reencaminha-a
    // para 'hub_calendario' (ver ROUTE_REDIRECTS em design/src/registry.js)
    // antes de chegar a qualquer render; por isso não há entrada dela no
    // `render` map abaixo.
    { id: "prospecao_calendario", section: "SCOUT", icon: "meeting", label: "Calend\xE1rio", adminOnly: false, title: "SCOUT \u2014 Calend\xE1rio", tooltip: "Reuni\xF5es e visitas agendadas \u2014 agora no calend\xE1rio do hub" },
    { id: "prospecao_scout", section: "SCOUT", icon: "search", label: "Pesquisar", adminOnly: false, title: "SCOUT \u2014 Pesquisar empresas", tooltip: "Pesquisar com Scout" },
    { id: "prospecao_stats", section: "SCOUT", icon: "dashboard", label: "Estat\xEDsticas", adminOnly: false, title: "SCOUT \u2014 Estat\xEDsticas", tooltip: "Estat\xEDsticas" },
    { id: "prospecao_indicators", section: "SCOUT", icon: "doc", label: "Documenta\xE7\xE3o de Apoio", adminOnly: false, title: "SCOUT \u2014 Documenta\xE7\xE3o de Apoio", tooltip: "Documenta\xE7\xE3o de apoio: significado de cada indicador DBInforma" },
    { id: "prospecao_admin", section: "Configura\xE7\xF5es", icon: "cog", label: "Configura\xE7\xF5es", adminOnly: true, title: "SCOUT \u2014 Configura\xE7\xF5es", tooltip: "Configura\xE7\xF5es de Prospe\xE7\xE3o" },
    { id: "prospecao_config", section: "Configura\xE7\xF5es", icon: "cog", label: "Prospe\xE7\xE3o", adminOnly: true, title: "SCOUT \u2014 Configura\xE7\xF5es de Prospe\xE7\xE3o", tooltip: "Limiares e pesos do score de interesse" },
    { id: "prospecao_estados", section: "Configura\xE7\xF5es", icon: "list", label: "Estados da Lead", adminOnly: true, title: "SCOUT \u2014 Estados da Lead", tooltip: "Configurar o pipeline interno (Nova, Qualificada, Ganha, \u2026)" },
    { id: "prospecao_estados_negocio", section: "Configura\xE7\xF5es", icon: "list", label: "Estados do Neg\xF3cio", adminOnly: true, title: "SCOUT \u2014 Estados do Neg\xF3cio", tooltip: "Configurar as fases do pipeline de neg\xF3cios" },
    { id: "prospecao_phc_saude", section: "Configura\xE7\xF5es", icon: "cog", label: "Mapeamento PHC", adminOnly: true, title: "SCOUT \u2014 Mapeamento PHC", tooltip: "Mapeamento fechado conceito\u2192dados PHC para a sa\xFAde financeira" },
    { id: "prospecao_saude_config", section: "Configura\xE7\xF5es", icon: "cog", label: "Score de Sa\xFAde", adminOnly: true, title: "SCOUT \u2014 Score de Sa\xFAde", tooltip: "Pesos, limiares de cor e inatividade do score de sa\xFAde financeira" },
    { id: "prospecao_phc_vistas", section: "Configura\xE7\xF5es", icon: "cog", label: "Vistas PHC", adminOnly: true, title: "SCOUT \u2014 Vistas PHC", tooltip: "Vistas relacionais PHC de documentos/linhas/anexos/produtos (selects fechados, sem SQL livre)" },
    { id: "prospecao_phc_vendedores", section: "Configura\xE7\xF5es", icon: "cog", label: "Vendedor PHC", adminOnly: true, title: "SCOUT \u2014 Vendedor PHC", tooltip: "Correspond\xEAncia vendedor PHC \u2194 utilizador do hub \u2014 origem do owner de cada Conta" },
    { id: "prospecao_atribuiveis", section: "Configura\xE7\xF5es", icon: "list", label: "Utilizadores atribu\xEDveis", adminOnly: true, title: "SCOUT \u2014 Utilizadores atribu\xEDveis", tooltip: "Quem pode ser owner de um lead" },
    { id: "prospecao_conta_acoes", section: "Configura\xE7\xF5es", icon: "list", label: "A\xE7\xF5es da Conta", adminOnly: true, title: "SCOUT \u2014 A\xE7\xF5es da Conta", tooltip: "Tipos de a\xE7\xE3o/atividade das Contas (visita, chamada, email\u2026) \u2014 usados no drawer" },
    { id: "prospecao_outlook", section: "Configura\xE7\xF5es", icon: "cog", label: "Outlook", adminOnly: true, title: "SCOUT \u2014 Outlook", tooltip: "Credenciais do Microsoft Graph e estado das liga\xE7\xF5es de calend\xE1rio" }
  ],
  // Partial render map — only the pure closures (no shell-local state).
  // prospecao and prospecao_admin stay in app.jsx's ROUTE_RENDER (impure).
  render: {
    prospecao_scout: () => React.createElement(window.ScoutSearchView),
    prospecao_stats: () => React.createElement(window.ScoutStatsView),
    prospecao_indicators: () => React.createElement(window.DBInformaIndicatorsView),
    prospecao_config: () => React.createElement(window.ProspecaoSettingsView),
    prospecao_estados: () => React.createElement(window.ProspecaoEstadosView),
    prospecao_contas: () => React.createElement(window.ScoutContasView),
    prospecao_negocios: () => React.createElement(window.ScoutNegociosView),
    prospecao_estados_negocio: () => React.createElement(window.ProspecaoNegocioEstadosView),
    prospecao_phc_saude: () => React.createElement(window.ProspecaoPhcSaudeView),
    prospecao_saude_config: () => React.createElement(window.ProspecaoSaudeConfigView),
    prospecao_phc_vistas: () => React.createElement(window.ProspecaoPhcVistasView),
    prospecao_phc_vendedores: () => React.createElement(window.ProspecaoPhcVendedoresView),
    prospecao_atribuiveis: () => React.createElement(window.HubAssignableUsers, { appLabel: "prospecao", appName: "SCOUT" }),
    prospecao_conta_acoes: () => React.createElement(window.ProspecaoContaAcoesView),
    prospecao_outlook: () => React.createElement(window.ProspecaoOutlookAdminView)
  }
});

// ===== stockreborn/frontend/reaproveitamento_verde.jsx =====
window.ReapVerde = {
  // n ≥ 1 → serve para pelo menos um artigo; caso contrário, sem destaque.
  classe(n) {
    return Number(n) >= 1 ? "reap-verde" : "";
  },
  // Injeta o `<style>` uma única vez (idempotente — chamar de vários pontos
  // de montagem não duplica a regra).
  garantirEstilo() {
    if (document.getElementById("reap-verde-css")) return;
    const style = document.createElement("style");
    style.id = "reap-verde-css";
    style.textContent = `
:root { --reap-verde: #16a34a; --reap-verde-fundo: #dcfce7; }
@media (prefers-color-scheme: dark) { :root:not([data-theme="light"]) { --reap-verde-fundo: rgba(22,163,74,.18); } }
:root[data-theme="dark"] { --reap-verde-fundo: rgba(22,163,74,.18); }
tr.reap-verde:not(.selected) > td { background: var(--reap-verde-fundo); }
tr.reap-verde:not(.selected) > td:first-child { box-shadow: inset 4px 0 0 var(--reap-verde); }
/* As colunas fixas do HubList t\xEAm fundo opaco (var(--panel)) com mais especificidade;
   o verde vai por cima dele, para continuarem opacas quando a linha passa por baixo. */
.dt-wrap table.dt tr.reap-verde:not(.selected):not(:hover) > td.dt-sticky-l,
.dt-wrap table.dt tr.reap-verde:not(.selected):not(:hover) > td.dt-sticky-l2 {
  background: linear-gradient(var(--reap-verde-fundo), var(--reap-verde-fundo)), var(--panel);
}
`;
    document.head.appendChild(style);
  },
  // Junta classes não vazias com espaço; `undefined` (não '') se não sobrar
  // nenhuma — é o que `rowClassName` do HubList.List espera para "sem classe".
  juntar(...classes) {
    const j = classes.filter(Boolean).join(" ");
    return j || void 0;
  }
};

// ===== stockreborn/frontend/listing.jsx =====
function Listing({ onOpenDetail, refs, setRefs, layout = "standard", reloadRefs, users = [], personalizacoes = [], onStats, servem = {} }) {
  const [includeInactive, setIncludeInactive] = useState(false);
  const [ghostRefs, setGhostRefs] = useState(null);
  const [ghostRefreshKey, setGhostRefreshKey] = useState(0);
  useEffect(() => {
    if (!includeInactive) {
      setGhostRefs(null);
      return;
    }
    let cancelled = false;
    (async () => {
      const fresh = await window.API.catalog({ include_inactive: 1, limit: 1e4 });
      if (cancelled) return;
      const items = fresh.results.map((raw) => {
        const adapted = window.adaptCatalogItem(raw);
        adapted.ativoNoErp = raw.ativo_no_erp;
        adapted.ultimoVistoEm = raw.ultimo_visto_em;
        return adapted;
      });
      setGhostRefs(items);
    })();
    return () => {
      cancelled = true;
    };
  }, [includeInactive, ghostRefreshKey]);
  useEffect(() => {
    const intent = window.SR_NAV_INTENT;
    if (intent && intent.includeInactive) {
      setIncludeInactive(true);
    }
    if (intent) {
      window.SR_NAV_INTENT = null;
    }
  }, []);
  const reloadGhostRefs = () => {
    if (ghostRefs !== null) setGhostRefreshKey((k) => k + 1);
  };
  const effectiveRefs = ghostRefs || refs;
  const [search, setSearch] = useState("");
  const [filterFlag, setFilterFlag] = useState(/* @__PURE__ */ new Set());
  const [filterFamilia, setFilterFamilia] = useState(/* @__PURE__ */ new Set());
  const [filterArtigo, setFilterArtigo] = useState(/* @__PURE__ */ new Set());
  const [filterAquis, setFilterAquis] = useState(/* @__PURE__ */ new Set());
  const [filterEstado, setFilterEstado] = useState(() => new Set(
    (window.SR_DATA?.estados || []).filter((s) => !s.terminal).map((s) => s.id)
  ));
  const [filterVendedor, setFilterVendedor] = useState(/* @__PURE__ */ new Set());
  const [filterAtribuido, setFilterAtribuido] = useState(() => {
    const me = window.SR_ME?.username;
    return me ? /* @__PURE__ */ new Set([me]) : /* @__PURE__ */ new Set();
  });
  const [filterFefco, setFilterFefco] = useState(/* @__PURE__ */ new Set());
  const [maxEncPct, setMaxEncPct] = useState("0");
  const [sort, setSort] = useState({ key: "valor", dir: "desc" });
  const [selected, setSelected] = useState(/* @__PURE__ */ new Set());
  const [groupBy, setGroupBy] = useState(null);
  const [sideRef, setSideRef] = useState(null);
  const [pickComercial, setPickComercial] = useState(false);
  const serializeFilters = () => ({
    search,
    includeInactive,
    filterFlag: Array.from(filterFlag),
    filterFamilia: Array.from(filterFamilia),
    filterArtigo: Array.from(filterArtigo),
    filterAquis: Array.from(filterAquis),
    filterEstado: Array.from(filterEstado),
    filterVendedor: Array.from(filterVendedor),
    filterAtribuido: Array.from(filterAtribuido),
    filterFefco: Array.from(filterFefco),
    maxEncPct,
    sort,
    groupBy
  });
  const applyFilters = (s) => {
    if (!s || typeof s !== "object") return;
    if ("search" in s) setSearch(s.search || "");
    if ("includeInactive" in s) setIncludeInactive(!!s.includeInactive);
    const set = (v) => new Set(Array.isArray(v) ? v : []);
    if ("filterFlag" in s) setFilterFlag(set(s.filterFlag));
    if ("filterFamilia" in s) setFilterFamilia(set(s.filterFamilia));
    if ("filterArtigo" in s) setFilterArtigo(set(s.filterArtigo));
    if ("filterAquis" in s) setFilterAquis(set(s.filterAquis));
    if ("filterEstado" in s) setFilterEstado(set(s.filterEstado));
    if ("filterVendedor" in s) setFilterVendedor(set(s.filterVendedor));
    if ("filterAtribuido" in s) setFilterAtribuido(set(s.filterAtribuido));
    if ("filterFefco" in s) setFilterFefco(set(s.filterFefco));
    if ("maxEncPct" in s) setMaxEncPct(s.maxEncPct ?? "0");
    if (s.sort) setSort(s.sort);
    if ("groupBy" in s) setGroupBy(s.groupBy ?? null);
  };
  useEffect(() => {
    let cancelled = false;
    window.HubSavedViewsAPI?.getDefault("stockreborn", "listagem").then((dv) => {
      if (!cancelled && dv) applyFilters(dv.state);
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, []);
  const filtered = useMemo(() => {
    let r = effectiveRefs;
    if (search) {
      const q = search.toLowerCase();
      r = r.filter(
        (x) => x.codigo.toLowerCase().includes(q) || x.descricao.toLowerCase().includes(q) || (x.ultimoCliente || "").toLowerCase().includes(q) || (x.niNumber || "").includes(q)
      );
    }
    if (filterFlag.size) r = r.filter((x) => x.flags.some((f) => filterFlag.has(f)));
    if (filterFamilia.size) r = r.filter((x) => filterFamilia.has(x.familia));
    if (filterArtigo.size) r = r.filter((x) => filterArtigo.has(x.tipoArtigo));
    if (filterAquis.size) r = r.filter((x) => filterAquis.has(x.tipoAquis));
    if (filterEstado.size) r = r.filter((x) => filterEstado.has(x.estado));
    if (filterVendedor.size) r = r.filter((x) => filterVendedor.has(x.vendedorCod));
    if (filterAtribuido.size) {
      r = r.filter((x) => filterAtribuido.has("__none__") && !x.atribuido || x.atribuido && filterAtribuido.has(x.atribuido));
    }
    if (filterFefco.size) r = r.filter((x) => filterFefco.has(x.fefco));
    if (maxEncPct !== "" && !isNaN(Number(maxEncPct))) {
      const threshold = Number(maxEncPct);
      r = r.filter((x) => {
        const enc = x.encAbertas || 0;
        const stock = x.stock || 0;
        if (enc === 0) return true;
        if (stock === 0) return false;
        return enc / stock * 100 <= threshold;
      });
    }
    const dir = sort.dir === "asc" ? 1 : -1;
    const k = sort.key;
    return [...r].sort((a, b) => {
      let av = a[k], bv = b[k];
      if (av instanceof Date) av = av.getTime();
      if (bv instanceof Date) bv = bv.getTime();
      if (av == null) av = sort.dir === "asc" ? Infinity : -Infinity;
      if (bv == null) bv = sort.dir === "asc" ? Infinity : -Infinity;
      if (typeof av === "string") return av.localeCompare(bv) * dir;
      return ((av || 0) - (bv || 0)) * dir;
    });
  }, [effectiveRefs, search, filterFlag, filterFamilia, filterArtigo, filterAquis, filterEstado, filterVendedor, filterAtribuido, filterFefco, maxEncPct, sort]);
  const grouped = useMemo(() => {
    if (!groupBy) return null;
    return window.HubList.__agrupar(filtered, (r) => stockGroupKey(groupBy, r));
  }, [filtered, groupBy]);
  const visualList = useMemo(() => {
    if (!grouped) return filtered;
    return grouped.flatMap((g) => g.rows);
  }, [filtered, grouped]);
  const stats = useMemo(() => {
    const total = filtered.length;
    const valor = filtered.reduce((s, r) => s + r.valor, 0);
    const porTratar = filtered.filter((r) => !r.estadoTerminal).length;
    return { total, valor, porTratar };
  }, [filtered]);
  useEffect(() => {
    onStats && onStats({ refs: stats.total, valor: stats.valor, porTratar: stats.porTratar });
  }, [stats, onStats]);
  const clearFilters = () => {
    setSearch("");
    setFilterFlag(/* @__PURE__ */ new Set());
    setFilterFamilia(/* @__PURE__ */ new Set());
    setFilterArtigo(/* @__PURE__ */ new Set());
    setFilterAquis(/* @__PURE__ */ new Set());
    setFilterEstado(/* @__PURE__ */ new Set());
    setFilterVendedor(/* @__PURE__ */ new Set());
    setFilterAtribuido(/* @__PURE__ */ new Set());
    setFilterFefco(/* @__PURE__ */ new Set());
    setMaxEncPct("");
    setIncludeInactive(false);
  };
  const activeFilters = (search ? 1 : 0) + (filterFlag.size ? 1 : 0) + (filterFamilia.size ? 1 : 0) + (filterArtigo.size ? 1 : 0) + (filterAquis.size ? 1 : 0) + (filterEstado.size ? 1 : 0) + (filterVendedor.size ? 1 : 0) + (filterAtribuido.size ? 1 : 0) + (filterFefco.size ? 1 : 0) + (maxEncPct !== "" ? 1 : 0) + (includeInactive ? 1 : 0);
  const bulkAssign = async (userId) => {
    const codigos = effectiveRefs.filter((r) => selected.has(r.id)).map((r) => r.codigo);
    if (!codigos.length) return;
    try {
      await window.API.bulkAssign(codigos, userId);
      setSelected(/* @__PURE__ */ new Set());
      if (reloadRefs) await reloadRefs();
      reloadGhostRefs();
    } catch (e) {
      console.error("bulkAssign failed:", e);
    }
  };
  const _patchLocal = (codigo, patch) => {
    if (ghostRefs) {
      setGhostRefs((rs) => rs.map((x) => x.codigo === codigo ? { ...x, ...patch } : x));
    } else {
      setRefs((rs) => rs.map((x) => x.codigo === codigo ? { ...x, ...patch } : x));
    }
  };
  const setRowState = async (r, stSlug) => {
    _patchLocal(r.codigo, { estado: stSlug });
    try {
      let monoId = r.monoId;
      if (!monoId) {
        await window.API.bulkAssign([r.codigo], null);
        const created = await window.API.monos({ referencia_codigo: r.codigo });
        const results = created.results || created;
        monoId = results[0]?.id || null;
        if (monoId) _patchLocal(r.codigo, { monoId });
      }
      if (monoId) {
        await window.API.patchMono(monoId, { estado_id_slug: stSlug });
      }
    } catch (e) {
      console.error("setRowState failed:", e);
      if (reloadRefs) reloadRefs();
      reloadGhostRefs();
    }
  };
  const canAssign = window.SR_ME?.access_actions?.stockreborn?.includes("assign") ?? false;
  const setRowAssigned = async (r, userId) => {
    if (!canAssign) {
      console.warn("setRowAssigned blocked: user lacks assign action");
      return;
    }
    const username = userId ? users.find((u) => u.id === userId)?.username || null : null;
    _patchLocal(r.codigo, { atribuido: username });
    try {
      await window.API.bulkAssign([r.codigo], userId);
    } catch (e) {
      console.error("setRowAssigned failed:", e);
      if (reloadRefs) reloadRefs();
      reloadGhostRefs();
    }
  };
  const setRowPersonalizacao = async (r, slug) => {
    _patchLocal(r.codigo, { personalizacao: slug });
    try {
      let monoId = r.monoId;
      if (!monoId) {
        await window.API.bulkAssign([r.codigo], null);
        const created = await window.API.monos({ referencia_codigo: r.codigo });
        const results = created.results || created;
        monoId = results[0]?.id || null;
        if (monoId) _patchLocal(r.codigo, { monoId });
      }
      if (monoId) {
        await window.API.patchMono(monoId, { personalizacao_id_slug: slug });
      }
    } catch (e) {
      console.error("setRowPersonalizacao failed:", e);
      if (reloadRefs) reloadRefs();
      reloadGhostRefs();
    }
  };
  const bulkSetState = async (stSlug) => {
    const selectedRefs = effectiveRefs.filter((r) => selected.has(r.id));
    if (!selectedRefs.length) return;
    try {
      await Promise.all(selectedRefs.map((r) => setRowState(r, stSlug)));
      setSelected(/* @__PURE__ */ new Set());
      if (reloadRefs) await reloadRefs();
      reloadGhostRefs();
    } catch (e) {
      console.error("bulkSetState failed:", e);
    }
  };
  const bulkSetPersonalizacao = async (slug) => {
    const selectedRefs = effectiveRefs.filter((r) => selected.has(r.id));
    if (!selectedRefs.length) return;
    try {
      await Promise.all(selectedRefs.map((r) => setRowPersonalizacao(r, slug)));
      setSelected(/* @__PURE__ */ new Set());
      if (reloadRefs) await reloadRefs();
      reloadGhostRefs();
    } catch (e) {
      console.error("bulkSetPersonalizacao failed:", e);
    }
  };
  const handleRowClick = (ref) => {
    if (layout === "split") setSideRef(ref);
    else onOpenDetail(ref, visualList);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "filters" }, /* @__PURE__ */ React.createElement("div", { className: "search-input" }, /* @__PURE__ */ React.createElement(Ico.search, null), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "Pesquisar por c\xF3digo, descri\xE7\xE3o, NI ou cliente\u2026",
      value: search,
      onChange: (e) => setSearch(e.target.value)
    }
  )), window.HubSavedViews && /* @__PURE__ */ React.createElement(
    window.HubSavedViews,
    {
      appLabel: "stockreborn",
      view: "listagem",
      currentState: serializeFilters(),
      onApply: applyFilters
    }
  ), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Sinaliza\xE7\xE3o",
      value: filterFlag,
      setValue: setFilterFlag,
      options: Object.entries(SR_DATA.classificacoes).map(([k, v]) => ({ value: k, label: v.nome, dot: v.cor }))
    }
  ), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Fam\xEDlia",
      value: filterFamilia,
      setValue: setFilterFamilia,
      options: Object.entries(SR_DATA.familias).map(([k, v]) => ({ value: k, label: `${k} \u2014 ${v.nome}`, dot: v.cor }))
    }
  ), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Artigo",
      value: filterArtigo,
      setValue: setFilterArtigo,
      options: Object.entries(SR_DATA.tiposArtigo).map(([k, v]) => ({ value: k, label: v.nome, dot: v.cor }))
    }
  ), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Estado",
      value: filterEstado,
      setValue: setFilterEstado,
      options: SR_DATA.estados.map((s) => ({ value: s.id, label: s.nome, dot: s.cor }))
    }
  ), /* @__PURE__ */ React.createElement(
    ChipFilter,
    {
      label: "Atribu\xEDdo a",
      value: filterAtribuido,
      setValue: setFilterAtribuido,
      options: [
        { value: "__none__", label: "\u2014 N\xE3o atribu\xEDdo", dot: "#9aa3ad" },
        ...window.HubAtribuicoes.eligibleUsers(users, "stockreborn").map((u) => ({
          value: u.username,
          label: u.first_name ? `${u.first_name} ${u.last_name || ""}`.trim() : u.username
        }))
      ]
    }
  ), /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", { className: "filter-chip" }, /* @__PURE__ */ React.createElement(Ico.filter, null), " Mais", /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement("div", { style: { padding: 4, display: "flex", flexDirection: "column", gap: 4 } }, /* @__PURE__ */ React.createElement(
    SubFilter,
    {
      label: "Aquisi\xE7\xE3o",
      value: filterAquis,
      setValue: setFilterAquis,
      options: Object.entries(SR_DATA.tiposAquisicao).map(([k, v]) => ({ value: k, label: v.nome, dot: v.cor }))
    }
  ), /* @__PURE__ */ React.createElement(
    SubFilter,
    {
      label: "Vendedor",
      value: filterVendedor,
      setValue: setFilterVendedor,
      options: SR_DATA.vendedores.map((c) => ({ value: c.id, label: `${c.codigo} \xB7 ${c.nome}`, dot: c.cor }))
    }
  ), /* @__PURE__ */ React.createElement(
    SubFilter,
    {
      label: "Fefco",
      value: filterFefco,
      setValue: setFilterFefco,
      options: SR_DATA.fefcos.map((f) => ({ value: f, label: `Fefco ${f}` }))
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { display: "grid", gridTemplateColumns: "80px 1fr", gap: 8, alignItems: "center", padding: "4px 6px" },
      title: "Esconde refs onde encomendas abertas representam mais do que X% do stock"
    },
    /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "Enc % m\xE1x"),
    /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "number",
        min: 0,
        value: maxEncPct,
        onChange: (e) => setMaxEncPct(e.target.value),
        placeholder: "ex: 0 (sem encomendas)",
        style: { padding: "4px 6px", fontSize: 12 }
      }
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { display: "grid", gridTemplateColumns: "80px 1fr", gap: 8, alignItems: "center", padding: "4px 6px" },
      title: "Incluir refer\xEAncias que j\xE1 n\xE3o est\xE3o na vista do ERP (mantemos snapshot)"
    },
    /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "Fora ERP"),
    /* @__PURE__ */ React.createElement("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 12 } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: includeInactive,
        onChange: (e) => setIncludeInactive(e.target.checked)
      }
    ), "Incluir refs fora do ERP")
  ))), /* @__PURE__ */ React.createElement("div", { className: "filter-divider" }), /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", { className: "filter-chip" }, groupBy ? `Agrupado: ${groupByLabel(groupBy)}` : "Agrupar", /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    setGroupBy(null);
    close();
  } }, "Sem agrupamento"), /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    setGroupBy("cliente");
    close();
  } }, "Por cliente"), /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    setGroupBy("vendedor");
    close();
  } }, "Por vendedor"), /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    setGroupBy("familia");
    close();
  } }, "Por fam\xEDlia"), /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    setGroupBy("artigo");
    close();
  } }, "Por tipo de artigo"))), activeFilters > 0 && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: clearFilters }, /* @__PURE__ */ React.createElement(Ico.close, null), " Limpar (", activeFilters, ")"), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => {
        const selected2 = Array.from(filterAtribuido).filter((v) => v !== "__none__");
        if (selected2.length === 1) {
          const u = users.find((x) => x.username === selected2[0]);
          if (u) {
            window.open(`/api/reports/comercial/${u.id}/`, "_blank");
            return;
          }
        }
        setPickComercial((v) => !v);
      }
    },
    "\u{1F4C4} PDF"
  ), pickComercial && /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "comercial-pick",
      defaultValue: "",
      onChange: (e) => {
        if (e.target.value) {
          window.open(`/api/reports/comercial/${e.target.value}/`, "_blank");
          setPickComercial(false);
        }
      }
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "Escolher comercial\u2026"),
    window.HubAtribuicoes.eligibleUsers(users, "stockreborn").map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.first_name ? `${u.first_name} ${u.last_name || ""}`.trim() : u.username))
  ))), /* @__PURE__ */ React.createElement("div", { className: "m-stack", style: { display: "grid", gridTemplateColumns: layout === "split" && sideRef ? "1fr 420px" : "1fr", height: "calc(100% - 53px)", overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: { overflow: "auto", position: "relative" } }, !grouped ? /* @__PURE__ */ React.createElement(
    DataTable,
    {
      rows: filtered,
      selected,
      onSelection: setSelected,
      onRowClick: handleRowClick,
      users,
      personalizacoes,
      onSetRowState: setRowState,
      onSetRowAssigned: setRowAssigned,
      onSetRowPersonalizacao: setRowPersonalizacao,
      canAssign,
      activeRef: layout === "split" ? sideRef : null,
      servem
    }
  ) : /* @__PURE__ */ React.createElement(
    GroupedTable,
    {
      rows: filtered,
      groupByKey: groupBy,
      selected,
      onSelection: setSelected,
      onRowClick: handleRowClick,
      users,
      personalizacoes,
      onSetRowState: setRowState,
      onSetRowAssigned: setRowAssigned,
      onSetRowPersonalizacao: setRowPersonalizacao,
      canAssign,
      activeRef: layout === "split" ? sideRef : null,
      servem
    }
  )), layout === "split" && sideRef && /* @__PURE__ */ React.createElement(SideDetail, { ref0: sideRef, users, onClose: () => setSideRef(null), onOpenFull: () => {
    onOpenDetail(sideRef, visualList);
    setSideRef(null);
  } })), selected.size > 0 && /* @__PURE__ */ React.createElement(
    BulkBar,
    {
      count: selected.size,
      onClear: () => setSelected(/* @__PURE__ */ new Set()),
      onAssign: bulkAssign,
      onSetState: bulkSetState,
      onSetPersonalizacao: bulkSetPersonalizacao,
      users,
      personalizacoes,
      canAssign
    }
  ));
}
function groupByLabel(k) {
  return { cliente: "cliente", vendedor: "vendedor", familia: "fam\xEDlia", artigo: "tipo" }[k] || k;
}
function stockGroupKey(groupBy, r) {
  if (groupBy === "cliente") return r.ultimoCliente || "\u2014 sem cliente";
  if (groupBy === "vendedor") return r.vendedorCod || "\u2014 sem vendedor";
  if (groupBy === "artigo") return r.tipoArtigo;
  if (groupBy === "familia") return r.familia;
  return "\u2014";
}
function groupValor(rows) {
  return rows.reduce((s, x) => s + x.valor, 0);
}
function ChipFilter({ label, value, setValue, options }) {
  const set = value instanceof Set ? value : /* @__PURE__ */ new Set();
  const selected = options.filter((o) => set.has(o.value));
  const toggle = (v) => {
    setValue((prev) => {
      const next = new Set(prev);
      if (next.has(v)) next.delete(v);
      else next.add(v);
      return next;
    });
  };
  const summary = selected.length === 0 ? /* @__PURE__ */ React.createElement("span", null, "Todos") : selected.length === 1 ? /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 5 } }, selected[0].dot && /* @__PURE__ */ React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: selected[0].dot } }), selected[0].label) : /* @__PURE__ */ React.createElement("span", null, selected.length, " selecionados");
  return /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", { className: "filter-chip" + (set.size ? " active" : "") }, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, label, ":"), summary, /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => setValue(/* @__PURE__ */ new Set()) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14 } }), "Limpar (todos)"), options.map((o) => /* @__PURE__ */ React.createElement(MenuItem, { key: o.value, onClick: () => toggle(o.value) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, display: "inline-flex", justifyContent: "center" } }, set.has(o.value) ? "\u2713" : ""), o.dot ? /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: o.dot } }) : /* @__PURE__ */ React.createElement("span", { style: { width: 8 } }), o.label))));
}
function SubFilter({ label, value, setValue, options }) {
  const set = value instanceof Set ? value : /* @__PURE__ */ new Set();
  const summary = set.size === 0 ? "Todos" : set.size === 1 ? options.find((o) => set.has(o.value))?.label || "1 sel." : `${set.size} sel.`;
  const toggle = (v) => {
    setValue((prev) => {
      const next = new Set(prev);
      if (next.has(v)) next.delete(v);
      else next.add(v);
      return next;
    });
  };
  return /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "80px 1fr", gap: 8, alignItems: "start", padding: "4px 6px" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em", paddingTop: 4 } }, label), /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", { className: "filter-chip", style: { width: "100%", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement("span", null, summary), /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => setValue(/* @__PURE__ */ new Set()) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14 } }), "Limpar"), options.map((o) => /* @__PURE__ */ React.createElement(MenuItem, { key: o.value, onClick: () => toggle(o.value) }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, display: "inline-flex", justifyContent: "center" } }, set.has(o.value) ? "\u2713" : ""), o.label)))));
}
function stockColumns({ users = [], personalizacoes = [], onSetRowState, onSetRowAssigned, onSetRowPersonalizacao, canAssign = true }) {
  return [
    {
      // 170/140: cabem os 14 caracteres mais longos vistos em produção
      // (ex. "114A02001001I1") em fonte monoespaçada, com a folga da
      // densidade "comfortable" — 130 cortava um quarto das referências.
      key: "codigo",
      label: "Refer\xEAncia",
      width: 170,
      minWidth: 140,
      fixed: true,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-tight" }, r.codigo, r.ativoNoErp === false && /* @__PURE__ */ React.createElement(
        "span",
        {
          style: {
            fontSize: 8.5,
            padding: "0 4px",
            borderRadius: 2,
            background: "#f1e8e7",
            color: "#8a3a3a",
            border: "1px solid #d8b6b3",
            fontWeight: 600,
            marginLeft: 5,
            verticalAlign: "middle",
            whiteSpace: "nowrap"
          },
          title: r.ultimoVistoEm ? `\xDAltimo visto no ERP em ${r.ultimoVistoEm.slice(0, 10)}` : "J\xE1 n\xE3o est\xE1 no ERP"
        },
        "sem ERP"
      ))
    },
    {
      key: "descricao",
      label: "Descri\xE7\xE3o",
      width: 260,
      minWidth: 200,
      render: (r) => /* @__PURE__ */ React.createElement("span", null, r.descricao, r.temImpressao && /* @__PURE__ */ React.createElement(
        "span",
        {
          style: {
            fontSize: 8.5,
            padding: "0 4px",
            borderRadius: 2,
            background: "#fbf2e3",
            color: "#7a4f12",
            border: "1px solid #e8c896",
            fontWeight: 600,
            marginLeft: 5,
            verticalAlign: "middle",
            whiteSpace: "nowrap"
          },
          title: "Tem impress\xE3o personalizada"
        },
        "IMP"
      ))
    },
    { key: "familia", label: "Fam\xEDlia", width: 130, render: (r) => /* @__PURE__ */ React.createElement(FamiliaTag, { familia: r.familia }) },
    { key: "tipoArtigo", label: "Tipo", width: 140, render: (r) => /* @__PURE__ */ React.createElement(TipoArtigoChip, { tipo: r.tipoArtigo }) },
    {
      key: "fefco",
      label: "Fefco",
      width: 90,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted td-tight" }, orDash(r.fefco))
    },
    { key: "dimensoes", label: "Dimens\xF5es (mm)", width: 150, render: (r) => /* @__PURE__ */ React.createElement(Dim, { c: r.c, l: r.l, h: r.h }) },
    // 140: a etiqueta mais larga ("Fim de vida") e o próprio cabeçalho
    // "SINALIZAÇÃO" não cabiam em 80 — cortavam as duas coisas.
    { key: "sinalizacao", label: "Sinaliza\xE7\xE3o", width: 140, minWidth: 140, render: (r) => /* @__PURE__ */ React.createElement(FlagDots, { flags: r.flags }) },
    {
      key: "stock",
      label: "Stock",
      width: 90,
      align: "right",
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, fmtQty(r.stock), r.encAbertas > 0 && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "td-mono",
          style: { fontSize: 10.5, color: "var(--muted)" },
          title: "Encomendas abertas"
        },
        fmtQty(r.encAbertas)
      ))
    },
    {
      key: "valor",
      label: "Valor \u20AC",
      width: 110,
      align: "right",
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { color: "var(--text)", fontWeight: 500 } }, fmtEur(r.valor))
    },
    {
      key: "ultimoCliente",
      label: "\xDAltimo cliente",
      width: 200,
      minWidth: 160,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-tight" }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5 }, title: r.ultimoCliente || "" }, trimCli(r.ultimoCliente, 28)), /* @__PURE__ */ React.createElement("div", { className: "td-mono td-muted", style: { fontSize: 10.5 } }, r.nUltimoCliente || "\u2014"))
    },
    {
      key: "estado",
      label: "Estado",
      width: 150,
      render: (r) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement(InlineStatePicker, { stateId: r.estado, onChange: (slug) => onSetRowState && onSetRowState(r, slug) }))
    },
    {
      key: "personalizacao",
      label: "Personaliza\xE7\xE3o",
      width: 150,
      render: (r) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement(
        InlinePersonalizacaoPicker,
        {
          slug: r.personalizacao,
          personalizacoes,
          onChange: (slug) => onSetRowPersonalizacao && onSetRowPersonalizacao(r, slug)
        }
      ))
    },
    {
      key: "atribuido",
      label: "Atribu\xEDdo",
      width: 160,
      render: (r) => /* @__PURE__ */ React.createElement("span", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement(InlineUserPicker, { username: r.atribuido, users, appLabel: "stockreborn", onChange: (uid) => onSetRowAssigned && onSetRowAssigned(r, uid), disabled: !canAssign }))
    },
    {
      key: "ultimaSaida",
      label: "\xDAlt. sa\xEDda",
      width: 110,
      render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted td-tight", title: fmtDate(r.ultimaSaida) }, fmtDateRel(r.ultimaSaida))
    },
    // Coluna de ícone: encurtar o label em vez de alargar a coluna evita
    // empurrar a tabela para scroll horizontal só para caber um cabeçalho
    // — o conteúdo da célula é sempre um único ícone, nunca texto.
    { key: "pdf", label: "Ficha", width: 60, render: (r) => /* @__PURE__ */ React.createElement(PdfLink, { url: r.url, niNumber: r.niNumber, compact: true }) }
  ];
}
const GROUPED_COLUMN_KEYS = [
  "codigo",
  "descricao",
  "familia",
  "tipoArtigo",
  "fefco",
  "dimensoes",
  "sinalizacao",
  "stock",
  "valor",
  "estado",
  "atribuido",
  "ultimaSaida"
];
function DataTable({ rows, selected, onSelection, onRowClick, users = [], personalizacoes = [], onSetRowState, onSetRowAssigned, onSetRowPersonalizacao, canAssign = true, activeRef = null, servem = {} }) {
  const columns = stockColumns({ users, personalizacoes, onSetRowState, onSetRowAssigned, onSetRowPersonalizacao, canAssign });
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "listagem",
      columns,
      data: rows,
      pagination: "client",
      rowKey: (r) => r.id,
      onRowClick,
      selectable: true,
      selection: selected,
      onSelection,
      rowClassName: (r) => window.ReapVerde ? window.ReapVerde.juntar(
        activeRef && activeRef.id === r.id ? "selected" : null,
        r.ativoNoErp === false ? "dt-linha-esbatida" : null,
        window.ReapVerde.classe(servem[r.codigo])
      ) : [
        activeRef && activeRef.id === r.id ? "selected" : null,
        r.ativoNoErp === false ? "dt-linha-esbatida" : null
      ].filter(Boolean).join(" ") || void 0,
      empty: "Nenhuma refer\xEAncia corresponde aos filtros."
    }
  );
}
function GroupedTable({ rows, groupByKey, selected, onSelection, onRowClick, activeRef, users = [], personalizacoes = [], onSetRowState, onSetRowAssigned, onSetRowPersonalizacao, canAssign = true, servem = {} }) {
  const columns = stockColumns({ users, personalizacoes, onSetRowState, onSetRowAssigned, onSetRowPersonalizacao, canAssign }).filter((c) => GROUPED_COLUMN_KEYS.includes(c.key));
  const labelGroup = (k) => {
    if (groupByKey === "vendedor") {
      const v = SR_DATA.vendedores.find((x) => x.id === k);
      return v ? `${v.codigo} \xB7 ${v.nome}` : k;
    }
    if (groupByKey === "familia") return `${k} \u2014 ${(SR_DATA.familias[k] ?? { nome: k }).nome}`;
    return k;
  };
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "listagem-agrupada",
      columns,
      data: rows,
      rowKey: (r) => r.id,
      onRowClick,
      selectable: true,
      selection: selected,
      onSelection,
      rowClassName: (r) => window.ReapVerde ? window.ReapVerde.juntar(
        activeRef && activeRef.id === r.id ? "selected" : null,
        window.ReapVerde.classe(servem[r.codigo])
      ) : activeRef && activeRef.id === r.id ? "selected" : void 0,
      empty: "Nenhuma refer\xEAncia corresponde aos filtros.",
      groupBy: (r) => stockGroupKey(groupByKey, r),
      groupHeader: ({ key, rows: grupo }) => /* @__PURE__ */ React.createElement(React.Fragment, null, groupByKey === "vendedor" && key !== "\u2014 sem vendedor" && /* @__PURE__ */ React.createElement(ComercialPill, { id: key, compact: true }), /* @__PURE__ */ React.createElement("strong", null, labelGroup(key)), /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontFamily: "var(--font-mono)", fontSize: 11 } }, grupo.length, " refs"), /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-2)" } }, fmtEur(groupValor(grupo)))),
      groupOrder: (a, b) => groupValor(b.rows) - groupValor(a.rows)
    }
  );
}
function BulkBar({ count, onClear, onAssign, onSetState, onSetPersonalizacao, users = [], personalizacoes = [], canAssign = true }) {
  return /* @__PURE__ */ React.createElement("div", { className: "bulk-bar" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "count" }, count), " refer\xEAncia", count !== 1 ? "s" : "", " seleccionada", count !== 1 ? "s" : ""), /* @__PURE__ */ React.createElement("div", { className: "spacer" }), /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", { disabled: !canAssign, title: !canAssign ? "Sem permiss\xE3o para reatribuir" : void 0 }, /* @__PURE__ */ React.createElement(Ico.user, null), " Atribuir a\u2026 ", /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    onAssign(null);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { style: { width: 14 } }) }, "\u2014 Remover atribui\xE7\xE3o"), window.HubAtribuicoes.eligibleUsers(users, "stockreborn").map((u) => /* @__PURE__ */ React.createElement(MenuItem, { key: u.id, onClick: () => {
    onAssign(u.id);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { className: "com-avatar", style: { background: "#2c5d8a", width: 16, height: 16, fontSize: 8 } }, (u.first_name ? u.first_name[0] : u.username[0]).toUpperCase()) }, `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username)))), /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", null, /* @__PURE__ */ React.createElement(Ico.refresh, null), " Mudar estado ", /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, SR_DATA.estados.map((s) => /* @__PURE__ */ React.createElement(MenuItem, { key: s.id, onClick: () => {
    onSetState(s.id);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: s.cor } }) }, s.nome)))), /* @__PURE__ */ React.createElement(Popover, { trigger: /* @__PURE__ */ React.createElement("button", null, /* @__PURE__ */ React.createElement(Ico.tag, null), " Personaliza\xE7\xE3o ", /* @__PURE__ */ React.createElement(Ico.chevron, null)) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    onSetPersonalizacao(null);
    close();
  } }, "\u2014 Sem personaliza\xE7\xE3o"), personalizacoes.map((p) => /* @__PURE__ */ React.createElement(MenuItem, { key: p.id_slug, onClick: () => {
    onSetPersonalizacao(p.id_slug);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: p.cor } }) }, p.nome)))), /* @__PURE__ */ React.createElement("button", { onClick: () => onSetState("descartado") }, /* @__PURE__ */ React.createElement(Ico.trash, null), " Marcar p/ sucata"), /* @__PURE__ */ React.createElement("button", { onClick: onClear }, /* @__PURE__ */ React.createElement(Ico.close, null), " Limpar"));
}
function SideDetail({ ref0, onClose, onOpenFull, users = [] }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    borderLeft: "1px solid var(--border)",
    background: "var(--panel)",
    overflow: "auto",
    padding: 16,
    display: "flex",
    flexDirection: "column",
    gap: 14
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)", fontSize: 13, fontWeight: 600 } }, ref0.codigo), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 4 } }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm icon-only", onClick: onOpenFull, title: "Abrir em p\xE1gina inteira" }, /* @__PURE__ */ React.createElement(Ico.external, null)), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm icon-only", onClick: onClose }, /* @__PURE__ */ React.createElement(Ico.close, null)))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "var(--text-2)" } }, ref0.descricao), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(FlagDots, { flags: ref0.flags }), /* @__PURE__ */ React.createElement(StatePill, { stateId: ref0.estado }), /* @__PURE__ */ React.createElement(FamiliaTag, { familia: ref0.familia }), /* @__PURE__ */ React.createElement(TipoArtigoChip, { tipo: ref0.tipoArtigo })), /* @__PURE__ */ React.createElement(BoxSchema, { c: ref0.c, l: ref0.l, h: ref0.h, fefco: ref0.fefco }), /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, /* @__PURE__ */ React.createElement("div", { className: "k" }, "\xDAltimo cliente"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, orDash(ref0.ultimoCliente)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "N\xBA cliente"), /* @__PURE__ */ React.createElement("div", { className: "v" }, orDash(ref0.nUltimoCliente)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Vendedor"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, /* @__PURE__ */ React.createElement(ComercialPill, { id: ref0.vendedorCod })), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Fefco"), /* @__PURE__ */ React.createElement("div", { className: "v" }, orDash(ref0.fefco)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Aquisi\xE7\xE3o"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, orDash(ref0.tipoAquis)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Stock"), /* @__PURE__ */ React.createElement("div", { className: "v" }, fmtQty(ref0.stock), " un"), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Valor"), /* @__PURE__ */ React.createElement("div", { className: "v" }, fmtEurDec(ref0.valor)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Custo / un"), /* @__PURE__ */ React.createElement("div", { className: "v" }, fmtEurDec(ref0.custoPond)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "\xDAlt. entrada"), /* @__PURE__ */ React.createElement("div", { className: "v" }, fmtDate(ref0.ultimaEntrada)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "\xDAlt. sa\xEDda"), /* @__PURE__ */ React.createElement("div", { className: "v" }, fmtDate(ref0.ultimaSaida)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Atribu\xEDdo"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, /* @__PURE__ */ React.createElement(UserPill, { username: ref0.atribuido, users })), ref0.url && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "k" }, "Ficha t\xE9cnica"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, /* @__PURE__ */ React.createElement(PdfLink, { url: ref0.url, niNumber: ref0.niNumber })))), /* @__PURE__ */ React.createElement("button", { className: "btn primary", onClick: onOpenFull }, "Abrir detalhe completo"));
}
window.Listing = Listing;

// ===== stockreborn/frontend/detail.jsx =====
function srMapMonoStreams(mono) {
  const acoes = (mono?.acoes || []).map((a) => ({
    id: a.id,
    source: "acao",
    tipo: a.tipo?.id_slug,
    tipoNome: a.tipo?.nome || a.tipo?.id_slug,
    autor: a.autor_username,
    atribuido: a.atribuido_username || null,
    criadoEm: a.criado_em ? new Date(a.criado_em) : null,
    descricao: a.descricao,
    tratada: !!a.tratada_em,
    tratadaEm: a.tratada_em ? new Date(a.tratada_em) : null,
    tratadaPor: a.tratada_por_username || null,
    prazo: a.data_limite || null
  })).sort((a, b) => (a.criadoEm?.getTime() || 0) - (b.criadoEm?.getTime() || 0));
  const LABELS = {
    estado: "Estado",
    atribuido: "Atribui\xE7\xE3o",
    personalizacao: "Personaliza\xE7\xE3o"
  };
  const transicoes = (mono?.transicoes || []).map((t) => {
    const de = t.evento === "estado" ? t.de_estado_nome : t.de_text;
    const para = t.evento === "estado" ? t.para_estado_nome : t.para_text;
    const label = LABELS[t.evento] || t.evento;
    const descricao = de ? `${label}: ${de} \u2192 ${para || "(vazio)"}` : `${label}: definido para "${para || "(vazio)"}"`;
    return {
      // Prefixo `t-`: o id de uma transição e o de um audit log vivem em
      // tabelas distintas e colidiriam na key do React ao serem misturados.
      id: `t-${t.id}`,
      evento: t.evento,
      descricao,
      actor_username: t.autor_username || null,
      criado_em: t.em || null
    };
  });
  return { acoes, transicoes };
}
window.srMapMonoStreams = srMapMonoStreams;
const SR_CAMPOS_COM_TRANSICAO = ["estado", "atribuido_a", "personalizacao"];
function srAuditParaLogs(events) {
  return (events || []).filter((e) => {
    if (e.verb === "assigned" || e.verb === "reassigned") return false;
    const campos = e.diff?.campos;
    if (!Array.isArray(campos) || campos.length === 0) return true;
    return !campos.every((c) => SR_CAMPOS_COM_TRANSICAO.includes(c));
  }).map((e) => ({
    id: e.id,
    evento: e.verb,
    descricao: e.summary,
    actor_username: e.actor_name,
    criado_em: e.when
  }));
}
window.srAuditParaLogs = srAuditParaLogs;
function DetailDrawer({ ref0, onClose, onNavigate, navList = [], setRefs, allRefs, reloadRefs, users = [], personalizacoes = [], me = null }) {
  const [obs, setObs] = useState(ref0.observacoes || "");
  const [history, setHistory] = useState([]);
  const [transicoes, setTransicoes] = useState([]);
  const [historyVersion, setHistoryVersion] = useState(0);
  const refreshHistory = useCallback(() => setHistoryVersion((v) => v + 1), []);
  const [notas, setNotas] = useState([]);
  const [notasVersion, setNotasVersion] = useState(0);
  const refreshNotas = useCallback(() => setNotasVersion((v) => v + 1), []);
  const [followers, setFollowers] = useState([]);
  const [followersVersion, setFollowersVersion] = useState(0);
  const refreshFollowers = useCallback(() => setFollowersVersion((v) => v + 1), []);
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    setHistory([]);
    setTransicoes([]);
    if (!ref0.monoId) return;
    let cancelled = false;
    fetch(`/api/monos/${ref0.monoId}/`, { credentials: "include" }).then((r) => r.ok ? r.json() : null).then((mono) => {
      if (cancelled || !mono) return;
      const streams = srMapMonoStreams(mono);
      setHistory(streams.acoes);
      setTransicoes(streams.transicoes);
    });
    return () => {
      cancelled = true;
    };
  }, [ref0.id, ref0.monoId, historyVersion]);
  useEffect(() => {
    if (!ref0.monoId) {
      setNotas([]);
      return;
    }
    let cancelled = false;
    window.API.notes({ app_label: "stockreborn", resource: "mono", resource_id: ref0.monoId }).then((r) => {
      if (!cancelled) setNotas(Array.isArray(r) ? r : r.results || []);
    }).catch(() => {
      if (!cancelled) setNotas([]);
    });
    return () => {
      cancelled = true;
    };
  }, [ref0.monoId, notasVersion]);
  useEffect(() => {
    if (!ref0.monoId) {
      setFollowers([]);
      return;
    }
    let cancelled = false;
    window.API.followers({ app_label: "stockreborn", resource: "mono", resource_id: ref0.monoId }).then((r) => {
      if (!cancelled) setFollowers(Array.isArray(r) ? r : r.results || []);
    }).catch(() => {
      if (!cancelled) setFollowers([]);
    });
    return () => {
      cancelled = true;
    };
  }, [ref0.monoId, followersVersion]);
  useEffect(() => {
    if (!ref0.monoId) {
      setLogs([]);
      return;
    }
    let cancelled = false;
    fetch(`/api/monos/${ref0.monoId}/audit/`, { credentials: "include" }).then((r) => r.ok ? r.json() : []).then((events) => {
      if (!cancelled) setLogs(srAuditParaLogs(events));
    }).catch(() => {
      if (!cancelled) setLogs([]);
    });
    return () => {
      cancelled = true;
    };
  }, [ref0.monoId, historyVersion]);
  useEffect(() => {
    const handler = (e) => {
      const t = e.target;
      const tag = t && t.tagName || "";
      if (tag === "INPUT" || tag === "TEXTAREA" || t && t.isContentEditable) return;
      if (window.HubLayers && window.HubLayers.__size() > 0) return;
      if (e.key === "Escape") {
        onClose();
        return;
      }
      if (!onNavigate || navList.length < 2) return;
      const idx = navList.findIndex((r) => r.id === ref0.id);
      if (e.key === "ArrowLeft" && idx > 0) onNavigate(navList[idx - 1]);
      if (e.key === "ArrowRight" && idx >= 0 && idx < navList.length - 1) onNavigate(navList[idx + 1]);
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose, onNavigate, navList, ref0]);
  const updateRef = (changes) => {
    setRefs((rs) => rs.map((r) => r.id === ref0.id ? { ...r, ...changes } : r));
  };
  const ensureMonoId = async () => {
    if (ref0.monoId) return ref0.monoId;
    await window.API.bulkAssign([ref0.codigo], null);
    const created = await window.API.monos({ referencia_codigo: ref0.codigo });
    const results = created.results || created;
    const novoId = results[0]?.id || null;
    if (novoId) updateRef({ monoId: novoId });
    return novoId;
  };
  const setState = async (newState) => {
    updateRef({ estado: newState });
    try {
      const monoId = await ensureMonoId();
      if (!monoId) return;
      await window.API.patchMono(monoId, { estado_id_slug: newState });
      refreshHistory();
    } catch (e) {
      console.error("setState failed:", e);
      if (reloadRefs) reloadRefs();
    }
  };
  const canAssign = window.SR_ME?.access_actions?.stockreborn?.includes("assign") ?? false;
  const acts = window.SR_ME?.access_actions?.stockreborn || [];
  const canCreate = acts.includes("create");
  const canUpdate = acts.includes("update");
  const setAssigned = async (userId) => {
    if (!canAssign) {
      console.warn("setAssigned blocked: user lacks assign action");
      return;
    }
    const username = userId ? users.find((u) => u.id === userId)?.username || null : null;
    updateRef({ atribuido: username });
    try {
      await window.API.bulkAssign([ref0.codigo], userId);
      refreshHistory();
    } catch (e) {
      console.error("setAssigned failed:", e);
      if (reloadRefs) reloadRefs();
    }
  };
  const setPersonalizacao = async (slug) => {
    updateRef({ personalizacao: slug });
    try {
      const monoId = await ensureMonoId();
      if (!monoId) return;
      await window.API.patchMono(monoId, { personalizacao_id_slug: slug });
      refreshHistory();
    } catch (e) {
      console.error("setPersonalizacao failed:", e);
      if (reloadRefs) reloadRefs();
    }
  };
  const savedObsRef = useRef(ref0.observacoes || "");
  const obsTimerRef = useRef(null);
  const obsRef = useRef(obs);
  const monoIdRef = useRef(ref0.monoId);
  useEffect(() => {
    obsRef.current = obs;
  }, [obs]);
  useEffect(() => {
    monoIdRef.current = ref0.monoId;
  }, [ref0.monoId]);
  useEffect(() => {
    savedObsRef.current = ref0.observacoes || "";
    setObs(ref0.observacoes || "");
  }, [ref0.id]);
  const saveObs = async () => {
    if (obsTimerRef.current) {
      clearTimeout(obsTimerRef.current);
      obsTimerRef.current = null;
    }
    const current2 = obs || "";
    if (current2 === (savedObsRef.current || "")) return;
    updateRef({ observacoes: current2 });
    try {
      const monoId = await ensureMonoId();
      if (!monoId) return;
      await window.API.patchMono(monoId, { observacoes: current2 });
      savedObsRef.current = current2;
      refreshHistory();
    } catch (e) {
      console.error("saveObs failed:", e);
      if (reloadRefs) reloadRefs();
    }
  };
  useEffect(() => {
    if (obs === (savedObsRef.current || "")) return;
    if (obsTimerRef.current) clearTimeout(obsTimerRef.current);
    obsTimerRef.current = setTimeout(() => {
      saveObs();
    }, 1e3);
    return () => {
      if (obsTimerRef.current) clearTimeout(obsTimerRef.current);
    };
  }, [obs]);
  useEffect(() => () => {
    const cur = obsRef.current || "";
    if (cur !== (savedObsRef.current || "") && monoIdRef.current) {
      window.API.patchMono(monoIdRef.current, { observacoes: cur }).catch((e) => console.error("flushObs failed:", e));
    }
  }, []);
  const deleteAction = async (acao) => {
    if (!await window.hubConfirm({ message: `Apagar esta a\xE7\xE3o?

${acao.descricao}` })) return;
    setHistory((h) => h.filter((a) => a.id !== acao.id));
    if (typeof acao.id === "string" && acao.id.startsWith("tmp-")) return;
    try {
      const monoId = ref0.monoId;
      if (!monoId) return;
      await window.API.deleteAcao(monoId, acao.id);
    } catch (e) {
      console.error("deleteAction failed:", e);
      refreshHistory();
    }
  };
  const addAction = async (tipoId, descricao, atribuidoId, prazo = null) => {
    const desc = (descricao || "").trim();
    if (!desc) return;
    const tipo = SR_DATA.tiposAcao.find((t) => t.id === tipoId);
    const atribuidoUser = atribuidoId ? users.find((u) => u.id === atribuidoId) : null;
    const localAcao = {
      id: `tmp-${Date.now()}`,
      tipo: tipoId,
      tipoNome: tipo?.nome || tipoId,
      autor: null,
      atribuido: atribuidoUser ? atribuidoUser.username : null,
      criadoEm: /* @__PURE__ */ new Date(),
      descricao: desc,
      prazo: prazo || null
    };
    setHistory((h) => [...h, localAcao]);
    try {
      const monoId = await ensureMonoId();
      if (!monoId) return;
      await window.API.addAcao(monoId, tipoId, desc, atribuidoId, prazo);
      refreshHistory();
    } catch (e) {
      console.error("addAction failed:", e);
      refreshHistory();
    }
  };
  const toggleTratada = async (acao) => {
    if (typeof acao.id === "string") return;
    setHistory((h) => h.map((a) => a.id === acao.id ? { ...a, tratada: !a.tratada } : a));
    try {
      if (!ref0.monoId) return;
      await window.API.tratarAcao(ref0.monoId, acao.id);
      refreshHistory();
    } catch (e) {
      console.error("toggleTratada failed:", e);
      refreshHistory();
    }
  };
  const addNota = async (descricao) => {
    const monoId = await ensureMonoId();
    if (!monoId) return;
    await window.API.createNote(
      { app_label: "stockreborn", resource: "mono", resource_id: monoId, descricao }
    );
    refreshNotas();
  };
  const updateNota = async (notaId, descricao) => {
    await window.API.updateNote(notaId, { descricao });
    refreshNotas();
  };
  const deleteNota = async (notaId) => {
    await window.API.deleteNote(notaId);
    refreshNotas();
  };
  const followMono = async () => {
    const monoId = await ensureMonoId();
    if (!monoId) return;
    await window.API.follow({ app_label: "stockreborn", resource: "mono", resource_id: monoId });
    refreshFollowers();
  };
  const unfollowMono = async (followerId) => {
    await window.API.unfollow(followerId);
    refreshFollowers();
  };
  const followOther = async (userId) => {
    const monoId = await ensureMonoId();
    if (!monoId) return;
    await window.API.follow(
      { app_label: "stockreborn", resource: "mono", resource_id: monoId, user_id: userId }
    );
    refreshFollowers();
  };
  const logsTimeline = useMemo(
    () => [...logs, ...transicoes],
    [logs, transicoes]
  );
  const current = allRefs.find((r) => r.id === ref0.id) || ref0;
  const estados = SR_DATA.estados;
  const currentIdx = estados.findIndex((s) => s.id === current.estado);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "drawer-overlay" }), /* @__PURE__ */ React.createElement("aside", { className: "drawer" }, /* @__PURE__ */ React.createElement("header", { className: "drawer-header" }, onNavigate && navList.length > 1 && (() => {
    const idx = navList.findIndex((r) => r.id === current.id);
    const prev = idx > 0 ? navList[idx - 1] : null;
    const next = idx >= 0 && idx < navList.length - 1 ? navList[idx + 1] : null;
    return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4, marginRight: 8 } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        disabled: !prev,
        onClick: () => prev && onNavigate(prev),
        title: "Anterior"
      },
      "\u2039"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        disabled: !next,
        onClick: () => next && onNavigate(next),
        title: "Pr\xF3ximo"
      },
      "\u203A"
    ));
  })(), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 2, flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "ref-code" }, current.codigo), /* @__PURE__ */ React.createElement("div", { className: "ref-desc" }, current.descricao)), /* @__PURE__ */ React.createElement("button", { className: "drawer-close", onClick: onClose, title: "Fechar (Esc)" }, /* @__PURE__ */ React.createElement(Ico.close, null))), /* @__PURE__ */ React.createElement("div", { className: "drawer-body" }, current.ativoNoErp === false && /* @__PURE__ */ React.createElement("div", { style: {
    gridColumn: "1 / -1",
    background: "#fdf6e3",
    border: "1px solid #e6d29a",
    color: "#6a4a1c",
    padding: "8px 12px",
    borderRadius: 4,
    fontSize: 12.5,
    margin: "16px 24px 0"
  } }, /* @__PURE__ */ React.createElement("strong", null, "Fora do ERP."), " Esta refer\xEAncia j\xE1 n\xE3o aparece na vista do ERP", current.ultimoVistoEm ? `. \xDAltimo visto em ${String(current.ultimoVistoEm).slice(0, 10)}.` : ".", " Os campos do ERP refletem o \xFAltimo valor conhecido."), /* @__PURE__ */ React.createElement("div", { className: "drawer-main" }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 14, alignItems: "center" } }, /* @__PURE__ */ React.createElement(FamiliaTag, { familia: current.familia }), /* @__PURE__ */ React.createElement(TipoArtigoChip, { tipo: current.tipoArtigo }), current.fefco && /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "var(--bg)", borderColor: "var(--border)", color: "var(--text-2)" } }, /* @__PURE__ */ React.createElement(Ico.ruler, null), " Fefco ", current.fefco), /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "var(--bg)", borderColor: "var(--border)", color: "var(--text-2)" } }, orDash(current.tipoAquis)), current.temImpressao && /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "#fbf2e3", borderColor: "#e8c896", color: "#7a4f12" } }, "Impress\xE3o"), current.url && /* @__PURE__ */ React.createElement(PdfLink, { url: current.url, niNumber: current.niNumber })), current.flags && current.flags.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 18, display: "flex", gap: 6, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(FlagDots, { flags: current.flags })), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Estado de tratamento"), /* @__PURE__ */ React.createElement("div", { className: "workflow" }, estados.map((s, i) => {
    const cls = s.id === current.estado ? "current" : i < currentIdx ? "done" : "";
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: s.id,
        className: "wf-step " + cls + (!canUpdate ? " disabled" : ""),
        onClick: () => canUpdate && setState(s.id),
        title: !canUpdate ? "Sem permiss\xE3o para alterar o estado" : void 0,
        style: {
          borderColor: s.id === current.estado ? s.cor : void 0,
          cursor: canUpdate ? void 0 : "default",
          opacity: canUpdate ? void 0 : 0.6
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "center", gap: 5, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: s.cor } }), /* @__PURE__ */ React.createElement("span", null, s.nome))
    );
  })), /* @__PURE__ */ React.createElement("div", { className: "section-divider" }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Dados da refer\xEAncia ", /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted-2)", textTransform: "none" } }, "\xB7 read-only do ERP")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 24, marginTop: 10 } }, /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, /* @__PURE__ */ React.createElement("div", { className: "k" }, "Refer\xEAncia"), /* @__PURE__ */ React.createElement("div", { className: "v" }, current.codigo), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Fam\xEDlia"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, current.familia, " \u2014 ", (SR_DATA.familias[current.familia] ?? { nome: current.familia }).nome), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Tipo artigo"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, current.tipoArtigo), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Fefco"), /* @__PURE__ */ React.createElement("div", { className: "v" }, orDash(current.fefco)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Dimens\xF5es"), /* @__PURE__ */ React.createElement("div", { className: "v" }, /* @__PURE__ */ React.createElement(Dim, { c: current.c, l: current.l, h: current.h }), " mm"), /* @__PURE__ */ React.createElement("div", { className: "k" }, "NI"), /* @__PURE__ */ React.createElement("div", { className: "v" }, current.niNumber ? `NI(${current.niNumber})` : "\u2014"), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Aquisi\xE7\xE3o"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, orDash(current.tipoAquis)), /* @__PURE__ */ React.createElement("div", { className: "k" }, "Impress\xE3o"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, current.temImpressao ? "Personalizada do cliente" : "Sem impress\xE3o"), current.url && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "k" }, "Ficha t\xE9cnica"), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, /* @__PURE__ */ React.createElement(PdfLink, { url: current.url, niNumber: current.niNumber })))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(BoxSchema, { c: current.c, l: current.l, h: current.h, fefco: current.fefco, withImp: true }))), /* @__PURE__ */ React.createElement("div", { className: "section-divider" }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Observa\xE7\xF5es internas"), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      value: obs,
      onChange: (e) => setObs(e.target.value),
      onBlur: saveObs,
      placeholder: "Notas internas sobre esta refer\xEAncia\u2026",
      style: { marginTop: 8 },
      rows: 3
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "section-divider" }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Stock e valor"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginTop: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { padding: 12, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "Stock"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 600, fontVariantNumeric: "tabular-nums", marginTop: 2 } }, fmtQty(current.stock)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, "unidades"), current.encAbertas > 0 && /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { fontSize: 11.5, marginTop: 4, color: "var(--text-2)", fontFamily: "var(--font-mono)" },
      title: "Encomendas abertas"
    },
    "+",
    fmtQty(current.encAbertas),
    " enc. abertas"
  )), /* @__PURE__ */ React.createElement("div", { style: { padding: 12, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "Valor (A1)"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 600, fontVariantNumeric: "tabular-nums", marginTop: 2 } }, fmtEurDec(current.valor)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, fmtEurDec(current.custoPond), " / un")), /* @__PURE__ */ React.createElement("div", { style: { padding: 12, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "\xDAlt. entrada"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 500, marginTop: 4 } }, fmtDateRel(current.ultimaEntrada)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)" } }, fmtDate(current.ultimaEntrada))), /* @__PURE__ */ React.createElement("div", { style: { padding: 12, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "\xDAlt. sa\xEDda"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 500, marginTop: 4 } }, fmtDateRel(current.ultimaSaida)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)" } }, fmtDate(current.ultimaSaida)))), window.ReapPodeVirar && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "section-divider" }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Pode virar\u2026"), /* @__PURE__ */ React.createElement(window.ReapPodeVirar, { key: current.codigo, codigo: current.codigo })), /* @__PURE__ */ React.createElement("div", { className: "section-divider" }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "\xDAltimo cliente"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginTop: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { padding: 12, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "Cliente"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 500, marginTop: 4 }, title: current.ultimoCliente || "" }, orDash(current.ultimoCliente)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: "var(--muted)", fontFamily: "var(--font-mono)", marginTop: 2 } }, "N\xBA ", orDash(current.nUltimoCliente))), /* @__PURE__ */ React.createElement("div", { style: { padding: 12, background: "var(--bg)", borderRadius: 6, border: "1px solid var(--border)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" } }, "Vendedor respons\xE1vel (ERP)"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 4 } }, /* @__PURE__ */ React.createElement(ComercialPill, { id: current.vendedorCod })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: "var(--muted)", marginTop: 2 } }, "Comercial associado a este cliente")))), /* @__PURE__ */ React.createElement("div", { className: "drawer-side" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Atribu\xEDdo ao tratamento"), /* @__PURE__ */ React.createElement(Popover, { align: "right", trigger: /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn",
      style: { width: "100%", justifyContent: "space-between" },
      disabled: !canAssign,
      title: !canAssign ? "Sem permiss\xE3o para reatribuir" : void 0
    },
    /* @__PURE__ */ React.createElement(UserPill, { username: current.atribuido, users }),
    /* @__PURE__ */ React.createElement(Ico.chevron, null)
  ) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    setAssigned(null);
    close();
  } }, "\u2014 Remover atribui\xE7\xE3o"), window.HubAtribuicoes.eligibleUsers(users, "stockreborn").map((u) => /* @__PURE__ */ React.createElement(MenuItem, { key: u.id, onClick: () => {
    setAssigned(u.id);
    close();
  }, icon: /* @__PURE__ */ React.createElement("span", { className: "com-avatar", style: { background: "#2c5d8a", width: 16, height: 16, fontSize: 8 } }, (u.first_name ? u.first_name[0] : u.username[0]).toUpperCase()) }, `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username)))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, fontSize: 11, color: "var(--muted)" } }, "Vendedor do cliente (ERP): ", /* @__PURE__ */ React.createElement(ComercialPill, { id: current.vendedorCod, compact: true })), /* @__PURE__ */ React.createElement("div", { style: { height: 16 } }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Personaliza\xE7\xE3o"), /* @__PURE__ */ React.createElement(InlinePersonalizacaoPicker, { slug: current.personalizacao, personalizacoes, onChange: setPersonalizacao }), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(
    HubActionTimeline,
    {
      streams: {
        acoes: {
          items: history,
          api: {
            onAdd: canCreate ? (tipoId, descricao, atribuidoId, prazo) => addAction(tipoId, descricao, atribuidoId, prazo) : void 0,
            onDelete: (a) => deleteAction(a),
            onToggleTratada: (a) => toggleTratada(a),
            onSetPrazo: (a, iso) => window.API.prazoAcao(ref0.monoId, a.id, iso).then(refreshHistory)
          }
        },
        notas: {
          items: notas,
          api: {
            onAdd: (descricao) => addNota(descricao),
            onUpdate: (notaId, descricao) => updateNota(notaId, descricao),
            onDelete: (notaId) => deleteNota(notaId)
          }
        },
        logs: { items: logsTimeline }
      },
      seguidores: {
        items: followers,
        me,
        canManage: canAssign,
        users,
        onFollow: () => followMono(),
        onUnfollow: (followerId) => unfollowMono(followerId),
        onAddOther: (uid) => followOther(uid)
      },
      users,
      me,
      appLabel: "stockreborn",
      resource: "mono",
      resourceId: ref0.monoId,
      appSlug: "stockreborn",
      assignable: canAssign
    }
  )))));
}
window.DetailDrawer = DetailDrawer;

// ===== stockreborn/frontend/crossfilter.jsx =====
const CROSS_FIELD = { estado: "estado", familia: "familia", tipoArtigo: "tipoArtigo", cliente: "ultimoCliente" };
function applyCrossFilter(refs, cf) {
  if (!cf) return refs;
  let out = refs;
  Object.keys(CROSS_FIELD).forEach((dim) => {
    const set = cf[dim];
    if (set && set.size) {
      const field = CROSS_FIELD[dim];
      out = out.filter((r) => set.has(r[field]));
    }
  });
  if (cf.periodo && cf.periodo.codigos) {
    out = out.filter((r) => cf.periodo.codigos.has(r.codigo));
  }
  return out;
}
function emptyCrossFilter() {
  return { estado: /* @__PURE__ */ new Set(), familia: /* @__PURE__ */ new Set(), tipoArtigo: /* @__PURE__ */ new Set(), cliente: /* @__PURE__ */ new Set(), periodo: null };
}
function toggleCrossFilterState(cf, dim, value) {
  if (dim === "periodo") return withPeriodo(cf, null);
  const next = { ...cf, [dim]: new Set(cf[dim]) };
  if (next[dim].has(value)) next[dim].delete(value);
  else next[dim].add(value);
  return next;
}
function withPeriodo(cf, periodo) {
  return { ...cf, periodo: periodo || null };
}
window.HubCrossFilter = { applyCrossFilter, emptyCrossFilter, toggleCrossFilterState, withPeriodo, CROSS_FIELD };
const CROSS_LABEL = { estado: "Estado", familia: "Fam\xEDlia", tipoArtigo: "Artigo", cliente: "Cliente", periodo: "Per\xEDodo" };
function CrossFilterChips({ cf, onRemove, onClear }) {
  const chips = [];
  Object.keys(CROSS_FIELD).forEach((dim) => {
    (cf[dim] ? [...cf[dim]] : []).forEach((value) => chips.push({ dim, value }));
  });
  if (cf.periodo) chips.push({ dim: "periodo", value: cf.periodo.label || `${cf.periodo.from} \u2192 ${cf.periodo.to}` });
  if (!chips.length) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "cross-filter-chips" }, chips.map(({ dim, value }) => /* @__PURE__ */ React.createElement("span", { key: `${dim}:${value}`, className: "chip chip--filter" }, /* @__PURE__ */ React.createElement("span", { className: "chip__label" }, CROSS_LABEL[dim], ": ", value), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "chip__x",
      onClick: () => onRemove(dim, value),
      "aria-label": "Remover filtro"
    },
    "\xD7"
  ))), /* @__PURE__ */ React.createElement("button", { className: "cross-filter-chips__clear", onClick: onClear }, "Limpar tudo"));
}
window.CrossFilterChips = CrossFilterChips;

// ===== stockreborn/frontend/moves.jsx =====
const SR_FLOW_COLORS = { entrada: "#c4434b", saida: "#3a8a4d" };
const MOVE_TIPO = { novo: "entrada", resolvido: "saida" };
const MOVE_TIPO_LABEL = { entrada: "Entrada", saida: "Sa\xEDda" };
function movesRows(movers) {
  return (movers || []).map((m, i) => ({
    id: `${m.codigo}-${m.tag}-${m.em}-${i}`,
    codigo: m.codigo,
    descricao: m.descricao || "",
    tipo: MOVE_TIPO[m.tag] || "saida",
    tipoLabel: MOVE_TIPO_LABEL[MOVE_TIPO[m.tag] || "saida"],
    estado: m.estado || "",
    em: m.em,
    valor: Number(m.valor) || 0
  }));
}
function MoveTipoChip({ tipo, label }) {
  const cor = tipo === "entrada" ? SR_FLOW_COLORS.entrada : SR_FLOW_COLORS.saida;
  return /* @__PURE__ */ React.createElement("span", { className: "pill", style: { background: "var(--bg)", borderColor: cor, color: cor } }, /* @__PURE__ */ React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: cor } }), label);
}
function MovesPanel({ movers, loading, errored, periodLabel, refsByCodigo, onOpenRef }) {
  const rows = useMemo(() => movesRows(movers), [movers]);
  const estadoOptions = useMemo(() => {
    const nomes = new Map((SR_DATA.estados || []).map((s) => [s.id, s.nome]));
    return [...new Set(rows.map((r) => r.estado).filter(Boolean))].map((id) => ({ value: id, label: nomes.get(id) || id }));
  }, [rows]);
  const estadoNome = (id) => ((SR_DATA.estados || []).find((s) => s.id === id) || {}).nome || id || "\u2014";
  if (!loading && errored) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 24, color: "var(--muted)" } }, "N\xE3o foi poss\xEDvel carregar os movimentos do per\xEDodo.");
  }
  const totalEntradas = rows.filter((r) => r.tipo === "entrada").length;
  const totalSaidas = rows.length - totalEntradas;
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", maxHeight: 560, flexShrink: 0 } }, /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      title: `Movimentos${periodLabel ? ` \xB7 ${periodLabel}` : ""}`,
      toolbar: /* @__PURE__ */ React.createElement("span", { className: "sub", style: { marginLeft: "auto", display: "flex", gap: 12 } }, /* @__PURE__ */ React.createElement("span", { style: { color: SR_FLOW_COLORS.entrada } }, totalEntradas, " entradas"), /* @__PURE__ */ React.createElement("span", { style: { color: SR_FLOW_COLORS.saida } }, totalSaidas, " sa\xEDdas")),
      data: rows,
      rowKey: (r) => r.id,
      search: { placeholder: "Refer\xEAncia ou descri\xE7\xE3o\u2026", fields: ["codigo", "descricao"] },
      filters: [
        { type: "chip", key: "tipo", label: "Tipo", options: [
          { value: "entrada", label: "Entradas", dot: SR_FLOW_COLORS.entrada },
          { value: "saida", label: "Sa\xEDdas", dot: SR_FLOW_COLORS.saida }
        ] },
        { type: "chip", key: "estado", label: "Estado", options: estadoOptions }
      ],
      pagination: "client",
      pageSize: 15,
      empty: "Sem movimentos no per\xEDodo.",
      appLabel: "stockreborn",
      viewId: "movimentos",
      onRowClick: onOpenRef ? (r) => {
        const ref = refsByCodigo && refsByCodigo.get(r.codigo);
        if (ref) onOpenRef(ref);
      } : void 0,
      columns: [
        { key: "codigo", label: "Refer\xEAncia", width: 130, mono: true, fixed: true },
        { key: "descricao", label: "Descri\xE7\xE3o", width: 260 },
        { key: "tipo", label: "Tipo", width: 110, render: (r) => /* @__PURE__ */ React.createElement(MoveTipoChip, { tipo: r.tipo, label: r.tipoLabel }) },
        { key: "estado", label: "Estado", width: 140, render: (r) => estadoNome(r.estado) },
        { key: "em", label: "Data", width: 100 },
        { key: "valor", label: "Valor \u20AC", width: 110, align: "right", render: (r) => fmtEurDec(r.valor) }
      ]
    }
  ));
}
window.SR_FLOW_COLORS = SR_FLOW_COLORS;
window.SR_MOVES = { rows: movesRows };
window.MovesPanel = MovesPanel;

// ===== stockreborn/frontend/dashboard.jsx =====
function usePeriodFlow(period, dims) {
  const [state, setState] = useState({ data: null, loading: true, errored: false });
  const dimParams = useMemo(() => periodDimParams(dims), [dims]);
  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, errored: false }));
    window.API.periodFlow({ from: period.from, to: period.to, ...dimParams }).then((data) => {
      if (!cancelled) setState({ data, loading: false, errored: false });
    }).catch(() => {
      if (!cancelled) setState({ data: null, loading: false, errored: true });
    });
    return () => {
      cancelled = true;
    };
  }, [period.from, period.to, dimParams.estado, dimParams.familia, dimParams.tipo_artigo, dimParams.cliente]);
  return state;
}
function periodDimParams(dims) {
  const d = dims || {};
  const csv = (s) => s && s.size ? [...s].join(",") : void 0;
  return {
    estado: csv(d.estado),
    familia: csv(d.familia),
    tipo_artigo: csv(d.tipoArtigo),
    cliente: csv(d.cliente)
  };
}
function Dashboard({ refs, onJumpTo, users = [] }) {
  const [refsAll, setRefsAll] = useState(refs);
  const [crossFilter, setCrossFilter] = useState(() => window.HubCrossFilter.emptyCrossFilter());
  const [period, setPeriod] = useState(() => window.SR_PERIOD.defaultPeriod(/* @__PURE__ */ new Date()));
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const fresh = await window.API.catalog({ include_inactive: 1, limit: 1e4 });
        if (cancelled) return;
        setRefsAll(fresh.results.map((raw) => {
          const adapted = window.adaptCatalogItem(raw);
          adapted.ativoNoErp = raw.ativo_no_erp;
          adapted.ultimoVistoEm = raw.ultimo_visto_em;
          return adapted;
        }));
      } catch (e) {
        if (!cancelled) setRefsAll(refs);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  const flow = usePeriodFlow(period, crossFilter);
  const movers = useMemo(() => flow.data && flow.data.movers || [], [flow.data]);
  const effectiveCF = useMemo(() => {
    if (!period.active || flow.errored) return window.HubCrossFilter.withPeriodo(crossFilter, null);
    return window.HubCrossFilter.withPeriodo(crossFilter, {
      from: period.from,
      to: period.to,
      label: period.label,
      codigos: new Set(movers.map((m) => m.codigo))
    });
  }, [crossFilter, period, movers, flow.errored]);
  const filteredRefs = useMemo(() => window.HubCrossFilter.applyCrossFilter(refsAll, effectiveCF), [refsAll, effectiveCF]);
  const refsByCodigo = useMemo(() => new Map(refsAll.map((r) => [r.codigo, r])), [refsAll]);
  const toggleCrossFilter = (dim, value) => {
    if (dim === "periodo") {
      setPeriod(window.SR_PERIOD.defaultPeriod(/* @__PURE__ */ new Date()));
      return;
    }
    setCrossFilter((cf) => window.HubCrossFilter.toggleCrossFilterState(cf, dim, value));
  };
  const clearCrossFilter = () => {
    setCrossFilter(window.HubCrossFilter.emptyCrossFilter());
    setPeriod(window.SR_PERIOD.defaultPeriod(/* @__PURE__ */ new Date()));
  };
  const kpis = useMemo(() => {
    const total = filteredRefs.length;
    const valorTotal = filteredRefs.reduce((s, r) => s + r.valor, 0);
    const porTag = {};
    Object.keys(SR_DATA.classificacoes).forEach((k) => {
      const arr = filteredRefs.filter((r) => r.flags.includes(k));
      porTag[k] = { count: arr.length, valor: arr.reduce((s, r) => s + r.valor, 0) };
    });
    const porFamilia = {};
    Object.keys(SR_DATA.familias).forEach((k) => {
      const arr = filteredRefs.filter((r) => r.familia === k);
      porFamilia[k] = { count: arr.length, valor: arr.reduce((s, r) => s + r.valor, 0) };
    });
    const porArtigo = {};
    Object.keys(SR_DATA.tiposArtigo).forEach((k) => {
      const arr = filteredRefs.filter((r) => r.tipoArtigo === k);
      if (arr.length > 0) porArtigo[k] = { count: arr.length, valor: arr.reduce((s, r) => s + r.valor, 0) };
    });
    const porVendedor = SR_DATA.vendedores.map((c) => {
      const arr = filteredRefs.filter((r) => r.atribuido === c.id);
      return {
        ...c,
        count: arr.length,
        valor: arr.reduce((s, r) => s + r.valor, 0),
        porTratar: arr.filter((r) => r.estado === "por_tratar").length,
        emProgresso: arr.filter((r) => ["em_progresso", "aguarda"].includes(r.estado)).length,
        resolvidos: arr.filter((r) => ["resolvido", "descartado"].includes(r.estado)).length
      };
    }).sort((a, b) => b.valor - a.valor);
    const naoAtribuidas = filteredRefs.filter((r) => !r.atribuido).length;
    const porEstado = SR_DATA.estados.map((s) => {
      const arr = filteredRefs.filter((r) => r.estado === s.id);
      return {
        ...s,
        count: arr.length,
        valor: arr.reduce((acc, r) => acc + r.valor, 0)
      };
    });
    const porTratarTotal = filteredRefs.filter((r) => r.estado === "por_tratar").length;
    const monoCount = filteredRefs.filter((r) => r.mono).length;
    const monoValor = filteredRefs.filter((r) => r.mono).reduce((s, r) => s + r.valor, 0);
    const fimVidaCount = filteredRefs.filter((r) => r.fimVida).length;
    const cliMap = /* @__PURE__ */ new Map();
    filteredRefs.forEach((r) => {
      if (!r.ultimoCliente) return;
      const cur = cliMap.get(r.ultimoCliente) || { nome: r.ultimoCliente, n: r.nUltimoCliente, count: 0, valor: 0 };
      cur.count++;
      cur.valor += r.valor;
      cliMap.set(r.ultimoCliente, cur);
    });
    const topClientes = [...cliMap.values()].sort((a, b) => b.valor - a.valor).slice(0, 8);
    return { total, valorTotal, porTag, porFamilia, porArtigo, porVendedor, naoAtribuidas, porEstado, porTratarTotal, monoCount, monoValor, fimVidaCount, topClientes };
  }, [filteredRefs]);
  const totalValor = kpis.valorTotal || 1;
  return /* @__PURE__ */ React.createElement("div", { className: "dash" }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end", marginBottom: 12 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => window.open("/api/reports/executive/", "_blank")
    },
    "\u{1F4C4} Sum\xE1rio Executivo"
  )), /* @__PURE__ */ React.createElement("div", { className: "kpi-row" }, /* @__PURE__ */ React.createElement("div", { className: "kpi" }, /* @__PURE__ */ React.createElement("div", { className: "kpi-accent", style: { background: "var(--brand-navy)" } }), /* @__PURE__ */ React.createElement("div", { className: "kpi-label" }, "Total refer\xEAncias"), /* @__PURE__ */ React.createElement("div", { className: "kpi-value" }, fmtQty(kpis.total)), /* @__PURE__ */ React.createElement("div", { className: "kpi-sub" }, "na extra\xE7\xE3o atual")), /* @__PURE__ */ React.createElement("div", { className: "kpi" }, /* @__PURE__ */ React.createElement("div", { className: "kpi-accent", style: { background: "var(--brand-green)" } }), /* @__PURE__ */ React.createElement("div", { className: "kpi-label" }, "Valor em stock"), /* @__PURE__ */ React.createElement("div", { className: "kpi-value" }, fmtEur(kpis.valorTotal)), /* @__PURE__ */ React.createElement("div", { className: "kpi-sub" }, "capital imobilizado")), /* @__PURE__ */ React.createElement("div", { className: "kpi" }, /* @__PURE__ */ React.createElement("div", { className: "kpi-accent", style: { background: "#c4434b" } }), /* @__PURE__ */ React.createElement("div", { className: "kpi-label" }, "MONO c/ stock"), /* @__PURE__ */ React.createElement("div", { className: "kpi-value" }, fmtQty(kpis.monoCount)), /* @__PURE__ */ React.createElement("div", { className: "kpi-sub" }, fmtEur(kpis.monoValor), " imobilizado")), /* @__PURE__ */ React.createElement("div", { className: "kpi" }, /* @__PURE__ */ React.createElement("div", { className: "kpi-accent", style: { background: "var(--brand-amber)" } }), /* @__PURE__ */ React.createElement("div", { className: "kpi-label" }, "Por tratar"), /* @__PURE__ */ React.createElement("div", { className: "kpi-value" }, fmtQty(kpis.porTratarTotal)), /* @__PURE__ */ React.createElement("div", { className: "kpi-sub" }, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", style: { padding: 0, fontSize: 11.5 }, onClick: () => toggleCrossFilter("estado", "por_tratar") }, crossFilter.estado.has("por_tratar") ? "remover filtro \xD7" : "filtrar \u2192")))), window.PeriodFlowPanel && /* @__PURE__ */ React.createElement(
    window.PeriodFlowPanel,
    {
      period,
      onPeriod: setPeriod,
      data: flow.data,
      loading: flow.loading,
      errored: flow.errored
    }
  ), window.CrossFilterChips && /* @__PURE__ */ React.createElement(window.CrossFilterChips, { cf: effectiveCF, onRemove: toggleCrossFilter, onClear: clearCrossFilter }), /* @__PURE__ */ React.createElement("div", { className: "two-col" }, /* @__PURE__ */ React.createElement(MonthlyFlowPanel, { dims: crossFilter, period, onPeriod: setPeriod }), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Estado de tratamento"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 workflow")), /* @__PURE__ */ React.createElement("div", { className: "class-split" }, /* @__PURE__ */ React.createElement("div", { className: "split-stack" }, kpis.porEstado.map((s) => {
    const w = s.valor > 0 ? s.valor / totalValor * 100 : 0;
    if (w === 0) return null;
    return /* @__PURE__ */ React.createElement("div", { key: s.id, title: `${s.nome}: ${fmtEur(s.valor)}`, style: { width: w + "%", background: s.cor } });
  })), /* @__PURE__ */ React.createElement("div", { className: "split-legend" }, kpis.porEstado.map((s) => /* @__PURE__ */ React.createElement("div", { key: s.id, className: "split-legend-row" + (crossFilter.estado.has(s.id) ? " selected" : ""), onClick: () => toggleCrossFilter("estado", s.id), style: { cursor: "pointer" } }, /* @__PURE__ */ React.createElement("span", { className: "sw", style: { background: s.cor } }), /* @__PURE__ */ React.createElement("span", null, s.nome), /* @__PURE__ */ React.createElement("span", { className: "v" }, fmtQty(s.count), " refs"), /* @__PURE__ */ React.createElement("span", { className: "v", style: { fontWeight: 600, color: "var(--text)" } }, fmtEur(s.valor)))), /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--border)", paddingTop: 10, marginTop: 4 } }, /* @__PURE__ */ React.createElement("div", { className: "split-legend-row" }, /* @__PURE__ */ React.createElement("span", { style: { width: 12 } }), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "Total stock"), /* @__PURE__ */ React.createElement("span", { className: "v", style: { color: "var(--muted)" } }, fmtQty(kpis.total)), /* @__PURE__ */ React.createElement("span", { className: "v", style: { fontWeight: 600, color: "var(--text)" } }, fmtEur(kpis.valorTotal)))))))), window.MovesPanel && /* @__PURE__ */ React.createElement(
    window.MovesPanel,
    {
      movers,
      loading: flow.loading,
      errored: flow.errored,
      periodLabel: period.label,
      refsByCodigo,
      onOpenRef: (ref) => onJumpTo("detalhe", { ref })
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "two-col" }, /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Composi\xE7\xE3o por tipo de artigo"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 valor em stock")), /* @__PURE__ */ React.createElement("div", { style: { padding: 16 } }, Object.entries(kpis.porArtigo).sort((a, b) => b[1].valor - a[1].valor).map(([k, v]) => {
    const cls = SR_DATA.tiposArtigo[k];
    const w = v.valor / totalValor * 100;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: k,
        className: "comp-row" + (crossFilter.tipoArtigo.has(k) ? " selected" : ""),
        style: { display: "grid", gridTemplateColumns: "110px 1fr 100px", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: "1px solid var(--border)", cursor: "pointer" },
        onClick: () => toggleCrossFilter("tipoArtigo", k)
      },
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 10, height: 10, borderRadius: 3, background: cls.cor } }), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12.5 } }, cls.nome)),
      /* @__PURE__ */ React.createElement("div", { style: { height: 8, background: "var(--bg-2)", borderRadius: 4, overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: { width: w + "%", height: "100%", background: cls.cor, borderRadius: 4 } })),
      /* @__PURE__ */ React.createElement("div", { style: { textAlign: "right", fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-2)" } }, fmtEur(v.valor), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: "var(--muted)" } }, v.count, " refs"))
    );
  }))), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Composi\xE7\xE3o por fam\xEDlia")), /* @__PURE__ */ React.createElement("div", { className: "class-split" }, /* @__PURE__ */ React.createElement("div", { className: "split-stack" }, Object.entries(kpis.porFamilia).map(([k, v]) => {
    const cls = SR_DATA.familias[k];
    const w = v.valor > 0 ? v.valor / totalValor * 100 : 0;
    return /* @__PURE__ */ React.createElement("div", { key: k, title: `${cls.nome}: ${fmtEur(v.valor)}`, style: { width: w + "%", background: cls.cor } });
  })), /* @__PURE__ */ React.createElement("div", { className: "split-legend" }, Object.entries(kpis.porFamilia).map(([k, v]) => {
    const cls = SR_DATA.familias[k];
    return /* @__PURE__ */ React.createElement("div", { key: k, className: "split-legend-row" + (crossFilter.familia.has(k) ? " selected" : ""), onClick: () => toggleCrossFilter("familia", k), style: { cursor: "pointer" } }, /* @__PURE__ */ React.createElement("span", { className: "sw", style: { background: cls.cor } }), /* @__PURE__ */ React.createElement("span", null, k, " \u2014 ", cls.nome), /* @__PURE__ */ React.createElement("span", { className: "v" }, fmtQty(v.count), " refs"), /* @__PURE__ */ React.createElement("span", { className: "v", style: { fontWeight: 600, color: "var(--text)" } }, fmtEur(v.valor)));
  }))))), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "dashboard-clientes",
      title: "Top clientes por valor imobilizado",
      columns: [
        { key: "nome", label: "Cliente", width: 220, fixed: true },
        { key: "n", label: "N\xBA", width: 100, render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, orDash(c.n)) },
        { key: "count", label: "Refs", width: 90, align: "right", render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, c.count) },
        {
          key: "valor",
          label: "Valor \u20AC",
          width: 120,
          align: "right",
          render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { fontWeight: 600 } }, fmtEur(c.valor))
        }
      ],
      data: kpis.topClientes,
      pagination: "client",
      pageSizeOptions: null,
      rowKey: (c) => c.nome,
      onRowClick: (c) => toggleCrossFilter("cliente", c.nome),
      rowClassName: (c) => crossFilter.cliente.has(c.nome) ? "selected" : void 0,
      empty: "Sem clientes com valor imobilizado."
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "dashboard-refs",
      title: "Top 8 refer\xEAncias por valor imobilizado",
      toolbar: /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", style: { marginLeft: "auto" }, onClick: () => {
        window.SR_NAV_INTENT = { includeInactive: true };
        onJumpTo("listagem");
      } }, "ver todas ", /* @__PURE__ */ React.createElement(Ico.chevron, null)),
      columns: [
        {
          key: "codigo",
          label: "Refer\xEAncia",
          width: 130,
          minWidth: 110,
          fixed: true,
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-tight" }, r.codigo)
        },
        { key: "descricao", label: "Descri\xE7\xE3o", width: 240, minWidth: 200 },
        {
          key: "ultimoCliente",
          label: "\xDAltimo cliente",
          width: 200,
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-tight", title: r.ultimoCliente || "" }, trimCli(r.ultimoCliente, 28))
        },
        { key: "familia", label: "Fam\xEDlia", width: 130, render: (r) => /* @__PURE__ */ React.createElement(FamiliaTag, { familia: r.familia }) },
        { key: "sinalizacao", label: "Sinaliza\xE7\xE3o", width: 90, render: (r) => /* @__PURE__ */ React.createElement(FlagDots, { flags: r.flags }) },
        { key: "atribuido", label: "Atribu\xEDdo", width: 150, render: (r) => /* @__PURE__ */ React.createElement(UserPill, { username: r.atribuido, users, compact: true }) },
        { key: "stock", label: "Stock", width: 90, align: "right", render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, fmtQty(r.stock)) },
        {
          key: "valor",
          label: "Valor \u20AC",
          width: 120,
          align: "right",
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { fontWeight: 600 } }, fmtEur(r.valor))
        }
      ],
      data: [...filteredRefs].sort((a, b) => b.valor - a.valor).slice(0, 8),
      pagination: "client",
      pageSizeOptions: null,
      rowKey: (r) => r.id,
      onRowClick: (r) => onJumpTo("detalhe", { ref: r }),
      empty: "Sem refer\xEAncias."
    }
  ));
}
function MonthlyFlowPanel({ dims, period, onPeriod }) {
  const [raw, setRaw] = useState(null);
  const dimParams = useMemo(() => periodDimParams(dims), [dims]);
  useEffect(() => {
    window.API.transitionsMonthly(dimParams).then(setRaw).catch(() => setRaw([]));
  }, [dimParams.estado, dimParams.familia, dimParams.tipo_artigo, dimParams.cliente]);
  const data = useMemo(() => {
    if (!raw) return null;
    return raw.map((b) => {
      const d = new Date(b.year, b.month - 1, 1);
      return {
        key: `${b.year}-${b.month}`,
        label: d.toLocaleDateString("pt-PT", { month: "short" }).replace(".", ""),
        year: b.year,
        month: b.month - 1,
        inVal: parseFloat(b.in_val) || 0,
        outVal: parseFloat(b.out_val) || 0,
        inCount: b.in_count,
        outCount: b.out_count
      };
    });
  }, [raw]);
  if (!data) return /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 24, color: "var(--muted)" } }, "A carregar evolu\xE7\xE3o\u2026");
  const max = Math.max(1, ...data.map((d) => Math.max(d.inVal, d.outVal)));
  const totalIn = data.reduce((s, d) => s + d.inVal, 0);
  const totalOut = data.reduce((s, d) => s + d.outVal, 0);
  const w = 720, h = 220, padL = 50, padR = 16, padT = 18, padB = 28;
  const innerW = w - padL - padR, innerH = h - padT - padB;
  const slot = innerW / data.length;
  const barW = Math.max(4, slot * 0.36);
  const cores = window.SR_FLOW_COLORS;
  const mesDoBucket = (d) => window.SR_PERIOD.monthPeriod(d.year, d.month);
  const mesSelecionado = (d) => {
    if (!period || !period.active) return false;
    const m = mesDoBucket(d);
    return period.from === m.from && period.to === m.to;
  };
  const onMes = (d) => {
    if (!onPeriod) return;
    onPeriod(mesSelecionado(d) ? window.SR_PERIOD.defaultPeriod(/* @__PURE__ */ new Date()) : mesDoBucket(d));
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Evolu\xE7\xE3o mensal de monos"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 entradas vs sa\xEDdas (\u20AC)"), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 12, fontSize: 12 } }, /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 5 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 10, height: 10, background: cores.entrada, borderRadius: 2 } }), " Entradas ", fmtEur(totalIn)), /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 5 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 10, height: 10, background: cores.saida, borderRadius: 2 } }), " Sa\xEDdas ", fmtEur(totalOut)))), /* @__PURE__ */ React.createElement("div", { style: { padding: 12, overflowX: "auto" } }, /* @__PURE__ */ React.createElement("svg", { width: w, height: h, viewBox: `0 0 ${w} ${h}`, style: { display: "block", maxWidth: "100%" } }, [0, 0.25, 0.5, 0.75, 1].map((p) => {
    const y = padT + innerH - p * innerH;
    return /* @__PURE__ */ React.createElement("g", { key: p }, /* @__PURE__ */ React.createElement("line", { x1: padL, y1: y, x2: w - padR, y2: y, stroke: "var(--border)", strokeDasharray: p === 0 ? "0" : "2 3" }), /* @__PURE__ */ React.createElement(
      "text",
      {
        x: padL - 6,
        y: y + 3,
        fontSize: "9.5",
        fontFamily: "var(--font-mono)",
        textAnchor: "end",
        fill: "var(--muted)"
      },
      fmtEur(p * max)
    ));
  }), data.map((d, i) => {
    const x = padL + i * slot;
    const inH = d.inVal / max * innerH;
    const outH = d.outVal / max * innerH;
    const inX = x + slot / 2 - barW - 1;
    const outX = x + slot / 2 + 1;
    const sel = mesSelecionado(d);
    return /* @__PURE__ */ React.createElement("g", { key: d.key, onClick: () => onMes(d), style: { cursor: onPeriod ? "pointer" : void 0 } }, /* @__PURE__ */ React.createElement(
      "rect",
      {
        x,
        y: padT,
        width: slot,
        height: innerH,
        fill: sel ? "var(--row-hover)" : "transparent"
      }
    ), /* @__PURE__ */ React.createElement(
      "rect",
      {
        x: inX,
        y: padT + innerH - inH,
        width: barW,
        height: inH,
        fill: cores.entrada,
        opacity: sel || !period || !period.active ? 1 : 0.45
      },
      /* @__PURE__ */ React.createElement("title", null, d.label, " ", d.year, ": entrou ", fmtEur(d.inVal), " (", d.inCount, " refs)")
    ), /* @__PURE__ */ React.createElement(
      "rect",
      {
        x: outX,
        y: padT + innerH - outH,
        width: barW,
        height: outH,
        fill: cores.saida,
        opacity: sel || !period || !period.active ? 1 : 0.45
      },
      /* @__PURE__ */ React.createElement("title", null, d.label, " ", d.year, ": saiu ", fmtEur(d.outVal), " (", d.outCount, " refs)")
    ), /* @__PURE__ */ React.createElement(
      "text",
      {
        x: x + slot / 2,
        y: h - 10,
        textAnchor: "middle",
        fontSize: "10.5",
        fontFamily: "var(--font-mono)",
        fill: sel ? "var(--text)" : "var(--muted)"
      },
      d.label
    ));
  })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 6, fontStyle: "italic" } }, "Entrada = data em que a ref entrou no workflow (cria\xE7\xE3o do Mono, stock parado). Sa\xEDda = Mono passou a estado terminal. Clica num m\xEAs para o p\xF4r em an\xE1lise.")));
}
window.Dashboard = Dashboard;

// ===== stockreborn/frontend/period.jsx =====
const PERIOD_PRESETS = [
  { key: "last-12m", label: "\xDAltimos 12m" },
  { key: "ytd", label: "Este ano" },
  { key: "this-month", label: "Este m\xEAs" },
  { key: "this-quarter", label: "Este trimestre" },
  { key: "custom", label: "Personalizado" }
];
const PERIOD_ISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
function resolvePeriodRange(preset, today) {
  const y = today.getFullYear();
  if (preset === "ytd") return { from: `${y}-01-01`, to: PERIOD_ISO(today) };
  if (preset === "this-month") return { from: PERIOD_ISO(new Date(y, today.getMonth(), 1)), to: PERIOD_ISO(today) };
  if (preset === "this-quarter") {
    const q = Math.floor(today.getMonth() / 3) * 3;
    return { from: PERIOD_ISO(new Date(y, q, 1)), to: PERIOD_ISO(today) };
  }
  const d = new Date(today);
  d.setFullYear(d.getFullYear() - 1);
  return { from: PERIOD_ISO(d), to: PERIOD_ISO(today) };
}
function periodLabel(preset, range) {
  const p = PERIOD_PRESETS.find((x) => x.key === preset);
  if (p && preset !== "custom") return p.label;
  return `${range.from} \u2192 ${range.to}`;
}
function defaultPeriod(today) {
  const preset = "last-12m";
  const range = resolvePeriodRange(preset, today || /* @__PURE__ */ new Date());
  return { preset, ...range, label: periodLabel(preset, range), active: false };
}
function presetPeriod(preset, today) {
  const range = resolvePeriodRange(preset, today || /* @__PURE__ */ new Date());
  return { preset, ...range, label: periodLabel(preset, range), active: true };
}
function monthPeriod(year, monthIdx) {
  const first = new Date(year, monthIdx, 1);
  const last = new Date(year, monthIdx + 1, 0);
  const label = first.toLocaleDateString("pt-PT", { month: "short", year: "numeric" }).replace(".", "");
  return { preset: "custom", from: PERIOD_ISO(first), to: PERIOD_ISO(last), label, active: true };
}
function customPeriod(from, to) {
  const range = { from, to };
  return { preset: "custom", ...range, label: periodLabel("custom", range), active: true };
}
function PeriodFlowStep({ label, val, count, kind }) {
  const cor = kind === "in" ? window.SR_FLOW_COLORS.entrada : kind === "out" ? window.SR_FLOW_COLORS.saida : void 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `period-flow__step period-flow__step--${kind || "neutral"}`,
      style: { padding: "10px 14px", background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 6, minWidth: 150 }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "period-flow__step-label",
        style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase", letterSpacing: "0.04em" }
      },
      label
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "period-flow__step-val",
        style: { color: cor, fontSize: 18, fontWeight: 600, fontVariantNumeric: "tabular-nums", marginTop: 2 }
      },
      kind === "in" ? "+" : kind === "out" ? "\u2212" : "",
      fmtEurDec(Number(val))
    ),
    count != null && /* @__PURE__ */ React.createElement("div", { className: "period-flow__step-count", style: { fontSize: 11, color: "var(--muted)" } }, count, " refs")
  );
}
function PeriodFlowPanel({ period, onPeriod, data, loading, errored } = {}) {
  const onPreset = (key) => {
    if (key === "custom") onPeriod(customPeriod(period.from, period.to));
    else onPeriod(presetPeriod(key, /* @__PURE__ */ new Date()));
  };
  return /* @__PURE__ */ React.createElement("div", { className: "panel period-flow" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Fluxo do per\xEDodo"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", period.label), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "period-flow__presets",
      style: { marginLeft: "auto", display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }
    },
    PERIOD_PRESETS.map((p) => /* @__PURE__ */ React.createElement(
      "button",
      {
        key: p.key,
        type: "button",
        className: `btn sm${p.key === period.preset ? " primary" : ""}`,
        onClick: () => onPreset(p.key)
      },
      p.label
    )),
    period.preset === "custom" && /* @__PURE__ */ React.createElement("span", { style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      background: "var(--bg)",
      border: "1px solid var(--border)",
      borderRadius: "var(--radius)",
      padding: "1px 8px"
    } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: period.from,
        style: PERIOD_DATE_INPUT,
        onChange: (e) => onPeriod(customPeriod(e.target.value, period.to))
      }
    ), /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2192"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: period.to,
        style: PERIOD_DATE_INPUT,
        onChange: (e) => onPeriod(customPeriod(period.from, e.target.value))
      }
    ))
  )), /* @__PURE__ */ React.createElement("div", { style: { padding: 12 } }, loading && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "A carregar\u2026"), !loading && errored && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--muted)" } }, "N\xE3o foi poss\xEDvel carregar o fluxo do per\xEDodo."), !loading && !errored && data && /* @__PURE__ */ React.createElement("div", { className: "period-flow__waterfall", style: { display: "flex", gap: 12, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(PeriodFlowStep, { label: "Valor inicial", val: data.valor_inicial, count: data.count_inicial }), /* @__PURE__ */ React.createElement(PeriodFlowStep, { label: "Entradas", val: data.entradas.val, count: data.entradas.count, kind: "in" }), /* @__PURE__ */ React.createElement(PeriodFlowStep, { label: "Sa\xEDdas", val: data.saidas.val, count: data.saidas.count, kind: "out" }), /* @__PURE__ */ React.createElement(PeriodFlowStep, { label: "Valor final", val: data.valor_final }))));
}
const PERIOD_DATE_INPUT = {
  border: "none",
  background: "transparent",
  outline: "none",
  padding: "5px 0",
  fontFamily: "var(--font-sans)",
  fontSize: 12.5,
  color: "var(--text)"
};
window.SR_PERIOD = {
  PRESETS: PERIOD_PRESETS,
  resolveRange: resolvePeriodRange,
  defaultPeriod,
  presetPeriod,
  monthPeriod,
  customPeriod,
  periodLabel
};
window.PeriodFlowPanel = PeriodFlowPanel;

// ===== stockreborn/frontend/search.jsx =====
function DimSearch({ refs, onOpenDetail }) {
  const [c, setC] = useState(0);
  const [l, setL] = useState(0);
  const [h, setH] = useState(0);
  const [margem, setMargem] = useState(10);
  const [fefco, setFefco] = useState("");
  const [familia, setFamilia] = useState("");
  const [excludeClient, setExcludeClient] = useState("");
  const [onlyMono, setOnlyMono] = useState(false);
  const [onlyLarger, setOnlyLarger] = useState(false);
  const results = useMemo(() => {
    const inMargin = (a, b) => {
      if (!b) return true;
      const m = margem / 100 * b;
      return Math.abs(a - b) <= m;
    };
    const passLarger = (a, b) => !b || a >= b;
    return refs.filter((r) => {
      if (!r.c && !r.l && !r.h) return false;
      if (onlyLarger) {
        if (!passLarger(r.c, c)) return false;
        if (!passLarger(r.l, l)) return false;
        if (h && !passLarger(r.h, h)) return false;
      }
      if (!inMargin(r.c, c)) return false;
      if (!inMargin(r.l, l)) return false;
      if (h && !inMargin(r.h, h)) return false;
      if (fefco && r.fefco !== fefco) return false;
      if (familia && r.familia !== familia) return false;
      if (excludeClient && r.ultimoCliente === excludeClient) return false;
      if (onlyMono && !r.mono) return false;
      return true;
    }).sort((a, b) => {
      const da = Math.abs(a.c - c) + Math.abs(a.l - l) + Math.abs((a.h || 0) - h);
      const db = Math.abs(b.c - c) + Math.abs(b.l - l) + Math.abs((b.h || 0) - h);
      return da - db;
    });
  }, [refs, c, l, h, margem, fefco, familia, excludeClient, onlyMono, onlyLarger]);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Pesquisa por dimens\xF5es parecidas"), /* @__PURE__ */ React.createElement("p", { style: { margin: "4px 0 0", fontSize: 13, color: "var(--muted)" } }, "Encontra refer\xEAncias com dimens\xF5es dentro de uma margem \u2014 \xFAtil para propor stock mono a cliente alternativo com necessidade similar.")), /* @__PURE__ */ React.createElement("div", { className: "search-form" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Comprimento (mm)"), /* @__PURE__ */ React.createElement("input", { type: "number", value: c || "", placeholder: "\u2014", onChange: (e) => setC(+e.target.value || 0) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Largura (mm)"), /* @__PURE__ */ React.createElement("input", { type: "number", value: l || "", placeholder: "\u2014", onChange: (e) => setL(+e.target.value || 0) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Altura (mm)"), /* @__PURE__ */ React.createElement("input", { type: "number", value: h || "", placeholder: "\u2014", onChange: (e) => setH(+e.target.value || 0) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Margem \xB1%"), /* @__PURE__ */ React.createElement("input", { type: "number", value: margem, onChange: (e) => setMargem(+e.target.value) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Fefco (opcional)"), /* @__PURE__ */ React.createElement("select", { value: fefco, onChange: (e) => setFefco(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todos"), SR_DATA.fefcos.map((f) => /* @__PURE__ */ React.createElement("option", { key: f, value: f }, f)))), /* @__PURE__ */ React.createElement("button", { className: "btn primary", style: { height: 34 } }, /* @__PURE__ */ React.createElement(Ico.search, null), " Pesquisar")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 10, alignItems: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase" } }, "Filtros adicionais:"), /* @__PURE__ */ React.createElement("select", { value: familia, onChange: (e) => setFamilia(e.target.value), style: { width: "auto", padding: "4px 8px" } }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todas as fam\xEDlias"), Object.entries(SR_DATA.familias).map(([k, v]) => /* @__PURE__ */ React.createElement("option", { key: k, value: k }, k, " \u2014 ", v.nome))), /* @__PURE__ */ React.createElement("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 12.5, cursor: "pointer" } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: onlyMono, onChange: (e) => setOnlyMono(e.target.checked) }), "S\xF3 monos"), /* @__PURE__ */ React.createElement(
    "label",
    {
      style: { display: "flex", alignItems: "center", gap: 6, fontSize: 12.5, cursor: "pointer" },
      title: "Mostrar s\xF3 refs com dimens\xF5es iguais ou maiores que as procuradas"
    },
    /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: onlyLarger, onChange: (e) => setOnlyLarger(e.target.checked) }),
    "S\xF3 \u2265 dimens\xF5es pedidas"
  )), /* @__PURE__ */ React.createElement("div", { className: "m-stack", style: { display: "grid", gridTemplateColumns: "280px 1fr", gap: 16, marginTop: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Caixa procurada"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "center", padding: "10px 0" } }, /* @__PURE__ */ React.createElement(BoxSchema, { c, l, h, fefco: fefco || "\u2014", withImp: true })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: "var(--muted)", textAlign: "center", fontFamily: "var(--font-mono)" } }, c, " \xD7 ", l, " \xD7 ", h, " mm \xB7 \xB1", margem, "%"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14, padding: 10, background: "var(--bg)", borderRadius: 6, fontSize: 12, color: "var(--text-2)" } }, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginBottom: 6 } }, "Range aceite"), /* @__PURE__ */ React.createElement("div", { style: { fontFamily: "var(--font-mono)", fontSize: 11.5, lineHeight: 1.6 } }, "C: ", Math.round(c * (1 - margem / 100)), "\u2013", Math.round(c * (1 + margem / 100)), /* @__PURE__ */ React.createElement("br", null), "L: ", Math.round(l * (1 - margem / 100)), "\u2013", Math.round(l * (1 + margem / 100)), /* @__PURE__ */ React.createElement("br", null), "H: ", Math.round(h * (1 - margem / 100)), "\u2013", Math.round(h * (1 + margem / 100))))), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "pesquisa",
      title: "Resultados",
      toolbar: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 ", results.length, " refer\xEAncias encontradas"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", style: { marginLeft: "auto" } }, /* @__PURE__ */ React.createElement(Ico.download, null), " Exportar")),
      columns: [
        // 170/140: mesmo critério do listing.jsx — cabem os 14
        // caracteres mais longos vistos em produção em fonte monoespaçada.
        {
          key: "codigo",
          label: "Refer\xEAncia",
          width: 170,
          minWidth: 140,
          fixed: true,
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-tight" }, r.codigo)
        },
        { key: "descricao", label: "Descri\xE7\xE3o", width: 240, minWidth: 200 },
        {
          key: "ultimoCliente",
          label: "\xDAltimo cliente",
          width: 180,
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-tight", title: r.ultimoCliente || "" }, trimCli(r.ultimoCliente, 26))
        },
        { key: "dimensoes", label: "Dimens\xF5es", width: 130, render: (r) => /* @__PURE__ */ React.createElement(Dim, { c: r.c, l: r.l, h: r.h }) },
        {
          key: "delta",
          label: "\u0394 vs procura",
          width: 140,
          render: (r) => {
            const dc = r.c - c, dl = r.l - l, dh = (r.h || 0) - h;
            return /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted", style: { fontSize: 11 } }, dc >= 0 ? "+" : "", dc, ", ", dl >= 0 ? "+" : "", dl, ", ", dh >= 0 ? "+" : "", dh);
          }
        },
        {
          key: "fefco",
          label: "Fefco",
          width: 90,
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, orDash(r.fefco))
        },
        // 140: mesmo critério do listing.jsx — a etiqueta mais larga
        // ("Fim de vida") e o cabeçalho "SINALIZAÇÃO" não cabiam antes.
        { key: "sinalizacao", label: "Sinaliza\xE7\xE3o", width: 140, minWidth: 140, render: (r) => /* @__PURE__ */ React.createElement(FlagDots, { flags: r.flags }) },
        {
          key: "stock",
          label: "Stock",
          width: 90,
          align: "right",
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num" }, fmtQty(r.stock))
        },
        {
          key: "valor",
          label: "Valor \u20AC",
          width: 110,
          align: "right",
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-num", style: { fontWeight: 500 } }, fmtEur(r.valor))
        }
      ],
      data: results,
      pagination: "client",
      rowKey: (r) => r.id,
      onRowClick: (r) => onOpenDetail(r, results),
      empty: "Sem resultados. Tenta aumentar a margem ou alterar as dimens\xF5es."
    }
  )));
}
window.DimSearch = DimSearch;

// ===== stockreborn/frontend/reports.jsx =====
function ReportsTab({ users }) {
  const [comercialId, setComercialId] = React.useState("");
  const [formato, setFormato] = React.useState("hybrid");
  const [month, setMonth] = React.useState(() => {
    const d = /* @__PURE__ */ new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });
  function gerarComercial(e) {
    e.preventDefault();
    if (!comercialId) return;
    window.open(`/api/reports/comercial/${comercialId}/?format=${formato}`, "_blank");
  }
  function gerarExecutive(e) {
    e.preventDefault();
    window.open(`/api/reports/executive/?month=${month}`, "_blank");
  }
  return /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", padding: "24px" } }, /* @__PURE__ */ React.createElement("section", { style: { border: "1px solid #e3e6eb", borderRadius: 8, padding: 16 } }, /* @__PURE__ */ React.createElement("h2", { style: { marginTop: 0 } }, "Por comercial"), /* @__PURE__ */ React.createElement("form", { onSubmit: gerarComercial }, /* @__PURE__ */ React.createElement("label", { style: { display: "block", marginBottom: 8 } }, "Comercial:\xA0", /* @__PURE__ */ React.createElement("select", { value: comercialId, onChange: (e) => setComercialId(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 escolher \u2014"), users.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.username)))), /* @__PURE__ */ React.createElement("fieldset", { style: { border: "none", padding: 0, margin: "8px 0" } }, /* @__PURE__ */ React.createElement("legend", null, "Detalhe:"), /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "radio",
      name: "fmt",
      value: "hybrid",
      checked: formato === "hybrid",
      onChange: (e) => setFormato(e.target.value)
    }
  ), " H\xEDbrido"), "\xA0\xA0", /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "radio",
      name: "fmt",
      value: "full",
      checked: formato === "full",
      onChange: (e) => setFormato(e.target.value)
    }
  ), " Detalhado")), /* @__PURE__ */ React.createElement("button", { type: "submit", disabled: !comercialId }, "Gerar PDF"))), /* @__PURE__ */ React.createElement("section", { style: { border: "1px solid #e3e6eb", borderRadius: 8, padding: 16 } }, /* @__PURE__ */ React.createElement("h2", { style: { marginTop: 0 } }, "Sum\xE1rio Executivo"), /* @__PURE__ */ React.createElement("form", { onSubmit: gerarExecutive }, /* @__PURE__ */ React.createElement("label", { style: { display: "block", marginBottom: 8 } }, "M\xEAs:\xA0", /* @__PURE__ */ React.createElement("input", { type: "month", value: month, onChange: (e) => setMonth(e.target.value) })), /* @__PURE__ */ React.createElement("button", { type: "submit" }, "Gerar PDF"))));
}
window.ReportsTab = ReportsTab;

// ===== stockreborn/frontend/admin.jsx =====
function StockAdminView({
  estados,
  tiposAcao,
  personalizacoes = [],
  reloadPersonalizacoes,
  dbConnections = [],
  reloadDBConnections,
  reloadEstados,
  reloadTiposAcao
}) {
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, maxWidth: 900 } }, /* @__PURE__ */ React.createElement(PersonalizacaoPanel, { personalizacoes, reload: reloadPersonalizacoes }), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(EstadoPanel, { estados, reload: reloadEstados }), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(TipoAcaoPanel, { tiposAcao, reload: reloadTiposAcao }), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(DBConnectionPanel, { dbConnections, reload: reloadDBConnections }));
}
window.StockAdminView = StockAdminView;

// ===== stockreborn/frontend/admin-personalizacao.jsx =====
function PersonalizacaoPanel({ personalizacoes = [], reload }) {
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const handleCreate = async (data) => {
    try {
      setError(null);
      await window.API.createPersonalizacao(data);
      setCreating(false);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleUpdate = async (slug, patch) => {
    try {
      setError(null);
      await window.API.updatePersonalizacao(slug, patch);
      setEditing(null);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDelete = async (p) => {
    if (!await window.hubConfirm({ message: `Apagar personaliza\xE7\xE3o "${p.nome}"? Refs com este valor ficam com personaliza\xE7\xE3o vazia.` })) return;
    try {
      setError(null);
      await window.API.deletePersonalizacao(p.id_slug);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const columns = [
    {
      key: "nome",
      label: "Nome",
      width: 200,
      minWidth: 140,
      fixed: true,
      render: (p) => /* @__PURE__ */ React.createElement("strong", null, p.nome)
    },
    {
      key: "id_slug",
      label: "Identificador",
      width: 170,
      minWidth: 120,
      render: (p) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, p.id_slug)
    },
    {
      key: "cor",
      label: "Cor",
      width: 120,
      minWidth: 100,
      render: (p) => /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, height: 14, borderRadius: 3, background: p.cor, border: "1px solid var(--border)" } }), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, p.cor))
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 70,
      render: (p) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, p.ordem)
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 160,
      minWidth: 140,
      render: (p) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(p) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleDelete(p) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Personaliza\xE7\xE3o"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 op\xE7\xF5es para classificar refs"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Nova")), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "admin-personalizacao",
      columns,
      data: personalizacoes,
      pagination: "none",
      rowKey: (p) => p.id_slug,
      empty: "Sem op\xE7\xF5es."
    }
  ), creating && /* @__PURE__ */ React.createElement(PersonalizacaoFormModal, { title: "Nova personaliza\xE7\xE3o", onClose: () => setCreating(false), onSubmit: handleCreate, withSlug: true }), editing && /* @__PURE__ */ React.createElement(
    PersonalizacaoFormModal,
    {
      title: `Editar ${editing.nome}`,
      initial: editing,
      onClose: () => setEditing(null),
      onSubmit: (data) => handleUpdate(editing.id_slug, data)
    }
  ));
}
window.PersonalizacaoPanel = PersonalizacaoPanel;
function PersonalizacaoFormModal({ title, initial = {}, withSlug = false, onClose, onSubmit }) {
  const [nome, setNome] = useState(initial.nome || "");
  const [idSlug, setIdSlug] = useState(initial.id_slug || "");
  const [cor, setCor] = useState(initial.cor || "#6a7888");
  const [ordem, setOrdem] = useState(initial.ordem ?? 0);
  const submit = (e) => {
    e.preventDefault();
    const data = { nome, cor, ordem: Number(ordem) };
    if (withSlug) data.id_slug = idSlug || nome.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
    onSubmit(data);
  };
  const formId = "personalizacao-form";
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: formId, className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: formId,
        onSubmit: submit,
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement("input", { value: nome, onChange: (e) => setNome(e.target.value), required: true, autoFocus: true })),
      withSlug && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Identificador (slug)"), /* @__PURE__ */ React.createElement(
        "input",
        {
          value: idSlug,
          onChange: (e) => setIdSlug(e.target.value),
          placeholder: "auto",
          pattern: "[a-z0-9_]*"
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Cor"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "color",
          value: cor,
          onChange: (e) => setCor(e.target.value),
          style: { height: 36, padding: 4 }
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Ordem"), /* @__PURE__ */ React.createElement("input", { type: "number", value: ordem, onChange: (e) => setOrdem(e.target.value), min: 0 })))
    )
  );
}
window.PersonalizacaoFormModal = PersonalizacaoFormModal;

// ===== stockreborn/frontend/admin-estados.jsx =====
function EstadoPanel({ estados = [], reload }) {
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const handleCreate = async (data) => {
    try {
      setError(null);
      await window.API.createEstado(data);
      setCreating(false);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleUpdate = async (slug, patch) => {
    try {
      setError(null);
      await window.API.updateEstado(slug, patch);
      setEditing(null);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDelete = async (s) => {
    if (!await window.hubConfirm({ message: `Apagar estado "${s.nome}"?` })) return;
    try {
      setError(null);
      await window.API.deleteEstado(s.id_slug);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const columns = [
    {
      key: "nome",
      label: "Nome",
      width: 180,
      minWidth: 130,
      fixed: true,
      render: (s) => /* @__PURE__ */ React.createElement("strong", null, s.nome)
    },
    {
      key: "id_slug",
      label: "Identificador",
      width: 170,
      minWidth: 120,
      render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, s.id_slug)
    },
    {
      key: "cor",
      label: "Cor",
      width: 120,
      minWidth: 100,
      render: (s) => /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 14, height: 14, borderRadius: 3, background: s.cor, border: "1px solid var(--border)" } }), /* @__PURE__ */ React.createElement("span", { className: "td-mono" }, s.cor))
    },
    {
      key: "ordem",
      label: "Ordem",
      width: 90,
      minWidth: 70,
      render: (s) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, s.ordem)
    },
    {
      key: "terminal",
      label: "Terminal",
      width: 100,
      minWidth: 80,
      render: (s) => s.terminal ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 160,
      minWidth: 140,
      render: (s) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(s) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleDelete(s) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Estados de workflow"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Novo")), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "admin-estados",
      columns,
      data: estados,
      pagination: "none",
      rowKey: (s) => s.id_slug
    }
  ), creating && /* @__PURE__ */ React.createElement(EstadoFormModal, { title: "Novo estado", onClose: () => setCreating(false), onSubmit: handleCreate, withSlug: true }), editing && /* @__PURE__ */ React.createElement(
    EstadoFormModal,
    {
      title: `Editar ${editing.nome}`,
      initial: editing,
      onClose: () => setEditing(null),
      onSubmit: (d) => handleUpdate(editing.id_slug, d)
    }
  ));
}
window.EstadoPanel = EstadoPanel;
function EstadoFormModal({ title, initial = {}, withSlug = false, onClose, onSubmit }) {
  const [nome, setNome] = useState(initial.nome || "");
  const [idSlug, setIdSlug] = useState(initial.id_slug || "");
  const [cor, setCor] = useState(initial.cor || "#6a7888");
  const [ordem, setOrdem] = useState(initial.ordem ?? 0);
  const [terminal, setTerminal] = useState(!!initial.terminal);
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "estado-form", className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement("form", { id: "estado-form", onSubmit: (e) => {
      e.preventDefault();
      const data = { nome, cor, ordem: Number(ordem), terminal };
      if (withSlug) data.id_slug = idSlug || nome.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
      onSubmit(data);
    }, style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement("input", { value: nome, onChange: (e) => setNome(e.target.value), required: true, autoFocus: true })), withSlug && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Identificador (slug)"), /* @__PURE__ */ React.createElement("input", { value: idSlug, onChange: (e) => setIdSlug(e.target.value), placeholder: "auto", pattern: "[a-z0-9_]*" })), /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Cor"), /* @__PURE__ */ React.createElement("input", { type: "color", value: cor, onChange: (e) => setCor(e.target.value), style: { height: 36, padding: 4 } })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Ordem"), /* @__PURE__ */ React.createElement("input", { type: "number", value: ordem, onChange: (e) => setOrdem(e.target.value), min: 0 }))), /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13 } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: terminal, onChange: (e) => setTerminal(e.target.checked) }), "Estado terminal (resolvido)"))
  );
}
window.EstadoFormModal = EstadoFormModal;

// ===== stockreborn/frontend/admin-tipos-acao.jsx =====
function TipoAcaoPanel({ tiposAcao = [], reload }) {
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const handleCreate = async (data) => {
    try {
      setError(null);
      await window.API.createTipoAcao(data);
      setCreating(false);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleUpdate = async (slug, patch) => {
    try {
      setError(null);
      await window.API.updateTipoAcao(slug, patch);
      setEditing(null);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDelete = async (t) => {
    if (!await window.hubConfirm({ message: `Apagar tipo de a\xE7\xE3o "${t.nome}"?` })) return;
    try {
      setError(null);
      await window.API.deleteTipoAcao(t.id_slug);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const columns = [
    {
      key: "nome",
      label: "Nome",
      width: 220,
      minWidth: 150,
      fixed: true,
      render: (t) => /* @__PURE__ */ React.createElement("strong", null, t.nome)
    },
    {
      key: "id_slug",
      label: "Identificador",
      width: 170,
      minWidth: 120,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, t.id_slug)
    },
    {
      key: "icon",
      label: "\xCDcone",
      width: 110,
      minWidth: 80,
      render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, t.icon || "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 160,
      minWidth: 140,
      render: (t) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(t) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleDelete(t) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Tipos de a\xE7\xE3o"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Novo")), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "admin-tipos-acao",
      columns,
      data: tiposAcao,
      pagination: "none",
      rowKey: (t) => t.id_slug
    }
  ), creating && /* @__PURE__ */ React.createElement(TipoAcaoFormModal, { title: "Novo tipo de a\xE7\xE3o", onClose: () => setCreating(false), onSubmit: handleCreate, withSlug: true }), editing && /* @__PURE__ */ React.createElement(
    TipoAcaoFormModal,
    {
      title: `Editar ${editing.nome}`,
      initial: editing,
      onClose: () => setEditing(null),
      onSubmit: (d) => handleUpdate(editing.id_slug, d)
    }
  ));
}
window.TipoAcaoPanel = TipoAcaoPanel;
function TipoAcaoFormModal({ title, initial = {}, withSlug = false, onClose, onSubmit }) {
  const [nome, setNome] = useState(initial.nome || "");
  const [idSlug, setIdSlug] = useState(initial.id_slug || "");
  const [icon, setIcon] = useState(initial.icon || "");
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "tipoacao-form", className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement("form", { id: "tipoacao-form", onSubmit: (e) => {
      e.preventDefault();
      const data = { nome, icon };
      if (withSlug) data.id_slug = idSlug || nome.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
      onSubmit(data);
    }, style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement("input", { value: nome, onChange: (e) => setNome(e.target.value), required: true, autoFocus: true })), withSlug && /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Identificador (slug)"), /* @__PURE__ */ React.createElement("input", { value: idSlug, onChange: (e) => setIdSlug(e.target.value), placeholder: "auto", pattern: "[a-z0-9_]*" })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "\xCDcone (opcional)"), /* @__PURE__ */ React.createElement("input", { value: icon, onChange: (e) => setIcon(e.target.value), placeholder: "ex: mail, phone, visit" })))
  );
}
window.TipoAcaoFormModal = TipoAcaoFormModal;

// ===== stockreborn/frontend/admin-db-connections.jsx =====
function DBConnectionPanel({ dbConnections = [], reload }) {
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const [testResults, setTestResults] = useState({});
  const handleCreate = async (data) => {
    try {
      setError(null);
      await window.API.createDBConnection(data);
      setCreating(false);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleUpdate = async (id, patch) => {
    try {
      setError(null);
      await window.API.updateDBConnection(id, patch);
      setEditing(null);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDelete = async (c) => {
    if (!await window.hubConfirm({ message: `Apagar liga\xE7\xE3o "${c.name}"?` })) return;
    try {
      setError(null);
      await window.API.deleteDBConnection(c.id);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleActivate = async (c) => {
    try {
      setError(null);
      await window.API.activateDBConnection(c.id);
      await reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleTest = async (c) => {
    setTestResults((r) => ({ ...r, [c.id]: { loading: true } }));
    try {
      const res = await window.API.testDBConnection(c.id);
      setTestResults((r) => ({ ...r, [c.id]: res }));
    } catch (e) {
      setTestResults((r) => ({ ...r, [c.id]: { ok: false, message: e.message } }));
    }
  };
  const columns = [
    {
      key: "name",
      label: "Nome",
      width: 180,
      minWidth: 130,
      fixed: true,
      render: (c) => /* @__PURE__ */ React.createElement("strong", null, c.name)
    },
    {
      key: "host",
      label: "Host",
      width: 190,
      minWidth: 140,
      render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, c.host, ":", c.port)
    },
    {
      key: "database",
      label: "Database",
      width: 150,
      minWidth: 110,
      render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, c.database)
    },
    {
      key: "view_name",
      label: "View",
      width: 150,
      minWidth: 110,
      render: (c) => /* @__PURE__ */ React.createElement("span", { className: "td-mono td-muted" }, c.view_name)
    },
    {
      key: "is_active",
      label: "Ativa",
      width: 80,
      minWidth: 60,
      render: (c) => c.is_active ? /* @__PURE__ */ React.createElement("span", { style: { color: "#059669" } }, "\u2713") : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 300,
      minWidth: 260,
      render: (c) => {
        const tr = testResults[c.id];
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleTest(c) }, "Testar"), !c.is_active && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleActivate(c) }, "Ativar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(c) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => handleDelete(c) }, "Apagar"), tr && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, marginTop: 4, color: tr.loading ? "var(--muted)" : tr.ok ? "#059669" : "#c4434b" } }, tr.loading ? "..." : tr.message));
      }
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Liga\xE7\xF5es ERP (MSSQL)"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 uma ativa de cada vez"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Nova")), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "admin-ligacoes-bd",
      columns,
      data: dbConnections,
      pagination: "none",
      rowKey: (c) => c.id,
      empty: "Sem liga\xE7\xF5es configuradas. Sem liga\xE7\xE3o ativa, a app usa mock data."
    }
  ), creating && /* @__PURE__ */ React.createElement(DBConnectionFormModal, { title: "Nova liga\xE7\xE3o", onClose: () => setCreating(false), onSubmit: handleCreate, withPassword: true }), editing && /* @__PURE__ */ React.createElement(
    DBConnectionFormModal,
    {
      title: `Editar ${editing.name}`,
      initial: editing,
      onClose: () => setEditing(null),
      onSubmit: (d) => handleUpdate(editing.id, d)
    }
  ));
}
window.DBConnectionPanel = DBConnectionPanel;
function DBConnectionFormModal({ title, initial = {}, withPassword = false, onClose, onSubmit }) {
  const [form, setForm] = useState({
    name: initial.name || "",
    host: initial.host || "",
    port: initial.port ?? 1433,
    database: initial.database || "",
    username: initial.username || "",
    password: "",
    driver: initial.driver || "ODBC Driver 18 for SQL Server",
    view_name: initial.view_name || "v_stockreborn"
  });
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      subtitle: "Credenciais encriptadas em BD",
      width: 520,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "db-form", className: "btn primary sm" }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement(
      "form",
      {
        id: "db-form",
        onSubmit: (e) => {
          e.preventDefault();
          onSubmit({ ...form, port: Number(form.port) });
        },
        style: { display: "flex", flexDirection: "column", gap: 12 }
      },
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome"), /* @__PURE__ */ React.createElement("input", { value: form.name, onChange: upd("name"), required: true, autoFocus: true })),
      /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field", style: { gridColumn: "span 1" } }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Host"), /* @__PURE__ */ React.createElement("input", { value: form.host, onChange: upd("host"), required: true, placeholder: "ex: srv01.local" })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Porta"), /* @__PURE__ */ React.createElement("input", { type: "number", value: form.port, onChange: upd("port") }))),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Database"), /* @__PURE__ */ React.createElement("input", { value: form.database, onChange: upd("database"), required: true })),
      /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Username"), /* @__PURE__ */ React.createElement("input", { value: form.username, onChange: upd("username"), required: true })), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Password"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "password",
          value: form.password,
          onChange: upd("password"),
          required: withPassword,
          placeholder: withPassword ? "" : "(manter)"
        }
      ))),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Driver ODBC"), /* @__PURE__ */ React.createElement("input", { value: form.driver, onChange: upd("driver") })),
      /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nome da view"), /* @__PURE__ */ React.createElement("input", { value: form.view_name, onChange: upd("view_name"), required: true }))
    )
  );
}
window.DBConnectionFormModal = DBConnectionFormModal;

// ===== stockreborn/frontend/reaproveitamento.jsx =====
function _reapCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}
window.ReapAPI = {
  get: async (path) => {
    const res = await fetch(path, { credentials: "include" });
    if (!res.ok) throw new Error(`GET ${path} \u2192 ${res.status}`);
    return res.json();
  },
  post: async (path) => {
    const csrf = _reapCookie("csrftoken");
    const res = await fetch(path, {
      method: "POST",
      credentials: "include",
      headers: csrf ? { "X-CSRFToken": csrf } : {}
    });
    if (!res.ok) {
      let body = null;
      try {
        body = await res.json();
      } catch (e) {
        body = null;
      }
      throw new Error(body && body.detail || `POST ${path} \u2192 ${res.status}`);
    }
    return res.status === 204 ? null : res.json();
  }
};
const REAP_ABAS = [
  { id: "plano", label: "Plano" },
  { id: "monos", label: "Monos" },
  { id: "alvos", label: "Artigos de maior sa\xEDda" }
];
const REAP_CORES_PALETA = [
  "#c8d8f0",
  "#d4ecd0",
  "#f5e3c0",
  "#f3cdd3",
  "#cdeee8",
  "#e6d6f0",
  "#f0dcc0",
  "#d0dce6"
];
function reapFmtData(iso) {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-PT") + (iso.length > 10 ? " " + d.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" }) : "");
}
function reapFmtNum(v, casas) {
  return v == null ? "\u2014" : Number(v).toLocaleString("pt-PT", { maximumFractionDigits: casas == null ? 0 : casas });
}
function reapPlanoTexto(plano) {
  if (!plano) return "";
  if (plano.estado_solver === "otimo") return "Solver: \xF3timo";
  if (plano.estado_solver === "viavel") {
    return plano.gap_pct == null ? "Solver: vi\xE1vel" : `Solver: vi\xE1vel (gap ${reapFmtNum(plano.gap_pct, 1)}%)`;
  }
  if (plano.estado_solver === "erro") return "Solver: erro \u2014 o plano n\xE3o foi calculado.";
  if (plano.estado_solver === "sem_solucao") return "Solver: sem solu\xE7\xE3o no tempo limite \u2014 recalcule; se persistir, avise quem mant\xE9m a app.";
  if (plano.estado_solver === "sem_fontes") return "Sem plano \u2014 nenhum mono serve para os artigos com procura.";
  return "O \xFAltimo c\xE1lculo \xE9 anterior ao plano de corte \u2014 recalcule para o ver.";
}
function ReapAbc({ abc }) {
  if (!abc) return /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, "\u2014");
  return /* @__PURE__ */ React.createElement("span", { className: "badge" }, abc);
}
function ReapPlanoDeCorte({ ref_ }) {
  const { useState, useEffect } = React;
  const [planoFonte, setPlanoFonte] = useState(null);
  useEffect(() => {
    setPlanoFonte(null);
    window.ReapAPI.get(`/api/reaproveitamento/plano/${encodeURIComponent(ref_)}/`).then(setPlanoFonte).catch((e) => {
      if (!/→ 404/.test(String(e && e.message))) console.error(e);
    });
  }, [ref_]);
  const cortes = planoFonte && planoFonte.cortes;
  if (!cortes || cortes.length === 0) return null;
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, "Plano de corte (todos os pain\xE9is)"), cortes.map((corte, i) => /* @__PURE__ */ React.createElement("div", { key: i, className: "td-muted", style: { fontSize: 12 } }, corte.quantidade, "\xD7 painel ", corte.comprimento, "\xD7", corte.largura, " \u2014 ", Object.keys(corte.contagem || {}).length === 0 ? "por cortar (sobra)" : Object.entries(corte.contagem).map(([ref, n]) => `${ref} \xD7${n}`).join(", "))));
}
function ReapFonteDrawer({ ref_, onClose }) {
  const { useState, useEffect } = React;
  const [det, setDet] = useState(null);
  const [erro, setErro] = useState("");
  useEffect(() => {
    setDet(null);
    setErro("");
    window.ReapAPI.get(`/api/reaproveitamento/fontes/${encodeURIComponent(ref_)}/`).then(setDet).catch((e) => setErro(/→ 404/.test(e.message) ? "Este mono n\xE3o est\xE1 no \xFAltimo c\xE1lculo." : String(e)));
  }, [ref_]);
  const f = det && det.fonte;
  const COMPAT_COLUNAS = [
    { key: "ref", label: "Artigo", width: 140, mono: true, render: (c) => c.ref },
    { key: "designacao", label: "Designa\xE7\xE3o", width: 240, render: (c) => c.designacao },
    { key: "abc", label: "ABC", width: 60, render: (c) => /* @__PURE__ */ React.createElement(ReapAbc, { abc: c.abc }) },
    {
      key: "compativel",
      label: "Serve?",
      width: 70,
      sortValue: (c) => c.compativel ? 0 : 1,
      render: (c) => c.compativel ? "\u2713" : "\u2717"
    },
    { key: "motivo", label: "Porqu\xEA", width: 220, render: (c) => c.motivo }
  ];
  return /* @__PURE__ */ React.createElement(window.DrawerShell, { title: ref_, subtitle: f ? f.descricao : "Reaproveitamento", onClose }, erro && /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { padding: 16 } }, erro), !det && !erro && /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { padding: 16 } }, "A carregar\u2026"), f && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "Fam\xEDlia"), " ", f.familia, " \xB7 ", /* @__PURE__ */ React.createElement("b", null, "FEFCO"), " ", f.fefco || "\u2014", " \xB7 ", /* @__PURE__ */ React.createElement("b", null, "Stock"), " ", f.stock), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "Placa"), " ", f.ref_mp || "\u2014", " \xB7 ", f.comprimento, "\xD7", f.largura, " mm \xB7 vincos ", f.vincos || "\u2014", " \xB7 ", /* @__PURE__ */ React.createElement("b", null, "qualidade"), " ", f.qualidade || "\u2014"), !f.calculavel && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--danger)" } }, "N\xE3o calcul\xE1vel: ", f.motivo)), det.paineis.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5 } }, /* @__PURE__ */ React.createElement("b", null, "Pain\xE9is \xFAteis por unidade:"), " ", det.paineis.map((p) => `${p.por_unidade}\xD7 ${p.comprimento}\xD7${p.largura}`).join(" \xB7 ")), f.calculavel && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "reap-fonte-compat",
      columns: COMPAT_COLUNAS,
      data: det.compat,
      pagination: "client",
      rowKey: (c) => c.ref,
      rowStyle: () => ({ cursor: "default" }),
      empty: "Nenhum artigo de maior sa\xEDda no c\xE1lculo."
    }
  ), /* @__PURE__ */ React.createElement(ReapDesenhoMono, { ref_ }), /* @__PURE__ */ React.createElement(ReapPlanoDeCorte, { ref_ })));
}
function ReaproveitamentoView({ entidade, params, navigate }) {
  const { useState, useEffect, useCallback, useRef } = React;
  const abaUrl = params && typeof params.get === "function" ? params.get("aba") : null;
  const aba = REAP_ABAS.some((a) => a.id === abaUrl) ? abaUrl : "plano";
  const [resumo, setResumo] = useState(null);
  const [fontes, setFontes] = useState([]);
  const [alvos, setAlvos] = useState([]);
  const [plano, setPlano] = useState(null);
  const [erro, setErro] = useState("");
  const [erroRecalcular, setErroRecalcular] = useState("");
  const [aPedir, setAPedir] = useState(false);
  useEffect(() => {
    window.ReapVerde && window.ReapVerde.garantirEstilo();
  }, []);
  const carregarFontesAlvos = useCallback(() => {
    Promise.all([
      window.ReapAPI.get("/api/reaproveitamento/fontes/"),
      window.ReapAPI.get("/api/reaproveitamento/alvos/"),
      window.ReapAPI.get("/api/reaproveitamento/plano/")
    ]).then(([f, a, p]) => {
      setFontes(f);
      setAlvos(a);
      setPlano(p);
    }).catch((e) => setErro(String(e)));
  }, []);
  useEffect(() => {
    window.ReapAPI.get("/api/reaproveitamento/").then((r) => {
      setResumo(r);
      carregarFontesAlvos();
    }).catch((e) => setErro(String(e)));
  }, [carregarFontesAlvos]);
  const corridaId = resumo && resumo.a_correr && resumo.a_correr.id;
  const recarregada = useRef(null);
  useEffect(() => {
    if (!corridaId) return void 0;
    const t = setInterval(() => {
      window.ReapAPI.get("/api/reaproveitamento/").then((r) => {
        setResumo(r);
        if (!r.a_correr && recarregada.current !== corridaId) {
          recarregada.current = corridaId;
          carregarFontesAlvos();
        }
      }).catch((e) => setErro(String(e)));
    }, 5e3);
    return () => clearInterval(t);
  }, [corridaId, carregarFontesAlvos]);
  const recalcular = async () => {
    setErroRecalcular("");
    setAPedir(true);
    try {
      await window.ReapAPI.post("/api/reaproveitamento/recalcular/");
      const r = await window.ReapAPI.get("/api/reaproveitamento/");
      setResumo(r);
      if (!r.a_correr) carregarFontesAlvos();
    } catch (e) {
      setErroRecalcular(String(e && e.message || e));
      window.ReapAPI.get("/api/reaproveitamento/").then(setResumo).catch(() => {
      });
    } finally {
      setAPedir(false);
    }
  };
  const irAba = (id) => navigate({ routeId: "reaproveitamento", params: { aba: id } });
  const abrir = (ref) => navigate({ routeId: "reaproveitamento", entidade: ref, params: { aba } });
  const fechar = () => navigate({ routeId: "reaproveitamento", params: { aba } });
  const FONTES_COLUNAS = [
    { key: "ref", label: "Mono", width: 150, mono: true, fixed: true, render: (f) => f.ref },
    { key: "descricao", label: "Descri\xE7\xE3o", width: 260, render: (f) => f.descricao },
    { key: "familia", label: "Fam\xEDlia", width: 70, render: (f) => f.familia },
    { key: "fefco", label: "FEFCO", width: 70, render: (f) => f.fefco || "\u2014" },
    { key: "stock", label: "Stock", width: 80, align: "right", mono: true, render: (f) => f.stock },
    { key: "qualidade", label: "Qualidade", width: 80, render: (f) => f.qualidade || "\u2014" },
    { key: "n_paineis", label: "Pain\xE9is", width: 70, align: "right", render: (f) => f.n_paineis },
    { key: "n_compativeis", label: "Serve para", width: 90, align: "right", render: (f) => f.n_compativeis },
    {
      key: "melhor_abc",
      label: "Melhor ABC",
      width: 90,
      sortValue: (f) => ({ A: 0, B: 1, C: 2 })[f.melhor_abc] ?? null,
      render: (f) => /* @__PURE__ */ React.createElement(ReapAbc, { abc: f.melhor_abc })
    },
    {
      key: "motivo",
      label: "N\xE3o calcul\xE1vel porque",
      width: 220,
      render: (f) => f.calculavel ? "" : f.motivo
    }
  ];
  const ALVOS_COLUNAS = [
    { key: "ref", label: "Artigo", width: 140, mono: true, fixed: true, render: (a) => a.ref },
    { key: "designacao", label: "Designa\xE7\xE3o", width: 260, render: (a) => a.designacao },
    { key: "abc", label: "ABC", width: 60, render: (a) => /* @__PURE__ */ React.createElement(ReapAbc, { abc: a.abc }) },
    {
      key: "valor",
      label: "Valor (\u20AC)",
      width: 110,
      align: "right",
      mono: true,
      sortValue: (a) => Number(a.valor),
      render: (a) => Number(a.valor).toLocaleString("pt-PT", { maximumFractionDigits: 0 })
    },
    {
      key: "procura_placas",
      label: "Procura (placas)",
      width: 120,
      align: "right",
      mono: true,
      sortValue: (a) => Number(a.procura_placas),
      render: (a) => Number(a.procura_placas).toLocaleString("pt-PT", { maximumFractionDigits: 0 })
    },
    {
      key: "placa",
      label: "Placa",
      width: 120,
      mono: true,
      sortable: false,
      render: (a) => `${a.comprimento}\xD7${a.largura}`
    },
    { key: "qualidade", label: "Qualidade", width: 80, render: (a) => a.qualidade },
    { key: "n_fontes", label: "Monos que servem", width: 120, align: "right", render: (a) => a.n_fontes },
    {
      key: "produzido_placas",
      label: "Produzido (placas)",
      width: 130,
      align: "right",
      mono: true,
      sortValue: (a) => Number(a.produzido_placas),
      render: (a) => reapFmtNum(a.produzido_placas)
    },
    {
      key: "unidades_artigo",
      label: "Unidades de artigo",
      width: 130,
      align: "right",
      mono: true,
      sortValue: (a) => Number(a.unidades_artigo),
      render: (a) => reapFmtNum(a.unidades_artigo)
    },
    {
      key: "cobertura_pct",
      label: "Cobertura %",
      width: 100,
      align: "right",
      mono: true,
      sortValue: (a) => a.cobertura_pct != null ? Number(a.cobertura_pct) : null,
      render: (a) => a.cobertura_pct != null ? `${reapFmtNum(a.cobertura_pct, 1)}%` : "\u2014"
    }
  ];
  const PLANO_COLUNAS = [
    { key: "ref", label: "Mono", width: 150, mono: true, fixed: true, render: (l) => l.ref },
    { key: "descricao", label: "Descri\xE7\xE3o", width: 260, render: (l) => l.descricao },
    { key: "stock", label: "Stock", width: 80, align: "right", mono: true, render: (l) => l.stock },
    {
      key: "unidades_abrir",
      label: "Abrir (unidades)",
      width: 130,
      align: "right",
      mono: true,
      render: (l) => l.unidades_abrir
    },
    {
      key: "quebra_pct",
      label: "Quebra %",
      width: 90,
      align: "right",
      mono: true,
      sortValue: (l) => l.quebra_pct != null ? Number(l.quebra_pct) : null,
      render: (l) => l.quebra_pct != null ? `${reapFmtNum(l.quebra_pct, 1)}%` : "\u2014"
    },
    {
      key: "alvos",
      label: "Serve",
      width: 280,
      sortable: false,
      render: (l) => l.alvos.map((a) => `${a.ref} \xD7${a.placas}`).join(" \xB7 ")
    }
  ];
  const calc = resumo && resumo.calculo;
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden", flex: 1, gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-start", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5, flex: 1 } }, calc ? `Calculado a ${reapFmtData(calc.terminado_em)} \xB7 vendas de ${reapFmtData(calc.datai)} a ${reapFmtData(calc.dataf)} \xB7 procura para ${calc.meses_cobertura} meses \xB7 ${calc.n_calculaveis} de ${calc.n_fontes} monos calcul\xE1veis` : resumo ? "Ainda n\xE3o h\xE1 nenhum c\xE1lculo. O primeiro corre esta noite." : ""), resumo && resumo.pode_configurar && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", disabled: aPedir || !!resumo.a_correr, onClick: recalcular }, resumo.a_correr ? "A calcular\u2026" : "Recalcular agora")), erroRecalcular && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--danger)", fontSize: 12.5 } }, erroRecalcular), resumo && resumo.ultimo_erro && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--danger)", fontSize: 12.5 } }, "O \xFAltimo c\xE1lculo (", reapFmtData(resumo.ultimo_erro.iniciado_em), ") falhou: ", resumo.ultimo_erro.erro), erro && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--danger)" } }, erro), /* @__PURE__ */ React.createElement("div", { className: "tabs", style: { display: "flex", gap: 16, borderBottom: "1px solid var(--border)", marginBottom: 4, flexShrink: 0 } }, REAP_ABAS.map((a) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: a.id,
      className: a.id === aba ? "tab-btn active" : "tab-btn",
      onClick: () => irAba(a.id),
      style: {
        background: "transparent",
        border: "none",
        cursor: "pointer",
        padding: "8px 4px",
        fontWeight: a.id === aba ? 600 : 400,
        borderBottom: a.id === aba ? "2px solid var(--accent)" : "2px solid transparent",
        marginBottom: -1
      }
    },
    a.label
  ))), aba === "plano" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5, flexShrink: 0 } }, reapPlanoTexto(plano)), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "reap-plano",
      pagination: "client",
      columns: PLANO_COLUNAS,
      data: plano && plano.linhas || [],
      rowKey: (l) => l.ref,
      onRowClick: (l) => abrir(l.ref),
      rowClassName: () => "reap-verde",
      empty: "Sem plano no \xFAltimo c\xE1lculo."
    }
  )), aba === "monos" && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "reap-monos",
      pagination: "client",
      columns: FONTES_COLUNAS,
      data: fontes,
      rowKey: (f) => f.ref,
      onRowClick: (f) => abrir(f.ref),
      rowClassName: (f) => (window.ReapVerde ? window.ReapVerde.classe(f.n_compativeis) : "") || void 0,
      empty: "Sem monos no \xFAltimo c\xE1lculo."
    }
  ), aba === "alvos" && /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "reap-alvos",
      pagination: "client",
      columns: ALVOS_COLUNAS,
      data: alvos,
      rowKey: (a) => a.ref,
      rowStyle: () => ({ cursor: "default" }),
      empty: "Sem artigos no \xFAltimo c\xE1lculo."
    }
  ), entidade && /* @__PURE__ */ React.createElement(ReapFonteDrawer, { ref_: entidade, onClose: fechar }));
}
window.ReaproveitamentoView = ReaproveitamentoView;

// ===== stockreborn/frontend/reaproveitamento_desenhos.jsx =====
const REAP_ESTILO_FORMA = {
  cartao: { fill: "var(--panel-2)", stroke: "var(--border-strong)" },
  pala: { fill: "var(--border)", stroke: "var(--border-strong)" },
  painel: { fill: "var(--reap-verde-fundo)", stroke: "var(--reap-verde)", dash: true },
  peca: { stroke: "var(--border-strong)" },
  vinco: { stroke: "var(--muted)", dash: true },
  face: { fill: "#e7c9a0", stroke: "#8a6a45" },
  topo: { fill: "#f0d9b5", stroke: "#8a6a45" },
  lado: { fill: "#d4b184", stroke: "#8a6a45" },
  interior: { fill: "#a9855c", stroke: "#8a6a45" },
  aba: { stroke: "#8a6a45" }
};
function reapForma(f, i, cores, traco, fonte) {
  const e = REAP_ESTILO_FORMA[f.classe] || {};
  const dash = e.dash ? `${4 * traco} ${3 * traco}` : void 0;
  if (f.t === "rect") {
    const fill = f.classe === "peca" ? cores[f.alvo] || "#ccc" : e.fill || "none";
    const r = /* @__PURE__ */ React.createElement(
      "rect",
      {
        key: i,
        x: f.x,
        y: f.y,
        width: f.w,
        height: f.h,
        fill,
        stroke: e.stroke || "none",
        strokeWidth: traco,
        strokeDasharray: dash
      }
    );
    const cabeTexto = f.classe === "peca" && Math.min(f.w, f.h) / traco >= REAP_PECA_COM_TEXTO_PX;
    if (!cabeTexto) return r;
    return /* @__PURE__ */ React.createElement("g", { key: i }, r, /* @__PURE__ */ React.createElement(
      "text",
      {
        x: f.x + f.w / 2,
        y: f.y + f.h / 2,
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 9 * traco,
        fill: "#1f2937"
      },
      f.alvo
    ));
  }
  if (f.t === "linha") {
    return /* @__PURE__ */ React.createElement(
      "line",
      {
        key: i,
        x1: f.x1,
        y1: f.y1,
        x2: f.x2,
        y2: f.y2,
        stroke: e.stroke || "var(--border-strong)",
        strokeWidth: traco,
        strokeDasharray: dash
      }
    );
  }
  if (f.t === "poli") {
    return /* @__PURE__ */ React.createElement(
      "polygon",
      {
        key: i,
        points: f.pontos.map((p) => p.join(",")).join(" "),
        fill: e.fill || "none",
        stroke: e.stroke || "none",
        strokeWidth: traco
      }
    );
  }
  if (f.t === "texto") {
    return /* @__PURE__ */ React.createElement(
      "text",
      {
        key: i,
        x: f.x,
        y: f.y,
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: fonte,
        fontWeight: f.classe === "rotulo" ? 600 : 400,
        fill: f.classe === "rotulo" ? "#1f2937" : "var(--text-2)"
      },
      f.texto
    );
  }
  return null;
}
const REAP_PECA_COM_TEXTO_PX = 40;
const REAP_MARGEM_MIN_PX = 34;
function ReapFormasSVG({ desenho, cores, larguraPx }) {
  if (!desenho || !desenho.largura || !desenho.altura) return null;
  const m0 = desenho.margem || 0;
  const m = Math.max(m0, REAP_MARGEM_MIN_PX / (larguraPx / (desenho.largura + 2 * m0)));
  const vbW = desenho.largura + 2 * m;
  const vbH = desenho.altura + 2 * m;
  const escala = larguraPx / vbW;
  const traco = 1 / escala;
  const fonte = Math.max(m0 * 0.45, 10 / escala);
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox: `${-m} ${-m} ${vbW} ${vbH}`,
      width: larguraPx,
      height: Math.round(vbH * escala),
      style: { display: "block", maxWidth: "100%", height: "auto" },
      role: "img"
    },
    (desenho.formas || []).map((f, i) => reapForma(f, i, cores || {}, traco, fonte))
  );
}
function reapMedidasArtigo(a) {
  if (a.codigo && a.c && a.l && a.h) return `${a.c}\xD7${a.l}\xD7${a.h} mm`;
  if (!a.codigo) return `${a.comprimento}\xD7${a.largura} mm`;
  return `placa ${a.comprimento}\xD7${a.largura} mm`;
}
function ReapDesenhoMono({ ref_, onAbrirArtigo }) {
  const { useState, useEffect, useMemo } = React;
  const [det, setDet] = useState(null);
  useEffect(() => {
    window.ReapVerde && window.ReapVerde.garantirEstilo();
  }, []);
  useEffect(() => {
    setDet(null);
    if (!ref_) return void 0;
    let cancelled = false;
    window.ReapAPI.get(`/api/reaproveitamento/desenho/${encodeURIComponent(ref_)}/`).then((d) => {
      if (!cancelled) setDet(d);
    }).catch((e) => {
      if (!/→ (404|403)/.test(String(e && e.message || e))) console.error(e);
    });
    return () => {
      cancelled = true;
    };
  }, [ref_]);
  const cores = useMemo(() => {
    const mapa = {};
    (det && det.aplicacoes || []).forEach((a, i) => {
      mapa[a.ref] = REAP_CORES_PALETA[i % REAP_CORES_PALETA.length];
    });
    return mapa;
  }, [det]);
  if (!det || !det.planificacao && det.aplicacoes.length === 0) return null;
  const p = det.planificacao;
  const extra = det.aplicacoes_origem === "compativel" ? det.n_compativeis - det.aplicacoes.length : 0;
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, "Como se aproveita"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-start" } }, p && /* @__PURE__ */ React.createElement("div", { style: { flex: "1 1 320px", minWidth: 0, display: "flex", flexDirection: "column", gap: 4 } }, /* @__PURE__ */ React.createElement(ReapFormasSVG, { desenho: p, cores, larguraPx: 420 }), /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12 } }, det.fonte.codigo ? `FEFCO ${det.fonte.codigo} aberta` : "Placa", p.por_unidade > 1 && ` \xB7 meia-placa (${p.por_unidade} por caixa)`, " \u2014 ", p.no_plano && p.desatualizada ? "os par\xE2metros de corte mudaram depois do c\xE1lculo \u2014 recalcule para ver as pe\xE7as." : p.no_plano ? p.caixa_tipo.length > 0 ? `caixa-tipo: ${p.caixa_tipo.map((c) => `${c.n}\xD7 ${c.alvo}`).join(" \xB7 ")}` : "caixa-tipo sem pe\xE7as (sobra)" : "fora do plano atual: a verde, onde se pode cortar.")), det.aplicacoes.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { flex: "1 1 240px", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 8 } }, det.aplicacoes.map((a) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key: a.ref,
      onClick: onAbrirArtigo ? () => onAbrirArtigo(a.ref) : void 0,
      style: {
        border: "1px solid var(--border)",
        borderLeft: `6px solid ${cores[a.ref]}`,
        borderRadius: 6,
        padding: 6,
        cursor: onAbrirArtigo ? "pointer" : "default",
        display: "flex",
        flexDirection: "column",
        gap: 4
      }
    },
    a.desenho ? /* @__PURE__ */ React.createElement(ReapFormasSVG, { desenho: a.desenho, cores, larguraPx: 140 }) : /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 11.5 } }, "Recalcule para ver o desenho."),
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontFamily: "var(--font-mono, monospace)" } }, a.ref, " ", /* @__PURE__ */ React.createElement(ReapAbc, { abc: a.abc })),
    /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 11.5 } }, a.codigo ? `FEFCO ${a.codigo}` : "Placa", " \xB7 ", reapMedidasArtigo(a), a.desenho && a.desenho.aproximado && " \xB7 desenho aproximado"),
    /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 11.5 } }, a.no_plano_placas ? `no plano: ${reapFmtNum(a.no_plano_placas)} placas` : `${a.pecas_por_unidade} por caixa`)
  )))), extra > 0 && /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12 } }, "+ ", extra, " ", extra === 1 ? "outro artigo compat\xEDvel" : "outros artigos compat\xEDveis", " na lista."));
}
window.ReapFormasSVG = ReapFormasSVG;
window.ReapDesenhoMono = ReapDesenhoMono;

// ===== stockreborn/frontend/reaproveitamento_pode_virar.jsx =====
function ReapFichaArtigo({ ref_, codigoAtual, onClose }) {
  const { useState, useEffect } = React;
  const [estado, setEstado] = useState("a_carregar");
  const [dados, setDados] = useState(null);
  useEffect(() => {
    setEstado("a_carregar");
    setDados(null);
    if (!ref_) return void 0;
    let cancelled = false;
    window.ReapAPI.get(`/api/reaproveitamento/alvos/${encodeURIComponent(ref_)}/`).then((det) => {
      if (cancelled) return;
      setDados(det);
      setEstado("ok");
    }).catch((e) => {
      if (cancelled) return;
      if (!/→ (404|403)/.test(String(e && e.message || e))) console.error(e);
      setEstado("fora");
    });
    return () => {
      cancelled = true;
    };
  }, [ref_]);
  const abrirMono = (f) => {
    onClose();
    window.HubRouter.navigate({ routeId: "listagem", entidade: f.ref });
  };
  const a = dados && dados.alvo;
  const FONTES_COLUNAS = [
    { key: "ref", label: "Mono", width: 140, mono: true, render: (f) => f.ref },
    { key: "descricao", label: "Descri\xE7\xE3o", width: 220, render: (f) => f.descricao },
    { key: "stock", label: "Stock", width: 80, align: "right", mono: true, render: (f) => f.stock },
    {
      key: "pecas_por_unidade",
      label: "Por caixa",
      width: 90,
      align: "right",
      mono: true,
      render: (f) => f.pecas_por_unidade
    },
    {
      key: "placas_max",
      label: "M\xE1x. placas",
      width: 100,
      align: "right",
      mono: true,
      render: (f) => reapFmtNum(f.placas_max)
    },
    {
      key: "no_plano_placas",
      label: "No plano",
      width: 90,
      align: "right",
      mono: true,
      render: (f) => f.no_plano_placas ? reapFmtNum(f.no_plano_placas) : "\u2014"
    }
  ];
  return /* @__PURE__ */ React.createElement(window.ModalShell, { title: `Artigo ${ref_}`, subtitle: a ? a.designacao : "", onClose, width: 720 }, estado === "a_carregar" && /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5 } }, "A carregar\u2026"), estado === "fora" && /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5 } }, "Este artigo n\xE3o est\xE1 no \xFAltimo c\xE1lculo."), estado === "ok" && a && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "ABC"), " ", a.abc || "\u2014", " \xB7 ", /* @__PURE__ */ React.createElement("b", null, "Valor"), " ", reapFmtNum(a.valor), " \u20AC \xB7", " ", /* @__PURE__ */ React.createElement("b", null, "Placa"), " ", a.comprimento, "\xD7", a.largura, " mm \xB7 ", /* @__PURE__ */ React.createElement("b", null, "Qualidade"), " ", a.qualidade || "\u2014"), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("b", null, "Procura"), " ", reapFmtNum(a.procura_placas), " placas \xB7", " ", /* @__PURE__ */ React.createElement("b", null, "Produzido"), " ", reapFmtNum(a.produzido_placas), " placas \xB7", " ", /* @__PURE__ */ React.createElement("b", null, "Cobertura"), " ", a.cobertura_pct != null ? `${reapFmtNum(a.cobertura_pct, 1)}%` : "\u2014")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "reap-ficha-artigo",
      rowClassName: (f) => f.ref === codigoAtual ? "selected" : void 0,
      pagination: "client",
      columns: FONTES_COLUNAS,
      data: dados.fontes,
      rowKey: (f) => f.ref,
      onRowClick: abrirMono,
      empty: "Nenhum mono compat\xEDvel."
    }
  )));
}
function ReapPodeVirar({ codigo }) {
  const { useState, useEffect } = React;
  const [estado, setEstado] = useState("a_carregar");
  const [fonte, setFonte] = useState(null);
  const [compat, setCompat] = useState([]);
  const [plano, setPlano] = useState(null);
  const [verPorque, setVerPorque] = useState(false);
  const [ficha, setFicha] = useState(null);
  useEffect(() => {
    window.ReapVerde && window.ReapVerde.garantirEstilo();
  }, []);
  useEffect(() => {
    setEstado("a_carregar");
    setFonte(null);
    setCompat([]);
    setPlano(null);
    setVerPorque(false);
    setFicha(null);
    if (!codigo) return void 0;
    let cancelled = false;
    window.ReapAPI.get(`/api/reaproveitamento/fontes/${encodeURIComponent(codigo)}/`).then((det) => {
      if (cancelled) return;
      setFonte(det.fonte);
      setCompat(det.compat || []);
      setEstado("ok");
      if (!(det.fonte && det.fonte.unidades_abrir > 0)) return;
      window.ReapAPI.get(`/api/reaproveitamento/plano/${encodeURIComponent(codigo)}/`).then((p) => {
        if (!cancelled) setPlano(p);
      }).catch((e) => {
        if (!cancelled && !/→ 404/.test(String(e && e.message || e))) console.error(e);
      });
    }).catch((e) => {
      if (cancelled) return;
      if (!/→ (404|403)/.test(String(e && e.message || e))) console.error(e);
      setEstado("fora");
    });
    return () => {
      cancelled = true;
    };
  }, [codigo]);
  const abrir = () => window.HubRouter.navigate({ routeId: "reaproveitamento", entidade: codigo, params: { aba: "monos" } });
  if (estado === "a_carregar") {
    return /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5 } }, "A ver o reaproveitamento\u2026");
  }
  if (estado === "fora") {
    return /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5 } }, "Este mono n\xE3o entrou no \xFAltimo c\xE1lculo de reaproveitamento.");
  }
  const compativeis = compat.filter((c) => c.compativel);
  const recusados = compat.filter((c) => !c.compativel && c.motivo);
  const contagemMotivos = {};
  recusados.forEach((c) => {
    contagemMotivos[c.motivo] = (contagemMotivos[c.motivo] || 0) + 1;
  });
  const motivos = Object.entries(contagemMotivos).sort((a, b) => b[1] - a[1]).slice(0, 6);
  const SERVE_COLUNAS = [
    { key: "ref", label: "Artigo", width: 140, mono: true, render: (c) => c.ref },
    {
      key: "abc",
      label: "ABC",
      width: 60,
      sortValue: (c) => ({ A: 0, B: 1, C: 2 })[c.abc] ?? 9,
      render: (c) => /* @__PURE__ */ React.createElement(ReapAbc, { abc: c.abc })
    },
    {
      key: "pecas_por_unidade",
      label: "Por caixa",
      width: 90,
      align: "right",
      mono: true,
      render: (c) => c.pecas_por_unidade
    },
    {
      key: "placas_max",
      label: "M\xE1x. placas",
      width: 100,
      align: "right",
      mono: true,
      render: (c) => reapFmtNum(c.placas_max)
    },
    {
      key: "artigos_max",
      label: "Artigos",
      width: 90,
      align: "right",
      mono: true,
      render: (c) => reapFmtNum(c.artigos_max)
    },
    {
      key: "procura_placas",
      label: "Procura (placas)",
      width: 120,
      align: "right",
      mono: true,
      render: (c) => reapFmtNum(c.procura_placas)
    },
    {
      key: "no_plano_placas",
      label: "No plano",
      width: 90,
      align: "right",
      mono: true,
      render: (c) => c.no_plano_placas ? reapFmtNum(c.no_plano_placas) : "\u2014"
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, !fonte.calculavel && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5 } }, "N\xE3o calcul\xE1vel: ", fonte.motivo, "."), fonte.calculavel && compativeis.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5 } }, "N\xE3o serve para nenhum dos artigos de maior sa\xEDda."), fonte.calculavel && compativeis.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--reap-verde-fundo)",
    borderLeft: "4px solid var(--reap-verde)",
    borderRadius: 4,
    padding: "8px 10px",
    fontSize: 12.5
  } }, "\u267B Reaproveit\xE1vel \u2014 serve ", /* @__PURE__ */ React.createElement("b", null, compativeis.length), " ", compativeis.length === 1 ? "artigo" : "artigos", plano && plano.fonte && /* @__PURE__ */ React.createElement(React.Fragment, null, " \xB7 plano: abrir ", /* @__PURE__ */ React.createElement("b", null, plano.fonte.unidades_abrir), " de ", plano.fonte.stock)), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "reap-pode-virar",
      pagination: "client",
      columns: SERVE_COLUNAS,
      data: compativeis,
      rowKey: (c) => c.ref,
      onRowClick: (c) => setFicha(c.ref),
      empty: "Sem artigos compat\xEDveis."
    }
  ), /* @__PURE__ */ React.createElement(ReapDesenhoMono, { ref_: codigo, onAbrirArtigo: setFicha })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, motivos.length > 0 && /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setVerPorque((v) => !v) }, "Ver porqu\xEA"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: abrir }, "Abrir no Reaproveitamento \u2192")), verPorque && motivos.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12 } }, motivos.map(([motivo, n]) => `${motivo} \u2014 ${reapFmtNum(n)}`).join(" \xB7 ")), ficha && /* @__PURE__ */ React.createElement(ReapFichaArtigo, { ref_: ficha, codigoAtual: codigo, onClose: () => setFicha(null) }));
}
window.ReapPodeVirar = ReapPodeVirar;

// ===== stockreborn/frontend/reaproveitamento_definicoes.jsx =====
function _reapDefCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}
async function _reapDefSend(path, init) {
  const res = await fetch(path, { credentials: "include", ...init });
  if (!res.ok) {
    let body = null;
    try {
      body = await res.json();
    } catch (e) {
      body = null;
    }
    const isFieldErrors = res.status === 400 && body && typeof body === "object" && !Array.isArray(body);
    const msg = res.status === 404 ? "Esta exce\xE7\xE3o j\xE1 n\xE3o existe \u2014 recarregue a p\xE1gina." : body && body.detail || `${init && init.method || "GET"} ${path} \u2192 ${res.status}`;
    const err = new Error(msg);
    if (isFieldErrors) err.fields = body;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}
function _reapDefJson(method) {
  return (path, body) => {
    const csrf = _reapDefCookie("csrftoken");
    return _reapDefSend(path, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...csrf ? { "X-CSRFToken": csrf } : {}
      },
      body: JSON.stringify(body)
    });
  };
}
window.ReapDefAPI = {
  get: (path) => _reapDefSend(path, { method: "GET", headers: {} }),
  post: _reapDefJson("POST"),
  put: _reapDefJson("PUT"),
  patch: _reapDefJson("PATCH"),
  del: (path) => {
    const csrf = _reapDefCookie("csrftoken");
    return _reapDefSend(path, {
      method: "DELETE",
      headers: csrf ? { "X-CSRFToken": csrf } : {}
    });
  }
};
function ReapExcecaoFormModal({ title, initial = {}, qualidades = [], onClose, onSubmit }) {
  const { useState } = React;
  const [qualidadeFonte, setQualidadeFonte] = useState(initial.qualidade_fonte || "");
  const [qualidadeAlvo, setQualidadeAlvo] = useState(initial.qualidade_alvo || "");
  const [efeito, setEfeito] = useState(initial.efeito || "permitir");
  const [nota, setNota] = useState(initial.nota || "");
  const [erros, setErros] = useState(null);
  const [a_gravar, setAGravar] = useState(false);
  const submeter = async (e) => {
    e.preventDefault();
    setErros(null);
    setAGravar(true);
    try {
      await onSubmit({
        qualidade_fonte: qualidadeFonte,
        qualidade_alvo: qualidadeAlvo,
        efeito,
        nota
      });
    } catch (err) {
      setErros(err && err.fields || { qualidade_alvo: String(err && err.message || err) });
    } finally {
      setAGravar(false);
    }
  };
  return /* @__PURE__ */ React.createElement(
    ModalShell,
    {
      title,
      onClose,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: onClose }, "Cancelar"), /* @__PURE__ */ React.createElement("button", { type: "submit", form: "reap-excecao-form", className: "btn primary sm", disabled: a_gravar }, "Guardar"))
    },
    /* @__PURE__ */ React.createElement("form", { id: "reap-excecao-form", onSubmit: submeter, style: { display: "flex", flexDirection: "column", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { className: "field-row" }, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Qualidade da fonte (mono)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        list: "reap-qualidades",
        value: qualidadeFonte,
        onChange: (e) => setQualidadeFonte(e.target.value),
        required: true,
        autoFocus: true
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Qualidade do alvo (artigo)"), /* @__PURE__ */ React.createElement(
      "input",
      {
        list: "reap-qualidades",
        value: qualidadeAlvo,
        onChange: (e) => setQualidadeAlvo(e.target.value),
        required: true
      }
    ))), /* @__PURE__ */ React.createElement("datalist", { id: "reap-qualidades" }, qualidades.map((q) => /* @__PURE__ */ React.createElement("option", { key: q.codigo, value: q.codigo }))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Efeito"), /* @__PURE__ */ React.createElement("select", { value: efeito, onChange: (e) => setEfeito(e.target.value) }, /* @__PURE__ */ React.createElement("option", { value: "permitir" }, "Permitir"), /* @__PURE__ */ React.createElement("option", { value: "bloquear" }, "Bloquear"))), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nota"), /* @__PURE__ */ React.createElement("input", { value: nota, onChange: (e) => setNota(e.target.value), placeholder: "opcional" })), erros && /* @__PURE__ */ React.createElement("div", { style: { color: "var(--danger)", fontSize: 12.5 } }, Object.values(erros).map((msg, i) => /* @__PURE__ */ React.createElement("div", { key: i }, msg))))
  );
}
window.ReapExcecaoFormModal = ReapExcecaoFormModal;
function ReapExcecoesPanel() {
  const { useState, useEffect, useCallback } = React;
  const [excecoes, setExcecoes] = useState([]);
  const [qualidades, setQualidades] = useState([]);
  const [creating, setCreating] = useState(false);
  const [editing, setEditing] = useState(null);
  const [erro, setErro] = useState("");
  const carregar = useCallback(async () => {
    try {
      const [exc, qual] = await Promise.all([
        window.ReapDefAPI.get("/api/reaproveitamento/excecoes/"),
        window.ReapDefAPI.get("/api/reaproveitamento/qualidades/")
      ]);
      setExcecoes(exc);
      setQualidades(qual);
    } catch (e) {
      setErro(String(e && e.message || e));
    }
  }, []);
  useEffect(() => {
    carregar();
  }, [carregar]);
  const criar = async (data) => {
    await window.ReapDefAPI.post("/api/reaproveitamento/excecoes/", data);
    setCreating(false);
    await carregar();
  };
  const atualizar = async (id, data) => {
    await window.ReapDefAPI.patch(`/api/reaproveitamento/excecoes/${id}/`, data);
    setEditing(null);
    await carregar();
  };
  const apagar = async (e) => {
    if (!await window.hubConfirm({ message: `Apagar a exce\xE7\xE3o ${e.qualidade_fonte} \u2192 ${e.qualidade_alvo}?` })) return;
    try {
      setErro("");
      await window.ReapDefAPI.del(`/api/reaproveitamento/excecoes/${e.id}/`);
      await carregar();
    } catch (err) {
      setErro(String(err && err.message || err));
    }
  };
  const columns = [
    {
      key: "qualidade_fonte",
      label: "Fonte",
      width: 110,
      minWidth: 90,
      mono: true,
      fixed: true,
      render: (e) => e.qualidade_fonte
    },
    {
      key: "qualidade_alvo",
      label: "Alvo",
      width: 110,
      minWidth: 90,
      mono: true,
      render: (e) => e.qualidade_alvo
    },
    {
      key: "efeito",
      label: "Efeito",
      width: 110,
      minWidth: 90,
      render: (e) => /* @__PURE__ */ React.createElement("span", { className: "badge" }, e.efeito)
    },
    {
      key: "nota",
      label: "Nota",
      width: 260,
      minWidth: 140,
      render: (e) => e.nota || "\u2014"
    },
    {
      key: "acoes",
      label: "A\xE7\xF5es",
      sortable: false,
      width: 160,
      minWidth: 140,
      render: (e) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => setEditing(e) }, "Editar"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => apagar(e) }, "Apagar"))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Exce\xE7\xF5es de qualidade"), /* @__PURE__ */ React.createElement("button", { className: "btn primary sm", style: { marginLeft: "auto" }, onClick: () => setCreating(true) }, /* @__PURE__ */ React.createElement(Ico.plus, null), " Nova")), erro && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, erro), /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { fontSize: 12.5, padding: "0 10px 10px" } }, "A regra: mesmo canal, ECT e gramagem iguais ou superiores. Uma exce\xE7\xE3o ", /* @__PURE__ */ React.createElement("b", null, "permitir"), " aceita um par que a regra recusa; ", /* @__PURE__ */ React.createElement("b", null, "bloquear"), " recusa um par que a regra aceita. O efeito v\xEA-se no pr\xF3ximo c\xE1lculo."), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "stockreborn",
      viewId: "reap-excecoes",
      columns,
      data: excecoes,
      pagination: "client",
      rowKey: (e) => e.id,
      empty: "Sem exce\xE7\xF5es manuais."
    }
  ), creating && /* @__PURE__ */ React.createElement(
    ReapExcecaoFormModal,
    {
      title: "Nova exce\xE7\xE3o",
      qualidades,
      onClose: () => setCreating(false),
      onSubmit: criar
    }
  ), editing && /* @__PURE__ */ React.createElement(
    ReapExcecaoFormModal,
    {
      title: `Editar ${editing.qualidade_fonte} \u2192 ${editing.qualidade_alvo}`,
      initial: editing,
      qualidades,
      onClose: () => setEditing(null),
      onSubmit: (d) => atualizar(editing.id, d)
    }
  ));
}
window.ReapExcecoesPanel = ReapExcecoesPanel;
const REAP_PARAM_CAMPOS = [
  { key: "meses_cobertura", label: "Meses de cobertura" },
  { key: "refile_mm", label: "Refile (mm)" },
  { key: "pala_min_mm", label: "Pala m\xEDnima (mm)" },
  { key: "pala_max_mm", label: "Pala m\xE1xima (mm)" },
  { key: "periodo_dias", label: "Per\xEDodo de vendas (dias)" },
  { key: "corte_a", label: "Corte A (%)" },
  { key: "corte_b", label: "Corte B (%)" }
];
function ReapParametrosPanel() {
  const { useState, useEffect } = React;
  const [valores, setValores] = useState(null);
  const [erros, setErros] = useState({});
  const [erro, setErro] = useState("");
  const [guardado, setGuardado] = useState(false);
  const [aGuardar, setAGuardar] = useState(false);
  const carregar = async () => {
    try {
      setErro("");
      setValores(await window.ReapDefAPI.get("/api/reaproveitamento/parametros/"));
    } catch (e) {
      setErro(String(e && e.message || e));
    }
  };
  useEffect(() => {
    carregar();
  }, []);
  const alterar = (k, v) => {
    setGuardado(false);
    setValores((s) => ({ ...s, [k]: v }));
  };
  const guardar = async (e) => {
    e.preventDefault();
    setErros({});
    setErro("");
    setGuardado(false);
    setAGuardar(true);
    try {
      const novo = await window.ReapDefAPI.put("/api/reaproveitamento/parametros/", valores);
      setValores(novo);
      setGuardado(true);
    } catch (err) {
      if (err && err.fields) setErros(err.fields);
      else setErro(String(err && err.message || err));
    } finally {
      setAGuardar(false);
    }
  };
  if (!valores) {
    return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Par\xE2metros")), erro ? /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, erro) : /* @__PURE__ */ React.createElement("div", { className: "td-muted", style: { padding: 10, fontSize: 12.5 } }, "A carregar\u2026"));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Par\xE2metros")), erro && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, erro), /* @__PURE__ */ React.createElement("form", { onSubmit: guardar, style: { display: "flex", flexDirection: "column", gap: 12, padding: "0 10px 12px" } }, /* @__PURE__ */ React.createElement("div", { className: "field-row" }, REAP_PARAM_CAMPOS.map((c) => /* @__PURE__ */ React.createElement("div", { className: "field", key: c.key }, /* @__PURE__ */ React.createElement("span", { className: "label" }, c.label), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      step: "any",
      value: valores[c.key],
      onChange: (e) => alterar(c.key, e.target.value)
    }
  ), erros[c.key] && /* @__PURE__ */ React.createElement("span", { style: { color: "var(--danger)", fontSize: 11.5 } }, erros[c.key])))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } }, /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn primary sm", disabled: aGuardar }, "Guardar"), guardado && /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 12.5 } }, "Guardado."))));
}
window.ReapParametrosPanel = ReapParametrosPanel;
function ReapDefinicoesView() {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", minHeight: 0, overflow: "auto", flex: 1, gap: 12 } }, /* @__PURE__ */ React.createElement(ReapExcecoesPanel, null), /* @__PURE__ */ React.createElement(ReapParametrosPanel, null));
}
window.ReapDefinicoesView = ReapDefinicoesView;

// ===== stockreborn/frontend/stock_app.jsx =====
let _SR_CATALOG = { refs: [], loaded: false };
let _SR_PERSONALIZACOES = [];
function StockApp({ me, view, entidade, params, navigate, reportStats, reportCounts, tweaks }) {
  const [refs, setRefs] = useState(() => _SR_CATALOG.refs);
  const [catalogLoading, setCatalogLoading] = useState(false);
  const [catalogLoaded, setCatalogLoaded] = useState(() => _SR_CATALOG.loaded);
  const [personalizacoes, setPersonalizacoes] = useState(() => _SR_PERSONALIZACOES);
  const [servem, setServem] = useState({});
  useEffect(() => {
    window.ReapVerde && window.ReapVerde.garantirEstilo();
  }, []);
  const carregarServem = async () => {
    if (!window.ReapAPI) return;
    try {
      const data = await window.ReapAPI.get("/api/reaproveitamento/servem/");
      setServem(data || {});
    } catch (e) {
      setServem({});
      if (!/→ 403/.test(String(e && e.message))) console.error("reaproveitamento servem failed", e);
    }
  };
  useEffect(() => {
    carregarServem();
  }, []);
  const [openedRefs, setOpenedRefs] = useState({});
  const cacheRef = (ref) => {
    if (!ref) return;
    setOpenedRefs((prev) => prev[ref.codigo] === ref ? prev : { ...prev, [ref.codigo]: ref });
  };
  const [navList, setNavList] = useState(null);
  const users = window.SR_USERS || [];
  async function reloadRefs() {
    setCatalogLoading(true);
    try {
      const fresh = await window.API.catalog({ limit: 2e3 });
      const items = fresh.results.map(window.adaptCatalogItem);
      _SR_CATALOG = { refs: items, loaded: true };
      setRefs(items);
      setCatalogLoaded(true);
    } finally {
      setCatalogLoading(false);
    }
  }
  useEffect(() => {
    _SR_CATALOG.refs = refs;
  }, [refs]);
  useEffect(() => {
    if (catalogLoaded || catalogLoading) return;
    reloadRefs().catch((e) => console.error("catalog load failed", e));
  }, [catalogLoaded, catalogLoading]);
  useEffect(() => {
    let cancelled = false;
    window.API.personalizacoes().then((r) => {
      const list = r.results || r;
      _SR_PERSONALIZACOES = list;
      if (!cancelled) setPersonalizacoes(list);
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, []);
  const reportRef = useRef(null);
  useEffect(() => {
    reportRef.current = { reportStats, reportCounts };
  });
  const totalNaoTerminais = useMemo(() => {
    const terminais = new Set(
      (window.SR_DATA?.estados || []).filter((e) => e.terminal).map((e) => e.id)
    );
    return refs.filter((r) => !terminais.has(r.estado)).length;
  }, [refs]);
  useEffect(() => {
    const r = reportRef.current || {};
    r.reportCounts && r.reportCounts({ listagem: totalNaoTerminais });
  }, [totalNaoTerminais]);
  useEffect(() => () => {
    const r = reportRef.current || {};
    r.reportStats && r.reportStats(null);
  }, []);
  const detailRef = useMemo(() => {
    if (!entidade) return null;
    const found = refs.find((r) => String(r.codigo) === entidade);
    if (found) return found;
    return openedRefs[entidade] || null;
  }, [entidade, refs, openedRefs]);
  const lookupAttempted = useRef(/* @__PURE__ */ new Set());
  const [lookupFailed, setLookupFailed] = useState({});
  useEffect(() => {
    if (!entidade || detailRef || !catalogLoaded) return;
    if (lookupAttempted.current.has(entidade)) return;
    lookupAttempted.current.add(entidade);
    let cancelled = false;
    window.API.catalogDetail(entidade).then((raw) => {
      if (cancelled) return;
      cacheRef(window.adaptCatalogItem(raw));
    }).catch((e) => {
      if (cancelled) return;
      if (window.API.isNetworkError(e)) {
        lookupAttempted.current.delete(entidade);
        window.srToast?.("Sem liga\xE7\xE3o ao servidor \u2014 n\xE3o foi poss\xEDvel verificar essa refer\xEAncia.", "error");
        return;
      }
      setLookupFailed((prev) => ({
        ...prev,
        [entidade]: /→ 404/.test(e.message) ? "not-found" : "no-access"
      }));
    });
    return () => {
      cancelled = true;
    };
  }, [entidade, detailRef, catalogLoaded]);
  useEffect(() => {
    if (!entidade || detailRef) return;
    const estado = lookupFailed[entidade];
    if (!estado) return;
    window.srToast?.(estado === "not-found" ? "Refer\xEAncia n\xE3o encontrada." : "Sem acesso a essa refer\xEAncia.", "error");
    navigate({ routeId: view, params }, { replace: true });
  }, [entidade, detailRef, lookupFailed, view, params]);
  const openDetail = (ref, list) => {
    if (!ref) return;
    cacheRef(ref);
    if (list && list.length) setNavList(list);
    navigate({ routeId: view, entidade: ref.codigo, params });
  };
  const closeDetail = () => {
    navigate({ routeId: view, params });
  };
  const jumpTo = (v, payload) => {
    if (v === "detalhe" && payload?.ref) {
      openDetail(payload.ref, refs);
      return;
    }
    navigate({ routeId: v });
  };
  const vista = view === "dashboard" ? /* @__PURE__ */ React.createElement(Dashboard, { refs, onJumpTo: jumpTo, users }) : view === "pesquisa" ? /* @__PURE__ */ React.createElement(DimSearch, { refs, onOpenDetail: openDetail }) : /* @__PURE__ */ React.createElement(
    Listing,
    {
      onOpenDetail: openDetail,
      refs,
      setRefs,
      layout: tweaks?.layout || "standard",
      reloadRefs,
      users,
      personalizacoes,
      onStats: reportStats,
      servem
    }
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, catalogLoading && /* @__PURE__ */ React.createElement("div", { className: "sr-loadbar", style: { flex: "0 0 auto" } }), vista, detailRef && // `key` pela referência: o ‹ › do cabeçalho troca a referência sem
  // fechar o drawer, e sem key o React reaproveita a instância — todo o
  // estado interno dos filhos (rascunho do "Adicionar", aba activa da
  // Timeline, painel de anexos) transitava para o mono seguinte, e o
  // lado direito ficava a mostrar — e a escrever para — o mono errado.
  /* @__PURE__ */ React.createElement(
    DetailDrawer,
    {
      key: detailRef.codigo,
      ref0: detailRef,
      onClose: closeDetail,
      onNavigate: (r) => openDetail(r),
      navList: navList && navList.length ? navList : refs,
      setRefs,
      allRefs: refs,
      reloadRefs,
      users,
      personalizacoes,
      me
    }
  ));
}
window.StockApp = StockApp;

// ===== stockreborn/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "stock",
  appLabel: "stockreborn",
  order: 1,
  name: "STOCK REBORN",
  sub: "Gest\xE3o de monos",
  accent: "#2c5d8a",
  brandLogo: "/static/assets/logo-mark.png?v=2",
  brandEmoji: "\u{1F4E6}",
  brandWordmark: "stockreborn",
  brandUseBrandMark: true,
  home: "listagem",
  launcher: true,
  frontendFiles: [
    "frontend/reaproveitamento_verde.jsx",
    "frontend/listing.jsx",
    "frontend/detail.jsx",
    "frontend/crossfilter.jsx",
    "frontend/moves.jsx",
    "frontend/dashboard.jsx",
    "frontend/period.jsx",
    "frontend/search.jsx",
    "frontend/reports.jsx",
    "frontend/admin.jsx",
    "frontend/admin-personalizacao.jsx",
    "frontend/admin-estados.jsx",
    "frontend/admin-tipos-acao.jsx",
    "frontend/admin-db-connections.jsx",
    "frontend/reaproveitamento.jsx",
    "frontend/reaproveitamento_desenhos.jsx",
    "frontend/reaproveitamento_pode_virar.jsx",
    "frontend/reaproveitamento_definicoes.jsx",
    "frontend/stock_app.jsx"
  ],
  routes: [
    { id: "listagem", section: "Tratamento", icon: "list", label: "Listagem", adminOnly: false, title: "Listagem de monos", tooltip: "Listagem", count: "listagem" },
    { id: "pesquisa", section: "Tratamento", icon: "ruler", label: "Pesquisa por dimens\xF5es", adminOnly: false, title: "Pesquisa por dimens\xF5es", tooltip: "Pesquisa por dimens\xF5es" },
    { id: "dashboard", section: "An\xE1lise", icon: "dashboard", label: "Dashboard", adminOnly: false, title: "Dashboard", tooltip: "Dashboard" },
    { id: "reaproveitamento", section: "An\xE1lise", icon: "ruler", label: "Reaproveitamento", adminOnly: false, title: "Reaproveitamento de monos", tooltip: "Que monos servem para os artigos de maior sa\xEDda" },
    { id: "relatorios", section: "An\xE1lise", icon: "printer", label: "Relat\xF3rios", adminOnly: false, title: "Relat\xF3rios", tooltip: "Relat\xF3rios" },
    { id: "stock_admin", section: "Configura\xE7\xF5es", icon: "cog", label: "Configura\xE7\xF5es", adminOnly: true, title: "Configura\xE7\xF5es Stock", tooltip: "Configura\xE7\xF5es do Stock" },
    { id: "stock_atribuiveis", section: "Configura\xE7\xF5es", icon: "cog", label: "Utilizadores atribu\xEDveis", adminOnly: true, title: "Utilizadores atribu\xEDveis", tooltip: "Utilizadores atribu\xEDveis" },
    { id: "reap_definicoes", section: "Configura\xE7\xF5es", icon: "cog", label: "Reaproveitamento", adminOnly: true, title: "Defini\xE7\xF5es do reaproveitamento", tooltip: "Exce\xE7\xF5es de qualidade e par\xE2metros do reaproveitamento" }
  ],
  // renderView() em app.jsx procura `app.render[id]` antes de cair no seu
  // ROUTE_RENDER local — as rotas declaradas aqui são servidas pela app.
  // O mesmo componente serve as três vistas do catálogo: assim o catálogo e
  // o drawer sobrevivem à troca entre elas (o React reutiliza a instância).
  // `relatorios` e `stock_admin` continuam no ROUTE_RENDER do shell.
  render: {
    listagem: (ctx) => React.createElement(window.StockApp, ctx),
    dashboard: (ctx) => React.createElement(window.StockApp, ctx),
    pesquisa: (ctx) => React.createElement(window.StockApp, ctx),
    reaproveitamento: (ctx) => React.createElement(window.ReaproveitamentoView, ctx),
    reap_definicoes: (ctx) => React.createElement(window.ReapDefinicoesView, ctx),
    stock_atribuiveis: () => React.createElement(window.HubAssignableUsers, { appLabel: "stockreborn", appName: "Stock Reborn" })
  }
});

// ===== trakker/frontend/trakker-api.jsx =====
(function() {
  function getCookie(name) {
    const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? m.pop() : "";
  }
  function req(path, { method = "GET", body, params } = {}) {
    let url = path;
    if (params) {
      const q = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v !== void 0 && v !== null && v !== "") q.append(k, v);
      });
      const s = q.toString();
      if (s) url += (url.includes("?") ? "&" : "?") + s;
    }
    const opts = { method, credentials: "same-origin", headers: {} };
    if (method !== "GET") opts.headers["X-CSRFToken"] = getCookie("csrftoken");
    if (body !== void 0) {
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then((r) => {
      if (r.status === 204) return null;
      if (!r.ok) {
        return r.json().then((e) => Promise.reject({ status: r.status, ...e })).catch((e) => Promise.reject(e && e.status ? e : { status: r.status }));
      }
      return r.json();
    });
  }
  const B = "/api/trakker";
  const enc = encodeURIComponent;
  const ESTADOS = {
    atrasada: { texto: "Atrasada", classe: "is-atrasada" },
    em_risco: { texto: "Em risco", classe: "is-risco" },
    no_prazo: { texto: "No prazo", classe: "is-ok" },
    sem_prazo: { texto: "Sem prazo", classe: "is-neutro" },
    bloqueada: { texto: "Cliente bloqueado", classe: "is-bloq" },
    parada: { texto: "Por validar / pagar", classe: "is-neutro" },
    fechada: { texto: "Fechada", classe: "is-neutro" }
  };
  const FORA = {
    stock: "Stock interno",
    pendente: "Pendente",
    proforma: "Pr\xF3-forma",
    anulada: "Anulada",
    servico: "Servi\xE7o",
    ferramenta: "Ferramenta",
    sem_movimento: "Sem movimento"
  };
  const FLUXOS = { producao: "Produ\xE7\xE3o", mercadoria: "Mercadoria", servico: "Servi\xE7o" };
  function fmt(iso) {
    return iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : "\u2014";
  }
  function fmtHora(iso) {
    return iso && iso.length > 10 ? `${fmt(iso)} ${iso.slice(11, 16)}` : fmt(iso);
  }
  function ultimaPrometida(l) {
    const data = l && l.ultima_prometida || null;
    const motivo = l ? l.ultima_prometida_motivo : null;
    let titulo;
    if (motivo === null || motivo === void 0) {
      titulo = l && l.adiamentos === null ? "Adiamentos indispon\xEDveis (PHC): a data de entrega inicial" : "Sem adiamentos: a data de entrega inicial";
    } else {
      const reg = l.ultima_prometida_registo ? ` (registado a ${fmt(l.ultima_prometida_registo)})` : "";
      titulo = `\xDAltimo adiamento${reg}: ${motivo || "sem motivo"}`;
    }
    return { data, texto: fmt(data), titulo, difere: !!data && data !== (l.prometida || null) };
  }
  function fmtEuro(v) {
    if (v === null || v === void 0 || v === "") return "\u2014";
    return `${Number(v).toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} \u20AC`;
  }
  function valorEntrega(l, minimo) {
    if (!l || l.valor_entrega === null || l.valor_entrega === void 0) return null;
    const de = l.valor_entrega_data ? `de ${fmt(l.valor_entrega_data)}` : "sem data";
    const min = minimo ?? l.valor_minimo_entrega;
    return {
      texto: `Valor da entrega ${de}: ${fmtEuro(l.valor_entrega)}`,
      abaixo: l.abaixo_minimo ? `abaixo do m\xEDnimo (${fmtMinimo(min)})` : null
    };
  }
  function fmtMinimo(v) {
    return fmtEuro(v).replace(",00 \u20AC", " \u20AC");
  }
  function chipMinimo(minimo) {
    return `< ${fmtMinimo(minimo)}`;
  }
  function doPhcHoje(l, col) {
    return Boolean(col && l && l.phc_hoje && l.phc_hoje[col]);
  }
  function esperaMinimo(l, e) {
    return Boolean(l && l.abaixo_minimo && e && e.marco_fim === "entrega" && e.estado === "estourada");
  }
  function dias(a, b) {
    return a && b ? Math.round((new Date(b) - new Date(a)) / 864e5) : null;
  }
  function haQuanto(iso) {
    if (!iso) return "";
    const min = Math.round((Date.now() - new Date(iso).getTime()) / 6e4);
    if (min < 60) return `h\xE1 ${Math.max(min, 1)} min`;
    if (min < 1440) return `h\xE1 ${Math.round(min / 60)} h`;
    return `h\xE1 ${Math.round(min / 1440)} d`;
  }
  function notasFornecedor(f) {
    const notas = [];
    const n = f.confirmou_dias_uteis;
    if (n) notas.push(`confirmou ${n} ${n === 1 ? "dia \xFAtil" : "dias \xFAteis"} depois do pedido`);
    if (f.atraso_dias) notas.push(`atraso do fornecedor ${f.atraso_dias} d (face \xE0 ${f.atraso_face})`);
    return notas;
  }
  function etapaFornecedor(l) {
    const f = l.fornecedor;
    const etapas = l.percurso && l.percurso.etapas || [];
    return f ? etapas.find((e) => e.marco_fim === `rececao_${f.tipo.toLowerCase()}`) : null;
  }
  function atrasoFornecedor(l, e) {
    const f = l.fornecedor;
    if (!f || !(f.atraso_dias > 0) || !e || e !== etapaFornecedor(l)) return null;
    return `fornecedor +${f.atraso_dias} d face \xE0 ${f.atraso_face}`;
  }
  function requisicaoFornecedor(f) {
    const ns = (f.requisicao_n || []).join(", ");
    const partes = [ns && `n\xBA ${ns}`, f.requisicao && fmt(f.requisicao)].filter(Boolean);
    return partes.length ? partes.join(" \xB7 ") : "\u2014";
  }
  function marcoConfirmacao(l) {
    const f = l.fornecedor;
    return f ? [`Confirmada pelo fornecedor (${f.tipo})`, f.confirmada] : ["Confirmada pelo fornecedor", l.dataconfme];
  }
  function etapaAtual(l) {
    if (l.dataentregaenc) return { etapa: "entregue", espera: "" };
    if (l.datapick2) return { etapa: "log\xEDstica", espera: "expedi\xE7\xE3o" };
    if (l.fluxo === "producao") {
      if (l.fecho_of && l.fecho_of.fecho) return { etapa: "log\xEDstica", espera: "picking" };
      if (l.datarecmp) return { etapa: "produ\xE7\xE3o", espera: l.nof ? `OF ${l.nof}` : "OF" };
      if (l.datadareqmp) return { etapa: "fornecedor MP", espera: l.fornmp || "fornecedor" };
      return { etapa: "lan\xE7amento", espera: "requisi\xE7\xE3o" };
    }
    if (l.datarecme) return { etapa: "log\xEDstica", espera: "picking" };
    if (l.datadareqme) return { etapa: "fornecedor", espera: l.fornme || "fornecedor" };
    return { etapa: "lan\xE7amento", espera: "requisi\xE7\xE3o" };
  }
  function excesso(n) {
    if (n === null || n === void 0) return "";
    if (n > 0) return `+${n} d`;
    return n < 0 ? `${n === -1 ? "falta" : "faltam"} ${-n} d` : "limite hoje";
  }
  function ondeEsta(l) {
    const o = l.onde_esta;
    if (o) {
      const ate = o.janela === "antes" || o.alvo === "pedida" ? `pedida ${fmt(o.limite)}` : o.limite ? `at\xE9 ${fmt(o.limite)}` : "sem limite";
      return [o.etapa, o.a_espera_de, ate, excesso(o.excesso)].filter(Boolean).join(" \xB7 ");
    }
    const { etapa, espera } = etapaAtual(l);
    const d = dias(l.hoje, l.prometida);
    const prazo = l.prometida ? `${fmt(l.prometida)}${d !== null && d < 0 ? ` \xB7 ${-d} d atraso` : ""}` : "sem prazo";
    return [etapa, espera, prazo].filter(Boolean).join(" \xB7 ");
  }
  function ordemApresentada(rows, sort, getters, agrupada) {
    const ordenadas = window.HubTable.applySort(rows || [], sort, getters || {});
    if (!agrupada) return ordenadas;
    const grupos = /* @__PURE__ */ new Map();
    ordenadas.forEach((r) => {
      const k = r.bostamp || r.bistamp;
      if (!grupos.has(k)) grupos.set(k, []);
      grupos.get(k).push(r);
    });
    return [...grupos.values()].flat();
  }
  function fatorLegivel(f, direcao) {
    const s = direcao === "tras" ? "\u2212" : "+";
    const n = (v, um, varios) => `${v} ${Number(v) === 1 ? um : varios}`;
    switch (f && f.tipo) {
      case "dias_fixos":
        return `${s} ${n(f.n, "dia", "dias")}`;
      case "lt_referencia":
        return `${s} LT da ${f.de} (sem LT: ${f.sem_lt})`;
      case "maquinas_roteiro":
        return `${s} ${n(f.dias_por_maquina, "dia", "dias")} por m\xE1quina do roteiro (m\xEDnimo ${f.minimo})`;
      case "turno_seguinte":
        return `${s} turno seguinte (corte \xE0s ${f.corte})`;
      default:
        return `${s} ${f && f.tipo || "?"}`;
    }
  }
  function adiamentosFicha(l) {
    const lista = l.adiamentos;
    if (!Array.isArray(lista)) return { titulo: "Adiamentos", itens: [], vazio: "Adiamentos indispon\xEDveis (PHC)" };
    const itens = lista;
    return { titulo: `Adiamentos (${itens.length})`, itens, vazio: itens.length ? null : "Sem adiamentos" };
  }
  function quantidades(l) {
    const encomendada = Number(l.qtdenc) || 0;
    const entregue = Number(l.qtdent) || 0;
    return { encomendada, entregue, em_falta: Math.max(encomendada - entregue, 0) };
  }
  function sacOpcoes(sacs) {
    const lista = (sacs || []).map((u) => ({ value: String(u.id), label: u.nome })).sort((a, b) => a.label.localeCompare(b.label, "pt"));
    return [{ value: "eu", label: "As minhas" }, ...lista, { value: "nenhum", label: "Sem utilizador do hub" }];
  }
  const sacConjunto = (valor) => new Set(String(valor || "").split(",").filter(Boolean));
  const sacFiltro = (conjunto) => conjunto && conjunto.size ? [...conjunto].join(",") : null;
  const sacTexto = (l) => l.sac ? l.sac.nome : "";
  function sacTitulo(l) {
    if (!l.sac) return void 0;
    return l.sac.id != null ? `PHC: ${l.sac.naturalid}` : `${l.sac.naturalid} \u2014 sem utilizador (Mapa SAC do OrderRetriever)`;
  }
  const CAMPOS_PHC = [
    { key: "pscmoridesc", rotulo: "Obs SAC", origem: "bi2.pscmoridesc" },
    { key: "efornecedor", rotulo: "Obs Produ\xE7\xE3o", origem: "bi.efornecedor" },
    { key: "descfx", rotulo: "Obs Log\xEDstica", origem: "bi2.descfx" }
  ];
  const camposPhc = (l) => CAMPOS_PHC.filter((c) => l && l[c.key]).map((c) => ({ ...c, valor: l[c.key] }));
  const ESTADOS_ETAPA = {
    cumprida: { texto: "Cumprida", classe: "is-ok" },
    em_curso: { texto: "Em curso", classe: "is-risco" },
    estourada: { texto: "Estourada", classe: "is-atrasada" },
    por_iniciar: { texto: "Por iniciar", classe: "is-neutro" },
    na: { texto: "Sem limite", classe: "is-neutro" },
    dispensada: { texto: "Dispensada", classe: "is-neutro" }
    // #328: uma etapa à frente já aconteceu
  };
  function vendaDinheiro(l) {
    return !!l && l.condpag === "VD";
  }
  window.TkChipVd = function TkChipVd({ l }) {
    return vendaDinheiro(l) ? /* @__PURE__ */ React.createElement("span", { className: "tk-estado is-vd tk-ao-lado", title: "Venda a dinheiro" }, "VD") : null;
  };
  function motivoErro(e) {
    if (!e || e.status == null) return "O pedido n\xE3o chegou ao servidor (sem liga\xE7\xE3o, ou foi cancelado).";
    if (e.erro === "erp_indisponivel") return `ERP indispon\xEDvel (Trino)${e.detail ? ` \u2014 ${e.detail}` : ""}.`;
    if (e.erro === "erp_query") return e.detail || "O ERP rejeitou a consulta.";
    if (e.status === 401) return "Sess\xE3o terminada: entra outra vez.";
    if (e.status === 403) return "Sem permiss\xE3o para ver estas linhas.";
    if (e.status === 504 || e.status === 408) return "Tempo esgotado \xE0 espera do servidor.";
    if (e.status >= 500) return `Erro do servidor (${e.status}).`;
    return e.detail || `Erro ${e.status}.`;
  }
  function pedidoUnico() {
    let n = 0;
    return (promessa, { ok, falha, fim }) => {
      const k = ++n;
      const meu = () => k === n;
      return promessa.then((d) => {
        if (meu() && ok) ok(d);
      }, (e) => {
        if (meu() && falha) falha(e);
      }).finally(() => {
        if (meu() && fim) fim();
      });
    };
  }
  function textoVazio({ aba, carregando, erro }) {
    if (erro) return null;
    if (carregando) return "A carregar\u2026";
    return aba === "fila" ? "Nada precisa de aten\xE7\xE3o." : "Sem linhas.";
  }
  window.TkFalhaCarga = function TkFalhaCarga({ titulo, motivo, onTentar, aTentar, children }) {
    return /* @__PURE__ */ React.createElement("div", { className: "tk-falha", role: "alert" }, /* @__PURE__ */ React.createElement("strong", null, titulo), motivo ? /* @__PURE__ */ React.createElement("span", null, motivo) : null, children, onTentar ? /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", disabled: !!aTentar, onClick: () => onTentar() }, aTentar ? "A tentar\u2026" : "Tentar outra vez") : null);
  };
  window.TrakkerAPI = {
    fatorLegivel,
    vendaDinheiro,
    ESTADOS_ETAPA,
    adiamentosFicha,
    quantidades,
    sacOpcoes,
    sacConjunto,
    sacFiltro,
    sacTexto,
    sacTitulo,
    CAMPOS_PHC,
    camposPhc,
    motivoErro,
    pedidoUnico,
    textoVazio,
    arvore: () => req(`${B}/arvore/`),
    gravarArvore: (ramos) => req(`${B}/arvore/`, { method: "PUT", body: { ramos } }),
    simular: (bistamp, ramos) => req(`${B}/arvore/simular/`, { method: "POST", body: ramos ? { bistamp, ramos } : { bistamp } }),
    feriados: () => req(`${B}/feriados/`),
    addFeriado: (data, nome) => req(`${B}/feriados/`, { method: "POST", body: { data, nome } }),
    delFeriado: (id) => req(`${B}/feriados/${id}/`, { method: "DELETE" }),
    req,
    ESTADOS,
    ordemApresentada,
    FORA,
    FLUXOS,
    fmt,
    fmtHora,
    fmtEuro,
    fmtMinimo,
    valorEntrega,
    ultimaPrometida,
    chipMinimo,
    esperaMinimo,
    doPhcHoje,
    haQuanto,
    ondeEsta,
    etapaAtual,
    excesso,
    notasFornecedor,
    requisicaoFornecedor,
    marcoConfirmacao,
    etapaFornecedor,
    atrasoFornecedor,
    rotuloEstado: (e) => ESTADOS[e] || { texto: e || "\u2014", classe: "is-neutro" },
    linhas: (params) => req(`${B}/linhas/`, { params }),
    linha: (b) => req(`${B}/linhas/${enc(b)}/`),
    opcoes: () => req(`${B}/opcoes/`),
    guardarOpcoes: (body) => req(`${B}/opcoes/`, { method: "PUT", body }),
    acoes: (b) => req(`${B}/linhas/${enc(b)}/acoes/`),
    addAcao: (b, body) => req(`${B}/linhas/${enc(b)}/acoes/`, { method: "POST", body }),
    delAcao: (b, id) => req(`${B}/linhas/${enc(b)}/acoes/${id}/`, { method: "DELETE" }),
    tratar: (b, id) => req(`${B}/linhas/${enc(b)}/acoes/${id}/tratar/`, { method: "POST", body: {} }),
    prazo: (b, id, iso) => req(`${B}/linhas/${enc(b)}/acoes/${id}/prazo/`, { method: "POST", body: { data_limite: iso || null } }),
    audit: (b) => req(`${B}/linhas/${enc(b)}/audit/`),
    responsavel: (b, id) => req(`${B}/linhas/${enc(b)}/responsavel/`, { method: "PUT", body: { responsavel_id: id } }),
    anexosPhc: (b) => req(`${B}/linhas/${enc(b)}/anexos-phc/`),
    anexoPhcUrl: (b, stamp, ver) => `${B}/linhas/${enc(b)}/anexos-phc/${enc(stamp)}/${ver ? "?ver=1" : ""}`,
    criarNota: (bistamp, descricao) => req("/api/notes/", { method: "POST", body: { app_label: "trakker", resource: "linha", resource_id: bistamp, descricao } })
  };
})();

// ===== trakker/frontend/trakker_fila.jsx =====
const TK_ORDEM_ESTADO = { atrasada: 0, bloqueada: 1, em_risco: 2, sem_prazo: 3, no_prazo: 4, parada: 5, fechada: 6 };
const TK_FILTROS = ["estado", "etapa", "fluxo", "fabrica", "vendedor", "segmento", "cliente_no", "responsavel", "sac", "primeiras", "abaixo_minimo", "mudou_hoje", "fora", "q", "mes", "condpag"];
function tkLerFiltros(params) {
  const out = {};
  TK_FILTROS.forEach((k) => {
    const v = params && typeof params.get === "function" ? params.get(k) : null;
    if (v) out[k] = v;
  });
  return out;
}
function tkOpcoes(rows, f) {
  return [...new Set(rows.map(f).filter(Boolean))].sort((a, b) => String(a).localeCompare(String(b), "pt"));
}
function tkHora(d) {
  return d ? d.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" }) : "\u2014";
}
function tkMesCorrente(hoje) {
  return (hoje || (/* @__PURE__ */ new Date()).toISOString()).slice(0, 7);
}
function TkObservacao({ r, onGravar }) {
  const [aberto, setAberto] = React.useState(false);
  const [texto, setTexto] = React.useState("");
  const [aGravar, setAGravar] = React.useState(false);
  const parar = (e) => e.stopPropagation();
  const gravar = () => {
    const t = texto.trim();
    if (!t || aGravar) return;
    setAGravar(true);
    onGravar(r, t).then(() => {
      setTexto("");
      setAberto(false);
    }).catch(() => {
    }).finally(() => setAGravar(false));
  };
  const u = r.ultima_nota;
  return /* @__PURE__ */ React.createElement("div", { className: "tk-obs", onClick: parar }, aberto ? /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input sm tk-obs-campo",
      autoFocus: true,
      value: texto,
      disabled: aGravar,
      placeholder: "Observa\xE7\xE3o\u2026 (Enter grava, Esc fecha)",
      "aria-label": "Nova observa\xE7\xE3o",
      onChange: (e) => setTexto(e.target.value),
      onKeyDown: (e) => {
        e.stopPropagation();
        if (e.key === "Enter") gravar();
        if (e.key === "Escape") setAberto(false);
      }
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost icon-only sm",
      title: "Escrever uma observa\xE7\xE3o",
      "aria-label": "Escrever uma observa\xE7\xE3o",
      onClick: () => setAberto(true)
    },
    "\uFF0B"
  ), u ? /* @__PURE__ */ React.createElement("span", { className: "tk-obs-ultima", title: u.texto }, /* @__PURE__ */ React.createElement("strong", null, u.autor), " \xB7 ", window.TrakkerAPI.haQuanto(u.em), " \xB7 ", u.texto) : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "\u2014"), r.n_notas > 1 && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha", title: `${r.n_notas} observa\xE7\xF5es` }, r.n_notas)));
}
function TkOndeEsta({ r }) {
  const A = window.TrakkerAPI;
  const o = r.onde_esta;
  const titulo = [
    r.ramo && `Ramo: ${r.ramo}`,
    r.etapa_perdida && `Perdida em: ${r.etapa_perdida}`,
    r.prazo_curto && "Prazo curto: da valida\xE7\xE3o, as etapas n\xE3o cabiam at\xE9 \xE0 prometida"
  ].filter(Boolean).join("\n");
  return /* @__PURE__ */ React.createElement("span", { className: `tk-onde${r.etapa_perdida ? " is-perdida" : ""}`, title: titulo || void 0 }, A.ondeEsta(r), o && o.responsavel ? /* @__PURE__ */ React.createElement("span", { className: "tk-onde-resp" }, o.responsavel) : null, r.etapa_perdida && r.etapa_perdida !== r.etapa_atual ? /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha is-atrasada" }, "perdida em ", r.etapa_perdida) : null, r.prazo_curto ? /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha is-atrasada" }, "prazo curto") : null);
}
function TkCabecalhoEncomenda({ rows }) {
  const r = rows[0] || {};
  const proxima = rows.map((x) => x.prometida).filter(Boolean).sort()[0];
  const mud = (r.mudancas_tipo || []).map((m) => `${m.de || "\u2014"} \u2192 ${m.para} (${window.TrakkerAPI.fmtHora(m.em)})`).join("\n");
  return /* @__PURE__ */ React.createElement("span", { className: "tk-grupo" }, /* @__PURE__ */ React.createElement("strong", null, r.cliente || "\u2014"), /* @__PURE__ */ React.createElement(window.TkChipVd, { l: r }), /* @__PURE__ */ React.createElement("span", null, "Enc. ", r.obrano || r.nenc || "\u2014"), /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha", title: mud || "Sem mudan\xE7as de tipo registadas" }, r.tipo_atual || "tipo desconhecido"), /* @__PURE__ */ React.createElement("span", { className: "muted" }, "prometida mais pr\xF3xima ", window.TrakkerAPI.fmt(proxima)), /* @__PURE__ */ React.createElement("span", { className: "muted" }, rows.length, " ", rows.length === 1 ? "linha" : "linhas"));
}
function TkFiltros({ aba, filtros, setFiltros, rows, hoje, estadosFila, etapas, sacs }) {
  const [q, setQ] = React.useState(filtros.q || "");
  React.useEffect(() => {
    setQ(filtros.q || "");
  }, [filtros.q]);
  React.useEffect(() => {
    if ((filtros.q || "") === q) return void 0;
    const t = setTimeout(() => setFiltros({ q: q || null }), 300);
    return () => clearTimeout(t);
  }, [q]);
  const sel = (k, label, opcoes) => /* @__PURE__ */ React.createElement("label", { className: "tk-filtro" }, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement("select", { className: "input sm", value: filtros[k] || "", onChange: (e) => setFiltros({ [k]: e.target.value || null }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todos"), opcoes.map(([v, t]) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, t))));
  const resp = tkOpcoes(rows, (r) => r.responsavel && `${r.responsavel.id}|${r.responsavel.nome}`).map((s) => s.split("|"));
  const mes = tkMesCorrente(hoje);
  const atalho = (label, patch, ativo) => /* @__PURE__ */ React.createElement("button", { type: "button", className: `btn sm ${ativo ? "primary" : "ghost"}`, onClick: () => setFiltros(patch, true) }, label);
  const limpo = { estado: null, fora: null, mes: null };
  const A = window.TrakkerAPI;
  const { ChipFilter } = window.HubList;
  const sacAtual = A.sacConjunto(filtros.sac);
  const setSac = (f) => setFiltros({ sac: A.sacFiltro(typeof f === "function" ? f(sacAtual) : f) });
  return /* @__PURE__ */ React.createElement("div", { className: "tk-filtros" }, /* @__PURE__ */ React.createElement("div", { className: "tk-atalhos" }, atalho("S\xF3 aten\xE7\xE3o", { ...limpo, aba: null }, aba === "fila"), atalho("Todas as abertas", { ...limpo, aba: "lista", fora: "nao", estado: "abertas" }, aba === "lista" && filtros.estado === "abertas"), atalho("Fechadas no m\xEAs", { ...limpo, aba: "lista", estado: "fechada", mes }, aba === "lista" && filtros.estado === "fechada"), atalho("Fora do OTIF", { ...limpo, aba: "lista", fora: "sim" }, aba === "lista" && filtros.fora === "sim"), /* @__PURE__ */ React.createElement("span", { className: "tk-otif muted" }, "OTIF do m\xEAs: chega com o sub-projeto 3")), /* @__PURE__ */ React.createElement("div", { className: "tk-filtros-linha" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input sm",
      type: "search",
      value: q,
      placeholder: "Encomenda, refer\xEAncia, designa\xE7\xE3o, cliente, n\xBA requisi\xE7\xE3o\u2026",
      "aria-label": "Pesquisa",
      onChange: (e) => setQ(e.target.value)
    }
  ), sel("fluxo", "Fluxo", Object.entries(window.TrakkerAPI.FLUXOS)), sel("fabrica", "F\xE1brica", tkOpcoes(rows, (r) => (r.validacao || {}).fabrica).map((v) => [v, v])), sel("vendedor", "Vendedor", tkOpcoes(rows, (r) => r.vendedor).map((v) => [v, v])), sel("segmento", "Segmento", tkOpcoes(rows, (r) => r.segmento).map((v) => [v, v])), sel("condpag", "Pagamento", tkOpcoes(rows, (r) => r.condpag).map((v) => [v, v === "VD" ? "VD (venda a dinheiro)" : v])), sel("responsavel", "Respons\xE1vel", [["sem", "\u2014 sem respons\xE1vel \u2014"], ...resp]), /* @__PURE__ */ React.createElement(ChipFilter, { label: "SAC", value: sacAtual, setValue: setSac, options: A.sacOpcoes(sacs) }), aba === "lista" && sel("estado", "Estado", [["abertas", "Todas as abertas"], ...Object.entries(window.TrakkerAPI.ESTADOS).map(([k, v]) => [k, v.texto])]), aba === "fila" && sel("estado", "Estado", (estadosFila || []).map((v) => [v, window.TrakkerAPI.rotuloEstado(v).texto])), sel("etapa", "Etapa", (etapas || []).map((v) => [v, v])), aba === "lista" && /* @__PURE__ */ React.createElement("label", { className: "tk-filtro" }, /* @__PURE__ */ React.createElement("span", null, "Fora do OTIF"), /* @__PURE__ */ React.createElement("select", { className: "input sm", value: filtros.fora || "", onChange: (e) => setFiltros({ fora: e.target.value || null }) }, /* @__PURE__ */ React.createElement("option", { value: "" }, "Todas"), /* @__PURE__ */ React.createElement("option", { value: "nao" }, "S\xF3 dentro"), /* @__PURE__ */ React.createElement("option", { value: "sim" }, "S\xF3 fora"))), /* @__PURE__ */ React.createElement("label", { className: "tk-filtro tk-check" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: filtros.abaixo_minimo === "1", onChange: (e) => setFiltros({ abaixo_minimo: e.target.checked ? "1" : null }) }), /* @__PURE__ */ React.createElement("span", null, "Abaixo do m\xEDnimo")), /* @__PURE__ */ React.createElement("label", { className: "tk-filtro tk-check", title: "Linhas com rece\xE7\xE3o ou requisi\xE7\xE3o registada hoje no PHC (a silver s\xF3 chega \xE0 noite)" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: filtros.mudou_hoje === "1", onChange: (e) => setFiltros({ mudou_hoje: e.target.checked ? "1" : null }) }), /* @__PURE__ */ React.createElement("span", null, "Mudou hoje")), /* @__PURE__ */ React.createElement("label", { className: "tk-filtro tk-check" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: filtros.primeiras === "1", onChange: (e) => setFiltros({ primeiras: e.target.checked ? "1" : null }) }), /* @__PURE__ */ React.createElement("span", null, "S\xF3 1.\xAA encomenda"))));
}
function TrakkerFila({ aba, params, navigate, routeId, aberta, onRows, recarregarToken }) {
  const [dados, setDados] = React.useState({ rows: [], hoje: null, phc_erro: null });
  const [carregando, setCarregando] = React.useState(true);
  const [erro, setErro] = React.useState(null);
  const pedir = React.useRef(null);
  if (!pedir.current) pedir.current = window.TrakkerAPI.pedidoUnico();
  const filtros = tkLerFiltros(params);
  const chave = JSON.stringify(filtros);
  const recarregar = React.useCallback(() => {
    setCarregando(true);
    pedir.current(window.TrakkerAPI.linhas({ aba, ...filtros }), {
      ok: (d) => {
        const rows = d.rows.map((r) => ({ ...r, hoje: d.hoje }));
        setDados({ ...d, rows, aba, carregadas_em: /* @__PURE__ */ new Date() });
        setErro(null);
      },
      falha: (e) => setErro({ motivo: window.TrakkerAPI.motivoErro(e) }),
      fim: () => setCarregando(false)
    });
  }, [aba, chave, recarregarToken]);
  React.useEffect(recarregar, [recarregar]);
  const setFiltros = (patch, historico) => window.HubRouter.setParams(patch, { replace: !historico });
  const observar = (r, texto) => window.TrakkerAPI.criarNota(r.bistamp, texto).then(recarregar).catch((e) => {
    window.srToast("Observa\xE7\xE3o", "error", e.status === 403 ? "Sem permiss\xE3o para escrever observa\xE7\xF5es." : e.detail || "N\xE3o foi gravada.");
    throw e;
  });
  const A = window.TrakkerAPI;
  const agrupada = aba === "fila" && dados.aba === "fila";
  const columns = [
    { key: "estado", label: "Estado", width: 130, sortValue: (r) => TK_ORDEM_ESTADO[r.estado] ?? 9, render: (r) => {
      const e = A.rotuloEstado(r.estado);
      return /* @__PURE__ */ React.createElement("span", { className: `tk-estado ${e.classe}` }, e.texto);
    } },
    // «Onde está» (spec §9.1): etapa · à espera de · limite · excesso, o responsável da
    // etapa, a vermelho quando há etapa perdida; ordena pelo excesso (o mais atrasado primeiro).
    { key: "onde", label: "Onde est\xE1", width: 320, sortValue: (r) => r.onde_esta && r.onde_esta.excesso != null ? -r.onde_esta.excesso : null, render: (r) => /* @__PURE__ */ React.createElement(TkOndeEsta, { r }) },
    { key: "cliente", label: "Cliente", width: 180, render: (r) => /* @__PURE__ */ React.createElement(React.Fragment, null, r.cliente, /* @__PURE__ */ React.createElement(window.TkChipVd, { l: r })) },
    { key: "obrano", label: "Encomenda", width: 95, sortValue: (r) => r.obrano || 0, render: (r) => r.obrano || r.nenc || "\u2014" },
    { key: "ref", label: "Refer\xEAncia", width: 140 },
    { key: "design", label: "Designa\xE7\xE3o", width: 220 },
    { key: "qtdenc", label: "Qtd", width: 100, render: (r) => `${r.qtdent || 0} / ${r.qtdenc}` },
    // #316: o que falta entregar das linhas abertas da encomenda com o mesmo dia de
    // entrega; o chip com o mínimo em vigor (vem do backend, editável nas opções).
    { key: "valor_entrega", label: "Valor entrega", width: 130, sortValue: (r) => r.valor_entrega ?? null, render: (r) => /* @__PURE__ */ React.createElement("span", { className: "tk-valor" }, A.fmtEuro(r.valor_entrega), r.abaixo_minimo ? /* @__PURE__ */ React.createElement("span", { className: "tk-chip-minimo", title: "Abaixo do valor m\xEDnimo de entrega: pode estar \xE0 espera de juntar mais" }, A.chipMinimo(dados.valor_minimo_entrega)) : null) },
    { key: "solicitada", label: "Solicitada", width: 95, render: (r) => A.fmt(r.solicitada) },
    { key: "prometida", label: "Prometida", width: 95, render: (r) => A.fmt(r.prometida) },
    // #324: o último adiamento, qualquer motivo; realçada quando não é a prometida
    { key: "ultima_prometida", label: "\xDAltima prometida", width: 110, sortValue: (r) => r.ultima_prometida || null, render: (r) => {
      const u = A.ultimaPrometida(r);
      return /* @__PURE__ */ React.createElement("span", { className: u.difere ? "tk-ultima-difere" : void 0, title: u.titulo }, u.texto);
    } },
    { key: "fluxo", label: "Fluxo", width: 100, render: (r) => A.FLUXOS[r.fluxo] || r.fluxo },
    { key: "fabrica", label: "F\xE1brica", width: 100, sortValue: (r) => (r.validacao || {}).fabrica || "", render: (r) => (r.validacao || {}).fabrica || "\u2014" },
    { key: "vendedor", label: "Vendedor", width: 110 },
    { key: "sac", label: "SAC", width: 120, sortValue: (r) => A.sacTexto(r), render: (r) => r.sac ? /* @__PURE__ */ React.createElement("span", { className: r.sac.id == null ? "tk-sac-sem" : void 0, title: A.sacTitulo(r) }, r.sac.nome) : "\u2014" },
    { key: "responsavel", label: "Respons\xE1vel", width: 130, sortValue: (r) => (r.responsavel || {}).nome || "", render: (r) => (r.responsavel || {}).nome || "\u2014" },
    { key: "ultima_nota", label: "\xDAltima observa\xE7\xE3o", width: 300, sortValue: (r) => (r.ultima_nota || {}).em || "", render: (r) => /* @__PURE__ */ React.createElement(TkObservacao, { r, onGravar: observar }) },
    { key: "primeira_enc", label: "1.\xAA enc.", width: 70, sortValue: (r) => r.primeira_enc ? 0 : 1, render: (r) => r.primeira_enc ? /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha" }, "1.\xAA") : null },
    // #320: o que a equipa escreve à mão na linha do PHC; opcionais no ⚙, desligadas
    ...A.CAMPOS_PHC.map((c) => ({ key: c.key, label: c.rotulo, width: 160, hidden: true, render: (r) => r[c.key] ? /* @__PURE__ */ React.createElement("span", { title: c.origem }, r[c.key]) : "\u2014" })),
    ...aba === "lista" ? [{ key: "fora_do_otif", label: "Fora do OTIF", width: 120, render: (r) => A.FORA[r.fora_do_otif] || "" }] : []
  ];
  const [ordenacao, setOrdenacao] = React.useState(null);
  const getters = {};
  columns.forEach((c) => {
    if (c.sortValue) getters[c.key] = c.sortValue;
  });
  React.useEffect(() => {
    if (onRows) onRows(A.ordemApresentada(dados.rows, ordenacao, getters, agrupada));
  }, [dados.rows, ordenacao, agrupada]);
  return /* @__PURE__ */ React.createElement("div", { className: "tk-fila" }, /* @__PURE__ */ React.createElement(TkFiltros, { aba, filtros, setFiltros, rows: dados.rows, hoje: dados.hoje, estadosFila: dados.estados_fila, etapas: dados.etapas, sacs: dados.sacs }), dados.phc_erro && /* @__PURE__ */ React.createElement("div", { className: "tk-aviso" }, "PHC indispon\xEDvel: alguns campos faltam (", dados.phc_erro, ")."), erro && dados.rows.length > 0 && /* @__PURE__ */ React.createElement(window.TkFalhaCarga, { titulo: "N\xE3o foi poss\xEDvel atualizar as linhas.", motivo: erro.motivo, onTentar: recarregar, aTentar: carregando }, /* @__PURE__ */ React.createElement("span", null, "As linhas abaixo s\xE3o da carga das ", tkHora(dados.carregadas_em), " e podem estar desatualizadas.")), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "trakker",
      viewId: `trakker-${aba}`,
      columns,
      data: dados.rows,
      rowKey: (r) => r.bistamp,
      onViewState: (v) => setOrdenacao(v.sort),
      groupBy: agrupada ? (r) => r.bostamp || r.bistamp : void 0,
      groupHeader: agrupada ? ({ rows }) => /* @__PURE__ */ React.createElement(TkCabecalhoEncomenda, { rows }) : void 0,
      pagination: agrupada ? "none" : "client",
      pageSize: 100,
      rowClassName: (r) => `${r.bistamp === aberta ? "is-aberta " : ""}tk-linha-${r.estado}`,
      onRowClick: (r) => navigate({ routeId, entidade: r.bistamp, params: window.HubRouter.current().params }),
      loading: carregando,
      empty: erro ? /* @__PURE__ */ React.createElement(window.TkFalhaCarga, { titulo: "N\xE3o foi poss\xEDvel carregar as linhas.", motivo: erro.motivo, onTentar: recarregar, aTentar: carregando }) : A.textoVazio({ aba, carregando, erro })
    }
  ));
}
window.TrakkerFila = TrakkerFila;

// ===== trakker/frontend/trakker_tapete.jsx =====
(function() {
  const X0 = 12;
  const CAMIAO = 96;
  const PALETE_MEIA = 17;
  const X_CAMIAO = 8;
  const ABA = 13;
  const FOLGA = PALETE_MEIA + ABA - X_CAMIAO + 4;
  const GAP = 84;
  const SEM_LARG = GAP - 4;
  const MODULO = 110;
  const ALTURA = 160;
  const ENTRADA = -24;
  const VIAGEM = 60;
  const ALVO_MIN = 74;
  const MS_DIA = 864e5;
  const dia = (iso) => iso ? Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10)) : null;
  const pct = (n) => `${Math.min(100, Math.max(0, n)).toFixed(2)}%`;
  function luzDe(e, risco) {
    if (e.estado === "dispensada") return "dispensada";
    if (e.estado === "cumprida") return "verde";
    if (e.estado === "estourada") return "vermelho";
    const n = e.janela === "antes" ? -e.ate_pedida : e.excesso_dias_uteis;
    return e.estado === "em_curso" && n !== null && n !== void 0 && -n <= risco ? "amarelo" : "apagado";
  }
  function excessoDe(e) {
    const n = e.excesso_dias_uteis;
    if (n === null || n === void 0) return "sem excesso";
    if (e.real) return n < 0 ? `${-n} d.\xFA. antes` : e.estado === "cumprida" && n === 0 ? "no dia" : `+${n} d.\xFA.`;
    if (n > 0) return `em atraso ${n} d.\xFA.`;
    return n < 0 ? `faltam ${-n} d.\xFA.` : "limite hoje";
  }
  const ESTADO_LUZ = { verde: "cumpriu", vermelho: "falhou", amarelo: "em curso", apagado: "por chegar", dispensada: "dispensada" };
  function textos(e, luz, fmt, forn, luzNossa) {
    const pedidaAntes = e.janela === "dentro" && e.pedida && e.limite && e.pedida < e.limite;
    const previsto = `previsto ${fmt(e.limite)}${pedidaAntes ? ` \xB7 pedida ${fmt(e.pedida)}` : ""} \xB7 real ${fmt(e.real)}`;
    if (forn) {
      const nosso = `${ESTADO_LUZ[luzNossa]} o nosso limite (${excessoDe(e)})`;
      return {
        atraso: false,
        forn: true,
        etiqueta: `forn. +${forn.atraso_dias} d`,
        // «22/10 → 19/10» não cabe ao lado (fica no aria)
        aria: `${e.nome}: ${nosso} \xB7 fornecedor atrasou ${forn.atraso_dias} d face \xE0 ${forn.atraso_face} \xB7 ${previsto}`
      };
    }
    if (luz === "dispensada") {
      const por = `dispensada \u2014 ${e.dispensada_por || "uma etapa seguinte"} j\xE1 aconteceu`;
      return { atraso: false, forn: false, etiqueta: "dispensada", aria: `${e.nome}: ${por} \xB7 ${previsto}` };
    }
    if (e.janela === "antes") {
      const tarde = e.pedida_tarde ? ` \xB7 pedida tarde (o nosso limite era ${fmt(e.limite)})` : "";
      return {
        atraso: false,
        forn: false,
        etiqueta: `pedida ${fmt(e.pedida)}`,
        aria: `${e.nome}: ${ESTADO_LUZ[luz]} \xB7 pedida ao fornecedor para ${fmt(e.pedida)}: s\xF3 conta a partir da\xED${tarde} \xB7 faltam ${e.ate_pedida} d.\xFA.`
      };
    }
    const atraso = luz === "vermelho" && !e.real;
    let etiqueta = e.limite ? `at\xE9 ${fmt(e.limite)}` : "sem limite";
    if (e.real) etiqueta = e.limite ? `${fmt(e.limite)} \u2192 ${fmt(e.real)}` : fmt(e.real);
    else if (atraso) etiqueta = `em atraso ${e.excesso_dias_uteis}`;
    const aria = `${e.nome}: ${ESTADO_LUZ[luz]} \xB7 ${previsto} \xB7 ${excessoDe(e)}`;
    return { atraso, forn: false, etiqueta, aria };
  }
  function afastar(xs, gap, min, max) {
    const querem = [];
    xs.forEach((x, i) => {
      querem.push(x ?? (i ? querem[i - 1] + gap : min));
    });
    const blocos = [];
    querem.forEach((x, i) => {
      blocos.push({ soma: x - i * gap, n: 1 });
      while (blocos.length > 1) {
        const b = blocos[blocos.length - 1];
        const a = blocos[blocos.length - 2];
        if (a.soma / a.n <= b.soma / b.n) break;
        blocos.pop();
        a.soma += b.soma;
        a.n += b.n;
      }
    });
    const teto = Math.max(min, max - (xs.length - 1) * gap);
    const out = [];
    blocos.forEach((b) => {
      const z = Math.min(Math.max(b.soma / b.n, min), teto);
      for (let k = 0; k < b.n; k += 1) out.push(z + out.length * gap);
    });
    return out;
  }
  function posicoes(xLimites, gap, min, max) {
    let chave = -Infinity;
    const ordem = xLimites.map((x, i) => {
      if (x !== null) chave = x;
      return { i, x, chave };
    }).sort((a, b) => a.chave - b.chave || a.i - b.i);
    const xs = afastar(ordem.map((o) => o.x), gap, min, max);
    const out = [];
    ordem.forEach((o, k) => {
      out[o.i] = xs[k];
    });
    return out;
  }
  function alvosDe(l, xDe, fmt) {
    const pedido = l.pedido_cliente_em && String(l.pedido_cliente_em).slice(0, 10);
    const lista = [
      pedido && { tipo: "pedido", x: xDe(pedido), texto: `pedido ${fmt(pedido)}` },
      // #306: o email do cliente
      l.solicitada && { tipo: "solicitada", x: xDe(l.solicitada), texto: `solicitada ${fmt(l.solicitada)}` },
      l.prometida && { tipo: "prometida", x: xDe(l.prometida), texto: `prometida ${fmt(l.prometida)}` },
      { tipo: "hoje", x: xDe(l.hoje), texto: "hoje" }
    ].filter(Boolean).sort((a, b) => a.x - b.x);
    lista.forEach((a, i) => {
      const ant = lista[i - 1];
      a.fila = ant && a.x - ant.x < ALVO_MIN ? 1 - ant.fila : 0;
      const mesma = lista[i - 2];
      a.xTexto = mesma && mesma.fila === a.fila ? Math.max(a.x, mesma.xTexto + ALVO_MIN) : a.x;
    });
    return lista;
  }
  function cssDe(t) {
    const de = ENTRADA;
    const ate = t.palete.x;
    const noCiclo = (x) => VIAGEM * ((x - de) / (ate - de));
    const passos = [`0% { transform: translateX(${de}px); opacity: 1; }`];
    t.juntas.filter((x) => x > de && x < ate).forEach((x) => {
      const p = noCiclo(x);
      passos.push(`${pct(p - 0.5)} { transform: translateX(${x - 4}px); }`);
      passos.push(`${pct(p)} { transform: translate(${x}px, -1.5px); }`);
      passos.push(`${pct(p + 0.5)} { transform: translateX(${x + 4}px); }`);
    });
    passos.push(`${VIAGEM}% { transform: translateX(${ate}px); opacity: 1; }`);
    passos.push(t.entregue ? `63%, 100% { transform: translateX(${ate}px); opacity: 0; }` : `96% { transform: translateX(${ate}px); opacity: 1; } 100% { transform: translateX(${ate}px); opacity: 0; }`);
    const sems = t.marcos.map((m, i) => {
      if (m.acende === null) return "";
      const p = Math.min(m.acende, 98);
      return `@keyframes tk-tap-sem-${i} { 0%, ${pct(p)} { opacity: 0; } ${pct(p + 1)}, 100% { opacity: 1; } }`;
    });
    return [`@keyframes tk-tap-palete { ${passos.join(" ")} }`, ...sems].filter(Boolean).join("\n");
  }
  function calcular(l, { largura = 0 } = {}) {
    const p = l && l.percurso;
    if (!p || !p.ramo || !(p.etapas || []).length) return null;
    const A = window.TrakkerAPI;
    const etapas = [...p.etapas].sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0));
    const entrega = l.dataentregaenc ? String(l.dataentregaenc).slice(0, 10) : null;
    const risco = l.dias_em_risco ?? 2;
    const saiu = !!entrega || l.qtdenc > 0 && l.qtdent >= l.qtdenc;
    const n = etapas.length;
    const total = Math.max(largura, n * GAP + X0 * 2 + CAMIAO);
    const xFim = total - CAMIAO;
    const xEixo = xFim - FOLGA;
    const pedido = l.pedido_cliente_em ? String(l.pedido_cliente_em).slice(0, 10) : null;
    const datas = [
      pedido,
      l.dataenc,
      l.solicitada,
      l.prometida,
      l.hoje,
      entrega,
      ...etapas.flatMap((e) => [e.limite, e.real, e.pedida])
    ].map(dia).filter((d) => d !== null);
    const ini = Math.min(...datas);
    const fim = Math.max(...datas, ini + MS_DIA);
    const xDe = (iso) => X0 + (dia(iso) - ini) / (fim - ini) * (xEixo - X0);
    const xs = posicoes(etapas.map((e) => e.limite ? xDe(e.limite) : null), GAP, X0 + GAP / 2, xFim - GAP / 2);
    const ultimaFeita = etapas.reduce((k, e, i) => e.real ? i : k, -1);
    const atual = etapas.findIndex((e, i) => i > ultimaFeita && !e.real && e.estado !== "na");
    const ultimo = Math.max(...xs);
    const palX = saiu ? xFim + 26 : atual >= 0 ? Math.min(xDe(l.hoje), xs[atual] - PALETE_MEIA) : Math.min(Math.max(xDe(l.hoje), ultimo + PALETE_MEIA + 8), xEixo);
    const marcos = etapas.map((e, i) => {
      const luzPino = luzDe(e, risco);
      const forn = A.atrasoFornecedor(l, e) ? l.fornecedor : null;
      const luz = forn ? "vermelho" : luzPino;
      const xLimite = e.limite ? xDe(e.limite) : null;
      const xReal = e.real ? xDe(e.real) : null;
      const xPedida = e.pedida ? xDe(e.pedida) : null;
      const onde = xReal ?? xLimite ?? palX;
      const aFrente = atual >= 0 && i >= atual && !e.real;
      const acende = luz === "apagado" || luz === "dispensada" ? null : aFrente ? 0 : VIAGEM * ((Math.min(onde, palX) - ENTRADA) / (palX - ENTRADA));
      return { nome: e.nome, luz, luzPino, x: xs[i], xLimite, xReal, xPedida, acende, ...textos(e, luz, A.fmt, forn, luzPino) };
    });
    const qtd = Math.max(2, Math.round((xFim - X0) / MODULO));
    const passo = (xFim - X0) / qtd;
    const modulos = Array.from({ length: qtd }, (_, i) => ({ x: X0 + i * passo, largura: passo }));
    const t = {
      largura: total,
      altura: ALTURA,
      x0: X0,
      xFim,
      xEixo,
      xCamiao: xFim + X_CAMIAO,
      abaCamiao: ABA,
      gap: GAP,
      marcos,
      modulos,
      juntas: modulos.slice(1).map((m) => m.x),
      alvos: alvosDe(l, xDe, A.fmt),
      palete: { x: palX, meia: PALETE_MEIA },
      entregue: entrega ? A.fmt(entrega) : saiu ? "sem data" : null
    };
    return { ...t, css: cssDe(t) };
  }
  function Modulo({ m }) {
    const yRolo = 66;
    const rolos = [m.x + 7, m.x + m.largura - 7];
    return /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { className: "tk-tap-estrutura", x: m.x + 1, y: 70, width: m.largura - 2, height: 9, rx: 1 }), /* @__PURE__ */ React.createElement("rect", { className: "tk-tap-banda", x: m.x + 1, y: 61, width: m.largura - 2, height: 10, rx: 5 }), /* @__PURE__ */ React.createElement("line", { className: "tk-tap-banda-marca", x1: m.x + 6, x2: m.x + m.largura - 6, y1: 61.5, y2: 61.5 }), rolos.map((x) => /* @__PURE__ */ React.createElement("g", { key: x, className: "tk-tap-rolo" }, /* @__PURE__ */ React.createElement("circle", { cx: x, cy: yRolo, r: 3.5 }), /* @__PURE__ */ React.createElement("line", { x1: x - 3.5, x2: x + 3.5, y1: yRolo, y2: yRolo }))));
  }
  function Palete({ x }) {
    return /* @__PURE__ */ React.createElement("g", { className: "tk-tap-palete", style: { transform: `translateX(${x}px)` } }, /* @__PURE__ */ React.createElement("rect", { className: "tk-tap-madeira", x: -17, y: 58, width: 34, height: 3 }), /* @__PURE__ */ React.createElement("rect", { className: "tk-tap-caixa", x: -15, y: 45, width: 14, height: 13 }), /* @__PURE__ */ React.createElement("rect", { className: "tk-tap-caixa", x: 1, y: 45, width: 14, height: 13 }), /* @__PURE__ */ React.createElement("rect", { className: "tk-tap-caixa", x: -8, y: 32, width: 15, height: 13 }));
  }
  function CamiaoAba({ x }) {
    return /* @__PURE__ */ React.createElement("g", { transform: `translate(${x} 0)` }, /* @__PURE__ */ React.createElement("g", { className: "tk-cam" }, /* @__PURE__ */ React.createElement("rect", { className: "tk-cam-aba", x: -ABA, y: 26, width: ABA, height: 38 })));
  }
  function Camiao({ x }) {
    return /* @__PURE__ */ React.createElement("g", { transform: `translate(${x} 0)` }, /* @__PURE__ */ React.createElement("g", { className: "tk-cam" }, /* @__PURE__ */ React.createElement("rect", { className: "tk-cam-caixa", x: 0, y: 24, width: 58, height: 42, rx: 1 }), /* @__PURE__ */ React.createElement("path", { className: "tk-cam-cabine", d: "M60 36 h11 l7 13 v17 h-18 z" }), /* @__PURE__ */ React.createElement("rect", { className: "tk-cam-chassi", x: 0, y: 66, width: 78, height: 4 }), [12, 46, 67].map((r) => /* @__PURE__ */ React.createElement("circle", { key: r, className: "tk-cam-roda", cx: r, cy: 73, r: 6 }))));
  }
  function Semaforo({ m, i, ativo, onFoco }) {
    const cor = { vermelho: 0, amarelo: 1, verde: 2 }[m.luz];
    return /* @__PURE__ */ React.createElement(
      "g",
      {
        className: `tk-sem is-${m.luz}${ativo ? " is-foco" : ""}`,
        tabIndex: 0,
        role: "img",
        "aria-label": m.aria,
        onMouseEnter: () => onFoco(i),
        onMouseLeave: () => onFoco(null),
        onFocus: () => onFoco(i),
        onBlur: () => onFoco(null),
        onClick: () => onFoco(i)
      },
      /* @__PURE__ */ React.createElement("title", null, m.aria),
      /* @__PURE__ */ React.createElement("rect", { className: "tk-sem-alvo", x: m.x - SEM_LARG / 2, y: 96, width: SEM_LARG, height: 62 }),
      /* @__PURE__ */ React.createElement("rect", { className: "tk-sem-caixa", x: m.x - 7, y: 98, width: 14, height: 34, rx: 3 }),
      [0, 1, 2].map((k) => /* @__PURE__ */ React.createElement(
        "circle",
        {
          key: k,
          className: `tk-sem-luz${k === cor ? ` is-on is-${m.luz}` : ""}`,
          cx: m.x,
          cy: 104.5 + k * 10.5,
          r: 4,
          style: k === cor && m.acende !== null ? { animationName: `tk-tap-sem-${i}` } : void 0
        }
      )),
      /* @__PURE__ */ React.createElement("text", { className: "tk-sem-nome", x: m.x, y: 143, textAnchor: "middle" }, m.nome.length > 15 ? `${m.nome.slice(0, 14)}\u2026` : m.nome),
      /* @__PURE__ */ React.createElement("text", { className: `tk-sem-data${m.atraso || m.forn ? " is-atraso" : ""}`, x: m.x, y: 155, textAnchor: "middle" }, m.etiqueta)
    );
  }
  function Pista({ m }) {
    const cor = `is-${m.luzPino}`;
    return /* @__PURE__ */ React.createElement("g", null, m.xLimite !== null && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("line", { className: "tk-tap-guia", x1: m.xLimite, y1: 94, x2: m.x, y2: 98 }), /* @__PURE__ */ React.createElement("rect", { className: `tk-tap-previsto${m.atraso ? " is-atraso" : ""}`, x: m.xLimite - 2, y: 81, width: 4, height: 13 })), m.xPedida !== null && /* @__PURE__ */ React.createElement("line", { className: "tk-tap-pedida", x1: m.xPedida, x2: m.xPedida, y1: 81, y2: 94 }), m.xReal !== null && /* @__PURE__ */ React.createElement("g", { className: `tk-tap-pino ${cor}` }, /* @__PURE__ */ React.createElement("line", { x1: m.xReal, x2: m.xReal, y1: 94, y2: 81 }), /* @__PURE__ */ React.createElement("path", { d: `M${m.xReal} 81 l8 3 l-8 3 z` })));
  }
  function Alvo({ a, t }) {
    const y = a.fila ? 19 : 9;
    const x = Math.min(Math.max(a.xTexto, 42), t.largura - 42);
    return /* @__PURE__ */ React.createElement("g", { className: `tk-alvo is-${a.tipo}` }, a.tipo === "prometida" ? /* @__PURE__ */ React.createElement("rect", { x: a.x - 3, y: 22, width: 6, height: 72, fill: "url(#tk-xadrez)" }) : /* @__PURE__ */ React.createElement("line", { x1: a.x, x2: a.x, y1: 22, y2: 94 }), /* @__PURE__ */ React.createElement("text", { x, y, textAnchor: "middle" }, a.texto));
  }
  function TkTapete({ l }) {
    const caixa = React.useRef(null);
    const [medida, setMedida] = React.useState(0);
    const [foco, setFoco] = React.useState(null);
    React.useLayoutEffect(() => {
      const el = caixa.current;
      if (!el) return void 0;
      const medir = () => setMedida(el.clientWidth);
      medir();
      if (!window.ResizeObserver) return void 0;
      const ro = new window.ResizeObserver(medir);
      ro.observe(el);
      return () => ro.disconnect();
    }, []);
    const t = calcular(l, { largura: medida });
    if (!t) return null;
    return /* @__PURE__ */ React.createElement("div", { className: "tk-tapete-bloco" }, /* @__PURE__ */ React.createElement("div", { className: `tk-tapete${t.entregue ? " is-entregue" : ""}`, ref: caixa }, medida > 0 && /* @__PURE__ */ React.createElement(
      "svg",
      {
        className: "tk-tapete-svg",
        width: t.largura,
        height: t.altura,
        viewBox: `0 0 ${t.largura} ${t.altura}`,
        role: "group",
        "aria-label": `Tapete dos marcos da linha${t.entregue ? `, entregue ${t.entregue}` : ""}`
      },
      /* @__PURE__ */ React.createElement("style", null, t.css),
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("pattern", { id: "tk-xadrez", width: 6, height: 6, patternUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("rect", { className: "tk-xadrez-a", width: 6, height: 6 }), /* @__PURE__ */ React.createElement("rect", { className: "tk-xadrez-b", width: 3, height: 3 }), /* @__PURE__ */ React.createElement("rect", { className: "tk-xadrez-b", x: 3, y: 3, width: 3, height: 3 }))),
      /* @__PURE__ */ React.createElement("rect", { className: "tk-tap-chao", x: 0, y: 80, width: t.largura, height: 14 }),
      t.alvos.map((a) => /* @__PURE__ */ React.createElement(Alvo, { key: a.tipo, a, t })),
      t.marcos.map((m, i) => /* @__PURE__ */ React.createElement(Pista, { key: i, m })),
      t.modulos.map((m) => /* @__PURE__ */ React.createElement(Modulo, { key: m.x, m })),
      /* @__PURE__ */ React.createElement(CamiaoAba, { x: t.xCamiao }),
      /* @__PURE__ */ React.createElement(Palete, { x: t.palete.x }),
      /* @__PURE__ */ React.createElement(Camiao, { x: t.xCamiao }),
      t.entregue && /* @__PURE__ */ React.createElement("text", { className: "tk-tap-entregue", x: t.largura - 6, y: 52, textAnchor: "end" }, "\u2713 entregue ", t.entregue),
      t.marcos.map((m, i) => /* @__PURE__ */ React.createElement(Semaforo, { key: i, m, i, ativo: foco === i, onFoco: setFoco }))
    )), /* @__PURE__ */ React.createElement("div", { className: "tk-tapete-info", "aria-live": "polite" }, foco !== null && t.marcos[foco] ? t.marcos[foco].aria : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Tra\xE7o cinzento = previsto \xB7 bandeira = real")));
  }
  window.TrakkerTapete = { calcular };
  window.TkTapete = TkTapete;
})();

// ===== trakker/frontend/trakker_drawer.jsx =====
const TK_EXT_IMG = ["png", "jpg", "jpeg", "gif", "webp"];
function tkAnexoTipo(a) {
  if (!a) return null;
  if (a.url) return "link";
  const ext = String(a.fext || "").toLowerCase();
  if (ext === "pdf") return "pdf";
  return TK_EXT_IMG.includes(ext) ? "img" : "baixar";
}
const tkTemValor = (p) => p && p[1] !== null && p[1] !== void 0 && p[1] !== "";
function TkKv({ pares }) {
  return /* @__PURE__ */ React.createElement("div", { className: "kv-grid" }, pares.filter(tkTemValor).map(([k, v]) => /* @__PURE__ */ React.createElement(React.Fragment, { key: k }, /* @__PURE__ */ React.createElement("div", { className: "k" }, k), /* @__PURE__ */ React.createElement("div", { className: "v txt" }, v))));
}
function tkMarcos(l) {
  const v = l.validacao || {};
  const mp = l.fluxo === "producao";
  const f = l.fornecedor;
  const m = [
    ["Pedido do cliente", l.pedido_cliente_em],
    ["Encomenda", l.dataenc],
    ["Valida\xE7\xE3o comercial", v.validado_em],
    l.tipo_inicial && l.tipo_inicial !== "Normal" && l.passou_a_normal_em ? ["Passou a Normal", l.passou_a_normal_em] : null,
    [mp ? "Requisi\xE7\xE3o MP" : "Requisi\xE7\xE3o", mp ? l.datadareqmp : l.datadareqme, mp ? "datadareqmp" : "datadareqme"],
    f ? [`Solicitada ao fornecedor (${f.tipo})`, f.solicitada] : null,
    window.TrakkerAPI.marcoConfirmacao(l),
    [mp ? "Rece\xE7\xE3o MP" : "Rece\xE7\xE3o", mp ? l.datarecmp : l.datarecme, mp ? "datarecmp" : "datarecme"],
    mp ? ["Fecho da OF", l.fecho_of && l.fecho_of.fecho] : null,
    ["Picking", l.datapick2],
    ["Entrega", l.dataentregaenc]
  ].filter((x) => x && x[1]).map(([nome, data, col]) => ({
    nome,
    data,
    tipo: "marco",
    phcHoje: window.TrakkerAPI.doPhcHoje(l, col)
  }));
  if (l.solicitada) m.push({ nome: "Solicitada pelo cliente", data: l.solicitada, tipo: "alvo" });
  if (l.prometida) m.push({ nome: "Prometida", data: l.prometida, tipo: "alvo" });
  return m.sort((a, b) => String(a.data).localeCompare(String(b.data)));
}
function tkExcessoEtapa(e) {
  const n = e.excesso_dias_uteis;
  if (e.janela === "antes") return ` \xB7 \xE0 espera da data pedida (${window.TrakkerAPI.fmt(e.pedida)})`;
  if (n === null || n === void 0 || e.estado === "por_iniciar") return "";
  const d = (k) => `${k} ${k === 1 ? "dia \xFAtil" : "dias \xFAteis"}`;
  if (e.estado === "cumprida") return n < 0 ? ` \xB7 ${d(-n)} antes` : " \xB7 no dia";
  if (n > 0) return ` \xB7 +${d(n)}`;
  return n < 0 ? ` \xB7 ${n === -1 ? "falta" : "faltam"} ${d(-n)}` : " \xB7 limite hoje";
}
const tkEtapaFornecedor = (l) => window.TrakkerAPI.etapaFornecedor(l);
function TkFornecedor({ f }) {
  const A = window.TrakkerAPI;
  const notas = A.notasFornecedor(f);
  return /* @__PURE__ */ React.createElement("div", { className: "tk-forn" }, /* @__PURE__ */ React.createElement("div", { className: "tk-forn-topo" }, /* @__PURE__ */ React.createElement("strong", null, "Fornecedor"), " ", /* @__PURE__ */ React.createElement("span", null, f.fornecedor || "\u2014")), /* @__PURE__ */ React.createElement(TkKv, { pares: [
    ["Requisi\xE7\xE3o", A.requisicaoFornecedor(f)],
    ["Solicitada ao fornecedor", A.fmt(f.solicitada)],
    ["Confirmada pelo fornecedor", A.fmt(f.confirmada)],
    ["Rece\xE7\xE3o", A.fmt(f.rececao)]
  ] }), notas.map((n) => /* @__PURE__ */ React.createElement("div", { key: n, className: "muted tk-forn-nota" }, n)));
}
function TkConta({ passos }) {
  const [aberta, setAberta] = React.useState(false);
  return /* @__PURE__ */ React.createElement("details", { className: "tk-etapa-conta", onToggle: (ev) => setAberta(ev.currentTarget.open) }, /* @__PURE__ */ React.createElement("summary", { className: "muted" }, "a conta"), aberta && /* @__PURE__ */ React.createElement("ul", { className: "tk-arv-passos" }, passos.map((t, k) => /* @__PURE__ */ React.createElement("li", { key: k }, t))));
}
function TkSubtitulo({ l }) {
  const A = window.TrakkerAPI;
  const v = A.valorEntrega(l);
  return /* @__PURE__ */ React.createElement("span", null, `${l.cliente} \xB7 Enc. ${l.obrano || l.nenc || "\u2014"}`, /* @__PURE__ */ React.createElement(window.TkChipVd, { l }), v && /* @__PURE__ */ React.createElement("span", { className: "tk-valor-ficha" }, " \xB7 ", v.texto, v.abaixo && /* @__PURE__ */ React.createElement("span", { className: "tk-chip-minimo" }, v.abaixo)));
}
function TkEtapas({ l }) {
  const A = window.TrakkerAPI;
  const p = l.percurso;
  if (!p) return null;
  if (!p.ramo) return /* @__PURE__ */ React.createElement("div", { className: "muted tk-etapas-fora" }, "Fora da \xE1rvore de prazos (", p.fora || "\u2014", "): o estado \xE9 s\xF3 pela prometida.");
  const me = window.SR_ME || {};
  const eForn = tkEtapaFornecedor(l);
  return /* @__PURE__ */ React.createElement("div", { className: "tk-etapas" }, /* @__PURE__ */ React.createElement("div", { className: "tk-etapas-ramo" }, /* @__PURE__ */ React.createElement("span", null, "Ramo ", /* @__PURE__ */ React.createElement("strong", null, p.ramo.nome)), me.is_staff && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost sm",
      onClick: () => window.HubRouter.navigate({ routeId: "trakker_arvore", entidade: l.bistamp })
    },
    "Ver no simulador"
  )), p.prazo_curto && /* @__PURE__ */ React.createElement("div", { className: "tk-aviso" }, "Prazo curto: da valida\xE7\xE3o, as etapas n\xE3o cabiam at\xE9 \xE0 prometida (", A.fmt(p.prometida), ") \u2014 a promessa j\xE1 nasceu sem margem."), l.percurso_aviso && /* @__PURE__ */ React.createElement("div", { className: "tk-aviso" }, l.percurso_aviso, " \u2014 os fatores do PHC contam como desconhecidos."), /* @__PURE__ */ React.createElement("ol", { className: "tk-arv-conta" }, p.etapas.map((e) => {
    const est = A.ESTADOS_ETAPA[e.estado] || { texto: e.estado, classe: "is-neutro" };
    const perdida = e.nome === p.etapa_perdida;
    const atual = e.nome === p.etapa_atual;
    const forn = A.atrasoFornecedor(l, e);
    return /* @__PURE__ */ React.createElement("li", { key: e.ordem, className: `${perdida ? "is-perdida" : ""}${atual ? " is-atual" : ""}` }, /* @__PURE__ */ React.createElement("div", { className: "tk-arv-conta-topo" }, /* @__PURE__ */ React.createElement("strong", null, e.nome), e.responsavel && /* @__PURE__ */ React.createElement("span", { className: "tk-onde-resp" }, e.responsavel), /* @__PURE__ */ React.createElement("span", null, "limite ", A.fmt(e.limite), " \xB7 real ", A.fmt(e.real)), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: `tk-estado ${est.classe}`,
        title: e.dispensada_por ? `dispensada \u2014 ${e.dispensada_por} j\xE1 aconteceu` : void 0
      },
      est.texto,
      tkExcessoEtapa(e),
      forn && /* @__PURE__ */ React.createElement("span", { className: "tk-estado-forn" }, "\xB7 ", forn)
    ), atual && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha" }, "aqui"), perdida && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha is-atrasada" }, "perdida aqui"), e.pedida_tarde && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha is-tarde", title: `pedida ao fornecedor para ${A.fmt(e.pedida)}, depois do nosso limite ${A.fmt(e.limite)}` }, "pedida tarde")), A.esperaMinimo(l, e) && /* @__PURE__ */ React.createElement("div", { className: "tk-nota-minimo" }, "\xE0 espera de valor m\xEDnimo? A entrega vale ", A.fmtEuro(l.valor_entrega), ", abaixo dos ", A.fmtMinimo(l.valor_minimo_entrega), "."), e === eForn && /* @__PURE__ */ React.createElement(TkFornecedor, { f: l.fornecedor }), /* @__PURE__ */ React.createElement(TkConta, { passos: e.passos }));
  })));
}
function TkPercurso({ l }) {
  const A = window.TrakkerAPI;
  const e = A.rotuloEstado(l.estado);
  const marcos = tkMarcos(l);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Percurso"), /* @__PURE__ */ React.createElement("div", { className: "tk-percurso-topo" }, /* @__PURE__ */ React.createElement("span", { className: `tk-estado ${e.classe}` }, e.texto), /* @__PURE__ */ React.createElement("span", null, A.ondeEsta(l))), /* @__PURE__ */ React.createElement(window.TkTapete, { l }), /* @__PURE__ */ React.createElement(TkEtapas, { l }), l.fornecedor && !tkEtapaFornecedor(l) && /* @__PURE__ */ React.createElement(TkFornecedor, { f: l.fornecedor }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Marcos do ERP"), marcos.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem marcos do ERP.") : /* @__PURE__ */ React.createElement("ol", { className: "tk-marcos" }, marcos.map((m, i) => /* @__PURE__ */ React.createElement("li", { key: `${m.nome}-${i}`, className: `tk-marco is-${m.tipo}${m.data > (l.hoje || "") ? " is-futuro" : ""}` }, /* @__PURE__ */ React.createElement("span", { className: "tk-marco-data" }, A.fmtHora(m.data)), /* @__PURE__ */ React.createElement("span", null, m.nome), m.phcHoje && /* @__PURE__ */ React.createElement("span", { className: "tk-phc-hoje", title: "hoje, do PHC (a silver ainda n\xE3o tem)", "aria-label": "hoje, do PHC" })))));
}
function TkDatas({ l }) {
  const A = window.TrakkerAPI;
  const adi = A.adiamentosFicha(l);
  const datas = [["Solicitada", l.solicitada], ["Prometida inicial", l.prometida_inicial], ["Prometida atual", l.prometida]];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Datas e adiamentos"), /* @__PURE__ */ React.createElement("div", { className: "tk-trio" }, datas.map(([k, v]) => /* @__PURE__ */ React.createElement("div", { key: k, className: `tk-trio-celula${k === "Prometida atual" && v !== l.prometida_inicial ? " is-mudou" : ""}` }, /* @__PURE__ */ React.createElement("span", { className: "tk-trio-k" }, k), /* @__PURE__ */ React.createElement("span", { className: "tk-trio-v" }, v ? A.fmt(v) : "sem data")))), /* @__PURE__ */ React.createElement("div", { className: "tk-subtitulo" }, adi.titulo), adi.vazio ? /* @__PURE__ */ React.createElement("div", { className: "muted" }, adi.vazio) : /* @__PURE__ */ React.createElement("div", { role: "table", "aria-label": "Adiamentos", className: "tk-grelha tk-grelha--adiamentos" }, /* @__PURE__ */ React.createElement("div", { role: "row", className: "tk-grelha-cabeca" }, ["Registado em", "Adiada para", "Motivo", "Comunica\xE7\xE3o"].map((c) => /* @__PURE__ */ React.createElement("span", { key: c, role: "columnheader" }, c))), adi.itens.map((a, i) => /* @__PURE__ */ React.createElement("div", { role: "row", key: `${a.registado_em}-${a.data}-${i}` }, /* @__PURE__ */ React.createElement("span", { role: "cell" }, a.registado_em ? A.fmt(a.registado_em) : ""), /* @__PURE__ */ React.createElement("span", { role: "cell" }, A.fmt(a.data)), /* @__PURE__ */ React.createElement("span", { role: "cell" }, a.motivo, a.muda_data && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha tk-pastilha-mais", title: "Este motivo muda a prometida" }, "muda a prometida")), /* @__PURE__ */ React.createElement("span", { role: "cell" }, a.comunicacao)))));
}
function TkGrupo({ titulo, children }) {
  return /* @__PURE__ */ React.createElement("div", { className: "tk-ctx-grupo" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, titulo), children);
}
const tkNum = (n) => new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 2 }).format(n || 0);
function TkContexto({ l }) {
  const A = window.TrakkerAPI;
  const v = l.validacao;
  const origem = { sondagem: "sondagem", u_encphist: "valida\xE7\xE3o PHC" }[l.origem_tipo];
  const tipo = /* @__PURE__ */ React.createElement("span", null, l.tipo_atual || "desconhecido (PHC indispon\xEDvel)", l.tipo_inicial && l.tipo_inicial !== l.tipo_atual ? ` (nasceu ${l.tipo_inicial})` : "", /* @__PURE__ */ React.createElement("span", { className: "muted tk-secundaria" }, origem ? `passou a Normal em ${A.fmtHora(l.passou_a_normal_em)} (${origem})` : `nascida Normal, data assumida (${A.fmt(l.passou_a_normal_em)})`), (l.mudancas_tipo || []).length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "tk-lista-curta" }, l.mudancas_tipo.map((m, i) => /* @__PURE__ */ React.createElement("li", { key: i }, m.de || "\u2014", " \u2192 ", m.para, " \xB7 ", A.fmtHora(m.em), " \xB7 ", m.origem === "u_encphist" ? "valida\xE7\xE3o PHC" : "sondagem"))));
  const cliente = l.cliente && /* @__PURE__ */ React.createElement("span", null, l.cliente, /* @__PURE__ */ React.createElement(window.TkChipVd, { l }), l.cliente_bloqueado ? /* @__PURE__ */ React.createElement("span", { className: "tk-estado is-bloq tk-ao-lado" }, l.cliente_estado) : l.cliente_estado ? /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 ", l.cliente_estado) : null);
  const encomenda = l.obrano && /* @__PURE__ */ React.createElement("span", null, l.obrano, l.enc_fechada && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha tk-ao-lado" }, "fechada no PHC"));
  const sac = l.sac && /* @__PURE__ */ React.createElement("span", { className: l.sac.id == null ? "tk-sac-sem" : void 0, title: A.sacTitulo(l) }, l.sac.nome);
  const gestao = l.gestao && /* @__PURE__ */ React.createElement("span", null, l.gestao === "stock" ? "por stock" : "por encomenda", l.com_stock !== null && l.com_stock !== void 0 && /* @__PURE__ */ React.createElement("span", { className: "muted tk-secundaria" }, l.com_stock ? "com stock \xE0 valida\xE7\xE3o" : "sem stock \xE0 valida\xE7\xE3o"));
  const up = A.ultimaPrometida(l);
  const q = A.quantidades(l);
  const camposPhc = A.camposPhc(l);
  const s = l.stock;
  const temStock = s && s.armazens && s.armazens.length > 0;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Contexto"), /* @__PURE__ */ React.createElement("div", { className: "tk-ctx-grupos" }, /* @__PURE__ */ React.createElement(TkGrupo, { titulo: "Encomenda" }, /* @__PURE__ */ React.createElement(TkKv, { pares: [
    ["Cliente", cliente],
    ["Encomenda n.\xBA", encomenda],
    ["N.\xBA do cliente", l.cliente_no],
    ["Vendedor", l.vendedor],
    ["SAC", sac],
    ["Tipo", tipo],
    up.difere ? ["\xDAltima prometida", /* @__PURE__ */ React.createElement("span", { className: "tk-ultima-difere", title: up.titulo }, up.texto, /* @__PURE__ */ React.createElement("span", { className: "tk-secundaria" }, up.titulo))] : null,
    l.fora_do_otif ? ["Fora do OTIF", A.FORA[l.fora_do_otif] || l.fora_do_otif] : null
  ] })), /* @__PURE__ */ React.createElement(TkGrupo, { titulo: "Artigo" }, /* @__PURE__ */ React.createElement(TkKv, { pares: [
    ["Fluxo", A.FLUXOS[l.fluxo] || l.fluxo],
    ["Segmento", l.segmento],
    ["Gest\xE3o", gestao]
  ] })), /* @__PURE__ */ React.createElement(TkGrupo, { titulo: "Quantidades" }, /* @__PURE__ */ React.createElement("div", { className: "tk-trio tk-trio--linhas" }, [["Encomendada", q.encomendada], ["Entregue", q.entregue], ["Em falta", q.em_falta]].map(([k, n]) => /* @__PURE__ */ React.createElement("div", { key: k, className: "tk-trio-celula" }, /* @__PURE__ */ React.createElement("span", { className: "tk-trio-k" }, k), /* @__PURE__ */ React.createElement("span", { className: "tk-trio-v tk-num" }, tkNum(n))))), l.a_menos && /* @__PURE__ */ React.createElement("div", { className: "tk-aviso tk-aviso-curto" }, "Entregue a menos: ", tkNum(l.a_menos.unidades), " un. (linha fechada)")), /* @__PURE__ */ React.createElement(TkGrupo, { titulo: "Valida\xE7\xE3o" }, v ? /* @__PURE__ */ React.createElement(TkKv, { pares: [
    ["Validada em", v.validado_em ? A.fmtHora(v.validado_em) : null],
    ["F\xE1brica", v.fabrica],
    ["Solicitada", v.dtsoli ? A.fmt(v.dtsoli) : null],
    ["M\xEDnima", v.dtmin ? A.fmt(v.dtmin) : null],
    ["Entrega", v.dtentr ? A.fmt(v.dtentr) : null],
    ["Lead time", v.leadtime != null ? `${v.leadtime} d` : null]
  ] }) : /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem registo de valida\xE7\xE3o (u_encphist).")), /* @__PURE__ */ React.createElement(TkGrupo, { titulo: "Stock" }, !s && /* @__PURE__ */ React.createElement("div", { className: "muted" }, l.stock_erro ? "Stock indispon\xEDvel (PHC)." : "Linha n\xE3o encontrada no PHC."), s && !temStock && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem stock em armaz\xE9m."), temStock && /* @__PURE__ */ React.createElement("div", { role: "table", "aria-label": "Stock por armaz\xE9m", className: "tk-grelha tk-grelha--stock" }, /* @__PURE__ */ React.createElement("div", { role: "row", className: "tk-grelha-cabeca" }, /* @__PURE__ */ React.createElement("span", { role: "columnheader" }, "Armaz\xE9m"), /* @__PURE__ */ React.createElement("span", { role: "columnheader" }, "Quantidade")), s.armazens.map((a) => /* @__PURE__ */ React.createElement("div", { role: "row", key: a.armazem }, /* @__PURE__ */ React.createElement("span", { role: "cell" }, a.armazem), /* @__PURE__ */ React.createElement("span", { role: "cell" }, tkNum(a.stock)))), /* @__PURE__ */ React.createElement("div", { role: "row", className: "is-total" }, /* @__PURE__ */ React.createElement("span", { role: "cell" }, "Total"), /* @__PURE__ */ React.createElement("span", { role: "cell" }, tkNum(s.total))))), camposPhc.length > 0 && /* @__PURE__ */ React.createElement(TkGrupo, { titulo: "Na linha do PHC" }, /* @__PURE__ */ React.createElement(TkKv, { pares: camposPhc.map((c) => [c.rotulo, /* @__PURE__ */ React.createElement("span", { title: c.origem }, c.valor)]) })), s && s.obs && /* @__PURE__ */ React.createElement(TkGrupo, { titulo: "Observa\xE7\xF5es da linha" }, /* @__PURE__ */ React.createElement("div", { className: "tk-obs" }, s.obs))), l.primeira_enc && /* @__PURE__ */ React.createElement("div", { className: "tk-primeira" }, /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha" }, "1.\xAA encomenda desta refer\xEAncia"), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn sm ghost",
      onClick: () => window.HubRouter.navigate({ routeId: "primustrack", entidade: l.ref })
    },
    "Abrir caso na Primustrack"
  )));
}
function TkResponsavel({ l, users, me, onChange }) {
  const elegiveis = window.HubAtribuicoes ? window.HubAtribuicoes.eligibleUsers(users, "trakker") : users;
  const atual = l.responsavel ? String(l.responsavel.id) : "";
  const [valor, setValor] = React.useState(atual);
  React.useEffect(() => {
    setValor(atual);
  }, [l.bistamp, atual]);
  const mudar = (v) => {
    const antes = valor;
    setValor(v);
    onChange(v ? Number(v) : null).catch((e) => {
      setValor(antes);
      window.srToast("Respons\xE1vel", "error", e.status === 403 ? "Sem permiss\xE3o para atribuir." : e.detail || "N\xE3o foi gravado.");
    });
  };
  return /* @__PURE__ */ React.createElement("label", { className: "tk-responsavel" }, /* @__PURE__ */ React.createElement("span", { className: "section-label" }, "Respons\xE1vel"), /* @__PURE__ */ React.createElement("select", { className: "input sm", value: valor, onChange: (e) => mudar(e.target.value), disabled: !me }, /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 sem respons\xE1vel \u2014"), elegiveis.map((u) => /* @__PURE__ */ React.createElement("option", { key: u.id, value: u.id }, u.full_name || u.username))));
}
function TkAnexoLinha({ bistamp, a, onVer }) {
  const nome = `${a.fname || "anexo"}${a.fext ? "." + a.fext : ""}`;
  const tipo = tkAnexoTipo(a);
  if (tipo === "link") return /* @__PURE__ */ React.createElement("a", { className: "tk-anexo", href: a.url, target: "_blank", rel: "noopener noreferrer" }, "\u2197 ", nome);
  if (tipo === "pdf" || tipo === "img") {
    return /* @__PURE__ */ React.createElement("a", { className: "tk-anexo", href: window.TrakkerAPI.anexoPhcUrl(bistamp, a.anexosstamp, true), onClick: (ev) => {
      ev.preventDefault();
      onVer(a);
    } }, "\u{1F441} ", nome);
  }
  return /* @__PURE__ */ React.createElement("a", { className: "tk-anexo", href: window.TrakkerAPI.anexoPhcUrl(bistamp, a.anexosstamp), target: "_blank", rel: "noopener noreferrer" }, "\u2B07 ", nome);
}
function TkAnexosPhc({ bistamp, anexos, onVer }) {
  if (anexos === null) return /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar anexos\u2026");
  const grupo = (titulo, lista) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, titulo), (lista || []).length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "muted" }, "Sem anexos.") : lista.map((a) => /* @__PURE__ */ React.createElement(TkAnexoLinha, { key: a.anexosstamp, bistamp, a, onVer })));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, anexos.erro && /* @__PURE__ */ React.createElement("div", { className: "tk-aviso" }, "N\xE3o foi poss\xEDvel ler os anexos do PHC."), grupo("Encomenda", anexos.encomenda), grupo("Artigo", anexos.artigo));
}
function TrakkerDrawer({ bistamp, vizinhos = [], onNavigate, onClose, reportCrumb }) {
  const A = window.TrakkerAPI;
  const [l, setL] = React.useState(null);
  const [erro, setErro] = React.useState(null);
  const [notas, setNotas] = React.useState([]);
  const [followers, setFollowers] = React.useState([]);
  const [logs, setLogs] = React.useState([]);
  const [acoes, setAcoes] = React.useState([]);
  const [anexos, setAnexos] = React.useState(null);
  const [anexoAberto, setAnexoAberto] = React.useState(null);
  const me = window.SR_ME || null;
  const users = window.SR_USERS || [];
  const resParams = { app_label: "trakker", resource: "linha", resource_id: bistamp };
  const pedir = React.useRef(null);
  if (!pedir.current) pedir.current = A.pedidoUnico();
  const [aCarregar, setACarregar] = React.useState(false);
  const recarregar = React.useCallback(() => {
    setACarregar(true);
    return pedir.current(window.TrakkerAPI.linha(bistamp), {
      ok: (d) => {
        setL(d);
        setErro(null);
      },
      falha: (e) => setErro(e && e.status === 404 ? { motivo: "Linha desconhecida.", tentar: false } : { motivo: A.motivoErro(e), tentar: true }),
      fim: () => setACarregar(false)
    });
  }, [bistamp]);
  const refreshNotas = React.useCallback(() => {
    window.API.notes(resParams).then((r) => setNotas(r.results || r || [])).catch(() => setNotas([]));
  }, [bistamp]);
  const refreshFollowers = React.useCallback(() => {
    window.API.followers(resParams).then((r) => setFollowers(r.results || r || [])).catch(() => setFollowers([]));
  }, [bistamp]);
  const refreshLogs = React.useCallback(() => {
    window.TrakkerAPI.audit(bistamp).then((rows) => setLogs((rows || []).map((a) => ({
      id: a.id,
      evento: a.verb,
      descricao: a.summary,
      actor_username: a.actor_name,
      criado_em: a.when
    })))).catch(() => setLogs([]));
  }, [bistamp]);
  const refreshAcoes = React.useCallback(() => {
    window.TrakkerAPI.acoes(bistamp).then((r) => setAcoes((r.results || r || []).map((a) => ({
      id: a.id,
      source: "acao",
      tipo: a.tipo?.id_slug,
      tipoNome: a.tipo?.nome || a.tipo?.id_slug,
      autor: a.autor_username,
      atribuido: a.atribuido_username || null,
      criadoEm: a.criado_em ? new Date(a.criado_em) : null,
      descricao: a.descricao,
      tratada: !!a.tratada_em,
      tratadaEm: a.tratada_em ? new Date(a.tratada_em) : null,
      tratadaPor: a.tratada_por_username || null,
      prazo: a.data_limite || null
    })))).catch(() => setAcoes([]));
  }, [bistamp]);
  React.useEffect(() => {
    if (!bistamp) return void 0;
    let vivo = true;
    setL(null);
    setErro(null);
    setAnexos(null);
    setAnexoAberto(null);
    recarregar();
    A.anexosPhc(bistamp).then((r) => vivo && setAnexos({ encomenda: r.encomenda || [], artigo: r.artigo || [], erro: !!r.erro })).catch(() => vivo && setAnexos({ encomenda: [], artigo: [], erro: true }));
    refreshNotas();
    refreshFollowers();
    refreshLogs();
    refreshAcoes();
    return () => {
      vivo = false;
    };
  }, [bistamp]);
  React.useEffect(() => {
    if (!reportCrumb) return void 0;
    reportCrumb(l ? `${l.cliente} \xB7 Enc. ${l.obrano || l.nenc || "\u2014"} \xB7 ${l.ref}` : null);
    return () => reportCrumb(null);
  }, [l, reportCrumb]);
  const erroToast = (titulo) => (e) => {
    window.srToast(titulo, "error", e && e.status === 403 ? "Sem permiss\xE3o." : e && e.detail || "N\xE3o foi gravado.");
    throw e;
  };
  const notasApi = {
    onAdd: (descricao) => window.API.createNote({ ...resParams, descricao }).then(() => {
      refreshNotas();
      refreshLogs();
    }),
    onUpdate: (id, descricao) => window.API.updateNote(id, { descricao }).then(refreshNotas),
    onDelete: (id) => window.API.deleteNote(id).then(refreshNotas)
  };
  const depois = () => {
    refreshAcoes();
    refreshLogs();
  };
  const acoesApi = {
    onAdd: (tipo, descricao, atribuidoId, prazo) => A.addAcao(bistamp, { tipo_id_slug: tipo, descricao, atribuido_id: atribuidoId, data_limite: prazo }).then(depois, erroToast("A\xE7\xE3o")),
    onDelete: (a) => A.delAcao(bistamp, a.id).then(depois, erroToast("A\xE7\xE3o")),
    onToggleTratada: (a) => A.tratar(bistamp, a.id).then(depois, erroToast("A\xE7\xE3o")),
    onSetPrazo: (a, iso) => A.prazo(bistamp, a.id, iso).then(depois, erroToast("Prazo"))
  };
  const seguidores = {
    items: followers,
    me,
    canManage: !!(me && me.is_staff),
    users,
    onFollow: () => window.API.follow(resParams).then(refreshFollowers),
    onUnfollow: (id) => window.API.unfollow(id).then(refreshFollowers),
    onAddOther: (uid) => window.API.follow({ ...resParams, user_id: uid }).then(refreshFollowers)
  };
  const side = /* @__PURE__ */ React.createElement("aside", { className: "tk-lateral" }, l && /* @__PURE__ */ React.createElement(
    TkResponsavel,
    {
      l,
      users,
      me,
      onChange: (id) => A.responsavel(bistamp, id).then(() => {
        recarregar();
        refreshLogs();
      })
    }
  ), /* @__PURE__ */ React.createElement(
    window.HubActionTimeline,
    {
      streams: { acoes: { items: acoes, api: acoesApi }, notas: { items: notas, api: notasApi }, logs: { items: logs } },
      seguidores,
      users,
      me,
      assignable: true,
      appLabel: "trakker",
      appSlug: "trakker",
      resource: "linha",
      resourceId: bistamp,
      defaultTab: "acoes",
      title: "Atividade",
      extraTabs: [{
        key: "anexos_phc",
        label: "Anexos PHC",
        count: anexos ? anexos.encomenda.length + anexos.artigo.length : null,
        render: () => /* @__PURE__ */ React.createElement(TkAnexosPhc, { bistamp, anexos, onVer: setAnexoAberto })
      }]
    }
  ));
  return /* @__PURE__ */ React.createElement(
    window.DrawerShell,
    {
      title: l ? `${l.ref} \u2014 ${l.design}` : "Linha",
      subtitle: l ? /* @__PURE__ */ React.createElement(TkSubtitulo, { l }) : "",
      onClose,
      navList: vizinhos,
      onNavigate,
      currentId: bistamp,
      side,
      largura: anexoAberto ? "min(1500px, 96vw)" : void 0
    },
    erro && /* @__PURE__ */ React.createElement(
      window.TkFalhaCarga,
      {
        titulo: l ? "N\xE3o foi poss\xEDvel atualizar a linha." : "N\xE3o foi poss\xEDvel carregar a linha.",
        motivo: erro.motivo,
        onTentar: erro.tentar ? recarregar : null,
        aTentar: aCarregar
      }
    ),
    !l && !erro && /* @__PURE__ */ React.createElement("div", { className: "muted" }, "A carregar\u2026"),
    l && /* @__PURE__ */ React.createElement("div", { className: `tk-ficha${anexoAberto ? " com-anexo" : ""}` }, /* @__PURE__ */ React.createElement("div", { className: "tk-ficha-main" }, /* @__PURE__ */ React.createElement("section", { className: "tk-datas" }, /* @__PURE__ */ React.createElement(TkDatas, { l })), /* @__PURE__ */ React.createElement("section", { className: "tk-percurso" }, /* @__PURE__ */ React.createElement(TkPercurso, { l })), /* @__PURE__ */ React.createElement("section", { className: "tk-contexto" }, /* @__PURE__ */ React.createElement(TkContexto, { l }))), anexoAberto && /* @__PURE__ */ React.createElement("div", { className: "tk-visualizador" }, /* @__PURE__ */ React.createElement("div", { className: "tk-visualizador-topo" }, /* @__PURE__ */ React.createElement("span", null, anexoAberto.fname, anexoAberto.fext ? `.${anexoAberto.fext}` : ""), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setAnexoAberto(null) }, "\u2715 fechar documento")), tkAnexoTipo(anexoAberto) === "pdf" ? /* @__PURE__ */ React.createElement("iframe", { title: "Anexo", src: A.anexoPhcUrl(bistamp, anexoAberto.anexosstamp, true) }) : /* @__PURE__ */ React.createElement("img", { alt: "Anexo", src: A.anexoPhcUrl(bistamp, anexoAberto.anexosstamp, true) })))
  );
}
window.TrakkerDrawer = TrakkerDrawer;

// ===== trakker/frontend/trakker.jsx =====
const TK_ABAS = [["fila", "Fila de trabalho"], ["lista", "Lista completa"]];
function TrakkerView({ routeId = "trakker", entidade, params, navigate, reportCrumb } = {}) {
  const nav = navigate || ((to) => window.HubRouter.navigate(to));
  const abaUrl = params && typeof params.get === "function" ? params.get("aba") : null;
  const aba = TK_ABAS.some(([id]) => id === abaUrl) ? abaUrl : "fila";
  const [rows, setRows] = React.useState([]);
  const irAba = (id) => window.HubRouter.setParams({ aba: id === "fila" ? null : id }, { replace: false });
  const fechar = () => nav({ routeId, params: window.HubRouter.current().params });
  const abrir = (b) => nav({ routeId, entidade: b, params: window.HubRouter.current().params });
  return /* @__PURE__ */ React.createElement("div", { className: "tk-view" }, /* @__PURE__ */ React.createElement("div", { className: "tk-abas", role: "tablist" }, TK_ABAS.map(([id, label]) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: id,
      type: "button",
      role: "tab",
      "aria-selected": aba === id,
      className: aba === id ? "is-ativa" : "",
      onClick: () => irAba(id)
    },
    label
  ))), /* @__PURE__ */ React.createElement(window.TrakkerFila, { aba, params, navigate: nav, routeId, aberta: entidade, onRows: setRows }), entidade && /* @__PURE__ */ React.createElement(
    window.TrakkerDrawer,
    {
      bistamp: entidade,
      vizinhos: rows.map((r) => ({ id: r.bistamp, label: `${r.ref} \xB7 ${r.cliente}` })),
      onNavigate: (a) => abrir(a.id),
      onClose: fechar,
      reportCrumb
    }
  ));
}
window.TrakkerView = TrakkerView;

// ===== trakker/frontend/trakker_arvore.jsx =====
let tkArvChave = 0;
const tkComChave = (r) => ({ ...r, _k: r._k || `k${++tkArvChave}` });
const tkSemChave = (ramos) => ramos.map(({ _k, ...r }) => r);
const tkValKey = (v) => JSON.stringify(v);
const TK_ROTULO_VALOR = {
  com_stock: { true: "Sim", false: "N\xE3o", null: "Desconhecido" },
  gestao: { '"encomenda"': "Por encomenda", '"stock"': "Stock" }
};
function tkRotuloValor(campo, v) {
  const r = TK_ROTULO_VALOR[campo];
  if (r && r[tkValKey(v)]) return r[tkValKey(v)];
  if (campo === "fluxo") return window.TrakkerAPI.FLUXOS[v] || v;
  return String(v);
}
function tkMover(ramos, de, para) {
  const lista = [...ramos];
  if (lista[de].resto) return lista;
  const [r] = lista.splice(de, 1);
  const ultimo = lista.findIndex((x) => x.resto);
  const alvo = Math.max(0, Math.min(para, ultimo < 0 ? lista.length : ultimo));
  lista.splice(alvo, 0, r);
  return lista;
}
function TkCondicoes({ ramo, catalogo, onChange }) {
  const cond = ramo.condicoes || {};
  const alternar = (campo, v) => {
    const atual = cond[campo] || [];
    const tem = atual.some((x) => tkValKey(x) === tkValKey(v));
    const novo = tem ? atual.filter((x) => tkValKey(x) !== tkValKey(v)) : [...atual, v];
    const c = { ...cond };
    if (novo.length) c[campo] = novo;
    else delete c[campo];
    onChange(c);
  };
  if (ramo.resto) return /* @__PURE__ */ React.createElement("p", { className: "muted" }, "O \xABResto\xBB apanha todas as linhas que n\xE3o ca\xEDram num ramo acima. N\xE3o tem condi\xE7\xF5es.");
  return /* @__PURE__ */ React.createElement("div", { className: "tk-arv-cond" }, catalogo.campos.map((c) => {
    const escolhidos = cond[c.id] || [];
    const valores = [...c.valores];
    escolhidos.forEach((v) => {
      if (!valores.some((x) => tkValKey(x) === tkValKey(v))) valores.push(v);
    });
    return /* @__PURE__ */ React.createElement("div", { key: c.id, className: "tk-arv-campo" }, /* @__PURE__ */ React.createElement("span", { className: "tk-arv-campo-nome" }, c.rotulo, escolhidos.length ? "" : /* @__PURE__ */ React.createElement("span", { className: "muted" }, " \xB7 qualquer")), /* @__PURE__ */ React.createElement("span", { className: "tk-arv-chips" }, valores.map((v) => {
      const on = escolhidos.some((x) => tkValKey(x) === tkValKey(v));
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: tkValKey(v),
          type: "button",
          "aria-pressed": on,
          className: `tk-chip${on ? " is-on" : ""}`,
          onClick: () => alternar(c.id, v)
        },
        tkRotuloValor(c.id, v)
      );
    }), c.livre && /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "input sm tk-arv-livre",
        placeholder: "+ valor",
        "aria-label": `Acrescentar valor a ${c.rotulo}`,
        onKeyDown: (e) => {
          const t = c.id === "prefixo_ref" ? e.target.value.trim().toUpperCase() : e.target.value.trim();
          if (e.key === "Enter" && t) {
            alternar(c.id, t);
            e.target.value = "";
          }
        }
      }
    )));
  }));
}
function TkFator({ f, direcao, catalogo, onChange, onRemover }) {
  const num = (k) => /* @__PURE__ */ React.createElement("label", { className: "tk-arv-param" }, k.replace(/_/g, " "), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input sm",
      type: "number",
      min: "0",
      value: f[k],
      "aria-label": k,
      onChange: (e) => onChange({ ...f, [k]: Math.max(0, parseInt(e.target.value, 10) || 0) })
    }
  ));
  const trocar = (tipo) => {
    const def = catalogo.fatores.find((x) => x.tipo === tipo);
    onChange({ tipo, ...def ? def.omissao : {} });
  };
  return /* @__PURE__ */ React.createElement("div", { className: "tk-arv-fator" }, /* @__PURE__ */ React.createElement("span", { className: "tk-arv-legivel" }, window.TrakkerAPI.fatorLegivel(f, direcao)), /* @__PURE__ */ React.createElement("select", { className: "input sm", value: f.tipo, "aria-label": "Tipo de fator", onChange: (e) => trocar(e.target.value) }, catalogo.fatores.map((x) => /* @__PURE__ */ React.createElement("option", { key: x.tipo, value: x.tipo }, x.rotulo))), f.tipo === "dias_fixos" && num("n"), f.tipo === "lt_referencia" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { className: "tk-arv-param" }, "de", /* @__PURE__ */ React.createElement("select", { className: "input sm", value: f.de, "aria-label": "Lead time de", onChange: (e) => onChange({ ...f, de: e.target.value }) }, catalogo.lt_de.map((x) => /* @__PURE__ */ React.createElement("option", { key: x.id, value: x.id }, x.rotulo)))), num("sem_lt")), f.tipo === "maquinas_roteiro" && /* @__PURE__ */ React.createElement(React.Fragment, null, num("dias_por_maquina"), num("minimo")), f.tipo === "turno_seguinte" && /* @__PURE__ */ React.createElement("label", { className: "tk-arv-param" }, "corte", /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input sm",
      type: "time",
      value: f.corte,
      "aria-label": "Hora de corte",
      onChange: (e) => onChange({ ...f, corte: e.target.value })
    }
  )), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost icon-only sm", title: "Tirar o fator", "aria-label": "Tirar o fator", onClick: onRemover }, "\u2715"));
}
function TkEtapa({ e, i, n, catalogo, onChange, onMover, onRemover }) {
  const regra = e.regra || { direcao: "frente", fatores: [] };
  const setRegra = (r) => onChange({ ...e, regra: { ...regra, ...r } });
  const fatores = regra.fatores || [];
  const marco = (k, rot) => /* @__PURE__ */ React.createElement("label", { className: "tk-arv-param" }, rot, /* @__PURE__ */ React.createElement("select", { className: "input sm", value: e[k] || "", "aria-label": `${rot} de ${e.nome}`, onChange: (ev) => onChange({ ...e, [k]: ev.target.value }) }, catalogo.marcos.map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.rotulo))));
  return /* @__PURE__ */ React.createElement("li", { className: "tk-arv-etapa" }, /* @__PURE__ */ React.createElement("div", { className: "tk-arv-etapa-topo" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input sm tk-arv-nome",
      value: e.nome || "",
      "aria-label": "Nome da etapa",
      placeholder: "Nome da etapa",
      maxLength: catalogo.tamanhos.etapa,
      onChange: (ev) => onChange({ ...e, nome: ev.target.value })
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input sm",
      list: "tk-arv-responsaveis",
      value: e.responsavel || "",
      placeholder: "respons\xE1vel",
      maxLength: catalogo.tamanhos.responsavel,
      "aria-label": `Respons\xE1vel de ${e.nome}`,
      onChange: (ev) => onChange({ ...e, responsavel: ev.target.value })
    }
  ), /* @__PURE__ */ React.createElement("span", { className: "tk-arv-acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost icon-only sm", disabled: i === 0, "aria-label": "Subir a etapa", onClick: () => onMover(-1) }, "\u2191"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost icon-only sm", disabled: i === n - 1, "aria-label": "Descer a etapa", onClick: () => onMover(1) }, "\u2193"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost icon-only sm", "aria-label": "Apagar a etapa", title: "Apagar a etapa", onClick: onRemover }, "\u2715"))), /* @__PURE__ */ React.createElement("div", { className: "tk-arv-etapa-marcos" }, marco("marco_inicio", "de"), marco("marco_fim", "at\xE9"), /* @__PURE__ */ React.createElement("label", { className: "tk-arv-param" }, "conta", /* @__PURE__ */ React.createElement("select", { className: "input sm", value: regra.direcao, "aria-label": `Dire\xE7\xE3o de ${e.nome}`, onChange: (ev) => setRegra({ direcao: ev.target.value }) }, catalogo.direcoes.map((x) => /* @__PURE__ */ React.createElement("option", { key: x.id, value: x.id }, x.rotulo))))), /* @__PURE__ */ React.createElement("div", { className: "tk-arv-fatores" }, fatores.length === 0 && /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Sem fatores: a etapa dura 0 dias."), fatores.map((f, j) => /* @__PURE__ */ React.createElement(
    TkFator,
    {
      key: j,
      f,
      direcao: regra.direcao,
      catalogo,
      onChange: (nf) => setRegra({ fatores: fatores.map((x, k) => k === j ? nf : x) }),
      onRemover: () => setRegra({ fatores: fatores.filter((_, k) => k !== j) })
    }
  )), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setRegra({ fatores: [...fatores, { tipo: "dias_fixos", n: 1 }] }) }, "+ fator")));
}
function TkRamo({ ramo, catalogo, onChange }) {
  const etapas = ramo.etapas || [];
  const setEtapas = (es) => onChange({ ...ramo, etapas: es });
  const mover = (i, d) => {
    const es = [...etapas];
    [es[i], es[i + d]] = [es[i + d], es[i]];
    setEtapas(es);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "tk-arv-ramo" }, /* @__PURE__ */ React.createElement("div", { className: "tk-arv-ramo-topo" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input tk-arv-nome",
      value: ramo.nome || "",
      "aria-label": "Nome do ramo",
      disabled: ramo.resto,
      maxLength: catalogo.tamanhos.ramo,
      onChange: (e) => onChange({ ...ramo, nome: e.target.value })
    }
  ), !ramo.resto && /* @__PURE__ */ React.createElement("label", { className: "tk-arv-param" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: ramo.ativo !== false,
      onChange: (e) => onChange({ ...ramo, ativo: e.target.checked })
    }
  ), " ativo")), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Condi\xE7\xF5es (todas t\xEAm de casar)"), /* @__PURE__ */ React.createElement(TkCondicoes, { ramo, catalogo, onChange: (c) => onChange({ ...ramo, condicoes: c }) }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Etapas"), /* @__PURE__ */ React.createElement("ol", { className: "tk-arv-etapas" }, etapas.map((e, i) => /* @__PURE__ */ React.createElement(
    TkEtapa,
    {
      key: i,
      e,
      i,
      n: etapas.length,
      catalogo,
      onChange: (ne) => setEtapas(etapas.map((x, k) => k === i ? ne : x)),
      onMover: (d) => mover(i, d),
      onRemover: () => setEtapas(etapas.filter((_, k) => k !== i))
    }
  ))), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: () => setEtapas([...etapas, {
    nome: "Nova etapa",
    marco_inicio: "validacao",
    marco_fim: "entrega",
    responsavel: "",
    regra: { direcao: "frente", fatores: [{ tipo: "dias_fixos", n: 1 }] }
  }]) }, "+ etapa"), /* @__PURE__ */ React.createElement("datalist", { id: "tk-arv-responsaveis" }, catalogo.responsaveis.map((r) => /* @__PURE__ */ React.createElement("option", { key: r, value: r }))));
}
function TkSimulador({ ramos, porGravar, inicial }) {
  const A = window.TrakkerAPI;
  const [fila, setFila] = React.useState([]);
  const [bistamp, setBistamp] = React.useState(inicial || "");
  const [colado, setColado] = React.useState("");
  const [res, setRes] = React.useState(null);
  const [erro, setErro] = React.useState(null);
  const [aCalcular, setACalcular] = React.useState(false);
  React.useEffect(() => {
    A.linhas({ aba: "fila" }).then((d) => setFila(d.rows || [])).catch(() => setFila([]));
  }, []);
  React.useEffect(() => {
    if (!bistamp) return void 0;
    let vivo = true;
    const t = setTimeout(() => {
      setACalcular(true);
      A.simular(bistamp, porGravar ? tkSemChave(ramos) : null).then((r2) => {
        if (vivo) {
          setRes(r2);
          setErro(null);
        }
      }).catch((e) => {
        if (!vivo) return;
        const msgs = (e && (e.erros || [e.detail]) || []).filter(Boolean);
        setErro(e && e.erro === "erp_indisponivel" ? "ERP indispon\xEDvel." : msgs.join(" \xB7 ") || "N\xE3o foi poss\xEDvel simular.");
      }).finally(() => {
        if (vivo) setACalcular(false);
      });
    }, 350);
    return () => {
      vivo = false;
      clearTimeout(t);
    };
  }, [bistamp, ramos, porGravar]);
  const r = res && res.resultado;
  const l = res && res.linha;
  return /* @__PURE__ */ React.createElement("aside", { className: "tk-arv-sim", "aria-label": "Simulador" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Simulador ", porGravar && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha is-risco" }, "com a \xE1rvore por gravar")), /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "input sm",
      value: fila.some((x) => x.bistamp === bistamp) ? bistamp : "",
      "aria-label": "Linha da fila",
      onChange: (e) => setBistamp(e.target.value)
    },
    /* @__PURE__ */ React.createElement("option", { value: "" }, "\u2014 uma linha da fila (", fila.length, ") \u2014"),
    fila.slice(0, 500).map((x) => /* @__PURE__ */ React.createElement("option", { key: x.bistamp, value: x.bistamp }, `${x.obrano || x.nenc || ""} \xB7 ${x.ref} \xB7 ${x.cliente}`))
  ), /* @__PURE__ */ React.createElement("div", { className: "tk-arv-colar" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "input sm",
      value: colado,
      placeholder: "ou cole um bistamp",
      "aria-label": "bistamp",
      onChange: (e) => setColado(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter" && colado.trim()) setBistamp(colado.trim());
      }
    }
  ), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn sm", disabled: !colado.trim(), onClick: () => setBistamp(colado.trim()) }, "Simular")), aCalcular && /* @__PURE__ */ React.createElement("p", { className: "muted" }, "A calcular\u2026"), erro && /* @__PURE__ */ React.createElement("p", { className: "tk-aviso", role: "alert" }, erro), res && !erro && /* @__PURE__ */ React.createElement("div", { className: "tk-arv-sim-res" }, /* @__PURE__ */ React.createElement("dl", { className: "kv-grid" }, /* @__PURE__ */ React.createElement("dt", { className: "k" }, "Linha"), /* @__PURE__ */ React.createElement("dd", null, `${l.obrano || l.nenc || ""} \xB7 ${l.ref} \xB7 ${l.cliente || ""}`), /* @__PURE__ */ React.createElement("dt", { className: "k" }, "Campos"), /* @__PURE__ */ React.createElement("dd", null, [
    l.tipo_atual,
    A.FLUXOS[l.fluxo] || l.fluxo,
    l.gestao && `gest\xE3o ${l.gestao}`,
    `stock \xE0 valida\xE7\xE3o: ${tkRotuloValor("com_stock", l.com_stock)}`,
    l.fabrica,
    l.segmento,
    l.prefixo_ref && `prefixo ${l.prefixo_ref}`
  ].filter(Boolean).join(" \xB7 ")), /* @__PURE__ */ React.createElement("dt", { className: "k" }, "Fatores"), /* @__PURE__ */ React.createElement("dd", null, `LT ref ${l.lt_ref ?? "\u2014"} \xB7 LT refmp ${l.refmp ? l.lt_refmp ?? "\u2014" : "sem refmp"} \xB7 m\xE1quinas ${l.maquinas ?? "\u2014"}`), /* @__PURE__ */ React.createElement("dt", { className: "k" }, "Prometida"), /* @__PURE__ */ React.createElement("dd", null, A.fmt(l.prometida)), /* @__PURE__ */ React.createElement("dt", { className: "k" }, "Ramo"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("strong", null, r.ramo ? r.ramo.nome : `fora (${r.fora})`)), /* @__PURE__ */ React.createElement("dt", { className: "k" }, "Estado"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("span", { className: `tk-estado ${A.rotuloEstado(r.estado).classe}` }, A.rotuloEstado(r.estado).texto), r.prazo_curto && /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha is-atrasada", title: "Da valida\xE7\xE3o, as etapas n\xE3o cabiam at\xE9 \xE0 prometida" }, "prazo curto")), /* @__PURE__ */ React.createElement("dt", { className: "k" }, "Onde est\xE1"), /* @__PURE__ */ React.createElement("dd", null, r.etapa_atual || "\u2014", r.etapa_perdida ? ` \xB7 perdida em ${r.etapa_perdida}` : "")), res.aviso && /* @__PURE__ */ React.createElement("p", { className: "tk-aviso" }, res.aviso, " \u2014 os fatores do PHC contam como desconhecidos."), /* @__PURE__ */ React.createElement("ol", { className: "tk-arv-conta" }, r.etapas.map((e) => {
    const est = A.ESTADOS_ETAPA[e.estado] || { texto: e.estado, classe: "is-neutro" };
    return /* @__PURE__ */ React.createElement("li", { key: e.ordem }, /* @__PURE__ */ React.createElement("div", { className: "tk-arv-conta-topo" }, /* @__PURE__ */ React.createElement("strong", null, e.nome), /* @__PURE__ */ React.createElement("span", null, "limite ", A.fmt(e.limite), e.real ? ` \xB7 real ${A.fmt(e.real)}` : ""), /* @__PURE__ */ React.createElement("span", { className: `tk-estado ${est.classe}` }, est.texto, e.excesso_dias_uteis > 0 ? ` +${e.excesso_dias_uteis} d` : "")), /* @__PURE__ */ React.createElement("ul", { className: "tk-arv-passos" }, e.passos.map((p, k) => /* @__PURE__ */ React.createElement("li", { key: k }, p))));
  }))));
}
function TkFeriados() {
  const A = window.TrakkerAPI;
  const [lista, setLista] = React.useState([]);
  const [data, setData] = React.useState("");
  const [nome, setNome] = React.useState("");
  const carregar = () => A.feriados().then(setLista).catch(() => setLista([]));
  React.useEffect(() => {
    carregar();
  }, []);
  const falhou = (e) => window.srToast("Feriados", "error", e && e.status === 403 ? "Sem permiss\xE3o." : e && e.detail || "N\xE3o foi gravado.");
  const futuros = lista.filter((f) => f.data >= (/* @__PURE__ */ new Date()).toISOString().slice(0, 10));
  return /* @__PURE__ */ React.createElement("details", { className: "tk-arv-feriados" }, /* @__PURE__ */ React.createElement("summary", null, "Feriados (", futuros.length, " por vir)"), /* @__PURE__ */ React.createElement("ul", null, futuros.map((f) => /* @__PURE__ */ React.createElement("li", { key: f.id }, A.fmt(f.data), "/", f.data.slice(0, 4), " ", f.nome, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn ghost icon-only sm",
      "aria-label": `Tirar o feriado ${f.data}`,
      onClick: () => A.delFeriado(f.id).then(carregar).catch(falhou)
    },
    "\u2715"
  )))), /* @__PURE__ */ React.createElement("div", { className: "tk-arv-colar" }, /* @__PURE__ */ React.createElement("input", { className: "input sm", type: "date", value: data, "aria-label": "Data do feriado", onChange: (e) => setData(e.target.value) }), /* @__PURE__ */ React.createElement("input", { className: "input sm", value: nome, placeholder: "nome", "aria-label": "Nome do feriado", onChange: (e) => setNome(e.target.value) }), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn sm",
      disabled: !data,
      onClick: () => A.addFeriado(data, nome).then(() => {
        setData("");
        setNome("");
        carregar();
      }).catch(falhou)
    },
    "Acrescentar"
  )));
}
function TrakkerArvoreView({ entidade } = {}) {
  const A = window.TrakkerAPI;
  const [ramos, setRamos] = React.useState(null);
  const [gravados, setGravados] = React.useState("");
  const [catalogo, setCatalogo] = React.useState(null);
  const [sel, setSel] = React.useState(0);
  const [arrastado, setArrastado] = React.useState(null);
  const [erros, setErros] = React.useState([]);
  const [aGravar, setAGravar] = React.useState(false);
  const aplicar = (d) => {
    const rs = d.ramos.map(tkComChave);
    setRamos(rs);
    setGravados(JSON.stringify(tkSemChave(rs)));
  };
  React.useEffect(() => {
    A.arvore().then((d) => {
      setCatalogo(d.catalogo);
      aplicar(d);
    }).catch((e) => window.srToast("\xC1rvore de prazos", "error", e && e.detail || "N\xE3o foi poss\xEDvel carregar."));
  }, []);
  if (!ramos || !catalogo) return /* @__PURE__ */ React.createElement("div", { className: "tk-arv muted" }, "A carregar a \xE1rvore\u2026");
  const porGravar = JSON.stringify(tkSemChave(ramos)) !== gravados;
  const atual = ramos[Math.min(sel, ramos.length - 1)];
  const mudarRamo = (novo) => setRamos(ramos.map((r) => r._k === atual._k ? novo : r));
  const mover = (de, para) => {
    const lista = tkMover(ramos, de, para);
    setRamos(lista);
    setSel(lista.findIndex((r) => r._k === ramos[de]._k));
  };
  const novoRamo = () => {
    const r = tkComChave({ nome: "Novo ramo", condicoes: {}, ativo: true, resto: false, etapas: [] });
    const lista = tkMover([r, ...ramos], 0, ramos.length);
    setRamos(lista);
    setSel(lista.findIndex((x) => x._k === r._k));
  };
  const apagar = () => {
    if (atual.resto) return;
    setRamos(ramos.filter((r) => r._k !== atual._k));
    setSel(0);
  };
  const gravar = () => {
    setAGravar(true);
    A.gravarArvore(tkSemChave(ramos)).then((d) => {
      aplicar(d);
      setErros([]);
      window.srToast("\xC1rvore de prazos", "success", d.mudou.length ? `Gravada: ${d.mudou.join(", ")}` : "Sem mudan\xE7as.");
    }).catch((e) => {
      setErros(e && e.erros || []);
      window.srToast("\xC1rvore de prazos", "error", e && e.status === 403 ? "Sem permiss\xE3o para mudar a \xE1rvore." : e && e.detail || "N\xE3o foi gravada.");
    }).finally(() => setAGravar(false));
  };
  return /* @__PURE__ */ React.createElement("div", { className: "tk-arv" }, /* @__PURE__ */ React.createElement("div", { className: "tk-arv-barra" }, /* @__PURE__ */ React.createElement("span", null, porGravar ? /* @__PURE__ */ React.createElement("span", { className: "tk-pastilha is-risco" }, "altera\xE7\xF5es por gravar") : /* @__PURE__ */ React.createElement("span", { className: "muted" }, "Gravada.")), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: !porGravar || aGravar, onClick: () => {
    aplicar({ ramos: JSON.parse(gravados) });
    setErros([]);
  } }, "Repor"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn primary sm", disabled: !porGravar || aGravar, onClick: gravar }, aGravar ? "A gravar\u2026" : "Gravar a \xE1rvore")), erros.length > 0 && /* @__PURE__ */ React.createElement("ul", { className: "tk-aviso", role: "alert" }, erros.map((e) => /* @__PURE__ */ React.createElement("li", { key: e }, e))), /* @__PURE__ */ React.createElement("div", { className: "tk-arv-corpo" }, /* @__PURE__ */ React.createElement("nav", { className: "tk-arv-ramos", "aria-label": "Ramos" }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Ramos (a linha cai no primeiro que casa)"), /* @__PURE__ */ React.createElement("ol", null, ramos.map((r, i) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: r._k,
      draggable: !r.resto,
      className: `tk-arv-ramo-item${r._k === atual._k ? " is-sel" : ""}${r.ativo === false ? " is-inativo" : ""}${arrastado === i ? " is-arrastado" : ""}`,
      onDragStart: () => setArrastado(i),
      onDragEnd: () => setArrastado(null),
      onDragOver: (e) => e.preventDefault(),
      onDrop: (e) => {
        e.preventDefault();
        if (arrastado !== null) mover(arrastado, i);
        setArrastado(null);
      }
    },
    /* @__PURE__ */ React.createElement("span", { className: "tk-arv-pega", "aria-hidden": "true" }, r.resto ? "\u{1F512}" : "\u283F"),
    /* @__PURE__ */ React.createElement("button", { type: "button", className: "tk-arv-ramo-nome", onClick: () => setSel(i) }, r.nome || "(sem nome)"),
    !r.resto && /* @__PURE__ */ React.createElement("span", { className: "tk-arv-acoes" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost icon-only sm", disabled: i === 0, "aria-label": `Subir ${r.nome}`, onClick: () => mover(i, i - 1) }, "\u2191"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost icon-only sm", disabled: i >= ramos.length - 2, "aria-label": `Descer ${r.nome}`, onClick: () => mover(i, i + 1) }, "\u2193"))
  ))), /* @__PURE__ */ React.createElement("div", { className: "tk-arv-colar" }, /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", onClick: novoRamo }, "+ ramo"), /* @__PURE__ */ React.createElement("button", { type: "button", className: "btn ghost sm", disabled: atual.resto, title: atual.resto ? "O \xABResto\xBB n\xE3o se apaga" : "", onClick: apagar }, "Apagar o ramo")), /* @__PURE__ */ React.createElement(TkFeriados, null)), /* @__PURE__ */ React.createElement(TkRamo, { ramo: atual, catalogo, onChange: mudarRamo }), /* @__PURE__ */ React.createElement(TkSimulador, { ramos, porGravar, inicial: entidade })));
}
window.TrakkerArvoreView = TrakkerArvoreView;
window.TrakkerArvoreFns = { tkMover };

// ===== trakker/frontend/entry.jsx =====
window.TrakkerView = window.TrakkerView || (() => null);
window.TrakkerArvoreView = window.TrakkerArvoreView || (() => null);
window.TrakkerUtilizadoresatribuiveisView = window.TrakkerUtilizadoresatribuiveisView || (() => null);

// ===== trakker/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "trakker",
  order: 12,
  name: "TRAKKER",
  sub: "Tracking de encomendas de cliente",
  accent: "#1f6f8b",
  // O logo da Primustrack passou para o TRAKKER, que a vai substituir (decisão do João, 2026-10-27).
  brandLogo: "/static/assets/primustrack-logo.png?v=2",
  home: "trakker",
  launcher: true,
  frontendFiles: [
    "frontend/trakker-api.jsx",
    "frontend/trakker_fila.jsx",
    "frontend/trakker_tapete.jsx",
    "frontend/trakker_drawer.jsx",
    "frontend/trakker.jsx",
    "frontend/trakker_arvore.jsx",
    "frontend/entry.jsx"
  ],
  routes: [
    { id: "trakker", section: "Encomendas", icon: "dot", label: "Encomendas", adminOnly: false, title: "Encomendas", tooltip: "Encomendas" },
    { id: "trakker_arvore", section: "Defini\xE7\xF5es", icon: "dot", label: "\xC1rvore de prazos", adminOnly: true, title: "\xC1rvore de prazos", tooltip: "\xC1rvore de prazos" },
    { id: "trakker_utilizadores_atribuiveis", section: "Defini\xE7\xF5es", icon: "dot", label: "Utilizadores atribu\xEDveis", adminOnly: true, title: "Utilizadores atribu\xEDveis", tooltip: "Utilizadores atribu\xEDveis" }
  ],
  render: {
    trakker: (ctx) => React.createElement(window.TrakkerView, {
      routeId: ctx && ctx.view,
      entidade: ctx && ctx.entidade,
      params: ctx && ctx.params,
      navigate: ctx && ctx.navigate,
      reportCrumb: ctx && ctx.reportCrumb
    }),
    trakker_arvore: (ctx) => React.createElement(window.TrakkerArvoreView, { entidade: ctx && ctx.entidade }),
    trakker_utilizadores_atribuiveis: () => React.createElement(window.HubAssignableUsers, { appLabel: "trakker", appName: "TRAKKER" })
  }
});

// ===== valora/frontend/view.jsx =====
(function() {
  const { useState, useMemo, useRef, useEffect, useCallback } = React;
  const API = window.API;
  const BUILD_VERSION = "v2.5.0-260424";
  const LOGO_DATA_URI = "data:image/png;base64,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";
  const RAJA_LOGO_DATA_URI = "data:image/png;base64,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";
  const evalF = (expr, L, W, H, e, g) => {
    try {
      return new Function("L", "W", "H", "e", "g", "return Math.round(" + expr + ")")(L, W, H, e, g);
    } catch (err) {
      return 0;
    }
  };
  const evalPanels = (json, L, W, H, e, g) => {
    try {
      const arr = typeof json === "string" ? JSON.parse(json) : json;
      return arr.map((p) => ({ s: evalF(p.expr || p.s || "0", L, W, H, e, g), n: p.n || "" }));
    } catch (err) {
      return [{ s: 0, n: "?" }];
    }
  };
  const NON_BODY = /* @__PURE__ */ new Set(["Glue", "G", "Pat", "Flap", "Aba"]);
  const parsePrintZones = (rawJson, code, panelsL, panelsW) => {
    if (rawJson == null || rawJson === "") return [];
    let obj;
    try {
      obj = typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;
    } catch (e) {
      console.warn("print_zones parse error", e);
      return [];
    }
    const v = obj?.[String(code)];
    if (!v) return [];
    if (v === "*") {
      const out = [];
      panelsL.forEach((pl, li) => {
        if (NON_BODY.has(pl.n)) return;
        panelsW.forEach((pw, wi) => {
          if (NON_BODY.has(pw.n)) return;
          out.push({ l: li, w: wi });
        });
      });
      return out;
    }
    if (!Array.isArray(v)) return [];
    return v.filter((z) => Number.isInteger(z.l) && Number.isInteger(z.w) && z.l >= 0 && z.l < panelsL.length && z.w >= 0 && z.w < panelsW.length);
  };
  const D_FM = [
    { id: "200", name: "200 Semi-Americano", glue: 60, active: true, formula_sl: "L+W+L+W+g", formula_sw: "H+Math.round(W/2+e/2)", panels_l: '[{"expr":"g","n":"Glue"},{"expr":"W","n":"W"},{"expr":"L","n":"L"},{"expr":"W","n":"W"},{"expr":"L","n":"L"}]', panels_w: '[{"expr":"Math.round(W/2+e/2)","n":"Flap"},{"expr":"H","n":"H"}]', print_zones: '{"12":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"13":[{"l":2,"w":1}],"14":[{"l":1,"w":1},{"l":3,"w":1}],"16":[{"l":2,"w":1},{"l":4,"w":1}],"21":"*","22":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"23":[{"l":2,"w":1}],"24":[{"l":1,"w":1},{"l":3,"w":1}],"26":[{"l":2,"w":1},{"l":4,"w":1}]}' },
    { id: "201", name: "201 Americano (RSC)", glue: 60, active: true, formula_sl: "L+W+L+W+g", formula_sw: "H+W+e", panels_l: '[{"expr":"g","n":"Glue"},{"expr":"W","n":"W"},{"expr":"L","n":"L"},{"expr":"W","n":"W"},{"expr":"L","n":"L"}]', panels_w: '[{"expr":"Math.round(W/2+e/2)","n":"Flap"},{"expr":"H","n":"H"},{"expr":"Math.round(W/2+e/2)","n":"Flap"}]', print_zones: '{"12":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"13":[{"l":2,"w":1}],"14":[{"l":1,"w":1},{"l":3,"w":1}],"15":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"16":[{"l":2,"w":1},{"l":4,"w":1}],"21":"*","22":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"23":[{"l":2,"w":1}],"24":[{"l":1,"w":1},{"l":3,"w":1}],"25":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"26":[{"l":2,"w":1},{"l":4,"w":1}]}' },
    { id: "202", name: "202 Abas iguais", glue: 60, active: true, formula_sl: "L+W+L+W+g", formula_sw: "H+2*(W+H/2)", panels_l: '[{"expr":"g","n":"Glue"},{"expr":"W","n":"W"},{"expr":"L","n":"L"},{"expr":"W","n":"W"},{"expr":"L","n":"L"}]', panels_w: '[{"expr":"Math.round(W+H/2)","n":"Aba"},{"expr":"H","n":"H"},{"expr":"Math.round(W+H/2)","n":"Aba"}]', print_zones: '{"12":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"13":[{"l":2,"w":1}],"14":[{"l":1,"w":1},{"l":3,"w":1}],"15":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"16":[{"l":2,"w":1},{"l":4,"w":1}],"21":"*","22":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"23":[{"l":2,"w":1}],"24":[{"l":1,"w":1},{"l":3,"w":1}],"25":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"26":[{"l":2,"w":1},{"l":4,"w":1}]}' },
    { id: "203", name: "203 Abas a sobrepor", glue: 60, active: true, formula_sl: "L+W+L+W+g", formula_sw: "H+2*W", panels_l: '[{"expr":"g","n":"Glue"},{"expr":"W","n":"W"},{"expr":"L","n":"L"},{"expr":"W","n":"W"},{"expr":"L","n":"L"}]', panels_w: '[{"expr":"W","n":"Aba"},{"expr":"H","n":"H"},{"expr":"W","n":"Aba"}]', print_zones: '{"12":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"13":[{"l":2,"w":1}],"14":[{"l":1,"w":1},{"l":3,"w":1}],"15":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"16":[{"l":2,"w":1},{"l":4,"w":1}],"21":"*","22":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"23":[{"l":2,"w":1}],"24":[{"l":1,"w":1},{"l":3,"w":1}],"25":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"26":[{"l":2,"w":1},{"l":4,"w":1}]}' },
    { id: "204", name: "204 Abas por comp.", glue: 60, active: true, formula_sl: "L+W+L+W+g", formula_sw: "H+L+e", panels_l: '[{"expr":"g","n":"Glue"},{"expr":"W","n":"W"},{"expr":"L","n":"L"},{"expr":"W","n":"W"},{"expr":"L","n":"L"}]', panels_w: '[{"expr":"Math.round(L/2+e/2)","n":"Flap"},{"expr":"H","n":"H"},{"expr":"Math.round(L/2+e/2)","n":"Flap"}]', print_zones: '{"12":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"13":[{"l":2,"w":1}],"14":[{"l":1,"w":1},{"l":3,"w":1}],"15":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"16":[{"l":2,"w":1},{"l":4,"w":1}],"21":"*","22":[{"l":1,"w":0},{"l":2,"w":0},{"l":3,"w":0},{"l":4,"w":0}],"23":[{"l":2,"w":1}],"24":[{"l":1,"w":1},{"l":3,"w":1}],"25":[{"l":1,"w":2},{"l":2,"w":2},{"l":3,"w":2},{"l":4,"w":2}],"26":[{"l":2,"w":1},{"l":4,"w":1}]}' },
    { id: "401", name: "401 Fundo/Tampa", glue: 0, active: true, formula_sl: "L+H+H+Math.round(0.7*W)", formula_sw: "W+H+W+e", panels_l: '[{"expr":"L","n":"L"},{"expr":"H","n":"H"},{"expr":"H","n":"H"},{"expr":"Math.round(0.7*W)","n":".7W"}]', panels_w: '[{"expr":"W","n":"W"},{"expr":"H","n":"H"},{"expr":"W","n":"W"},{"expr":"e","n":"e"}]', print_zones: '{"21":"*"}' },
    { id: "402", name: "402 Telescopica", glue: 0, active: true, formula_sl: "Math.round(L/2+e/2)+H+L+H+Math.round(L/2+e/2)", formula_sw: "Math.round(W/2+e/2)+H+W+H+Math.round(W/2+e/2)", panels_l: '[{"expr":"Math.round(L/2+e/2)","n":"L/2"},{"expr":"H","n":"H"},{"expr":"L","n":"L"},{"expr":"H","n":"H"},{"expr":"Math.round(L/2+e/2)","n":"L/2"}]', panels_w: '[{"expr":"Math.round(W/2+e/2)","n":"W/2"},{"expr":"H","n":"H"},{"expr":"W","n":"W"},{"expr":"H","n":"H"},{"expr":"Math.round(W/2+e/2)","n":"W/2"}]', print_zones: '{"21":"*"}' },
    { id: "409", name: "409 Cx Planificada", glue: 0, active: true, formula_sl: "W+H+W+H+H", formula_sw: "L+2*H", panels_l: '[{"expr":"W","n":"W"},{"expr":"H","n":"H"},{"expr":"W","n":"W"},{"expr":"H","n":"H"},{"expr":"H","n":"H"}]', panels_w: '[{"expr":"H","n":"H"},{"expr":"L","n":"L"},{"expr":"H","n":"H"}]', print_zones: '{"21":"*"}' },
    { id: "427", name: "427 Mailer box", glue: 0, active: true, formula_sl: "H+W+H+(W+2*e)+(H-2*e)", formula_sw: "2*e+(H-e)+2*e+(H+e)+L+(H+e)+2*e+(H-e)+2*e", panels_l: '[{"expr":"H","n":"H"},{"expr":"W","n":"W"},{"expr":"H","n":"H"},{"expr":"W+2*e","n":"W+"},{"expr":"H-2*e","n":"H"}]', panels_w: '[{"expr":"2*e","n":"2e"},{"expr":"H-e","n":"H"},{"expr":"2*e","n":"2e"},{"expr":"H+e","n":"H+"},{"expr":"L","n":"L"},{"expr":"H+e","n":"H+"},{"expr":"2*e","n":"2e"},{"expr":"H-e","n":"H"},{"expr":"2*e","n":"2e"}]', print_zones: '{"21":"*"}' },
    { id: "422", name: "422 Tray", glue: 0, active: true, formula_sl: "2*e+(H-2*e)+2*e+H+L+H+2*e+(H-2*e)+2*e", formula_sw: "H+W+H", panels_l: '[{"expr":"2*e","n":"2e"},{"expr":"H-2*e","n":"H"},{"expr":"2*e","n":"2e"},{"expr":"H","n":"H"},{"expr":"L","n":"L"},{"expr":"H","n":"H"},{"expr":"2*e","n":"2e"},{"expr":"H-2*e","n":"H"},{"expr":"2*e","n":"2e"}]', panels_w: '[{"expr":"H","n":"H"},{"expr":"W","n":"W"},{"expr":"H","n":"H"}]', print_zones: '{"21":"*"}' },
    { id: "501", name: "501 Sleeve", glue: 40, active: true, formula_sl: "L+W+L+W+g", formula_sw: "H", panels_l: '[{"expr":"L","n":"L"},{"expr":"W","n":"W"},{"expr":"L","n":"L"},{"expr":"W","n":"W"},{"expr":"g","n":"G"}]', panels_w: '[{"expr":"H","n":"H"}]', print_zones: '{"13":[{"l":0,"w":0}],"14":[{"l":1,"w":0}],"16":[{"l":0,"w":0},{"l":2,"w":0}],"21":"*","23":[{"l":0,"w":0}],"24":[{"l":1,"w":0}],"26":[{"l":0,"w":0},{"l":2,"w":0}]}' },
    { id: "933", name: "933 Divisoria", glue: 0, active: true, formula_sl: "Math.max(L,W)", formula_sw: "H", panels_l: '[{"expr":"Math.max(L,W)","n":"L/W"}]', panels_w: '[{"expr":"H","n":"H"}]', print_zones: null }
  ];
  const T = { bg: "var(--bg)", white: "var(--panel)", dark: "var(--text)", pri: "var(--accent)", priD: "var(--accent-ink)", priDD: "var(--accent-ink)", acc: "var(--accent)", bdr: "var(--border)", bdr2: "var(--border)", t2: "var(--text-2)", t3: "var(--muted)", t4: "var(--muted-2)", ok: "#16a34a", warn: "#f59e0b", err: "#dc2626" };
  const EUR = (n) => new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(n || 0);
  const EUR4 = (n) => (n || 0).toFixed(4) + " EUR";
  const inS = { width: "100%", padding: "8px 11px", background: "var(--bg)", border: "1px solid " + T.bdr, borderRadius: "var(--radius)", color: T.dark, fontSize: 14, outline: "none", boxSizing: "border-box" };
  const lbS = { fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: T.t3, marginBottom: 4 };
  const btnSmS = { background: "none", border: "none", cursor: "pointer", fontSize: 12, fontWeight: 700, padding: "4px 8px" };
  const btnS = (type) => ({ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 16px", borderRadius: "var(--radius)", border: "1px solid " + (type === "pri" ? T.pri : T.bdr), background: type === "pri" ? T.pri : "var(--panel)", color: type === "pri" ? "#fff" : T.dark, fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" });
  const cardSt = { background: T.white, border: "1px solid " + T.bdr, borderRadius: "var(--radius-lg)", marginBottom: 14, overflow: "hidden" };
  const cardHd = { padding: "12px 16px", borderBottom: "1px solid " + T.bdr2, background: "var(--panel-2)", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 };
  const cardBd = { padding: "14px 16px" };
  const Badge = ({ text, color }) => {
    const bg = color === "ok" ? "rgba(22,163,74,0.15)" : color === "pri" ? "var(--accent-soft)" : "rgba(245,158,11,0.15)";
    const fg = color === "ok" ? T.ok : color === "pri" ? T.acc : T.warn;
    return /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, padding: "3px 10px", borderRadius: 2, fontWeight: 700, letterSpacing: "0.06em", background: bg, color: fg } }, text);
  };
  const SecTitle = ({ text }) => /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 700, fontSize: 14, color: T.dark } }, text));
  const BDRow = ({ label, value, total: isT }) => /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", padding: isT ? "12px 14px 8px" : "8px 14px", background: isT ? "var(--accent-soft)" : "transparent", borderBottom: isT ? "none" : "1px solid " + T.bdr2, borderTop: isT ? "2px solid " + T.pri : "none", marginTop: isT ? 4 : 0 } }, /* @__PURE__ */ React.createElement("span", { style: { color: isT ? T.priD : T.t3, fontSize: isT ? 14 : 13, fontWeight: isT ? 700 : 500 } }, label), /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "monospace", fontWeight: isT ? 700 : 600, color: isT ? T.priD : T.dark, fontSize: isT ? 16 : 14 } }, value));
  function SheetSVG({ sheetL: sL, sheetW: sW, panelsL, panelsW, printCode, modelId, printZones, printSize }) {
    if (!sL || !sW || !panelsL || !panelsW) return null;
    let ki = 0;
    const k = () => "sk" + ki++;
    let sc = 520 / Math.max(sL, 1);
    if (sW * sc > 280) sc = 280 / sW;
    const pxW = sL * sc, pxH = sW * sc, ox = 55, oy = 32, svgW = pxW + ox + 60, svgH = pxH + oy + 50;
    const bF = "#c0d4f0", fF = "#e4edfb", gF = "#d8dce8", eF = "#fff";
    const isB = (n) => n === "H" || n === "L" || n === "W";
    const els = [];
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: "0", y: "0", width: svgW, height: svgH, fill: "#fff", rx: "6", stroke: T.bdr, strokeWidth: "1" }));
    els.push(/* @__PURE__ */ React.createElement("defs", { key: k() }, /* @__PURE__ */ React.createElement("pattern", { id: "shPh", width: "5", height: "5", patternUnits: "userSpaceOnUse", patternTransform: "rotate(45)" }, /* @__PURE__ */ React.createElement("line", { x1: "0", y1: "0", x2: "0", y2: "5", stroke: T.pri, strokeWidth: "1.5", opacity: "0.3" }))));
    let cx = ox;
    for (let i = 0; i < panelsL.length; i++) {
      let cy = oy;
      const pw = Math.max(panelsL[i].s * sc, 1);
      const iBC = isB(panelsL[i].n);
      for (let j = 0; j < panelsW.length; j++) {
        const ph = Math.max(panelsW[j].s * sc, 1);
        const iBR = isB(panelsW[j].n);
        let fl;
        if (panelsL[i].n === "Glue" || panelsL[i].n === "G" || panelsL[i].n === "Pat") fl = gF;
        else if (iBC && iBR) fl = bF;
        else fl = fF;
        els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: cx, y: cy, width: pw, height: ph, fill: fl, stroke: T.bdr, strokeWidth: "0.5" }));
        if (pw > 20 && ph > 14) {
          const fs2 = Math.min(8, Math.min(pw * 0.3, ph * 0.5));
          if (fs2 > 4) els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: cx + pw / 2, y: cy + ph / 2 + fs2 * 0.35, textAnchor: "middle", fill: iBC && iBR ? T.t2 : T.t4, fontSize: fs2, fontWeight: iBC && iBR ? "700" : "500", opacity: "0.7" }, iBC && iBR ? panelsL[i].n + "x" + panelsW[j].n : ""));
        }
        cy += ph;
      }
      cx += pw;
    }
    cx = ox;
    for (let v = 0; v < panelsL.length - 1; v++) {
      cx += Math.max(panelsL[v].s * sc, 1);
      els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: cx, y1: oy - 6, x2: cx, y2: oy + pxH + 6, stroke: T.pri, strokeWidth: "2", strokeDasharray: "8 4", opacity: "0.65" }));
    }
    let cy2 = oy;
    for (let h = 0; h < panelsW.length - 1; h++) {
      cy2 += Math.max(panelsW[h].s * sc, 1);
      els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: ox - 6, y1: cy2, x2: ox + pxW + 6, y2: cy2, stroke: T.pri, strokeWidth: "2", strokeDasharray: "8 4", opacity: "0.65" }));
    }
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: ox, y: oy, width: pxW, height: pxH, fill: "none", stroke: T.dark, strokeWidth: "1.5", rx: "1" }));
    const dy = oy + pxH + 32;
    els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: ox, y1: dy, x2: ox + pxW, y2: dy, stroke: T.t2, strokeWidth: "1" }));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: ox + pxW / 2, y: dy + 14, textAnchor: "middle", fill: T.dark, fontSize: "10", fontWeight: "700" }, sL + " mm"));
    const dx = ox - 35;
    els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: dx, y1: oy, x2: dx, y2: oy + pxH, stroke: T.t2, strokeWidth: "1" }));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: dx - 6, y: oy + pxH / 2 + 3, textAnchor: "end", fill: T.dark, fontSize: "10", fontWeight: "700" }, sW + "mm"));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: ox, y: 16, fill: T.dark, fontSize: "11", fontWeight: "700" }, "FEFCO " + modelId));
    cx = ox;
    for (let li = 0; li < panelsL.length; li++) {
      const lpw = Math.max(panelsL[li].s * sc, 1);
      els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: cx + lpw / 2, y: oy + pxH + 14, textAnchor: "middle", fill: T.t2, fontSize: "8", fontWeight: "600" }, panelsL[li].n));
      els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: cx + lpw / 2, y: oy + pxH + 23, textAnchor: "middle", fill: T.t3, fontSize: "7" }, Math.round(panelsL[li].s)));
      cx += lpw;
    }
    if (printZones && printCode && printCode !== "00") {
      const zones = parsePrintZones(printZones, printCode, panelsL, panelsW);
      const isM = printSize === "M";
      const pad = isM ? 0.25 : 0.125;
      zones.forEach((z) => {
        let x0 = ox, y0 = oy;
        for (let i = 0; i < z.l; i++) x0 += Math.max(panelsL[i].s * sc, 1);
        for (let j = 0; j < z.w; j++) y0 += Math.max(panelsW[j].s * sc, 1);
        const pw = Math.max(panelsL[z.l].s * sc, 1);
        const ph = Math.max(panelsW[z.w].s * sc, 1);
        const px = x0 + pw * pad, py = y0 + ph * pad;
        const rectW = pw * (1 - 2 * pad), rectH = ph * (1 - 2 * pad);
        if (rectW < 8 || rectH < 8) return;
        els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: px, y: py, width: rectW, height: rectH, fill: "#fff", stroke: T.pri, strokeWidth: "1", strokeDasharray: "4 3" }));
        const inset = Math.min(rectW, rectH) * 0.1;
        els.push(/* @__PURE__ */ React.createElement("image", { key: k(), href: LOGO_DATA_URI, x: px + inset, y: py + inset, width: rectW - 2 * inset, height: rectH - 2 * inset, preserveAspectRatio: "xMidYMid meet" }));
      });
    }
    return /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 " + svgW + " " + svgH, style: { width: "100%", maxHeight: 340 } }, els);
  }
  function PalletSVG({ fitL, fitW, layers, flatL, flatW, flatH, pal, bpp, aiLayout, palBaseHmm }) {
    const baseHmm = palBaseHmm || 150;
    if (!pal || !fitL || !fitW || !layers) return null;
    let ki = 0;
    const k = () => "pk" + ki++;
    const gap = 4, palW = pal.lengthMm, palD = pal.widthMm;
    let boxes = [];
    if (aiLayout?.length > 0) {
      aiLayout.forEach((b) => boxes.push(b));
    } else {
      for (let r = 0; r < fitW; r++) for (let col = 0; col < fitL; col++) boxes.push({ x: col * flatL, y: r * flatW, w: flatL, h: flatW });
    }
    let usedW = fitL * flatL, usedD = fitW * flatW, offsetX = (palW - usedW) / 2, offsetY = (palD - usedD) / 2;
    if (aiLayout?.length > 0) {
      let mxB = 0, myB = 0;
      boxes.forEach((b) => {
        if (b.x + b.w > mxB) mxB = b.x + b.w;
        if (b.y + b.h > myB) myB = b.y + b.h;
      });
      offsetX = (palW - mxB) / 2;
      offsetY = (palD - myB) / 2;
      usedW = mxB;
      usedD = myB;
    }
    const topSc = 280 / Math.max(palW, palD), tW = palW * topSc, tD = palD * topSc, topOx = 50, topOy = 44;
    const sideH = 150, palBaseH = 12, totalRealH = layers * flatH, sideSc = (sideH - palBaseH) / Math.max(totalRealH, 1), stackPx = Math.min(totalRealH * sideSc, sideH - palBaseH), sideOx = tW + topOx + 60, sideW2 = tW * 0.5;
    const svgW = sideOx + sideW2 + 80, svgH = Math.max(tD + topOy + 55, sideH + topOy + 45) + 10;
    const bxC = ["#c8d8f0", "#a8bce0", "#d4e2f5", "#b8cce8", "#9cb0d4", "#dce8fb"];
    const els = [];
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: "0", y: "0", width: svgW, height: svgH, fill: "#fafcff", rx: "6" }));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: topOx, y: 20, fill: T.t2, fontSize: "11", fontWeight: "700" }, "TOP VIEW"));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: topOx, y: 32, fill: T.t3, fontSize: "9" }, boxes.length + " boxes/layer"));
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: topOx, y: topOy, width: tW, height: tD, fill: "#f5e6d0", stroke: "#b8884e", strokeWidth: "1.5", rx: "2" }));
    for (let sl = 0; sl < 3; sl++) {
      const slY = topOy + tD * (sl + 0.5) / 3 - 3;
      els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: topOx, y: slY, width: tW, height: 6, fill: "#e8d4b4", stroke: "#c4a070", strokeWidth: "0.3", rx: "1" }));
    }
    boxes.forEach((box, bi2) => {
      const bx = topOx + (box.x + offsetX) * topSc + gap / 2, by = topOy + (box.y + offsetY) * topSc + gap / 2, bw = box.w * topSc - gap, bh = box.h * topSc - gap, ci = bi2 % bxC.length;
      els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: bx, y: by, width: bw, height: bh, fill: bxC[ci], fillOpacity: 0.65, stroke: T.pri, strokeWidth: "1", rx: "2" }));
      const fs = Math.min(11, Math.min(bw, bh) * 0.3);
      if (fs > 5) {
        els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: bx + bw / 2, y: by + bh / 2 - fs * 0.2, textAnchor: "middle", fill: T.t2, fontSize: fs, fontWeight: "700" }, "#" + (bi2 + 1)));
        els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: bx + bw / 2, y: by + bh / 2 + fs * 0.9, textAnchor: "middle", fill: T.t3, fontSize: fs * 0.7 }, Math.round(box.w) + "x" + Math.round(box.h)));
      }
    });
    const dimY = topOy + tD + 16;
    els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: topOx, y1: dimY, x2: topOx + tW, y2: dimY, stroke: T.t4, strokeWidth: "0.8" }));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: topOx + tW / 2, y: dimY + 14, textAnchor: "middle", fill: T.t2, fontSize: "9", fontWeight: "700" }, palW + "mm"));
    const dimX = topOx - 16;
    els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: dimX, y1: topOy, x2: dimX, y2: topOy + tD, stroke: T.t4, strokeWidth: "0.8" }));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: dimX - 4, y: topOy + tD / 2 + 3, textAnchor: "end", fill: T.t2, fontSize: "9", fontWeight: "700" }, palD + "mm"));
    const sBaseY = topOy + Math.max(tD, sideH);
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: sideOx, y: 20, fill: T.t2, fontSize: "11", fontWeight: "700" }, "SIDE VIEW"));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: sideOx, y: 32, fill: T.t3, fontSize: "9" }, layers + " layers, " + bpp + " total"));
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: sideOx, y: sBaseY, width: sideW2, height: palBaseH, fill: "#d4a66a", stroke: "#8a6530", strokeWidth: "1", rx: "1" }));
    const fW = sideW2 * 0.08;
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: sideOx + sideW2 * 0.1, y: sBaseY + palBaseH, width: fW, height: 8, fill: "#b8884e", stroke: "#8a6530", strokeWidth: "0.5" }));
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: sideOx + sideW2 * 0.45, y: sBaseY + palBaseH, width: fW, height: 8, fill: "#b8884e", stroke: "#8a6530", strokeWidth: "0.5" }));
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: sideOx + sideW2 * 0.82, y: sBaseY + palBaseH, width: fW, height: 8, fill: "#b8884e", stroke: "#8a6530", strokeWidth: "0.5" }));
    const mB = Math.min(layers, 25), bH = stackPx / mB;
    for (let b = 0; b < mB; b++) {
      els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: sideOx + 1, y: sBaseY - (b + 1) * bH, width: sideW2 - 2, height: bH - 0.5, fill: bxC[b % bxC.length], stroke: T.t4, strokeWidth: "0.3", rx: "0.5" }));
    }
    const sTop = sBaseY - stackPx;
    els.push(/* @__PURE__ */ React.createElement("rect", { key: k(), x: sideOx, y: sTop, width: sideW2, height: stackPx, fill: "none", stroke: T.pri, strokeWidth: "1", rx: "1" }));
    const hX = sideOx + sideW2 + 12;
    els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: hX, y1: sBaseY + palBaseH + 8, x2: hX, y2: sTop, stroke: T.t4, strokeWidth: "0.8" }));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: hX + 6, y: (sBaseY + palBaseH + 8 + sTop) / 2 + 3, fill: T.t2, fontSize: "9", fontWeight: "700" }, Math.round(totalRealH + baseHmm) + "mm"));
    if (pal.maxHeightMm > 0) {
      const mL = sBaseY - Math.min(pal.maxHeightMm * sideSc, stackPx + 15);
      els.push(/* @__PURE__ */ React.createElement("line", { key: k(), x1: sideOx - 6, y1: mL, x2: sideOx + sideW2 + 6, y2: mL, stroke: T.err, strokeWidth: "0.8", strokeDasharray: "4 2" }));
      els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: sideOx + sideW2 + 8, y: mL - 3, fill: T.err, fontSize: "8", fontWeight: "600" }, "Max " + pal.maxHeightMm + "mm"));
    }
    return /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 " + svgW + " " + svgH, style: { width: "100%", maxHeight: 320 } }, els);
  }
  const ISO_C = Math.cos(Math.PI / 6), ISO_S = Math.sin(Math.PI / 6);
  const isoPt = (x, y, z) => [(x - y) * ISO_C, (x + y) * ISO_S - z];
  function isoProjector(corners, vw, vh, pad) {
    const pts = corners.map((c) => isoPt(c[0], c[1], c[2]));
    const xs = pts.map((p) => p[0]), ys = pts.map((p) => p[1]);
    const minx = Math.min(...xs), maxx = Math.max(...xs), miny = Math.min(...ys), maxy = Math.max(...ys);
    const sc = Math.min((vw - 2 * pad) / (maxx - minx || 1), (vh - 2 * pad) / (maxy - miny || 1));
    const tx = pad + (vw - 2 * pad - (maxx - minx) * sc) / 2 - minx * sc, ty = pad + (vh - 2 * pad - (maxy - miny) * sc) / 2 - miny * sc;
    return (x, y, z) => {
      const p = isoPt(x, y, z);
      return [p[0] * sc + tx, p[1] * sc + ty];
    };
  }
  function isoCuboid(P, x, y, z, dx, dy, dz, fill, k) {
    const poly = (pts, op) => /* @__PURE__ */ React.createElement("polygon", { key: k(), points: pts.map((p) => P(p[0], p[1], p[2]).join(",")).join(" "), fill, fillOpacity: op, stroke: T.dark, strokeOpacity: "0.22", strokeWidth: "0.7", strokeLinejoin: "round" });
    const right = [[x + dx, y, z], [x + dx, y + dy, z], [x + dx, y + dy, z + dz], [x + dx, y, z + dz]];
    const front = [[x, y + dy, z], [x + dx, y + dy, z], [x + dx, y + dy, z + dz], [x, y + dy, z + dz]];
    const top = [[x, y, z + dz], [x + dx, y, z + dz], [x + dx, y + dy, z + dz], [x, y + dy, z + dz]];
    return [poly(right, 0.55), poly(front, 0.4), poly(top, 0.82)];
  }
  function BoxIso({ L, W, H }) {
    if (!L || !W || !H) return null;
    let ki = 0;
    const k = () => "bi" + ki++;
    const vw = 300, vh = 240;
    const P = isoProjector([[0, 0, 0], [L, 0, 0], [0, W, 0], [L, W, 0], [0, 0, H], [L, 0, H], [0, W, H], [L, W, H]], vw, vh, 30);
    const els = [...isoCuboid(P, 0, 0, 0, L, W, H, T.pri, k)];
    const lbl = (x, y, z, txt, ddx, ddy, anchor) => {
      const p = P(x, y, z);
      els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: p[0] + (ddx || 0), y: p[1] + (ddy || 0), textAnchor: anchor || "middle", fill: T.t2, fontSize: "10", fontWeight: "700" }, txt));
    };
    lbl(L / 2, W, 0, "L " + Math.round(L), 0, 16);
    lbl(L, W / 2, 0, "W " + Math.round(W), 10, 12, "start");
    lbl(L, W, H / 2, "H " + Math.round(H), 10, 2, "start");
    return /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 " + vw + " " + vh, style: { width: "100%", maxHeight: 280 } }, els);
  }
  function PalletIso({ fitL, fitW, layers, flatL, flatW, flatH, pal, palBaseHmm }) {
    if (!pal || !fitL || !fitW || !layers || !flatL || !flatW || !flatH) return null;
    let ki = 0;
    const k = () => "pi" + ki++;
    const palW = pal.lengthMm, palD = pal.widthMm, baseH = Math.max(palBaseHmm || 120, 80);
    const vl = Math.min(layers, 30);
    const totalH = baseH + vl * flatH;
    const vw = 360, vh = 320;
    const P = isoProjector([[0, 0, 0], [palW, 0, 0], [0, palD, 0], [palW, palD, 0], [0, 0, totalH], [palW, 0, totalH], [0, palD, totalH], [palW, palD, totalH]], vw, vh, 28);
    const els = [];
    els.push(...isoCuboid(P, 0, 0, 0, palW, palD, baseH, "#c8995e", k));
    const usedW = fitL * flatL, usedD = fitW * flatW, offX = (palW - usedW) / 2, offY = (palD - usedD) / 2;
    const gap = Math.min(flatL, flatW) * 0.05;
    const cells = [];
    for (let l = 0; l < vl; l++) for (let r = 0; r < fitW; r++) for (let col = 0; col < fitL; col++) {
      if (!(l === vl - 1 || col === fitL - 1 || r === fitW - 1)) continue;
      cells.push({ l, col, r, key: (col + r) * 1e3 + l });
    }
    cells.sort((a, b) => a.key - b.key);
    cells.forEach((c) => els.push(...isoCuboid(P, offX + c.col * flatL + gap / 2, offY + c.r * flatW + gap / 2, baseH + c.l * flatH, flatL - gap, flatW - gap, flatH, T.pri, k)));
    els.push(/* @__PURE__ */ React.createElement("text", { key: k(), x: vw / 2, y: vh - 6, textAnchor: "middle", fill: T.t3, fontSize: "9" }, fitL * fitW + " /camada \xD7 " + layers + " camadas" + (layers > vl ? " (mostradas " + vl + ")" : "")));
    return /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 " + vw + " " + vh, style: { width: "100%", maxHeight: 320 } }, els);
  }
  const D_CT = [{ cardTypeId: "1", name: "Micro s/ Kraft", flute: "E", thicknessMm: 1.5, compensationMm: 1.5, pricePerM2: 0.45, flapOffsetMm: 0, active: true }, { cardTypeId: "10", name: "Fino s/ Kraft", flute: "B", thicknessMm: 3, compensationMm: 3, pricePerM2: 0.48, flapOffsetMm: 0, active: true }, { cardTypeId: "15", name: "Fino 2 Krafts", flute: "B", thicknessMm: 3, compensationMm: 3, pricePerM2: 0.62, flapOffsetMm: 0, active: true }, { cardTypeId: "30", name: "Largo s/ Kraft", flute: "C", thicknessMm: 4, compensationMm: 4, pricePerM2: 0.54, flapOffsetMm: 0, active: true }, { cardTypeId: "35", name: "Largo 2 Krafts", flute: "C", thicknessMm: 4, compensationMm: 4, pricePerM2: 0.7, flapOffsetMm: 0, active: true }, { cardTypeId: "70", name: "Duplo s/ Kraft", flute: "BC", thicknessMm: 7, compensationMm: 7, pricePerM2: 0.72, flapOffsetMm: 0, active: true }, { cardTypeId: "75", name: "Duplo 2 Krafts", flute: "BC", thicknessMm: 7, compensationMm: 7, pricePerM2: 0.95, flapOffsetMm: 0, active: true }, { cardTypeId: "85", name: "Duplo Branco", flute: "BC", thicknessMm: 7, compensationMm: 7, pricePerM2: 1.05, flapOffsetMm: 0, active: true }, { cardTypeId: "95", name: "Triplo 2 Krafts", flute: "ABC", thicknessMm: 10, compensationMm: 10, pricePerM2: 1.25, flapOffsetMm: 0, active: true }];
  const D_TR = [{ district: "Lisboa", cost: 22.5 }, { district: "Porto", cost: 26.5 }, { district: "Setubal", cost: 22.5 }, { district: "Leiria", cost: 24 }, { district: "Aveiro", cost: 26.5 }, { district: "Braga", cost: 31.5 }, { district: "Faro", cost: 31.5 }, { district: "Coimbra", cost: 24 }, { district: "Evora", cost: 26.5 }, { district: "Viseu", cost: 28.5 }, { district: "Beja", cost: 31.5 }, { district: "Guarda", cost: 31.5 }, { district: "Braganca", cost: 34.5 }, { district: "Santarem", cost: 24 }, { district: "Madeira", cost: 45 }, { district: "Acores", cost: 55 }];
  const D_MC = [{ machineId: "M1", name: "Flexo Small", flexoSize: "small", costPerUnit: 0.03, setupCost: 25, minWidthMm: 0, maxWidthMm: 0, minLengthMm: 0, maxLengthMm: 0, minBoxL: 0, maxBoxL: 0, minBoxW: 0, maxBoxW: 0, minBoxH: 0, maxBoxH: 0, maxColors: 0, cardTypes: [] }, { machineId: "M2", name: "Flexo Medium", flexoSize: "medium", costPerUnit: 0.04, setupCost: 35, minWidthMm: 0, maxWidthMm: 0, minLengthMm: 0, maxLengthMm: 0, minBoxL: 0, maxBoxL: 0, minBoxW: 0, maxBoxW: 0, minBoxH: 0, maxBoxH: 0, maxColors: 0, cardTypes: [] }, { machineId: "M3", name: "Flexo Large", flexoSize: "large", costPerUnit: 0.05, setupCost: 50, minWidthMm: 0, maxWidthMm: 0, minLengthMm: 0, maxLengthMm: 0, minBoxL: 0, maxBoxL: 0, minBoxW: 0, maxBoxW: 0, minBoxH: 0, maxBoxH: 0, maxColors: 0, cardTypes: [] }];
  const D_PL = [{ code: "00", size: "M/L", name: "Without Printing", small: 0, medium: 0, large: 0 }, { code: "12", size: "M", name: "Top", small: 0.04, medium: 0.05, large: 0.065 }, { code: "13", size: "M", name: "Front", small: 0.04, medium: 0.05, large: 0.065 }, { code: "14", size: "M", name: "2 Sides", small: 0.08, medium: 0.1, large: 0.13 }, { code: "15", size: "M", name: "Top Inside", small: 0.04, medium: 0.05, large: 0.065 }, { code: "16", size: "M", name: "Front And Back", small: 0.08, medium: 0.1, large: 0.13 }, { code: "21", size: "L", name: "Full Size", small: 0.12, medium: 0.13, large: 0.16 }, { code: "22", size: "L", name: "Top", small: 0.08, medium: 0.1, large: 0.13 }, { code: "23", size: "L", name: "Front", small: 0.08, medium: 0.1, large: 0.13 }, { code: "24", size: "L", name: "2 Sides", small: 0.16, medium: 0.12, large: 0.16 }, { code: "25", size: "L", name: "Top Inside", small: 0.08, medium: 0.1, large: 0.13 }, { code: "26", size: "L", name: "Front And Back", small: 0.16, medium: 0.12, large: 0.16 }];
  const D_GL = { toolingCostPerCm2: 0.012, minOrderM2: 500, aiApiKey: "", maxTruckHeightMm: 2400 };
  const D_PA = [{ palletTypeId: "EUR", name: "Euro Pallet", lengthMm: 1200, widthMm: 800, maxHeightMm: 1800, price: 8, active: true }, { palletTypeId: "IND", name: "Industrial", lengthMm: 1200, widthMm: 1e3, maxHeightMm: 1800, price: 10, active: true }, { palletTypeId: "HLF", name: "Half Pallet", lengthMm: 800, widthMm: 600, maxHeightMm: 1500, price: 6, active: true }];
  const mCT = (r) => ({ cardTypeId: r.id, name: r.name, flute: r.flute, thicknessMm: +r.thickness_mm, compensationMm: +(r.compensation_mm ?? r.thickness_mm), pricePerM2: +r.price_per_m2, flapOffsetMm: +(r.flap_offset_mm || 0), active: r.active !== false });
  const mTR = (r) => ({ district: r.district, cost: +r.cost, cost12: +(r.cost_12 || 0), cost22: +(r.cost_22 || 0) });
  const mMC = (r) => ({ machineId: r.id, name: r.name, flexoSize: r.flexo_size, costPerUnit: +r.cost_per_unit, setupCost: +r.setup_cost, minWidthMm: +(r.min_width_mm || 0), maxWidthMm: +(r.max_width_mm || 0), minLengthMm: +(r.min_length_mm || 0), maxLengthMm: +(r.max_length_mm || 0), minBoxL: +(r.min_box_l_mm || 0), maxBoxL: +(r.max_box_l_mm || 0), minBoxW: +(r.min_box_w_mm || 0), maxBoxW: +(r.max_box_w_mm || 0), minBoxH: +(r.min_box_h_mm || 0), maxBoxH: +(r.max_box_h_mm || 0), maxColors: +(r.max_colors || 0), cardTypes: Array.isArray(r.machine_card_types) ? r.machine_card_types.map((x) => x.card_type_id) : [] });
  const mPL = (r) => ({ code: r.code, size: r.size, name: r.name, small: +r.small, medium: +r.medium, large: +r.large });
  const mGL = (rows) => {
    const r = rows[0] || {};
    return { toolingCostPerCm2: +(r.tooling_cost_per_cm2 || 0.012), minOrderM2: +(r.min_order_m2 || 500), aiApiKey: r.ai_api_key || "", maxTruckHeightMm: +(r.max_truck_height_mm || 2400) };
  };
  const mPA = (r) => ({ palletTypeId: r.id, name: r.name, lengthMm: +r.length_mm, widthMm: +r.width_mm, maxHeightMm: +r.max_height_mm, price: +(r.price || 0), active: r.active !== false });
  const uCT = (r) => ({ id: r.cardTypeId, name: r.name, flute: r.flute, thickness_mm: r.thicknessMm, compensation_mm: r.compensationMm, price_per_m2: r.pricePerM2, flap_offset_mm: r.flapOffsetMm || 0, active: r.active !== false });
  const uTR = (r) => ({ district: r.district, cost: r.cost, cost_12: r.cost12 || 0, cost_22: r.cost22 || 0 });
  const uMC = (r) => ({ id: r.machineId, name: r.name, flexo_size: r.flexoSize, cost_per_unit: r.costPerUnit, setup_cost: r.setupCost, min_width_mm: r.minWidthMm || 0, max_width_mm: r.maxWidthMm || 0, min_length_mm: r.minLengthMm || 0, max_length_mm: r.maxLengthMm || 0, min_box_l_mm: r.minBoxL || 0, max_box_l_mm: r.maxBoxL || 0, min_box_w_mm: r.minBoxW || 0, max_box_w_mm: r.maxBoxW || 0, min_box_h_mm: r.minBoxH || 0, max_box_h_mm: r.maxBoxH || 0, max_colors: r.maxColors || 0 });
  const uPL = (r) => ({ code: r.code, size: r.size, name: r.name, small: r.small, medium: r.medium, large: r.large });
  const uGL = (g) => ({ id: 1, tooling_cost_per_cm2: g.toolingCostPerCm2, min_order_m2: g.minOrderM2, ai_api_key: g.aiApiKey || "", max_truck_height_mm: g.maxTruckHeightMm || 2400 });
  const uPA = (r) => ({ id: r.palletTypeId, name: r.name, length_mm: r.lengthMm, width_mm: r.widthMm, max_height_mm: r.maxHeightMm, price: r.price || 0, active: r.active !== false });
  const within = (v, mn, mx) => (mn === 0 || v >= mn) && (mx === 0 || v <= mx);
  const machineFits = (m, shL, shW, boxL, boxW, boxH, cardTypeId, colors) => {
    const fitsSheet = (L, W) => (m.maxLengthMm === 0 || L <= m.maxLengthMm) && (m.minLengthMm === 0 || L >= m.minLengthMm) && (m.maxWidthMm === 0 || W <= m.maxWidthMm) && (m.minWidthMm === 0 || W >= m.minWidthMm);
    const sheetOk = fitsSheet(shL, shW) || fitsSheet(shW, shL);
    const boxOk = within(boxL, m.minBoxL, m.maxBoxL) && within(boxW, m.minBoxW, m.maxBoxW) && within(boxH, m.minBoxH, m.maxBoxH);
    const colorsOk = m.maxColors === 0 || colors <= m.maxColors;
    const cardOk = !m.cardTypes || m.cardTypes.length === 0 || m.cardTypes.includes(cardTypeId);
    return sheetOk && boxOk && colorsOk && cardOk;
  };
  function EditCell({ value, onChange, num, opts, fmt, freeText }) {
    const toStr = (v) => v == null ? "" : typeof v === "object" ? JSON.stringify(v) : String(v);
    const [editing, setEditing] = useState(false);
    const [val, setVal] = useState(toStr(value));
    const ref = useRef(null);
    useEffect(() => {
      setVal(toStr(value));
    }, [value]);
    useEffect(() => {
      if (editing && ref.current) ref.current.focus();
    }, [editing]);
    const commit = () => {
      setEditing(false);
      const v = num ? parseFloat(val) || 0 : val;
      if (v !== value) onChange(v);
    };
    if (!editing) {
      const display = fmt ? fmt(num ? parseFloat(val) : val) : String(val);
      return /* @__PURE__ */ React.createElement("span", { onClick: () => setEditing(true), title: freeText ? display : void 0, style: { cursor: "pointer", display: "block" } }, display);
    }
    if (opts) {
      return /* @__PURE__ */ React.createElement("select", { ref, style: { ...inS, padding: "6px 8px", fontSize: 13 }, value: val, onChange: (e) => {
        setVal(e.target.value);
      }, onBlur: commit }, opts.map((o) => /* @__PURE__ */ React.createElement("option", { key: o, value: o }, o)));
    }
    return /* @__PURE__ */ React.createElement("input", { ref, style: { ...inS, padding: "6px 8px", fontSize: 13, fontFamily: num ? "monospace" : "inherit" }, type: num ? "number" : "text", value: val, onChange: (e) => setVal(e.target.value), onBlur: commit, onKeyDown: (e) => {
      if (e.key === "Enter") commit();
      if (e.key === "Escape") {
        setVal(toStr(value));
        setEditing(false);
      }
    } });
  }
  function DataTable({ rows, setRows, cols, idKey, onSaveRow, onDeleteRow, appLabel, viewId }) {
    const [adding, setAdding] = useState(false);
    const [newForm, setNewForm] = useState({});
    const startNew = () => {
      const b = {};
      cols.forEach((c) => {
        b[c.key] = c.def !== void 0 ? c.def : "";
      });
      setAdding(true);
      setNewForm(b);
    };
    const saveNew = () => {
      if (!newForm[idKey] && newForm[idKey] !== 0) return;
      const f = { ...newForm };
      cols.forEach((c) => {
        if (c.num) f[c.key] = parseFloat(f[c.key]) || 0;
      });
      setRows([...rows, f]);
      setAdding(false);
      if (onSaveRow) onSaveRow(f);
    };
    const updateCell = (row, colKey, val) => {
      const next = rows.map((r) => r[idKey] === row[idKey] ? { ...r, [colKey]: val } : r);
      setRows(next);
      if (onSaveRow) onSaveRow(next.find((r) => r[idKey] === row[idKey]));
    };
    const del = async (row) => {
      if (!await window.hubConfirm({ message: "Eliminar este registo?" })) return;
      setRows(rows.filter((r) => r[idKey] !== row[idKey]));
      if (onDeleteRow) onDeleteRow(row);
    };
    const columns = [
      ...cols.map((c2) => ({
        key: c2.key,
        label: c2.label,
        width: c2.width,
        minWidth: c2.minWidth,
        fixed: c2.fixed,
        align: c2.num ? "right" : void 0,
        mono: !!c2.num,
        render: (row) => /* @__PURE__ */ React.createElement(EditCell, { value: row[c2.key], num: c2.num, opts: c2.opts, fmt: c2.fmt, freeText: !c2.num && !c2.opts, onChange: (v) => updateCell(row, c2.key, v) })
      })),
      {
        key: "_acoes",
        label: "",
        sortable: false,
        align: "center",
        width: 44,
        render: (row) => /* @__PURE__ */ React.createElement("button", { onClick: () => del(row), title: "Eliminar", style: { background: "none", border: "none", cursor: "pointer", color: T.t4, fontSize: 14, padding: 4, borderRadius: 2, lineHeight: 1, transition: "color 0.15s" }, onMouseEnter: (e) => e.target.style.color = T.err, onMouseLeave: (e) => e.target.style.color = T.t4 }, "\xD7")
      }
    ];
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { onClick: startNew, style: btnS("pri") }, "+ Adicionar"), adding && /* @__PURE__ */ React.createElement("div", { style: { background: T.bg, border: "1px solid " + T.bdr, borderRadius: 4, padding: 14, margin: "10px 0" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 10 } }, cols.map((c2) => /* @__PURE__ */ React.createElement("div", { key: c2.key, style: { flex: "1 1 120px" } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, c2.label), c2.opts ? /* @__PURE__ */ React.createElement("select", { style: inS, value: newForm[c2.key] || "", onChange: (e) => setNewForm({ ...newForm, [c2.key]: e.target.value }) }, c2.opts.map((o) => /* @__PURE__ */ React.createElement("option", { key: o, value: o }, o))) : /* @__PURE__ */ React.createElement("input", { style: inS, value: newForm[c2.key] !== void 0 ? newForm[c2.key] : "", onChange: (e) => setNewForm({ ...newForm, [c2.key]: e.target.value }), placeholder: c2.label })))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement("button", { onClick: saveNew, style: btnS("pri") }, "Guardar"), /* @__PURE__ */ React.createElement("button", { onClick: () => setAdding(false), style: btnS("out") }, "Cancelar"))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10 } }, /* @__PURE__ */ React.createElement(window.HubList.List, { columns, data: rows, pagination: "client", rowKey: (r) => r[idKey], appLabel, viewId, empty: "Sem registos." })));
  }
  function MachineCardTypesPanel({ machines, cardTypes, setMachines, setSaveStatus }) {
    const toggle = (machineId, cardTypeId) => {
      const m = machines.find((x) => x.machineId === machineId);
      if (!m) return;
      const has = (m.cardTypes || []).includes(cardTypeId);
      const next = has ? (m.cardTypes || []).filter((id) => id !== cardTypeId) : [...m.cardTypes || [], cardTypeId];
      setSaveStatus("saving");
      window.API.valoraSetMachineCards(machineId, next).then(() => {
        setMachines((prev) => prev.map((x) => x.machineId === machineId ? { ...x, cardTypes: next } : x));
        setSaveStatus("saved");
        setTimeout(() => setSaveStatus(""), 1500);
      }).catch(() => {
        setSaveStatus("error");
        setTimeout(() => setSaveStatus(""), 2500);
      });
    };
    const activeCT = cardTypes.filter((ct) => ct.active !== false && ct.active !== "false");
    const larguraPorRotulo = (label, minimo) => Math.max(minimo, Math.round(String(label).length * 8.8) + 32);
    const columns = [
      {
        key: "maquina",
        label: "Machine",
        width: 160,
        minWidth: 130,
        fixed: true,
        render: (m) => /* @__PURE__ */ React.createElement("span", null, m.name, " ", /* @__PURE__ */ React.createElement("span", { style: { color: T.t4, fontWeight: 400 } }, "(", m.machineId, ")"))
      },
      ...activeCT.map((ct) => ({
        key: "ct_" + ct.cardTypeId,
        // Decisão: o cabeçalho fica a UMA linha (o rótulo é só o cardTypeId,
        // no estilo 11px/uppercase do hub) — o flute, que a tabela antiga
        // desenhava numa 2ª linha, passa para o title (hover). Duas linhas
        // aqui quebraria a convenção de cabeçalho do HubList, usada por todas
        // as outras colunas geradas em runtime (matriz de acessos incluída).
        label: ct.cardTypeId,
        title: ct.cardTypeId + " \u2014 flute " + ct.flute,
        sortable: false,
        align: "center",
        width: larguraPorRotulo(ct.cardTypeId, 80),
        render: (m) => /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "center" } }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: (m.cardTypes || []).includes(ct.cardTypeId), onChange: () => toggle(m.machineId, ct.cardTypeId), style: { cursor: "pointer" } }))
      }))
    ];
    return /* @__PURE__ */ React.createElement("div", { style: { marginTop: 18 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 13, color: T.dark, marginBottom: 8 } }, "Cards accepted per machine ", /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 400, color: T.t3, fontSize: 11 } }, "\u2014 empty = accepts all")), /* @__PURE__ */ React.createElement(window.HubList.List, { appLabel: "valora", viewId: "machine-card-types", columns, data: machines, pagination: "client", rowKey: (m) => m.machineId, empty: "Sem m\xE1quinas." }));
  }
  function ValoraView(props) {
    const isAdmin = !!(props && props.isAdmin);
    const isSuperAdmin = isAdmin;
    const canManageUsers = false;
    const userName = props && props.userName || "valora";
    const session = { user: { email: userName } };
    const setSession = () => {
    };
    const dispName = userName;
    const role = isAdmin ? "jnadmin" : "user";
    const loginOpen = false, setLoginOpen = () => {
    };
    const loginEmail = "", setLoginEmail = () => {
    }, loginPw = "", setLoginPw = () => {
    }, loginErr = "", loginLoading = false;
    const tk = null;
    const tryLogin = () => {
    }, logout = () => {
    };
    const userList = [], newUser = { email: "", password: "", displayName: "", role: "user" }, setNewUser = () => {
    }, nuErr = "", nuOk = "";
    const loadUsers = () => {
    }, createUser = () => {
    };
    const saveAll = () => {
    };
    const [page, setPage] = useState("calc");
    const [saveStatus, setSaveStatus] = useState("");
    const [adminTab, setAdminTab] = useState("Cardboard");
    const [cardTypes, setCardTypes] = useState(D_CT);
    const [transport, setTransport] = useState(D_TR);
    const [machines, setMachines] = useState(D_MC);
    const [printLocs, setPrintLocs] = useState(D_PL);
    const [globals, setGlobals] = useState(D_GL);
    const [pallets, setPallets] = useState(D_PA);
    const [fefcoModels, setFefcoModels] = useState(D_FM);
    const [c, setC] = useState({ cardTypeId: "75", fefcoId: "201", length: 300, width: 200, height: 150, quantity: 500, printLocCode: "00", numColors: 0, colorAreas: [], district: "Lisboa", machineId: "M2", palletTypeId: "EUR", notes: "" });
    const up = (k, v) => setC((p) => {
      const next = { ...p, [k]: v };
      if (k === "numColors") {
        const n = parseInt(v) || 0;
        const old = p.colorAreas || [];
        const arr = [];
        for (let i = 0; i < n; i++) arr.push(i < old.length ? old[i] : 0);
        next.colorAreas = arr;
        if (n > 0 && next.printLocCode === "00") {
          const first = printLocs.find((pl) => pl.code !== "00");
          if (first) next.printLocCode = first.code;
        }
      }
      if (k === "printLocCode" && v === "00") {
        next.numColors = 0;
        next.colorAreas = [];
      }
      if (k === "width" || k === "length") {
        const L = +next.length || 0, W = +next.width || 0;
        if (W > L && L > 0) {
          next.length = String(W);
          next.width = String(L);
        }
      }
      return next;
    });
    const upColor = (idx, v) => setC((p) => {
      const arr = [...p.colorAreas || []];
      arr[idx] = parseFloat(v) || 0;
      return { ...p, colorAreas: arr };
    });
    const [aiLayout, setAiLayout] = useState(null);
    const [aiLoading, setAiLoading] = useState(false);
    const [palletOverflow, setPalletOverflow] = useState(0);
    const [qpb, setQpb] = useState(0);
    const [pdfBusy, setPdfBusy] = useState(false);
    useEffect(() => {
      Promise.all([API.valoraCardTypes(), API.valoraTransport(), API.valoraMachines(), API.valoraPrintLocations(), API.valoraGlobals(), API.valoraPallets(), API.valoraFefcoModels()]).then(([ct, tr, mc, pl, gl, pa, fm]) => {
        if (ct && ct.length) setCardTypes(ct.map(mCT));
        if (tr && tr.length) setTransport(tr.map(mTR));
        if (mc && mc.length) setMachines(mc.map(mMC));
        if (pl && pl.length) setPrintLocs(pl.map(mPL));
        if (gl && gl.length) setGlobals(mGL(gl));
        if (pa && pa.length) setPallets(pa.map(mPA));
        if (fm && fm.length && !fm.error) setFefcoModels(fm);
      }).catch(() => {
      });
    }, []);
    const trackSave = (p) => {
      setSaveStatus("saving");
      p.then(() => {
        setSaveStatus("saved");
        setTimeout(() => setSaveStatus(""), 1500);
      }).catch(() => {
        setSaveStatus("error");
        setTimeout(() => setSaveStatus(""), 2500);
      });
    };
    const saveCT = (r) => trackSave(API.valoraSaveCardType(uCT(r)));
    const delCT = (r) => trackSave(API.valoraDeleteCardType(r.cardTypeId));
    const saveTR = (r) => trackSave(API.valoraSaveTransport(uTR(r)));
    const delTR = (r) => trackSave(API.valoraDeleteTransport(r.district));
    const saveMC = (r) => trackSave(API.valoraSaveMachine(uMC(r)));
    const delMC = (r) => trackSave(API.valoraDeleteMachine(r.machineId));
    const savePL = (r) => trackSave(API.valoraSavePrintLocation(uPL(r)));
    const delPL = (r) => trackSave(API.valoraDeletePrintLocation(r.code));
    const savePA = (r) => trackSave(API.valoraSavePallet(uPA(r)));
    const delPA = (r) => trackSave(API.valoraDeletePallet(r.palletTypeId));
    const uFM = (r) => {
      const out = { ...r };
      if (typeof out.print_zones === "string") {
        const s = out.print_zones.trim();
        if (s === "" || s === "null") out.print_zones = null;
        else {
          try {
            out.print_zones = JSON.parse(s);
          } catch (e) {
          }
        }
      }
      return out;
    };
    const saveFM = (r) => trackSave(API.valoraSaveFefco(uFM(r)));
    const delFM = (r) => trackSave(API.valoraDeleteFefco(r.id));
    const saveGL = () => trackSave(API.valoraSaveGlobals({ tooling_cost_per_cm2: globals.toolingCostPerCm2, min_order_m2: globals.minOrderM2, max_truck_height_mm: globals.maxTruckHeightMm }));
    const optimizePallet = () => {
      if (!pricing || !pricing.pal) return;
      setAiLoading(true);
      setAiLayout(null);
      const pL = pricing.pal.lengthMm, pW = pricing.pal.widthMm, bA = pricing.flatA, bB = pricing.flatB;
      const prompt = `You are a 2D bin-packing solver. Pack as many rectangles as possible into a container.

CONTAINER: ${pL} mm (length/x-axis) x ${pW} mm (width/y-axis).
RECTANGLES: Each box is either ${bA}x${bB} mm OR ${bB}x${bA} mm (rotated 90\xB0). You may mix orientations.

HARD CONSTRAINTS \u2014 violating any makes the solution INVALID:
1. Every box must fit ENTIRELY inside the container: x >= 0, y >= 0, x + w <= ${pL}, y + h <= ${pW}
2. No two boxes may overlap (their areas must not intersect)
3. w and h of each box must be exactly ${bA}x${bB} or ${bB}x${bA}

GOAL: Maximize the number of boxes placed.

VERIFY your solution: check that EVERY box satisfies constraint 1 and no pair overlaps.

Return ONLY a JSON array, no text, no explanation:
[{"x":0,"y":0,"w":${bA},"h":${bB}},...]`;
      API.valoraAiPallet(prompt).then((data) => {
        try {
          const txt = data && data.text || "";
          const clean = txt.replace(/```json/g, "").replace(/```/g, "").trim();
          const layout = JSON.parse(clean);
          if (Array.isArray(layout) && layout.length > 0) {
            const valid = layout.filter((b) => {
              const ok = b.x >= 0 && b.y >= 0 && b.x + b.w <= pL + 1 && b.y + b.h <= pW + 1;
              const sizeOk = b.w === bA && b.h === bB || b.w === bB && b.h === bA;
              return ok && sizeOk;
            });
            if (valid.length > 0) setAiLayout(valid);
          }
        } catch (e) {
          console.error("AI parse error", e);
        }
        setAiLoading(false);
      }).catch(() => setAiLoading(false));
    };
    const pricing = useMemo(() => {
      const ct = cardTypes.find((t) => t.cardTypeId === c.cardTypeId);
      if (!ct) return null;
      const L = +c.length || 0, W = +c.width || 0, H = +c.height || 0, reqQty = parseInt(c.quantity) || 0, nCol = parseInt(c.numColors) || 0;
      if (!L || !W || !H || !reqQty) return null;
      if (nCol > 0) {
        const ar = c.colorAreas || [];
        if (ar.length < nCol) return null;
        for (let i = 0; i < nCol; i++) {
          if (!(+ar[i] > 0)) return null;
        }
      }
      const comp = ct.compensationMm;
      const fefco = fefcoModels.find((m) => m.id === c.fefcoId) || fefcoModels[0] || D_FM[0];
      const glueFlap = (fefco.glue || 0) + (ct.flapOffsetMm || 0);
      const shL = evalF(fefco.formula_sl, L, W, H, comp, glueFlap), shW = evalF(fefco.formula_sw, L, W, H, comp, glueFlap);
      const m2 = shL * shW / 1e6;
      const availMachines = shL > 0 && shW > 0 ? machines.filter((m) => machineFits(m, shL, shW, L, W, H, c.cardTypeId, nCol)) : machines;
      const pal = pallets.find((p) => p.palletTypeId === c.palletTypeId);
      const palBaseH = 125;
      const cardThk = +ct.thicknessMm || comp;
      const fA = L + W, fB = shW, fH = cardThk * 2;
      let fitL = 0, fitW = 0, ly = 0, bpp = 0, flatL = fA, flatW = fB, stackH = fH;
      if (pal) {
        const palLenEff = pal.lengthMm * (1 + 2 * palletOverflow);
        const palWidEff = pal.widthMm * (1 + 2 * palletOverflow);
        const capSupp = (pd, bd) => Math.floor(pd / bd + 0.8);
        const fitDim = (pe, pd, bd) => Math.min(Math.floor(pe / bd), capSupp(pd, bd));
        const fA_L = fitDim(palLenEff, pal.lengthMm, fA), fA_W = fitDim(palWidEff, pal.widthMm, fA);
        const fB_L = fitDim(palLenEff, pal.lengthMm, fB), fB_W = fitDim(palWidEff, pal.widthMm, fB);
        const o1 = fA_L * fB_W, o2 = fB_L * fA_W;
        if (o2 > o1) {
          fitL = Math.max(1, fB_L);
          fitW = Math.max(1, fA_W);
          flatL = fB;
          flatW = fA;
        } else {
          fitL = Math.max(1, fA_L);
          fitW = Math.max(1, fB_W);
        }
        const usableH = (pal.maxHeightMm - palBaseH) * 1.01;
        const perL = fitL * fitW;
        if (qpb > 0) {
          stackH = qpb * fH;
          ly = Math.max(1, Math.floor(Math.max(usableH, 1) / Math.max(stackH, 1)));
          bpp = perL * ly * qpb;
        } else {
          ly = Math.max(1, Math.floor(Math.max(usableH, 1) / Math.max(fH, 1)));
          bpp = perL * ly;
          if (bpp >= 5) {
            bpp = Math.floor(bpp / 5) * 5;
            ly = Math.max(1, Math.ceil(bpp / perL));
          }
        }
      }
      const bppFor = (p) => {
        if (!p || fA <= 0 || fB <= 0 || fH <= 0) return 0;
        const pLE = p.lengthMm * (1 + 2 * palletOverflow), pWE = p.widthMm * (1 + 2 * palletOverflow);
        const cap = (pd, bd) => Math.floor(pd / bd + 0.8);
        const fd = (pe, pd, bd) => Math.min(Math.floor(pe / bd), cap(pd, bd));
        const aL = fd(pLE, p.lengthMm, fA), aW = fd(pWE, p.widthMm, fA);
        const bL = fd(pLE, p.lengthMm, fB), bW = fd(pWE, p.widthMm, fB);
        const a1 = aL * bW, a2 = bL * aW;
        const fL = Math.max(1, a2 > a1 ? bL : aL), fW2 = Math.max(1, a2 > a1 ? aW : bW);
        const uH = (p.maxHeightMm - palBaseH) * 1.01;
        const perL2 = fL * fW2;
        let b;
        if (qpb > 0) {
          const sH = qpb * fH;
          const ly2 = Math.max(1, Math.floor(Math.max(uH, 1) / Math.max(sH, 1)));
          b = perL2 * ly2 * qpb;
        } else {
          const ly2 = Math.max(1, Math.floor(Math.max(uH, 1) / Math.max(fH, 1)));
          b = perL2 * ly2;
          if (b >= 5) b = Math.floor(b / 5) * 5;
        }
        return b;
      };
      let bestFit = null;
      pallets.filter((p) => p.active !== false && p.active !== "false").forEach((p) => {
        const b = bppFor(p);
        if (b > 0 && (!bestFit || b > bestFit.bpp)) bestFit = { p, bpp: b };
      });
      const minQtyM2 = Math.ceil(globals.minOrderM2 / m2);
      const minQtyPal = bpp > 0 ? bpp : 1;
      const minQty = Math.max(minQtyM2, minQtyPal);
      let qty = reqQty;
      if (bpp > 0) qty = Math.ceil(Math.max(qty, minQty) / bpp) * bpp;
      else qty = Math.max(qty, minQty);
      if (qpb > 0) qty = Math.ceil(qty / qpb) * qpb;
      const calcForQty = (q) => {
        const palN = bpp > 0 ? Math.ceil(q / bpp) : 1;
        const palTH = palBaseH + ly * stackH;
        const maxTruck = globals.maxTruckHeightMm || 2400;
        const canSt = palTH * 2 <= maxTruck * 1.05;
        const ppl = canSt ? 2 : 1;
        const nLoads = Math.ceil(palN / ppl);
        const palP = pal ? pal.price || 0 : 0;
        const mT = m2 * ct.pricePerM2 * q;
        const pl = printLocs.find((p) => p.code === c.printLocCode);
        const mach = machines.find((m) => m.machineId === c.machineId) || machines[0];
        const pRate = pl && mach ? (pl[mach.flexoSize] || 0) * nCol : 0;
        const prT = pRate * q;
        const areas = c.colorAreas || [];
        const tool = nCol > 0 && c.printLocCode !== "00" ? areas.reduce((sum, a) => sum + (a || 0) * globals.toolingCostPerCm2, 0) : 0;
        const prodT = mach ? mach.costPerUnit * q + mach.setupCost : 0;
        const palC = palP * palN;
        const tr = transport.find((t) => t.district === c.district);
        const cpl = tr ? palN >= 22 && tr.cost22 > 0 ? tr.cost22 : palN >= 12 && tr.cost12 > 0 ? tr.cost12 : tr.cost : 0;
        const trC = cpl * nLoads;
        const tot = mT + prT + tool + prodT + palC + trC;
        return { qty: q, matTotal: mT, printRate: pRate, printTotal: prT, tooling: tool, prodTotal: prodT, palletsCost: palC, transCost: trC, costPerLoad: cpl, numLoads: nLoads, palNeeded: palN, palTotalH: palTH, canStack: canSt, palsPerLoad: ppl, total: tot, unit: q > 0 ? tot / q : 0 };
      };
      const main = calcForQty(qty);
      const totalPrintArea = (c.colorAreas || []).reduce((s, a) => s + (a || 0), 0);
      const optUp = bpp > 0 ? (main.palNeeded + 1) * bpp : qty;
      const cUp = bpp > 0 ? calcForQty(optUp) : main;
      const optPrev = bpp > 0 && main.palNeeded > 1 ? (main.palNeeded - 1) * bpp : 0;
      const cPrev = optPrev >= minQty && optPrev > 0 ? calcForQty(optPrev) : null;
      const optUpVisible = bpp > 0;
      const pnL = evalPanels(fefco.panels_l, L, W, H, comp, glueFlap), pnW = evalPanels(fefco.panels_w, L, W, H, comp, glueFlap);
      return { ...main, sheetL: shL, sheetW: shW, comp, m2, minQty, reqQty, totalPrintArea, ct, flatL, flatW, flatH: stackH, flatA: fA, flatB: fB, fitL, fitW, layers: ly, perLayer: fitL * fitW, pal, fefco, glueFlap, panelsL: pnL, panelsW: pnW, bpp, optUp, optUpVisible, cUp, optPrev, cPrev, availMachines, palBaseH, bestFit };
    }, [c, cardTypes, machines, printLocs, globals, transport, pallets, fefcoModels, palletOverflow, qpb]);
    useEffect(() => {
      if (!pricing || !pricing.availMachines || pricing.availMachines.length === 0) return;
      if (!pricing.availMachines.find((m) => m.machineId === c.machineId)) {
        up("machineId", pricing.availMachines[0].machineId);
      }
    }, [pricing?.availMachines, c.machineId]);
    const selFefco = fefcoModels.find((m) => m.id === c.fefcoId) || fefcoModels[0] || D_FM[0];
    const RL = { user: "User", jn: "JN", jnadmin: "JN Admin", raja: "VALORA", superadmin: "Super Admin" };
    const RC = { user: "ok", jn: "pri", jnadmin: "pri", raja: "warn", superadmin: "warn" };
    const exportPDF = () => {
      if (!pricing || pdfBusy) return;
      const h2c = window.html2canvas;
      const jsPdf = window.jspdf?.jsPDF;
      if (!h2c || !jsPdf) {
        setSaveStatus("error");
        setTimeout(() => setSaveStatus(""), 3e3);
        return;
      }
      setPdfBusy(true);
      const ct = pricing.ct || {}, fefco = pricing.fefco || {}, pal = pricing.pal || {};
      const pl = printLocs.find((p) => p.code === c.printLocCode) || {};
      const mc = machines.find((m) => m.machineId === c.machineId) || {};
      const tr = transport.find((t) => t.district === c.district) || {};
      const userPart = dispName || (session?.user?.email || "no session");
      const dateStr = (/* @__PURE__ */ new Date()).toLocaleString("pt-PT");
      const ovfPct = (palletOverflow * 100).toFixed(0) + "%";
      const areasHtml = (c.colorAreas || []).slice(0, parseInt(c.numColors) || 0).map((a, i) => '<tr><td style="color:#6b7280;padding:1px 0;">Cor ' + (i + 1) + '</td><td style="font-weight:600;text-align:right;">' + (+a || 0).toFixed(0) + " cm\xB2</td></tr>").join("");
      const row = (lb, vl) => '<tr><td style="color:#6b7280;padding:2px 0;font-size:10px;">' + lb + '</td><td style="text-align:right;font-weight:600;font-size:10px;">' + vl + "</td></tr>";
      const colHd = (t) => '<div style="font-weight:700;font-size:9px;color:#0076CE;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:6px;border-bottom:1px solid #dbe4f0;padding-bottom:3px;">' + t + "</div>";
      const colWrap = (inner) => '<div style="background:#f8faff;border:1px solid #dbe4f0;border-radius:4px;padding:8px 10px;">' + inner + "</div>";
      const liveRoot = document.getElementById("pdfRoot");
      const liveSvgs = liveRoot ? Array.from(liveRoot.querySelectorAll("svg")) : [];
      const sheetSvg = liveSvgs[0] ? liveSvgs[0].outerHTML : '<div style="color:#9ca3af;font-style:italic;">Sem sheet</div>';
      const palletSvg = liveSvgs[1] ? liveSvgs[1].outerHTML : '<div style="color:#9ca3af;font-style:italic;">Sem pallet</div>';
      const wrapper = document.createElement("div");
      wrapper.style.cssText = "position:fixed;top:-10000px;left:0;background:#fff;padding:14px 16px;font-family:system-ui,sans-serif;color:#00142A;width:760px;height:1075px;box-sizing:border-box;display:flex;flex-direction:column;";
      wrapper.innerHTML = '<div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1.5px solid #0076CE;padding-bottom:6px;margin-bottom:12px;flex-shrink:0;"><img src="' + LOGO_DATA_URI + '" style="height:42px;width:auto;display:block;" alt="GJN"/><div style="color:#374151;font-size:11px;text-align:right;">' + userPart + '<br/><span style="color:#9ca3af;">' + dateStr + " &nbsp;|&nbsp; " + BUILD_VERSION + '</span></div></div><div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:10px;flex-shrink:0;">' + colWrap(colHd("Box (inner dimensions)") + '<table style="width:100%;font-size:10px;border-collapse:collapse;">' + row("FEFCO", fefco.id ? fefco.id + " \u2014 " + (fefco.name || "") : "\u2014") + row("Cardboard", ct.name ? ct.name + " (" + (ct.flute || "") + ")" : "\u2014") + row("Length", (c.length || 0) + " mm") + row("Width", (c.width || 0) + " mm") + row("Height", (c.height || 0) + " mm") + row("Sheet", pricing.sheetL + " \xD7 " + pricing.sheetW + " mm") + row("Quantity", pricing.qty + " pcs") + "</table>") + colWrap(colHd("Printing") + '<table style="width:100%;font-size:10px;border-collapse:collapse;">' + row("Print Loc.", pl.code ? pl.code + " \u2014 " + (pl.name || "") : "\u2014") + row("Size", pl.size || "\u2014") + row("Colors", c.numColors || 0) + areasHtml + row("Machine", mc.name ? mc.name + " (" + (mc.flexoSize || "") + ")" : "\u2014") + "</table>") + colWrap(colHd("Delivery") + '<table style="width:100%;font-size:10px;border-collapse:collapse;">' + row("District", c.district ? c.district + " \u2014 " + EUR(tr.cost || 0) : "\u2014") + row("Pallet", pal.name ? pal.name + " (" + pal.lengthMm + "\xD7" + pal.widthMm + ")" : "\u2014") + row("Overflow", ovfPct) + row("QPB", qpb === 0 ? "no bundling" : qpb) + row("Pallets", pricing.palNeeded + " (" + (pricing.canStack ? "2 pal/load" : "1 pal/load") + ")") + row("Loads", pricing.numLoads) + "</table>") + '</div><div style="background:#fff;border:1px solid #dbe4f0;border-radius:4px;padding:8px 12px;margin-bottom:10px;flex-shrink:0;"><div style="display:flex;justify-content:space-between;align-items:baseline;border-bottom:1px solid #dbe4f0;padding-bottom:5px;margin-bottom:6px;"><span style="font-weight:700;font-size:10px;color:#0076CE;text-transform:uppercase;letter-spacing:0.05em;">Price Breakdown</span><span style="font-weight:900;font-size:18px;color:#0076CE;">' + EUR(pricing.total) + '</span></div><table style="width:100%;font-size:10px;border-collapse:collapse;">' + row("Material (" + pricing.m2.toFixed(3) + " m\xB2/sheet \xD7 " + EUR(ct.pricePerM2 || 0) + "/m\xB2 \xD7 " + pricing.qty + ")", EUR(pricing.matTotal)) + row("Printing (" + EUR4(pricing.printRate) + "/u \xD7 " + pricing.qty + ")", EUR(pricing.printTotal)) + row("Tooling (" + (c.numColors || 0) + " cliches, " + pricing.totalPrintArea.toFixed(0) + " cm\xB2)", EUR(pricing.tooling)) + row("Production", EUR(pricing.prodTotal)) + row("Pallets (" + pricing.palNeeded + " \xD7 " + EUR(pal.price || 0) + ")", EUR(pricing.palletsCost)) + row("Transporte (" + pricing.numLoads + " \xD7 " + EUR(pricing.costPerLoad) + ")", EUR(pricing.transCost)) + '<tr><td style="padding:5px 0 0;border-top:1.5px solid #0076CE;font-weight:700;font-size:11px;">TOTAL</td><td style="padding:5px 0 0;border-top:1.5px solid #0076CE;font-weight:900;text-align:right;font-size:12px;">' + EUR(pricing.total) + '</td></tr><tr><td style="padding:2px 0;color:#6b7280;font-size:10px;">Unit Price</td><td style="text-align:right;font-weight:700;font-family:monospace;font-size:11px;">' + EUR4(pricing.unit) + '</td></tr></table></div><div style="background:#fafcff;border:1px solid #dbe4f0;border-radius:4px;padding:8px;margin-bottom:8px;flex-shrink:0;"><div style="font-weight:700;font-size:9px;color:#0076CE;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:6px;">Sheet \u2014 FEFCO ' + (fefco.id || "") + '</div><div style="display:flex;justify-content:center;align-items:center;min-height:140px;">' + sheetSvg + '</div></div><div style="background:#fafcff;border:1px solid #dbe4f0;border-radius:4px;padding:8px;flex:1;display:flex;flex-direction:column;min-height:0;"><div style="font-weight:700;font-size:9px;color:#0076CE;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:6px;flex-shrink:0;">Pallet Layout \u2014 ' + pricing.perLayer + "/layer \xD7 " + pricing.layers + '</div><div style="display:flex;justify-content:center;align-items:center;flex:1;min-height:0;">' + palletSvg + "</div></div>";
      const sheetWrapSvg = wrapper.querySelectorAll("svg")[0];
      const palletWrapSvg = wrapper.querySelectorAll("svg")[1];
      if (sheetWrapSvg) {
        sheetWrapSvg.removeAttribute("width");
        sheetWrapSvg.removeAttribute("height");
        sheetWrapSvg.style.maxWidth = "100%";
        sheetWrapSvg.style.maxHeight = "200px";
        sheetWrapSvg.style.height = "auto";
        sheetWrapSvg.style.display = "block";
      }
      if (palletWrapSvg) {
        palletWrapSvg.removeAttribute("width");
        palletWrapSvg.removeAttribute("height");
        palletWrapSvg.style.maxWidth = "100%";
        palletWrapSvg.style.maxHeight = "100%";
        palletWrapSvg.style.width = "auto";
        palletWrapSvg.style.height = "100%";
        palletWrapSvg.style.display = "block";
      }
      document.body.appendChild(wrapper);
      const slug = (session?.user?.email || "user").split("@")[0].toLowerCase().replace(/[^a-z0-9._-]/g, "");
      const fefcoIdStr = fefco.id || "FEFCO";
      const dim = (c.length || 0) + "x" + (c.width || 0) + "x" + (c.height || 0);
      const date = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
      const filename = "valora_" + date + "_" + slug + "_" + fefcoIdStr + "_" + dim + ".pdf";
      const cleanup = () => {
        try {
          document.body.removeChild(wrapper);
        } catch (e) {
        }
      };
      h2c(wrapper, { scale: 2, useCORS: true, backgroundColor: "#ffffff", logging: false }).then((canvas) => {
        const pdf = new jsPdf({ orientation: "portrait", unit: "mm", format: "a4", compress: true });
        const pageW = pdf.internal.pageSize.getWidth();
        const pageH = pdf.internal.pageSize.getHeight();
        const margin = 5;
        const availW = pageW - 2 * margin, availH = pageH - 2 * margin;
        const aspect = canvas.width / canvas.height;
        let w, h;
        if (aspect > availW / availH) {
          w = availW;
          h = w / aspect;
        } else {
          h = availH;
          w = h * aspect;
        }
        const x = margin + (availW - w) / 2, y = margin;
        pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", x, y, w, h, void 0, "FAST");
        pdf.save(filename);
        cleanup();
        setPdfBusy(false);
      }).catch(() => {
        cleanup();
        setPdfBusy(false);
        setSaveStatus("error");
        setTimeout(() => setSaveStatus(""), 3e3);
      });
    };
    return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, color: T.dark, fontSize: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 14 } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 700, fontSize: 16, color: T.dark } }, page === "admin" ? "Configura\xE7\xE3o" : "Calculadora de caixas"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: T.t3, flex: 1 } }, page === "admin" ? "" : fefcoModels.filter((m) => m.active !== false && m.active !== "false").length + " modelos FEFCO"), saveStatus === "saving" && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: T.warn } }, "A guardar\u2026"), saveStatus === "saved" && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: T.ok } }, "Guardado"), saveStatus === "error" && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: T.err } }, "Erro"), page === "calc" && /* @__PURE__ */ React.createElement("button", { onClick: exportPDF, disabled: !pricing || pdfBusy, title: !pricing ? "Preenche o formul\xE1rio primeiro" : pdfBusy ? "A gerar\u2026" : "Exportar PDF", style: { ...btnS("out"), opacity: !pricing || pdfBusy ? 0.5 : 1, cursor: !pricing || pdfBusy ? "not-allowed" : "pointer" } }, pdfBusy ? "A gerar\u2026" : "\u{1F4C4} PDF"), isAdmin && /* @__PURE__ */ React.createElement("button", { onClick: () => setPage(page === "admin" ? "calc" : "admin"), style: btnS(page === "admin" ? "out" : "pri") }, page === "admin" ? "Calculadora" : "Configura\xE7\xE3o")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 14, alignItems: "flex-start" } }, page === "calc" && /* @__PURE__ */ React.createElement("div", { id: "pdfRoot", className: "valora-split", style: { display: "flex", flex: 1 } }, /* @__PURE__ */ React.createElement("div", { className: "valora-aside", style: { width: 300, flexShrink: 0, background: T.white, borderRight: "1px solid " + T.bdr, overflowY: "auto", padding: "14px 16px" } }, /* @__PURE__ */ React.createElement("div", { style: { ...lbS, marginBottom: 12 } }, "Box Specification (inner dimensions)"), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "FEFCO Model"), /* @__PURE__ */ React.createElement("select", { style: { ...inS, fontWeight: 700, color: T.priD }, value: c.fefcoId, onChange: (e) => {
      up("fefcoId", e.target.value);
      setAiLayout(null);
    } }, fefcoModels.filter((m) => m.active !== false && m.active !== "false").map((m) => /* @__PURE__ */ React.createElement("option", { key: m.id, value: m.id }, m.name)))), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Cardboard Type"), /* @__PURE__ */ React.createElement("select", { style: inS, value: c.cardTypeId, onChange: (e) => up("cardTypeId", e.target.value) }, cardTypes.filter((ct) => ct.active !== false && ct.active !== "false").map((ct) => /* @__PURE__ */ React.createElement("option", { key: ct.cardTypeId, value: ct.cardTypeId }, ct.name, " - ", ct.flute, " (", ct.thicknessMm, "mm)")))), [["Length (mm)", "length"], ["Width (mm)", "width"], ["Height (mm)", "height"], ["Quantity", "quantity"]].map(([lb, ky]) => /* @__PURE__ */ React.createElement("div", { key: ky, style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, lb), /* @__PURE__ */ React.createElement("input", { style: inS, type: "number", min: "1", value: c[ky], onChange: (e) => up(ky, e.target.value) }))), /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid " + T.bdr2, paddingTop: 12, marginTop: 6 } }), /* @__PURE__ */ React.createElement("div", { style: { ...lbS, marginBottom: 10 } }, "Printing"), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Print Location"), /* @__PURE__ */ React.createElement("select", { style: inS, value: c.printLocCode, onChange: (e) => up("printLocCode", e.target.value) }, printLocs.map((p) => /* @__PURE__ */ React.createElement("option", { key: p.code, value: p.code }, p.code, " [", p.size, "] ", p.name)))), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Colors"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "number", min: "0", max: "8", value: c.numColors, onChange: (e) => up("numColors", e.target.value) })), (c.colorAreas || []).length > 0 && (() => {
      const nC = parseInt(c.numColors) || 0;
      const empties = nC > 0 ? (c.colorAreas || []).slice(0, nC).map((a, i) => ({ i, empty: !(+a > 0) })).filter((x) => x.empty) : [];
      return /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8, background: "var(--panel-2)", border: "1px solid " + T.bdr2, borderRadius: 3, padding: "8px 10px" } }, /* @__PURE__ */ React.createElement("div", { style: { ...lbS, marginBottom: 6, fontSize: 10 } }, "Area per cliche (cm\xB2)"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(90px,1fr))", gap: 6 } }, (c.colorAreas || []).map((a, i) => {
        const isEmpty = i < nC && !(+a > 0);
        return /* @__PURE__ */ React.createElement("div", { key: i }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 9, color: isEmpty ? T.err : T.t4, marginBottom: 2, fontWeight: isEmpty ? 700 : 400 } }, "Color ", i + 1, isEmpty ? " *" : ""), /* @__PURE__ */ React.createElement("input", { style: { ...inS, padding: "6px 8px", fontSize: 12, fontFamily: "monospace", borderColor: isEmpty ? T.err : T.bdr }, type: "number", min: "0", step: "1", value: a || "", placeholder: "0", onChange: (e) => upColor(i, e.target.value) }));
      })), empties.length > 0 ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.err, marginTop: 4, fontWeight: 600 } }, "\u26A0 Fill in the area for each cliche (", empties.length, " of ", nC, " missing). Pricing requires all areas > 0.") : (c.colorAreas || []).some((a) => a > 0) && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t3, marginTop: 4 } }, "Total: ", /* @__PURE__ */ React.createElement("strong", null, (c.colorAreas || []).reduce((s, a) => s + (a || 0), 0).toFixed(0), " cm2"), " (", c.numColors, " cliches)"));
    })(), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Machine"), /* @__PURE__ */ React.createElement("select", { style: inS, value: c.machineId, onChange: (e) => up("machineId", e.target.value) }, (pricing?.availMachines || machines).map((m) => /* @__PURE__ */ React.createElement("option", { key: m.machineId, value: m.machineId }, m.name, " (", m.flexoSize, ")"))), pricing && pricing.availMachines && pricing.availMachines.length > 0 && !pricing.availMachines.find((m) => m.machineId === c.machineId) && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.warn, marginTop: 4, fontWeight: 600 } }, "\u26A0 Machine auto-adjusted (not compatible with sheet)")), /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid " + T.bdr2, paddingTop: 12, marginTop: 6 } }), /* @__PURE__ */ React.createElement("div", { style: { ...lbS, marginBottom: 10 } }, "Delivery"), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "District"), /* @__PURE__ */ React.createElement("select", { style: inS, value: c.district, onChange: (e) => up("district", e.target.value) }, transport.map((t) => /* @__PURE__ */ React.createElement("option", { key: t.district, value: t.district }, t.district, " - ", EUR(t.cost))))), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Pallet"), /* @__PURE__ */ React.createElement("select", { style: inS, value: c.palletTypeId, onChange: (e) => {
      up("palletTypeId", e.target.value);
      setAiLayout(null);
    } }, pallets.filter((p) => p.active !== false && p.active !== "false").map((p) => /* @__PURE__ */ React.createElement("option", { key: p.palletTypeId, value: p.palletTypeId }, p.name, " (", p.lengthMm, "x", p.widthMm, ")")))), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Pallet overflow"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, [{ v: 0, l: "0%" }, { v: 0.05, l: "5%" }, { v: 0.1, l: "10%" }, { v: 0.25, l: "25%" }].map((o) => /* @__PURE__ */ React.createElement("label", { key: o.v, style: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 4, padding: "6px 4px", border: "1px solid " + (palletOverflow === o.v ? T.pri : T.bdr), borderRadius: 3, background: palletOverflow === o.v ? "#eef4ff" : T.white, cursor: "pointer", fontSize: 12, fontWeight: 600, color: palletOverflow === o.v ? T.priD : T.t2 } }, /* @__PURE__ */ React.createElement("input", { type: "radio", name: "palovf", checked: palletOverflow === o.v, onChange: () => setPalletOverflow(o.v), style: { margin: 0 } }), o.l))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t4, marginTop: 4 } }, "Allowed overflow per side relative to the pallet.")), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Quantity Per Bundle"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "number", min: "0", step: "1", value: qpb, onChange: (e) => setQpb(Math.max(0, parseInt(e.target.value) || 0)) }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t4, marginTop: 4 } }, "0 = no bundling. >0 = boxes per bundle, qty rounded to multiple."))), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflow: "auto", padding: "16px 20px" } }, pricing && /* @__PURE__ */ React.createElement("div", { style: cardSt }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Sheet: FEFCO " + selFefco.id }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(Badge, { text: pricing.sheetL + " x " + pricing.sheetW + " mm", color: "pri" }), /* @__PURE__ */ React.createElement(Badge, { text: pricing.m2.toFixed(4) + " m2/sheet", color: "pri" }), /* @__PURE__ */ React.createElement(Badge, { text: "Min: " + pricing.minQty + " pcs", color: "warn" }))), /* @__PURE__ */ React.createElement("div", { style: { ...cardBd, background: "var(--panel-2)" } }, /* @__PURE__ */ React.createElement(SheetSVG, { sheetL: pricing.sheetL, sheetW: pricing.sheetW, panelsL: pricing.panelsL, panelsW: pricing.panelsW, printCode: c.printLocCode, modelId: selFefco.id, printZones: selFefco.print_zones, printSize: (printLocs.find((p) => p.code === c.printLocCode) || {}).size }))), /* @__PURE__ */ React.createElement("div", { className: "m-stack", style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 } }, pricing && /* @__PURE__ */ React.createElement("div", { style: cardSt }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Price Breakdown" }), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 20, fontWeight: 900, color: T.priD } }, EUR(pricing.total))), /* @__PURE__ */ React.createElement("div", { style: { padding: 0 } }, pricing.availMachines && pricing.availMachines.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { background: "rgba(220,38,38,0.10)", padding: "10px 14px", borderBottom: "1px solid rgba(220,38,38,0.30)", fontSize: 13, color: T.err, fontWeight: 600 } }, "\u26D4 No machine available for sheet of ", pricing.sheetL, "\xD7", pricing.sheetW, " mm"), pricing.bestFit && pricing.bestFit.p && pricing.bestFit.p.palletTypeId !== c.palletTypeId && pricing.bestFit.bpp > pricing.bpp && /* @__PURE__ */ React.createElement("div", { style: { background: "rgba(22,163,74,0.10)", padding: "8px 14px", borderBottom: "1px solid rgba(22,163,74,0.30)", fontSize: 12, color: T.dark, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("span", null, "\u{1F4A1} Better pallet fit: ", /* @__PURE__ */ React.createElement("strong", null, pricing.bestFit.p.name), " \u2014 ", pricing.bestFit.bpp, " boxes/pallet (vs ", pricing.bpp, " now)"), /* @__PURE__ */ React.createElement("button", { onClick: () => up("palletTypeId", pricing.bestFit.p.palletTypeId), style: { ...btnS("pri"), padding: "5px 10px", fontSize: 11, whiteSpace: "nowrap" } }, "Switch to ", pricing.bestFit.p.name)), pricing.qty !== pricing.reqQty && /* @__PURE__ */ React.createElement("div", { style: { background: "rgba(245,158,11,0.12)", padding: "8px 14px", borderBottom: "1px solid rgba(245,158,11,0.35)", fontSize: 12, color: T.warn, fontWeight: 600 } }, "Pedido: ", pricing.reqQty, " \u2192 Ajustado para ", /* @__PURE__ */ React.createElement("strong", null, pricing.qty), " (paletes completas, min ", pricing.minQty, ")"), /* @__PURE__ */ React.createElement(BDRow, { label: "Quantity", value: pricing.qty + " pcs (" + pricing.palNeeded + " pal.)" }), /* @__PURE__ */ React.createElement(BDRow, { label: "Material (" + pricing.m2.toFixed(3) + "m2 x " + EUR(pricing.ct.pricePerM2) + "/m2 x " + pricing.qty + ")", value: EUR(pricing.matTotal) }), /* @__PURE__ */ React.createElement(BDRow, { label: "Printing (" + EUR4(pricing.printRate) + "/u x " + pricing.qty + ")", value: EUR(pricing.printTotal) }), /* @__PURE__ */ React.createElement(BDRow, { label: "Tooling (" + c.numColors + " cliches, " + pricing.totalPrintArea.toFixed(0) + " cm2 x " + EUR(globals.toolingCostPerCm2) + "/cm2)", value: EUR(pricing.tooling) }), /* @__PURE__ */ React.createElement(BDRow, { label: "Production", value: EUR(pricing.prodTotal) }), /* @__PURE__ */ React.createElement(BDRow, { label: "Pallets (" + pricing.palNeeded + " x " + EUR(pricing.pal?.price || 0) + ")", value: EUR(pricing.palletsCost) }), /* @__PURE__ */ React.createElement(BDRow, { label: "Transport " + c.district + " (" + pricing.numLoads + " load" + (pricing.numLoads > 1 ? "s" : "") + " x " + EUR(pricing.costPerLoad) + (pricing.canStack ? " - 2 pal/load" : " - 1 pal/load") + ")", value: EUR(pricing.transCost) }), /* @__PURE__ */ React.createElement(BDRow, { label: "TOTAL", value: EUR(pricing.total), total: true }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", padding: "10px 14px" } }, /* @__PURE__ */ React.createElement("span", { style: { color: T.t3, fontSize: 13, fontWeight: 600 } }, "Unit Price"), /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "monospace", fontSize: 18, fontWeight: 700, color: T.dark } }, EUR4(pricing.unit))), pricing.pal && /* @__PURE__ */ React.createElement("div", { style: { padding: "6px 14px 10px", fontSize: 10, color: T.t4 } }, "Pallet H: ", pricing.palTotalH, "mm | Truck max: ", globals.maxTruckHeightMm, "mm | ", pricing.canStack ? "Stack 2" : "1 per load"), pricing.bpp > 0 && pricing.optUpVisible && (() => {
      const showPrev = !!pricing.cPrev;
      return /* @__PURE__ */ React.createElement("div", { style: { background: "rgba(22,163,74,0.08)", borderTop: "2px solid " + T.ok, padding: "12px 14px" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, fontWeight: 700, color: T.ok, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 } }, "Other quantities (full pallets)"), /* @__PURE__ */ React.createElement("div", { className: "m-stack", style: { display: "grid", gridTemplateColumns: showPrev ? "1fr 1fr 1fr" : "1fr 1fr", gap: 8, marginBottom: 4 } }, showPrev && /* @__PURE__ */ React.createElement("div", { style: { background: "var(--panel)", border: "1px solid " + T.bdr, borderRadius: 4, padding: 10, textAlign: "center", cursor: "pointer" }, onClick: () => up("quantity", String(pricing.optPrev)) }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 9, color: T.t4, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 } }, "Previous pallet"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 900, color: T.priD } }, pricing.cPrev.qty), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t3 } }, pricing.cPrev.palNeeded, " pal. | ", EUR4(pricing.cPrev.unit), "/u"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: T.dark, marginTop: 2 } }, EUR(pricing.cPrev.total))), /* @__PURE__ */ React.createElement("div", { style: { background: "var(--panel)", border: "1px solid " + T.bdr, borderRadius: 4, padding: 10, textAlign: "center", cursor: "pointer" }, onClick: () => up("quantity", String(pricing.qty)) }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 9, color: T.t4, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 } }, "Current"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 900, color: T.priD } }, pricing.qty), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t3 } }, pricing.palNeeded, " pal. | ", EUR4(pricing.unit), "/u"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: T.dark, marginTop: 2 } }, EUR(pricing.total))), /* @__PURE__ */ React.createElement("div", { style: { background: "var(--panel)", border: "1px solid " + T.bdr, borderRadius: 4, padding: 10, textAlign: "center", cursor: "pointer" }, onClick: () => up("quantity", String(pricing.optUp)) }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 9, color: T.t4, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 } }, "Next pallet"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 900, color: T.priD } }, pricing.cUp.qty), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t3 } }, pricing.cUp.palNeeded, " pal. | ", EUR4(pricing.cUp.unit), "/u"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: T.dark, marginTop: 2 } }, EUR(pricing.cUp.total)))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t4 } }, "Click to select"));
    })())), pricing && /* @__PURE__ */ React.createElement("div", { style: cardSt }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Palletization" })), /* @__PURE__ */ React.createElement("div", { style: cardBd }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 10 } }, [{ n: pricing.bpp, l: "Boxes/Pallet" }, { n: pricing.palNeeded, l: "Pallets" }, { n: pricing.qty, l: "Total" }].map((s, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: { background: T.bg, border: "1px solid " + T.bdr, borderRadius: 4, padding: 10, textAlign: "center" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 900, color: T.priD } }, s.n), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 9, color: T.t3, marginTop: 2, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700 } }, s.l))))))), pricing && pricing.pal && (() => {
      const ovX = Math.max(0, (pricing.fitL * pricing.flatL - pricing.pal.lengthMm) / 2);
      const ovY = Math.max(0, (pricing.fitW * pricing.flatW - pricing.pal.widthMm) / 2);
      return /* @__PURE__ */ React.createElement("div", { style: cardSt }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Pallet Layout" }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(Badge, { text: pricing.perLayer + "/layer x " + pricing.layers, color: "pri" }), (ovX > 0 || ovY > 0) && /* @__PURE__ */ React.createElement(Badge, { text: "Overhang +" + Math.round(ovX) + "L / +" + Math.round(ovY) + "W mm/side", color: "warn" }))), /* @__PURE__ */ React.createElement("div", { style: { ...cardBd, background: "var(--panel-2)" } }, /* @__PURE__ */ React.createElement(PalletSVG, { fitL: pricing.fitL, fitW: pricing.fitW, layers: pricing.layers, flatL: pricing.flatL, flatW: pricing.flatW, flatH: pricing.flatH, pal: pricing.pal, bpp: pricing.bpp, aiLayout: null, palBaseHmm: pricing.palBaseH })));
    })(), pricing && /* @__PURE__ */ React.createElement("div", { className: "m-stack", style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginTop: 14 } }, /* @__PURE__ */ React.createElement("div", { style: cardSt }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Caixa 3D" })), /* @__PURE__ */ React.createElement("div", { style: { ...cardBd, background: "var(--panel-2)" } }, /* @__PURE__ */ React.createElement(BoxIso, { L: +c.length, W: +c.width, H: +c.height }))), pricing.pal && /* @__PURE__ */ React.createElement("div", { style: cardSt }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Paletiza\xE7\xE3o 3D" })), /* @__PURE__ */ React.createElement("div", { style: { ...cardBd, background: "var(--panel-2)" } }, /* @__PURE__ */ React.createElement(PalletIso, { fitL: pricing.fitL, fitW: pricing.fitW, layers: pricing.layers, flatL: pricing.flatL, flatW: pricing.flatW, flatH: pricing.flatH, pal: pricing.pal, palBaseHmm: pricing.palBaseH })))))), page === "admin" && isAdmin && /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflow: "auto", padding: "22px 26px" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 14 } }, ["Cardboard", "Transport", "Machines", "Print Locations", "FEFCO Models", "Globals", "Pallets"].map((t) => /* @__PURE__ */ React.createElement("button", { key: t, onClick: () => setAdminTab(t), style: btnS(adminTab === t ? "pri" : "out") }, t))), adminTab === "Cardboard" && /* @__PURE__ */ React.createElement(DataTable, { appLabel: "valora", viewId: "cardboard", rows: cardTypes, setRows: setCardTypes, idKey: "cardTypeId", onSaveRow: saveCT, onDeleteRow: delCT, cols: [{ key: "cardTypeId", label: "ID", def: "", width: 70, minWidth: 60, fixed: true }, { key: "name", label: "Name", def: "", width: 130, minWidth: 100 }, { key: "flute", label: "Flute", def: "B", width: 85 }, { key: "thicknessMm", label: "Thickness (info)", num: true, def: 3, width: 160 }, { key: "compensationMm", label: "Compensation (mm)", num: true, def: 0, width: 175 }, { key: "pricePerM2", label: "Price/m2", num: true, def: 0.5, fmt: EUR, width: 110 }, { key: "flapOffsetMm", label: "Flap +/-", num: true, def: 0, width: 100 }, { key: "active", label: "Active", def: true, opts: ["true", "false"], width: 95 }] }), adminTab === "Transport" && /* @__PURE__ */ React.createElement(DataTable, { appLabel: "valora", viewId: "transport", rows: transport, setRows: setTransport, idKey: "district", onSaveRow: saveTR, onDeleteRow: delTR, cols: [{ key: "district", label: "District", def: "", width: 110, minWidth: 90, fixed: true }, { key: "cost", label: "Cost (<12 pal.)", num: true, def: 25, fmt: EUR, width: 145 }, { key: "cost12", label: "Cost (\u226512 pal.)", num: true, def: 0, fmt: EUR, width: 145 }, { key: "cost22", label: "Cost (\u226522 pal.)", num: true, def: 0, fmt: EUR, width: 145 }] }), adminTab === "Machines" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(DataTable, { appLabel: "valora", viewId: "machines", rows: machines, setRows: setMachines, idKey: "machineId", onSaveRow: saveMC, onDeleteRow: delMC, cols: [{ key: "machineId", label: "ID", def: "", width: 70, minWidth: 60, fixed: true }, { key: "name", label: "Name", def: "", width: 130, minWidth: 100 }, { key: "flexoSize", label: "Size", def: "small", opts: ["small", "medium", "large"], width: 100 }, { key: "costPerUnit", label: "Cost/u", num: true, def: 0.03, fmt: EUR4, width: 105 }, { key: "setupCost", label: "Setup", num: true, def: 25, fmt: EUR, width: 90 }, { key: "minWidthMm", label: "Sheet W min", num: true, def: 0, width: 125 }, { key: "maxWidthMm", label: "Sheet W max", num: true, def: 0, width: 126 }, { key: "minLengthMm", label: "Sheet L min", num: true, def: 0, width: 122 }, { key: "maxLengthMm", label: "Sheet L max", num: true, def: 0, width: 123 }, { key: "minBoxL", label: "Box L min", num: true, def: 0, width: 108 }, { key: "maxBoxL", label: "Box L max", num: true, def: 0, width: 109 }, { key: "minBoxW", label: "Box W min", num: true, def: 0, width: 112 }, { key: "maxBoxW", label: "Box W max", num: true, def: 0, width: 113 }, { key: "minBoxH", label: "Box H min", num: true, def: 0, width: 110 }, { key: "maxBoxH", label: "Box H max", num: true, def: 0, width: 111 }, { key: "maxColors", label: "Max Colors", num: true, def: 0, width: 122 }] }), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, fontSize: 11, color: T.t3 } }, '0 = no limit (any column). Colors compares against the "Colors" input in the main form.'), /* @__PURE__ */ React.createElement(MachineCardTypesPanel, { machines, cardTypes, setMachines, tk, setSaveStatus })), adminTab === "Print Locations" && /* @__PURE__ */ React.createElement(DataTable, { appLabel: "valora", viewId: "print-locations", rows: printLocs, setRows: setPrintLocs, idKey: "code", onSaveRow: savePL, onDeleteRow: delPL, cols: [{ key: "code", label: "Code", def: "", width: 85, minWidth: 70, fixed: true }, { key: "size", label: "Size", def: "M", width: 90 }, { key: "name", label: "Name", def: "", width: 140, minWidth: 100 }, { key: "small", label: "S", num: true, def: 0, width: 70 }, { key: "medium", label: "M", num: true, def: 0, width: 70 }, { key: "large", label: "L", num: true, def: 0, width: 75 }] }), adminTab === "FEFCO Models" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(DataTable, { appLabel: "valora", viewId: "fefco-models", rows: fefcoModels, setRows: setFefcoModels, idKey: "id", onSaveRow: saveFM, onDeleteRow: delFM, cols: [
      { key: "id", label: "ID", def: "", width: 70, minWidth: 60, fixed: true },
      { key: "name", label: "Name", def: "", width: 160, minWidth: 120 },
      { key: "glue", label: "Glue Flap", num: true, def: 60, width: 110 },
      { key: "active", label: "Active", def: true, opts: ["true", "false"], width: 95 },
      { key: "formula_sl", label: "Formula SL", width: 260 },
      { key: "formula_sw", label: "Formula SW", width: 260 },
      { key: "panels_l", label: "Panels L (JSON)", width: 280 },
      { key: "panels_w", label: "Panels W (JSON)", width: 280 },
      { key: "print_zones", label: "Print Zones (JSON)", width: 300 }
    ] }), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12, padding: 14, background: "var(--accent-soft)", borderRadius: 4, fontSize: 11, color: T.t3 } }, /* @__PURE__ */ React.createElement("strong", null, "Variables available in formulas:"), " L (length), W (width), H (height), e (cardboard compensation), g (flap = model flap + card flap)", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "Functions:"), " Math.round(), Math.max(), Math.min(), Math.floor()", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "Formula examples:"), " ", /* @__PURE__ */ React.createElement("code", null, "L+W+L+W+g"), " \xA0 ", /* @__PURE__ */ React.createElement("code", null, "H+Math.round(W/2+e/2)"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "Panels JSON:"), " ", /* @__PURE__ */ React.createElement("code", null, "[", "{", '\\"expr\\":\\"g\\",\\"n\\":\\"Glue\\"', "}", ",", "{", '\\"expr\\":\\"W\\",\\"n\\":\\"W\\"', "}", ",", "{", '\\"expr\\":\\"L\\",\\"n\\":\\"L\\"', "}", "]")), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12, padding: 14, background: "var(--accent-soft)", borderRadius: 4, fontSize: 11, color: T.t3, lineHeight: 1.6 } }, /* @__PURE__ */ React.createElement("strong", null, "Print Zones (JSON)"), ' \u2014 defines where print areas (placeholder "LOGO") appear on the sheet.', /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "Format:"), " ", /* @__PURE__ */ React.createElement("code", null, "{", '\\"<c\xF3digo>\\": [', "{", '\\"l\\":<idx>, \\"w\\":<idx>', "}", ", ...]", "}"), /* @__PURE__ */ React.createElement("br", null), "\xA0\xA0\u2022 ", /* @__PURE__ */ React.createElement("code", null, "<c\xF3digo>"), " = code from Print Locations table (e.g.: ", /* @__PURE__ */ React.createElement("code", null, '"13"'), " = Front)", /* @__PURE__ */ React.createElement("br", null), "\xA0\xA0\u2022 ", /* @__PURE__ */ React.createElement("code", null, "l"), " = index in ", /* @__PURE__ */ React.createElement("code", null, "panels_l"), " (0 = leftmost panel)", /* @__PURE__ */ React.createElement("br", null), "\xA0\xA0\u2022 ", /* @__PURE__ */ React.createElement("code", null, "w"), " = index in ", /* @__PURE__ */ React.createElement("code", null, "panels_w"), " (0 = top)", /* @__PURE__ */ React.createElement("br", null), "\xA0\xA0\u2022 Cada ", /* @__PURE__ */ React.createElement("code", null, "{", "l,w", "}"), ' marks a rectangle where "LOGO" appears', /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "Wildcard:"), " ", /* @__PURE__ */ React.createElement("code", null, '"*"'), " as value \u2192 all body panels of the model. Excludes Glue/G/Pat/Flap/Aba.", /* @__PURE__ */ React.createElement("br", null), "\xA0\xA0Ex: ", /* @__PURE__ */ React.createElement("code", null, "{", '\\"21\\": \\"*\\"', "}"), " \u2192 Full Size paints the entire box.", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "NULL:"), " ", /* @__PURE__ */ React.createElement("code", null, "print_zones = null"), " (or empty) \u2192 disables overlay for this model. Useful for dividers.", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "Example (FEFCO 201, RSC American):"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("code", null, "{", '\\"12\\":[', "{", '\\"l\\":1,\\"w\\":0', "}", ",", "{", '\\"l\\":2,\\"w\\":0', "}", ",", "{", '\\"l\\":3,\\"w\\":0', "}", ",", "{", '\\"l\\":4,\\"w\\":0', "}", '],\\"13\\":[', "{", '\\"l\\":2,\\"w\\":1', "}", '],\\"14\\":[', "{", '\\"l\\":1,\\"w\\":1', "}", ",", "{", '\\"l\\":3,\\"w\\":1', "}", '],\\"21\\":\\"*\\"', "}"))), adminTab === "Globals" && /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 500 } }, /* @__PURE__ */ React.createElement("div", { style: cardSt }, /* @__PURE__ */ React.createElement("div", { style: cardBd }, /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Tooling Cost / cm2"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "number", step: "0.001", value: globals.toolingCostPerCm2, onChange: (e) => setGlobals((g) => ({ ...g, toolingCostPerCm2: +e.target.value || 0 })), onBlur: saveGL })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Min Order m2"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "number", step: "10", value: globals.minOrderM2, onChange: (e) => setGlobals((g) => ({ ...g, minOrderM2: +e.target.value || 0 })), onBlur: saveGL })), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Max Truck Height (mm)"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "number", step: "100", value: globals.maxTruckHeightMm || 2400, onChange: (e) => setGlobals((g) => ({ ...g, maxTruckHeightMm: +e.target.value || 2400 })), onBlur: saveGL }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.t4, marginTop: 4 } }, "Determines if 2 pallets can be stacked in transport")))), false), adminTab === "Pallets" && /* @__PURE__ */ React.createElement(DataTable, { appLabel: "valora", viewId: "pallets", rows: pallets, setRows: setPallets, idKey: "palletTypeId", onSaveRow: savePA, onDeleteRow: delPA, cols: [{ key: "palletTypeId", label: "ID", def: "", width: 70, minWidth: 60, fixed: true }, { key: "name", label: "Name", def: "", width: 110, minWidth: 90 }, { key: "lengthMm", label: "L mm", num: true, def: 1200, width: 80 }, { key: "widthMm", label: "W mm", num: true, def: 800, width: 85 }, { key: "maxHeightMm", label: "Max H", num: true, def: 1800, width: 90 }, { key: "price", label: "Price", num: true, def: 8, fmt: EUR, width: 90 }, { key: "active", label: "Active", def: true, opts: ["true", "false"], width: 95 }] }), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 20, padding: 14, background: "var(--accent-soft)", borderRadius: 4, fontSize: 12, color: T.t3 } }, "Changes are saved automatically to the database when leaving each field.")), page === "users" && canManageUsers && /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflow: "auto", padding: "22px 26px" } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 20, marginBottom: 16 } }, "User Management"), /* @__PURE__ */ React.createElement("div", { style: { ...cardSt, maxWidth: 500 } }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Create New User" })), /* @__PURE__ */ React.createElement("div", { style: cardBd }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Email"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "email", placeholder: "email@empresa.pt", value: newUser.email, onChange: (e) => setNewUser({ ...newUser, email: e.target.value }) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Password"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "text", placeholder: "initial password", value: newUser.password, onChange: (e) => setNewUser({ ...newUser, password: e.target.value }) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Name"), /* @__PURE__ */ React.createElement("input", { style: inS, type: "text", placeholder: "Nome", value: newUser.displayName, onChange: (e) => setNewUser({ ...newUser, displayName: e.target.value }) })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: lbS }, "Role"), /* @__PURE__ */ React.createElement("select", { style: inS, value: newUser.role, onChange: (e) => setNewUser({ ...newUser, role: e.target.value }) }, /* @__PURE__ */ React.createElement("option", { value: "user" }, "User"), /* @__PURE__ */ React.createElement("option", { value: "jn" }, "JN"), /* @__PURE__ */ React.createElement("option", { value: "jnadmin" }, "JN Admin"), /* @__PURE__ */ React.createElement("option", { value: "raja" }, "VALORA")))), nuErr && /* @__PURE__ */ React.createElement("div", { style: { color: T.err, fontSize: 12, marginBottom: 8 } }, nuErr), nuOk && /* @__PURE__ */ React.createElement("div", { style: { color: T.ok, fontSize: 12, marginBottom: 8 } }, nuOk), /* @__PURE__ */ React.createElement("button", { onClick: createUser, style: btnS("pri") }, "Create User"))), /* @__PURE__ */ React.createElement("div", { style: { ...cardSt, marginTop: 16 } }, /* @__PURE__ */ React.createElement("div", { style: cardHd }, /* @__PURE__ */ React.createElement(SecTitle, { text: "Users" }), /* @__PURE__ */ React.createElement("button", { onClick: loadUsers, style: btnS("out") }, "Refresh")), /* @__PURE__ */ React.createElement(
      window.HubList.List,
      {
        appLabel: "valora",
        viewId: "users",
        pagination: "client",
        rowKey: (u) => u.id,
        columns: [
          { key: "email", label: "Email", width: 220, minWidth: 170, fixed: true },
          { key: "nome", label: "Nome", width: 180, minWidth: 140, render: (u) => u.display_name || "-" },
          { key: "role", label: "Role", width: 140, minWidth: 110, render: (u) => /* @__PURE__ */ React.createElement(Badge, { text: RL[u.role] || u.role, color: RC[u.role] || "ok" }) }
        ],
        data: userList,
        empty: 'Click "Refresh"'
      }
    )))));
  }
  window.ValoraView = ValoraView;
})();

// ===== valora/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "valora",
  order: 5,
  name: "VALORA",
  sub: "Calculadora de caixas",
  accent: "#0076CE",
  brandLogo: "/static/assets/valora-logo.png",
  brandEmoji: "\u{1F4E6}",
  brandEmojiFontSize: "26px",
  home: "valora",
  launcher: true,
  frontendFiles: [
    "frontend/view.jsx"
  ],
  routes: [
    { id: "valora", section: "VALORA", icon: "ruler", label: "Calculadora", adminOnly: false, title: "VALORA \u2014 Calculadora de caixas", tooltip: "Calculadora de pre\xE7os de caixas" }
  ]
  // NO render map — closure stays in app.jsx (see header comment).
});

// ===== whale/frontend/entry.jsx =====
function _readUrlRange(defaultPreset) {
  const params = window.HubRouter.current().params;
  const from = params.get("from");
  const to = params.get("to");
  const preset = params.get("preset") || defaultPreset;
  if (from && to) return { preset, from, to };
  const year = params.get("year");
  if (year) {
    const cumulative = params.get("cumulative") === "1" || params.get("cumulative") === "true";
    const yy = Number(year);
    const p = cumulative ? `cumulative:${yy}` : `year:${yy}`;
    const r2 = window.HubCharts.resolvePreset(p, /* @__PURE__ */ new Date());
    return { preset: p, from: r2.from, to: r2.to };
  }
  const r = window.HubCharts.resolvePreset(defaultPreset, /* @__PURE__ */ new Date());
  return { preset: defaultPreset, from: r.from, to: r.to };
}
function _writeUrlRange(range) {
  window.HubRouter.setParams({
    preset: range.preset,
    from: range.from,
    to: range.to,
    year: null,
    cumulative: null
    // legado: limpa-se se ainda lá estiver
  });
}
function useWhaleRange(defaultPreset = "ytd") {
  const [range, _setRange] = useState(() => _readUrlRange(defaultPreset));
  useEffect(() => {
    _writeUrlRange(range);
  }, []);
  const setRange = (next) => {
    _setRange(next);
    _writeUrlRange(next);
  };
  return { range, setRange };
}
window.__whaleReadUrlRange = _readUrlRange;
window.__whaleWriteUrlRange = _writeUrlRange;
window.__whaleUseWhaleRange = useWhaleRange;
function WhaleAccountsView({ routeId, entidade, params, navigate, reportCrumb } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { range, setRange } = useWhaleRange("ytd");
  const [search, setSearch] = useState("");
  const openNo = entidade ? Number(entidade) : null;
  const [users, setUsers] = useState([]);
  useEffect(() => {
    window.API.users?.().then((r) => setUsers(r.results || r || [])).catch(() => setUsers([]));
  }, []);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await window.API.whaleAccounts({ from: range.from, to: range.to });
      setData(r);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, [range.from, range.to]);
  const filtered = useMemo(() => {
    if (!data?.results) return [];
    const q = search.trim().toLowerCase();
    if (!q) return data.results;
    return data.results.filter(
      (a) => String(a.no).includes(q) || (a.nome || "").toLowerCase().includes(q)
    );
  }, [data, search]);
  const fmt = (v) => Number(v || 0).toLocaleString("pt-PT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const fmtDate = (s) => s ? new Date(s).toLocaleDateString("pt-PT") : "\u2014";
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "WHALES \u2014 Big Accounts"), data && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 ", filtered.length, " de ", data.count, " contas \xB7 fatura\xE7\xE3o total ", fmt(data.total), " \u20AC"), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" } }, /* @__PURE__ */ React.createElement(window.HubCharts.DateFilter, { value: range, onChange: setRange }), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: load }, /* @__PURE__ */ React.createElement(Ico.refresh, null), " Atualizar"))), /* @__PURE__ */ React.createElement("div", { className: "filters", style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { className: "search-input" }, /* @__PURE__ */ React.createElement(Ico.search, null), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      placeholder: "Pesquisar n\xBA ou nome\u2026",
      value: search,
      onChange: (e) => setSearch(e.target.value)
    }
  ))), error && /* @__PURE__ */ React.createElement("div", { style: { color: "#c4434b", padding: 10, fontSize: 12 } }, error), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      loading,
      appLabel: "whale",
      viewId: "ranking",
      columns: [
        { key: "no", label: "N\xBA", width: 70, minWidth: 60, fixed: true, mono: true },
        {
          key: "nome",
          label: "Nome",
          width: 220,
          minWidth: 160,
          render: (a) => /* @__PURE__ */ React.createElement("strong", null, a.nome || "\u2014")
        },
        { key: "invoices", label: "Faturas", width: 90, minWidth: 70, align: "right", mono: true },
        {
          key: "total",
          label: "Total (\u20AC)",
          width: 120,
          minWidth: 100,
          align: "right",
          mono: true,
          render: (a) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, fmt(a.total))
        },
        {
          key: "delta_homologo_pct",
          label: "\u0394% Hom\xF3logo",
          width: 120,
          minWidth: 100,
          align: "right",
          mono: true,
          title: "\u0394% Ano Atual vs Ano Hom\xF3logo (ERP)",
          render: (a) => /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: a.delta_homologo_pct })
        },
        {
          key: "trend",
          label: "Tend\xEAncia",
          width: 195,
          minWidth: 150,
          render: (a) => /* @__PURE__ */ React.createElement(window.HubCharts.TrendPill, { arrow: a.trend_arrow, label: a.trend_label })
        },
        {
          key: "rank_l1",
          label: `#${data?.month_label_l1 || "L-1"}`,
          width: 80,
          minWidth: 64,
          align: "right",
          mono: true,
          title: `Rank em ${data?.month_label_l1 || "\u2014"}`,
          render: (a) => a.rank_l1 != null ? `#${a.rank_l1}` : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
        },
        {
          key: "rank_l2",
          label: `#${data?.month_label_l2 || "L-2"}`,
          width: 80,
          minWidth: 64,
          align: "right",
          mono: true,
          title: `Rank em ${data?.month_label_l2 || "\u2014"}`,
          render: (a) => a.rank_l2 != null ? `#${a.rank_l2}` : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")
        },
        {
          key: "atribuido",
          label: "Atribu\xEDdo",
          width: 150,
          minWidth: 120,
          render: (a) => a.atribuido ? /* @__PURE__ */ React.createElement(UserPill, { username: a.atribuido, users, compact: true }) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)", fontSize: 12 } }, "\u2014")
        },
        {
          key: "last_date",
          label: "\xDAltima fatura",
          width: 110,
          minWidth: 100,
          render: (a) => /* @__PURE__ */ React.createElement("span", { className: "td-muted", style: { fontSize: 12 } }, fmtDate(a.last_date))
        }
      ],
      data: filtered,
      pagination: "client",
      rowKey: (a) => a.no,
      onRowClick: (a) => navigate({ routeId, entidade: String(a.no), params }),
      empty: "Sem Big Accounts (verifica liga\xE7\xE3o ERP em Stock \u2192 Configura\xE7\xF5es ou o flag cl2.u_bigacc)."
    }
  ), Number.isFinite(openNo) && /* @__PURE__ */ React.createElement(
    WhaleAccountDrawer,
    {
      no: openNo,
      range,
      navList: filtered,
      users,
      onNavigate: (a) => navigate({ routeId, entidade: String(a.no), params }),
      onClose: () => navigate({ routeId, params }),
      reportCrumb
    }
  ));
}
function WhaleAccountDrawer({ no, range, onClose, navList = [], onNavigate, users = [], reportCrumb }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [obs, setObs] = useState("");
  const [logs, setLogs] = useState([]);
  const obsRef = useRef("");
  const savedObsRef = useRef("");
  const noRef = useRef(no);
  useEffect(() => {
    obsRef.current = obs;
  }, [obs]);
  useEffect(() => {
    noRef.current = no;
  }, [no]);
  const flushObs = () => {
    const cur = obsRef.current || "";
    if (cur !== (savedObsRef.current || "")) {
      window.API.whaleAccountUpdate(noRef.current, { observacoes: cur }).catch((e) => console.error("flushObs failed:", e));
      savedObsRef.current = cur;
    }
  };
  const reload = () => window.API.whaleAccount(no, { from: range.from, to: range.to }).then((d) => {
    setData(d);
    const v = d?.meta?.observacoes || "";
    setObs(v);
    savedObsRef.current = v;
  }).catch((e) => setError(e.message));
  useEffect(() => {
    reload();
  }, [no, range.from, range.to]);
  useEffect(() => {
    if (no == null) {
      setLogs([]);
      return;
    }
    let cancelled = false;
    fetch(`/api/whale/accounts/${no}/audit/`, { credentials: "include" }).then((r) => r.ok ? r.json() : []).then((events) => {
      if (!cancelled) setLogs((events || []).map((e) => ({
        id: e.id,
        evento: e.verb,
        descricao: e.summary,
        actor_username: e.actor_name,
        criado_em: e.when
      })));
    }).catch(() => {
      if (!cancelled) setLogs([]);
    });
    return () => {
      cancelled = true;
    };
  }, [no, data]);
  useEffect(() => {
    reportCrumb && reportCrumb(data?.nome || null);
    return () => {
      reportCrumb && reportCrumb(null);
    };
  }, [data, reportCrumb]);
  useEffect(() => () => flushObs(), []);
  const closeAndFlush = () => {
    flushObs();
    onClose && onClose();
  };
  useEffect(() => {
    const h2 = (e) => {
      const t = e.target, tag = t && t.tagName || "";
      if (tag === "INPUT" || tag === "TEXTAREA" || t && t.isContentEditable) return;
      if (e.key === "Escape") {
        closeAndFlush();
        return;
      }
      if (!onNavigate || navList.length < 2) return;
      const idx = navList.findIndex((a) => a.no === no);
      if (e.key === "ArrowLeft" && idx > 0) onNavigate(navList[idx - 1]);
      if (e.key === "ArrowRight" && idx >= 0 && idx < navList.length - 1) onNavigate(navList[idx + 1]);
    };
    document.addEventListener("keydown", h2);
    return () => document.removeEventListener("keydown", h2);
  }, [no, navList, onNavigate, onClose]);
  const patchMeta = async (patch) => {
    try {
      await window.API.whaleAccountUpdate(no, patch);
      reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const delAcao = async (id) => {
    if (!await window.hubConfirm({ message: "Apagar esta a\xE7\xE3o?" })) return;
    try {
      const csrf = (document.cookie.match(/csrftoken=([^;]+)/) || [])[1];
      const resp = await fetch(`/api/whale/acoes/${id}/`, {
        method: "DELETE",
        credentials: "include",
        headers: csrf ? { "X-CSRFToken": csrf } : {}
      });
      if (!resp.ok && resp.status !== 204) throw new Error(`HTTP ${resp.status}`);
      reload();
    } catch (e) {
      setError(e.message);
    }
  };
  const fmt = (v) => Number(v || 0).toLocaleString("pt-PT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const fmtDate = (s) => s ? new Date(s).toLocaleDateString("pt-PT") : "\u2014";
  const monthly = data?.monthly || [];
  const maxTotal = Math.max(0.01, ...monthly.map((m) => Number(m.total)));
  const w = 700, h = 180, padL = 40, padR = 12, padT = 12, padB = 24;
  const innerW = w - padL - padR, innerH = h - padT - padB;
  const slot = monthly.length ? innerW / monthly.length : innerW;
  const reg = (() => {
    if (monthly.length < 2) return null;
    const n = monthly.length;
    let sx = 0, sy = 0, sxx = 0, sxy = 0;
    monthly.forEach((m, i) => {
      const y = Number(m.total) || 0;
      sx += i;
      sy += y;
      sxx += i * i;
      sxy += i * y;
    });
    const denom = n * sxx - sx * sx;
    if (!denom) return null;
    const a = (n * sxy - sx * sy) / denom;
    const b = (sy - a * sx) / n;
    return { a, b };
  })();
  const navIdx = navList.findIndex((a) => a.no === no);
  const prevAcc = navIdx > 0 ? navList[navIdx - 1] : null;
  const nextAcc = navIdx >= 0 && navIdx < navList.length - 1 ? navList[navIdx + 1] : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "drawer-overlay" }), /* @__PURE__ */ React.createElement("aside", { className: "drawer" }, /* @__PURE__ */ React.createElement("header", { className: "drawer-header" }, onNavigate && navList.length > 1 && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 4, marginRight: 8 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      disabled: !prevAcc,
      onClick: () => prevAcc && onNavigate(prevAcc),
      title: "Anterior"
    },
    "\u2039"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only sm",
      disabled: !nextAcc,
      onClick: () => nextAcc && onNavigate(nextAcc),
      title: "Pr\xF3ximo"
    },
    "\u203A"
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 2, flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "ref-code" }, "#", no), /* @__PURE__ */ React.createElement("div", { className: "ref-desc" }, data?.nome || "\u2026")), data && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, data.invoices_count, " faturas \xB7 ", fmt(data.total), " \u20AC"), /* @__PURE__ */ React.createElement("button", { className: "drawer-close", onClick: closeAndFlush, title: "Fechar (Esc)" }, /* @__PURE__ */ React.createElement(Ico.close, null))), error && /* @__PURE__ */ React.createElement("div", { style: { padding: 10, color: "#c4434b", fontSize: 12 } }, error), !data && !error && /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026"), data && /* @__PURE__ */ React.createElement("div", { className: "drawer-body", style: {
    display: "grid",
    gridTemplateColumns: "minmax(680px, 1fr) minmax(360px, 420px)",
    gap: 0,
    overflowX: "auto",
    overflowY: "hidden",
    flex: 1
  } }, /* @__PURE__ */ React.createElement("div", { style: { overflow: "auto", padding: 14, borderRight: "1px solid var(--border)", minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Dados ERP \xB7 read-only"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "var(--muted)", marginBottom: 12 } }, "Tend\xEAncia ", data.trend_arrow != null ? (() => {
    const up = data.trend_arrow > 0, down = data.trend_arrow < 0;
    const bg = up ? "#dcfce7" : down ? "#fee2e2" : "#e5e7eb";
    const fg = up ? "#166534" : down ? "#991b1b" : "#374151";
    const txt = up ? "\u2197 a crescer" : down ? "\u2198 a cair" : "\u2192 est\xE1vel";
    return /* @__PURE__ */ React.createElement("span", { style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: "2px 8px",
      borderRadius: 10,
      fontSize: 11,
      fontWeight: 600,
      background: bg,
      color: fg
    } }, txt);
  })() : "\u2014", data.trend_text && /* @__PURE__ */ React.createElement(
    "span",
    {
      style: { marginLeft: 8, fontFamily: "var(--font-mono)", fontSize: 11 },
      title: "F\xF3rmula de regress\xE3o"
    },
    data.trend_text
  )), data.kpis?.length > 0 && (() => {
    const visibleKpis = data.kpis.filter((k) => k.value != null);
    const hasDonut = (data.tipoart_sales || []).some((t) => Number(t.vlr_ano) > 0);
    return /* @__PURE__ */ React.createElement("div", { className: "m-kpi4", style: {
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      gridAutoRows: "1fr",
      gap: 8,
      marginBottom: 16
    } }, hasDonut && /* @__PURE__ */ React.createElement("div", { style: {
      gridColumn: "3 / span 2",
      gridRow: "1 / span 2",
      padding: 10,
      background: "var(--bg)",
      borderRadius: 6,
      border: "1px solid var(--border)",
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    } }, /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 10.5,
      color: "var(--muted)",
      fontFamily: "var(--font-mono)",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      marginBottom: 8
    } }, "Mix por tipo de artigo"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      window.HubCharts.Donut,
      {
        fmt,
        items: data.tipoart_sales.filter((t) => Number(t.vlr_ano) > 0).map((t) => ({ label: t.tipoart || "\u2014", value: t.vlr_ano })),
        size: 130
      }
    ))), visibleKpis.map((k) => /* @__PURE__ */ React.createElement(window.HubCharts.KpiCard, { key: k.indicator, kpi: k, fmt })));
  })(), /* @__PURE__ */ React.createElement("div", { style: { height: 12 } }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Evolu\xE7\xE3o mensal \xB7 \xFAltimos 12m vs hom\xF3logo"), /* @__PURE__ */ React.createElement(window.HubCharts.Rolling12m, { data: data.rolling_12m, fmt }), /* @__PURE__ */ React.createElement("div", { style: { height: 16 } }), /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Vendas por tipo de artigo \xB7 \xFAltimos 24 meses"), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "whale",
      viewId: "artigos",
      columns: [
        {
          key: "tipoart",
          label: "Tipo artigo",
          width: 160,
          minWidth: 120,
          fixed: true,
          render: (t) => /* @__PURE__ */ React.createElement("strong", null, t.tipoart || "\u2014")
        },
        {
          key: "vlr_ano",
          label: "Vendas ano",
          width: 120,
          minWidth: 100,
          align: "right",
          mono: true,
          render: (t) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 500 } }, fmt(t.vlr_ano), " \u20AC")
        },
        {
          key: "vlr_ano_hm",
          label: "Hom\xF3logo",
          width: 120,
          minWidth: 100,
          align: "right",
          mono: true,
          render: (t) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, fmt(t.vlr_ano_hm), " \u20AC")
        },
        {
          key: "delta_pct",
          label: "\u0394%",
          width: 90,
          minWidth: 70,
          align: "right",
          mono: true,
          render: (t) => /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: t.delta_pct })
        },
        {
          key: "qtd_l12m",
          label: "Qtd 12m",
          width: 90,
          minWidth: 70,
          align: "right",
          mono: true,
          title: "Quantidade \xFAltimos 12 meses",
          render: (t) => Number(t.qtd_l12m).toLocaleString("pt-PT", { maximumFractionDigits: 0 })
        },
        { key: "skus", label: "SKUs", width: 70, minWidth: 60, align: "right", mono: true },
        {
          key: "evolucao",
          label: "Evolu\xE7\xE3o 24m",
          width: 170,
          minWidth: 140,
          render: (t) => {
            const sw = 160, sh = 36, sp = 3;
            const hm = t.series.slice(0, 12);
            const cur = t.series.slice(12, 24);
            const max = Math.max(0.01, ...t.series);
            const xStep = (sw - sp * 2) / Math.max(1, 11);
            const toPts = (arr) => arr.map((v, i) => `${sp + i * xStep},${sh - sp - v / max * (sh - sp * 2)}`).join(" ");
            return /* @__PURE__ */ React.createElement("span", { title: "Linha grossa: \xFAltimos 12m \xB7 Linha clara tracejada: 12m hom\xF3logo" }, /* @__PURE__ */ React.createElement("svg", { width: sw, height: sh, viewBox: `0 0 ${sw} ${sh}`, style: { display: "block" } }, /* @__PURE__ */ React.createElement(
              "polyline",
              {
                points: toPts(hm),
                fill: "none",
                stroke: "var(--muted)",
                strokeWidth: "1",
                strokeDasharray: "2 2",
                opacity: "0.7"
              }
            ), /* @__PURE__ */ React.createElement("polyline", { points: toPts(cur), fill: "none", stroke: "var(--accent)", strokeWidth: "1.8" })));
          }
        }
      ],
      data: data.tipoart_sales || [],
      pagination: "client",
      rowKey: (t) => t.tipoart,
      empty: "Sem dados em u_indicst."
    }
  )), /* @__PURE__ */ React.createElement("div", { style: { overflow: "auto", padding: 14, background: "var(--bg)" } }, /* @__PURE__ */ React.createElement("div", { className: "section-label" }, "Atribu\xEDdo ao tratamento"), /* @__PURE__ */ React.createElement(
    InlineUserPicker,
    {
      username: data.meta?.atribuido,
      users,
      appSlug: "whale",
      onChange: (uId) => {
        if (uId == null) return patchMeta({ atribuido: "__null__" });
        const u = users.find((x) => x.id === uId);
        if (u) patchMeta({ atribuido: u.username });
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { height: 16 } }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement("div", { className: "section-label", style: { marginBottom: 0 } }, "Observa\xE7\xF5es internas"), (obs || "") !== (data.meta?.observacoes || "") && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn primary sm",
      onClick: () => patchMeta({ observacoes: obs })
    },
    "Guardar"
  )), /* @__PURE__ */ React.createElement(
    "textarea",
    {
      value: obs,
      onChange: (e) => setObs(e.target.value),
      onBlur: () => {
        if ((obs || "") !== (data.meta?.observacoes || "")) {
          patchMeta({ observacoes: obs });
        }
      },
      placeholder: "Notas internas sobre esta conta\u2026",
      rows: 4,
      style: { width: "100%", resize: "vertical", fontFamily: "inherit", fontSize: 13, marginTop: 6 }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", marginTop: 4 } }, (obs || "") !== (data.meta?.observacoes || "") ? "Altera\xE7\xF5es por guardar \u2014 clica Guardar (ou sai do campo)." : data.meta?.atualizado_em ? `\xDAltima grava\xE7\xE3o: ${fmtDateTime(new Date(data.meta.atualizado_em))}` : "Sem grava\xE7\xF5es ainda."), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React.createElement(
    HubActionTimeline,
    {
      title: "Hist\xF3rico",
      appLabel: "whale",
      appSlug: "whale",
      resource: "conta",
      resourceId: no,
      users,
      me: window.SR_ME,
      streams: {
        acoes: {
          items: (data.acoes || []).map((a) => ({
            id: a.id,
            tipoNome: a.tipo_nome,
            autor: a.autor,
            criadoEm: a.criado_em ? new Date(a.criado_em) : null,
            descricao: a.descricao,
            system: a.tipo_id_slug === "sistema"
          })),
          api: {
            onAdd: async (tipo, descricao) => {
              const csrf = (document.cookie.match(/csrftoken=([^;]+)/) || [])[1];
              const resp = await fetch(`/api/whale/accounts/${no}/acoes/`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json", ...csrf ? { "X-CSRFToken": csrf } : {} },
                body: JSON.stringify({ tipo_id_slug: tipo, descricao })
              });
              if (!resp.ok) throw new Error(`HTTP ${resp.status}: ${await resp.text()}`);
              reload();
            },
            onDelete: (a) => delAcao(a.id)
          }
        },
        logs: { items: logs }
      }
    }
  )))));
}
function WhaleDashboardView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const { range, setRange } = useWhaleRange("ytd");
  const reload = () => window.API.whaleStats({ from: range.from, to: range.to }).then(setData).catch((e) => setError(e.message));
  useEffect(() => {
    reload();
  }, [range.from, range.to]);
  const fmt = (v) => Number(v || 0).toLocaleString("pt-PT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const fmtInt = (v) => Number(v || 0).toLocaleString("pt-PT", { maximumFractionDigits: 0 });
  if (error) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "#c4434b" } }, error);
  if (!data) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026");
  const fmtVal = (v, format) => {
    if (v == null) return "\u2014";
    if (format === "eur") return `${fmt(v)} \u20AC`;
    if (format === "pct") return `${Number(v).toFixed(2)} %`;
    return fmtInt(v);
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "WHALES \u2014 Dashboard agregado"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 ", data.accounts, " contas (", data.accounts_with_indicators, " com indicadores)"), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" } }, /* @__PURE__ */ React.createElement(window.HubCharts.DateFilter, { value: range, onChange: setRange }), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: reload }, /* @__PURE__ */ React.createElement(Ico.refresh, null), " Atualizar"))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { padding: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, alignItems: "center" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase" } }, "Fatura\xE7\xE3o total \u2014 per\xEDodo"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 24, fontWeight: 700, marginTop: 4 } }, fmt(data.totals.V_Ano_Atual), " \u20AC")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase" } }, "Hom\xF3logo (mesmo per\xEDodo \u22121 ano)"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, color: "var(--text-2)", marginTop: 4 } }, fmt(data.totals.V_Ano_Homologo), " \u20AC")), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "right" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)", textTransform: "uppercase" } }, "\u0394% vs hom\xF3logo"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6 } }, /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: data.totals.delta_pct }))))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Indicadores agregados"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 soma para contadores e EUR; m\xE9dia para % e tempos")), /* @__PURE__ */ React.createElement("div", { style: {
    padding: 14,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 10
  } }, data.kpis.map((k) => /* @__PURE__ */ React.createElement("div", { key: k.indicator, style: {
    padding: 10,
    background: "var(--bg)",
    borderRadius: 6,
    border: "1px solid var(--border)"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 10.5,
    color: "var(--muted)",
    fontFamily: "var(--font-mono)",
    textTransform: "uppercase",
    letterSpacing: "0.04em"
  } }, k.label, " ", /* @__PURE__ */ React.createElement("span", { style: { opacity: 0.6 } }, "(", k.mode, ")")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 17, fontWeight: 600, marginTop: 4, fontVariantNumeric: "tabular-nums" } }, fmtVal(k.value, k.format)), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
    fontSize: 11,
    color: "var(--muted)"
  } }, k.prev != null && /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "var(--font-mono)" } }, fmtVal(k.prev, k.format)), k.delta_pct != null && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto" } }, /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: k.delta_pct, invert: k.invert }))))))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Top 5 a crescer"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 \u0394% V_Ano_Atual / V_Ano_Homologo")), /* @__PURE__ */ React.createElement(MoversTable, { rows: data.top_growing, fmt })), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Top 5 a cair")), /* @__PURE__ */ React.createElement(MoversTable, { rows: data.top_declining, fmt }))));
}
function MoversTable({ rows, fmt }) {
  return /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "whale",
      viewId: "homologo",
      columns: [
        { key: "no", label: "N\xBA", width: 70, minWidth: 60, fixed: true, mono: true },
        { key: "nome", label: "Nome", width: 200, minWidth: 150 },
        {
          key: "cur",
          label: "Atual (\u20AC)",
          width: 110,
          minWidth: 90,
          align: "right",
          mono: true,
          render: (r) => fmt(r.cur)
        },
        {
          key: "prev",
          label: "Hom\xF3logo (\u20AC)",
          width: 110,
          minWidth: 90,
          align: "right",
          mono: true,
          render: (r) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, fmt(r.prev))
        },
        {
          key: "delta",
          label: "\u0394%",
          width: 130,
          minWidth: 100,
          align: "right",
          mono: true,
          render: (r) => /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: r.delta })
        }
      ],
      data: rows,
      pagination: "client",
      rowKey: (r) => r.no,
      empty: "\u2014"
    }
  );
}
function WhaleMonthlyRankingView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const { range, setRange } = useWhaleRange("ytd");
  const [top, setTop] = useState(15);
  const [openNo, setOpenNo] = useState(null);
  const reload = () => window.API.whaleMonthlyRanking({ from: range.from, to: range.to, top }).then(setData).catch((e) => setError(e.message));
  useEffect(() => {
    reload();
  }, [range.from, range.to, top]);
  const fmt = (v) => Number(v || 0).toLocaleString("pt-PT", { maximumFractionDigits: 0 });
  const MONTHS = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez"
  ];
  if (error) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "#c4434b" } }, error);
  if (!data) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "var(--muted)" } }, "A carregar\u2026");
  const rankDelta = (cur, prev) => {
    if (cur == null || prev == null) return null;
    return prev - cur;
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 20, width: "100%" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "WHALES \u2014 Ranking mensal"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 Top ", data.top, " \xB7 ", data.year, " vs ", data.prev_year), (data.date_from || data.date_to) && /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, color: "var(--muted)" } }, "\xB7 ", data.date_from, " \u2192 ", data.date_to), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" } }, /* @__PURE__ */ React.createElement(window.HubCharts.DateFilter, { value: range, onChange: setRange, hidePresets: ["last-12m"] }), /* @__PURE__ */ React.createElement("label", { style: { fontSize: 12 } }, "Top", /* @__PURE__ */ React.createElement("select", { value: top, onChange: (e) => setTop(Number(e.target.value)), style: { marginLeft: 6 } }, [10, 15, 25, 50].map((n) => /* @__PURE__ */ React.createElement("option", { key: n, value: n }, n)))), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: reload }, /* @__PURE__ */ React.createElement(Ico.refresh, null), " Atualizar"))), /* @__PURE__ */ React.createElement("div", { className: "panel", style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Totais mensais"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 soma de todas as Big Accounts \xB7 \u0394% vs mesmo m\xEAs ", data.prev_year)), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "whale",
      viewId: "mensal",
      columns: [
        {
          key: "month",
          label: "M\xEAs",
          width: 90,
          minWidth: 70,
          fixed: true,
          render: (m) => MONTHS[m.month - 1]
        },
        {
          key: "total",
          label: `${data.year} (\u20AC)`,
          width: 120,
          minWidth: 100,
          align: "right",
          mono: true,
          render: (m) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 500 } }, fmt(m.total))
        },
        {
          key: "prev_total",
          label: `${data.prev_year} (\u20AC)`,
          width: 120,
          minWidth: 100,
          align: "right",
          mono: true,
          render: (m) => /* @__PURE__ */ React.createElement("span", { className: "td-muted" }, fmt(m.prev_total))
        },
        {
          key: "delta_pct",
          label: "\u0394%",
          width: 90,
          minWidth: 70,
          align: "right",
          mono: true,
          render: (m) => /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: m.delta_pct })
        }
      ],
      rowStyle: (m) => m.in_range === false ? { opacity: 0.35 } : void 0,
      data: data.month_totals,
      pagination: "client",
      rowKey: (m) => m.month
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "panel" }, /* @__PURE__ */ React.createElement("div", { className: "panel-h" }, /* @__PURE__ */ React.createElement("span", { className: "title" }, "Ranking por conta \xB7 m\xEAs a m\xEAs"), /* @__PURE__ */ React.createElement("span", { className: "sub" }, "\xB7 cada c\xE9lula: valor ", data.year, " \xB7 \u0394% vs mesmo m\xEAs ", data.prev_year, "\xB7 ", /* @__PURE__ */ React.createElement("strong", null, "\u25B2N"), " subiu N posi\xE7\xF5es / ", /* @__PURE__ */ React.createElement("strong", null, "\u25BCN"), " desceu N posi\xE7\xF5es vs ", data.prev_year)), /* @__PURE__ */ React.createElement(
    window.HubList.List,
    {
      appLabel: "whale",
      viewId: "anual",
      columns: [
        {
          key: "rank",
          label: "#",
          width: 72,
          minWidth: 60,
          fixed: true,
          render: (a) => {
            const rd = rankDelta(a.rank, a.prev_rank);
            return /* @__PURE__ */ React.createElement("span", { title: a.prev_rank != null ? `Posi\xE7\xE3o atual: #${a.rank} \xB7 em ${data.prev_year}: #${a.prev_rank}` : `Posi\xE7\xE3o atual: #${a.rank}` }, /* @__PURE__ */ React.createElement("strong", null, a.rank), rd != null && rd !== 0 && /* @__PURE__ */ React.createElement("span", { style: {
              marginLeft: 4,
              fontSize: 10,
              color: rd > 0 ? "#166534" : "#991b1b"
            } }, rd > 0 ? `\u25B2${rd}` : `\u25BC${Math.abs(rd)}`));
          }
        },
        {
          key: "nome",
          label: "Conta",
          width: 200,
          minWidth: 180,
          render: (a) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 600 } }, a.nome), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)", fontFamily: "var(--font-mono)" } }, "#", a.no))
        },
        ...MONTHS.map((mLabel, mi) => {
          const monthNum = mi + 1;
          return {
            key: `m${monthNum}`,
            label: mLabel,
            width: 90,
            minWidth: 74,
            align: "right",
            mono: true,
            render: (a) => {
              const m = (a.monthly || []).find((x) => x.month === monthNum);
              if (!m) return /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014");
              const total = Number(m.total);
              const drk = rankDelta(m.rank, m.prev_rank);
              const tipLines = [
                `${MONTHS[m.month - 1]} ${data.year}: ${total ? fmt(total) + " \u20AC" : "sem fatura\xE7\xE3o"}`,
                `${MONTHS[m.month - 1]} ${data.prev_year}: ${Number(m.prev_total) ? fmt(m.prev_total) + " \u20AC" : "sem fatura\xE7\xE3o"}`
              ];
              if (m.rank) tipLines.push(`Ranking ${data.year}: #${m.rank}`);
              if (m.prev_rank) tipLines.push(`Ranking ${data.prev_year}: #${m.prev_rank}`);
              const cellOpacity = m.in_range === false ? 0.35 : m.closed === false ? 0.7 : 1;
              return /* @__PURE__ */ React.createElement("span", { title: tipLines.join("\n"), style: { display: "inline-block", opacity: cellOpacity } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 500, fontVariantNumeric: "tabular-nums" } }, total ? fmt(total) : /* @__PURE__ */ React.createElement("span", { style: { color: "var(--muted)" } }, "\u2014")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end", gap: 6, marginTop: 2 } }, m.delta_pct != null && /* @__PURE__ */ React.createElement("span", { style: {
                fontSize: 10,
                fontWeight: 600,
                color: m.delta_pct >= 0 ? "#166534" : "#991b1b"
              } }, m.delta_pct >= 0 ? "+" : "", m.delta_pct.toFixed(0), "%"), drk != null && drk !== 0 && /* @__PURE__ */ React.createElement(
                "span",
                {
                  style: { fontSize: 10, color: drk > 0 ? "#166534" : "#991b1b" },
                  title: `#${m.rank} agora (era #${m.prev_rank} em ${data.prev_year}) \u2192 ${drk > 0 ? "subiu" : "desceu"} ${Math.abs(drk)} posi\xE7\xF5es`
                },
                drk > 0 ? `\u25B2${drk}` : `\u25BC${Math.abs(drk)}`
              )));
            }
          };
        }),
        {
          key: "total_ano",
          label: "Ano (\u20AC)",
          width: 110,
          minWidth: 90,
          align: "right",
          mono: true,
          render: (a) => /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, fmt(a.total))
        },
        {
          key: "year_delta_pct",
          label: "\u0394%",
          width: 130,
          minWidth: 100,
          align: "right",
          mono: true,
          render: (a) => /* @__PURE__ */ React.createElement(window.HubCharts.DeltaBadge, { pct: a.year_delta_pct })
        }
      ],
      data: data.accounts,
      pagination: "client",
      rowKey: (a) => a.no,
      onRowClick: (a) => setOpenNo(a.no),
      empty: `Sem dados para ${data.year}.`
    }
  )), openNo != null && /* @__PURE__ */ React.createElement(
    WhaleAccountDrawer,
    {
      no: openNo,
      range,
      navList: data.accounts,
      onNavigate: (a) => setOpenNo(a.no),
      onClose: () => setOpenNo(null)
    }
  ));
}
window.WhaleAccountsView = WhaleAccountsView;
window.WhaleDashboardView = WhaleDashboardView;
window.WhaleMonthlyRankingView = WhaleMonthlyRankingView;

// ===== whale/manifest.js =====
(window.__HUB_APPS = window.__HUB_APPS || []).push({
  slug: "whale",
  order: 3,
  name: "WHALES",
  sub: "Big Accounts",
  accent: "#1e40af",
  brandLogo: "/static/assets/whales-icon.png",
  brandEmoji: "\u{1F40B}",
  brandEmojiFontSize: "28px",
  home: "whale",
  launcher: true,
  frontendFiles: [
    "frontend/entry.jsx"
  ],
  routes: [
    { id: "whale", section: "WHALES", icon: "list", label: "Big Accounts", adminOnly: false, title: "WHALES \u2014 Big Accounts", tooltip: "Big Accounts" },
    { id: "whale_dashboard", section: "WHALES", icon: "dashboard", label: "Dashboard", adminOnly: false, title: "WHALES \u2014 Dashboard agregado", tooltip: "Dashboard agregado" },
    { id: "whale_ranking", section: "WHALES", icon: "ranking", label: "Ranking mensal", adminOnly: false, title: "WHALES \u2014 Ranking mensal", tooltip: "Ranking mensal de fatura\xE7\xE3o" },
    { id: "whale_admin", section: "Configura\xE7\xF5es", icon: "cog", label: "Configura\xE7\xF5es", adminOnly: true, title: "WHALES \u2014 Configura\xE7\xF5es", tooltip: "Configura\xE7\xF5es WHALES" },
    { id: "whale_atribuiveis", section: "Configura\xE7\xF5es", icon: "list", label: "Utilizadores atribu\xEDveis", adminOnly: true, title: "WHALES \u2014 Utilizadores atribu\xEDveis", tooltip: "Quem pode ser atribu\xEDdo ao tratamento" }
  ],
  render: {
    whale: (ctx) => React.createElement(window.WhaleAccountsView, {
      routeId: ctx.view,
      entidade: ctx.entidade,
      params: ctx.params,
      navigate: ctx.navigate,
      reportCrumb: ctx.reportCrumb
    }),
    whale_dashboard: () => React.createElement(window.WhaleDashboardView),
    whale_ranking: () => React.createElement(window.WhaleMonthlyRankingView),
    whale_admin: () => React.createElement(
      "div",
      { style: { padding: 40, textAlign: "center", color: "var(--muted)" } },
      React.createElement("h2", { style: { margin: 0, fontSize: 16, fontWeight: 600 } }, "Configura\xE7\xF5es WHALES"),
      React.createElement("p", { style: { marginTop: 8 } }, "Por definir.")
    ),
    whale_atribuiveis: () => React.createElement(window.HubAssignableUsers, { appLabel: "whale", appName: "WHALES" })
  }
});

// ===== registry.js =====
const ADMIN_SLUG = "admin";
function sortAppsForLauncher(apps) {
  const adminApp = apps.find((a) => a.slug === ADMIN_SLUG);
  const rest = apps.filter((a) => a.slug !== ADMIN_SLUG).sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
  return adminApp ? [...rest, adminApp] : rest;
}
const STATIC_AREAS = [
  {
    slug: "conta",
    order: 6,
    name: "A minha conta",
    sub: "A MINHA CONTA",
    accent: "",
    brandLogo: null,
    brandEmoji: null,
    home: "minha_conta",
    launcher: false,
    routes: [
      { id: "conta_perfil", viewId: "minha_conta", contaTab: "perfil", section: "A minha conta", icon: "user", label: "Perfil", adminOnly: false, title: "A minha conta", tooltip: "Perfil" },
      { id: "conta_notificacoes", viewId: "minha_conta", contaTab: "notificacoes", section: "A minha conta", icon: "bell", label: "Notifica\xE7\xF5es", adminOnly: false, title: "A minha conta", tooltip: "Notifica\xE7\xF5es" },
      { id: "conta_atividade", viewId: "minha_conta", contaTab: "atividade", section: "A minha conta", icon: "dashboard", label: "Atividade", adminOnly: false, title: "A minha conta", tooltip: "Atividade" }
    ]
  },
  {
    slug: "calendario",
    order: 5,
    name: "Calend\xE1rio",
    sub: "CALEND\xC1RIO",
    accent: "",
    brandLogo: null,
    brandEmoji: "\u{1F4C5}",
    home: "hub_calendario",
    launcher: false,
    routes: [
      {
        id: "hub_calendario",
        section: "Calend\xE1rio",
        icon: "meeting",
        label: "Calend\xE1rio",
        adminOnly: false,
        title: "Calend\xE1rio",
        tooltip: "Tudo o que tens marcado, em qualquer app"
      }
    ]
  },
  {
    slug: "sem_modulos",
    order: 6.5,
    name: "Sem m\xF3dulos",
    sub: "",
    accent: "",
    brandLogo: null,
    brandEmoji: null,
    home: "sem_modulos",
    launcher: false,
    routes: []
  },
  {
    slug: "admin",
    order: 7,
    name: "ADMINISTRA\xC7\xC3O",
    sub: "Equipa e gest\xE3o geral",
    accent: "#475569",
    brandLogo: "/static/assets/config-logo.png?v=2",
    brandEmoji: "\u2699\uFE0F",
    brandWordmark: "Administra\xE7\xE3o",
    brandAlt: "Administra\xE7\xE3o",
    brandEmojiFontSize: "24px",
    home: "admin_geral",
    launcher: true,
    launcherStaffOnly: true,
    // not a real app; shown on the launcher to staff only
    routes: [
      { id: "admin_geral", section: "Administra\xE7\xE3o", icon: "user", label: "Utilizadores", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Utilizadores", tooltip: "Utilizadores + API keys" },
      { id: "admin_user_types", section: "Administra\xE7\xE3o", icon: "tag", label: "Tipos de utilizador", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Tipos de utilizador", tooltip: "Definir tipos / perfis de utilizador" },
      { id: "admin_email", section: "Administra\xE7\xE3o", icon: "cog", label: "Email (SMTP)", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Email (SMTP)", tooltip: "Configura\xE7\xE3o de envio de email (SMTP)" },
      { id: "admin_email_templates", section: "Administra\xE7\xE3o", icon: "printer", label: "Templates de email", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Templates de email", tooltip: "Aspeto e conte\xFAdo dos emails" },
      { id: "admin_access_matrix", section: "Acessos", icon: "grid", label: "Matriz de Acessos", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Matriz de Acessos", tooltip: "UserType \xD7 app: rules e actions" },
      { id: "admin_feature_config", section: "Acessos", icon: "grid", label: "Features por app", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Features por app", tooltip: "Liga/desliga features por app e tipo" },
      { id: "admin_anexos_settings", section: "Acessos", icon: "grid", label: "Anexos \u2014 armazenamento", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Anexos (armazenamento)", tooltip: "SharePoint/Graph para anexos" },
      { id: "admin_teams", section: "Acessos", icon: "users", label: "Equipas", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Equipas", tooltip: "CRUD de Team para regra R4_TEAM" },
      { id: "admin_auditoria", section: "Acessos", icon: "doc", label: "Auditoria", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Auditoria", tooltip: "Audit log cross-app + denials" },
      { id: "admin_impersonacao", section: "Acessos", icon: "user", label: "Impersona\xE7\xE3o", adminOnly: true, impersonateOnly: true, title: "Administra\xE7\xE3o \u2014 Impersona\xE7\xE3o", tooltip: "Entrar como um utilizador n\xE3o-admin (auditado)" },
      { id: "admin_user_config_guide", section: "Documenta\xE7\xE3o", icon: "doc", label: "Configura\xE7\xE3o de Utilizadores", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Configura\xE7\xE3o de Utilizadores", tooltip: "Guia end-to-end: UserTypes, AccessRules, Teams" },
      { id: "admin_plugin_manual", section: "Documenta\xE7\xE3o", icon: "doc", label: "Claude Plugin Manual", adminOnly: true, title: "Administra\xE7\xE3o \u2014 Claude Plugin Manual", tooltip: "Manual auto-gerado dos plugins Claude Code" }
    ]
  }
];
const AREAS = sortAppsForLauncher([...STATIC_AREAS, ...window.__HUB_APPS || []]);
function _routeMatches(route, view) {
  return (route.viewId || route.id) === view;
}
function areaForView(view) {
  for (const a of AREAS) {
    if (a.routes.some((r) => _routeMatches(r, view))) return a.slug;
  }
  for (const a of AREAS) {
    if (a.home === view) return a.slug;
  }
  return "stock";
}
function routesForArea(slug, isStaff, routeAccess = {}, canImpersonate = false) {
  const a = AREAS.find((x) => x.slug === slug);
  if (!a) return [];
  return a.routes.filter(
    (r) => (isStaff || !r.adminOnly) && (!r.impersonateOnly || canImpersonate) && (!r.scoped || routeAccess[r.id] !== false)
  );
}
function homeView(slug, routeAccess = {}, isStaff = false, canImpersonate = false, userTypeNames = []) {
  const a = AREAS.find((x) => x.slug === slug);
  if (!a) return "listagem";
  const visible = routesForArea(slug, isStaff, routeAccess, canImpersonate);
  if (a.homePorPerfil) {
    const alvo = userTypeNames.map((n) => a.homePorPerfil[n]).find(Boolean);
    if (alvo && visible.some((r) => r.id === alvo)) return alvo;
  }
  if (visible.some((r) => r.id === a.home)) return a.home;
  return visible.length ? visible[0].id : a.home;
}
function titleFor(view) {
  for (const a of AREAS) {
    const r = a.routes.find((x) => x.id === view) || a.routes.find((x) => _routeMatches(x, view));
    if (r) return r.title || "";
  }
  return "";
}
function areaList(apps, isStaff) {
  return AREAS.filter((a) => a.launcher && (a.launcherStaffOnly ? isStaff : apps.includes(a.appLabel || a.slug)));
}
function brandFor(slug) {
  const a = AREAS.find((x) => x.slug === slug);
  if (!a) return null;
  return { name: a.name, accent: a.accent, brandLogo: a.brandLogo, brandEmoji: a.brandEmoji };
}
function appRoster() {
  return (window.__HUB_APPS || []).map((a) => ({ app_label: a.appLabel || a.slug, name: a.name, order: a.order ?? 999 })).sort((x, y) => x.order - y.order || x.app_label.localeCompare(y.app_label));
}
const AREAS_DO_SHELL = ["conta", "sem_modulos", "calendario"];
function routeById(routeId) {
  for (const a of AREAS) {
    const r = a.routes.find((x) => x.id === routeId);
    if (r) return r;
  }
  return null;
}
const ROUTE_REDIRECTS = {
  prospecao_calendario: "hub_calendario"
};
function resolveRoute(routeIdPedido, {
  apps = [],
  routeAccess = {},
  isStaff = false,
  canImpersonate = false,
  userTypeNames = []
} = {}) {
  const _destino = (id, motivo) => {
    const r = routeById(id);
    return {
      routeId: id,
      view: r ? r.viewId || r.id : id,
      contaTab: r ? r.contaTab || null : null,
      motivo
    };
  };
  const _recurso = (motivo) => {
    if (!apps.length) return _destino("sem_modulos", motivo);
    const area = areaList(apps, isStaff)[0];
    if (!area) return _destino("sem_modulos", motivo);
    return _destino(homeView(area.slug, routeAccess, isStaff, canImpersonate, userTypeNames), motivo);
  };
  const routeId = ROUTE_REDIRECTS[routeIdPedido] || routeIdPedido;
  const rota = routeById(routeId);
  if (!rota) return _recurso(apps.length ? "desconhecida" : "sem-apps");
  const slug = areaForView(rota.viewId || rota.id);
  const doShell = AREAS_DO_SHELL.includes(slug);
  if (!doShell && !apps.length) return _destino("sem_modulos", "sem-apps");
  if (!doShell) {
    const area = AREAS.find((a) => a.slug === slug);
    const label = area ? area.appLabel || area.slug : slug;
    const temApp = area && area.launcherStaffOnly ? isStaff : apps.includes(label);
    if (!temApp) return _recurso("sem-acesso-app");
  }
  const visiveis = routesForArea(slug, isStaff, routeAccess, canImpersonate);
  if (!visiveis.some((r) => r.id === rota.id)) return _recurso("sem-acesso-rota");
  return _destino(rota.id, "ok");
}
const LINK_DRAWERS = { chat: "chat" };
function routeForLink(linkView) {
  const v = String(linkView || "");
  if (!v) return null;
  if (LINK_DRAWERS[v]) return { routeId: null, drawer: LINK_DRAWERS[v] };
  if (routeById(v)) return { routeId: v, drawer: null };
  const area = AREAS.find((a) => a.slug === v || a.appLabel === v);
  if (area) return { routeId: homeView(area.slug), drawer: null };
  return null;
}
function crumbLabelFor(rota) {
  return rota.label || rota.title || rota.id;
}
function breadcrumb({ routeId, entidade = null, entidadeLabel = null } = {}) {
  const rota = routeId ? routeById(routeId) : null;
  if (!rota) return [];
  const slug = areaForView(rota.viewId || rota.id);
  const marca = brandFor(slug);
  const home = homeView(slug);
  if (rota.id === home && !entidade) return [];
  const out = [{ label: marca && marca.name || slug, routeId: home }];
  if (rota.id !== home) {
    out.push({ label: crumbLabelFor(rota), routeId: rota.id });
  }
  if (entidade) {
    if (rota.id === home) {
      out.push({ label: crumbLabelFor(rota), routeId: rota.id });
    }
    out.push({ label: entidadeLabel || entidade, routeId: null });
  }
  return out;
}
window.HUB_REG = Object.freeze({
  AREAS,
  areaForView,
  routesForArea,
  homeView,
  titleFor,
  areaList,
  brandFor,
  appRoster,
  sortAppsForLauncher,
  routeById,
  resolveRoute,
  routeForLink,
  breadcrumb
});

// ===== app.jsx =====
const TWEAK_DEFAULTS = (
  /*EDITMODE-BEGIN*/
  {
    "theme": "light",
    "density": "normal",
    "layout": "standard",
    "accent": "#2c5d8a"
  }
);
const MOTIVO_TOAST = {
  "desconhecida": "Essa p\xE1gina n\xE3o existe.",
  "sem-acesso-rota": "N\xE3o tens acesso a essa p\xE1gina.",
  "sem-acesso-app": "N\xE3o tens acesso a essa app."
};
function ViewVariantToggle({ views, active, onChange }) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      role: "tablist",
      "aria-label": "Vista",
      style: {
        display: "inline-flex",
        border: "1px solid var(--border)",
        borderRadius: 8,
        overflow: "hidden",
        marginLeft: 12
      }
    },
    views.map((v) => {
      const IcoCmp = Ico[v.icon] || Ico.list;
      const isActive = v.id === active;
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: v.id,
          role: "tab",
          type: "button",
          "aria-selected": isActive,
          onClick: () => onChange(v.id),
          title: v.label,
          style: {
            padding: "5px 10px",
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            fontWeight: 500,
            border: "none",
            cursor: "pointer",
            background: isActive ? "var(--accent)" : "transparent",
            color: isActive ? "#fff" : "var(--text-2)"
          }
        },
        /* @__PURE__ */ React.createElement(IcoCmp, null),
        " ",
        /* @__PURE__ */ React.createElement("span", null, v.label)
      );
    })
  );
}
function EmptyModulesHome() {
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "64px 24px",
    color: "var(--muted)",
    gap: 8
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 32 } }, "\u{1F4AC}"), /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontSize: 18, fontWeight: 600, color: "var(--fg)" } }, "Ainda n\xE3o tens m\xF3dulos atribu\xEDdos."), /* @__PURE__ */ React.createElement("p", { style: { margin: 0, fontSize: 14 } }, "Usa o chat \u{1F4AC} ou contacta o administrador."));
}
function impersonationBannerText(me) {
  if (!me || !me.impersonation || !me.impersonation.active) return null;
  return `A ver como ${me.impersonation.target.name} \xB7 via admin`;
}
async function stopImpersonating() {
  try {
    await window.API.stopImpersonate();
  } finally {
    window.location.reload();
  }
}
function ImpersonationBanner({ me }) {
  const text = impersonationBannerText(me);
  if (!text) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "impersonation-banner", role: "status" }, /* @__PURE__ */ React.createElement("span", null, "\u26A0\uFE0F ", text), /* @__PURE__ */ React.createElement("button", { type: "button", onClick: stopImpersonating }, "Terminar"));
}
function App() {
  const [tweaks, setTweak] = useTweaks(TWEAK_DEFAULTS);
  const [bootstrap, setBootstrap] = useState(null);
  const [bootstrapError, setBootstrapError] = useState(null);
  const [unauthenticated, setUnauthenticated] = useState(false);
  const [loc, setLoc] = useState(() => window.HubRouter.current());
  const leaveGuardRef = useRef(null);
  const registerLeaveGuard = useCallback((fn) => {
    leaveGuardRef.current = fn;
    return () => {
      if (leaveGuardRef.current === fn) leaveGuardRef.current = null;
    };
  }, []);
  const hashAnteriorRef = useRef(window.location.hash);
  useEffect(() => window.HubRouter.subscribe((next) => {
    const novo = window.location.hash;
    if (!window.HubRouter.consumirNavegacaoPropria(novo)) {
      const d = window.HubRouter.hubDecidirSaida(
        leaveGuardRef.current,
        hashAnteriorRef.current,
        novo
      );
      if (!d.sair) {
        window.HubRouter.navigate(window.HubRouter.parse(d.repor));
        if (window.location.hash !== novo) return;
      }
    }
    hashAnteriorRef.current = novo;
    setLoc(next);
    if (!next.routeId) {
      if (bootstrap?.me && (bootstrap.me.apps || []).length >= 2) setShowLauncher(true);
    } else {
      setShowLauncher(false);
    }
  }), [bootstrap?.me]);
  const destino = useMemo(() => {
    if (!bootstrap?.me) return { view: "listagem", contaTab: "perfil", motivo: "ok" };
    return window.HUB_REG.resolveRoute(loc.routeId, {
      apps: bootstrap.me.apps || [],
      routeAccess: bootstrap.me.route_access || {},
      isStaff: !!bootstrap.me.is_staff,
      canImpersonate: !!bootstrap.me.can_impersonate,
      userTypeNames: bootstrap.me.user_types || []
    });
  }, [loc.routeId, bootstrap?.me]);
  const view = destino.view;
  const contaTab = destino.contaTab || "perfil";
  const setView = (routeId, opts) => window.HubRouter.navigate({ routeId }, opts || {});
  const setContaTab = (tab) => setView(`conta_${tab}`);
  useEffect(() => {
    if (!bootstrap?.me || !loc.routeId) return;
    if (destino.motivo === "ok" && destino.routeId === loc.routeId) return;
    const msg = MOTIVO_TOAST[destino.motivo];
    if (msg) window.srToast?.(msg, "warning");
    window.HubRouter.navigate({ routeId: destino.routeId }, { replace: true });
  }, [destino, loc.routeId, bootstrap?.me]);
  const [viewVariants, setViewVariants] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hub.viewVariants") || "{}");
    } catch (_) {
      return {};
    }
  });
  const setViewVariant = (route, variant) => {
    setViewVariants((prev) => {
      const next = { ...prev, [route]: variant };
      try {
        localStorage.setItem("hub.viewVariants", JSON.stringify(next));
      } catch (_) {
      }
      return next;
    });
    window.HubRouter.setParams({ v: variant });
  };
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem("sr.sidebarCollapsed") === "1"
  );
  const [showLauncher, setShowLauncher] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatIntent, setChatIntent] = useState(null);
  useEffect(() => {
    const SHORTCUTS = { s: 1, c: 1, n: 1, p: 1, a: 1, r: 1, e: 1, f: 1 };
    const onDown = (e) => {
      if (e.altKey) document.body.classList.add("alt-down");
      if (!e.altKey) return;
      const key = (e.key || "").toLowerCase();
      if (key === "alt") {
        e.preventDefault();
        return;
      }
      if (!SHORTCUTS[key]) return;
      const matches = document.querySelectorAll(
        `[data-shortcut="${key}"]:not([disabled])`
      );
      const btn = matches[matches.length - 1];
      if (btn) {
        e.preventDefault();
        btn.click();
      }
    };
    const onUp = (e) => {
      if (e.key === "Alt") {
        e.preventDefault();
        document.body.classList.remove("alt-down");
      } else if (!e.altKey) document.body.classList.remove("alt-down");
    };
    const onBlur = () => document.body.classList.remove("alt-down");
    document.addEventListener("keydown", onDown);
    document.addEventListener("keyup", onUp);
    window.addEventListener("blur", onBlur);
    return () => {
      document.removeEventListener("keydown", onDown);
      document.removeEventListener("keyup", onUp);
      window.removeEventListener("blur", onBlur);
      document.body.classList.remove("alt-down");
    };
  }, []);
  const navigateFromNotification = (linkView, linkTarget) => {
    const destino2 = window.HUB_REG.routeForLink(linkView);
    if (!destino2) {
      window.srToast?.("Notifica\xE7\xE3o inv\xE1lida.", "error");
      return;
    }
    if (destino2.drawer === "chat") {
      setChatIntent({
        convId: linkTarget != null ? String(linkTarget) : null,
        ts: Date.now()
      });
      setChatOpen(true);
      return;
    }
    window.HubRouter.navigate({
      routeId: destino2.routeId,
      entidade: linkTarget != null && linkTarget !== "" ? String(linkTarget) : null
    });
  };
  useEffect(() => {
    setMenuOpen(false);
  }, [view]);
  useEffect(() => {
    if (!bootstrap?.me) return;
    if (loc.routeId) return;
    const apps2 = bootstrap.me.apps || [];
    if (apps2.length === 1) {
      const area2 = window.HUB_REG.areaList(apps2, !!bootstrap.me?.is_staff)[0];
      const slug = area2 ? area2.slug : apps2[0];
      window.HubRouter.navigate({
        routeId: window.HUB_REG.homeView(
          slug,
          bootstrap.me?.route_access || {},
          !!bootstrap.me?.is_staff,
          false,
          bootstrap.me?.user_types || []
        )
      }, { replace: true });
    } else if (apps2.length >= 2) {
      setShowLauncher(true);
    } else {
      window.HubRouter.navigate({ routeId: "sem_modulos" }, { replace: true });
    }
  }, [loc.routeId, bootstrap?.me]);
  useEffect(() => {
    localStorage.setItem("sr.sidebarCollapsed", sidebarCollapsed ? "1" : "0");
  }, [sidebarCollapsed]);
  useEffect(() => {
    if (!bootstrap?.me) return;
    let ws = null, retry = 0, closed = false, pingTimer = null, reconnectTimer = null;
    const connect = () => {
      if (closed) return;
      try {
        ws = window.API.openUserSocket();
      } catch {
        return;
      }
      ws.onopen = () => {
        retry = 0;
        pingTimer = setInterval(() => {
          try {
            ws.send(JSON.stringify({ type: "ping" }));
          } catch {
          }
        }, 25e3);
      };
      ws.onmessage = (ev) => {
        let data;
        try {
          data = JSON.parse(ev.data);
        } catch {
          return;
        }
        if (data.type === "pong") return;
        window.dispatchEvent(new CustomEvent("sr:realtime", { detail: data }));
      };
      ws.onclose = () => {
        if (pingTimer) {
          clearInterval(pingTimer);
          pingTimer = null;
        }
        if (closed) return;
        retry = Math.min(retry + 1, 6);
        reconnectTimer = setTimeout(connect, 1e3 * retry);
      };
      ws.onerror = () => {
        try {
          ws.close();
        } catch {
        }
      };
    };
    connect();
    return () => {
      closed = true;
      if (pingTimer) clearInterval(pingTimer);
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (ws) {
        try {
          ws.close();
        } catch {
        }
      }
    };
  }, [bootstrap?.me]);
  useEffect(() => {
    Promise.all([
      API.estados().catch(() => ({ results: [] })),
      API.tiposAcao().catch(() => ({ results: [] })),
      API.users().catch(() => ({ results: [] })),
      API.vendedores().catch(() => []),
      API.me(),
      API.personalizacoes().catch(() => ({ results: [] })),
      API.dbConnections().catch(() => ({ results: [] })),
      API.userTypes().catch(() => ({ results: [] })),
      // Per-app drawer feature gating (timeline/notas/seguidores/anexos tabs) —
      // loaded once here so HubActionTimeline has it on the very first drawer
      // open. Failure already falls back to "show everything" inside load().
      window.HubFeatures.load().catch(() => null)
    ]).then(([estados2, tipos, users, vendedores, me, personalizacoes, dbConnections, userTypes]) => {
      const estadosList = estados2.results || estados2;
      const tiposList = tipos.results || tipos;
      window.SR_DATA.estados = estadosList.map((e) => ({
        id: e.id_slug,
        nome: e.nome,
        cor: e.cor,
        ordem: e.ordem,
        terminal: e.terminal
      }));
      window.SR_DATA.tiposAcao = tiposList.map((t) => ({
        id: t.id_slug,
        nome: t.nome,
        icon: t.icon
      }));
      window.SR_USERS = users.results || users;
      window.SR_USERTYPES = userTypes.results || userTypes;
      window.SR_ME = me || null;
      setBootstrap({
        estados: estadosList,
        tiposAcao: tiposList,
        users: users.results || users,
        userTypes: userTypes.results || userTypes,
        personalizacoes: personalizacoes.results || personalizacoes,
        dbConnections: dbConnections.results || dbConnections,
        vendedores,
        me,
        familias: window.SR_DATA.familias,
        tiposArtigo: window.SR_DATA.tiposArtigo,
        tiposAquisicao: window.SR_DATA.tiposAquisicao,
        classificacoes: window.SR_DATA.classificacoes
      });
    }).catch((e) => {
      if (/\/api\/auth\/me\/\s*→\s*40[13]\b/.test(e.message)) setUnauthenticated(true);
      else setBootstrapError(e.message);
    });
  }, []);
  async function reloadUsers(includeInactive = false) {
    const fresh = await window.API.users(includeInactive ? { include_inactive: "1" } : void 0);
    setBootstrap((b) => ({ ...b, users: fresh.results || fresh }));
  }
  async function reloadPersonalizacoes() {
    const fresh = await window.API.personalizacoes();
    setBootstrap((b) => ({ ...b, personalizacoes: fresh.results || fresh }));
  }
  async function reloadEstados() {
    const fresh = await window.API.estados();
    const list = fresh.results || fresh;
    setBootstrap((b) => ({ ...b, estados: list }));
    window.SR_DATA.estados = list.map((e) => ({
      id: e.id_slug,
      nome: e.nome,
      cor: e.cor,
      ordem: e.ordem,
      terminal: e.terminal
    }));
  }
  async function reloadTiposAcao() {
    const fresh = await window.API.tiposAcao();
    const list = fresh.results || fresh;
    setBootstrap((b) => ({ ...b, tiposAcao: list }));
    window.SR_DATA.tiposAcao = list.map((t) => ({ id: t.id_slug, nome: t.nome, icon: t.icon }));
  }
  async function reloadDBConnections() {
    const fresh = await window.API.dbConnections();
    setBootstrap((b) => ({ ...b, dbConnections: fresh.results || fresh }));
  }
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", tweaks.theme);
    document.documentElement.setAttribute("data-density", tweaks.density);
    document.documentElement.style.setProperty("--accent", tweaks.accent);
  }, [tweaks]);
  const [viewStats, setViewStats] = useState(null);
  const reportStats = useCallback((s) => setViewStats(s || null), []);
  const [counts, setCounts] = useState({});
  const reportCounts = useCallback((c) => setCounts(c || {}), []);
  const [crumbLabel, setCrumbLabel] = useState(null);
  const reportCrumb = useCallback((label) => setCrumbLabel(label || null), []);
  const apps = bootstrap?.me?.apps || [];
  const renderedView = apps.length === 0 && view === "listagem" ? "sem_modulos" : view;
  const area = window.HUB_REG.areaForView(renderedView);
  const prevAreaRef = useRef(area);
  if (prevAreaRef.current !== area) {
    prevAreaRef.current = area;
    setCounts({});
  }
  const prevEntidadeRef = useRef(loc.entidade);
  if (prevEntidadeRef.current !== loc.entidade) {
    prevEntidadeRef.current = loc.entidade;
    if (crumbLabel !== null) setCrumbLabel(null);
  }
  if (window.location.pathname.startsWith("/set-password")) return /* @__PURE__ */ React.createElement(SetPasswordScreen, null);
  if (unauthenticated) return /* @__PURE__ */ React.createElement(LoginScreen, null);
  if (bootstrapError) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24, color: "red" } }, "Erro: ", bootstrapError);
  if (!bootstrap) return /* @__PURE__ */ React.createElement("div", { style: { padding: 24 } }, "A carregar\u2026");
  if (showLauncher) {
    const leaveLauncher = () => {
      sessionStorage.setItem("sr.launcherDismissed", "1");
      setShowLauncher(false);
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ImpersonationBanner, { me: bootstrap.me }), /* @__PURE__ */ React.createElement(
      LauncherScreen,
      {
        me: bootstrap.me,
        apps,
        onPick: (slug) => {
          setView(window.HUB_REG.homeView(slug, bootstrap.me?.route_access || {}, !!bootstrap.me?.is_staff, false, bootstrap.me?.user_types || []));
          leaveLauncher();
        },
        onProfile: () => {
          setView("conta_perfil");
          leaveLauncher();
        },
        onNotifications: () => {
          setView("conta_notificacoes");
          leaveLauncher();
        },
        onChat: () => {
          setView("conta_perfil", { replace: true });
          leaveLauncher();
          setChatOpen(true);
        },
        onNavigate: (view2, target) => {
          leaveLauncher();
          navigateFromNotification(view2, target);
        }
      }
    ));
  }
  const { estados, tiposAcao } = bootstrap;
  const ROUTE_RENDER = {
    relatorios: () => /* @__PURE__ */ React.createElement(ReportsTab, { users: bootstrap.users }),
    stock_admin: () => /* @__PURE__ */ React.createElement(
      StockAdminView,
      {
        estados,
        tiposAcao,
        personalizacoes: bootstrap.personalizacoes,
        reloadPersonalizacoes,
        dbConnections: bootstrap.dbConnections,
        reloadDBConnections,
        reloadEstados,
        reloadTiposAcao
      }
    ),
    prospecao: (ctx) => /* @__PURE__ */ React.createElement(
      ProspecaoApp,
      {
        me: bootstrap.me,
        view: ctx?.viewVariant,
        entidade: ctx?.entidade,
        params: ctx?.params,
        navigate: ctx?.navigate,
        reportCrumb: ctx?.reportCrumb,
        registerLeaveGuard: ctx?.registerLeaveGuard
      }
    ),
    prospecao_admin: () => /* @__PURE__ */ React.createElement(ProspeccaoAdminView, null),
    minha_conta: () => /* @__PURE__ */ React.createElement(
      MyAccountView,
      {
        me: bootstrap.me,
        tab: contaTab,
        onTab: setContaTab,
        reloadMe: async () => {
          const fresh = await window.API.me();
          setBootstrap((b) => ({ ...b, me: fresh }));
        }
      }
    ),
    hub_calendario: (ctx) => /* @__PURE__ */ React.createElement(
      window.HubCalendarioView,
      {
        params: ctx?.params,
        navigate: ctx?.navigate
      }
    ),
    sem_modulos: () => /* @__PURE__ */ React.createElement(EmptyModulesHome, null),
    admin_geral: () => /* @__PURE__ */ React.createElement(GeneralAdminView, { users: bootstrap.users, reloadUsers, me: bootstrap.me }),
    admin_user_types: () => /* @__PURE__ */ React.createElement(UserTypesView, null),
    admin_email: () => /* @__PURE__ */ React.createElement(EmailSettingsView, { me: bootstrap.me }),
    admin_email_templates: () => /* @__PURE__ */ React.createElement(EmailTemplatesView, null),
    admin_access_matrix: () => /* @__PURE__ */ React.createElement(window.AccessMatrixView, null),
    admin_feature_config: () => /* @__PURE__ */ React.createElement(window.FeatureConfigView, null),
    admin_anexos_settings: () => /* @__PURE__ */ React.createElement(window.AnexosSettingsView, null),
    admin_teams: () => /* @__PURE__ */ React.createElement(window.AccessTeamsView, null),
    admin_auditoria: () => /* @__PURE__ */ React.createElement(window.AuditoriaView, null),
    admin_impersonacao: () => bootstrap.me?.can_impersonate ? /* @__PURE__ */ React.createElement(window.ImpersonacaoView, { me: bootstrap.me }) : null,
    admin_user_config_guide: () => window.AdministracaoUserConfigGuideView ? React.createElement(window.AdministracaoUserConfigGuideView) : null,
    admin_plugin_manual: () => window.AdministracaoManualView ? React.createElement(window.AdministracaoManualView) : null,
    valora: () => window.ValoraView ? React.createElement(window.ValoraView, {
      isAdmin: !!bootstrap.me?.is_staff,
      userName: bootstrap.me?.first_name || bootstrap.me?.username || "valora"
    }) : null
  };
  const _routeMeta = (v) => window.HUB_REG.AREAS.flatMap((a) => a.routes).find((r) => (r.viewId || r.id) === v);
  const _activeVariant = (v) => {
    const meta = _routeMeta(v);
    if (!meta?.views || meta.views.length === 0) return null;
    const ids = meta.views.map((x) => x.id);
    const doUrl = loc.params.get("v");
    if (doUrl && ids.includes(doUrl)) return doUrl;
    const saved = viewVariants[v];
    if (saved && ids.includes(saved)) return saved;
    return meta.defaultView && ids.includes(meta.defaultView) ? meta.defaultView : meta.views[0].id;
  };
  const currentMeta = _routeMeta(view);
  const currentVariant = _activeVariant(view);
  const renderView = () => {
    const meta = _routeMeta(renderedView);
    if (meta && meta.adminOnly && !bootstrap.me?.is_staff) return null;
    const ctx = {
      me: bootstrap.me,
      view: renderedView,
      viewVariant: currentVariant,
      // Fase 2: a localização completa. `entidade` é opaca para o shell —
      // só a app sabe o que a string significa.
      entidade: loc.entidade || null,
      params: loc.params,
      navigate: (to, opts) => window.HubRouter.navigate(to, opts || {}),
      // Números do cromo (topbar/sidebar) — quem está montado reporta-os
      // para cima; ver `viewStats`/`counts` acima.
      reportStats,
      reportCounts,
      // Rótulo da entidade aberta (última migalha da barra de caminho); ver
      // `crumbLabel` acima.
      reportCrumb,
      // Guard de saída (ver `leaveGuardRef` acima). Uma app com alterações
      // por gravar regista uma função `(hashNovo) => boolean` e recebe de
      // volta a função que a desregista (para o cleanup do efeito). Uma app
      // sem estado por gravar não regista nada.
      registerLeaveGuard,
      // Aparência do shell (tema, densidade, acento, modo da listagem). É
      // estado do shell, não da app, mas quem renderiza precisa dele — o
      // painel de Tweaks continua a viver aqui.
      tweaks
    };
    const app = (window.__HUB_APPS || []).find((a) => a.render && a.render[renderedView]);
    if (app) return app.render[renderedView](ctx);
    const fn = ROUTE_RENDER[renderedView];
    return fn ? fn(ctx) : null;
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "app" + (menuOpen ? " menu-open" : ""),
      "data-screen-label": `SR / ${window.HUB_REG.titleFor(view)}`,
      "data-sidebar": sidebarCollapsed ? "collapsed" : "expanded",
      "data-area": area,
      onClick: (e) => {
        if (menuOpen && e.target === e.currentTarget) setMenuOpen(false);
      }
    },
    /* @__PURE__ */ React.createElement("aside", { className: "sidebar" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "sidebar-toggle",
        onClick: () => setSidebarCollapsed((c) => !c),
        title: sidebarCollapsed ? "Expandir" : "Recolher"
      },
      sidebarCollapsed ? "\u203A" : "\u2039"
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "sidebar-brand",
        style: { cursor: "pointer" },
        title: "Voltar ao menu inicial",
        onClick: () => {
          sessionStorage.removeItem("sr.launcherDismissed");
          setShowLauncher(true);
        }
      },
      /* @__PURE__ */ React.createElement(AreaBrand, { area, me: bootstrap.me })
    ), /* @__PURE__ */ React.createElement("nav", { className: "nav" }, (() => {
      const routes = window.HUB_REG.routesForArea(area, !!bootstrap.me?.is_staff, bootstrap.me?.route_access || {}, !!bootstrap.me?.can_impersonate);
      let lastSection = null;
      const out = [];
      for (const r of routes) {
        if (r.section && r.section !== lastSection) {
          out.push(/* @__PURE__ */ React.createElement("div", { key: "sec-" + r.id, className: "nav-section" }, r.section));
          lastSection = r.section;
        }
        const vid = r.viewId || r.id;
        const isActive = r.contaTab ? destino.routeId === r.id : vid === view;
        const onClick = r.contaTab ? () => setView(r.id) : () => setView(vid);
        const IcoCmp = Ico[r.icon] || Ico.list;
        out.push(
          /* @__PURE__ */ React.createElement(
            "div",
            {
              key: r.id,
              className: "nav-item " + (isActive ? "active" : ""),
              onClick,
              title: r.tooltip
            },
            /* @__PURE__ */ React.createElement(IcoCmp, null),
            " ",
            /* @__PURE__ */ React.createElement("span", null, r.label),
            r.count && counts[r.count] != null ? /* @__PURE__ */ React.createElement("span", { className: "nav-count" }, counts[r.count]) : null
          )
        );
      }
      return out;
    })()), /* @__PURE__ */ React.createElement("div", { className: "sidebar-user" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "avatar",
        style: {
          background: "var(--brand-navy)",
          border: "none",
          cursor: "pointer",
          padding: 0,
          overflow: "hidden"
        },
        onClick: () => setView("conta_perfil"),
        title: "A minha conta"
      },
      bootstrap.me?.photo_url ? /* @__PURE__ */ React.createElement("img", { src: bootstrap.me.photo_url, alt: "", style: { width: "100%", height: "100%", objectFit: "cover" } }) : (bootstrap.me?.first_name?.[0] || bootstrap.me?.username?.[0] || "?").toUpperCase()
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        style: {
          flex: 1,
          minWidth: 0,
          textAlign: "left",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 0
        },
        onClick: () => setView("conta_perfil"),
        title: "A minha conta"
      },
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, bootstrap.me ? `${bootstrap.me.first_name || ""} ${bootstrap.me.last_name || ""}`.trim() || bootstrap.me.username : "\u2014"),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, bootstrap.me?.is_staff ? "Administrador" : "Comercial")
    ), apps.length >= 2 && /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        title: "Trocar aplica\xE7\xE3o",
        onClick: () => {
          sessionStorage.removeItem("sr.launcherDismissed");
          setShowLauncher(true);
        }
      },
      /* @__PURE__ */ React.createElement(Ico.swap, null)
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        title: "Terminar sess\xE3o",
        onClick: async () => {
          await window.API.logout();
          window.location.reload();
        }
      },
      /* @__PURE__ */ React.createElement(Ico.close, null)
    ))),
    /* @__PURE__ */ React.createElement("main", { className: "main" }, /* @__PURE__ */ React.createElement(ImpersonationBanner, { me: bootstrap.me }), /* @__PURE__ */ React.createElement("header", { className: "topbar" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm mobile-menu-btn",
        onClick: () => setMenuOpen((o) => !o),
        title: "Menu",
        "aria-label": "Menu"
      },
      /* @__PURE__ */ React.createElement(Ico.menu, null)
    ), (() => {
      const migalhas = window.HUB_REG.breadcrumb({
        routeId: destino.routeId,
        entidade: loc.entidade,
        entidadeLabel: crumbLabel
      });
      if (migalhas.length === 0) {
        return /* @__PURE__ */ React.createElement("h1", null, window.HUB_REG.titleFor(view));
      }
      return /* @__PURE__ */ React.createElement("h1", { className: "breadcrumb" }, migalhas.map((m, i) => /* @__PURE__ */ React.createElement(React.Fragment, { key: `${m.routeId || "atual"}-${i}` }, i > 0 && /* @__PURE__ */ React.createElement("span", { className: "breadcrumb-sep", "aria-hidden": "true" }, "\u203A"), m.routeId ? /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "breadcrumb-link",
          onClick: () => {
            const fechaDrawer = m.routeId === destino.routeId;
            const to = fechaDrawer ? { routeId: m.routeId, params: loc.params } : { routeId: m.routeId };
            if (fechaDrawer) {
              const hashNovo = window.HubRouter.build(to);
              const d = window.HubRouter.hubDecidirSaida(
                leaveGuardRef.current,
                window.location.hash,
                hashNovo
              );
              if (!d.sair) return;
            }
            window.HubRouter.navigate(to);
          }
        },
        m.label
      ) : /* @__PURE__ */ React.createElement("span", { className: "breadcrumb-atual", "aria-current": "page" }, m.label))));
    })(), view === "listagem" && /* @__PURE__ */ React.createElement("span", { className: "crumb" }, viewStats === null ? null : `${viewStats.refs} refs \xB7 ${fmtEur(viewStats.valor)} imobilizado \xB7 ${viewStats.porTratar} por tratar`), currentMeta?.views && currentMeta.views.length > 1 && /* @__PURE__ */ React.createElement(
      ViewVariantToggle,
      {
        views: currentMeta.views,
        active: currentVariant,
        onChange: (v) => setViewVariant(view, v)
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "topbar-actions" }, view === "listagem" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm" }, /* @__PURE__ */ React.createElement(Ico.printer, null), " Relat\xF3rio PDF"), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm" }, /* @__PURE__ */ React.createElement(Ico.download, null), " Exportar Excel")), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn ghost icon-only sm",
        title: "Calend\xE1rio",
        onClick: () => setView("hub_calendario")
      },
      /* @__PURE__ */ React.createElement(Ico.meeting, null)
    ), /* @__PURE__ */ React.createElement(ChatBell, { onOpen: () => setChatOpen(true) }), /* @__PURE__ */ React.createElement(
      NotificationBell,
      {
        onOpenAccount: () => setView("conta_perfil"),
        onNavigate: navigateFromNotification
      }
    ), /* @__PURE__ */ React.createElement(Popover, { align: "right", trigger: /* @__PURE__ */ React.createElement("button", { className: "btn ghost icon-only sm", title: "Conta" }, /* @__PURE__ */ React.createElement("span", { style: {
      width: 26,
      height: 26,
      borderRadius: "50%",
      overflow: "hidden",
      background: "var(--brand-navy)",
      color: "#fff",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 12,
      fontWeight: 600,
      position: "relative"
    } }, (bootstrap.me?.first_name?.[0] || bootstrap.me?.username?.[0] || "?").toUpperCase(), bootstrap.me?.photo_url && /* @__PURE__ */ React.createElement(
      "img",
      {
        src: bootstrap.me.photo_url,
        alt: "",
        onError: (e) => {
          e.currentTarget.style.display = "none";
        },
        style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
      }
    ))) }, (close) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { padding: "6px 10px", borderBottom: "1px solid var(--border)", marginBottom: 4 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, `${bootstrap.me?.first_name || ""} ${bootstrap.me?.last_name || ""}`.trim() || bootstrap.me?.username), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "var(--muted)" } }, bootstrap.me?.email || "@" + bootstrap.me?.username)), /* @__PURE__ */ React.createElement(MenuItem, { icon: /* @__PURE__ */ React.createElement(Ico.user, null), onClick: () => {
      close();
      setView("conta_perfil");
    } }, "A minha conta"), apps.length >= 2 && /* @__PURE__ */ React.createElement(MenuItem, { icon: /* @__PURE__ */ React.createElement(Ico.swap, null), onClick: () => {
      close();
      sessionStorage.removeItem("sr.launcherDismissed");
      setShowLauncher(true);
    } }, "Trocar aplica\xE7\xE3o"), /* @__PURE__ */ React.createElement(MenuItem, { icon: /* @__PURE__ */ React.createElement(Ico.close, null), danger: true, onClick: async () => {
      close();
      await window.API.logout();
      window.location.reload();
    } }, "Terminar sess\xE3o"))))), /* @__PURE__ */ React.createElement("div", { className: "content", style: { display: "flex", flexDirection: "column", position: "relative" } }, renderView())),
    chatOpen && /* @__PURE__ */ React.createElement(
      ChatDrawer,
      {
        onClose: () => {
          setChatOpen(false);
          setChatIntent(null);
        },
        currentUserId: bootstrap.me?.id,
        users: bootstrap.users || [],
        userTypes: bootstrap.userTypes || [],
        initialConvId: chatIntent?.convId || null,
        initialTs: chatIntent?.ts || null
      }
    ),
    /* @__PURE__ */ React.createElement(SRTweaksPanel, { tweaks, setTweak }),
    /* @__PURE__ */ React.createElement(ToastDock, { onNavigate: navigateFromNotification }),
    /* @__PURE__ */ React.createElement(ConfirmHost, null),
    area === "admin" && bootstrap.me?.is_staff && /* @__PURE__ */ React.createElement(AdminLogConsole, null)
  );
}
function SRTweaksPanel({ tweaks, setTweak }) {
  return /* @__PURE__ */ React.createElement(TweaksPanel, null, /* @__PURE__ */ React.createElement(TweakSection, { label: "Layout" }, /* @__PURE__ */ React.createElement(
    TweakRadio,
    {
      label: "Modo da listagem",
      value: tweaks.layout,
      onChange: (v) => setTweak("layout", v),
      options: [
        { value: "standard", label: "Tabela" },
        { value: "split", label: "Split view" }
      ]
    }
  ), /* @__PURE__ */ React.createElement(
    TweakRadio,
    {
      label: "Densidade",
      value: tweaks.density,
      onChange: (v) => setTweak("density", v),
      options: [
        { value: "compact", label: "Densa" },
        { value: "normal", label: "Normal" },
        { value: "comfortable", label: "Larga" }
      ]
    }
  )), /* @__PURE__ */ React.createElement(TweakSection, { label: "Apar\xEAncia" }, /* @__PURE__ */ React.createElement(
    TweakRadio,
    {
      label: "Tema",
      value: tweaks.theme,
      onChange: (v) => setTweak("theme", v),
      options: [
        { value: "light", label: "Claro" },
        { value: "dark", label: "Escuro" }
      ]
    }
  ), /* @__PURE__ */ React.createElement(
    TweakColor,
    {
      label: "Cor de acento",
      value: tweaks.accent,
      onChange: (v) => setTweak("accent", v),
      options: ["#2c5d8a", "#15324f", "#3a8a4d", "#3577a8", "#1f2933"]
    }
  )));
}
function AreaBrand({ area, me }) {
  if (area === "sem_modulos") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { color: "var(--text)" } }, /* @__PURE__ */ React.createElement(HubMark, { size: 30 })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-wordmark" }, "GJN HUB"), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "GRUPO JOS\xC9 NEVES")));
  }
  if (area === "conta") {
    const initial = (me?.first_name?.[0] || me?.username?.[0] || "?").toUpperCase();
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
      width: 34,
      height: 34,
      borderRadius: "50%",
      overflow: "hidden",
      background: "var(--brand-navy)",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 14,
      fontWeight: 600,
      flexShrink: 0
    } }, me?.photo_url ? /* @__PURE__ */ React.createElement("img", { src: me.photo_url, alt: "", style: { width: "100%", height: "100%", objectFit: "cover" } }) : initial), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-wordmark", style: { fontSize: 14 } }, `${me?.first_name || ""} ${me?.last_name || ""}`.trim() || me?.username), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "A MINHA CONTA")));
  }
  if (area === "calendario") {
    const b2 = window.HUB_REG.brandFor(area);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { width: 30, display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 24 } }, b2 && b2.brandEmoji || "\u{1F4C5}")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-wordmark" }, b2 && b2.name || "Calend\xE1rio"), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "GRUPO JOS\xC9 NEVES")));
  }
  const b = window.HUB_REG.brandFor(area);
  const areaData = b && window.HUB_REG.AREAS.find((a) => a.slug === area);
  if (b && b.brandLogo && !(areaData && areaData.brandUseBrandMark)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: {
      width: 36,
      height: 36,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    } }, /* @__PURE__ */ React.createElement(
      "img",
      {
        src: b.brandLogo,
        alt: areaData && areaData.brandAlt || b.name,
        onError: (e) => {
          if (areaData && areaData.brandLogoFallback) {
            const fb = areaData.brandLogoFallback;
            e.currentTarget.src = fb.src;
            Object.assign(e.currentTarget.style, fb.imgStyles);
            e.currentTarget.parentElement.style.height = fb.containerHeight;
          } else {
            e.currentTarget.style.display = "none";
            e.currentTarget.parentElement.innerHTML = `<span style="font-size:${areaData && areaData.brandEmojiFontSize || "26px"}">${b.brandEmoji}</span>`;
          }
        },
        style: { width: 36, height: 36, objectFit: "contain", display: "block" }
      }
    )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-wordmark", style: { color: b.accent } }, areaData && areaData.brandWordmark || b.name), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "GRUPO JOS\xC9 NEVES")));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { color: "var(--text)" } }, /* @__PURE__ */ React.createElement(BrandMark, { size: 30 })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-wordmark" }, "stockreborn"), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "GRUPO JOS\xC9 NEVES")));
}
function LauncherScreen({ me, apps, onPick, onProfile, onNotifications, onChat, onNavigate }) {
  const [nUnread, setNUnread] = useState(0);
  const [cUnread, setCUnread] = useState(0);
  const refresh = useCallback(() => {
    window.API.notificationsUnread().then((r) => setNUnread(r.unread || 0)).catch(() => {
    });
    window.API.chatUnreadCount().then((r) => setCUnread(r.unread || 0)).catch(() => {
    });
  }, []);
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 3e4);
    return () => clearInterval(t);
  }, [refresh]);
  useEffect(() => {
    const onRealtime = (e) => {
      if (e.detail && e.detail.type === "notification.new") refresh();
    };
    window.addEventListener("sr:realtime", onRealtime);
    return () => window.removeEventListener("sr:realtime", onRealtime);
  }, [refresh]);
  const badgeStyle = {
    position: "absolute",
    top: -4,
    right: -4,
    minWidth: 16,
    height: 16,
    padding: "0 4px",
    borderRadius: 8,
    background: "#dc2626",
    color: "#fff",
    fontSize: 10,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };
  const iconFrame = {
    width: 72,
    height: 72,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };
  const iconImg = {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    display: "block"
  };
  const Img = ({ src, alt, fallbackEmoji }) => /* @__PURE__ */ React.createElement("div", { style: iconFrame }, !src ? fallbackEmoji ? /* @__PURE__ */ React.createElement("span", { style: { fontSize: 42 } }, fallbackEmoji) : null : /* @__PURE__ */ React.createElement(
    "img",
    {
      src,
      alt,
      style: iconImg,
      onError: (e) => {
        e.currentTarget.style.display = "none";
        e.currentTarget.parentElement.innerHTML = `<span style="font-size:42px">${fallbackEmoji}</span>`;
      }
    }
  ));
  const cards = window.HUB_REG.areaList(apps, !!me?.is_staff).map((a) => ({
    slug: a.slug,
    name: a.name,
    sub: a.sub,
    accent: a.accent,
    icon: /* @__PURE__ */ React.createElement(Img, { src: a.brandLogo, alt: a.brandAlt || a.name, fallbackEmoji: a.brandEmoji })
  }));
  return /* @__PURE__ */ React.createElement("div", { style: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--bg)",
    padding: 24,
    gap: 28
  } }, /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 16, right: 20, display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only",
      title: "Chat",
      onClick: onChat,
      style: { position: "relative" }
    },
    /* @__PURE__ */ React.createElement(Ico.chat, null),
    cUnread > 0 && /* @__PURE__ */ React.createElement("span", { style: badgeStyle }, cUnread > 9 ? "9+" : cUnread)
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost icon-only",
      title: "Notifica\xE7\xF5es",
      onClick: onNotifications,
      style: { position: "relative" }
    },
    /* @__PURE__ */ React.createElement(Ico.bell, null),
    nUnread > 0 && /* @__PURE__ */ React.createElement("span", { style: badgeStyle }, nUnread > 9 ? "9+" : nUnread)
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onProfile,
      title: "A minha conta",
      style: { border: "none", background: "none", cursor: "pointer", padding: 0 }
    },
    /* @__PURE__ */ React.createElement("span", { style: {
      width: 32,
      height: 32,
      borderRadius: "50%",
      overflow: "hidden",
      background: "var(--brand-navy)",
      color: "#fff",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 13,
      fontWeight: 600,
      position: "relative"
    } }, (me?.first_name?.[0] || me?.username?.[0] || "?").toUpperCase(), me?.photo_url && /* @__PURE__ */ React.createElement(
      "img",
      {
        src: me.photo_url,
        alt: "",
        onError: (e) => {
          e.currentTarget.style.display = "none";
        },
        style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
      }
    ))
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 14 } }, /* @__PURE__ */ React.createElement(HubMark, { size: 96 }), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 40, fontWeight: 800, letterSpacing: "0.04em", lineHeight: 1 } }, "GJN HUB"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "var(--muted)", letterSpacing: "0.18em", marginTop: 6 } }, "GRUPO JOS\xC9 NEVES"))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 20, flexWrap: "wrap", justifyContent: "center" } }, cards.map((c) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: c.slug,
      onClick: () => onPick(c.slug),
      type: "button",
      style: {
        width: 220,
        padding: 22,
        background: "var(--panel)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 14,
        textAlign: "center",
        boxShadow: "var(--shadow-md)",
        transition: "transform 120ms, box-shadow 120ms, border-color 120ms"
      },
      onMouseEnter: (e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.borderColor = c.accent;
      },
      onMouseLeave: (e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.borderColor = "var(--border)";
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { height: 72, display: "flex", alignItems: "center" } }, c.icon),
    /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 600, fontSize: 15 } }, c.name), /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 12,
      color: "var(--muted)",
      lineHeight: 1.25,
      minHeight: "2.5em"
    } }, c.sub)),
    /* @__PURE__ */ React.createElement("span", { style: {
      background: c.accent,
      color: "#fff",
      padding: "4px 12px",
      borderRadius: 12,
      fontSize: 11
    } }, "Entrar")
  ))), /* @__PURE__ */ React.createElement("button", { className: "btn ghost sm", onClick: () => {
    window.API.logout().then(() => window.location.reload());
  } }, "Terminar sess\xE3o"), /* @__PURE__ */ React.createElement(ToastDock, { onNavigate }));
}
function LoginScreen() {
  const [mode, setMode] = useState("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resetLogin, setResetLogin] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await window.API.login(username, password);
      window.location.reload();
    } catch (err) {
      setError(/401/.test(err.message) ? "Credenciais inv\xE1lidas." : err.message);
      setLoading(false);
    }
  };
  const submitForgot = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await window.API.requestPasswordReset(resetLogin);
      setResetSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const linkStyle = {
    background: "none",
    border: "none",
    color: "var(--accent)",
    cursor: "pointer",
    fontSize: 12,
    padding: 0,
    textAlign: "left"
  };
  return /* @__PURE__ */ React.createElement("div", { className: "login-screen" }, mode === "login" ? /* @__PURE__ */ React.createElement("form", { onSubmit: submit, className: "login-card" }, /* @__PURE__ */ React.createElement("div", { className: "login-brand" }, /* @__PURE__ */ React.createElement(HubMark, { size: 40 }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-name" }, "GJN HUB"), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "GRUPO JOS\xC9 NEVES"))), /* @__PURE__ */ React.createElement("div", { className: "login-head" }, /* @__PURE__ */ React.createElement("h2", { className: "login-title" }, "Iniciar sess\xE3o"), /* @__PURE__ */ React.createElement("div", { className: "login-hint" }, "Usa as tuas credenciais corporativas")), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Username"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: username,
      onChange: (e) => setUsername(e.target.value),
      required: true,
      autoFocus: true,
      autoComplete: "username"
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Password"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: password,
      onChange: (e) => setPassword(e.target.value),
      required: true,
      autoComplete: "current-password"
    }
  )), error && /* @__PURE__ */ React.createElement("div", { className: "login-error" }, error), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "submit",
      className: "btn primary",
      disabled: loading,
      style: { justifyContent: "center", padding: "10px 14px", fontSize: 13 }
    },
    loading ? "A entrar\u2026" : "Entrar"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...linkStyle, marginTop: 10 },
      onClick: () => {
        setMode("forgot");
        setError(null);
        setResetLogin(username);
      }
    },
    "Esqueci-me da password"
  )) : /* @__PURE__ */ React.createElement("form", { onSubmit: submitForgot, className: "login-card" }, /* @__PURE__ */ React.createElement("div", { className: "login-brand" }, /* @__PURE__ */ React.createElement(HubMark, { size: 40 }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-name" }, "GJN HUB"), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "GRUPO JOS\xC9 NEVES"))), /* @__PURE__ */ React.createElement("div", { className: "login-head" }, /* @__PURE__ */ React.createElement("h2", { className: "login-title" }, "Repor password"), /* @__PURE__ */ React.createElement("div", { className: "login-hint" }, "Enviamos-te um link por email para definires uma nova password.")), resetSent ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "var(--text-2)", lineHeight: 1.5 } }, "Se existir uma conta com esses dados, envi\xE1mos um email com o link para repor a password. Verifica tamb\xE9m o spam."), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "btn primary",
      style: { justifyContent: "center", padding: "10px 14px", fontSize: 13, marginTop: 12 },
      onClick: () => {
        setMode("login");
        setResetSent(false);
      }
    },
    "Voltar ao login"
  )) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Username ou email"), /* @__PURE__ */ React.createElement(
    "input",
    {
      value: resetLogin,
      onChange: (e) => setResetLogin(e.target.value),
      required: true,
      autoFocus: true,
      autoComplete: "username"
    }
  )), error && /* @__PURE__ */ React.createElement("div", { className: "login-error" }, error), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "submit",
      className: "btn primary",
      disabled: loading || !resetLogin,
      style: { justifyContent: "center", padding: "10px 14px", fontSize: 13 }
    },
    loading ? "A enviar\u2026" : "Enviar link"
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      style: { ...linkStyle, marginTop: 10 },
      onClick: () => {
        setMode("login");
        setError(null);
      }
    },
    "\u2190 Voltar ao login"
  ))), /* @__PURE__ */ React.createElement("div", { className: "login-foot" }, "\xA9 ", (/* @__PURE__ */ new Date()).getFullYear(), " Grupo Jos\xE9 Neves"));
}
function SetPasswordScreen() {
  const params = new URLSearchParams(window.location.search);
  const uid = params.get("uid") || "";
  const token = params.get("token") || "";
  const [state, setState] = useState("checking");
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let alive = true;
    window.API.validateSetPassword(uid, token).then((r) => {
      if (alive) {
        setState(r.valid ? "valid" : "invalid");
        setUsername(r.username);
      }
    }).catch(() => {
      if (alive) setState("invalid");
    });
    return () => {
      alive = false;
    };
  }, [uid, token]);
  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password.length < 4) {
      setError("A password tem de ter pelo menos 4 caracteres.");
      return;
    }
    if (password !== confirm) {
      setError("As passwords n\xE3o coincidem.");
      return;
    }
    setLoading(true);
    try {
      await window.API.setPasswordWithToken(uid, token, password);
      setState("done");
      setTimeout(() => window.location.assign("/"), 1200);
    } catch (err) {
      setError(/400/.test(err.message) ? "Link inv\xE1lido ou expirado." : err.message);
      setLoading(false);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "login-screen" }, /* @__PURE__ */ React.createElement("div", { className: "login-card" }, /* @__PURE__ */ React.createElement("div", { className: "login-brand" }, /* @__PURE__ */ React.createElement(HubMark, { size: 40 }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "brand-name" }, "GJN HUB"), /* @__PURE__ */ React.createElement("div", { className: "brand-sub" }, "GRUPO JOS\xC9 NEVES"))), state === "checking" && /* @__PURE__ */ React.createElement("div", { className: "login-hint" }, "A validar o link\u2026"), state === "invalid" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "login-head" }, /* @__PURE__ */ React.createElement("h2", { className: "login-title" }, "Link inv\xE1lido")), /* @__PURE__ */ React.createElement("div", { className: "login-hint" }, "Este link \xE9 inv\xE1lido ou j\xE1 expirou. Pede ao administrador para reenviar o email."), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn ghost sm",
      onClick: () => window.location.assign("/"),
      style: { marginTop: 12 }
    },
    "Ir para o login"
  )), state === "done" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "login-head" }, /* @__PURE__ */ React.createElement("h2", { className: "login-title" }, "Password definida")), /* @__PURE__ */ React.createElement("div", { className: "login-hint" }, "A entrar\u2026")), state === "valid" && /* @__PURE__ */ React.createElement("form", { onSubmit: submit }, /* @__PURE__ */ React.createElement("div", { className: "login-head" }, /* @__PURE__ */ React.createElement("h2", { className: "login-title" }, "Define a tua password"), /* @__PURE__ */ React.createElement("div", { className: "login-hint" }, username ? `Conta: ${username}` : "Escolhe uma password")), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Nova password"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: password,
      onChange: (e) => setPassword(e.target.value),
      required: true,
      minLength: 4,
      autoFocus: true,
      autoComplete: "new-password"
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "field" }, /* @__PURE__ */ React.createElement("span", { className: "label" }, "Confirmar password"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "password",
      value: confirm,
      onChange: (e) => setConfirm(e.target.value),
      required: true,
      minLength: 4,
      autoComplete: "new-password"
    }
  )), error && /* @__PURE__ */ React.createElement("div", { className: "login-error" }, error), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "submit",
      className: "btn primary",
      disabled: loading,
      style: { justifyContent: "center", padding: "10px 14px", fontSize: 13 }
    },
    loading ? "A guardar\u2026" : "Definir password"
  ))), /* @__PURE__ */ React.createElement("div", { className: "login-foot" }, "\xA9 ", (/* @__PURE__ */ new Date()).getFullYear(), " Grupo Jos\xE9 Neves"));
}
ReactDOM.createRoot(document.getElementById("root")).render(/* @__PURE__ */ React.createElement(App, null));
